/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/drop2worldwind/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 28);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(15);
var isBuffer = __webpack_require__(57);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baseStyles = __webpack_require__(104);

var _baseStyles2 = _interopRequireDefault(_baseStyles);

var _BurgerIcon = __webpack_require__(105);

var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);

var _CrossIcon = __webpack_require__(106);

var _CrossIcon2 = _interopRequireDefault(_CrossIcon);

exports['default'] = function (styles) {
  var Menu = (function (_Component) {
    _inherits(Menu, _Component);

    function Menu(props) {
      _classCallCheck(this, Menu);

      _get(Object.getPrototypeOf(Menu.prototype), 'constructor', this).call(this, props);
      this.state = {
        isOpen: false
      };
    }

    _createClass(Menu, [{
      key: 'toggleMenu',
      value: function toggleMenu() {
        var _this = this;

        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
        var isOpen = options.isOpen;
        var noStateChange = options.noStateChange;

        var newState = {
          isOpen: typeof isOpen !== 'undefined' ? isOpen : !this.state.isOpen
        };

        this.applyWrapperStyles();

        this.setState(newState, function () {
          !noStateChange && _this.props.onStateChange(newState);

          // Timeout ensures wrappers are cleared after animation finishes.
          _this.timeoutId && clearTimeout(_this.timeoutId);
          _this.timeoutId = setTimeout(function () {
            _this.timeoutId = null;
            if (!newState.isOpen) {
              _this.applyWrapperStyles(false);
            }
          }, 500);
        });
      }

      // Applies component-specific styles to external wrapper elements.
    }, {
      key: 'applyWrapperStyles',
      value: function applyWrapperStyles() {
        var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

        if (this.props.bodyClassName) {
          var body = document.querySelector('body');
          body.classList[set ? 'add' : 'remove'](this.props.bodyClassName);
        }

        if (styles.pageWrap && this.props.pageWrapId) {
          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, set);
        }

        if (styles.outerContainer && this.props.outerContainerId) {
          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, set);
        }
      }

      // Sets or unsets styles on DOM elements outside the menu component.
      // This is necessary for correct page interaction with some of the menus.
      // Throws and returns if the required external elements don't exist,
      // which means any external page animations won't be applied.
    }, {
      key: 'handleExternalWrapper',
      value: function handleExternalWrapper(id, wrapperStyles, set) {
        var html = document.querySelector('html');
        var body = document.querySelector('body');
        var wrapper = document.getElementById(id);

        if (!wrapper) {
          console.error("Element with ID '" + id + "' not found");
          return;
        }

        var builtStyles = this.getStyle(wrapperStyles);

        for (var prop in builtStyles) {
          if (builtStyles.hasOwnProperty(prop)) {
            wrapper.style[prop] = set ? builtStyles[prop] : '';
          }
        }

        // Prevent any horizontal scroll.
        [html, body].forEach(function (element) {
          element.style['overflow-x'] = set ? 'hidden' : '';
        });
      }

      // Builds styles incrementally for a given element.
    }, {
      key: 'getStyles',
      value: function getStyles(el, index, inline) {
        var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());

        // Set base styles.
        var output = _baseStyles2['default'][el] ? this.getStyle(_baseStyles2['default'][el]) : {};

        // Add animation-specific styles.
        if (styles[el]) {
          output = _extends({}, output, this.getStyle(styles[el], index + 1));
        }

        // Add custom styles.
        if (this.props.styles[propName]) {
          output = _extends({}, output, this.props.styles[propName]);
        }

        // Add element inline styles.
        if (inline) {
          output = _extends({}, output, inline);
        }

        return output;
      }
    }, {
      key: 'getStyle',
      value: function getStyle(style, index) {
        var width = this.props.width;

        var formattedWidth = typeof width !== 'string' ? width + 'px' : width;
        return style(this.state.isOpen, formattedWidth, this.props.right, index);
      }
    }, {
      key: 'listenForClose',
      value: function listenForClose(e) {
        e = e || window.event;

        if (this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
          this.toggleMenu();
        }
      }
    }, {
      key: 'shouldDisableOverlayClick',
      value: function shouldDisableOverlayClick() {
        if (typeof this.props.disableOverlayClick === 'function') {
          return this.props.disableOverlayClick();
        } else {
          return this.props.disableOverlayClick;
        }
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (!styles) {
          throw new Error('No styles supplied');
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        // Bind ESC key handler (unless disabled or custom function supplied).
        if (this.props.customOnKeyDown) {
          window.onkeydown = this.props.customOnKeyDown;
        } else if (!this.props.disableCloseOnEsc) {
          window.onkeydown = this.listenForClose.bind(this);
        }

        // Allow initial open state to be set by props.
        if (this.props.isOpen) {
          this.toggleMenu({ isOpen: true, noStateChange: true });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.onkeydown = null;

        this.applyWrapperStyles(false);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        var _this2 = this;

        if (styles.svg) {
          (function () {
            var morphShape = _reactDom2['default'].findDOMNode(_this2, 'bm-morph-shape');
            var path = styles.svg.lib(morphShape).select('path');

            if (_this2.state.isOpen) {
              // Animate SVG path.
              styles.svg.animate(path);
            } else {
              // Reset path (timeout ensures animation happens off screen).
              setTimeout(function () {
                path.attr('d', styles.svg.pathInitial);
              }, 300);
            }
          })();
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (typeof nextProps.isOpen !== 'undefined' && nextProps.isOpen !== this.state.isOpen) {
          this.toggleMenu();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        return _react2['default'].createElement(
          'div',
          null,
          !this.props.noOverlay && _react2['default'].createElement('div', {
            className: ('bm-overlay ' + this.props.overlayClassName).trim(),
            onClick: function () {
              return !_this3.shouldDisableOverlayClick() && _this3.toggleMenu();
            },
            style: this.getStyles('overlay')
          }),
          _react2['default'].createElement(
            'div',
            {
              id: this.props.id,
              className: ('bm-menu-wrap ' + this.props.className).trim(),
              style: this.getStyles('menuWrap')
            },
            styles.svg && _react2['default'].createElement(
              'div',
              {
                className: ('bm-morph-shape ' + this.props.morphShapeClassName).trim(),
                style: this.getStyles('morphShape')
              },
              _react2['default'].createElement(
                'svg',
                {
                  width: '100%',
                  height: '100%',
                  viewBox: '0 0 100 800',
                  preserveAspectRatio: 'none'
                },
                _react2['default'].createElement('path', { d: styles.svg.pathInitial })
              )
            ),
            _react2['default'].createElement(
              'div',
              {
                className: ('bm-menu ' + this.props.menuClassName).trim(),
                style: this.getStyles('menu')
              },
              _react2['default'].createElement(
                'nav',
                {
                  className: ('bm-item-list ' + this.props.itemListClassName).trim(),
                  style: this.getStyles('itemList')
                },
                _react2['default'].Children.map(this.props.children, function (item, index) {
                  if (item) {
                    var classList = ['bm-item', _this3.props.itemClassName, item.props.className].filter(function (className) {
                      return !!className;
                    }).join(' ');
                    var extraProps = {
                      key: index,
                      className: classList,
                      style: _this3.getStyles('item', index, item.props.style)
                    };
                    return _react2['default'].cloneElement(item, extraProps);
                  }
                })
              )
            ),
            this.props.customCrossIcon !== false && _react2['default'].createElement(
              'div',
              { style: this.getStyles('closeButton') },
              _react2['default'].createElement(_CrossIcon2['default'], {
                onClick: function () {
                  return _this3.toggleMenu();
                },
                styles: this.props.styles,
                customIcon: this.props.customCrossIcon,
                className: this.props.crossButtonClassName,
                crossClassName: this.props.crossClassName
              })
            )
          ),
          this.props.customBurgerIcon !== false && _react2['default'].createElement(
            'div',
            { style: this.getStyles('burgerIcon') },
            _react2['default'].createElement(_BurgerIcon2['default'], {
              onClick: function () {
                return _this3.toggleMenu();
              },
              styles: this.props.styles,
              customIcon: this.props.customBurgerIcon,
              className: this.props.burgerButtonClassName,
              barClassName: this.props.burgerBarClassName
            })
          )
        );
      }
    }]);

    return Menu;
  })(_react.Component);

  Menu.propTypes = {
    bodyClassName: _propTypes2['default'].string,
    burgerBarClassName: _propTypes2['default'].string,
    burgerButtonClassName: _propTypes2['default'].string,
    crossButtonClassName: _propTypes2['default'].string,
    crossClassName: _propTypes2['default'].string,
    customBurgerIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
    customCrossIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
    customOnKeyDown: _propTypes2['default'].func,
    disableCloseOnEsc: _propTypes2['default'].bool,
    disableOverlayClick: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].func]),
    id: _propTypes2['default'].string,
    isOpen: _propTypes2['default'].bool,
    itemClassName: _propTypes2['default'].string,
    itemListClassName: _propTypes2['default'].string,
    menuClassName: _propTypes2['default'].string,
    morphShapeClassName: _propTypes2['default'].string,
    noOverlay: _propTypes2['default'].bool,
    onStateChange: _propTypes2['default'].func,
    outerContainerId: styles && styles.outerContainer ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
    overlayClassName: _propTypes2['default'].string,
    pageWrapId: styles && styles.pageWrap ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
    right: _propTypes2['default'].bool,
    styles: _propTypes2['default'].object,
    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
  };

  Menu.defaultProps = {
    bodyClassName: '',
    burgerBarClassName: '',
    burgerButtonClassName: '',
    className: '',
    crossButtonClassName: '',
    crossClassName: '',
    disableCloseOnEsc: false,
    id: '',
    itemClassName: '',
    itemListClassName: '',
    menuClassName: '',
    morphShapeClassName: '',
    noOverlay: false,
    onStateChange: function onStateChange() {},
    outerContainerId: '',
    overlayClassName: '',
    pageWrapId: '',
    styles: {},
    width: 300
  };

  return Menu;
};

module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(35);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var ReactCurrentOwner = __webpack_require__(24);

var warning = __webpack_require__(9);
var canDefineProperty = __webpack_require__(23);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(25);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(4);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(0);
var normalizeHeaderName = __webpack_require__(59);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(17);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(17);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(102)();
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(31);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 13 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(36);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var settle = __webpack_require__(60);
var buildURL = __webpack_require__(62);
var parseHeaders = __webpack_require__(63);
var isURLSameOrigin = __webpack_require__(64);
var createError = __webpack_require__(18);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(65);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(66);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(61);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(8),
    _assign = __webpack_require__(3);

var ReactNoopUpdateQueue = __webpack_require__(22);

var canDefineProperty = __webpack_require__(23);
var emptyObject = __webpack_require__(7);
var invariant = __webpack_require__(5);
var lowPriorityWarning = __webpack_require__(81);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(9);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function () {
  var Snap = undefined;
  try {
    Snap = __webpack_require__(109);
  } finally {
    return Snap;
  }
};

module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29);
module.exports = __webpack_require__(34);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(30).enable();
  window.Promise = __webpack_require__(32);
}

// fetch() polyfill for making API calls.
__webpack_require__(33);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(3);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(12);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(12);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__include_jquery__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(119);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(3),n=__webpack_require__(7),p=__webpack_require__(4),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(2),l=__webpack_require__(37),B=__webpack_require__(3),C=__webpack_require__(4),ba=__webpack_require__(38),da=__webpack_require__(39),ea=__webpack_require__(40),fa=__webpack_require__(41),ia=__webpack_require__(44),D=__webpack_require__(7);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(4);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(42);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(43);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
window.jQuery=window.$=__WEBPACK_IMPORTED_MODULE_0_jquery__;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globe__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dropZone_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_full_screen__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_full_screen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_full_screen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__slideMenu_js__ = __webpack_require__(99);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));_this.state={isFull:false,autoRefreshSearch:false};_this.goFull=_this.goFull.bind(_this);_this.handleKey=_this.handleKey.bind(_this);return _this;}_createClass(App,[{key:'handleKey',value:function handleKey(e){// this prevents the paste event to be overitten
if(e.ctrlKey||e.metaKey){return false;}e.preventDefault();switch(e.key){case"f":{this.goFull();break;}default:break;}return false;}},{key:'goFull',value:function goFull(){this.setState({isFull:true});}},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('keydown',this.handleKey);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('keydown',this.handleKey);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_full_screen___default.a,{enabled:this.state.isFull,onChange:function onChange(isFull){return _this2.setState({isFull:isFull});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__slideMenu_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__dropZone_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__globe__["a" /* default */],{projection:"3D",autoRefreshSearch:this.state.autoRefreshSearch}))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globe_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globe_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__globe_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_parse__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wellknown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wellknown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_wellknown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_white_dot_png__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_white_dot_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_white_dot_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_webworldwind_oli__);
var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ... other declarations here
var Globe=function(_React$Component){_inherits(Globe,_React$Component);function Globe(props){_classCallCheck(this,Globe);var _this=_possibleConstructorReturn(this,(Globe.__proto__||Object.getPrototypeOf(Globe)).call(this,props));_this.state={wwdCreated:false,currentProjection:props.hasOwnProperty('projection')?props.projection:"Equirectangular",credentials:null,autoRefresh:props.hasOwnProperty('autoRefreshSearch')?props.autoRefreshSearch:false//supportedProjections = [ "3D", "Equirectangular", "Mercator" ]
};//this.dropKML = this.dropKML.bind(this);
_this.addKML=_this.addKML.bind(_this);_this.handleKey=_this.handleKey.bind(_this);_this.toggleProjection=_this.toggleProjection.bind(_this);_this.clearGlobe=_this.clearGlobe.bind(_this);_this.clearLastLayer=_this.clearLastLayer.bind(_this);_this.handlePaste=_this.handlePaste.bind(_this);_this.addHeatMap=_this.addHeatMap.bind(_this);_this.handleDropFiles=_this.handleDropFiles.bind(_this);_this.handleDropText=_this.handleDropText.bind(_this);return _this;}_createClass(Globe,[{key:'showSettings',value:function showSettings(event){event.preventDefault();}},{key:'handleKey',value:function handleKey(e){switch(e.key){case"p":{this.toggleProjection();break;}case"c":{this.clearLastLayer();break;}case"C":{this.clearGlobe();break;}case"a":{this.setState({autoRefresh:!this.state.autoRefresh});break;}default:break;}}},{key:'clearGlobe',value:function clearGlobe(){var LayersToRemove=this.wwd.layers;console.log("nb layers to remove:"+LayersToRemove.length);//LayersToRemove.shift();
for(var i=LayersToRemove.length;i>1;i--){this.wwd.removeLayer(LayersToRemove.pop());}this.wwd.redraw();}},{key:'clearLastLayer',value:function clearLastLayer(){var LayersToRemove=this.wwd.layers;this.wwd.removeLayer(LayersToRemove.pop());this.wwd.redraw();}},{key:'addKML',value:function addKML(url,context){var kmlFilePromise=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.KmlFile(url,[]);kmlFilePromise.then(function(kmlFile){var renderableLayer=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.RenderableLayer("Surface Shapes");renderableLayer.addRenderable(kmlFile);context.wwd.removeLayer(context.state.kmlLayer);context.wwd.addLayer(renderableLayer);context.wwd.redraw();context.setState({kmlLayer:renderableLayer});});}},{key:'addJson',value:function addJson(data,context){console.log(data);var jsonObject=JSON.parse(data);if(!Array.isArray(jsonObject)){this.addGeoJson(data,this);}else{if(jsonObject[0].hasOwnProperty('count')&&jsonObject[0].hasOwnProperty('lat')&&jsonObject[0].hasOwnProperty('lon')){//console.log("heat");
this.addHeatMap(jsonObject,this);}}}},{key:'addGeoJson',value:function addGeoJson(url,context){function shapeConfigurationCallback(geometry,properties){var configuration={};var placemarkAttributes=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.PlacemarkAttributes(null);placemarkAttributes.imageScale=10;placemarkAttributes.imageColor=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Color(0,1,1,0.2);placemarkAttributes.labelAttributes.offset=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Offset(__WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.OFFSET_FRACTION,5,__WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.OFFSET_FRACTION,5);//placemarkAttributes.imageSource = whiteDot;
if(geometry.isPointType()||geometry.isMultiPointType()){configuration.attributes=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.PlacemarkAttributes(placemarkAttributes);}else if(geometry.isLineStringType()||geometry.isMultiLineStringType()){configuration.attributes=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.ShapeAttributes(null);configuration.attributes.drawOutline=true;configuration.attributes.outlineColor=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Color(0.1*configuration.attributes.interiorColor.red,0.3*configuration.attributes.interiorColor.green,0.7*configuration.attributes.interiorColor.blue,1);configuration.attributes.outlineWidth=1;}else if(geometry.isPolygonType()||geometry.isMultiPolygonType()){configuration.attributes=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.ShapeAttributes(null);configuration.attributes.interiorColor=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Color(0,1,1,0.2);configuration.attributes.outlineColor=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Color(1,1,1,1);}console.log(configuration.attributes);return configuration;}function loadCompleteCallback(){context.wwd.redraw();}var renderableLayer=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.RenderableLayer("GeoJSON");context.wwd.addLayer(renderableLayer);var geoJson=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.GeoJSONParser(url);geoJson.load(loadCompleteCallback,shapeConfigurationCallback,renderableLayer);}},{key:'addWkt',value:function addWkt(wktString,context){function shapeConfigurationCallback(geometry,properties){var configuration={};configuration.attributes=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.ShapeAttributes(null);configuration.attributes.interiorColor=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Color(0,1,1,0.2);configuration.attributes.outlineColor=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Color(1,1,1,1);return configuration;}var renderableLayer=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.RenderableLayer("WKT");context.wwd.addLayer(renderableLayer);var wkt=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Wkt(wktString);wkt.load(null,shapeConfigurationCallback,renderableLayer);context.wwd.redraw();}},{key:'addWMS',value:function addWMS(wmsurl,context){var loc=new __WEBPACK_IMPORTED_MODULE_2_url_parse___default.a(wmsurl.replace(/\s|\u200B/g,''),true);// removes spaces which might be added when dragging a URL directly from a browser console log)
console.log(loc);console.log("URL without spaces: "+wmsurl.replace(/\s/g,''));console.log("Should add background WMS");console.log(loc.query);console.log("format: "+loc.query.FORMAT);console.log("FORMAT"in loc.query);var time="time"in loc.query?loc.query.time:loc.query.TIME;console.log("time: "+time);var wmsConfig={service:loc.protocol+"//"+loc.host+loc.pathname,layerNames:"layers"in loc.query?loc.query.layers:loc.query.LAYERS,numLevels:19,format:"format"in loc.query?loc.query.format:loc.query.FORMAT,coordinateSystem:"crs"in loc.query?loc.query.crs:loc.query.CRS,size:256,sector:__WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Sector.FULL_SPHERE,levelZeroDelta:new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Location(90,90)};console.log(wmsConfig);var renderableLayer=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.WmsLayer(wmsConfig,time);renderableLayer.crossOrigin='use-credentials';context.wwd.addLayer(renderableLayer);context.wwd.redraw();}},{key:'addHeatMap',value:function addHeatMap(jsonObject,context){var locations=[];for(var i=0;i<jsonObject.length;i++){if(jsonObject[i].type=="GRDH"){locations.push(new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.MeasuredLocation(jsonObject[i].lon,jsonObject[i].lat,jsonObject[i].count));}//console.log(locations.length);
}context.wwd.addLayer(new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.HeatMapLayer("HeatMap",locations));context.wwd.redraw();}},{key:'addGeoTiff',value:function addGeoTiff(url,context){var geotiffObject=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.GeoTiffReader(url);geotiffObject.readAsImage(function(canvas){var surfaceGeoTiff=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.SurfaceImage(geotiffObject.metadata.bbox,new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.ImageSource(canvas));var geotiffLayer=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.RenderableLayer("GeoTiff");geotiffLayer.addRenderable(surfaceGeoTiff);context.wwd.addLayer(geotiffLayer);});}},{key:'mapFromHubOpenSearch',value:function mapFromHubOpenSearch(item){function reshuffle(array){var json={};for(var i=0;i<array.length;i++){json[array[i].name]=array[i].content;}return json;}try{var hubItem={};if(item.date)Object.assign(hubItem,reshuffle(item.date));if(item.int)Object.assign(hubItem,reshuffle(item.int));if(item.double)Object.assign(hubItem,reshuffle(item.double));if(item.str)Object.assign(hubItem,reshuffle(item.str));var sizeArray=hubItem.size.split(" ");var sizeInBytes;switch(sizeArray[1]){case"B":sizeInBytes=Math.round(parseFloat(sizeArray[0]));break;case"MB":sizeInBytes=Math.round(parseFloat(sizeArray[0])*1024);break;case"GB":sizeInBytes=Math.round(parseFloat(sizeArray[0])*1024*1024);break;case"TB":sizeInBytes=Math.round(parseFloat(sizeArray[0])*1024*1024*1024);break;}var newItem={id:item.title,geometry:__WEBPACK_IMPORTED_MODULE_4_wellknown___default()(hubItem.footprint),type:"Feature",properties:{updated:new Date(hubItem.ingestiondate),title:item.title,name:item.title,date:hubItem.beginposition+'/'+hubItem.endposition,links:{data:[{href:item.link[0].href}]},earthObservation:{parentIdentifier:"",status:"ARCHIVED",acquisitionInformation:[{platform:{platformShortName:hubItem.platformname,platformSerialIdentifier:hubItem.platformserialidentifier},sensor:{instrument:hubItem.instrumentshortname,operationalMode:hubItem.sensoroperationalmode},acquisitionParameter:{acquisitionStartTime:new Date(hubItem.beginposition),acquisitionStopTime:new Date(hubItem.endposition),relativePassNumber:parseInt(hubItem.relativeorbitnumber),orbitNumber:parseInt(hubItem.orbitnumber),startTimeFromAscendingNode:null,stopTimeFromAscendingNode:null,orbitDirection:hubItem.orbitdirection}}],productInformation:{productType:hubItem.producttype,//timeliness: indexes["product"]["Timeliness Category"],
size:sizeInBytes}}}};//console.log("item: "+JSON.stringify(newItem));
return newItem;}catch(err){console.log("error: "+err.message);return null;}}},{key:'addDataHubOpenSearchResults',value:function addDataHubOpenSearchResults(url,context,mapFunction){var _this2=this;if(!this.state.credentials)this.state.credentials=prompt('Please enter your credentials for accessing the datahub (format: "username:password") ');var authorizationBasic=window.btoa(this.state.credentials);__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url,{crossdomain:true,headers:{'Authorization':"Basic "+authorizationBasic}}).then(function(response){return handleDHuSResponse(response,mapFunction,_this2.state.autoRefresh);});var i=0;if(this.state.autoRefresh){var intervalId=setInterval(function(){if(i===1000){clearInterval(intervalId);}console.log("Repeat: "+i);__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url,{crossdomain:true,headers:{'Authorization':"Basic "+authorizationBasic}}).then(function(response){return handleDHuSResponse(response,mapFunction,true);});i++;},10000);}function loadCompleteCallback(){context.wwd.redraw();}//function shapeConfigurationCallback() {}
function shapeConfigurationCallback(geometry,properties){//console.log(properties);
var configuration={};var name=properties.name||properties.Name||properties.NAME;if(name){configuration.name=name;}if(geometry.isPointType()||geometry.isMultiPointType()){configuration.attributes=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.PlacemarkAttributes();if(properties&&(properties.name||properties.Name||properties.NAME)){configuration.name=properties.name||properties.Name||properties.NAME;}if(properties&&properties.POP_MAX){var population=properties.POP_MAX;configuration.attributes.imageScale=0.01*Math.log(population);}}else if(geometry.isLineStringType()||geometry.isMultiLineStringType()){configuration.attributes=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.ShapeAttributes(null);configuration.attributes.drawOutline=true;configuration.attributes.outlineColor=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Color(0.1*configuration.attributes.interiorColor.red,0.3*configuration.attributes.interiorColor.green,0.7*configuration.attributes.interiorColor.blue,1);configuration.attributes.outlineWidth=1;}else if(geometry.isPolygonType()||geometry.isMultiPolygonType()){configuration.attributes=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.ShapeAttributes(null);configuration.attributes.interiorColor=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Color(0,0.8,0.8,0.7);// Paint the outline in a darker variant of the interior color.
configuration.attributes.outlineColor=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Color(0,0.8,0.8,0.7);configuration.attributes.outlineWidth=1;configuration.attributes.applyLighting=true;configuration.userProperties=properties;}return configuration;}function handleDHuSResponse(json,mapFunction,autoRefresh){console.log(autoRefresh);var features=[];if(json.data.feed.entry){var entries=[];if(!Array.isArray(json.data.feed.entry)){entries[0]=json.data.feed.entry;}else{entries=json.data.feed.entry;}console.log(entries.length+" items found");try{features=entries.map(function(a){return mapFunction(a);});}catch(err){console.log(json);console.log("Error: ");console.log(err);return;}//console.log(JSON.stringify(features));
var geojson={type:"FeatureCollection",id:"search",properties:{totalResults:json.data.feed["opensearch:totalResults"],startIndex:json.data.feed["opensearch:startIndex"]?json.data.feed["opensearch:startIndex"]:1,itemsPerPage:json.data.feed["opensearch:itemsPerPage"],title:json.data.feed["title"],updated:new Date()},features:features};//console.log(JSON.stringify(geojson));
//let geometryCollectionGeoJSON = new WorldWind.GeoJSONParser(JSON.stringify(geojson));
//let geometryCollectionLayer = new WorldWind.RenderableLayer("DHuSOpenSearchResults");
var myGeoJSONParser=function(_WorldWind$GeoJSONPar){_inherits(myGeoJSONParser,_WorldWind$GeoJSONPar);function myGeoJSONParser(json){_classCallCheck(this,myGeoJSONParser);return _possibleConstructorReturn(this,(myGeoJSONParser.__proto__||Object.getPrototypeOf(myGeoJSONParser)).call(this,json));}_createClass(myGeoJSONParser,[{key:'addRenderablesForPolygon',value:function addRenderablesForPolygon(layer,geometry,properties){var name=properties.name||properties.Name||properties.NAME;var existingRenderable=null;for(var _i=0;_i<layer.renderables.length;_i++){if(layer.renderables[_i].displayName==name)existingRenderable=layer.renderables[_i];}if(!existingRenderable){//console.log("adding item: "+name);
_get(myGeoJSONParser.prototype.__proto__||Object.getPrototypeOf(myGeoJSONParser.prototype),'addRenderablesForPolygon',this).call(this,layer,geometry,properties);layer.renderables[layer.renderables.length-1].displayName=name;}else{//console.log("Not adding item: "+name);
}}},{key:'addRenderablesForMultiPolygon',value:function addRenderablesForMultiPolygon(layer,geometry,properties){var name=properties.name||properties.Name||properties.NAME;var existingRenderable=null;for(var _i2=0;_i2<layer.renderables.length;_i2++){if(layer.renderables[_i2].displayName==name)existingRenderable=layer.renderables[_i2];}if(!existingRenderable){//console.log("adding item: "+name);
_get(myGeoJSONParser.prototype.__proto__||Object.getPrototypeOf(myGeoJSONParser.prototype),'addRenderablesForMultiPolygon',this).call(this,layer,geometry,properties);layer.renderables[layer.renderables.length-1].displayName=name;}else{//console.log("Not adding item: "+name);
}}}]);return myGeoJSONParser;}(__WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.GeoJSONParser);var geometryCollectionGeoJSON=new myGeoJSONParser(JSON.stringify(geojson));var geometryCollectionLayer=null;if(!autoRefresh){geometryCollectionLayer=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.RenderableLayer();context.wwd.addLayer(geometryCollectionLayer);}else{for(var _i3=0;_i3<context.wwd.layers.length;_i3++){if(context.wwd.layers[_i3].displayName==="DHuSOpenSearchResults"){geometryCollectionLayer=context.wwd.layers[_i3];//console.log(geometryCollectionLayer);
}}if(!geometryCollectionLayer){console.log("DHuS Layer not found!");geometryCollectionLayer=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.RenderableLayer("DHuSOpenSearchResults");context.wwd.addLayer(geometryCollectionLayer);}else{console.log("Found DHuS Layer with "+geometryCollectionLayer.renderables.length+" items");for(var _i4=0;_i4<geometryCollectionLayer.renderables.length;_i4++){console.log("Red shift");var r=geometryCollectionLayer.renderables[_i4].attributes.interiorColor.red*256;var g=geometryCollectionLayer.renderables[_i4].attributes.interiorColor.green*256;var b=geometryCollectionLayer.renderables[_i4].attributes.interiorColor.blue*256;var factor=0.1;r=Math.round(r+factor*(200-r));g=Math.round(g+factor*(0-g));b=Math.round(b+factor*(0-b));//var newColor = _interpolateColor(geometryCollectionLayer.renderables[i].attributes.interiorColor,)
geometryCollectionLayer.renderables[_i4].attributes.interiorColor.red=r/256;geometryCollectionLayer.renderables[_i4].attributes.interiorColor.green=g/256;geometryCollectionLayer.renderables[_i4].attributes.interiorColor.blue=b/256;geometryCollectionLayer.renderables[_i4].attributes.outlineColor.red=r/256;geometryCollectionLayer.renderables[_i4].attributes.outlineColor.green=g/256;geometryCollectionLayer.renderables[_i4].attributes.outlineColor.blue=b/256;geometryCollectionLayer.renderables[_i4].attributes.stateKeyInvalid=true;/*
                            geometryCollectionLayer.renderables[i].attributes.interiorColor.red = 
                                (geometryCollectionLayer.renderables[i].attributes.interiorColor.red >=1)? 1: geometryCollectionLayer.renderables[i].attributes.interiorColor.red+0.05;
                            geometryCollectionLayer.renderables[i].attributes.interiorColor.green = 
                                (geometryCollectionLayer.renderables[i].attributes.interiorColor.green <=0.1)? 0.1: geometryCollectionLayer.renderables[i].attributes.interiorColor.green-0.05;
                            geometryCollectionLayer.renderables[i].attributes.interiorColor.blue = 
                                (geometryCollectionLayer.renderables[i].attributes.interiorColor.blue <=0.1)? 0.1: geometryCollectionLayer.renderables[i].attributes.interiorColor.blue-0.05;
                            geometryCollectionLayer.renderables[i].attributes.stateKeyInvalid = true;
                            */}}}geometryCollectionGeoJSON.load(loadCompleteCallback,shapeConfigurationCallback,geometryCollectionLayer);//console.log(context.wwd.layers);
}else{console.log("No items found!");}}}},{key:'toggleProjection',value:function toggleProjection(proj){var supportedProjections=["3D","Equirectangular","Mercator","North Polar","South Polar"];this.setState({currentProjection:proj?proj:supportedProjections[(supportedProjections.indexOf(this.state.currentProjection)+1)%supportedProjections.length]});switch(this.state.currentProjection){case"3D":this.wwd.globe.projection=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.ProjectionWgs84();break;case"Equirectangular":this.wwd.globe.projection=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.ProjectionEquirectangular();break;case"Mercator":this.wwd.globe.projection=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.ProjectionMercator();break;case"North Polar":this.wwd.globe.projection=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.ProjectionPolarEquidistant("North");break;case"South Polar":this.wwd.globe.projection=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.ProjectionPolarEquidistant("South");break;default:this.wwd.globe=this.state.roundGlobe;}this.wwd.redraw();}},{key:'handlePaste',value:function handlePaste(text){console.log("pasted: "+text);// detect if it is a geojson or a wkt or a wms url
var isValidJSON=true;try{JSON.parse(text);}catch(e){isValidJSON=false;}try{if(isValidJSON){this.addJson(text,this);}else{if(text.includes("apihub/search?")||text.includes("dhus/search?")){this.addDataHubOpenSearchResults(text,this,this.mapFromHubOpenSearch);}else{if(text.includes("opensearch/request?")||text.includes("finder.creodias.eu")||text.includes("ngeo/catalogue")||text.includes("search")){console.log("fedeo !!");this.addGeoJson(text,this);}else{if(text.includes("GetMap")){this.addWMS(text,this);}else{this.addWkt(text,this);}}}}}catch(e){console.log("Could not handle the dropped item: "+e);}}},{key:'handleDropText',value:function handleDropText(text){console.log("dropped: "+text);this.handlePaste(text);}},{key:'handleDropFiles',value:function handleDropFiles(files){var reader=new FileReader();var context=this;for(var i=0;i<files.length;i++){if(files[i].type==='application/vnd.google-earth.kml+xml'){reader.onload=function(){console.log("kml");context.addKML(this.result,context);};reader.readAsDataURL(files[i]);}if(files[i].type==='image/tiff'){reader.onload=function(){//console.log(this.result);
context.addGeoTiff(this.result,context);};reader.readAsDataURL(files[i]);}if(files[i].name.endsWith('.geojson')||files[i].name.endsWith('.json')){reader.onload=function(){//console.log(this.result);
context.addJson(this.result,context);};reader.readAsText(files[i]);}}}},{key:'componentDidMount',value:function componentDidMount(){if(!this.state.wwd){var elevationModel=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.EarthElevationModel();var wwd=new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.WorldWindow("globe",elevationModel);wwd.navigator.minAllowedRange=15000;// works using worlwind branch @ https://github.com/OBarois/WebWorldWind/tree/inertia 
this.setState({wwd:wwd});this.wwd=wwd;var wmsConfig={service:"https://tiles.maps.eox.at/wms",layerNames:"s2cloudless-2018",numLevels:19,format:"image/png",size:256,sector:__WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Sector.FULL_SPHERE,levelZeroDelta:new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Location(90,90)};var layers=[{layer:new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.WmsLayer(wmsConfig,""),enabled:true}];for(var l=0;l<layers.length;l++){layers[l].layer.enabled=layers[l].enabled;wwd.addLayer(layers[l].layer);}this.toggleProjection(this.props.hasOwnProperty('projection')?this.props.projection:"Equirectangular");wwd.goToAnimator.travelTime=1000;wwd.goTo(new __WEBPACK_IMPORTED_MODULE_6_webworldwind_oli___default.a.Location(41.827424,12.674346));window.addEventListener('keydown',this.handleKey);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('keydown',this.handleKey);}},{key:'render',value:function render(){var globeStyle={width:"100%",height:"100%"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Globe',id:'outer-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{id:'globe',style:globeStyle}));}}]);return Globe;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Globe);

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var required = __webpack_require__(53)
  , qs = __webpack_require__(54)
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  function sanitize(address) {          // Sanitize what is left of the address
    return address.replace('\\', '/');
  },
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */
function lolcation(loc) {
  var globalVar;

  if (typeof window !== 'undefined') globalVar = window;
  else if (typeof global !== 'undefined') globalVar = global;
  else if (typeof self !== 'undefined') globalVar = self;
  else globalVar = {};

  var location = globalVar.location || {};
  loc = loc || location;

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new Url(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new Url(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @private
 */
function extractProtocol(address) {
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */
function resolve(relative, base) {
  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */
function Url(address, location, parser) {
  if (!(this instanceof Url)) {
    return new Url(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[3] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];

    if (typeof instruction === 'function') {
      address = instruction(address);
      continue;
    }

    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

Url.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.qs = qs;

module.exports = Url;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , undef;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String} The decoded string.
 * @api private
 */
function decode(input) {
  return decodeURIComponent(input.replace(/\+/g, ' '));
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  while (part = parser.exec(query)) {
    var key = decode(part[1])
      , value = decode(part[2]);

    //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    if (key in result) continue;
    result[key] = value;
  }

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = []
    , value
    , key;

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key];

      //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //
      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(value));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(56);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var bind = __webpack_require__(15);
var Axios = __webpack_require__(58);
var defaults = __webpack_require__(10);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(20);
axios.CancelToken = __webpack_require__(72);
axios.isCancel = __webpack_require__(19);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(73);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(10);
var utils = __webpack_require__(0);
var InterceptorManager = __webpack_require__(67);
var dispatchRequest = __webpack_require__(68);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(18);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var transformData = __webpack_require__(69);
var isCancel = __webpack_require__(19);
var defaults = __webpack_require__(10);
var isAbsoluteURL = __webpack_require__(70);
var combineURLs = __webpack_require__(71);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(20);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

/*eslint-disable no-cond-assign */
module.exports = parse;
module.exports.parse = parse;
module.exports.stringify = stringify;

var numberRegexp = /[-+]?([0-9]*\.[0-9]+|[0-9]+)([eE][-+]?[0-9]+)?/;
// Matches sequences like '100 100' or '100 100 100'.
var tuples = new RegExp('^' + numberRegexp.source + '(\\s' + numberRegexp.source + '){1,}');

/*
 * Parse WKT and return GeoJSON.
 *
 * @param {string} _ A WKT geometry
 * @return {?Object} A GeoJSON geometry object
 */
function parse (input) {
  var parts = input.split(';');
  var _ = parts.pop();
  var srid = (parts.shift() || '').split('=').pop();

  var i = 0;

  function $ (re) {
    var match = _.substring(i).match(re);
    if (!match) return null;
    else {
      i += match[0].length;
      return match[0];
    }
  }

  function crs (obj) {
    if (obj && srid.match(/\d+/)) {
      obj.crs = {
        type: 'name',
        properties: {
          name: 'urn:ogc:def:crs:EPSG::' + srid
        }
      };
    }

    return obj;
  }

  function white () { $(/^\s*/); }

  function multicoords () {
    white();
    var depth = 0;
    var rings = [];
    var stack = [rings];
    var pointer = rings;
    var elem;

    while (elem =
           $(/^(\()/) ||
             $(/^(\))/) ||
               $(/^(,)/) ||
                 $(tuples)) {
      if (elem === '(') {
        stack.push(pointer);
        pointer = [];
        stack[stack.length - 1].push(pointer);
        depth++;
      } else if (elem === ')') {
        // For the case: Polygon(), ...
        if (pointer.length === 0) return null;

        pointer = stack.pop();
        // the stack was empty, input was malformed
        if (!pointer) return null;
        depth--;
        if (depth === 0) break;
      } else if (elem === ',') {
        pointer = [];
        stack[stack.length - 1].push(pointer);
      } else if (!elem.split(/\s/g).some(isNaN)) {
        Array.prototype.push.apply(pointer, elem.split(/\s/g).map(parseFloat));
      } else {
        return null;
      }
      white();
    }

    if (depth !== 0) return null;

    return rings;
  }

  function coords () {
    var list = [];
    var item;
    var pt;
    while (pt =
           $(tuples) ||
             $(/^(,)/)) {
      if (pt === ',') {
        list.push(item);
        item = [];
      } else if (!pt.split(/\s/g).some(isNaN)) {
        if (!item) item = [];
        Array.prototype.push.apply(item, pt.split(/\s/g).map(parseFloat));
      }
      white();
    }

    if (item) list.push(item);
    else return null;

    return list.length ? list : null;
  }

  function point () {
    if (!$(/^(point(\sz)?)/i)) return null;
    white();
    if (!$(/^(\()/)) return null;
    var c = coords();
    if (!c) return null;
    white();
    if (!$(/^(\))/)) return null;
    return {
      type: 'Point',
      coordinates: c[0]
    };
  }

  function multipoint () {
    if (!$(/^(multipoint)/i)) return null;
    white();
    var newCoordsFormat = _
      .substring(_.indexOf('(') + 1, _.length - 1)
      .replace(/\(/g, '')
      .replace(/\)/g, '');
    _ = 'MULTIPOINT (' + newCoordsFormat + ')';
    var c = multicoords();
    if (!c) return null;
    white();
    return {
      type: 'MultiPoint',
      coordinates: c
    };
  }

  function multilinestring () {
    if (!$(/^(multilinestring)/i)) return null;
    white();
    var c = multicoords();
    if (!c) return null;
    white();
    return {
      type: 'MultiLineString',
      coordinates: c
    };
  }

  function linestring () {
    if (!$(/^(linestring(\sz)?)/i)) return null;
    white();
    if (!$(/^(\()/)) return null;
    var c = coords();
    if (!c) return null;
    if (!$(/^(\))/)) return null;
    return {
      type: 'LineString',
      coordinates: c
    };
  }

  function polygon () {
    if (!$(/^(polygon(\sz)?)/i)) return null;
    white();
    var c = multicoords();
    if (!c) return null;
    return {
      type: 'Polygon',
      coordinates: c
    };
  }

  function multipolygon () {
    if (!$(/^(multipolygon)/i)) return null;
    white();
    var c = multicoords();
    if (!c) return null;
    return {
      type: 'MultiPolygon',
      coordinates: c
    };
  }

  function geometrycollection () {
    var geometries = [];
    var geometry;

    if (!$(/^(geometrycollection)/i)) return null;
    white();

    if (!$(/^(\()/)) return null;
    while (geometry = root()) {
      geometries.push(geometry);
      white();
      $(/^(,)/);
      white();
    }
    if (!$(/^(\))/)) return null;

    return {
      type: 'GeometryCollection',
      geometries: geometries
    };
  }

  function root () {
    return point() ||
      linestring() ||
      polygon() ||
      multipoint() ||
      multilinestring() ||
      multipolygon() ||
      geometrycollection();
  }

  return crs(root());
}

/**
 * Stringifies a GeoJSON object into WKT
 */
function stringify (gj) {
  if (gj.type === 'Feature') {
    gj = gj.geometry;
  }

  function pairWKT (c) {
    return c.join(' ');
  }

  function ringWKT (r) {
    return r.map(pairWKT).join(', ');
  }

  function ringsWKT (r) {
    return r.map(ringWKT).map(wrapParens).join(', ');
  }

  function multiRingsWKT (r) {
    return r.map(ringsWKT).map(wrapParens).join(', ');
  }

  function wrapParens (s) { return '(' + s + ')'; }

  switch (gj.type) {
    case 'Point':
      return 'POINT (' + pairWKT(gj.coordinates) + ')';
    case 'LineString':
      return 'LINESTRING (' + ringWKT(gj.coordinates) + ')';
    case 'Polygon':
      return 'POLYGON (' + ringsWKT(gj.coordinates) + ')';
    case 'MultiPoint':
      return 'MULTIPOINT (' + ringWKT(gj.coordinates) + ')';
    case 'MultiPolygon':
      return 'MULTIPOLYGON (' + multiRingsWKT(gj.coordinates) + ')';
    case 'MultiLineString':
      return 'MULTILINESTRING (' + ringsWKT(gj.coordinates) + ')';
    case 'GeometryCollection':
      return 'GEOMETRYCOLLECTION (' + gj.geometries.map(stringify).join(', ') + ')';
    default:
      throw new Error('stringify requires a valid GeoJSON Feature or geometry object as input');
  }
}


/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * @license almond 0.3.0 Copyright (c) 2011-2014, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/almond for details
 */

/*
 * Copyright 2003-2006, 2009, 2017, United States Government, as represented by the Administrator of the
 * National Aeronautics and Space Administration. All rights reserved.
 *
 * The NASAWorldWind/WebWorldWind platform is licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*
 * Copyright 2003-2006, 2009, 2017, 2018, 2019, United States Government, as represented by the Administrator of the
 * National Aeronautics and Space Administration. All rights reserved.
 *
 * The NASAWorldWind/WebWorldWind platform is licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*
 * @license
 * Copyright 2000, Silicon Graphics, Inc. All Rights Reserved.
 * Copyright 2014, Google Inc. All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice including the dates of first publication and
 * either this permission notice or a reference to http://oss.sgi.com/projects/FreeB/
 * shall be included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 * SILICON GRAPHICS, INC. BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
 * IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Original Code. The Original Code is: OpenGL Sample Implementation,
 * Version 1.2.1, released January 26, 2000, developed by Silicon Graphics,
 * Inc. The Original Code is Copyright (c) 1991-2000 Silicon Graphics, Inc.
 * Copyright in any portions created by third parties is as indicated
 * elsewhere herein. All Rights Reserved.
 */

/*
 * Copyright 2003-2006, 2009, 2017, 2018, 2019 United States Government, as represented by the Administrator of the
 * National Aeronautics and Space Administration. All rights reserved.
 *
 * The NASAWorldWind/WebWorldWind platform is licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
 * @version   3.0.2
 */

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

/*
 * Copyright 2003-2006, 2009, 2017, United States Government, as represented by the Administrator of the
 * National Aeronautics and Space Administration. All rights reserved.
 *
 * The NASAWorldWind/WebWorldWind platform is licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):t.WorldWind=e()}(this,function(){var t,e,i;!function(r){function n(t,e){return _.call(t,e)}function o(t,e){var i,r,n,o,s,a,l,h,u,c,d,p=e&&e.split("/"),f=E.map,g=f&&f["*"]||{};if(t&&"."===t.charAt(0))if(e){for(p=p.slice(0,p.length-1),t=t.split("/"),s=t.length-1,E.nodeIdCompat&&w.test(t[s])&&(t[s]=t[s].replace(w,"")),t=p.concat(t),u=0;u<t.length;u+=1)if(d=t[u],"."===d)t.splice(u,1),u-=1;else if(".."===d){if(1===u&&(".."===t[2]||".."===t[0]))break;u>0&&(t.splice(u-1,2),u-=2)}t=t.join("/")}else 0===t.indexOf("./")&&(t=t.substring(2));if((p||g)&&f){for(i=t.split("/"),u=i.length;u>0;u-=1){if(r=i.slice(0,u).join("/"),p)for(c=p.length;c>0;c-=1)if(n=f[p.slice(0,c).join("/")],n&&(n=n[r])){o=n,a=u;break}if(o)break;!l&&g&&g[r]&&(l=g[r],h=u)}!o&&l&&(o=l,a=h),o&&(i.splice(0,a,o),t=i.join("/"))}return t}function s(t,e){return function(){var i=b.call(arguments,0);return"string"!=typeof i[0]&&1===i.length&&i.push(null),p.apply(r,i.concat([t,e]))}}function a(t){return function(e){return o(e,t)}}function l(t){return function(e){m[t]=e}}function h(t){if(n(y,t)){var e=y[t];delete y[t],v[t]=!0,d.apply(r,e)}if(!n(m,t)&&!n(v,t))throw new Error("No "+t);return m[t]}function u(t){var e,i=t?t.indexOf("!"):-1;return i>-1&&(e=t.substring(0,i),t=t.substring(i+1,t.length)),[e,t]}function c(t){return function(){return E&&E.config&&E.config[t]||{}}}var d,p,f,g,m={},y={},E={},v={},_=Object.prototype.hasOwnProperty,b=[].slice,w=/\.js$/;f=function(t,e){var i,r=u(t),n=r[0];return t=r[1],n&&(n=o(n,e),i=h(n)),n?t=i&&i.normalize?i.normalize(t,a(e)):o(t,e):(t=o(t,e),r=u(t),n=r[0],t=r[1],n&&(i=h(n))),{f:n?n+"!"+t:t,n:t,pr:n,p:i}},g={require:function(t){return s(t)},exports:function(t){var e=m[t];return"undefined"!=typeof e?e:m[t]={}},module:function(t){return{id:t,uri:"",exports:m[t],config:c(t)}}},d=function(t,e,i,o){var a,u,c,d,p,E,_=[],b=typeof i;if(o=o||t,"undefined"===b||"function"===b){for(e=!e.length&&i.length?["require","exports","module"]:e,p=0;p<e.length;p+=1)if(d=f(e[p],o),u=d.f,"require"===u)_[p]=g.require(t);else if("exports"===u)_[p]=g.exports(t),E=!0;else if("module"===u)a=_[p]=g.module(t);else if(n(m,u)||n(y,u)||n(v,u))_[p]=h(u);else{if(!d.p)throw new Error(t+" missing "+u);d.p.load(d.n,s(o,!0),l(u),{}),_[p]=m[u]}c=i?i.apply(m[t],_):void 0,t&&(a&&a.exports!==r&&a.exports!==m[t]?m[t]=a.exports:c===r&&E||(m[t]=c))}else t&&(m[t]=i)},t=e=p=function(t,e,i,n,o){if("string"==typeof t)return g[t]?g[t](e):h(f(t,e).f);if(!t.splice){if(E=t,E.deps&&p(E.deps,E.callback),!e)return;e.splice?(t=e,e=i,i=null):t=r}return e=e||function(){},"function"==typeof i&&(i=n,n=o),n?d(r,t,e,i):setTimeout(function(){d(r,t,e,i)},4),p},p.config=function(t){return p(t)},t._defined=m,i=function(t,e,i){e.splice||(i=e,e=[]),n(m,t)||n(y,t)||(y[t]=[t,e,i])},i.amd={jQuery:!0}}(),i("../tools/almond",function(){}),i("formats/aaigrid/AAIGridConstants",[],function(){"use strict";var t={N_COLS:"ncols",N_ROWS:"nrows",X_LL_CORNER:"xllcorner",Y_LL_CORNER:"yllcorner",CELL_SIZE:"cellsize",NO_DATA_VALUE:"NODATA_value"};return t}),i("formats/aaigrid/AAIGridMetadata",[],function(){"use strict";var t=function(){this._ncols=null,this._nrows=null,this._xllcorner=null,this._yllcorner=null,this._cellsize=null,this._NODATA_value=void 0};return Object.defineProperties(t.prototype,{ncols:{get:function(){return this._ncols},set:function(t){this._ncols=t}},nrows:{get:function(){return this._nrows},set:function(t){this._nrows=t}},xllcorner:{get:function(){return this._xllcorner},set:function(t){this._xllcorner=t}},yllcorner:{get:function(){return this._yllcorner},set:function(t){this._yllcorner=t}},cellsize:{get:function(){return this._cellsize},set:function(t){this._cellsize=t}},NODATA_value:{get:function(){return this._NODATA_value},set:function(t){this._NODATA_value=t}}}),t}),i("error/AbstractError",[],function(){"use strict";var t=function(t,e){this.name=t,this.message=e};return t.prototype.toString=function(){var t=this.name+": "+this.message;return this.stack&&(t+="\n"+this.stack.toString()),t},t}),i("error/ArgumentError",["../error/AbstractError"],function(t){"use strict";var e=function(e){t.call(this,"ArgumentError",e);var i;try{throw new Error}catch(t){i=t.stack}this.stack=i};return e.prototype=Object.create(t.prototype),e}),i("util/Logger",[],function(){"use strict";var t={LEVEL_NONE:0,LEVEL_SEVERE:1,LEVEL_WARNING:2,LEVEL_INFO:3,setLoggingLevel:function(t){e=t},getLoggingLevel:function(){return e},log:function(i,r){r&&i>0&&i<=e&&(i===t.LEVEL_SEVERE?console.error(r):i===t.LEVEL_WARNING?console.warn(r):i===t.LEVEL_INFO?console.info(r):console.log(r))},makeMessage:function(t,e,i){var r=this.messageTable[i]?this.messageTable[i]:i;return t+"."+e+": "+r},logMessage:function(t,e,i,r){var n=this.makeMessage(e,i,r);return this.log(t,n),n},messageTable:{abstractInvocation:"The function called is abstract and must be overridden in a subclass.",indexOutOfRange:"The specified index is out of range.",invalidColumn:"The specified column is out of range.",invalidHeight:"The specified height is zero or negative.",invalidWidth:"The specified width is zero or negative.",invalidRow:"The specified row is out of range.",invalidSize:"The specified size is zero or negative.",missingAltitudeMode:"The specified altitude mode is null or undefined.",missingArrayBuffer:"The specified array buffer is null or undefined",missingAttributeName:"The specified DBase attribute file name is null or undefined.",missingArray:"The specified array is null, undefined or of insufficient length.",missingBoundaries:"The specified boundaries array is null or undefined.",missingBuffer:"The specified buffer descriptor is null or undefined.",missingColor:"The specified color is null or undefined.",missingConfig:"The specified config is null or undefined.",missingDc:"The specified draw context is null or undefined.",missingDomElement:"The specified DOM element is null or undefined.",missingEntry:"The specified entry is null or undefined.",missingFont:"The specified font is null or undefined.",missingFrustum:"The specified frustum is null or undefined.",missingFunction:"The specified function is null or undefined.",missingGlContext:"The specified WebGL rendering context is null or undefined.",missingGlobe:"The specified globe is null or undefined.",missingId:"The specified id is null or undefined.",missingImage:"The specified image is null or undefined.",missingImageFormat:"The specified image format is null or undefined.",missingIndices:"The specified indices array is null or undefined.",missingKey:"The specified key is null or undefined.",missingLevel:"The specified level is null or undefined.",missingLine:"The specified line is null or undefined.",missingList:"The specified list is null or undefined.",missingListener:"The specified listener is null or undefined",missingLocation:"The specified location is null or undefined.",missingMatrix:"The specified matrix is null or undefined.",missingOffset:"The specified offset is null or undefined.",missingPath:"The specified path is null or undefined.",missingPlacename:"The specified place name is null or undefined.",missingPlane:"The specified plane is null or undefined.",missingPoint:"The specified point is null or undefined.",missingPoints:"The specified points array is null or undefined.",missingPosition:"The specified position is null or undefined.",missingPositions:"The specified positions array is null or undefined.",missingProgram:"The specified program is null or undefined.",missingProjection:"The specified projection is null or undefined.",missingRectangle:"The specified rectangle is null or undefined.",missingRenderable:"The specified renderable is null or undefined.",missingResolution:"The specified resolution is null, undefined, or zero.",missingResource:"The specified resource is null or undefined.",missingResult:"The specified result variable is null or undefined.",missingResults:"The specified results array is null or undefined.",missingSector:"The specified sector is null or undefined.",missingShapeType:"The specified shape type is null or undefined.",missingSize:"The specified size is null or undefined.",missingText:"The specified text is null or undefined.",missingTexture:"The specified texture is null or undefined.",missingTile:"The specified tile is null or undefined.",missingType:"The specified type is null or undefined.",missingUrl:"The specified URL is null or undefined",missingVector:"The specified vector is null or undefined.",missingVertex:"The specified vertex is null or undefined.",missingViewport:"The specified viewport is null or undefined.",missingWebCoverageService:"The specified WebCoverageService is null or undefined.",missingWorldWindow:"The specified WorldWindow is null or undefined.",notYetImplemented:"This function is not yet implemented",unsupportedVersion:"The specified version is not supported.",webglNotSupported:"The browser does not support WebGL, or WebGL is disabled."}},e=1;return t}),i("formats/aaigrid/AAIGridReader",["./AAIGridConstants","./AAIGridMetadata","../../error/ArgumentError","../../util/Logger"],function(t,e,i,r){"use strict";var n=function(t){if(!t)throw new i(r.logMessage(r.LEVEL_SEVERE,"AAIGridReader","constructor","missingDataSource"));if("string"!=typeof t&&!(t instanceof ArrayBuffer))throw new i(r.logMessage(r.LEVEL_SEVERE,"AAIGridReader","constructor","invalidDataSource"));this._values=null,this._metadata=new e;var n=this.decodeData(t);this.parse(n)};return Object.defineProperties(n.prototype,{metadata:{get:function(){return this._metadata}}}),n.prototype.getImageData=function(){return this._values},n.prototype.decodeData=function(t){if("string"!=typeof t&&!(t instanceof ArrayBuffer))throw new i(r.logMessage(r.LEVEL_SEVERE,"AAIGridReader","decodeData","invalidDataSource"));if("string"==typeof t)return t;if("function"==typeof window.TextDecoder){var e=new TextDecoder("utf-8");return e.decode(t)}for(var n="",o=new Uint8Array(t),s=65535,a=0,l=o.length;a<l;a+=s)a+s>l&&(s=l-a),n+=String.fromCharCode.apply(null,o.subarray(a,a+s));return n},n.prototype.parse=function(e){if("string"!=typeof e)throw new i(r.logMessage(r.LEVEL_SEVERE,"AAIGridReader","parse","invalidDataString"));for(var n=e.replace(/\r?\n|\r/g,"\n").split("\n"),o=[],s=!0,a=0,l=n.length;a<l;a++){var h=n[a];if(h){var u=h.trim().split(" ").map(function(t){return t.trim()}).filter(function(t){return""!==t});if(u[0]===t.N_COLS)this.metadata.ncols=+u[1];else if(u[0]===t.N_ROWS)this.metadata.nrows=+u[1];else if(u[0]===t.X_LL_CORNER)this.metadata.xllcorner=+u[1];else if(u[0]===t.Y_LL_CORNER)this.metadata.yllcorner=+u[1];else if(u[0]===t.CELL_SIZE)this.metadata.cellsize=+u[1];else if(u[0]===t.NO_DATA_VALUE)this.metadata.NODATA_value=+u[1];else if(isFinite(+u[0])){var c=u.map(function(t){var e=+t;return Math.floor(e)!==e&&(s=!1),e});o=o.concat(c)}}}this._values=s?new Int16Array(o):new Float32Array(o)},n.retrieveFromUrl=function(t,e){if(!t)throw new i(r.logMessage(r.LEVEL_SEVERE,"AAIGridReader","retrieveFromUrl","missingUrl"));if(!e)throw new i(r.logMessage(r.LEVEL_SEVERE,"AAIGridReader","retrieveFromUrl","The specified callback is null or undefined."));var o=new XMLHttpRequest;o.onload=function(){this.status>=200&&this.status<300?e(new n(this.response),o):(r.log(r.LEVEL_WARNING,"AAIGrid retrieval failed ("+o.statusText+"): "+t),e(null,o))},o.onerror=function(){r.log(r.LEVEL_WARNING,"AAIGrid retrieval failed: "+t),e(null,o)},o.ontimeout=function(){r.log(r.LEVEL_WARNING,"AAIGrid retrieval timed out: "+t),e(null,o)},o.open("GET",t,!0),o.responseType="arraybuffer",o.send(null)},n}),i("geom/Angle",[],function(){"use strict";var t={DEGREES_TO_RADIANS:Math.PI/180,RADIANS_TO_DEGREES:180/Math.PI,TWO_PI:2*Math.PI,HALF_PI:Math.PI/2,normalizedDegrees:function(t){var e=t%360;return e>180?e-360:e<-180?360+e:e},normalizedDegreesLatitude:function(t){var e=t%180;return e>90?180-e:e<-90?-180-e:e},normalizedDegreesLongitude:function(t){var e=t%360;return e>180?e-360:e<-180?360+e:e},normalizedRadians:function(t){var e=t%this.TWO_PI;return e>Math.PI?e-this.TWO_PI:e<-Math.PI?this.TWO_PI+e:e},normalizedRadiansLatitude:function(t){var e=t%Math.PI;return e>this.HALF_PI?Math.PI-e:e<-this.HALF_PI?-Math.PI-e:e},normalizedRadiansLongitude:function(t){var e=t%this.TWO_PI;return e>Math.PI?e-this.TWO_PI:e<-Math.PI?this.TWO_PI+e:e},isValidLatitude:function(t){return t>=-90&&t<=90},isValidLongitude:function(t){return t>=-180&&t<=180},toString:function(t){return t.toString()+"°"},toDecimalDegreesString:function(t){return t.toString()+"°"},toDMSString:function(t){var e,i,r,n,o;return e=t<0?-1:1,i=e*t,r=Math.floor(i),i=60*(i-r),n=Math.floor(i),i=60*(i-n),o=Math.round(i),60==o&&(n++,o=0),60==n&&(r++,n=0),(e==-1?"-":"")+r+"° "+n+"’ "+o+"”"},toDMString:function(t){var e,i,r,n,o,s;return e=t<0?-1:1,i=e*t,r=Math.floor(i),i=60*(i-r),n=Math.floor(i),i=60*(i-n),o=Math.round(i),60==o&&(n++,o=0),60==n&&(r++,n=0),s=0==o?n:n+o/60,(e==-1?"-":"")+r+"° "+s+"’"}};return t}),i("util/Color",["../util/Logger"],function(t){"use strict";var e=function(t,e,i,r){this.red=t,this.green=e,this.blue=i,this.alpha=r};return e.WHITE=new e(1,1,1,1),e.BLACK=new e(0,0,0,1),e.RED=new e(1,0,0,1),e.GREEN=new e(0,1,0,1),e.BLUE=new e(0,0,1,1),e.CYAN=new e(0,1,1,1),e.YELLOW=new e(1,1,0,1),e.MAGENTA=new e(1,0,1,1),e.LIGHT_GRAY=new e(.75,.75,.75,1),e.MEDIUM_GRAY=new e(.5,.5,.5,1),e.DARK_GRAY=new e(.25,.25,.25,1),e.TRANSPARENT=new e(0,0,0,0),e.prototype.set=function(t,e,i,r){return this.red=t,this.green=e,this.blue=i,this.alpha=r,this},e.prototype.copy=function(e){if(!e)throw new ArgumentError(t.logMessage(t.LEVEL_SEVERE,"Color","copy","missingColor"));return this.red=e.red,this.green=e.green,this.blue=e.blue,this.alpha=e.alpha,this},e.prototype.clone=function(){return new e(this.red,this.green,this.blue,this.alpha)},e.prototype.premultipliedComponents=function(t){var e=this.alpha;return t[0]=this.red*e,t[1]=this.green*e,t[2]=this.blue*e,t[3]=e,t},e.colorFromByteArray=function(t){return new e(t[0]/255,t[1]/255,t[2]/255,t[3]/255)},e.colorFromBytes=function(t,i,r,n){return new e(t/255,i/255,r/255,n/255)},e.colorFromHex=function(t){var i=parseInt(t.substring(0,2),16),r=parseInt(t.substring(2,4),16),n=parseInt(t.substring(4,6),16),o=parseInt(t.substring(6,8),16);return e.colorFromBytes(i,r,n,o)},e.colorFromKmlHex=function(t){var i=parseInt(t.substring(0,2),16),r=parseInt(t.substring(2,4),16),n=parseInt(t.substring(4,6),16),o=parseInt(t.substring(6,8),16);return e.colorFromBytes(o,n,r,i)},e.prototype.nextColor=function(){var t=Math.round(255*this.red),e=Math.round(255*this.green),i=Math.round(255*this.blue);return t<255?this.red=(t+1)/255:e<255?(this.red=0,this.green=(e+1)/255):i<255?(this.red=0,this.green=0,this.blue=(i+1)/255):(this.red=1/255,this.green=0,this.blue=0),this},e.prototype.equals=function(t){var e=Math.round(255*this.red),i=Math.round(255*this.green),r=Math.round(255*this.blue),n=Math.round(255*this.alpha),o=Math.round(255*t.red),s=Math.round(255*t.green),a=Math.round(255*t.blue),l=Math.round(255*t.alpha);return e===o&&i===s&&r===a&&n===l},e.prototype.equalsBytes=function(t){var e=Math.round(255*this.red),i=Math.round(255*this.green),r=Math.round(255*this.blue),n=Math.round(255*this.alpha);return e===t[0]&&i===t[1]&&r===t[2]&&n===t[3]},e.prototype.toByteString=function(){var t=Math.round(255*this.red),e=Math.round(255*this.green),i=Math.round(255*this.blue),r=Math.round(255*this.alpha);return"("+t+","+e+","+i+","+r+")"},e.prototype.toHexString=function(t){var e=Math.ceil(255*this.red).toString(16),i=Math.ceil(255*this.green).toString(16),r=Math.ceil(255*this.blue).toString(16),n=Math.ceil(255*this.alpha).toString(16),o="#";return o+=e.length<2?"0"+e:e,o+=i.length<2?"0"+i:i,o+=r.length<2?"0"+r:r,t&&(o+=n.length<2?"0"+n:n),o},e.prototype.toCssColorString=function(){var t=Math.round(255*this.red),e=Math.round(255*this.green),i=Math.round(255*this.blue);return"rgba("+t+", "+e+", "+i+", "+this.alpha+")"},e}),i("util/Font",["../error/ArgumentError","../util/Color","../util/Logger"],function(t,e,i){"use strict";var r=function(e,r,n,o,s,a){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"Font","constructor","missingSize"));if(e<=0)throw new t(i.logMessage(i.LEVEL_SEVERE,"Font","constructor","invalidSize"));this._size=e,this.style=r||"normal",this.variant=n||"normal",this.weight=o||"normal",this.family=s||"sans-serif",this.horizontalAlignment=a||"center"};return Object.defineProperties(r.prototype,{size:{get:function(){return this._size},set:function(t){this._fontString=null,this._size=t}},style:{get:function(){return this._style},set:function(t){this._fontString=null,this._style=t}},variant:{get:function(){return this._variant},set:function(t){this._fontString=null,this._variant=t}},weight:{get:function(){return this._weight},set:function(t){this._fontString=null,this._weight=t}},family:{get:function(){return this._family},set:function(t){this._fontString=null,this._family=t}},horizontalAlignment:{get:function(){return this._horizontalAlignment},set:function(t){this._toString=null,this._horizontalAlignment=t}},fontString:{get:function(){return this._fontString||(this._fontString=this._style+" "+this.variant+" "+this._weight+" "+this._size.toString()+"px "+this._family),this._fontString}}}),r.prototype.toString=function(){return this._toString&&this._fontString||(this._toString=this.fontString+" "+this.horizontalAlignment),this._toString},r}),i("util/Insets",["../error/ArgumentError","../util/Logger"],function(t,e){"use strict";var i=function(i,r,n,o){if(4!==arguments.length)throw new t(e.logMessage(e.LEVEL_SEVERE,"Insets","constructor","invalidArgumentCount"));this._top=i,this._left=r,this._bottom=n,this._right=o};return i.prototype.set=function(t,e,i,r){this._top=t,this._left=e,this._bottom=i,this._right=r},i.prototype.clone=function(){return new i(this._top,this._left,this._bottom,this._right)},i.prototype.toString=function(){return this._top+" "+this._left+" "+this._bottom+" "+this._right},Object.defineProperties(i.prototype,{top:{get:function(){return this._top},set:function(t){this._top=t}},left:{get:function(){return this._left},set:function(t){this._left=t}},bottom:{get:function(){return this._bottom},set:function(t){this._bottom=t}},right:{get:function(){return this._right},set:function(t){this._right=t}}}),i}),i("geom/Vec3",["../util/Logger","../error/ArgumentError"],function(t,e){"use strict";var i=function(t,e,i){this[0]=t,this[1]=e,this[2]=i};return i.prototype=new Float64Array(3),i.ZERO=new i(0,0,0),i.average=function(i,r){if(!i||i.length<1)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","average","missingArray"));if(!r)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","average","missingResult"));var n,o=i.length;r[0]=0,r[1]=0,r[2]=0;for(var s=0,a=i.length;s<a;s++)n=i[s],r[0]+=n[0]/o,r[1]+=n[1]/o,r[2]+=n[2]/o;return r},i.averageOfBuffer=function(i,r){if(!i||i.length<1)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","averageBuffer","missingArray"));if(!r)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","averageBuffer","missingResult"));var n=i.length/3;r[0]=0,r[1]=0,r[2]=0;for(var o=0;o<n;o++)r[0]+=i[3*o]/n,r[1]+=i[3*o+1]/n,r[2]+=i[3*o+2]/n;return r},i.areColinear=function(r,n,o){if(!r||!n||!o)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","areColinear","missingVector"));var s=new i(r[0]-n[0],r[1]-n[1],r[2]-n[2]).normalize(),a=new i(o[0]-n[0],o[1]-n[1],o[2]-n[2]).normalize();return Math.abs(s.dot(a))>.999},i.computeTriangleNormal=function(r,n,o){if(!r||!n||!o)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","areColinear","missingVector"));var s=(n[1]-r[1])*(o[2]-r[2])-(n[2]-r[2])*(o[1]-r[1]),a=(n[2]-r[2])*(o[0]-r[0])-(n[0]-r[0])*(o[2]-r[2]),l=(n[0]-r[0])*(o[1]-r[1])-(n[1]-r[1])*(o[0]-r[0]),h=s*s+a*a+l*l;return 0===h?new i(s,a,l):(h=Math.sqrt(h),new i(s/h,a/h,l/h))},i.findThreeIndependentVertices=function(t,e){var r=e&&e>0?e:3;if(!t||t.length<3*r)return null;for(var n=new i(t[0],t[1],t[2]),o=null,s=null,a=r;a<t.length&&(o=new i(t[a],t[a+1],t[a+2]),o[0]===n[0]&&o[1]===n[1]&&o[2]===n[2]);a+=r)o=null;if(!o)return null;for(a+=r;a<t.length&&(s=new i(t[a],t[a+1],t[a+2]),s[0]===n[0]&&s[1]===n[1]&&s[2]===n[2]||s[0]===o[0]&&s[1]===o[1]&&s[2]===o[2]||i.areColinear(n,o,s));a+=r)s=null;return s?[n,o,s]:null},i.computeBufferNormal=function(t,e){var r=i.findThreeIndependentVertices(t,e);return r?i.computeTriangleNormal(r[0],r[1],r[2]):null},i.prototype.set=function(t,e,i){return this[0]=t,this[1]=e,this[2]=i,this},i.prototype.copy=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","copy","missingVector"));return this[0]=i[0],this[1]=i[1],this[2]=i[2],this},i.prototype.equals=function(t){return this[0]===t[0]&&this[1]===t[1]&&this[2]===t[2]},i.prototype.add=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","add","missingVector"));return this[0]+=i[0],this[1]+=i[1],this[2]+=i[2],this},i.prototype.subtract=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","subtract","missingVector"));return this[0]-=i[0],this[1]-=i[1],this[2]-=i[2],this},i.prototype.multiply=function(t){return this[0]*=t,this[1]*=t,this[2]*=t,this},i.prototype.divide=function(t){return this[0]/=t,this[1]/=t,this[2]/=t,this},i.prototype.multiplyByMatrix=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","multiplyByMatrix","missingMatrix"));var r=i[0]*this[0]+i[1]*this[1]+i[2]*this[2]+i[3],n=i[4]*this[0]+i[5]*this[1]+i[6]*this[2]+i[7],o=i[8]*this[0]+i[9]*this[1]+i[10]*this[2]+i[11],s=i[12]*this[0]+i[13]*this[1]+i[14]*this[2]+i[15];return this[0]=r/s,this[1]=n/s,this[2]=o/s,this},i.prototype.mix=function(i,r){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","mix","missingVector"));var n=1-r,o=r;return this[0]=this[0]*n+i[0]*o,this[1]=this[1]*n+i[1]*o,this[2]=this[2]*n+i[2]*o,this},i.prototype.negate=function(){return this[0]=-this[0],this[1]=-this[1],this[2]=-this[2],this},i.prototype.dot=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","dot","missingVector"));return this[0]*i[0]+this[1]*i[1]+this[2]*i[2]},i.prototype.cross=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","cross","missingVector"));var r=this[1]*i[2]-this[2]*i[1],n=this[2]*i[0]-this[0]*i[2],o=this[0]*i[1]-this[1]*i[0];return this[0]=r,this[1]=n,this[2]=o,this},i.prototype.magnitudeSquared=function(){return this.dot(this)},i.prototype.magnitude=function(){return Math.sqrt(this.magnitudeSquared())},i.prototype.normalize=function(){var t=this.magnitude(),e=1/t;return this[0]*=e,this[1]*=e,this[2]*=e,this},i.prototype.distanceToSquared=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","distanceToSquared","missingVector"));var r=this[0]-i[0],n=this[1]-i[1],o=this[2]-i[2];return r*r+n*n+o*o},i.prototype.distanceTo=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec3","distanceTo","missingVector"));return Math.sqrt(this.distanceToSquared(i))},i.prototype.swap=function(t){var e=this[0];return this[0]=t[0],t[0]=e,e=this[1],this[1]=t[1],t[1]=e,e=this[2],this[2]=t[2],t[2]=e,this},i.prototype.toString=function(){return"("+this[0]+", "+this[1]+", "+this[2]+")"},i}),i("geom/Vec2",["../util/Logger","../error/ArgumentError","../geom/Vec3"],function(t,e,i){"use strict";var r=function(t,e){this[0]=t,this[1]=e};return r.prototype=new Float64Array(2),r.prototype.set=function(t,e){return this[0]=t,this[1]=e,this},r.prototype.copy=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec2","copy","missingVector"));return this[0]=i[0],this[1]=i[1],this},r.prototype.equals=function(t){return this[0]===t[0]&&this[1]===t[1]},r.average=function(i,r){if(!i||i.length<1)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec2","average","missingArray"));if(!r)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec2","average","missingResult"));var n,o=i.length;r[0]=0,r[1]=0;for(var s=0,a=i.length;s<a;s++)n=i[s],r[0]+=n[0]/o,r[1]+=n[1]/o;return r},r.prototype.add=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec2","add","missingVector"));return this[0]+=i[0],this[1]+=i[1],this},r.prototype.subtract=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec2","subtract","missingVector"));return this[0]-=i[0],this[1]-=i[1],this},r.prototype.multiply=function(t){return this[0]*=t,this[1]*=t,this},r.prototype.divide=function(t){return this[0]/=t,this[1]/=t,this},r.prototype.mix=function(i,r){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec2","mix","missingVector"));var n=1-r,o=r;return this[0]=this[0]*n+i[0]*o,this[1]=this[1]*n+i[1]*o,this},r.prototype.negate=function(){return this[0]=-this[0],this[1]=-this[1],this},r.prototype.dot=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec2","dot","missingVector"));return this[0]*i[0]+this[1]*i[1]},r.prototype.magnitudeSquared=function(){return this.dot(this)},r.prototype.magnitude=function(){return Math.sqrt(this.magnitudeSquared())},r.prototype.normalize=function(){var t=this.magnitude(),e=1/t;return this[0]*=e,this[1]*=e,this},r.prototype.distanceToSquared=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec2","distanceToSquared","missingVector"));var r=this[0]-i[0],n=this[1]-i[1];return r*r+n*n},r.prototype.distanceTo=function(i){if(!i)throw new e(t.logMessage(t.LEVEL_SEVERE,"Vec2","distanceTo","missingVector"));return Math.sqrt(this.distanceToSquared(i))},r.prototype.toVec3=function(){return new i(this[0],this[1],0)},r.prototype.swap=function(t){var e=this[0];return this[0]=t[0],t[0]=e,e=this[1],this[1]=t[1],t[1]=e,this},r.prototype.toString=function(){return"("+this[0]+", "+this[1]+")"},r}),i("util/Offset",["../geom/Vec2"],function(t){"use strict";var e=function(t,e,i,r){this.x=e,this.y=r,this.xUnits=t,this.yUnits=i};return e.prototype.clone=function(){return new e(this.xUnits,this.x,this.yUnits,this.y)},e.prototype.offsetForSize=function(e,i){var r,n;return r=this.xUnits===WorldWind.OFFSET_FRACTION?e*this.x:this.xUnits===WorldWind.OFFSET_INSET_PIXELS?e-this.x:this.x,n=this.yUnits===WorldWind.OFFSET_FRACTION?i*this.y:this.yUnits===WorldWind.OFFSET_INSET_PIXELS?i-this.y:this.y,new t(r,n)},e.prototype.toString=function(){return this.xUnits+" "+this.x+" "+this.yUnits+" "+this.y},e}),i("shapes/TextAttributes",["../util/Color","../util/Font","../util/Offset"],function(t,e,i){"use strict";var r=function(r){this._color=r?r._color.clone():t.WHITE.clone(),this._font=r?r._font:new e(14),this._offset=r?r._offset:new i(WorldWind.OFFSET_FRACTION,.5,WorldWind.OFFSET_FRACTION,0),this._scale=r?r._scale:1,this._depthTest=!!r&&r._depthTest,this._enableOutline=!r||r._enableOutline,this._outlineWidth=r?r._outlineWidth:4,this._outlineColor=r?r._outlineColor:new t(0,0,0,.5),this.stateKeyInvalid=!0};return r.prototype.computeStateKey=function(){return"c "+this._color.toHexString(!0)+" f "+this._font.toString()+" o "+this._offset.toString()+" s "+this._scale+" dt "+this._depthTest+" eo "+this._enableOutline+" ow "+this._outlineWidth+" oc "+this._outlineColor.toHexString(!0)},Object.defineProperties(r.prototype,{stateKey:{get:function(){return this.stateKeyInvalid&&(this._stateKey=this.computeStateKey(),this.stateKeyInvalid=!1),this._stateKey}},color:{get:function(){return this._color},set:function(t){this._color=t,this.stateKeyInvalid=!0}},font:{get:function(){return this._font},set:function(t){this._font=t,this.stateKeyInvalid=!0}},offset:{get:function(){return this._offset},set:function(t){this._offset=t,this.stateKeyInvalid=!0}},scale:{get:function(){return this._scale},set:function(t){this._scale=t,this.stateKeyInvalid=!0}},depthTest:{get:function(){return this._depthTest},set:function(t){this._depthTest=t,this.stateKeyInvalid=!0}},enableOutline:{get:function(){return this._enableOutline},set:function(t){this._enableOutline=t,this.stateKeyInvalid=!0}},outlineWidth:{get:function(){return this._outlineWidth},set:function(t){this._outlineWidth=t,this.stateKeyInvalid=!0}},outlineColor:{get:function(){return this._outlineColor},set:function(t){this._outlineColor=t,this.stateKeyInvalid=!0}}}),r}),i("shapes/AnnotationAttributes",["../util/Color","../util/Font","../util/Insets","../shapes/TextAttributes"],function(t,e,i,r){"use strict";var n=function(e){this._cornerRadius=e?e._cornerRadius:0,this._insets=e?e._insets:new i(0,0,0,0),this._backgroundColor=e?e._backgroundColor.clone():t.WHITE.clone(),this._leaderGapWidth=e?e._leaderGapWidth:40,this._leaderGapHeight=e?e._leaderGapHeight:30,this._opacity=e?e._opacity:1,this._scale=e?e._scale:1,this._drawLeader=!e||e._drawLeader,this._width=e?e._width:200,this._height=e?e._height:100,this._textAttributes=e?e._textAttributes:this.createDefaultTextAttributes(),this.stateKeyInvalid=!0};return n.prototype.computeStateKey=function(){return"wi "+this._width+" he "+this._height+" cr "+this._cornerRadius+" in "+this._insets.toString()+" bg "+this.backgroundColor.toHexString(!0)+" dl "+this.drawLeader+" lgw "+this.leaderGapWidth+" lgh "+this.leaderGapHeight+" op "+this.opacity+" ta "+this._textAttributes.stateKey+" sc "+this.scale},n.prototype.createDefaultTextAttributes=function(){var t=new r(null);return t.enableOutline=!1,t},Object.defineProperties(n.prototype,{width:{get:function(){return this._width},set:function(t){this._width=t,this.stateKeyInvalid=!0}},height:{get:function(){return this._height},set:function(t){this._height=t,this.stateKeyInvalid=!0}},cornerRadius:{get:function(){return this._cornerRadius},set:function(t){this._cornerRadius=t,this.stateKeyInvalid=!0}},insets:{get:function(){return this._insets},set:function(t){this._insets=t,this.stateKeyInvalid=!0}},backgroundColor:{get:function(){return this._backgroundColor},set:function(t){this._backgroundColor=t,this.stateKeyInvalid=!0}},textAttributes:{get:function(){return this._textAttributes},set:function(t){this._textAttributes=t,this.stateKeyInvalid=!0}},drawLeader:{get:function(){return this._drawLeader},set:function(t){this._drawLeader=t,this.stateKeyInvalid=!0}},leaderGapWidth:{get:function(){return this._leaderGapWidth},set:function(t){this._leaderGapWidth=t,this.stateKeyInvalid=!0}},leaderGapHeight:{get:function(){return this._leaderGapHeight},set:function(t){this._leaderGapHeight=t,this.stateKeyInvalid=!0}},opacity:{get:function(){return this._opacity},set:function(t){this._opacity=t,this.stateKeyInvalid=!0}},scale:{get:function(){return this._scale},set:function(t){this._scale=t,this.stateKeyInvalid=!0}},stateKey:{get:function(){return this.stateKeyInvalid&&(this._stateKey=this.computeStateKey(),this.stateKeyInvalid=!1),this._stateKey}}}),n}),i("shaders/GpuShader",["../error/ArgumentError","../util/Logger"],function(t,e){"use strict";var i=function(i,r,n){if(r!==i.VERTEX_SHADER&&r!==i.FRAGMENT_SHADER)throw new t(e.logMessage(e.LEVEL_SEVERE,"GpuShader","constructor","The specified shader type is unrecognized."));if(!n)throw new t(e.logMessage(e.LEVEL_SEVERE,"GpuShader","constructor","The specified shader source is null or undefined."));var o=i.createShader(r);if(!o)throw new t(e.logMessage(e.LEVEL_SEVERE,"GpuShader","constructor","Unable to create shader of type "+(r==i.VERTEX_SHADER?"VERTEX_SHADER.":"FRAGMENT_SHADER.")));if(!this.compile(i,o,r,n)){var s=i.getShaderInfoLog(o);throw i.deleteShader(o),new t(e.logMessage(e.LEVEL_SEVERE,"GpuShader","constructor","Unable to compile shader: "+s))}this.shaderId=o};return i.prototype.compile=function(t,e,i,r){return t.shaderSource(e,r),t.compileShader(e),t.getShaderParameter(e,t.COMPILE_STATUS)},i.prototype.dispose=function(t){this.shaderId&&(t.deleteShader(this.shaderId),delete this.shaderId)},i}),i("shaders/GpuProgram",["../error/ArgumentError","../util/Color","../shaders/GpuShader","../util/Logger"],function(t,e,i,r){"use strict";var n=function(e,n,o,s){if(!n||!o)throw new t(r.logMessage(r.LEVEL_SEVERE,"GpuProgram","constructor","The specified shader source is null or undefined."));var a,l,h;try{l=new i(e,e.VERTEX_SHADER,n),h=new i(e,e.FRAGMENT_SHADER,o)}catch(t){throw l&&l.dispose(e),h&&h.dispose(e),t}if(a=e.createProgram(),!a)throw new t(r.logMessage(r.LEVEL_SEVERE,"GpuProgram","constructor","Unable to create shader program."));
if(e.attachShader(a,l.shaderId),e.attachShader(a,h.shaderId),s)for(var u=0,c=s.length;u<c;u++)e.bindAttribLocation(a,u,s[u]);if(!this.link(e,a)){var d=e.getProgramInfoLog(a);throw e.detachShader(a,l.shaderId),e.detachShader(a,h.shaderId),e.deleteProgram(a),l.dispose(e),h.dispose(e),new t(r.logMessage(r.LEVEL_SEVERE,"GpuProgram","constructor","Unable to link shader program: "+d))}this.programId=a,this.attributeLocations={},this.uniformLocations={},this.vertexShader=l,this.fragmentShader=h,this.size=n.length+o.length,this.scratchArray=new Float32Array(16)};return n.prototype.dispose=function(t){this.programId&&(this.vertexShader&&t.detachShader(this.programId,this.vertexShader.shaderId),this.fragmentShader&&t.detachShader(this.programId,this.fragmentShader.shaderId),t.deleteProgram(this.programId),delete this.programId),this.vertexShader&&(this.vertexShader.dispose(t),delete this.vertexShader),this.fragmentShader&&(this.fragmentShader.dispose(t),delete this.fragmentShader),this.attributeLocations={},this.uniformLocations={}},n.prototype.attributeLocation=function(e,i){if(!i||0==i.length)throw new t(r.logMessage(r.LEVEL_SEVERE,"GpuProgram","attributeLocation","The specified attribute name is null, undefined or empty."));var n=this.attributeLocations[i];return n||(n=e.getAttribLocation(this.programId,i),this.attributeLocations[i]=n),n},n.prototype.uniformLocation=function(e,i){if(!i||0==i.length)throw new t(r.logMessage(r.LEVEL_SEVERE,"GpuProgram","uniformLocation","The specified uniform name is null, undefined or empty."));var n=this.uniformLocations[i];return n||(n=e.getUniformLocation(this.programId,i),this.uniformLocations[i]=n),n},n.prototype.link=function(t,e){return t.linkProgram(e),t.getProgramParameter(e,t.LINK_STATUS)},n.prototype.loadUniformMatrix=function(e,i,n){if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"GpuProgram","loadUniformMatrix","missingMatrix"));var o=i.columnMajorComponents(this.scratchArray);e.uniformMatrix4fv(n,!1,o)},n.prototype.loadUniformColor=function(e,i,n){if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"GpuProgram","loadUniformColor","missingColor"));var o=i.premultipliedComponents(this.scratchArray);e.uniform4f(n,o[0],o[1],o[2],o[3])},n.prototype.loadUniformColorComponents=function(t,e,i,r,n,o){t.uniform4f(o,e*n,i*n,r*n,n)},n}),i("shaders/BasicTextureProgram",["../error/ArgumentError","../util/Color","../shaders/GpuProgram","../util/Logger"],function(t,e,i,r){"use strict";var n=function(t){var e="attribute vec4 vertexPoint;\nattribute vec4 vertexTexCoord;\nattribute vec4 normalVector;\nuniform mat4 mvpMatrix;\nuniform mat4 mvInverseMatrix;\nuniform mat4 texCoordMatrix;\nuniform bool applyLighting;\nvarying vec2 texCoord;\nvarying vec4 normal;\nvoid main() {gl_Position = mvpMatrix * vertexPoint;\ntexCoord = (texCoordMatrix * vertexTexCoord).st;\nif (applyLighting) {normal = mvInverseMatrix * normalVector;}\n}",r="precision mediump float;\nuniform float opacity;\nuniform vec4 color;\nuniform bool enableTexture;\nuniform bool modulateColor;\nuniform sampler2D textureSampler;\nuniform bool applyLighting;\nvarying vec2 texCoord;\nvarying vec4 normal;\nvoid main() {\nvec4 textureColor = texture2D(textureSampler, texCoord);\nfloat ambient = 0.15; vec4 lightDirection = vec4(0, 0, 1, 0);\nif (enableTexture && !modulateColor)\n    gl_FragColor = textureColor * color * opacity;\nelse if (enableTexture && modulateColor)\n    gl_FragColor = color * floor(textureColor.a + 0.5);\nelse\n    gl_FragColor = color * opacity;\nif (gl_FragColor.a == 0.0) {discard;}\nif (applyLighting) {\n    vec4 n = normal * (gl_FrontFacing ? 1.0 : -1.0);\n    gl_FragColor.rgb *= clamp(ambient + dot(lightDirection, n), 0.0, 1.0);\n}\n}",n=["vertexPoint","normalVector","vertexTexCoord"];i.call(this,t,e,r,n),this.vertexPointLocation=this.attributeLocation(t,"vertexPoint"),this.normalVectorLocation=this.attributeLocation(t,"normalVector"),this.vertexTexCoordLocation=this.attributeLocation(t,"vertexTexCoord"),this.mvpMatrixLocation=this.uniformLocation(t,"mvpMatrix"),this.mvInverseMatrixLocation=this.uniformLocation(t,"mvInverseMatrix"),this.colorLocation=this.uniformLocation(t,"color"),this.textureEnabledLocation=this.uniformLocation(t,"enableTexture"),this.modulateColorLocation=this.uniformLocation(t,"modulateColor"),this.textureUnitLocation=this.uniformLocation(t,"textureSampler"),this.textureMatrixLocation=this.uniformLocation(t,"texCoordMatrix"),this.opacityLocation=this.uniformLocation(t,"opacity"),this.applyLightingLocation=this.uniformLocation(t,"applyLighting")};return n.key="WorldWindGpuBasicTextureProgram",n.prototype=Object.create(i.prototype),n.prototype.loadModelviewInverse=function(e,i){if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"BasicTextureProgram","loadModelviewInverse","missingMatrix"));this.loadUniformMatrix(e,i,this.mvInverseMatrixLocation)},n.prototype.loadModelviewProjection=function(e,i){if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"BasicTextureProgram","loadModelviewProjection","missingMatrix"));this.loadUniformMatrix(e,i,this.mvpMatrixLocation)},n.prototype.loadColor=function(e,i){if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"BasicTextureProgram","loadColor","missingColor"));this.loadUniformColor(e,i,this.colorLocation)},n.prototype.loadTextureEnabled=function(t,e){t.uniform1i(this.textureEnabledLocation,e?1:0)},n.prototype.loadModulateColor=function(t,e){t.uniform1i(this.modulateColorLocation,e?1:0)},n.prototype.loadTextureUnit=function(t,e){t.uniform1i(this.textureUnitLocation,e-t.TEXTURE0)},n.prototype.loadTextureMatrix=function(t,e){this.loadUniformMatrix(t,e,this.textureMatrixLocation)},n.prototype.loadOpacity=function(t,e){t.uniform1f(this.opacityLocation,e)},n.prototype.loadApplyLighting=function(t,e){t.uniform1i(this.applyLightingLocation,e)},n}),i("geom/Line",["../error/ArgumentError","../util/Logger","../geom/Vec3"],function(t,e,i){"use strict";var r=function(i,r){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"Line","constructor","Origin is null or undefined."));if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"Line","constructor","Direction is null or undefined."));this.origin=i,this.direction=r};return r.fromSegment=function(n,o){if(!n||!o)throw new t(e.logMessage(e.LEVEL_SEVERE,"Line","fromSegment","missingPoint"));var s=new i(n[0],n[1],n[2]),a=new i(o[0]-n[0],o[1]-n[1],o[2]-n[2]);return new r(s,a)},r.prototype.pointAt=function(i,r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"Line","pointAt","missingResult."));return r[0]=this.origin[0]+this.direction[0]*i,r[1]=this.origin[1]+this.direction[1]*i,r[2]=this.origin[2]+this.direction[2]*i,r},r.prototype.equals=function(t){return!!t&&(this.origin.equals(t.origin)&&this.direction.equals(t.direction))},r.prototype.clone=function(){var t=new r(new i(0,0,0),new i(0,0,0));return t.copy(this),t},r.prototype.copy=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"Line","copy","missingLine"));return this.origin.copy(i.origin),this.direction.copy(i.direction),this},r}),i("geom/Plane",["../error/ArgumentError","../geom/Line","../util/Logger","../geom/Vec3"],function(t,e,i,r){"use strict";var n=function(t,e,i,n){this.normal=new r(t,e,i),this.distance=n};return n.fromPoints=function(e,o,s){if(!e||!o||!s)throw new t(i.logMessage(i.LEVEL_SEVERE,"Plane","fromPoints","missingVector"));var a=new r(o[0],o[1],o[2]);a.subtract(e);var l=new r(s[0],s[1],s[2]);l.subtract(e),a.cross(l),a.normalize();var h=-a.dot(e);return new n(a[0],a[1],a[2],h)},n.prototype.dot=function(e){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"Plane","dot","missingVector"));return this.normal.dot(e)+this.distance},n.prototype.distanceToPoint=function(t){return this.dot(t)},n.prototype.transformByMatrix=function(e){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"Plane","transformByMatrix","missingMatrix"));var r=e[0]*this.normal[0]+e[1]*this.normal[1]+e[2]*this.normal[2]+e[3]*this.distance,n=e[4]*this.normal[0]+e[5]*this.normal[1]+e[6]*this.normal[2]+e[7]*this.distance,o=e[8]*this.normal[0]+e[9]*this.normal[1]+e[10]*this.normal[2]+e[11]*this.distance,s=e[12]*this.normal[0]+e[13]*this.normal[1]+e[14]*this.normal[2]+e[15]*this.distance;return this.normal[0]=r,this.normal[1]=n,this.normal[2]=o,this.distance=s,this},n.prototype.normalize=function(){var t=this.normal.magnitude();return 0===t?this:(this.normal.divide(t),this.distance/=t,this)},n.prototype.intersectsSegment=function(t,e){var i=this.dot(t),r=this.dot(e);return i*r<=0},n.prototype.intersectsSegmentAt=function(t,e,i){var r=this.dot(t),n=this.dot(e);if(0===r&&0===n)return i[0]=t[0],i[1]=t[1],i[2]=t[2],!0;if(r===n)return!1;var o=-r/(n-r),s=1-o;return i[0]=o*t[0]+s*e[0],i[1]=o*t[1]+s*e[1],i[2]=o*t[2]+s*e[2],r*n<=0},n.prototype.onSameSide=function(e,r){if(!e||!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"Plane","onSameSide","missingPoint"));var n=this.distanceToPoint(e),o=this.distanceToPoint(r);return n<0&&o<0?-1:n>0&&o>0?1:0},n.prototype.clip=function(n,o){if(!n||!o)throw new t(i.logMessage(i.LEVEL_SEVERE,"Plane","clip","missingPoint"));if(n.equals(o))return null;var s,a,l,h=e.fromSegment(n,o),u=this.normal.dot(h.direction);return 0===u?(s=this.dot(h.origin),0===s?[n,o]:null):(a=-this.dot(h.origin)/u,a<0||a>1?null:(l=h.pointAt(a,new r(0,0,0)),u>0?[l,o]:[n,l]))},n}),i("geom/Rectangle",["../util/Logger"],function(t){"use strict";var e=function(t,e,i,r){this.x=t,this.y=e,this.width=i,this.height=r};return e.prototype.set=function(t,e,i,r){this.x=t,this.y=e,this.width=i,this.height=r},e.prototype.getMinX=function(){return this.x},e.prototype.getMinY=function(){return this.y},e.prototype.getMaxX=function(){return this.x+this.width},e.prototype.getMaxY=function(){return this.y+this.height},e.prototype.containsPoint=function(t){return t[0]>=this.x&&t[0]<=this.x+this.width&&t[1]>=this.y&&t[1]<=this.y+this.height},e.prototype.intersects=function(t){return!(t.x+t.width<this.x)&&(!(t.x>this.x+this.width)&&(!(t.y+t.height<this.y)&&!(t.y>this.y+this.height)))},e.prototype.intersectsRectangles=function(t){if(t)for(var e=0;e<t.length;e++)if(this.intersects(t[e]))return!0;return!1},e.prototype.toString=function(){return this.x+", "+this.y+", "+this.width+", "+this.height},e}),i("util/WWMath",["../geom/Angle","../error/ArgumentError","../geom/Line","../util/Logger","../geom/Rectangle","../geom/Vec3"],function(t,e,i,r,n,o){"use strict";var s={clamp:function(t,e,i){return t<e?e:t>i?i:t},interpolate:function(t,e,i){return(1-t)*e+t*i},cbrt:function(t){return"function"==typeof Math.cbrt?Math.cbrt(t):Math.pow(t,1/3)},computeEllipsoidalGlobeIntersection:function(t,i,n,o){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeEllipsoidalGlobeIntersection","missingLine"));if(!o)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeEllipsoidalGlobeIntersection","missingResult"));var s,a=t.direction[0],l=t.direction[1],h=t.direction[2],u=t.origin[0],c=t.origin[1],d=t.origin[2],p=i/n,f=p*p,g=i*i,m=a*a+f*l*l+h*h,y=2*(u*a+f*c*l+d*h),E=u*u+f*c*c+d*d-g,v=y*y-4*m*E;return!(v<0)&&(s=(-y-Math.sqrt(v))/(2*m),o[0]=u+a*s,o[1]=c+l*s,o[2]=d+h*s,!0)},computeTriangleIntersection:function(t,i,n,o,s){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeTriangleIntersection","missingLine"));if(!i||!n||!o)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeTriangleIntersection","missingVertex"));if(!s)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeTriangleIntersection","missingResult"));var a=t.direction[0],l=t.direction[1],h=t.direction[2],u=t.origin[0],c=t.origin[1],d=t.origin[2],p=1e-5,f=n[0]-i[0],g=n[1]-i[1],m=n[2]-i[2],y=o[0]-i[0],E=o[1]-i[1],v=o[2]-i[2],_=l*v-h*E,b=h*y-a*v,w=a*E-l*y,S=f*_+g*b+m*w;if(S>-p&&S<p)return!1;var L=1/S,T=u-i[0],A=c-i[1],R=d-i[2],x=L*(T*_+A*b+R*w);if(x<-p||x>1+p)return!1;var C=A*m-R*g,M=R*f-T*m,P=T*g-A*f,O=L*(a*C+l*M+h*P);if(O<-p||x+O>1+p)return!1;var N=L*(y*C+E*M+v*P);return!(N<0)&&(s[0]=u+a*N,s[1]=c+l*N,s[2]=d+h*N,!0)},computeIndexedTrianglesIntersection:function(t,i,n,a){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeIndexedTrianglesIntersection","missingLine"));if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeIndexedTrianglesIntersection","missingPoints"));if(!n)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeIndexedTrianglesIntersection","missingIndices"));if(!a)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeIndexedTrianglesIntersection","missingResults"));for(var l=new o(0,0,0),h=new o(0,0,0),u=new o(0,0,0),c=new o(0,0,0),d=0,p=n.length;d<p;d+=3){var f=3*n[d],g=3*n[d+1],m=3*n[d+2];l[0]=i[f],l[1]=i[f+1],l[2]=i[f+2],h[0]=i[g],h[1]=i[g+1],h[2]=i[g+2],u[0]=i[m],u[1]=i[m+1],u[2]=i[m+2],s.computeTriangleIntersection(t,l,h,u,c)&&(a.push(c),c=new o(0,0,0))}return a.length>0},computeTriStripIntersections:function(t,i,n,s){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeTriStripIntersections","missingLine"));if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeTriStripIntersections","missingPoints"));if(!n)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeTriStripIntersections","missingIndices"));if(!s)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","computeTriStripIntersections","missingResults"));var a,l,h,u,c,d,p,f,g,m,y,E,v,_,b,w,S,L,T,A,R,x,C,M,P,O,N,I,D,k,F=t.direction[0],V=t.direction[1],G=t.direction[2],W=t.origin[0],B=t.origin[1],U=t.origin[2],K=1e-5;k=3*n[0],u=i[k++],c=i[k++],d=i[k],k=3*n[1],p=i[k++],f=i[k++],g=i[k];for(var j=2,z=n.length;j<z;j++)a=u,l=c,h=d,u=p,c=f,d=g,k=3*n[j],p=i[k++],f=i[k++],g=i[k],m=u-a,y=c-l,E=d-h,v=p-a,_=f-l,b=g-h,w=V*b-G*_,S=G*v-F*b,L=F*_-V*v,I=m*w+y*S+E*L,I>-K&&I<K||(D=1/I,T=W-a,A=B-l,R=U-h,P=D*(T*w+A*S+R*L),P<-K||P>1+K||(x=A*E-R*y,C=R*m-T*E,M=T*y-A*m,O=D*(F*x+V*C+G*M),O<-K||P+O>1+K||(N=D*(v*x+_*C+b*M),N>=0&&s.push(new o(W+F*N,B+V*N,U+G*N)))))},fabs:function(t){return t>=0?t:-t},fmod:function(t,e){return 0===e?0:t-Math.floor(t/e)*e},fract:function(t){return t-Math.floor(t)},mod:function(t,e){return(t%e+e)%e},max:function(t,e){return t>e?t:e},localCoordinateAxesAtPoint:function(t,i,n,o,s){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","localCoordinateAxesAtPoint","missingVector"));if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","localCoordinateAxesAtPoint","missingGlobe"));if(!n||!o||!s)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","localCoordinateAxesAtPoint","missingResult"));var a=t[0],l=t[1],h=t[2];i.surfaceNormalAtPoint(a,l,h,s),i.northTangentAtPoint(a,l,h,o),n.set(o[0],o[1],o[2]),n.cross(s),n.normalize(),o.set(s[0],s[1],s[2]),o.cross(n),o.normalize()},horizonDistanceForGlobeRadius:function(t,i){if(t<0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","horizontalDistanceForGlobeRadius","The specified globe radius is negative."));return t>0&&i>0?Math.sqrt(i*(2*t+i)):0},perspectiveNearDistanceForFarDistance:function(t,i,n){if(t<0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectiveNearDistanceForFarDistance","The specified distance is negative."));if(i<0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectiveNearDistanceForFarDistance","The specified resolution is negative."));if(n<1)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectiveNearDistanceForFarDistance","The specified depth bits is negative."));var o=(1<<n)-1;return t/(o/(1-i/t)-o+1)},perspectiveNearDistance:function(t,i,n){if(t<=0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectiveNearDistance","invalidWidth"));if(i<=0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectiveNearDistance","invalidHeight"));if(n<0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectiveNearDistance","The specified distance is negative."));var o=i/t;return 2*n/Math.sqrt(o*o+5)},perspectiveFrustumRectangle:function(t,i,o){if(t<=0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectiveFrustumRectangle","invalidWidth"));if(i<=0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectiveFrustumRectangle","invalidHeight"));if(o<0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectiveFrustumRectangle","The specified distance is negative."));var s=o,a=o*i/t;return new n(-s/2,-a/2,s,a)},perspectivePixelSize:function(t,i,n){if(t<=0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectivePixelSize","invalidWidth"));if(i<=0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectivePixelSize","invalidHeight"));if(n<0)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","perspectivePixelSize","The specified distance is negative."));var o=s.perspectiveFrustumRectangle(t,i,n).height;return o/i},boundingRectForUnitQuad:function(t){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"WWMath","boundingRectForUnitQuad","missingMatrix"));var i=t,o=i[3],s=i[7],a=i[0]+i[3],l=i[4]+i[7],h=i[1]+i[3],u=i[5]+i[7],c=i[0]+i[1]+i[3],d=i[4]+i[5]+i[7],p=Math.min(Math.min(o,a),Math.min(h,c)),f=Math.max(Math.max(o,a),Math.max(h,c)),g=Math.min(Math.min(s,l),Math.min(u,d)),m=Math.max(Math.max(s,l),Math.max(u,d));return new n(p,g,f-p,m-g)},isPowerOfTwo:function(t){return 0!=t&&0===(t&t-1)},signum:function(t){return t>0?1:t<0?-1:0},gudermannianInverse:function(e){return Math.log(Math.tan(Math.PI/4+e*t.DEGREES_TO_RADIANS/2))/Math.PI},epsg3857ToEpsg4326:function(e,i){var r=6378100,n=Math.PI/2-2*Math.atan(Math.exp(-i/r)),o=e/r;return[s.clamp(n*t.RADIANS_TO_DEGREES,-90,90),s.clamp(o*t.RADIANS_TO_DEGREES,-180,180)]},powerOfTwoFloor:function(t){var e=Math.floor(Math.log(t)/Math.log(2));return Math.pow(2,e)},normalizeAngle360:function(t){var e=t%360;return e>=0?e:e<0?360+e:360-e}};return s}),i("geom/Location",["../geom/Angle","../error/ArgumentError","../util/Logger","../geom/Plane","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o){"use strict";var s=function(t,e){this.latitude=t,this.longitude=e};return s.ZERO=new s(0,0),s.fromRadians=function(e,i){return new s(e*t.RADIANS_TO_DEGREES,i*t.RADIANS_TO_DEGREES)},s.prototype.copy=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","copy","missingLocation"));return this.latitude=t.latitude,this.longitude=t.longitude,this},s.prototype.set=function(t,e){return this.latitude=t,this.longitude=e,this},s.prototype.equals=function(t){return t&&t.latitude===this.latitude&&t.longitude===this.longitude},s.interpolateAlongPath=function(t,r,n,o,s){if(!n||!o)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","interpolateAlongPath","missingLocation"));if(!s)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","interpolateAlongPath","missingResult"));return t===WorldWind.GREAT_CIRCLE?this.interpolateGreatCircle(r,n,o,s):t&&t===WorldWind.RHUMB_LINE?this.interpolateRhumb(r,n,o,s):this.interpolateLinear(r,n,o,s)},s.interpolateGreatCircle=function(t,r,n,s){if(!r||!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","interpolateGreatCircle","missingLocation"));if(!s)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","interpolateGreatCircle","missingResult"));if(r.equals(n))return s.latitude=r.latitude,s.longitude=r.longitude,s;var a=o.clamp(t,0,1),l=this.greatCircleAzimuth(r,n),h=this.greatCircleDistance(r,n);return this.greatCircleLocation(r,l,a*h,s)},s.greatCircleAzimuth=function(r,n){if(!r||!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","greatCircleAzimuth","missingLocation"));var o,s,a,l=r.latitude*t.DEGREES_TO_RADIANS,h=n.latitude*t.DEGREES_TO_RADIANS,u=r.longitude*t.DEGREES_TO_RADIANS,c=n.longitude*t.DEGREES_TO_RADIANS;return l==h&&u==c?0:u==c?l>h?180:0:(s=Math.cos(h)*Math.sin(c-u),o=Math.cos(l)*Math.sin(h)-Math.sin(l)*Math.cos(h)*Math.cos(c-u),a=Math.atan2(s,o),isNaN(a)?0:a*t.RADIANS_TO_DEGREES)},s.greatCircleDistance=function(r,n){if(!r||!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","greatCircleDistance","missingLocation"));var o,s,a,l,h=r.latitude*t.DEGREES_TO_RADIANS,u=n.latitude*t.DEGREES_TO_RADIANS,c=r.longitude*t.DEGREES_TO_RADIANS,d=n.longitude*t.DEGREES_TO_RADIANS;return h==u&&c==d?0:(o=Math.sin((u-h)/2),s=Math.sin((d-c)/2),a=o*o+Math.cos(h)*Math.cos(u)*s*s,l=2*Math.asin(Math.sqrt(a)),isNaN(l)?0:l)},s.greatCircleLocation=function(r,n,o,s){if(!r)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","greatCircleLocation","missingLocation"));if(!s)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","greatCircleLocation","missingResult"));if(0==o)return s.latitude=r.latitude,s.longitude=r.longitude,s;var a,l,h=r.latitude*t.DEGREES_TO_RADIANS,u=r.longitude*t.DEGREES_TO_RADIANS,c=n*t.DEGREES_TO_RADIANS;return a=Math.asin(Math.sin(h)*Math.cos(o)+Math.cos(h)*Math.sin(o)*Math.cos(c)),l=u+Math.atan2(Math.sin(o)*Math.sin(c),Math.cos(h)*Math.cos(o)-Math.sin(h)*Math.sin(o)*Math.cos(c)),isNaN(a)||isNaN(l)?(s.latitude=r.latitude,s.longitude=r.longitude):(s.latitude=t.normalizedDegreesLatitude(a*t.RADIANS_TO_DEGREES),s.longitude=t.normalizedDegreesLongitude(l*t.RADIANS_TO_DEGREES)),s},s.interpolateRhumb=function(t,r,n,s){if(!r||!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","interpolateRhumb","missingLocation"));if(!s)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","interpolateRhumb","missingResult"));if(r.equals(n))return s.latitude=r.latitude,s.longitude=r.longitude,s;var a=o.clamp(t,0,1),l=this.rhumbAzimuth(r,n),h=this.rhumbDistance(r,n);return this.rhumbLocation(r,l,a*h,s)},s.rhumbAzimuth=function(r,n){if(!r||!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","rhumbAzimuth","missingLocation"));var s,a,l,h=r.latitude*t.DEGREES_TO_RADIANS,u=n.latitude*t.DEGREES_TO_RADIANS,c=r.longitude*t.DEGREES_TO_RADIANS,d=n.longitude*t.DEGREES_TO_RADIANS;return h==u&&c==d?0:(s=d-c,a=Math.log(Math.tan(u/2+Math.PI/4)/Math.tan(h/2+Math.PI/4)),o.fabs(s)>Math.PI&&(s=s>0?-(2*Math.PI-s):2*Math.PI+s),l=Math.atan2(s,a),isNaN(l)?0:l*t.RADIANS_TO_DEGREES)},s.rhumbDistance=function(r,n){if(!r||!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","rhumbDistance","missingLocation"));var s,a,l,h,u,c=r.latitude*t.DEGREES_TO_RADIANS,d=n.latitude*t.DEGREES_TO_RADIANS,p=r.longitude*t.DEGREES_TO_RADIANS,f=n.longitude*t.DEGREES_TO_RADIANS;return c==d&&p==f?0:(s=d-c,a=f-p,l=Math.log(Math.tan(d/2+Math.PI/4)/Math.tan(c/2+Math.PI/4)),h=s/l,(isNaN(l)||isNaN(h))&&(h=Math.cos(c)),o.fabs(a)>Math.PI&&(a=a>0?-(2*Math.PI-a):2*Math.PI+a),u=Math.sqrt(s*s+h*h*a*a),isNaN(u)?0:u)},s.rhumbLocation=function(r,n,s,a){if(!r)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","rhumbLocation","missingLocation"));if(!a)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","rhumbLocation","missingResult"));if(0==s)return a.latitude=r.latitude,a.longitude=r.longitude,a;var l,h,u=r.latitude*t.DEGREES_TO_RADIANS,c=r.longitude*t.DEGREES_TO_RADIANS,d=n*t.DEGREES_TO_RADIANS,p=u+s*Math.cos(d),f=Math.log(Math.tan(p/2+Math.PI/4)/Math.tan(u/2+Math.PI/4)),g=(p-u)/f;return(isNaN(f)||isNaN(g)||!isFinite(g))&&(g=Math.cos(u)),l=s*Math.sin(d)/g,o.fabs(p)>Math.PI/2&&(p=p>0?Math.PI-p:-Math.PI-p),h=o.fmod(c+l+Math.PI,2*Math.PI)-Math.PI,isNaN(p)||isNaN(h)?(a.latitude=r.latitude,a.longitude=r.longitude):(a.latitude=t.normalizedDegreesLatitude(p*t.RADIANS_TO_DEGREES),a.longitude=t.normalizedDegreesLongitude(h*t.RADIANS_TO_DEGREES)),a},s.interpolateLinear=function(t,r,n,s){if(!r||!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","interpolateLinear","missingLocation"));if(!s)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","interpolateLinear","missingResult"));if(r.equals(n))return s.latitude=r.latitude,s.longitude=r.longitude,s;var a=o.clamp(t,0,1),l=this.linearAzimuth(r,n),h=this.linearDistance(r,n);return this.linearLocation(r,l,a*h,s)},s.linearAzimuth=function(r,n){if(!r||!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","linearAzimuth","missingLocation"));var s,a,l,h=r.latitude*t.DEGREES_TO_RADIANS,u=n.latitude*t.DEGREES_TO_RADIANS,c=r.longitude*t.DEGREES_TO_RADIANS,d=n.longitude*t.DEGREES_TO_RADIANS;return h==u&&c==d?0:(s=d-c,a=u-h,o.fabs(s)>Math.PI&&(s=s>0?-(2*Math.PI-s):2*Math.PI+s),l=Math.atan2(s,a),isNaN(l)?0:l*t.RADIANS_TO_DEGREES)},s.linearDistance=function(r,n){if(!r||!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","linearDistance","missingLocation"));var s,a,l,h=r.latitude*t.DEGREES_TO_RADIANS,u=n.latitude*t.DEGREES_TO_RADIANS,c=r.longitude*t.DEGREES_TO_RADIANS,d=n.longitude*t.DEGREES_TO_RADIANS;return h==u&&c==d?0:(s=u-h,a=d-c,o.fabs(a)>Math.PI&&(a=a>0?-(2*Math.PI-a):2*Math.PI+a),l=Math.sqrt(s*s+a*a),isNaN(l)?0:l)},s.linearLocation=function(r,n,s,a){if(!r)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","linearLocation","missingLocation"));if(!a)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","linearLocation","missingResult"));if(0==s)return a.latitude=r.latitude,a.longitude=r.longitude,a;var l,h=r.latitude*t.DEGREES_TO_RADIANS,u=r.longitude*t.DEGREES_TO_RADIANS,c=n*t.DEGREES_TO_RADIANS,d=h+s*Math.cos(c);return o.fabs(d)>Math.PI/2&&(d=d>0?Math.PI-d:-Math.PI-d),l=o.fmod(u+s*Math.sin(c)+Math.PI,2*Math.PI)-Math.PI,isNaN(d)||isNaN(l)?(a.latitude=r.latitude,a.longitude=r.longitude):(a.latitude=t.normalizedDegreesLatitude(d*t.RADIANS_TO_DEGREES),a.longitude=t.normalizedDegreesLongitude(l*t.RADIANS_TO_DEGREES)),a},s.locationsCrossDateLine=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","locationsCrossDateline","missingLocation"));for(var r=null,n=0,s=t.length;n<s;n+=1){var a=t[n];if(null!=r&&o.signum(r.longitude)!=o.signum(a.longitude)){var l=Math.abs(r.longitude-a.longitude);if(l>180&&l<360)return!0}r=a}return!1},s.greatCircleArcExtremeLocations=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","greatCircleArcExtremeLocations","missingLocation"));for(var r=null,n=null,o=null,a=0,l=t.length;a<l;a+=1){var h=t[a];if(null!=o){var u=s.greatCircleArcExtremeForTwoLocations(o,h);if(null==u)continue;(null==r||r.latitude>u[0].latitude)&&(r=u[0]),(null==n||n.latitude<u[1].latitude)&&(n=u[1])}o=h}return[r,n]},s.greatCircleArcExtremeForTwoLocations=function(t,r){if(!t||!r)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","greatCircleArcExtremeForTwoLocations","missingLocation"));var n,a,l,h=null,u=null,c=90,d=-90,p=[t,r];for(n=0,a=p.length;n<a;n+=1)l=p[n],c>=l.latitude&&(c=l.latitude,h=l),d<=l.latitude&&(d=l.latitude,u=l);var f=s.greatCircleAzimuth(t,r),g=s.greatCircleDistance(t,r),m=s.greatCircleExtremeLocationsUsingAzimuth(t,f);for(n=0,a=m.length;n<a;n+=1){l=m[n];var y=s.greatCircleAzimuth(t,l),E=s.greatCircleDistance(t,l);o.signum(y)==o.signum(f)&&E>=0&&E<=g&&(c>=l.latitude&&(c=l.latitude,h=l),d<=l.latitude&&(d=l.latitude,u=l))}return[h,u]},s.greatCircleExtremeLocationsUsingAzimuth=function(r,n){if(!r)throw new e(i.logMessage(i.LEVEL_SEVERE,"Location","greatCircleArcExtremeLocationsUsingAzimuth","missingLocation"));var o=r.latitude,a=n*t.DEGREES_TO_RADIANS,l=-Math.tan(o)/Math.cos(a),h=Math.atan(l),u=h+Math.PI/2,c=h-Math.PI/2;return[s.greatCircleLocation(r,n,u,new s(0,0)),s.greatCircleLocation(r,n,c,new s(0,0))]},s.intersectionWithMeridian=function(t,e,i,o){var s=o.computePointFromLocation(t.latitude,t.longitude,new n(0,0,0)),a=o.computePointFromLocation(e.latitude,e.longitude,new n(0,0,0)),l=o.computePointFromLocation(90,i,new n(0,0,0)),h=o.computePointFromLocation(0,i,new n(0,0,0)),u=r.fromPoints(l,h,n.ZERO),c=new n(0,0,0);if(!u.intersectsSegmentAt(s,a,c))return null;var d=new WorldWind.Position(0,0,0);return o.computePositionFromPoint(c[0],c[1],c[2],d),d.latitude},s.meridianIntersection=function(t,e,i){var r=t.longitude<0?t.longitude+360:t.longitude,n=e.longitude<0?e.longitude+360:e.longitude;if(r===n)return null;var o=i<0?i+360:i,s=(e.latitude-t.latitude)/(n-r),a=t.latitude+s*(o-r);return a},s.poles={NONE:0,NORTH:1,SOUTH:2},s}),i("geom/Position",["../geom/Angle","../error/ArgumentError","../geom/Location","../util/Logger","../util/WWMath"],function(t,e,i,r,n){"use strict";var o=function(t,e,i){this.latitude=t,this.longitude=e,this.altitude=i};return o.ZERO=new o(0,0,0),o.fromRadians=function(e,i,r){return new o(e*t.RADIANS_TO_DEGREES,i*t.RADIANS_TO_DEGREES,r)},o.prototype.copy=function(t){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"Position","copy","missingPosition"));return this.latitude=t.latitude,this.longitude=t.longitude,this.altitude=t.altitude,this},o.prototype.equals=function(t){return t&&t.latitude===this.latitude&&t.longitude===this.longitude&&t.altitude===this.altitude},o.interpolateGreatCircle=function(t,o,s,a){if(!o||!s)throw new e(r.logMessage(r.LEVEL_SEVERE,"Position","interpolateGreatCircle","missingPosition"));if(!a)throw new e(r.logMessage(r.LEVEL_SEVERE,"Position","interpolateGreatCircle","missingResult"));var l=n.clamp(t,0,1);return a.altitude=n.interpolate(l,o.altitude,s.altitude),i.interpolateGreatCircle(l,o,s,a),a},o.interpolateRhumb=function(t,o,s,a){if(!o||!s)throw new e(r.logMessage(r.LEVEL_SEVERE,"Position","interpolateRhumb","missingPosition"));if(!a)throw new e(r.logMessage(r.LEVEL_SEVERE,"Position","interpolateRhumb","missingResult"));var l=n.clamp(t,0,1);return a.altitude=n.interpolate(l,o.altitude,s.altitude),i.interpolateRhumb(l,o,s,a),a},o.interpolateLinear=function(t,o,s,a){if(!o||!s)throw new e(r.logMessage(r.LEVEL_SEVERE,"Position","interpolateLinear","missingPosition"));if(!a)throw new e(r.logMessage(r.LEVEL_SEVERE,"Position","interpolateLinear","missingResult"));var l=n.clamp(t,0,1);return a.altitude=n.interpolate(l,o.altitude,s.altitude),i.interpolateLinear(l,o,s,a),a},o.prototype.toString=function(){return"("+this.latitude.toString()+"°, "+this.longitude.toString()+"°, "+this.altitude.toString()+")"},o}),i("render/Texture",["../error/ArgumentError","../util/Logger","../util/WWMath"],function(t,e,i){"use strict";var r=function(r,n,o){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"Texture","constructor","missingGlContext"));if(!n)throw new t(e.logMessage(e.LEVEL_SEVERE,"Texture","constructor","missingImage"));o||(o=r.CLAMP_TO_EDGE);var s=r.createTexture(),a=i.isPowerOfTwo(n.width)&&i.isPowerOfTwo(n.height);this.originalImageWidth=n.width,this.originalImageHeight=n.height,o!==r.REPEAT||a||(n=this.resizeImage(n),a=!0),this.imageWidth=n.width,this.imageHeight=n.height,this.size=n.width*n.height*4,r.bindTexture(r.TEXTURE_2D,s),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MIN_FILTER,a?r.LINEAR_MIPMAP_LINEAR:r.LINEAR),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_S,o),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_T,o),r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL,1),r.texImage2D(r.TEXTURE_2D,0,r.RGBA,r.RGBA,r.UNSIGNED_BYTE,n),r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL,0),a&&r.generateMipmap(r.TEXTURE_2D),this.textureId=s,this.creationTime=new Date,this.texParameters={},this.anisotropicFilterExt=r.getExtension("EXT_texture_filter_anisotropic")||r.getExtension("WEBKIT_EXT_texture_filter_anisotropic")};return r.prototype.setTexParameter=function(t,e){this.texParameters[t]=e},r.prototype.getTexParameter=function(t){return this.texParameters[t]},r.prototype.clearTexParameters=function(){this.texParameters={}},r.prototype.dispose=function(t){t.deleteTexture(this.textureId),delete this.textureId},r.prototype.bind=function(t){var e=t.currentGlContext;return e.bindTexture(e.TEXTURE_2D,this.textureId),this.applyTexParameters(t),t.frameStatistics.incrementTextureLoadCount(1),!0},r.prototype.applyTexParameters=function(t){var e=t.currentGlContext,i=this.texParameters[e.TEXTURE_MAG_FILTER]||e.LINEAR;e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,i),i===e.LINEAR&&this.anisotropicFilterExt&&e.texParameteri(e.TEXTURE_2D,this.anisotropicFilterExt.TEXTURE_MAX_ANISOTROPY_EXT,4)},r.prototype.resizeImage=function(t){var e=document.createElement("canvas");e.width=i.powerOfTwoFloor(t.width),e.height=i.powerOfTwoFloor(t.height);var r=e.getContext("2d");return r.drawImage(t,0,0,e.width,e.height),e},r}),i("geom/Matrix",["../geom/Angle","../error/ArgumentError","../util/Logger","../geom/Plane","../geom/Position","../geom/Rectangle","../render/Texture","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o,s,a,l){"use strict";var h=function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g){this[0]=t,this[1]=e,this[2]=i,this[3]=r,this[4]=n,this[5]=o,this[6]=s,this[7]=a,this[8]=l,this[9]=h,this[10]=u,this[11]=c,this[12]=d,this[13]=p,this[14]=f,this[15]=g};return h.prototype=new Float64Array(16),h.fromIdentity=function(){return new h(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)},h.principalAxesFromPoints=function(t,r,n,o){if(!t||t.length<1)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","principalAxesFromPoints","missingPoints"));
if(!r||!n||!o)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","principalAxesFromPoints","An axis argument is null or undefined."));var s=h.fromIdentity();s.setToCovarianceOfPoints(t),s.eigensystemFromSymmetricMatrix(r,n,o),r.normalize(),n.normalize(),o.normalize()},h.prototype.set=function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g){return this[0]=t,this[1]=e,this[2]=i,this[3]=r,this[4]=n,this[5]=o,this[6]=s,this[7]=a,this[8]=l,this[9]=h,this[10]=u,this[11]=c,this[12]=d,this[13]=p,this[14]=f,this[15]=g,this},h.prototype.setToIdentity=function(){this[0]=1,this[1]=0,this[2]=0,this[3]=0,this[4]=0,this[5]=1,this[6]=0,this[7]=0,this[8]=0,this[9]=0,this[10]=1,this[11]=0,this[12]=0,this[13]=0,this[14]=0,this[15]=1},h.prototype.copy=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","copy","missingMatrix"));this[0]=t[0],this[1]=t[1],this[2]=t[2],this[3]=t[3],this[4]=t[4],this[5]=t[5],this[6]=t[6],this[7]=t[7],this[8]=t[8],this[9]=t[9],this[10]=t[10],this[11]=t[11],this[12]=t[12],this[13]=t[13],this[14]=t[14],this[15]=t[15]},h.prototype.clone=function(){var t=h.fromIdentity();return t.copy(this),t},h.prototype.equals=function(t){return t&&this[0]==t[0]&&this[1]==t[1]&&this[2]==t[2]&&this[3]==t[3]&&this[4]==t[4]&&this[5]==t[5]&&this[6]==t[6]&&this[7]==t[7]&&this[8]==t[8]&&this[9]==t[9]&&this[10]==t[10]&&this[11]==t[11]&&this[12]==t[12]&&this[13]==t[13]&&this[14]==t[14]&&this[15]==t[15]},h.prototype.columnMajorComponents=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","columnMajorComponents","missingResult"));return t[0]=this[0],t[1]=this[4],t[2]=this[8],t[3]=this[12],t[4]=this[1],t[5]=this[5],t[6]=this[9],t[7]=this[13],t[8]=this[2],t[9]=this[6],t[10]=this[10],t[11]=this[14],t[12]=this[3],t[13]=this[7],t[14]=this[11],t[15]=this[15],t},h.prototype.setToTranslation=function(t,e,i){return this[0]=1,this[1]=0,this[2]=0,this[3]=t,this[4]=0,this[5]=1,this[6]=0,this[7]=e,this[8]=0,this[9]=0,this[10]=1,this[11]=i,this[12]=0,this[13]=0,this[14]=0,this[15]=1,this},h.prototype.setTranslation=function(t,e,i){return this[3]=t,this[7]=e,this[11]=i,this},h.prototype.setToScale=function(t,e,i){return this[0]=t,this[1]=0,this[2]=0,this[3]=0,this[4]=0,this[5]=e,this[6]=0,this[7]=0,this[8]=0,this[9]=0,this[10]=i,this[11]=0,this[12]=0,this[13]=0,this[14]=0,this[15]=1,this},h.prototype.setScale=function(t,e,i){return this[0]=t,this[5]=e,this[10]=i,this},h.prototype.setToTransposeOfMatrix=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","setToTransposeOfMatrix","missingMatrix"));return this[0]=t[0],this[1]=t[4],this[2]=t[8],this[3]=t[12],this[4]=t[1],this[5]=t[5],this[6]=t[9],this[7]=t[13],this[8]=t[2],this[9]=t[6],this[10]=t[10],this[11]=t[14],this[12]=t[3],this[13]=t[7],this[14]=t[11],this[15]=t[15],this},h.prototype.setToMultiply=function(t,r){if(!t||!r)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","setToMultiply","missingMatrix"));var n=t,o=r;return this[0]=n[0]*o[0]+n[1]*o[4]+n[2]*o[8]+n[3]*o[12],this[1]=n[0]*o[1]+n[1]*o[5]+n[2]*o[9]+n[3]*o[13],this[2]=n[0]*o[2]+n[1]*o[6]+n[2]*o[10]+n[3]*o[14],this[3]=n[0]*o[3]+n[1]*o[7]+n[2]*o[11]+n[3]*o[15],this[4]=n[4]*o[0]+n[5]*o[4]+n[6]*o[8]+n[7]*o[12],this[5]=n[4]*o[1]+n[5]*o[5]+n[6]*o[9]+n[7]*o[13],this[6]=n[4]*o[2]+n[5]*o[6]+n[6]*o[10]+n[7]*o[14],this[7]=n[4]*o[3]+n[5]*o[7]+n[6]*o[11]+n[7]*o[15],this[8]=n[8]*o[0]+n[9]*o[4]+n[10]*o[8]+n[11]*o[12],this[9]=n[8]*o[1]+n[9]*o[5]+n[10]*o[9]+n[11]*o[13],this[10]=n[8]*o[2]+n[9]*o[6]+n[10]*o[10]+n[11]*o[14],this[11]=n[8]*o[3]+n[9]*o[7]+n[10]*o[11]+n[11]*o[15],this[12]=n[12]*o[0]+n[13]*o[4]+n[14]*o[8]+n[15]*o[12],this[13]=n[12]*o[1]+n[13]*o[5]+n[14]*o[9]+n[15]*o[13],this[14]=n[12]*o[2]+n[13]*o[6]+n[14]*o[10]+n[15]*o[14],this[15]=n[12]*o[3]+n[13]*o[7]+n[14]*o[11]+n[15]*o[15],this},h.prototype.setToCovarianceOfPoints=function(t){if(!t||t.length<1)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","setToCovarianceOfPoints","missingArray"));var r,n,o,s,l=0,h=0,u=0,c=0,d=0,p=0,f=0,g=new a(0,0,0);r=a.averageOfBuffer(t,new a(0,0,0));for(var m=0,y=t.length/3;m<y;m++)g[0]=t[3*m],g[1]=t[3*m+1],g[2]=t[3*m+2],n=g[0]-r[0],o=g[1]-r[1],s=g[2]-r[2],++l,h+=n*n,u+=o*o,c+=s*s,d+=n*o,p+=n*s,f+=o*s;return this[0]=h/l,this[1]=d/l,this[2]=p/l,this[3]=0,this[4]=d/l,this[5]=u/l,this[6]=f/l,this[7]=0,this[8]=p/l,this[9]=f/l,this[10]=c/l,this[11]=0,this[12]=0,this[13]=0,this[14]=0,this[15]=0,this},h.prototype.multiplyByTranslation=function(t,e,i){return this.multiply(1,0,0,t,0,1,0,e,0,0,1,i,0,0,0,1),this},h.prototype.multiplyByRotation=function(e,i,r,n){var o=Math.cos(n*t.DEGREES_TO_RADIANS),s=Math.sin(n*t.DEGREES_TO_RADIANS);return this.multiply(o+(1-o)*e*e,(1-o)*e*i-s*r,(1-o)*e*r+s*i,0,(1-o)*e*i+s*r,o+(1-o)*i*i,(1-o)*i*r-s*e,0,(1-o)*e*r-s*i,(1-o)*i*r+s*e,o+(1-o)*r*r,0,0,0,0,1),this},h.prototype.multiplyByScale=function(t,e,i){return this.multiply(t,0,0,0,0,e,0,0,0,0,i,0,0,0,0,1),this},h.prototype.setToUnitYFlip=function(){return this[0]=1,this[1]=0,this[2]=0,this[3]=0,this[4]=0,this[5]=-1,this[6]=0,this[7]=1,this[8]=0,this[9]=0,this[10]=1,this[11]=0,this[12]=0,this[13]=0,this[14]=0,this[15]=1,this},h.prototype.multiplyByLocalCoordinateTransform=function(t,r){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","multiplyByLocalCoordinateTransform","Origin vector is null or undefined"));if(!r)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","multiplyByLocalCoordinateTransform","missingGlobe"));var n=new a(0,0,0),o=new a(0,0,0),s=new a(0,0,0);return l.localCoordinateAxesAtPoint(t,r,n,o,s),this.multiply(n[0],o[0],s[0],t[0],n[1],o[1],s[1],t[1],n[2],o[2],s[2],t[2],0,0,0,1),this},h.prototype.multiplyByTextureTransform=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","multiplyByTextureTransform","missingTexture"));var r=t.originalImageWidth/t.imageWidth,n=t.originalImageHeight/t.imageHeight;return this.multiply(r,0,0,0,0,-n,0,n,0,0,1,0,0,0,0,1),this},h.prototype.extractTranslation=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","extractTranslation","missingResult"));return t[0]=this[3],t[1]=this[7],t[2]=this[11],t},h.prototype.extractRotationAngles=function(r){if(!r)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","extractRotationAngles","missingResult"));var n=Math.atan2(this[6],this[10]),o=Math.atan2(-this[2],Math.sqrt(this[0]*this[0]+this[1]*this[1])),s=Math.cos(n),a=Math.sin(n),l=Math.atan2(a*this[8]-s*this[4],s*this[5]-a*this[9]);return r[0]=n*t.RADIANS_TO_DEGREES,r[1]=o*t.RADIANS_TO_DEGREES,r[2]=l*t.RADIANS_TO_DEGREES,r},h.prototype.multiplyByFirstPersonModelview=function(r,n,o,s,h){if(!r)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","multiplyByFirstPersonModelview","missingPosition"));if(!h)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","multiplyByFirstPersonModelview","missingGlobe"));var u,c,d,p,f,g,m,y,E,v,_,b,w,S,L=new a(0,0,0),T=new a(0,0,0),A=new a(0,0,0),R=new a(0,0,0);return u=Math.cos(s*t.DEGREES_TO_RADIANS),c=Math.sin(s*t.DEGREES_TO_RADIANS),this.multiply(u,c,0,0,-c,u,0,0,0,0,1,0,0,0,0,1),u=Math.cos(o*t.DEGREES_TO_RADIANS),c=Math.sin(o*t.DEGREES_TO_RADIANS),this.multiply(1,0,0,0,0,u,c,0,0,-c,u,0,0,0,0,1),u=Math.cos(n*t.DEGREES_TO_RADIANS),c=Math.sin(n*t.DEGREES_TO_RADIANS),this.multiply(u,-c,0,0,c,u,0,0,0,0,1,0,0,0,0,1),h.computePointFromPosition(r.latitude,r.longitude,r.altitude,L),d=L[0],p=L[1],f=L[2],l.localCoordinateAxesAtPoint(L,h,T,A,R),g=T[0],m=T[1],y=T[2],E=A[0],v=A[1],_=A[2],b=R[0],w=R[1],S=R[2],this.multiply(g,m,y,-g*d-m*p-y*f,E,v,_,-E*d-v*p-_*f,b,w,S,-b*d-w*p-S*f,0,0,0,1),this},h.prototype.multiplyByLookAtModelview=function(t,r,n,o,s,a){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","multiplyByLookAtModelview","missingPosition"));if(r<0)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","multiplyByLookAtModelview","Range is less than zero"));if(!a)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","multiplyByLookAtModelview","missingGlobe"));return this.multiplyByTranslation(0,0,-r),this.multiplyByFirstPersonModelview(t,n,o,s,a),this},h.prototype.setToPerspectiveProjection=function(t,r,n,o){if(t<=0)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","setToPerspectiveProjection","invalidWidth"));if(r<=0)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","setToPerspectiveProjection","invalidHeight"));if(n===o)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","setToPerspectiveProjection","Near and far distance are the same."));if(n<=0||o<=0)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","setToPerspectiveProjection","Near or far distance is less than or equal to zero."));var s=l.perspectiveFrustumRectangle(t,r,n),a=s.getMinX(),h=s.getMaxX(),u=s.getMinY(),c=s.getMaxY();return this[0]=2*n/(h-a),this[1]=0,this[2]=(h+a)/(h-a),this[3]=0,this[4]=0,this[5]=2*n/(c-u),this[6]=(c+u)/(c-u),this[7]=0,this[8]=0,this[9]=0,this[10]=-(o+n)/(o-n),this[11]=-2*n*o/(o-n),this[12]=0,this[13]=0,this[14]=-1,this[15]=0,this},h.prototype.setToScreenProjection=function(t,r){if(t<=0)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","setToScreenProjection","invalidWidth"));if(r<=0)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","setToScreenProjection","invalidHeight"));return this[0]=2/t,this[1]=0,this[2]=0,this[3]=-1,this[4]=0,this[5]=2/r,this[6]=0,this[7]=-1,this[8]=0,this[9]=0,this[10]=2,this[11]=-1,this[12]=0,this[13]=0,this[14]=0,this[15]=1,this},h.prototype.extractEyePoint=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","extractEyePoint","missingResult"));return t[0]=-(this[0]*this[3])-this[4]*this[7]-this[8]*this[11],t[1]=-(this[1]*this[3])-this[5]*this[7]-this[9]*this[11],t[2]=-(this[2]*this[3])-this[6]*this[7]-this[10]*this[11],t},h.prototype.extractForwardVector=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","extractForwardVector","missingResult"));return t[0]=-this[8],t[1]=-this[9],t[2]=-this[10],t},h.prototype.extractViewingParameters=function(r,o,s,a){if(!r)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","extractViewingParameters","The specified origin is null or undefined."));if(!s)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","extractViewingParameters","missingGlobe"));if(!a)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","extractViewingParameters","missingResult"));var l,u,c,d,p,f,g,m,y,E=new n(0,0,0),v=h.fromIdentity();return s.computePositionFromPoint(r[0],r[1],r[2],E),v.copy(this),v.multiplyByLocalCoordinateTransform(r,s),l=-v[11],u=v[10],c=Math.sqrt(v[2]*v[2]+v[6]*v[6]),d=Math.atan2(c,u)*t.RADIANS_TO_DEGREES,p=Math.cos(o*t.DEGREES_TO_RADIANS),f=Math.sin(o*t.DEGREES_TO_RADIANS),g=p*v[0]-f*v[4],m=f*v[5]-p*v[1],y=Math.atan2(m,g)*t.RADIANS_TO_DEGREES,a.origin=E,a.range=l,a.heading=y,a.tilt=d,a.roll=o,a},h.prototype.offsetProjectionDepth=function(t){return this[10]*=1+t,this},h.prototype.multiplyMatrix=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","multiplyMatrix","missingMatrix"));var r,n,o,s,a=this,l=t;return r=a[0],n=a[1],o=a[2],s=a[3],a[0]=r*l[0]+n*l[4]+o*l[8]+s*l[12],a[1]=r*l[1]+n*l[5]+o*l[9]+s*l[13],a[2]=r*l[2]+n*l[6]+o*l[10]+s*l[14],a[3]=r*l[3]+n*l[7]+o*l[11]+s*l[15],r=a[4],n=a[5],o=a[6],s=a[7],a[4]=r*l[0]+n*l[4]+o*l[8]+s*l[12],a[5]=r*l[1]+n*l[5]+o*l[9]+s*l[13],a[6]=r*l[2]+n*l[6]+o*l[10]+s*l[14],a[7]=r*l[3]+n*l[7]+o*l[11]+s*l[15],r=a[8],n=a[9],o=a[10],s=a[11],a[8]=r*l[0]+n*l[4]+o*l[8]+s*l[12],a[9]=r*l[1]+n*l[5]+o*l[9]+s*l[13],a[10]=r*l[2]+n*l[6]+o*l[10]+s*l[14],a[11]=r*l[3]+n*l[7]+o*l[11]+s*l[15],r=a[12],n=a[13],o=a[14],s=a[15],a[12]=r*l[0]+n*l[4]+o*l[8]+s*l[12],a[13]=r*l[1]+n*l[5]+o*l[9]+s*l[13],a[14]=r*l[2]+n*l[6]+o*l[10]+s*l[14],a[15]=r*l[3]+n*l[7]+o*l[11]+s*l[15],this},h.prototype.multiply=function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g){var m,y,E,v,_=this;return m=_[0],y=_[1],E=_[2],v=_[3],_[0]=m*t+y*n+E*l+v*d,_[1]=m*e+y*o+E*h+v*p,_[2]=m*i+y*s+E*u+v*f,_[3]=m*r+y*a+E*c+v*g,m=_[4],y=_[5],E=_[6],v=_[7],_[4]=m*t+y*n+E*l+v*d,_[5]=m*e+y*o+E*h+v*p,_[6]=m*i+y*s+E*u+v*f,_[7]=m*r+y*a+E*c+v*g,m=_[8],y=_[9],E=_[10],v=_[11],_[8]=m*t+y*n+E*l+v*d,_[9]=m*e+y*o+E*h+v*p,_[10]=m*i+y*s+E*u+v*f,_[11]=m*r+y*a+E*c+v*g,m=_[12],y=_[13],E=_[14],v=_[15],_[12]=m*t+y*n+E*l+v*d,_[13]=m*e+y*o+E*h+v*p,_[14]=m*i+y*s+E*u+v*f,_[15]=m*r+y*a+E*c+v*g,this},h.prototype.invertMatrix=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","invertMatrix","missingMatrix"));var r=[[],[],[],[]];r[0][0]=t[0],r[0][1]=t[1],r[0][2]=t[2],r[0][3]=t[3],r[1][0]=t[4],r[1][1]=t[5],r[1][2]=t[6],r[1][3]=t[7],r[2][0]=t[8],r[2][1]=t[9],r[2][2]=t[10],r[2][3]=t[11],r[3][0]=t[12],r[3][1]=t[13],r[3][2]=t[14],r[3][3]=t[15];var n,o,s=[],a=h.ludcmp(r,s);for(n=0;n<4;n+=1)a*=r[n][n];if(Math.abs(a)<1e-8)return null;var l=[[],[],[],[]],u=[];for(o=0;o<4;o+=1){for(n=0;n<4;n+=1)u[n]=0;for(u[o]=1,h.lubksb(r,s,u),n=0;n<4;n+=1)l[n][o]=u[n]}return this[0]=l[0][0],this[1]=l[0][1],this[2]=l[0][2],this[3]=l[0][3],this[4]=l[1][0],this[5]=l[1][1],this[6]=l[1][2],this[7]=l[1][3],this[8]=l[2][0],this[9]=l[2][1],this[10]=l[2][2],this[11]=l[2][3],this[12]=l[3][0],this[13]=l[3][1],this[14]=l[3][2],this[15]=l[3][3],this},h.lubksb=function(t,e,i){var r,n,o,s=-1;for(r=0;r<4;r+=1){var a=e[r];if(o=i[a],i[a]=i[r],s!=-1)for(n=s;n<=r-1;n+=1)o-=t[r][n]*i[n];else 0!=o&&(s=r);i[r]=o}for(r=3;r>=0;r-=1){for(o=i[r],n=r+1;n<4;n+=1)o-=t[r][n]*i[n];i[r]=o/t[r][r]}},h.ludcmp=function(t,e){var i,r,n,o,s,a,l,h,u=1e-20,c=[],d=1;for(r=0;r<4;r+=1){for(s=0,n=0;n<4;n+=1)(i=Math.abs(t[r][n]))>s&&(s=i);if(0==s)return 0;c[r]=1/s}for(n=0;n<4;n+=1){for(r=0;r<n;r+=1){for(a=t[r][n],o=0;o<r;o+=1)a-=t[r][o]*t[o][n];t[r][n]=a}for(s=0,l=-1,r=n;r<4;r+=1){for(a=t[r][n],o=0;o<n;o++)a-=t[r][o]*t[o][n];t[r][n]=a,(h=c[r]*Math.abs(a))>=s&&(s=h,l=r)}if(n!=l){for(o=0;o<4;o+=1)h=t[l][o],t[l][o]=t[n][o],t[n][o]=h;d=-d,c[l]=c[n]}if(e[n]=l,0==t[n][n]&&(t[n][n]=u),3!=n)for(h=1/t[n][n],r=n+1;r<4;r+=1)t[r][n]*=h}return d},h.prototype.invertOrthonormalMatrix=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","invertOrthonormalMatrix","missingMatrix"));var r=t;return this[0]=r[0],this[1]=r[4],this[2]=r[8],this[3]=0-r[0]*r[3]-r[4]*r[7]-r[8]*r[11],this[4]=r[1],this[5]=r[5],this[6]=r[9],this[7]=0-r[1]*r[3]-r[5]*r[7]-r[9]*r[11],this[8]=r[2],this[9]=r[6],this[10]=r[10],this[11]=0-r[2]*r[3]-r[6]*r[7]-r[10]*r[11],this[12]=0,this[13]=0,this[14]=0,this[15]=1,this},h.prototype.eigensystemFromSymmetricMatrix=function(t,r,n){if(!t||!r||!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","eigensystemFromSymmetricMatrix","missingResult"));if(this[1]!=this[4]||this[2]!=this[8]||this[6]!=this[9])throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","eigensystemFromSymmetricMatrix","Matrix is not symmetric"));for(var o,s,a,h,u,c,d,p,f,g,m,y=1e-10,E=this[0],v=this[1],_=this[2],b=this[5],w=this[6],S=this[10],L=[[1,0,0],[0,1,0],[0,0,1]],T=32,A=0;A<T&&!(l.fabs(v)<y&&l.fabs(_)<y&&l.fabs(w)<y);A++){if(0!=v)for(o=.5*(b-E)/v,s=o*o,a=s+1,h=a!=s?(o<0?-1:1)*(Math.sqrt(a)-l.fabs(o)):.5/o,u=1/Math.sqrt(h*h+1),c=u*h,E-=h*v,b+=h*v,v=0,d=u*_-c*w,w=c*_+u*w,_=d,p=0;p<3;p++)d=u*L[p][0]-c*L[p][1],L[p][1]=c*L[p][0]+u*L[p][1],L[p][0]=d;if(0!=_)for(o=.5*(S-E)/_,s=o*o,a=s+1,h=a!=s?(o<0?-1:1)*(Math.sqrt(a)-l.fabs(o)):.5/o,u=1/Math.sqrt(h*h+1),c=u*h,E-=h*_,S+=h*_,_=0,d=u*v-c*w,w=c*v+u*w,v=d,p=0;p<3;p++)d=u*L[p][0]-c*L[p][2],L[p][2]=c*L[p][0]+u*L[p][2],L[p][0]=d;if(0!=w)for(o=.5*(S-b)/w,s=o*o,a=s+1,h=a!=s?(o<0?-1:1)*(Math.sqrt(a)-l.fabs(o)):.5/o,u=1/Math.sqrt(h*h+1),c=u*h,b-=h*w,S+=h*w,w=0,d=u*v-c*_,_=c*v+u*_,v=d,p=0;p<3;p++)d=u*L[p][1]-c*L[p][2],L[p][2]=c*L[p][1]+u*L[p][2],L[p][1]=d}f=0,g=1,m=2,E<b&&(d=E,E=b,b=d,d=f,f=g,g=d),b<S&&(d=b,b=S,S=d,d=g,g=m,m=d),E<b&&(d=E,E=b,b=d,d=f,f=g,g=d),t[0]=L[0][f],t[1]=L[1][f],t[2]=L[2][f],r[0]=L[0][g],r[1]=L[1][g],r[2]=L[2][g],n[0]=L[0][m],n[1]=L[1][m],n[2]=L[2][m],t.normalize(),r.normalize(),n.normalize(),t.multiply(E),r.multiply(b),n.multiply(S)},h.prototype.upper3By3=function(){var t=h.fromIdentity();return t[0]=this[0],t[1]=this[1],t[2]=this[2],t[4]=this[4],t[5]=this[5],t[6]=this[6],t[8]=this[8],t[9]=this[9],t[10]=this[10],t},h.prototype.unProject=function(t,r,n){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","unProject","missingPoint"));if(!r)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","unProject","missingViewport"));if(!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"Matrix","unProject","missingResult"));var o=t[0],s=t[1],a=t[2];if(o=(o-r.x)/r.width,s=(s-r.y)/r.height,o=2*o-1,s=2*s-1,a=2*a-1,a<-1||a>1)return!1;var l=this[0]*o+this[1]*s+this[2]*a+this[3],h=this[4]*o+this[5]*s+this[6]*a+this[7],u=this[8]*o+this[9]*s+this[10]*a+this[11],c=this[12]*o+this[13]*s+this[14]*a+this[15];return 0!==c&&(n[0]=l/c,n[1]=h/c,n[2]=u/c,!0)},h}),i("pick/PickedObject",[],function(){"use strict";var t=function(t,e,i,r,n){this.color=t,this.userObject=e,this.position=i,this.parentLayer=r,this.isTerrain=n,this.isOnTop=!1};return t}),i("error/UnsupportedOperationError",["../error/AbstractError"],function(t){"use strict";var e=function(e){t.call(this,"UnsupportedOperationError",e);var i;try{throw new Error}catch(t){i=t.stack}this.stack=i};return e.prototype=Object.create(t.prototype),e}),i("render/Renderable",["../util/Logger","../error/UnsupportedOperationError"],function(t,e){"use strict";var i=function(){this.displayName="Renderable",this.enabled=!0,this.pickDelegate=null,this.userProperties={},this.timeRange=[]};return i.prototype.render=function(i){throw new e(t.logMessage(t.LEVEL_SEVERE,"Renderable","render","abstractInvocation"))},i}),i("shapes/Annotation",["../shapes/AnnotationAttributes","../error/ArgumentError","../shaders/BasicTextureProgram","../util/Color","../util/Font","../util/Insets","../util/Logger","../geom/Matrix","../util/Offset","../pick/PickedObject","../render/Renderable","../shapes/TextAttributes","../geom/Vec2","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f){"use strict";var g=function(i,r){if(!i)throw new e(s.logMessage(s.LEVEL_SEVERE,"Annotation","constructor","missingPosition"));u.call(this),this.position=i,this.attributes=r?r:new t(null),this.altitudeMode=WorldWind.ABSOLUTE,this.layer=null,this.lastStateKey=null,this.calloutTransform=a.fromIdentity(),this.calloutOffset=new WorldWind.Offset(WorldWind.OFFSET_FRACTION,.5,WorldWind.OFFSET_FRACTION,0),this.label="",this.labelTexture=null,this.labelTransform=a.fromIdentity(),this.placePoint=new p(0,0,0),this.depthOffset=-2.05,this.calloutPoints=null};return g.matrix=a.fromIdentity(),g.screenPoint=new p(0,0,0),g.scratchPoint=new p(0,0,0),g.prototype=Object.create(u.prototype),Object.defineProperties(g.prototype,{text:{get:function(){return this.label},set:function(t){this.label=t,this.lastStateKey=null}}}),g.prototype.renderOrdered=function(t){if(this.drawOrderedAnnotation(t),t.pickingMode){var e=new h(this.pickColor.clone(),this,this.position,this.layer,!1);t.pickPoint&&this.labelBounds.containsPoint(t.convertPointToViewport(t.pickPoint,g.scratchPoint))&&(e.labelPicked=!0),t.resolvePick(e)}},g.prototype.clone=function(){var t=new g(this.position);return t.copy(this),t.pickDelegate=this.pickDelegate?this.pickDelegate:this,t},g.prototype.copy=function(t){return this.position=t.position,this.enabled=t.enabled,this.attributes=t.attributes,this.label=t.label,this.altitudeMode=t.altitudeMode,this.pickDelegate=t.pickDelegate,this.depthOffset=t.depthOffset,this},g.prototype.render=function(t){if(this.enabled&&t.accumulateOrderedRenderables&&(!t.globe.projectionLimits||t.globe.projectionLimits.containsLocation(this.position.latitude,this.position.longitude))){var e;if(this.lastFrameTime!==t.timestamp)e=this.makeOrderedRenderable(t);else{var i=this.clone();e=i.makeOrderedRenderable(t)}e&&(e.layer=t.currentLayer,this.lastFrameTime=t.timestamp,t.addOrderedRenderable(e))}},g.prototype.drawOrderedAnnotation=function(t){this.beginDrawing(t);try{this.doDrawOrderedAnnotation(t)}finally{this.endDrawing(t)}},g.prototype.makeOrderedRenderable=function(t){var e,i,r,n,o,s,a,l,h;if(this.label=t.textRenderer.wrap(this.label,this.attributes.width,this.attributes.height),t.surfacePointForMode(this.position.latitude,this.position.longitude,this.position.altitude,this.altitudeMode,this.placePoint),this.eyeDistance=t.eyePoint.distanceTo(this.placePoint),!t.projectWithDepth(this.placePoint,this.depthOffset,g.screenPoint))return null;this.labelTexture=t.createTextTexture(this.label,this.attributes.textAttributes),e=this.labelTexture.imageWidth,i=this.labelTexture.imageHeight,r=this.attributes.scale,n=this.attributes.insets.left,o=this.attributes.insets.right,s=this.attributes.insets.top,a=this.attributes.insets.bottom,h=this.attributes.leaderGapHeight,l=this.calloutOffset.offsetForSize((e+n+o)*r,(i+s+a)*r),this.calloutTransform.setTranslation(g.screenPoint[0]-l[0],g.screenPoint[1]+h,g.screenPoint[2]),this.labelTransform.setTranslation(g.screenPoint[0]-l[0]+n*r,g.screenPoint[1]+h+a*r,g.screenPoint[2]),this.labelTransform.setScale(e*r,i*r,1),this.labelBounds=f.boundingRectForUnitQuad(this.labelTransform);var u=(e+n+o)*r,c=(i+s+a)*r,d=u/2,p=-h;return this.attributes.drawLeader||(p=0),this.attributes.stateKey!==this.lastStateKey&&(this.calloutPoints=this.createCallout(u,c,d,p,this.attributes.leaderGapWidth,this.attributes.cornerRadius)),this},g.prototype.beginDrawing=function(t){var e,r=t.currentGlContext;t.findAndBindProgram(i),e=t.currentProgram,r.enableVertexAttribArray(e.vertexPointLocation),r.enableVertexAttribArray(e.vertexTexCoordLocation),e.loadModulateColor(r,t.pickingMode)},g.prototype.endDrawing=function(t){var e=t.currentGlContext,i=t.currentProgram;e.disableVertexAttribArray(i.vertexPointLocation),e.disableVertexAttribArray(i.vertexTexCoordLocation),t.bindProgram(null)},g.prototype.drawCorner=function(t,e,i,r,n,o,s,a){if(i<1)return a;for(var l=(n-r)/(o-1),h=1;h<o-1;h++){var u=r+l*h,c=t+Math.cos(u)*i,d=e+Math.sin(u)*i;s[a++]=c,s[a++]=d}return a},g.prototype.createCallout=function(t,e,i,r,n,o){var s=16,a=2*(12+(o<1?0:4*(s-2))),l=new Float32Array(a),h=0;return l[h++]=t/2+n/2,l[h++]=0,l[h++]=t-o,l[h++]=0,h=this.drawCorner(t-o,o,o,-Math.PI/2,0,s,l,h),l[h++]=t,l[h++]=o,l[h++]=t,l[h++]=e-o,h=this.drawCorner(t-o,e-o,o,0,Math.PI/2,s,l,h),l[h++]=t-o,l[h++]=e,l[h++]=o,l[h++]=e,h=this.drawCorner(o,e-o,o,Math.PI/2,Math.PI,s,l,h),l[h++]=0,l[h++]=e-o,l[h++]=0,l[h++]=o,h=this.drawCorner(o,o,o,Math.PI,1.5*Math.PI,s,l,h),l[h++]=o,l[h++]=0,l[h++]=t/2-n/2,l[h++]=0,l[h++]=i,l[h++]=r,l[h++]=t/2+n/2,l[h]=0,l},g.prototype.doDrawOrderedAnnotation=function(t){var e,i=t.currentGlContext,n=t.currentProgram,o=!1;t.pickingMode&&(this.pickColor=t.uniquePickColor()),n.loadOpacity(i,t.pickingMode?1:this.attributes.opacity*this.layer.opacity);var s=this.attributes.stateKey!==this.lastStateKey;this.calloutCacheKey&&!s||(this.calloutCacheKey=t.gpuResourceCache.generateCacheKey());var a=t.gpuResourceCache.resourceForKey(this.calloutCacheKey);a||(a=i.createBuffer(),t.gpuResourceCache.putResource(this.calloutCacheKey,a,4*this.calloutPoints.length),o=!0),s&&this.calloutCacheKey&&t.gpuResourceCache.removeResource(this.calloutCacheKey),this.lastStateKey=this.attributes.stateKey,g.matrix.copy(t.screenProjection),g.matrix.multiplyMatrix(this.calloutTransform),n.loadModelviewProjection(i,g.matrix),i.bindBuffer(i.ARRAY_BUFFER,a),o&&(i.bufferData(i.ARRAY_BUFFER,this.calloutPoints,i.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1)),n.loadColor(i,t.pickingMode?this.pickColor:this.attributes.backgroundColor),n.loadTextureEnabled(i,!1),i.vertexAttribPointer(n.vertexPointLocation,2,i.FLOAT,!1,0,0),i.vertexAttribPointer(n.vertexTexCoordLocation,2,i.FLOAT,!1,0,0),i.drawArrays(i.TRIANGLE_FAN,0,this.calloutPoints.length/2),g.matrix.copy(t.screenProjection),g.matrix.multiplyMatrix(this.labelTransform),n.loadModelviewProjection(i,g.matrix),g.matrix.setToIdentity(),g.matrix.multiplyByTextureTransform(this.labelTexture),n.loadTextureMatrix(i,g.matrix),n.loadColor(i,t.pickingMode?this.pickColor:r.WHITE),e=this.labelTexture.bind(t),n.loadTextureEnabled(i,e),i.bindBuffer(i.ARRAY_BUFFER,t.unitQuadBuffer3()),i.vertexAttribPointer(n.vertexPointLocation,3,i.FLOAT,!1,0,0),i.bindBuffer(i.ARRAY_BUFFER,t.unitQuadBuffer()),i.vertexAttribPointer(n.vertexTexCoordLocation,2,i.FLOAT,!1,0,0),i.drawArrays(i.TRIANGLE_STRIP,0,4)},g}),i("ArcBallCamera",["./geom/Angle","./error/ArgumentError","./util/Logger","./geom/Matrix","./geom/Position","./geom/Vec3","./util/WWMath"],function(t,e,i,r,n,o,s){"use strict";var a=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"ArcBallCamera","constructor","missing WorldWindow instance."));this.position=new n(30,-110,0),this.heading=0,this.tilt=0,this.range=1e7,this.roll=0,this.wwd=t,this._scratchMatrix=r.fromIdentity(),this._scratchVector=new o(0,0,0)};return a.prototype.createViewMatrix=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"ArcBallCamera","createViewMatrix","missing matrix"));return this.applyLimits(),t.setToIdentity(),t.multiplyByLookAtModelview(this.position,this.range,this.heading,this.tilt,this.roll,this.wwd.globe),t},a.prototype.clone=function(t){return t=t||new a(this.wwd),t.copy(this),t},a.prototype.copy=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"ArcBallCamera","copy","missing camera"));return this.position.copy(t.position),this.tilt=t.tilt,this.heading=t.heading,this.range=t.range,this.roll=t.roll,this},a.prototype.applyLimits=function(){if(this.position.latitude=s.clamp(this.position.latitude,-90,90),this.position.longitude=t.normalizedDegreesLongitude(this.position.longitude),this.position.altitude=s.clamp(this.position.altitude,0,Number.MAX_VALUE),this.range=s.clamp(this.range,1,Number.MAX_VALUE),this.heading=t.normalizedDegrees(this.heading),this.tilt=s.clamp(this.tilt,0,90),this.roll=t.normalizedDegrees(this.roll),this.wwd.globe.is2D()){var e=2*Math.PI*this.wwd.globe.equatorialRadius;this.range=s.clamp(this.range,1,e),this.tilt=0}},a.prototype.toFirstPerson=function(t){if(!t)throw new e(i.logMessage(i.LEVEL_SEVERE,"ArcBallCamera","toFirstPerson","missing camera"));var r=this.createViewMatrix(this._scratchMatrix),n=r.extractEyePoint(this._scratchVector),o=r.extractViewingParameters(n,this.roll,this.wwd.globe,{});return t.position.copy(o.origin),t.heading=o.heading,t.tilt=o.tilt-90,t.roll=o.roll,t.applyLimits(),t},a}),i("util/measure/MeasurerUtils",["../../geom/Location","../../geom/Position"],function(t,e){"use strict";var i={subdividePositions:function(i,r,n,o,s){var a,l=[],h=new t(0,0),u=new t(0,0),c=r[0];this.addPosition(i,l,c,n);for(var d=1;d<r.length;d++){var p=r[d],f=t.greatCircleDistance(c,p);h=t.interpolateAlongPath(o,.5,c,p,h);var g=f*i.radiusAt(h.latitude,h.longitude);if(g>s)for(var m=null,y=null,E=Math.ceil(g/s),v=1;v<E;v++){var _=v/E;o===WorldWind.LINEAR?u=t.interpolateLinear(_,c,p,u):o===WorldWind.RHUMB_LINE?(null==m&&(m=t.rhumbAzimuth(c,p),y=t.rhumbDistance(c,p)),u=t.rhumbLocation(c,m,_*y,u)):(null==m&&(m=t.greatCircleAzimuth(c,p),y=t.greatCircleDistance(c,p)),u=t.greatCircleLocation(c,m,_*y,u)),a=n?i.elevationAtLocation(u.latitude,u.longitude):c.altitude*(1-_)+p.altitude*_,l.push(new e(u.latitude,u.longitude,a))}this.addPosition(i,l,p,n),c=p}return l},addPosition:function(t,i,r,n){var o=r.altitude;return n&&(o=t.elevationAtLocation(r.latitude,r.longitude)),i.push(new e(r.latitude,r.longitude,o)),i},isLocationInside:function(t,e){for(var i=!1,r=e[0],n=1,o=e.length;n<o;n++){var s=e[n];(s.latitude<=t.latitude&&t.latitude<r.latitude||r.latitude<=t.latitude&&t.latitude<s.latitude)&&t.longitude<(r.longitude-s.longitude)*(t.latitude-s.latitude)/(r.latitude-s.latitude)+s.longitude&&(i=!i),r=s}return i},angleBetweenVectors:function(t,e){var i=t.dot(e),r=t.magnitude()*e.magnitude();return 0!==r&&1!==r&&(i/=r),i<-1?i=-1:i>1&&(i=1),Math.acos(i)}};return i}),i("geom/Sector",["../geom/Angle","../error/ArgumentError","../geom/Location","../util/Logger","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o){"use strict";var s=function(t,e,i,r){this.minLatitude=t,this.maxLatitude=e,this.minLongitude=i,this.maxLongitude=r};return s.ZERO=new s(0,0,0,0),s.FULL_SPHERE=new s(-90,90,-180,180),s.prototype.copy=function(t){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"Sector","copy","missingSector"));return this.minLatitude=t.minLatitude,this.maxLatitude=t.maxLatitude,this.minLongitude=t.minLongitude,this.maxLongitude=t.maxLongitude,this},s.prototype.isEmpty=function(){return this.minLatitude===this.maxLatitude&&this.minLongitude===this.maxLongitude},s.prototype.deltaLatitude=function(){return this.maxLatitude-this.minLatitude},s.prototype.deltaLongitude=function(){return this.maxLongitude-this.minLongitude},s.prototype.centroidLatitude=function(){return.5*(this.minLatitude+this.maxLatitude)},s.prototype.centroidLongitude=function(){return.5*(this.minLongitude+this.maxLongitude)},s.prototype.centroid=function(t){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"Sector","centroid","missingResult"));return t.latitude=this.centroidLatitude(),t.longitude=this.centroidLongitude(),t},s.prototype.minLatitudeRadians=function(){return this.minLatitude*t.DEGREES_TO_RADIANS},s.prototype.maxLatitudeRadians=function(){return this.maxLatitude*t.DEGREES_TO_RADIANS},s.prototype.minLongitudeRadians=function(){return this.minLongitude*t.DEGREES_TO_RADIANS},s.prototype.maxLongitudeRadians=function(){return this.maxLongitude*t.DEGREES_TO_RADIANS},s.prototype.setToBoundingSector=function(t){if(!t||t.length<2)throw new e(r.logMessage(r.LEVEL_SEVERE,"Sector","setToBoundingSector","missingArray"));for(var i=90,n=-90,o=180,s=-180,a=0,l=t.length;a<l;a+=1){var h=t[a];h&&(i=Math.min(i,h.latitude),n=Math.max(n,h.latitude),o=Math.min(o,h.longitude),s=Math.max(s,h.longitude))}return this.minLatitude=i,this.maxLatitude=n,this.minLongitude=o,this.maxLongitude=s,this},s.splitBoundingSectors=function(t){if(!t||t.length<2)throw new e(r.logMessage(r.LEVEL_SEVERE,"Sector","splitBoundingSectors","missingArray"));for(var i=90,n=180,a=-90,l=-180,h=null,u=0,c=t.length;u<c;u+=1){var d=t[u],p=d.latitude;p<i&&(i=p),p>a&&(a=p);var f=d.longitude;if(f>=0&&f<n&&(n=f),f<=0&&f>l&&(l=f),null!=h){var g=h.longitude;o.signum(f)!=o.signum(g)&&Math.abs(f-g)<180&&(l=0,n=0)}h=d}return i===a&&n===l?null:[new s(i,a,n,180),new s(i,a,-180,l)]},s.prototype.intersects=function(t){return t&&this.minLongitude<=t.maxLongitude&&this.maxLongitude>=t.minLongitude&&this.minLatitude<=t.maxLatitude&&this.maxLatitude>=t.minLatitude},s.prototype.overlaps=function(t){return t&&this.minLongitude<t.maxLongitude&&this.maxLongitude>t.minLongitude&&this.minLatitude<t.maxLatitude&&this.maxLatitude>t.minLatitude},s.prototype.contains=function(t){return t&&this.minLatitude<=t.minLatitude&&this.maxLatitude>=t.maxLatitude&&this.minLongitude<=t.minLongitude&&this.maxLongitude>=t.maxLongitude},s.prototype.containsLocation=function(t,e){return this.minLatitude<=t&&this.maxLatitude>=t&&this.minLongitude<=e&&this.maxLongitude>=e},s.prototype.intersection=function(t){if(!t instanceof s)throw new e(r.logMessage(r.LEVEL_SEVERE,"Sector","intersection","missingSector"));return this.minLatitude<t.minLatitude&&(this.minLatitude=t.minLatitude),this.maxLatitude>t.maxLatitude&&(this.maxLatitude=t.maxLatitude),this.minLongitude<t.minLongitude&&(this.minLongitude=t.minLongitude),this.maxLongitude>t.maxLongitude&&(this.maxLongitude=t.maxLongitude),this.maxLatitude<this.minLatitude&&(this.maxLatitude=this.minLatitude),this.maxLongitude<this.minLongitude&&(this.maxLongitude=this.minLongitude),this},s.prototype.getCorners=function(){var t=[];return t.push(new i(this.minLatitude,this.minLongitude)),t.push(new i(this.minLatitude,this.maxLongitude)),t.push(new i(this.maxLatitude,this.maxLongitude)),t.push(new i(this.maxLatitude,this.minLongitude)),t},s.prototype.computeBoundingPoints=function(t,o){if(null===t)throw new e(r.logMessage(r.LEVEL_SEVERE,"Sector","computeBoundingBox","missingGlobe"));var s=t.minAndMaxElevationsForSector(this),a=s[0]*o,l=s[1]*o;a===l&&(l=a+10);for(var h=[],u=this.getCorners(),c=0;c<u.length;c++)h.push(t.computePointFromPosition(u[c].latitude,u[c].longitude,a,new n(0,0,0))),h.push(t.computePointFromPosition(u[c].latitude,u[c].longitude,l,new n(0,0,0)));var d=this.centroid(new i(0,0));if(h.push(t.computePointFromPosition(d.latitude,d.longitude,l,new n(0,0,0))),this.minLatitude<0&&this.maxLatitude>0?(h.push(t.computePointFromPosition(this.minLatitude,d.longitude,l,new n(0,0,0))),
h.push(t.computePointFromPosition(this.maxLatitude,d.longitude,l,new n(0,0,0))),h.push(t.computePointFromPosition(0,this.minLongitude,l,new n(0,0,0))),h.push(t.computePointFromPosition(0,this.maxLongitude,l,new n(0,0,0)))):this.minLatitude<0?h.push(t.computePointFromPosition(this.maxLatitude,d.longitude,l,new n(0,0,0))):h.push(t.computePointFromPosition(this.minLatitude,d.longitude,l,new n(0,0,0))),this.deltaLongitude()>=360){var p=this.minLatitude;h.push(t.computePointFromPosition(p,0,l,new n(0,0,0))),h.push(t.computePointFromPosition(p,90,l,new n(0,0,0))),h.push(t.computePointFromPosition(p,-90,l,new n(0,0,0))),h.push(t.computePointFromPosition(p,180,l,new n(0,0,0)));var f=this.maxLatitude;h.push(t.computePointFromPosition(f,0,l,new n(0,0,0))),h.push(t.computePointFromPosition(f,90,l,new n(0,0,0))),h.push(t.computePointFromPosition(f,-90,l,new n(0,0,0))),h.push(t.computePointFromPosition(f,180,l,new n(0,0,0)))}else if(this.deltaLongitude()>180){var g=d.longitude,m=d.latitude,y=(this.minLongitude+g)/2;h.push(t.computePointFromPosition(m,y,l,new n(0,0,0))),y=(g+this.maxLongitude)/2,h.push(t.computePointFromPosition(m,y,l,new n(0,0,0))),h.push(t.computePointFromPosition(m,this.minLongitude,l,new n(0,0,0))),h.push(t.computePointFromPosition(m,this.maxLongitude,l,new n(0,0,0)))}return h},s.prototype.union=function(t){if(!t instanceof s)throw new e(r.logMessage(r.LEVEL_SEVERE,"Sector","union","missingSector"));return this.minLatitude>t.minLatitude&&(this.minLatitude=t.minLatitude),this.maxLatitude<t.maxLatitude&&(this.maxLatitude=t.maxLatitude),this.minLongitude>t.minLongitude&&(this.minLongitude=t.minLongitude),this.maxLongitude<t.maxLongitude&&(this.maxLongitude=t.maxLongitude),this},s});var r={};return r.DEBUG=!1,r.assert=function(t,e){if(r.DEBUG&&!t)throw new Error("Assertion failed"+(e?": "+e:""))},r.GLU_TESS_MAX_COORD=1e150,r.TRUE_PROJECT=!1,r.TESS_MAX_CACHE=100,r.GLU_TESS_DEFAULT_TOLERANCE=0,r.windingRule={GLU_TESS_WINDING_ODD:100130,GLU_TESS_WINDING_NONZERO:100131,GLU_TESS_WINDING_POSITIVE:100132,GLU_TESS_WINDING_NEGATIVE:100133,GLU_TESS_WINDING_ABS_GEQ_TWO:100134},r.primitiveType={GL_LINE_LOOP:2,GL_TRIANGLES:4,GL_TRIANGLE_STRIP:5,GL_TRIANGLE_FAN:6},r.errorType={GLU_TESS_MISSING_BEGIN_POLYGON:100151,GLU_TESS_MISSING_END_POLYGON:100153,GLU_TESS_MISSING_BEGIN_CONTOUR:100152,GLU_TESS_MISSING_END_CONTOUR:100154,GLU_TESS_COORD_TOO_LARGE:100155,GLU_TESS_NEED_COMBINE_CALLBACK:100156},r.gluEnum={GLU_TESS_BEGIN:100100,GLU_TESS_VERTEX:100101,GLU_TESS_END:100102,GLU_TESS_ERROR:100103,GLU_TESS_EDGE_FLAG:100104,GLU_TESS_COMBINE:100105,GLU_TESS_BEGIN_DATA:100106,GLU_TESS_VERTEX_DATA:100107,GLU_TESS_END_DATA:100108,GLU_TESS_ERROR_DATA:100109,GLU_TESS_EDGE_FLAG_DATA:100110,GLU_TESS_COMBINE_DATA:100111,GLU_TESS_MESH:100112,GLU_TESS_TOLERANCE:100142,GLU_TESS_WINDING_RULE:100140,GLU_TESS_BOUNDARY_ONLY:100141,GLU_INVALID_ENUM:100900,GLU_INVALID_VALUE:100901},r.PQHandle,r.PQKey,r.geom={},r.geom.vertEq=function(t,e){return t.s===e.s&&t.t===e.t},r.geom.vertLeq=function(t,e){return t.s<e.s||t.s===e.s&&t.t<=e.t},r.geom.edgeEval=function(t,e,i){var r=e.s-t.s,n=i.s-e.s;return r+n>0?r<n?e.t-t.t+(t.t-i.t)*(r/(r+n)):e.t-i.t+(i.t-t.t)*(n/(r+n)):0},r.geom.edgeSign=function(t,e,i){var r=e.s-t.s,n=i.s-e.s;return r+n>0?(e.t-i.t)*r+(e.t-t.t)*n:0},r.geom.transLeq=function(t,e){return t.t<e.t||t.t===e.t&&t.s<=e.s},r.geom.transEval=function(t,e,i){var r=e.t-t.t,n=i.t-e.t;return r+n>0?r<n?e.s-t.s+(t.s-i.s)*(r/(r+n)):e.s-i.s+(i.s-t.s)*(n/(r+n)):0},r.geom.transSign=function(t,e,i){var r=e.t-t.t,n=i.t-e.t;return r+n>0?(e.s-i.s)*r+(e.s-t.s)*n:0},r.geom.edgeGoesLeft=function(t){return r.geom.vertLeq(t.dst(),t.org)},r.geom.edgeGoesRight=function(t){return r.geom.vertLeq(t.org,t.dst())},r.geom.vertL1dist=function(t,e){return Math.abs(t.s-e.s)+Math.abs(t.t-e.t)},r.geom.vertCCW=function(t,e,i){return t.s*(e.t-i.t)+e.s*(i.t-t.t)+i.s*(t.t-e.t)>=0},r.geom.interpolate_=function(t,e,i,r){return t=t<0?0:t,i=i<0?0:i,t<=i?0===i?(e+r)/2:e+(r-e)*(t/(t+i)):r+(e-r)*(i/(t+i))},r.geom.edgeIntersect=function(t,e,i,n,o){var s,a,l;r.geom.vertLeq(t,e)||(l=t,t=e,e=l),r.geom.vertLeq(i,n)||(l=i,i=n,n=l),r.geom.vertLeq(t,i)||(l=t,t=i,i=l,l=e,e=n,n=l),r.geom.vertLeq(i,e)?r.geom.vertLeq(e,n)?(s=r.geom.edgeEval(t,i,e),a=r.geom.edgeEval(i,e,n),s+a<0&&(s=-s,a=-a),o.s=r.geom.interpolate_(s,i.s,a,e.s)):(s=r.geom.edgeSign(t,i,e),a=-r.geom.edgeSign(t,n,e),s+a<0&&(s=-s,a=-a),o.s=r.geom.interpolate_(s,i.s,a,n.s)):o.s=(i.s+e.s)/2,r.geom.transLeq(t,e)||(l=t,t=e,e=l),r.geom.transLeq(i,n)||(l=i,i=n,n=l),r.geom.transLeq(t,i)||(l=t,t=i,i=l,l=e,e=n,n=l),r.geom.transLeq(i,e)?r.geom.transLeq(e,n)?(s=r.geom.transEval(t,i,e),a=r.geom.transEval(i,e,n),s+a<0&&(s=-s,a=-a),o.t=r.geom.interpolate_(s,i.t,a,e.t)):(s=r.geom.transSign(t,i,e),a=-r.geom.transSign(t,n,e),s+a<0&&(s=-s,a=-a),o.t=r.geom.interpolate_(s,i.t,a,n.t)):o.t=(i.t+e.t)/2},r.mesh={},r.mesh.makeEdge=function(t){var e=r.mesh.makeEdgePair_(t.eHead);return r.mesh.makeVertex_(e,t.vHead),r.mesh.makeVertex_(e.sym,t.vHead),r.mesh.makeFace_(e,t.fHead),e},r.mesh.meshSplice=function(t,e){var i=!1,n=!1;t!==e&&(e.org!==t.org&&(n=!0,r.mesh.killVertex_(e.org,t.org)),e.lFace!==t.lFace&&(i=!0,r.mesh.killFace_(e.lFace,t.lFace)),r.mesh.splice_(e,t),n||(r.mesh.makeVertex_(e,t.org),t.org.anEdge=t),i||(r.mesh.makeFace_(e,t.lFace),t.lFace.anEdge=t))},r.mesh.deleteEdge=function(t){var e=t.sym,i=!1;t.lFace!==t.rFace()&&(i=!0,r.mesh.killFace_(t.lFace,t.rFace())),t.oNext===t?r.mesh.killVertex_(t.org,null):(t.rFace().anEdge=t.oPrev(),t.org.anEdge=t.oNext,r.mesh.splice_(t,t.oPrev()),i||r.mesh.makeFace_(t,t.lFace)),e.oNext===e?(r.mesh.killVertex_(e.org,null),r.mesh.killFace_(e.lFace,null)):(t.lFace.anEdge=e.oPrev(),e.org.anEdge=e.oNext,r.mesh.splice_(e,e.oPrev())),r.mesh.killEdge_(t)},r.mesh.addEdgeVertex=function(t){var e=r.mesh.makeEdgePair_(t),i=e.sym;return r.mesh.splice_(e,t.lNext),e.org=t.dst(),r.mesh.makeVertex_(i,e.org),e.lFace=i.lFace=t.lFace,e},r.mesh.splitEdge=function(t){var e=r.mesh.addEdgeVertex(t),i=e.sym;return r.mesh.splice_(t.sym,t.sym.oPrev()),r.mesh.splice_(t.sym,i),t.sym.org=i.org,i.dst().anEdge=i.sym,i.sym.lFace=t.rFace(),i.winding=t.winding,i.sym.winding=t.sym.winding,i},r.mesh.connect=function(t,e){var i=!1,n=r.mesh.makeEdgePair_(t),o=n.sym;return e.lFace!==t.lFace&&(i=!0,r.mesh.killFace_(e.lFace,t.lFace)),r.mesh.splice_(n,t.lNext),r.mesh.splice_(o,e),n.org=t.dst(),o.org=e.org,n.lFace=o.lFace=t.lFace,t.lFace.anEdge=o,i||r.mesh.makeFace_(n,t.lFace),n},r.mesh.zapFace=function(t){var e,i=t.anEdge,n=i.lNext;do if(e=n,n=e.lNext,e.lFace=null,null===e.rFace()){e.oNext===e?r.mesh.killVertex_(e.org,null):(e.org.anEdge=e.oNext,r.mesh.splice_(e,e.oPrev()));var o=e.sym;o.oNext===o?r.mesh.killVertex_(o.org,null):(o.org.anEdge=o.oNext,r.mesh.splice_(o,o.oPrev())),r.mesh.killEdge_(e)}while(e!==i);var s=t.prev,a=t.next;a.prev=s,s.next=a},r.mesh.meshUnion=function(t,e){var i=t.fHead,r=t.vHead,n=t.eHead,o=e.fHead,s=e.vHead,a=e.eHead;return o.next!==o&&(i.prev.next=o.next,o.next.prev=i.prev,o.prev.next=i,i.prev=o.prev),s.next!==s&&(r.prev.next=s.next,s.next.prev=r.prev,s.prev.next=r,r.prev=s.prev),a.next!==a&&(n.sym.next.sym.next=a.next,a.next.sym.next=n.sym.next,a.sym.next.sym.next=n,n.sym.next=a.sym.next),t},r.mesh.deleteMesh=function(t){},r.mesh.makeEdgePair_=function(t){var e=new r.GluHalfEdge,i=new r.GluHalfEdge,n=t.sym.next;return i.next=n,n.sym.next=e,e.next=t,t.sym.next=i,e.sym=i,e.oNext=e,e.lNext=i,i.sym=e,i.oNext=i,i.lNext=e,e},r.mesh.splice_=function(t,e){var i=t.oNext,r=e.oNext;i.sym.lNext=e,r.sym.lNext=t,t.oNext=r,e.oNext=i},r.mesh.makeVertex_=function(t,e){var i=e.prev,n=new r.GluVertex(e,i);i.next=n,e.prev=n,n.anEdge=t;var o=t;do o.org=n,o=o.oNext;while(o!==t)},r.mesh.makeFace_=function(t,e){var i=e.prev,n=new r.GluFace(e,i);i.next=n,e.prev=n,n.anEdge=t,n.inside=e.inside;var o=t;do o.lFace=n,o=o.lNext;while(o!==t)},r.mesh.killEdge_=function(t){var e=t.next,i=t.sym.next;e.sym.next=i,i.sym.next=e},r.mesh.killVertex_=function(t,e){var i=t.anEdge,r=i;do r.org=e,r=r.oNext;while(r!==i);var n=t.prev,o=t.next;o.prev=n,n.next=o},r.mesh.killFace_=function(t,e){var i=t.anEdge,r=i;do r.lFace=e,r=r.lNext;while(r!==i);var n=t.prev,o=t.next;o.prev=n,n.next=o},r.normal={},r.normal.S_UNIT_X_=1,r.normal.S_UNIT_Y_=0,r.normal.projectPolygon=function(t){var e=!1,i=[t.normal[0],t.normal[1],t.normal[2]];0===i[0]&&0===i[1]&&0===i[2]&&(r.normal.computeNormal_(t,i),e=!0);var n=t.sUnit,o=t.tUnit,s=r.normal.longAxis_(i);if(r.TRUE_PROJECT){r.normal.normalize_(i),n[s]=0,n[(s+1)%3]=r.normal.S_UNIT_X_,n[(s+2)%3]=r.normal.S_UNIT_Y_;var a=r.normal.dot_(n,i);n[0]-=a*i[0],n[1]-=a*i[1],n[2]-=a*i[2],r.normal.normalize_(n),o[0]=i[1]*n[2]-i[2]*n[1],o[1]=i[2]*n[0]-i[0]*n[2],o[2]=i[0]*n[1]-i[1]*n[0],r.normal.normalize_(o)}else n[s]=0,n[(s+1)%3]=r.normal.S_UNIT_X_,n[(s+2)%3]=r.normal.S_UNIT_Y_,o[s]=0,o[(s+1)%3]=i[s]>0?-r.normal.S_UNIT_Y_:r.normal.S_UNIT_Y_,o[(s+2)%3]=i[s]>0?r.normal.S_UNIT_X_:-r.normal.S_UNIT_X_;for(var l=t.mesh.vHead,h=l.next;h!==l;h=h.next)h.s=r.normal.dot_(h.coords,n),h.t=r.normal.dot_(h.coords,o);e&&r.normal.checkOrientation_(t)},r.normal.dot_=function(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]},r.normal.normalize_=function(t){var e=t[0]*t[0]+t[1]*t[1]+t[2]*t[2];e=Math.sqrt(e),t[0]/=e,t[1]/=e,t[2]/=e},r.normal.longAxis_=function(t){var e=0;return Math.abs(t[1])>Math.abs(t[0])&&(e=1),Math.abs(t[2])>Math.abs(t[e])&&(e=2),e},r.normal.computeNormal_=function(t,e){var i,n=[-2*r.GLU_TESS_MAX_COORD,-2*r.GLU_TESS_MAX_COORD,-2*r.GLU_TESS_MAX_COORD],o=[2*r.GLU_TESS_MAX_COORD,2*r.GLU_TESS_MAX_COORD,2*r.GLU_TESS_MAX_COORD],s=[],a=[],l=t.mesh.vHead;for(i=l.next;i!==l;i=i.next)for(var h=0;h<3;++h){var u=i.coords[h];u<o[h]&&(o[h]=u,a[h]=i),u>n[h]&&(n[h]=u,s[h]=i)}var c=0;if(n[1]-o[1]>n[0]-o[0]&&(c=1),n[2]-o[2]>n[c]-o[c]&&(c=2),o[c]>=n[c])return e[0]=0,e[1]=0,void(e[2]=1);var d=0,p=a[c],f=s[c],g=[0,0,0],m=[p.coords[0]-f.coords[0],p.coords[1]-f.coords[1],p.coords[2]-f.coords[2]],y=[0,0,0];for(i=l.next;i!==l;i=i.next){y[0]=i.coords[0]-f.coords[0],y[1]=i.coords[1]-f.coords[1],y[2]=i.coords[2]-f.coords[2],g[0]=m[1]*y[2]-m[2]*y[1],g[1]=m[2]*y[0]-m[0]*y[2],g[2]=m[0]*y[1]-m[1]*y[0];var E=g[0]*g[0]+g[1]*g[1]+g[2]*g[2];E>d&&(d=E,e[0]=g[0],e[1]=g[1],e[2]=g[2])}d<=0&&(e[0]=e[1]=e[2]=0,e[r.normal.longAxis_(m)]=1)},r.normal.checkOrientation_=function(t){for(var e=0,i=t.mesh.fHead,r=i.next;r!==i;r=r.next){var n=r.anEdge;if(!(n.winding<=0))do e+=(n.org.s-n.dst().s)*(n.org.t+n.dst().t),n=n.lNext;while(n!==r.anEdge)}if(e<0){for(var o=t.mesh.vHead,s=o.next;s!==o;s=s.next)s.t=-s.t;t.tUnit[0]=-t.tUnit[0],t.tUnit[1]=-t.tUnit[1],t.tUnit[2]=-t.tUnit[2]}},r.render={},r.render.renderMesh=function(t,e,i){for(var n=!1,o=-1,s=e.fHead.prev;s!==e.fHead;s=s.prev)if(s.inside){n||(t.callBeginOrBeginData(r.primitiveType.GL_TRIANGLES),n=!0);var a=s.anEdge;do{if(i){var l=a.rFace().inside?0:1;o!==l&&(o=l,t.callEdgeFlagOrEdgeFlagData(!!o))}t.callVertexOrVertexData(a.org.data),a=a.lNext}while(a!==s.anEdge)}n&&t.callEndOrEndData()},r.render.renderBoundary=function(t,e){for(var i=e.fHead.next;i!==e.fHead;i=i.next)if(i.inside){t.callBeginOrBeginData(r.primitiveType.GL_LINE_LOOP);var n=i.anEdge;do t.callVertexOrVertexData(n.org.data),n=n.lNext;while(n!==i.anEdge);t.callEndOrEndData()}},r.sweep={},r.sweep.SENTINEL_COORD_=4*r.GLU_TESS_MAX_COORD,r.sweep.TOLERANCE_NONZERO_=!1,r.sweep.computeInterior=function(t){t.fatalError=!1,r.sweep.removeDegenerateEdges_(t),r.sweep.initPriorityQ_(t),r.sweep.initEdgeDict_(t);for(var e;null!==(e=t.pq.extractMin());){for(;;){var i=t.pq.minimum();if(null===i||!r.geom.vertEq(i,e))break;i=t.pq.extractMin(),r.sweep.spliceMergeVertices_(t,e.anEdge,i.anEdge)}r.sweep.sweepEvent_(t,e)}var n=t.dict.getMin().getKey();t.event=n.eUp.org,r.sweep.doneEdgeDict_(t),r.sweep.donePriorityQ_(t),r.sweep.removeDegenerateFaces_(t.mesh),t.mesh.checkMesh()},r.sweep.addWinding_=function(t,e){t.winding+=e.winding,t.sym.winding+=e.sym.winding},r.sweep.edgeLeq_=function(t,e,i){var n=t.event,o=e.eUp,s=i.eUp;if(o.dst()===n)return s.dst()===n?r.geom.vertLeq(o.org,s.org)?r.geom.edgeSign(s.dst(),o.org,s.org)<=0:r.geom.edgeSign(o.dst(),s.org,o.org)>=0:r.geom.edgeSign(s.dst(),n,s.org)<=0;if(s.dst()===n)return r.geom.edgeSign(o.dst(),n,o.org)>=0;var a=r.geom.edgeEval(o.dst(),n,o.org),l=r.geom.edgeEval(s.dst(),n,s.org);return a>=l},r.sweep.deleteRegion_=function(t,e){e.fixUpperEdge,e.eUp.activeRegion=null,t.dict.deleteNode(e.nodeUp),e.nodeUp=null},r.sweep.fixUpperEdge_=function(t,e){r.mesh.deleteEdge(t.eUp),t.fixUpperEdge=!1,t.eUp=e,e.activeRegion=t},r.sweep.topLeftRegion_=function(t){var e=t.eUp.org;do t=t.regionAbove();while(t.eUp.org===e);if(t.fixUpperEdge){var i=r.mesh.connect(t.regionBelow().eUp.sym,t.eUp.lNext);r.sweep.fixUpperEdge_(t,i),t=t.regionAbove()}return t},r.sweep.topRightRegion_=function(t){var e=t.eUp.dst();do t=t.regionAbove();while(t.eUp.dst()===e);return t},r.sweep.addRegionBelow_=function(t,e,i){var n=new r.ActiveRegion;return n.eUp=i,n.nodeUp=t.dict.insertBefore(e.nodeUp,n),i.activeRegion=n,n},r.sweep.isWindingInside_=function(t,e){switch(t.windingRule){case r.windingRule.GLU_TESS_WINDING_ODD:return 0!==(1&e);case r.windingRule.GLU_TESS_WINDING_NONZERO:return 0!==e;case r.windingRule.GLU_TESS_WINDING_POSITIVE:return e>0;case r.windingRule.GLU_TESS_WINDING_NEGATIVE:return e<0;case r.windingRule.GLU_TESS_WINDING_ABS_GEQ_TWO:return e>=2||e<=-2}return!1},r.sweep.computeWinding_=function(t,e){e.windingNumber=e.regionAbove().windingNumber+e.eUp.winding,e.inside=r.sweep.isWindingInside_(t,e.windingNumber)},r.sweep.finishRegion_=function(t,e){var i=e.eUp,n=i.lFace;n.inside=e.inside,n.anEdge=i,r.sweep.deleteRegion_(t,e)},r.sweep.finishLeftRegions_=function(t,e,i){for(var n=e,o=e.eUp;n!==i;){n.fixUpperEdge=!1;var s=n.regionBelow(),a=s.eUp;if(a.org!==o.org){if(!s.fixUpperEdge){r.sweep.finishRegion_(t,n);break}a=r.mesh.connect(o.lPrev(),a.sym),r.sweep.fixUpperEdge_(s,a)}o.oNext!==a&&(r.mesh.meshSplice(a.oPrev(),a),r.mesh.meshSplice(o,a)),r.sweep.finishRegion_(t,n),o=s.eUp,n=s}return o},r.sweep.addRightEdges_=function(t,e,i,n,o,s){var a=!0,l=i;do r.sweep.addRegionBelow_(t,e,l.sym),l=l.oNext;while(l!==n);null===o&&(o=e.regionBelow().eUp.rPrev());for(var h,u=e,c=o;h=u.regionBelow(),l=h.eUp.sym,l.org===c.org;)l.oNext!==c&&(r.mesh.meshSplice(l.oPrev(),l),r.mesh.meshSplice(c.oPrev(),l)),h.windingNumber=u.windingNumber-l.winding,h.inside=r.sweep.isWindingInside_(t,h.windingNumber),u.dirty=!0,!a&&r.sweep.checkForRightSplice_(t,u)&&(r.sweep.addWinding_(l,c),r.sweep.deleteRegion_(t,u),r.mesh.deleteEdge(c)),a=!1,u=h,c=l;u.dirty=!0,s&&r.sweep.walkDirtyRegions_(t,u)},r.sweep.callCombine_=function(t,e,i,n,o){var s=[e.coords[0],e.coords[1],e.coords[2]];e.data=null,e.data=t.callCombineOrCombineData(s,i,n),null===e.data&&(o?t.fatalError||(t.callErrorOrErrorData(r.errorType.GLU_TESS_NEED_COMBINE_CALLBACK),t.fatalError=!0):e.data=i[0])},r.sweep.spliceMergeVertices_=function(t,e,i){var n=[null,null,null,null],o=[.5,.5,0,0];n[0]=e.org.data,n[1]=i.org.data,r.sweep.callCombine_(t,e.org,n,o,!1),r.mesh.meshSplice(e,i)},r.sweep.vertexWeights_=function(t,e,i,n,o){var s=r.geom.vertL1dist(e,t),a=r.geom.vertL1dist(i,t),l=o,h=o+1;n[l]=.5*a/(s+a),n[h]=.5*s/(s+a),t.coords[0]+=n[l]*e.coords[0]+n[h]*i.coords[0],t.coords[1]+=n[l]*e.coords[1]+n[h]*i.coords[1],t.coords[2]+=n[l]*e.coords[2]+n[h]*i.coords[2]},r.sweep.getIntersectData_=function(t,e,i,n,o,s){var a=[0,0,0,0],l=[i.data,n.data,o.data,s.data];e.coords[0]=e.coords[1]=e.coords[2]=0,r.sweep.vertexWeights_(e,i,n,a,0),r.sweep.vertexWeights_(e,o,s,a,2),r.sweep.callCombine_(t,e,l,a,!0)},r.sweep.checkForRightSplice_=function(t,e){var i=e.regionBelow(),n=e.eUp,o=i.eUp;if(r.geom.vertLeq(n.org,o.org)){if(r.geom.edgeSign(o.dst(),n.org,o.org)>0)return!1;r.geom.vertEq(n.org,o.org)?n.org!==o.org&&(t.pq.remove(n.org.pqHandle),r.sweep.spliceMergeVertices_(t,o.oPrev(),n)):(r.mesh.splitEdge(o.sym),r.mesh.meshSplice(n,o.oPrev()),e.dirty=i.dirty=!0)}else{if(r.geom.edgeSign(n.dst(),o.org,n.org)<0)return!1;e.regionAbove().dirty=e.dirty=!0,r.mesh.splitEdge(n.sym),r.mesh.meshSplice(o.oPrev(),n)}return!0},r.sweep.checkForLeftSplice_=function(t,e){var i,n=e.regionBelow(),o=e.eUp,s=n.eUp;if(r.geom.vertLeq(o.dst(),s.dst())){if(r.geom.edgeSign(o.dst(),s.dst(),o.org)<0)return!1;e.regionAbove().dirty=e.dirty=!0,i=r.mesh.splitEdge(o),r.mesh.meshSplice(s.sym,i),i.lFace.inside=e.inside}else{if(r.geom.edgeSign(s.dst(),o.dst(),s.org)>0)return!1;e.dirty=n.dirty=!0,i=r.mesh.splitEdge(s),r.mesh.meshSplice(o.lNext,s.sym),i.rFace().inside=e.inside}return!0},r.sweep.checkForIntersect_=function(t,e){var i=e.regionBelow(),n=e.eUp,o=i.eUp,s=n.org,a=o.org,l=n.dst(),h=o.dst(),u=new r.GluVertex;if(s===a)return!1;var c=Math.min(s.t,l.t),d=Math.max(a.t,h.t);if(c>d)return!1;if(r.geom.vertLeq(s,a)){if(r.geom.edgeSign(h,s,a)>0)return!1}else if(r.geom.edgeSign(l,a,s)<0)return!1;r.geom.edgeIntersect(l,s,h,a,u),r.geom.vertLeq(u,t.event)&&(u.s=t.event.s,u.t=t.event.t);var p=r.geom.vertLeq(s,a)?s:a;if(r.geom.vertLeq(p,u)&&(u.s=p.s,u.t=p.t),r.geom.vertEq(u,s)||r.geom.vertEq(u,a))return r.sweep.checkForRightSplice_(t,e),!1;if(!r.geom.vertEq(l,t.event)&&r.geom.edgeSign(l,t.event,u)>=0||!r.geom.vertEq(h,t.event)&&r.geom.edgeSign(h,t.event,u)<=0){if(h===t.event)return r.mesh.splitEdge(n.sym),r.mesh.meshSplice(o.sym,n),e=r.sweep.topLeftRegion_(e),n=e.regionBelow().eUp,r.sweep.finishLeftRegions_(t,e.regionBelow(),i),r.sweep.addRightEdges_(t,e,n.oPrev(),n,n,!0),!0;if(l===t.event){r.mesh.splitEdge(o.sym),r.mesh.meshSplice(n.lNext,o.oPrev()),i=e,e=r.sweep.topRightRegion_(e);var f=e.regionBelow().eUp.rPrev();return i.eUp=o.oPrev(),o=r.sweep.finishLeftRegions_(t,i,null),r.sweep.addRightEdges_(t,e,o.oNext,n.rPrev(),f,!0),!0}return r.geom.edgeSign(l,t.event,u)>=0&&(e.regionAbove().dirty=e.dirty=!0,r.mesh.splitEdge(n.sym),n.org.s=t.event.s,n.org.t=t.event.t),r.geom.edgeSign(h,t.event,u)<=0&&(e.dirty=i.dirty=!0,r.mesh.splitEdge(o.sym),o.org.s=t.event.s,o.org.t=t.event.t),!1}return r.mesh.splitEdge(n.sym),r.mesh.splitEdge(o.sym),r.mesh.meshSplice(o.oPrev(),n),n.org.s=u.s,n.org.t=u.t,n.org.pqHandle=t.pq.insert(n.org),r.sweep.getIntersectData_(t,n.org,s,l,a,h),e.regionAbove().dirty=e.dirty=i.dirty=!0,!1},r.sweep.walkDirtyRegions_=function(t,e){for(var i=e.regionBelow();;){for(;i.dirty;)e=i,i=i.regionBelow();if(!e.dirty&&(i=e,e=e.regionAbove(),null===e||!e.dirty))return;e.dirty=!1;var n=e.eUp,o=i.eUp;if(n.dst()!==o.dst()&&r.sweep.checkForLeftSplice_(t,e)&&(i.fixUpperEdge?(r.sweep.deleteRegion_(t,i),r.mesh.deleteEdge(o),i=e.regionBelow(),o=i.eUp):e.fixUpperEdge&&(r.sweep.deleteRegion_(t,e),r.mesh.deleteEdge(n),e=i.regionAbove(),n=e.eUp)),n.org!==o.org)if(n.dst()===o.dst()||e.fixUpperEdge||i.fixUpperEdge||n.dst()!==t.event&&o.dst()!==t.event)r.sweep.checkForRightSplice_(t,e);else if(r.sweep.checkForIntersect_(t,e))return;n.org===o.org&&n.dst()===o.dst()&&(r.sweep.addWinding_(o,n),r.sweep.deleteRegion_(t,e),r.mesh.deleteEdge(n),e=i.regionAbove())}},r.sweep.connectRightVertex_=function(t,e,i){var n=i.oNext,o=e.regionBelow(),s=e.eUp,a=o.eUp,l=!1;if(s.dst()!==a.dst()&&r.sweep.checkForIntersect_(t,e),r.geom.vertEq(s.org,t.event)&&(r.mesh.meshSplice(n.oPrev(),s),e=r.sweep.topLeftRegion_(e),n=e.regionBelow().eUp,r.sweep.finishLeftRegions_(t,e.regionBelow(),o),l=!0),r.geom.vertEq(a.org,t.event)&&(r.mesh.meshSplice(i,a.oPrev()),i=r.sweep.finishLeftRegions_(t,o,null),l=!0),l)return void r.sweep.addRightEdges_(t,e,i.oNext,n,n,!0);var h;h=r.geom.vertLeq(a.org,s.org)?a.oPrev():s,h=r.mesh.connect(i.lPrev(),h),r.sweep.addRightEdges_(t,e,h,h.oNext,h.oNext,!1),h.sym.activeRegion.fixUpperEdge=!0,r.sweep.walkDirtyRegions_(t,e)},r.sweep.connectLeftDegenerate_=function(t,e,i){var n=e.eUp;if(r.geom.vertEq(n.org,i))return void(r.sweep.TOLERANCE_NONZERO_&&r.sweep.spliceMergeVertices_(t,n,i.anEdge));if(!r.geom.vertEq(n.dst(),i))return r.mesh.splitEdge(n.sym),e.fixUpperEdge&&(r.mesh.deleteEdge(n.oNext),e.fixUpperEdge=!1),r.mesh.meshSplice(i.anEdge,n),void r.sweep.sweepEvent_(t,i);if(r.sweep.TOLERANCE_NONZERO_){e=r.sweep.topRightRegion_(e);var o=e.regionBelow(),s=o.eUp.sym,a=s.oNext,l=a;o.fixUpperEdge&&(r.sweep.deleteRegion_(t,o),r.mesh.deleteEdge(s),s=a.oPrev()),r.mesh.meshSplice(i.anEdge,s),r.geom.edgeGoesLeft(a)||(a=null),r.sweep.addRightEdges_(t,e,s.oNext,l,a,!0)}},r.sweep.connectLeftVertex_=function(t,e){var i=new r.ActiveRegion;i.eUp=e.anEdge.sym;var n=t.dict.search(i).getKey(),o=n.regionBelow(),s=n.eUp,a=o.eUp;if(0===r.geom.edgeSign(s.dst(),e,s.org))return void r.sweep.connectLeftDegenerate_(t,n,e);var l,h=r.geom.vertLeq(a.dst(),s.dst())?n:o;if(n.inside||h.fixUpperEdge){if(h===n)l=r.mesh.connect(e.anEdge.sym,s.lNext);else{var u=r.mesh.connect(a.dNext(),e.anEdge);l=u.sym}h.fixUpperEdge?r.sweep.fixUpperEdge_(h,l):r.sweep.computeWinding_(t,r.sweep.addRegionBelow_(t,n,l)),r.sweep.sweepEvent_(t,e)}else r.sweep.addRightEdges_(t,n,e.anEdge,e.anEdge,null,!0)},r.sweep.sweepEvent_=function(t,e){t.event=e;for(var i=e.anEdge;null===i.activeRegion;)if(i=i.oNext,i===e.anEdge)return void r.sweep.connectLeftVertex_(t,e);var n=r.sweep.topLeftRegion_(i.activeRegion),o=n.regionBelow(),s=o.eUp,a=r.sweep.finishLeftRegions_(t,o,null);a.oNext===s?r.sweep.connectRightVertex_(t,n,a):r.sweep.addRightEdges_(t,n,a.oNext,s,s,!0)},r.sweep.addSentinel_=function(t,e){var i=new r.ActiveRegion,n=r.mesh.makeEdge(t.mesh);n.org.s=r.sweep.SENTINEL_COORD_,n.org.t=e,n.dst().s=-r.sweep.SENTINEL_COORD_,n.dst().t=e,t.event=n.dst(),i.eUp=n,i.windingNumber=0,i.inside=!1,i.fixUpperEdge=!1,i.sentinel=!0,i.dirty=!1,i.nodeUp=t.dict.insert(i)},r.sweep.initEdgeDict_=function(t){t.dict=new r.Dict(t,r.sweep.edgeLeq_),r.sweep.addSentinel_(t,-r.sweep.SENTINEL_COORD_),r.sweep.addSentinel_(t,r.sweep.SENTINEL_COORD_)},r.sweep.doneEdgeDict_=function(t){for(var e;null!==(e=t.dict.getMin().getKey());)!e.sentinel,r.sweep.deleteRegion_(t,e);t.dict=null},r.sweep.removeDegenerateEdges_=function(t){for(var e,i=t.mesh.eHead,n=i.next;n!==i;n=e){e=n.next;var o=n.lNext;r.geom.vertEq(n.org,n.dst())&&n.lNext.lNext!==n&&(r.sweep.spliceMergeVertices_(t,o,n),r.mesh.deleteEdge(n),n=o,o=n.lNext),o.lNext===n&&(o!==n&&(o!==e&&o!==e.sym||(e=e.next),r.mesh.deleteEdge(o)),n!==e&&n!==e.sym||(e=e.next),r.mesh.deleteEdge(n))}},r.sweep.initPriorityQ_=function(t){var e=new r.PriorityQ(r.geom.vertLeq);t.pq=e;var i,n=t.mesh.vHead;for(i=n.next;i!==n;i=i.next)i.pqHandle=e.insert(i);e.init()},r.sweep.donePriorityQ_=function(t){t.pq.deleteQ(),t.pq=null},r.sweep.removeDegenerateFaces_=function(t){for(var e,i=t.fHead.next;i!==t.fHead;i=e){e=i.next;var n=i.anEdge;n.lNext.lNext===n&&(r.sweep.addWinding_(n.oNext,n),r.mesh.deleteEdge(n))}},r.tessmono={},r.tessmono.tessellateMonoRegion_=function(t){for(var e=t.anEdge;r.geom.vertLeq(e.dst(),e.org);e=e.lPrev());for(;r.geom.vertLeq(e.org,e.dst());e=e.lNext);for(var i,n=e.lPrev();e.lNext!==n;)if(r.geom.vertLeq(e.dst(),n.org)){for(;n.lNext!==e&&(r.geom.edgeGoesLeft(n.lNext)||r.geom.edgeSign(n.org,n.dst(),n.lNext.dst())<=0);)i=r.mesh.connect(n.lNext,n),n=i.sym;n=n.lPrev()}else{for(;n.lNext!==e&&(r.geom.edgeGoesRight(e.lPrev())||r.geom.edgeSign(e.dst(),e.org,e.lPrev().org)>=0);)i=r.mesh.connect(e,e.lPrev()),e=i.sym;e=e.lNext}for(;n.lNext.lNext!==e;)i=r.mesh.connect(n.lNext,n),n=i.sym},r.tessmono.tessellateInterior=function(t){for(var e,i=t.fHead.next;i!==t.fHead;i=e)e=i.next,i.inside&&r.tessmono.tessellateMonoRegion_(i)},r.tessmono.discardExterior=function(t){for(var e,i=t.fHead.next;i!==t.fHead;i=e)e=i.next,i.inside||r.mesh.zapFace(i)},r.tessmono.setWindingNumber=function(t,e,i){for(var n,o=t.eHead.next;o!==t.eHead;o=n)n=o.next,o.rFace().inside!==o.lFace.inside?o.winding=o.lFace.inside?e:-e:i?r.mesh.deleteEdge(o):o.winding=0},r.Dict=function(t,e){this.head_=new r.DictNode,this.frame_=t,this.leq_=e},r.Dict.prototype.deleteDict_=function(){},r.Dict.prototype.insertBefore=function(t,e){do t=t.prev;while(null!==t.key&&!this.leq_(this.frame_,t.key,e));var i=new r.DictNode(e,t.next,t);return t.next.prev=i,t.next=i,i},r.Dict.prototype.insert=function(t){return this.insertBefore(this.head_,t)},r.Dict.prototype.deleteNode=function(t){t.next.prev=t.prev,t.prev.next=t.next},r.Dict.prototype.search=function(t){var e=this.head_;do e=e.next;while(null!==e.key&&!this.leq_(this.frame_,t,e.key));return e},r.Dict.prototype.getMin=function(){return this.head_.next},r.Dict.prototype.getMax=function(){return this.head_.prev},r.DictNode=function(t,e,i){this.key=t||null,this.next=e||this,this.prev=i||this},r.DictNode.prototype.getKey=function(){return this.key},r.DictNode.prototype.getSuccessor=function(){return this.next},r.DictNode.prototype.getPredecessor=function(){return this.prev},r.CachedVertex=function(){this.coords=[0,0,0],this.data=null},r.GluTesselator=function(){this.state=r.GluTesselator.tessState_.T_DORMANT,this.lastEdge_=null,this.mesh=null,this.callError_=null,this.normal=[0,0,0],this.sUnit=[0,0,0],this.tUnit=[0,0,0],this.relTolerance=r.GLU_TESS_DEFAULT_TOLERANCE,this.windingRule=r.windingRule.GLU_TESS_WINDING_ODD,this.fatalError=!1,this.dict=null,this.pq=null,this.event=null,this.callCombine_=null,this.boundaryOnly=!1,this.callBegin_=null,this.callEdgeFlag_=null,this.callVertex_=null,this.callEnd_=null,this.callMesh_=null,this.callBeginData_=null,this.callEdgeFlagData_=null,this.callVertexData_=null,this.callEndData_=null,this.callErrorData_=null,this.callCombineData_=null,this.polygonData_=null,this.emptyCache=!1,this.cacheCount=0,this.cache=new Array(r.TESS_MAX_CACHE);for(var t=0;t<r.TESS_MAX_CACHE;t++)this.cache[t]=new r.CachedVertex},r.GluTesselator.tessState_={T_DORMANT:0,T_IN_POLYGON:1,T_IN_CONTOUR:2},r.GluTesselator.prototype.gluDeleteTess=function(){this.requireState_(r.GluTesselator.tessState_.T_DORMANT)},r.GluTesselator.prototype.gluTessProperty=function(t,e){switch(t){case r.gluEnum.GLU_TESS_TOLERANCE:if(e<0||e>1)break;return void(this.relTolerance=e);case r.gluEnum.GLU_TESS_WINDING_RULE:var i=e;switch(i){case r.windingRule.GLU_TESS_WINDING_ODD:case r.windingRule.GLU_TESS_WINDING_NONZERO:case r.windingRule.GLU_TESS_WINDING_POSITIVE:case r.windingRule.GLU_TESS_WINDING_NEGATIVE:case r.windingRule.GLU_TESS_WINDING_ABS_GEQ_TWO:return void(this.windingRule=i)}break;case r.gluEnum.GLU_TESS_BOUNDARY_ONLY:return void(this.boundaryOnly=!!e);default:return void this.callErrorOrErrorData(r.gluEnum.GLU_INVALID_ENUM)}this.callErrorOrErrorData(r.gluEnum.GLU_INVALID_VALUE)},r.GluTesselator.prototype.gluGetTessProperty=function(t){switch(t){case r.gluEnum.GLU_TESS_TOLERANCE:return this.relTolerance;case r.gluEnum.GLU_TESS_WINDING_RULE:var e=this.windingRule;return e;case r.gluEnum.GLU_TESS_BOUNDARY_ONLY:return this.boundaryOnly;default:this.callErrorOrErrorData(r.gluEnum.GLU_INVALID_ENUM)}return!1},r.GluTesselator.prototype.gluTessNormal=function(t,e,i){this.normal[0]=t,this.normal[1]=e,this.normal[2]=i},r.GluTesselator.prototype.gluTessCallback=function(t,e){var i=e?e:null;switch(t){case r.gluEnum.GLU_TESS_BEGIN:return void(this.callBegin_=i);case r.gluEnum.GLU_TESS_BEGIN_DATA:return void(this.callBeginData_=i);case r.gluEnum.GLU_TESS_EDGE_FLAG:return void(this.callEdgeFlag_=i);case r.gluEnum.GLU_TESS_EDGE_FLAG_DATA:return void(this.callEdgeFlagData_=i);case r.gluEnum.GLU_TESS_VERTEX:return void(this.callVertex_=i);case r.gluEnum.GLU_TESS_VERTEX_DATA:return void(this.callVertexData_=i);case r.gluEnum.GLU_TESS_END:return void(this.callEnd_=i);case r.gluEnum.GLU_TESS_END_DATA:return void(this.callEndData_=i);case r.gluEnum.GLU_TESS_ERROR:return void(this.callError_=i);case r.gluEnum.GLU_TESS_ERROR_DATA:return void(this.callErrorData_=i);case r.gluEnum.GLU_TESS_COMBINE:return void(this.callCombine_=i);case r.gluEnum.GLU_TESS_COMBINE_DATA:return void(this.callCombineData_=i);case r.gluEnum.GLU_TESS_MESH:return void(this.callMesh_=i);default:return void this.callErrorOrErrorData(r.gluEnum.GLU_INVALID_ENUM)}},r.GluTesselator.prototype.gluTessVertex=function(t,e){var i=!1,n=[0,0,0];this.requireState_(r.GluTesselator.tessState_.T_IN_CONTOUR),this.emptyCache&&(this.emptyCache_(),this.lastEdge_=null);for(var o=0;o<3;++o){var s=t[o];s<-r.GLU_TESS_MAX_COORD&&(s=-r.GLU_TESS_MAX_COORD,i=!0),s>r.GLU_TESS_MAX_COORD&&(s=r.GLU_TESS_MAX_COORD,i=!0),n[o]=s}if(i&&this.callErrorOrErrorData(r.errorType.GLU_TESS_COORD_TOO_LARGE),null===this.mesh){if(this.cacheCount<r.TESS_MAX_CACHE)return void this.cacheVertex_(n,e);this.emptyCache_()}this.addVertex_(n,e)},r.GluTesselator.prototype.gluTessBeginPolygon=function(t){this.requireState_(r.GluTesselator.tessState_.T_DORMANT),this.state=r.GluTesselator.tessState_.T_IN_POLYGON,this.cacheCount=0,this.emptyCache=!1,this.mesh=null,this.polygonData_=t},r.GluTesselator.prototype.gluTessBeginContour=function(){this.requireState_(r.GluTesselator.tessState_.T_IN_POLYGON),this.state=r.GluTesselator.tessState_.T_IN_CONTOUR,this.lastEdge_=null,this.cacheCount>0&&(this.emptyCache=!0)},r.GluTesselator.prototype.gluTessEndContour=function(){this.requireState_(r.GluTesselator.tessState_.T_IN_CONTOUR),this.state=r.GluTesselator.tessState_.T_IN_POLYGON},r.GluTesselator.prototype.gluTessEndPolygon=function(){if(this.requireState_(r.GluTesselator.tessState_.T_IN_POLYGON),this.state=r.GluTesselator.tessState_.T_DORMANT,null===this.mesh&&this.emptyCache_(),r.normal.projectPolygon(this),r.sweep.computeInterior(this),!this.fatalError){var t=this.mesh;if(this.boundaryOnly?r.tessmono.setWindingNumber(t,1,!0):r.tessmono.tessellateInterior(t),this.mesh.checkMesh(),this.callBegin_||this.callEnd_||this.callVertex_||this.callEdgeFlag_||this.callBeginData_||this.callEndData_||this.callVertexData_||this.callEdgeFlagData_)if(this.boundaryOnly)r.render.renderBoundary(this,this.mesh);else{var e=!(!this.callEdgeFlag_&&!this.callEdgeFlagData_);r.render.renderMesh(this,this.mesh,e)}if(this.callMesh_)return r.tessmono.discardExterior(this.mesh),this.callMesh_(this.mesh),this.mesh=null,void(this.polygonData_=null)}r.mesh.deleteMesh(this.mesh),this.polygonData_=null,this.mesh=null},r.GluTesselator.prototype.makeDormant_=function(){this.mesh&&r.mesh.deleteMesh(this.mesh),this.state=r.GluTesselator.tessState_.T_DORMANT,this.lastEdge_=null,this.mesh=null},r.GluTesselator.prototype.requireState_=function(t){this.state!==t&&this.gotoState_(t)},r.GluTesselator.prototype.gotoState_=function(t){for(;this.state!==t;)if(this.state<t)switch(this.state){case r.GluTesselator.tessState_.T_DORMANT:this.callErrorOrErrorData(r.errorType.GLU_TESS_MISSING_BEGIN_POLYGON),this.gluTessBeginPolygon(null);break;case r.GluTesselator.tessState_.T_IN_POLYGON:this.callErrorOrErrorData(r.errorType.GLU_TESS_MISSING_BEGIN_CONTOUR),this.gluTessBeginContour()}else switch(this.state){case r.GluTesselator.tessState_.T_IN_CONTOUR:this.callErrorOrErrorData(r.errorType.GLU_TESS_MISSING_END_CONTOUR),this.gluTessEndContour();break;case r.GluTesselator.tessState_.T_IN_POLYGON:this.callErrorOrErrorData(r.errorType.GLU_TESS_MISSING_END_POLYGON),this.makeDormant_()}},r.GluTesselator.prototype.addVertex_=function(t,e){var i=this.lastEdge_;null===i?(i=r.mesh.makeEdge(this.mesh),r.mesh.meshSplice(i,i.sym)):(r.mesh.splitEdge(i),i=i.lNext),i.org.data=e,i.org.coords[0]=t[0],i.org.coords[1]=t[1],i.org.coords[2]=t[2],i.winding=1,i.sym.winding=-1,this.lastEdge_=i},r.GluTesselator.prototype.cacheVertex_=function(t,e){var i=this.cache[this.cacheCount];i.data=e,i.coords[0]=t[0],i.coords[1]=t[1],i.coords[2]=t[2],++this.cacheCount},r.GluTesselator.prototype.emptyCache_=function(){this.mesh=new r.GluMesh;for(var t=0;t<this.cacheCount;t++){var e=this.cache[t];this.addVertex_(e.coords,e.data)}this.cacheCount=0,this.emptyCache=!1},r.GluTesselator.prototype.callBeginOrBeginData=function(t){this.callBeginData_?this.callBeginData_(t,this.polygonData_):this.callBegin_&&this.callBegin_(t)},r.GluTesselator.prototype.callVertexOrVertexData=function(t){this.callVertexData_?this.callVertexData_(t,this.polygonData_):this.callVertex_&&this.callVertex_(t)},r.GluTesselator.prototype.callEdgeFlagOrEdgeFlagData=function(t){this.callEdgeFlagData_?this.callEdgeFlagData_(t,this.polygonData_):this.callEdgeFlag_&&this.callEdgeFlag_(t)},r.GluTesselator.prototype.callEndOrEndData=function(){this.callEndData_?this.callEndData_(this.polygonData_):this.callEnd_&&this.callEnd_();
},r.GluTesselator.prototype.callCombineOrCombineData=function(t,e,i){var r;return this.callCombineData_?r=this.callCombineData_(t,e,i,this.polygonData_):this.callCombine_&&(r=this.callCombine_(t,e,i)),void 0===r&&(r=null),r},r.GluTesselator.prototype.callErrorOrErrorData=function(t){this.callErrorData_?this.callErrorData_(t,this.polygonData_):this.callError_&&this.callError_(t)},r.GluFace=function(t,e){this.next=t||this,this.prev=e||this,this.anEdge=null,this.data=null,this.inside=!1},r.GluHalfEdge=function(t){this.next=t||this,this.sym=null,this.oNext=null,this.lNext=null,this.org=null,this.lFace=null,this.activeRegion=null,this.winding=0},r.GluHalfEdge.prototype.rFace=function(){return this.sym.lFace},r.GluHalfEdge.prototype.dst=function(){return this.sym.org},r.GluHalfEdge.prototype.oPrev=function(){return this.sym.lNext},r.GluHalfEdge.prototype.lPrev=function(){return this.oNext.sym},r.GluHalfEdge.prototype.dPrev=function(){return this.lNext.sym},r.GluHalfEdge.prototype.rPrev=function(){return this.sym.oNext},r.GluHalfEdge.prototype.dNext=function(){return this.rPrev().sym},r.GluHalfEdge.prototype.rNext=function(){return this.oPrev().sym},r.GluMesh=function(){this.vHead=new r.GluVertex,this.fHead=new r.GluFace,this.eHead=new r.GluHalfEdge,this.eHeadSym=new r.GluHalfEdge,this.eHead.sym=this.eHeadSym,this.eHeadSym.sym=this.eHead},r.GluMesh.prototype.checkMesh=function(){if(r.DEBUG){var t,e,i=this.fHead,n=this.vHead,o=this.eHead,s=i;for(s=i;(e=s.next)!==i;s=e){t=e.anEdge;do t=t.lNext;while(t!==e.anEdge)}var a,l=n;for(l=n;(a=l.next)!==n;l=a){t=a.anEdge;do t=t.oNext;while(t!==a.anEdge)}var h=o;for(h=o;(t=h.next)!==o;h=t);}},r.GluVertex=function(t,e){this.next=t||this,this.prev=e||this,this.anEdge=null,this.data=null,this.coords=[0,0,0],this.s=0,this.t=0,this.pqHandle=null},r.PQHandleElem=function(){this.key=null,this.node=0},r.PQHandleElem.realloc=function(t,e){var i=new Array(e),n=0;if(null!==t)for(;n<t.length;n++)i[n]=t[n];for(;n<e;n++)i[n]=new r.PQHandleElem;return i},r.PQNode=function(){this.handle=0},r.PQNode.realloc=function(t,e){var i=new Array(e),n=0;if(null!==t)for(;n<t.length;n++)i[n]=t[n];for(;n<e;n++)i[n]=new r.PQNode;return i},r.PriorityQ=function(t){this.keys_=r.PriorityQ.prototype.PQKeyRealloc_(null,r.PriorityQ.INIT_SIZE_),this.order_=null,this.size_=0,this.max_=r.PriorityQ.INIT_SIZE_,this.initialized_=!1,this.leq_=t,this.heap_=new r.PriorityQHeap(this.leq_)},r.PriorityQ.INIT_SIZE_=32,r.PriorityQ.prototype.deleteQ=function(){this.heap_.deleteHeap(),this.heap_=null,this.order_=null,this.keys_=null},r.PriorityQ.prototype.init=function(){this.order_=[];for(var t=0;t<this.size_;t++)this.order_[t]=t;var e=function(t,e){return function(i,r){return e(t[i],t[r])?1:-1}}(this.keys_,this.leq_);if(this.order_.sort(e),this.max_=this.size_,this.initialized_=!0,this.heap_.init(),r.DEBUG){var i=0,n=i+this.size_-1;for(t=i;t<n;++t);}},r.PriorityQ.prototype.insert=function(t){if(this.initialized_)return this.heap_.insert(t);var e=this.size_;return++this.size_>=this.max_&&(this.max_*=2,this.keys_=r.PriorityQ.prototype.PQKeyRealloc_(this.keys_,this.max_)),this.keys_[e]=t,-(e+1)},r.PriorityQ.prototype.PQKeyRealloc_=function(t,e){var i=new Array(e),r=0;if(null!==t)for(;r<t.length;r++)i[r]=t[r];for(;r<e;r++)i[r]=null;return i},r.PriorityQ.prototype.keyLessThan_=function(t,e){var i=this.keys_[t],r=this.keys_[e];return!this.leq_(r,i)},r.PriorityQ.prototype.keyGreaterThan_=function(t,e){var i=this.keys_[t],r=this.keys_[e];return!this.leq_(i,r)},r.PriorityQ.prototype.extractMin=function(){if(0===this.size_)return this.heap_.extractMin();var t=this.keys_[this.order_[this.size_-1]];if(!this.heap_.isEmpty()){var e=this.heap_.minimum();if(this.leq_(e,t))return this.heap_.extractMin()}do--this.size_;while(this.size_>0&&null===this.keys_[this.order_[this.size_-1]]);return t},r.PriorityQ.prototype.minimum=function(){if(0===this.size_)return this.heap_.minimum();var t=this.keys_[this.order_[this.size_-1]];if(!this.heap_.isEmpty()){var e=this.heap_.minimum();if(this.leq_(e,t))return e}return t},r.PriorityQ.prototype.isEmpty_=function(){return 0===this.size_&&this.heap_.isEmpty()},r.PriorityQ.prototype.remove=function(t){if(t>=0)return void this.heap_.remove(t);for(t=-(t+1),this.keys_[t]=null;this.size_>0&&null===this.keys_[this.order_[this.size_-1]];)--this.size_},r.PriorityQHeap=function(t){this.nodes_=r.PQNode.realloc(null,r.PriorityQHeap.INIT_SIZE_+1),this.handles_=r.PQHandleElem.realloc(null,r.PriorityQHeap.INIT_SIZE_+1),this.size_=0,this.max_=r.PriorityQHeap.INIT_SIZE_,this.freeList_=0,this.initialized_=!1,this.leq_=t,this.nodes_[1].handle=1},r.PriorityQHeap.INIT_SIZE_=32,r.PriorityQHeap.prototype.deleteHeap=function(){this.handles_=null,this.nodes_=null},r.PriorityQHeap.prototype.init=function(){for(var t=this.size_;t>=1;--t)this.floatDown_(t);this.initialized_=!0},r.PriorityQHeap.prototype.insert=function(t){var e=++this.size_;2*e>this.max_&&(this.max_*=2,this.nodes_=r.PQNode.realloc(this.nodes_,this.max_+1),this.handles_=r.PQHandleElem.realloc(this.handles_,this.max_+1));var i;return 0===this.freeList_?i=e:(i=this.freeList_,this.freeList_=this.handles_[i].node),this.nodes_[e].handle=i,this.handles_[i].node=e,this.handles_[i].key=t,this.initialized_&&this.floatUp_(e),i},r.PriorityQHeap.prototype.isEmpty=function(){return 0===this.size_},r.PriorityQHeap.prototype.minimum=function(){return this.handles_[this.nodes_[1].handle].key},r.PriorityQHeap.prototype.extractMin=function(){var t=this.nodes_,e=this.handles_,i=t[1].handle,r=e[i].key;return this.size_>0&&(t[1].handle=t[this.size_].handle,e[t[1].handle].node=1,e[i].key=null,e[i].node=this.freeList_,this.freeList_=i,--this.size_>0&&this.floatDown_(1)),r},r.PriorityQHeap.prototype.remove=function(t){var e=this.nodes_,i=this.handles_,r=i[t].node;e[r].handle=e[this.size_].handle,i[e[r].handle].node=r,r<=--this.size_&&(r<=1||this.leq_(i[e[r>>1].handle].key,i[e[r].handle].key)?this.floatDown_(r):this.floatUp_(r)),i[t].key=null,i[t].node=this.freeList_,this.freeList_=t},r.PriorityQHeap.prototype.floatDown_=function(t){for(var e=this.nodes_,i=this.handles_,r=e[t].handle;;){var n=t<<1;n<this.size_&&this.leq_(i[e[n+1].handle].key,i[e[n].handle].key)&&++n;var o=e[n].handle;if(n>this.size_||this.leq_(i[r].key,i[o].key)){e[t].handle=r,i[r].node=t;break}e[t].handle=o,i[o].node=t,t=n}},r.PriorityQHeap.prototype.floatUp_=function(t){for(var e=this.nodes_,i=this.handles_,r=e[t].handle;;){var n=t>>1,o=e[n].handle;if(0===n||this.leq_(i[o].key,i[r].key)){e[t].handle=r,i[r].node=t;break}e[t].handle=o,i[o].node=t,t=n}},r.ActiveRegion=function(){this.eUp=null,this.nodeUp=null,this.windingNumber=0,this.inside=!1,this.sentinel=!1,this.dirty=!1,this.fixUpperEdge=!1},r.ActiveRegion.prototype.regionBelow=function(){return this.nodeUp.getPredecessor().getKey()},r.ActiveRegion.prototype.regionAbove=function(){return this.nodeUp.getSuccessor().getKey()},"undefined"!=typeof module&&(module.exports=r),i("util/libtess",function(){}),i("util/measure/AreaMeasurer",["../../geom/Angle","../../error/ArgumentError","../../geom/Location","../Logger","./MeasurerUtils","../../geom/Sector","../../geom/Vec3","../libtess"],function(t,e,i,n,o,s,a,l){"use strict";var h=function(t){if(!t)throw new e(n.logMessage(n.LEVEL_SEVERE,"AreaMeasurer","constructor","missingWorldWindow"));this.wwd=t,this.DEFAULT_AREA_SAMPLING_STEPS=32,this._areaTerrainSamplingSteps=this.DEFAULT_AREA_SAMPLING_STEPS,this._maxSegmentLength=1e5,this.subdividedPositions=null,this.vecZ=new a(0,0,1),this.scratchLocation=new i(0,0)};return Object.defineProperties(h.prototype,{areaTerrainSamplingSteps:{get:function(){return this._areaTerrainSamplingSteps},set:function(t){this._areaTerrainSamplingSteps=t}},maxSegmentLength:{get:function(){return this._maxSegmentLength},set:function(t){this._maxSegmentLength=t}}}),h.prototype.getArea=function(t,e,i){var r=this.wwd.globe;return e?this.computeSurfaceAreaSampling(r,t,i):this.computeProjectedAreaGeometry(r,t,i)},h.prototype.computeSurfaceAreaSampling=function(e,i,r){var n=new s(0,0,0,0);n.setToBoundingSector(i),this.subdividedPositions=o.subdividePositions(e,i,!0,r,this._maxSegmentLength);for(var l=Math.max(this.DEFAULT_AREA_SAMPLING_STEPS,this._areaTerrainSamplingSteps),h=n.deltaLatitude()*t.DEGREES_TO_RADIANS,u=n.deltaLongitude()*t.DEGREES_TO_RADIANS,c=Math.max(h/l,u/l),d=Math.round(h/c),p=Math.round(u/c*Math.cos(n.centroidLatitude()*t.DEGREES_TO_RADIANS)),f=h/d,g=u/p,m=0,y=0;y<d;y++)for(var E=n.minLatitude*t.DEGREES_TO_RADIANS+f*y,v=e.radiusAt((E+f/2)*t.RADIANS_TO_DEGREES,n.centroidLongitude()),_=g*v*Math.cos(E+f/2),b=f*v,w=_*b,S=0;S<p;S++){var L=n.minLongitude*t.DEGREES_TO_RADIANS+g*S,T=E*t.RADIANS_TO_DEGREES,A=(E+f)*t.RADIANS_TO_DEGREES,R=L*t.RADIANS_TO_DEGREES,x=(L+g)*t.RADIANS_TO_DEGREES,C=new s(T,A,R,x),M=o.isLocationInside(C.centroid(this.scratchLocation),this.subdividedPositions);if(M){var P=e.elevationAtLocation(T,R),O=e.elevationAtLocation(T,x),N=e.elevationAtLocation(A,R),I=new a(_,0,O-P),D=new a(0,b,N-P);I.normalize(),D.normalize();var k=I.cross(D).normalize(),F=Math.tan(o.angleBetweenVectors(this.vecZ,k)),V=Math.sqrt(1+F*F);m+=w*V}}return m},h.prototype.computeProjectedAreaGeometry=function(e,i,r){this.subdividedPositions=o.subdividePositions(e,i,!1,r,this._maxSegmentLength);var n=this.subdividedPositions.length,s=this.subdividedPositions[0],a=this.subdividedPositions[n-1];s.equals(a)&&n--;for(var l=[],h=0,u=0;u<n;u++){var c=this.subdividedPositions[u];l[h++]=c.longitude*t.DEGREES_TO_RADIANS,l[h++]=c.latitude*t.DEGREES_TO_RADIANS,l[h++]=0}var d=this.tessellatePolygon(n,l),p=0,f=d.length/9;for(u=0;u<f;u++){h=9*u;var g=[d[h+0],d[h+1],d[h+2],d[h+3],d[h+4],d[h+5],d[h+6],d[h+7],d[h+8]];p+=this.computeTriangleProjectedArea(e,g)}return p},h.prototype.computeTriangleProjectedArea=function(e,i){var r=i[0],n=i[1],o=i[3],s=i[4],a=i[6],l=i[7],h=Math.abs(r*(s-l)+o*(l-n)+a*(n-s));h/=2;var u=(r+o+a)/3,c=(n+s+l)/3,d=e.radiusAt(c*t.RADIANS_TO_DEGREES,u*t.RADIANS_TO_DEGREES);return h*=Math.cos(c)*d*d},h.prototype.tessellatePolygon=function(t,e){var i,o=new r.GluTesselator,s=[];o.gluTessCallback(r.gluEnum.GLU_TESS_BEGIN,function(t){t!==r.primitiveType.GL_TRIANGLES&&n.logMessage(n.LEVEL_WARNING,"AreaMeasurer","tessellatePolygon","Tessellation error, primitive is not TRIANGLES.")}),o.gluTessCallback(r.gluEnum.GLU_TESS_VERTEX_DATA,function(t,e){e.push(t[0]),e.push(t[1]),e.push(t[2])}),o.gluTessCallback(r.gluEnum.GLU_TESS_EDGE_FLAG,function(){}),o.gluTessCallback(r.gluEnum.GLU_TESS_ERROR,function(t){n.logMessage(n.LEVEL_WARNING,"AreaMeasurer","tessellatePolygon","Tessellation error "+t+".")}),o.gluTessBeginPolygon(s),o.gluTessBeginContour();for(var a=0;a<t;a++)i=e.slice(3*a,3*a+3),o.gluTessVertex(i,i);return o.gluTessEndContour(),o.gluTessEndPolygon(),s},h}),i("util/AbsentResourceList",[],function(){"use strict";var t=function(t,e){this.maxTrys=t,this.minCheckInterval=e,this.tryAgainInterval=6e4,this.possiblyAbsent={}};return t.prototype.isResourceAbsent=function(t){var e=this.possiblyAbsent[t];if(!e)return!1;if(e.permanent)return!0;var i=Date.now()-e.timeOfLastMark;return i>this.tryAgainInterval?(delete this.possiblyAbsent[t],!1):i<this.minCheckInterval||e.numTrys>this.maxTrys},t.prototype.markResourceAbsent=function(t){var e=this.possiblyAbsent[t];e||(e={timeOfLastMark:Date.now(),numTrys:0},this.possiblyAbsent[t]=e),e.numTrys=e.numTrys+1,e.timeOfLastMark=Date.now()},t.prototype.markResourceAbsentPermanently=function(t){var e=this.possiblyAbsent[t];e||(e={timeOfLastMark:Date.now(),numTrys:0},this.possiblyAbsent[t]=e),e.numTrys=e.numTrys+1,e.timeOfLastMark=Date.now(),e.permanent=!0},t.prototype.unmarkResourceAbsent=function(t){var e=this.possiblyAbsent[t];e&&delete this.possiblyAbsent[t]},t}),i("globe/ElevationCoverage",["../error/ArgumentError","../util/Logger","../geom/Sector"],function(t,e,i){"use strict";var r=function(r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"ElevationCoverage","constructor","missingResolution"));this.timestamp=Date.now(),this.displayName="Coverage",this._enabled=!0,this.resolution=r,this.coverageSector=i.FULL_SPHERE};return Object.defineProperties(r.prototype,{enabled:{get:function(){return this._enabled},set:function(t){this._enabled=t,this.timestamp=Date.now()}}}),r.prototype.minAndMaxElevationsForSector=function(i,r){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"ElevationCoverage","minAndMaxElevationsForSector","missingSector"));if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"ElevationCoverage","minAndMaxElevationsForSector","missingResult"));return r[0]>0&&(r[0]=0),r[1]<0&&(r[1]=0),!0},r.prototype.elevationAtLocation=function(t,e){return 0},r.prototype.elevationsForGrid=function(i,r,n,o){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"ElevationCoverage","elevationsForGrid","missingSector"));if(r<=0||n<=0)throw new t(e.logMessage(e.LEVEL_SEVERE,"ElevationCoverage","elevationsForGrid","numLat or numLon is less than 1"));if(!o||o.length<r*n)throw new t(e.logMessage(e.LEVEL_SEVERE,"ElevationCoverage","elevationsForGrid","missingArray"));for(var s=0,a=o.length;s<a;s++)o[s]=0;return!0},r}),i("globe/ElevationImage",["../error/ArgumentError","../util/Logger","../util/WWMath"],function(t,e,i){"use strict";var r=function(i,r,n){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"ElevationImage","constructor","missingSector"));this.sector=i,this.imageWidth=r,this.imageHeight=n,this.size=this.imageWidth*this.imageHeight,this.hasData=!0,this.hasMissingData=!1};return r.NO_DATA=0,r.isNoData=function(t,e,i,n){var o=r.NO_DATA;return t===o&&e===o&&i===o&&n===o},r.prototype.pixel=function(t,e){return t<0||t>=this.imageWidth?0:e<0||e>=this.imageHeight?0:(e=this.imageHeight-e-1,this.imageData[t+e*this.imageWidth])},r.prototype.elevationAtLocation=function(t,e){var n=this.sector.maxLatitude,o=this.sector.minLongitude,s=this.sector.deltaLatitude(),a=this.sector.deltaLongitude(),l=(this.imageWidth-1)*(e-o)/a,h=(this.imageHeight-1)*(n-t)/s,u=Math.floor(i.clamp(l,0,this.imageWidth-1)),c=Math.floor(i.clamp(u+1,0,this.imageWidth-1)),d=Math.floor(i.clamp(h,0,this.imageHeight-1)),p=Math.floor(i.clamp(d+1,0,this.imageHeight-1)),f=this.imageData,g=f[u+d*this.imageWidth],m=f[c+d*this.imageWidth],y=f[u+p*this.imageWidth],E=f[c+p*this.imageWidth],v=l-u,_=h-d;return r.isNoData(g,m,y,E)?NaN:(1-v)*(1-_)*g+v*(1-_)*m+(1-v)*_*y+v*_*E},r.prototype.elevationsForGrid=function(n,o,s,a){if(!n)throw new t(e.logMessage(e.LEVEL_SEVERE,"ElevationImage","elevationsForGrid","missingSector"));if(o<1||s<1)throw new t(e.logMessage(e.LEVEL_SEVERE,"ElevationImage","elevationsForGrid","The specified number of sample points is less than 1."));if(!a)throw new t(e.logMessage(e.LEVEL_SEVERE,"ElevationImage","elevationsForGrid","missingResult"));var l,h,u,c,d=this.sector.minLatitude,p=this.sector.maxLatitude,f=this.sector.minLongitude,g=this.sector.maxLongitude,m=p-d,y=g-f,E=n.minLatitude,v=n.maxLatitude,_=n.minLongitude,b=n.maxLongitude,w=(v-E)/(o>1?o-1:1),S=(b-_)/(s>1?s-1:1),L=0,T=this.imageData;for(c=0,l=E;c<o;c+=1,l+=w)if(c===o-1&&(l=v),l>=d&&l<=p){var A=(this.imageHeight-1)*(p-l)/m,R=Math.floor(i.clamp(A,0,this.imageHeight-1)),x=Math.floor(i.clamp(R+1,0,this.imageHeight-1)),C=A-R;for(u=0,h=_;u<s;u+=1,h+=S){if(u===s-1&&(h=b),h>=f&&h<=g&&isNaN(a[L])){var M=(this.imageWidth-1)*(h-f)/y,P=Math.floor(i.clamp(M,0,this.imageWidth-1)),O=Math.floor(i.clamp(P+1,0,this.imageWidth-1)),N=M-P,I=T[P+R*this.imageWidth],D=T[O+R*this.imageWidth],k=T[P+x*this.imageWidth],F=T[O+x*this.imageWidth];r.isNoData(I,D,k,F)?a[L]=NaN:a[L]=(1-N)*(1-C)*I+N*(1-C)*D+(1-N)*C*k+N*C*F}L++}}else L+=s},r.prototype.minAndMaxElevationsForSector=function(t){if(!this.hasData)return null;var e=[];if(t)if(t.contains(this.sector))e[0]>this.minElevation&&(e[0]=this.minElevation),e[1]<this.maxElevation&&(e[1]=this.maxElevation);else{var r=this.sector.maxLatitude,n=this.sector.minLongitude,o=this.sector.deltaLatitude(),s=this.sector.deltaLongitude(),a=t.minLatitude,l=t.maxLatitude,h=t.minLongitude,u=t.maxLongitude,c=Math.floor((this.imageHeight-1)*(r-l)/o),d=Math.ceil((this.imageHeight-1)*(r-a)/o),p=Math.floor((this.imageWidth-1)*(h-n)/s),f=Math.ceil((this.imageWidth-1)*(u-n)/s);c=i.clamp(c,0,this.imageHeight-1),d=i.clamp(d,0,this.imageHeight-1),p=i.clamp(p,0,this.imageWidth-1),f=i.clamp(f,0,this.imageWidth-1);for(var g=this.imageData,m=Number.MAX_VALUE,y=-m,E=c;E<=d;E++)for(var v=p;v<=f;v++){var _=g[Math.floor(v+E*this.imageWidth)];m>_&&(m=_),y<_&&(y=_)}e[0]>m&&(e[0]=m),e[1]<y&&(e[1]=y)}else e[0]=this.minElevation,e[1]=this.maxElevation;return e},r.prototype.findMinAndMaxElevation=function(){if(this.hasData=!1,this.hasMissingData=!1,this.imageData&&this.imageData.length>0){this.minElevation=Number.MAX_VALUE,this.maxElevation=-Number.MAX_VALUE;for(var t=this.imageData,e=this.imageWidth*this.imageHeight,i=0;i<e;i++){var n=t[i];n!==r.NO_DATA?(this.hasData=!0,this.minElevation>n&&(this.minElevation=n),this.maxElevation<n&&(this.maxElevation=n)):this.hasMissingData=!0}}this.hasData||(this.minElevation=0,this.maxElevation=0)},r}),i("formats/geotiff/GeoTiffConstants",[],function(){"use strict";var t={Tag:{MODEL_PIXEL_SCALE:33550,MODEL_TRANSFORMATION:34264,MODEL_TIEPOINT:33922,GEO_KEY_DIRECTORY:34735,GEO_DOUBLE_PARAMS:34736,GEO_ASCII_PARAMS:34737,GDAL_NODATA:42113,GDAL_METADATA:42112},Key:{GTModelTypeGeoKey:1024,GTRasterTypeGeoKey:1025,GTCitationGeoKey:1026,GeographicTypeGeoKey:2048,GeogCitationGeoKey:2049,GeogGeodeticDatumGeoKey:2050,GeogPrimeMeridianGeoKey:2051,GeogLinearUnitsGeoKey:2052,GeogLinearUnitSizeGeoKey:2053,GeogAngularUnitsGeoKey:2054,GeogAngularUnitSizeGeoKey:2055,GeogEllipsoidGeoKey:2056,GeogSemiMajorAxisGeoKey:2057,GeogSemiMinorAxisGeoKey:2058,GeogInvFlatteningGeoKey:2059,GeogAzimuthUnitsGeoKey:2060,GeogPrimeMeridianLongGeoKey:2061,GeogTOWGS84GeoKey:2062,ProjectedCSTypeGeoKey:3072,PCSCitationGeoKey:3073,ProjectionGeoKey:3074,ProjCoordTransGeoKey:3075,ProjLinearUnitsGeoKey:3076,ProjLinearUnitSizeGeoKey:3077,ProjStdParallel1GeoKey:3078,ProjStdParallel2GeoKey:3079,ProjNatOriginLongGeoKey:3080,ProjNatOriginLatGeoKey:3081,ProjFalseEastingGeoKey:3082,ProjFalseNorthingGeoKey:3083,ProjFalseOriginLongGeoKey:3084,ProjFalseOriginLatGeoKey:3085,ProjFalseOriginEastingGeoKey:3086,ProjFalseOriginNorthingGeoKey:3087,ProjCenterLongGeoKey:3088,ProjCenterLatGeoKey:3089,ProjCenterEastingGeoKey:3090,ProjCenterNorthingGeoKey:3091,ProjScaleAtNatOriginGeoKey:3092,ProjScaleAtCenterGeoKey:3093,ProjAzimuthAngleGeoKey:3094,ProjStraightVertPoleLongGeoKey:3095,VerticalCSTypeGeoKey:4096,VerticalCitationGeoKey:4097,VerticalDatumGeoKey:4098,VerticalUnitsGeoKey:4099}};return t}),i("formats/geotiff/GeoTiffKeyEntry",["../../error/AbstractError","../../error/ArgumentError","./GeoTiffConstants","../../util/Logger"],function(t,e,i,r){"use strict";var n=function(t,i,n,o){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"GeoTiffKeyEntry","constructor","missingKeyId"));if(null===i||void 0===i)throw new e(r.logMessage(r.LEVEL_SEVERE,"GeoTiffKeyEntry","constructor","missingTiffTagLocation"));if(!n)throw new e(r.logMessage(r.LEVEL_SEVERE,"GeoTiffKeyEntry","constructor","missingCount"));if(null===o||void 0===o)throw new e(r.logMessage(r.LEVEL_SEVERE,"GeoTiffKeyEntry","constructor","missingValueOffset"));this._keyId=t,this._tiffTagLocation=i,this._count=n,this._valueOffset=o};return Object.defineProperties(n.prototype,{keyId:{get:function(){return this._keyId}},tiffTagLocation:{get:function(){return this._tiffTagLocation}},count:{get:function(){return this._count}},valueOffset:{get:function(){return this._valueOffset}}}),n.prototype.getGeoKeyValue=function(t,e){var r;if(0===this.tiffTagLocation)r=this.valueOffset;else if(this.tiffTagLocation===i.Tag.GEO_ASCII_PARAMS){var n="";if(e){for(var o=this.valueOffset;o<this.count-1;o++)n+=e[o];"|"!=e[this.count-1]&&(n+=e[this.count-1]),r=n}}else this.tiffTagLocation===i.Tag.GEO_DOUBLE_PARAMS&&t&&(r=t[this.valueOffset]);return r},n}),i("formats/geotiff/GeoTiffMetadata",[],function(){"use strict";var t=function(){this._bitsPerSample=null,this._colorMap=null,this._compression=null,this._extraSamples=null,this._imageDescription=null,this._imageLength=null,this._imageWidth=null,this._maxSampleValue=null,this._minSampleValue=null,this._orientation=0,this._photometricInterpretation=null,this._planarConfiguration=null,this._resolutionUnit=null,this._rowsPerStrip=null,this._samplesPerPixel=null,this._sampleFormat=null,this._software=null,this._stripByteCounts=null,this._stripOffsets=null,this._tileByteCounts=null,this._tileOffsets=null,this._tileLength=null,this._tileWidth=null,this._xResolution=null,this._yResolution=null,this._geoAsciiParams=null,this._geoDoubleParams=null,this._geoKeyDirectory=null,this._modelPixelScale=null,this._modelTiepoint=null,this._modelTransformation=null,this._noData=null,this._metaData=null,this._bbox=null,this._gtModelTypeGeoKey=null,this._gtRasterTypeGeoKey=null,this._gtCitationGeoKey=null,this._geographicTypeGeoKey=null,this._geogCitationGeoKey=null,this._geogAngularUnitsGeoKey=null,this._geogAngularUnitSizeGeoKey=null,this._geogSemiMajorAxisGeoKey=null,this._geogInvFlatteningGeoKey=null,this._projectedCSType=null,this._projLinearUnits=null};return Object.defineProperties(t.prototype,{bitsPerSample:{get:function(){return this._bitsPerSample},set:function(t){this._bitsPerSample=t}},colorMap:{get:function(){return this._colorMap},set:function(t){this._colorMap=t}},compression:{get:function(){return this._compression},set:function(t){this._compression=t}},extraSamples:{get:function(){return this._extraSamples},set:function(t){this._extraSamples=t}},imageDescription:{get:function(){return this._imageDescription},set:function(t){this._imageDescription=t}},imageLength:{get:function(){return this._imageLength},set:function(t){this._imageLength=t}},imageWidth:{get:function(){return this._imageWidth},set:function(t){this._imageWidth=t}},maxSampleValue:{get:function(){return this._maxSampleValue},set:function(t){this._maxSampleValue=t}},minSampleValue:{get:function(){return this._minSampleValue},set:function(t){this._minSampleValue=t}},orientation:{get:function(){return this._orientation},set:function(t){this._orientation=t}},photometricInterpretation:{get:function(){return this._photometricInterpretation},set:function(t){this._photometricInterpretation=t}},planarConfiguration:{get:function(){return this._planarConfiguration},set:function(t){this._planarConfiguration=t}},resolutionUnit:{get:function(){return this._resolutionUnit},set:function(t){this._resolutionUnit=t}},rowsPerStrip:{get:function(){return this._rowsPerStrip},set:function(t){this._rowsPerStrip=t}},samplesPerPixel:{get:function(){return this._samplesPerPixel},set:function(t){this._samplesPerPixel=t}},sampleFormat:{get:function(){return this._sampleFormat},set:function(t){this._sampleFormat=t}},software:{get:function(){return this._software},set:function(t){this._software=t}},stripByteCounts:{get:function(){return this._stripByteCounts},set:function(t){this._stripByteCounts=t}},stripOffsets:{get:function(){return this._stripOffsets},set:function(t){this._stripOffsets=t}},tileByteCounts:{get:function(){return this._tileByteCounts},set:function(t){this._tileByteCounts=t}},tileOffsets:{get:function(){return this._tileOffsets},set:function(t){this._tileOffsets=t}},tileLength:{get:function(){return this._tileLength},set:function(t){this._tileLength=t}},tileWidth:{get:function(){return this._tileWidth},set:function(t){this._tileWidth=t}},geoAsciiParams:{get:function(){return this._geoAsciiParams},set:function(t){this._geoAsciiParams=t}},geoDoubleParams:{get:function(){return this._geoDoubleParams},set:function(t){this._geoDoubleParams=t}},geoKeyDirectory:{get:function(){return this._geoKeyDirectory},set:function(t){this._geoKeyDirectory=t}},modelPixelScale:{get:function(){return this._modelPixelScale},set:function(t){this._modelPixelScale=t}},modelTiepoint:{get:function(){return this._modelTiepoint},set:function(t){this._modelTiepoint=t}},modelTransformation:{get:function(){return this._modelTransformation},set:function(t){this._modelTransformation=t}},noData:{get:function(){return this._noData},set:function(t){this._noData=t}},metaData:{get:function(){return this._metaData},set:function(t){this._metaData=t}},bbox:{get:function(){return this._bbox},set:function(t){this._bbox=t}},gtModelTypeGeoKey:{get:function(){return this._gtModelTypeGeoKey},set:function(t){this._gtModelTypeGeoKey=t}},gtRasterTypeGeoKey:{get:function(){return this._gtRasterTypeGeoKey},set:function(t){this._gtRasterTypeGeoKey=t}},gtCitationGeoKey:{get:function(){return this._gtCitationGeoKey},set:function(t){this._gtCitationGeoKey=t}},geographicTypeGeoKey:{get:function(){return this._geographicTypeGeoKey},set:function(t){this._geographicTypeGeoKey=t}},geogCitationGeoKey:{get:function(){return this._geogCitationGeoKey},set:function(t){this._geogCitationGeoKey=t}},geogAngularUnitsGeoKey:{get:function(){return this._geogAngularUnitsGeoKey},set:function(t){this._geogAngularUnitsGeoKey=t}},geogAngularUnitSizeGeoKey:{get:function(){return this._geogAngularUnitSizeGeoKey},set:function(t){this._geogAngularUnitSizeGeoKey=t}},geogSemiMajorAxisGeoKey:{get:function(){return this._geogSemiMajorAxisGeoKey},set:function(t){this._geogSemiMajorAxisGeoKey=t}},geogInvFlatteningGeoKey:{get:function(){return this._geogInvFlatteningGeoKey},set:function(t){this._geogInvFlatteningGeoKey=t}},projectedCSType:{get:function(){return this._projectedCSType},set:function(t){this._projectedCSType=t}},projLinearUnits:{get:function(){return this._projLinearUnits},set:function(t){this._projLinearUnits=t}},xResolution:{get:function(){return this._xResolution},set:function(t){this._xResolution=t}},yResolution:{get:function(){return this._yResolution},set:function(t){this._yResolution=t}}}),t}),i("formats/geotiff/TiffConstants",[],function(){"use strict";var t={Tag:{NEW_SUBFILE_TYPE:254,SUBFILE_TYPE:255,IMAGE_WIDTH:256,IMAGE_LENGTH:257,BITS_PER_SAMPLE:258,COMPRESSION:259,PHOTOMETRIC_INTERPRETATION:262,THRESHHOLDING:263,CELL_WIDTH:264,CELL_LENGTH:265,FILL_ORDER:266,DOCUMENT_NAME:269,IMAGE_DESCRIPTION:270,MAKE:271,MODEL:272,STRIP_OFFSETS:273,ORIENTATION:274,SAMPLES_PER_PIXEL:277,ROWS_PER_STRIP:278,STRIP_BYTE_COUNTS:279,MIN_SAMPLE_VALUE:280,MAX_SAMPLE_VALUE:281,X_RESOLUTION:282,Y_RESOLUTION:283,PLANAR_CONFIGURATION:284,PAGE_NAME:285,X_POSITION:286,Y_POSITION:287,FREE_OFFSETS:288,FREE_BYTE_COUNTS:289,GRAY_RESPONSE_UNIT:290,GRAY_RESPONSE_CURVE:291,T4_OPTIONS:292,T6_PTIONS:293,RESOLUTION_UNIT:296,PAGE_NUMBER:297,TRANSFER_FUNCTION:301,SOFTWARE:305,DATE_TIME:306,ARTIST:315,HOST_COMPUTER:316,PREDICTOR:317,WHITE_POINT:318,PRIMARY_CHROMATICITIES:319,COLOR_MAP:320,HALFTONE_HINTS:321,TILE_WIDTH:322,TILE_LENGTH:323,TILE_OFFSETS:324,TILE_BYTE_COUNTS:325,INK_SET:332,INK_NAMES:333,NUMBER_OF_INKS:334,DOT_RANGE:336,TARGET_PRINTER:337,EXTRA_SAMPLES:338,SAMPLE_FORMAT:339,S_MIN_SAMPLE_VALUE:340,S_MAX_SAMPLE_VALUE:341,TRANSFER_RANGE:342,JPEG_PROC:512,JPEG_INTERCHANGE_FORMAT:513,JPEG_INTERCHANGE_FORMAT_LENGTH:514,JPEG_RESTART_INTERVAL:515,JPEG_LOSSLESS_PREDICTORS:517,JPEG_POINT_TRANSFORMS:518,JPEG_Q_TABLES:519,JPEG_DC_TABLES:520,JPEG_AC_TABLES:521,Y_Cb_Cr_COEFFICIENTS:529,Y_Cb_Cr_SUB_SAMPLING:530,Y_Cb_Cr_POSITIONING:531,REFERENCE_BLACK_WHITE:532,COPYRIGHT:33432},Compression:{UNCOMPRESSED:1,CCITT_1D:2,GROUP_3_FAX:3,GROUP_4_FAX:4,LZW:5,JPEG:6,PACK_BITS:32773},Orientation:{Row0_IS_TOP__Col0_IS_LHS:1,Row0_IS_TOP__Col0_IS_RHS:2,Row0_IS_BOTTOM__Col0_IS_RHS:3,Row0_IS_BOTTOM__Col0_IS_LHS:4,Row0_IS_LHS__Col0_IS_TOP:5,Row0_IS_RHS__Col0_IS_TOP:6,Row0_IS_RHS__Col0_IS_BOTTOM:7,Row0_IS_LHS__Col0_IS_BOTTOM:8},PhotometricInterpretation:{WHITE_IS_ZERO:0,BLACK_IS_ZERO:1,RGB:2,RGB_PALETTE:3,TRANSPARENCY_MASK:4,CMYK:5,Y_Cb_Cr:6,CIE_LAB:7},PlanarConfiguration:{CHUNKY:1,PLANAR:2},ResolutionUnit:{NONE:1,INCH:2,CENTIMETER:3},SampleFormat:{UNSIGNED:1,SIGNED:2,IEEE_FLOAT:3,UNDEFINED:4,DEFAULT:1},Type:{BYTE:1,ASCII:2,SHORT:3,LONG:4,RATIONAL:5,SBYTE:6,UNDEFINED:7,SSHORT:8,SLONG:9,SRATIONAL:10,FLOAT:11,DOUBLE:12}};return t}),i("formats/geotiff/GeoTiffUtil",["../../error/ArgumentError","../../util/Logger","./TiffConstants"],function(t,e,i){"use strict";var r={getBytes:function(i,r,n,o,s){if(n<=0)throw new t(e.logMessage(e.LEVEL_SEVERE,"GeoTiffReader","getBytes","noBytesRequested"));if(n<=1)return s?i.getInt8(r,o):i.getUint8(r,o);if(n<=2)return s?i.getInt16(r,o):i.getUint16(r,o);if(n<=3)return s?i.getInt32(r,o)>>>8:i.getUint32(r,o)>>>8;if(n<=4)return s?i.getInt32(r,o):i.getUint32(r,o);if(n<=8)return i.getFloat64(r,o);throw new t(e.logMessage(e.LEVEL_SEVERE,"GeoTiffReader","getBytes","tooManyBytesRequested"))},getSampleBytes:function(t,r,n,o,s){var a;switch(o){case i.SampleFormat.UNSIGNED:a=this.getBytes(t,r,n,s,!1);break;case i.SampleFormat.SIGNED:a=this.getBytes(t,r,n,s,!0);break;case i.SampleFormat.IEEE_FLOAT:3==n?a=t.getFloat32(r,s)>>>8:4==n?a=t.getFloat32(r,s):8==n?a=t.getFloat64(r,s):e.log(e.LEVEL_WARNING,"Do not attempt to parse the data  not handled: "+n);break;case i.SampleFormat.UNDEFINED:default:a=this.getBytes(t,r,n,s,!1)}return a},getRGBAFillValue:function(t,e,i,r){return"undefined"==typeof r&&(r=1),"rgba("+t+", "+e+", "+i+", "+r+")"},clampColorSample:function(t,e){var i=Math.pow(2,8-e);return Math.floor(t*i+(i-1))}};return r}),i("util/proj4-src",[],function(){"use strict";function t(t,e){if(t[e])return t[e];for(var i,r,n=Object.keys(t),o=e.toLowerCase().replace(Be,""),s=-1;++s<n.length;)if(i=n[s],r=i.toLowerCase().replace(Be,""),r===o)return t[i]}function e(t){if("string"!=typeof t)throw new Error("not a string");this.text=t.trim(),this.level=0,this.place=0,this.root=null,this.stack=[],this.currentObject=null,this.state=Ke}function i(t){var i=new e(t);return i.output()}function r(t,e,i){Array.isArray(e)&&(i.unshift(e),e=null);var r=e?{}:t,o=i.reduce(function(t,e){return n(e,t),t},r);e&&(t[e]=o)}function n(t,e){if(!Array.isArray(t))return void(e[t]=!0);var i=t.shift();if("PARAMETER"===i&&(i=t.shift()),1===t.length)return Array.isArray(t[0])?(e[i]={},void n(t[0],e[i])):void(e[i]=t[0]);if(!t.length)return void(e[i]=!0);if("TOWGS84"===i)return void(e[i]=t);Array.isArray(i)||(e[i]={});var o;switch(i){case"UNIT":case"PRIMEM":case"VERT_DATUM":return e[i]={name:t[0].toLowerCase(),convert:t[1]},void(3===t.length&&n(t[2],e[i]));case"SPHEROID":case"ELLIPSOID":return e[i]={name:t[0],a:t[1],rf:t[2]},void(4===t.length&&n(t[3],e[i]));case"PROJECTEDCRS":case"PROJCRS":case"GEOGCS":case"GEOCCS":case"PROJCS":case"LOCAL_CS":case"GEODCRS":case"GEODETICCRS":case"GEODETICDATUM":case"EDATUM":case"ENGINEERINGDATUM":case"VERT_CS":case"VERTCRS":case"VERTICALCRS":case"COMPD_CS":case"COMPOUNDCRS":case"ENGINEERINGCRS":case"ENGCRS":case"FITTED_CS":case"LOCAL_DATUM":case"DATUM":return t[0]=["name",t[0]],void r(e,i,t);default:for(o=-1;++o<t.length;)if(!Array.isArray(t[o]))return n(t,e[i]);return r(e,i,t)}}function o(t,e){var i=e[0],r=e[1];!(i in t)&&r in t&&(t[i]=t[r],3===e.length&&(t[i]=e[2](t[i])))}function s(t){return t*ti}function a(t){function e(e){var i=t.to_meter||1;return e*i}"GEOGCS"===t.type?t.projName="longlat":"LOCAL_CS"===t.type?(t.projName="identity",t.local=!0):"object"==typeof t.PROJECTION?t.projName=Object.keys(t.PROJECTION)[0]:t.projName=t.PROJECTION,t.UNIT&&(t.units=t.UNIT.name.toLowerCase(),"metre"===t.units&&(t.units="meter"),t.UNIT.convert&&("GEOGCS"===t.type?t.DATUM&&t.DATUM.SPHEROID&&(t.to_meter=t.UNIT.convert*t.DATUM.SPHEROID.a):(t.to_meter=t.UNIT.convert,10)));var i=t.GEOGCS;"GEOGCS"===t.type&&(i=t),i&&(i.DATUM?t.datumCode=i.DATUM.name.toLowerCase():t.datumCode=i.name.toLowerCase(),"d_"===t.datumCode.slice(0,2)&&(t.datumCode=t.datumCode.slice(2)),"new_zealand_geodetic_datum_1949"!==t.datumCode&&"new_zealand_1949"!==t.datumCode||(t.datumCode="nzgd49"),"wgs_1984"===t.datumCode&&("Mercator_Auxiliary_Sphere"===t.PROJECTION&&(t.sphere=!0),t.datumCode="wgs84"),"_ferro"===t.datumCode.slice(-6)&&(t.datumCode=t.datumCode.slice(0,-6)),"_jakarta"===t.datumCode.slice(-8)&&(t.datumCode=t.datumCode.slice(0,-8)),~t.datumCode.indexOf("belge")&&(t.datumCode="rnb72"),i.DATUM&&i.DATUM.SPHEROID&&(t.ellps=i.DATUM.SPHEROID.name.replace("_19","").replace(/[Cc]larke\_18/,"clrk"),
"international"===t.ellps.toLowerCase().slice(0,13)&&(t.ellps="intl"),t.a=i.DATUM.SPHEROID.a,t.rf=parseFloat(i.DATUM.SPHEROID.rf,10)),~t.datumCode.indexOf("osgb_1936")&&(t.datumCode="osgb36")),t.b&&!isFinite(t.b)&&(t.b=t.a);var r=function(e){return o(t,e)},n=[["standard_parallel_1","Standard_Parallel_1"],["standard_parallel_2","Standard_Parallel_2"],["false_easting","False_Easting"],["false_northing","False_Northing"],["central_meridian","Central_Meridian"],["latitude_of_origin","Latitude_Of_Origin"],["latitude_of_origin","Central_Parallel"],["scale_factor","Scale_Factor"],["k0","scale_factor"],["latitude_of_center","Latitude_of_center"],["lat0","latitude_of_center",s],["longitude_of_center","Longitude_Of_Center"],["longc","longitude_of_center",s],["x0","false_easting",e],["y0","false_northing",e],["long0","central_meridian",s],["lat0","latitude_of_origin",s],["lat0","standard_parallel_1",s],["lat1","standard_parallel_1",s],["lat2","standard_parallel_2",s],["alpha","azimuth",s],["srsCode","name"]];n.forEach(r),t.long0||!t.longc||"Albers_Conic_Equal_Area"!==t.projName&&"Lambert_Azimuthal_Equal_Area"!==t.projName||(t.long0=t.longc),t.lat_ts||!t.lat1||"Stereographic_South_Pole"!==t.projName&&"Polar Stereographic (variant B)"!==t.projName||(t.lat0=s(t.lat1>0?90:-90),t.lat_ts=t.lat1)}function l(t){var e=this;if(2===arguments.length){var i=arguments[1];"string"==typeof i?"+"===i.charAt(0)?l[t]=Ue(arguments[1]):l[t]=ei(arguments[1]):l[t]=i}else if(1===arguments.length){if(Array.isArray(t))return t.map(function(t){Array.isArray(t)?l.apply(e,t):l(t)});if("string"==typeof t){if(t in l)return l[t]}else"EPSG"in t?l["EPSG:"+t.EPSG]=t:"ESRI"in t?l["ESRI:"+t.ESRI]=t:"IAU2000"in t?l["IAU2000:"+t.IAU2000]=t:console.log(t);return}}function h(t){return"string"==typeof t}function u(t){return t in l}function c(t){return ii.some(function(e){return t.indexOf(e)>-1})}function d(t){return"+"===t[0]}function p(t){return h(t)?u(t)?l[t]:c(t)?ei(t):d(t)?Ue(t):void 0:t}function f(){var t=this.b/this.a;this.es=1-t*t,"x0"in this||(this.x0=0),"y0"in this||(this.y0=0),this.e=Math.sqrt(this.es),this.lat_ts?this.sphere?this.k0=Math.cos(this.lat_ts):this.k0=ni(this.e,Math.sin(this.lat_ts),Math.cos(this.lat_ts)):this.k0||(this.k?this.k0=this.k:this.k0=1)}function g(t){var e=t.x,i=t.y;if(i*De>90&&i*De<-90&&e*De>180&&e*De<-180)return null;var r,n;if(Math.abs(Math.abs(i)-Ce)<=Ne)return null;if(this.sphere)r=this.x0+this.a*this.k0*si(e-this.long0),n=this.y0+this.a*this.k0*Math.log(Math.tan(ke+.5*i));else{var o=Math.sin(i),s=ai(this.e,i,o);r=this.x0+this.a*this.k0*si(e-this.long0),n=this.y0-this.a*this.k0*Math.log(s)}return t.x=r,t.y=n,t}function m(t){var e,i,r=t.x-this.x0,n=t.y-this.y0;if(this.sphere)i=Ce-2*Math.atan(Math.exp(-n/(this.a*this.k0)));else{var o=Math.exp(-n/(this.a*this.k0));if(i=li(this.e,o),i===-9999)return null}return e=si(this.long0+r/(this.a*this.k0)),t.x=e,t.y=i,t}function y(){}function E(t){return t}function v(t,e){var i=gi.length;return t.names?(gi[i]=t,t.names.forEach(function(t){fi[t.toLowerCase()]=i}),this):(console.log(e),!0)}function _(t){if(!t)return!1;var e=t.toLowerCase();return"undefined"!=typeof fi[e]&&gi[fi[e]]?gi[fi[e]]:void 0}function b(){pi.forEach(v)}function w(t,e,i,r){var n=t*t,o=e*e,s=(n-o)/n,a=0;r?(t*=1-s*(Me+s*(Pe+s*Oe)),n=t*t,s=0):a=Math.sqrt(s);var l=(n-o)/o;return{es:s,e:a,ep2:l}}function S(e,i,r,n,o){if(!e){var s=t(yi,n);s||(s=Ei),e=s.a,i=s.b,r=s.rf}return r&&!i&&(i=(1-1/r)*e),(0===r||Math.abs(e-i)<Ne)&&(o=!0,i=e),{a:e,b:i,rf:r,sphere:o}}function L(t,e,i,r,n,o){var s={};return void 0===t||"none"===t?s.datum_type=Re:s.datum_type=Ae,e&&(s.datum_params=e.map(parseFloat),0===s.datum_params[0]&&0===s.datum_params[1]&&0===s.datum_params[2]||(s.datum_type=Le),s.datum_params.length>3&&(0===s.datum_params[3]&&0===s.datum_params[4]&&0===s.datum_params[5]&&0===s.datum_params[6]||(s.datum_type=Te,s.datum_params[3]*=xe,s.datum_params[4]*=xe,s.datum_params[5]*=xe,s.datum_params[6]=s.datum_params[6]/1e6+1))),s.a=i,s.b=r,s.es=n,s.ep2=o,s}function T(e,i){if(!(this instanceof T))return new T(e);i=i||function(t){if(t)throw t};var r=p(e);if("object"!=typeof r)return void i(e);var n=T.projections.get(r.projName);if(!n)return void i(e);if(r.datumCode&&"none"!==r.datumCode){var o=t(vi,r.datumCode);o&&(r.datum_params=o.towgs84?o.towgs84.split(","):null,r.ellps=o.ellipse,r.datumName=o.datumName?o.datumName:r.datumCode)}r.k0=r.k0||1,r.axis=r.axis||"enu",r.ellps=r.ellps||"wgs84";var s=S(r.a,r.b,r.rf,r.ellps,r.sphere),a=w(s.a,s.b,s.rf,r.R_A),l=r.datum||L(r.datumCode,r.datum_params,s.a,s.b,a.es,a.ep2);ri(this,r),ri(this,n),this.a=s.a,this.b=s.b,this.rf=s.rf,this.sphere=s.sphere,this.es=a.es,this.e=a.e,this.ep2=a.ep2,this.datum=l,this.init(),i(null,this)}function A(t,e){return t.datum_type===e.datum_type&&(!(t.a!==e.a||Math.abs(t.es-e.es)>5e-11)&&(t.datum_type===Le?t.datum_params[0]===e.datum_params[0]&&t.datum_params[1]===e.datum_params[1]&&t.datum_params[2]===e.datum_params[2]:t.datum_type!==Te||t.datum_params[0]===e.datum_params[0]&&t.datum_params[1]===e.datum_params[1]&&t.datum_params[2]===e.datum_params[2]&&t.datum_params[3]===e.datum_params[3]&&t.datum_params[4]===e.datum_params[4]&&t.datum_params[5]===e.datum_params[5]&&t.datum_params[6]===e.datum_params[6]))}function R(t,e,i){var r,n,o,s,a=t.x,l=t.y,h=t.z?t.z:0;if(l<-Ce&&l>-1.001*Ce)l=-Ce;else if(l>Ce&&l<1.001*Ce)l=Ce;else if(l<-Ce||l>Ce)return null;return a>Math.PI&&(a-=2*Math.PI),n=Math.sin(l),s=Math.cos(l),o=n*n,r=i/Math.sqrt(1-e*o),{x:(r+h)*s*Math.cos(a),y:(r+h)*s*Math.sin(a),z:(r*(1-e)+h)*n}}function x(t,e,i,r){var n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_=1e-12,b=_*_,w=30,S=t.x,L=t.y,T=t.z?t.z:0;if(n=Math.sqrt(S*S+L*L),o=Math.sqrt(S*S+L*L+T*T),n/i<_){if(y=0,o/i<_)return E=Ce,v=-r,{x:t.x,y:t.y,z:t.z}}else y=Math.atan2(L,S);s=T/o,a=n/o,l=1/Math.sqrt(1-e*(2-e)*a*a),c=a*(1-e)*l,d=s*l,m=0;do m++,u=i/Math.sqrt(1-e*d*d),v=n*c+T*d-u*(1-e*d*d),h=e*u/(u+v),l=1/Math.sqrt(1-h*(2-h)*a*a),p=a*(1-h)*l,f=s*l,g=f*c-p*d,c=p,d=f;while(g*g>b&&m<w);return E=Math.atan(f/Math.abs(p)),{x:y,y:E,z:v}}function C(t,e,i){if(e===Le)return{x:t.x+i[0],y:t.y+i[1],z:t.z+i[2]};if(e===Te){var r=i[0],n=i[1],o=i[2],s=i[3],a=i[4],l=i[5],h=i[6];return{x:h*(t.x-l*t.y+a*t.z)+r,y:h*(l*t.x+t.y-s*t.z)+n,z:h*(-a*t.x+s*t.y+t.z)+o}}}function M(t,e,i){if(e===Le)return{x:t.x-i[0],y:t.y-i[1],z:t.z-i[2]};if(e===Te){var r=i[0],n=i[1],o=i[2],s=i[3],a=i[4],l=i[5],h=i[6],u=(t.x-r)/h,c=(t.y-n)/h,d=(t.z-o)/h;return{x:u+l*c-a*d,y:-l*u+c+s*d,z:a*u-s*c+d}}}function P(t){return t===Le||t===Te}function O(t,e){return(t.datum.datum_type===Le||t.datum.datum_type===Te)&&"WGS84"!==e.datumCode||(e.datum.datum_type===Le||e.datum.datum_type===Te)&&"WGS84"!==t.datumCode}function N(t,e,i){var r;return Array.isArray(i)&&(i=wi(i)),t.datum&&e.datum&&O(t,e)&&(r=new T("WGS84"),i=N(t,r,i),t=r),"enu"!==t.axis&&(i=bi(t,!1,i)),"longlat"===t.projName?i={x:i.x*Ie,y:i.y*Ie}:(t.to_meter&&(i={x:i.x*t.to_meter,y:i.y*t.to_meter}),i=t.inverse(i)),t.from_greenwich&&(i.x+=t.from_greenwich),i=_i(t.datum,e.datum,i),e.from_greenwich&&(i={x:i.x-e.from_greenwich,y:i.y}),"longlat"===e.projName?i={x:i.x*De,y:i.y*De}:(i=e.forward(i),e.to_meter&&(i={x:i.x/e.to_meter,y:i.y/e.to_meter})),"enu"!==e.axis?bi(e,!0,i):i}function I(t,e,i){var r;return Array.isArray(i)?(r=N(t,e,i),3===i.length?[r.x,r.y,r.z]:[r.x,r.y]):N(t,e,i)}function D(t){return t instanceof T?t:t.oProj?t.oProj:T(t)}function k(t,e,i){t=D(t);var r,n=!1;return"undefined"==typeof e?(e=t,t=Si,n=!0):("undefined"!=typeof e.x||Array.isArray(e))&&(i=e,e=t,t=Si,n=!0),e=D(e),i?I(t,e,i):(r={forward:function(i){return I(t,e,i)},inverse:function(i){return I(e,t,i)}},n&&(r.oProj=e),r)}function F(t,e){return e=e||5,z(U({lat:t[1],lon:t[0]}),e)}function V(t){var e=K(X(t.toUpperCase()));return e.lat&&e.lon?[e.lon,e.lat,e.lon,e.lat]:[e.left,e.bottom,e.right,e.top]}function G(t){var e=K(X(t.toUpperCase()));return e.lat&&e.lon?[e.lon,e.lat]:[(e.left+e.right)/2,(e.top+e.bottom)/2]}function W(t){return t*(Math.PI/180)}function B(t){return 180*(t/Math.PI)}function U(t){var e,i,r,n,o,s,a,l,h,u=t.lat,c=t.lon,d=6378137,p=.00669438,f=.9996,g=W(u),m=W(c);h=Math.floor((c+180)/6)+1,180===c&&(h=60),u>=56&&u<64&&c>=3&&c<12&&(h=32),u>=72&&u<84&&(c>=0&&c<9?h=31:c>=9&&c<21?h=33:c>=21&&c<33?h=35:c>=33&&c<42&&(h=37)),e=6*(h-1)-180+3,l=W(e),i=p/(1-p),r=d/Math.sqrt(1-p*Math.sin(g)*Math.sin(g)),n=Math.tan(g)*Math.tan(g),o=i*Math.cos(g)*Math.cos(g),s=Math.cos(g)*(m-l),a=d*((1-p/4-3*p*p/64-5*p*p*p/256)*g-(3*p/8+3*p*p/32+45*p*p*p/1024)*Math.sin(2*g)+(15*p*p/256+45*p*p*p/1024)*Math.sin(4*g)-35*p*p*p/3072*Math.sin(6*g));var y=f*r*(s+(1-n+o)*s*s*s/6+(5-18*n+n*n+72*o-58*i)*s*s*s*s*s/120)+5e5,E=f*(a+r*Math.tan(g)*(s*s/2+(5-n+9*o+4*o*o)*s*s*s*s/24+(61-58*n+n*n+600*o-330*i)*s*s*s*s*s*s/720));return u<0&&(E+=1e7),{northing:Math.round(E),easting:Math.round(y),zoneNumber:h,zoneLetter:j(u)}}function K(t){var e=t.northing,i=t.easting,r=t.zoneLetter,n=t.zoneNumber;if(n<0||n>60)return null;var o,s,a,l,h,u,c,d,p,f,g=.9996,m=6378137,y=.00669438,E=(1-Math.sqrt(1-y))/(1+Math.sqrt(1-y)),v=i-5e5,_=e;r<"N"&&(_-=1e7),d=6*(n-1)-180+3,o=y/(1-y),c=_/g,p=c/(m*(1-y/4-3*y*y/64-5*y*y*y/256)),f=p+(3*E/2-27*E*E*E/32)*Math.sin(2*p)+(21*E*E/16-55*E*E*E*E/32)*Math.sin(4*p)+151*E*E*E/96*Math.sin(6*p),s=m/Math.sqrt(1-y*Math.sin(f)*Math.sin(f)),a=Math.tan(f)*Math.tan(f),l=o*Math.cos(f)*Math.cos(f),h=m*(1-y)/Math.pow(1-y*Math.sin(f)*Math.sin(f),1.5),u=v/(s*g);var b=f-s*Math.tan(f)/h*(u*u/2-(5+3*a+10*l-4*l*l-9*o)*u*u*u*u/24+(61+90*a+298*l+45*a*a-252*o-3*l*l)*u*u*u*u*u*u/720);b=B(b);var w=(u-(1+2*a+l)*u*u*u/6+(5-2*l+28*a-3*l*l+8*o+24*a*a)*u*u*u*u*u/120)/Math.cos(f);w=d+B(w);var S;if(t.accuracy){var L=K({northing:t.northing+t.accuracy,easting:t.easting+t.accuracy,zoneLetter:t.zoneLetter,zoneNumber:t.zoneNumber});S={top:L.lat,right:L.lon,bottom:b,left:w}}else S={lat:b,lon:w};return S}function j(t){var e="Z";return 84>=t&&t>=72?e="X":72>t&&t>=64?e="W":64>t&&t>=56?e="V":56>t&&t>=48?e="U":48>t&&t>=40?e="T":40>t&&t>=32?e="S":32>t&&t>=24?e="R":24>t&&t>=16?e="Q":16>t&&t>=8?e="P":8>t&&t>=0?e="N":0>t&&t>=-8?e="M":-8>t&&t>=-16?e="L":-16>t&&t>=-24?e="K":-24>t&&t>=-32?e="J":-32>t&&t>=-40?e="H":-40>t&&t>=-48?e="G":-48>t&&t>=-56?e="F":-56>t&&t>=-64?e="E":-64>t&&t>=-72?e="D":-72>t&&t>=-80&&(e="C"),e}function z(t,e){var i="00000"+t.easting,r="00000"+t.northing;return t.zoneNumber+t.zoneLetter+H(t.easting,t.northing,t.zoneNumber)+i.substr(i.length-5,e)+r.substr(r.length-5,e)}function H(t,e,i){var r=q(i),n=Math.floor(t/1e5),o=Math.floor(e/1e5)%20;return Y(n,o,r)}function q(t){var e=t%Li;return 0===e&&(e=Li),e}function Y(t,e,i){var r=i-1,n=Ti.charCodeAt(r),o=Ai.charCodeAt(r),s=n+t-1,a=o+e,l=!1;s>Pi&&(s=s-Pi+Ri-1,l=!0),(s===xi||n<xi&&s>xi||(s>xi||n<xi)&&l)&&s++,(s===Ci||n<Ci&&s>Ci||(s>Ci||n<Ci)&&l)&&(s++,s===xi&&s++),s>Pi&&(s=s-Pi+Ri-1),a>Mi?(a=a-Mi+Ri-1,l=!0):l=!1,(a===xi||o<xi&&a>xi||(a>xi||o<xi)&&l)&&a++,(a===Ci||o<Ci&&a>Ci||(a>Ci||o<Ci)&&l)&&(a++,a===xi&&a++),a>Mi&&(a=a-Mi+Ri-1);var h=String.fromCharCode(s)+String.fromCharCode(a);return h}function X(t){if(t&&0===t.length)throw"MGRSPoint coverting from nothing";for(var e,i=t.length,r=null,n="",o=0;!/[A-Z]/.test(e=t.charAt(o));){if(o>=2)throw"MGRSPoint bad conversion from: "+t;n+=e,o++}var s=parseInt(n,10);if(0===o||o+3>i)throw"MGRSPoint bad conversion from: "+t;var a=t.charAt(o++);if(a<="A"||"B"===a||"Y"===a||a>="Z"||"I"===a||"O"===a)throw"MGRSPoint zone letter "+a+" not handled: "+t;r=t.substring(o,o+=2);for(var l=q(s),h=J(r.charAt(0),l),u=Q(r.charAt(1),l);u<Z(a);)u+=2e6;var c=i-o;if(c%2!==0)throw"MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters"+t;var d,p,f,g,m,y=c/2,E=0,v=0;return y>0&&(d=1e5/Math.pow(10,y),p=t.substring(o,o+y),E=parseFloat(p)*d,f=t.substring(o+y),v=parseFloat(f)*d),g=E+h,m=v+u,{easting:g,northing:m,zoneLetter:a,zoneNumber:s,accuracy:d}}function J(t,e){for(var i=Ti.charCodeAt(e-1),r=1e5,n=!1;i!==t.charCodeAt(0);){if(i++,i===xi&&i++,i===Ci&&i++,i>Pi){if(n)throw"Bad character: "+t;i=Ri,n=!0}r+=1e5}return r}function Q(t,e){if(t>"V")throw"MGRSPoint given invalid Northing "+t;for(var i=Ai.charCodeAt(e-1),r=0,n=!1;i!==t.charCodeAt(0);){if(i++,i===xi&&i++,i===Ci&&i++,i>Mi){if(n)throw"Bad character: "+t;i=Ri,n=!0}r+=1e5}return r}function Z(t){var e;switch(t){case"C":e=11e5;break;case"D":e=2e6;break;case"E":e=28e5;break;case"F":e=37e5;break;case"G":e=46e5;break;case"H":e=55e5;break;case"J":e=64e5;break;case"K":e=73e5;break;case"L":e=82e5;break;case"M":e=91e5;break;case"N":e=0;break;case"P":e=8e5;break;case"Q":e=17e5;break;case"R":e=26e5;break;case"S":e=35e5;break;case"T":e=44e5;break;case"U":e=53e5;break;case"V":e=62e5;break;case"W":e=7e6;break;case"X":e=79e5;break;default:e=-1}if(e>=0)return e;throw"Invalid zone letter: "+t}function $(t,e,i){if(!(this instanceof $))return new $(t,e,i);if(Array.isArray(t))this.x=t[0],this.y=t[1],this.z=t[2]||0;else if("object"==typeof t)this.x=t.x,this.y=t.y,this.z=t.z||0;else if("string"==typeof t&&"undefined"==typeof e){var r=t.split(",");this.x=parseFloat(r[0],10),this.y=parseFloat(r[1],10),this.z=parseFloat(r[2],10)||0}else this.x=t,this.y=e,this.z=i||0;console.warn("proj4.Point will be removed in version 3, use proj4.toPoint")}function tt(){this.x0=void 0!==this.x0?this.x0:0,this.y0=void 0!==this.y0?this.y0:0,this.long0=void 0!==this.long0?this.long0:0,this.lat0=void 0!==this.lat0?this.lat0:0,this.es&&(this.en=Hi(this.es),this.ml0=qi(this.lat0,Math.sin(this.lat0),Math.cos(this.lat0),this.en))}function et(t){var e,i,r,n=t.x,o=t.y,s=si(n-this.long0),a=Math.sin(o),l=Math.cos(o);if(this.es){var h=l*s,u=Math.pow(h,2),c=this.ep2*Math.pow(l,2),d=Math.pow(c,2),p=Math.abs(l)>Ne?Math.tan(o):0,f=Math.pow(p,2),g=Math.pow(f,2);e=1-this.es*Math.pow(a,2),h/=Math.sqrt(e);var m=qi(o,a,l,this.en);i=this.a*(this.k0*h*(1+u/6*(1-f+c+u/20*(5-18*f+g+14*c-58*f*c+u/42*(61+179*g-g*f-479*f)))))+this.x0,r=this.a*(this.k0*(m-this.ml0+a*s*h/2*(1+u/12*(5-f+9*c+4*d+u/30*(61+g-58*f+270*c-330*f*c+u/56*(1385+543*g-g*f-3111*f))))))+this.y0}else{var y=l*Math.sin(s);if(Math.abs(Math.abs(y)-1)<Ne)return 93;if(i=.5*this.a*this.k0*Math.log((1+y)/(1-y))+this.x0,r=l*Math.cos(s)/Math.sqrt(1-Math.pow(y,2)),y=Math.abs(r),y>=1){if(y-1>Ne)return 93;r=0}else r=Math.acos(r);o<0&&(r=-r),r=this.a*this.k0*(r-this.lat0)+this.y0}return t.x=i,t.y=r,t}function it(t){var e,i,r,n,o=(t.x-this.x0)*(1/this.a),s=(t.y-this.y0)*(1/this.a);if(this.es)if(e=this.ml0+s/this.k0,i=Xi(e,this.es,this.en),Math.abs(i)<Ce){var a=Math.sin(i),l=Math.cos(i),h=Math.abs(l)>Ne?Math.tan(i):0,u=this.ep2*Math.pow(l,2),c=Math.pow(u,2),d=Math.pow(h,2),p=Math.pow(d,2);e=1-this.es*Math.pow(a,2);var f=o*Math.sqrt(e)/this.k0,g=Math.pow(f,2);e*=h,r=i-e*g/(1-this.es)*.5*(1-g/12*(5+3*d-9*u*d+u-4*c-g/30*(61+90*d-252*u*d+45*p+46*u-g/56*(1385+3633*d+4095*p+1574*p*d)))),n=si(this.long0+f*(1-g/6*(1+2*d+u-g/20*(5+28*d+24*p+8*u*d+6*u-g/42*(61+662*d+1320*p+720*p*d))))/l)}else r=Ce*oi(s),n=0;else{var m=Math.exp(o/this.k0),y=.5*(m-1/m),E=this.lat0+s/this.k0,v=Math.cos(E);e=Math.sqrt((1-Math.pow(v,2))/(1+Math.pow(y,2))),r=Math.asin(e),s<0&&(r=-r),n=0===y&&0===v?0:si(Math.atan2(y,v)+this.long0)}return t.x=n,t.y=r,t}function rt(){if(void 0===this.es||this.es<=0)throw new Error("incorrect elliptical usage");this.x0=void 0!==this.x0?this.x0:0,this.y0=void 0!==this.y0?this.y0:0,this.long0=void 0!==this.long0?this.long0:0,this.lat0=void 0!==this.lat0?this.lat0:0,this.cgb=[],this.cbg=[],this.utg=[],this.gtu=[];var t=this.es/(1+Math.sqrt(1-this.es)),e=t/(2-t),i=e;this.cgb[0]=e*(2+e*(-2/3+e*(-2+e*(116/45+e*(26/45+e*(-2854/675)))))),this.cbg[0]=e*(-2+e*(2/3+e*(4/3+e*(-82/45+e*(32/45+e*(4642/4725)))))),i*=e,this.cgb[1]=i*(7/3+e*(-1.6+e*(-227/45+e*(2704/315+e*(2323/945))))),this.cbg[1]=i*(5/3+e*(-16/15+e*(-13/9+e*(904/315+e*(-1522/945))))),i*=e,this.cgb[2]=i*(56/15+e*(-136/35+e*(-1262/105+e*(73814/2835)))),this.cbg[2]=i*(-26/15+e*(34/21+e*(1.6+e*(-12686/2835)))),i*=e,this.cgb[3]=i*(4279/630+e*(-332/35+e*(-399572/14175))),this.cbg[3]=i*(1237/630+e*(-2.4+e*(-24832/14175))),i*=e,this.cgb[4]=i*(4174/315+e*(-144838/6237)),this.cbg[4]=i*(-734/315+e*(109598/31185)),i*=e,this.cgb[5]=i*(601676/22275),this.cbg[5]=i*(444337/155925),i=Math.pow(e,2),this.Qn=this.k0/(1+e)*(1+i*(.25+i*(1/64+i/256))),this.utg[0]=e*(-.5+e*(2/3+e*(-37/96+e*(1/360+e*(81/512+e*(-96199/604800)))))),this.gtu[0]=e*(.5+e*(-2/3+e*(5/16+e*(41/180+e*(-127/288+e*(7891/37800)))))),this.utg[1]=i*(-1/48+e*(-1/15+e*(437/1440+e*(-46/105+e*(1118711/3870720))))),this.gtu[1]=i*(13/48+e*(-.6+e*(557/1440+e*(281/630+e*(-1983433/1935360))))),i*=e,this.utg[2]=i*(-17/480+e*(37/840+e*(209/4480+e*(-5569/90720)))),this.gtu[2]=i*(61/240+e*(-103/140+e*(15061/26880+e*(167603/181440)))),i*=e,this.utg[3]=i*(-4397/161280+e*(11/504+e*(830251/7257600))),this.gtu[3]=i*(49561/161280+e*(-179/168+e*(6601661/7257600))),i*=e,this.utg[4]=i*(-4583/161280+e*(108847/3991680)),this.gtu[4]=i*(34729/80640+e*(-3418889/1995840)),i*=e,this.utg[5]=i*-.03233083094085698,this.gtu[5]=.6650675310896665*i;var r=ir(this.cbg,this.lat0);this.Zb=-this.Qn*(r+rr(this.gtu,2*r))}function nt(t){var e=si(t.x-this.long0),i=t.y;i=ir(this.cbg,i);var r=Math.sin(i),n=Math.cos(i),o=Math.sin(e),s=Math.cos(e);i=Math.atan2(r,s*n),e=Math.atan2(o*n,$i(r,n*s)),e=er(Math.tan(e));var a=or(this.gtu,2*i,2*e);i+=a[0],e+=a[1];var l,h;return Math.abs(e)<=2.623395162778?(l=this.a*(this.Qn*e)+this.x0,h=this.a*(this.Qn*i+this.Zb)+this.y0):(l=1/0,h=1/0),t.x=l,t.y=h,t}function ot(t){var e=(t.x-this.x0)*(1/this.a),i=(t.y-this.y0)*(1/this.a);i=(i-this.Zb)/this.Qn,e/=this.Qn;var r,n;if(Math.abs(e)<=2.623395162778){var o=or(this.utg,2*i,2*e);i+=o[0],e+=o[1],e=Math.atan(Zi(e));var s=Math.sin(i),a=Math.cos(i),l=Math.sin(e),h=Math.cos(e);i=Math.atan2(s*h,$i(l,h*a)),e=Math.atan2(l,h*a),r=si(e+this.long0),n=ir(this.cgb,i)}else r=1/0,n=1/0;return t.x=r,t.y=n,t}function st(){var t=lr(this.zone,this.long0);if(void 0===t)throw new Error("unknown utm zone");this.lat0=0,this.long0=(6*Math.abs(t)-183)*Ie,this.x0=5e5,this.y0=this.utmSouth?1e7:0,this.k0=.9996,ar.init.apply(this),this.forward=ar.forward,this.inverse=ar.inverse}function at(){var t=Math.sin(this.lat0),e=Math.cos(this.lat0);e*=e,this.rc=Math.sqrt(1-this.es)/(1-this.es*t*t),this.C=Math.sqrt(1+this.es*e*e/(1-this.es)),this.phic0=Math.asin(t/this.C),this.ratexp=.5*this.C*this.e,this.K=Math.tan(.5*this.phic0+ke)/(Math.pow(Math.tan(.5*this.lat0+ke),this.C)*dr(this.e*t,this.ratexp))}function lt(t){var e=t.x,i=t.y;return t.y=2*Math.atan(this.K*Math.pow(Math.tan(.5*i+ke),this.C)*dr(this.e*Math.sin(i),this.ratexp))-Ce,t.x=this.C*e,t}function ht(t){for(var e=1e-14,i=t.x/this.C,r=t.y,n=Math.pow(Math.tan(.5*r+ke)/this.K,1/this.C),o=pr;o>0&&(r=2*Math.atan(n*dr(this.e*Math.sin(t.y),-.5*this.e))-Ce,!(Math.abs(r-t.y)<e));--o)t.y=r;return o?(t.x=i,t.y=r,t):null}function ut(){gr.init.apply(this),this.rc&&(this.sinc0=Math.sin(this.phic0),this.cosc0=Math.cos(this.phic0),this.R2=2*this.rc,this.title||(this.title="Oblique Stereographic Alternative"))}function ct(t){var e,i,r,n;return t.x=si(t.x-this.long0),gr.forward.apply(this,[t]),e=Math.sin(t.y),i=Math.cos(t.y),r=Math.cos(t.x),n=this.k0*this.R2/(1+this.sinc0*e+this.cosc0*i*r),t.x=n*i*Math.sin(t.x),t.y=n*(this.cosc0*e-this.sinc0*i*r),t.x=this.a*t.x+this.x0,t.y=this.a*t.y+this.y0,t}function dt(t){var e,i,r,n,o;if(t.x=(t.x-this.x0)/this.a,t.y=(t.y-this.y0)/this.a,t.x/=this.k0,t.y/=this.k0,o=Math.sqrt(t.x*t.x+t.y*t.y)){var s=2*Math.atan2(o,this.R2);e=Math.sin(s),i=Math.cos(s),n=Math.asin(i*this.sinc0+t.y*e*this.cosc0/o),r=Math.atan2(t.x*e,o*this.cosc0*i-t.y*this.sinc0*e)}else n=this.phic0,r=0;return t.x=r,t.y=n,gr.inverse.apply(this,[t]),t.x=si(t.x+this.long0),t}function pt(t,e,i){return e*=i,Math.tan(.5*(Ce+t))*Math.pow((1-e)/(1+e),.5*i)}function ft(){this.coslat0=Math.cos(this.lat0),this.sinlat0=Math.sin(this.lat0),this.sphere?1===this.k0&&!isNaN(this.lat_ts)&&Math.abs(this.coslat0)<=Ne&&(this.k0=.5*(1+oi(this.lat0)*Math.sin(this.lat_ts))):(Math.abs(this.coslat0)<=Ne&&(this.lat0>0?this.con=1:this.con=-1),this.cons=Math.sqrt(Math.pow(1+this.e,1+this.e)*Math.pow(1-this.e,1-this.e)),1===this.k0&&!isNaN(this.lat_ts)&&Math.abs(this.coslat0)<=Ne&&(this.k0=.5*this.cons*ni(this.e,Math.sin(this.lat_ts),Math.cos(this.lat_ts))/ai(this.e,this.con*this.lat_ts,this.con*Math.sin(this.lat_ts))),this.ms1=ni(this.e,this.sinlat0,this.coslat0),this.X0=2*Math.atan(this.ssfn_(this.lat0,this.sinlat0,this.e))-Ce,this.cosX0=Math.cos(this.X0),this.sinX0=Math.sin(this.X0))}function gt(t){var e,i,r,n,o,s,a=t.x,l=t.y,h=Math.sin(l),u=Math.cos(l),c=si(a-this.long0);return Math.abs(Math.abs(a-this.long0)-Math.PI)<=Ne&&Math.abs(l+this.lat0)<=Ne?(t.x=NaN,t.y=NaN,t):this.sphere?(e=2*this.k0/(1+this.sinlat0*h+this.coslat0*u*Math.cos(c)),t.x=this.a*e*u*Math.sin(c)+this.x0,t.y=this.a*e*(this.coslat0*h-this.sinlat0*u*Math.cos(c))+this.y0,t):(i=2*Math.atan(this.ssfn_(l,h,this.e))-Ce,n=Math.cos(i),r=Math.sin(i),Math.abs(this.coslat0)<=Ne?(o=ai(this.e,l*this.con,this.con*h),s=2*this.a*this.k0*o/this.cons,t.x=this.x0+s*Math.sin(a-this.long0),t.y=this.y0-this.con*s*Math.cos(a-this.long0),t):(Math.abs(this.sinlat0)<Ne?(e=2*this.a*this.k0/(1+n*Math.cos(c)),t.y=e*r):(e=2*this.a*this.k0*this.ms1/(this.cosX0*(1+this.sinX0*r+this.cosX0*n*Math.cos(c))),t.y=e*(this.cosX0*r-this.sinX0*n*Math.cos(c))+this.y0),t.x=e*n*Math.sin(c)+this.x0,t))}function mt(t){t.x-=this.x0,t.y-=this.y0;var e,i,r,n,o,s=Math.sqrt(t.x*t.x+t.y*t.y);if(this.sphere){var a=2*Math.atan(s/(.5*this.a*this.k0));return e=this.long0,i=this.lat0,s<=Ne?(t.x=e,t.y=i,t):(i=Math.asin(Math.cos(a)*this.sinlat0+t.y*Math.sin(a)*this.coslat0/s),e=si(Math.abs(this.coslat0)<Ne?this.lat0>0?this.long0+Math.atan2(t.x,-1*t.y):this.long0+Math.atan2(t.x,t.y):this.long0+Math.atan2(t.x*Math.sin(a),s*this.coslat0*Math.cos(a)-t.y*this.sinlat0*Math.sin(a))),t.x=e,t.y=i,t)}if(Math.abs(this.coslat0)<=Ne){if(s<=Ne)return i=this.lat0,e=this.long0,t.x=e,t.y=i,t;t.x*=this.con,t.y*=this.con,r=s*this.cons/(2*this.a*this.k0),i=this.con*li(this.e,r),e=this.con*si(this.con*this.long0+Math.atan2(t.x,-1*t.y))}else n=2*Math.atan(s*this.cosX0/(2*this.a*this.k0*this.ms1)),e=this.long0,s<=Ne?o=this.X0:(o=Math.asin(Math.cos(n)*this.sinX0+t.y*Math.sin(n)*this.cosX0/s),e=si(this.long0+Math.atan2(t.x*Math.sin(n),s*this.cosX0*Math.cos(n)-t.y*this.sinX0*Math.sin(n)))),i=-1*li(this.e,Math.tan(.5*(Ce+o)));return t.x=e,t.y=i,t}function yt(){var t=this.lat0;this.lambda0=this.long0;var e=Math.sin(t),i=this.a,r=this.rf,n=1/r,o=2*n-Math.pow(n,2),s=this.e=Math.sqrt(o);this.R=this.k0*i*Math.sqrt(1-o)/(1-o*Math.pow(e,2)),this.alpha=Math.sqrt(1+o/(1-o)*Math.pow(Math.cos(t),4)),this.b0=Math.asin(e/this.alpha);var a=Math.log(Math.tan(Math.PI/4+this.b0/2)),l=Math.log(Math.tan(Math.PI/4+t/2)),h=Math.log((1+s*e)/(1-s*e));this.K=a-this.alpha*l+this.alpha*s/2*h}function Et(t){var e=Math.log(Math.tan(Math.PI/4-t.y/2)),i=this.e/2*Math.log((1+this.e*Math.sin(t.y))/(1-this.e*Math.sin(t.y))),r=-this.alpha*(e+i)+this.K,n=2*(Math.atan(Math.exp(r))-Math.PI/4),o=this.alpha*(t.x-this.lambda0),s=Math.atan(Math.sin(o)/(Math.sin(this.b0)*Math.tan(n)+Math.cos(this.b0)*Math.cos(o))),a=Math.asin(Math.cos(this.b0)*Math.sin(n)-Math.sin(this.b0)*Math.cos(n)*Math.cos(o));return t.y=this.R/2*Math.log((1+Math.sin(a))/(1-Math.sin(a)))+this.y0,t.x=this.R*s+this.x0,t}function vt(t){for(var e=t.x-this.x0,i=t.y-this.y0,r=e/this.R,n=2*(Math.atan(Math.exp(i/this.R))-Math.PI/4),o=Math.asin(Math.cos(this.b0)*Math.sin(n)+Math.sin(this.b0)*Math.cos(n)*Math.cos(r)),s=Math.atan(Math.sin(r)/(Math.cos(this.b0)*Math.cos(r)-Math.sin(this.b0)*Math.tan(n))),a=this.lambda0+s/this.alpha,l=0,h=o,u=-1e3,c=0;Math.abs(h-u)>1e-7;){if(++c>20)return;l=1/this.alpha*(Math.log(Math.tan(Math.PI/4+o/2))-this.K)+this.e*Math.log(Math.tan(Math.PI/4+Math.asin(this.e*Math.sin(h))/2)),u=h,h=2*Math.atan(Math.exp(l))-Math.PI/2}return t.x=a,t.y=h,t}function _t(){this.no_off=this.no_off||!1,this.no_rot=this.no_rot||!1,isNaN(this.k0)&&(this.k0=1);var t=Math.sin(this.lat0),e=Math.cos(this.lat0),i=this.e*t;this.bl=Math.sqrt(1+this.es/(1-this.es)*Math.pow(e,4)),this.al=this.a*this.bl*this.k0*Math.sqrt(1-this.es)/(1-i*i);var r=ai(this.e,this.lat0,t),n=this.bl/e*Math.sqrt((1-this.es)/(1-i*i));n*n<1&&(n=1);var o,s;if(isNaN(this.longc)){var a=ai(this.e,this.lat1,Math.sin(this.lat1)),l=ai(this.e,this.lat2,Math.sin(this.lat2));this.lat0>=0?this.el=(n+Math.sqrt(n*n-1))*Math.pow(r,this.bl):this.el=(n-Math.sqrt(n*n-1))*Math.pow(r,this.bl);var h=Math.pow(a,this.bl),u=Math.pow(l,this.bl);o=this.el/h,s=.5*(o-1/o);var c=(this.el*this.el-u*h)/(this.el*this.el+u*h),d=(u-h)/(u+h),p=si(this.long1-this.long2);this.long0=.5*(this.long1+this.long2)-Math.atan(c*Math.tan(.5*this.bl*p)/d)/this.bl,this.long0=si(this.long0);var f=si(this.long1-this.long0);this.gamma0=Math.atan(Math.sin(this.bl*f)/s),this.alpha=Math.asin(n*Math.sin(this.gamma0))}else o=this.lat0>=0?n+Math.sqrt(n*n-1):n-Math.sqrt(n*n-1),this.el=o*Math.pow(r,this.bl),s=.5*(o-1/o),this.gamma0=Math.asin(Math.sin(this.alpha)/n),this.long0=this.longc-Math.asin(s*Math.tan(this.gamma0))/this.bl;this.no_off?this.uc=0:this.lat0>=0?this.uc=this.al/this.bl*Math.atan2(Math.sqrt(n*n-1),Math.cos(this.alpha)):this.uc=-1*this.al/this.bl*Math.atan2(Math.sqrt(n*n-1),Math.cos(this.alpha))}function bt(t){var e,i,r,n=t.x,o=t.y,s=si(n-this.long0);if(Math.abs(Math.abs(o)-Ce)<=Ne)r=o>0?-1:1,i=this.al/this.bl*Math.log(Math.tan(ke+r*this.gamma0*.5)),e=-1*r*Ce*this.al/this.bl;else{var a=ai(this.e,o,Math.sin(o)),l=this.el/Math.pow(a,this.bl),h=.5*(l-1/l),u=.5*(l+1/l),c=Math.sin(this.bl*s),d=(h*Math.sin(this.gamma0)-c*Math.cos(this.gamma0))/u;i=Math.abs(Math.abs(d)-1)<=Ne?Number.POSITIVE_INFINITY:.5*this.al*Math.log((1-d)/(1+d))/this.bl,e=Math.abs(Math.cos(this.bl*s))<=Ne?this.al*this.bl*s:this.al*Math.atan2(h*Math.cos(this.gamma0)+c*Math.sin(this.gamma0),Math.cos(this.bl*s))/this.bl}return this.no_rot?(t.x=this.x0+e,t.y=this.y0+i):(e-=this.uc,t.x=this.x0+i*Math.cos(this.alpha)+e*Math.sin(this.alpha),t.y=this.y0+e*Math.cos(this.alpha)-i*Math.sin(this.alpha)),t}function wt(t){var e,i;this.no_rot?(i=t.y-this.y0,e=t.x-this.x0):(i=(t.x-this.x0)*Math.cos(this.alpha)-(t.y-this.y0)*Math.sin(this.alpha),e=(t.y-this.y0)*Math.cos(this.alpha)+(t.x-this.x0)*Math.sin(this.alpha),e+=this.uc);var r=Math.exp(-1*this.bl*i/this.al),n=.5*(r-1/r),o=.5*(r+1/r),s=Math.sin(this.bl*e/this.al),a=(s*Math.cos(this.gamma0)+n*Math.sin(this.gamma0))/o,l=Math.pow(this.el/Math.sqrt((1+a)/(1-a)),1/this.bl);return Math.abs(a-1)<Ne?(t.x=this.long0,t.y=Ce):Math.abs(a+1)<Ne?(t.x=this.long0,t.y=-1*Ce):(t.y=li(this.e,l),t.x=si(this.long0-Math.atan2(n*Math.cos(this.gamma0)-s*Math.sin(this.gamma0),Math.cos(this.bl*e/this.al))/this.bl)),t}function St(){if(this.lat2||(this.lat2=this.lat1),this.k0||(this.k0=1),this.x0=this.x0||0,this.y0=this.y0||0,!(Math.abs(this.lat1+this.lat2)<Ne)){var t=this.b/this.a;this.e=Math.sqrt(1-t*t);var e=Math.sin(this.lat1),i=Math.cos(this.lat1),r=ni(this.e,e,i),n=ai(this.e,this.lat1,e),o=Math.sin(this.lat2),s=Math.cos(this.lat2),a=ni(this.e,o,s),l=ai(this.e,this.lat2,o),h=ai(this.e,this.lat0,Math.sin(this.lat0));Math.abs(this.lat1-this.lat2)>Ne?this.ns=Math.log(r/a)/Math.log(n/l):this.ns=e,isNaN(this.ns)&&(this.ns=e),this.f0=r/(this.ns*Math.pow(n,this.ns)),this.rh=this.a*this.f0*Math.pow(h,this.ns),this.title||(this.title="Lambert Conformal Conic")}}function Lt(t){var e=t.x,i=t.y;Math.abs(2*Math.abs(i)-Math.PI)<=Ne&&(i=oi(i)*(Ce-2*Ne));var r,n,o=Math.abs(Math.abs(i)-Ce);if(o>Ne)r=ai(this.e,i,Math.sin(i)),n=this.a*this.f0*Math.pow(r,this.ns);else{if(o=i*this.ns,o<=0)return null;n=0}var s=this.ns*si(e-this.long0);return t.x=this.k0*(n*Math.sin(s))+this.x0,t.y=this.k0*(this.rh-n*Math.cos(s))+this.y0,t}function Tt(t){var e,i,r,n,o,s=(t.x-this.x0)/this.k0,a=this.rh-(t.y-this.y0)/this.k0;this.ns>0?(e=Math.sqrt(s*s+a*a),i=1):(e=-Math.sqrt(s*s+a*a),i=-1);var l=0;if(0!==e&&(l=Math.atan2(i*s,i*a)),0!==e||this.ns>0){if(i=1/this.ns,r=Math.pow(e/(this.a*this.f0),i),n=li(this.e,r),n===-9999)return null}else n=-Ce;return o=si(l/this.ns+this.long0),t.x=o,t.y=n,t}function At(){this.a=6377397.155,this.es=.006674372230614,this.e=Math.sqrt(this.es),this.lat0||(this.lat0=.863937979737193),this.long0||(this.long0=.4334234309119251),this.k0||(this.k0=.9999),this.s45=.785398163397448,this.s90=2*this.s45,this.fi0=this.lat0,this.e2=this.es,this.e=Math.sqrt(this.e2),this.alfa=Math.sqrt(1+this.e2*Math.pow(Math.cos(this.fi0),4)/(1-this.e2)),this.uq=1.04216856380474,this.u0=Math.asin(Math.sin(this.fi0)/this.alfa),this.g=Math.pow((1+this.e*Math.sin(this.fi0))/(1-this.e*Math.sin(this.fi0)),this.alfa*this.e/2),this.k=Math.tan(this.u0/2+this.s45)/Math.pow(Math.tan(this.fi0/2+this.s45),this.alfa)*this.g,this.k1=this.k0,this.n0=this.a*Math.sqrt(1-this.e2)/(1-this.e2*Math.pow(Math.sin(this.fi0),2)),this.s0=1.37008346281555,this.n=Math.sin(this.s0),this.ro0=this.k1*this.n0/Math.tan(this.s0),this.ad=this.s90-this.uq}function Rt(t){var e,i,r,n,o,s,a,l=t.x,h=t.y,u=si(l-this.long0);return e=Math.pow((1+this.e*Math.sin(h))/(1-this.e*Math.sin(h)),this.alfa*this.e/2),i=2*(Math.atan(this.k*Math.pow(Math.tan(h/2+this.s45),this.alfa)/e)-this.s45),r=-u*this.alfa,n=Math.asin(Math.cos(this.ad)*Math.sin(i)+Math.sin(this.ad)*Math.cos(i)*Math.cos(r)),o=Math.asin(Math.cos(i)*Math.sin(r)/Math.cos(n)),s=this.n*o,a=this.ro0*Math.pow(Math.tan(this.s0/2+this.s45),this.n)/Math.pow(Math.tan(n/2+this.s45),this.n),t.y=a*Math.cos(s)/1,t.x=a*Math.sin(s)/1,this.czech||(t.y*=-1,t.x*=-1),t}function xt(t){var e,i,r,n,o,s,a,l,h=t.x;t.x=t.y,t.y=h,this.czech||(t.y*=-1,t.x*=-1),s=Math.sqrt(t.x*t.x+t.y*t.y),o=Math.atan2(t.y,t.x),n=o/Math.sin(this.s0),r=2*(Math.atan(Math.pow(this.ro0/s,1/this.n)*Math.tan(this.s0/2+this.s45))-this.s45),e=Math.asin(Math.cos(this.ad)*Math.sin(r)-Math.sin(this.ad)*Math.cos(r)*Math.cos(n)),i=Math.asin(Math.cos(r)*Math.sin(n)/Math.cos(e)),t.x=this.long0-i/this.alfa,a=e,l=0;var u=0;do t.y=2*(Math.atan(Math.pow(this.k,-1/this.alfa)*Math.pow(Math.tan(e/2+this.s45),1/this.alfa)*Math.pow((1+this.e*Math.sin(a))/(1-this.e*Math.sin(a)),this.e/2))-this.s45),Math.abs(a-t.y)<1e-10&&(l=1),a=t.y,u+=1;while(0===l&&u<15);return u>=15?null:t}function Ct(){this.sphere||(this.e0=Cr(this.es),this.e1=Mr(this.es),this.e2=Pr(this.es),this.e3=Or(this.es),this.ml0=this.a*xr(this.e0,this.e1,this.e2,this.e3,this.lat0))}function Mt(t){var e,i,r=t.x,n=t.y;if(r=si(r-this.long0),this.sphere)e=this.a*Math.asin(Math.cos(n)*Math.sin(r)),i=this.a*(Math.atan2(Math.tan(n),Math.cos(r))-this.lat0);else{var o=Math.sin(n),s=Math.cos(n),a=Nr(this.a,this.e,o),l=Math.tan(n)*Math.tan(n),h=r*Math.cos(n),u=h*h,c=this.es*s*s/(1-this.es),d=this.a*xr(this.e0,this.e1,this.e2,this.e3,n);e=a*h*(1-u*l*(1/6-(8-l+8*c)*u/120)),i=d-this.ml0+a*o/s*u*(.5+(5-l+6*c)*u/24)}return t.x=e+this.x0,t.y=i+this.y0,t}function Pt(t){t.x-=this.x0,t.y-=this.y0;var e,i,r=t.x/this.a,n=t.y/this.a;if(this.sphere){var o=n+this.lat0;e=Math.asin(Math.sin(o)*Math.cos(r)),i=Math.atan2(Math.tan(r),Math.cos(o))}else{var s=this.ml0/this.a+n,a=Dr(s,this.e0,this.e1,this.e2,this.e3);if(Math.abs(Math.abs(a)-Ce)<=Ne)return t.x=this.long0,t.y=Ce,n<0&&(t.y*=-1),t;var l=Nr(this.a,this.e,Math.sin(a)),h=l*l*l/this.a/this.a*(1-this.es),u=Math.pow(Math.tan(a),2),c=r*this.a/l,d=c*c;e=a-l*Math.tan(a)/h*c*c*(.5-(1+3*u)*c*c/24),i=c*(1-d*(u/3+(1+3*u)*u*d/15))/Math.cos(a)}return t.x=si(i+this.long0),t.y=Ir(e),t}function Ot(){var t=Math.abs(this.lat0);if(Math.abs(t-Ce)<Ne?this.mode=this.lat0<0?this.S_POLE:this.N_POLE:Math.abs(t)<Ne?this.mode=this.EQUIT:this.mode=this.OBLIQ,this.es>0){var e;switch(this.qp=Vr(this.e,1),this.mmf=.5/(1-this.es),this.apa=Dt(this.es),this.mode){case this.N_POLE:this.dd=1;break;case this.S_POLE:this.dd=1;break;case this.EQUIT:this.rq=Math.sqrt(.5*this.qp),this.dd=1/this.rq,this.xmf=1,this.ymf=.5*this.qp;break;case this.OBLIQ:this.rq=Math.sqrt(.5*this.qp),e=Math.sin(this.lat0),this.sinb1=Vr(this.e,e)/this.qp,this.cosb1=Math.sqrt(1-this.sinb1*this.sinb1),this.dd=Math.cos(this.lat0)/(Math.sqrt(1-this.es*e*e)*this.rq*this.cosb1),this.ymf=(this.xmf=this.rq)/this.dd,this.xmf*=this.dd}}else this.mode===this.OBLIQ&&(this.sinph0=Math.sin(this.lat0),this.cosph0=Math.cos(this.lat0))}function Nt(t){
var e,i,r,n,o,s,a,l,h,u,c=t.x,d=t.y;if(c=si(c-this.long0),this.sphere){if(o=Math.sin(d),u=Math.cos(d),r=Math.cos(c),this.mode===this.OBLIQ||this.mode===this.EQUIT){if(i=this.mode===this.EQUIT?1+u*r:1+this.sinph0*o+this.cosph0*u*r,i<=Ne)return null;i=Math.sqrt(2/i),e=i*u*Math.sin(c),i*=this.mode===this.EQUIT?o:this.cosph0*o-this.sinph0*u*r}else if(this.mode===this.N_POLE||this.mode===this.S_POLE){if(this.mode===this.N_POLE&&(r=-r),Math.abs(d+this.phi0)<Ne)return null;i=ke-.5*d,i=2*(this.mode===this.S_POLE?Math.cos(i):Math.sin(i)),e=i*Math.sin(c),i*=r}}else{switch(a=0,l=0,h=0,r=Math.cos(c),n=Math.sin(c),o=Math.sin(d),s=Vr(this.e,o),this.mode!==this.OBLIQ&&this.mode!==this.EQUIT||(a=s/this.qp,l=Math.sqrt(1-a*a)),this.mode){case this.OBLIQ:h=1+this.sinb1*a+this.cosb1*l*r;break;case this.EQUIT:h=1+l*r;break;case this.N_POLE:h=Ce+d,s=this.qp-s;break;case this.S_POLE:h=d-Ce,s=this.qp+s}if(Math.abs(h)<Ne)return null;switch(this.mode){case this.OBLIQ:case this.EQUIT:h=Math.sqrt(2/h),i=this.mode===this.OBLIQ?this.ymf*h*(this.cosb1*a-this.sinb1*l*r):(h=Math.sqrt(2/(1+l*r)))*a*this.ymf,e=this.xmf*h*l*n;break;case this.N_POLE:case this.S_POLE:s>=0?(e=(h=Math.sqrt(s))*n,i=r*(this.mode===this.S_POLE?h:-h)):e=i=0}}return t.x=this.a*e+this.x0,t.y=this.a*i+this.y0,t}function It(t){t.x-=this.x0,t.y-=this.y0;var e,i,r,n,o,s,a,l=t.x/this.a,h=t.y/this.a;if(this.sphere){var u,c=0,d=0;if(u=Math.sqrt(l*l+h*h),i=.5*u,i>1)return null;switch(i=2*Math.asin(i),this.mode!==this.OBLIQ&&this.mode!==this.EQUIT||(d=Math.sin(i),c=Math.cos(i)),this.mode){case this.EQUIT:i=Math.abs(u)<=Ne?0:Math.asin(h*d/u),l*=d,h=c*u;break;case this.OBLIQ:i=Math.abs(u)<=Ne?this.phi0:Math.asin(c*this.sinph0+h*d*this.cosph0/u),l*=d*this.cosph0,h=(c-Math.sin(i)*this.sinph0)*u;break;case this.N_POLE:h=-h,i=Ce-i;break;case this.S_POLE:i-=Ce}e=0!==h||this.mode!==this.EQUIT&&this.mode!==this.OBLIQ?Math.atan2(l,h):0}else{if(a=0,this.mode===this.OBLIQ||this.mode===this.EQUIT){if(l/=this.dd,h*=this.dd,s=Math.sqrt(l*l+h*h),s<Ne)return t.x=0,t.y=this.phi0,t;n=2*Math.asin(.5*s/this.rq),r=Math.cos(n),l*=n=Math.sin(n),this.mode===this.OBLIQ?(a=r*this.sinb1+h*n*this.cosb1/s,o=this.qp*a,h=s*this.cosb1*r-h*this.sinb1*n):(a=h*n/s,o=this.qp*a,h=s*r)}else if(this.mode===this.N_POLE||this.mode===this.S_POLE){if(this.mode===this.N_POLE&&(h=-h),o=l*l+h*h,!o)return t.x=0,t.y=this.phi0,t;a=1-o/this.qp,this.mode===this.S_POLE&&(a=-a)}e=Math.atan2(l,h),i=kt(Math.asin(a),this.apa)}return t.x=si(this.long0+e),t.y=i,t}function Dt(t){var e,i=[];return i[0]=t*Kr,e=t*t,i[0]+=e*jr,i[1]=e*Hr,e*=t,i[0]+=e*zr,i[1]+=e*qr,i[2]=e*Yr,i}function kt(t,e){var i=t+t;return t+e[0]*Math.sin(i)+e[1]*Math.sin(i+i)+e[2]*Math.sin(i+i+i)}function Ft(){Math.abs(this.lat1+this.lat2)<Ne||(this.temp=this.b/this.a,this.es=1-Math.pow(this.temp,2),this.e3=Math.sqrt(this.es),this.sin_po=Math.sin(this.lat1),this.cos_po=Math.cos(this.lat1),this.t1=this.sin_po,this.con=this.sin_po,this.ms1=ni(this.e3,this.sin_po,this.cos_po),this.qs1=Vr(this.e3,this.sin_po,this.cos_po),this.sin_po=Math.sin(this.lat2),this.cos_po=Math.cos(this.lat2),this.t2=this.sin_po,this.ms2=ni(this.e3,this.sin_po,this.cos_po),this.qs2=Vr(this.e3,this.sin_po,this.cos_po),this.sin_po=Math.sin(this.lat0),this.cos_po=Math.cos(this.lat0),this.t3=this.sin_po,this.qs0=Vr(this.e3,this.sin_po,this.cos_po),Math.abs(this.lat1-this.lat2)>Ne?this.ns0=(this.ms1*this.ms1-this.ms2*this.ms2)/(this.qs2-this.qs1):this.ns0=this.con,this.c=this.ms1*this.ms1+this.ns0*this.qs1,this.rh=this.a*Math.sqrt(this.c-this.ns0*this.qs0)/this.ns0)}function Vt(t){var e=t.x,i=t.y;this.sin_phi=Math.sin(i),this.cos_phi=Math.cos(i);var r=Vr(this.e3,this.sin_phi,this.cos_phi),n=this.a*Math.sqrt(this.c-this.ns0*r)/this.ns0,o=this.ns0*si(e-this.long0),s=n*Math.sin(o)+this.x0,a=this.rh-n*Math.cos(o)+this.y0;return t.x=s,t.y=a,t}function Gt(t){var e,i,r,n,o,s;return t.x-=this.x0,t.y=this.rh-t.y+this.y0,this.ns0>=0?(e=Math.sqrt(t.x*t.x+t.y*t.y),r=1):(e=-Math.sqrt(t.x*t.x+t.y*t.y),r=-1),n=0,0!==e&&(n=Math.atan2(r*t.x,r*t.y)),r=e*this.ns0/this.a,this.sphere?s=Math.asin((this.c-r*r)/(2*this.ns0)):(i=(this.c-r*r)/this.ns0,s=this.phi1z(this.e3,i)),o=si(n/this.ns0+this.long0),t.x=o,t.y=s,t}function Wt(t,e){var i,r,n,o,s,a=Qr(.5*e);if(t<Ne)return a;for(var l=t*t,h=1;h<=25;h++)if(i=Math.sin(a),r=Math.cos(a),n=t*i,o=1-n*n,s=.5*o*o/r*(e/(1-l)-i/o+.5/t*Math.log((1-n)/(1+n))),a+=s,Math.abs(s)<=1e-7)return a;return null}function Bt(){this.sin_p14=Math.sin(this.lat0),this.cos_p14=Math.cos(this.lat0),this.infinity_dist=1e3*this.a,this.rc=1}function Ut(t){var e,i,r,n,o,s,a,l,h=t.x,u=t.y;return r=si(h-this.long0),e=Math.sin(u),i=Math.cos(u),n=Math.cos(r),s=this.sin_p14*e+this.cos_p14*i*n,o=1,s>0||Math.abs(s)<=Ne?(a=this.x0+this.a*o*i*Math.sin(r)/s,l=this.y0+this.a*o*(this.cos_p14*e-this.sin_p14*i*n)/s):(a=this.x0+this.infinity_dist*i*Math.sin(r),l=this.y0+this.infinity_dist*(this.cos_p14*e-this.sin_p14*i*n)),t.x=a,t.y=l,t}function Kt(t){var e,i,r,n,o,s;return t.x=(t.x-this.x0)/this.a,t.y=(t.y-this.y0)/this.a,t.x/=this.k0,t.y/=this.k0,(e=Math.sqrt(t.x*t.x+t.y*t.y))?(n=Math.atan2(e,this.rc),i=Math.sin(n),r=Math.cos(n),s=Qr(r*this.sin_p14+t.y*i*this.cos_p14/e),o=Math.atan2(t.x*i,e*this.cos_p14*r-t.y*this.sin_p14*i),o=si(this.long0+o)):(s=this.phic0,o=0),t.x=o,t.y=s,t}function jt(){this.sphere||(this.k0=ni(this.e,Math.sin(this.lat_ts),Math.cos(this.lat_ts)))}function zt(t){var e,i,r=t.x,n=t.y,o=si(r-this.long0);if(this.sphere)e=this.x0+this.a*o*Math.cos(this.lat_ts),i=this.y0+this.a*Math.sin(n)/Math.cos(this.lat_ts);else{var s=Vr(this.e,Math.sin(n));e=this.x0+this.a*this.k0*o,i=this.y0+this.a*s*.5/this.k0}return t.x=e,t.y=i,t}function Ht(t){t.x-=this.x0,t.y-=this.y0;var e,i;return this.sphere?(e=si(this.long0+t.x/this.a/Math.cos(this.lat_ts)),i=Math.asin(t.y/this.a*Math.cos(this.lat_ts))):(i=rn(this.e,2*t.y*this.k0/this.a),e=si(this.long0+t.x/(this.a*this.k0))),t.x=e,t.y=i,t}function qt(){this.x0=this.x0||0,this.y0=this.y0||0,this.lat0=this.lat0||0,this.long0=this.long0||0,this.lat_ts=this.lat_ts||0,this.title=this.title||"Equidistant Cylindrical (Plate Carre)",this.rc=Math.cos(this.lat_ts)}function Yt(t){var e=t.x,i=t.y,r=si(e-this.long0),n=Ir(i-this.lat0);return t.x=this.x0+this.a*r*this.rc,t.y=this.y0+this.a*n,t}function Xt(t){var e=t.x,i=t.y;return t.x=si(this.long0+(e-this.x0)/(this.a*this.rc)),t.y=Ir(this.lat0+(i-this.y0)/this.a),t}function Jt(){this.temp=this.b/this.a,this.es=1-Math.pow(this.temp,2),this.e=Math.sqrt(this.es),this.e0=Cr(this.es),this.e1=Mr(this.es),this.e2=Pr(this.es),this.e3=Or(this.es),this.ml0=this.a*xr(this.e0,this.e1,this.e2,this.e3,this.lat0)}function Qt(t){var e,i,r,n=t.x,o=t.y,s=si(n-this.long0);if(r=s*Math.sin(o),this.sphere)Math.abs(o)<=Ne?(e=this.a*s,i=-1*this.a*this.lat0):(e=this.a*Math.sin(r)/Math.tan(o),i=this.a*(Ir(o-this.lat0)+(1-Math.cos(r))/Math.tan(o)));else if(Math.abs(o)<=Ne)e=this.a*s,i=-1*this.ml0;else{var a=Nr(this.a,this.e,Math.sin(o))/Math.tan(o);e=a*Math.sin(r),i=this.a*xr(this.e0,this.e1,this.e2,this.e3,o)-this.ml0+a*(1-Math.cos(r))}return t.x=e+this.x0,t.y=i+this.y0,t}function Zt(t){var e,i,r,n,o,s,a,l,h;if(r=t.x-this.x0,n=t.y-this.y0,this.sphere)if(Math.abs(n+this.a*this.lat0)<=Ne)e=si(r/this.a+this.long0),i=0;else{s=this.lat0+n/this.a,a=r*r/this.a/this.a+s*s,l=s;var u;for(o=ln;o;--o)if(u=Math.tan(l),h=-1*(s*(l*u+1)-l-.5*(l*l+a)*u)/((l-s)/u-1),l+=h,Math.abs(h)<=Ne){i=l;break}e=si(this.long0+Math.asin(r*Math.tan(l)/this.a)/Math.sin(i))}else if(Math.abs(n+this.ml0)<=Ne)i=0,e=si(this.long0+r/this.a);else{s=(this.ml0+n)/this.a,a=r*r/this.a/this.a+s*s,l=s;var c,d,p,f,g;for(o=ln;o;--o)if(g=this.e*Math.sin(l),c=Math.sqrt(1-g*g)*Math.tan(l),d=this.a*xr(this.e0,this.e1,this.e2,this.e3,l),p=this.e0-2*this.e1*Math.cos(2*l)+4*this.e2*Math.cos(4*l)-6*this.e3*Math.cos(6*l),f=d/this.a,h=(s*(c*f+1)-f-.5*c*(f*f+a))/(this.es*Math.sin(2*l)*(f*f+a-2*s*f)/(4*c)+(s-f)*(c*p-2/Math.sin(2*l))-p),l-=h,Math.abs(h)<=Ne){i=l;break}c=Math.sqrt(1-this.es*Math.pow(Math.sin(i),2))*Math.tan(i),e=si(this.long0+Math.asin(r*c/this.a)/Math.sin(i))}return t.x=e,t.y=i,t}function $t(){this.A=[],this.A[1]=.6399175073,this.A[2]=-.1358797613,this.A[3]=.063294409,this.A[4]=-.02526853,this.A[5]=.0117879,this.A[6]=-.0055161,this.A[7]=.0026906,this.A[8]=-.001333,this.A[9]=67e-5,this.A[10]=-34e-5,this.B_re=[],this.B_im=[],this.B_re[1]=.7557853228,this.B_im[1]=0,this.B_re[2]=.249204646,this.B_im[2]=.003371507,this.B_re[3]=-.001541739,this.B_im[3]=.04105856,this.B_re[4]=-.10162907,this.B_im[4]=.01727609,this.B_re[5]=-.26623489,this.B_im[5]=-.36249218,this.B_re[6]=-.6870983,this.B_im[6]=-1.1651967,this.C_re=[],this.C_im=[],this.C_re[1]=1.3231270439,this.C_im[1]=0,this.C_re[2]=-.577245789,this.C_im[2]=-.007809598,this.C_re[3]=.508307513,this.C_im[3]=-.112208952,this.C_re[4]=-.15094762,this.C_im[4]=.18200602,this.C_re[5]=1.01418179,this.C_im[5]=1.64497696,this.C_re[6]=1.9660549,this.C_im[6]=2.5127645,this.D=[],this.D[1]=1.5627014243,this.D[2]=.5185406398,this.D[3]=-.03333098,this.D[4]=-.1052906,this.D[5]=-.0368594,this.D[6]=.007317,this.D[7]=.0122,this.D[8]=.00394,this.D[9]=-.0013}function te(t){var e,i=t.x,r=t.y,n=r-this.lat0,o=i-this.long0,s=n/xe*1e-5,a=o,l=1,h=0;for(e=1;e<=10;e++)l*=s,h+=this.A[e]*l;var u,c,d=h,p=a,f=1,g=0,m=0,y=0;for(e=1;e<=6;e++)u=f*d-g*p,c=g*d+f*p,f=u,g=c,m=m+this.B_re[e]*f-this.B_im[e]*g,y=y+this.B_im[e]*f+this.B_re[e]*g;return t.x=y*this.a+this.x0,t.y=m*this.a+this.y0,t}function ee(t){var e,i,r,n=t.x,o=t.y,s=n-this.x0,a=o-this.y0,l=a/this.a,h=s/this.a,u=1,c=0,d=0,p=0;for(e=1;e<=6;e++)i=u*l-c*h,r=c*l+u*h,u=i,c=r,d=d+this.C_re[e]*u-this.C_im[e]*c,p=p+this.C_im[e]*u+this.C_re[e]*c;for(var f=0;f<this.iterations;f++){var g,m,y=d,E=p,v=l,_=h;for(e=2;e<=6;e++)g=y*d-E*p,m=E*d+y*p,y=g,E=m,v+=(e-1)*(this.B_re[e]*y-this.B_im[e]*E),_+=(e-1)*(this.B_im[e]*y+this.B_re[e]*E);y=1,E=0;var b=this.B_re[1],w=this.B_im[1];for(e=2;e<=6;e++)g=y*d-E*p,m=E*d+y*p,y=g,E=m,b+=e*(this.B_re[e]*y-this.B_im[e]*E),w+=e*(this.B_im[e]*y+this.B_re[e]*E);var S=b*b+w*w;d=(v*b+_*w)/S,p=(_*b-v*w)/S}var L=d,T=p,A=1,R=0;for(e=1;e<=9;e++)A*=L,R+=this.D[e]*A;var x=this.lat0+R*xe*1e5,C=this.long0+T;return t.x=C,t.y=x,t}function ie(){}function re(t){var e=t.x,i=t.y,r=si(e-this.long0),n=this.x0+this.a*r,o=this.y0+this.a*Math.log(Math.tan(Math.PI/4+i/2.5))*1.25;return t.x=n,t.y=o,t}function ne(t){t.x-=this.x0,t.y-=this.y0;var e=si(this.long0+t.x/this.a),i=2.5*(Math.atan(Math.exp(.8*t.y/this.a))-Math.PI/4);return t.x=e,t.y=i,t}function oe(){this.sphere?(this.n=1,this.m=0,this.es=0,this.C_y=Math.sqrt((this.m+1)/this.n),this.C_x=this.C_y/(this.m+1)):this.en=Hi(this.es)}function se(t){var e,i,r=t.x,n=t.y;if(r=si(r-this.long0),this.sphere){if(this.m)for(var o=this.n*Math.sin(n),s=gn;s;--s){var a=(this.m*n+Math.sin(n)-o)/(this.m+Math.cos(n));if(n-=a,Math.abs(a)<Ne)break}else n=1!==this.n?Math.asin(this.n*Math.sin(n)):n;e=this.a*this.C_x*r*(this.m+Math.cos(n)),i=this.a*this.C_y*n}else{var l=Math.sin(n),h=Math.cos(n);i=this.a*qi(n,l,h,this.en),e=this.a*r*h/Math.sqrt(1-this.es*l*l)}return t.x=e,t.y=i,t}function ae(t){var e,i,r,n;return t.x-=this.x0,r=t.x/this.a,t.y-=this.y0,e=t.y/this.a,this.sphere?(e/=this.C_y,r/=this.C_x*(this.m+Math.cos(e)),this.m?e=Qr((this.m*e+Math.sin(e))/this.n):1!==this.n&&(e=Qr(Math.sin(e)/this.n)),r=si(r+this.long0),e=Ir(e)):(e=Xi(t.y/this.a,this.es,this.en),n=Math.abs(e),n<Ce?(n=Math.sin(e),i=this.long0+t.x*Math.sqrt(1-this.es*n*n)/(this.a*Math.cos(e)),r=si(i)):n-Ne<Ce&&(r=this.long0)),t.x=r,t.y=e,t}function le(){}function he(t){for(var e=t.x,i=t.y,r=si(e-this.long0),n=i,o=Math.PI*Math.sin(i),s=0;!0;s++){var a=-(n+Math.sin(n)-o)/(1+Math.cos(n));if(n+=a,Math.abs(a)<Ne)break}n/=2,Math.PI/2-Math.abs(i)<Ne&&(r=0);var l=.900316316158*this.a*r*Math.cos(n)+this.x0,h=1.4142135623731*this.a*Math.sin(n)+this.y0;return t.x=l,t.y=h,t}function ue(t){var e,i;t.x-=this.x0,t.y-=this.y0,i=t.y/(1.4142135623731*this.a),Math.abs(i)>.999999999999&&(i=.999999999999),e=Math.asin(i);var r=si(this.long0+t.x/(.900316316158*this.a*Math.cos(e)));r<-Math.PI&&(r=-Math.PI),r>Math.PI&&(r=Math.PI),i=(2*e+Math.sin(2*e))/Math.PI,Math.abs(i)>1&&(i=1);var n=Math.asin(i);return t.x=r,t.y=n,t}function ce(){Math.abs(this.lat1+this.lat2)<Ne||(this.lat2=this.lat2||this.lat1,this.temp=this.b/this.a,this.es=1-Math.pow(this.temp,2),this.e=Math.sqrt(this.es),this.e0=Cr(this.es),this.e1=Mr(this.es),this.e2=Pr(this.es),this.e3=Or(this.es),this.sinphi=Math.sin(this.lat1),this.cosphi=Math.cos(this.lat1),this.ms1=ni(this.e,this.sinphi,this.cosphi),this.ml1=xr(this.e0,this.e1,this.e2,this.e3,this.lat1),Math.abs(this.lat1-this.lat2)<Ne?this.ns=this.sinphi:(this.sinphi=Math.sin(this.lat2),this.cosphi=Math.cos(this.lat2),this.ms2=ni(this.e,this.sinphi,this.cosphi),this.ml2=xr(this.e0,this.e1,this.e2,this.e3,this.lat2),this.ns=(this.ms1-this.ms2)/(this.ml2-this.ml1)),this.g=this.ml1+this.ms1/this.ns,this.ml0=xr(this.e0,this.e1,this.e2,this.e3,this.lat0),this.rh=this.a*(this.g-this.ml0))}function de(t){var e,i=t.x,r=t.y;if(this.sphere)e=this.a*(this.g-r);else{var n=xr(this.e0,this.e1,this.e2,this.e3,r);e=this.a*(this.g-n)}var o=this.ns*si(i-this.long0),s=this.x0+e*Math.sin(o),a=this.y0+this.rh-e*Math.cos(o);return t.x=s,t.y=a,t}function pe(t){t.x-=this.x0,t.y=this.rh-t.y+this.y0;var e,i,r,n;this.ns>=0?(i=Math.sqrt(t.x*t.x+t.y*t.y),e=1):(i=-Math.sqrt(t.x*t.x+t.y*t.y),e=-1);var o=0;if(0!==i&&(o=Math.atan2(e*t.x,e*t.y)),this.sphere)return n=si(this.long0+o/this.ns),r=Ir(this.g-i/this.a),t.x=n,t.y=r,t;var s=this.g-i/this.a;return r=Dr(s,this.e0,this.e1,this.e2,this.e3),n=si(this.long0+o/this.ns),t.x=n,t.y=r,t}function fe(){this.R=this.a}function ge(t){var e,i,r=t.x,n=t.y,o=si(r-this.long0);Math.abs(n)<=Ne&&(e=this.x0+this.R*o,i=this.y0);var s=Qr(2*Math.abs(n/Math.PI));(Math.abs(o)<=Ne||Math.abs(Math.abs(n)-Ce)<=Ne)&&(e=this.x0,i=n>=0?this.y0+Math.PI*this.R*Math.tan(.5*s):this.y0+Math.PI*this.R*-Math.tan(.5*s));var a=.5*Math.abs(Math.PI/o-o/Math.PI),l=a*a,h=Math.sin(s),u=Math.cos(s),c=u/(h+u-1),d=c*c,p=c*(2/h-1),f=p*p,g=Math.PI*this.R*(a*(c-f)+Math.sqrt(l*(c-f)*(c-f)-(f+l)*(d-f)))/(f+l);o<0&&(g=-g),e=this.x0+g;var m=l+c;return g=Math.PI*this.R*(p*m-a*Math.sqrt((f+l)*(l+1)-m*m))/(f+l),i=n>=0?this.y0+g:this.y0-g,t.x=e,t.y=i,t}function me(t){var e,i,r,n,o,s,a,l,h,u,c,d,p;return t.x-=this.x0,t.y-=this.y0,c=Math.PI*this.R,r=t.x/c,n=t.y/c,o=r*r+n*n,s=-Math.abs(n)*(1+o),a=s-2*n*n+r*r,l=-2*s+1+2*n*n+o*o,p=n*n/l+(2*a*a*a/l/l/l-9*s*a/l/l)/27,h=(s-a*a/3/l)/l,u=2*Math.sqrt(-h/3),c=3*p/h/u,Math.abs(c)>1&&(c=c>=0?1:-1),d=Math.acos(c)/3,i=t.y>=0?(-u*Math.cos(d+Math.PI/3)-a/3/l)*Math.PI:-(-u*Math.cos(d+Math.PI/3)-a/3/l)*Math.PI,e=Math.abs(r)<Ne?this.long0:si(this.long0+Math.PI*(o-1+Math.sqrt(1+2*(r*r-n*n)+o*o))/2/r),t.x=e,t.y=i,t}function ye(){this.sin_p12=Math.sin(this.lat0),this.cos_p12=Math.cos(this.lat0)}function Ee(t){var e,i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_,b,w,S,L=t.x,T=t.y,A=Math.sin(t.y),R=Math.cos(t.y),x=si(L-this.long0);return this.sphere?Math.abs(this.sin_p12-1)<=Ne?(t.x=this.x0+this.a*(Ce-T)*Math.sin(x),t.y=this.y0-this.a*(Ce-T)*Math.cos(x),t):Math.abs(this.sin_p12+1)<=Ne?(t.x=this.x0+this.a*(Ce+T)*Math.sin(x),t.y=this.y0+this.a*(Ce+T)*Math.cos(x),t):(E=this.sin_p12*A+this.cos_p12*R*Math.cos(x),m=Math.acos(E),y=m/Math.sin(m),t.x=this.x0+this.a*y*R*Math.sin(x),t.y=this.y0+this.a*y*(this.cos_p12*A-this.sin_p12*R*Math.cos(x)),t):(e=Cr(this.es),i=Mr(this.es),r=Pr(this.es),n=Or(this.es),Math.abs(this.sin_p12-1)<=Ne?(o=this.a*xr(e,i,r,n,Ce),s=this.a*xr(e,i,r,n,T),t.x=this.x0+(o-s)*Math.sin(x),t.y=this.y0-(o-s)*Math.cos(x),t):Math.abs(this.sin_p12+1)<=Ne?(o=this.a*xr(e,i,r,n,Ce),s=this.a*xr(e,i,r,n,T),t.x=this.x0+(o+s)*Math.sin(x),t.y=this.y0+(o+s)*Math.cos(x),t):(a=A/R,l=Nr(this.a,this.e,this.sin_p12),h=Nr(this.a,this.e,A),u=Math.atan((1-this.es)*a+this.es*l*this.sin_p12/(h*R)),c=Math.atan2(Math.sin(x),this.cos_p12*Math.tan(u)-this.sin_p12*Math.cos(x)),v=0===c?Math.asin(this.cos_p12*Math.sin(u)-this.sin_p12*Math.cos(u)):Math.abs(Math.abs(c)-Math.PI)<=Ne?-Math.asin(this.cos_p12*Math.sin(u)-this.sin_p12*Math.cos(u)):Math.asin(Math.sin(x)*Math.cos(u)/Math.sin(c)),d=this.e*this.sin_p12/Math.sqrt(1-this.es),p=this.e*this.cos_p12*Math.cos(c)/Math.sqrt(1-this.es),f=d*p,g=p*p,_=v*v,b=_*v,w=b*v,S=w*v,m=l*v*(1-_*g*(1-g)/6+b/8*f*(1-2*g)+w/120*(g*(4-7*g)-3*d*d*(1-7*g))-S/48*f),t.x=this.x0+m*Math.sin(c),t.y=this.y0+m*Math.cos(c),t))}function ve(t){t.x-=this.x0,t.y-=this.y0;var e,i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_,b,w,S;if(this.sphere){if(e=Math.sqrt(t.x*t.x+t.y*t.y),e>2*Ce*this.a)return;return i=e/this.a,r=Math.sin(i),n=Math.cos(i),o=this.long0,Math.abs(e)<=Ne?s=this.lat0:(s=Qr(n*this.sin_p12+t.y*r*this.cos_p12/e),a=Math.abs(this.lat0)-Ce,o=si(Math.abs(a)<=Ne?this.lat0>=0?this.long0+Math.atan2(t.x,-t.y):this.long0-Math.atan2(-t.x,t.y):this.long0+Math.atan2(t.x*r,e*this.cos_p12*n-t.y*this.sin_p12*r))),t.x=o,t.y=s,t}return l=Cr(this.es),h=Mr(this.es),u=Pr(this.es),c=Or(this.es),Math.abs(this.sin_p12-1)<=Ne?(d=this.a*xr(l,h,u,c,Ce),e=Math.sqrt(t.x*t.x+t.y*t.y),p=d-e,s=Dr(p/this.a,l,h,u,c),o=si(this.long0+Math.atan2(t.x,-1*t.y)),t.x=o,t.y=s,t):Math.abs(this.sin_p12+1)<=Ne?(d=this.a*xr(l,h,u,c,Ce),e=Math.sqrt(t.x*t.x+t.y*t.y),p=e-d,s=Dr(p/this.a,l,h,u,c),o=si(this.long0+Math.atan2(t.x,t.y)),t.x=o,t.y=s,t):(e=Math.sqrt(t.x*t.x+t.y*t.y),m=Math.atan2(t.x,t.y),f=Nr(this.a,this.e,this.sin_p12),y=Math.cos(m),E=this.e*this.cos_p12*y,v=-E*E/(1-this.es),_=3*this.es*(1-v)*this.sin_p12*this.cos_p12*y/(1-this.es),b=e/f,w=b-v*(1+v)*Math.pow(b,3)/6-_*(1+3*v)*Math.pow(b,4)/24,S=1-v*w*w/2-b*w*w*w/6,g=Math.asin(this.sin_p12*Math.cos(w)+this.cos_p12*Math.sin(w)*y),o=si(this.long0+Math.asin(Math.sin(m)*Math.sin(w)/Math.cos(g))),s=Math.atan((1-this.es*S*this.sin_p12/Math.sin(g))*Math.tan(g)/(1-this.es)),t.x=o,t.y=s,t)}function _e(){this.sin_p14=Math.sin(this.lat0),this.cos_p14=Math.cos(this.lat0)}function be(t){var e,i,r,n,o,s,a,l,h=t.x,u=t.y;return r=si(h-this.long0),e=Math.sin(u),i=Math.cos(u),n=Math.cos(r),s=this.sin_p14*e+this.cos_p14*i*n,o=1,(s>0||Math.abs(s)<=Ne)&&(a=this.a*o*i*Math.sin(r),l=this.y0+this.a*o*(this.cos_p14*e-this.sin_p14*i*n)),t.x=a,t.y=l,t}function we(t){var e,i,r,n,o,s,a;return t.x-=this.x0,t.y-=this.y0,e=Math.sqrt(t.x*t.x+t.y*t.y),i=Qr(e/this.a),r=Math.sin(i),n=Math.cos(i),s=this.long0,Math.abs(e)<=Ne?(a=this.lat0,t.x=s,t.y=a,t):(a=Qr(n*this.sin_p14+t.y*r*this.cos_p14/e),o=Math.abs(this.lat0)-Ce,Math.abs(o)<=Ne?(s=si(this.lat0>=0?this.long0+Math.atan2(t.x,-t.y):this.long0-Math.atan2(-t.x,t.y)),t.x=s,t.y=a,t):(s=si(this.long0+Math.atan2(t.x*r,e*this.cos_p14*n-t.y*this.sin_p14*r)),t.x=s,t.y=a,t))}var Se=function(t){t("EPSG:4326","+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"),t("EPSG:4269","+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees"),t("EPSG:3857","+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs"),t.WGS84=t["EPSG:4326"],t["EPSG:3785"]=t["EPSG:3857"],t.GOOGLE=t["EPSG:3857"],t["EPSG:900913"]=t["EPSG:3857"],t["EPSG:102113"]=t["EPSG:3857"]},Le=1,Te=2,Ae=4,Re=5,xe=484813681109536e-20,Ce=Math.PI/2,Me=.16666666666666666,Pe=.04722222222222222,Oe=.022156084656084655,Ne="undefined"==typeof Number.EPSILON?1e-10:Number.EPSILON,Ie=.017453292519943295,De=57.29577951308232,ke=Math.PI/4,Fe=2*Math.PI,Ve=3.14159265359,Ge={};Ge.greenwich=0,Ge.lisbon=-9.131906111111,Ge.paris=2.337229166667,Ge.bogota=-74.080916666667,Ge.madrid=-3.687938888889,Ge.rome=12.452333333333,Ge.bern=7.439583333333,Ge.jakarta=106.807719444444,Ge.ferro=-17.666666666667,Ge.brussels=4.367975,Ge.stockholm=18.058277777778,Ge.athens=23.7163375,Ge.oslo=10.722916666667;var We={ft:{to_meter:.3048},"us-ft":{to_meter:1200/3937}},Be=/[\s_\-\/\(\)]/g,Ue=function(e){var i,r,n,o={},s=e.split("+").map(function(t){return t.trim()}).filter(function(t){return t}).reduce(function(t,e){var i=e.split("=");return i.push(!0),t[i[0].toLowerCase()]=i[1],t},{}),a={proj:"projName",datum:"datumCode",rf:function(t){o.rf=parseFloat(t)},lat_0:function(t){o.lat0=t*Ie},lat_1:function(t){o.lat1=t*Ie},lat_2:function(t){o.lat2=t*Ie},lat_ts:function(t){o.lat_ts=t*Ie},lon_0:function(t){o.long0=t*Ie},lon_1:function(t){o.long1=t*Ie},lon_2:function(t){o.long2=t*Ie},alpha:function(t){o.alpha=parseFloat(t)*Ie},lonc:function(t){o.longc=t*Ie},x_0:function(t){o.x0=parseFloat(t)},y_0:function(t){o.y0=parseFloat(t)},k_0:function(t){o.k0=parseFloat(t)},k:function(t){o.k0=parseFloat(t)},a:function(t){o.a=parseFloat(t)},b:function(t){o.b=parseFloat(t)},r_a:function(){o.R_A=!0},zone:function(t){o.zone=parseInt(t,10)},south:function(){o.utmSouth=!0},towgs84:function(t){o.datum_params=t.split(",").map(function(t){return parseFloat(t)})},to_meter:function(t){o.to_meter=parseFloat(t)},units:function(e){o.units=e;var i=t(We,e);i&&(o.to_meter=i.to_meter)},from_greenwich:function(t){o.from_greenwich=t*Ie},pm:function(e){var i=t(Ge,e);o.from_greenwich=(i?i:parseFloat(e))*Ie},nadgrids:function(t){"@null"===t?o.datumCode="none":o.nadgrids=t},axis:function(t){var e="ewnsud";3===t.length&&e.indexOf(t.substr(0,1))!==-1&&e.indexOf(t.substr(1,1))!==-1&&e.indexOf(t.substr(2,1))!==-1&&(o.axis=t)}};for(i in s)r=s[i],i in a?(n=a[i],"function"==typeof n?n(r):o[n]=r):o[i]=r;return"string"==typeof o.datumCode&&"WGS84"!==o.datumCode&&(o.datumCode=o.datumCode.toLowerCase()),o},Ke=1,je=2,ze=3,He=4,qe=5,Ye=-1,Xe=/\s/,Je=/[A-Za-z]/,Qe=/[A-Za-z84]/,Ze=/[,\]]/,$e=/[\d\.E\-\+]/;e.prototype.readCharicter=function(){var t=this.text[this.place++];if(this.state!==He)for(;Xe.test(t);){if(this.place>=this.text.length)return;t=this.text[this.place++]}switch(this.state){case Ke:return this.neutral(t);case je:return this.keyword(t);case He:return this.quoted(t);case qe:return this.afterquote(t);case ze:return this.number(t);case Ye:return}},e.prototype.afterquote=function(t){if('"'===t)return this.word+='"',void(this.state=He);if(Ze.test(t))return this.word=this.word.trim(),void this.afterItem(t);throw new Error("havn't handled \""+t+'" in afterquote yet, index '+this.place)},e.prototype.afterItem=function(t){return","===t?(null!==this.word&&this.currentObject.push(this.word),this.word=null,void(this.state=Ke)):"]"===t?(this.level--,null!==this.word&&(this.currentObject.push(this.word),this.word=null),this.state=Ke,this.currentObject=this.stack.pop(),void(this.currentObject||(this.state=Ye))):void 0},e.prototype.number=function(t){if($e.test(t))return void(this.word+=t);if(Ze.test(t))return this.word=parseFloat(this.word),void this.afterItem(t);throw new Error("havn't handled \""+t+'" in number yet, index '+this.place)},e.prototype.quoted=function(t){return'"'===t?void(this.state=qe):void(this.word+=t)},e.prototype.keyword=function(t){if(Qe.test(t))return void(this.word+=t);if("["===t){var e=[];return e.push(this.word),this.level++,null===this.root?this.root=e:this.currentObject.push(e),this.stack.push(this.currentObject),this.currentObject=e,void(this.state=Ke)}if(Ze.test(t))return void this.afterItem(t);throw new Error("havn't handled \""+t+'" in keyword yet, index '+this.place)},e.prototype.neutral=function(t){if(Je.test(t))return this.word=t,void(this.state=je);if('"'===t)return this.word="",void(this.state=He);if($e.test(t))return this.word=t,void(this.state=ze);if(Ze.test(t))return void this.afterItem(t);throw new Error("havn't handled \""+t+'" in neutral yet, index '+this.place)},e.prototype.output=function(){for(;this.place<this.text.length;)this.readCharicter();if(this.state===Ye)return this.root;throw new Error('unable to parse string "'+this.text+'". State is '+this.state)};var ti=.017453292519943295,ei=function(t){var e=i(t),r=e.shift(),o=e.shift();e.unshift(["name",o]),e.unshift(["type",r]);var s={};return n(e,s),a(s),s};Se(l);var ii=["PROJECTEDCRS","PROJCRS","GEOGCS","GEOCCS","PROJCS","LOCAL_CS","GEODCRS","GEODETICCRS","GEODETICDATUM","ENGCRS","ENGINEERINGCRS"],ri=function(t,e){t=t||{};var i,r;if(!e)return t;for(r in e)i=e[r],void 0!==i&&(t[r]=i);return t},ni=function(t,e,i){var r=t*e;return i/Math.sqrt(1-r*r)},oi=function(t){return t<0?-1:1},si=function(t){return Math.abs(t)<=Ve?t:t-oi(t)*Fe},ai=function(t,e,i){var r=t*i,n=.5*t;return r=Math.pow((1-r)/(1+r),n),Math.tan(.5*(Ce-e))/r},li=function(t,e){for(var i,r,n=.5*t,o=Ce-2*Math.atan(e),s=0;s<=15;s++)if(i=t*Math.sin(o),r=Ce-2*Math.atan(e*Math.pow((1-i)/(1+i),n))-o,o+=r,Math.abs(r)<=1e-10)return o;return-9999},hi=["Mercator","Popular Visualisation Pseudo Mercator","Mercator_1SP","Mercator_Auxiliary_Sphere","merc"],ui={init:f,forward:g,inverse:m,names:hi},ci=["longlat","identity"],di={init:y,forward:E,inverse:E,names:ci},pi=[ui,di],fi={},gi=[],mi={start:b,add:v,get:_},yi={};yi.MERIT={a:6378137,rf:298.257,ellipseName:"MERIT 1983"},yi.SGS85={a:6378136,rf:298.257,ellipseName:"Soviet Geodetic System 85"},yi.GRS80={a:6378137,rf:298.257222101,ellipseName:"GRS 1980(IUGG, 1980)"},yi.IAU76={a:6378140,rf:298.257,ellipseName:"IAU 1976"},yi.airy={a:6377563.396,b:6356256.91,ellipseName:"Airy 1830"},yi.APL4={a:6378137,rf:298.25,ellipseName:"Appl. Physics. 1965"},yi.NWL9D={a:6378145,rf:298.25,ellipseName:"Naval Weapons Lab., 1965"},yi.mod_airy={a:6377340.189,b:6356034.446,ellipseName:"Modified Airy"},yi.andrae={a:6377104.43,rf:300,ellipseName:"Andrae 1876 (Den., Iclnd.)"},yi.aust_SA={a:6378160,rf:298.25,ellipseName:"Australian Natl & S. Amer. 1969"},yi.GRS67={a:6378160,rf:298.247167427,ellipseName:"GRS 67(IUGG 1967)"},yi.bessel={a:6377397.155,rf:299.1528128,ellipseName:"Bessel 1841"},yi.bess_nam={a:6377483.865,rf:299.1528128,ellipseName:"Bessel 1841 (Namibia)"},yi.clrk66={a:6378206.4,b:6356583.8,ellipseName:"Clarke 1866"},yi.clrk80={a:6378249.145,rf:293.4663,ellipseName:"Clarke 1880 mod."},yi.clrk58={a:6378293.645208759,rf:294.2606763692654,ellipseName:"Clarke 1858"},yi.CPM={a:6375738.7,rf:334.29,ellipseName:"Comm. des Poids et Mesures 1799"},yi.delmbr={a:6376428,rf:311.5,ellipseName:"Delambre 1810 (Belgium)"},yi.engelis={a:6378136.05,rf:298.2566,ellipseName:"Engelis 1985"},yi.evrst30={a:6377276.345,rf:300.8017,ellipseName:"Everest 1830"},yi.evrst48={a:6377304.063,rf:300.8017,ellipseName:"Everest 1948"},yi.evrst56={a:6377301.243,rf:300.8017,ellipseName:"Everest 1956"},yi.evrst69={a:6377295.664,rf:300.8017,ellipseName:"Everest 1969"},yi.evrstSS={a:6377298.556,rf:300.8017,ellipseName:"Everest (Sabah & Sarawak)"},yi.fschr60={a:6378166,rf:298.3,ellipseName:"Fischer (Mercury Datum) 1960"},yi.fschr60m={a:6378155,rf:298.3,ellipseName:"Fischer 1960"},yi.fschr68={a:6378150,rf:298.3,ellipseName:"Fischer 1968"},yi.helmert={a:6378200,rf:298.3,ellipseName:"Helmert 1906"},yi.hough={a:6378270,rf:297,ellipseName:"Hough"},yi.intl={a:6378388,rf:297,ellipseName:"International 1909 (Hayford)"},yi.kaula={a:6378163,rf:298.24,ellipseName:"Kaula 1961"},yi.lerch={a:6378139,rf:298.257,ellipseName:"Lerch 1979"},yi.mprts={a:6397300,rf:191,ellipseName:"Maupertius 1738"},yi.new_intl={a:6378157.5,b:6356772.2,ellipseName:"New International 1967"},yi.plessis={a:6376523,rf:6355863,ellipseName:"Plessis 1817 (France)"},yi.krass={a:6378245,rf:298.3,ellipseName:"Krassovsky, 1942"},yi.SEasia={a:6378155,b:6356773.3205,ellipseName:"Southeast Asia"},yi.walbeck={a:6376896,b:6355834.8467,ellipseName:"Walbeck"},yi.WGS60={a:6378165,rf:298.3,ellipseName:"WGS 60"},yi.WGS66={a:6378145,rf:298.25,ellipseName:"WGS 66"},yi.WGS7={a:6378135,rf:298.26,ellipseName:"WGS 72"};var Ei=yi.WGS84={a:6378137,rf:298.257223563,ellipseName:"WGS 84"};yi.sphere={a:6370997,b:6370997,ellipseName:"Normal Sphere (r=6370997)"};var vi={};vi.wgs84={towgs84:"0,0,0",ellipse:"WGS84",datumName:"WGS84"},vi.ch1903={towgs84:"674.374,15.056,405.346",ellipse:"bessel",datumName:"swiss"},vi.ggrs87={towgs84:"-199.87,74.79,246.62",ellipse:"GRS80",datumName:"Greek_Geodetic_Reference_System_1987"},vi.nad83={towgs84:"0,0,0",ellipse:"GRS80",datumName:"North_American_Datum_1983"},vi.nad27={nadgrids:"@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",ellipse:"clrk66",datumName:"North_American_Datum_1927"},vi.potsdam={towgs84:"606.0,23.0,413.0",ellipse:"bessel",datumName:"Potsdam Rauenberg 1950 DHDN"},vi.carthage={towgs84:"-263.0,6.0,431.0",ellipse:"clark80",datumName:"Carthage 1934 Tunisia"},vi.hermannskogel={towgs84:"653.0,-212.0,449.0",ellipse:"bessel",datumName:"Hermannskogel"},vi.ire65={towgs84:"482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",ellipse:"mod_airy",datumName:"Ireland 1965"},vi.rassadiran={towgs84:"-133.63,-157.5,-158.62",ellipse:"intl",datumName:"Rassadiran"},vi.nzgd49={towgs84:"59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",ellipse:"intl",datumName:"New Zealand Geodetic Datum 1949"},vi.osgb36={towgs84:"446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",ellipse:"airy",datumName:"Airy 1830"},vi.s_jtsk={towgs84:"589,76,480",ellipse:"bessel",datumName:"S-JTSK (Ferro)"},vi.beduaram={towgs84:"-106,-87,188",ellipse:"clrk80",datumName:"Beduaram"},vi.gunung_segara={towgs84:"-403,684,41",ellipse:"bessel",datumName:"Gunung Segara Jakarta"},vi.rnb72={towgs84:"106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",ellipse:"intl",datumName:"Reseau National Belge 1972"},T.projections=mi,T.projections.start();var _i=function(t,e,i){return A(t,e)?i:t.datum_type===Re||e.datum_type===Re?i:t.es!==e.es||t.a!==e.a||P(t.datum_type)||P(e.datum_type)?(i=R(i,t.es,t.a),P(t.datum_type)&&(i=C(i,t.datum_type,t.datum_params)),P(e.datum_type)&&(i=M(i,e.datum_type,e.datum_params)),x(i,e.es,e.a,e.b)):i},bi=function(t,e,i){var r,n,o,s=i.x,a=i.y,l=i.z||0,h={};for(o=0;o<3;o++)if(!e||2!==o||void 0!==i.z)switch(0===o?(r=s,n="x"):1===o?(r=a,n="y"):(r=l,n="z"),t.axis[o]){case"e":h[n]=r;break;case"w":h[n]=-r;break;case"n":h[n]=r;break;case"s":h[n]=-r;break;case"u":void 0!==i[n]&&(h.z=r);break;case"d":void 0!==i[n]&&(h.z=-r);break;default:return null}return h},wi=function(t){var e={x:t[0],y:t[1]};return t.length>2&&(e.z=t[2]),t.length>3&&(e.m=t[3]),e},Si=T("WGS84"),Li=6,Ti="AJSAJS",Ai="AFAFAF",Ri=65,xi=73,Ci=79,Mi=86,Pi=90,Oi={forward:F,inverse:V,toPoint:G};$.fromMGRS=function(t){return new $(G(t))},$.prototype.toMGRS=function(t){return F([this.x,this.y],t)};var Ni="2.4.3",Ii=1,Di=.25,ki=.046875,Fi=.01953125,Vi=.01068115234375,Gi=.75,Wi=.46875,Bi=.013020833333333334,Ui=.007120768229166667,Ki=.3645833333333333,ji=.005696614583333333,zi=.3076171875,Hi=function(t){var e=[];e[0]=Ii-t*(Di+t*(ki+t*(Fi+t*Vi))),e[1]=t*(Gi-t*(ki+t*(Fi+t*Vi)));var i=t*t;return e[2]=i*(Wi-t*(Bi+t*Ui)),i*=t,e[3]=i*(Ki-t*ji),e[4]=i*t*zi,e},qi=function(t,e,i,r){return i*=e,e*=e,r[0]*t-i*(r[1]+e*(r[2]+e*(r[3]+e*r[4])))},Yi=20,Xi=function(t,e,i){for(var r=1/(1-e),n=t,o=Yi;o;--o){var s=Math.sin(n),a=1-e*s*s;if(a=(qi(n,s,Math.cos(n),i)-t)*(a*Math.sqrt(a))*r,n-=a,Math.abs(a)<Ne)return n}return n},Ji=["Transverse_Mercator","Transverse Mercator","tmerc"],Qi={init:tt,forward:et,inverse:it,names:Ji},Zi=function(t){var e=Math.exp(t);return e=(e-1/e)/2},$i=function(t,e){t=Math.abs(t),e=Math.abs(e);var i=Math.max(t,e),r=Math.min(t,e)/(i?i:1);return i*Math.sqrt(1+Math.pow(r,2))},tr=function(t){var e=1+t,i=e-1;return 0===i?t:t*Math.log(e)/i},er=function(t){var e=Math.abs(t);return e=tr(e*(1+e/($i(1,e)+1))),t<0?-e:e},ir=function(t,e){for(var i,r=2*Math.cos(2*e),n=t.length-1,o=t[n],s=0;--n>=0;)i=-s+r*o+t[n],s=o,o=i;return e+i*Math.sin(2*e)},rr=function(t,e){for(var i,r=2*Math.cos(e),n=t.length-1,o=t[n],s=0;--n>=0;)i=-s+r*o+t[n],s=o,o=i;return Math.sin(e)*i},nr=function(t){var e=Math.exp(t);return e=(e+1/e)/2},or=function(t,e,i){for(var r,n,o=Math.sin(e),s=Math.cos(e),a=Zi(i),l=nr(i),h=2*s*l,u=-2*o*a,c=t.length-1,d=t[c],p=0,f=0,g=0;--c>=0;)r=f,n=p,f=d,p=g,d=-r+h*f-u*p+t[c],g=-n+u*f+h*p;return h=o*l,u=s*a,[h*d-u*g,h*g+u*d]},sr=["Extended_Transverse_Mercator","Extended Transverse Mercator","etmerc"],ar={init:rt,forward:nt,inverse:ot,names:sr},lr=function(t,e){if(void 0===t){if(t=Math.floor(30*(si(e)+Math.PI)/Math.PI)+1,t<0)return 0;if(t>60)return 60}return t},hr="etmerc",ur=["Universal Transverse Mercator System","utm"],cr={init:st,names:ur,dependsOn:hr},dr=function(t,e){return Math.pow((1-t)/(1+t),e)},pr=20,fr=["gauss"],gr={init:at,forward:lt,inverse:ht,names:fr},mr=["Stereographic_North_Pole","Oblique_Stereographic","Polar_Stereographic","sterea","Oblique Stereographic Alternative"],yr={
init:ut,forward:ct,inverse:dt,names:mr},Er=["stere","Stereographic_South_Pole","Polar Stereographic (variant B)"],vr={init:ft,forward:gt,inverse:mt,names:Er,ssfn_:pt},_r=["somerc"],br={init:yt,forward:Et,inverse:vt,names:_r},wr=["Hotine_Oblique_Mercator","Hotine Oblique Mercator","Hotine_Oblique_Mercator_Azimuth_Natural_Origin","Hotine_Oblique_Mercator_Azimuth_Center","omerc"],Sr={init:_t,forward:bt,inverse:wt,names:wr},Lr=["Lambert Tangential Conformal Conic Projection","Lambert_Conformal_Conic","Lambert_Conformal_Conic_2SP","lcc"],Tr={init:St,forward:Lt,inverse:Tt,names:Lr},Ar=["Krovak","krovak"],Rr={init:At,forward:Rt,inverse:xt,names:Ar},xr=function(t,e,i,r,n){return t*n-e*Math.sin(2*n)+i*Math.sin(4*n)-r*Math.sin(6*n)},Cr=function(t){return 1-.25*t*(1+t/16*(3+1.25*t))},Mr=function(t){return.375*t*(1+.25*t*(1+.46875*t))},Pr=function(t){return.05859375*t*t*(1+.75*t)},Or=function(t){return t*t*t*(35/3072)},Nr=function(t,e,i){var r=e*i;return t/Math.sqrt(1-r*r)},Ir=function(t){return Math.abs(t)<Ce?t:t-oi(t)*Math.PI},Dr=function(t,e,i,r,n){var o,s;o=t/e;for(var a=0;a<15;a++)if(s=(t-(e*o-i*Math.sin(2*o)+r*Math.sin(4*o)-n*Math.sin(6*o)))/(e-2*i*Math.cos(2*o)+4*r*Math.cos(4*o)-6*n*Math.cos(6*o)),o+=s,Math.abs(s)<=1e-10)return o;return NaN},kr=["Cassini","Cassini_Soldner","cass"],Fr={init:Ct,forward:Mt,inverse:Pt,names:kr},Vr=function(t,e){var i;return t>1e-7?(i=t*e,(1-t*t)*(e/(1-i*i)-.5/t*Math.log((1-i)/(1+i)))):2*e},Gr=1,Wr=2,Br=3,Ur=4,Kr=.3333333333333333,jr=.17222222222222222,zr=.10257936507936508,Hr=.06388888888888888,qr=.0664021164021164,Yr=.016415012942191543,Xr=["Lambert Azimuthal Equal Area","Lambert_Azimuthal_Equal_Area","laea"],Jr={init:Ot,forward:Nt,inverse:It,names:Xr,S_POLE:Gr,N_POLE:Wr,EQUIT:Br,OBLIQ:Ur},Qr=function(t){return Math.abs(t)>1&&(t=t>1?1:-1),Math.asin(t)},Zr=["Albers_Conic_Equal_Area","Albers","aea"],$r={init:Ft,forward:Vt,inverse:Gt,names:Zr,phi1z:Wt},tn=["gnom"],en={init:Bt,forward:Ut,inverse:Kt,names:tn},rn=function(t,e){var i=1-(1-t*t)/(2*t)*Math.log((1-t)/(1+t));if(Math.abs(Math.abs(e)-i)<1e-6)return e<0?-1*Ce:Ce;for(var r,n,o,s,a=Math.asin(.5*e),l=0;l<30;l++)if(n=Math.sin(a),o=Math.cos(a),s=t*n,r=Math.pow(1-s*s,2)/(2*o)*(e/(1-t*t)-n/(1-s*s)+.5/t*Math.log((1-s)/(1+s))),a+=r,Math.abs(r)<=1e-10)return a;return NaN},nn=["cea"],on={init:jt,forward:zt,inverse:Ht,names:nn},sn=["Equirectangular","Equidistant_Cylindrical","eqc"],an={init:qt,forward:Yt,inverse:Xt,names:sn},ln=20,hn=["Polyconic","poly"],un={init:Jt,forward:Qt,inverse:Zt,names:hn},cn=["New_Zealand_Map_Grid","nzmg"],dn={init:$t,forward:te,inverse:ee,names:cn},pn=["Miller_Cylindrical","mill"],fn={init:ie,forward:re,inverse:ne,names:pn},gn=20,mn=["Sinusoidal","sinu"],yn={init:oe,forward:se,inverse:ae,names:mn},En=["Mollweide","moll"],vn={init:le,forward:he,inverse:ue,names:En},_n=["Equidistant_Conic","eqdc"],bn={init:ce,forward:de,inverse:pe,names:_n},wn=["Van_der_Grinten_I","VanDerGrinten","vandg"],Sn={init:fe,forward:ge,inverse:me,names:wn},Ln=["Azimuthal_Equidistant","aeqd"],Tn={init:ye,forward:Ee,inverse:ve,names:Ln},An=["ortho"],Rn={init:_e,forward:be,inverse:we,names:An},xn=function(t){t.Proj.projections.add(Qi),t.Proj.projections.add(ar),t.Proj.projections.add(cr),t.Proj.projections.add(yr),t.Proj.projections.add(vr),t.Proj.projections.add(br),t.Proj.projections.add(Sr),t.Proj.projections.add(Tr),t.Proj.projections.add(Rr),t.Proj.projections.add(Fr),t.Proj.projections.add(Jr),t.Proj.projections.add($r),t.Proj.projections.add(en),t.Proj.projections.add(on),t.Proj.projections.add(an),t.Proj.projections.add(un),t.Proj.projections.add(dn),t.Proj.projections.add(fn),t.Proj.projections.add(yn),t.Proj.projections.add(vn),t.Proj.projections.add(bn),t.Proj.projections.add(Sn),t.Proj.projections.add(Tn),t.Proj.projections.add(Rn)};return k.defaultDatum="WGS84",k.Proj=T,k.WGS84=new k.Proj("WGS84"),k.Point=$,k.toPoint=wi,k.defs=l,k.transform=N,k.mgrs=Oi,k.version=Ni,xn(k),k}),i("formats/geotiff/TiffIFDEntry",["../../error/AbstractError","../../error/ArgumentError","./GeoTiffUtil","../../util/Logger","./TiffConstants"],function(t,e,i,r,n){"use strict";var o=function(t,i,n,o,s,a){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"TiffIFDEntry","constructor","missingTag"));if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"TiffIFDEntry","constructor","missingType"));if(!n)throw new e(r.logMessage(r.LEVEL_SEVERE,"TiffIFDEntry","constructor","missingCount"));if(null===o||void 0===o)throw new e(r.logMessage(r.LEVEL_SEVERE,"TiffIFDEntry","constructor","missingValueOffset"));if(!s)throw new e(r.logMessage(r.LEVEL_SEVERE,"TiffIFDEntry","constructor","missingGeoTiffData"));if(null===a||void 0===a)throw new e(r.logMessage(r.LEVEL_SEVERE,"TiffIFDEntry","constructor","missingIsLittleEndian"));this._tag=t,this._type=i,this._count=n,this._valueOffset=o,this._geoTiffData=s,this._isLittleEndian=a};return Object.defineProperties(o.prototype,{tag:{get:function(){return this._tag}},type:{get:function(){return this._type}},count:{get:function(){return this._count}},valueOffset:{get:function(){return this._valueOffset}},geoTiffData:{get:function(){return this._geoTiffData}},isLittleEndian:{get:function(){return this._isLittleEndian}}}),o.prototype.getIFDTypeLength=function(){switch(this.type){case n.Type.BYTE:case n.Type.ASCII:case n.Type.SBYTE:case n.Type.UNDEFINED:return 1;case n.Type.SHORT:case n.Type.SSHORT:return 2;case n.Type.LONG:case n.Type.SLONG:case n.Type.FLOAT:return 4;case n.Type.RATIONAL:case n.Type.SRATIONAL:case n.Type.DOUBLE:return 8;default:return-1}},o.prototype.getIFDEntryValue=function(){var e=[],o=null,s=this.getIFDTypeLength(),a=s*this.count;if(a<=4)o=this.isLittleEndian===!1?this.valueOffset>>>8*(4-s):this.valueOffset,e.push(o);else for(var l=0;l<this.count;l++){var h=s*l;if(s>=8)if(this.type===n.Type.RATIONAL||this.type===n.Type.SRATIONAL)e.push(i.getBytes(this.geoTiffData,this.valueOffset+h,4,this.isLittleEndian)),e.push(i.getBytes(this.geoTiffData,this.valueOffset+h+4,4,this.isLittleEndian));else{if(this.type!==n.Type.DOUBLE)throw new t(r.logMessage(r.LEVEL_SEVERE,"TiffIFDEntry","parse","invalidTypeOfIFD"));e.push(i.getBytes(this.geoTiffData,this.valueOffset+h,8,this.isLittleEndian))}else e.push(i.getBytes(this.geoTiffData,this.valueOffset+h,s,this.isLittleEndian))}return this.type===n.Type.ASCII?(e.forEach(function(t,e,i){0===t?i.splice(e,1):i[e]=String.fromCharCode(t)}),e.join("")):e},o}),i("util/WWUtil",["../error/ArgumentError","../geom/Line","../util/Logger","../geom/Rectangle","../geom/Vec3"],function(t,e,i,r,n){"use strict";var o={latLonRegex:/^(\-?\d+(\.\d+)?),\s*(\-?\d+(\.\d+)?)$/,suffixForMimeType:function(t){return"image/png"===t?"png":"image/jpeg"===t?"jpg":"application/bil16"===t?"bil":"application/bil32"===t?"bil":null},currentUrlSansFilePart:function(){for(var t=window.location.protocol,e=window.location.host,i=window.location.pathname,r=i.split("/"),n="",o=0,s=r.length;o<s-1;o++)r[o].length>0&&(n=n+"/"+r[o]);return t+"//"+e+n},worldwindlibLocation:function(){for(var t=document.getElementsByTagName("script"),e="/worldwind.",i=0;i<t.length;i++){var r=t[i].src.indexOf(e);if(r>=0)return t[i].src.substring(0,r)+"/"}return null},urlPath:function(t){if(!t)return"";for(var e=t.split("/"),i="",r=0,n=e.length;r<n;r++){var o=e[r];o&&0!==o.length&&o.indexOf(":")==-1&&"."!==o&&".."!==o&&"null"!==o&&"undefined"!==o&&(0!==i.length&&(i+="/"),i+=o)}return i},fillArray:function(t,e){if(t)for(var i=0,r=t.length;i<r;i++)t[i]=e},multiplyArray:function(t,e){if(t)for(var i=0,r=t.length;i<r;i++)t[i]*=e},jsonpCounter:0,jsonp:function(t,e,i){var r="gov_nasa_worldwind_jsonp_"+o.jsonpCounter++;window[r]=function(t){delete window[r],i(t)};var n=t+(t.indexOf("?")===-1?"?":"&");n+=e+"="+r;var s=document.createElement("script");s.async=!0,s.src=n;var a=document.getElementsByTagName("head")[0],l=function(){s.onload=void 0,s.onerror=void 0,a.removeChild(s)};s.onload=l,s.onerror=l,a.appendChild(s)},arrayEquals:function(t,e){return t.length==e.length&&t.every(function(t,i){return t===e[i]||t.equals&&t.equals(e[i])})},transformToBoolean:function(t){return 0!=t&&"0"!=t&&"false"!=t&&Boolean(t)},clone:function(t){var e,i={},r=Object.keys(t);for(e=0;e<r.length;e++)i[r[e]]=t[r[e]];return i},guid:function(){function t(){return Math.floor(65536*(1+Math.random())).toString(16).substring(1)}return t()+t()+"-"+t()+"-"+t()+"-"+t()+"-"+t()+t()+t()},date:function(t){return new Date(t)},startsWith:function(t,e,i){return i=i||0,t.substr(i,e.length)===e},endsWith:function(t,e,i){("number"!=typeof i||!isFinite(i)||Math.floor(i)!==i||i>t.length)&&(i=t.length),i-=e.length;var r=t.lastIndexOf(e,i);return r!==-1&&r===i},arrayIncludes:function(t,e){if(!t)return!1;for(var i=0,r=t.length;i<r;i++){var n=t[i];if(n===e||"number"==typeof n&&"number"==typeof e&&isNaN(n)&&isNaN(e))return!0}return!1}};return o}),i("formats/geotiff/GeoTiffReader",["../../error/AbstractError","../../error/ArgumentError","./GeoTiffConstants","./GeoTiffKeyEntry","./GeoTiffMetadata","./GeoTiffUtil","../../geom/Location","../../geom/Sector","../../util/Logger","../../util/proj4-src","./TiffConstants","./TiffIFDEntry","../../util/WWUtil"],function(t,e,i,r,n,o,s,a,l,h,u,c,d){"use strict";var p=function(t){if(!t)throw new e(l.logMessage(l.LEVEL_SEVERE,"GeoTiffReader","constructor","missingArrayBuffer"));this._isLittleEndian=!1,this._imageFileDirectories=[],this._geoTiffData=new DataView(t),this._metadata=new n,this.parse()};return Object.defineProperties(p.prototype,{isLittleEndian:{get:function(){return this._isLittleEndian}},imageFileDirectories:{get:function(){return this._imageFileDirectories}},geoTiffData:{get:function(){return this._geoTiffData}},metadata:{get:function(){return this._metadata}}}),p.retrieveFromUrl=function(t,i){if(!t)throw new e(l.logMessage(l.LEVEL_SEVERE,"GeoTiffReader","retrieveFromUrl","missingUrl"));if(!i)throw new e(l.logMessage(l.LEVEL_SEVERE,"GeoTiffReader","retrieveFromUrl","The specified callback is null or undefined."));var r=new XMLHttpRequest;r.open("GET",t,!0),r.responseType="arraybuffer",r.onreadystatechange=function(){if(4===r.readyState)if(200===r.status){var e=r.response;e&&i(new p(e),r)}else l.log(l.LEVEL_WARNING,"GeoTiff retrieval failed ("+r.statusText+"): "+t),i(null,r)}.bind(this),r.onerror=function(){l.log(l.LEVEL_WARNING,"GeoTiff retrieval failed: "+t),i(null,r)},r.ontimeout=function(){l.log(l.LEVEL_WARNING,"GeoTiff retrieval timed out: "+t),i(null,r)},r.send(null)},p.prototype.parse=function(){if(!this._imageFileDirectories.length){if(this.getEndianness(),!this.isTiffFileType())throw new t(l.logMessage(l.LEVEL_SEVERE,"GeoTiffReader","parse","invalidTiffFileType"));var e=o.getBytes(this.geoTiffData,4,4,this.isLittleEndian);this.parseImageFileDirectory(e),this.getMetadataFromImageFileDirectory(),this.parseGeoKeys(),this.setBBox()}},p.prototype.getEndianness=function(){var e=o.getBytes(this.geoTiffData,0,2,this.isLittleEndian);if(18761===e)this._isLittleEndian=!0;else{if(19789!==e)throw new t(l.logMessage(l.LEVEL_SEVERE,"GeoTiffReader","getEndianness","invalidByteOrderValue"));this._isLittleEndian=!1}},p.prototype.getImage=function(){return this.createImage()},p.prototype.getImageData=function(){return this.createTypedElevationArray()},p.prototype.isTiffFileType=function(){var t=o.getBytes(this.geoTiffData,2,2,this.isLittleEndian);return 42===t},p.prototype.isGeoTiff=function(){return!!this.getIFDByTag(i.Tag.GEO_KEY_DIRECTORY)},p.prototype.createImage=function(){var t=this.metadata.bitsPerSample,e=this.metadata.samplesPerPixel,i=this.metadata.photometricInterpretation,r=this.metadata.imageLength,n=this.metadata.imageWidth;if(this.metadata.colorMap)var o=this.metadata.colorMap,s=Math.pow(2,t[0]);var a=document.createElement("canvas");a.width=n,a.height=r;var l=a.getContext("2d");if(this.metadata.stripOffsets){var h=this.parseStrips(!1);if(this.metadata.rowsPerStrip)var u=this.metadata.rowsPerStrip;else var u=r;for(var c=h.length,d=0,p=u,f=r%u,g=0===f?u:f,m=0;m<c;m++){m+1===c&&(p=g);for(var y=h[m].length,E=d*m,v=0,_=0;_<y;v++)for(var b=0;b<n;b++,_++){var w=h[m][_];l.fillStyle=this.getFillStyle(w,i,t,e,o,s),l.fillRect(b,E+v,1,1)}d=u}}else if(this.metadata.tileOffsets)for(var S=this.parseTiles(!1),L=this.metadata.tileWidth,T=this.metadata.tileLength,A=Math.ceil(n/L),v=0;v<r;v++)for(var b=0;b<n;b++){var R=Math.floor(b/L),x=Math.floor(v/T),C=x*A+R,M=b%L,P=v%T,O=P*L+M,w=S[C][O];l.fillStyle=this.getFillStyle(w,i,t,e,o,s),l.fillRect(b,v,1,1)}return this._geoTiffData=null,a},p.prototype.getFillStyle=function(t,e,i,r,n,s){var a=0,h=0,c=0,d=1;switch(this.metadata.noData&&t[0]==this.metadata.noData&&(d=0),e){case u.PhotometricInterpretation.WHITE_IS_ZERO:var p=Math.pow(2,i)-1;t[0]=p-t[0];case u.PhotometricInterpretation.BLACK_IS_ZERO:a=h=c=o.clampColorSample(t[0],i[0]);break;case u.PhotometricInterpretation.RGB:if(a=o.clampColorSample(t[0],i[0]),h=o.clampColorSample(t[1],i[1]),c=o.clampColorSample(t[2],i[2]),4===r&&2===this.metadata.extraSamples[0]){var f=Math.pow(2,i[3]);d=t[3]/f}break;case u.PhotometricInterpretation.RGB_PALETTE:if(n){var g=t[0];a=o.clampColorSample(n[g],16),h=o.clampColorSample(n[s+g],16),c=o.clampColorSample(n[2*s+g],16)}break;case u.PhotometricInterpretation.TRANSPARENCY_MASK:l.log(l.LEVEL_WARNING,"Photometric interpretation not yet implemented: TRANSPARENCY_MASK");break;case u.PhotometricInterpretation.CMYK:l.log(l.LEVEL_WARNING,"Photometric interpretation not yet implemented: CMYK");break;case u.PhotometricInterpretation.Y_Cb_Cr:l.log(l.LEVEL_WARNING,"Photometric interpretation not yet implemented: Y_Cb_Cr");break;case u.PhotometricInterpretation.CIE_LAB:l.log(l.LEVEL_WARNING,"Photometric interpretation not yet implemented: CIE_LAB");break;default:l.log("Unknown photometric interpretation: "+e)}return o.getRGBAFillValue(a,h,c,d)},p.prototype.createTypedElevationArray=function(){var t,e=[],i=this.metadata.bitsPerSample[0];if(this.metadata.stripOffsets)for(var r=this.parseStrips(!0),n=0;n<r.length;n++)e=e.concat(r[n]);else if(this.metadata.tileOffsets)for(var o=this.parseTiles(!0),s=this.metadata.imageWidth,a=this.metadata.imageLength,l=this.metadata.tileWidth,h=this.metadata.tileLength,c=Math.ceil(s/l),d=0;d<a;d++)for(var p=0;p<s;p++){var f=Math.floor(p/l),g=Math.floor(d/h),m=g*c+f,y=p%l,E=d%h,v=E*l+y,_=o[m][v];e.push(_)}if(this.metadata.sampleFormat)var b=this.metadata.sampleFormat[0];else var b=u.SampleFormat.UNSIGNED;switch(i){case 8:t=b===u.SampleFormat.SIGNED?new Int8Array(e):new Uint8Array(e);break;case 16:t=b===u.SampleFormat.SIGNED?new Int16Array(e):new Uint16Array(e);break;case 32:t=b===u.SampleFormat.SIGNED?new Int32Array(e):b===u.SampleFormat.IEEE_FLOAT?new Float32Array(e):new Uint32Array(e);break;case 64:t=new Float64Array(e)}return t},p.prototype.parseStrips=function(t){var e=this.metadata.samplesPerPixel,i=this.metadata.bitsPerSample,r=this.metadata.stripOffsets,n=this.metadata.stripByteCounts,o=this.metadata.compression;if(this.metadata.sampleFormat)var s=this.metadata.sampleFormat;else var s=u.SampleFormat.UNSIGNED;for(var a=e*i[0],l=a/8,h=[],c=0;c<r.length;c++){var d=r[c],p=n[c];h[c]=this.parseBlock(t,o,l,p,d,i,s)}return h},p.prototype.parseBlock=function(t,e,i,r,n,s,a){var h=[];switch(e){case u.Compression.UNCOMPRESSED:for(var c=0,d=i;c<r;c+=d){for(var p=0,f=[];p<s.length;p++){var g=s[p]/8,m=p*g;f.push(o.getSampleBytes(this.geoTiffData,n+c+m,g,a[p],this.isLittleEndian))}t?h.push(f[0]):h.push(f)}break;case u.Compression.CCITT_1D:l.log(l.LEVEL_WARNING,"Compression type not yet implemented: CCITT_1D");break;case u.Compression.GROUP_3_FAX:l.log(l.LEVEL_WARNING,"Compression type not yet implemented: GROUP_3_FAX");break;case u.Compression.GROUP_4_FAX:l.log(l.LEVEL_WARNING,"Compression type not yet implemented: GROUP_4_FAX");break;case u.Compression.LZW:l.log(l.LEVEL_WARNING,"Compression type not yet implemented: LZW");break;case u.Compression.JPEG:l.log(l.LEVEL_WARNING,"Compression type not yet implemented: JPEG");break;case u.Compression.PACK_BITS:if(this.metadata.tileOffsets)var y=this.metadata.tileWidth,E=this.metadata.tileWidth,v=new ArrayBuffer(y*E*i);else var _=this.metadata.rowsPerStrip,b=this.metadata.imageWidth,v=new ArrayBuffer(_*b*i);for(var w=new DataView(v),S=!0,f=[],L=0,T=0,A=0,c=0;c<r;c+=1)if(S){L=1,T=1,S=!1;var R=this.geoTiffData.getInt8(n+c,this.isLittleEndian);R>=0&&R<=127?L=R+1:R>=-127&&R<=-1?T=-R+1:S=!0}else{for(var x=o.getBytes(this.geoTiffData,n+c,1,this.isLittleEndian),C=0;C<T;C++)w.setInt8(A,x),A++;L--,0===L&&(S=!0)}for(var c=0,d=i;c<v.byteLength;c+=d){for(var p=0,f=[];p<s.length;p++){var g=s[p]/8,m=p*g;f.push(o.getSampleBytes(w,c+m,g,a[p],this.isLittleEndian))}t?h.push(f[0]):h.push(f)}}return h},p.prototype.parseTiles=function(t){var e=this.metadata.samplesPerPixel,i=this.metadata.bitsPerSample,r=this.metadata.compression;if(this.metadata.sampleFormat)var n=this.metadata.sampleFormat;else{var n=new Array(e);d.fillArray(n,u.SampleFormat.UNSIGNED)}for(var o=e*i[0],s=o/8,a=this.metadata.tileWidth,l=this.metadata.tileLength,h=this.metadata.tileOffsets,c=this.metadata.tileByteCounts,p=this.metadata.imageLength,f=this.metadata.imageWidth,g=Math.ceil(f/a),m=Math.ceil(p/l),y=[],E=0;E<m;E++)for(var v=0;v<g;v++){var _=g*E+v,b=h[_],w=c[_];y[_]=this.parseBlock(t,r,s,w,b,i,n)}return y},p.prototype.geoTiffImageToPCS=function(t,i){if(null===t||void 0===t)throw new e(l.logMessage(l.LEVEL_SEVERE,"GeoTiffReader","geoTiffImageToPCS","missingXValue"));if(null===i||void 0===i)throw new e(l.logMessage(l.LEVEL_SEVERE,"GeoTiffReader","geoTiffImageToPCS","missingYValue"));var r=[t,i],n=this.metadata.modelTiepoint,o=this.metadata.modelPixelScale,a=this.metadata.modelTransformation,u=n?n.length:0,c=o?o.length:0,d=a?a.length:0;if(u>6&&0===c);else if(16===d){var p=t,f=i;t=p*a[0]+f*a[1]+a[3],i=p*a[4]+f*a[5]+a[7],r=[t,i]}else c<3||u<6?r=[t,i]:(t=(t-n[0])*o[0]+n[3],i=(i-n[1])*(-1*o[1])+n[4],r=[t,i]);return h.defs([["EPSG:26771","+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.9999749999999999 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs "],["EPSG:32633","+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs"]]),this.metadata.projectedCSType&&(r=h("EPSG:"+this.metadata.projectedCSType,"EPSG:4326",r)),new s(r[1],r[0])},p.prototype.setBBox=function(){var t=this.geoTiffImageToPCS(0,0),e=this.geoTiffImageToPCS(this.metadata.imageWidth,0),i=this.geoTiffImageToPCS(0,this.metadata.imageLength);this.geoTiffImageToPCS(this.metadata.imageWidth,this.metadata.imageLength);this.metadata.bbox=new a(i.latitude,t.latitude,t.longitude,e.longitude)},p.prototype.getMetadataFromImageFileDirectory=function(){for(var t=0;t<this.imageFileDirectories[0].length;t++)switch(this.imageFileDirectories[0][t].tag){case u.Tag.BITS_PER_SAMPLE:this.metadata.bitsPerSample=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.COLOR_MAP:this.metadata.colorMap=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.COMPRESSION:this.metadata.compression=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.EXTRA_SAMPLES:this.metadata.extraSamples=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.IMAGE_DESCRIPTION:this.metadata.imageDescription=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.IMAGE_LENGTH:this.metadata.imageLength=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.IMAGE_WIDTH:this.metadata.imageWidth=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.MAX_SAMPLE_VALUE:this.metadata.maxSampleValue=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.MIN_SAMPLE_VALUE:this.metadata.minSampleValue=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.ORIENTATION:this.metadata.orientation=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.PHOTOMETRIC_INTERPRETATION:this.metadata.photometricInterpretation=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.PLANAR_CONFIGURATION:this.metadata.planarConfiguration=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.ROWS_PER_STRIP:this.metadata.rowsPerStrip=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.RESOLUTION_UNIT:this.metadata.resolutionUnit=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.SAMPLES_PER_PIXEL:this.metadata.samplesPerPixel=this.imageFileDirectories[0][t].getIFDEntryValue()[0];break;case u.Tag.SAMPLE_FORMAT:this.metadata.sampleFormat=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.SOFTWARE:this.metadata.software=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.STRIP_BYTE_COUNTS:this.metadata.stripByteCounts=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.STRIP_OFFSETS:this.metadata.stripOffsets=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.TILE_BYTE_COUNTS:this.metadata.tileByteCounts=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.TILE_OFFSETS:this.metadata.tileOffsets=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.TILE_LENGTH:this.metadata.tileLength=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.TILE_WIDTH:this.metadata.tileWidth=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.X_RESOLUTION:this.metadata.xResolution=this.imageFileDirectories[0][t].getIFDEntryValue();break;case u.Tag.Y_RESOLUTION:this.metadata.tileWidth=this.imageFileDirectories[0][t].getIFDEntryValue();break;case i.Tag.GEO_ASCII_PARAMS:this.metadata.geoAsciiParams=this.imageFileDirectories[0][t].getIFDEntryValue();break;case i.Tag.GEO_DOUBLE_PARAMS:this.metadata.geoDubleParams=this.imageFileDirectories[0][t].getIFDEntryValue();break;case i.Tag.GEO_KEY_DIRECTORY:this.metadata.geoKeyDirectory=this.imageFileDirectories[0][t].getIFDEntryValue();break;case i.Tag.MODEL_PIXEL_SCALE:this.metadata.modelPixelScale=this.imageFileDirectories[0][t].getIFDEntryValue();break;case i.Tag.MODEL_TIEPOINT:this.metadata.modelTiepoint=this.imageFileDirectories[0][t].getIFDEntryValue();break;case i.Tag.GDAL_METADATA:this.metadata.metaData=this.imageFileDirectories[0][t].getIFDEntryValue();break;case i.Tag.GDAL_NODATA:this.metadata.noData=this.imageFileDirectories[0][t].getIFDEntryValue();break;default:l.log(l.LEVEL_WARNING,"Ignored GeoTiff tag: "+this.imageFileDirectories[0][t].tag)}},p.prototype.parseGeoKeys=function(){if(!this.isGeoTiff())throw new t(l.logMessage(l.LEVEL_SEVERE,"GeoTiffReader","parse","invalidGeoTiffFile"));var e=this.metadata.geoKeyDirectory;if(!e)throw new t(l.logMessage(l.LEVEL_SEVERE,"GeoTiffReader","parseGeoKeys","missingGeoKeyDirectoryTag"));for(var n=(e[0],e[1],e[2],e[3]),o=0;o<n;o++){var s=e[4+4*o],a=e[5+4*o],h=e[6+4*o],u=e[7+4*o];switch(s){case i.Key.GTModelTypeGeoKey:this.metadata.gtModelTypeGeoKey=new r(s,a,h,u).getGeoKeyValue(this.metadata.geoDoubleParams,this.metadata.geoAsciiParams);break;case i.Key.GTRasterTypeGeoKey:this.metadata.gtRasterTypeGeoKey=new r(s,a,h,u).getGeoKeyValue(this.metadata.geoDoubleParams,this.metadata.geoAsciiParams);break;case i.Key.GTCitationGeoKey:this.metadata.gtCitationGeoKey=new r(s,a,h,u).getGeoKeyValue(this.metadata.geoDoubleParams,this.metadata.geoAsciiParams);break;case i.Key.GeographicTypeGeoKey:this.metadata.geographicTypeGeoKey=new r(s,a,h,u).getGeoKeyValue(this.metadata.geoDoubleParams,this.metadata.geoAsciiParams);break;case i.Key.GeogCitationGeoKey:this.metadata.geogCitationGeoKey=new r(s,a,h,u).getGeoKeyValue(this.metadata.geoDoubleParams,this.metadata.geoAsciiParams);break;case i.Key.GeogAngularUnitsGeoKey:this.metadata.geogAngularUnitsGeoKey=new r(s,a,h,u).getGeoKeyValue(this.metadata.geoDoubleParams,this.metadata.geoAsciiParams);break;case i.Key.GeogAngularUnitSizeGeoKey:this.metadata.geogAngularUnitSizeGeoKey=new r(s,a,h,u).getGeoKeyValue(this.metadata.geoDoubleParams,this.metadata.geoAsciiParams);break;case i.Key.GeogSemiMajorAxisGeoKey:this.metadata.geogSemiMajorAxisGeoKey=new r(s,a,h,u).getGeoKeyValue(this.metadata.geoDoubleParams,this.metadata.geoAsciiParams);break;case i.Key.GeogInvFlatteningGeoKey:this.metadata.geogInvFlatteningGeoKey=new r(s,a,h,u).getGeoKeyValue(this.metadata.geoDoubleParams,this.metadata.geoAsciiParams);break;case i.Key.ProjectedCSTypeGeoKey:this.metadata.projectedCSType=new r(s,a,h,u).getGeoKeyValue(this.metadata.geoDoubleParams,this.metadata.geoAsciiParams);break;case i.Key.ProjLinearUnitsGeoKey:this.metadata.projLinearUnits=new r(s,a,h,u).getGeoKeyValue(this.metadata.geoDoubleParams,this.metadata.geoAsciiParams);break;default:l.log(l.LEVEL_WARNING,"Ignored GeoTiff key: "+s)}}},p.prototype.parseImageFileDirectory=function(t){if(!t)throw new e(l.logMessage(l.LEVEL_SEVERE,"GeoTiffReader","parseImageFileDirectory","missingOffset"));for(var i=o.getBytes(this.geoTiffData,t,2,this.isLittleEndian),r=[],n=t+2,s=0;s<i;n+=12,s++){var a=o.getBytes(this.geoTiffData,n,2,this.isLittleEndian),h=o.getBytes(this.geoTiffData,n+2,2,this.isLittleEndian),u=o.getBytes(this.geoTiffData,n+4,4,this.isLittleEndian),d=o.getBytes(this.geoTiffData,n+8,4,this.isLittleEndian);r.push(new c(a,h,u,d,this.geoTiffData,this.isLittleEndian))}this._imageFileDirectories.push(r);var p=o.getBytes(this.geoTiffData,n,4,this.isLittleEndian);0!==p&&this.parseImageFileDirectory(p)},p.prototype.getIFDByTag=function(t){if(!t)throw new e(l.logMessage(l.LEVEL_SEVERE,"GeoTiffReader","getIFDByTag","missingTag"));for(var i=0;i<this.imageFileDirectories[0].length;i++)if(this.imageFileDirectories[0][i].tag===t)return this.imageFileDirectories[0][i];return null},p}),i("util/Level",["../geom/Angle","../error/ArgumentError","../geom/Location","../util/Logger"],function(t,e,i,r){"use strict";var n=function(i,n,o){if(!n)throw new e(r.logMessage(r.LEVEL_SEVERE,"Level","constructor","The specified tile delta is null or undefined"));if(!o)throw new e(r.logMessage(r.LEVEL_SEVERE,"Level","constructor","The specified parent level set is null or undefined"));this.levelNumber=i,this.tileDelta=n,this.parent=o,this.texelSize=n.latitude*t.DEGREES_TO_RADIANS/o.tileHeight,this.tileWidth=o.tileWidth,this.tileHeight=o.tileHeight,this.sector=o.sector};return n.prototype.isFirstLevel=function(){return this.parent.firstLevel()==this},n.prototype.isLastLevel=function(){return this.parent.lastLevel()==this},n.prototype.previousLevel=function(){return this.parent.level(this.levelNumber-1)},n.prototype.nextLevel=function(){return this.parent.level(this.levelNumber+1)},n.prototype.compare=function(t){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"Level","compare","The specified level is null or undefined"));return this.levelNumber<t.levelNumber?-1:this.levelNumber>t.levelNumber?1:0},n}),i("util/LevelSet",["../error/ArgumentError","../util/Level","../geom/Location","../util/Logger"],function(t,e,i,r){"use strict";var n=function(n,o,s,a,l){if(!n)throw new t(r.logMessage(r.LEVEL_SEVERE,"LevelSet","constructor","missingSector"));if(!o)throw new t(r.logMessage(r.LEVEL_SEVERE,"LevelSet","constructor","The specified level zero delta is null or undefined"));if(o.latitude<=0||o.longitude<=0)throw new t(r.logMessage(r.LEVEL_SEVERE,"LevelSet","constructor","The specified level zero delta is less than or equal to zero."));if(s<1)throw new t(r.logMessage(r.LEVEL_SEVERE,"LevelSet","constructor","The specified number of levels is less than one."));if(a<1||l<1)throw new t(r.logMessage(r.LEVEL_SEVERE,"LevelSet","constructor","The specified tile width or tile height is less than one."));this.sector=n,this.levelZeroDelta=o,this.numLevels=s,this.tileWidth=a,this.tileHeight=l,this.levels=[];for(var h=0;h<s;h+=1){var u=Math.pow(2,h),c=o.latitude/u,d=o.longitude/u,p=new i(c,d),f=new e(h,p,this);this.levels[h]=f}};return n.numLevelsForResolution=function(e,i){if(!e||!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"LevelSet","numLevelsForResolution","missingResolution"));var n=Math.log(e/i)/Math.log(2);return n<0&&(n=0),n+1},n.prototype.level=function(t){return t<0||t>=this.levels.length?null:this.levels[t]},n.prototype.levelForTexelSize=function(t){var e=this.lastLevel();if(e.texelSize>=t)return e;for(var i=0,r=this.levels.length;i<r;i+=1){var n=this.levels[i];if(n.texelSize<=t)return n}return e},n.prototype.firstLevel=function(){return this.levels[0]},n.prototype.lastLevel=function(){return this.levels[this.levels.length-1]},n}),i("cache/MemoryCache",["../error/ArgumentError","../util/Logger"],function(t,e){"use strict";var i=function(i,r){if(!i||i<1)throw new t(e.logMessage(e.LEVEL_SEVERE,"MemoryCache","constructor","The specified capacity is undefined, zero or negative"));if(!r||r>=i||r<0)throw new t(e.logMessage(e.LEVEL_SEVERE,"MemoryCache","constructor","The specified low-water value is undefined, greater than or equal to the capacity, or less than 1"));this._capacity=i,this._lowWater=r,this.usedCapacity=0,this.freeCapacity=i,this.entries={},this.listeners=[]};return Object.defineProperties(i.prototype,{capacity:{get:function(){return this._capacity},set:function(i){if(!i||i<1)throw new t(e.logMessage(e.LEVEL_SEVERE,"MemoryCache","capacity","Specified cache capacity is undefined, 0 or negative."));var r=this._capacity;this._capacity=i,this._capacity<=this.lowWater&&(this._lowWater=.85*this._capacity),this._capacity<r&&this.makeSpace(0)}},lowWater:{get:function(){return this._lowWater},set:function(i){if(!i||i>=this._capacity||i<0)throw new t(e.logMessage(e.LEVEL_SEVERE,"MemoryCache","lowWater","Specified cache low-water value is undefined, negative or not less than the current capacity."));this._lowWater=i}}}),i.prototype.entryForKey=function(t){if(!t)return null;var e=this.entries[t];return e?(e.lastUsed=Date.now(),e.entry):null},i.prototype.putEntry=function(i,r,n){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"MemoryCache","putEntry","missingKey."));if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"MemoryCache","putEntry","missingEntry."));if(n<1)throw new t(e.logMessage(e.LEVEL_SEVERE,"MemoryCache","putEntry","The specified entry size is less than 1."));var o,s=this.entries[i];s&&this.removeEntry(i),this.usedCapacity+n>this._capacity&&this.makeSpace(n),this.usedCapacity+=n,this.freeCapacity=this._capacity-this.usedCapacity,o={key:i,entry:r,size:n,lastUsed:Date.now(),agingFactor:1},this.entries[i]=o},i.prototype.clear=function(t){if(t)for(var e in this.entries)this.entries.hasOwnProperty(e)&&this.removeCacheEntry(e);this.entries={},this.freeCapacity=this._capacity,this.usedCapacity=0},i.prototype.removeEntry=function(t){if(t){var e=this.entries[t];e&&this.removeCacheEntry(e)}},i.prototype.setEntryAgingFactor=function(t,e){if(t){var i=this.entries[t];i&&(i.agingFactor=e)}},i.prototype.removeCacheEntry=function(t){delete this.entries[t.key],this.usedCapacity-=t.size,this.freeCapacity=this._capacity-this.usedCapacity;for(var e=0,i=this.listeners.length;e<i;e++)try{this.listeners[e].entryRemoved(t.key,t.entry)}catch(i){this.listeners[e].removalError(i,t.key,t.entry)}},i.prototype.containsKey=function(t){return t&&this.entries[t]},i.prototype.addCacheListener=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"MemoryCache","addCacheListener","missingListener"));if("function"!=typeof i.entryRemoved||"function"!=typeof i.removalError)throw new t(e.logMessage(e.LEVEL_SEVERE,"MemoryCache","addCacheListener","The specified listener does not implement the required functions."));this.listeners.push(i)},i.prototype.removeCacheListener=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"MemoryCache","removeCacheListener","missingListener"));var r=this.listeners.indexOf(i);r>-1&&this.listeners.splice(r,1)},i.prototype.makeSpace=function(t){var e=[],i=Date.now();for(var r in this.entries)this.entries.hasOwnProperty(r)&&e.push(this.entries[r]);e.sort(function(t,e){var r=(i-t.lastUsed)*t.agingFactor,n=(i-e.lastUsed)*e.agingFactor;return n-r});for(var n=0,o=e.length;n<o&&(this.usedCapacity>this._lowWater||this.freeCapacity<t);n++)this.removeCacheEntry(e[n])},i}),i("shaders/BasicProgram",["../error/ArgumentError","../util/Color","../shaders/GpuProgram","../util/Logger"],function(t,e,i,r){
"use strict";var n=function(t){var e="attribute vec4 vertexPoint;\nuniform mat4 mvpMatrix;\nvoid main() {gl_Position = mvpMatrix * vertexPoint;}",r="precision mediump float;\nuniform vec4 color;\nvoid main() {gl_FragColor = color;}";i.call(this,t,e,r),this.vertexPointLocation=this.attributeLocation(t,"vertexPoint"),this.mvpMatrixLocation=this.uniformLocation(t,"mvpMatrix"),this.colorLocation=this.uniformLocation(t,"color")};return n.key="WorldWindGpuBasicProgram",n.prototype=Object.create(i.prototype),n.prototype.loadModelviewProjection=function(e,i){if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"BasicProgram","loadModelviewProjection","missingMatrix"));this.loadUniformMatrix(e,i,this.mvpMatrixLocation)},n.prototype.loadColor=function(e,i){if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"BasicProgram","loadColor","missingColor"));this.loadUniformColor(e,i,this.colorLocation)},n.prototype.loadColorComponents=function(t,e,i,r,n){this.loadUniformColorComponents(t,e,i,r,n,this.colorLocation)},n}),i("geom/Frustum",["../error/ArgumentError","../geom/Matrix","../geom/Plane","../util/Logger"],function(t,e,i,r){"use strict";var n=function(e,i,n,o,s,a){if(!(e&&i&&n&&o&&s&&a))throw new t(r.logMessage(r.LEVEL_SEVERE,"Frustum","constructor","missingPlane"));this._left=e,this._right=i,this._bottom=n,this._top=o,this._near=s,this._far=a,this._planes=[this._left,this._right,this._top,this._bottom,this._near,this._far]};return Object.defineProperties(n.prototype,{left:{get:function(){return this._left}},right:{get:function(){return this._right}},bottom:{get:function(){return this._bottom}},top:{get:function(){return this._top}},near:{get:function(){return this._near}},far:{get:function(){return this._far}}}),n.prototype.transformByMatrix=function(e){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"Frustum","transformByMatrix","missingMatrix"));return this._left.transformByMatrix(e),this._right.transformByMatrix(e),this._bottom.transformByMatrix(e),this._top.transformByMatrix(e),this._near.transformByMatrix(e),this._far.transformByMatrix(e),this},n.prototype.normalize=function(){return this._left.normalize(),this._right.normalize(),this._bottom.normalize(),this._top.normalize(),this._near.normalize(),this._far.normalize(),this},n.unitFrustum=function(){return new n(new i(1,0,0,1),new i(-1,0,0,1),new i(0,1,1,1),new i(0,-1,0,1),new i(0,0,-1,1),new i(0,0,1,1))},n.fromProjectionMatrix=function(e){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"Frustum","fromProjectionMatrix","missingMatrix"));var o,s,a,l,h,u,c,d,p,f,g;return o=e[12]+e[0],s=e[13]+e[1],a=e[14]+e[2],l=e[15]+e[3],h=Math.sqrt(o*o+s*s+a*a),u=new i(o/h,s/h,a/h,l/h),o=e[12]-e[0],s=e[13]-e[1],a=e[14]-e[2],l=e[15]-e[3],h=Math.sqrt(o*o+s*s+a*a),c=new i(o/h,s/h,a/h,l/h),o=e[12]+e[4],s=e[13]+e[5],a=e[14]+e[6],l=e[15]+e[7],h=Math.sqrt(o*o+s*s+a*a),p=new i(o/h,s/h,a/h,l/h),o=e[12]-e[4],s=e[13]-e[5],a=e[14]-e[6],l=e[15]-e[7],h=Math.sqrt(o*o+s*s+a*a),d=new i(o/h,s/h,a/h,l/h),o=e[12]+e[8],s=e[13]+e[9],a=e[14]+e[10],l=e[15]+e[11],h=Math.sqrt(o*o+s*s+a*a),f=new i(o/h,s/h,a/h,l/h),o=e[12]-e[8],s=e[13]-e[9],a=e[14]-e[10],l=e[15]-e[11],h=Math.sqrt(o*o+s*s+a*a),g=new i(o/h,s/h,a/h,l/h),new n(u,c,p,d,f,g)},n.prototype.containsPoint=function(e){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"Frustum","containsPoint","missingPoint"));return!(this._far.dot(e)<=0)&&(!(this._left.dot(e)<=0)&&(!(this._right.dot(e)<=0)&&(!(this._top.dot(e)<=0)&&(!(this._bottom.dot(e)<=0)&&!(this._near.dot(e)<=0)))))},n.prototype.intersectsSegment=function(e,i){if(!e||!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"Frustum","containsPoint","missingPoint"));if(this.containsPoint(e)||this.containsPoint(i))return!0;if(e.equals(i))return!1;for(var n=0,o=this._planes.length;n<o;n++){if(this._planes[n].onSameSide(e,i)<0)return!1;if(null!=this._planes[n].clip(e,i))return!0}return!1},n}),i("error/NotYetImplementedError",["../error/AbstractError"],function(t){"use strict";var e=function(e){t.call(this,"NotYetImplementedError",e);var i;try{throw new Error}catch(t){i=t.stack}this.stack=i};return e.prototype=Object.create(t.prototype),e}),i("geom/BoundingBox",["../error/ArgumentError","../shaders/BasicProgram","../geom/Frustum","../util/Logger","../geom/Matrix","../error/NotYetImplementedError","../geom/Plane","../geom/Sector","../geom/Vec3","../util/WWMath","../util/WWUtil"],function(t,e,i,r,n,o,s,a,l,h,u){"use strict";var c=function(){this.center=new l(0,0,0),this.bottomCenter=new l(-.5,0,0),this.topCenter=new l(.5,0,0),this.r=new l(1,0,0),this.s=new l(0,1,0),this.t=new l(0,0,1),this.radius=Math.sqrt(3),this.tmp1=new l(0,0,0),this.tmp2=new l(0,0,0),this.tmp3=new l(0,0,0),this.scratchElevations=new Float64Array(9),this.scratchPoints=new Float64Array(3*this.scratchElevations.length)};return c.scratchMatrix=n.fromIdentity(),c.prototype.getCorners=function(){var t=new l(this.s[0],this.s[1],this.s[2]),e=new l(this.t[0],this.t[1],this.t[2]),i=new l(this.s[0],this.s[1],this.s[2]),r=new l(this.s[0],this.s[1],this.s[2]);t.add(this.t).multiply(-.5),e.subtract(this.s).multiply(.5),i.add(this.t).multiply(.5),r.subtract(this.t).multiply(.5);for(var n=[],o=0;o<4;o++)n.push(new l(this.bottomCenter[0],this.bottomCenter[1],this.bottomCenter[2]));for(o=0;o<4;o++)n.push(new l(this.topCenter[0],this.topCenter[1],this.topCenter[2]));return n[0].add(t),n[1].add(e),n[2].add(i),n[3].add(r),n[4].add(t),n[5].add(e),n[6].add(i),n[7].add(r),n},c.prototype.setToPoints=function(e){if(!e||e.length<3)throw new t(r.logMessage(r.LEVEL_SEVERE,"BoundingBox","setToPoints","missingArray"));var i,o,s,a,h,u,c,d,p,f,g,m,y,E,v,_=+Number.MAX_VALUE,b=-Number.MAX_VALUE,w=+Number.MAX_VALUE,S=-Number.MAX_VALUE,L=+Number.MAX_VALUE,T=-Number.MAX_VALUE,A=this.r,R=this.s,x=this.t,C=new l(0,0,0);n.principalAxesFromPoints(e,A,R,x);for(var M=0,P=e.length/3;M<P;M++)C[0]=e[3*M],C[1]=e[3*M+1],C[2]=e[3*M+2],i=C.dot(A),_>i&&(_=i),b<i&&(b=i),o=C.dot(R),w>o&&(w=o),S<o&&(S=o),s=C.dot(x),L>s&&(L=s),T<s&&(T=s);return b===_&&(b=_+1),S===w&&(S=w+1),T===L&&(T=L+1),a=b-_,h=S-w,u=T-L,c=b+_,d=S+w,p=T+L,f=.5*A[0]*a,g=.5*A[1]*a,m=.5*A[2]*a,y=.5*(A[0]*c+R[0]*d+x[0]*p),E=.5*(A[1]*c+R[1]*d+x[1]*p),v=.5*(A[2]*c+R[2]*d+x[2]*p),this.center[0]=y,this.center[1]=E,this.center[2]=v,this.topCenter[0]=y+f,this.topCenter[1]=E+g,this.topCenter[2]=v+m,this.bottomCenter[0]=y-f,this.bottomCenter[1]=E-g,this.bottomCenter[2]=v-m,A.multiply(a),R.multiply(h),x.multiply(u),this.radius=.5*Math.sqrt(a*a+h*h+u*u),this},c.prototype.setToVec3Points=function(e){if(!e||0===e.length)throw new t(r.logMessage(r.LEVEL_SEVERE,"BoundingBox","setToVec3Points","missingArray"));for(var i=new Float32Array(3*e.length),n=0;n<e.length;n++)for(var o=e[n],s=0;s<3;s++)i[3*n+s]=o[s];return this.setToPoints(i)},c.prototype.setToSector=function(e,i,n,o){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"BoundingBox","setToSector","missingSector"));if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"BoundingBox","setToSector","missingGlobe"));var s=this.scratchElevations,a=this.scratchPoints;u.fillArray(s,o),s[0]=s[2]=s[6]=s[8]=n,i.computePointsForGrid(e,3,3,s,l.ZERO,a);var c=12;this.tmp1.set(a[c],a[c+1],a[c+2]),h.localCoordinateAxesAtPoint(this.tmp1,i,this.r,this.s,this.t);for(var d=[Number.POSITIVE_INFINITY,Number.NEGATIVE_INFINITY],p=[Number.POSITIVE_INFINITY,Number.NEGATIVE_INFINITY],f=[Number.POSITIVE_INFINITY,Number.NEGATIVE_INFINITY],g=0,m=a.length;g<m;g+=3)this.tmp1.set(a[g],a[g+1],a[g+2]),this.adjustExtremes(this.r,d,this.s,p,this.t,f,this.tmp1);e.deltaLongitude()>180&&(i.computePointFromPosition(e.centroidLatitude(),e.centroidLongitude()+90,o,this.tmp1),i.computePointFromPosition(e.centroidLatitude(),e.centroidLongitude()-90,o,this.tmp2),this.adjustExtremes(this.r,d,this.s,p,this.t,f,this.tmp1),this.adjustExtremes(this.r,d,this.s,p,this.t,f,this.tmp2)),d[1]-d[0]<p[1]-p[0]&&this.swapAxes(this.r,d,this.s,p),p[1]-p[0]<f[1]-f[0]&&this.swapAxes(this.s,p,this.t,f),d[1]-d[0]<p[1]-p[0]&&this.swapAxes(this.r,d,this.s,p);var y=d[1]-d[0],E=p[1]-p[0],v=f[1]-f[0],_=d[1]+d[0],b=p[1]+p[0],w=f[1]+f[0],S=.5*(this.r[0]*_+this.s[0]*b+this.t[0]*w),L=.5*(this.r[1]*_+this.s[1]*b+this.t[1]*w),T=.5*(this.r[2]*_+this.s[2]*b+this.t[2]*w),A=.5*this.r[0]*y,R=.5*this.r[1]*y,x=.5*this.r[2]*y;return this.center.set(S,L,T),this.topCenter.set(S+A,L+R,T+x),this.bottomCenter.set(S-A,L-R,T-x),this.r.multiply(y),this.s.multiply(E),this.t.multiply(v),this.radius=.5*Math.sqrt(y*y+E*E+v*v),this},c.prototype.translate=function(e){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"BoundingBox","translate","missingVector"));return this.bottomCenter.add(e),this.topCenter.add(e),this.center.add(e),this},c.prototype.distanceTo=function(e){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"BoundingBox","distanceTo","missingPoint"));var i=this.center.distanceTo(e)-this.radius;return i>=0?i:-i},c.prototype.effectiveRadius=function(e){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"BoundingBox","effectiveRadius","missingPlane"));var i=e.normal;return.5*(h.fabs(this.r.dot(i))+h.fabs(this.s.dot(i))+h.fabs(this.t.dot(i)))},c.prototype.intersectsFrustum=function(e){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"BoundingBox","intersectsFrustum","missingFrustum"));return this.tmp1.copy(this.bottomCenter),this.tmp2.copy(this.topCenter),!(this.intersectionPoint(e.near)<0)&&(!(this.intersectionPoint(e.far)<0)&&(!(this.intersectionPoint(e.left)<0)&&(!(this.intersectionPoint(e.right)<0)&&(!(this.intersectionPoint(e.top)<0)&&!(this.intersectionPoint(e.bottom)<0)))))},c.prototype.intersectionPoint=function(t){var e=t.normal,i=.5*(Math.abs(this.s.dot(e))+Math.abs(this.t.dot(e)));return this.intersectsAt(t,i,this.tmp1,this.tmp2)},c.prototype.intersectsAt=function(t,e,i,r){var n=t.dot(i),o=n<=-e,s=t.dot(r),a=s<=-e;if(o&&a)return-1;if(o==a)return 0;this.tmp3.copy(i),this.tmp3.subtract(r);var l=(e+n)/t.normal.dot(this.tmp3);return this.tmp3.copy(r),this.tmp3.subtract(i),this.tmp3.multiply(l),this.tmp3.add(i),o?i.copy(this.tmp3):r.copy(this.tmp3),l},c.prototype.adjustExtremes=function(t,e,i,r,n,o,s){var a=s.dot(t);e[0]>a&&(e[0]=a),e[1]<a&&(e[1]=a);var l=s.dot(i);r[0]>l&&(r[0]=l),r[1]<l&&(r[1]=l);var h=s.dot(n);o[0]>h&&(o[0]=h),o[1]<h&&(o[1]=h)},c.prototype.swapAxes=function(t,e,i,r){t.swap(i);var n=e[0];e[0]=r[0],r[0]=n,n=e[1],e[1]=r[1],r[1]=n},c.prototype.render=function(t){var i=t.currentGlContext,r=c.scratchMatrix,n=t.findAndBindProgram(e);try{r.copy(t.modelviewProjection),r.multiply(this.r[0],this.s[0],this.t[0],this.center[0],this.r[1],this.s[1],this.t[1],this.center[1],this.r[2],this.s[2],this.t[2],this.center[2],0,0,0,1),r.multiplyByTranslation(-.5,-.5,-.5),n.loadModelviewProjection(i,r),i.disable(i.CULL_FACE),i.bindBuffer(i.ARRAY_BUFFER,t.unitCubeBuffer()),i.bindBuffer(i.ELEMENT_ARRAY_BUFFER,t.unitCubeElements()),i.enableVertexAttribArray(n.vertexPointLocation),i.vertexAttribPointer(n.vertexPointLocation,3,i.FLOAT,!1,0,0),n.loadColorComponents(i,0,1,0,.6),i.drawElements(i.LINES,24,i.UNSIGNED_SHORT,72),n.loadColorComponents(i,1,1,1,.3),i.drawElements(i.TRIANGLES,36,i.UNSIGNED_SHORT,0)}finally{i.enable(i.CULL_FACE),i.bindBuffer(i.ARRAY_BUFFER,null),i.bindBuffer(i.ELEMENT_ARRAY_BUFFER,null)}},c}),i("util/Tile",["../error/ArgumentError","../geom/BoundingBox","../util/Logger","../geom/Sector","../geom/Vec3","../util/WWUtil"],function(t,e,i,r,n,o){"use strict";var s=function(e,r,n,o){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","constructor","missingSector"));if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","constructor","The specified level is null or undefined."));if(n<0||o<0)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","constructor","The specified row or column is less than zero."));this.sector=e,this.level=r,this.row=n,this.column=o,this.tileWidth=r.tileWidth,this.tileHeight=r.tileHeight,this.texelSize=r.texelSize,this.tileKey=s.computeTileKey(r.levelNumber,n,o),this.extent=null,this.referencePoint=null,this.opacity=1,this.samplePoints=null,this.sampleElevations=null,this.updateTimestamp=null,this.updateVerticalExaggeration=null,this.updateGlobeStateKey=null};return s.prototype.isEqual=function(t){return!!t&&(!!t.tileKey&&this.tileKey==t.tileKey)},s.prototype.size=function(){return 828},s.prototype.distanceTo=function(e){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","distanceTo","missingVector"));for(var r,n,o,s=e[0],a=e[1],l=e[2],h=this.samplePoints,u=Number.POSITIVE_INFINITY,c=0,d=h.length;c<d;c+=3)r=s-h[c],n=a-h[c+1],o=l-h[c+2],u=Math.min(u,r*r+n*n+o*o);return Math.sqrt(u)},s.prototype.subdivide=function(e,n){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","subdivide","The specified level is null or undefined."));if(!n)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","subdivide","The specified tile factory is null or undefined."));var o,s,a,l=this.sector.minLatitude,h=this.sector.maxLatitude,u=this.sector.centroidLatitude(),c=this.sector.minLongitude,d=this.sector.maxLongitude,p=this.sector.centroidLongitude(),f=[];return o=2*this.row,s=2*this.column,a=new r(l,u,c,p),f.push(n.createTile(a,e,o,s)),o=2*this.row,s=2*this.column+1,a=new r(l,u,p,d),f.push(n.createTile(a,e,o,s)),o=2*this.row+1,s=2*this.column,a=new r(u,h,c,p),f.push(n.createTile(a,e,o,s)),o=2*this.row+1,s=2*this.column+1,a=new r(u,h,p,d),f.push(n.createTile(a,e,o,s)),f},s.prototype.subdivideToCache=function(e,r,n){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","subdivideToCache","The specified level is null or undefined."));if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","subdivideToCache","The specified tile factory is null or undefined."));var o=n?n.entryForKey(this.tileKey):null;return o||(o=this.subdivide(e,r),o&&n&&n.putEntry(this.tileKey,o,4*o[0].size())),o},s.prototype.mustSubdivide=function(t,e){var i=t.globe.equatorialRadius*this.texelSize,r=this.distanceTo(t.eyePoint),n=t.pixelSizeAtDistance(r);return i>e*n},s.prototype.update=function(t){var e=t.globe.elevationTimestamp(),i=t.verticalExaggeration,r=t.globeStateKey;this.updateTimestamp==e&&this.updateVerticalExaggeration==i&&this.updateGlobeStateKey==r||(this.doUpdate(t),t.frameStatistics.incrementTileUpdateCount(1),this.updateTimestamp=e,this.updateVerticalExaggeration=i,this.updateGlobeStateKey=r)},s.prototype.doUpdate=function(t){var i=t.globe,r=t.verticalExaggeration,s=i.minAndMaxElevationsForSector(this.sector),a=s[0]*r,l=s[1]*r;a===l&&(a=l+10),this.extent||(this.extent=new e),this.extent.setToSector(this.sector,i,a,l),this.samplePoints||(this.sampleElevations=new Float64Array(9),this.samplePoints=new Float64Array(3*this.sampleElevations.length)),o.fillArray(this.sampleElevations,.5*(a+l)),i.computePointsForGrid(this.sector,3,3,this.sampleElevations,n.ZERO,this.samplePoints),this.referencePoint||(this.referencePoint=new n(0,0,0)),i.computePointFromPosition(this.sector.centroidLatitude(),this.sector.centroidLongitude(),0,this.referencePoint)},s.computeTileKey=function(t,e,i){return t+"."+e+"."+i},s.computeRow=function(t,e){var i=Math.floor((e+90)/t);return 90==e&&(i-=1),i},s.computeColumn=function(t,e){var i=Math.floor((e+180)/t);return 180==e&&(i-=1),i},s.computeLastRow=function(t,e){var i=Math.ceil((e+90)/t-1);return e+90<t&&(i=0),i},s.computeLastColumn=function(t,e){var i=Math.ceil((e+180)/t-1);return e+180<t&&(i=0),i},s.computeSector=function(e,n,o){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","computeSector","missingLevel"));if(n<0||o<0)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","computeSector","The specified row or column is less than zero."));var s=e.tileDelta.latitude,a=e.tileDelta.longitude,l=-90+n*s,h=-180+o*a,u=l+s,c=h+a;return new r(l,u,h,c)},s.createTilesForLevel=function(e,n,o){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","createTilesForLevel","missingLevel"));if(!n)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","createTilesForLevel","The specified tile factory is null or undefined"));if(!o)throw new t(i.logMessage(i.LEVEL_SEVERE,"Tile","createTilesForLevel","missingResult"));for(var a,l,h,u=e.tileDelta.latitude,c=e.tileDelta.longitude,d=e.sector,p=s.computeRow(u,d.minLatitude),f=s.computeRow(u,d.maxLatitude),g=s.computeColumn(c,d.minLongitude),m=s.computeColumn(c,d.maxLongitude),y=-90+p*u,E=-180+g*c,v=y,_=p;_<=f;_+=1){l=v+u,a=E;for(var b=g;b<=m;b+=1){h=a+c;var w=new r(v,l,a,h),S=n.createTile(w,e,_,b);o.push(S),a=h}v=l}},s}),i("globe/TiledElevationCoverage",["../util/AbsentResourceList","../geom/Angle","../error/ArgumentError","../globe/ElevationCoverage","../globe/ElevationImage","../formats/geotiff/GeoTiffReader","../util/LevelSet","../geom/Location","../util/Logger","../cache/MemoryCache","../geom/Sector","../util/Tile","../util/WWMath","../util/WWUtil"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p){"use strict";var f=function(e){if(!e)throw new i(l.logMessage(l.LEVEL_SEVERE,"TiledElevationCoverage","constructor","missingConfig"));if(!e.coverageSector)throw new i(l.logMessage(l.LEVEL_SEVERE,"TiledElevationCoverage","constructor","missingSector"));if(!e.resolution)throw new i(l.logMessage(l.LEVEL_SEVERE,"TiledElevationCoverage","constructor","missingResolution"));if(!e.retrievalImageFormat)throw new i(l.logMessage(l.LEVEL_SEVERE,"TiledElevationCoverage","constructor","missingImageFormat"));r.call(this,e.resolution);var n=45,o=256,c=s.numLevelsForResolution(n/o,e.resolution),d=Math.ceil(c);this.coverageSector=e.coverageSector,this.retrievalImageFormat=e.retrievalImageFormat,this.minElevation=e.minElevation||0,this.maxElevation=e.maxElevation||0,this.pixelIsPoint=!1,this.levels=new s(this.coverageSector,new a(n,n),d,o,o),this.currentTiles=[],this.currentSector=new u(0,0,0,0),this.tileCache=new h(1e6,8e5),this.imageCache=new h(1e7,8e6),this.retrievalQueueSize=WorldWind.configuration.coverageRetrievalQueueSize,this.currentRetrievals=[],this.absentResourceList=new t(3,5e3),this.urlBuilder=e.urlBuilder||null};return f.prototype=Object.create(r.prototype),f.prototype.minAndMaxElevationsForSector=function(t,r){if(!t)throw new i(l.logMessage(l.LEVEL_SEVERE,"TiledElevationCoverage","minAndMaxElevationsForSector","missingSector"));if(!r)throw new i(l.logMessage(l.LEVEL_SEVERE,"TiledElevationCoverage","minAndMaxElevationsForSector","missingResult"));var n=this.levels.levelForTexelSize(t.deltaLatitude()*e.DEGREES_TO_RADIANS/64);if(this.assembleTiles(n,t,!1),0===this.currentTiles.length)return!1;for(var o=!0,s=0,a=this.currentTiles.length;s<a;s++){var h=this.imageCache.entryForKey(this.currentTiles[s].tileKey);if(h&&h.hasData){var u=h.minElevation;r[0]>u&&(r[0]=u);var c=h.maxElevation;r[1]<c&&(r[1]=c)}h&&h.hasData&&!h.hasMissingData||(o=!1)}return o},f.prototype.elevationAtLocation=function(t,e){return this.coverageSector.containsLocation(t,e)?this.pointElevationForLocation(t,e):null},f.prototype.elevationsForGrid=function(t,r,n,o){if(!t)throw new i(l.logMessage(l.LEVEL_SEVERE,"TiledElevationCoverage","elevationsForGrid","missingSector"));if(!r||!n||r<1||n<1)throw new i(l.logMessage(l.LEVEL_SEVERE,"TiledElevationCoverage","elevationsForGrid","The specified number of latitudinal or longitudinal positions is less than one."));var s=t.deltaLatitude()/(r-1)*e.DEGREES_TO_RADIANS,a=this.levels.levelForTexelSize(s);return this.pixelIsPoint?this.pointElevationsForGrid(t,r,n,a,o):this.areaElevationsForGrid(t,r,n,a,o)},f.prototype.pointElevationForLocation=function(t,e){for(var i,r=this.levels.lastLevel(),n=r.tileDelta.latitude,o=r.tileDelta.longitude,s=c.computeRow(n,t),a=c.computeColumn(o,e),l=null,h=r.levelNumber;h>=0;h--){if(i=c.computeTileKey(h,s,a),l=this.imageCache.entryForKey(i)){var u=l.elevationAtLocation(t,e);return isNaN(u)?null:u}s=Math.floor(s/2),a=Math.floor(a/2)}return null},f.prototype.pointElevationsForGrid=function(t,e,i,r,n){if(this.assembleTiles(r,t,!0),0===this.currentTiles.length)return!1;this.currentTiles.sort(function(t,e){return t.level.levelNumber-e.level.levelNumber});for(var o=0,s=this.currentTiles.length;o<s;o++){var a=this.imageCache.entryForKey(this.currentTiles[o].tileKey);a&&a.elevationsForGrid(t,e,i,n)}return!p.arrayIncludes(n,NaN)},f.prototype.areaElevationsForGrid=function(t,e,i,r,n){var o,s,a,l,h,u,c=t.minLatitude,d=t.maxLatitude,f=t.minLongitude,g=t.maxLongitude,m=t.deltaLatitude()/(e>1?e-1:1),y=t.deltaLongitude()/(i>1?i-1:1),E=0;for(h=0,o=c;h<e;h+=1,o+=m)for(h===e-1&&(o=d),u=0,s=f;u<i;u+=1,s+=y)u===i-1&&(s=g),isNaN(n[E])&&this.coverageSector.containsLocation(o,s)&&(a=(s+180)/360,l=(o+90)/180,this.areaElevationForCoord(a,l,r.levelNumber,n,E)),E++;return!p.arrayIncludes(n,NaN)},f.prototype.areaElevationForCoord=function(t,e,i,r,o){for(var s,a,l,h,u,c,p,f,g,m,y,E,v,_,b,w,S=new Float64Array(4),L=i;L>=0;L--)if(s=this.levels.level(L),a=Math.round(360*s.tileWidth/s.tileDelta.longitude),l=Math.round(180*s.tileHeight/s.tileDelta.latitude),h=1/(2*l),u=1-h,c=0,p=l-1,f=a*d.fract(t),g=l*d.clamp(e,h,u),m=d.mod(Math.floor(f-.5),a),y=d.mod(m+1,a),E=d.clamp(Math.floor(g-.5),c,p),v=d.clamp(E+1,c,p),_=d.fract(f-.5),b=d.fract(g-.5),w=L==i||0==L,this.lookupPixels(m,y,E,v,s,w,S))return!n.isNoData(S[0],S[1],S[2],S[3])&&(r[o]=(1-_)*(1-b)*S[0]+_*(1-b)*S[1]+(1-_)*b*S[2]+_*b*S[3],!0);return!1},f.prototype.lookupPixels=function(t,e,i,r,n,o,s){var a,l,h,u,c=n.levelNumber,d=n.tileWidth,p=n.tileHeight,f=Math.floor(i/p),g=Math.floor(r/p),m=Math.floor(t/d),y=Math.floor(e/d);return f==g&&f==this.cachedRow&&m==y&&m==this.cachedCol?a=l=h=u=this.cachedImage:f==g&&m==y?(a=this.lookupImage(c,f,m,o),l=h=u=a,this.cachedRow=f,this.cachedCol=m,this.cachedImage=a):(a=this.lookupImage(c,f,m,o),l=this.lookupImage(c,f,y,o),h=this.lookupImage(c,g,m,o),u=this.lookupImage(c,g,y,o)),!!(a&&l&&h&&u)&&(s[0]=a.pixel(t%d,i%p),s[1]=l.pixel(e%d,i%p),s[2]=h.pixel(t%d,r%p),s[3]=u.pixel(e%d,r%p),!0)},f.prototype.lookupImage=function(t,e,i,r){var n=c.computeTileKey(t,e,i),o=this.imageCache.entryForKey(n);if(null==o&&r){var s=this.tileForLevel(t,e,i);this.retrieveTileImage(s)}return o},f.prototype.assembleTiles=function(t,e,i){if(this.currentTiles=[],this.currentSector.copy(e),this.currentSector.intersection(this.coverageSector),!this.currentSector.isEmpty())for(var r=t.tileDelta.latitude,n=t.tileDelta.longitude,o=c.computeRow(r,this.currentSector.minLatitude),s=c.computeLastRow(r,this.currentSector.maxLatitude),a=c.computeColumn(n,this.currentSector.minLongitude),l=c.computeLastColumn(n,this.currentSector.maxLongitude),h=o;h<=s;h++)for(var u=a;u<=l;u++)this.addTileOrAncestor(t,h,u,i)},f.prototype.addTileOrAncestor=function(t,e,i,r){var n=this.tileForLevel(t.levelNumber,e,i);this.isTileImageInMemory(n)?this.addToCurrentTiles(n):(r&&this.retrieveTileImage(n),t.isFirstLevel()?this.currentTiles.push(n):this.addAncestor(t,e,i,r))},f.prototype.addAncestor=function(t,e,i,r){for(var n=null,o=Math.floor(e/2),s=Math.floor(i/2),a=t.levelNumber-1;a>=0;a--){if(n=this.tileForLevel(a,o,s),this.isTileImageInMemory(n))return void this.addToCurrentTiles(n);o=Math.floor(o/2),s=Math.floor(s/2)}this.addToCurrentTiles(n),r&&this.retrieveTileImage(n)},f.prototype.addToCurrentTiles=function(t){this.currentTiles.push(t)},f.prototype.tileForLevel=function(t,e,i){var r=c.computeTileKey(t,e,i),n=this.tileCache.entryForKey(r);if(n)return n;var o=this.levels.level(t),s=c.computeSector(o,e,i);return n=new c(s,o,e,i),this.tileCache.putEntry(r,n,n.size()),n},f.prototype.isTileImageInMemory=function(t){return this.imageCache.containsKey(t.tileKey)},f.prototype.resourceUrlForTile=function(t){return this.urlBuilder.urlForTile(t,this.retrievalImageFormat)},f.prototype.retrieveTileImage=function(t){if(this.currentRetrievals.indexOf(t.tileKey)<0){if(this.currentRetrievals.length>this.retrievalQueueSize)return;var e=this.resourceUrlForTile(t,this.retrievalImageFormat),i=new XMLHttpRequest,r=this;if(!e)return;i.open("GET",e,!0),i.responseType="arraybuffer",i.onreadystatechange=function(){if(4===i.readyState){r.removeFromCurrentRetrievals(t.tileKey);var n=i.getResponseHeader("content-type");if(200===i.status)if(n===r.retrievalImageFormat||"text/plain"===n||"application/octet-stream"===n){l.log(l.LEVEL_INFO,"Elevations retrieval succeeded: "+e),r.loadElevationImage(t,i),r.absentResourceList.unmarkResourceAbsent(t.tileKey);var o=document.createEvent("Event");o.initEvent(WorldWind.REDRAW_EVENT_TYPE,!0,!0),window.dispatchEvent(o)}else"text/xml"===n?(r.absentResourceList.markResourceAbsent(t.tileKey),l.log(l.LEVEL_WARNING,"Elevations retrieval failed ("+i.statusText+"): "+e+".\n "+String.fromCharCode.apply(null,new Uint8Array(i.response)))):(r.absentResourceList.markResourceAbsent(t.tileKey),l.log(l.LEVEL_WARNING,"Elevations retrieval failed: "+e+". Unexpected content type "+n));else r.absentResourceList.markResourceAbsent(t.tileKey),l.log(l.LEVEL_WARNING,"Elevations retrieval failed ("+i.statusText+"): "+e)}},i.onerror=function(){r.removeFromCurrentRetrievals(t.tileKey),r.absentResourceList.markResourceAbsent(t.tileKey),l.log(l.LEVEL_WARNING,"Elevations retrieval failed: "+e)},i.ontimeout=function(){r.removeFromCurrentRetrievals(t.tileKey),r.absentResourceList.markResourceAbsent(t.tileKey),l.log(l.LEVEL_WARNING,"Elevations retrieval timed out: "+e)},i.send(null),this.currentRetrievals.push(t.tileKey)}},f.prototype.removeFromCurrentRetrievals=function(t){var e=this.currentRetrievals.indexOf(t);e>-1&&this.currentRetrievals.splice(e,1)},f.prototype.loadElevationImage=function(t,e){var i,r=new n(t.sector,t.tileWidth,t.tileHeight);"application/bil16"===this.retrievalImageFormat?(r.imageData=new Int16Array(e.response),r.size=2*r.imageData.length):"application/bil32"===this.retrievalImageFormat?(r.imageData=new Float32Array(e.response),r.size=4*r.imageData.length):"image/tiff"===this.retrievalImageFormat&&(i=new o(e.response),r.imageData=i.getImageData(),r.size=r.imageData.length*i.metadata.bitsPerSample[0]/8),r.imageData&&(r.findMinAndMaxElevation(),this.imageCache.putEntry(t.tileKey,r,r.size),this.timestamp=Date.now())},f}),i("util/WmsUrlBuilder",["../error/ArgumentError","../util/Logger"],function(t,e){"use strict";var i=function(i,r,n,o,s){if(!i||0===i.length)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsUrlBuilder","constructor","The WMS service address is missing."));if(!r||0===r.length)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsUrlBuilder","constructor","The WMS layer names are not specified."));this.serviceAddress=i,this.layerNames=r,this.styleNames=n?n:"",this.transparent=!0,this.wmsVersion=o&&o.length>0?o:"1.3.0",this.isWms130OrGreater=this.wmsVersion>="1.3.0",this.crs="EPSG:4326",this.timeString=s};return i.prototype.urlForTile=function(r,n){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsUrlBuilder","urlForTile","missingTile"));if(!n)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsUrlBuilder","urlForTile","The image format is null or undefined."));var o=r.sector,s=i.fixGetMapString(this.serviceAddress);return s.search(/service=wms/i)<0&&(s+="service=WMS"),s+="&request=GetMap",s=s+"&version="+this.wmsVersion,s=s+"&transparent="+(this.transparent?"TRUE":"FALSE"),s=s+"&layers="+this.layerNames,s=s+"&styles="+this.styleNames,s=s+"&format="+n,s=s+"&width="+r.tileWidth,s=s+"&height="+r.tileHeight,this.timeString&&(s=s+"&time="+this.timeString),this.isWms130OrGreater?(s=s+"&crs="+this.crs,s+="&bbox=","CRS:84"===this.crs?(s=s+o.minLongitude+","+o.minLatitude+",",s=s+o.maxLongitude+","+o.maxLatitude):(s=s+o.minLatitude+","+o.minLongitude+",",s=s+o.maxLatitude+","+o.maxLongitude)):(s=s+"&srs="+this.crs,s+="&bbox=",s=s+o.minLongitude+","+o.minLatitude+",",s=s+o.maxLongitude+","+o.maxLatitude),s=s.replace(" ","%20")},i.fixGetMapString=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsUrlBuilder","fixGetMapString","The specified service address is null or undefined."));var r=i.indexOf("?");return r<0?i+="?":r!==i.length-1&&(r=i.search(/&$/),r<0&&(i+="&")),i},i}),i("globe/AsterV2ElevationCoverage",["../geom/Location","../geom/Sector","../globe/TiledElevationCoverage","../util/WmsUrlBuilder"],function(t,e,i,r){"use strict";var n=function(){i.call(this,{coverageSector:new e(-83.0001,83.0001,-180,180),resolution:.000277777777778,retrievalImageFormat:"application/bil16",minElevation:-11e3,maxElevation:8850,urlBuilder:new r("https://worldwind26.arc.nasa.gov/elev","aster_v2","","1.3.0")}),this.displayName="ASTER V2 Earth Elevation Coverage"};return n.prototype=Object.create(i.prototype),n}),i("shaders/AtmosphereProgram",["../error/ArgumentError","../shaders/GpuProgram","../util/Logger"],function(t,e,i){"use strict";var r=function(t,i,r,n){e.call(this,t,i,r,n),this.FRAGMODE_SKY=1,this.FRAGMODE_GROUND_PRIMARY=2,this.FRAGMODE_GROUND_SECONDARY=3,this.FRAGMODE_GROUND_PRIMARY_TEX_BLEND=4,this.altitude=16e4,this.rayleighScaleDepth=.25,this.fragModeLocation=this.uniformLocation(t,"fragMode"),this.mvpMatrixLocation=this.uniformLocation(t,"mvpMatrix"),this.texCoordMatrixLocation=this.uniformLocation(t,"texCoordMatrix"),this.vertexOriginLocation=this.uniformLocation(t,"vertexOrigin"),this.eyePointLocation=this.uniformLocation(t,"eyePoint"),this.eyeMagnitudeLocation=this.uniformLocation(t,"eyeMagnitude"),this.eyeMagnitude2Location=this.uniformLocation(t,"eyeMagnitude2"),this.lightDirectionLocation=this.uniformLocation(t,"lightDirection"),this.atmosphereRadiusLocation=this.uniformLocation(t,"atmosphereRadius"),this.atmosphereRadius2Location=this.uniformLocation(t,"atmosphereRadius2"),this.globeRadiusLocation=this.uniformLocation(t,"globeRadius"),this.scaleLocation=this.uniformLocation(t,"scale"),this.scaleDepthLocation=this.uniformLocation(t,"scaleDepth"),this.scaleOverScaleDepthLocation=this.uniformLocation(t,"scaleOverScaleDepth"),this.scratchArray9=new Float32Array(9)};return r.key="WorldWindGpuAtmosphereProgram",r.prototype=Object.create(e.prototype),r.prototype.getAltitude=function(){return this.altitude},r.prototype.loadFragMode=function(e,r){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"AtmosphereProgram","loadFragMode","missingFragMode"));e.uniform1i(this.fragModeLocation,r)},r.prototype.loadModelviewProjection=function(e,r){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"AtmosphereProgram","loadModelviewProjection","missingMatrix"));this.loadUniformMatrix(e,r,this.mvpMatrixLocation)},r.prototype.loadVertexOrigin=function(e,r){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"AtmosphereProgram","loadVertexOrigin","missingVector"));e.uniform3f(this.vertexOriginLocation,r[0],r[1],r[2])},r.prototype.loadLightDirection=function(e,r){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"AtmosphereProgram","loadLightDirection","missingVector"));e.uniform3f(this.lightDirectionLocation,r[0],r[1],r[2])},r.prototype.loadEyePoint=function(e,r){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"AtmosphereProgram","loadEyePoint","missingVector"));e.uniform3f(this.eyePointLocation,r[0],r[1],r[2]),e.uniform1f(this.eyeMagnitudeLocation,r.magnitude()),e.uniform1f(this.eyeMagnitude2Location,r.magnitudeSquared())},r.prototype.loadGlobeRadius=function(e,r){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"AtmosphereProgram","loadGlobeRadius","missingGlobeRadius"));var n=r,o=n+this.altitude;e.uniform1f(this.globeRadiusLocation,n),e.uniform1f(this.atmosphereRadiusLocation,o),e.uniform1f(this.atmosphereRadius2Location,o*o)},r.prototype.setScale=function(t){t.uniform1f(this.scaleLocation,1/this.getAltitude()),t.uniform1f(this.scaleDepthLocation,this.rayleighScaleDepth),t.uniform1f(this.scaleOverScaleDepthLocation,1/this.getAltitude()/this.rayleighScaleDepth)},r.prototype.loadTexMatrix=function(e,r){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"AtmosphereProgram","loadTexMatrix","missingMatrix"));r.columnMajorComponents(this.scratchArray9),e.uniformMatrix3fv(this.texCoordMatrixLocation,!1,this.scratchArray9)},r}),i("shaders/GroundProgram",["../shaders/AtmosphereProgram"],function(t){"use strict";var e=function(e){var i="precision mediump int;\nconst int FRAGMODE_GROUND_PRIMARY_TEX_BLEND = 4;\nconst int SAMPLE_COUNT = 2;\nconst float SAMPLES = 2.0;\nconst float PI = 3.141592653589;\nconst float Kr = 0.0025;\nconst float Kr4PI = Kr * 4.0 * PI;\nconst float Km = 0.0015;\nconst float Km4PI = Km * 4.0 * PI;\nconst float ESun = 15.0;\nconst float KmESun = Km * ESun;\nconst float KrESun = Kr * ESun;\nconst vec3 invWavelength = vec3(5.60204474633241, 9.473284437923038, 19.643802610477206);\nconst float rayleighScaleDepth = 0.25;\nuniform int fragMode;\nuniform mat4 mvpMatrix;\nuniform mat3 texCoordMatrix;\nuniform vec3 vertexOrigin;\nuniform vec3 eyePoint;\nuniform float eyeMagnitude;\nuniform float eyeMagnitude2;\nuniform vec3 lightDirection;\nuniform float atmosphereRadius;\nuniform float atmosphereRadius2;\nuniform float globeRadius;\nuniform float scale;\nuniform float scaleDepth;\nuniform float scaleOverScaleDepth;\nattribute vec4 vertexPoint;\nattribute vec2 vertexTexCoord;\nvarying vec3 primaryColor;\nvarying vec3 secondaryColor;\nvarying vec2 texCoord;\nfloat scaleFunc(float cos) {\n    float x = 1.0 - cos;\n    return scaleDepth * exp(-0.00287 + x*(0.459 + x*(3.83 + x*(-6.80 + x*5.25))));\n}\nvoid sampleGround() {\n    vec3 point = vertexPoint.xyz + vertexOrigin;\n    vec3 ray = point - eyePoint;\n    float far = length(ray);\n    ray /= far;\n    vec3 start;\n    if (eyeMagnitude < atmosphereRadius) {\n        start = eyePoint;\n    } else {\n        float B = 2.0 * dot(eyePoint, ray);\n        float C = eyeMagnitude2 - atmosphereRadius2;\n        float det = max(0.0, B*B - 4.0 * C);\n        float near = 0.5 * (-B - sqrt(det));\n        start = eyePoint + ray * near;\n        far -= near;\n}\n    float depth = exp((globeRadius - atmosphereRadius) / scaleDepth);\n    float eyeAngle = dot(-ray, point) / length(point);\n    float lightAngle = dot(lightDirection, point) / length(point);\n    float eyeScale = scaleFunc(eyeAngle);\n    float lightScale = scaleFunc(lightAngle);\n    float eyeOffset = depth*eyeScale;\n    float temp = (lightScale + eyeScale);\n    float sampleLength = far / SAMPLES;\n    float scaledLength = sampleLength * scale;\n    vec3 sampleRay = ray * sampleLength;\n    vec3 samplePoint = start + sampleRay * 0.5;\n    vec3 frontColor = vec3(0.0, 0.0, 0.0);\n    vec3 attenuate = vec3(0.0, 0.0, 0.0);\n    for(int i=0; i<SAMPLE_COUNT; i++)\n    {\n        float height = length(samplePoint);\n        float depth = exp(scaleOverScaleDepth * (globeRadius - height));\n        float scatter = depth*temp - eyeOffset;\n        attenuate = exp(-scatter * (invWavelength * Kr4PI + Km4PI));\n        frontColor += attenuate * (depth * scaledLength);\n        samplePoint += sampleRay;\n    }\n    primaryColor = frontColor * (invWavelength * KrESun + KmESun);\n    secondaryColor = attenuate;\n}\nvoid main()\n {\n    sampleGround();\n    gl_Position = mvpMatrix * vertexPoint;\n    if (fragMode == FRAGMODE_GROUND_PRIMARY_TEX_BLEND) {\n        texCoord = (texCoordMatrix * vec3(vertexTexCoord, 1.0)).st;\n    }\n}",r="precision mediump float;\nprecision mediump int;\nconst int FRAGMODE_GROUND_PRIMARY = 2;\nconst int FRAGMODE_GROUND_SECONDARY = 3;\nconst int FRAGMODE_GROUND_PRIMARY_TEX_BLEND = 4;\nuniform int fragMode;\nuniform sampler2D texSampler;\nvarying vec3 primaryColor;\nvarying vec3 secondaryColor;\nvarying vec2 texCoord;\nvoid main (void)\n{\n    if (fragMode == FRAGMODE_GROUND_PRIMARY) {\n        gl_FragColor = vec4(primaryColor, 1.0);\n    } else if (fragMode == FRAGMODE_GROUND_SECONDARY) {\n        gl_FragColor = vec4(secondaryColor, 1.0);\n    } else if (fragMode == FRAGMODE_GROUND_PRIMARY_TEX_BLEND) {\n        vec4 texColor = texture2D(texSampler, texCoord);\n        gl_FragColor = vec4(primaryColor + texColor.rgb * (1.0 - secondaryColor), 1.0);\n    }\n}";
t.call(this,e,i,r,["vertexPoint","vertexTexCoord"])};return e.key="WorldWindGroundProgram",e.prototype=Object.create(t.prototype),e}),i("layer/Layer",["../util/Logger"],function(t){"use strict";var e=function(t){this.displayName=t?t:"Layer",this.enabled=!0,this.pickEnabled=!0,this.opacity=1,this.minActiveAltitude=-Number.MAX_VALUE,this.maxActiveAltitude=Number.MAX_VALUE,this.inCurrentFrame=!1,this.time=null};return e.prototype.refresh=function(){},e.prototype.render=function(t){this.inCurrentFrame=!1,this.enabled&&(t.pickingMode&&!this.pickEnabled||this.withinActiveAltitudes(t)&&this.isLayerInView(t)&&this.doRender(t))},e.prototype.doRender=function(t){},e.prototype.withinActiveAltitudes=function(t){var e=t.eyePosition;return!!e&&(e.altitude>=this.minActiveAltitude&&e.altitude<=this.maxActiveAltitude)},e.prototype.isLayerInView=function(t){return!0},e}),i("geom/Matrix3",["../error/ArgumentError","../util/Logger"],function(t,e){"use strict";var i=function(t,e,i,r,n,o,s,a,l){this[0]=t,this[1]=e,this[2]=i,this[3]=r,this[4]=n,this[5]=o,this[6]=s,this[7]=a,this[8]=l};return i.prototype=new Float64Array(9),i.fromIdentity=function(){return new i(1,0,0,0,1,0,0,0,1)},i.prototype.setToUnitYFlip=function(){return this[0]=1,this[1]=0,this[2]=0,this[3]=0,this[4]=-1,this[5]=1,this[6]=0,this[7]=0,this[8]=1,this},i.prototype.multiplyMatrix=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"Matrix3","multiplyMatrix","missingMatrix"));var r,n,o,s=this,a=i;return r=s[0],n=s[1],o=s[2],s[0]=r*a[0]+n*a[3]+o*a[6],s[1]=r*a[1]+n*a[4]+o*a[7],s[2]=r*a[2]+n*a[5]+o*a[8],r=s[3],n=s[4],o=s[5],s[3]=r*a[0]+n*a[3]+o*a[6],s[4]=r*a[1]+n*a[4]+o*a[7],s[5]=r*a[2]+n*a[5]+o*a[8],r=s[6],n=s[7],o=s[8],s[6]=r*a[0]+n*a[3]+o*a[6],s[7]=r*a[1]+n*a[4]+o*a[7],s[8]=r*a[2]+n*a[5]+o*a[8],this},i.prototype.multiplyByTileTransform=function(t,e){var i=t.deltaLatitude(),r=t.deltaLongitude(),n=e.deltaLatitude(),o=e.deltaLongitude(),s=r/o,a=i/n,l=(t.minLongitude-e.minLongitude)/o,h=(t.minLatitude-e.minLatitude)/n,u=this;return u[2]+=u[0]*l+u[1]*h,u[5]+=u[3]*l+u[4]*h,u[8]+=u[6]*l+u[6]*h,u[0]*=s,u[1]*=a,u[3]*=s,u[4]*=a,u[6]*=s,u[7]*=a,this},i.prototype.columnMajorComponents=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"Matrix3","columnMajorComponents","missingResult"));return i[0]=this[0],i[1]=this[3],i[2]=this[6],i[3]=this[1],i[4]=this[4],i[5]=this[7],i[6]=this[2],i[7]=this[5],i[8]=this[8],i},i}),i("shaders/SkyProgram",["../shaders/AtmosphereProgram"],function(t){"use strict";var e=function(e){var i="precision mediump int;\nconst int SAMPLE_COUNT = 2;\nconst float SAMPLES = 2.0;\nconst float PI = 3.141592653589;\nconst float Kr = 0.0025;\nconst float Kr4PI = Kr * 4.0 * PI;\nconst float Km = 0.0015;\nconst float Km4PI = Km * 4.0 * PI;\nconst float ESun = 15.0;\nconst float KmESun = Km * ESun;\nconst float KrESun = Kr * ESun;\nconst vec3 invWavelength = vec3(5.60204474633241, 9.473284437923038, 19.643802610477206);\nconst float rayleighScaleDepth = 0.25;\nuniform mat4 mvpMatrix;\nuniform vec3 vertexOrigin;\nuniform vec3 eyePoint;\nuniform float eyeMagnitude;\nuniform float eyeMagnitude2;\nuniform mediump vec3 lightDirection;\nuniform float atmosphereRadius;\nuniform float atmosphereRadius2;\nuniform float globeRadius;\nuniform float scale;\nuniform float scaleDepth;\nuniform float scaleOverScaleDepth;\nattribute vec4 vertexPoint;\nvarying vec3 primaryColor;\nvarying vec3 secondaryColor;\nvarying vec3 direction;\nfloat scaleFunc(float cos)\n{\n    float x = 1.0 - cos;\n    return scaleDepth * exp(-0.00287 + x*(0.459 + x*(3.83 + x*(-6.80 + x*5.25))));\n}\nvoid sampleSky() {\n    vec3 point = vertexPoint.xyz + vertexOrigin;\n    vec3 ray = point - eyePoint;\n    float far = length(ray);\n    ray /= far;\n    vec3 start;\n    float startOffset;\n    if (eyeMagnitude < atmosphereRadius) {\n        start = eyePoint;\n        float height = length(start);\n        float depth = exp(scaleOverScaleDepth * (globeRadius - eyeMagnitude));\n        float startAngle = dot(ray, start) / height;\n        startOffset = depth*scaleFunc(startAngle);\n    } else {\n        float B = 2.0 * dot(eyePoint, ray);\n        float C = eyeMagnitude2 - atmosphereRadius2;\n        float det = max(0.0, B*B - 4.0 * C);\n        float near = 0.5 * (-B - sqrt(det));\n        start = eyePoint + ray * near;\n        far -= near;\n        float startAngle = dot(ray, start) / atmosphereRadius;\n        float startDepth = exp(-1.0 / scaleDepth);\n        startOffset = startDepth*scaleFunc(startAngle);\n    }\n    float sampleLength = far / SAMPLES;\n    float scaledLength = sampleLength * scale;\n    vec3 sampleRay = ray * sampleLength;\n    vec3 samplePoint = start + sampleRay * 0.5;\n    vec3 frontColor = vec3(0.0, 0.0, 0.0);\n    for(int i=0; i<SAMPLE_COUNT; i++)\n    {\n       float height = length(samplePoint);\n       float depth = exp(scaleOverScaleDepth * (globeRadius - height));\n       float lightAngle = dot(lightDirection, samplePoint) / height;\n       float cameraAngle = dot(ray, samplePoint) / height;\n       float scatter = (startOffset + depth*(scaleFunc(lightAngle) - scaleFunc(cameraAngle)));\n       vec3 attenuate = exp(-scatter * (invWavelength * Kr4PI + Km4PI));\n       frontColor += attenuate * (depth * scaledLength);\n       samplePoint += sampleRay;\n    }\n    primaryColor = frontColor * (invWavelength * KrESun);\n    secondaryColor = frontColor * KmESun;\n    direction = eyePoint - point;\n}\nvoid main()\n{\n    sampleSky();\n    gl_Position = mvpMatrix * vertexPoint;\n}",r="#ifdef GL_FRAGMENT_PRECISION_HIGH\nprecision highp float;\n#else\nprecision mediump float;\n#endif\nconst float g = -0.95;\nconst float g2 = g * g;\nuniform mediump vec3 lightDirection;\nvarying vec3 primaryColor;\nvarying vec3 secondaryColor;\nvarying vec3 direction;\nvoid main (void)\n{\n    float cos = dot(lightDirection, direction) / length(direction);\n    float rayleighPhase = 0.75 * (1.0 + cos * cos);\n    float miePhase = 1.5 * ((1.0 - g2) / (2.0 + g2)) * (1.0 + cos*cos) /         pow(1.0 + g2 - 2.0*g*cos, 1.5);\n    const float exposure = 2.0;\n    vec3 color = primaryColor * rayleighPhase + secondaryColor * miePhase;\n    color = vec3(1.0) - exp(-exposure * color);\n    gl_FragColor = vec4(color, color.b);\n}";t.call(this,e,i,r,["vertexPoint"])};return e.key="WorldWindSkyProgram",e.prototype=Object.create(t.prototype),e}),i("util/SunPosition",["../geom/Angle","../error/ArgumentError","./Logger","./WWMath"],function(t,e,i,r){"use strict";var n={getAsGeographicLocation:function(t){if(t instanceof Date==!1)throw new e(i.logMessage(i.LEVEL_SEVERE,"SunPosition","getAsGeographicLocation","missingDate"));var r=this.getAsCelestialLocation(t);return this.celestialToGeographic(r,t)},getAsCelestialLocation:function(n){if(n instanceof Date==!1)throw new e(i.logMessage(i.LEVEL_SEVERE,"SunPosition","getAsCelestialLocation","missingDate"));var o=this.computeJulianDate(n),s=o-2451545,a=r.normalizeAngle360(280.46+.9856474*s),l=r.normalizeAngle360(357.528+.9856003*s)*t.DEGREES_TO_RADIANS,h=a+1.915*Math.sin(l)+.02*Math.sin(2*l),u=h*t.DEGREES_TO_RADIANS,c=(23.439-4e-7*s)*t.DEGREES_TO_RADIANS,d=Math.asin(Math.sin(c)*Math.sin(u))*t.RADIANS_TO_DEGREES,p=Math.atan(Math.cos(c)*Math.tan(u))*t.RADIANS_TO_DEGREES;return h>=90&&h<270&&(p+=180),p=r.normalizeAngle360(p),{declination:d,rightAscension:p}},celestialToGeographic:function(n,o){if(!n)throw new e(i.logMessage(i.LEVEL_SEVERE,"SunPosition","celestialToGeographic","missingCelestialLocation"));if(o instanceof Date==!1)throw new e(i.logMessage(i.LEVEL_SEVERE,"SunPosition","celestialToGeographic","missingDate"));var s=this.computeJulianDate(o),a=s-2451545,l=r.normalizeAngle360(280.46061837+360.98564736629*a),h=r.normalizeAngle360(l-n.rightAscension),u=t.normalizedDegreesLongitude(-h);return{latitude:n.declination,longitude:u}},computeJulianDate:function(t){if(t instanceof Date==!1)throw new e(i.logMessage(i.LEVEL_SEVERE,"SunPosition","computeJulianDate","missingDate"));var r=t.getUTCFullYear(),n=t.getUTCMonth()+1,o=t.getUTCDate(),s=t.getUTCHours(),a=t.getUTCMinutes(),l=t.getUTCSeconds(),h=(s+a/60+l/3600)/24;n<=2&&(r-=1,n+=12);var u=Math.floor(r/100),c=2-u+Math.floor(u/4),d=Math.floor(365.25*(r+4716))+Math.floor(30.6001*(n+1))+o+c-1524.5;return d+h}};return n}),i("layer/AtmosphereLayer",["../error/ArgumentError","../shaders/GroundProgram","../layer/Layer","../util/Logger","../geom/Matrix","../geom/Matrix3","../geom/Sector","../shaders/SkyProgram","../util/SunPosition","../geom/Vec3","../util/WWUtil"],function(t,e,i,r,n,o,s,a,l,h,u){"use strict";var c=function(t){i.call(this,"Atmosphere"),this.pickEnabled=!1,this._nightImageSource=t||WorldWind.configuration.baseUrl+"images/dnb_land_ocean_ice_2012.png",this._activeLightDirection=new h(0,0,0),this._fullSphereSector=s.FULL_SPHERE,this._skyData={},this._skyWidth=128,this._skyHeight=128,this._numIndices=0,this._texMatrix=o.fromIdentity(),this._activeTexture=null};return c.prototype=Object.create(i.prototype),Object.defineProperties(c.prototype,{nightImageSource:{get:function(){return this._nightImageSource},set:function(t){this._nightImageSource=t}}}),c.prototype.doRender=function(t){t.globe.is2D()||(this.determineLightDirection(t),this.drawSky(t),this.drawGround(t))},c.prototype.applySkyVertices=function(t){var e,i,r=t.currentGlContext,n=t.currentProgram,o=this._skyData;o.verticesVboCacheKey||(o.verticesVboCacheKey=t.gpuResourceCache.generateCacheKey()),i=t.gpuResourceCache.resourceForKey(o.verticesVboCacheKey),i?(r.bindBuffer(r.ARRAY_BUFFER,i),r.vertexAttribPointer(0,3,r.FLOAT,!1,0,0)):(e=this.assembleVertexPoints(t,this._skyHeight,this._skyWidth,n.getAltitude()),i=r.createBuffer(),r.bindBuffer(r.ARRAY_BUFFER,i),r.bufferData(r.ARRAY_BUFFER,e,r.STATIC_DRAW),r.vertexAttribPointer(0,3,r.FLOAT,!1,0,0),t.gpuResourceCache.putResource(o.verticesVboCacheKey,i,4*e.length),t.frameStatistics.incrementVboLoadCount(1))},c.prototype.applySkyIndices=function(t){var e,i,r=t.currentGlContext,n=this._skyData;n.indicesVboCacheKey||(n.indicesVboCacheKey=t.gpuResourceCache.generateCacheKey()),i=t.gpuResourceCache.resourceForKey(n.indicesVboCacheKey),i?r.bindBuffer(r.ELEMENT_ARRAY_BUFFER,i):(e=this.assembleTriStripIndices(this._skyWidth,this._skyHeight),i=r.createBuffer(),r.bindBuffer(r.ELEMENT_ARRAY_BUFFER,i),r.bufferData(r.ELEMENT_ARRAY_BUFFER,e,r.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1),t.gpuResourceCache.putResource(n.indicesVboCacheKey,i,2*e.length))},c.prototype.drawSky=function(t){var e=t.currentGlContext,i=t.findAndBindProgram(a);i.loadGlobeRadius(e,t.globe.equatorialRadius),i.loadEyePoint(e,t.eyePoint),i.loadVertexOrigin(e,h.ZERO),i.loadModelviewProjection(e,t.modelviewProjection),i.loadLightDirection(e,this._activeLightDirection),i.setScale(e),this.applySkyVertices(t),this.applySkyIndices(t),e.depthMask(!1),e.frontFace(e.CW),e.enableVertexAttribArray(0),e.drawElements(e.TRIANGLE_STRIP,this._numIndices,e.UNSIGNED_SHORT,0),e.depthMask(!0),e.frontFace(e.CCW),e.disableVertexAttribArray(0)},c.prototype.drawGround=function(t){if(t.terrain){var i,r=t.currentGlContext,n=t.findAndBindProgram(e),o=t.terrain;n.loadGlobeRadius(r,t.globe.equatorialRadius),n.loadEyePoint(r,t.eyePoint),n.loadLightDirection(r,this._activeLightDirection),n.setScale(r),this.nightImageSource&&null!==this.time&&(this._activeTexture=t.gpuResourceCache.resourceForKey(this.nightImageSource),this._activeTexture||(this._activeTexture=t.gpuResourceCache.retrieveTexture(r,this.nightImageSource)),i=this._activeTexture&&this._activeTexture.bind(t)),o.beginRendering(t);for(var s=0,a=o.surfaceGeometry.length;s<a;s++){var l=o.surfaceGeometry[s],h=l.referencePoint;n.loadVertexOrigin(r,h),i&&(this._texMatrix.setToUnitYFlip(),this._texMatrix.multiplyByTileTransform(l.sector,this._fullSphereSector),n.loadTexMatrix(r,this._texMatrix)),o.beginRenderingTile(t,l),n.loadFragMode(r,n.FRAGMODE_GROUND_SECONDARY),r.blendFunc(r.DST_COLOR,r.ZERO),o.renderTile(t,l);var u=i?n.FRAGMODE_GROUND_PRIMARY_TEX_BLEND:n.FRAGMODE_GROUND_PRIMARY;n.loadFragMode(r,u),r.blendFunc(r.ONE,r.ONE),o.renderTile(t,l),o.endRenderingTile(t,l)}o.endRendering(t),r.blendFunc(r.ONE,r.ONE_MINUS_SRC_ALPHA),this._activeTexture=null}},c.prototype.assembleVertexPoints=function(t,e,i,r){var n=e*i,o=new Array(n);u.fillArray(o,r);var s=new Float32Array(3*n);return t.globe.computePointsForGrid(this._fullSphereSector,e,i,o,h.ZERO,s)},c.prototype.assembleTriStripIndices=function(t,e){for(var i=[],r=0,n=0;n<t-1;n++){for(var o=0;o<e;o++)r=o+n*e,i.push(r+e),i.push(r);n<t-2&&(i.push(r),i.push((n+2)*e))}return this._numIndices=i.length,new Uint16Array(i)},c.prototype.determineLightDirection=function(t){if(null!==this.time){var e=l.getAsGeographicLocation(this.time);t.globe.computePointFromLocation(e.latitude,e.longitude,this._activeLightDirection)}else this._activeLightDirection.copy(t.eyePoint);this._activeLightDirection.normalize()},c}),i("util/BasicTimeSequence",["../error/ArgumentError","../util/Logger"],function(t,e){"use strict";var i=function(i){if(!i&&i.length<2)throw new t(e.logMessage(e.LEVEL_SEVERE,"BasicTimeSequence","constructor","missingDates"));this.dates=i,this.currentIndex=0,this.currentTime=i[0]};return Object.defineProperties(i.prototype,{scaleForCurrentTime:{get:function(){return this.currentTime?this.currentIndex/this.dates.length:1}}}),i.prototype.next=function(){return this.currentIndex>=this.dates.length-1?null:(this.currentIndex++,this.currentTime=this.dates[this.currentIndex],this.currentTime)},i.prototype.previous=function(){return this.currentIndex<=0?null:(this.currentIndex--,this.currentTime=this.dates[this.currentIndex],this.currentTime)},i.prototype.reset=function(){this.currentIndex=-1,this.currentTime=null},i.prototype.getTimeForScale=function(t){return t<=0?this.currentIndex=0:t>=1?this.currentIndex=this.dates.length-1:this.currentIndex=Math.floor(this.dates.length*t),this.currentTime=this.dates[this.currentIndex],this.currentTime},i}),i("gesture/Touch",[],function(){"use strict";var t=function(t,e,i){this.identifier=t,this._clientX=e,this._clientY=i,this._clientStartX=e,this._clientStartY=i};return Object.defineProperties(t.prototype,{clientX:{get:function(){return this._clientX},set:function(t){this._clientX=t}},clientY:{get:function(){return this._clientY},set:function(t){this._clientY=t}},translationX:{get:function(){return this._clientX-this._clientStartX},set:function(t){this._clientStartX=this._clientX-t}},translationY:{get:function(){return this._clientY-this._clientStartY},set:function(t){this._clientStartY=this._clientY-t}}}),t}),i("gesture/GestureRecognizer",["../error/ArgumentError","../util/Logger","../gesture/Touch"],function(t,e,i){"use strict";var r=function(i,n){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"GestureRecognizer","constructor","missingTarget"));this.target=i,this.enabled=!0,this._state=WorldWind.POSSIBLE,this._nextState=null,this._clientX=0,this._clientY=0,this._clientStartX=0,this._clientStartY=0,this._translationX=0,this._translationY=0,this._translationWeight=.4,this._mouseButtonMask=0,this._touches=[],this._touchCentroidShiftX=0,this._touchCentroidShiftY=0,this._gestureCallbacks=[],this._canRecognizeWith=[],this._requiresFailureOf=[],this._requiredToFailBy=[],n&&this._gestureCallbacks.push(n),this.listenerList=[],r.allRecognizers.push(this)};return r.allRecognizers=[],Object.defineProperties(r.prototype,{state:{get:function(){return this._state},set:function(t){this.transitionToState(t)}},clientX:{get:function(){return this._clientX},set:function(t){this._clientX=t}},clientY:{get:function(){return this._clientY},set:function(t){this._clientY=t}},translationX:{get:function(){return this._translationX},set:function(t){this._translationX=t,this._clientStartX=this._clientX,this._touchCentroidShiftX=0}},translationY:{get:function(){return this._translationY},set:function(t){this._translationY=t,this._clientStartY=this._clientY,this._touchCentroidShiftY=0}},mouseButtonMask:{get:function(){return this._mouseButtonMask}},touchCount:{get:function(){return this._touches.length}},gestureCallbacks:{get:function(){return this._gestureCallbacks}}}),r.prototype.touch=function(i){if(i<0||i>=this._touches.length)throw new t(e.logMessage(e.LEVEL_SEVERE,"GestureRecognizer","touch","indexOutOfRange"));return this._touches[i]},r.prototype.recognizeSimultaneouslyWith=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"GestureRecognizer","recognizeSimultaneouslyWith","The specified gesture recognizer is null or undefined."));var r=this._canRecognizeWith.indexOf(i);r==-1&&(this._canRecognizeWith.push(i),i._canRecognizeWith.push(this))},r.prototype.canRecognizeSimultaneouslyWith=function(t){var e=this._canRecognizeWith.indexOf(t);return e!=-1},r.prototype.requireRecognizerToFail=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"GestureRecognizer","requireRecognizerToFail","The specified gesture recognizer is null or undefined"));var r=this._requiresFailureOf.indexOf(i);r==-1&&(this._requiresFailureOf.push(i),i._requiredToFailBy.push(this))},r.prototype.requiresRecognizerToFail=function(t){var e=this._requiresFailureOf.indexOf(t);return e!=-1},r.prototype.requiredToFailByRecognizer=function(t){var e=this._requiredToFailBy.indexOf(t);return e!=-1},r.prototype.reset=function(){this._state=WorldWind.POSSIBLE,this._nextState=null,this._clientX=0,this._clientY=0,this._clientStartX=0,this._clientStartY=0,this._translationX=0,this._translationY=0,this._mouseButtonMask=0,this._touches=[],this._touchCentroidShiftX=0,this._touchCentroidShiftY=0},r.prototype.prepareToRecognize=function(){},r.prototype.mouseDown=function(t){},r.prototype.mouseMove=function(t){},r.prototype.mouseUp=function(t){},r.prototype.touchStart=function(t){},r.prototype.touchMove=function(t){},r.prototype.touchCancel=function(t){},r.prototype.touchEnd=function(t){},r.prototype.transitionToState=function(t){this._nextState=null,t===WorldWind.FAILED?(this._state=t,this.updateRecognizersWaitingForFailure(),this.resetIfEventsEnded()):t===WorldWind.RECOGNIZED?(this.tryToRecognize(t),this._state===t&&(this.prepareToRecognize(),this.notifyListeners(),this.callGestureCallbacks(),this.resetIfEventsEnded())):t===WorldWind.BEGAN?(this.tryToRecognize(t),this._state===t&&(this.prepareToRecognize(),this.notifyListeners(),this.callGestureCallbacks())):t===WorldWind.CHANGED?(this._state=t,this.notifyListeners(),this.callGestureCallbacks()):t===WorldWind.CANCELLED?(this._state=t,this.notifyListeners(),this.callGestureCallbacks(),this.resetIfEventsEnded()):t===WorldWind.ENDED&&(this._state=t,this.notifyListeners(),this.callGestureCallbacks(),this.resetIfEventsEnded())},r.prototype.updateRecognizersWaitingForFailure=function(){for(var t=0,e=this._requiredToFailBy.length;t<e;t++){var i=this._requiredToFailBy[t];null!=i._nextState&&i.transitionToState(i._nextState)}},r.prototype.tryToRecognize=function(t){if(r.allRecognizers.some(this.canBePreventedByRecognizer,this))return void this.transitionToState(WorldWind.FAILED);if(r.allRecognizers.some(this.isWaitingForRecognizerToFail,this))return void(this._nextState=t);for(var e=r.allRecognizers.filter(this.canPreventRecognizer,this),i=0,n=e.length;i<n;i++)e[i].transitionToState(WorldWind.FAILED);this._state=t},r.prototype.canPreventRecognizer=function(t){return this!=t&&this.target==t.target&&t.state==WorldWind.POSSIBLE&&(this.requiredToFailByRecognizer(t)||!this.canRecognizeSimultaneouslyWith(t))},r.prototype.canBePreventedByRecognizer=function(t){return this!=t&&this.target==t.target&&t.state==WorldWind.RECOGNIZED&&(this.requiresRecognizerToFail(t)||!this.canRecognizeSimultaneouslyWith(t))},r.prototype.isWaitingForRecognizerToFail=function(t){return this!=t&&this.target==t.target&&t.state==WorldWind.POSSIBLE&&this.requiresRecognizerToFail(t)},r.prototype.addListener=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"GestureRecognizer","addListener","missingListener"));this.listenerList.push(i)},r.prototype.removeListener=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"GestureRecognizer","removeListener","missingListener"));var r=this.listenerList.indexOf(i);r!==-1&&this.listenerList.splice(r,1)},r.prototype.notifyListeners=function(){for(var t=0;t<this.listenerList.length;t++)this.listenerList[t].gestureStateChanged(this)},r.prototype.callGestureCallbacks=function(){for(var t=0,e=this._gestureCallbacks.length;t<e;t++)this._gestureCallbacks[t](this)},r.prototype.onGestureEvent=function(t){if(this.enabled&&(!t.defaultPrevented||this.state!==WorldWind.POSSIBLE)){var i,r;try{if("mousedown"===t.type)this.handleMouseDown(t);else if("mousemove"===t.type)this.handleMouseMove(t);else if("mouseup"===t.type)this.handleMouseUp(t);else if("touchstart"===t.type)for(i=0,r=t.changedTouches.length;i<r;i++)this.handleTouchStart(t.changedTouches.item(i));else if("touchmove"===t.type)for(i=0,r=t.changedTouches.length;i<r;i++)this.handleTouchMove(t.changedTouches.item(i));else if("touchcancel"===t.type)for(i=0,r=t.changedTouches.length;i<r;i++)this.handleTouchCancel(t.changedTouches.item(i));else if("touchend"===t.type)for(i=0,r=t.changedTouches.length;i<r;i++)this.handleTouchEnd(t.changedTouches.item(i));else"pointerdown"===t.type&&"mouse"===t.pointerType?this.handleMouseDown(t):"pointermove"===t.type&&"mouse"===t.pointerType?this.handleMouseMove(t):"pointercancel"===t.type&&"mouse"===t.pointerType||("pointerup"===t.type&&"mouse"===t.pointerType?this.handleMouseUp(t):"pointerdown"===t.type&&"touch"===t.pointerType?this.handleTouchStart(t):"pointermove"===t.type&&"touch"===t.pointerType?this.handleTouchMove(t):"pointercancel"===t.type&&"touch"===t.pointerType?this.handleTouchCancel(t):"pointerup"===t.type&&"touch"===t.pointerType?this.handleTouchEnd(t):e.logMessage(e.LEVEL_INFO,"GestureRecognizer","handleEvent","Unrecognized event type: "+t.type))}catch(t){e.logMessage(e.LEVEL_SEVERE,"GestureRecognizer","handleEvent","Error handling event.\n"+t.toString())}}},r.prototype.handleMouseDown=function(t){if(!("mousedown"==t.type&&this._touches.length>0)){var e=1<<t.button;e&0!=this._mouseButtonMask||(0==this._mouseButtonMask&&(this._clientX=t.clientX,this._clientY=t.clientY,this._clientStartX=t.clientX,this._clientStartY=t.clientY,this._translationX=0,this._translationY=0),this._mouseButtonMask|=e,this.mouseDown(t))}},r.prototype.handleMouseMove=function(t){if(0!=this._mouseButtonMask&&(this._clientX!=t.clientX||this._clientY!=t._clientY)){var e=t.clientX-this._clientStartX,i=t.clientY-this._clientStartY,r=this._translationWeight;this._clientX=t.clientX,this._clientY=t.clientY,this._translationX=this._translationX*(1-r)+e*r,this._translationY=this._translationY*(1-r)+i*r,this.mouseMove(t)}},r.prototype.handleMouseUp=function(t){var e=1<<t.button;e&0==this._mouseButtonMask||(this._mouseButtonMask&=~e,this.mouseUp(t),0==this._mouseButtonMask&&this.resetIfEventsEnded())},r.prototype.handleTouchStart=function(t){var e=new i(t.identifier||t.pointerId,t.clientX,t.clientY);this._touches.push(e),1==this._touches.length?(this._clientX=t.clientX,this._clientY=t.clientY,this._clientStartX=t.clientX,this._clientStartY=t.clientY,this._translationX=0,this._translationY=0,this._touchCentroidShiftX=0,this._touchCentroidShiftY=0):this.touchesAddedOrRemoved(),this.touchStart(e)},r.prototype.handleTouchMove=function(t){var e=this.indexOfTouchWithId(t.identifier||t.pointerId);if(e!=-1){var i=this._touches[e];if(i.clientX!=t.clientX||i.clientY!=t.clientY){i.clientX=t.clientX,i.clientY=t.clientY;var r=this.touchCentroid(),n=r.clientX-this._clientStartX+this._touchCentroidShiftX,o=r.clientY-this._clientStartY+this._touchCentroidShiftY,s=this._translationWeight;this._clientX=r.clientX,this._clientY=r.clientY,this._translationX=this._translationX*(1-s)+n*s,this._translationY=this._translationY*(1-s)+o*s,this.touchMove(i)}}},r.prototype.handleTouchCancel=function(t){var e=this.indexOfTouchWithId(t.identifier||t.pointerId);if(e!=-1){var i=this._touches[e];this._touches.splice(e,1),this.touchesAddedOrRemoved(),this.touchCancel(i),this.resetIfEventsEnded()}},r.prototype.handleTouchEnd=function(t){var e=this.indexOfTouchWithId(t.identifier||t.pointerId);if(e!=-1){var i=this._touches[e];this._touches.splice(e,1),this.touchesAddedOrRemoved(),this.touchEnd(i),this.resetIfEventsEnded()}},r.prototype.resetIfEventsEnded=function(){this._state!=WorldWind.POSSIBLE&&0==this._mouseButtonMask&&0==this._touches.length&&this.reset()},r.prototype.touchesAddedOrRemoved=function(){this._touchCentroidShiftX+=this._clientX,this._touchCentroidShiftY+=this._clientY;var t=this.touchCentroid();this._clientX=t.clientX,this._clientY=t.clientY,this._touchCentroidShiftX-=this._clientX,this._touchCentroidShiftY-=this._clientY},r.prototype.touchCentroid=function(){for(var t=0,e=0,i=0,r=this._touches.length;i<r;i++){var n=this._touches[i];t+=n.clientX/r,e+=n.clientY/r}return{clientX:t,clientY:e}},r.prototype.indexOfTouchWithId=function(t){for(var e=0,i=this._touches.length;e<i;e++)if(this._touches[e].identifier==t)return e;return-1},r}),i("gesture/ClickRecognizer",["../gesture/GestureRecognizer"],function(t){"use strict";var e=function(e,i){t.call(this,e,i),this.numberOfClicks=1,this.button=0,this.maxMouseMovement=5,this.maxClickDuration=500,this.maxClickInterval=400,this.clicks=[],this.timeout=null};return e.prototype=Object.create(t.prototype),e.prototype.reset=function(){t.prototype.reset.call(this),this.clicks=[],this.cancelFailAfterDelay()},e.prototype.mouseDown=function(t){if(this.state==WorldWind.POSSIBLE)if(this.button!=t.button)this.state=WorldWind.FAILED;else{var e={clientX:this.clientX,clientY:this.clientY};this.clicks.push(e),this.failAfterDelay(this.maxClickDuration)}},e.prototype.mouseMove=function(t){if(this.state==WorldWind.POSSIBLE){var e=this.translationX,i=this.translationY,r=Math.sqrt(e*e+i*i);r>this.maxMouseMovement&&(this.state=WorldWind.FAILED)}},e.prototype.mouseUp=function(t){if(this.state==WorldWind.POSSIBLE&&0==this.mouseButtonMask){var e=this.clicks.length;e==this.numberOfClicks?(this.clientX=this.clicks[0].clientX,this.clientY=this.clicks[0].clientY,this.state=WorldWind.RECOGNIZED):this.failAfterDelay(this.maxClickInterval)}},e.prototype.touchStart=function(t){this.state==WorldWind.POSSIBLE&&(this.state=WorldWind.FAILED)},e.prototype.failAfterDelay=function(t){var e=this;e.timeout&&window.clearTimeout(e.timeout),e.timeout=window.setTimeout(function(){e.timeout=null,e.state==WorldWind.POSSIBLE&&(e.state=WorldWind.FAILED)},t)},e.prototype.cancelFailAfterDelay=function(){var t=this;t.timeout&&(window.clearTimeout(t.timeout),t.timeout=null)},e}),i("gesture/DragRecognizer",["../gesture/GestureRecognizer"],function(t){"use strict";var e=function(e,i){t.call(this,e,i),this.button=0,this.interpretDistance=5};return e.prototype=Object.create(t.prototype),e.prototype.mouseMove=function(t){this.state==WorldWind.POSSIBLE?this.shouldInterpret()&&(this.shouldRecognize()?(this.translationX=0,this.translationY=0,this.state=WorldWind.BEGAN):this.state=WorldWind.FAILED):this.state!=WorldWind.BEGAN&&this.state!=WorldWind.CHANGED||(this.state=WorldWind.CHANGED)},e.prototype.mouseUp=function(t){0==this.mouseButtonMask&&(this.state==WorldWind.POSSIBLE?this.state=WorldWind.FAILED:this.state!=WorldWind.BEGAN&&this.state!=WorldWind.CHANGED||(this.state=WorldWind.ENDED))},e.prototype.touchStart=function(t){this.state==WorldWind.POSSIBLE&&(this.state=WorldWind.FAILED)},e.prototype.shouldInterpret=function(){var t=this.translationX,e=this.translationY,i=Math.sqrt(t*t+e*e);return i>this.interpretDistance},e.prototype.shouldRecognize=function(){var t=1<<this.button;return t==this.mouseButtonMask},e}),i("gesture/FlingRecognizer",["../gesture/GestureRecognizer"],function(t){"use strict";var e=function(e,i){t.call(this,e,i),this.minVelocity=200,this._stackLimit=5,this._positionStack=[]};return e.prototype=Object.create(t.prototype),e.prototype._pushEvent=function(t){this._positionStack.length>=this._stackLimit&&this._positionStack.shift(),this._positionStack.push({time:new Date,x:t.clientX,y:t.clientY})},e.prototype._getVelocity=function(){var t=this._positionStack.length;if(t<4)return{x:0,y:0};var e=this._positionStack[t-3],i=this._positionStack[t-2],r=this._positionStack[t-1];this._positionStack.length=0;var n=(r.time-i.time)/1e3,o=r.x-e.x,s=r.y-e.y;return{x:o/n,y:s/n}},e.prototype.mouseMove=function(t){this._pushEvent(t)},e.prototype.mouseUp=function(t){this._pushEvent(t),this._checkForFling()},e.prototype.touchMove=function(t){1===this.touchCount&&this._pushEvent(t)},e.prototype.touchCancel=function(t){this._positionStack.length=0},e.prototype.touchEnd=function(t){0===this.touchCount?(this._pushEvent(event),this._checkForFling()):this._positionStack.length=0},e.prototype._checkForFling=function(){var t=this._getVelocity();this.state===WorldWind.POSSIBLE&&(Math.abs(t.x)>this.minVelocity||Math.abs(t.y)>this.minVelocity)&&(this.state=WorldWind.RECOGNIZED)},e}),i("gesture/PanRecognizer",["../gesture/GestureRecognizer"],function(t){"use strict";var e=function(e,i){t.call(this,e,i),this.minNumberOfTouches=1,this.maxNumberOfTouches=Number.MAX_VALUE,this.interpretDistance=20};return e.prototype=Object.create(t.prototype),e.prototype.mouseDown=function(t){this.state==WorldWind.POSSIBLE&&(this.state=WorldWind.FAILED)},e.prototype.touchMove=function(t){this.state==WorldWind.POSSIBLE?this.shouldInterpret()&&(this.shouldRecognize()?this.state=WorldWind.BEGAN:this.state=WorldWind.FAILED):this.state!=WorldWind.BEGAN&&this.state!=WorldWind.CHANGED||(this.state=WorldWind.CHANGED)},e.prototype.touchEnd=function(t){0==this.touchCount&&(this.state==WorldWind.POSSIBLE?this.state=WorldWind.FAILED:this.state!=WorldWind.BEGAN&&this.state!=WorldWind.CHANGED||(this.state=WorldWind.ENDED))},e.prototype.touchCancel=function(t){0==this.touchCount&&(this.state==WorldWind.POSSIBLE?this.state=WorldWind.FAILED:this.state!=WorldWind.BEGAN&&this.state!=WorldWind.CHANGED||(this.state=WorldWind.CANCELLED))},e.prototype.prepareToRecognize=function(){this.translationX=0,this.translationY=0},e.prototype.shouldInterpret=function(){var t=this.translationX,e=this.translationY,i=Math.sqrt(t*t+e*e);return i>this.interpretDistance},e.prototype.shouldRecognize=function(){var t=this.touchCount;return 0!=t&&t>=this.minNumberOfTouches&&t<=this.maxNumberOfTouches},e}),i("gesture/PinchRecognizer",["../gesture/GestureRecognizer"],function(t){"use strict";var e=function(e,i){t.call(this,e,i),this._scale=1,this._offsetScale=1,this.referenceDistance=0,this.interpretThreshold=20,this.weight=.4,this.pinchTouches=[]};return e.prototype=Object.create(t.prototype),Object.defineProperties(e.prototype,{scale:{get:function(){return this._scale*this._offsetScale}}}),e.prototype.reset=function(){t.prototype.reset.call(this),this._scale=1,this._offsetScale=1,this.referenceDistance=0,this.pinchTouches=[]},e.prototype.mouseDown=function(t){this.state==WorldWind.POSSIBLE&&(this.state=WorldWind.FAILED)},e.prototype.touchStart=function(t){this.pinchTouches.length<2&&2==this.pinchTouches.push(t)&&(this.referenceDistance=this.currentPinchDistance(),this._offsetScale*=this._scale,this._scale=1)},e.prototype.touchMove=function(t){if(2==this.pinchTouches.length)if(this.state==WorldWind.POSSIBLE)this.shouldRecognize()&&(this.state=WorldWind.BEGAN);else if(this.state==WorldWind.BEGAN||this.state==WorldWind.CHANGED){var e=this.currentPinchDistance(),i=Math.abs(e/this.referenceDistance),r=this.weight;this._scale=this._scale*(1-r)+i*r,this.state=WorldWind.CHANGED}},e.prototype.touchEnd=function(t){var e=this.pinchTouches.indexOf(t);e!=-1&&this.pinchTouches.splice(e,1),0==this.touchCount&&(this.state==WorldWind.POSSIBLE?this.state=WorldWind.FAILED:this.state!=WorldWind.BEGAN&&this.state!=WorldWind.CHANGED||(this.state=WorldWind.ENDED))},e.prototype.touchCancel=function(t){var e=this.pinchTouches.indexOf(t);e!=-1&&this.pinchTouches.splice(e,1),0==this.touchCount&&(this.state==WorldWind.POSSIBLE?this.state=WorldWind.FAILED:this.state!=WorldWind.BEGAN&&this.state!=WorldWind.CHANGED||(this.state=WorldWind.CANCELLED));
},e.prototype.prepareToRecognize=function(){this.referenceDistance=this.currentPinchDistance(),this._scale=1},e.prototype.shouldRecognize=function(){var t=this.currentPinchDistance();return Math.abs(t-this.referenceDistance)>this.interpretThreshold},e.prototype.currentPinchDistance=function(){var t=this.pinchTouches[0],e=this.pinchTouches[1],i=t.clientX-e.clientX,r=t.clientY-e.clientY;return Math.sqrt(i*i+r*r)},e}),i("gesture/RotationRecognizer",["../geom/Angle","../gesture/GestureRecognizer"],function(t,e){"use strict";var i=function(t,i){e.call(this,t,i),this._rotation=0,this._offsetRotation=0,this.referenceAngle=0,this.interpretThreshold=20,this.weight=.4,this.rotationTouches=[]};return i.prototype=Object.create(e.prototype),Object.defineProperties(i.prototype,{rotation:{get:function(){return this._rotation+this._offsetRotation}}}),i.prototype.reset=function(){e.prototype.reset.call(this),this._rotation=0,this._offsetRotation=0,this.referenceAngle=0,this.rotationTouches=[]},i.prototype.mouseDown=function(t){this.state==WorldWind.POSSIBLE&&(this.state=WorldWind.FAILED)},i.prototype.touchStart=function(t){this.rotationTouches.length<2&&2==this.rotationTouches.push(t)&&(this.referenceAngle=this.currentTouchAngle(),this._offsetRotation+=this._rotation,this._rotation=0)},i.prototype.touchMove=function(e){if(2==this.rotationTouches.length)if(this.state==WorldWind.POSSIBLE)this.shouldRecognize()&&(this.state=WorldWind.BEGAN);else if(this.state==WorldWind.BEGAN||this.state==WorldWind.CHANGED){var i=this.currentTouchAngle(),r=t.normalizedDegrees(i-this.referenceAngle),n=this.weight;this._rotation=this._rotation*(1-n)+r*n,this.state=WorldWind.CHANGED}},i.prototype.touchEnd=function(t){var e=this.rotationTouches.indexOf(t);e!=-1&&this.rotationTouches.splice(e,1),0==this.touchCount&&(this.state==WorldWind.POSSIBLE?this.state=WorldWind.FAILED:this.state!=WorldWind.BEGAN&&this.state!=WorldWind.CHANGED||(this.state=WorldWind.ENDED))},i.prototype.touchCancel=function(t){var e=this.rotationTouches.indexOf(t);e!=-1&&(this.rotationTouches.splice(e,1),0==this.touchCount&&(this.state==WorldWind.POSSIBLE?this.state=WorldWind.FAILED:this.state!=WorldWind.BEGAN&&this.state!=WorldWind.CHANGED||(this.state=WorldWind.CANCELLED)))},i.prototype.prepareToRecognize=function(){this.referenceAngle=this.currentTouchAngle(),this._rotation=0},i.prototype.shouldRecognize=function(){var e=this.currentTouchAngle(),i=t.normalizedDegrees(e-this.referenceAngle);return Math.abs(i)>this.interpretThreshold},i.prototype.currentTouchAngle=function(){var e=this.rotationTouches[0],i=this.rotationTouches[1],r=e.clientX-i.clientX,n=e.clientY-i.clientY;return Math.atan2(n,r)*t.RADIANS_TO_DEGREES},i}),i("gesture/TapRecognizer",["../gesture/GestureRecognizer"],function(t){"use strict";var e=function(e,i){t.call(this,e,i),this.numberOfTaps=1,this.numberOfTouches=1,this.maxTouchMovement=20,this.maxTapDuration=500,this.maxTapInterval=400,this.taps=[],this.timeout=null};return e.prototype=Object.create(t.prototype),e.prototype.reset=function(){t.prototype.reset.call(this),this.taps=[],this.cancelFailAfterDelay()},e.prototype.mouseDown=function(t){this.state==WorldWind.POSSIBLE&&(this.state=WorldWind.FAILED)},e.prototype.touchStart=function(t){if(this.state==WorldWind.POSSIBLE){var e;this.touchCount>this.numberOfTouches?this.state=WorldWind.FAILED:1==this.touchCount?(e={touchCount:this.touchCount,clientX:this.clientX,clientY:this.clientY},this.taps.push(e),this.failAfterDelay(this.maxTapDuration)):(e=this.taps[this.taps.length-1],e.touchCount=this.touchCount,e.clientX=this.clientX,e.clientY=this.clientY)}},e.prototype.touchMove=function(t){if(this.state==WorldWind.POSSIBLE){var e=this.translationX,i=this.translationY,r=Math.sqrt(e*e+i*i);r>this.maxTouchMovement&&(this.state=WorldWind.FAILED)}},e.prototype.touchEnd=function(t){if(this.state==WorldWind.POSSIBLE&&0==this.touchCount){var e=this.taps.length,i=this.taps[e-1];i.touchCount!=this.numberOfTouches?this.state=WorldWind.FAILED:e==this.numberOfTaps?(this.clientX=this.taps[0].clientX,this.clientY=this.taps[0].clientY,this.state=WorldWind.RECOGNIZED):this.failAfterDelay(this.maxTapInterval)}},e.prototype.touchCancel=function(t){this.state==WorldWind.POSSIBLE&&(this.state=WorldWind.FAILED)},e.prototype.failAfterDelay=function(t){var e=this;e.timeout&&window.clearTimeout(e.timeout),e.timeout=window.setTimeout(function(){e.timeout=null,e.state==WorldWind.POSSIBLE&&(e.state=WorldWind.FAILED)},t)},e.prototype.cancelFailAfterDelay=function(){var t=this;t.timeout&&(window.clearTimeout(t.timeout),t.timeout=null)},e}),i("gesture/TiltRecognizer",["../gesture/PanRecognizer"],function(t){"use strict";var e=function(e,i){t.call(this,e,i),this.maxTouchDistance=250,this.maxTouchDivergence=50};return e.LEFT=1,e.RIGHT=2,e.UP=4,e.DOWN=8,e.prototype=Object.create(t.prototype),e.prototype.shouldInterpret=function(){for(var t=0,e=this.touchCount;t<e;t++){var i=this.touch(t),r=i.translationX,n=i.translationY,o=Math.sqrt(r*r+n*n);if(o>this.interpretDistance)return!0}return!1},e.prototype.shouldRecognize=function(){var t=this.touchCount;if(t<2)return!1;var i=this.touch(0),r=this.touch(1),n=i.clientX-r.clientX,o=i.clientY-r.clientY,s=Math.sqrt(n*n+o*o);if(s>this.maxTouchDistance)return!1;var a=i.translationX-r.translationX,l=i.translationY-r.translationY,h=Math.sqrt(a*a+l*l);if(h>this.maxTouchDivergence)return!1;var u=e.UP|e.DOWN,c=this.touchDirection(i)&u,d=this.touchDirection(r)&u;return 0!=(c&d)},e.prototype.touchDirection=function(t){var i=t.translationX,r=t.translationY,n=0;return Math.abs(i)>Math.abs(r)?(n|=i<0?e.LEFT:0,n|=i>0?e.RIGHT:0):(n|=r<0?e.UP:0,n|=r>0?e.DOWN:0),n},e}),i("WorldWindowController",["./error/ArgumentError","./util/Logger","./error/UnsupportedOperationError"],function(t,e,i){"use strict";var r=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WorldWindowController","constructor","missingWorldWindow"));this.wwd=i,this.allGestureListeners=[]};return r.prototype.onGestureEvent=function(t){for(var e=!1,i=0;i<this.allGestureListeners.length&&!e;i++)e|=this.allGestureListeners[i].onGestureEvent(t);return e},r.prototype.gestureStateChanged=function(t){throw new i(e.logMessage(e.LEVEL_SEVERE,"WorldWindowController","gestureStateChanged","abstractInvocation"))},r.prototype.addGestureListener=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WorldWindowController","addGestureListener","missingListener"));this.allGestureListeners.push(i)},r.prototype.removeGestureListener=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WorldWindowController","removeGestureListener","missingListener"));var r=this.allGestureListeners.indexOf(i);r!==-1&&this.allGestureListeners.splice(r,1)},r.prototype.applyLimits=function(){},r}),i("BasicWorldWindowController",["./geom/Angle","./ArcBallCamera","./error/ArgumentError","./gesture/ClickRecognizer","./gesture/DragRecognizer","./gesture/FlingRecognizer","./gesture/GestureRecognizer","./geom/Line","./geom/Location","./util/Logger","./geom/Matrix","./util/measure/MeasurerUtils","./gesture/PanRecognizer","./gesture/PinchRecognizer","./geom/Position","./gesture/RotationRecognizer","./gesture/TapRecognizer","./gesture/TiltRecognizer","./geom/Vec2","./geom/Vec3","./WorldWindowController","./util/WWMath"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_,b){"use strict";var w=function(t){_.call(this,t),this.zoomToMouseEnabled=!0,this.keepNorthUp=!0,this.primaryDragRecognizer=new n(this.wwd,null),this.primaryDragRecognizer.addListener(this),this.secondaryDragRecognizer=new n(this.wwd,null),this.secondaryDragRecognizer.addListener(this),this.secondaryDragRecognizer.button=2,this.panRecognizer=new d(this.wwd,null),this.panRecognizer.addListener(this),this.pinchRecognizer=new p(this.wwd,null),this.pinchRecognizer.addListener(this),this.rotationRecognizer=new g(this.wwd,null),this.rotationRecognizer.addListener(this),this.tiltRecognizer=new y(this.wwd,null),this.tiltRecognizer.addListener(this),this.panRecognizer.recognizeSimultaneouslyWith(this.pinchRecognizer),this.panRecognizer.recognizeSimultaneouslyWith(this.rotationRecognizer),this.pinchRecognizer.recognizeSimultaneouslyWith(this.rotationRecognizer),this.panRecognizer.requireRecognizerToFail(this.tiltRecognizer),this.pinchRecognizer.requireRecognizerToFail(this.tiltRecognizer),this.rotationRecognizer.requireRecognizerToFail(this.tiltRecognizer),this.tapRecognizer=new m(this.wwd,null),this.tapRecognizer.addListener(this),this.clickRecognizer=new r(this.wwd,null),this.clickRecognizer.addListener(this),this.flingRecognizer=new o(this.wwd,null),this.flingRecognizer.addListener(this),this.flingRecognizer.recognizeSimultaneouslyWith(this.primaryDragRecognizer),this.flingRecognizer.recognizeSimultaneouslyWith(this.panRecognizer),this.flingRecognizer.recognizeSimultaneouslyWith(this.pinchRecognizer),this.flingRecognizer.recognizeSimultaneouslyWith(this.rotationRecognizer),this.beginPoint=new E(0,0),this.lastPoint=new E(0,0),this.beginHeading=0,this.beginTilt=0,this.beginRange=0,this.lastRotation=0,this.pointerLocation=null,this.dragDelta=new E(0,0),this.dragLastLocation=new l(0,0),this.flingAnimationId=-1,this.beginIntersectionPoint=new v(0,0,0),this.lastIntersectionPoint=new v(0,0,0),this.beginIntersectionPosition=new f(0,0,0),this.lastIntersectionPosition=new f(0,0,0),this.rotationVector=new v(0,0,0),this.scratchRay=new a(new v(0,0,0),new v(0,0,0)),this.scratchMatrix=u.fromIdentity(),this.doubleClick=!1,this.longClick=!1,this.readyToDetectLongClickBeforeMove=!1,this.lastClickTime=0};return w.prototype=Object.create(_.prototype),w.prototype.onGestureEvent=function(t){var e=_.prototype.onGestureEvent.call(this,t);if(("mousemove"===t.type||"mouse"===t.pointerType&&"pointermove"===t.type)&&(this.pointerLocation=null),"pointermove"===t.type&&this.readyToDetectLongClickBeforeMove&&(this.longClick=t.timeStamp-this.lastClickTime>1e3,this.readyToDetectLongClickBeforeMove=!1),"pointerup"===t.type&&(this.doubleClick=!1),"pointerdown"===t.type&&(this.doubleClick||(this.doubleClick=t.timeStamp-this.lastClickTime<300),this.readyToDetectLongClickBeforeMove=!0,this.lastClickTime=t.timeStamp,this.cancelFlingAnimation(),this.longClick=!1),!e)if("wheel"===t.type)e=!0,this.handleWheelEvent(t);else for(var i=0,r=s.allRecognizers.length;i<r;i++){var n=s.allRecognizers[i];n.target===this.wwd&&(e|=n.onGestureEvent(t))}return e},w.prototype.gestureStateChanged=function(t){t.state!==WorldWind.BEGAN&&t.state!==WorldWind.RECOGNIZED||this.cancelFlingAnimation();var i=this.wwd.navigator.camera instanceof e;t===this.primaryDragRecognizer||t===this.panRecognizer?i?this.handlePanOrDrag(t):this.handleSecondaryDrag(t):t===this.secondaryDragRecognizer?i&&this.handleSecondaryDrag(t):t===this.pinchRecognizer?this.handlePinch(t):t===this.rotationRecognizer?this.handleRotation(t):t===this.tiltRecognizer?this.handleTilt(t):t===this.clickRecognizer||t===this.tapRecognizer?this.handleClickOrTap(t):t===this.flingRecognizer&&this.handleFling(t)},w.prototype.handleClickOrTap=function(t){},w.prototype.handlePanOrDrag=function(t){this.doubleClick?this.handleDoubleClickDragOrPan(t):this.wwd.globe.is2D()?this.handlePanOrDrag2D(t):this.handlePanOrDrag3D(t)},w.prototype.handlePanOrDrag3D=function(e){var i=this.wwd,r=e.state,n=e.clientX,o=e.clientY;if(r===WorldWind.BEGAN){this.cancelFlingAnimation();var s=i.rayThroughScreenPoint(i.canvasCoordinates(n,o));if(!i.globe.intersectsLine(s,this.beginIntersectionPoint))return;i.globe.computePositionFromPoint(this.beginIntersectionPoint[0],this.beginIntersectionPoint[1],this.beginIntersectionPoint[2],this.beginIntersectionPosition),this.beginPoint.set(n,o),this.lastPoint.set(n,o)}else if(r===WorldWind.CHANGED){var a=this.move3D(n,o);a&&(this.beginPoint.copy(this.lastPoint),this.lastPoint.set(n,o),this.applyLimits(),this.dragDelta.set(this.dragLastLocation.latitude-i.navigator.lookAtLocation.latitude,t.normalizedDegreesLongitude(this.dragLastLocation.longitude-i.navigator.lookAtLocation.longitude)),this.dragLastLocation.copy(i.navigator.lookAtLocation),i.redraw())}},w.prototype.move3D=function(t,e){var i=this.wwd,r=i.rayThroughScreenPoint(i.canvasCoordinates(t,e));if(!i.globe.intersectsLine(r,this.lastIntersectionPoint))return!1;if(i.globe.computePositionFromPoint(this.lastIntersectionPoint[0],this.lastIntersectionPoint[1],this.lastIntersectionPoint[2],this.lastIntersectionPosition),this.isSphereRotation(this.lastIntersectionPosition)){console.log("sphere rotation");var n=this.computeRotationVectorAndAngle(this.beginIntersectionPoint,this.lastIntersectionPoint,this.rotationVector),o=!1;return this.rotateShpere(this.rotationVector,n,o)}var s=this.lastIntersectionPosition.latitude-this.beginIntersectionPosition.latitude,a=this.lastIntersectionPosition.longitude-this.beginIntersectionPosition.longitude,l=i.navigator.lookAtLocation;return l.latitude-=s,l.longitude-=a,!0},w.prototype.isSphereRotation=function(t){var e=this.wwd.navigator.lookAtLocation.latitude,i=this.wwd.navigator.heading;return(0!==i||Math.abs(e)>75||Math.abs(t.latitude)>75)&&!this.keepNorthUp},w.prototype.computeRotationVectorAndAngle=function(e,i,r){var n=c.angleBetweenVectors(e,i),o=n*t.RADIANS_TO_DEGREES;return r.copy(e),r.cross(i),r.normalize(),o},w.prototype.rotateShpere=function(t,e,i){if(!(isFinite(e)&&isFinite(t[0])&&isFinite(t[1])&&isFinite(t[2])))return!1;var r=this.wwd,n=r.navigator,o=this.scratchMatrix,s=n.lookAtLocation.altitude,a=n.tilt;if(n.tilt=0,r.computeViewingTransform(null,o),o.multiplyByRotation(t[0],t[1],t[2],e),o.extractEyePoint(this.scratchRay.origin),o.extractForwardVector(this.scratchRay.direction),!r.globe.intersectsLine(this.scratchRay,this.lastIntersectionPoint))return n.tilt=a,!1;var l=o.extractViewingParameters(this.lastIntersectionPoint,n.roll,r.globe,{});return!i&&Math.abs(n.heading)<5&&Math.abs(n.lookAtLocation.latitude<70)&&Math.abs(this.lastIntersectionPosition.latitude)<70?n.heading=Math.round(l.heading):n.heading=l.heading,n.lookAtLocation.copy(l.origin),n.lookAtLocation.altitude=s,n.tilt=a,!0},w.prototype.handlePanOrDrag2D=function(t){var e=t.state,i=t.clientX,r=t.clientY,n=t.translationX,o=t.translationY;this.wwd.navigator;e===WorldWind.BEGAN?(this.beginPoint.set(i,r),this.lastPoint.set(i,r)):e===WorldWind.CHANGED&&this.move2D(n,o)},w.prototype.move2D=function(t,e){var i=this.wwd.navigator,r=this.lastPoint[0],n=this.lastPoint[1],o=this.beginPoint[0]+t,s=this.beginPoint[1]+e;this.lastPoint.set(o,s);var a=this.wwd.globe,l=this.wwd.rayThroughScreenPoint(this.wwd.canvasCoordinates(r,n)),h=new v(0,0,0),c=new v(0,0,0),d=new v(0,0,0);if(a.intersectsLine(l,h)&&(l=this.wwd.rayThroughScreenPoint(this.wwd.canvasCoordinates(o,s)),a.intersectsLine(l,c))){var p=u.fromIdentity();if(this.wwd.computeViewingTransform(null,p),p.multiplyByTranslation(c[0]-h[0],c[1]-h[1],c[2]-h[2]),p.extractEyePoint(l.origin),p.extractForwardVector(l.direction),a.intersectsLine(l,d)){var f=p.extractViewingParameters(d,i.roll,a,{});i.lookAtLocation.copy(f.origin),i.range=f.range,i.heading=f.heading,i.tilt=f.tilt,i.roll=f.roll,this.applyLimits(),this.wwd.redraw(),this.dragDelta.set(r-o,n-s),this.dragLastLocation.copy(i.lookAtLocation)}}},w.prototype.handleFling=function(t){this.wwd.globe.is2D()?this.handleFling2D(t):this.handleFling3D(t)},w.prototype.handleFling2D=function(t){if(t.state===WorldWind.RECOGNIZED){var e=this.wwd,i=e.navigator,r=1500;this.beginPoint.copy(this.lastPoint);var n=new l;n.copy(this.dragLastLocation);var o=new Date,s=this.dragDelta[0],a=this.dragDelta[1],h=s,u=a,c=this,d=function(){if(c.flingAnimationId=-1,n.equals(i.lookAtLocation)){var t=(new Date-o)/r;t=t>1?1:t;var e=Math.sin(t*Math.PI/2);h-=s-s*e,u-=a-a*e,c.move2D(h,u),n.copy(i.lookAtLocation),t<1&&(c.flingAnimationId=requestAnimationFrame(d))}};this.flingAnimationId=requestAnimationFrame(d)}},w.prototype.handleFling3D=function(t){if(t.state===WorldWind.RECOGNIZED){var e=this.wwd.navigator,i=1500,r=new E;r.copy(this.dragDelta);var n=new l;n.copy(this.dragLastLocation);var o=this.wwd,s=0,a=o.rayThroughScreenPoint(o.canvasCoordinates(this.lastPoint[0],this.lastPoint[1]));if(!o.globe.intersectsLine(a,this.lastIntersectionPoint))return void console.log("lost1!");o.globe.computePositionFromPoint(this.lastIntersectionPoint[0],this.lastIntersectionPoint[1],this.lastIntersectionPoint[2],this.lastIntersectionPosition);var h=this.isSphereRotation(this.lastIntersectionPosition);if(h){var a=o.rayThroughScreenPoint(o.canvasCoordinates(this.beginPoint[0],this.beginPoint[1]));if(!o.globe.intersectsLine(a,this.beginIntersectionPoint))return void console.log("lost2!");if(s=this.computeRotationVectorAndAngle(this.beginIntersectionPoint,this.lastIntersectionPoint,this.rotationVector),!(isFinite(s)&&isFinite(this.rotationVector[0])&&isFinite(this.rotationVector[1])&&isFinite(this.rotationVector[2])))return void console.log("lost3!")}var u=new Date,c=this,d=function(){if(c.flingAnimationId=-1,n.equals(e.lookAtLocation)){var t=(new Date-u)/(c.longClick?6e6:i);t=t>1?1:t;var o=Math.sin(t*Math.PI/2);if(h){var a=s*(1-o),l=!0;c.rotateShpere(c.rotationVector,a,l)}else{var p=r[0]-r[0]*o,f=r[1]-r[1]*o;e.lookAtLocation.latitude-=p,e.lookAtLocation.longitude-=f}c.applyLimits(),c.wwd.redraw(),n.copy(e.lookAtLocation),t<1&&(c.flingAnimationId=requestAnimationFrame(d))}};this.flingAnimationId=requestAnimationFrame(d)}},w.prototype.cancelFlingAnimation=function(){this.flingAnimationId!==-1&&(cancelAnimationFrame(this.flingAnimationId),this.flingAnimationId=-1)},w.prototype.handleSecondaryDrag=function(t){var e=t.state,i=t.translationX,r=t.translationY,n=this.wwd.navigator;if(e===WorldWind.BEGAN)this.beginHeading=n.heading,this.beginTilt=n.tilt;else if(e===WorldWind.CHANGED){var o=180*i/this.wwd.canvas.clientWidth,s=90*r/this.wwd.canvas.clientHeight;n.heading=this.beginHeading+o,n.tilt=this.beginTilt+s,this.applyLimits(),this.wwd.redraw()}},w.prototype.handlePinch=function(t){var e=this.wwd.navigator,i=t.state,r=t.scale;if(i===WorldWind.BEGAN)this.beginRange=e.range,this.pointerLocation=null;else if(i===WorldWind.CHANGED&&0!==r){var n=this.beginRange/r,o=n/e.range;this.moveZoom(t.clientX,t.clientY,o),e.range=n,this.applyLimits(),this.wwd.redraw()}},w.prototype.handleRotation=function(t){var e=this.wwd.navigator,i=t.state,r=t.rotation;i===WorldWind.BEGAN?this.lastRotation=0:i===WorldWind.CHANGED&&(e.heading-=r-this.lastRotation,this.lastRotation=r,this.applyLimits(),this.wwd.redraw())},w.prototype.handleTilt=function(t){var e=this.wwd.navigator,i=t.state,r=t.translationY;if(i===WorldWind.BEGAN)this.beginTilt=e.tilt;else if(i===WorldWind.CHANGED){var n=-90*r/this.wwd.canvas.clientHeight;e.tilt=this.beginTilt+n,this.applyLimits(),this.wwd.redraw()}},w.prototype.handleDoubleClickDragOrPan=function(t){var e=t.state,i=t.clientX,r=t.clientY;if(e===WorldWind.BEGAN)this.beginPoint.set(i,r),this.lastPoint.set(i,r);else if(e===WorldWind.CHANGED){var n=r-this.lastPoint[1],o=this.wwd.navigator,s=1+n/300;this.lastPoint.set(i,r),this.moveZoom(this.beginPoint[0],this.beginPoint[1],s),o.range*=s,this.applyLimits(),this.wwd.redraw()}},w.prototype.handleWheelEvent=function(t){this.cancelFlingAnimation();var e,i=this.wwd.navigator;t.deltaMode===WheelEvent.DOM_DELTA_PIXEL?e=t.deltaY:t.deltaMode===WheelEvent.DOM_DELTA_LINE?e=40*t.deltaY:t.deltaMode===WheelEvent.DOM_DELTA_PAGE&&(e=400*t.deltaY);var r=1+e/1e3;this.moveZoom(t.clientX,t.clientY,r),i.range*=r,this.applyLimits(),this.wwd.redraw()},w.prototype.locationAtPickPoint=function(t,e){for(var i=this.wwd.canvasCoordinates(t,e),r=this.wwd.pickTerrain(i),n=0;n<r.objects.length;n++){var o=r.objects[n];if(o.isTerrain){var s=o.position;if(s)return new l(s.latitude,s.longitude)}}},w.prototype.moveZoom=function(t,e,i){if(this.zoomToMouseEnabled&&1!==i&&(this.pointerLocation||(this.pointerLocation=this.locationAtPickPoint(t,e)),this.pointerLocation)){var r,n=this.wwd.navigator.lookAtLocation;if(i<1){var o=l.greatCircleDistance(n,this.pointerLocation)*this.wwd.globe.equatorialRadius;r=o<=5e4?this.pointerLocation:l.interpolateGreatCircle(i,this.pointerLocation,n,new l(0,0))}else{var s=l.interpolateGreatCircle(1/i,this.pointerLocation,n,new l(0,0)),a=l.greatCircleDistance(n,s),h=l.greatCircleAzimuth(n,s);r=l.greatCircleLocation(n,h-180,a,new l(0,0))}n.latitude=r.latitude,n.longitude=r.longitude}},w.prototype.applyLimits=function(){this.wwd.navigator.camera.applyLimits()},w}),i("util/ImageSource",["../error/ArgumentError","../util/Color","../util/Logger"],function(t,e,i){"use strict";var r=function(e){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"ImageSource","constructor","missingImage"));this.image=e,this.key="ImageSource "+ ++r.keyPool};return r.keyPool=0,r}),i("shapes/ScreenImage",["../error/ArgumentError","../shaders/BasicTextureProgram","../util/Color","../util/ImageSource","../util/Logger","../geom/Matrix","../util/Offset","../pick/PickedObject","../render/Renderable","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o,s,a,l,h,u){"use strict";var c=function(e,r){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"ScreenImage","constructor","missingOffset"));if(!r)throw new t(n.logMessage(n.LEVEL_SEVERE,"ScreenImage","constructor","missingImage"));l.call(this),this.screenOffset=e,this._imageSource=r,this.imageColor=i.WHITE,this.imageOffset=new s(WorldWind.OFFSET_FRACTION,.5,WorldWind.OFFSET_FRACTION,.5),this.imageScale=1,this.imageRotation=0,this.imageTilt=0,this.enabled=!0,this.opacity=1,this.pickDelegate=null,this.activeTexture=null,this.imageTransform=o.fromIdentity(),this.texCoordMatrix=o.fromIdentity(),this.imageBounds=null,this.layer=null};return c.matrix=o.fromIdentity(),c.prototype=Object.create(l.prototype),Object.defineProperties(c.prototype,{imageSource:{get:function(){return this._imageSource},set:function(e){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"ScreenImage","imageSource","missingImage"));this._imageSource=e,this.imageSourceWasUpdated=!0}}}),c.prototype.render=function(t){if(this.enabled&&t.accumulateOrderedRenderables){var e=null;this.lastFrameTime!==t.timestamp&&(e=this.makeOrderedRenderable(t)),e&&e.isVisible(t)&&(e.layer=t.currentLayer,this.lastFrameTime=t.timestamp,t.addOrderedRenderable(e))}},c.prototype.renderOrdered=function(t){if(this.drawOrderedScreenImage(t),t.pickingMode){var e=new a(this.pickColor.clone(),this.pickDelegate?this.pickDelegate:this,null,this.layer,!1);t.resolvePick(e)}},c.prototype.makeOrderedRenderable=function(t){var e,i,r,n,o,s,a;return this.activeTexture=this.getActiveTexture(t),this.activeTexture&&!this.imageSourceWasUpdated||(this.activeTexture=t.gpuResourceCache.retrieveTexture(t.currentGlContext,this._imageSource),this.activeTexture)?(this.eyeDistance=0,e=this.activeTexture.imageWidth,i=this.activeTexture.imageHeight,r=this.imageScale,s=this.imageOffset.offsetForSize(e,i),n=t.viewport.width,o=t.viewport.height,a=this.screenOffset.offsetForSize(n,o),this.imageTransform.setTranslation(a[0]-s[0]*r,a[1]-s[1]*r,0),this.imageTransform.setScale(e*r,i*r,1),this.imageBounds=u.boundingRectForUnitQuad(this.imageTransform),this):null},c.prototype.getActiveTexture=function(t){return t.gpuResourceCache.resourceForKey(this._imageSource)},c.prototype.isVisible=function(t){return t.pickingMode?t.pickRectangle&&this.imageBounds.intersects(t.pickRectangle):this.imageBounds.intersects(t.viewport)},c.prototype.drawOrderedScreenImage=function(t){this.beginDrawing(t);try{this.doDrawOrderedScreenImage(t)}finally{this.endDrawing(t)}},c.prototype.beginDrawing=function(t){var i,r=t.currentGlContext;t.findAndBindProgram(e),i=t.currentProgram,r.bindBuffer(r.ARRAY_BUFFER,t.unitQuadBuffer()),r.vertexAttribPointer(i.vertexTexCoordLocation,2,r.FLOAT,!1,0,0),r.enableVertexAttribArray(i.vertexPointLocation),r.enableVertexAttribArray(i.vertexTexCoordLocation),i.loadTextureUnit(r,r.TEXTURE0),i.loadModulateColor(r,t.pickingMode),r.disable(r.DEPTH_TEST)},c.prototype.endDrawing=function(t){var e=t.currentGlContext,i=t.currentProgram;e.disableVertexAttribArray(i.vertexPointLocation),e.disableVertexAttribArray(i.vertexTexCoordLocation),e.bindBuffer(e.ARRAY_BUFFER,null),e.bindTexture(e.TEXTURE_2D,null),e.enable(e.DEPTH_TEST)},c.prototype.doDrawOrderedScreenImage=function(t){var e=t.currentGlContext,i=t.currentProgram;e.bindBuffer(e.ARRAY_BUFFER,t.unitQuadBuffer3()),e.vertexAttribPointer(i.vertexPointLocation,3,e.FLOAT,!1,0,0),c.matrix.copy(t.screenProjection),c.matrix.multiplyMatrix(this.imageTransform),c.matrix.multiplyByTranslation(.5,.5,.5),c.matrix.multiplyByRotation(1,0,0,this.imageTilt),c.matrix.multiplyByRotation(0,0,1,this.imageRotation),c.matrix.multiplyByTranslation(-.5,-.5,0),i.loadModelviewProjection(e,c.matrix),i.loadTextureEnabled(e,!0),t.pickingMode?(this.pickColor=t.uniquePickColor(),i.loadColor(e,this.pickColor),i.loadOpacity(e,1)):(i.loadColor(e,this.imageColor),i.loadOpacity(e,this.opacity*this.layer.opacity)),this.texCoordMatrix.setToIdentity(),this.texCoordMatrix.multiplyByTextureTransform(this.activeTexture),i.loadTextureMatrix(e,this.texCoordMatrix),this.activeTexture.bind(t)&&e.drawArrays(e.TRIANGLE_STRIP,0,4)},c}),i("render/TextureTile",["../error/ArgumentError","../util/Logger","../util/Tile"],function(t,e,i){"use strict";var r=function(t,e,r,n){i.call(this,t,e,r,n),this.gpuCacheKey=null};return r.prototype=Object.create(i.prototype),r.prototype.size=function(){return i.prototype.size.call(this)},r.prototype.bind=function(t){var e=t.gpuResourceCache.resourceForKey(this.gpuCacheKey);return!!e&&e.bind(t)},r.prototype.applyInternalTransform=function(t,e){},r}),i("render/ImageTile",["../error/ArgumentError","../util/Logger","../render/TextureTile","../util/Tile"],function(t,e,i,r){"use strict";var n=function(r,n,o,s,a){if(!a||a.length<1)throw new t(e.logMessage(e.LEVEL_SEVERE,"ImageTile","constructor","The specified image path is null, undefined or zero length."));i.call(this,r,n,o,s),this.imagePath=a,this.fallbackTile=null,this.gpuCacheKey=a};return n.prototype=Object.create(i.prototype),n.prototype.size=function(){return this.__proto__.__proto__.size.call(this)+this.imagePath.length+8},n.prototype.bind=function(t){var e=this.__proto__.__proto__.bind.call(this,t);return!!e||!!this.fallbackTile&&this.fallbackTile.bind(t)},n.prototype.applyInternalTransform=function(t,e){this.fallbackTile&&!t.gpuResourceCache.resourceForKey(this.imagePath)&&this.applyFallbackTransform(e)},n.prototype.applyFallbackTransform=function(t){var e=this.level.levelNumber-this.fallbackTile.level.levelNumber;if(!(e<=0)){var i=this.fallbackTile.sector.deltaLatitude(),r=this.fallbackTile.sector.deltaLongitude(),n=this.sector.deltaLongitude()/r,o=this.sector.deltaLatitude()/i,s=(this.sector.minLongitude-this.fallbackTile.sector.minLongitude)/r,a=(this.sector.minLatitude-this.fallbackTile.sector.minLatitude)/i;t.multiply(n,0,0,s,0,o,0,a,0,0,1,0,0,0,0,1)}},n}),i("layer/TiledImageLayer",["../util/AbsentResourceList","../error/ArgumentError","../render/ImageTile","../layer/Layer","../util/LevelSet","../util/Logger","../geom/Matrix","../cache/MemoryCache","../render/Texture","../util/Tile","../util/WWUtil"],function(t,e,i,r,n,o,s,a,l,h,u){"use strict";var c=function(i,l,h,u,c,d,p){if(!i)throw new e(o.logMessage(o.LEVEL_SEVERE,"TiledImageLayer","constructor","missingSector"));if(!l)throw new e(o.logMessage(o.LEVEL_SEVERE,"TiledImageLayer","constructor","The specified level-zero delta is null or undefined."));if(!u)throw new e(o.logMessage(o.LEVEL_SEVERE,"TiledImageLayer","constructor","The specified image format is null or undefined."));if(!c)throw new e(o.logMessage(o.LEVEL_SEVERE,"TiledImageLayer","constructor","The specified cache path is null or undefined."));if(!h||h<1)throw new e(o.logMessage(o.LEVEL_SEVERE,"TiledImageLayer","constructor","The specified number of levels is less than one."));if(!d||!p||d<1||p<1)throw new e(o.logMessage(o.LEVEL_SEVERE,"TiledImageLayer","constructor","The specified tile width or height is less than one."));r.call(this,"Tiled Image Layer"),this.retrievalImageFormat=u,this.cachePath=c,this.retrievalQueueSize=WorldWind.configuration.layerRetrievalQueueSize,this.levels=new n(i,l,h,d,p),this.detailControl=1.75,this.crossOrigin="anonymous",this.expiration=null,this.currentTiles=[],this.currentTilesInvalid=!0,this.tileCache=new a(5e5,4e5),this.currentRetrievals=[],this.absentResourceList=new t(3,5e4),this.pickEnabled=!1,this.lasTtMVP=s.fromIdentity()};return c.prototype=Object.create(r.prototype),c.prototype.refresh=function(){this.expiration=new Date,this.currentTilesInvalid=!0},c.prototype.prePopulate=function(t){if(!t)throw new e(o.logMessage(o.LEVEL_SEVERE,"TiledImageLayer","prePopulate","missingWorldWindow"));var i=t.drawContext;this.topLevelTiles&&0!==this.topLevelTiles.length||this.createTopLevelTiles(i);for(var r=0;r<this.topLevelTiles.length;r++){var n=this.topLevelTiles[r];this.isTileTextureInMemory(i,n)||this.retrieveTileImage(i,n,!0)}},c.prototype.prePopulateCurrentTiles=function(t){if(!t)throw new e(o.logMessage(o.LEVEL_SEVERE,"TiledImageLayer","prePopulate","missingWorldWindow"));var i=t.drawContext;this.assembleTiles(i);for(var r=0,n=this.currentTiles.length;r<n;r++){var s=this.currentTiles[r];this.isTileTextureInMemory(i,s)||this.retrieveTileImage(i,s,!0)}},c.prototype.isPrePopulated=function(t){if(!t)throw new e(o.logMessage(o.LEVEL_SEVERE,"TiledImageLayer","isPrePopulated","missingWorldWindow"));for(var i=0;i<this.topLevelTiles.length;i++)if(!this.isTileTextureInMemory(t.drawContext,this.topLevelTiles[i]))return!1;return!0},c.prototype.createTile=function(t,e,r,n){var o=this.cachePath+"-layer/"+e.levelNumber+"/"+r+"/"+r+"_"+n+"."+u.suffixForMimeType(this.retrievalImageFormat);return new i(t,e,r,n,o)},c.prototype.doRender=function(t){if(t.terrain){if(this.currentTilesInvalid||!t.modelviewProjection.equals(this.lasTtMVP)||t.globeStateKey!==this.lastGlobeStateKey)if(this.currentTilesInvalid=!1,t.surfaceOpacity>=1&&this.opacity>=1){this.previousTiles={};for(var e=0;e<this.currentTiles.length;e++)this.previousTiles[this.currentTiles[e].imagePath]=this.currentTiles[e];this.assembleTiles(t),this.fadeOutgoingTiles(t)}else this.assembleTiles(t);this.lasTtMVP.copy(t.modelviewProjection),this.lastGlobeStateKey=t.globeStateKey,this.currentTiles.length>0&&(t.surfaceTileRenderer.renderTiles(t,this.currentTiles,this.opacity,t.surfaceOpacity>=1),t.frameStatistics.incrementImageTileCount(this.currentTiles.length),this.inCurrentFrame=!0)}},c.prototype.fadeOutgoingTiles=function(t){for(var e=(t.timestamp-t.previousRedrawTimestamp)/t.fadeTime,i={},r=0;r<this.currentTiles.length;r++){var n=this.currentTiles[r];i[n.imagePath]=n}for(var o in this.previousTiles)this.previousTiles.hasOwnProperty(o)&&(n=this.previousTiles[o],n.opacity>0&&!i[n.imagePath]&&(n.opacity=Math.max(0,n.opacity-e),n.opacity>0&&(this.currentTiles.push(n),this.currentTilesInvalid=!0,t.redrawRequested=!0)))},c.prototype.isLayerInView=function(t){return t.terrain&&t.terrain.sector&&t.terrain.sector.intersects(this.levels.sector)},c.prototype.createTopLevelTiles=function(t){this.topLevelTiles=[],h.createTilesForLevel(this.levels.firstLevel(),this,this.topLevelTiles)},c.prototype.assembleTiles=function(t){this.currentTiles=[],this.topLevelTiles&&0!==this.topLevelTiles.length||this.createTopLevelTiles(t);for(var e=0,i=this.topLevelTiles.length;e<i;e++){var r=this.topLevelTiles[e];r.update(t),this.currentAncestorTile=null,this.isTileVisible(t,r)&&this.addTileOrDescendants(t,r)}},c.prototype.addTileOrDescendants=function(t,e){if(this.tileMeetsRenderingCriteria(t,e))return void this.addTile(t,e);var i=null;try{(this.isTileTextureInMemory(t,e)||0===e.level.levelNumber)&&(i=this.currentAncestorTile,this.currentAncestorTile=e);for(var r=this.levels.level(e.level.levelNumber+1),n=e.subdivideToCache(r,this,this.tileCache),o=0,s=n.length;o<s;o++){var a=n[o];a.update(t),this.levels.sector.intersects(a.sector)&&this.isTileVisible(t,a)&&this.addTileOrDescendants(t,a)}}finally{i&&(this.currentAncestorTile=i)}},c.prototype.addTile=function(t,e){e.fallbackTile=null;var i=t.gpuResourceCache.resourceForKey(e.imagePath);
return i?(e.opacity=1,this.currentTiles.push(e),void(this.expiration&&this.isTextureExpired(i)&&this.retrieveTileImage(t,e))):(this.retrieveTileImage(t,e),void(this.currentAncestorTile&&this.isTileTextureInMemory(t,this.currentAncestorTile)&&(e.fallbackTile=this.currentAncestorTile,e.fallbackTile.opacity=1,this.currentTiles.push(e))))},c.prototype.isTileVisible=function(t,e){return!(t.globe.projectionLimits&&!e.sector.overlaps(t.globe.projectionLimits))&&e.extent.intersectsFrustum(t.frustumInModelCoordinates)},c.prototype.tileMeetsRenderingCriteria=function(t,e){var i=this.detailControl;return(e.sector.minLatitude>=75||e.sector.maxLatitude<=-75)&&(i*=1.2),e.level.isLastLevel()||!e.mustSubdivide(t,i)},c.prototype.isTileTextureInMemory=function(t,e){return t.gpuResourceCache.containsResource(e.imagePath)},c.prototype.isTextureExpired=function(t){return this.expiration&&t.creationTime.getTime()<=this.expiration.getTime()},c.prototype.retrieveTileImage=function(t,e,i){if(this.currentRetrievals.indexOf(e.imagePath)<0){if(this.currentRetrievals.length>this.retrievalQueueSize)return;if(this.absentResourceList.isResourceAbsent(e.imagePath))return;var r=this.resourceUrlForTile(e,this.retrievalImageFormat),n=new Image,s=e.imagePath,a=t.gpuResourceCache,l=t.currentGlContext.canvas,h=this;if(!r)return void(this.currentTilesInvalid=!0);n.onload=function(){o.log(o.LEVEL_INFO,"Image retrieval succeeded: "+r);var u=h.createTexture(t,e,n);if(h.removeFromCurrentRetrievals(s),u&&(a.putResource(s,u,u.size),h.currentTilesInvalid=!0,h.absentResourceList.unmarkResourceAbsent(s),!i)){var c=document.createEvent("Event");c.initEvent(WorldWind.REDRAW_EVENT_TYPE,!0,!0),l.dispatchEvent(c)}},n.onerror=function(){h.removeFromCurrentRetrievals(s),h.absentResourceList.markResourceAbsent(s),o.log(o.LEVEL_WARNING,"Image retrieval failed: "+r)},this.currentRetrievals.push(s),n.crossOrigin=this.crossOrigin,n.src=r}},c.prototype.createTexture=function(t,e,i){return new l(t.currentGlContext,i)},c.prototype.removeFromCurrentRetrievals=function(t){var e=this.currentRetrievals.indexOf(t);e>-1&&this.currentRetrievals.splice(e,1)},c.prototype.resourceUrlForTile=function(t,e){return this.urlBuilder?this.urlBuilder.urlForTile(t,e):null},c}),i("layer/MercatorTiledImageLayer",["../util/Color","../geom/Sector","../layer/TiledImageLayer","../geom/Vec2","../util/WWMath"],function(t,e,i,r,n){"use strict";var o=function(t,e,n,o,s,a,l){i.call(this,t,e,n,o,s,a,l),this.detectBlankImages=!1,this.testPixels=[new r(20,20),new r(235,20),new r(20,235),new r(235,235)],this.destCanvas=document.createElement("canvas"),this.destContext=this.destCanvas.getContext("2d")};return o.prototype=Object.create(i.prototype),o.prototype.createTile=function(t,r,o,s){var a,l,h,u,c,d,p=this.mapSizeForLevel(r.levelNumber),f=n.clamp(s*this.imageSize,0,p),g=n.clamp(o*this.imageSize,0,p),m=n.clamp(f+this.imageSize,0,p),y=n.clamp(g+this.imageSize,0,p);return a=f/p-.5,l=.5-y/p,h=90-360*Math.atan(Math.exp(2*-l*Math.PI))/Math.PI,u=360*a,a=m/p-.5,l=.5-g/p,c=90-360*Math.atan(Math.exp(2*-l*Math.PI))/Math.PI,d=360*a,t=new e(h,c,u,d),i.prototype.createTile.call(this,t,r,o,s)},o.prototype.createTexture=function(t,e,r){var o,s,a,l,h,u,c,d,p=t.canvas2D,f=t.ctx2D,g=this.destCanvas,m=this.destContext,y=m.createImageData(r.width,r.height),E=e.sector,v=n.gudermannianInverse(E.minLatitude),_=n.gudermannianInverse(E.maxLatitude);if(p.width=r.width,p.height=r.height,g.width=r.width,g.height=r.height,f.drawImage(r,0,0,r.width,r.height),o=f.getImageData(0,0,r.width,r.height),this.detectBlankImages&&this.isBlankImage(r,o))return this.absentResourceList.markResourceAbsentPermanently(e.imagePath),null;for(var b=0;b<1;b++)for(var w=0;w<r.height;w++){c=1-w/(r.height-1),s=c*E.deltaLatitude()+E.minLatitude,a=n.gudermannianInverse(s),d=1-(a-v)/(_-v),d=n.clamp(d,0,1),l=Math.floor(d*(r.height-1));for(var S=0;S<r.width;S++)h=4*(S+l*r.width),u=4*(S+w*r.width),y.data[u]=o.data[h],y.data[u+1]=o.data[h+1],y.data[u+2]=o.data[h+2],y.data[u+3]=o.data[h+3]}return m.putImageData(y,0,0),i.prototype.createTexture.call(this,t,e,g)},o.prototype.isBlankImage=function(t,e){for(var i,r,n=null,o=0,s=this.testPixels.length;o<s;o++)if(i=this.testPixels[o],r=4*(i[0]+i[1]*t.width),n){if(e.data[r]!=n[0]||e.data[r+1]!=n[1]||e.data[r+2]!=n[2])return!1}else n=[e.data[r],e.data[r+1],e.data[r+2]];return!0},o}),i("layer/BingTiledImageLayer",["../geom/Angle","../util/Color","../geom/Location","../util/Offset","../shapes/ScreenImage","../geom/Sector","../layer/MercatorTiledImageLayer"],function(t,e,i,r,n,o,s){"use strict";var a=function(t){this.imageSize=256,s.call(this,new o(-85.05,85.05,-180,180),new i(85.05,180),23,"image/jpeg",t,this.imageSize,this.imageSize),this.displayName=t,this.pickEnabled=!0,this.detectBlankImages=!0};return a.logoImage=null,a.logoLastFrameTime=0,a.prototype=Object.create(s.prototype),a.prototype.doRender=function(t){s.prototype.doRender.call(this,t),this.inCurrentFrame&&this.renderLogo(t)},a.prototype.createTopLevelTiles=function(t){this.topLevelTiles=[],this.topLevelTiles.push(this.createTile(null,this.levels.firstLevel(),0,0)),this.topLevelTiles.push(this.createTile(null,this.levels.firstLevel(),0,1)),this.topLevelTiles.push(this.createTile(null,this.levels.firstLevel(),1,0)),this.topLevelTiles.push(this.createTile(null,this.levels.firstLevel(),1,1))},a.prototype.renderLogo=function(t){a.logoImage||(a.logoImage=new n(WorldWind.configuration.bingLogoPlacement,WorldWind.configuration.baseUrl+"images/powered-by-bing.png"),a.logoImage.imageColor=new e(1,1,1,.5)),a.logoLastFrameTime!==t.timestamp&&(a.logoImage.screenOffset=WorldWind.configuration.bingLogoPlacement,a.logoImage.imageOffset=WorldWind.configuration.bingLogoAlignment,a.logoImage.render(t),a.logoLastFrameTime=t.timestamp)},a.prototype.mapSizeForLevel=function(t){return 256<<t+1},a}),i("util/BingImageryUrlBuilder",["../error/ArgumentError","../util/Logger","../util/WWUtil"],function(t,e,i){"use strict";var r=function(t,e){var i="AkttWCS8p6qzxvx5RH3qUcCPgwG9nRJ7IwlpFGb14B0rBorB5DvmXr2Y_eCUNIxH";this.bingMapsKey=e,this.bingMapsKey||(this.bingMapsKey=WorldWind.BingMapsKey),this.bingMapsKey||(this.bingMapsKey=i),this.bingMapsKey===i&&r.showBingMapsKeyWarning(),this.imagerySet=t};return r.showBingMapsKeyWarning=function(){r.keyMessagePrinted||(r.keyMessagePrinted=!0,e.log(e.LEVEL_WARNING,"WARNING: You are using a limited use, non-production Bing Maps key.\nIf you are developing an app or a web page this violates the Bing Terms of Use.\nPlease visit https://www.microsoft.com/en-us/maps/create-a-bing-maps-key to obtain your own key for your application.\nSpecify that key to WorldWind by setting the WorldWind.BingMapsKey property to your key prior to creating any Bing Maps layers.\n"))},r.prototype.requestMetadata=function(){if(!this.metadataRetrievalInProcess){this.metadataRetrievalInProcess=!0;var t="https://dev.virtualearth.net/REST/V1/Imagery/Metadata/"+this.imagerySet+"/0,0?zl=1&uriScheme=https&key="+this.bingMapsKey,e=this;i.jsonp(t,"jsonp",function(t){e.imageUrl=t.resourceSets[0].resources[0].imageUrl;var i=document.createEvent("Event");i.initEvent(WorldWind.REDRAW_EVENT_TYPE,!0,!0),window.dispatchEvent(i),e.metadataRetrievalInProcess=!1})}},r.prototype.urlForTile=function(i,r){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"BingImageryUrlBuilder","urlForTile","missingTile"));if(!this.imageUrl)return this.requestMetadata(),null;var n,o=this.quadKeyFromLevelRowColumn(i.level.levelNumber,i.row,i.column);return"Aerial"===this.imagerySet?n=this.imageUrl.replace(/a3/,"a"+o):"AerialWithLabels"===this.imagerySet?n=this.imageUrl.replace(/h3/,"h"+o):"Road"===this.imagerySet&&(n=this.imageUrl.replace(/r3/,"r"+o)),n},r.prototype.quadKeyFromLevelRowColumn=function(t,e,i){for(var r,n,o="",s=t+1;s>0;s--)r=0,n=1<<s-1,0!=(i&n)&&(r+=1),0!=(e&n)&&(r+=2),o+=r.toString();return o},r}),i("layer/BingAerialLayer",["../geom/Location","../geom/Sector","../layer/BingTiledImageLayer","../util/BingImageryUrlBuilder"],function(t,e,i,r){"use strict";var n=function(t){i.call(this,"Bing Aerial"),this.urlBuilder=new r("Aerial",t)};return n.prototype=Object.create(i.prototype),n}),i("layer/BingAerialWithLabelsLayer",["../geom/Location","../geom/Sector","../layer/BingTiledImageLayer","../util/BingImageryUrlBuilder"],function(t,e,i,r){"use strict";var n=function(t){i.call(this,"Bing Aerial with Labels"),this.urlBuilder=new r("AerialWithLabels",t)};return n.prototype=Object.create(i.prototype),n}),i("layer/BingRoadsLayer",["../geom/Location","../geom/Sector","../layer/BingTiledImageLayer","../util/BingImageryUrlBuilder"],function(t,e,i,r){"use strict";var n=function(t){i.call(this,"Bing Roads"),this.urlBuilder=new r("Road",t),this.detectBlankImages=!1};return n.prototype=Object.create(i.prototype),n}),i("layer/BingWMSLayer",["../geom/Location","../geom/Sector","../layer/TiledImageLayer","../util/WmsUrlBuilder"],function(t,e,i,r){"use strict";var n=function(){i.call(this,e.FULL_SPHERE,new t(45,45),16,"image/png","BingWMS",256,256),this.displayName="Bing WMS",this.pickEnabled=!1,this.maxActiveAltitude=1e4,this.urlBuilder=new r("https://worldwind27.arc.nasa.gov/wms/virtualearth","ve","","1.3.0")};return n.prototype=Object.create(i.prototype),n}),i("layer/BMNGLandsatLayer",["../geom/Location","../geom/Sector","../layer/TiledImageLayer","../util/WmsUrlBuilder"],function(t,e,i,r){"use strict";var n=function(){i.call(this,e.FULL_SPHERE,new t(45,45),12,"image/jpeg","BMNGLandsat256",256,256),this.displayName="Blue Marble & Landsat",this.pickEnabled=!1,this.urlBuilder=new r("https://worldwind25.arc.nasa.gov/wms","BlueMarble-200405,esat","","1.3.0")};return n.prototype=Object.create(i.prototype),n}),i("layer/BMNGLayer",["../geom/Location","../geom/Sector","../layer/TiledImageLayer","../util/WmsUrlBuilder"],function(t,e,i,r){"use strict";var n=function(n){i.call(this,e.FULL_SPHERE,new t(45,45),7,"image/jpeg",n||"BMNG256",256,256),this.displayName="Blue Marble",this.pickEnabled=!1,this.urlBuilder=new r("https://worldwind25.arc.nasa.gov/wms",n||"BlueMarble-200405","","1.3.0")};return n.prototype=Object.create(i.prototype),n}),i("layer/RenderableLayer",["../error/ArgumentError","../layer/Layer","../util/Logger"],function(t,e,i){"use strict";var r=function(t){e.call(this,t),this.renderables=[],this.timeRange=[]};return r.prototype=Object.create(e.prototype),r.prototype.addRenderable=function(e){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"RenderableLayer","addRenderable","missingRenderable"));this.renderables.push(e)},r.prototype.addRenderables=function(e){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"RenderableLayer","addRenderables","The renderables array is null or undefined."));for(var r=0,n=e.length;r<n;r++)this.addRenderable(e[r])},r.prototype.removeRenderable=function(t){var e=this.renderables.indexOf(t);e>=0&&this.renderables.splice(e,1)},r.prototype.removeAllRenderables=function(){this.renderables=[]},r.prototype.doRender=function(t){for(var e=t.orderedRenderables.length,r=0,n=this.renderables.length;r<n;r++)try{var o=this.renderables[r].enabled;this.renderables[r].enabled=this.solveTimeVisibility(t,this.renderables[r]),this.renderables[r].render(t),this.renderables[r].enabled=o}catch(t){i.logMessage(i.LEVEL_SEVERE,"RenderableLayer","doRender","Error while rendering shape "+this.renderables[r].displayName+".\n"+t.toString())}t.orderedRenderables.length>e&&(this.inCurrentFrame=!0)},r.prototype.solveTimeVisibility=function(t,e){var i=t.currentLayer.timeRange;if(e.timeRange.length>=2&&i.length>=2){var r=e.timeRange[0],n=e.timeRange[1],o=i[0],s=i[1];if(r<o||n>s)return!1}return e.enabled},r}),i("render/SurfaceTile",["../error/ArgumentError","../util/Logger","../geom/Matrix","../geom/Sector","../error/UnsupportedOperationError"],function(t,e,i,r,n){"use strict";var o=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"SurfaceTile","constructor","missingSector"));this.sector=i};return o.prototype.bind=function(t){throw new n(e.logMessage(e.LEVEL_SEVERE,"SurfaceTile","bind","abstractInvocation"))},o.prototype.applyInternalTransform=function(t,i){throw new n(e.logMessage(e.LEVEL_SEVERE,"SurfaceTile","applyInternalTransform","abstractInvocation"))},o}),i("shapes/SurfaceImage",["../error/ArgumentError","../util/Logger","../pick/PickedObject","../render/SurfaceTile"],function(t,e,i,r){"use strict";var n=function(i,n){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"SurfaceImage","constructor","missingSector"));if(!n)throw new t(e.logMessage(e.LEVEL_SEVERE,"SurfaceImage","constructor","missingImage"));r.call(this,i),this.enabled=!0,this._imageSource=n,this.resamplingMode=WorldWind.FILTER_LINEAR,this.opacity=1,this.displayName="Surface Image",this.imageSourceWasUpdated=!0};return n.prototype=Object.create(r.prototype),Object.defineProperties(n.prototype,{imageSource:{get:function(){return this._imageSource},set:function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"SurfaceImage","imageSource","missingImage"));this._imageSource=i,this.imageSourceWasUpdated=!0}}}),n.prototype.bind=function(t){var e=t.gpuResourceCache.resourceForKey(this._imageSource);return e&&!this.imageSourceWasUpdated?this.bindTexture(t,e):(e=t.gpuResourceCache.retrieveTexture(t.currentGlContext,this._imageSource),this.imageSourceWasUpdated=!1,e?this.bindTexture(t,e):void 0)},n.prototype.bindTexture=function(t,e){var i=t.currentGlContext;return e.setTexParameter(i.TEXTURE_MAG_FILTER,this.resamplingMode===WorldWind.FILTER_NEAREST?i.NEAREST:i.LINEAR),e.bind(t)},n.prototype.applyInternalTransform=function(t,e){},n.prototype.render=function(t){if(this.enabled&&t.terrain&&this.sector.overlaps(t.terrain.sector)){if(t.pickingMode&&(this.pickColor=t.uniquePickColor()),t.surfaceTileRenderer.renderTiles(t,[this],this.opacity*t.currentLayer.opacity),t.pickingMode){var e=new i(this.pickColor.clone(),this.pickDelegate?this.pickDelegate:this,null,this.layer,!1);t.resolvePick(e)}t.currentLayer.inCurrentFrame=!0}},n}),i("layer/BMNGOneImageLayer",["../layer/RenderableLayer","../geom/Sector","../shapes/SurfaceImage","../util/WWUtil"],function(t,e,i,r){"use strict";var n=function(){t.call(this,"Blue Marble Image");var r=new i(e.FULL_SPHERE,WorldWind.configuration.baseUrl+"images/BMNG_world.topo.bathy.200405.3.2048x1024.jpg");this.addRenderable(r),this.pickEnabled=!1,this.minActiveAltitude=3e6};return n.prototype=Object.create(t.prototype),n}),i("util/PeriodicTimeSequence",["../error/ArgumentError","../util/Logger"],function(t,e){"use strict";var i=function(r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"PeriodicTimeSequence","constructor","missingString"));var n=r.split("/");if(3!==n.length)throw new t(e.logMessage(e.LEVEL_SEVERE,"PeriodicTimeSequence","constructor","The interval string "+r+" does not contain 3 elements."));this.sequenceString=r,this.startTime=new Date(n[0]),this.endTime=new Date(n[1]),this.intervalMilliseconds=this.endTime.getTime()-this.startTime.getTime(),this._currentTime=this.startTime,this.infiniteInterval=this.startTime.getTime()==this.endTime.getTime(),this.period=i.parsePeriodString(n[2],!1)};return Object.defineProperties(i.prototype,{currentTime:{get:function(){return this._currentTime},set:function(t){this._currentTime=t}},scaleForCurrentTime:{get:function(){return this.currentTime?(this.currentTime.getTime()-this.startTime.getTime())/this.intervalMilliseconds:1}}}),i.prototype.next=function(){return this.currentTime?this.currentTime.getTime()>=this.endTime.getTime()&&!this.infiniteInterval?this.currentTime=null:this.currentTime=i.incrementTime(this.currentTime,this.period):this.currentTime=this.startTime,this.currentTime},i.prototype.previous=function(){return this.currentTime?this.currentTime.getTime()===this.startTime.getTime()?this.currentTime=null:this.currentTime=this.getTimeForScale(.9999*this.scaleForCurrentTime):this.currentTime=this.endTime,this.currentTime},i.prototype.reset=function(){this.currentTime=null},i.prototype.getTimeForScale=function(t){if(t<=0)return this.startTime;if(t>=1)return this.endTime;var e=new Date(this.startTime.getTime()),r=e,n=0;for(n=0;n<t;n=(e.getTime()-this.startTime.getTime())/this.intervalMilliseconds)r=e,e=i.incrementTime(e,this.period);return r},i.incrementTime=function(t,e){var r=new Date(t.getTime());return 0!=e[0]&&r.setUTCFullYear(r.getUTCFullYear()+e[0]),0!=e[1]&&i.addMonths(r,e[1]),0!=e[2]&&r.setUTCDate(r.getUTCDate()+7*e[2]),0!=e[3]&&r.setUTCDate(r.getUTCDate()+e[3]),0!=e[4]&&r.setUTCHours(r.getUTCHours()+e[4]),0!=e[5]&&r.setUTCMinutes(r.getUTCMinutes()+e[5]),0!=e[6]&&r.setUTCSeconds(r.getUTCSeconds()+e[6]),r},i.isLeapYear=function(t){return t%4===0&&t%100!==0||t%400===0},i.getDaysInMonth=function(t,e){return[31,i.isLeapYear(t)?29:28,31,30,31,30,31,31,30,31,30,31][e]},i.addMonths=function(t,e){var r=t.getUTCDate();return t.setUTCDate(1),t.setUTCMonth(t.getUTCMonth()+e),t.setUTCDate(Math.min(r,i.getDaysInMonth(t.getUTCFullYear(),t.getUTCMonth()))),t},i.parsePeriodString=function(i,r){var n,o=!!r&&r,s=[2,3,4,5,7,8,9],a=[0,0,0,0,0,0,0],l=[0,12,4,7,24,60,60];if(i=i.toUpperCase().trim(),!i)return a;if("string"!=typeof i)throw new t(e.logMessage(e.LEVEL_SEVERE,"PeriodicTimeSequence","parsePeriodString","Invalid ISO8601 period string '"+i+"'"));if(!(n=/^P((\d+Y)?(\d+M)?(\d+W)?(\d+D)?)?(T(\d+H)?(\d+M)?(\d+S)?)?$/.exec(i)))throw new t(e.logMessage(e.LEVEL_SEVERE,"PeriodicTimeSequence","parsePeriodString","String '"+i+"' is not a valid ISO8601 period."));for(var h=0;h<s.length;h++){var u=s[h];a[h]=n[u]?+n[u].replace(/[A-Za-z]+/g,""):0}if(o)for(h=a.length-1;h>0;h--)a[h]>=l[h]&&(a[h-1]=a[h-1]+Math.floor(a[h]/l[h]),a[h]=a[h]%l[h]);return a},i}),i("util/LevelRowColumnUrlBuilder",["../error/ArgumentError","../util/Logger","../util/WWUtil"],function(t,e,i){"use strict";var r=function(t,e){this.serverAddress=t,t&&0!==t.length||(this.serverAddress=i.currentUrlSansFilePart()),this.pathToData=e};return r.prototype.urlForTile=function(r,n){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsUrlBuilder","urlForTile","missingTile"));if(!n)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsUrlBuilder","urlForTile","The image format is null or undefined."));var o=this.serverAddress;return this.pathToData&&(o=o+"/"+this.pathToData),o=o+"/"+r.level.levelNumber.toString(),o=o+"/"+r.row.toString(),o=o+"/"+r.row.toString()+"_"+r.column.toString(),o=o+"."+i.suffixForMimeType(n),o=o.replace(" ","%20")},r}),i("layer/RestTiledImageLayer",["../error/ArgumentError","../geom/Location","../util/Logger","../geom/Sector","../layer/TiledImageLayer","../util/LevelRowColumnUrlBuilder","../util/WWUtil"],function(t,e,i,r,n,o,s){"use strict";var a=function(t,i,a,l){var h=s.urlPath(t+"/"+i);n.call(this,l&&l.sector||r.FULL_SPHERE,l&&l.levelZeroTileDelta||new e(45,45),l&&l.numLevels||5,l&&l.imageFormat||"image/jpeg",h,l&&l.tileWidth||256,l&&l.tileHeight||256),this.displayName=a,this.pickEnabled=!1,this.urlBuilder=new o(t,i)};return a.prototype=Object.create(n.prototype),a}),i("layer/BMNGRestLayer",["../error/ArgumentError","../layer/Layer","../util/Logger","../util/PeriodicTimeSequence","../layer/RestTiledImageLayer"],function(t,e,i,r,n){"use strict";var o=function(t,i,n,s){e.call(this,n||"Blue Marble time series"),this.time=s||new Date("2004-01"),this.timeSequence=new r("2004-01-01/2004-12-01/P1M"),this.serverAddress=t,this.pathToData=i,this.layers={},this.layerNames=[{month:"BlueMarble-200401",time:o.availableTimes[0]},{month:"BlueMarble-200402",time:o.availableTimes[1]},{month:"BlueMarble-200403",time:o.availableTimes[2]},{month:"BlueMarble-200404",time:o.availableTimes[3]},{month:"BlueMarble-200405",time:o.availableTimes[4]},{month:"BlueMarble-200406",time:o.availableTimes[5]},{month:"BlueMarble-200407",time:o.availableTimes[6]},{month:"BlueMarble-200408",time:o.availableTimes[7]},{month:"BlueMarble-200409",time:o.availableTimes[8]},{month:"BlueMarble-200410",time:o.availableTimes[9]},{month:"BlueMarble-200411",time:o.availableTimes[10]},{month:"BlueMarble-200412",time:o.availableTimes[11]}],this.pickEnabled=!1};return o.prototype=Object.create(e.prototype),o.availableTimes=[new Date("2004-01"),new Date("2004-02"),new Date("2004-03"),new Date("2004-04"),new Date("2004-05"),new Date("2004-06"),new Date("2004-07"),new Date("2004-08"),new Date("2004-09"),new Date("2004-10"),new Date("2004-11"),new Date("2004-12")],o.prototype.prePopulate=function(e){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"BMNGRestLayer","prePopulate","missingWorldWindow"));for(var r=0;r<this.layerNames.length;r++){var n=this.layerNames[r].month;this.layers[n]||this.createSubLayer(n),this.layers[n].prePopulate(e)}},o.prototype.isPrePopulated=function(t){for(var e=0;e<this.layerNames.length;e++){var i=this.layers[this.layerNames[e].month];if(!i||!i.isPrePopulated(t))return!1}return!0},o.prototype.doRender=function(t){var e=this.nearestLayer(this.time);e.opacity=this.opacity,this.detailControl&&(e.detailControl=this.detailControl),e.doRender(t),this.inCurrentFrame=e.inCurrentFrame},o.prototype.nearestLayer=function(t){var e=this.nearestLayerName(t);return this.layers[e]||this.createSubLayer(e),this.layers[e]},o.prototype.createSubLayer=function(t){var e="";e=this.pathToData?this.pathToData+"/"+t:t,this.layers[t]=new n(this.serverAddress,e,this.displayName)},o.prototype.nearestLayerName=function(t){var e=t.getTime();if(e<=this.layerNames[0].time.getTime())return this.layerNames[0].month;if(e>=this.layerNames[11].time.getTime())return this.layerNames[11].month;for(var i=0;i<this.layerNames.length-1;i++){var r=this.layerNames[i].time.getTime(),n=this.layerNames[i+1].time.getTime();if(e>=r&&e<=n){var o=e-r,s=n-e;return o<s?this.layerNames[i].month:this.layerNames[i+1].month}}},o}),i("formats/collada/ColladaAsset",[],function(){"use strict";var t=function(t){this.xmlAsset=t.getElementsByTagName("asset")[0],this.asset={daeVersion:t.querySelector("COLLADA").getAttribute("version")}};return t.prototype.parse=function(){if(!this.xmlAsset)return null;for(var t=0;t<this.xmlAsset.childNodes.length;t++){var e=this.xmlAsset.childNodes.item(t);if(1===e.nodeType)switch(e.nodeName){case"contributor":var i=e.querySelector("authoring_tool");i&&(this.asset.authoring_tool=i.textContext);break;case"unit":this.asset.unit=e.getAttribute("meter");break;default:this.asset[e.localName]=e.textContent}}return this.xmlAsset=null,this.asset},t}),i("formats/collada/ColladaUtils",["../../util/Logger"],function(t){"use strict";var e={getRawValues:function(t){if(!t)return null;var e=t.textContent;return e=e.replace(/\n/gi," "),e=e.replace(/\s+/gi," "),e=e.trim(),0===e.length?null:e.split(" ")},bufferDataFloat32:function(t){var e=this.getRawValues(t);if(!e)return null;for(var i=e.length,r=new Float32Array(i),n=0;n<i;n++)r[n]=parseFloat(e[n]);return r},bufferDataUInt32:function(t){var e=this.getRawValues(t);if(!e)return null;for(var i=e.length,r=new Uint32Array(i),n=0;n<i;n++)r[n]=parseInt(e[n]);return r},getFirstChildElement:function(t,e){for(var i=t.childNodes,r=0;r<i.length;++r){var n=i.item(r);if(1===n.nodeType&&(n.nodeName&&!e||e&&e===n.nodeName))return n}return null},getFilename:function(t){var e=t.lastIndexOf("\\");return e!==-1&&(t=t.substr(e+1)),e=t.lastIndexOf("/"),e!==-1&&(t=t.substr(e+1)),t},replaceSpace:function(t){return t?t.replace(/ /g,"_"):""},querySelectorById:function(t,e){for(var i=0;i<t.length;i++){var r=t.item(i).getAttribute("id");if(r&&r.toString()===e)return t.item(i)}return null},getTextureType:function(t){for(var e=!0,i=0,r=t.length;i<r;i++)if(t[i]<0||t[i]>1){e=!1;break}return e},fetchFile:function(e,i){var r=new XMLHttpRequest;r.onload=function(){this.status>=200&&this.status<400||0===this.status?i(this.response):(t.log(t.LEVEL_SEVERE,"sever error: "+this.status),i(null))},r.onerror=function(e){t.log(t.LEVEL_SEVERE,"connection error: "+e),i(null)},r.open("get",e,!0),r.send()}};return e}),i("formats/collada/ColladaImage",["./ColladaUtils"],function(t){"use strict";var e=function(t,e){this.filename="",this.map=t,this.name=e,this.path=""};return e.prototype.parse=function(e){for(var i=0;i<e.childNodes.length;i++){var r=e.childNodes[i];if(1===r.nodeType)switch(r.nodeName){case"init_from":this.filename=t.getFilename(r.textContent),this.path=r.textContent}}return this},e}),i("formats/collada/ColladaMaterial",["./ColladaUtils"],function(t){"use strict";var e=function(t){this.id=t,this.newParams=[]};return e.prototype.parse=function(t){for(var e=0;e<t.childNodes.length;e++){var i=t.childNodes[e];if(1===i.nodeType)switch(i.nodeName){case"profile_COMMON":this.parseProfileCommon(i)}}return this},e.prototype.parseProfileCommon=function(t){for(var e=0;e<t.childNodes.length;e++){var i=t.childNodes[e];if(1===i.nodeType)switch(i.nodeName){case"newparam":this.parseNewparam(i);break;case"image":break;case"technique":this.parseTechnique(i)}}},e.prototype.parseNewparam=function(t){for(var e=t.getAttribute("sid"),i=0;i<t.childNodes.length;i++){var r=t.childNodes[i];if(1===r.nodeType)switch(r.nodeName){case"surface":var n=r.querySelector("init_from");n&&this.newParams.push({sid:e,type:"surface",initFrom:n.textContent});break;case"sampler2D":var o=r.querySelector("source");this.newParams.push({sid:e,type:"sampler2D",source:o.textContent});break;case"extra":}}},e.prototype.parseTechnique=function(t){for(var e=0;e<t.childNodes.length;e++){var i=t.childNodes[e];if(1===i.nodeType)switch(i.nodeName){case"constant":case"lambert":case"blinn":case"phong":this.techniqueType=i.nodeName,this.parseTechniqueType(i);break;case"extra":}}},e.prototype.parseTechniqueType=function(e){for(var i=0;i<e.childNodes.length;i++){var r=e.childNodes[i];if(1===r.nodeType&&r.nodeName){var n=r.nodeName,o=t.getFirstChildElement(r);if(o)switch(o.nodeName){case"color":this[n]=t.bufferDataFloat32(o).subarray(0,4);break;case"float":this[n]=t.bufferDataFloat32(o)[0];break;case"texture":var s=o.getAttribute("texture"),a=this.newParams.map(function(t){return t.sid}).indexOf(s),l=this.newParams[a].source;a=this.newParams.map(function(t){return t.sid}).indexOf(l);var h=this.newParams[a].initFrom;this.textures||(this.textures={}),this.textures[n]={mapId:h}}}}},e}),i("formats/collada/ColladaMesh",["./ColladaUtils"],function(t){"use strict";var e=function(t){this.filename=t||"",this.name=t||"",this.buffers=[]};return e.prototype.parse=function(e){for(var i={},r={},n={id:"",inputs:[]},o=0;o<e.childNodes.length;o++){var s=e.childNodes[o];if(1===s.nodeType)switch(s.nodeName){case"source":if(!s.querySelector)continue;var a=s.querySelector("float_array");if(!a)continue;var l=t.bufferDataFloat32(a),h=s.querySelector("accessor"),u=parseInt(h.getAttribute("stride"));i[s.getAttribute("id")]={stride:u,data:l};break;case"vertices":this.parseVertices(s,n);break;case"triangles":r=this.parsePolygons(s,i,n,3),this.buffers.push(r);break;case"polygons":r=this.parsePolygons(s,i,n,4),this.buffers.push(r);break;case"polylist":r=this.parsePolygons(s,i,n,null),this.buffers.push(r)}}return this},e.prototype.parseVertices=function(t,e){e.id=t.getAttribute("id");for(var i=t.querySelectorAll("input"),r=0;r<i.length;r++){var n=i[r],o=n.getAttribute("source").substr(1),s=n.getAttribute("semantic").toUpperCase();e.inputs.push({semantic:s,source:o})}},e.prototype.parsePolygons=function(t,e,i,r){var n=[];if(null==r){var o=t.querySelector("vcount");n=o.textContent.trim().split(" ")}var s=parseInt(t.getAttribute("count")),a=t.getAttribute("material"),l=this.parseInputs(t,e,i),h=l.inputs,u=l.maxOffset,c=t.querySelector("p"),d=[];c&&(d=c.textContent.trim().split(" "));for(var p=h.length,f=0,g={},m=[],y=0,E=!1,v=!1,_=0;_<s;_++){if(n.length)var b=parseInt(n[_]);else b=r;for(var w=-1,S=-1,L=-1,T=0;T<b;T++){var A=d.slice(y,y+u).join(" ");if(L=S,g.hasOwnProperty(A))S=g[A],E=!0;else{for(var R=0;R<p;R++){var x=h[R],C=x[4],M=parseInt(d[y+C]),P=x[1],O=x[3];M*=x[2];for(var N=0;N<x[2];N++)P.push(O[M+N])}S=f,f+=1,g[A]=S}b>3&&(0===T&&(w=S),T>2*u&&((w>65535||L>65535)&&(v=!0),m.push(w),m.push(L))),S>65535&&(v=!0),m.push(S),y+=u}}var I={vertices:new Float32Array(h[0][1]),indexedRendering:E,material:a};return I.indexedRendering&&(I.indices=v?new Uint32Array(m):new Uint16Array(m)),this.transformMeshInfo(I,h),I},e.prototype.parseInputs=function(t,e,i){for(var r=[],n=0,o=t.querySelectorAll("input"),s=0;s<o.length;s++){var a=o.item(s);if(a.getAttribute){var l=a.getAttribute("semantic").toUpperCase(),h=a.getAttribute("source").substr(1),u=parseInt(a.getAttribute("offset"));n=n<u+1?u+1:n;var c=0;if(a.getAttribute("set")&&(c=parseInt(a.getAttribute("set"))),i.id===h)for(var d=i.inputs,p=0;p<d.length;p++){var f=e[d[p].source];f&&r.push([d[p].semantic,[],f.stride,f.data,u,c])}else f=e[h],r.push([l,[],f.stride,f.data,u,c])}}return{inputs:r,maxOffset:n}},e.prototype.transformMeshInfo=function(e,i){for(var r={normal:"normals",texcoord:"uvs"},n=1;n<i.length;n++){var o=i[n][0].toLowerCase(),s=i[n][1];s.length&&(r[o]&&(o=r[o]),e[o]&&(o+=i[n][5]),e[o]=new Float32Array(s),"uvs"===o&&(e.isClamp=t.getTextureType(s)))}return e},e}),i("formats/collada/ColladaNode",["./ColladaUtils","../../geom/Matrix","../../geom/Vec3"],function(t,e,i){"use strict";var r=function(){this.id="",this.name="",this.sid="",this.children=[],this.materials=[],this.mesh="",this.localMatrix=e.fromIdentity(),this.worldMatrix=e.fromIdentity()};return r.prototype.parse=function(t,i,n){this.id=t.getAttribute("id"),this.sid=t.getAttribute("sid"),this.name=t.getAttribute("name"),this.children=[],this.materials=[],this.mesh="",this.localMatrix=e.fromIdentity(),this.worldMatrix=e.fromIdentity(),this.setNodeTransforms(t,n);for(var o=0;o<t.childNodes.length;o++){var s=t.childNodes[o];if(1===s.nodeType)switch(s.nodeName){case"node":this.children.push((new r).parse(s,i,this.worldMatrix));break;case"instance_geometry":this.mesh=s.getAttribute("url").substr(1);for(var a=s.querySelectorAll("instance_material"),l=0;l<a.length;l++){var h=a.item(l);this.materials.push({id:h.getAttribute("target").substr(1),symbol:h.getAttribute("symbol")})}break;case"instance_node":var u=s.getAttribute("url").substr(1),c=this.getLibraryNode(i,u);c&&this.children.push((new r).parse(c,i,this.worldMatrix))}}return this},r.prototype.setNodeTransforms=function(r,n){var o=e.fromIdentity(),s=e.fromIdentity(),a=e.fromIdentity(),l=e.fromIdentity();n||(n=e.fromIdentity());for(var h=[],u=0;u<r.childNodes.length;u++){var c=r.childNodes[u];if(1===c.nodeType)switch(c.nodeName){case"matrix":var d=t.bufferDataFloat32(c);o.copy(d),h.push(o);break;case"rotate":d=t.bufferDataFloat32(c),s.multiplyByRotation(d[0],d[1],d[2],d[3]),h.push(s);break;case"translate":d=t.bufferDataFloat32(c),a.multiplyByTranslation(d[0],d[1],d[2]),h.push(a);break;case"scale":d=t.bufferDataFloat32(c),l.multiplyByScale(d[0],d[1],d[2]),h.push(l)}}for(u=0;u<h.length;u++)this.localMatrix.multiplyMatrix(h[u]);this.worldMatrix.setToMultiply(n,this.localMatrix),this.normalMatrix=e.fromIdentity();var p=new i(0,0,0);this.worldMatrix.extractRotationAngles(p),this.normalMatrix.multiplyByRotation(-1,0,0,p[0]),this.normalMatrix.multiplyByRotation(0,-1,0,p[1]),this.normalMatrix.multiplyByRotation(0,0,-1,p[2])},r.prototype.getLibraryNode=function(t,e){for(var i=0;i<t.length;i++){var r=t[i].attributes.getNamedItem("id");if(r&&r.value===e)return t[i]}return null},r}),i("formats/collada/ColladaScene",["../../error/ArgumentError","../../shaders/BasicTextureProgram","../../util/Color","../../util/Logger","../../geom/Matrix","../../geom/Position","../../pick/PickedObject","../../render/Renderable","../../geom/Vec3"],function(t,e,i,r,n,o,s,a,l){"use strict";var h=function(e,o){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"ColladaScene","constructor","missingPosition"));a.call(this),this._position=e,this._nodes=[],this._meshes={},this._materials={},this._images={},this._upAxis="",this._dirPath="",this._xRotation=0,this._yRotation=0,this._zRotation=0,this._xTranslation=0,this._yTranslation=0,this._zTranslation=0,this._scale=1,this._altitudeMode=WorldWind.ABSOLUTE,this._localTransforms=!0,this._useTexturePaths=!0,this._nodesToHide=[],this._hideNodes=!1,this._placePoint=new l(0,0,0),this._transformationMatrix=n.fromIdentity(),
this._mvpMatrix=n.fromIdentity(),this._normalTransformMatrix=n.fromIdentity(),this._normalMatrix=n.fromIdentity(),this._texCoordMatrix=n.fromIdentity().setToUnitYFlip(),this._entities=[],this._activeTexture=null,this._tmpVector=new l(0,0,0),this._tmpColor=new i(1,1,1,1),this._vboCacheKey="",this._iboCacheKey="",this.setSceneData(o)};return h.prototype=Object.create(a.prototype),h.prototype.constructor=h,Object.defineProperties(h.prototype,{position:{get:function(){return this._position},set:function(t){this._position=t}},nodes:{get:function(){return this._nodes},set:function(t){this._nodes=t}},meshes:{get:function(){return this._meshes},set:function(t){this._meshes=t}},materials:{get:function(){return this._materials},set:function(t){this._materials=t}},images:{get:function(){return this._images},set:function(t){this._images=t}},upAxis:{get:function(){return this._upAxis},set:function(t){this._upAxis=t}},dirPath:{get:function(){return this._dirPath},set:function(t){this._dirPath=t}},xRotation:{get:function(){return this._xRotation},set:function(t){this._xRotation=t}},yRotation:{get:function(){return this._yRotation},set:function(t){this._yRotation=t}},zRotation:{get:function(){return this._zRotation},set:function(t){this._zRotation=t}},xTranslation:{get:function(){return this._xTranslation},set:function(t){this._xTranslation=t}},yTranslation:{get:function(){return this._yTranslation},set:function(t){this._yTranslation=t}},zTranslation:{get:function(){return this._zTranslation},set:function(t){this._zTranslation=t}},scale:{get:function(){return this._scale},set:function(t){this._scale=t}},placePoint:{get:function(){return this._placePoint},set:function(t){this._placePoint=t}},altitudeMode:{get:function(){return this._altitudeMode},set:function(t){this._altitudeMode=t}},transformationMatrix:{get:function(){return this._transformationMatrix},set:function(t){this._transformationMatrix=t}},normalMatrix:{get:function(){return this._normalMatrix},set:function(t){this._normalMatrix=t}},localTransforms:{get:function(){return this._localTransforms},set:function(t){this._localTransforms=t}},useTexturePaths:{get:function(){return this._useTexturePaths},set:function(t){this._useTexturePaths=t}},nodesToHide:{get:function(){return this._nodesToHide},set:function(t){this._nodesToHide=t}},hideNodes:{get:function(){return this._hideNodes},set:function(t){this._hideNodes=t}}}),h.prototype.setSceneData=function(t){t&&(this._nodes=t.root.children,this._meshes=t.meshes,this._materials=t.materials,this._images=t.images,this._upAxis=t.metadata.up_axis,this._dirPath=t.dirPath,this.flattenModel())},h.prototype.flattenModel=function(){for(var t=0,e=this._nodes.length;t<e;t++)this.flattenNode(this._nodes[t]);this._entities.sort(function(t,e){var i=null===t.imageKey?"":""+t,r=null===e.imageKey?"":""+e;return i>r?1:i===r?0:-1})},h.prototype.flattenNode=function(t){if(t.mesh)for(var e=t.mesh,i=this._meshes[e].buffers,r=0,n=i.length;r<n;r++){for(var o=i[r].material,s=0;s<t.materials.length;s++)if(o===t.materials[s].symbol){var a=t.materials[s].id;break}var l=this._materials[a],h=null,u=l&&l.textures&&i[r].uvs&&i[r].uvs.length>0;u&&(l.textures.diffuse?h=l.textures.diffuse.mapId:l.textures.reflective&&(h=l.textures.reflective.mapId)),this._entities.push({mesh:i[r],material:l,node:t,imageKey:h})}for(var c=0;c<t.children.length;c++)this.flattenNode(t.children[c])},h.prototype.render=function(t){var e,i=t.frustumInModelCoordinates;this.enabled&&(this.lastFrameTime!==t.timestamp&&(e=this.makeOrderedRenderable(t)),e&&i.containsPoint(this._placePoint)&&(e.layer=t.currentLayer,this.lastFrameTime=t.timestamp,t.addOrderedRenderable(e)))},h.prototype.makeOrderedRenderable=function(t){return t.surfacePointForMode(this._position.latitude,this._position.longitude,this._position.altitude,this._altitudeMode,this._placePoint),this.eyeDistance=t.eyePoint.distanceTo(this._placePoint),this},h.prototype.renderOrdered=function(t){if(this.drawOrderedScene(t),t.pickingMode){var e=new s(this.pickColor.clone(),this,this._position,this.layer,!1);t.resolvePick(e)}},h.prototype.drawOrderedScene=function(t){try{this.beginDrawing(t)}finally{this.endDrawing(t)}},h.prototype.beginDrawing=function(t){var i=t.currentGlContext,r=t.gpuResourceCache,n=r.resourceForKey(this._vboCacheKey),o=r.resourceForKey(this._iboCacheKey);n||(this.setupBuffers(t),n=r.resourceForKey(this._vboCacheKey),o=r.resourceForKey(this._iboCacheKey)),i.bindBuffer(i.ARRAY_BUFFER,n),o&&i.bindBuffer(i.ELEMENT_ARRAY_BUFFER,o),t.findAndBindProgram(e),i.enableVertexAttribArray(0),t.pickingMode&&(this.pickColor=t.uniquePickColor()),this.computeTransformationMatrix(t.globe);for(var s=0,a=this._entities.length;s<a;s++){var l=this.mustRenderNode(this._entities[s].node.id);l&&this.draw(t,this._entities[s])}},h.prototype.setupBuffers=function(t){for(var e=t.currentGlContext,i=Float32Array.BYTES_PER_ELEMENT||4,n=Uint16Array.BYTES_PER_ELEMENT||2,o=Uint32Array.BYTES_PER_ELEMENT||4,s=!1,a=0,l=0,h=0,u=this._entities.length;h<u;h++){var c=this._entities[h].mesh;c.indexedRendering&&(a+=c.indices.length,c.indices instanceof Uint32Array&&(s=!0)),l+=c.vertices.length,this._entities[h].imageKey&&(l+=c.uvs.length),c.normals&&c.normals.length&&(l+=c.normals.length)}var d=e.createBuffer();e.bindBuffer(e.ARRAY_BUFFER,d),e.bufferData(e.ARRAY_BUFFER,l*i,e.STATIC_DRAW);var p=0;for(h=0,u=this._entities.length;h<u;h++){var f=this._entities[h].mesh.vertices;this._entities[h].vertexOffset=p,e.bufferSubData(e.ARRAY_BUFFER,p*i,f),p+=f.length}for(h=0,u=this._entities.length;h<u;h++)this._entities[h].imageKey&&(f=this._entities[h].mesh.uvs,this._entities[h].uvOffset=p,e.bufferSubData(e.ARRAY_BUFFER,p*i,f),p+=f.length);for(h=0,u=this._entities.length;h<u;h++)f=f=this._entities[h].mesh.normals,f&&f.length&&(this._entities[h].normalOffset=p,e.bufferSubData(e.ARRAY_BUFFER,p*i,f),p+=f.length);var g,m=n,y=a*m;if(s&&(g=t.getExtension("OES_element_index_uint"),g?(m=o,y=a*m):r.log(r.LEVEL_SEVERE,'The 3D model is too big and might not render properly. \nYour browser does not support the "OES_element_index_uint" extension, required to render large models.')),a){var E=e.createBuffer();for(e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,E),e.bufferData(e.ELEMENT_ARRAY_BUFFER,y,e.STATIC_DRAW),p=0,h=0,u=this._entities.length;h<u;h++)c=this._entities[h].mesh,c.indexedRendering&&(f=c.indices,f instanceof Uint32Array&&!g&&(f=new Uint16Array(f)),this._entities[h].indexOffset=p,this._entities[h].indexSize=m,e.bufferSubData(e.ELEMENT_ARRAY_BUFFER,p*m,f),p+=f.length)}this._vboCacheKey=t.gpuResourceCache.generateCacheKey(),t.gpuResourceCache.putResource(this._vboCacheKey,d,l*i),a&&(this._iboCacheKey=t.gpuResourceCache.generateCacheKey(),t.gpuResourceCache.putResource(this._iboCacheKey,E,y))},h.prototype.draw=function(t,e){var i=t.currentGlContext,r=t.currentProgram,n=t.gpuResourceCache,o=e.mesh,s=e.material,a=e.node.worldMatrix,l=e.node.normalMatrix,h=o.normals&&o.normals.length,u=e.imageKey;if(this.applyColor(t,s),u){var c=this._useTexturePaths?this._images[u].path:this._images[u].filename,d=this._dirPath+c;if(this._activeTexture=n.resourceForKey(d),!this._activeTexture){var p=o.isClamp?i.CLAMP_TO_EDGE:i.REPEAT;this._activeTexture=n.retrieveTexture(i,d,p)}var f=this._activeTexture&&this._activeTexture.bind(t);f?(r.loadTextureEnabled(i,!0),i.vertexAttribPointer(2,2,i.FLOAT,!1,8,4*e.uvOffset),i.enableVertexAttribArray(2),r.loadModulateColor(i,t.pickingMode)):(r.loadTextureEnabled(i,!1),i.disableVertexAttribArray(2))}else r.loadTextureEnabled(i,!1),i.disableVertexAttribArray(2);if(h&&!t.pickingMode?(r.loadApplyLighting(i,1),i.vertexAttribPointer(1,3,i.FLOAT,!1,12,4*e.normalOffset),i.enableVertexAttribArray(1)):(r.loadApplyLighting(i,0),i.disableVertexAttribArray(1)),this.applyMatrix(t,h,d,a,l),i.vertexAttribPointer(0,3,i.FLOAT,!1,12,4*e.vertexOffset),o.indexedRendering){var g=e.indexOffset*e.indexSize;o.indices instanceof Uint32Array&&t.getExtension("OES_element_index_uint")?i.drawElements(i.TRIANGLES,o.indices.length,i.UNSIGNED_INT,g):i.drawElements(i.TRIANGLES,o.indices.length,i.UNSIGNED_SHORT,g)}else i.drawArrays(i.TRIANGLES,0,Math.floor(o.vertices.length/3))},h.prototype.applyColor=function(t,e){var i=t.currentGlContext,r=t.currentProgram;if(e)if("constant"===e.techniqueType)var n=e.reflective;else n=e.diffuse;var o,s=1,a=1,l=1,h=1;n&&(s=n[0],a=n[1],l=n[2],h=null!=n[3]?n[3]:1),this._tmpColor.set(s,a,l,h),o=h*this.layer.opacity,i.depthMask(o>=1||t.pickingMode),r.loadColor(i,t.pickingMode?this.pickColor:this._tmpColor),r.loadOpacity(i,t.pickingMode?o>0?1:0:o)},h.prototype.applyMatrix=function(t,e,i,r,n){this._mvpMatrix.copy(t.modelviewProjection),this._mvpMatrix.multiplyMatrix(this._transformationMatrix),r&&this._localTransforms&&this._mvpMatrix.multiplyMatrix(r),e&&!t.pickingMode&&(this._normalMatrix.copy(t.modelviewNormalTransform),this._normalMatrix.multiplyMatrix(this._normalTransformMatrix),n&&this._localTransforms&&this._normalMatrix.multiplyMatrix(n),t.currentProgram.loadModelviewInverse(t.currentGlContext,this._normalMatrix)),i&&this._activeTexture&&(t.currentProgram.loadTextureMatrix(t.currentGlContext,this._texCoordMatrix),this._activeTexture=null),t.currentProgram.loadModelviewProjection(t.currentGlContext,this._mvpMatrix)},h.prototype.endDrawing=function(t){var e=t.currentGlContext,i=t.currentProgram;e.disableVertexAttribArray(1),e.disableVertexAttribArray(2),i.loadApplyLighting(e,0),i.loadTextureEnabled(e,!1)},h.prototype.computeTransformationMatrix=function(t){this._transformationMatrix.setToIdentity(),this._transformationMatrix.multiplyByLocalCoordinateTransform(this._placePoint,t),this._transformationMatrix.multiplyByRotation(1,0,0,this._xRotation),this._transformationMatrix.multiplyByRotation(0,1,0,this._yRotation),this._transformationMatrix.multiplyByRotation(0,0,1,this._zRotation),this._transformationMatrix.multiplyByScale(this._scale,this._scale,this._scale),this._transformationMatrix.multiplyByTranslation(this._xTranslation,this._yTranslation,this._zTranslation),this.computeNormalMatrix()},h.prototype.computeNormalMatrix=function(){this._transformationMatrix.extractRotationAngles(this._tmpVector),this._normalTransformMatrix.setToIdentity(),this._normalTransformMatrix.multiplyByRotation(-1,0,0,this._tmpVector[0]),this._normalTransformMatrix.multiplyByRotation(0,-1,0,this._tmpVector[1]),this._normalTransformMatrix.multiplyByRotation(0,0,-1,this._tmpVector[2])},h.prototype.mustRenderNode=function(t){var e=!0;if(this._hideNodes){var i=this._nodesToHide.indexOf(t);e=i===-1}return e},h}),i("formats/collada/ColladaLoader",["../../error/ArgumentError","./ColladaAsset","./ColladaImage","./ColladaMaterial","./ColladaMesh","./ColladaNode","./ColladaScene","./ColladaUtils","../../util/Logger"],function(t,e,i,r,n,o,s,a,l){"use strict";var h=function(e,i){if(!e)throw new t(l.logMessage(l.LEVEL_SEVERE,"ColladaLoader","constructor","missingPosition"));this.position=e,this.dirPath="/",this.init(i)};return h.prototype.init=function(t){t&&(this.dirPath=t.dirPath||"/"),this.scene={type:"SceneTree",dirPath:this.dirPath,images:{},metadata:{},materials:{},meshes:{},root:{children:[]}},this.xmlDoc=null},h.prototype.load=function(t,e){t.indexOf("://")===-1&&(t=this.dirPath+t),a.fetchFile(t,function(t){if(t)try{i=this.parse(t)}catch(t){i=null,l.log(l.LEVEL_SEVERE,"error parsing collada file: "+t)}else var i=null;e(i)}.bind(this))},h.prototype.parse=function(t){this.init();var i=new DOMParser;this.xmlDoc=i.parseFromString(t,"text/xml");var r=this.xmlDoc.querySelectorAll("library_nodes node"),n=this.xmlDoc.querySelectorAll("library_effects effect");return this.scene.metadata=new e(this.xmlDoc).parse(),this.parseLib("visual_scene",r),this.parseLib("library_geometries"),this.parseLib("library_materials",n),this.parseLib("library_images"),this.xmlDoc=null,new s(this.position,this.scene)},h.prototype.parseLib=function(t,e){var s=this.xmlDoc.getElementsByTagName(t),l=[];s&&s.length&&(l=s[0].childNodes);for(var h=0;h<l.length;h++){var u=l[h];if(1===u.nodeType)switch(u.nodeName){case"node":var c=(new o).parse(u,e);c&&this.scene.root.children.push(c);break;case"geometry":var d=u.getAttribute("id"),p=u.querySelector("mesh"),f=new n(d).parse(p);f&&(this.scene.meshes[d]=f);break;case"material":var g=u.getAttribute("id"),m=u.querySelector("instance_effect"),y=m.getAttribute("url").substr(1),E=a.querySelectorById(e,y),v=new r(g).parse(E);v&&(this.scene.materials[g]=v);break;case"image":var _=u.getAttribute("id"),b=u.getAttribute("name"),w=new i(_,b).parse(u);w&&(this.scene.images[_]=w)}}},h}),i("shapes/Compass",["../error/ArgumentError","../util/Logger","../util/Offset","../shapes/ScreenImage"],function(t,e,i,r){"use strict";var n=function(t,e){var n=t?t:new i(WorldWind.OFFSET_FRACTION,1,WorldWind.OFFSET_FRACTION,1),o=e?e:WorldWind.configuration.baseUrl+"images/notched-compass.png";r.call(this,n,o),t||(this.imageOffset=new i(WorldWind.OFFSET_FRACTION,1.1,WorldWind.OFFSET_FRACTION,1.1)),this.size=.15};return n.prototype=Object.create(r.prototype),n.prototype.render=function(t){this.imageRotation=t.navigator.heading,this.imageTilt=t.navigator.tilt;var e=this.getActiveTexture(t);e&&(this.imageScale=this.size*t.currentGlContext.drawingBufferWidth/e.imageWidth),r.prototype.render.call(this,t)},n}),i("layer/CompassLayer",["../shapes/Compass","../layer/RenderableLayer"],function(t,e){"use strict";var i=function(){e.call(this,"Compass"),this._compass=new t(null,null),this.addRenderable(this._compass)};return i.prototype=Object.create(e.prototype),Object.defineProperties(i.prototype,{compass:{get:function(){return this._compass},set:function(e){e&&e instanceof t&&(this.removeAllRenderables(),this.addRenderable(e),this._compass=e)}}}),i}),i("shapes/Text",["../error/ArgumentError","../shaders/BasicTextureProgram","../util/Color","../util/Font","../util/Logger","../geom/Matrix","../pick/PickedObject","../render/Renderable","../shapes/TextAttributes","../error/UnsupportedOperationError","../geom/Vec2","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o,s,a,l,h,u,c,d){"use strict";var p=function(e){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"Text","constructor","missingText"));a.call(this),this.attributes=new l(null),this.highlightAttributes=null,this.highlighted=!1,this.enabled=!0,this.text=e,this.altitudeMode=WorldWind.ABSOLUTE,this.pickDelegate=null,this.alwaysOnTop=!1,this.targetVisibility=1,this.currentVisibility=1,this.declutterGroup=0,this.markerImageSource=WorldWind.configuration.baseUrl+"images/white-dot.png",this.markerImageScale=.1,this.activeAttributes=null,this.activeTexture=null,this.imageTransform=o.fromIdentity(),this.imageBounds=null,this.layer=null,this.depthOffset=-.003,this.screenPoint=new c(0,0,0)};return p.matrix=o.fromIdentity(),p.glPickPoint=new c(0,0,0),p.prototype=Object.create(a.prototype),p.prototype.copy=function(t){return this.text=t.text,this.attributes=t.attributes,this.highlightAttributes=t.highlightAttributes,this.highlighted=t.highlighted,this.enabled=t.enabled,this.altitudeMode=t.altitudeMode,this.pickDelegate=t.pickDelegate,this.alwaysOnTop=t.alwaysOnTop,this.depthOffset=t.depthOffset,this.declutterGroup=t.declutterGroup,this.targetVisibility=t.targetVisibility,this.currentVisibility=t.currentVisibility,this},Object.defineProperties(p.prototype,{screenBounds:{get:function(){return this.imageBounds}}}),p.prototype.render=function(t){if(this.enabled&&this.text&&0!==this.text.length&&t.accumulateOrderedRenderables){var e;if(this.lastFrameTime!==t.timestamp)e=this.makeOrderedRenderable(t);else{var i=this.clone();e=i.makeOrderedRenderable(t)}e&&e.isVisible(t)&&(e.layer=t.currentLayer,this.lastFrameTime=t.timestamp,t.addOrderedRenderable(e))}},p.prototype.renderOrdered=function(t){if((0!==this.currentVisibility||0!==this.targetVisibility||this.markerImageSource)&&(this.drawOrderedText(t),t.pickingMode)){var e=new s(this.pickColor.clone(),this.pickDelegate?this.pickDelegate:this,this.position,this.layer,!1);t.resolvePick(e)}},p.prototype.makeOrderedRenderable=function(t){var e,i,r,n;return this.determineActiveAttributes(t),this.activeAttributes&&this.computeScreenPointAndEyeDistance(t)?(this.activeTexture=t.createTextTexture(this.text,this.activeAttributes),e=this.activeTexture.imageWidth,i=this.activeTexture.imageHeight,r=this.activeAttributes.scale,n=this.activeAttributes.offset.offsetForSize(e,i),this.imageTransform.setTranslation(this.screenPoint[0]-n[0]*r,this.screenPoint[1]-n[1]*r,this.screenPoint[2]),this.imageTransform.setScale(e*r,i*r,1),this.imageBounds=d.boundingRectForUnitQuad(this.imageTransform),this):null},p.prototype.computeScreenPointAndEyeDistance=function(t){throw new h(n.logMessage(n.LEVEL_SEVERE,"Renderable","render","abstractInvocation"))},p.prototype.determineActiveAttributes=function(t){this.highlighted&&this.highlightAttributes?this.activeAttributes=this.highlightAttributes:this.activeAttributes=this.attributes},p.prototype.isVisible=function(t){return t.pickingMode?t.pickRectangle&&this.imageBounds.intersects(t.pickRectangle):this.imageBounds.intersects(t.viewport)},p.prototype.drawOrderedText=function(t){this.beginDrawing(t);try{this.doDrawOrderedText(t),!t.pickingMode}finally{this.endDrawing(t)}},p.prototype.drawBatchOrderedText=function(t){for(var e;(e=t.peekOrderedRenderable())&&e instanceof p;){t.popOrderedRenderable();try{e.doDrawOrderedText(t)}catch(t){n.logMessage(n.LEVEL_WARNING,"Text","drawBatchOrderedText","Error occurred while rendering text using batching: "+t.message)}}},p.prototype.beginDrawing=function(t){var i,r=t.currentGlContext;t.findAndBindProgram(e),i=t.currentProgram,r.bindBuffer(r.ARRAY_BUFFER,t.unitQuadBuffer3()),r.vertexAttribPointer(i.vertexPointLocation,3,r.FLOAT,!1,0,0),r.bindBuffer(r.ARRAY_BUFFER,t.unitQuadBuffer()),r.vertexAttribPointer(i.vertexTexCoordLocation,2,r.FLOAT,!1,0,0),r.enableVertexAttribArray(i.vertexPointLocation),r.enableVertexAttribArray(i.vertexTexCoordLocation),i.loadTextureUnit(r,r.TEXTURE0),i.loadModulateColor(r,!1),r.depthMask(!1)},p.prototype.endDrawing=function(t){var e=t.currentGlContext,i=t.currentProgram;e.disableVertexAttribArray(i.vertexPointLocation),e.disableVertexAttribArray(i.vertexTexCoordLocation),e.bindBuffer(e.ARRAY_BUFFER,null),e.bindTexture(e.TEXTURE_2D,null),e.depthMask(!0)},p.prototype.doDrawOrderedText=function(t){var e=t.currentGlContext,r=t.currentProgram;if(!t.pickingMode&&this.currentVisibility!==this.targetVisibility){var n=(t.timestamp-t.previousRedrawTimestamp)/t.fadeTime;this.currentVisibility<this.targetVisibility?this.currentVisibility=Math.min(1,this.currentVisibility+n):this.currentVisibility=Math.max(0,this.currentVisibility-n),t.redrawRequested=!0}this.activeAttributes.depthTest||e.disable(e.DEPTH_TEST),t.pickingMode?(this.pickColor=t.uniquePickColor(),r.loadColor(e,this.pickColor),r.loadOpacity(e,1),r.loadTextureEnabled(e,!1)):(r.loadColor(e,i.WHITE),r.loadOpacity(e,this.layer.opacity*this.currentVisibility)),this.currentVisibility>0&&this.drawLabel(t),this.currentVisibility<1&&this.markerImageSource&&this.drawMarker(t),this.activeAttributes.depthTest||e.enable(e.DEPTH_TEST)},p.prototype.drawLabel=function(t){var e,i=t.currentGlContext,r=t.currentProgram;!t.pickingMode&&this.activeTexture&&(p.matrix.setToIdentity(),p.matrix.multiplyByTextureTransform(this.activeTexture),e=this.activeTexture.bind(t),r.loadTextureEnabled(i,e),r.loadTextureMatrix(i,p.matrix)),p.matrix.copy(t.screenProjection),p.matrix.multiplyMatrix(this.imageTransform),r.loadModelviewProjection(i,p.matrix),i.drawArrays(i.TRIANGLE_STRIP,0,4)},p.prototype.drawMarker=function(t){var e,i=t.currentGlContext,r=t.currentProgram,n=t.gpuResourceCache.resourceForKey(this.markerImageSource);if(!n)return void t.gpuResourceCache.retrieveTexture(t.currentGlContext,this.markerImageSource);t.pickingMode||(p.matrix.setToIdentity(),p.matrix.multiplyByTextureTransform(n),e=n.bind(t),r.loadTextureEnabled(i,e),r.loadTextureMatrix(i,p.matrix),r.loadOpacity(i,this.layer.opacity*(1-this.currentVisibility)));var o=this.markerImageScale;p.matrix.copy(t.screenProjection),p.matrix.multiplyByTranslation(this.screenPoint[0]-o*n.imageWidth/2,this.screenPoint[1]-o*n.imageWidth/2,this.screenPoint[2]),p.matrix.multiplyByScale(n.imageWidth*o,n.imageHeight*o,1),r.loadModelviewProjection(i,p.matrix),i.drawArrays(i.TRIANGLE_STRIP,0,4)},p}),i("shapes/ScreenText",["../error/ArgumentError","../util/Logger","../util/Offset","../shapes/Text"],function(t,e,i,r){"use strict";var n=function(i,n){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"Text","constructor","missingOffset"));r.call(this,n),this.screenOffset=i,this.altitudeMode=null};return n.prototype=Object.create(r.prototype),n.prototype.render=function(t){this.lastFrameTime!==t.timestamp&&r.prototype.render.call(this,t)},n.prototype.computeScreenPointAndEyeDistance=function(t){var e=t.currentGlContext,i=this.screenOffset.offsetForSize(e.drawingBufferWidth,e.drawingBufferHeight);return this.screenPoint[0]=i[0],this.screenPoint[1]=i[1],this.screenPoint[2]=0,this.eyeDistance=0,!0},n}),i("layer/CoordinatesDisplayLayer",["../error/ArgumentError","../util/Color","../util/Font","../layer/Layer","../util/Logger","../util/Offset","../geom/Position","../shapes/ScreenImage","../shapes/ScreenText","../shapes/TextAttributes","../geom/Vec2"],function(t,e,i,r,n,o,s,a,l,h,u){"use strict";var c=function(i){function s(t){p.handleUIEvent(t)}function u(t,e){p.handleRedraw(e)}if(!i)throw new t(n.logMessage(n.LEVEL_SEVERE,"CoordinatesDisplayLayer","constructor","missingWorldWindow"));r.call(this,"Coordinates"),this.wwd=i,this.pickEnabled=!1,this.eventType=null,this.clientX=null,this.clientY=null,this.terrainPosition=null,this.latText=new l(new o(WorldWind.OFFSET_PIXELS,0,WorldWind.OFFSET_PIXELS,0)," "),this.latText.attributes=new h(null),this.latText.attributes.color=e.YELLOW,this.lonText=new l(new o(WorldWind.OFFSET_PIXELS,0,WorldWind.OFFSET_PIXELS,0)," "),this.lonText.attributes=new h(null),this.lonText.attributes.color=e.YELLOW,this.elevText=new l(new o(WorldWind.OFFSET_PIXELS,0,WorldWind.OFFSET_PIXELS,0)," "),this.elevText.attributes=new h(null),this.elevText.attributes.color=e.YELLOW,this.eyeText=new l(new o(WorldWind.OFFSET_PIXELS,0,WorldWind.OFFSET_PIXELS,0)," "),this.eyeText.attributes=new h(null),this.eyeText.attributes.color=e.YELLOW;var c=new o(WorldWind.OFFSET_FRACTION,.5,WorldWind.OFFSET_FRACTION,.5),d=WorldWind.configuration.baseUrl+"images/crosshair.png";this.crosshairImage=new a(c,d);var p=this;window.PointerEvent?(i.addEventListener("pointerdown",s),i.addEventListener("pointermove",s),i.addEventListener("pointerleave",s)):(i.addEventListener("mousedown",s),i.addEventListener("mousemove",s),i.addEventListener("mouseleave",s),i.addEventListener("touchstart",s),i.addEventListener("touchmove",s)),this.wwd.redrawCallbacks.push(u)};return c.prototype=Object.create(r.prototype),c.prototype.doRender=function(t){var e,i,r,n,s,a=this.terrainPosition,l=t.eyePosition,h=t.currentGlContext.canvas.clientWidth;h>650?(e=h/2-50,i=11,r=WorldWind.OFFSET_PIXELS,n=0):h>400?(e=60,i=5,r=WorldWind.OFFSET_INSET_PIXELS,n=1):(e=60,i=5,r=WorldWind.OFFSET_INSET_PIXELS,n=1,s=!0),this.latText.text=a?this.formatLatitude(a.latitude):null,this.latText.screenOffset=new o(WorldWind.OFFSET_PIXELS,e,r,i),this.latText.attributes.offset=new o(WorldWind.OFFSET_FRACTION,1,WorldWind.OFFSET_FRACTION,n),this.latText.render(t),e+=70,this.lonText.text=a?this.formatLongitude(a.longitude):null,this.lonText.screenOffset=new o(WorldWind.OFFSET_PIXELS,e,r,i),this.lonText.attributes.offset=new o(WorldWind.OFFSET_FRACTION,1,WorldWind.OFFSET_FRACTION,n),this.lonText.render(t),t.globe.is2D()||(e+=70,this.elevText.text=a?this.formatAltitude(a.altitude,"m"):null,this.elevText.screenOffset=new o(WorldWind.OFFSET_PIXELS,e,r,i),this.elevText.attributes.offset=new o(WorldWind.OFFSET_FRACTION,1,WorldWind.OFFSET_FRACTION,n),this.elevText.render(t)),s||(e+=40,this.eyeText.text="Eye  "+this.formatAltitude(l.altitude,l.altitude<1e3?"m":"km"),this.eyeText.screenOffset=new o(WorldWind.OFFSET_PIXELS,e,r,i),this.eyeText.attributes.offset=new o(WorldWind.OFFSET_FRACTION,0,WorldWind.OFFSET_FRACTION,n),this.eyeText.render(t)),"touch"===this.eventType&&this.crosshairImage.render(t),this.inCurrentFrame=!0},c.prototype.handleUIEvent=function(t){t.type.indexOf("pointer")!==-1?this.eventType=t.pointerType:t.type.indexOf("mouse")!==-1?this.eventType="mouse":t.type.indexOf("touch")!==-1&&(this.eventType="touch"),t.type.indexOf("leave")!==-1?(this.clientX=null,this.clientY=null):(this.clientX=t.clientX,this.clientY=t.clientY),this.wwd.redraw()},c.prototype.handleRedraw=function(t){if(t===WorldWind.BEFORE_REDRAW){var e,i;("mouse"===this.eventType||"pen"===this.eventType)&&this.clientX&&this.clientY?(e=this.wwd.canvasCoordinates(this.clientX,this.clientY),e[0]>=0&&e[0]<this.wwd.canvas.width&&e[1]>=0&&e[1]<this.wwd.canvas.height&&(i=this.wwd.pickTerrain(e).terrainObject())):"touch"===this.eventType&&(e=new u(this.wwd.canvas.width/2,this.wwd.canvas.height/2),i=this.wwd.pickTerrain(e).terrainObject()),this.terrainPosition=i?i.position:null}},c.prototype.formatLatitude=function(t){var e=t<0?"°S":"°N";return Math.abs(t).toFixed(2)+e},c.prototype.formatLongitude=function(t){var e=t<0?"°W":"°E";return Math.abs(t).toFixed(2)+e},c.prototype.formatAltitude=function(t,e){return"km"===e&&(t/=1e3),t.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,",")+" "+e},c}),i("util/Date",[],function(){"use strict";var t=function(t){t?this._date=new Date(t):this._date=new Date};return t.prototype=Object.create(Date.prototype),t.prototype.isAfter=function(t){return this.compare(t)==-1},t.prototype.isBefore=function(t){return 1==this.compare(t)},t.prototype.valueOf=function(){return this._date.valueOf()},t.prototype.getTime=function(){return this._date.getTime()},t.prototype.compare=function(t){var e=this._date.valueOf(),i=t.valueOf();return e>i?-1:e<i?1:0},t}),i("layer/DigitalGlobeTiledImageLayer",["../geom/Angle","../error/ArgumentError","../util/Color","../geom/Location","../util/Logger","../geom/Sector","../layer/MercatorTiledImageLayer"],function(t,e,i,r,n,o,s){"use strict";var a=function(t,i,a){if(!i)throw new e(n.logMessage(n.LEVEL_SEVERE,"DigitalGlobeTiledImageLayer","constructor","The map ID is null or undefined."));if(!a)throw new e(n.logMessage(n.LEVEL_SEVERE,"DigitalGlobeTiledImageLayer","constructor","The access token is null or undefined."));this.imageSize=256,t=t||"Digital Globe",s.call(this,new o(-85.05,85.05,-180,180),new r(85.05,180),19,"image/jpeg",t,this.imageSize,this.imageSize),this.mapId=i,this.accessToken=a,this.displayName=t,this.pickEnabled=!0,this.destCanvas=document.createElement("canvas"),this.destContext=this.destCanvas.getContext("2d"),this.requestMetadata();var l=this;this.urlBuilder={urlForTile:function(t,e){return l.metadataRetrievalInProcess?null:l.urlTemplate.replace("{z}",t.level.levelNumber+1).replace("{x}",t.column).replace("{y}",t.row)}}};return a.prototype=Object.create(s.prototype),a.prototype.requestMetadata=function(){if(!this.metadataRetrievalInProcess){this.metadataRetrievalInProcess=!0;var t="https://api.mapbox.com/v4/"+this.mapId+".json?secure&access_token="+this.accessToken,e=new XMLHttpRequest,i=this;e.onreadystatechange=function(){if(4===e.readyState&&200===e.status){var t=JSON.parse(e.responseText);i.urlTemplate=t.tiles[0];var r=document.createEvent("Event");r.initEvent(WorldWind.REDRAW_EVENT_TYPE,!0,!0),window.dispatchEvent(r),i.metadataRetrievalInProcess=!1}},e.open("GET",t,!0),e.send()}},a.prototype.doRender=function(t){s.prototype.doRender.call(this,t),this.inCurrentFrame&&t.screenCreditController.addCredit("© Digital Globe",i.DARK_GRAY)},a.prototype.createTopLevelTiles=function(t){this.topLevelTiles=[],this.topLevelTiles.push(this.createTile(null,this.levels.firstLevel(),0,0)),this.topLevelTiles.push(this.createTile(null,this.levels.firstLevel(),0,1)),this.topLevelTiles.push(this.createTile(null,this.levels.firstLevel(),1,0)),this.topLevelTiles.push(this.createTile(null,this.levels.firstLevel(),1,1))},a.prototype.mapSizeForLevel=function(t){return 256<<t+1},a}),i("render/DoubleBufferedFbo",["../error/ArgumentError","../util/Logger"],function(t,e){"use strict";var i=function(i,r,n,o,s){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"DoubleBufferedFbo","constructor","missing DrawContext"));if(!r||!n)throw new t(e.logMessage(e.LEVEL_SEVERE,"DoubleBufferedFbo","constructor","missing texture"));if(o<0||s<0)throw new t(e.logMessage(e.LEVEL_SEVERE,"DoubleBufferedFbo","constructor","The framebuffer width or height is less than zero."));this.width=o,this.height=s,this.size=o*s*4*2,this.fbo1=i.currentGlContext.createFramebuffer(),this.fbo2=i.currentGlContext.createFramebuffer(),this.texture1=r,this.texture2=n,this.fbo1Complete=!1,this.fbo2Complete=!1,this.primary=1,this.isCleared=!0};return i.prototype.bindFbo=function(t){var e=t.currentGlContext,i=this.getPrimaryFbo();e.bindFramebuffer(e.FRAMEBUFFER,i),this.ensureFboComplete(t)},i.prototype.bind=function(t){var e=t.currentGlContext,i=this.getPrimaryTexture();return e.bindTexture(e.TEXTURE_2D,i),t.frameStatistics.incrementTextureLoadCount(1),!0},i.prototype.dispose=function(t){t.deleteTexture(this.texture1),t.deleteTexture(this.texture2),t.deleteFramebuffer(this.fbo1),t.deleteFramebuffer(this.fbo2),this.texture1=void 0,this.texture2=void 0,this.fbo1=void 0,this.fbo2=void 0},i.prototype.getPrimaryFbo=function(){return 1===this.primary?this.fbo1:this.fbo2},i.prototype.getSecondaryFbo=function(){return 1===this.primary?this.fbo2:this.fbo1},i.prototype.getPrimaryTexture=function(){return 1===this.primary?this.texture1:this.texture2},i.prototype.getSecondaryTexture=function(){return 1===this.primary?this.texture2:this.texture1},i.prototype.clearFbo=function(t){if(!this.isCleared){var e=t.currentGlContext,i=e.COLOR_BUFFER_BIT|e.DEPTH_BUFFER_BIT|e.STENCIL_BUFFER_BIT;this.bindFbo(t),e.clear(i),e.viewport(0,0,this.width,this.height),this.swap(),this.bindFbo(t),e.clear(i),this.swap(),this.isCleared=!0}},i.prototype.swap=function(){1===this.primary?this.primary=2:this.primary=1},i.prototype.ensureFboComplete=function(t){var e=t.currentGlContext;1!==this.primary||this.fbo1Complete?2!==this.primary||this.fbo2Complete||(e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,this.texture2,0),this.fbo2Complete=!0):(e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,this.texture1,0),this.fbo1Complete=!0)},i}),i("util/FrameStatistics",[],function(){"use strict";var t=function(){this.frameCount=0,this.frameTimeCumulative=0,this.frameTimeBase=0,this.frameTimeExtremes=[Number.POSITIVE_INFINITY,Number.NEGATIVE_INFINITY],this.frameTime=0,this.tessellationTime=0,this.layerRenderingTime=0,this.orderedRenderingTime=0,this.terrainTileCount=0,this.imageTileCount=0,this.renderedTileCount=0,this.tileUpdateCount=0,this.textureLoadCount=0,this.vboLoadCount=0,this.frameTimeAverage=0,this.frameRateAverage=0,this.frameTimeMin=0,this.frameTimeMax=0};return t.prototype.beginFrame=function(){this.frameTime=Date.now(),this.tessellationTime=0,this.layerRenderingTime=0,this.orderedRenderingTime=0,this.terrainTileCount=0,this.imageTileCount=0,this.renderedTileCount=0,this.tileUpdateCount=0,this.textureLoadCount=0,this.vboLoadCount=0,++this.frameCount},t.prototype.endFrame=function(){var t=Date.now();this.frameTime=t-this.frameTime,this.frameTimeCumulative+=this.frameTime,this.frameTimeExtremes[0]=Math.min(this.frameTimeExtremes[0],this.frameTime),this.frameTimeExtremes[1]=Math.max(this.frameTimeExtremes[1],this.frameTime),t-this.frameTimeBase>2e3&&(this.frameTimeAverage=this.frameTimeCumulative/this.frameCount,this.frameRateAverage=1e3*this.frameCount/(t-this.frameTimeBase),this.frameTimeMin=this.frameTimeExtremes[0],this.frameTimeMax=this.frameTimeExtremes[1],this.frameCount=0,this.frameTimeCumulative=0,this.frameTimeBase=t,this.frameTimeExtremes=[Number.POSITIVE_INFINITY,Number.NEGATIVE_INFINITY])},t.prototype.incrementRenderedTileCount=function(t){this.renderedTileCount+=t},t.prototype.setTerrainTileCount=function(t){
this.terrainTileCount=t},t.prototype.incrementImageTileCount=function(t){this.imageTileCount=t},t.prototype.incrementTileUpdateCount=function(t){this.tileUpdateCount+=t},t.prototype.incrementTextureLoadCount=function(t){this.textureLoadCount+=t},t.prototype.incrementVboLoadCount=function(t){this.vboLoadCount+=t},t}),i("render/FramebufferTexture",["../error/ArgumentError","../util/Logger","../util/WWMath"],function(t,e){"use strict";var i=function(i,r,n,o){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"FramebufferTexture","constructor","missingGlContext"));if(r<0||n<0)throw new t(e.logMessage(e.LEVEL_SEVERE,"FramebufferTexture","constructor","The framebuffer width or height is less than zero."));this.width=r,this.height=n,this.depth=o,this.size=r*n*4+(o?r*n*2:0),this.framebufferId=i.createFramebuffer(),i.bindFramebuffer(i.FRAMEBUFFER,this.framebufferId),this.texture=i.createTexture(),i.bindTexture(i.TEXTURE_2D,this.texture),i.texParameteri(i.TEXTURE_2D,i.TEXTURE_MIN_FILTER,i.LINEAR),i.texParameteri(i.TEXTURE_2D,i.TEXTURE_MAG_FILTER,i.LINEAR),i.texParameteri(i.TEXTURE_2D,i.TEXTURE_WRAP_S,i.CLAMP_TO_EDGE),i.texParameteri(i.TEXTURE_2D,i.TEXTURE_WRAP_T,i.CLAMP_TO_EDGE),i.texImage2D(i.TEXTURE_2D,0,i.RGBA,r,n,0,i.RGBA,i.UNSIGNED_BYTE,null),i.framebufferTexture2D(i.FRAMEBUFFER,i.COLOR_ATTACHMENT0,i.TEXTURE_2D,this.texture,0),this.depthBuffer=null,o&&(this.depthBuffer=i.createRenderbuffer(),i.bindRenderbuffer(i.RENDERBUFFER,this.depthBuffer),i.renderbufferStorage(i.RENDERBUFFER,i.DEPTH_COMPONENT16,r,n),i.framebufferRenderbuffer(i.FRAMEBUFFER,i.DEPTH_ATTACHMENT,i.RENDERBUFFER,this.depthBuffer));var s=i.checkFramebufferStatus(i.FRAMEBUFFER);s!=i.FRAMEBUFFER_COMPLETE&&(e.logMessage(e.LEVEL_WARNING,"FramebufferTexture","constructor","Error creating framebuffer: "+s),this.framebufferId=null,this.texture=null,this.depthBuffer=null),i.bindFramebuffer(i.FRAMEBUFFER,null),i.bindRenderbuffer(i.RENDERBUFFER,null),i.bindTexture(i.TEXTURE_2D,null)};return i.prototype.bind=function(t){return this.texture&&t.currentGlContext.bindTexture(gl.TEXTURE_2D,this.texture),!!this.texture},i}),i("render/FramebufferTile",["../error/ArgumentError","../render/FramebufferTexture","../util/Logger","../geom/Matrix","../geom/Rectangle","../render/TextureTile"],function(t,e,i,r,n,o){"use strict";var s=function(e,n,s,a,l){if(!l||l.length<1)throw new t(i.logMessage(i.LEVEL_SEVERE,"FramebufferTile","constructor","The specified cache name is null, undefined or zero length."));o.call(this,e,n,s,a),this.gpuCacheKey=l,this.textureTransform=r.fromIdentity().setToUnitYFlip(),this.mustClear=!0};return s.prototype=Object.create(o.prototype),s.prototype.clearFramebuffer=function(t){this.mustClear=!0},s.prototype.bindFramebuffer=function(t){var e=t.gpuResourceCache.resourceForKey(this.gpuCacheKey);return e||(e=this.createFramebuffer(t)),t.bindFramebuffer(e),this.mustClear&&(this.doClearFramebuffer(t),this.mustClear=!1),!0},s.prototype.createFramebuffer=function(t){var i=new e(t.currentGlContext,this.tileWidth,this.tileHeight,!1);return t.gpuResourceCache.putResource(this.gpuCacheKey,i,i.size),i},s.prototype.doClearFramebuffer=function(t){var e=t.currentGlContext;e.clearColor(0,0,0,0),e.clear(e.COLOR_BUFFER_BIT)},s.prototype.applyInternalTransform=function(t,e){e.multiplyMatrix(this.textureTransform)},s}),i("render/FramebufferTileController",["../error/ArgumentError","../render/FramebufferTile","../util/LevelSet","../geom/Location","../util/Logger","../cache/MemoryCache","../geom/Sector","../util/Tile"],function(t,e,i,r,n,o,s,a){"use strict";var l=function(){this.tileWidth=256,this.tileHeight=256,this.detailControl=1.75,this.levels=new i(s.FULL_SPHERE,new r(45,45),16,this.tileWidth,this.tileHeight),this.topLevelTiles=[],this.currentTiles=[],this.currentTimestamp=null,this.currentGlobeStateKey=null,this.tileCache=new o(5e5,4e5),this.key="FramebufferTileController "+ ++l.keyPool};return l.keyPool=0,l.prototype.selectTiles=function(e,i){if(!i)throw new t(n.logMessage(n.LEVEL_SEVERE,"FramebufferTileController","selectTiles","missingSector"));this.assembleTiles(e);for(var r=[],o=0,s=this.currentTiles.length;o<s;o++){var a=this.currentTiles[o];a.sector.overlaps(i)&&(a.selected=!0,r.push(a))}return r},l.prototype.render=function(t){if(0!=this.currentTiles.length){for(var e=[],i=0,r=this.currentTiles.length;i<r;i++){var n=this.currentTiles[i];n.selected&&e.push(n)}t.surfaceTileRenderer.renderTiles(t,e,1);var o=t.currentGlContext,s=t.currentFramebuffer;try{for(o.clearColor(0,0,0,0),i=0,r=e.length;i<r;i++)n=e[i],n.selected=!1,n.bindFramebuffer(t),o.clear(o.COLOR_BUFFER_BIT)}finally{t.bindFramebuffer(s)}}},l.prototype.assembleTiles=function(t){var e=t.timestamp,i=t.globeStateKey;this.currentTimestamp==e&&this.currentGlobeStateKey==i||(this.doAssembleTiles(t),this.currentTimestamp=e,this.currentGlobeStateKey=i)},l.prototype.doAssembleTiles=function(t){if(this.currentTiles=[],t.terrain){0==this.topLevelTiles.length&&this.createTopLevelTiles();for(var e=0,i=this.topLevelTiles.length;e<i;e++){var r=this.topLevelTiles[e];r.update(t),this.isTileVisible(t,r)&&this.addTileOrDescendants(t,r)}}},l.prototype.createTile=function(t,i,r,n){var o=this.key+" "+i.levelNumber+"."+r+"."+n;return new e(t,i,r,n,o)},l.prototype.createTopLevelTiles=function(){a.createTilesForLevel(this.levels.firstLevel(),this,this.topLevelTiles)},l.prototype.addTileOrDescendants=function(t,e){if(this.tileMeetsRenderingCriteria(t,e))return void this.addTile(e);for(var i=e.subdivideToCache(e.level.nextLevel(),this,this.tileCache),r=0,n=i.length;r<n;r++){var o=i[r];o.update(t),this.isTileVisible(t,o)&&this.addTileOrDescendants(t,o)}},l.prototype.addTile=function(t){this.currentTiles.push(t)},l.prototype.isTileVisible=function(t,e){return!(t.globe.projectionLimits&&!e.sector.overlaps(t.globe.projectionLimits))&&(t.pickingMode?e.extent.intersectsFrustum(t.pickFrustum):e.extent.intersectsFrustum(t.frustumInModelCoordinates))},l.prototype.tileMeetsRenderingCriteria=function(t,e){var i=this.detailControl;return(e.sector.minLatitude>=75||e.sector.maxLatitude<=-75)&&(i*=1.2),e.level.isLastLevel()||!e.mustSubdivide(t,i)},l}),i("globe/ElevationModel",["../error/ArgumentError","../geom/Angle","../geom/Location","../util/Logger","../util/WWUtil"],function(t,e,i,r,n){"use strict";var o=function(){this.id=0,this.stateKey="",this.coverages=[],this.scratchLocation=new i(0,0),this.computeStateKey()};return Object.defineProperties(o.prototype,{timestamp:{get:function(){var t,e,i=0;for(t=0,e=this.coverages.length;t<e;t++){var r=this.coverages[t];i<r.timestamp&&(i=r.timestamp)}return i}},minElevation:{get:function(){for(var t=Number.MAX_VALUE,e=0,i=this.coverages.length;e<i;e++){var r=this.coverages[e];r.enabled&&r.minElevation<t&&(t=r.minElevation)}return t!==Number.MAX_VALUE?t:0}},maxElevation:{get:function(){for(var t=-Number.MAX_VALUE,e=0,i=this.coverages.length;e<i;e++){var r=this.coverages[e];r.enabled&&r.maxElevation>t&&(t=r.maxElevation)}return t!==-Number.MAX_VALUE?t:0}}}),o.idPool=0,o.prototype.computeStateKey=function(){this.id=++o.idPool,this.stateKey="elevationModel "+this.id.toString()+" "},o.prototype.coverageComparator=function(t,e){var i=t.resolution,r=e.resolution;return i>r?-1:i===r?0:1},o.prototype.performCoverageListChangedActions=function(){this.coverages.length>1&&this.coverages.sort(this.coverageComparator),this.computeStateKey()},o.prototype.addCoverage=function(e){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"ElevationModel","addCoverage","missingCoverage"));return!this.containsCoverage(e)&&(this.coverages.push(e),this.performCoverageListChangedActions(),!0)},o.prototype.removeAllCoverages=function(){this.coverages.length>0&&(this.coverages=[],this.performCoverageListChangedActions())},o.prototype.removeCoverage=function(e){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"ElevationModel","removeCoverage","missingCoverage"));var i=this.coverages.indexOf(e);i>=0&&(this.coverages.splice(i,1),this.performCoverageListChangedActions())},o.prototype.containsCoverage=function(e){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"ElevationModel","containsCoverage","missingCoverage"));var i=this.coverages.indexOf(e);return i>=0},o.prototype.minAndMaxElevationsForSector=function(e){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"ElevationModel","minAndMaxElevationsForSector","missingSector"));for(var i=[Number.MAX_VALUE,-Number.MAX_VALUE],n=this.coverages.length-1;n>=0;n--){var o=this.coverages[n];if(o.enabled&&o.coverageSector.intersects(e)&&o.minAndMaxElevationsForSector(e,i))break}return i[0]!==Number.MAX_VALUE?i:[0,0]},o.prototype.elevationAtLocation=function(t,e){var i,r=this.coverages.length;for(i=r-1;i>=0;i--){var n=this.coverages[i];if(n.enabled&&n.coverageSector.containsLocation(t,e)){var o=n.elevationAtLocation(t,e);if(null!==o)return o}}return 0},o.prototype.preferredCoverageIndex=function(t,e,i){var r,n=this.coverages.length,o=Number.MAX_VALUE,s=-1;for(r=0;r<n;r++){var a=this.coverages[r],l=a.enabled&&(null!==t&&a.coverageSector.intersects(t)||null!==e&&a.coverageSector.containsLocation(e.latitude,e.longitude));if(l){var h=Math.abs(a.resolution-i);if(h>o)return s;o=h,s=r}}return s},o.prototype.bestCoverageAtLocation=function(e,i,n){if(!n||n<0)throw new t(r.logMessage(r.LEVEL_SEVERE,"ElevationModel","bestCoverageAtLocation","invalidResolution"));this.scratchLocation.set(e,i);var o=this.preferredCoverageIndex(null,this.scratchLocation,n);return o>=0?this.coverages[o]:null},o.prototype.elevationsForGrid=function(e,i,o,s,a){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"ElevationModel","elevationsForGrid","missingSector"));if(!i||!o||i<1||o<1)throw new t(r.logMessage(r.LEVEL_SEVERE,"ElevationModel","elevationsForGrid","The specified number of latitudinal or longitudinal positions is less than one."));if(!s)throw new t(r.logMessage(r.LEVEL_SEVERE,"ElevationModel","elevationsForGrid","missingTargetResolution"));if(!a)throw new t(r.logMessage(r.LEVEL_SEVERE,"ElevationModel","elevationsForGrid","missingResult"));n.fillArray(a,NaN);var l=Number.MAX_VALUE,h=!1,u=this.preferredCoverageIndex(e,null,s);if(u>=0)for(var c=u;!h&&c>=0;c--){var d=this.coverages[c];d.enabled&&d.coverageSector.intersects(e)&&(h=d.elevationsForGrid(e,i,o,a),h&&(l=d.resolution))}if(!h){var p=a.length;for(c=0;c<p;c++)isNaN(a[c])&&(a[c]=0)}return l},o}),i("projections/GeographicProjection",["../error/ArgumentError","../util/Logger","../geom/Sector","../error/UnsupportedOperationError"],function(t,e,i,r){"use strict";var n=function(t,e,i){this.displayName=t||"Geographic Projection",this.continuous=e,this.projectionLimits=i,this.is2D=!0};return n.prototype.geographicToCartesian=function(t,i,n,o,s,a){throw new r(e.logMessage(e.LEVEL_SEVERE,"GeographicProjection","geographicToCartesian","abstractInvocation"))},n.prototype.geographicToCartesianGrid=function(t,i,n,o,s,a,l,h){throw new r(e.logMessage(e.LEVEL_SEVERE,"GeographicProjection","geographicToCartesianGrid","abstractInvocation"))},n.prototype.cartesianToGeographic=function(t,i,n,o,s,a){throw new r(e.logMessage(e.LEVEL_SEVERE,"GeographicProjection","cartesianToGeographic","abstractInvocation"))},n.prototype.northTangentAtLocation=function(i,r,n,o){if(!o)throw new t(e.logMessage(e.LEVEL_SEVERE,"ProjectionEquirectangular","northTangentAtLocation","missingResult"));return o[0]=0,o[1]=1,o[2]=0,o},n.prototype.northTangentAtPoint=function(i,r,n,o,s,a){if(!a)throw new t(e.logMessage(e.LEVEL_SEVERE,"ProjectionEquirectangular","northTangentAtPoint","missingResult"));return a[0]=0,a[1]=1,a[2]=0,a},n.prototype.surfaceNormalAtLocation=function(i,r,n,o){if(!o)throw new t(e.logMessage(e.LEVEL_SEVERE,"GeographicProjection","surfaceNormalAtLocation","missingResult"));return o[0]=0,o[1]=0,o[2]=1,o},n.prototype.surfaceNormalAtPoint=function(i,r,n,o,s){if(!s)throw new t(e.logMessage(e.LEVEL_SEVERE,"GeographicProjection","surfaceNormalAtPoint","missingResult"));return s[0]=0,s[1]=0,s[2]=1,s},n}),i("projections/ProjectionWgs84",["../geom/Angle","../error/ArgumentError","../projections/GeographicProjection","../util/Logger","../geom/Position","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o,s){"use strict";var a=function(){i.call(this,"WGS84",!1,null),this.is2D=!1,this.scratchPosition=new n(0,0,0)};return a.prototype=Object.create(i.prototype),Object.defineProperties(a.prototype,{stateKey:{get:function(){return"projection wgs84 "}}}),a.prototype.geographicToCartesian=function(i,n,o,s,a,l){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionWgs84","geographicToCartesian","missingGlobe"));var h=Math.cos(n*t.DEGREES_TO_RADIANS),u=Math.sin(n*t.DEGREES_TO_RADIANS),c=Math.cos(o*t.DEGREES_TO_RADIANS),d=Math.sin(o*t.DEGREES_TO_RADIANS),p=i.equatorialRadius/Math.sqrt(1-i.eccentricitySquared*u*u);return l[0]=(p+s)*h*d,l[1]=(p*(1-i.eccentricitySquared)+s)*u,l[2]=(p+s)*h*c,l},a.prototype.geographicToCartesianGrid=function(i,n,s,a,l,h,u,c){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionWgs84","geographicToCartesianGrid","missingGlobe"));var d,p,f,g,m,y,E,v,_=n.minLatitude*t.DEGREES_TO_RADIANS,b=n.maxLatitude*t.DEGREES_TO_RADIANS,w=n.minLongitude*t.DEGREES_TO_RADIANS,S=n.maxLongitude*t.DEGREES_TO_RADIANS,L=(b-_)/(s>1?s-1:1),T=(S-w)/(a>1?a-1:1),A=h?h:new o(0,0,0),R=0,x=0,C=new Float64Array(a),M=new Float64Array(a);for(p=0,g=w;p<a;p++,g+=T)p===a-1&&(g=S),C[p]=Math.cos(g),M[p]=Math.sin(g);for(d=0,f=_;d<s;d++,f+=L)for(d===s-1&&(f=b),E=Math.cos(f),v=Math.sin(f),m=i.equatorialRadius/Math.sqrt(1-i.eccentricitySquared*v*v),p=0;p<a;p++)y=l[R++],c[x++]=(m+y)*E*M[p]-A[0],c[x++]=(m*(1-i.eccentricitySquared)+y)*v-A[1],c[x++]=(m+y)*E*C[p]-A[2];return c},a.prototype.cartesianToGeographic=function(i,n,o,a,l,h){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionWgs84","cartesianToGeographic","missingGlobe"));var u,c,d,p,f,g,m,y,E,v,_,b,w,S,L,T=a,A=n,R=o,x=T*T+A*A,C=Math.sqrt(x),M=i.equatorialRadius,P=1/(M*M),O=i.eccentricitySquared,N=O*O,I=x*P,D=R*R*(1-O)*P,k=(I+D-N)/6,F=8*k*k*k+N*I*D;return F>0||0!=D?(F>0?(p=Math.sqrt(F),f=Math.sqrt(N*I*D),F>10*O?(g=s.cbrt((p+f)*(p+f)),d=k+.5*g+2*k*k/g):d=k+.5*s.cbrt((p+f)*(p+f))+.5*s.cbrt((p-f)*(p-f))):(p=Math.sqrt(-F),f=Math.sqrt(-8*k*k*k),g=Math.sqrt(N*I*D),m=2*Math.atan2(g,p+f)/3,d=-4*k*Math.sin(m)*Math.cos(Math.PI/6+m)),y=Math.sqrt(d*d+N*D),E=O*(d+y-D)/(2*y),v=(d+y)/(Math.sqrt(E*E+d+y)+E),_=v*C/(v+O),b=Math.sqrt(_*_+R*R),u=(v+O-1)*b/v,c=2*Math.atan2(R,b+_)):(p=Math.sqrt(1-O),f=Math.sqrt(O-I),w=Math.sqrt(O),u=-M*p*f/w,c=f/(w*f+p*Math.sqrt(I))),L=Math.sqrt(2),S=(L-1)*A<C+T?2*Math.atan2(A,C+T):C+A<(L+1)*T?.5*-Math.PI+2*Math.atan2(T,C-A):.5*Math.PI-2*Math.atan2(T,C+A),h.latitude=t.RADIANS_TO_DEGREES*c,h.longitude=t.RADIANS_TO_DEGREES*S,h.altitude=u,h},a.prototype.northTangentAtLocation=function(e,i,r,n){var o=Math.cos(i*t.DEGREES_TO_RADIANS),s=Math.cos(r*t.DEGREES_TO_RADIANS),a=Math.sin(i*t.DEGREES_TO_RADIANS),l=Math.sin(r*t.DEGREES_TO_RADIANS);return n[0]=-a*l,n[1]=o,n[2]=-a*s,n.normalize()},a.prototype.northTangentAtPoint=function(t,e,i,r,n,s){return this.cartesianToGeographic(t,e,i,r,o.ZERO,this.scratchPosition),this.northTangentAtLocation(t,this.scratchPosition.latitude,this.scratchPosition.longitude,s)},a.prototype.surfaceNormalAtLocation=function(e,i,r,n){var o=Math.cos(i*t.DEGREES_TO_RADIANS),s=Math.cos(r*t.DEGREES_TO_RADIANS),a=Math.sin(i*t.DEGREES_TO_RADIANS),l=Math.sin(r*t.DEGREES_TO_RADIANS);return n[0]=o*l,n[1]=a,n[2]=o*s,n.normalize()},a.prototype.surfaceNormalAtPoint=function(t,i,n,o,s){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionWgs84","surfaceNormalAtPoint","missingGlobe"));var a=t.equatorialRadius*t.equatorialRadius,l=t.polarRadius*t.polarRadius;return s[0]=i/a,s[1]=n/l,s[2]=o/a,s.normalize()},a}),i("globe/Terrain",["../error/ArgumentError","../util/Logger","../geom/Vec3"],function(t,e,i){"use strict";var r=function(t,e,i,r){this.globe=t,this.verticalExaggeration=r,this.sector=i.sector,this.tessellator=e,this.surfaceGeometry=i.tileArray,this.stateKey=t.stateKey+" ve "+r.toString()};return r.scratchPoint=new i(0,0,0),r.prototype.surfacePoint=function(i,n,o,s){if(!s)throw new t(e.logMessage(e.LEVEL_SEVERE,"Terrain","surfacePoint","missingResult"));for(var a=0,l=this.surfaceGeometry.length;a<l;a++)if(this.surfaceGeometry[a].sector.containsLocation(i,n)){if(this.surfaceGeometry[a].surfacePoint(i,n,s),o){var h=this.globe.surfaceNormalAtPoint(s[0],s[1],s[2],r.scratchPoint);s[0]+=h[0]*o,s[1]+=h[1]*o,s[2]+=h[2]*o}return s}var u=o+this.globe.elevationAtLocation(i,n)*this.verticalExaggeration;return this.globe.computePointFromPosition(i,n,u,s),s},r.prototype.surfacePointForMode=function(i,r,n,o,s){if(!s)throw new t(e.logMessage(e.LEVEL_SEVERE,"Terrain","surfacePointForMode","missingResult"));if(o||(o=WorldWind.ABSOLUTE),o===WorldWind.CLAMP_TO_GROUND)return this.surfacePoint(i,r,0,s);if(o===WorldWind.RELATIVE_TO_GROUND)return this.surfacePoint(i,r,n,s);var a=n*this.verticalExaggeration;return this.globe.computePointFromPosition(i,r,a,s),s},r.prototype.beginRendering=function(t){this.globe&&this.globe.tessellator&&this.globe.tessellator.beginRendering(t)},r.prototype.endRendering=function(t){this.globe&&this.globe.tessellator&&this.globe.tessellator.endRendering(t)},r.prototype.beginRenderingTile=function(i,r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"Terrain","beginRenderingTile","missingTile"));this.globe&&this.globe.tessellator&&this.globe.tessellator.beginRenderingTile(i,r)},r.prototype.endRenderingTile=function(t,e){},r.prototype.renderTile=function(i,r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"Terrain","renderTile","missingTile"));this.globe&&this.globe.tessellator&&this.globe.tessellator.renderTile(i,r)},r.prototype.pick=function(t){this.globe&&this.globe.tessellator&&this.globe.tessellator.pick(t,this.surfaceGeometry,this)},r}),i("globe/TerrainTile",["../error/ArgumentError","../util/Logger","../geom/Matrix","../util/Tile"],function(t,e,i,r){"use strict";var n=function(t,e,n,o){r.call(this,t,e,n,o),this.transformationMatrix=i.fromIdentity(),this.points=null,this.pointsStateKey=null,this.pointsVboStateKey=null,this.neighborMap={},this.neighborMap[WorldWind.NORTH]=null,this.neighborMap[WorldWind.SOUTH]=null,this.neighborMap[WorldWind.EAST]=null,this.neighborMap[WorldWind.WEST]=null,this._stateKey=null,this._elevationTimestamp=null,this.scratchArray=[]};return n.prototype=Object.create(r.prototype),Object.defineProperties(n.prototype,{stateKey:{get:function(){return this._stateKey||(this._stateKey=this.computeStateKey()),this._stateKey}}}),n.prototype.neighborLevel=function(t){return this.neighborMap[t]},n.prototype.setNeighborLevel=function(t,e){this.neighborMap[t]=e,this._stateKey=null},n.prototype.surfacePoint=function(i,r,n){if(!n)throw new t(e.logMessage(e.LEVEL_SEVERE,"TerrainTile","surfacePoint","missingResult"));var o,s,a,l,h,u,c,d,p,f,g=this.sector,m=g.minLatitude,y=g.maxLatitude,E=g.minLongitude,v=g.maxLongitude,_=this.tileWidth,b=this.tileHeight;o=(r-E)/(v-E)*_,s=(i-m)/(y-m)*b,a=o<_?Math.floor(o):_-1,l=s<b?Math.floor(s):b-1,h=_+1,u=this.points,c=this.scratchArray,d=3*(a+l*h);for(var w=0;w<6;w++)c[w]=u[d+w];d=3*(a+(l+1)*h);for(var S=6;S<12;S++)c[S]=u[d+(S-6)];return p=o<_?o-Math.floor(o):1,f=s<b?s-Math.floor(s):1,p>f?(n[0]=c[0]+p*(c[3]-c[0])+f*(c[6]-c[0]),n[1]=c[1]+p*(c[4]-c[1])+f*(c[7]-c[1]),n[2]=c[2]+p*(c[5]-c[2])+f*(c[8]-c[2])):(n[0]=c[9]+(1-p)*(c[6]-c[9])+(1-f)*(c[3]-c[9]),n[1]=c[10]+(1-p)*(c[7]-c[10])+(1-f)*(c[4]-c[10]),n[2]=c[11]+(1-p)*(c[8]-c[11])+(1-f)*(c[5]-c[11])),n[0]+=this.referencePoint[0],n[1]+=this.referencePoint[1],n[2]+=this.referencePoint[2],n},n.prototype.update=function(t){r.prototype.update.call(this,t);var e=t.globe.elevationTimestamp();this._elevationTimestamp!=e&&(this._elevationTimestamp=e,this._stateKey=null)},n.prototype.computeStateKey=function(){var t=[];return t.push(this._elevationTimestamp),t.push(this.neighborMap[WorldWind.NORTH]?this.neighborMap[WorldWind.NORTH].compare(this.level):0),t.push(this.neighborMap[WorldWind.SOUTH]?this.neighborMap[WorldWind.SOUTH].compare(this.level):0),t.push(this.neighborMap[WorldWind.EAST]?this.neighborMap[WorldWind.EAST].compare(this.level):0),t.push(this.neighborMap[WorldWind.WEST]?this.neighborMap[WorldWind.WEST].compare(this.level):0),t.join(".")},n}),i("globe/TerrainTileList",["../error/ArgumentError","../util/Logger","../geom/Sector"],function(t,e,i){"use strict";var r=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"TerrainTileList","TerrainTileList","missingTessellator"));this.tessellator=i,this.sector=null,this.tileArray=[]};return Object.defineProperties(r.prototype,{length:{get:function(){return this.tileArray.length}}}),r.prototype.addTile=function(r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"TerrainTileList","addTile","missingTile"));this.tileArray.indexOf(r)==-1&&(this.tileArray.push(r),this.sector?this.sector.union(r.sector):(this.sector=new i(0,0,0,0),this.sector.copy(r.sector)))},r.prototype.removeAllTiles=function(){this.tileArray=[],this.sector=null},r}),i("globe/Tessellator",["../geom/Angle","../error/ArgumentError","../shaders/BasicProgram","../globe/Globe","../shaders/GpuProgram","../util/Level","../util/LevelSet","../geom/Location","../util/Logger","../geom/Matrix","../cache/MemoryCache","../error/NotYetImplementedError","../pick/PickedObject","../geom/Position","../geom/Rectangle","../geom/Sector","../globe/Terrain","../globe/TerrainTile","../globe/TerrainTileList","../util/Tile","../util/WWMath","../util/WWUtil"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_,b){"use strict";var w=function(){this.numRowsTilesInTopLevel=4,this.numColumnsTilesInTopLevel=8,this.maximumSubdivisionDepth=15,this.tileWidth=32,this.tileHeight=32,this.detailControl=40,this.levels=new s(g.FULL_SPHERE,new a(180/this.numRowsTilesInTopLevel,360/this.numColumnsTilesInTopLevel),this.maximumSubdivisionDepth,this.tileWidth,this.tileHeight),this.topLevelTiles={},this.currentTiles=new E(this),this.tileCache=new u(5e6,4e6),this.elevationTimestamp=void 0,this.lastModelViewProjection=h.fromIdentity(),this.vertexPointLocation=-1,this.vertexTexCoordLocation=-1,this.texCoords=null,this.texCoordVboCacheKey="global_tex_coords",this.indices=null,this.indicesVboCacheKey="global_indices",this.baseIndices=null,this.baseIndicesOffset=null,this.numBaseIndices=null,this.indicesNorth=null,this.indicesNorthOffset=null,this.numIndicesNorth=null,this.indicesSouth=null,this.indicesSouthOffset=null,this.numIndicesSouth=null,this.indicesWest=null,this.indicesWestOffset=null,this.numIndicesWest=null,this.indicesEast=null,this.indicesEastOffset=null,this.numIndicesEast=null,this.indicesLoresNorth=null,this.indicesLoresNorthOffset=null,this.numIndicesLoresNorth=null,this.indicesLoresSouth=null,this.indicesLoresSouthOffset=null,this.numIndicesLoresSouth=null,this.indicesLoresWest=null,this.indicesLoresWestOffset=null,this.numIndicesLoresWest=null,this.indicesLoresEast=null,this.indicesLoresEastOffset=null,this.numIndicesLoresEast=null,this.outlineIndicesOffset=null,this.numOutlineIndices=null,this.wireframeIndicesOffset=null,this.numWireframeIndices=null,this.scratchMatrix=h.fromIdentity(),this.scratchElevations=null,this.scratchPrevElevations=null,this.corners={},this.tiles=[]};return w.prototype.tessellate=function(t){if(!t)throw new e(l.logMessage(l.LEVEL_SEVERE,"Tessellator","tessellate","missingDC"));var i=t.globe.elevationTimestamp();if(this.lastGlobeStateKey===t.globeStateKey&&this.lastVerticalExaggeration===t.verticalExaggeration&&this.elevationTimestamp===i&&t.modelviewProjection.equals(this.lastModelViewProjection))return this.lastTerrain;this.lastModelViewProjection.copy(t.modelviewProjection),this.lastGlobeStateKey=t.globeStateKey,this.elevationTimestamp=i,this.lastVerticalExaggeration=t.verticalExaggeration,this.currentTiles.removeAllTiles(),this.topLevelTiles[t.globeStateKey]&&0!=this.topLevelTiles[t.globeStateKey].length||this.createTopLevelTiles(t),this.corners={},this.tiles=[];for(var r=0,n=this.topLevelTiles[t.globeStateKey].length;r<n;r+=1){var o=this.topLevelTiles[t.globeStateKey][r];o.update(t),this.isTileVisible(t,o)&&this.addTileOrDescendants(t,o)}return this.refineNeighbors(t),this.finishTessellating(t),this.lastTerrain=0===this.currentTiles.length?null:new m(t.globe,this,this.currentTiles,t.verticalExaggeration),this.lastTerrain},w.prototype.createTile=function(t,i,r,n){if(!t)throw new e(l.logMessage(l.LEVEL_SEVERE,"Tile","constructor","missingSector"));if(!i)throw new e(l.logMessage(l.LEVEL_SEVERE,"Tile","constructor","The specified level is null or undefined."));if(r<0||n<0)throw new e(l.logMessage(l.LEVEL_SEVERE,"Tile","constructor","The specified row or column is less than zero."));return new y(t,i,r,n)},w.prototype.beginRendering=function(t){var e=t.currentProgram;if(!e)return void l.logMessage(l.LEVEL_INFO,"Tessellator","beginRendering","Current Program is empty");this.buildSharedGeometry(),this.cacheSharedGeometryVBOs(t);var i=t.currentGlContext,r=t.gpuResourceCache;if(this.vertexPointLocation=e.attributeLocation(i,"vertexPoint"),this.vertexTexCoordLocation=e.attributeLocation(i,"vertexTexCoord"),i.enableVertexAttribArray(this.vertexPointLocation),this.vertexTexCoordLocation>=0){var n=r.resourceForKey(this.texCoordVboCacheKey);i.bindBuffer(i.ARRAY_BUFFER,n),i.vertexAttribPointer(this.vertexTexCoordLocation,2,i.FLOAT,!1,0,0),i.enableVertexAttribArray(this.vertexTexCoordLocation)}var o=r.resourceForKey(this.indicesVboCacheKey);i.bindBuffer(i.ELEMENT_ARRAY_BUFFER,o)},w.prototype.endRendering=function(t){var e=t.currentGlContext;e.bindBuffer(e.ARRAY_BUFFER,null),e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,null),this.vertexPointLocation>=0&&e.disableVertexAttribArray(this.vertexPointLocation),this.vertexTexCoordLocation>=0&&e.disableVertexAttribArray(this.vertexTexCoordLocation)},w.prototype.beginRenderingTile=function(t,i){if(!i)throw new e(l.logMessage(l.LEVEL_SEVERE,"Tessellator","beginRenderingTile","missingTile"));var r=t.currentGlContext,n=t.gpuResourceCache;this.scratchMatrix.setToMultiply(t.modelviewProjection,i.transformationMatrix),t.currentProgram.loadModelviewProjection(r,this.scratchMatrix);var o=t.globeStateKey+i.tileKey,s=n.resourceForKey(o);s?i.pointsVboStateKey!=i.pointsStateKey?(r.bindBuffer(r.ARRAY_BUFFER,s),r.bufferSubData(r.ARRAY_BUFFER,0,i.points),i.pointsVboStateKey=i.pointsStateKey):t.currentGlContext.bindBuffer(r.ARRAY_BUFFER,s):(s=r.createBuffer(),r.bindBuffer(r.ARRAY_BUFFER,s),r.bufferData(r.ARRAY_BUFFER,i.points,r.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1),n.putResource(o,s,4*i.points.length),i.pointsVboStateKey=i.pointsStateKey),r.vertexAttribPointer(this.vertexPointLocation,3,r.FLOAT,!1,0,0)},w.prototype.endRenderingTile=function(t,e){},w.prototype.renderTile=function(t,i){if(!i)throw new e(l.logMessage(l.LEVEL_SEVERE,"Tessellator","renderTile","missingTile"));var r=t.currentGlContext,n=r.TRIANGLE_STRIP;r.drawElements(n,this.numBaseIndices,r.UNSIGNED_SHORT,2*this.baseIndicesOffset);var o,s=i.level;o=i.neighborLevel(WorldWind.NORTH),o&&o.compare(s)<0?r.drawElements(n,this.numIndicesLoresNorth,r.UNSIGNED_SHORT,2*this.indicesLoresNorthOffset):r.drawElements(n,this.numIndicesNorth,r.UNSIGNED_SHORT,2*this.indicesNorthOffset),o=i.neighborLevel(WorldWind.SOUTH),o&&o.compare(s)<0?r.drawElements(n,this.numIndicesLoresSouth,r.UNSIGNED_SHORT,2*this.indicesLoresSouthOffset):r.drawElements(n,this.numIndicesSouth,r.UNSIGNED_SHORT,2*this.indicesSouthOffset),o=i.neighborLevel(WorldWind.WEST),o&&o.compare(s)<0?r.drawElements(n,this.numIndicesLoresWest,r.UNSIGNED_SHORT,2*this.indicesLoresWestOffset):r.drawElements(n,this.numIndicesWest,r.UNSIGNED_SHORT,2*this.indicesWestOffset),o=i.neighborLevel(WorldWind.EAST),o&&o.compare(s)<0?r.drawElements(n,this.numIndicesLoresEast,r.UNSIGNED_SHORT,2*this.indicesLoresEastOffset):r.drawElements(n,this.numIndicesEast,r.UNSIGNED_SHORT,2*this.indicesEastOffset)},w.prototype.renderWireframeTile=function(t,i){if(!i)throw new e(l.logMessage(l.LEVEL_SEVERE,"Tessellator","renderWireframeTile","missingTile"));var r=t.currentGlContext;this.vertexTexCoordLocation>=0&&r.disableVertexAttribArray(this.vertexTexCoordLocation),r.drawElements(r.LINES,this.numWireframeIndices,r.UNSIGNED_SHORT,2*this.wireframeIndicesOffset)},w.prototype.renderTileOutline=function(t,i){if(!i)throw new e(l.logMessage(l.LEVEL_SEVERE,"Tessellator","renderTileOutline","missingTile"));var r=t.currentGlContext;this.vertexTexCoordLocation>=0&&r.disableVertexAttribArray(this.vertexTexCoordLocation),r.drawElements(r.LINE_LOOP,this.numOutlineIndices,r.UNSIGNED_SHORT,2*this.outlineIndicesOffset)},w.prototype.pick=function(t,i,r){if(!t)throw new e(l.logMessage(l.LEVEL_SEVERE,"Tessellator","pick","missingDc"));if(!i)throw new e(l.logMessage(l.LEVEL_SEVERE,"Tessellator","pick","missingList"));for(var n=null,o=r||this,s=new p(0,0,0),a=[],h=0,u=i.length;h<u;h++){var c=i[h];c.extent.intersectsFrustum(t.pickFrustum)&&a.push(c)}if(t.pickTerrainOnly||(n=t.uniquePickColor(),this.drawPickTiles(t,a,n)),!t.regionPicking){var f=t.pickRay.clone(),g=this.computeNearestIntersection(f,a);g&&(t.globe.computePositionFromPoint(g[0],g[1],g[2],s),s.altitude=t.globe.elevationAtLocation(s.latitude,s.longitude),t.addPickedObject(new d(n,o,s,null,!0)))}},w.prototype.drawPickTiles=function(t,e,r){var n=t.currentGlContext;try{t.findAndBindProgram(i),t.currentProgram.loadColor(n,r),this.beginRendering(t);for(var o=0,s=e.length;o<s;o++){var a=e[o];this.beginRenderingTile(t,a),this.renderTile(t,a),this.endRenderingTile(t,a)}}finally{this.endRendering(t)}},w.prototype.computeNearestIntersection=function(t,e){for(var i=[],r=0,n=e.length;r<n;r++)this.computeIntersections(t,e[r],i);if(0==i.length)return null;var o,s=Number.POSITIVE_INFINITY;for(r=0,n=i.length;r<n;r++){var a=t.origin.distanceToSquared(i[r]);s>a&&(s=a,o=r)}return i[o]},w.prototype.computeIntersections=function(t,e,i){var r,n,o=e.level,s=e.points,a=i.length;t.origin.subtract(e.referencePoint),this.buildSharedGeometry(e),n=this.baseIndices,_.computeTriStripIntersections(t,s,n,i),r=e.neighborLevel(WorldWind.SOUTH),n=r&&r.compare(o)<0?this.indicesLoresSouth:this.indicesSouth,_.computeTriStripIntersections(t,s,n,i),r=e.neighborLevel(WorldWind.WEST),n=r&&r.compare(o)<0?this.indicesLoresWest:this.indicesWest,_.computeTriStripIntersections(t,s,n,i),r=e.neighborLevel(WorldWind.EAST),n=r&&r.compare(o)<0?this.indicesLoresEast:this.indicesEast,_.computeTriStripIntersections(t,s,n,i),r=e.neighborLevel(WorldWind.NORTH),n=r&&r.compare(o)<0?this.indicesLoresNorth:this.indicesNorth,_.computeTriStripIntersections(t,s,n,i),t.origin.add(e.referencePoint);for(var l=a,h=i.length;l<h;l++)i[l].add(e.referencePoint)},w.prototype.createTopLevelTiles=function(t){this.topLevelTiles[t.globeStateKey]=[],v.createTilesForLevel(this.levels.firstLevel(),this,this.topLevelTiles[t.globeStateKey])},w.prototype.addTileOrDescendants=function(t,e){return this.tileMeetsRenderCriteria(t,e)?void this.addTile(t,e):void this.addTileDescendants(t,e)},w.prototype.addTileDescendants=function(t,e){for(var i=e.level.nextLevel(),r=e.subdivideToCache(i,this,this.tileCache),n=0;n<r.length;n+=1){var o=r[n];o.update(t),this.levels.sector.intersects(o.sector)&&this.isTileVisible(t,o)&&this.addTileOrDescendants(t,o)}},w.prototype.addTile=function(t,e){var i=this.tiles.length;this.tiles.push(e);var r,n=e.sector,o=[n.maxLatitude,n.maxLongitude].toString(),s=[n.minLatitude,n.maxLongitude].toString(),a=[n.maxLatitude,n.minLongitude].toString(),l=[n.minLatitude,n.minLongitude].toString();r=this.corners[l],r?r.sw=i:this.corners[l]={sw:i},r=this.corners[a],r?r.nw=i:this.corners[a]={nw:i},r=this.corners[s],r?r.se=i:this.corners[s]={se:i},r=this.corners[o],r?r.ne=i:this.corners[o]={ne:i}},w.prototype.refineNeighbors=function(t){for(var e={},i=0,r=this.tiles.length;i<r;i+=1){var n,o,i,r,s=this.tiles[i],a=s.level.levelNumber,l=s.sector,h=[l.maxLatitude,l.maxLongitude].toString(),u=[l.minLatitude,l.maxLongitude].toString(),c=[l.maxLatitude,l.minLongitude].toString(),d=[l.minLatitude,l.minLongitude].toString();n=this.corners[h],n.hasOwnProperty("se")&&(o=n.se,this.tiles[o].level.levelNumber<a-1&&(e[o]||(e[o]=!0))),
n.hasOwnProperty("nw")&&(o=n.nw,this.tiles[o].level.levelNumber<a-1&&(e[o]||(e[o]=!0))),n=this.corners[u],n.hasOwnProperty("ne")&&(o=n.ne,this.tiles[o].level.levelNumber<a-1&&(e[o]||(e[o]=!0))),n.hasOwnProperty("sw")&&(o=n.sw,this.tiles[o].level.levelNumber<a-1&&(e[o]||(e[o]=!0))),n=this.corners[c],n.hasOwnProperty("ne")&&(o=n.ne,this.tiles[o].level.levelNumber<a-1&&(e[o]||(e[o]=!0))),n.hasOwnProperty("sw")&&(o=n.sw,this.tiles[o].level.levelNumber<a-1&&(e[o]||(e[o]=!0))),n=this.corners[d],n.hasOwnProperty("se")&&(o=n.se,this.tiles[o].level.levelNumber<a-1&&(e[o]||(e[o]=!0))),n.hasOwnProperty("nw")&&(o=n.nw,this.tiles[o].level.levelNumber<a-1&&(e[o]||(e[o]=!0)))}var p=[],f=[];for(i=0,r=this.tiles.length;i<r;i+=1)s=this.tiles[i],e[i]?p.push(s):f.push(s);if(p.length>0){for(this.tiles=[],this.corners={},i=0,r=f.length;i<r;i+=1)s=f[i],this.addTile(t,s);for(i=0,r=p.length;i<r;i+=1){var s=p[i];this.addTileDescendants(t,s)}this.refineNeighbors(t)}},w.prototype.finishTessellating=function(t){for(var e=0,i=this.tiles.length;e<i;e+=1){var r=this.tiles[e];this.setNeighbors(r),this.regenerateTileGeometryIfNeeded(t,r),this.currentTiles.addTile(r)}},w.prototype.setNeighbors=function(t){var e=t.sector,i=[e.maxLatitude,e.maxLongitude].toString(),r=[e.minLatitude,e.maxLongitude].toString(),n=[e.maxLatitude,e.minLongitude].toString(),o=[e.minLatitude,e.minLongitude].toString(),s=this.corners[i],a=this.corners[r],l=this.corners[n],h=this.corners[o],u=-1,c=-1,d=-1,p=-1;s.hasOwnProperty("se")?u=s.se:l.hasOwnProperty("sw")&&(u=l.sw),a.hasOwnProperty("ne")?c=a.ne:h.hasOwnProperty("nw")&&(c=h.nw),s.hasOwnProperty("nw")?d=s.nw:a.hasOwnProperty("sw")&&(d=a.sw),l.hasOwnProperty("ne")?p=l.ne:h.hasOwnProperty("se")&&(p=h.se),t.setNeighborLevel(WorldWind.NORTH,u>=0?this.tiles[u].level:null),t.setNeighborLevel(WorldWind.SOUTH,c>=0?this.tiles[c].level:null),t.setNeighborLevel(WorldWind.EAST,d>=0?this.tiles[d].level:null),t.setNeighborLevel(WorldWind.WEST,p>=0?this.tiles[p].level:null)},w.prototype.isTileVisible=function(t,e){return!(t.globe.projectionLimits&&!e.sector.overlaps(t.globe.projectionLimits))&&e.extent.intersectsFrustum(t.frustumInModelCoordinates)},w.prototype.tileMeetsRenderCriteria=function(t,e){var i=this.detailControl;return(e.sector.minLatitude>=75||e.sector.maxLatitude<=-75)&&(i*=2),e.level.isLastLevel()||!e.mustSubdivide(t,i)},w.prototype.regenerateTileGeometryIfNeeded=function(t,e){var i=t.globeStateKey+e.stateKey+t.verticalExaggeration;e.points&&e.pointsStateKey==i||(this.regenerateTileGeometry(t,e),e.pointsStateKey=i)},w.prototype.coverageTargetResolution=function(e){return e/8*t.RADIANS_TO_DEGREES},w.prototype.regenerateTileGeometry=function(t,e){var i=e.tileHeight+1,r=e.tileWidth+1,n=e.referencePoint,o=this.scratchElevations;o||(o=new Float64Array(i*r),this.scratchElevations=o),e.points||(e.points=new Float32Array(i*r*3)),b.fillArray(o,0),t.globe.elevationsForGrid(e.sector,i,r,this.coverageTargetResolution(e.texelSize),o),this.mustAlignNeighborElevations(t,e)&&this.alignNeighborElevations(t,e,o),b.multiplyArray(o,t.verticalExaggeration),t.globe.computePointsForGrid(e.sector,i,r,o,n,e.points),e.transformationMatrix.setTranslation(n[0],n[1],n[2])},w.prototype.mustAlignNeighborElevations=function(t,e){var i=e.level,r=e.neighborLevel(WorldWind.NORTH),n=e.neighborLevel(WorldWind.SOUTH),o=e.neighborLevel(WorldWind.EAST),s=e.neighborLevel(WorldWind.WEST);return r&&r.compare(i)<0||n&&n.compare(i)<0||o&&o.compare(i)<0||s&&s.compare(i)<0},w.prototype.alignNeighborElevations=function(t,e,i){var r,n,o,s,a=e.tileHeight+1,l=e.tileWidth+1,h=e.level,u=Math.floor(a/2)+1,c=Math.floor(l/2)+1,d=h.previousLevel(),p=this.scratchPrevElevations;if(p||(p=new Float64Array(u*c),this.scratchPrevElevations=p),b.fillArray(p,0),t.globe.elevationsForGrid(e.sector,u,c,this.coverageTargetResolution(d.texelSize),p),r=e.neighborLevel(WorldWind.NORTH),r&&r.compare(h)<0)for(o=(a-1)*l,s=(u-1)*c,n=0;n<c;n++,o+=2,s+=1)i[o]=p[s],n<c-1&&(i[o+1]=.5*(p[s]+p[s+1]));if(r=e.neighborLevel(WorldWind.SOUTH),r&&r.compare(h)<0)for(o=0,s=0,n=0;n<c;n++,o+=2,s+=1)i[o]=p[s],n<c-1&&(i[o+1]=.5*(p[s]+p[s+1]));if(r=e.neighborLevel(WorldWind.EAST),r&&r.compare(h)<0)for(o=l-1,s=c-1,n=0;n<u;n++,o+=2*l,s+=c)i[o]=p[s],n<u-1&&(i[o+l]=.5*(p[s]+p[s+c]));if(r=e.neighborLevel(WorldWind.WEST),r&&r.compare(h)<0)for(o=0,s=0,n=0;n<u;n++,o+=2*l,s+=c)i[o]=p[s],n<u-1&&(i[o+l]=.5*(p[s]+p[s+c]))},w.prototype.buildSharedGeometry=function(){var t=this.levels.tileWidth,e=this.levels.tileHeight;this.texCoords||this.buildTexCoords(t,e),this.indices||this.buildIndices(t,e)},w.prototype.buildTexCoords=function(t,e){for(var i=t+1,r=e+1,n=1/t,o=1/e,s=new Float32Array(i*r*2),a=0,l=0,h=0;l<r;l++,h+=o){l==r-1&&(h=1);for(var u=0,c=0;u<i;u++,c+=n)u==i-1&&(c=1),s[a++]=c,s[a++]=h}this.texCoords=s},w.prototype.buildIndices=function(t,e){for(var i,r=e+1,n=t+1,o=2*(r-3)*(n-2)+2*(r-3),s=[],a=0,l=1;l<n-2;l+=1){for(var h=1;h<r-1;h+=1)i=l+h*n,s[a++]=i,s[a++]=i+1;s[a++]=i+1,i=l+1+1*n,s[a++]=i}for(this.baseIndicesOffset=s.length-o,this.baseIndices=new Uint16Array(s.slice(this.baseIndicesOffset)),this.numBaseIndices=o,o=2*n-2,h=r-1,l=n-1,i=l+h*n,s[a++]=i,l=n-2;l>0;l-=1)i=l+h*n,s[a++]=i,s[a++]=i-n;for(l=0,i=l+h*n,s[a++]=i,this.indicesNorthOffset=s.length-o,this.indicesNorth=new Uint16Array(s.slice(this.indicesNorthOffset)),this.numIndicesNorth=o,o=2*n-2,h=0,l=0,i=l+h*n,s[a++]=i,l=1;l<n-1;l+=1)i=l+h*n,s[a++]=i,s[a++]=i+n;for(l=n-1,i=l+h*n,s[a++]=i,this.indicesSouthOffset=s.length-o,this.indicesSouth=new Uint16Array(s.slice(this.indicesSouthOffset)),this.numIndicesSouth=o,o=2*r-2,l=0,h=r-1,i=l+h*n,s[a++]=i,h=r-2;h>0;h-=1)i=l+h*n,s[a++]=i,s[a++]=i+1;for(h=0,i=l+h*n,s[a++]=i,this.indicesWestOffset=s.length-o,this.indicesWest=new Uint16Array(s.slice(this.indicesWestOffset)),this.numIndicesWest=o,o=2*r-2,l=n-1,h=0,i=l+h*n,s[a++]=i,h=1;h<r-1;h+=1)i=l+h*n,s[a++]=i,s[a++]=i-1;for(h=r-1,i=l+h*n,s[a++]=i,this.indicesEastOffset=s.length-o,this.indicesEast=new Uint16Array(s.slice(this.indicesEastOffset)),this.numIndicesEast=o,o=2*n-2,h=r-1,l=n-1,i=l+h*n,s[a++]=i,l=n-2;l>0;l-=1)i=(l+1&-2)+h*n,s[a++]=i,i=l+(h-1)*n,s[a++]=i;for(l=0,i=l+h*n,s[a++]=i,this.indicesLoresNorthOffset=s.length-o,this.indicesLoresNorth=new Uint16Array(s.slice(this.indicesLoresNorthOffset)),this.numIndicesLoresNorth=o,o=2*n-2,h=0,l=0,i=l+h*n,s[a++]=i,l=1;l<n-1;l+=1)i=(l&-2)+h*n,s[a++]=i,i=l+(h+1)*n,s[a++]=i;for(l=n-1,i=l+h*n,s[a++]=i,this.indicesLoresSouthOffset=s.length-o,this.indicesLoresSouth=new Uint16Array(s.slice(this.indicesLoresSouthOffset)),this.numIndicesLoresSouth=o,o=2*r-2,l=0,h=r-1,i=l+h*n,s[a++]=i,h=r-2;h>0;h-=1)i=l+(h+1&-2)*n,s[a++]=i,i=l+1+h*n,s[a++]=i;for(h=0,i=l+h*n,s[a++]=i,this.indicesLoresWestOffset=s.length-o,this.indicesLoresWest=new Uint16Array(s.slice(this.indicesLoresWestOffset)),this.numIndicesLoresWest=o,o=2*r-2,l=n-1,h=0,i=l+h*n,s[a++]=i,h=1;h<r-1;h+=1)i=l+(h&-2)*n,s[a++]=i,i=l-1+h*n,s[a++]=i;h=r-1,i=l+h*n,s[a++]=i,this.indicesLoresEastOffset=s.length-o,this.indicesLoresEast=new Uint16Array(s.slice(this.indicesLoresEastOffset)),this.numIndicesLoresEast=o;var u=this.buildWireframeIndices(t,e),c=this.buildOutlineIndices(t,e);s=s.concat(u),this.wireframeIndicesOffset=s.length-this.numWireframeIndices,s=s.concat(c),this.outlineIndicesOffset=s.length-this.numOutlineIndices,this.indices=new Uint16Array(s)},w.prototype.buildWireframeIndices=function(t,e){var i,r,n,o=e+1,s=t+1,a=2*t*o+2*e*s,l=[],h=s,u=0;for(r=0;r<o;r+=1)for(i=0;i<t;i+=1)n=i+r*h,l[u]=n,l[u+1]=n+1,u+=2;for(i=0;i<s;i+=1)for(r=0;r<e;r+=1)n=i+r*h,l[u]=n,l[u+1]=n+h,u+=2;return this.numWireframeIndices=a,l},w.prototype.buildOutlineIndices=function(t,e){var i,r,n,o=e+1,s=t+1,a=2*(o-2)+2*s+1,l=[],h=0;for(r=0,i=0;i<s;i+=1)n=i+r*s,l[h]=n,h+=1;for(i=s-1,r=1;r<o;r+=1)n=i+r*s,l[h]=n,h+=1;for(r=o-1,i=s-1;i>=0;i-=1)n=i+r*s,l[h]=n,h+=1;for(i=0,r=o-1;r>=0;r-=1)n=i+r*s,l[h]=n,h+=1;return this.numOutlineIndices=a,l},w.prototype.cacheSharedGeometryVBOs=function(t){var e=t.currentGlContext,i=t.gpuResourceCache,r=i.resourceForKey(this.texCoordVboCacheKey);r||(r=e.createBuffer(),e.bindBuffer(e.ARRAY_BUFFER,r),e.bufferData(e.ARRAY_BUFFER,this.texCoords,e.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1),i.putResource(this.texCoordVboCacheKey,r,4*this.texCoords.length/2));var n=i.resourceForKey(this.indicesVboCacheKey);n||(n=e.createBuffer(),e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,n),e.bufferData(e.ELEMENT_ARRAY_BUFFER,this.indices,e.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1),i.putResource(this.indicesVboCacheKey,n,2*this.indices.length))},w}),i("globe/Globe",["../geom/Angle","../error/ArgumentError","../geom/BoundingBox","../globe/ElevationModel","../geom/Line","../geom/Location","../util/Logger","../geom/Position","../projections/ProjectionWgs84","../geom/Sector","../globe/Tessellator","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o,s,a,l,h,u,c,d){"use strict";var p=function(t,i){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","constructor","Elevation model is null or undefined."));this.elevationModel=t,this.equatorialRadius=WorldWind.WGS84_SEMI_MAJOR_AXIS;var r=1/WorldWind.WGS84_INVERSE_FLATTENING;this.polarRadius=this.equatorialRadius*(1-r),this.eccentricitySquared=2*r-r*r,this.tessellator=new u,this._projection=i||new l,this._offset=0,this.offsetVector=new c(0,0,0),this.id=++p.idPool,this._stateKey="globe "+this.id.toString()+" "};return p.idPool=0,Object.defineProperties(p.prototype,{stateKey:{get:function(){return this._stateKey+this.elevationModel.stateKey+"offset "+this.offset.toString()+" "+this.projection.stateKey}},continuous:{get:function(){return this.projection.continuous}},projection:{get:function(){return this._projection},set:function(t){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","projection","missingProjection"));this.projection!=t&&(this.tessellator=new u),this._projection=t}},projectionLimits:{get:function(){return this._projection.projectionLimits}},offset:{get:function(){return this._offset},set:function(t){this._offset=t,this.offsetVector[0]=2*t*Math.PI*this.equatorialRadius}}}),p.prototype.is2D=function(){return this.projection.is2D},p.prototype.computePointFromPosition=function(t,i,r,n){if(!n)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","computePointFromPosition","missingResult"));return this.projection.geographicToCartesian(this,t,i,r,this.offsetVector,n)},p.prototype.computePointFromLocation=function(t,i,r){if(!r)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","computePointFromLocation","missingResult"));return this.computePointFromPosition(t,i,0,r)},p.prototype.computePointsForGrid=function(t,i,r,n,o,a){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","computePointsFromPositions","missingSector"));if(i<1||r<1)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","computePointsFromPositions","Number of latitude or longitude locations is less than one."));var l=i*r;if(!n||n.length<l)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","computePointsFromPositions","Elevations array is null, undefined or insufficient length."));if(!a||a.length<l)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","computePointsFromPositions","Result array is null, undefined or insufficient length."));return this.projection.geographicToCartesianGrid(this,t,i,r,n,o,this.offsetVector,a)},p.prototype.computePositionFromPoint=function(t,i,r,n){if(!n)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","computePositionFromPoint","missingResult"));return this.projection.cartesianToGeographic(this,t,i,r,this.offsetVector,n),this.continuous&&(n.longitude<-180?n.longitude+=360:n.longitude>180&&(n.longitude-=360)),n},p.prototype.radiusAt=function(e,i){var r=Math.sin(e*t.DEGREES_TO_RADIANS),n=this.equatorialRadius/Math.sqrt(1-this.eccentricitySquared*r*r);return n*Math.sqrt(1+(this.eccentricitySquared*this.eccentricitySquared-2*this.eccentricitySquared)*r*r)},p.prototype.surfaceNormalAtLocation=function(i,r,n){if(!n)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","surfaceNormalAtLocation","missingResult"));if(this.projection.surfaceNormalAtLocation)return this.projection.surfaceNormalAtLocation(this,i,r,n);if(this.is2D())return n[0]=0,n[1]=0,n[2]=1,n;var o=Math.cos(i*t.DEGREES_TO_RADIANS),a=Math.cos(r*t.DEGREES_TO_RADIANS),l=Math.sin(i*t.DEGREES_TO_RADIANS),h=Math.sin(r*t.DEGREES_TO_RADIANS);return n[0]=o*h,n[1]=l,n[2]=o*a,n.normalize()},p.prototype.surfaceNormalAtPoint=function(t,i,r,n){if(!n)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","surfaceNormalAtPoint","missingResult"));if(this.projection.surfaceNormalAtPoint)return this.projection.surfaceNormalAtPoint(this,t,i,r,n);if(this.is2D())return n[0]=0,n[1]=0,n[2]=1,n;var o=this.equatorialRadius*this.equatorialRadius,a=this.polarRadius*this.polarRadius;return n[0]=t/o,n[1]=i/a,n[2]=r/o,n.normalize()},p.prototype.northTangentAtLocation=function(t,i,r){if(!r)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","northTangentAtLocation","missingResult"));return this.projection.northTangentAtLocation(this,t,i,r)},p.prototype.northTangentAtPoint=function(t,i,r,n){if(!n)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","northTangentAtPoint","missingResult"));return this.projection.northTangentAtPoint(this,t,i,r,this.offsetVector,n)},p.prototype.intersectsFrustum=function(t){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","intersectsFrustum","missingFrustum"));if(this.is2D()){var r=new i;return r.setToSector(h.FULL_SPHERE,this,this.elevationModel.minElevation,this.elevationModel.maxElevation),r.intersectsFrustum(t)}return!(t.far.distance<=this.equatorialRadius)&&(!(t.left.distance<=this.equatorialRadius)&&(!(t.right.distance<=this.equatorialRadius)&&(!(t.top.distance<=this.equatorialRadius)&&(!(t.bottom.distance<=this.equatorialRadius)&&!(t.near.distance<=this.equatorialRadius)))))},p.prototype.intersectsLine=function(t,i){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","intersectWithRay","missingLine"));if(!i)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","intersectsLine","missingResult"));var r,n=t.direction[0],o=t.direction[1],a=t.direction[2],l=t.origin[0],h=t.origin[1],u=t.origin[2];if(this.is2D())return(0!=a||0==u)&&(r=-u/a,!(r<0)&&(i[0]=l+n*r,i[1]=h+o*r,i[2]=u+a*r,!0));var c,d,p,f,g=this.equatorialRadius,m=g*g,y=g/this.polarRadius,E=y*y;return c=n*n+E*o*o+a*a,d=2*(l*n+E*h*o+u*a),p=l*l+E*h*h+u*u-m,f=d*d-4*c*p,!(f<0)&&(r=(-d-Math.sqrt(f))/(2*c),r>0?(i[0]=l+n*r,i[1]=h+o*r,i[2]=u+a*r,!0):(r=(-d+Math.sqrt(f))/(2*c),r>0&&(i[0]=l+n*r,i[1]=h+o*r,i[2]=u+a*r,!0)))},p.prototype.elevationTimestamp=function(){return this.elevationModel.timestamp},p.prototype.minElevation=function(){return this.elevationModel.minElevation},p.prototype.maxElevation=function(){return this.elevationModel.maxElevation},p.prototype.minAndMaxElevationsForSector=function(t){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","minAndMaxElevationsForSector","missingSector"));return this.elevationModel.minAndMaxElevationsForSector(t)},p.prototype.elevationAtLocation=function(t,e){return this.elevationModel.elevationAtLocation(t,e)},p.prototype.elevationsForGrid=function(t,i,r,n,o){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","elevationsForSector","missingSector"));if(i<=0||r<=0)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","elevationsForSector","numLat or numLon is less than 1"));if(!o||o.length<i*r)throw new e(s.logMessage(s.LEVEL_SEVERE,"Globe","elevationsForSector","missingArray"));return this.elevationModel.elevationsForGrid(t,i,r,n,o)},p}),i("cache/GpuResourceCache",["../util/AbsentResourceList","../error/ArgumentError","../util/ImageSource","../util/Logger","../cache/MemoryCache","../render/Texture"],function(t,e,i,r,n,o){"use strict";var s=function(i,o){if(!i||i<1)throw new e(r.logMessage(r.LEVEL_SEVERE,"GpuResourceCache","constructor","Specified cache capacity is undefined, 0 or negative."));if(!o||o<0||o>=i)throw new e(r.logMessage(r.LEVEL_SEVERE,"GpuResourceCache","constructor","Specified cache low-water value is undefined, negative or not less than the capacity."));this.entries=new n(i,o),this.cacheKeyPool=0,this.currentRetrievals={},this.absentResourceList=new t(3,6e4)};return Object.defineProperties(s.prototype,{capacity:{get:function(){return this.entries.capacity}},lowWater:{get:function(){return this.entries.lowWater}},usedCapacity:{get:function(){return this.entries.usedCapacity}},freeCapacity:{get:function(){return this.entries.freeCapacity}}}),s.prototype.generateCacheKey=function(){return"GpuResourceCache "+ ++this.cacheKeyPool},s.prototype.putResource=function(t,n,o){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"GpuResourceCache","putResource","missingKey."));if(!n)throw new e(r.logMessage(r.LEVEL_SEVERE,"GpuResourceCache","putResource","missingResource."));if(!o||o<1)throw new e(r.logMessage(r.LEVEL_SEVERE,"GpuResourceCache","putResource","The specified resource size is undefined or less than 1."));var s={resource:n};this.entries.putEntry(t instanceof i?t.key:t,s,o)},s.prototype.resourceForKey=function(t){var e=t instanceof i?this.entries.entryForKey(t.key):this.entries.entryForKey(t),r=e?e.resource:null;return null!==r&&"function"==typeof r.clearTexParameters&&r.clearTexParameters(),r},s.prototype.setResourceAgingFactor=function(t,e){this.entries.setEntryAgingFactor(t,e)},s.prototype.containsResource=function(t){return this.entries.containsKey(t instanceof i?t.key:t)},s.prototype.removeResource=function(t){this.entries.removeEntry(t instanceof i?t.key:t)},s.prototype.clear=function(){this.entries.clear(!1)},s.prototype.retrieveTexture=function(t,e,n){if(!e)return null;if(e instanceof i){var s=new o(t,e.image,n);return this.putResource(e.key,s,s.size),s}if(this.currentRetrievals[e]||this.absentResourceList.isResourceAbsent(e))return null;var a=this,l=new Image;return l.onload=function(){r.log(r.LEVEL_INFO,"Image retrieval succeeded: "+e);var i=new o(t,l,n);a.putResource(e,i,i.size),delete a.currentRetrievals[e],a.absentResourceList.unmarkResourceAbsent(e);var s=document.createEvent("Event");s.initEvent(WorldWind.REDRAW_EVENT_TYPE,!0,!0),window.dispatchEvent(s)},l.onerror=function(){delete a.currentRetrievals[e],a.absentResourceList.markResourceAbsent(e),r.log(r.LEVEL_WARNING,"Image retrieval failed: "+e)},this.currentRetrievals[e]=e,l.crossOrigin="anonymous",l.src=e,null},s}),i("pick/PickedObjectList",[],function(){"use strict";var t=function(){this.objects=[]};return t.prototype.hasNonTerrainObjects=function(){return this.objects.length>1||1===this.objects.length&&null==this.terrainObject()},t.prototype.terrainObject=function(){for(var t=0,e=this.objects.length;t<e;t++)if(this.objects[t].isTerrain)return this.objects[t];return null},t.prototype.add=function(t){if(t)if(t.isTerrain){for(var e=this.objects.length,i=0,r=this.objects.length;i<r;i++)if(this.objects[i].isTerrain){e=i;break}this.objects[e]=t}else this.objects.push(t)},t.prototype.clear=function(){this.objects=[]},t.prototype.topPickedObject=function(){var t=this.objects.length;if(t>1)for(var e=0;e<t;e++)if(this.objects[e].isOnTop)return this.objects[e];return t>0?this.objects[0]:null},t}),i("render/ScreenCreditController",["../error/ArgumentError","../util/Color","../util/Font","../layer/Layer","../util/Logger","../util/Offset","../shapes/ScreenText"],function(t,e,i,r,n,o,s){"use strict";var a=function(){r.call(this,"ScreenCreditController"),this.creditPlacement=new o(WorldWind.OFFSET_PIXELS,11,WorldWind.OFFSET_PIXELS,2),this.creditMargin=11,this.opacity=.5,this.credits=[]};return a.prototype=Object.create(r.prototype),a.prototype.clear=function(){this.credits=[]},a.prototype.addCredit=function(e,r,a){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"ScreenCreditController","addCredit","missingText"));if(!r)throw new t(n.logMessage(n.LEVEL_SEVERE,"ScreenCreditController","addCredit","missingColor"));for(var l=0,h=this.credits.length;l<h;l++)if(this.credits[l].text===e)return;var u=new s(new o(WorldWind.OFFSET_PIXELS,0,WorldWind.OFFSET_PIXELS,0),e);u.attributes.font=new i(10),u.attributes.color=r,u.attributes.enableOutline=!1,u.attributes.offset=new o(WorldWind.OFFSET_FRACTION,0,WorldWind.OFFSET_FRACTION,0),a&&(u.userProperties.url=a),this.credits.push(u)},a.prototype.doRender=function(t){for(var e=this.creditPlacement.offsetForSize(t.viewport.width,t.viewport.height),i=0,r=this.credits.length;i<r;i++)this.credits[i].screenOffset.x=e[0],this.credits[i].screenOffset.y=e[1],this.credits[i].render(t),t.textRenderer.typeFace=this.credits[i].attributes.font,t.textRenderer.outlineWidth=this.credits[i].attributes.outlineWidth,t.textRenderer.enableOutline=this.credits[i].attributes.enableOutline,e[0]+=t.textRenderer.textSize(this.credits[i].text)[0],e[0]+=this.creditMargin},a}),i("util/HashMap",[],function(){"use strict";var t=function(){this._entries=Object.create(null)};return t.prototype.get=function(t){return this._entries[t]},t.prototype.set=function(t,e){this._entries[t]=e},t.prototype.remove=function(t){delete this._entries[t]},t.prototype.contains=function(t){return t in this._entries},t.reIndex=function(e,i,r){var n=new t;for(var o in e._entries){var s=parseInt(o);s>=i&&(s+=r);var a=e.get(o);a.index=s,n.set(s,a)}return n},t}),i("util/PolygonSplitter",["./HashMap","../geom/Location","../geom/Position","./WWMath"],function(t,e,i,r){"use strict";var n={addedIndex:-1,poleIndexOffset:-1,splitContours:function(t,e){for(var i=!1,r=0,n=t.length;r<n;r++){var o=this.splitContour(t[r]);o.polygons.length>1&&(i=!0),e.push(o)}return i},splitContour:function(i){var r=new t,n=[],o=[],s=[],a=[],l=-1,h=this.findIntersectionAndPole(i,n,o,r);return 0===o.length?(s.push(n),a.push(r),this.formatContourOutput(s,h,l,a)):(o.length>2&&o.sort(function(t,e){return e.latitude-t.latitude}),h!==e.poles.NONE&&(n=this.handleOnePole(n,o,r,h),r=this.reindexIntersections(o,r,this.poleIndexOffset)),0===o.length?(s.push(n),a.push(r),l=0,this.formatContourOutput(s,h,l,a)):(this.linkIntersections(o,r),l=this.makePolygons(n,o,r,s,a),this.formatContourOutput(s,h,l,a)))},findIntersectionAndPole:function(t,i,n,o){var s=!1,a=90,l=-90;this.addedIndex=-1;for(var h=0,u=t.length;h<u;h++){var c=t[h],d=t[(h+1)%u];a=Math.min(a,c.latitude),l=Math.max(l,c.latitude);var p=e.locationsCrossDateLine([c,d]);if(p){s=!s;var f=e.meridianIntersection(c,d,180);null===f&&(f=(c.latitude+d.latitude)/2);var g=180*r.signum(c.longitude)||180,m=this.createPoint(f,g,c.altitude),y=this.createPoint(f,-g,d.altitude);this.safeAdd(i,c,h,u);var E=i.length;o.set(E,this.makeIntersectionEntry(E)),o.set(E+1,this.makeIntersectionEntry(E+1)),n.push({indexEnd:E,indexStart:E+1,latitude:f}),i.push(m),i.push(y),this.safeAdd(i,d,h+1,u)}else this.safeAdd(i,c,h,u),this.safeAdd(i,d,h+1,u)}var v=e.poles.NONE;return s&&(v=this.determinePole(a,l)),v},determinePole:function(t,i){var r;return r=t>0?e.poles.NORTH:i<0?e.poles.SOUTH:Math.abs(i)>=Math.abs(t)?e.poles.NORTH:e.poles.SOUTH},handleOnePole:function(t,i,r,n){var o;if(n===e.poles.NORTH)var s=i.shift(),a=90;else n===e.poles.SOUTH&&(s=i.pop(),a=-90);var l=r.get(s.indexEnd),h=r.get(s.indexStart);l.forPole=!0,h.forPole=!0,this.poleIndexOffset=s.indexStart,o=t.slice(0,s.indexEnd+1);var u=this.createPoint(a,t[l.index].longitude,t[l.index].altitude),c=this.createPoint(a,t[h.index].longitude,t[h.index].altitude);return o.push(u,c),o=o.concat(t.slice(this.poleIndexOffset))},linkIntersections:function(t,e){for(var i=0;i<t.length-1;i+=2){var r=t[i],n=t[i+1],o=e.get(r.indexEnd),s=e.get(r.indexStart),a=e.get(n.indexEnd),l=e.get(n.indexStart);o.linkTo=n.indexStart,s.linkTo=n.indexEnd,a.linkTo=r.indexStart,l.linkTo=r.indexEnd}},reindexIntersections:function(e,i,r){i=t.reIndex(i,r,2);for(var n=0,o=e.length;n<o;n++)e[n].indexEnd>=r&&(e[n].indexEnd+=2),e[n].indexStart>=r&&(e[n].indexStart+=2);return i},makePolygons:function(e,i,r,n,o){for(var s=-1,a=0;a<i.length-1;a+=2){var l=i[a],h=i[a+1],u=l.indexStart,c=h.indexEnd,d=[],p=new t,f=this.makePolygon(u,c,e,r,d,p);d.length&&(n.push(d),o.push(p),f&&(s=n.length-1)),u=h.indexStart,c=l.indexEnd,d=[],p=new t,f=this.makePolygon(u,c,e,r,d,p),d.length&&(n.push(d),o.push(p),f&&(s=n.length-1))}return s},makePolygon:function(t,e,i,r,n,o){var s=!1,a=i.length,l=!1;e<t&&(e+=a);for(var h=t;h<=e;h++){var u=h%a,c=i[u],d=r.get(u);if(d){if(d.visited)break;if(n.push(c),o.set(n.length-1,d),d.forPole)l=!0;else{if(s&&(h=d.linkTo-1,h+1===t))break;s=!s,d.visited=!0}}else n.push(c)}return l},safeAdd:function(t,e,i,r){this.addedIndex<i&&this.addedIndex<r-1&&(t.push(e),this.addedIndex=i)},createPoint:function(t,r,n){return null==n?new e(t,r):new i(t,r,n)},formatContourOutput:function(t,e,i,r){return{polygons:t,pole:e,poleIndex:i,iMap:r}},makeIntersectionEntry:function(t){return null==t&&(t=-1),{visited:!1,forPole:!1,index:t,linkTo:-1}}};return n}),i("shapes/ShapeAttributes",["../util/Color","../util/ImageSource"],function(t,e){"use strict";var i=function(e){this._drawInterior=!e||e._drawInterior,this._drawOutline=!e||e._drawOutline,this._enableLighting=!!e&&e._enableLighting,this._interiorColor=e?e._interiorColor.clone():t.WHITE.clone(),this._outlineColor=e?e._outlineColor.clone():t.RED.clone(),this._outlineWidth=e?e._outlineWidth:1,this._outlineStippleFactor=e?e._outlineStippleFactor:0,this._outlineStipplePattern=e?e._outlineStipplePattern:61680,this._imageSource=e?e._imageSource:null,this._depthTest=!e||e._depthTest,this._drawVerticals=!!e&&e._drawVerticals,this._applyLighting=!!e&&e._applyLighting,this.stateKeyInvalid=!0};return i.prototype.computeStateKey=function(){return"di "+this._drawInterior+" do "+this._drawOutline+" el "+this._enableLighting+" ic "+this._interiorColor.toHexString(!0)+" oc "+this._outlineColor.toHexString(!0)+" ow "+this._outlineWidth+" osf "+this._outlineStippleFactor+" osp "+this._outlineStipplePattern+" is "+(this._imageSource?this.imageSource instanceof e?this.imageSource.key:this.imageSource:"null")+" dt "+this._depthTest+" dv "+this._drawVerticals+" li "+this._applyLighting},Object.defineProperties(i.prototype,{stateKey:{get:function(){return this.stateKeyInvalid&&(this._stateKey=this.computeStateKey(),this.stateKeyInvalid=!1),this._stateKey}},drawInterior:{get:function(){return this._drawInterior},set:function(t){this._drawInterior=t,this.stateKeyInvalid=!0}},drawOutline:{get:function(){return this._drawOutline},set:function(t){this._drawOutline=t,this.stateKeyInvalid=!0}},enableLighting:{get:function(){return this._enableLighting},set:function(t){this._enableLighting=t,this.stateKeyInvalid=!0}},interiorColor:{get:function(){return this._interiorColor},set:function(t){this._interiorColor=t,this.stateKeyInvalid=!0}},outlineColor:{get:function(){return this._outlineColor},set:function(t){this._outlineColor=t,this.stateKeyInvalid=!0}},outlineWidth:{get:function(){return this._outlineWidth},set:function(t){this._outlineWidth=t,this.stateKeyInvalid=!0}},outlineStipplePattern:{get:function(){return this._outlineStipplePattern},set:function(t){this._outlineStipplePattern=t,this.stateKeyInvalid=!0}},outlineStippleFactor:{get:function(){return this._outlineStippleFactor},set:function(t){this._outlineStippleFactor=t,this.stateKeyInvalid=!0}},imageSource:{get:function(){return this._imageSource},set:function(t){this._imageSource=t,this.stateKeyInvalid=!0}},depthTest:{get:function(){return this._depthTest},set:function(t){this._depthTest=t,this.stateKeyInvalid=!0}},drawVerticals:{get:function(){return this._drawVerticals},set:function(t){this._drawVerticals=t,this.stateKeyInvalid=!0}},applyLighting:{get:function(){return this._applyLighting},set:function(t){this._applyLighting=t,this.stateKeyInvalid=!0}}}),i}),i("shapes/SurfaceShape",["../error/AbstractError","../geom/Angle","../error/ArgumentError","../geom/BoundingBox","../util/Color","../geom/Location","../util/Logger","../cache/MemoryCache","../error/NotYetImplementedError","../pick/PickedObject","../util/PolygonSplitter","../render/Renderable","../geom/Sector","../shapes/ShapeAttributes","../error/UnsupportedOperationError","../geom/Vec3"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g){"use strict";var m=function(t){c.call(this),this._displayName="Surface Shape",this._attributes=t?t:new p(null),this._highlightAttributes=null,this._highlighted=!1,this._enabled=!0,this._pathType=WorldWind.GREAT_CIRCLE,this._maximumNumEdgeIntervals=m.DEFAULT_NUM_EDGE_INTERVALS,this._polarThrottle=m.DEFAULT_POLAR_THROTTLE,this._boundingSector=null,this.pickDelegate=null,this._boundingSectors=[],this._locations=null,this._boundaries=null,this._interiorGeometry=null,this._outlineGeometry=null,this._isInteriorInhibited=!1,this.stateKeyInvalid=!0,this._attributesStateKey=null,this.boundariesArePrepared=!1,this.layer=null,this.pickColor=null,this.contours=[],this.containsPole=!1,this.crossesAntiMeridian=!1,this.expirationInterval=2e3,this.shapeDataCache=new a(3,2),this.currentData=null};return m.prototype=Object.create(c.prototype),Object.defineProperties(m.prototype,{stateKey:{get:function(){if(this._attributesStateKey){var t=null;this._highlighted?this._highlightAttributes&&(t=this._highlightAttributes.stateKey):this._attributes&&(t=this._attributes.stateKey),t!=this._attributesStateKey&&(this._attributesStateKey=t,this.stateKeyInvalid=!0)}else this._highlighted?this._highlightAttributes&&(this._attributesStateKey=this._highlightAttributes.stateKey):this._attributes&&(this._attributesStateKey=this._attributes.stateKey),this._attributesStateKey&&(this.stateKeyInvalid=!0);return this.stateKeyInvalid&&(this._stateKey=this.computeStateKey()),this._stateKey}},displayName:{get:function(){return this._displayName},set:function(t){this.stateKeyInvalid=!0,this._displayName=t}},attributes:{get:function(){return this._attributes},set:function(t){this.stateKeyInvalid=!0,this._attributes=t,this._attributesStateKey=t.stateKey}},highlightAttributes:{get:function(){return this._highlightAttributes},set:function(t){this.stateKeyInvalid=!0,this._highlightAttributes=t}},highlighted:{get:function(){return this._highlighted},set:function(t){this.stateKeyInvalid=!0,this._highlighted=t}},enabled:{get:function(){return this._enabled},set:function(t){this.stateKeyInvalid=!0,this._enabled=t}},pathType:{get:function(){return this._pathType},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._pathType=t}},maximumNumEdgeIntervals:{get:function(){return this._maximumNumEdgeIntervals},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._maximumNumEdgeIntervals=t}},polarThrottle:{get:function(){return this._polarThrottle},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._polarThrottle=t}},boundingSector:{get:function(){return this._boundingSector}}}),m.staticStateKey=function(t){return t.stateKeyInvalid=!1,t.highlighted&&t._highlightAttributes?t._attributesStateKey=t._highlightAttributes.stateKey:t._attributes?t._attributesStateKey=t._attributes.stateKey:t._attributesStateKey=null,"dn "+t.displayName+" at "+(t._attributesStateKey?t._attributesStateKey:"null")+" hi "+t.highlighted+" en "+t.enabled+" pt "+t.pathType+" ne "+t.maximumNumEdgeIntervals+" po "+t.polarThrottle+" se ["+t.boundingSector.minLatitude+","+t.boundingSector.maxLatitude+","+t.boundingSector.minLongitude+","+t.boundingSector.maxLongitude+"]"},m.prototype.computeStateKey=function(){return m.staticStateKey(this)},m.prototype.area=function(t,e){throw new l(s.logMessage(s.LEVEL_SEVERE,"SurfaceShape","area","notYetImplemented"))},m.prototype.computeBoundaries=function(e){throw new t(s.logMessage(s.LEVEL_SEVERE,"SurfaceShape","computeBoundaries","abstractInvocation"))},m.prototype.intersectsFrustum=function(t){return!this.currentData||!this.currentData.extent||(t.pickingMode?this.currentData.extent.intersectsFrustum(t.pickFrustum):this.currentData.extent.intersectsFrustum(t.frustumInModelCoordinates))},m.prototype.isShapeDataCurrent=function(t,e){return e.verticalExaggeration===t.verticalExaggeration&&e.expiryTime>Date.now()},m.prototype.createShapeDataObject=function(){return{}},m.prototype.resetExpiration=function(t){t.expiryTime=Date.now()+this.expirationInterval+1e3*Math.random()},m.prototype.establishCurrentData=function(t){this.currentData=this.shapeDataCache.entryForKey(t.globeStateKey),
this.currentData||(this.currentData=this.createShapeDataObject(),this.resetExpiration(this.currentData),this.shapeDataCache.putEntry(t.globeStateKey,this.currentData,1)),this.currentData.isExpired=!this.isShapeDataCurrent(t,this.currentData)},m.prototype.render=function(t){this.enabled&&(this.layer=t.currentLayer,this.prepareBoundaries(t),this.establishCurrentData(t),!this.currentData.isExpired&&this.currentData.extent||(this.computeExtent(t),this.currentData.verticalExaggeration=t.verticalExaggeration,this.resetExpiration(this.currentData)),this.currentData&&this.currentData.extent&&!this.intersectsFrustum(t)||t.surfaceShapeTileBuilder.insertSurfaceShape(this))},m.prototype.interpolateLocations=function(t){var e,i,r,n=t[0],o=n,s=!0,a=!0,l=0,h=!0;for(this._locations=[n],i=1,r=t.length;i<r;i+=1)e=o,a=s,o=t[i],s=o.latitude==n.latitude&&o.longitude==n.longitude,h=!0,(s||a)&&(l+=1,l>2&&(h=!1)),h&&this.interpolateEdge(e,o,this._locations),this._locations.push(o),e=o;this._isInteriorInhibited||e.latitude==n.latitude&&e.longitude==n.longitude||(this.interpolateEdge(e,n,this._locations),this._locations.push(n))},m.prototype.interpolateEdge=function(t,e,i){var r,n,s=o.greatCircleDistance(t,e),a=Math.round(this._maximumNumEdgeIntervals*s/Math.PI);if(a>0){r=1/a,n=t;for(var l=this.throttledStep(r,n);l<1;l+=this.throttledStep(r,n))n=new o(0,0),o.interpolateAlongPath(this._pathType,l,t,e,n),180===t.longitude&&180===e.longitude?n.longitude=180:t.longitude===-180&&e.longitude===-180&&(n.longitude=-180),i.push(n)}},m.prototype.throttledStep=function(t,i){var r=Math.cos(i.latitude*e.DEGREES_TO_RADIANS);r*=r;var n=this._polarThrottle/(1+this._polarThrottle);return t*(1-n+n*r)},m.prototype.prepareBoundaries=function(t){if(!this.boundariesArePrepared){this.computeBoundaries(t);var e=this.formatBoundaries();this.normalizeAngles(e),e=this.interpolateBoundaries(e);var i=[],r=u.splitContours(e,i);this.contours=i,this.crossesAntiMeridian=r,this.prepareGeometry(t,i),this.prepareSectors(),this.boundariesArePrepared=!0}},m.prototype.formatBoundaries=function(){var t=[];return this._boundaries.length?(null!=this._boundaries[0].latitude?t.push(this._boundaries):t=this._boundaries,t):t},m.prototype.resetBoundaries=function(){this.boundariesArePrepared=!1,this.shapeDataCache.clear(!1)},m.prototype.normalizeAngles=function(t){for(var i=0,r=t.length;i<r;i++)for(var n=t[i],o=0,s=n.length;o<s;o++){var a=n[o];(a.longitude<-180||a.longitude>180)&&(a.longitude=e.normalizedDegreesLongitude(a.longitude)),(a.latitude<-90||a.latitude>90)&&(a.latitude=e.normalizedDegreesLatitude(a.latitude))}},m.prototype.interpolateBoundaries=function(t){for(var e=[],i=0,r=t.length;i<r;i++){var n=t[i];this.interpolateLocations(n),e.push(this._locations.slice()),this._locations.length=0}return e},m.prototype.computeSectors=function(t){return this._boundingSectors&&this._boundingSectors.length>0?this._boundingSectors:(this.prepareBoundaries(t),this._boundingSectors)},m.prototype.computeExtent=function(t){if(!this._boundingSectors||0===this._boundingSectors.length)return null;if(!this.currentData)return null;this.currentData.extent||(this.currentData.extent=new r);var e;if(1===this._boundingSectors.length)e=this._boundingSectors[0].computeBoundingPoints(t.globe,t.verticalExaggeration),this.currentData.extent.setToVec3Points(e);else{for(var i=[],n=0;n<this._boundingSectors.length;n++){e=this._boundingSectors[n].computeBoundingPoints(t.globe,t.verticalExaggeration);var o=new r;o.setToVec3Points(e);for(var s=o.getCorners(),a=0;a<s.length;a++)i.push(s[a])}this.currentData.extent.setToVec3Points(i)}return this.currentData.extent},m.prototype.computeShiftedLocations=function(t,e,i,r){var n=[],s=new g(0,0,0),a=new WorldWind.Position(0,0,0),l=t.computePointFromLocation(e.latitude,e.longitude,new g(0,0,0)),h=t.computePointFromLocation(i.latitude,i.longitude,new g(0,0,0));if(t.is2D())for(var u=h.subtract(l),c=0,d=r.length;c<d;c++)t.computePointFromLocation(r[c].latitude,r[c].longitude,s),s.add(u),t.computePositionFromPoint(s[0],s[1],s[2],a),n.push(new o(a.latitude,a.longitude));else{for(var p=i.latitude-e.latitude,f=i.longitude-e.longitude,m=-90,y=90,c=0,d=r.length;c<d;c++){var E=r[c].latitude+p,v=r[c].longitude+f;E>90?(E=180-E,v+=180):E<-90&&(E=-180-E,v+=180),v<-180?v+=360:v>180&&(v-=360),E>m&&(m=E),E<y&&(y=E),n.push(new o(E,v))}if(m>90)for(var u=m-90,c=0,d=n.length;c<d;c++)n[c].latitude-=u}return n},m.prototype.prepareSectors=function(){this.determineSectors(),this.crossesAntiMeridian?this.sectorsOverAntiMeridian():this.sectorsNotOverAntiMeridian()},m.prototype.determineSectors=function(){for(var t=0,e=this.contours.length;t<e;t++){var i=this.contours[t],r=i.polygons;i.sectors=[];for(var n=0,s=r.length;n<s;n++){var a=r[n],l=new d(0,0,0,0);if(l.setToBoundingSector(a),this._pathType===WorldWind.GREAT_CIRCLE){var h=o.greatCircleArcExtremeLocations(a),u=Math.min(l.minLatitude,h[0].latitude),c=Math.max(l.maxLatitude,h[1].latitude);l.minLatitude=u,l.maxLatitude=c}i.sectors.push(l)}}},m.prototype.sectorsOverAntiMeridian=function(){for(var t=new d(90,-90,180,-180),e=new d(90,-90,180,-180),i=0,r=this.contours.length;i<r;i++)for(var n=this.contours[i].sectors,o=0,s=n.length;o<s;o++){var a=n[o];a.minLongitude<0&&a.maxLongitude>0?(e.union(a),t.union(a)):a.minLongitude<0?e.union(a):t.union(a)}var l=Math.min(t.minLatitude,e.minLatitude),h=Math.max(t.maxLatitude,t.maxLatitude);this._boundingSector=new d(l,h,-180,180),this._boundingSectors=[t,e]},m.prototype.sectorsNotOverAntiMeridian=function(){this._boundingSector=new d(90,-90,180,-180);for(var t=0,e=this.contours.length;t<e;t++)for(var i=this.contours[t].sectors,r=0,n=i.length;r<n;r++)this._boundingSector.union(i[r]);this._boundingSectors=[this._boundingSector]},m.prototype.prepareGeometry=function(t,e){for(var i=[],r=[],n=0,s=e.length;n<s;n++)for(var a=e[n],l=a.poleIndex,h=0,u=a.polygons.length;h<u;h++){var c=a.polygons[h],d=a.iMap[h];i.push(c),a.pole!==o.poles.NONE&&u>1?h===l?this.outlineForPole(c,d,r):this.outlineForSplit(c,d,r):a.pole!==o.poles.NONE&&1===u?this.outlineForPole(c,d,r):a.pole===o.poles.NONE&&u>1?this.outlineForSplit(c,d,r):a.pole===o.poles.NONE&&1===u&&r.push(c)}this._interiorGeometry=i,this._outlineGeometry=r},m.prototype.outlineForPole=function(t,e,i){this.containsPole=!0;for(var r=[],n=0,o=0,s=t.length;o<s;o++){var a=t[o],l=e.get(o);l&&l.forPole&&(n++,n%2===1&&(r.push(a),i.push(r),r=[])),n%2===0&&r.push(a)}r.length&&i.push(r)},m.prototype.outlineForSplit=function(t,e,i){for(var r=[],n=0,o=0,s=t.length;o<s;o++){var a=t[o],l=e.get(o);l&&!l.forPole&&(n++,n%2===0&&(r.push(a),i.push(r),r=[])),n%2===1&&r.push(a)}},m.prototype.resetPickColor=function(){this.pickColor=null},m.prototype.renderToTexture=function(t,e,i,r,o,s){var a=this._highlighted?this._highlightAttributes||this._attributes:this._attributes;if(a){var l=!this._isInteriorInhibited&&a.drawInterior,u=a.drawOutline&&a.outlineWidth>0;if(l||u){if(t.pickingMode)this.pickColor||(this.pickColor=t.uniquePickColor()),e.fillStyle=this.pickColor.toCssColorString(),e.strokeStyle=e.fillStyle,e.lineWidth=a.outlineWidth;else{var c=a.interiorColor,d=a.outlineColor;e.fillStyle=new n(c.red,c.green,c.blue,c.alpha*this.layer.opacity).toCssColorString(),e.strokeStyle=new n(d.red,d.green,d.blue,d.alpha*this.layer.opacity).toCssColorString(),e.lineWidth=a.outlineWidth}if(this.crossesAntiMeridian||this.containsPole?(l&&(this.draw(this._interiorGeometry,e,i,r,o,s),e.fill()),u&&(this.draw(this._outlineGeometry,e,i,r,o,s),e.stroke())):(this.draw(this._interiorGeometry,e,i,r,o,s),l&&e.fill(),u&&e.stroke()),t.pickingMode){var p=new h(this.pickColor.clone(),this.pickDelegate?this.pickDelegate:this,null,this.layer,!1);t.resolvePick(p)}}}},m.prototype.draw=function(t,e,i,r,n,o){e.beginPath();for(var s=0,a=t.length;s<a;s++){var l=t[s],h=l[0],u=h.longitude*i+n,c=h.latitude*r+o;e.moveTo(u,c);for(var d=1,p=l.length;d<p;d++)h=l[d],u=h.longitude*i+n,c=h.latitude*r+o,e.lineTo(u,c)}},m.DEFAULT_NUM_EDGE_INTERVALS=128,m.DEFAULT_POLAR_THROTTLE=10,m}),i("shapes/SurfaceShapeTile",["../geom/Angle","../error/ArgumentError","../util/Level","../util/Logger","../geom/Sector","../render/Texture","../render/TextureTile"],function(t,e,i,r,n,o,s){"use strict";var a=function(t,e,i,r){s.call(this,t,e,i,r),this.surfaceShapes=[],this.surfaceShapeStateKeys=[],this.asRenderedSurfaceShapeStateKeys=[],this.sector=t,this.cacheKey=null,this.pickSequence=0,this.createCtx2D()};return a.prototype=Object.create(s.prototype),a.prototype.clearShapes=function(){this.surfaceShapes=[],this.surfaceShapeStateKeys=[]},a.prototype.hasShapes=function(){return this.surfaceShapes.length>0},a.prototype.getShapes=function(){return this.surfaceShapes},a.prototype.setShapes=function(t){this.surfaceShapes=t},a.prototype.getSector=function(){return this.sector},a.prototype.addSurfaceShape=function(t){this.surfaceShapes.push(t),this.surfaceShapeStateKeys.push(t.stateKey+" lo "+t.layer.opacity)},a.prototype.needsUpdate=function(t){var e,i;if(this.surfaceShapes.length!=this.asRenderedSurfaceShapeStateKeys.length)return!0;for(e=0,i=this.surfaceShapes.length;e<i;e+=1)if(this.surfaceShapeStateKeys[e]!==this.asRenderedSurfaceShapeStateKeys[e])return!0;return!this.hasTexture(t)},a.prototype.hasTexture=function(t){return!t.pickingMode&&(this.gpuCacheKey||(this.gpuCacheKey=this.getCacheKey()),t.gpuResourceCache.containsResource(this.gpuCacheKey))},a.prototype.updateTexture=function(t){var e=t.currentGlContext,i=a.canvas,r=a.ctx2D;i.width=this.tileWidth,i.height=this.tileHeight;var n=this.tileWidth/this.sector.deltaLongitude(),s=-this.tileHeight/this.sector.deltaLatitude(),l=-this.sector.minLongitude*n,h=-this.sector.maxLatitude*s;this.asRenderedSurfaceShapeStateKeys=[];for(var u=0,c=this.surfaceShapes.length;u<c;u+=1){var d=this.surfaceShapes[u];this.asRenderedSurfaceShapeStateKeys.push(this.surfaceShapeStateKeys[u]),d.renderToTexture(t,r,n,s,l,h)}this.gpuCacheKey=this.getCacheKey();var p=t.gpuResourceCache,f=new o(e,i);return p.putResource(this.gpuCacheKey,f,f.size),p.setResourceAgingFactor(this.gpuCacheKey,10),f},a.prototype.getCacheKey=function(){return this.cacheKey||(this.cacheKey="SurfaceShapeTile:"+this.tileKey+","+this.pickSequence.toString()),this.cacheKey},a.prototype.createCtx2D=function(){a.ctx2D||(a.canvas=document.createElement("canvas"),a.ctx2D=a.canvas.getContext("2d"))},a.canvas=null,a.ctx2D=null,a}),i("shapes/SurfaceShapeTileBuilder",["../error/ArgumentError","../render/DrawContext","../globe/Globe","../shaders/GpuProgram","../util/Level","../util/LevelSet","../geom/Location","../util/Logger","../geom/Matrix","../cache/MemoryCache","../error/NotYetImplementedError","../pick/PickedObject","../geom/Rectangle","../geom/Sector","../shapes/SurfaceShape","../shapes/SurfaceShapeTile","../globe/Terrain","../globe/TerrainTile","../globe/TerrainTileList","../render/TextureTile","../util/Tile"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_){"use strict";var b=function(){this.numRowsTilesInTopLevel=4,this.numColumnsTilesInTopLevel=8,this.maximumSubdivisionDepth=15,this.tileWidth=256,this.tileHeight=256,this.levels=new o(p.FULL_SPHERE,new s(180/this.numRowsTilesInTopLevel,360/this.numColumnsTilesInTopLevel),this.maximumSubdivisionDepth,this.tileWidth,this.tileHeight),this.surfaceShapes=[],this.surfaceShapeTiles=[],this.topLevelTiles=[],this.sector=new p(-90,90,-180,180),this.detailControl=1.25,this.tileCache=new h(5e5,4e5)};return b.prototype.clear=function(){this.surfaceShapeTiles.splice(0,this.surfaceShapeTiles.length),this.surfaceShapes.splice(0,this.surfaceShapes.length)},b.prototype.insertSurfaceShape=function(t){this.surfaceShapes.push(t)},b.prototype.doRender=function(t){if(t.pickingMode){for(var e=0,i=this.surfaceShapes.length;e<i;e+=1)this.surfaceShapes[e].resetPickColor();b.pickSequence+=1;var r=this.surfaceShapeTiles,n=this.topLevelTiles;this.surfaceShapeTiles=[],this.topLevelTiles=[],this.buildTiles(t),t.deepPicking?this.doDeepPickingRender(t):t.surfaceTileRenderer.renderTiles(t,this.surfaceShapeTiles,1),this.surfaceShapeTiles=r,this.topLevelTiles=n}else this.buildTiles(t),t.surfaceTileRenderer.renderTiles(t,this.surfaceShapeTiles,1)},b.prototype.doDeepPickingRender=function(t){var e,i,r,n,o,s,a,l,h,u=[];for(o=0,s=t.objectsAtPickPoint.objects.length;o<s;o+=1)a=t.objectsAtPickPoint.objects[o],a.userObject instanceof f&&(l=a.userObject,u.indexOf(l)<0&&(u.push(l),t.objectsAtPickPoint.objects.splice(o,1),o-=1,s-=1));if(!(u.length<=0)){var d=[];for(r=0,n=u.length;r<n;r+=1){for(l=u[r],e=0,i=this.surfaceShapeTiles.length;e<i;e+=1)h=this.surfaceShapeTiles[e],h.setShapes([l]),h.updateTexture(t);t.surfaceTileRenderer.renderTiles(t,this.surfaceShapeTiles,1);var p=t.readPickColor(t.pickPoint);p&&l.pickColor.equals(p)&&(a=new c(l.pickColor.clone(),l.pickDelegate?l.pickDelegate:l,null,l.layer,!1),d.push(a))}for(o=0,s=t.objectsAtPickPoint.objects.length;o<s;o+=1)a=t.objectsAtPickPoint.objects[o],a.userObject instanceof f&&(t.objectsAtPickPoint.objects.splice(o,1),o-=1,s-=1);for(o=0,s=d.length;o<s;o+=1)a=d[o],t.objectsAtPickPoint.objects.push(a)}},b.prototype.buildTiles=function(e){if(!e)throw new t(a.logMessage(a.LEVEL_SEVERE,"SurfaceShapeTileBuilder","buildTiles","missingDc"));if(this.surfaceShapes&&!(this.surfaceShapes.length<1)){this.assembleTiles(e),this.surfaceShapes.splice(0,this.surfaceShapes.length);for(var i=0,r=this.surfaceShapeTiles.length;i<r;i+=1){var n=this.surfaceShapeTiles[i];n.clearShapes()}}},b.prototype.assembleTiles=function(t){var e,i,r,n,o,s,a;this.topLevelTiles.length<1&&this.createTopLevelTiles();var l={};for(i=0,r=this.surfaceShapes.length;i<r;i+=1){var h=this.surfaceShapes[i],u=h.computeSectors(t);if(u)for(s=0,a=u.length;s<a;s+=1){var c=u[s];for(n=0,o=this.topLevelTiles.length;n<o;n+=1)if(e=this.topLevelTiles[n],e.sector.intersects(c)){var d=e.tileKey;l[d]=e,e.addSurfaceShape(h)}}}for(var p in l)l.hasOwnProperty(p)&&(e=l[p],this.addTileOrDescendants(t,this.levels,null,e))},b.prototype.addTileOrDescendants=function(t,e,i,r){if(!this.intersectsFrustum(t,r))return void r.clearShapes();if(null!=i&&this.addIntersectingShapes(t,i,r),r.hasShapes()){if(this.meetsRenderCriteria(t,e,r))return void this.addTile(t,r);for(var n=e.level(r.level.levelNumber+1),o=t.pickingMode?r.subdivide(n,this):r.subdivideToCache(n,this,this.tileCache),s=0,a=o.length;s<a;s+=1){var l=o[s];this.addTileOrDescendants(t,e,r,l)}r.clearShapes()}},b.prototype.addIntersectingShapes=function(t,e,i){for(var r=e.getShapes(),n=0,o=r.length;n<o;n+=1){var s=r[n],a=s.computeSectors(t);if(a)for(var l=0,h=a.length;l<h;l+=1){var u=a[l];if(i.getSector().intersects(u)){i.addSurfaceShape(s);break}}}},b.prototype.addTile=function(t,e){t.pickingMode&&(e.pickSequence=b.pickSequence),e.needsUpdate(t)&&e.updateTexture(t),this.surfaceShapeTiles.push(e)},b.prototype.createTile=function(t,e,i,r){return new g(t,e,i,r)},b.prototype.createTopLevelTiles=function(){_.createTilesForLevel(this.levels.firstLevel(),this,this.topLevelTiles)},b.prototype.intersectsFrustum=function(t,e){return!(t.globe.projectionLimits&&!e.sector.overlaps(t.globe.projectionLimits))&&(e.update(t),e.extent.intersectsFrustum(t.pickingMode?t.pickFrustum:t.frustumInModelCoordinates))},b.prototype.meetsRenderCriteria=function(t,e,i){return i.level.levelNumber==e.lastLevel().levelNumber||!i.mustSubdivide(t,this.detailControl)},b.pickSequence=0,b}),i("shaders/SurfaceTileRendererProgram",["../error/ArgumentError","../util/Color","../shaders/GpuProgram","../util/Logger"],function(t,e,i,r){"use strict";var n=function(t){var e="attribute vec4 vertexPoint;\nattribute vec4 vertexTexCoord;\nuniform mat4 mvpMatrix;\nuniform mat4 texSamplerMatrix;\nuniform mat4 texMaskMatrix;\nvarying vec2 texSamplerCoord;\nvarying vec2 texMaskCoord;\nvoid main() {\ngl_Position = mvpMatrix * vertexPoint;\ntexSamplerCoord = (texSamplerMatrix * vertexTexCoord).st;\ntexMaskCoord = (texMaskMatrix * vertexTexCoord).st;\n}",r="precision mediump float;\nuniform sampler2D texSampler;\nuniform float opacity;\nuniform vec4 color;\nuniform bool modulateColor;\nvarying vec2 texSamplerCoord;\nvarying vec2 texMaskCoord;\nbool isInsideTextureImage(const vec2 coord) {\n    return coord.x >= 0.0 && coord.x <= 1.0 && coord.y >= 0.0 && coord.y <= 1.0;\n}\nvoid main(void) {\nfloat mask = float(isInsideTextureImage(texMaskCoord));if (modulateColor) {\n    gl_FragColor = color * mask * floor(texture2D(texSampler, texSamplerCoord).a + 0.5);\n} else {\n    gl_FragColor = texture2D(texSampler, texSamplerCoord) * mask * opacity;\n}\n}";i.call(this,t,e,r),this.vertexPointLocation=this.attributeLocation(t,"vertexPoint"),this.vertexTexCoordLocation=this.attributeLocation(t,"vertexTexCoord"),this.mvpMatrixLocation=this.uniformLocation(t,"mvpMatrix"),this.colorLocation=this.uniformLocation(t,"color"),this.modulateColorLocation=this.uniformLocation(t,"modulateColor"),this.texSamplerMatrixLocation=this.uniformLocation(t,"texSamplerMatrix"),this.texMaskMatrixLocation=this.uniformLocation(t,"texMaskMatrix"),this.texSamplerLocation=this.uniformLocation(t,"texSampler"),this.opacityLocation=this.uniformLocation(t,"opacity"),this.vertexPointLocation=-1};return n.key="WorldWindGpuSurfaceTileRenderingProgram",n.prototype=Object.create(i.prototype),n.prototype.loadModelviewProjection=function(e,i){if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"SurfaceTileRendererProgram","loadModelviewProjection","missingMatrix"));this.loadUniformMatrix(e,i,this.mvpMatrixLocation)},n.prototype.loadTexSamplerMatrix=function(e,i){if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"SurfaceTileRendererProgram","loadTexSamplerMatrix","missingMatrix"));this.loadUniformMatrix(e,i,this.texSamplerMatrixLocation)},n.prototype.loadTexMaskMatrix=function(e,i){if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"SurfaceTileRendererProgram","loadTexMaskMatrix","missingMatrix"));this.loadUniformMatrix(e,i,this.texMaskMatrixLocation)},n.prototype.loadTexSampler=function(t,e){t.uniform1i(this.texSamplerLocation,e-WebGLRenderingContext.TEXTURE0)},n.prototype.loadOpacity=function(t,e){t.uniform1f(this.opacityLocation,e)},n.prototype.loadColor=function(e,i){if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"SurfaceTileRendererProgram","loadColor","missingColor"));this.loadUniformColor(e,i,this.colorLocation)},n.prototype.loadModulateColor=function(t,e){t.uniform1i(this.modulateColorLocation,e?1:0)},n}),i("render/SurfaceTileRenderer",["../error/ArgumentError","../util/Logger","../geom/Matrix","../shapes/SurfaceShapeTile","../shaders/SurfaceTileRendererProgram"],function(t,e,i,r,n){"use strict";var o=function(){this.texMaskMatrix=i.fromIdentity(),this.texSamplerMatrix=i.fromIdentity(),this.isSurfaceShapeTileRendering=!1};return o.prototype.renderTiles=function(i,n,o,s){if(!n)throw new t(e.logMessage(e.LEVEL_SEVERE,"SurfaceTileRenderer","renderTiles","Specified surface tiles array is null or undefined."));if(!(n.length<1)){var a,l,h,u,c=i.terrain,d=i.currentGlContext,p=0,f=1;if(c){this.isSurfaceShapeTileRendering=n[0]instanceof r,o*=i.surfaceOpacity,a=this.beginRendering(i,o),c.beginRendering(i);try{for(var g=0,m=c.surfaceGeometry.length;g<m;g++){l=c.surfaceGeometry[g],h=l.sector,c.beginRenderingTile(i,l);try{for(var y=0,E=n.length;y<E;y++)u=n[y],u.sector.overlaps(h)&&u.bind(i)&&(i.pickingMode?u.pickColor&&a.loadColor(d,u.pickColor):s&&u.opacity!=f&&(a.loadOpacity(d,o*u.opacity),f=u.opacity),this.applyTileState(i,l,u),c.renderTile(i,l),++p)}catch(t){console.log(t)}finally{c.endRenderingTile(i,l)}}}catch(t){console.log(t)}finally{c.endRendering(i),this.endRendering(i),i.frameStatistics.incrementRenderedTileCount(p)}}}},o.prototype.beginRendering=function(t,e){var i=t.currentGlContext,r=t.findAndBindProgram(n);return r.loadTexSampler(i,i.TEXTURE0),t.pickingMode&&!this.isSurfaceShapeTileRendering?r.loadModulateColor(i,!0):(r.loadModulateColor(i,!1),r.loadOpacity(i,e)),r},o.prototype.endRendering=function(t){var e=t.currentGlContext;e.bindTexture(e.TEXTURE_2D,null)},o.prototype.applyTileState=function(t,e,i){var r=t.currentGlContext,n=t.currentProgram,o=e.sector,s=o.deltaLatitude(),a=o.deltaLongitude(),l=i.sector,h=l.deltaLatitude(),u=l.deltaLongitude(),c=h>0?h:1,d=u>0?u:1,p=a/d,f=s/c,g=-(l.minLongitude-o.minLongitude)/d,m=-(l.minLatitude-o.minLatitude)/c;this.texMaskMatrix.set(p,0,0,g,0,f,0,m,0,0,1,0,0,0,0,1),this.texSamplerMatrix.setToUnitYFlip(),i.applyInternalTransform(t,this.texSamplerMatrix),this.texSamplerMatrix.multiplyMatrix(this.texMaskMatrix),n.loadTexSamplerMatrix(r,this.texSamplerMatrix),n.loadTexMaskMatrix(r,this.texMaskMatrix)},o}),i("render/TextRenderer",["../error/ArgumentError","../shaders/BasicTextureProgram","../util/Color","../util/Font","../util/Logger","../geom/Matrix","../render/Texture","../geom/Vec2"],function(t,e,i,r,n,o,s,a){"use strict";var l=function(e){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"TextRenderer","constructor","missingDc"));this.canvas2D=document.createElement("canvas"),this.ctx2D=this.canvas2D.getContext("2d"),this.dc=e,this.enableOutline=!0,this.lineSpacing=.15,this.outlineColor=new i(0,0,0,.5),this.outlineWidth=4,this.textColor=new i(1,1,1,1),this.typeFace=new r(14)};return l.prototype.textSize=function(t){if(0===t.length)return new a(0,0);this.ctx2D.font=this.typeFace.fontString;for(var e=t.split("\n"),i=e.length*(this.typeFace.size*(1+this.lineSpacing)),r=0,n=0;n<e.length;n++)r=Math.max(r,this.ctx2D.measureText(e[n]).width);return this.enableOutline&&(r+=this.outlineWidth,i+=this.outlineWidth),new a(r,i)},l.prototype.renderText=function(t){if(t&&t.length>0){var e=this.drawText(t);return new s(this.dc.currentGlContext,e)}return null},l.prototype.drawText=function(t){var e=this.ctx2D,i=this.canvas2D,r=this.textSize(t),n=t.split("\n"),o=this.enableOutline?this.outlineWidth/2:0,s=this.dc.pixelScale;i.width=Math.ceil(r[0])*s,i.height=Math.ceil(r[1])*s,e.scale(s,s),e.font=this.typeFace.fontString,e.textBaseline="bottom",e.textAlign=this.typeFace.horizontalAlignment,e.fillStyle=this.textColor.toCssColorString(),e.strokeStyle=this.outlineColor.toCssColorString(),e.lineWidth=this.outlineWidth,e.lineCap="round",e.lineJoin="round","left"===this.typeFace.horizontalAlignment?e.translate(o,0):"right"===this.typeFace.horizontalAlignment?e.translate(r[0]-o,0):e.translate(r[0]/2,0);for(var a=0;a<n.length;a++)e.translate(0,this.typeFace.size*(1+this.lineSpacing)+o),this.enableOutline&&e.strokeText(n[a],0,0),e.fillText(n[a],0,0);return i},l.prototype.getMaxLineHeight=function(){return this.textSize("_É")[1]},l.prototype.wrap=function(e,i,r){if(!e)throw new t(n.logMessage(n.WARNING,"TextRenderer","wrap","missing text"));var o,s=e.split("\n"),a="";for(o=0;o<s.length;o++)s[o]=this.wrapLine(s[o],i);var l=0,h=!1,u=this.getMaxLineHeight();for(o=0;o<s.length&&!h;o++){for(var c=s[o].split("\n"),d=0;d<c.length&&!h;d++)r<=0||l+u<=r?(a+=c[d],l+=u+this.lineSpacing,d<c.length-1&&(a+="\n")):h=!0;o<s.length-1&&!h&&(a+="\n")}return h&&(a.length>0&&(a=a.substring(0,a.length-1)),a+="..."),a},l.prototype.wrapLine=function(t,e){var i="",r=t.trim(),n=this.textSize(r);if(n[0]>e){for(var o="",s=0,a=r.indexOf(" ",s+1);s<r.length;){a===-1&&(a=r.length);var l=r.substring(s,a),h=o+l;this.textSize(h)[0]<=e?o+=l:0!==o.length?(i+=o,i+="\n",o="",o+=l.trim()):o+=l.trim(),s=a,s<r.length-1&&(a=r.indexOf(" ",s+1))}i+=o}else i+=r;return i},l}),i("render/DrawContext",["../error/ArgumentError","../util/Color","../util/FrameStatistics","../render/FramebufferTexture","../render/FramebufferTileController","../geom/Frustum","../globe/Globe","../shaders/GpuProgram","../cache/GpuResourceCache","../layer/Layer","../geom/Line","../util/Logger","../geom/Matrix","../pick/PickedObjectList","../geom/Plane","../geom/Position","../geom/Rectangle","../render/ScreenCreditController","../geom/Sector","../shapes/SurfaceShape","../shapes/SurfaceShapeTileBuilder","../render/SurfaceTileRenderer","../render/TextRenderer","../geom/Vec2","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_,b,w,S,L,T){"use strict";var A=function(i){if(!i)throw new t(c.logMessage(c.LEVEL_SEVERE,"Texture","constructor","missingGlContext"));this.currentGlContext=i,this.canvas2D=document.createElement("canvas"),this.ctx2D=this.canvas2D.getContext("2d"),this.clearColor=e.TRANSPARENT,this.gpuResourceCache=new l(WorldWind.configuration.gpuCacheSize,.8*WorldWind.configuration.gpuCacheSize),this.surfaceTileRenderer=new b,this.surfaceShapeTileBuilder=new _,this.surfaceShapeTileController=new n,this.screenCreditController=new y,this.textRenderer=new w(this),this.currentFramebuffer=null,this.currentProgram=null,this.surfaceRenderables=[],this.orderedRenderingMode=!1,this.orderedRenderables=[],this.orderedRenderablesCounter=0,this.timestamp=Date.now(),this.previousRedrawTimestamp=this.timestamp,this.redrawRequested=!1,this.globe=null,this.globeStateKey=null,this.layers=null,this.currentLayer=null,this.eyePosition=new g(0,0,0),this.eyePoint=new L(0,0,0),this.screenProjection=d.fromIdentity(),this.terrain=null,this.verticalExaggeration=1,this.fadeTime=500,this.surfaceOpacity=1,this.frameStatistics=null,this.pickingMode=!1,this.pickTerrainOnly=!1,this.deepPicking=!1,this.regionPicking=!1,this.pickPoint=null,this.pickRay=null,this.pickRectangle=null,this.pickFramebuffer=null,this.pickFrustum=null,this.pickColor=new e(0,0,0,1),this.objectsAtPickPoint=new p,this.pixelScale=1,this.navigator=null,this.modelview=d.fromIdentity(),this.projection=d.fromIdentity(),this.modelviewProjection=d.fromIdentity(),this.frustumInModelCoordinates=null,this.modelviewNormalTransform=d.fromIdentity(),this.viewport=new m(0,0,0,0),this.pixelSizeFactor=0,this.pixelSizeOffset=0,this.glExtensionsCache={}};return A.unitCubeKey="DrawContextUnitCubeKey",A.unitCubeElementsKey="DrawContextUnitCubeElementsKey",A.unitQuadKey="DrawContextUnitQuadKey",A.unitQuadKey3="DrawContextUnitQuadKey3",A.prototype.reset=function(){this.screenCreditController.clear(),this.surfaceRenderables=[],this.orderedRenderingMode=!1,this.orderedRenderables=[],this.screenRenderables=[],this.orderedRenderablesCounter=0;var t=this.timestamp;this.timestamp=Date.now(),this.timestamp===t&&++this.timestamp,this.redrawRequested=!1,this.globe=null,this.globeStateKey=null,this.layers=null,this.currentLayer=null,this.terrain=null,this.verticalExaggeration=1,this.frameStatistics=null,this.accumulateOrderedRenderables=!0,this.pickingMode=!1,this.pickTerrainOnly=!1,this.deepPicking=!1,this.regionPicking=!1,this.pickPoint=null,this.pickRay=null,this.pickRectangle=null,this.pickFrustum=null,this.pickColor=new e(0,0,0,1),this.objectsAtPickPoint.clear(),this.eyePoint.set(0,0,0),this.modelview.setToIdentity(),this.projection.setToIdentity(),this.modelviewProjection.setToIdentity(),this.frustumInModelCoordinates=null,this.modelviewNormalTransform.setToIdentity()},A.prototype.update=function(){var t=this.currentGlContext,e=this.eyePoint;this.globeStateKey=this.globe.stateKey,this.globe.computePositionFromPoint(e[0],e[1],e[2],this.eyePosition),this.screenProjection.setToScreenProjection(t.drawingBufferWidth,t.drawingBufferHeight)},A.prototype.contextLost=function(){this.gpuResourceCache.clear(),this.pickFramebuffer=null,this.currentFramebuffer=null,this.currentProgram=null,this.glExtensionsCache={}},A.prototype.contextRestored=function(){this.gpuResourceCache.clear(),this.glExtensionsCache={}},A.prototype.bindFramebuffer=function(t){this.currentFramebuffer!=t&&(this.currentGlContext.bindFramebuffer(this.currentGlContext.FRAMEBUFFER,t?t.framebufferId:null),this.currentFramebuffer=t)},A.prototype.bindProgram=function(t){this.currentProgram!=t&&(this.currentGlContext.useProgram(t?t.programId:null),this.currentProgram=t)},A.prototype.findAndBindProgram=function(e){if(!e)throw new t(c.logMessage(c.LEVEL_SEVERE,"DrawContext","findAndBindProgram","The specified program constructor is null or undefined."));var i=this.gpuResourceCache.resourceForKey(e.key);if(i)this.bindProgram(i);else try{i=new e(this.currentGlContext),this.bindProgram(i),this.gpuResourceCache.putResource(e.key,i,i.size)}catch(t){c.log(c.LEVEL_SEVERE,"Error attempting to create GPU program.")}return i},A.prototype.addSurfaceRenderable=function(t){t&&this.surfaceRenderables.push(t)},A.prototype.peekSurfaceRenderable=function(){return this.surfaceRenderables.length>0?this.surfaceRenderables[this.surfaceRenderables.length-1]:null},A.prototype.popSurfaceRenderable=function(){return this.surfaceRenderables.length>0?this.surfaceRenderables.pop():null},A.prototype.reverseSurfaceRenderables=function(){this.surfaceRenderables.reverse()},A.prototype.addOrderedRenderable=function(t,e){if(t){var i={orderedRenderable:t,insertionOrder:this.orderedRenderablesCounter++,eyeDistance:e||t.eyeDistance,globeStateKey:this.globeStateKey};this.globe.continuous&&(i.globeOffset=this.globe.offset),0===i.eyeDistance?this.screenRenderables.push(i):this.orderedRenderables.push(i)}},A.prototype.addOrderedRenderableToBack=function(t){if(t){var e={orderedRenderable:t,insertionOrder:this.orderedRenderablesCounter++,eyeDistance:Number.MAX_VALUE,globeStateKey:this.globeStateKey};this.globe.continuous&&(e.globeOffset=this.globe.offset),this.orderedRenderables.push(e)}},A.prototype.peekOrderedRenderable=function(){return this.orderedRenderables.length>0?this.orderedRenderables[this.orderedRenderables.length-1].orderedRenderable:null},A.prototype.popOrderedRenderable=function(){if(this.orderedRenderables.length>0){var t=this.orderedRenderables.pop();return this.globeStateKey=t.globeStateKey,this.globe.continuous&&(this.globe.offset=t.globeOffset),t.orderedRenderable}return null},A.prototype.nextScreenRenderable=function(){if(this.screenRenderables.length>0){var t=this.screenRenderables.shift();return this.globeStateKey=t.globeStateKey,this.globe.continuous&&(this.globe.offset=t.globeOffset),t.orderedRenderable}return null},A.prototype.sortOrderedRenderables=function(){this.orderedRenderables.sort(function(t,e){var i=t.eyeDistance,r=e.eyeDistance;if(i<r)return-1;if(i>r)return 1;var n=t.insertionOrder,o=e.insertionOrder;return n>o?-1:n<o?1:0})},A.prototype.readPickColor=function(t){var i=this.convertPointToViewport(t,new S(0,0)),r=new Uint8Array(4);return this.currentGlContext.readPixels(i[0],i[1],1,1,this.currentGlContext.RGBA,this.currentGlContext.UNSIGNED_BYTE,r),this.clearColor.equalsBytes(r)?null:e.colorFromByteArray(r)},A.prototype.readPickColors=function(t){var i,r=this.currentGlContext,n=new Uint8Array(t.width*t.height*4),o={},s=new e(0,0,0,0),a=r.getParameter(r.PACK_ALIGNMENT);r.pixelStorei(r.PACK_ALIGNMENT,1),this.currentGlContext.readPixels(t.x,t.y,t.width,t.height,r.RGBA,r.UNSIGNED_BYTE,n),r.pixelStorei(r.PACK_ALIGNMENT,a);for(var l=0,h=t.width*t.height;l<h;l++){var u=4*l;i=e.colorFromBytes(n[u],n[u+1],n[u+2],n[u+3]),i.equals(this.clearColor)||i.equals(s)||(o[i.toByteString()]=i)}return o},A.prototype.resolvePick=function(t){if(t.userObject instanceof v||!this.deepPicking||this.regionPicking)this.addPickedObject(t);else{var e=this.readPickColor(this.pickPoint);if(!e)return null;t.color.equals(e)&&this.addPickedObject(t)}},A.prototype.addPickedObject=function(t){t&&this.objectsAtPickPoint.add(t)},A.prototype.uniquePickColor=function(){var t=this.pickColor.nextColor().clone();return t.equals(this.clearColor)?t.nextColor():t},A.prototype.makePickFramebuffer=function(){var t=this.currentGlContext,e=t.drawingBufferWidth,i=t.drawingBufferHeight;return this.pickFramebuffer&&this.pickFramebuffer.width==e&&this.pickFramebuffer.height==i||(this.pickFramebuffer=new r(t,e,i,!0)),this.pickFramebuffer},A.prototype.makePickFrustum=function(){if(!this.pickPoint&&!this.pickRectangle)return!1;var t,e,i,r,n,s,a,l,h,u,c,p,g,y,E,v,_,b,w,A,R,x,C=new L(0,0,0),M=2,P=new L(0,0,0),O=this.pickRectangle,N=this.viewport;O||(x=this.convertPointToViewport(this.pickPoint,new S(0,0)),O=new m(x[0]-M,x[1]-M,2*M,2*M));var I=O.x,D=O.x+O.width,k=O.y,F=O.y+O.height;if(D<0||F<0||I>N.x+N.width||k>N.y+N.height)return!1;O.x=T.clamp(I,N.x,N.x+N.width),O.y=T.clamp(k,N.y,N.y+N.height),O.width=T.clamp(D,N.x,N.x+N.width)-O.x,O.height=T.clamp(F,N.y,N.y+N.height)-O.y,
this.pickRectangle=O;var V=d.fromIdentity();return V.invertMatrix(this.modelviewProjection),P[0]=O.x,P[1]=O.y,P[2]=0,V.unProject(P,N,t=new L(0,0,0)),P[0]=O.x,P[1]=O.y,P[2]=1,V.unProject(P,N,e=new L(0,0,0)),P[0]=O.x+O.width,P[1]=O.y,P[2]=0,V.unProject(P,N,i=new L(0,0,0)),P[0]=O.x+O.width,P[1]=O.y,P[2]=1,V.unProject(P,N,r=new L(0,0,0)),P[0]=O.x,P[1]=O.y+O.height,P[2]=0,V.unProject(P,N,n=new L(0,0,0)),P[0]=O.x,P[1]=O.y+O.height,P[2]=1,V.unProject(P,N,s=new L(0,0,0)),P[0]=O.x+O.width,P[1]=O.y+O.height,P[2]=0,V.unProject(P,N,a=new L(0,0,0)),P[0]=O.x+O.width,P[1]=O.y+O.height,P[2]=1,V.unProject(P,N,l=new L(0,0,0)),R=new L(s[0]-t[0],s[1]-t[1],s[2]-t[2]),C.set(n[0]-e[0],n[1]-e[1],n[2]-e[2]),h=R.cross(C),E=new f(h[0],h[1],h[2],-h.dot(t)),E.normalize(),R=new L(a[0]-r[0],a[1]-r[1],a[2]-r[2]),C.set(l[0]-i[0],l[1]-i[1],l[2]-i[2]),u=R.cross(C),v=new f(u[0],u[1],u[2],-u.dot(i)),v.normalize(),R=new L(s[0]-a[0],s[1]-a[1],s[2]-a[2]),C.set(l[0]-n[0],l[1]-n[1],l[2]-n[2]),c=R.cross(C),_=new f(c[0],c[1],c[2],-c.dot(n)),_.normalize(),R=new L(r[0]-t[0],r[1]-t[1],r[2]-t[2]),C.set(e[0]-i[0],e[1]-i[1],e[2]-i[2]),p=R.cross(C),b=new f(p[0],p[1],p[2],-p.dot(i)),b.normalize(),R=new L(n[0]-i[0],n[1]-i[1],n[2]-i[2]),C.set(a[0]-t[0],a[1]-t[1],a[2]-t[2]),g=R.cross(C),w=new f(g[0],g[1],g[2],-g.dot(t)),w.normalize(),R=new L(l[0]-e[0],l[1]-e[1],l[2]-e[2]),C.set(s[0]-r[0],s[1]-r[1],s[2]-r[2]),y=R.cross(C),A=new f(y[0],y[1],y[2],-y.dot(e)),A.normalize(),this.pickFrustum=new o(E,v,b,_,w,A),!0},A.prototype.isSmall=function(t,e){if(!t)return!1;var i=this.eyePoint.distanceTo(t.center),r=this.pixelSizeAtDistance(i);return 2*t.radius<e*r},A.prototype.unitCubeBuffer=function(){var t=this.gpuResourceCache.resourceForKey(A.unitCubeKey);if(!t){var e=this.currentGlContext,i=new Float32Array(24),r=0;i[r++]=0,i[r++]=1,i[r++]=0,i[r++]=0,i[r++]=0,i[r++]=0,i[r++]=1,i[r++]=1,i[r++]=0,i[r++]=1,i[r++]=0,i[r++]=0,i[r++]=0,i[r++]=1,i[r++]=1,i[r++]=0,i[r++]=0,i[r++]=1,i[r++]=1,i[r++]=1,i[r++]=1,i[r++]=1,i[r++]=0,i[r]=1,t=e.createBuffer(),e.bindBuffer(e.ARRAY_BUFFER,t),e.bufferData(e.ARRAY_BUFFER,i,e.STATIC_DRAW),e.bindBuffer(e.ARRAY_BUFFER,null),this.frameStatistics.incrementVboLoadCount(1),this.gpuResourceCache.putResource(A.unitCubeKey,t,4*i.length)}return t},A.prototype.unitCubeElements=function(){var t=this.gpuResourceCache.resourceForKey(A.unitCubeElementsKey);if(!t){var e=this.currentGlContext,i=new Int16Array(60),r=0;i[r++]=1,i[r++]=0,i[r++]=3,i[r++]=3,i[r++]=0,i[r++]=2,i[r++]=4,i[r++]=5,i[r++]=6,i[r++]=6,i[r++]=5,i[r++]=7,i[r++]=5,i[r++]=1,i[r++]=7,i[r++]=7,i[r++]=1,i[r++]=3,i[r++]=6,i[r++]=2,i[r++]=4,i[r++]=4,i[r++]=2,i[r++]=0,i[r++]=4,i[r++]=0,i[r++]=5,i[r++]=5,i[r++]=0,i[r++]=1,i[r++]=7,i[r++]=3,i[r++]=6,i[r++]=6,i[r++]=3,i[r++]=2,i[r++]=0,i[r++]=1,i[r++]=1,i[r++]=3,i[r++]=3,i[r++]=2,i[r++]=2,i[r++]=0,i[r++]=4,i[r++]=5,i[r++]=5,i[r++]=7,i[r++]=7,i[r++]=6,i[r++]=6,i[r++]=4,i[r++]=0,i[r++]=4,i[r++]=5,i[r++]=1,i[r++]=2,i[r++]=6,i[r++]=7,i[r]=3,t=e.createBuffer(),e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,t),e.bufferData(e.ELEMENT_ARRAY_BUFFER,i,e.STATIC_DRAW),e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,null),this.frameStatistics.incrementVboLoadCount(1),this.gpuResourceCache.putResource(A.unitCubeElementsKey,t,2*i.length)}return t},A.prototype.unitQuadBuffer=function(){var t=this.gpuResourceCache.resourceForKey(A.unitQuadKey);if(!t){var e=this.currentGlContext,i=new Float32Array(8);i[0]=0,i[1]=1,i[2]=0,i[3]=0,i[4]=1,i[5]=1,i[6]=1,i[7]=0,t=e.createBuffer(),e.bindBuffer(e.ARRAY_BUFFER,t),e.bufferData(e.ARRAY_BUFFER,i,e.STATIC_DRAW),e.bindBuffer(e.ARRAY_BUFFER,null),this.frameStatistics.incrementVboLoadCount(1),this.gpuResourceCache.putResource(A.unitQuadKey,t,4*i.length)}return t},A.prototype.unitQuadBuffer3=function(){var t=this.gpuResourceCache.resourceForKey(A.unitQuadKey3);if(!t){var e=this.currentGlContext,i=new Float32Array(12);i[0]=0,i[1]=1,i[2]=0,i[3]=0,i[4]=0,i[5]=0,i[6]=1,i[7]=1,i[8]=0,i[9]=1,i[10]=0,i[11]=0,t=e.createBuffer(),e.bindBuffer(e.ARRAY_BUFFER,t),e.bufferData(e.ARRAY_BUFFER,i,e.STATIC_DRAW),e.bindBuffer(e.ARRAY_BUFFER,null),this.frameStatistics.incrementVboLoadCount(1),this.gpuResourceCache.putResource(A.unitQuadKey3,t,4*i.length)}return t},A.prototype.surfacePointForMode=function(e,i,r,n,o){if(!o)throw new t(c.logMessage(c.LEVEL_SEVERE,"DrawContext","surfacePointForMode","missingResult"));if(this.terrain)this.terrain.surfacePointForMode(e,i,r,n,o);else{var s=r+this.globe.elevationAtLocation(e,i)*this.verticalExaggeration;this.globe.computePointFromPosition(e,i,s,o)}return o},A.prototype.project=function(e,i){if(!e)throw new t(c.logMessage(c.LEVEL_SEVERE,"DrawContext","project","missingPoint"));if(!i)throw new t(c.logMessage(c.LEVEL_SEVERE,"DrawContext","project","missingResult"));var r=e[0],n=e[1],o=e[2],s=this.modelviewProjection,a=s[0]*r+s[1]*n+s[2]*o+s[3],l=s[4]*r+s[5]*n+s[6]*o+s[7],h=s[8]*r+s[9]*n+s[10]*o+s[11],u=s[12]*r+s[13]*n+s[14]*o+s[15];return 0!==u&&(a/=u,l/=u,h/=u,!(h<-1||h>1)&&(a=.5*a+.5,l=.5*l+.5,h=.5*h+.5,a=a*this.viewport.width+this.viewport.x,l=l*this.viewport.height+this.viewport.y,i[0]=a,i[1]=l,i[2]=h,!0))},A.prototype.projectWithDepth=function(e,i,r){if(!e)throw new t(c.logMessage(c.LEVEL_SEVERE,"DrawContext","projectWithDepth","missingPoint"));if(!r)throw new t(c.logMessage(c.LEVEL_SEVERE,"DrawContext","projectWithDepth","missingResult"));var n=e[0],o=e[1],s=e[2],a=this.modelview,l=a[0]*n+a[1]*o+a[2]*s+a[3],h=a[4]*n+a[5]*o+a[6]*s+a[7],u=a[8]*n+a[9]*o+a[10]*s+a[11],d=a[12]*n+a[13]*o+a[14]*s+a[15],p=this.projection,f=p[0]*l+p[1]*h+p[2]*u+p[3]*d,g=p[4]*l+p[5]*h+p[6]*u+p[7]*d,m=p[8]*l+p[9]*h+p[10]*u+p[11]*d,y=p[12]*l+p[13]*h+p[14]*u+p[15]*d;return 0!==y&&(f/=y,g/=y,m/=y,!(m<-1||m>1)&&(m=p[8]*l+p[9]*h+p[10]*u*(1+i)+p[11]*d,m/=y,m=T.clamp(m,-1,1),f=.5*f+.5,g=.5*g+.5,m=.5*m+.5,f=f*this.viewport.width+this.viewport.x,g=g*this.viewport.height+this.viewport.y,r[0]=f,r[1]=g,r[2]=m,!0))},A.prototype.convertPointToViewport=function(e,i){if(!e)throw new t(c.logMessage(c.LEVEL_SEVERE,"DrawContext","convertPointToViewport","missingPoint"));if(!i)throw new t(c.logMessage(c.LEVEL_SEVERE,"DrawContext","convertPointToViewport","missingResult"));return i[0]=e[0],i[1]=this.viewport.height-e[1],i},A.prototype.pixelSizeAtDistance=function(t){return this.pixelSizeFactor*t+this.pixelSizeOffset},A.prototype.createTextTexture=function(t,e){if(!t||!e)return null;var i=this.computeTextTextureStateKey(t,e),r=this.gpuResourceCache.resourceForKey(i);return r||(this.textRenderer.textColor=e.color,this.textRenderer.typeFace=e.font,this.textRenderer.enableOutline=e.enableOutline,this.textRenderer.outlineColor=e.outlineColor,this.textRenderer.outlineWidth=e.outlineWidth,r=this.textRenderer.renderText(t),this.gpuResourceCache.putResource(i,r,r.size),this.gpuResourceCache.setResourceAgingFactor(i,100)),r},A.prototype.computeTextTextureStateKey=function(t,e){return t&&e?t+"c "+e.color.toHexString(!0)+" f "+e.font.toString()+" eo "+e.enableOutline+" ow "+e.outlineWidth+" oc "+e.outlineColor.toHexString(!0):null},A.prototype.getExtension=function(e){if(!e)throw new t(c.logMessage(c.LEVEL_SEVERE,"DrawContext","getExtension","missingExtensionName"));return e in this.glExtensionsCache||(this.glExtensionsCache[e]=this.currentGlContext.getExtension(e)||null),this.glExtensionsCache[e]},A}),i("globe/GebcoElevationCoverage",["../geom/Location","../geom/Sector","../globe/TiledElevationCoverage","../util/WmsUrlBuilder"],function(t,e,i,r){"use strict";var n=function(){i.call(this,{coverageSector:e.FULL_SPHERE,resolution:.008333333333333,retrievalImageFormat:"application/bil16",minElevation:-11e3,maxElevation:8850,urlBuilder:new r("https://worldwind26.arc.nasa.gov/elev","GEBCO","","1.3.0")}),this.displayName="GEBCO Earth Elevation Coverage"};return n.prototype=Object.create(i.prototype),n}),i("globe/UsgsNedElevationCoverage",["../geom/Location","../geom/Sector","../globe/TiledElevationCoverage","../util/WmsUrlBuilder"],function(t,e,i,r){"use strict";var n=function(){i.call(this,{coverageSector:new e(24.396308,49.384358,-124.848974,-66.885444),resolution:92592592593e-15,retrievalImageFormat:"application/bil16",minElevation:-11e3,maxElevation:8850,urlBuilder:new r("https://worldwind26.arc.nasa.gov/elev","USGS-NED","","1.3.0")}),this.displayName="USGS NED Earth Elevation Coverage"};return n.prototype=Object.create(i.prototype),n}),i("globe/UsgsNedHiElevationCoverage",["../geom/Location","../geom/Sector","../globe/TiledElevationCoverage","../util/WmsUrlBuilder"],function(t,e,i,r){"use strict";var n=function(){i.call(this,{coverageSector:new e(18.86546,28.517269,-178.443593,-154.755792),resolution:92592592593e-15,retrievalImageFormat:"application/bil16",minElevation:-11e3,maxElevation:8850,urlBuilder:new r("https://worldwind26.arc.nasa.gov/elev","USGS-NED","","1.3.0")}),this.displayName="USGS NED Hawaii Elevation Coverage"};return n.prototype=Object.create(i.prototype),n}),i("globe/EarthElevationModel",["../globe/AsterV2ElevationCoverage","../globe/ElevationModel","../globe/GebcoElevationCoverage","../globe/UsgsNedElevationCoverage","../globe/UsgsNedHiElevationCoverage"],function(t,e,i,r,n){"use strict";var o=function(){e.call(this),this.addCoverage(new i),this.addCoverage(new t),this.addCoverage(new r),this.addCoverage(new n)};return o.prototype=Object.create(e.prototype),o}),i("globe/EarthRestElevationCoverage",["../util/LevelSet","../geom/Location","../geom/Sector","../util/LevelRowColumnUrlBuilder","../globe/TiledElevationCoverage"],function(t,e,i,r,n){"use strict";var o=function(o,s,a){n.call(this,{coverageSector:i.FULL_SPHERE,resolution:.00732421875,retrievalImageFormat:"application/bil16",minElevation:-11e3,maxElevation:8850,urlBuilder:new r(o,s)}),this.displayName=a||"Earth Elevations",this.levels=new t(i.FULL_SPHERE,new e(60,60),5,512,512)};return o.prototype=Object.create(n.prototype),o}),i("FirstPersonCamera",["./geom/Angle","./error/ArgumentError","./geom/Line","./util/Logger","./geom/Matrix","./geom/Position","./geom/Vec3","./util/WWMath"],function(t,e,i,r,n,o,s,a){"use strict";var l=function(t){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"FirstPersonCamera","constructor","missing WorldWindow instance."));this.position=new o(30,-110,1e3),this.heading=0,this.tilt=0,this.roll=0,this.wwd=t,this._scratchMatrix=n.fromIdentity(),this._scratchVector=new s(0,0,0),this._ray=new i(new s(0,0,0),new s(0,0,0))};return Object.defineProperties(l.prototype,{range:{get:function(){return this.position.altitude},set:function(t){this.position.altitude=t}}}),l.prototype.createViewMatrix=function(t){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"FirstPersonCamera","createViewMatrix","missing matrix"));return this.applyLimits(),t.setToIdentity(),t.multiplyByLookAtModelview(this.position,0,this.heading,this.tilt+90,this.roll,this.wwd.globe),t},l.prototype.clone=function(t){return t=t||new l(this.wwd),t.copy(this),t},l.prototype.copy=function(t){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"FirstPersonCamera","copy","missing camera"));return this.position.copy(t.position),this.heading=t.heading,this.tilt=t.tilt,this.roll=t.roll,this},l.prototype.applyLimits=function(){this.position.latitude=a.clamp(this.position.latitude,-90,90),this.position.longitude=t.normalizedDegreesLongitude(this.position.longitude),this.position.altitude=a.clamp(this.position.altitude,0,Number.MAX_VALUE),this.tilt=a.clamp(this.tilt,-90,90),this.heading=t.normalizedDegrees(this.heading),this.roll=t.normalizedDegrees(this.roll)},l.prototype.toArcBall=function(t){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"FirstPersonCamera","toArcBall","missing arcBallCamera"));var i=this.createViewMatrix(this._scratchMatrix);i.extractEyePoint(this._ray.origin),i.extractForwardVector(this._ray.direction);var n=this._ray.pointAt(t.range,this._scratchVector),o=i.extractViewingParameters(n,this.roll,this.wwd.globe,{});return t.position.copy(o.origin),t.heading=o.heading,t.tilt=o.tilt,t.roll=o.roll,t.applyLimits(),t},l}),i("layer/FrameStatisticsLayer",["../error/ArgumentError","../util/Color","../util/Font","../layer/Layer","../util/Logger","../util/Offset","../shapes/ScreenText","../shapes/TextAttributes"],function(t,e,i,r,n,o,s,a){"use strict";var l=function(l){function h(t,e){c.handleRedraw(t,e)}if(!l)throw new t(n.logMessage(n.LEVEL_SEVERE,"FrameStatisticsLayer","constructor","missingWorldWindow"));r.call(this,"Frame Statistics"),this.pickEnabled=!1;var u=new a(null);u.color=e.GREEN,u.font=new i(12),u.offset=new o(WorldWind.OFFSET_FRACTION,0,WorldWind.OFFSET_FRACTION,1),this.frameTime=new s(new o(WorldWind.OFFSET_PIXELS,5,WorldWind.OFFSET_INSET_PIXELS,5)," "),this.frameTime.attributes=u,this.frameRate=new s(new o(WorldWind.OFFSET_PIXELS,5,WorldWind.OFFSET_INSET_PIXELS,25)," "),this.frameRate.attributes=u;var c=this;l.redrawCallbacks.push(h)};return l.prototype=Object.create(r.prototype),l.prototype.doRender=function(t){this.frameRate.render(t),this.frameTime.render(t),this.inCurrentFrame=!0},l.prototype.handleRedraw=function(t,e){if(e===WorldWind.BEFORE_REDRAW){var i=t.frameStatistics;this.frameTime.text="Frame time  "+i.frameTimeAverage.toFixed(0)+" ms  ("+i.frameTimeMin.toFixed(0)+" - "+i.frameTimeMax.toFixed(0)+")",this.frameRate.text="Frame rate  "+i.frameRateAverage.toFixed(0)+" fps"}},l}),i("shapes/AbstractShape",["../error/ArgumentError","../util/Logger","../geom/Matrix","../cache/MemoryCache","../render/Renderable","../shapes/ShapeAttributes","../error/UnsupportedOperationError","../geom/Vec3"],function(t,e,i,r,n,o,s,a){"use strict";var l=function(t){n.call(this),this._attributes=t?t:new o(null),this._highlightAttributes=null,this.highlighted=!1,this._altitudeMode=WorldWind.ABSOLUTE,this.referencePosition=null,this.shapeDataCache=new r(3,2),this.currentData=null,this.activeAttributes=null,this.expirationInterval=2e3,this.useSurfaceShapeFor2D=!1,this.scratchMatrix=i.fromIdentity()};return l.prototype=Object.create(n.prototype),Object.defineProperties(l.prototype,{attributes:{get:function(){return this._attributes},set:function(t){this._attributes=t,this.surfaceShape&&(this.surfaceShape.attributes=this._attributes)}},highlightAttributes:{get:function(){return this._highlightAttributes},set:function(t){this._highlightAttributes=t,this.surfaceShape&&(this.surfaceShape.highlightAttributes=this._highlightAttributes)}},altitudeMode:{get:function(){return this._altitudeMode},set:function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"AbstractShape","altitudeMode","missingAltitudeMode"));this._altitudeMode=i,this.reset()}}}),l.prototype.reset=function(){this.shapeDataCache.clear(!1),this.surfaceShape=null},l.prototype.updateSurfaceShape=function(){this.surfaceShape.displayName=this.displayName,this.surfaceShape.highlighted=this.highlighted,this.surfaceShape.enabled=this.enabled,this.surfaceShape.pathType=this.pathType,this.surfaceShape.pickDelegate=this.pickDelegate?this.pickDelegate:this},l.prototype.createSurfaceShape=function(){return null},l.prototype.render=function(t){if(this.enabled&&t.accumulateOrderedRenderables){if(t.globe.is2D()&&this.useSurfaceShapeFor2D&&(this.surfaceShape||(this.surfaceShape=this.createSurfaceShape(),this.surfaceShape&&(this.surfaceShape.attributes=this._attributes,this.surfaceShape.highlightAttributes=this._highlightAttributes)),this.surfaceShape))return this.updateSurfaceShape(),void this.surfaceShape.render(t);if((t.terrain||this.altitudeMode==WorldWind.ABSOLUTE)&&(this.establishCurrentData(t),(!t.globe.projectionLimits||this.isWithinProjectionLimits(t))&&(!this.currentData.extent||this.intersectsFrustum(t))&&(this.determineActiveAttributes(t),this.activeAttributes))){var e=this.makeOrderedRenderable(t);if(e){if(!this.intersectsFrustum(t))return;if(t.isSmall(this.currentData.extent,1))return;e.layer=t.currentLayer,t.addOrderedRenderable(e,this.currentData.eyeDistance)}}}},l.prototype.renderOrdered=function(t){this.currentData=this.shapeDataCache.entryForKey(t.globeStateKey),this.beginDrawing(t);try{this.doRenderOrdered(t)}finally{this.endDrawing(t)}},l.prototype.makeOrderedRenderable=function(t){var e=this.doMakeOrderedRenderable(t);return this.currentData.verticalExaggeration=t.verticalExaggeration,e},l.prototype.doMakeOrderedRenderable=function(t){throw new s(e.logMessage(e.LEVEL_SEVERE,"AbstractShape","makeOrderedRenderable","abstractInvocation"))},l.prototype.doRenderOrdered=function(t){throw new s(e.logMessage(e.LEVEL_SEVERE,"AbstractShape","doRenderOrdered","abstractInvocation"))},l.prototype.beginDrawing=function(t){},l.prototype.endDrawing=function(t){},l.prototype.intersectsFrustum=function(t){return!this.currentData||!this.currentData.extent||(t.pickingMode?this.currentData.extent.intersectsFrustum(t.pickFrustum):this.currentData.extent.intersectsFrustum(t.frustumInModelCoordinates))},l.prototype.establishCurrentData=function(t){this.currentData=this.shapeDataCache.entryForKey(t.globeStateKey),this.currentData||(this.currentData=this.createShapeDataObject(),this.resetExpiration(this.currentData),this.shapeDataCache.putEntry(t.globeStateKey,this.currentData,1)),this.currentData.isExpired=!this.isShapeDataCurrent(t,this.currentData)},l.prototype.createShapeDataObject=function(){return{transformationMatrix:i.fromIdentity(),referencePoint:new a(0,0,0)}},l.prototype.resetExpiration=function(t){t.expiryTime=Date.now()+this.expirationInterval+1e3*Math.random()},l.prototype.isShapeDataCurrent=function(t,e){return e.verticalExaggeration===t.verticalExaggeration&&e.expiryTime>Date.now()},l.prototype.determineActiveAttributes=function(t){this.highlighted&&this._highlightAttributes?this.activeAttributes=this.highlightAttributes:this.activeAttributes=this._attributes},l.prototype.isWithinProjectionLimits=function(t){return!0},l.prototype.applyMvpMatrix=function(t){this.scratchMatrix.copy(t.modelviewProjection),this.scratchMatrix.multiplyMatrix(this.currentData.transformationMatrix),t.currentProgram.loadModelviewProjection(t.currentGlContext,this.scratchMatrix)},l.prototype.applyMvpMatrixForOutline=function(t){this.scratchMatrix.copy(t.projection),this.scratchMatrix.offsetProjectionDepth(-.001),this.scratchMatrix.multiplyMatrix(t.modelview),this.scratchMatrix.multiplyMatrix(this.currentData.transformationMatrix),t.currentProgram.loadModelviewProjection(t.currentGlContext,this.scratchMatrix)},l}),i("shapes/AbstractMesh",["../shapes/AbstractShape","../error/ArgumentError","../shaders/BasicTextureProgram","../geom/BoundingBox","../util/Color","../util/ImageSource","../geom/Line","../geom/Location","../util/Logger","../geom/Matrix","../pick/PickedObject","../geom/Position","../shapes/ShapeAttributes","../geom/Vec2","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g){"use strict";var m=function(e){t.call(this,e),this.pickTransparentImagePixels=!0,this._altitudeScale=1};return m.prototype=Object.create(t.prototype),Object.defineProperties(m.prototype,{altitudeScale:{get:function(){return this._altitudeScale},set:function(t){this._altitudeScale=t,this.reset()}}}),m.prototype.mustGenerateGeometry=function(t){return!this.currentData.meshPoints||(this.currentData.drawInterior!==this.activeAttributes.drawInterior||(!(!this.activeAttributes.applyLighting||this.currentData.normals)||this.altitudeMode!==WorldWind.ABSOLUTE&&this.currentData.isExpired))},m.prototype.doMakeOrderedRenderable=function(t){if(!this.activeAttributes.drawInterior&&!this.activeAttributes.drawOutline)return null;if(!this.mustGenerateGeometry(t))return this;var e=this.currentData,i=e.referencePoint;return t.surfacePointForMode(this.referencePosition.latitude,this.referencePosition.longitude,this.referencePosition.altitude*this._altitudeScale,this._altitudeMode,i),e.transformationMatrix.setToTranslation(i[0],i[1],i[2]),e.meshPoints=this.computeMeshPoints(t,e),e.refreshVertexBuffer=!0,this.activeAttributes.imageSource&&!this.texCoords&&(this.texCoords=this.computeTexCoords(),this.texCoords&&(e.refreshTexCoordBuffer=!0)),this.meshIndices||(this.meshIndices=this.computeMeshIndices(),e.refreshMeshIndices=!0),this.meshOutlineIndices||(this.meshOutlineIndices=this.computeOutlineIndices(),this.meshOutlineIndices&&(e.refreshOutlineIndices=!0)),this.activeAttributes.applyLighting&&this.computeNormals(e),e.drawInterior=this.activeAttributes.drawInterior,this.resetExpiration(e),e.extent||(e.extent=new r),e.extent.setToPoints(e.meshPoints),e.extent.translate(e.referencePoint),this},m.prototype.computeMeshPoints=function(t,e){throw new UnsupportedOperationError(l.logMessage(l.LEVEL_SEVERE,"AbstractMesh","computeMeshPoints","abstractInvocation"))},m.prototype.computeTexCoords=function(){return null},m.prototype.computeMeshIndices=function(t){throw new UnsupportedOperationError(l.logMessage(l.LEVEL_SEVERE,"AbstractMesh","computeMeshIndices","abstractInvocation"))},m.prototype.computeOutlineIndices=function(t){},m.prototype.computeNormals=function(t){for(var e,i=new Float32Array(t.meshPoints.length),r=this.meshIndices,n=t.meshPoints,o=[],s=[new f(0,0,0),new f(0,0,0),new f(0,0,0)],a=0;a<r.length;a+=3){for(var l=0;l<3;l++)e=r[a+l],s[l].set(n[3*e],n[3*e+1],n[3*e+2]);var h=f.computeTriangleNormal(s[0],s[1],s[2]);for(l=0;l<3;l++)e=r[a+l],o[e]||(o[e]=[]),o[e].push(h)}for(h=new f(0,0,0),a=0;a<o.length;a++)o[a]?(f.average(o[a],h),h.normalize(),i[3*a]=h[0],i[3*a+1]=h[1],i[3*a+2]=h[2]):(i[3*a]=0,i[3*a+1]=0,i[3*a+2]=0);t.normals=i,t.refreshNormalsBuffer=!0},m.prototype.doRenderOrdered=function(t){var e,i,r,n,o=t.currentGlContext,s=t.currentProgram,a=this.currentData,l=this.texCoords&&!!this.activeAttributes.imageSource;if(t.pickingMode&&(r=t.uniquePickColor()),a.pointsVboCacheKey||(a.pointsVboCacheKey=t.gpuResourceCache.generateCacheKey()),e=t.gpuResourceCache.resourceForKey(a.pointsVboCacheKey),e||(e=o.createBuffer(),t.gpuResourceCache.putResource(a.pointsVboCacheKey,e,4*a.meshPoints.length),a.refreshVertexBuffer=!0),o.bindBuffer(o.ARRAY_BUFFER,e),a.refreshVertexBuffer&&(o.bufferData(o.ARRAY_BUFFER,a.meshPoints,o.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1),a.refreshVertexBuffer=!1),o.vertexAttribPointer(s.vertexPointLocation,3,o.FLOAT,!1,0,0),s.loadTextureEnabled(o,!1),this.activeAttributes.drawInterior){var h=!t.pickingMode&&a.normals&&this.activeAttributes.applyLighting;this.applyMvpMatrix(t),a.meshIndicesVboCacheKey||(a.meshIndicesVboCacheKey=t.gpuResourceCache.generateCacheKey()),e=t.gpuResourceCache.resourceForKey(a.meshIndicesVboCacheKey),e||(e=o.createBuffer(),t.gpuResourceCache.putResource(a.meshIndicesVboCacheKey,e,2*this.meshIndices.length),a.refreshMeshIndices=!0),o.bindBuffer(o.ELEMENT_ARRAY_BUFFER,e),a.refreshMeshIndices&&(o.bufferData(o.ELEMENT_ARRAY_BUFFER,this.meshIndices,o.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1),a.refreshMeshIndices=!1),i=this.activeAttributes.interiorColor,o.depthMask(i.alpha*this.layer.opacity>=1||t.pickingMode),s.loadColor(o,t.pickingMode?r:i),s.loadOpacity(o,t.pickingMode?1:this.layer.opacity),!l||t.pickingMode&&this.pickTransparentImagePixels||(this.activeTexture=t.gpuResourceCache.resourceForKey(this.activeAttributes.imageSource),this.activeTexture||(this.activeTexture=t.gpuResourceCache.retrieveTexture(t.currentGlContext,this.activeAttributes.imageSource)),n=this.activeTexture&&this.activeTexture.bind(t),n&&(a.texCoordsVboCacheKey||(a.texCoordsVboCacheKey=t.gpuResourceCache.generateCacheKey()),e=t.gpuResourceCache.resourceForKey(a.texCoordsVboCacheKey),e||(e=o.createBuffer(),t.gpuResourceCache.putResource(a.texCoordsVboCacheKey,e,4*this.texCoords.length),a.refreshTexCoordBuffer=!0),o.bindBuffer(o.ARRAY_BUFFER,e),a.refreshTexCoordBuffer&&(o.bufferData(o.ARRAY_BUFFER,this.texCoords,o.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1),a.refreshTexCoordBuffer=!1),o.enableVertexAttribArray(s.vertexTexCoordLocation),o.vertexAttribPointer(s.vertexTexCoordLocation,2,o.FLOAT,!1,0,0),this.scratchMatrix.setToIdentity(),this.scratchMatrix.multiplyByTextureTransform(this.activeTexture),s.loadTextureEnabled(o,!0),s.loadTextureUnit(o,o.TEXTURE0),s.loadTextureMatrix(o,this.scratchMatrix),s.loadModulateColor(o,t.pickingMode))),h&&(s.loadApplyLighting(o,!0),a.normalsVboCacheKey||(a.normalsVboCacheKey=t.gpuResourceCache.generateCacheKey()),e=t.gpuResourceCache.resourceForKey(a.normalsVboCacheKey),e||(e=o.createBuffer(),t.gpuResourceCache.putResource(a.normalsVboCacheKey,e,4*a.normals.length),a.refreshNormalsBuffer=!0),o.bindBuffer(o.ARRAY_BUFFER,e),a.refreshNormalsBuffer&&(o.bufferData(o.ARRAY_BUFFER,a.normals,o.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1),a.refreshNormalsBuffer=!1),o.enableVertexAttribArray(s.normalVectorLocation),o.vertexAttribPointer(s.normalVectorLocation,3,o.FLOAT,!1,0,0)),o.drawElements(o.TRIANGLES,this.meshIndices.length,o.UNSIGNED_SHORT,0),l&&o.disableVertexAttribArray(s.vertexTexCoordLocation),h&&(s.loadApplyLighting(o,!1),o.disableVertexAttribArray(s.normalVectorLocation))}if(this.activeAttributes.drawOutline&&this.meshOutlineIndices&&(s.loadTextureEnabled(o,!1),o.disableVertexAttribArray(s.vertexTexCoordLocation),this.applyMvpMatrixForOutline(t),i=this.activeAttributes.outlineColor,o.depthMask(i.alpha*this.layer.opacity>=1||t.pickingMode),s.loadColor(o,t.pickingMode?r:i),s.loadOpacity(o,t.pickingMode?1:this.layer.opacity),o.lineWidth(this.activeAttributes.outlineWidth),a.outlineIndicesVboCacheKey||(a.outlineIndicesVboCacheKey=t.gpuResourceCache.generateCacheKey()),e=t.gpuResourceCache.resourceForKey(a.outlineIndicesVboCacheKey),e||(e=o.createBuffer(),t.gpuResourceCache.putResource(a.outlineIndicesVboCacheKey,e,2*this.meshOutlineIndices.length),a.refreshOutlineIndices=!0),o.bindBuffer(o.ELEMENT_ARRAY_BUFFER,e),a.refreshOutlineIndices&&(o.bufferData(o.ELEMENT_ARRAY_BUFFER,this.meshOutlineIndices,o.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1),a.refreshOutlineIndices=!1),o.drawElements(o.LINE_STRIP,this.meshOutlineIndices.length,o.UNSIGNED_SHORT,0)),t.pickingMode){var c=this.computePickPosition(t),d=new u(r,this.pickDelegate?this.pickDelegate:this,c,this.layer,!1);t.resolvePick(d)}},m.prototype.computePickPosition=function(t){if(null===t.pickRay)return null;var e=this.currentData,i=t.pickRay,r=new f(i.origin[0],i.origin[1],i.origin[2]).subtract(e.referencePoint),n=new s(r,i.direction),o=[];if(g.computeIndexedTrianglesIntersection(n,e.meshPoints,this.meshIndices,o)){var a=o[0];if(o.length>1)for(var l=a.distanceToSquared(t.eyePoint),h=1;h<o.length;h++){var u=o[h].distanceToSquared(t.eyePoint);u<l&&(l=u,a=o[h])}var d=new c(0,0,0);return t.globe.computePositionFromPoint(a[0]+e.referencePoint[0],a[1]+e.referencePoint[1],a[2]+e.referencePoint[2],d),d.altitude/=this._altitudeScale,d}return null},m.prototype.beginDrawing=function(t){var e=t.currentGlContext;if(this.activeAttributes.drawInterior){e.disable(e.CULL_FACE),t.findAndBindProgram(i);var r=!t.pickMode&&this.currentData.normals&&this.activeAttributes.applyLighting;r&&t.currentProgram.loadModelviewInverse(e,t.modelviewNormalTransform)}e.enableVertexAttribArray(t.currentProgram.vertexPointLocation)},m.prototype.endDrawing=function(t){var e=t.currentGlContext;e.disableVertexAttribArray(t.currentProgram.vertexPointLocation),e.depthMask(!0),e.lineWidth(1),e.enable(e.CULL_FACE)},m}),i("shapes/SurfacePolygon",["../error/ArgumentError","../util/Logger","../shapes/ShapeAttributes","../shapes/SurfaceShape"],function(t,e,i,r){"use strict";var n=function(i,o){if(!Array.isArray(i))throw new t(e.logMessage(e.LEVEL_SEVERE,"SurfacePolygon","constructor","The specified boundary is not an array."));r.call(this,o),this._boundaries=i,this._stateId=n.stateId++};return n.prototype=Object.create(r.prototype),Object.defineProperties(n.prototype,{boundaries:{get:function(){return this._boundaries},set:function(i){if(!Array.isArray(i))throw new t(e.logMessage(e.LEVEL_SEVERE,"SurfacePolygon","set boundaries","The specified value is not an array."));this.resetBoundaries(),this._boundaries=i,this._stateId=n.stateId++,this.stateKeyInvalid=!0}}}),n.stateId=Number.MIN_SAFE_INTEGER,n.staticStateKey=function(t){var e=r.staticStateKey(t);return e+" pg "+t._stateId},n.prototype.computeStateKey=function(){return n.staticStateKey(this)},n.prototype.computeBoundaries=function(t){},n.prototype.getReferencePosition=function(){return this.boundaries.length>0&&this.boundaries[0].length>2?this.boundaries[0][0]:this.boundaries.length>2?this.boundaries[0]:null},n.prototype.moveTo=function(t,e){if(this.boundaries.length>0&&this.boundaries[0].length>2){for(var i=[],r=0,n=this._boundaries.length;r<n;r++){var o=this.computeShiftedLocations(t,this.getReferencePosition(),e,this._boundaries[r]);i.push(o)}this.boundaries=i}else this.boundaries.length>2&&(this.boundaries=this.computeShiftedLocations(t,this.getReferencePosition(),e,this._boundaries))},n}),i("shapes/GeographicMesh",["../shapes/AbstractMesh","../error/ArgumentError","../shaders/BasicTextureProgram","../geom/BoundingBox","../util/Color","../util/ImageSource","../geom/Location","../util/Logger","../geom/Matrix","../pick/PickedObject","../geom/Position","../shapes/ShapeAttributes","../shapes/SurfacePolygon","../geom/Vec2","../geom/Vec3"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f){"use strict";var g=function(i,r){if(!i)throw new e(a.logMessage(a.LEVEL_SEVERE,"GeographicMesh","constructor","missingPositions"));if(i.length<2||i[0].length<2)throw new e(a.logMessage(a.LEVEL_SEVERE,"GeographicMesh","constructor","Number of positions is insufficient."));if(i.length*i[0].length>65536)throw new e(a.logMessage(a.LEVEL_SEVERE,"GeographicMesh","constructor","Too many positions. Must be fewer than 65536. Try using multiple meshes."));for(var n=i[0].length,o=1;o<i.length;o++)if(i[o].length!==n)throw new e(a.logMessage(a.LEVEL_SEVERE,"GeographicMesh","constructor","Array lengths are inconsistent."));var s=i.length,l=i[0].length;t.call(this,r),this.pickTransparentImagePixels=!0,this._positions=i,this._altitudeScale=1,this.numRows=s,this.numColumns=l,this._textureCoordinates=null,this.referencePosition=this.determineReferencePosition(this._positions)};return g.prototype=Object.create(t.prototype),Object.defineProperties(g.prototype,{positions:{get:function(){return this._positions},set:function(t){if(!t)throw new e(a.logMessage(a.LEVEL_SEVERE,"GeographicMesh","positions","missingPositions"));if(t.length<2||t[0].length<2)throw new e(a.logMessage(a.LEVEL_SEVERE,"GeographicMesh","positions","Number of positions is insufficient."));for(var i=t[0].length,r=1;r<t.length;r++)if(t[r].length!==i)throw new e(a.logMessage(a.LEVEL_SEVERE,"GeographicMesh","positions","Array lengths are inconsistent."));this.numRows=t.length,this.numColumns=t[0].length,this._positions=t,this.referencePosition=this.determineReferencePosition(this._positions),this.reset(),this.meshIndices=null,this.meshOutlineIndices=null}},textureCoordinates:{get:function(){return this._textureCoordinates},set:function(t){if(t&&t.length!=this.numRows)throw new e(a.logMessage(a.LEVEL_SEVERE,"GeographicMesh","textureCoordinates","Number of texture coordinate rows is inconsistent with the currently specified positions."));for(var i=0;i<this.numRows;i++)if(t[i].length!==this.numColumns)throw new e(a.logMessage(a.LEVEL_SEVERE,"GeographicMesh","textureCoordinates","Texture coordinate row lengths are inconsistent with the currently specified positions."));this._textureCoordinates=t,this.reset(),this.texCoords=null}}}),g.makeGridIndices=function(t,e){for(var i=[],r=0,n=0;n<t-1;n++)for(var o=0;o<e-1;o++){var s=n*e+o;i[r++]=s,i[r++]=s+1,i[r++]=s+e,i[r++]=s+1,i[r++]=s+1+e,i[r++]=s+e}return i},g.prototype.determineReferencePosition=function(t){return t[0][0]},g.prototype.createSurfaceShape=function(){for(var t=[],e=0;e<this.numColumns;e++)t.push(this._positions[0][e]);for(var i=1;i<this.numRows;i++)t.push(this._positions[i][this.numColumns-1]);for(e=this.numColumns-2;e>=0;e--)t.push(this._positions[this.numRows-1][e]);for(i=this.numRows-2;i>0;i--)t.push(this._positions[i][0]);return new d(t,null)},g.prototype.computeMeshPoints=function(t,e){for(var i,r,n=Number.MAX_VALUE,o=t.eyePoint,s=new Float32Array(this.numRows*this.numColumns*3),a=new f(0,0,0),l=0,h=0;h<this._positions.length;h++)for(var u=0,c=this._positions[h].length;u<c;u++)i=this._positions[h][u],
t.surfacePointForMode(i.latitude,i.longitude,i.altitude*this._altitudeScale,this.altitudeMode,a),r=a.distanceToSquared(o),r<n&&(n=r),a.subtract(this.currentData.referencePoint),s[l++]=a[0],s[l++]=a[1],s[l++]=a[2];return e.eyeDistance=Math.sqrt(n),s},g.prototype.computeTexCoords=function(){return this._textureCoordinates?this.computeExplicitTexCoords():this.computeImplicitTexCoords()},g.prototype.computeExplicitTexCoords=function(){for(var t=new Float32Array(2*this.numRows*this.numColumns),e=0,i=0;i<this._textureCoordinates.length;i++)for(var r=0,n=this._textureCoordinates[i].length;r<n;r++){var o=this._textureCoordinates[i][r];t[e++]=o[0],t[e++]=o[1]}return t},g.prototype.computeImplicitTexCoords=function(){for(var t=new Float32Array(2*this.numRows*this.numColumns),e=1/(this.numRows-1),i=1/(this.numColumns-1),r=0,n=0;n<this._positions.length;n++)for(var o=n===this.numRows-1?1:n*e,s=0,a=this._positions[n].length;s<a;s++)t[r++]=s===this.numColumns-1?1:s*i,t[r++]=o;return t},g.prototype.computeMeshIndices=function(){for(var t=new Uint16Array((this.numRows-1)*(this.numColumns-1)*6),e=0,i=0;i<this.numRows-1;i++)for(var r=0;r<this.numColumns-1;r++){var n=i*this.numColumns+r;t[e++]=n,t[e++]=n+1,t[e++]=n+this.numColumns,t[e++]=n+1,t[e++]=n+1+this.numColumns,t[e++]=n+this.numColumns}return t},g.prototype.computeOutlineIndices=function(){for(var t=new Uint16Array(2*this.numRows+2*this.numColumns),e=0,i=0;i<this.numColumns;i++)t[e++]=i;for(var r=1;r<this.numRows;r++)t[e++]=(r+1)*this.numColumns-1;for(i=this.numRows*this.numColumns-2;i>=(this.numRows-1)*this.numColumns;i--)t[e++]=i;for(r=this.numRows-2;r>=0;r--)t[e++]=r*this.numColumns;return t},g}),i("shapes/GeographicText",["../error/ArgumentError","../util/Logger","../shapes/Text","../geom/Vec3"],function(t,e,i,r){"use strict";var n=function(r,n){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"Text","constructor","missingPosition"));i.call(this,n),this.position=r,this.declutterGroup=1};return n.placePoint=new r(0,0,0),n.prototype=Object.create(i.prototype),n.prototype.clone=function(){var t=new n(this.position,this.text);return t.copy(this),t.pickDelegate=this.pickDelegate?this.pickDelegate:this,t},n.prototype.render=function(t){t.globe.projectionLimits&&!t.globe.projectionLimits.containsLocation(this.position.latitude,this.position.longitude)||i.prototype.render.call(this,t)},n.prototype.computeScreenPointAndEyeDistance=function(t){return t.surfacePointForMode(this.position.latitude,this.position.longitude,this.position.altitude,this.altitudeMode,n.placePoint),!!t.frustumInModelCoordinates.containsPoint(n.placePoint)&&(this.eyeDistance=this.alwaysOnTop?0:t.eyePoint.distanceTo(n.placePoint),!!t.projectWithDepth(n.placePoint,this.depthOffset,this.screenPoint))},n}),i("formats/geojson/GeoJSONConstants",[],function(){"use strict";var t=function(){};return t.FIELD_TYPE="type",t.FIELD_CRS="crs",t.FIELD_NAME="name",t.FIELD_BBOX="bbox",t.FIELD_COORDINATES="coordinates",t.FIELD_GEOMETRIES="geometries",t.FIELD_GEOMETRY="geometry",t.FIELD_PROPERTIES="properties",t.FIELD_FEATURES="features",t.FIELD_ID="id",t.TYPE_POINT="Point",t.TYPE_MULTI_POINT="MultiPoint",t.TYPE_LINE_STRING="LineString",t.TYPE_MULTI_LINE_STRING="MultiLineString",t.TYPE_POLYGON="Polygon",t.TYPE_MULTI_POLYGON="MultiPolygon",t.TYPE_GEOMETRY_COLLECTION="GeometryCollection",t.TYPE_FEATURE="Feature",t.TYPE_FEATURE_COLLECTION="FeatureCollection",t.FIELD_CRS_NAME="name",t.FIELD_CRS_LINK="link",t.WGS84_CRS="urn:ogc:def:crs:OGC:1.3:CRS84",t.EPSG4326_CRS="EPSG:4326",t}),i("formats/geojson/GeoJSONExporter",["../../error/ArgumentError","./GeoJSONConstants","../../util/Logger"],function(t,e,i){"use strict";var r={exportRenderable:function(e){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportRenderable","missingRenderable"));return e instanceof WorldWind.Placemark?this.exportPlacemark(e):e instanceof WorldWind.SurfacePolyline?this.exportSurfacePolyline(e):e instanceof WorldWind.SurfacePolygon?this.exportSurfacePolygon(e):e instanceof WorldWind.SurfaceEllipse?this.exportSurfaceEllipse(e):e instanceof WorldWind.SurfaceCircle?this.exportSurfaceCircle(e):e instanceof WorldWind.SurfaceRectangle?this.exportSurfaceRectangle(e):e instanceof WorldWind.SurfaceSector?this.exportSurfaceSector(e):e instanceof WorldWind.Path?this.exportPath(e):e instanceof WorldWind.Polygon?this.exportPolygon(e):(i.log(i.LEVEL_WARNING,"Export renderable not implemented: "+e),null)},exportRenderables:function(r){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportRenderables","missingRenderables"));if(0!=r.length){if(r.length>1){var n="{";n=n+'"'+e.FIELD_TYPE+'":"'+e.TYPE_GEOMETRY_COLLECTION+'"',n=n+',"'+e.FIELD_GEOMETRIES+'":[';for(var o=0;o<r.length;o++){var s=this.exportRenderable(r[o]);s&&(n+=s,n+=",")}return","===n.slice(-1)&&(n=n.substring(0,n.length-1)),n+="]",n+="}"}return this.exportRenderable(r[0])}},exportLayer:function(e){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportLayer","missingLayer"));return this.exportRenderables(e.renderables)},exportPlacemark:function(r){if(!(r instanceof WorldWind.Placemark))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportPlacemark","invalidTypeOfRenderable"));var n="{";return n=n+'"'+e.FIELD_TYPE+'":"'+e.TYPE_POINT+'",',n=n+'"'+e.FIELD_COORDINATES+'":',n=n+"["+r.position.longitude+","+r.position.latitude+"]",n+="}"},exportSurfacePolyline:function(r){if(!(r instanceof WorldWind.SurfacePolyline))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportSurfacePolyline","invalidTypeOfRenderable"));var n="{";n=n+'"'+e.FIELD_TYPE+'":"'+e.TYPE_LINE_STRING+'",',n=n+'"'+e.FIELD_COORDINATES+'":[';for(var o=0;o<r.boundaries.length;o++)n=n+"["+r.boundaries[o].longitude+","+r.boundaries[o].latitude+"]",o!==r.boundaries.length-1&&(n+=",");return n+="]",n+="}"},exportSurfacePolygon:function(r){if(!(r instanceof WorldWind.SurfacePolygon))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportSurfacePolygon","invalidTypeOfRenderable"));var n="{";if(n=n+'"'+e.FIELD_TYPE+'":"'+e.TYPE_POLYGON+'",',n=n+'"'+e.FIELD_COORDINATES+'":[',r.boundaries.length>0&&r.boundaries[0].length>2)for(var o=0;o<r.boundaries.length;o++){n+="[";for(var s=0;s<r.boundaries[o].length;s++)n=n+"["+r.boundaries[o][s].longitude+","+r.boundaries[o][s].latitude+"]",n+=",",s===r.boundaries[o].length-1&&(n=n+"["+r.boundaries[o][0].longitude+","+r.boundaries[o][0].latitude+"]");n+="]",o!==r.boundaries.length-1&&(n+=",")}else{n+="[";for(var o=0;o<r.boundaries.length;o++)n=n+"["+r.boundaries[o].longitude+","+r.boundaries[o].latitude+"]",n+=",",o===r.boundaries.length-1&&(n=n+"["+r.boundaries[0].longitude+","+r.boundaries[0].latitude+"]");n+="]"}return n+="]",n+="}"},exportSurfaceEllipse:function(r){if(!(r instanceof WorldWind.SurfaceEllipse))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportSurfaceEllipse","invalidTypeOfRenderable"));var n="{";n=n+'"'+e.FIELD_TYPE+'":"'+e.TYPE_POLYGON+'",',n=n+'"'+e.FIELD_COORDINATES+'":[',n+="[";for(var o=0;o<r._boundaries.length;o++)n=n+"["+r._boundaries[o].longitude+","+r._boundaries[o].latitude+"]",n+=",",o===r._boundaries.length-1&&(n=n+"["+r._boundaries[0].longitude+","+r._boundaries[0].latitude+"]");return n+="]",n+="]",n+="}"},exportSurfaceCircle:function(r){if(!(r instanceof WorldWind.SurfaceCircle))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportSurfaceCircle","invalidTypeOfRenderable"));var n="{";n=n+'"'+e.FIELD_TYPE+'":"'+e.TYPE_POLYGON+'",',n=n+'"'+e.FIELD_COORDINATES+'":[',n+="[";for(var o=r._boundaries.length-1;o>=0;o--)n=n+"["+r._boundaries[o].longitude+","+r._boundaries[o].latitude+"]",n+=",",0===o&&(n=n+"["+r._boundaries[r._boundaries.length-1].longitude+","+r._boundaries[r._boundaries.length-1].latitude+"]");return n+="]",n+="]",n+="}"},exportSurfaceRectangle:function(r){if(!(r instanceof WorldWind.SurfaceRectangle))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportSurfaceRectangle","invalidTypeOfRenderable"));var n="{";n=n+'"'+e.FIELD_TYPE+'":"'+e.TYPE_POLYGON+'",',n=n+'"'+e.FIELD_COORDINATES+'":[',n+="[";for(var o=0;o<r._boundaries.length;o++)n=n+"["+r._boundaries[o].longitude+","+r._boundaries[o].latitude+"]",n+=",",o===r._boundaries.length-1&&(n=n+"["+r._boundaries[0].longitude+","+r._boundaries[0].latitude+"]");return n+="]",n+="]",n+="}"},exportSurfaceSector:function(r){if(!(r instanceof WorldWind.SurfaceSector))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportSurfaceSector","invalidTypeOfRenderable"));var n="{";n=n+'"'+e.FIELD_TYPE+'":"'+e.TYPE_POLYGON+'",',n=n+'"'+e.FIELD_COORDINATES+'":[',n+="[",r._boundaries.reverse();for(var o=0;o<r._boundaries.length;o++)n=n+"["+r._boundaries[o].longitude+","+r._boundaries[o].latitude+"]",n+=",",o===r._boundaries.length-1&&(n=n+"["+r._boundaries[0].longitude+","+r._boundaries[0].latitude+"]");return n+="]",n+="]",n+="}"},exportPath:function(r){if(!(r instanceof WorldWind.Path))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportPath","invalidTypeOfRenderable"));var n="{";n=n+'"'+e.FIELD_TYPE+'":"'+e.TYPE_LINE_STRING+'",',n=n+'"'+e.FIELD_COORDINATES+'":[';for(var o=0;o<r.positions.length;o++)n=n+"["+r.positions[o].longitude+","+r.positions[o].latitude+","+r.positions[o].altitude+"]",o!==r.positions.length-1&&(n+=",");return n+="]",n+="}"},exportPolygon:function(r){if(!(r instanceof WorldWind.Polygon))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONExporter","exportPolygon","invalidTypeOfRenderable"));var n="{";if(n=n+'"'+e.FIELD_TYPE+'":"'+e.TYPE_POLYGON+'",',n=n+'"'+e.FIELD_COORDINATES+'":[',r.boundaries.length>0&&r.boundaries[0].length>2)for(var o=0;o<r.boundaries.length;o++){n+="[";for(var s=0;s<r.boundaries[o].length;s++)n=n+"["+r.boundaries[o][s].longitude+","+r.boundaries[o][s].latitude+","+r.boundaries[o][s].altitude+"]",n+=",",s===r.boundaries[o].length-1&&(n=n+"["+r.boundaries[o][0].longitude+","+r.boundaries[o][0].latitude+","+r.boundaries[o][0].altitude+"]");n+="]",o!==r.boundaries.length-1&&(n+=",")}else{n+="[";for(var o=0;o<r.boundaries.length;o++)n=n+"["+r.boundaries[o].longitude+","+r.boundaries[o].latitude+","+r.boundaries[o].altitude+"]",n+=",",o===r.boundaries.length-1&&(n=n+"["+r.boundaries[0].longitude+","+r.boundaries[0].latitude+","+r.boundaries[0].altitude+"]");n+="]"}return n+="]",n+="}"}};return r}),i("formats/geojson/GeoJSONGeometry",["../../error/ArgumentError","./GeoJSONConstants","../../util/Logger"],function(t,e,i){"use strict";var r=function(e,r,n){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometry","constructor","missingCoordinates"));if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometry","constructor","missingType"));this._coordinates=e,this._type=r,this._bbox=n?n:null};return Object.defineProperties(r.prototype,{coordinates:{get:function(){return this._coordinates}},type:{get:function(){return this._type}},bbox:{get:function(){return this._bbox}}}),r.prototype.isPointType=function(){return this.type===e.TYPE_POINT},r.prototype.isMultiPointType=function(){return this.type===e.TYPE_MULTI_POINT},r.prototype.isLineStringType=function(){return this.type===e.TYPE_LINE_STRING},r.prototype.isMultiLineStringType=function(){return this.type===e.TYPE_MULTI_LINE_STRING},r.prototype.isPolygonType=function(){return this.type===e.TYPE_POLYGON},r.prototype.isMultiPolygonType=function(){return this.type===e.TYPE_MULTI_POLYGON},r}),i("formats/geojson/GeoJSONGeometryCollection",["../../error/ArgumentError","./GeoJSONConstants","../../util/Logger"],function(t,e,i){"use strict";var r=function(e,r){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryCollection","constructor","missingGeometries"));if("[object Array]"!==Object.prototype.toString.call(e))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryCollection","constructor","invalidGeometries"));this._geometries=e,this._bbox=r};return Object.defineProperties(r.prototype,{geometries:{get:function(){return this._geometries}},bbox:{get:function(){return this._bbox}}}),r}),i("formats/geojson/GeoJSONGeometryLineString",["../../error/ArgumentError","./GeoJSONGeometry","../../util/Logger"],function(t,e,i){"use strict";var r=function(r,n,o){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryLineString","constructor","missingCoordinates"));if(r.length<2||r[0].length<2)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryLineString","constructor","invalidNumberOfCoordinates"));if("[object Array]"!==Object.prototype.toString.call(r[0])||"[object Number]"!==Object.prototype.toString.call(r[0][0]))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryLineString","constructor","invalidCoordinatesType"));if(!n)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryLineString","constructor","missingType"));e.call(this,r,n,o)};return r.prototype=Object.create(e.prototype),r}),i("formats/geojson/GeoJSONGeometryMultiLineString",["../../error/ArgumentError","./GeoJSONGeometry","../../util/Logger"],function(t,e,i){"use strict";var r=function(r,n,o){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryMultiLineString","constructor","missingCoordinates"));if(r[0].length<2||r[0][0].length<2)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryMultiLineString","constructor","invalidNumberOfCoordinates"));if("[object Array]"!==Object.prototype.toString.call(r[0])||"[object Array]"!==Object.prototype.toString.call(r[0][0])||"[object Number]"!==Object.prototype.toString.call(r[0][0][0]))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryMultiLineString","constructor","invalidCoordinatesType"));if(!n)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryLineString","constructor","missingType"));e.call(this,r,n,o)};return r.prototype=Object.create(e.prototype),r}),i("formats/geojson/GeoJSONGeometryMultiPoint",["../../error/ArgumentError","./GeoJSONGeometry","../../util/Logger"],function(t,e,i){"use strict";var r=function(r,n,o){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryMultiPoint","constructor","missingCoordinates"));if(r[0].length<2)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryMultiPoint","constructor","invalidNumberOfCoordinates"));if("[object Array]"!==Object.prototype.toString.call(r[0])||"[object Number]"!==Object.prototype.toString.call(r[0][0]))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryMultiPoint","constructor","invalidCoordinatesType"));if(!n)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPoint","constructor","missingType"));e.call(this,r,n,o)};return r.prototype=Object.create(e.prototype),r}),i("formats/geojson/GeoJSONGeometryMultiPolygon",["../../error/ArgumentError","./GeoJSONGeometry","../../util/Logger"],function(t,e,i){"use strict";var r=function(r,n,o){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryMultiPolygon","constructor","missingCoordinates"));if("[object Array]"!==Object.prototype.toString.call(r[0])||"[object Array]"!==Object.prototype.toString.call(r[0][0])||"[object Array]"!==Object.prototype.toString.call(r[0][0][0])||"[object Number]"!==Object.prototype.toString.call(r[0][0][0][0]))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPolygon","constructor","invalidCoordinatesType"));if(!n)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPolygon","constructor","missingType"));e.call(this,r,n,o)};return r.prototype=Object.create(e.prototype),r}),i("formats/geojson/GeoJSONGeometryPoint",["../../error/ArgumentError","./GeoJSONGeometry","../../util/Logger"],function(t,e,i){"use strict";var r=function(r,n,o){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPoint","constructor","missingCoordinates"));if(r.length<2)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPoint","constructor","invalidNumberOfCoordinates"));if("[object Array]"!==Object.prototype.toString.call(r)||"[object Number]"!==Object.prototype.toString.call(r[0]))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPoint","constructor","invalidCoordinatesType"));if(!n)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPoint","constructor","missingType"));e.call(this,r,n,o)};return r.prototype=Object.create(e.prototype),r}),i("formats/geojson/GeoJSONGeometryPolygon",["../../error/ArgumentError","./GeoJSONGeometry","../../util/Logger"],function(t,e,i){"use strict";var r=function(r,n,o){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPolygon","constructor","missingCoordinates"));if(r[0].length<2||r[0][0].length<2)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPolygon","constructor","invalidNumberOfCoordinates"));if("[object Array]"!==Object.prototype.toString.call(r[0])||"[object Array]"!==Object.prototype.toString.call(r[0][0])||"[object Number]"!==Object.prototype.toString.call(r[0][0][0]))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPolygon","constructor","invalidCoordinatesType"));for(var s=0;s<r.length;s++)if(r[s][0][0]!==r[s][r[s].length-1][0]||r[s][0][1]!==r[s][r[s].length-1][1])throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPolygon","constructor","invalidLinearRing"));if(!n)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONGeometryPolygon","constructor","missingType"));e.call(this,r,n,o)};return r.prototype=Object.create(e.prototype),r}),i("formats/geojson/GeoJSONCRS",["../../error/ArgumentError","./GeoJSONConstants","../../util/Logger","../../util/proj4-src"],function(t,e,i,r){"use strict";var n=function(e,r){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONCRS","constructor","missingType"));if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONCRS","constructor","missingProperties"));this._type=e,this._properties=r,this._projectionString=null};return Object.defineProperties(n.prototype,{type:{get:function(){return this._type}},properties:{get:function(){return this._properties}},projectionString:{get:function(){return this._projectionString}}}),n.prototype.isDefault=function(){return!(!this.isNamed()||this._projectionString!==e.EPSG4326_CRS&&this._projectionString!==e.WGS84_CRS)},n.prototype.isNamed=function(){return this._type===e.FIELD_CRS_NAME},n.prototype.isLinked=function(){return this._type===e.FIELD_CRS_LINK},n.prototype.isCRSSupported=function(){try{r(this._projectionString,e.EPSG4326_CRS)}catch(t){return i.log(i.LEVEL_WARNING,"Unknown GeoJSON coordinate reference system ("+t+"): "+this._properties.name),!1}return!0},n.prototype.getLinkedCRSString=function(t,e){var r=new XMLHttpRequest;r.open("GET",t,!0),r.responseType="text",r.onreadystatechange=function(){4===r.readyState&&(200===r.status?(this._projectionString=r.response,e()):i.log(i.LEVEL_WARNING,"GeoJSON Linked CRS retrieval failed ("+r.statusText+"): "+t))}.bind(this),r.onerror=function(){i.log(i.LEVEL_WARNING,"GeoJSON Linked CRS retrieval failed: "+t)},r.ontimeout=function(){i.log(i.LEVEL_WARNING,"GeoJSON Linked CRS retrieval timed out: "+t)},r.send(null)},n.prototype.setCRSString=function(t){this.isNamed()?(this._projectionString=this._properties.name,t()):this.isLinked()&&this.getLinkedCRSString(this._properties.href,t)},n}),i("formats/geojson/GeoJSONFeature",["../../error/ArgumentError","./GeoJSONConstants","../../util/Logger"],function(t,e,i){"use strict";var r=function(r,n,o,s){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONFeature","constructor","missingGeometry"));if(!r[e.FIELD_TYPE])throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONFeature","constructor","missingFeatureGeometryType"));if(!n)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONFeature","constructor","missingProperties"));this._geometry=r,this._properties=n,this._id=o,this._bbox=s};return Object.defineProperties(r.prototype,{geometry:{get:function(){return this._geometry}},properties:{get:function(){return this._properties}},id:{get:function(){return this._id}},bbox:{get:function(){return this._bbox}}}),r}),i("formats/geojson/GeoJSONFeatureCollection",["../../error/ArgumentError","./GeoJSONConstants","../../util/Logger"],function(t,e,i){"use strict";var r=function(e,r,n){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONFeatureCollection","constructor","missingFeatures"));if("[object Array]"!==Object.prototype.toString.call(e))throw new t(i.logMessage(i.LEVEL_SEVERE,"GeoJSONFeatureCollection","constructor","invalidFeatures"));this._properties=r,this._features=e,this._bbox=n};return Object.defineProperties(r.prototype,{features:{get:function(){return this._features}},properties:{get:function(){return this._properties}},bbox:{get:function(){return this._bbox}}}),r}),i("shapes/PlacemarkAttributes",["../util/Color","../util/Font","../util/Offset","../shapes/ShapeAttributes","../shapes/TextAttributes"],function(t,e,i,r,n){"use strict";var o=function(e){this._imageColor=e?e._imageColor.clone():t.WHITE.clone(),this._imageOffset=e?e._imageOffset:new i(WorldWind.OFFSET_FRACTION,.5,WorldWind.OFFSET_FRACTION,.5),this._imageScale=e?e._imageScale:1,this._imageSource=e?e._imageSource:null,this._depthTest=!e||e._depthTest,this._labelAttributes=e?e._labelAttributes:new n(null),this._drawLeaderLine=!!e&&e._drawLeaderLine,this._leaderLineAttributes=e?e._leaderLineAttributes:new r(null),this.stateKeyInvalid=!0};return o.prototype.computeStateKey=function(){return"ic "+this._imageColor.toHexString(!0)+" io "+this._imageOffset.toString()+" is "+this._imageScale+" ip "+this._imageSource+" dt "+this._depthTest+" la "+this._labelAttributes.stateKey+" dll "+this._drawLeaderLine+" lla "+this._leaderLineAttributes.stateKey},Object.defineProperties(o.prototype,{stateKey:{get:function(){return this.stateKeyInvalid&&(this._stateKey=this.computeStateKey(),this.stateKeyInvalid=!1),this._stateKey}},imageColor:{get:function(){return this._imageColor},set:function(t){this._imageColor=t,this.stateKeyInvalid=!0}},imageOffset:{get:function(){return this._imageOffset},set:function(t){this._imageOffset=t,this.stateKeyInvalid=!0}},imageScale:{get:function(){return this._imageScale},set:function(t){this._imageScale=t,this.stateKeyInvalid=!0}},imageSource:{get:function(){return this._imageSource},set:function(t){this._imageSource=t,this.stateKeyInvalid=!0}},depthTest:{get:function(){return this._depthTest},set:function(t){this._depthTest=t,this.stateKeyInvalid=!0}},labelAttributes:{get:function(){return this._labelAttributes},set:function(t){this._labelAttributes=t,this.stateKeyInvalid=!0}},drawLeaderLine:{get:function(){return this._drawLeaderLine},set:function(t){this._drawLeaderLine=t,this.stateKeyInvalid=!0}},leaderLineAttributes:{get:function(){return this._leaderLineAttributes},set:function(t){this._leaderLineAttributes=t,this.stateKeyInvalid=!0}}}),o}),i("shapes/Placemark",["../error/ArgumentError","../shaders/BasicTextureProgram","../util/Color","../util/Font","../util/Logger","../geom/Matrix","../pick/PickedObject","../shapes/PlacemarkAttributes","../render/Renderable","../geom/Vec2","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o,s,a,l,h,u,c){"use strict";var d=function(e,i,r){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"Placemark","constructor","missingPosition"));l.call(this),this.attributes=r?r:new a(null),this.highlightAttributes=null,this.highlighted=!1,this.position=e,this.eyeDistanceScaling=i,this.eyeDistanceScalingThreshold=1e6,this.eyeDistanceScalingLabelThreshold=1.5*this.eyeDistanceScalingThreshold,this.label=null,this.altitudeMode=WorldWind.ABSOLUTE,this.alwaysOnTop=!1,this.enableLeaderLinePicking=!1,this.updateImage=!0,this.declutterGroup=2,this.targetVisibility=1,this.currentVisibility=1,this.imageRotation=0,this.imageTilt=0,this.imageRotationReference=WorldWind.RELATIVE_TO_SCREEN,this.imageTiltReference=WorldWind.RELATIVE_TO_SCREEN,this.activeAttributes=null,this.activeTexture=null,this.labelTexture=null,this.placePoint=new u(0,0,0),this.groundPoint=new u(0,0,0),this.imageTransform=o.fromIdentity(),this.labelTransform=o.fromIdentity(),this.texCoordMatrix=o.fromIdentity(),this.imageBounds=null,this.layer=null,this.depthOffset=-.003};return d.screenPoint=new u(0,0,0),d.matrix=o.fromIdentity(),d.scratchPoint=new u(0,0,0),d.prototype=Object.create(l.prototype),Object.defineProperties(d.prototype,{screenBounds:{get:function(){return this.labelBounds}}}),d.prototype.copy=function(t){return this.position=t.position,this.attributes=t.attributes,this.highlightAttributes=t.highlightAttributes,this.highlighted=t.highlighted,this.enabled=t.enabled,this.label=t.label,this.altitudeMode=t.altitudeMode,this.pickDelegate=t.pickDelegate,this.alwaysOnTop=t.alwaysOnTop,this.depthOffset=t.depthOffset,this.targetVisibility=t.targetVisibility,this.currentVisibility=t.currentVisibility,this.imageRotation=t.imageRotation,this.imageTilt=t.imageTilt,this.imageRotationReference=t.imageRotationReference,this.imageTiltReference=t.imageTiltReference,this},d.prototype.clone=function(){var t=new d(this.position);return t.copy(this),t.pickDelegate=this.pickDelegate?this.pickDelegate:this,t},d.prototype.render=function(t){if(this.enabled&&t.accumulateOrderedRenderables&&(!t.globe.projectionLimits||t.globe.projectionLimits.containsLocation(this.position.latitude,this.position.longitude))){var e;if(this.lastFrameTime!==t.timestamp)e=this.makeOrderedRenderable(t);else{var i=this.clone();e=i.makeOrderedRenderable(t)}e&&e.isVisible(t)&&(e.layer=t.currentLayer,this.lastFrameTime=t.timestamp,t.addOrderedRenderable(e))}},d.prototype.renderOrdered=function(t){if(this.drawOrderedPlacemark(t),t.pickingMode){var e=new s(this.pickColor.clone(),this.pickDelegate?this.pickDelegate:this,this.position,this.layer,!1);t.pickPoint&&this.mustDrawLabel()&&this.labelBounds.containsPoint(t.convertPointToViewport(t.pickPoint,d.scratchPoint))&&(e.labelPicked=!0),t.resolvePick(e)}},d.prototype.makeOrderedRenderable=function(t){var e,i,r,n;if(this.determineActiveAttributes(t),!this.activeAttributes)return null;if(t.surfacePointForMode(this.position.latitude,this.position.longitude,this.position.altitude,this.altitudeMode,this.placePoint),this.eyeDistance=this.alwaysOnTop?0:t.eyePoint.distanceTo(this.placePoint),this.mustDrawLeaderLine(t)&&t.surfacePointForMode(this.position.latitude,this.position.longitude,0,this.altitudeMode,this.groundPoint),!t.projectWithDepth(this.placePoint,this.depthOffset,d.screenPoint))return null;var o=this.eyeDistanceScaling?Math.max(0,Math.min(1,this.eyeDistanceScalingThreshold/this.eyeDistance)):1;return this.activeTexture?(e=this.activeTexture.originalImageWidth,i=this.activeTexture.originalImageHeight,r=this.activeAttributes.imageScale*o,n=this.activeAttributes.imageOffset.offsetForSize(e,i),this.imageTransform.setTranslation(d.screenPoint[0]-n[0]*r,d.screenPoint[1]-n[1]*r,d.screenPoint[2]),this.imageTransform.setScale(e*r,i*r,1)):(r=this.activeAttributes.imageScale*o,n=this.activeAttributes.imageOffset.offsetForSize(r,r),this.imageTransform.setTranslation(d.screenPoint[0]-n[0],d.screenPoint[1]-n[1],d.screenPoint[2]),this.imageTransform.setScale(r,r,1)),this.imageBounds=c.boundingRectForUnitQuad(this.imageTransform),this.mustDrawLabel()&&(this.labelTexture=t.createTextTexture(this.label,this.activeAttributes.labelAttributes),e=this.labelTexture.imageWidth,i=this.labelTexture.imageHeight,r=this.activeAttributes.labelAttributes.scale*o,n=this.activeAttributes.labelAttributes.offset.offsetForSize(e,i),this.labelTransform.setTranslation(d.screenPoint[0]-n[0]*r,d.screenPoint[1]-n[1]*r,d.screenPoint[2]),this.labelTransform.setScale(e*r,i*r,1),this.labelBounds=c.boundingRectForUnitQuad(this.labelTransform)),this},d.prototype.determineActiveAttributes=function(t){this.highlighted&&this.highlightAttributes?this.activeAttributes=this.highlightAttributes:this.activeAttributes=this.attributes,this.activeAttributes&&this.activeAttributes.imageSource&&(this.activeTexture=t.gpuResourceCache.resourceForKey(this.activeAttributes.imageSource),this.activeTexture&&!this.updateImage||(this.activeTexture=t.gpuResourceCache.retrieveTexture(t.currentGlContext,this.activeAttributes.imageSource),this.updateImage=!1))},d.prototype.isVisible=function(t){return t.pickingMode?t.pickRectangle&&(this.imageBounds.intersects(t.pickRectangle)||this.mustDrawLabel()&&this.labelBounds.intersects(t.pickRectangle)||this.mustDrawLeaderLine(t)&&t.pickFrustum.intersectsSegment(this.groundPoint,this.placePoint)):this.imageBounds.intersects(t.viewport)||this.mustDrawLabel()&&this.labelBounds.intersects(t.viewport)||this.mustDrawLeaderLine(t)&&t.frustumInModelCoordinates.intersectsSegment(this.groundPoint,this.placePoint)},d.prototype.drawOrderedPlacemark=function(t){this.beginDrawing(t);try{this.doDrawOrderedPlacemark(t),t.pickingMode||this.drawBatchOrderedPlacemarks(t)}finally{this.endDrawing(t)}},d.prototype.drawBatchOrderedPlacemarks=function(t){for(var e;(e=t.peekOrderedRenderable())&&e.doDrawOrderedPlacemark;){t.popOrderedRenderable();try{e.doDrawOrderedPlacemark(t)}catch(t){n.logMessage(n.LEVEL_WARNING,"Placemark","drawBatchOrderedPlacemarks","Error occurred while rendering placemark using batching: "+t.message)}}},d.prototype.beginDrawing=function(t){var i,r=t.currentGlContext;t.findAndBindProgram(e),i=t.currentProgram,r.bindBuffer(r.ARRAY_BUFFER,t.unitQuadBuffer()),r.vertexAttribPointer(i.vertexTexCoordLocation,2,r.FLOAT,!1,0,0),r.enableVertexAttribArray(i.vertexPointLocation),r.enableVertexAttribArray(i.vertexTexCoordLocation),i.loadTextureUnit(r,r.TEXTURE0),i.loadModulateColor(r,t.pickingMode)},d.prototype.endDrawing=function(t){var e=t.currentGlContext,i=t.currentProgram;e.disableVertexAttribArray(i.vertexPointLocation),e.disableVertexAttribArray(i.vertexTexCoordLocation),e.bindBuffer(e.ARRAY_BUFFER,null),e.bindTexture(e.TEXTURE_2D,null)},d.prototype.doDrawOrderedPlacemark=function(t){var e,r=t.currentGlContext,n=t.currentProgram,o=!0;if(t.pickingMode&&(this.pickColor=t.uniquePickColor()),this.eyeDistanceScaling&&this.eyeDistance>this.eyeDistanceScalingLabelThreshold&&(this.targetVisibility=0),!t.pickingMode&&this.mustDrawLabel()&&this.currentVisibility!=this.targetVisibility){var s=(t.timestamp-t.previousRedrawTimestamp)/t.fadeTime;this.currentVisibility<this.targetVisibility?this.currentVisibility=Math.min(1,this.currentVisibility+s):this.currentVisibility=Math.max(0,this.currentVisibility-s),t.redrawRequested=!0}if(n.loadOpacity(r,t.pickingMode?1:this.layer.opacity),this.mustDrawLeaderLine(t)){this.leaderLinePoints||(this.leaderLinePoints=new Float32Array(6)),this.leaderLinePoints[0]=this.groundPoint[0],this.leaderLinePoints[1]=this.groundPoint[1],this.leaderLinePoints[2]=this.groundPoint[2],this.leaderLinePoints[3]=this.placePoint[0],this.leaderLinePoints[4]=this.placePoint[1],this.leaderLinePoints[5]=this.placePoint[2],this.leaderLineCacheKey||(this.leaderLineCacheKey=t.gpuResourceCache.generateCacheKey());var a=t.gpuResourceCache.resourceForKey(this.leaderLineCacheKey);a||(a=r.createBuffer(),t.gpuResourceCache.putResource(this.leaderLineCacheKey,a,4*this.leaderLinePoints.length)),n.loadTextureEnabled(r,!1),n.loadColor(r,t.pickingMode?this.pickColor:this.activeAttributes.leaderLineAttributes.outlineColor),d.matrix.copy(t.modelviewProjection),n.loadModelviewProjection(r,d.matrix),this.activeAttributes.leaderLineAttributes.depthTest||r.disable(r.DEPTH_TEST),r.lineWidth(this.activeAttributes.leaderLineAttributes.outlineWidth),r.bindBuffer(r.ARRAY_BUFFER,a),r.bufferData(r.ARRAY_BUFFER,this.leaderLinePoints,r.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1),r.vertexAttribPointer(n.vertexPointLocation,3,r.FLOAT,!1,0,0),r.drawArrays(r.LINES,0,2)}this.activeAttributes.depthTest||(o=!1,r.disable(r.DEPTH_TEST)),r.bindBuffer(r.ARRAY_BUFFER,t.unitQuadBuffer3()),r.vertexAttribPointer(n.vertexPointLocation,3,r.FLOAT,!1,0,0),d.matrix.copy(t.screenProjection),d.matrix.multiplyMatrix(this.imageTransform);var l=this.imageRotationReference===WorldWind.RELATIVE_TO_GLOBE?t.navigator.heading-this.imageRotation:-this.imageRotation;d.matrix.multiplyByTranslation(.5,.5,0),d.matrix.multiplyByRotation(0,0,1,l),d.matrix.multiplyByTranslation(-.5,-.5,0);var h=this.imageTiltReference===WorldWind.RELATIVE_TO_GLOBE?t.navigator.tilt+this.imageTilt:this.imageTilt;d.matrix.multiplyByRotation(-1,0,0,h),
n.loadModelviewProjection(r,d.matrix),n.loadTextureEnabled(r,!0),t.pickingMode?n.loadColor(r,this.pickColor):n.loadColor(r,this.activeAttributes.imageColor),this.texCoordMatrix.setToIdentity(),this.activeTexture&&this.texCoordMatrix.multiplyByTextureTransform(this.activeTexture),n.loadTextureMatrix(r,this.texCoordMatrix),this.activeTexture?(e=this.activeTexture.bind(t),n.loadTextureEnabled(r,e)):n.loadTextureEnabled(r,!1),r.drawArrays(r.TRIANGLE_STRIP,0,4),this.mustDrawLabel()&&this.currentVisibility>0&&(n.loadOpacity(r,t.pickingMode?1:this.layer.opacity*this.currentVisibility),d.matrix.copy(t.screenProjection),d.matrix.multiplyMatrix(this.labelTransform),n.loadModelviewProjection(r,d.matrix),!t.pickingMode&&this.labelTexture?(this.texCoordMatrix.setToIdentity(),this.texCoordMatrix.multiplyByTextureTransform(this.labelTexture),n.loadTextureMatrix(r,this.texCoordMatrix),n.loadColor(r,i.WHITE),e=this.labelTexture.bind(t),n.loadTextureEnabled(r,e)):(n.loadTextureEnabled(r,!1),n.loadColor(r,this.pickColor)),this.activeAttributes.labelAttributes.depthTest?o||(o=!0,r.enable(r.DEPTH_TEST)):(o=!1,r.disable(r.DEPTH_TEST)),r.drawArrays(r.TRIANGLE_STRIP,0,4)),o||r.enable(r.DEPTH_TEST)},d.prototype.mustDrawLabel=function(){return this.label&&this.label.length>0&&this.activeAttributes.labelAttributes},d.prototype.mustDrawLeaderLine=function(t){return this.activeAttributes.drawLeaderLine&&this.activeAttributes.leaderLineAttributes&&(!t.pickingMode||this.enableLeaderLinePicking)},d.prototype.getReferencePosition=function(){return this.position},d.prototype.moveTo=function(t,e){this.position=e},d}),i("shapes/Polygon",["../shapes/AbstractShape","../error/ArgumentError","../shaders/BasicTextureProgram","../geom/BoundingBox","../util/Color","../util/ImageSource","../geom/Location","../util/Logger","../geom/Matrix","../pick/PickedObject","../geom/Position","../shapes/ShapeAttributes","../shapes/SurfacePolygon","../geom/Vec2","../geom/Vec3","../util/libtess"],function(t,e,i,n,o,s,a,l,h,u,c,d,p,f,g,m){"use strict";var y=function(i,r){if(!i)throw new e(l.logMessage(l.LEVEL_SEVERE,"Polygon","constructor","missingBoundaries"));t.call(this,r),i.length>0&&i[0].latitude&&(i=[i],this._boundariesSpecifiedSimply=!0),this._boundaries=i,this._textureCoordinates=null,this.referencePosition=this.determineReferencePosition(this._boundaries),this._extrude=!1,this.scratchPoint=new g(0,0,0)};return y.prototype=Object.create(t.prototype),Object.defineProperties(y.prototype,{boundaries:{get:function(){return this._boundariesSpecifiedSimply?this._boundaries[0]:this._boundaries},set:function(t){if(!t)throw new e(l.logMessage(l.LEVEL_SEVERE,"Polygon","boundaries","missingBoundaries"));t.length>0&&t[0].latitude&&(t=[t],this._boundariesSpecifiedSimply=!0),this._boundaries=t,this.referencePosition=this.determineReferencePosition(this._boundaries),this.reset()}},textureCoordinates:{get:function(){return this._textureCoordinates},set:function(t){this._textureCoordinates=t,this.reset()}},extrude:{get:function(){return this._extrude},set:function(t){this._extrude=t,this.reset()}}}),y.prototype.determineReferencePosition=function(t){return t.length>0&&t[0].length>2?t[0][0]:null},y.prototype.mustGenerateGeometry=function(t){return!this.currentData.boundaryPoints||(this.currentData.drawInterior!==this.activeAttributes.drawInterior||this.altitudeMode!==WorldWind.ABSOLUTE&&this.currentData.isExpired)},y.prototype.hasCapTexture=function(){return this.textureCoordinates&&this.capImageSource()},y.prototype.capImageSource=function(){return this.activeAttributes.imageSource?"string"==typeof this.activeAttributes.imageSource||this.activeAttributes.imageSource instanceof s?this.activeAttributes.imageSource:Array.isArray(this.activeAttributes.imageSource)&&this.activeAttributes.imageSource[0]&&("string"==typeof this.activeAttributes.imageSource[0]||this.activeAttributes.imageSource instanceof s)?this.activeAttributes.imageSource[0]:null:null},y.prototype.hasSideTextures=function(){return this.activeAttributes.imageSource&&Array.isArray(this.activeAttributes.imageSource)&&this.activeAttributes.imageSource.length>1},y.prototype.sideImageSource=function(t){if(0===t||2===this.activeAttributes.imageSource.length)return this.activeAttributes.imageSource[1];var e=this.activeAttributes.imageSource.length-1;return t=Math.min(t+1,e),this.activeAttributes.imageSource[t]},y.prototype.createSurfaceShape=function(){return new p(this.boundaries,null)},y.prototype.doMakeOrderedRenderable=function(t){if(!this.referencePosition)return null;if(!this.activeAttributes.drawInterior&&!this.activeAttributes.drawOutline)return null;if(!this.mustGenerateGeometry(t))return this;var e=this.currentData,i=e.referencePoint;t.surfacePointForMode(this.referencePosition.latitude,this.referencePosition.longitude,this.referencePosition.altitude,this._altitudeMode,i),e.transformationMatrix.setToTranslation(i[0],i[1],i[2]);for(var r=[],o=0;o<this._boundaries.length;o++)r[o]=this._boundaries[o].slice(0),r[o].push(this._boundaries[o][0]);var s=this.computeBoundaryPoints(t,r);if(this.activeAttributes.drawInterior){var a=this.tessellatePolygon(t,s);if(a){e.capTriangles=new Float32Array(a.length);for(var l=0,h=a.length;l<h;l++)e.capTriangles[l]=a[l]}}if(e.boundaryPoints=s,e.drawInterior=this.activeAttributes.drawInterior,this.resetExpiration(e),e.refreshBuffers=!0,e.extent||(e.extent=new n),1===s.length)e.extent.setToPoints(s[0]);else{var u=[];for(o=0;o<s.length;o++)for(var c=0;c<s[o].length;c++)u.push(s[o][c]);e.extent.setToPoints(u)}return e.extent.translate(e.referencePoint),this},y.prototype.computeBoundaryPoints=function(t,e){for(var i,r,n,o,s=Number.MAX_VALUE,a=t.eyePoint,l=[],h=this._extrude?6:3,u=new g(0,0,0),c=0;c<e.length;c++){i=(this._extrude?2:1)*e[c].length,l[c]=new Float32Array(3*i);for(var d=0,p=e[c].length;d<p;d++)r=e[c][d],t.surfacePointForMode(r.latitude,r.longitude,r.altitude,this.altitudeMode,u),o=u.distanceToSquared(a),o<s&&(s=o),u.subtract(this.currentData.referencePoint),n=h*d,l[c][n]=u[0],l[c][n+1]=u[1],l[c][n+2]=u[2],this._extrude&&(t.surfacePointForMode(r.latitude,r.longitude,0,WorldWind.CLAMP_TO_GROUND,u),o=u.distanceToSquared(a),o<s&&(s=o),u.subtract(this.currentData.referencePoint),l[c][n+3]=u[0],l[c][n+4]=u[1],l[c][n+5]=u[2])}return this.currentData.eyeDistance=0,l},y.prototype.tessellatePolygon=function(t,e){var i,n,o=[],s=0,a=this._extrude?6:3,h=this.hasCapTexture();this.polygonTessellator||(this.polygonTessellator=new r.GluTesselator,this.polygonTessellator.gluTessCallback(r.gluEnum.GLU_TESS_VERTEX_DATA,function(t,e){e[e.length]=t[0],e[e.length]=t[1],e[e.length]=t[2],h&&(e[e.length]=t[3],e[e.length]=t[4])}),this.polygonTessellator.gluTessCallback(r.gluEnum.GLU_TESS_COMBINE,function(t,e,i){var r=[t[0],t[1],t[2]];if(h)for(var n=3;n<=4;n++){for(var o=0,s=0;s<4;s++)i[s]>0&&(o+=i[s]*e[s][n]);r[n]=o}return r}),this.polygonTessellator.gluTessCallback(r.gluEnum.GLU_TESS_ERROR,function(t){s=t,l.logMessage(l.LEVEL_WARNING,"Polygon","tessellatePolygon","Tessellation error "+t+".")})),n=g.computeBufferNormal(e[0],a),n||(n=new g(0,0,0),t.globe.surfaceNormalAtLocation(this.referencePosition.latitude,this.referencePosition.longitude,n)),this.polygonTessellator.gluTessNormal(n[0],n[1],n[2]),this.currentData.capNormal=n,this.polygonTessellator.gluTessBeginPolygon(o);for(var u=0;u<e.length;u++){var c=0;this.polygonTessellator.gluTessBeginContour();for(var d=e[u],p=0;p<d.length;p+=a)i=[d[p],d[p+1],d[p+2]],h&&(c<this.textureCoordinates[u].length?(i[3]=this.textureCoordinates[u][c][0],i[4]=this.textureCoordinates[u][c][1]):(i[3]=this.textureCoordinates[u][0][0],i[4]=this.textureCoordinates[u][1][1]),++c),this.polygonTessellator.gluTessVertex(i,i);this.polygonTessellator.gluTessEndContour()}return this.polygonTessellator.gluTessEndPolygon(),0===s?o:null},y.prototype.mustDrawVerticals=function(t){return this._extrude&&this.activeAttributes.drawOutline&&this.activeAttributes.drawVerticals&&this.altitudeMode!==WorldWind.CLAMP_TO_GROUND},y.prototype.doRenderOrdered=function(t){var e,i=this.currentData;if(t.pickingMode&&(e=t.uniquePickColor()),this.activeAttributes.drawInterior&&i.capTriangles&&i.capTriangles.length>0&&this.drawCap(t,e),this._extrude&&this.activeAttributes.drawInterior&&this.drawSides(t,e),this.activeAttributes.drawOutline&&this.drawOutline(t,e),i.refreshBuffers=!1,t.pickingMode){var r=new u(e,this.pickDelegate?this.pickDelegate:this,null,this.layer,!1);t.resolvePick(r)}},y.prototype.drawCap=function(t,e){var i,r,n,o,s,a=t.currentGlContext,l=t.currentProgram,h=this.currentData,u=h.refreshBuffers,c=!!this.hasCapTexture(),d=this.activeAttributes.applyLighting,p=h.capTriangles.length/(c?5:3);l.loadTextureEnabled(a,!1),this.applyMvpMatrix(t),h.capVboCacheKey||(h.capVboCacheKey=t.gpuResourceCache.generateCacheKey()),i=t.gpuResourceCache.resourceForKey(h.capVboCacheKey),i||(i=a.createBuffer(),t.gpuResourceCache.putResource(h.capVboCacheKey,i,4*h.capTriangles.length),u=!0),a.bindBuffer(a.ARRAY_BUFFER,i),u&&(s=d?this.makeCapBufferWithNormals():h.capTriangles,a.bufferData(a.ARRAY_BUFFER,s,a.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1)),r=this.activeAttributes.interiorColor,a.depthMask(r.alpha*this.layer.opacity>=1||t.pickingMode),l.loadColor(a,t.pickingMode?e:r),l.loadOpacity(a,t.pickingMode?1:this.layer.opacity),n=12+(c?8:0)+(d?12:0),c&&!t.pickingMode&&(this.activeTexture=t.gpuResourceCache.resourceForKey(this.capImageSource()),this.activeTexture||(this.activeTexture=t.gpuResourceCache.retrieveTexture(t.currentGlContext,this.capImageSource())),o=this.activeTexture&&this.activeTexture.bind(t),o&&(a.enableVertexAttribArray(l.vertexTexCoordLocation),a.vertexAttribPointer(l.vertexTexCoordLocation,2,a.FLOAT,!1,n,12),this.scratchMatrix.setToIdentity(),this.scratchMatrix.multiplyByTextureTransform(this.activeTexture),l.loadTextureEnabled(a,!0),l.loadTextureUnit(a,a.TEXTURE0),l.loadTextureMatrix(a,this.scratchMatrix),l.loadModulateColor(a,t.pickingMode))),d&&!t.pickingMode&&(l.loadApplyLighting(a,!0),a.enableVertexAttribArray(l.normalVectorLocation),a.vertexAttribPointer(l.normalVectorLocation,3,a.FLOAT,!1,n,n-12)),a.vertexAttribPointer(l.vertexPointLocation,3,a.FLOAT,!1,n,0),a.drawArrays(a.TRIANGLES,0,p)},y.prototype.makeCapBufferWithNormals=function(){for(var t=this.currentData,e=t.capNormal,i=this.hasCapTexture()?5:3,r=i+3,n=t.capTriangles.length/i,o=t.capTriangles,s=new Float32Array(n*r),a=0,l=0;l<n;l++){for(var h=0;h<i;h++)s[a++]=o[l*i+h];s[a++]=e[0],s[a++]=e[1],s[a++]=e[2]}return s},y.prototype.drawSides=function(t,e){var i,r,n,o,s,a=t.currentGlContext,l=t.currentProgram,h=this.currentData,u=h.refreshBuffers,c=this.hasSideTextures(),d=this.activeAttributes.applyLighting,p=3+(c?2:0)+(d?3:0),f=4*p;s=0;for(var g=0;g<h.boundaryPoints.length;g++)s+=h.boundaryPoints[g].length/6-1;if(h.sidesVboCacheKey||(h.sidesVboCacheKey=t.gpuResourceCache.generateCacheKey()),i=t.gpuResourceCache.resourceForKey(h.sidesVboCacheKey),!i||u?(o=this.makeSidesBuffer(s),h.numSideVertices=o.length/p,i||(i=a.createBuffer()),t.gpuResourceCache.putResource(h.sidesVboCacheKey,i,4*o.length),a.bindBuffer(a.ARRAY_BUFFER,i),a.bufferData(a.ARRAY_BUFFER,o,a.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1)):a.bindBuffer(a.ARRAY_BUFFER,i),r=this.activeAttributes.interiorColor,a.depthMask(r.alpha*this.layer.opacity>=1||t.pickingMode),l.loadColor(a,t.pickingMode?e:r),l.loadOpacity(a,t.pickingMode?1:this.layer.opacity),c&&!t.pickingMode){d?(l.loadApplyLighting(a,!0),a.enableVertexAttribArray(l.normalVectorLocation)):l.loadApplyLighting(a,!1);for(var m=0;m<s;m++){var y=this.sideImageSource(m),E=t.gpuResourceCache.resourceForKey(y),v=6*m*f;y&&!E&&(E=t.gpuResourceCache.retrieveTexture(t.currentGlContext,y)),n=E&&E.bind(t),n?(a.enableVertexAttribArray(l.vertexTexCoordLocation),a.vertexAttribPointer(l.vertexTexCoordLocation,2,a.FLOAT,!1,f,v+12),this.scratchMatrix.setToIdentity(),this.scratchMatrix.multiplyByTextureTransform(E),l.loadTextureEnabled(a,!0),l.loadTextureUnit(a,a.TEXTURE0),l.loadTextureMatrix(a,this.scratchMatrix)):(l.loadTextureEnabled(a,!1),a.disableVertexAttribArray(l.vertexTexCoordLocation)),d&&a.vertexAttribPointer(l.normalVectorLocation,3,a.FLOAT,!1,f,v+20),a.vertexAttribPointer(l.vertexPointLocation,3,a.FLOAT,!1,f,v),a.drawArrays(a.TRIANGLES,0,6)}}else l.loadTextureEnabled(a,!1),d&&!t.pickingMode?(l.loadApplyLighting(a,!0),a.enableVertexAttribArray(l.normalVectorLocation),a.vertexAttribPointer(l.normalVectorLocation,3,a.FLOAT,!1,f,f-12)):l.loadApplyLighting(a,!1),a.vertexAttribPointer(l.vertexPointLocation,3,a.FLOAT,!1,f,0),a.drawArrays(a.TRIANGLES,0,h.numSideVertices)},y.prototype.makeSidesBuffer=function(t){var e,i,r,n,o,s,a,l,h,u,c,d=this.currentData,p=this.hasSideTextures(),m=this.activeAttributes.applyLighting,y=3+(p?2:0)+(m?3:0);r=2*t*3*y,e=new Float32Array(r),i=0,n=new g(0,0,0),o=new g(0,0,0),s=new g(0,0,0),a=new g(0,0,0),p?(l=new f(0,1),h=new f(0,0),u=new f(1,1),c=new f(1,0)):l=h=u=c=null;for(var E=0;E<d.boundaryPoints.length;E++)for(var v,_=d.boundaryPoints[E],b=0;b<_.length-6;b+=6)n[0]=_[b],n[1]=_[b+1],n[2]=_[b+2],o[0]=_[b+3],o[1]=_[b+4],o[2]=_[b+5],s[0]=_[b+6],s[1]=_[b+7],s[2]=_[b+8],a[0]=_[b+9],a[1]=_[b+10],a[2]=_[b+11],v=m?g.computeTriangleNormal(n,o,s):null,this.addVertexToBuffer(n,l,v,e,i),i+=y,this.addVertexToBuffer(o,h,v,e,i),i+=y,this.addVertexToBuffer(s,u,v,e,i),i+=y,this.addVertexToBuffer(o,h,v,e,i),i+=y,this.addVertexToBuffer(a,c,v,e,i),i+=y,this.addVertexToBuffer(s,u,v,e,i),i+=y;return e},y.prototype.addVertexToBuffer=function(t,e,i,r,n){r[n++]=t[0],r[n++]=t[1],r[n++]=t[2],e&&(r[n++]=e[0],r[n++]=e[1]),i&&(r[n++]=i[0],r[n++]=i[1],r[n]=i[2])},y.prototype.drawOutline=function(t,e){var i,r,n,o,s,a=t.currentGlContext,l=t.currentProgram,h=this.currentData,u=h.refreshBuffers;l.loadTextureEnabled(a,!1),l.loadApplyLighting(a,!1),this.hasCapTexture()&&a.disableVertexAttribArray(l.vertexTexCoordLocation),this.activeAttributes.applyLighting&&a.disableVertexAttribArray(l.normalVectorLocation),h.boundaryVboCacheKeys||(this.currentData.boundaryVboCacheKeys=[]),this.applyMvpMatrixForOutline(t),l.loadTextureEnabled(a,!1),a.disableVertexAttribArray(l.vertexTexCoordLocation);for(var c=0;c<h.boundaryPoints.length;c++)i=h.boundaryPoints[c].length/3,h.boundaryVboCacheKeys[c]||(h.boundaryVboCacheKeys[c]=t.gpuResourceCache.generateCacheKey()),r=t.gpuResourceCache.resourceForKey(h.boundaryVboCacheKeys[c]),r||(r=a.createBuffer(),t.gpuResourceCache.putResource(h.boundaryVboCacheKeys[c],r,12*i),u=!0),a.bindBuffer(a.ARRAY_BUFFER,r),u&&(a.bufferData(a.ARRAY_BUFFER,h.boundaryPoints[c],a.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1)),n=this.activeAttributes.outlineColor,a.depthMask(n.alpha*this.layer.opacity>=1||t.pickingMode),l.loadColor(a,t.pickingMode?e:n),l.loadOpacity(a,t.pickingMode?1:this.layer.opacity),a.lineWidth(this.activeAttributes.outlineWidth),this._extrude?(o=24,s=i/2):(o=12,s=i),a.vertexAttribPointer(l.vertexPointLocation,3,a.FLOAT,!1,o,0),a.drawArrays(a.LINE_STRIP,0,s),this.mustDrawVerticals(t)&&(a.vertexAttribPointer(l.vertexPointLocation,3,a.FLOAT,!1,0,0),a.drawArrays(a.LINES,0,i-2))},y.prototype.beginDrawing=function(t){var e=t.currentGlContext;this.activeAttributes.drawInterior&&e.disable(e.CULL_FACE),t.findAndBindProgram(i),e.enableVertexAttribArray(t.currentProgram.vertexPointLocation);var r=!t.pickMode&&this.activeAttributes.applyLighting;r&&t.currentProgram.loadModelviewInverse(e,t.modelviewNormalTransform)},y.prototype.endDrawing=function(t){var e=t.currentGlContext;e.disableVertexAttribArray(t.currentProgram.vertexPointLocation),e.disableVertexAttribArray(t.currentProgram.normalVectorLocation),e.depthMask(!0),e.lineWidth(1),e.enable(e.CULL_FACE)},y}),i("shapes/SurfacePolyline",["../error/ArgumentError","../util/Logger","../shapes/ShapeAttributes","../shapes/SurfaceShape"],function(t,e,i,r){"use strict";var n=function(i,o){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"SurfacePolyline","constructor","The specified locations array is null or undefined."));r.call(this,o),this._boundaries=i,this._stateId=n.stateId++,this._isInteriorInhibited=!0};return n.prototype=Object.create(r.prototype),Object.defineProperties(n.prototype,{boundaries:{get:function(){return this._boundaries},set:function(i){if(!Array.isArray(i))throw new t(e.logMessage(e.LEVEL_SEVERE,"SurfacePolyline","set boundaries","The specified value is not an array."));this.resetBoundaries(),this._boundaries=i,this._stateId=n.stateId++,this.stateKeyInvalid=!0}}}),n.stateId=Number.MIN_SAFE_INTEGER,n.staticStateKey=function(t){var e=r.staticStateKey(t);return e+" pl "+t._stateId},n.prototype.computeStateKey=function(){return n.staticStateKey(this)},n.prototype.computeBoundaries=function(t){},n.prototype.getReferencePosition=function(){return this.boundaries.length>1?this.boundaries[0]:null},n.prototype.moveTo=function(t,e){this.boundaries=this.computeShiftedLocations(t,this.getReferencePosition(),e,this._boundaries)},n}),i("formats/geojson/GeoJSONParser",["../../error/ArgumentError","../../util/Color","./GeoJSONConstants","./GeoJSONCRS","./GeoJSONFeature","./GeoJSONFeatureCollection","./GeoJSONGeometry","./GeoJSONGeometryCollection","./GeoJSONGeometryLineString","./GeoJSONGeometryMultiLineString","./GeoJSONGeometryMultiPoint","./GeoJSONGeometryMultiPolygon","./GeoJSONGeometryPoint","./GeoJSONGeometryPolygon","../../geom/Location","../../util/Logger","../../shapes/Placemark","../../shapes/PlacemarkAttributes","../../shapes/Polygon","../../geom/Position","../../util/proj4-src","../../layer/RenderableLayer","../../shapes/ShapeAttributes","../../shapes/SurfacePolygon","../../shapes/SurfacePolyline"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_,b,w,S,L){"use strict";var T=function(e){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","constructor","missingDataSource"));this._dataSource=e,this._geoJSONObject=null,this._geoJSONType=null,this._crs=null,this._layer=null,this._parserCompletionCallback=null,this._shapeConfigurationCallback=this.defaultShapeConfigurationCallback,this.defaultPlacemarkAttributes=new y(null),this.defaultShapeAttributes=new w(null),this.setProj4jsAliases()};return Object.defineProperties(T.prototype,{dataSource:{get:function(){return this._dataSource}},geoJSONObject:{get:function(){return this._geoJSONObject}},geoJSONType:{get:function(){return this._geoJSONType}},crs:{get:function(){return this._crs}},layer:{get:function(){return this._layer}},parserCompletionCallback:{get:function(){return this._parserCompletionCallback}},shapeConfigurationCallback:{get:function(){return this._shapeConfigurationCallback}}}),T.prototype.load=function(t,e,i){t&&(this._parserCompletionCallback=t),e&&(this._shapeConfigurationCallback=e),this._layer=i||new b;var r=typeof this.dataSource;if("string"===r){var n=T.tryParseJSONString(this.dataSource);null!==n?this.handle(n):this.requestUrl(this.dataSource)}else"object"===r?this.handle(this.dataSource):g.logMessage(g.LEVEL_SEVERE,"GeoJSON","load","Unsupported data source type: "+r)},T.prototype.defaultShapeConfigurationCallback=function(t,e){var i={},r=e.name||e.Name||e.NAME;return r&&(i.name=r),t.isPointType()||t.isMultiPointType()?i.attributes=this.defaultPlacemarkAttributes:t.isLineStringType()||t.isMultiLineStringType()?i.attributes=this.defaultShapeAttributes:(t.isPolygonType()||t.isMultiPolygonType())&&(i.attributes=this.defaultShapeAttributes),i},T.prototype.requestUrl=function(t){var e=new XMLHttpRequest;e.open("GET",t,!0),e.responseType="text",e.onreadystatechange=function(){4===e.readyState&&(200===e.status?this.handle(T.tryParseJSONString(e.response)):g.log(g.LEVEL_WARNING,"GeoJSON retrieval failed ("+e.statusText+"): "+t))}.bind(this),e.onerror=function(){g.log(g.LEVEL_WARNING,"GeoJSON retrieval failed: "+t)},e.ontimeout=function(){g.log(g.LEVEL_WARNING,"GeoJSON retrieval timed out: "+t)},e.send(null)},T.prototype.handle=function(e){if(e||g.logMessage(g.LEVEL_SEVERE,"GeoJSON","handle","Invalid GeoJSON object"),this._geoJSONObject=e,"[object Array]"===Object.prototype.toString.call(this.geoJSONObject))throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","handle","invalidGeoJSONObjectLength"));if(!this.geoJSONObject.hasOwnProperty(i.FIELD_TYPE))throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","handle","missingGeoJSONType"));this.setGeoJSONType(),this.setGeoJSONCRS(),this._parserCompletionCallback&&"function"==typeof this._parserCompletionCallback&&this._parserCompletionCallback(this.layer)},T.prototype.setGeoJSONCRS=function(){if(this.geoJSONObject[i.FIELD_CRS]){this._crs=new r(this.geoJSONObject[i.FIELD_CRS][i.FIELD_TYPE],this.geoJSONObject[i.FIELD_CRS][i.FIELD_PROPERTIES]);var t=function(){this.addRenderablesForGeoJSON(this.layer)}.bind(this);this.crs.setCRSString(t)}else this.addRenderablesForGeoJSON(this.layer)},T.prototype.addRenderablesForGeoJSON=function(e){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForGeoJSON","missingLayer"));switch(this.geoJSONType){case i.TYPE_FEATURE:var r=new n(this.geoJSONObject[i.FIELD_GEOMETRY],this.geoJSONObject[i.FIELD_PROPERTIES],this.geoJSONObject[i.FIELD_ID],this.geoJSONObject[i.FIELD_BBOX]);this.addRenderablesForFeature(e,r);break;case i.TYPE_FEATURE_COLLECTION:var s=new o(this.geoJSONObject[i.FIELD_FEATURES],this.geoJSONObject[i.FIELD_PROPERTIES],this.geoJSONObject[i.FIELD_BBOX]);this.addRenderablesForFeatureCollection(e,s);break;case i.TYPE_GEOMETRY_COLLECTION:var l=new a(this.geoJSONObject[i.FIELD_GEOMETRIES],this.geoJSONObject[i.FIELD_BBOX]);this.addRenderablesForGeometryCollection(e,l,null);break;default:this.addRenderablesForGeometry(e,this.geoJSONObject,null)}},T.prototype.addRenderablesForGeometry=function(e,r,n){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForGeometry","missingLayer"));if(!r)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForGeometry","missingGeometry"));switch(r[i.FIELD_TYPE]){case i.TYPE_POINT:var o=new d(r[i.FIELD_COORDINATES],r[i.FIELD_TYPE],r[i.FIELD_BBOX]);this.addRenderablesForPoint(e,o,n?n:null);break;case i.TYPE_MULTI_POINT:var s=new u(r[i.FIELD_COORDINATES],r[i.FIELD_TYPE],r[i.FIELD_BBOX]);this.addRenderablesForMultiPoint(e,s,n?n:null);break;case i.TYPE_LINE_STRING:var a=new l(r[i.FIELD_COORDINATES],r[i.FIELD_TYPE],r[i.FIELD_BBOX]);this.addRenderablesForLineString(e,a,n?n:null);break;case i.TYPE_MULTI_LINE_STRING:var f=new h(r[i.FIELD_COORDINATES],r[i.FIELD_TYPE],r[i.FIELD_BBOX]);this.addRenderablesForMultiLineString(e,f,n?n:null);break;case i.TYPE_POLYGON:var m=new p(r[i.FIELD_COORDINATES],r[i.FIELD_TYPE],r[i.FIELD_BBOX]);this.addRenderablesForPolygon(e,m,n?n:null);break;case i.TYPE_MULTI_POLYGON:var y=new c(r[i.FIELD_COORDINATES],r[i.FIELD_TYPE],r[i.FIELD_BBOX]);this.addRenderablesForMultiPolygon(e,y,n?n:null)}},T.prototype.addRenderablesForPoint=function(e,i,r){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForPoint","missingLayer"));if(!i)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForPoint","missingGeometry"));var n=this.shapeConfigurationCallback(i,r);if(!this.crs||this.crs.isCRSSupported()){var o=i.coordinates[0],s=i.coordinates[1],a=i.coordinates[2]?i.coordinates[2]:0,l=this.getReprojectedIfRequired(s,o,this.crs),h=new v(l[1],l[0],a),u=new m(h,!1,n&&n.attributes?n.attributes:null);u.altitudeMode=WorldWind.RELATIVE_TO_GROUND,n&&n.name&&(u.label=n.name),n.highlightAttributes&&(u.highlightAttributes=n.highlightAttributes),n&&n.pickDelegate&&(u.pickDelegate=n.pickDelegate),n&&n.userProperties&&(u.userProperties=n.userProperties),n&&n.timeRange&&(u.timeRange=n.timeRange),e.addRenderable(u)}},T.prototype.addRenderablesForMultiPoint=function(e,i,r){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForMultiPoint","missingLayer"));if(!i)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForMultiPoint","missingGeometry"));var n=this.shapeConfigurationCallback(i,r);if(!this.crs||this.crs.isCRSSupported())for(var o=0,s=i.coordinates.length;o<s;o+=1){var a=i.coordinates[o][0],l=i.coordinates[o][1],h=i.coordinates[o][2]?i.coordinates[o][2]:0,u=this.getReprojectedIfRequired(l,a,this.crs),c=new v(u[1],u[0],h),d=new m(c,!1,n&&n.attributes?n.attributes:null);d.altitudeMode=WorldWind.RELATIVE_TO_GROUND,n&&n.name&&(d.label=n.name),n.highlightAttributes&&(d.highlightAttributes=n.highlightAttributes),n&&n.pickDelegate&&(d.pickDelegate=n.pickDelegate),n&&n.userProperties&&(d.userProperties=n.userProperties),n&&n.timeRange&&(d.timeRange=n.timeRange),e.addRenderable(d)}},T.prototype.addRenderablesForLineString=function(e,i,r){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForLineString","missingLayer"));if(!i)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForLineString","missingGeometry"));var n=this.shapeConfigurationCallback(i,r);if(!this.crs||this.crs.isCRSSupported()){for(var o=[],s=0,a=i.coordinates;s<a.length;s++){var l=a[s][0],h=a[s][1],u=this.getReprojectedIfRequired(h,l,this.crs),c=new f(u[1],u[0]);o.push(c)}var d;d=new L(o,n&&n.attributes?n.attributes:null),n.highlightAttributes&&(d.highlightAttributes=n.highlightAttributes),n&&n.name&&(d.displayName=n.name),n&&n.pickDelegate&&(d.pickDelegate=n.pickDelegate),n&&n.userProperties&&(d.userProperties=n.userProperties),n&&n.timeRange&&(d.timeRange=n.timeRange),e.addRenderable(d)}},T.prototype.addRenderablesForMultiLineString=function(e,i,r){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForMultiLineString","missingLayer"));if(!i)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForMultiLineString","missingGeometry"));var n=this.shapeConfigurationCallback(i,r);if(!this.crs||this.crs.isCRSSupported())for(var o=0,s=i.coordinates;o<s.length;o++){for(var a=[],l=0,h=s[o];l<h.length;l++){var u=h[l][0],c=h[l][1],d=this.getReprojectedIfRequired(c,u,this.crs),p=new f(d[1],d[0]);a.push(p)}var m;m=new L(a,n&&n.attributes?n.attributes:null),n.highlightAttributes&&(m.highlightAttributes=n.highlightAttributes),n&&n.name&&(m.displayName=n.name),n&&n.pickDelegate&&(m.pickDelegate=n.pickDelegate),n&&n.userProperties&&(m.userProperties=n.userProperties),n&&n.timeRange&&(m.timeRange=n.timeRange),e.addRenderable(m)}},T.prototype.addRenderablesForPolygon=function(e,i,r){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForPolygon","missingLayer"));if(!i)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForPolygon","missingGeometry"));var n=this.shapeConfigurationCallback(i,r);if(!this.crs||this.crs.isCRSSupported()){for(var o=[],s=0,a=i.coordinates;s<a.length;s++){for(var l=[],h=0,u=a[s];h<u.length;h++){var c=u[h][0],d=u[h][1],p=this.getReprojectedIfRequired(d,c,this.crs),m=new f(p[1],p[0]);l.push(m)}o.push(l)}var y;y=new S(o,n&&n.attributes?n.attributes:null),n.highlightAttributes&&(y.highlightAttributes=n.highlightAttributes),n&&n.name&&(y.displayName=n.name),n&&n.pickDelegate&&(y.pickDelegate=n.pickDelegate),n&&n.userProperties&&(y.userProperties=n.userProperties),n&&n.timeRange&&(y.timeRange=n.timeRange),e.addRenderable(y)}},T.prototype.addRenderablesForMultiPolygon=function(e,i,r){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForMultiPolygon","missingLayer"));if(!i)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForMultiPolygon","missingGeometry"));var n=this.shapeConfigurationCallback(i,r);if(!this.crs||this.crs.isCRSSupported())for(var o=0,s=i.coordinates;o<s.length;o++){for(var a=[],l=0;l<s[o].length;l++){for(var h=[],u=0,c=s[o][l];u<c.length;u++){var d=c[u][0],p=c[u][1],m=this.getReprojectedIfRequired(p,d,this.crs),y=new f(m[1],m[0]);h.push(y)}a.push(h)}var E;E=new S(a,n&&n.attributes?n.attributes:null),n.highlightAttributes&&(E.highlightAttributes=n.highlightAttributes),n&&n.name&&(E.displayName=n.name),n&&n.pickDelegate&&(E.pickDelegate=n.pickDelegate),n&&n.userProperties&&(E.userProperties=n.userProperties),n&&n.timeRange&&(E.timeRange=n.timeRange),e.addRenderable(E)}},T.prototype.addRenderablesForGeometryCollection=function(e,r,n){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForGeometryCollection","missingLayer"));if(!r)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForGeometryCollection","missingGeometryCollection"));for(var o=0,s=r.geometries;o<s.length;o++)s[o].hasOwnProperty(i.FIELD_TYPE)&&this.addRenderablesForGeometry(e,s[o],n)},T.prototype.addRenderablesForFeature=function(e,r){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForFeature","missingLayer"));if(!r)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForFeature","missingFeature"));if(r.geometry.type===i.TYPE_GEOMETRY_COLLECTION){var n=new a(r.geometry.geometries,r.bbox);this.addRenderablesForGeometryCollection(e,n,r.properties)}else this.addRenderablesForGeometry(e,r.geometry,r.properties)},T.prototype.addRenderablesForFeatureCollection=function(e,r){if(!e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForFeatureCollection","missingLayer"));if(!r)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","addRenderablesForFeatureCollection","missingFeatureCollection"));if(r.features.length>0)for(var o=0;o<r.features.length;o++){var s=new n(r.features[o][i.FIELD_GEOMETRY],r.features[o][i.FIELD_PROPERTIES],r.features[o][i.FIELD_ID],r.features[o][i.FIELD_BBOX]);this.addRenderablesForFeature(e,s)}},T.prototype.setGeoJSONType=function(){switch(this.geoJSONObject[i.FIELD_TYPE]){case i.TYPE_POINT:this._geoJSONType=i.TYPE_POINT;break;case i.TYPE_MULTI_POINT:this._geoJSONType=i.TYPE_MULTI_POINT;break;case i.TYPE_LINE_STRING:this._geoJSONType=i.TYPE_LINE_STRING;break;case i.TYPE_MULTI_LINE_STRING:this._geoJSONType=i.TYPE_MULTI_LINE_STRING;break;case i.TYPE_POLYGON:this._geoJSONType=i.TYPE_POLYGON;break;case i.TYPE_MULTI_POLYGON:this._geoJSONType=i.TYPE_MULTI_POLYGON;break;case i.TYPE_GEOMETRY_COLLECTION:this._geoJSONType=i.TYPE_GEOMETRY_COLLECTION;break;case i.TYPE_FEATURE:this._geoJSONType=i.TYPE_FEATURE;break;case i.TYPE_FEATURE_COLLECTION:this._geoJSONType=i.TYPE_FEATURE_COLLECTION;break;default:throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","setGeoJSONType","invalidGeoJSONType"))}},T.prototype.getReprojectedIfRequired=function(e,r,n){if(!e&&0!==e)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","getReprojectedIfRequired","missingLatitude"));if(!r&&0!==r)throw new t(g.logMessage(g.LEVEL_SEVERE,"GeoJSON","getReprojectedIfRequired","missingLongitude"));return!n||n.isDefault()?[r,e]:_(n.projectionString,i.EPSG4326_CRS,[r,e])},T.prototype.setProj4jsAliases=function(){_.defs([["urn:ogc:def:crs:EPSG::4326",_.defs("EPSG:4326")],["urn:ogc:def:crs:OGC:1.3:CRS84",_.defs("EPSG:4326")],["urn:ogc:def:crs:EPSG::3857",_.defs("EPSG:3857")]])},T.tryParseJSONString=function(t){try{return JSON.parse(t)}catch(t){return null}},T}),i("projections/ProjectionEquirectangular",["../geom/Angle","../error/ArgumentError","../projections/GeographicProjection","../util/Logger","../geom/Vec3"],function(t,e,i,r,n){"use strict";var o=function(){i.call(this,"Equirectangular",!0,null)};return o.prototype=Object.create(i.prototype),Object.defineProperties(o.prototype,{stateKey:{get:function(){return"projection equirectangular "}}}),o.prototype.geographicToCartesian=function(i,n,o,s,a,l){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionEquirectangular","geographicToCartesian","missingGlobe"));if(!l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionEquirectangular","geographicToCartesian","missingResult"));return l[0]=i.equatorialRadius*o*t.DEGREES_TO_RADIANS+(a?a[0]:0),l[1]=i.equatorialRadius*n*t.DEGREES_TO_RADIANS,l[2]=s,l},o.prototype.geographicToCartesianGrid=function(i,o,s,a,l,h,u,c){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionEquirectangular","geographicToCartesianGrid","missingGlobe"));if(!o)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionEquirectangular","geographicToCartesianGrid","missingSector"));if(!l||l.length<s*a)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionEquirectangular","geographicToCartesianGrid","The specified elevations array is null, undefined or insufficient length"));
if(!c)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionEquirectangular","geographicToCartesianGrid","missingResult"));var d,p,f,g,m,y=i.equatorialRadius,E=o.minLatitude*t.DEGREES_TO_RADIANS,v=o.maxLatitude*t.DEGREES_TO_RADIANS,_=o.minLongitude*t.DEGREES_TO_RADIANS,b=o.maxLongitude*t.DEGREES_TO_RADIANS,w=(v-E)/(s>1?s-1:1),S=(b-_)/(a>1?a-1:1),L=h?h:new n(0,0,0),T=u?u[0]:0,A=0,R=0;for(d=0,f=E;d<s;d++,f+=w)for(d===s-1&&(f=v),m=y*f-L[1],p=0,g=_;p<a;p++,g+=S)p===a-1&&(g=b),c[R++]=y*g-L[0]+T,c[R++]=m,c[R++]=l[A++]-L[2];return c},o.prototype.cartesianToGeographic=function(i,n,o,s,a,l){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionEquirectangular","cartesianToGeographic","missingGlobe"));if(!l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionEquirectangular","cartesianToGeographic","missingResult"));return l.latitude=o/i.equatorialRadius*t.RADIANS_TO_DEGREES,l.longitude=(n-(a?a[0]:0))/i.equatorialRadius*t.RADIANS_TO_DEGREES,l.altitude=s,l},o}),i("globe/Globe2D",["../globe/ElevationModel","../globe/Globe","../projections/ProjectionEquirectangular"],function(t,e,i){"use strict";var r=function(){e.call(this,new t,new i)};return r.prototype=Object.create(e.prototype),r}),i("util/GoToAnimator",["../geom/Location","../util/Logger","../geom/Position","../geom/Vec3"],function(t,e,i,r){"use strict";var n=function(t){if(!t)throw new ArgumentError(e.logMessage(e.LEVEL_SEVERE,"GoToAnimator","constructor","missingWorldWindow"));this.wwd=t,this.animationFrequency=20,this.travelTime=3e3,this.cancelled=!1};return n.prototype.cancel=function(){this.cancelled=!0},n.prototype.goTo=function(n,o){if(!n)throw new ArgumentError(e.logMessage(e.LEVEL_SEVERE,"GoToAnimator","goTo","missingPosition"));this.completionCallback=o,this.cancelled=!1,this.wwd.navigator.lookAtLocation.altitude=n.altitude||0,this.targetPosition=new i(n.latitude,n.longitude,this.wwd.navigator.range),this.startPosition=new i(this.wwd.navigator.lookAtLocation.latitude,this.wwd.navigator.lookAtLocation.longitude,this.wwd.navigator.range),this.startTime=Date.now();var s,a=this.travelTime,l=t.greatCircleDistance(this.startPosition,this.targetPosition),h=this.wwd.globe.computePointFromLocation(this.startPosition.latitude,this.startPosition.longitude,new r(0,0,0)),u=this.wwd.globe.computePointFromLocation(this.targetPosition.latitude,this.targetPosition.longitude,new r(0,0,0));this.maxAltitude=h.distanceTo(u);var c=this.wwd.pixelSizeAtDistance(this.startPosition.altitude)*this.wwd.canvas.clientWidth/this.wwd.globe.equatorialRadius;l<=2*c&&(this.maxAltitude=this.startPosition.altitude),this.maxAltitudeReachedTime=this.maxAltitude<=this.wwd.navigator.range?Date.now():null,this.maxAltitude>this.startPosition.altitude?(s=Math.max(0,this.maxAltitude-this.startPosition.altitude),s+=Math.abs(this.targetPosition.altitude-this.maxAltitude)):s=Math.abs(this.targetPosition.altitude-this.startPosition.altitude);var d=Math.max(l,s/this.wwd.globe.equatorialRadius);if(0!==d){d<2*c&&(a=Math.min(d/c*this.travelTime,this.travelTime)),a=Math.max(1,a),this.panVelocity=l/a,this.rangeVelocity=s/a;var p=this,f=function(){return p.cancelled?void(p.completionCallback&&p.completionCallback(p)):void(p.update()?setTimeout(f,p.animationFrequency):p.completionCallback&&p.completionCallback(p))};setTimeout(f,this.animationFrequency)}},n.prototype.update=function(){var t=new i(this.wwd.navigator.lookAtLocation.latitude,this.wwd.navigator.lookAtLocation.longitude,this.wwd.navigator.range),e=this.updateRange(t);return e=this.updateLocation(t)||e,this.wwd.redraw(),e},n.prototype.updateRange=function(t){var e,i,r=!1;return this.maxAltitudeReachedTime?(i=Date.now()-this.maxAltitudeReachedTime,this.maxAltitude>this.targetPosition.altitude?(e=this.maxAltitude-this.rangeVelocity*i,e=Math.max(e,this.targetPosition.altitude)):(e=this.maxAltitude+this.rangeVelocity*i,e=Math.min(e,this.targetPosition.altitude)),this.wwd.navigator.range=e,r=Math.abs(this.wwd.navigator.range-this.targetPosition.altitude)>1):(i=Date.now()-this.startTime,e=Math.min(this.startPosition.altitude+this.rangeVelocity*i,this.maxAltitude),Math.abs(this.wwd.navigator.range-e)<1&&(this.maxAltitudeReachedTime=Date.now()),this.wwd.navigator.range=e,r=!0),r},n.prototype.updateLocation=function(e){var i=Date.now()-this.startTime,r=t.greatCircleDistance(this.startPosition,e),n=t.greatCircleDistance(e,this.targetPosition),o=t.greatCircleAzimuth(e,this.targetPosition),s=this.panVelocity*i,a=Math.min(s-r,n),l=t.greatCircleLocation(e,o,a,new t(0,0)),h=!1;return this.wwd.navigator.lookAtLocation.latitude=l.latitude,this.wwd.navigator.lookAtLocation.longitude=l.longitude,a<1/this.wwd.globe.equatorialRadius&&(h=!0),!h},n}),i("shaders/GridParticleProgram",["../error/ArgumentError","./GpuProgram","../util/Logger"],function(t,e,i){"use strict";var r=function(t){var i="attribute vec2 vertexPosition;\nuniform mediump int drawMode;\nuniform sampler2D simParticleSampler;\nuniform float simTextureDimension;\nuniform vec4 bbox;\nvarying vec2 texureCoord;\nconst int MODE_TEX_COPY_FADE = 0;\nconst int MODE_DRAW_PARTICLES = 1;\nconst vec2 bitEnc = vec2(1.0, 255.0);\nconst vec2 bitDec = 1.0 / bitEnc;\nvec2 decodePositionFromRGBA(const vec4 color) {\n   vec4 roundedColor = floor(color * 255.0 + 0.5) / 255.0;\n   float x = dot(roundedColor.rg, bitDec);\n   float y = dot(roundedColor.ba, bitDec);\n   return vec2(x, y);\n}\nvoid main() {\n   if (drawMode == MODE_TEX_COPY_FADE) {\n       texureCoord = vertexPosition;\n       gl_Position = vec4(1.0 - 2.0 * vertexPosition, 0, 1);\n   }\n   else {\n       float row = vertexPosition.x / simTextureDimension;\n       vec2 uv = vec2(fract(row), floor(row) / simTextureDimension);\n       vec4 color = texture2D(simParticleSampler, uv);\n       vec2 pos = decodePositionFromRGBA(color);\n       texureCoord = bbox.xy + pos * (bbox.zw - bbox.xy);       gl_Position = vec4((2.0 * pos.x - 1.0), (2.0 * pos.y - 1.0), 0.0, 1.0);\n       gl_PointSize = 1.0;\n   }\n}",r="precision mediump float;\nuniform sampler2D tileOrColorsSampler;\nuniform mediump int drawMode;\nuniform float fadeOpacity;\nuniform sampler2D gridSampler;\nuniform vec4 gridMinMax;\nvarying vec2 texureCoord;\nconst int MODE_TEX_COPY_FADE = 0;\nconst int MODE_DRAW_PARTICLES = 1;\nvoid main() {\n   if (drawMode == MODE_TEX_COPY_FADE) {\n       vec4 color = texture2D(tileOrColorsSampler, 1.0 - texureCoord);\n       gl_FragColor = vec4(floor(255.0 * color * fadeOpacity) / 255.0);\n   }\n   else {\n       vec2 gridVector = mix(gridMinMax.xy, gridMinMax.zw, texture2D(gridSampler, texureCoord).rg);\n       float normalizedDistance = length(gridVector) / length(gridMinMax.zw);\n       vec2 textCoord = vec2(fract(16.0 * normalizedDistance), floor(16.0 * normalizedDistance) / 16.0);\n       gl_FragColor = texture2D(tileOrColorsSampler, textCoord);\n   }\n}";e.call(this,t,i,r,["vertexPosition"]),this.vertexPositionLocation=this.attributeLocation(t,"vertexPosition"),this.simParticleSamplerLocation=this.uniformLocation(t,"simParticleSampler"),this.simTextureDimensionLocation=this.uniformLocation(t,"simTextureDimension"),this.drawModeLocation=this.uniformLocation(t,"drawMode"),this.tileOrColorsSamplerLocation=this.uniformLocation(t,"tileOrColorsSampler"),this.fadeOpacityLocation=this.uniformLocation(t,"fadeOpacity"),this.gridSamplerLocation=this.uniformLocation(t,"gridSampler"),this.gridMinMaxLocation=this.uniformLocation(t,"gridMinMax"),this.bboxLocation=this.uniformLocation(t,"bbox"),this.MODE_TEX_COPY_FADE=0,this.MODE_DRAW_PARTICLES=1};return r.key="WorldWindGpuGridParticleProgram",r.prototype=Object.create(e.prototype),r.prototype.loadSimParticleSamper=function(t,e){t.uniform1i(this.simParticleSamplerLocation,e-t.TEXTURE0)},r.prototype.loadSimTextureDimension=function(e,r){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleProgram","loadSimTextureDimension","missing dimension"));e.uniform1f(this.simTextureDimensionLocation,r)},r.prototype.loadDrawMode=function(t,e){t.uniform1i(this.drawModeLocation,e)},r.prototype.loadTileOrColorsSampler=function(t,e){t.uniform1i(this.tileOrColorsSamplerLocation,e-t.TEXTURE0)},r.prototype.loadFadeOpacity=function(e,r){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleProgram","loadFadeOpacity","missing fadeOpacity"));e.uniform1f(this.fadeOpacityLocation,r)},r.prototype.loadGridSampler=function(t,e){t.uniform1i(this.gridSamplerLocation,e-t.TEXTURE0)},r.prototype.loadGridMinMax=function(e,r,n,o,s){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleProgram","loadGridMinMax","missing uMin"));if(null==n)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleProgram","loadGridMinMax","missing vMin"));if(null==o)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleProgram","loadGridMinMax","missing uMax"));if(null==s)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleProgram","loadGridMinMax","missing vMax"));e.uniform4f(this.gridMinMaxLocation,r,n,o,s)},r.prototype.loadBbox=function(e,r){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleProgram","loadBbox","missing bbox"));e.uniform4fv(this.bboxLocation,r)},r}),i("shaders/GridParticleSimProgram",["../error/ArgumentError","./GpuProgram","../util/Logger"],function(t,e,i){"use strict";var r=function(t){var i="attribute vec2 vertexPosition;\nvarying vec2 texureCoord;\nvoid main() {\n    texureCoord = vertexPosition;\n    gl_Position = vec4(1.0 - 2.0 * vertexPosition, 0, 1);\n}",r="#ifdef GL_FRAGMENT_PRECISION_HIGH\nprecision highp float;\n#else\nprecision mediump float;\n#endif\nuniform sampler2D particleSampler;\nuniform sampler2D gridSampler;\nuniform vec2 gridDimensions;\nuniform vec4 gridMinMax;\nuniform float randSeed;\nuniform float speedFactor;\nuniform float dropRate;\nuniform float dropRateMultiplier;\nuniform vec4 bbox;\nvarying vec2 texureCoord;\nconst vec2 bitEnc = vec2(1.0, 255.0);\nconst vec2 bitDec = 1.0 / bitEnc;\nconst vec3 rand_constants = vec3(12.9898, 78.233, 4375.85453);\nfloat rand(const vec2 co) {\n   float t = dot(rand_constants.xy, co);\n   return fract(sin(t) * (rand_constants.z + t));\n}\nvec2 lookupGridVector(const vec2 uv) {\n   vec2 px = 1.0 / gridDimensions;\n   vec2 vc = (floor(uv * gridDimensions)) * px;\n   vec2 f = fract(uv * gridDimensions);\n   vec2 tl = texture2D(gridSampler, vc).rg;\n   vec2 tr = texture2D(gridSampler, vc + vec2(px.x, 0)).rg;\n   vec2 bl = texture2D(gridSampler, vc + vec2(0, px.y)).rg;\n   vec2 br = texture2D(gridSampler, vc + px).rg;\n   return mix(mix(tl, tr, f.x), mix(bl, br, f.x), f.y);\n}\nvec2 decodePositionFromRGBA(const vec4 color) {\n   vec4 rounded_color = floor(color * 255.0 + 0.5) / 255.0;\n   float x = dot(rounded_color.rg, bitDec);\n   float y = dot(rounded_color.ba, bitDec);\n   return vec2(x, y);\n}\nvec4 encodePositionToRGBA(const vec2 pos) {\n   vec2 rg = bitEnc * pos.x;\n   rg = fract(rg);\n   rg -= rg.yy * vec2(1.0 / 255.0, 0.0);\n   vec2 ba = bitEnc * pos.y;\n   ba = fract(ba);\n   ba -= ba.yy * vec2(1.0 / 255.0, 0.0);\n   return vec4(rg, ba);\n}\nvoid main() {\n   vec4 color = texture2D(particleSampler, texureCoord);\n   vec2 pos = decodePositionFromRGBA(color);\n   vec2 global_pos = bbox.xy + pos * (bbox.zw - bbox.xy);\n   vec2 normalizedGridVector = lookupGridVector(global_pos);\n   vec2 gridVector = mix(gridMinMax.xy, gridMinMax.zw, normalizedGridVector);\n   float normalizedDistance = length(gridVector) / length(gridMinMax.zw);\n   float distortion = max(cos(radians(global_pos.y * 180.0 - 90.0)), 0.00001);\n   float speedReduction = 0.0001;\n   vec2 offset = vec2(gridVector.x / distortion, -gridVector.y) * speedReduction * speedFactor;\n   pos = fract(1.0 + pos + offset);\n   float dropRating = dropRate + normalizedDistance * dropRateMultiplier;\n   vec2 seed = (pos + texureCoord) * randSeed;\n   float retain = step(dropRating, rand(seed));\n   vec2 randomPos = vec2(rand(seed + 1.3), 1.0 - rand(seed + 2.1));\n   pos = mix(pos, randomPos, 1.0 - retain);\n    gl_FragColor = encodePositionToRGBA(pos);\n}";e.call(this,t,i,r,["vertexPosition"]),this.vertexPointLocation=this.attributeLocation(t,"vertexPosition"),this.particleSamplerLocation=this.uniformLocation(t,"particleSampler"),this.gridSamplerLocation=this.uniformLocation(t,"gridSampler"),this.gridDimensionsLocation=this.uniformLocation(t,"gridDimensions"),this.gridMinMaxLocation=this.uniformLocation(t,"gridMinMax"),this.randSeedLocation=this.uniformLocation(t,"randSeed"),this.speedFactorLocation=this.uniformLocation(t,"speedFactor"),this.dropRateLocation=this.uniformLocation(t,"dropRate"),this.dropRateMultiplierLocation=this.uniformLocation(t,"dropRateMultiplier"),this.bboxLocation=this.uniformLocation(t,"bbox")};return r.key="WorldWindGpuGridParticleSimProgram",r.prototype=Object.create(e.prototype),r.prototype.loadGridDimensions=function(e,r,n){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleSimProgram","loadGridDimensions","missing width"));if(null==n)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleSimProgram","loadGridDimensions","missing height"));e.uniform2f(this.gridDimensionsLocation,r,n)},r.prototype.loadGridMinMax=function(e,r,n,o,s){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleSimProgram","loadGridMinMax","missing uMin"));if(null==n)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleSimProgram","loadGridMinMax","missing vMin"));if(null==o)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleSimProgram","loadGridMinMax","missing uMax"));if(null==s)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleSimProgram","loadGridMinMax","missing vMax"));e.uniform4f(this.gridMinMaxLocation,r,n,o,s)},r.prototype.loadRandSeed=function(e,r){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleSimProgram","loadRandSeed","missing seed"));e.uniform1f(this.randSeedLocation,r)},r.prototype.loadSpeedFactor=function(e,r){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleSimProgram","loadSpeedFactor","missing speedFactor"));e.uniform1f(this.speedFactorLocation,r)},r.prototype.loadDropRate=function(e,r){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleSimProgram","loadDropRate","missing dropRate"));e.uniform1f(this.dropRateLocation,r)},r.prototype.loadDropRateMultiplier=function(e,r){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleSimProgram","loadDropRateMultiplier","missing dropRateMultiplier"));e.uniform1f(this.dropRateMultiplierLocation,r)},r.prototype.loadBbox=function(e,r){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"GridParticleSimProgram","loadBbox","missing bbox"));e.uniform4fv(this.bboxLocation,r)},r.prototype.loadGridSampler=function(t,e){t.uniform1i(this.gridSamplerLocation,e-t.TEXTURE0)},r.prototype.loadParticleSamper=function(t,e){t.uniform1i(this.particleSamplerLocation,e-t.TEXTURE0)},r}),i("layer/GriddedDataLayer",["../render/DoubleBufferedFbo","../shaders/GridParticleProgram","../shaders/GridParticleSimProgram","../geom/Location","../geom/Sector","./TiledImageLayer","../util/WWMath","../util/WWUtil"],function(t,e,i,r,n,o,s,a){"use strict";var l=function(t,e){var i=16,s="GriddedDataLayer_"+a.guid(),l=256,h=256;o.call(this,new n(-90,90,-180,180),new r(45,45),i,"image/png",s,l,h),this.displayName=t||"GriddedDataLayer",this._numParticles=16384,this._colors={0:"#3288bd",.1:"#66c2a5",.2:"#abdda4",.3:"#e6f598",.4:"#fee08b",.5:"#fdae61",.6:"#f46d43",1:"#d53e4f"},this.fadeOpacity=.996,this.speedFactor=.25,this.dropRate=.003,this.dropRateMultiplier=.01,this.waitTime=334,this.gridData=null,this.eyeAltitudeReduction=.15,this.eyeAltitudeReductionTrehshold=2e7,this.sector=new n(-90,90,-180,180),this._gridDataUrl=e,this._simTextureResolution=128,this._groundTextureResolution=2048,this._loadInProgress=!1,this._bbox=new Float32Array([0,0,1,1]),this._lastGroundFboClear=0,this._requiresFboClear=!1,this._simTextureKey=s+"_simTexture",this._simTextureKey1=s+"_simTexture1",this._simTextureKey2=s+"_simTexture2",this._colorsTextureKey=s+"_colorsTexture",this._gridTextureKey=s+"_gridTexure",this._groundTextureKey=s+"_groundTexure",this._groundTextureKey1=s+"_groundTexure1",this._groundTextureKey2=s+"_groundTexure2",this._particleVboKey=s+"_particleVbo",this._quadVboKey=s+"_quadVbo"};return l.prototype=Object.create(o.prototype),Object.defineProperties(l.prototype,{numParticles:{get:function(){return this._numParticles},set:function(t){this._simTextureResolution=Math.ceil(Math.sqrt(t)),this._numParticles=this._simTextureResolution*this._simTextureResolution;var e="GriddedDataLayer_"+a.guid();this._simTextureKey=e+"_simTexture",this._simTextureKey1=e+"_simTexture1",this._simTextureKey2=e+"_simTexture2",this._particleVboKey=e+"_particleVbo",this._requiresFboClear=!0}},colors:{get:function(){return this._colors},set:function(t){this._colors=t;var e="GriddedDataLayer_"+a.guid();this._colorsTextureKey=e+"_colorsTexture",this._requiresFboClear=!0}}}),l.prototype.doRender=function(t){if(t.redrawRequested=!0,t.terrain){if(!this.gridData)return void this.loadGridData(this._gridDataUrl);var e=!t.modelviewProjection.equals(this.lasTtMVP);if((this.currentTilesInvalid||e||t.globeStateKey!==this.lastGlobeStateKey)&&(this.currentTilesInvalid=!1,this.assembleTiles(t),t.globe.is2D()||(this.currentTiles=this.cullTilesHorizon(t,this.currentTiles)),e&&(this._requiresFboClear=!0)),this.lasTtMVP.copy(t.modelviewProjection),this.lastGlobeStateKey=t.globeStateKey,this.currentTiles.length>0){if(this._requiresFboClear&&this.clearGroundFbo(t),Date.now()-this._lastGroundFboClear<=this.waitTime)return;try{this.renderToTexture(t)}finally{this.restoreGLState(t)}t.surfaceTileRenderer.renderTiles(t,[this],this.opacity,t.surfaceOpacity>=1),t.frameStatistics.incrementImageTileCount(1),this.inCurrentFrame=!0}}},l.prototype.renderToTexture=function(t){var r=t.currentGlContext,n=t.gpuResourceCache,o=r.COLOR_BUFFER_BIT|r.DEPTH_BUFFER_BIT|r.STENCIL_BUFFER_BIT,s=this._groundTextureKey,a=this._simTextureKey;1===t.globe.offset?(s=this._groundTextureKey1,a=this._simTextureKey1):t.globe.offset===-1&&(s=this._groundTextureKey2,a=this._simTextureKey2),r.disable(r.DEPTH_TEST),r.disable(r.STENCIL_TEST),r.blendFunc(r.ONE,r.ZERO),r.activeTexture(r.TEXTURE0);var l=n.resourceForKey(this._gridTextureKey);l||(l=this.createGridTexture(t,this._gridTextureKey)),r.bindTexture(r.TEXTURE_2D,l),t.frameStatistics.incrementTextureLoadCount(1),r.activeTexture(r.TEXTURE1);var h=n.resourceForKey(a);h||(h=this.createSimFbo(t,a)),r.bindTexture(r.TEXTURE_2D,h.getSecondaryTexture()),t.frameStatistics.incrementTextureLoadCount(1);var u=n.resourceForKey(this._quadVboKey);u||(u=this.createQuadVbo(t));var c=n.resourceForKey(this._particleVboKey);c||(c=this.createParticleVbo(t));var d=n.resourceForKey(this._colorsTextureKey);d||(d=this.createColorsTexture(t,this._colorsTextureKey));var p=n.resourceForKey(s);p||(p=this.createGroundFbo(t,s));var f=this.getBoundingSector(this.currentTiles,this.sector),g=this.getBoundingBox(f,this._bbox),m=t.findAndBindProgram(e);r.enableVertexAttribArray(0),r.activeTexture(r.TEXTURE2),m.loadGridSampler(r,r.TEXTURE0),m.loadSimParticleSamper(r,r.TEXTURE1),m.loadTileOrColorsSampler(r,r.TEXTURE2),m.loadFadeOpacity(r,this.fadeOpacity),m.loadSimTextureDimension(r,this._simTextureResolution),m.loadGridMinMax(r,this.gridData.uMin,this.gridData.vMin,this.gridData.uMax,this.gridData.vMax),p.bindFbo(t),r.clear(o),r.viewport(0,0,p.width,p.height),m.loadDrawMode(r,m.MODE_TEX_COPY_FADE),r.bindBuffer(r.ARRAY_BUFFER,u),r.vertexAttribPointer(0,2,r.FLOAT,!1,0,0),r.bindTexture(r.TEXTURE_2D,p.getSecondaryTexture()),t.frameStatistics.incrementTextureLoadCount(1),r.drawArrays(r.TRIANGLES,0,6),r.bindBuffer(r.ARRAY_BUFFER,c),r.vertexAttribPointer(0,2,r.FLOAT,!1,0,0),m.loadDrawMode(r,m.MODE_DRAW_PARTICLES),m.loadBbox(r,g),r.bindTexture(r.TEXTURE_2D,d),t.frameStatistics.incrementTextureLoadCount(1),r.drawArrays(r.POINTS,0,this._numParticles),p.swap(),p.isCleared=!1,h.bindFbo(t),r.clear(o),r.viewport(0,0,this._simTextureResolution,this._simTextureResolution),r.disable(r.BLEND),m=t.findAndBindProgram(i),r.bindBuffer(r.ARRAY_BUFFER,u),r.enableVertexAttribArray(0),r.vertexAttribPointer(0,2,r.FLOAT,!1,0,0),m.loadGridDimensions(r,this.gridData.width,this.gridData.height),m.loadGridMinMax(r,this.gridData.uMin,this.gridData.vMin,this.gridData.uMax,this.gridData.vMax),m.loadRandSeed(r,Math.random()),m.loadSpeedFactor(r,this.speedFactor),m.loadDropRate(r,this.dropRate),m.loadDropRateMultiplier(r,this.dropRateMultiplier),m.loadGridSampler(r,r.TEXTURE0),m.loadParticleSamper(r,r.TEXTURE1),m.loadBbox(r,g),r.drawArrays(r.TRIANGLES,0,6),h.swap(),h.isCleared=!1},l.prototype.restoreGLState=function(t){var e=t.currentGlContext;e.bindFramebuffer(e.FRAMEBUFFER,null),e.viewport(0,0,t.viewport.width,t.viewport.height),e.enable(e.DEPTH_TEST),e.enable(e.BLEND),e.activeTexture(e.TEXTURE0),e.blendFunc(e.ONE,e.ONE_MINUS_SRC_ALPHA)},l.prototype.clearGroundFbo=function(t){this._requiresFboClear=!1;var e=this._groundTextureKey;1===t.globe.offset?e=this._groundTextureKey1:t.globe.offset===-1&&(e=this._groundTextureKey2);var i=t.gpuResourceCache.resourceForKey(e);if(i&&!i.isCleared){i.clearFbo(t);var r=t.currentGlContext;r.bindFramebuffer(r.FRAMEBUFFER,null),r.viewport(0,0,t.viewport.width,t.viewport.height),this._lastGroundFboClear=Date.now()}},l.prototype.bind=function(t){var e=this._groundTextureKey;1===t.globe.offset?e=this._groundTextureKey1:t.globe.offset===-1&&(e=this._groundTextureKey2);var i=t.gpuResourceCache.resourceForKey(e);return!!i&&i.bind(t)},l.prototype.applyInternalTransform=function(t,e){},l.prototype.loadGridData=function(t){if(!this._loadInProgress&&t){var e=this,i=new XMLHttpRequest;i.onload=function(){if(e._loadInProgress=!1,!(i.status>=200&&i.status<300||0===i.status))throw new Error(i.statusText);var t=JSON.parse(i.response);e.gridData=e.createGridData(t)},i.onerror=function(){throw e._loadInProgress=!1,new Error("Unable to fetch data: "+t)},i.open("GET",t,!0),i.send(),this._loadInProgress=!0}},l.prototype.createGridData=function(t){for(var e=t[0],i=t[1],r=Math.floor(e.header.nx),n=Math.floor(e.header.ny),o=e.data[0],s=e.data[0],a=i.data[0],l=i.data[0],h=1,u=e.data.length;h<u;h++)o>e.data[h]&&(o=e.data[h]),s<e.data[h]&&(s=e.data[h]),a>i.data[h]&&(a=i.data[h]),l<i.data[h]&&(l=i.data[h]);for(var c=new Uint8Array(r*n*4),d=s-o,p=l-a,f=Math.floor(r/2),g=0;g<n;g++)for(var m=0;m<r;m++){h=4*(g*r+m);var y=g*r+(m+f)%r;c[h+0]=Math.floor(255*(e.data[y]-o)/d),c[h+1]=Math.floor(255*(i.data[y]-a)/p),c[h+2]=0,c[h+3]=255}var E={width:r,height:n,uMin:o,uMax:s,vMin:a,vMax:l,data:c};return E},l.prototype.getBoundingSector=function(t,e){t.length&&e.copy(t[0].sector);for(var i=1,r=t.length;i<r;i++)e.union(t[i].sector);return e},l.prototype.getBoundingBox=function(t,e){return e[0]=(t.minLongitude+180)/360,e[1]=(t.maxLatitude-90)/-180,e[2]=(t.maxLongitude+180)/360,e[3]=(t.minLatitude-90)/-180,e},l.prototype.cullTilesHorizon=function(t,e){var i=[],r=t.eyePosition.altitude,n=1-this.eyeAltitudeReduction;r>this.eyeAltitudeReductionTrehshold&&(n=1);for(var o=s.horizonDistanceForGlobeRadius(t.globe.equatorialRadius,r*n),a=0,l=e.length;a<l;a++){var h=e[a],u=h.distanceTo(t.eyePoint);u<=o&&i.push(h)}return i},l.prototype.retrieveTileImage=function(t,e,i){if(this.currentTilesInvalid=!0,!i){var r=document.createEvent("Event");r.initEvent(WorldWind.REDRAW_EVENT_TYPE,!0,!0),window.dispatchEvent(r)}},l.prototype.addTile=function(t,e){e.fallbackTile=null,e.opacity=1,this.currentTiles.push(e)},l.prototype.createSimFbo=function(e,i){this._simTextureResolution=Math.ceil(Math.sqrt(this._numParticles)),this._numParticles=this._simTextureResolution*this._simTextureResolution;for(var r=new Uint8Array(4*this._numParticles),n=0,o=r.length;n<o;n++)r[n]=Math.floor(256*Math.random());var s={width:this._simTextureResolution,height:this._simTextureResolution},a=this.createTexture(e,r,s),l=this.createTexture(e,r,s),h=new t(e,a,l,s.width,s.height);return e.gpuResourceCache.putResource(i,h,h.size),h},l.prototype.createGroundFbo=function(e,i){var r=e.currentGlContext,n={width:this._groundTextureResolution,height:this._groundTextureResolution};n[r.TEXTURE_MIN_FILTER]=r.NEAREST,n[r.TEXTURE_MAG_FILTER]=r.NEAREST;var o=new Uint8Array(n.width*n.height*4),s=this.createTexture(e,o,n),a=this.createTexture(e,o,n),l=new t(e,s,a,n.width,n.height);return e.gpuResourceCache.putResource(i,l,l.size),l},l.prototype.createColorsTexture=function(t,e){var i=t.currentGlContext,r=this.createColorGradient(this._colors),n={width:16,height:16};n[i.TEXTURE_MIN_FILTER]=i.LINEAR,n[i.TEXTURE_MAG_FILTER]=i.LINEAR;var o=this.createTexture(t,r,n),s=n.width*n.height*4;return t.gpuResourceCache.putResource(e,o,s),o},l.prototype.createGridTexture=function(t,e){var i=t.currentGlContext,r=this.gridData.data,n={width:this.gridData.width,height:this.gridData.height};n[i.TEXTURE_MIN_FILTER]=i.LINEAR,n[i.TEXTURE_MAG_FILTER]=i.LINEAR;var o=this.createTexture(t,r,n),s=n.width*n.height*4;return t.gpuResourceCache.putResource(e,o,s),o},l.prototype.createParticleVbo=function(t){for(var e=t.currentGlContext,i=2*this._numParticles,r=new Float32Array(i),n=0,o=0;o<i;o+=2)r[o]=n++;var s=e.createBuffer();return e.bindBuffer(e.ARRAY_BUFFER,s),e.bufferData(e.ARRAY_BUFFER,r,e.STATIC_DRAW),t.gpuResourceCache.putResource(this._particleVboKey,s,r.byteLength),s},l.prototype.createQuadVbo=function(t){var e=t.currentGlContext,i=new Float32Array([0,0,1,0,0,1,0,1,1,0,1,1]),r=e.createBuffer();return e.bindBuffer(e.ARRAY_BUFFER,r),e.bufferData(e.ARRAY_BUFFER,i,e.STATIC_DRAW),t.gpuResourceCache.putResource(this._quadVboKey,r,i.byteLength),r},l.prototype.createTexture=function(t,e,i){var r=t.currentGlContext,n=r.createTexture();r.bindTexture(r.TEXTURE_2D,n),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_S,i[r.TEXTURE_WRAP_S]||r.CLAMP_TO_EDGE),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_T,i[r.TEXTURE_WRAP_T]||r.CLAMP_TO_EDGE),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MIN_FILTER,i[r.TEXTURE_MIN_FILTER]||r.NEAREST),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MAG_FILTER,i[r.TEXTURE_MAG_FILTER]||r.NEAREST);var o=i.level||0,s=i.format||r.RGBA,a=i.type||r.UNSIGNED_BYTE,l=i.width,h=i.height,u=0;return r.texImage2D(r.TEXTURE_2D,o,s,l,h,u,s,a,e),n},l.prototype.createColorGradient=function(t){var e=document.createElement("canvas");e.width=256,e.height=1;for(var i=e.getContext("2d"),r=i.createLinearGradient(0,0,256,0),n=Object.keys(t),o=0,s=n.length;o<s;o++){var a=n[o];r.addColorStop(Number(a),t[a])}return i.fillStyle=r,i.fillRect(0,0,256,1),i.getImageData(0,0,256,1).data},l}),i("layer/heatmap/HeatMapTile",[],function(){var t=function(t,e){this._data=t,this._sector=e.sector,this._canvas=this.createCanvas(e.width,e.height),this._width=e.width,this._height=e.height,this._intensityGradient=e.intensityGradient,this._radius=e.radius,this._incrementPerIntensity=e.incrementPerIntensity};return t.prototype.url=function(){return this.draw().toDataURL()},t.prototype.canvas=function(){return this.draw()},t.prototype.draw=function(){var t=[];for(var e in this._intensityGradient)this._intensityGradient.hasOwnProperty(e)&&t.push({shape:this.shape(e),min:e});for(var i,r=this._canvas.getContext("2d"),n=null,o=0;o<this._data.length;o++){var s=this._data[o];i=s.measure*this._incrementPerIntensity,r.globalAlpha=i,t.forEach(function(t){i>t.min&&(n=t.shape)}),r.drawImage(n,this.longitudeInSector(s,this._sector,this._width)-n.width/2,this._height-this.latitudeInSector(s,this._sector,this._height)-n.height/2)}return this._canvas},t.prototype.createCanvas=function(t,e){var i=document.createElement("canvas");return i.width=t,i.height=e,i},t.prototype.shape=function(t){var e=this.createCanvas(2*this._radius,2*this._radius),i=e.getContext("2d"),r=i.createRadialGradient(this._radius,this._radius,0,this._radius,this._radius,this._radius);return r.addColorStop(0,"rgba(0,0,0,"+t+")"),r.addColorStop(1,"rgba(0,0,0,0)"),i.beginPath(),i.arc(this._radius,this._radius,this._radius,0,2*Math.PI,!0),i.fillStyle=r,i.fill(),i.closePath(),e},t.prototype.latitudeInSector=function(t,e,i){var r=e.maxLatitude-e.minLatitude,n=t.latitude-e.minLatitude;return Math.ceil(n/r*i)},t.prototype.longitudeInSector=function(t,e,i){var r=e.maxLongitude-e.minLongitude,n=t.longitude-e.minLongitude;return Math.ceil(n/r*i)},t}),i("layer/heatmap/HeatMapColoredTile",["./HeatMapTile"],function(t){var e=function(e,i){t.call(this,e,i),this._extendedWidth=i.extendedWidth,this._extendedHeight=i.extendedHeight,this._gradient=this.gradient(i.intensityGradient)};return e.prototype=Object.create(t.prototype),e.prototype.draw=function(){var e=t.prototype.draw.call(this),i=e.getContext("2d"),r=0,n=0,o=this._width,s=this._height;this._extendedHeight&&(r=this._extendedHeight,s=this._height-2*this._extendedHeight),this._extendedWidth&&(n=this._extendedWidth,o=this._width-2*this._extendedWidth);var a=i.getImageData(r,n,o,s);return this.colorize(a.data,this._gradient),i.putImageData(a,r,n),e},e.prototype.gradient=function(t){var e=this.createCanvas(1,256),i=e.getContext("2d"),r=i.createLinearGradient(0,0,0,256);for(var n in t)r.addColorStop(+n,t[n]);return i.fillStyle=r,i.fillRect(0,0,1,256),i.getImageData(0,0,1,256).data},e.prototype.colorize=function(t,e){for(var i,r=0,n=t.length;r<n;r+=4)i=4*t[r+3],i&&(t[r]=e[i],t[r+1]=e[i+1],t[r+2]=e[i+2],t[r+3]=255)},e}),i("layer/heatmap/HeatMapIntervalType",[],function(){"use strict";var t={CONTINUOUS:0,QUANTILES:1};return t}),i("geom/MeasuredLocation",["./Angle","./Location"],function(t,e){"use strict";var i=function(t,i,r){e.call(this,t,i),this.measure=r};return i.prototype=Object.create(e.prototype),i.fromRadians=function(e,r,n){return new i(e*t.RADIANS_TO_DEGREES,r*t.RADIANS_TO_DEGREES,n)},i.prototype.copy=function(t){return e.prototype.copy.call(this,t),this.measure=t.measure,this},i.prototype.set=function(t,i,r){return e.prototype.set.call(this,t,i),this.measure=r,this},i.prototype.equals=function(t){return e.prototype.equals.call(this,t)&&this.measure===t.measure},i}),i("layer/heatmap/HeatMapLayer",["../../error/ArgumentError","./HeatMapColoredTile","./HeatMapIntervalType","./HeatMapTile","../../util/ImageSource","../../geom/Location","../../util/Logger","../../geom/MeasuredLocation","../TiledImageLayer","../../geom/Sector","../../util/WWUtil"],function(t,e,i,r,n,o,s,a,l,h,u){"use strict";var c=function(t,e,r){this.tileWidth=256,this.tileHeight=256,l.call(this,new h(-90,90,-180,180),new o(45,45),r||18,"image/png","HeatMap"+u.guid(),this.tileWidth,this.tileHeight),this.displayName=t;for(var n={},s=-90;s<=90;s++){n[s]={};for(var a=-180;a<=180;a++)n[s][a]=[]}var c,d,p=Number.MIN_VALUE;e.forEach(function(t){c=Math.floor(t.latitude),d=Math.floor(t.longitude),n[c][d].push(t),t.measure>p&&(p=t.measure)}),this._data=n,this._measuredLocations=e,this._intervalType=i.CONTINUOUS,this._scale=["blue","cyan","lime","yellow","red"],this._radius=12.5,this._incrementPerIntensity=1/p,this.setGradient(e)};return c.prototype=Object.create(l.prototype),Object.defineProperties(c.prototype,{intervalType:{get:function(){return this._intervalType},set:function(t){this._intervalType=t,this.setGradient()}},scale:{get:function(){return this._scale},set:function(t){this._scale=t,this.setGradient()}},gradient:{get:function(){return this._gradient}},radius:{get:function(){return this._radius},set:function(t){this._radius=t}}}),c.prototype.filterGeographically=function(t,e){var i=Math.floor(e.minLatitude),r=Math.floor(e.maxLatitude),n=Math.floor(e.minLongitude),o=Math.floor(e.maxLongitude),s=0,a=0;i<=-90&&(i=-90),r>=90&&(r=90),n<=-180&&(s=Math.abs(n- -180),n=-180),o>=180&&(a=Math.abs(o-180),o=180);var l=[];if(this.gatherGeographical(t,l,e,i,r,n,o),0!==s){var u=new h(i,r,180-s,180);this.gatherGeographical(t,l,u,i,r,180-s,180,-360)}if(0!==a){var c=new h(i,r,-180,-180+a);this.gatherGeographical(t,l,c,i,r,-180,-180+a,360)}return l},c.prototype.gatherGeographical=function(t,e,i,r,n,o,s,l){var h,u;for(h=r;h<=n;h++)for(u=o;u<=s;u++)t[h][u].forEach(function(t){i.containsLocation(t.latitude,t.longitude)&&(l?e.push(new a(t.latitude,l+t.longitude,t.measure)):e.push(t))})},c.prototype.setGradient=function(){
var t=this.intervalType,e=this.scale,r={};if(t===i.CONTINUOUS)e.forEach(function(t,i){r[i/e.length]=t});else if(t===i.QUANTILES){var n=this._measuredLocations;n.sort(function(t,e){return t.measure<e.measure?-1:t.measure>e.measure?1:0});var o=n[n.length-1].measure;n.length>=e.length?e.forEach(function(t,i){0===i?r[0]=t:r[n[Math.floor(i/e.length*n.length)].measure/o]=t}):e.forEach(function(t,i){r[i/e.length]=t})}this._gradient=r},c.prototype.retrieveTileImage=function(t,e,i){if(this.currentRetrievals.indexOf(e.imagePath)<0){if(this.absentResourceList.isResourceAbsent(e.imagePath))return;var r=e.imagePath,n=t.gpuResourceCache,o=this,s=this.radius,a=this.calculateExtendedSector(e.sector,2*(s/this.tileWidth),2*(s/this.tileHeight)),l=Math.ceil(a.extensionFactorWidth*this.tileWidth),h=Math.ceil(a.extensionFactorHeight*this.tileHeight),u=this.filterGeographically(this._data,a.sector),c=this.createHeatMapTile(u,{sector:a.sector,width:this.tileWidth+2*l,height:this.tileHeight+2*h,radius:s,intensityGradient:this.gradient,incrementPerIntensity:this._incrementPerIntensity,extendedWidth:l,extendedHeight:h}).canvas(),d=document.createElement("canvas");d.height=this.tileHeight,d.width=this.tileWidth,d.getContext("2d").putImageData(c.getContext("2d").getImageData(l,h,this.tileWidth,this.tileHeight),0,0);var p=o.createTexture(t,e,d);if(o.removeFromCurrentRetrievals(r),p&&(n.putResource(r,p,p.size),o.currentTilesInvalid=!0,o.absentResourceList.unmarkResourceAbsent(r),!i)){var f=document.createEvent("Event");f.initEvent(WorldWind.REDRAW_EVENT_TYPE,!0,!0),window.dispatchEvent(f)}}},c.prototype.calculateExtendedSector=function(t,e,i){var r=(t.maxLatitude-t.minLatitude)*i,n=(t.maxLongitude-t.minLongitude)*e;return{sector:new h(t.minLatitude-r,t.maxLatitude+r,t.minLongitude-n,t.maxLongitude+n),extensionFactorHeight:i,extensionFactorWidth:e}},c.prototype.createHeatMapTile=function(t,i){return new e(t,i)},c}),i("util/HighlightController",["../error/ArgumentError","../util/Logger"],function(t,e){"use strict";var i=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"HighlightController","constructor","missingWorldWindow"));this.worldWindow=i;var r=[],n=function(t){for(var e=t.clientX,n=t.clientY,o=r.length>0,s=0;s<r.length;s++)r[s].highlighted=!1;r=[];var a=i.pick(i.canvasCoordinates(e,n));if(a.objects.length>0&&(o=!0),a.objects.length>0)for(var l=0;l<a.objects.length;l++)a.objects[l].isTerrain||(a.objects[l].userObject.highlighted=!0,r.push(a.objects[l].userObject));o&&i.redraw()};this.worldWindow.addEventListener("mousemove",n);new WorldWind.TapRecognizer(this.worldWindow,n)};return i}),i("formats/kml/util/KmlAttribute",[],function(){"use strict";var t=function(t,e){this.node=t,this.name=e};return t.prototype.value=function(){return this.node.attributes&&this.node.attributes.getNamedItem(this.name)&&this.node.attributes.getNamedItem(this.name).value||null},t.prototype.exists=function(){return null!=this.value()},t.prototype.save=function(t){this.node.setAttribute(this.name,t)},t}),i("formats/kml/KmlElements",[],function(){"use strict";var t={keys:{},addKey:function(t,e){this.keys[t]=e},getKey:function(t){return this.keys[t]}};return t}),i("formats/kml/util/KmlNodeTransformers",["./KmlAttribute","../KmlElements","../../../geom/Position","../../../util/WWUtil"],function(t,e,i,r){function n(t){var e;return null!=t&&t.childNodes[0]?e=t.childNodes[0].nodeValue:null!=t&&(e=""),e}var o=function(){};return o.string=function(t){return String(n(t))},o.number=function(t){return Number(n(t))},o.boolean=function(t){return r.transformToBoolean(n(t))},o.date=function(t){return r.date(n(t))},o.kmlObject=function(t,i,r){var n=t.nodeName,o=e.getKey(n);return o?new o({objectNode:t,parent:i,controls:r}):null},o.linearRing=function(t,i,r){var n=e.getKey("LinearRing");if(!n)return null;var o=null;return Array.prototype.forEach.call(t.childNodes,function(t){t.nodeName.toUpperCase()=="LinearRing".toUpperCase()&&(o=t)}),new n({objectNode:o,parent:i,controls:r})},o.positions=function(t){var e=[],r=n(t).trim().replace(/\s+/g," ").split(" ");return r.forEach(function(t){t=t.split(","),e.push(new i(Number(t[1]),Number(t[0]),Number(t[2]||0)))}),e},o.attribute=function(e){return function(i){return new t(i,e).value()}},o}),i("formats/kml/util/KmlElementsFactory",["./KmlNodeTransformers"],function(t){"use strict";var e=function(t){this.options=t||{},this.options.controls=this.options.controls||[]};e.prototype.specific=function(t,e){var i=t.node,r=null,n=this;return[].forEach.call(i.childNodes,function(i){i.nodeName==e.name&&(r=e.transformer(i,t,n.options.controls))}),r},e.prototype.any=function(e,i){var r=e.node,n=null,o=this;return[].forEach.call(r.childNodes,function(r){i.name.indexOf(r.nodeName)!=-1&&(n=t.kmlObject(r,e,o.options.controls))}),n},e.prototype.all=function(e){var i=e.node,r=[],n=this;return[].forEach.call(i.childNodes,function(i){var o=t.kmlObject(i,e,n.options.controls);o&&r.push(o)}),r};var i=new e;return e.applicationWide=function(){return i},e}),i("formats/kml/util/KmlTreeKeyValueCache",["../../../util/WWUtil"],function(t){"use strict";var e=function(){this.map={}};e.prototype.add=function(t,e,i){this.map[t]||(this.map[t]={}),this.map[t][e]=i},e.prototype.value=function(e,i){if(!this.map[e])return null;if(i.indexOf("#")==-1){var r=this.level(e);for(var n in r)if(r.hasOwnProperty(n)&&t.startsWith(n,i))return r[n]}return this.map[e][i]||null},e.prototype.level=function(t){return this.map[t]},e.prototype.remove=function(t,e){delete this.map[t][e]};var i=new e;return e.applicationLevelCache=function(){return i},e}),i("formats/kml/util/KmlElementsFactoryCached",["./KmlAttribute","./KmlElementsFactory","./KmlTreeKeyValueCache","../../../util/WWUtil"],function(t,e,i,r){"use strict";var n=function(t){this.internalFactory=new e(t),this.cache=i.applicationLevelCache()};n.prototype.all=function(t){var e=t.node,i=this.cache.level(this.cacheKey(t.node,"All"));if(i){var r=[];for(var n in i)i.hasOwnProperty(n)&&r.push(i[n]);return r}var o=this.internalFactory.all(t);if(o&&o.length){var s=this;o.forEach(function(t){s.cache.add(s.cacheKey(e,"All"),s.cacheKey(t.node),t)})}return o},n.prototype.specific=function(t,e){var i=t.node,r=e.name;e.attribute&&(r=e.attribute+r);var n=this.cache.value(this.cacheKey(i),r);if(n)return n;var o=this.internalFactory.specific(t,e);return o&&o.node?this.cache.add(this.cacheKey(i),this.cacheKey(o.node),o):o&&this.cache.add(this.cacheKey(i),r,o),o},n.prototype.any=function(t,e){var i,r=t.node,n=this,o=null;if(e.name.forEach(function(t){i=n.cache.value(n.cacheKey(r),t),i&&(o=i)}),o)return o;var s=this.internalFactory.any(t,e);return s&&this.cache.add(n.cacheKey(r),n.cacheKey(s.node),s),s},n.prototype.cacheKey=function(e,i){var n=new t(e,"id");n.exists()||n.save(r.guid());var o=e.nodeName+"#"+n.value();return i&&(o=i+o),o};var o=new n;return n.applicationWide=function(){return o},n}),function(){"use strict";function t(t){return"function"==typeof t||"object"==typeof t&&null!==t}function r(t){return"function"==typeof t}function n(t){return"object"==typeof t&&null!==t}function o(t){K=t}function s(t){q=t}function a(){return function(){process.nextTick(d)}}function l(){return function(){U(d)}}function h(){var t=0,e=new J(d),i=document.createTextNode("");return e.observe(i,{characterData:!0}),function(){i.data=t=++t%2}}function u(){var t=new MessageChannel;return t.port1.onmessage=d,function(){t.port2.postMessage(0)}}function c(){return function(){setTimeout(d,1)}}function d(){for(var t=0;t<H;t+=2){var e=$[t],i=$[t+1];e(i),$[t]=void 0,$[t+1]=void 0}H=0}function p(){try{var t=e,i=t("vertx");return U=i.runOnLoop||i.runOnContext,l()}catch(t){return c()}}function f(){}function g(){return new TypeError("You cannot resolve a promise with itself")}function m(){return new TypeError("A promises callback cannot return that same promise.")}function y(t){try{return t.then}catch(t){return rt.error=t,rt}}function E(t,e,i,r){try{t.call(e,i,r)}catch(t){return t}}function v(t,e,i){q(function(t){var r=!1,n=E(i,e,function(i){r||(r=!0,e!==i?w(t,i):L(t,i))},function(e){r||(r=!0,T(t,e))},"Settle: "+(t._label||" unknown promise"));!r&&n&&(r=!0,T(t,n))},t)}function _(t,e){e._state===et?L(t,e._result):e._state===it?T(t,e._result):A(e,void 0,function(e){w(t,e)},function(e){T(t,e)})}function b(t,e){if(e.constructor===t.constructor)_(t,e);else{var i=y(e);i===rt?T(t,rt.error):void 0===i?L(t,e):r(i)?v(t,e,i):L(t,e)}}function w(e,i){e===i?T(e,g()):t(i)?b(e,i):L(e,i)}function S(t){t._onerror&&t._onerror(t._result),R(t)}function L(t,e){t._state===tt&&(t._result=e,t._state=et,0!==t._subscribers.length&&q(R,t))}function T(t,e){t._state===tt&&(t._state=it,t._result=e,q(S,t))}function A(t,e,i,r){var n=t._subscribers,o=n.length;t._onerror=null,n[o]=e,n[o+et]=i,n[o+it]=r,0===o&&t._state&&q(R,t)}function R(t){var e=t._subscribers,i=t._state;if(0!==e.length){for(var r,n,o=t._result,s=0;s<e.length;s+=3)r=e[s],n=e[s+i],r?M(i,r,n,o):n(o);t._subscribers.length=0}}function x(){this.error=null}function C(t,e){try{return t(e)}catch(t){return nt.error=t,nt}}function M(t,e,i,n){var o,s,a,l,h=r(i);if(h){if(o=C(i,n),o===nt?(l=!0,s=o.error,o=null):a=!0,e===o)return void T(e,m())}else o=n,a=!0;e._state!==tt||(h&&a?w(e,o):l?T(e,s):t===et?L(e,o):t===it&&T(e,o))}function P(t,e){try{e(function(e){w(t,e)},function(e){T(t,e)})}catch(e){T(t,e)}}function O(t,e){var i=this;i._instanceConstructor=t,i.promise=new t(f),i._validateInput(e)?(i._input=e,i.length=e.length,i._remaining=e.length,i._init(),0===i.length?L(i.promise,i._result):(i.length=i.length||0,i._enumerate(),0===i._remaining&&L(i.promise,i._result))):T(i.promise,i._validationError())}function N(t){return new ot(this,t).promise}function I(t){function e(t){w(n,t)}function i(t){T(n,t)}var r=this,n=new r(f);if(!z(t))return T(n,new TypeError("You must pass an array to race.")),n;for(var o=t.length,s=0;n._state===tt&&s<o;s++)A(r.resolve(t[s]),void 0,e,i);return n}function D(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var i=new e(f);return w(i,t),i}function k(t){var e=this,i=new e(f);return T(i,t),i}function F(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function V(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function G(t){this._id=ut++,this._state=void 0,this._result=void 0,this._subscribers=[],f!==t&&(r(t)||F(),this instanceof G||V(),P(this,t))}function W(){var t;if("undefined"!=typeof ft)t=ft;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(t){throw new Error("polyfill failed because global object is unavailable in this environment")}var e=t.Promise;e&&"[object Promise]"===Object.prototype.toString.call(e.resolve())&&!e.cast||(t.Promise=ct)}var B;B=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var U,K,j,z=B,H=0,q=({}.toString,function(t,e){$[H]=t,$[H+1]=e,H+=2,2===H&&(K?K(d):j())}),Y="undefined"!=typeof window?window:void 0,X=Y||{},J=X.MutationObserver||X.WebKitMutationObserver,Q="undefined"!=typeof process&&"[object process]"==={}.toString.call(process),Z="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,$=new Array(1e3);j=Q?a():J?h():Z?u():void 0===Y&&"function"==typeof e?p():c();var tt=void 0,et=1,it=2,rt=new x,nt=new x;O.prototype._validateInput=function(t){return z(t)},O.prototype._validationError=function(){return new Error("Array Methods must be provided an Array")},O.prototype._init=function(){this._result=new Array(this.length)};var ot=O;O.prototype._enumerate=function(){for(var t=this,e=t.length,i=t.promise,r=t._input,n=0;i._state===tt&&n<e;n++)t._eachEntry(r[n],n)},O.prototype._eachEntry=function(t,e){var i=this,r=i._instanceConstructor;n(t)?t.constructor===r&&t._state!==tt?(t._onerror=null,i._settledAt(t._state,e,t._result)):i._willSettleAt(r.resolve(t),e):(i._remaining--,i._result[e]=t)},O.prototype._settledAt=function(t,e,i){var r=this,n=r.promise;n._state===tt&&(r._remaining--,t===it?T(n,i):r._result[e]=i),0===r._remaining&&L(n,r._result)},O.prototype._willSettleAt=function(t,e){var i=this;A(t,void 0,function(t){i._settledAt(et,e,t)},function(t){i._settledAt(it,e,t)})};var st=N,at=I,lt=D,ht=k,ut=0,ct=G;G.all=st,G.race=at,G.resolve=lt,G.reject=ht,G._setScheduler=o,G._setAsap=s,G._asap=q,G.prototype={constructor:G,then:function(t,e){var i=this,r=i._state;if(r===et&&!t||r===it&&!e)return this;var n=new this.constructor(f),o=i._result;if(r){var s=arguments[r-1];q(function(){M(r,n,s,o)})}else A(i,n,t,e);return n},catch:function(t){return this.then(null,t)}};var dt=W,pt={Promise:ct,polyfill:dt};"function"==typeof i&&i.amd?i("util/es6-promise",[],function(){return pt}):"undefined"!=typeof module&&module.exports?module.exports=pt:"undefined"!=typeof this&&(this.ES6Promise=pt);var ft={};dt()}.call(this),i("util/Promise",["./es6-promise"],function(t){"use strict";return window.Promise?window.Promise:t.Promise}),i("formats/kml/KmlObject",["../../error/ArgumentError","./util/KmlAttribute","./KmlElements","./util/KmlElementsFactoryCached","../../util/Logger","../../util/Promise","../../render/Renderable"],function(t,e,i,r,n,o,s){"use strict";var a=function(e){if(s.call(this),e=e||{},!e.objectNode)throw new t(n.logMessage(n.LEVEL_SEVERE,"KmlObject","constructor","Passed node isn't defined."));this._node=e.objectNode,this._cache={},this._controls=e.controls||[],this._factory=new r({controls:this._controls}),this.hook(this._controls,e)};return a.prototype=Object.create(s.prototype),Object.defineProperties(a.prototype,{id:{get:function(){return new e(this.node,"id").value()}},node:{get:function(){return this._node}}}),a.prototype.hook=function(t,e){var i=this;t.forEach(function(t){t.hook(i,e)})},a.prototype.render=function(t){},a.prototype.getTagNames=function(){return[]},a}),i("formats/kml/KmlTimePrimitive",["./KmlObject"],function(t){"use strict";var e=function(e){t.call(this,e)};return e.prototype=Object.create(t.prototype),e.prototype.kmlTimeRange=function(){var t,e;return this.kmlBegin&&(e=t=this.kmlBegin.valueOf()),this.kmlEnd&&(e=this.kmlEnd.valueOf(),t||(t=e)),this.kmlWhen&&(e=t=this.kmlWhen.valueOf()),{from:t,to:e}},e.prototype.getTagNames=function(){return["TimeSpan","TimeStamp"]},e}),i("formats/kml/KmlAbstractView",["./KmlObject","./KmlElements","./KmlTimePrimitive"],function(t,e,i){"use strict";var r=function(e){t.call(this,e)};return r.prototype=Object.create(t.prototype),Object.defineProperties(r.prototype,{kmlTimePrimitive:{get:function(){return this._factory.any(this,{name:i.prototype.getTagNames()})}}}),r.prototype.getTagNames=function(){return["Camera","LookAt"]},r}),i("formats/kml/styles/KmlSubStyle",["./../KmlObject"],function(t){"use strict";var e=function(e){t.call(this,e)};return e.prototype=Object.create(t.prototype),e.prototype.getTagNames=function(){return["LineStyle","PolyStyle","IconStyle","LabelStyle","BalloonStyle","ListStyle"]},e}),i("formats/kml/styles/KmlBalloonStyle",["../KmlElements","./KmlSubStyle","../util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlBgColor:{get:function(){return this._factory.specific(this,{name:"bgColor",transformer:i.string})}},kmlTextColor:{get:function(){return this._factory.specific(this,{name:"textColor",transformer:i.string})}},kmlText:{get:function(){return this._factory.specific(this,{name:"text",transformer:i.string})}},kmlDisplayMode:{get:function(){return this._factory.specific(this,{name:"displayMode",transformer:i.string})}}}),r.update=function(){},r.prototype.getTagNames=function(){return["BalloonStyle"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/KmlCamera",["./KmlElements","./KmlAbstractView","./util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlLongitude:{get:function(){return this._factory.specific(this,{name:"longitude",transformer:i.string})}},kmlLatitude:{get:function(){return this._factory.specific(this,{name:"latitude",transformer:i.string})}},kmlAltitude:{get:function(){return this._factory.specific(this,{name:"altitude",transformer:i.string})}},kmlHeading:{get:function(){return this._factory.specific(this,{name:"heading",transformer:i.string})}},kmlTilt:{get:function(){return this._factory.specific(this,{name:"tilt",transformer:i.string})}},kmlRoll:{get:function(){return this._factory.specific(this,{name:"roll",transformer:i.string})}},kmlAltitudeMode:{get:function(){return this._factory.specific(this,{name:"altitudeMode",transformer:i.string})}}}),r.prototype.getTagNames=function(){return["Camera"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/util/KmlChange",["../KmlElements","../KmlObject"],function(t,e){var i=function(t){e.call(this,t)};return i.prototype=Object.create(e.prototype),Object.defineProperties(i.prototype,{shapes:{get:function(){return this._factory.all(this)}}}),i.prototype.getTagNames=function(){return["Change"]},t.addKey(i.prototype.getTagNames()[0],i),i}),i("formats/kml/styles/KmlColorStyle",["./KmlSubStyle","../util/KmlNodeTransformers"],function(t,e){"use strict";var i=function(e){t.call(this,e)};return i.prototype=Object.create(t.prototype),Object.defineProperties(i.prototype,{kmlColor:{get:function(){return this._factory.specific(this,{name:"color",transformer:e.string})}},kmlColorMode:{get:function(){return this._factory.specific(this,{name:"colorMode",transformer:e.string})}}}),i.prototype.getTagNames=function(){return["LineStyle","PolyStyle","IconStyle","LabelStyle"]},i}),i("formats/kml/KmlFileCache",[],function(){"use strict";var t=function(){this._rootFile=null,this._map={}};return t.prototype.retrieve=function(t){if(0!=t.indexOf("kmz;")&&0!=t.indexOf("href;")&&(0==t.indexOf("#")||null==t||0!=t.indexOf("http")))return this._rootFile;var e=t;return t.indexOf("#")!=-1&&(e=t.substr(0,t.indexOf("#")-1)),this._map[e]?this._map[e]:null},t.prototype.add=function(t,e,i){i?this._rootFile=e:this._map[t]=e},t}),i("formats/kml/styles/KmlStyleSelector",["./../KmlObject"],function(t){"use strict";var e=function(e){t.call(this,e)};return e.prototype=Object.create(t.prototype),e.prototype.getTagNames=function(){return["Style","StyleMap"]},e}),i("formats/kml/styles/KmlPolyStyle",["../../../util/Color","./KmlColorStyle","./../KmlElements","../util/KmlNodeTransformers"],function(t,e,i,r){"use strict";var n=function(t){e.call(this,t)};return n.prototype=Object.create(e.prototype),Object.defineProperties(n.prototype,{kmlFill:{get:function(){return this._factory.specific(this,{name:"fill",transformer:r.boolean})}},kmlOutline:{get:function(){return this._factory.specific(this,{name:"outline",transformer:r.boolean})}}}),n.update=function(e,i){e=e||{};var r=i||{};return r._drawInterior=e.kmlFill||!0,r._drawOutline=e.kmlOutline||!1,r._outlineColor=i._outlineColor||t.WHITE,r._interiorColor=e.kmlColor&&t.colorFromKmlHex(e.kmlColor)||t.WHITE,r._colorMode=e.kmlColorMode||"normal",r},n.prototype.getTagNames=function(){return["PolyStyle"]},i.addKey(n.prototype.getTagNames()[0],n),n}),i("formats/kml/util/KmlHrefResolver",["../../../util/Promise","../../../util/WWUtil"],function(t,e){var i=function(t,e){this._url=t,this._fileCache=e};return i.prototype.url=function(){if(e.startsWith(this._url,"http://")||e.startsWith(this._url,"https://"))return this._url;var t=this._fileCache.retrieve("kmz;"+this._url);return t?t:(t=this._fileCache.retrieve("href;"+this._url),t?t:this._url)},i}),i("formats/kml/KmlLink",["./util/KmlHrefResolver","./KmlElements","./KmlObject","./util/KmlNodeTransformers"],function(t,e,i,r){"use strict";var n=function(t){i.call(this,t),this.onChangeListeners=[]};return n.prototype=Object.create(i.prototype),Object.defineProperties(n.prototype,{kmlRefreshMode:{get:function(){return this._factory.specific(this,{name:"refreshMode",transformer:r.string})}},kmlRefreshInterval:{get:function(){return this._factory.specific(this,{name:"refreshInterval",transformer:r.number})}},kmlViewRefreshMode:{get:function(){return this._factory.specific(this,{name:"viewRefreshMode",transformer:r.string})}},kmlViewRefreshTime:{get:function(){return this._factory.specific(this,{name:"viewRefreshTime",transformer:r.number})}},kmlViewBoundScale:{get:function(){return this._factory.specific(this,{name:"viewBoundScale",transformer:r.number})}},kmlViewFormat:{get:function(){return this._factory.specific(this,{name:"viewFormat",transformer:r.string})}},kmlHttpQuery:{get:function(){return this._factory.specific(this,{name:"httpQuery",transformer:r.string})}}}),n.prototype.kmlHref=function(e){return new t(this._factory.specific(this,{name:"href",transformer:r.string}),e).url()},n.prototype.getTagNames=function(){return["Link"]},e.addKey(n.prototype.getTagNames()[0],n),n}),i("formats/kml/KmlIcon",["./KmlLink","./KmlElements","./util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(e){t.call(this,e)};return r.prototype=Object.create(t.prototype),Object.defineProperties(r.prototype,{kmlX:{get:function(){return this._factory.specific(this,{name:"gx:x",transformer:i.number})}},kmlY:{get:function(){return this._factory.specific(this,{name:"gx:y",transformer:i.number})}},kmlW:{get:function(){return this._factory.specific(this,{name:"gx:w",transformer:i.number})}},kmlH:{get:function(){return this._factory.specific(this,{name:"gx:h",transformer:i.number})}}}),r.prototype.getTagNames=function(){return["Icon"]},e.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/styles/KmlIconStyle",["./KmlColorStyle","./../KmlElements","../KmlIcon","../util/KmlNodeTransformers"],function(t,e,i,r){"use strict";var n=function(e){t.call(this,e)};return n.prototype=Object.create(t.prototype),Object.defineProperties(n.prototype,{kmlScale:{get:function(){return this._factory.specific(this,{name:"scale",transformer:r.number})}},kmlHeading:{get:function(){return this._factory.specific(this,{name:"heading",transformer:r.number})}},kmlIcon:{get:function(){return this._factory.any(this,{name:i.prototype.getTagNames()})}},kmlHotSpotX:{get:function(){return this._factory.specific(this,{name:"hotSpot",transformer:r.attribute("x")})}},kmlHotSpotY:{get:function(){return this._factory.specific(this,{name:"hotSpot",transformer:r.attribute("y")})}},kmlHotSpotXUnits:{get:function(){return this._factory.specific(this,{name:"hotSpot",transformer:r.attribute("xunits")})}},kmlHotSpotYUnits:{get:function(){return this._factory.specific(this,{name:"hotSpot",transformer:r.attribute("yunits")})}}}),n.update=function(t,e,i){t=t||{};var r=e||{};return r._imageScale=t.kmlScale||1,r._imageSource=t.kmlIcon&&t.kmlIcon.kmlHref(i)||null,r},n.prototype.getTagNames=function(){return["IconStyle"]},e.addKey(n.prototype.getTagNames()[0],n),n}),i("formats/kml/styles/KmlLabelStyle",["./KmlColorStyle","../KmlElements","../util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(e){t.call(this,e)};return r.prototype=Object.create(t.prototype),Object.defineProperties(r.prototype,{kmlScale:{get:function(){return this._factory.specific(this,{name:"scale",transformer:i.number})}}}),r.update=function(){},r.prototype.getTagNames=function(){return["LabelStyle"]},e.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/styles/KmlLineStyle",["../../../util/Color","./KmlColorStyle","./../KmlElements","../util/KmlNodeTransformers"],function(t,e,i,r){"use strict";var n=function(t){e.call(this,t)};return n.prototype=Object.create(e.prototype),Object.defineProperties(n.prototype,{kmlWidth:{get:function(){return this._factory.specific(this,{name:"width",transformer:r.number})}},kmlOuterColor:{get:function(){return this._factory.specific(this,{name:"gx:outerColor",transformer:r.string})}},kmlOuterWidth:{get:function(){return this._factory.specific(this,{name:"gx:outerWidth",transformer:r.number})}},kmlPhysicalWidth:{get:function(){return this._factory.specific(this,{name:"gx:physicalWidth",transformer:r.number})}},kmlLabelVisibility:{get:function(){return this._factory.specific(this,{name:"gx:labelVisibility",transformer:r.boolean})}}}),n.update=function(e,i){var r=i||{};return e=e||{},r._outlineColor=e.kmlColor&&t.colorFromKmlHex(e.kmlColor)||t.WHITE,r._outlineWidth=e.kmlWidth||10,r},n.prototype.getTagNames=function(){return["LineStyle"]},i.addKey(n.prototype.getTagNames()[0],n),n}),i("formats/kml/util/KmlItemIcon",["./KmlHrefResolver","./../KmlElements","../KmlObject","./KmlNodeTransformers"],function(t,e,i,r){"use strict";var n=function(t){i.call(this,t)};return n.prototype=Object.create(i.prototype),Object.defineProperties(n.prototype,{kmlState:{get:function(){return this._factory.specific(this,{name:"state",transformer:r.string})}}}),n.prototype.kmlHref=function(e){return new t(this._factory.specific(this,{name:"href",transformer:r.string}),e).url()},n.prototype.getTagNames=function(){return["ItemIcon"]},e.addKey(n.prototype.getTagNames()[0],n),n}),i("formats/kml/styles/KmlListStyle",["../util/KmlItemIcon","../KmlElements","./KmlSubStyle","../util/KmlNodeTransformers"],function(t,e,i,r){"use strict";var n=function(t){i.call(this,t)};return n.prototype=Object.create(i.prototype),Object.defineProperties(n.prototype,{kmlBgColor:{get:function(){return this._factory.specific(this,{name:"bgColor",transformer:r.string})}},kmlListItemType:{get:function(){return this._factory.specific(this,{name:"listItemType",transformer:r.string})}},kmlItemIcon:{get:function(){return this._factory.any(this,{name:t.prototype.getTagNames()})}}}),n.update=function(){},n.prototype.getTagNames=function(){return["ListStyle"]},e.addKey(n.prototype.getTagNames()[0],n),n}),i("formats/kml/styles/KmlStyle",["../../../util/Color","../../../util/Font","./KmlStyleSelector","./../KmlElements","./KmlPolyStyle","./KmlIconStyle","./KmlLabelStyle","./KmlLineStyle","./KmlListStyle","./KmlBalloonStyle","../../../util/Offset","../../../util/Promise","../../../shapes/ShapeAttributes","../../../shapes/TextAttributes"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p){"use strict";var f=function(t){i.call(this,t)};return f.prototype=Object.create(i.prototype),Object.defineProperties(f.prototype,{kmlIconStyle:{get:function(){return this._factory.any(this,{name:o.prototype.getTagNames()})}},kmlLabelStyle:{get:function(){return this._factory.any(this,{name:s.prototype.getTagNames()})}},kmlLineStyle:{get:function(){return this._factory.any(this,{name:a.prototype.getTagNames()})}},kmlPolyStyle:{get:function(){return this._factory.any(this,{name:n.prototype.getTagNames()})}},kmlBalloonStyle:{get:function(){return this._factory.any(this,{name:h.prototype.getTagNames()})}},kmlListStyle:{get:function(){return this._factory.any(this,{name:l.prototype.getTagNames()})}}}),f.prototype.generate=function(t,e){t=t||{};var i=this||{};return i.kmlIconStyle&&o.update(i.kmlIconStyle,t,e),i.kmlListStyle&&l.update(i.kmlListStyle,t),i.kmlBalloonStyle&&h.update(i.kmlBalloonStyle,t),i.kmlLabelStyle&&s.update(i.kmlLabelStyle,t),i.kmlPolyStyle&&n.update(i.kmlPolyStyle,t),i.kmlLineStyle&&a.update(i.kmlLineStyle,t),t},f.prototype.getStyle=function(){var t=this;return new c(function(e){window.setTimeout(function(){e(t)},0)})},f.prototype.getTagNames=function(){return["Style"]},r.addKey(f.prototype.getTagNames()[0],f),f.placemarkAttributes=function(e){return e=e||{},e._imageColor=e._imageColor||new t(1,1,1,1),e._imageOffset=e._imageOffset||new u(WorldWind.OFFSET_FRACTION,.5,WorldWind.OFFSET_FRACTION,.5),e._imageScale=e._imageScale||1,e._imageSource=e._imageSource||null,e._depthTest=e._depthTest||!0,e._labelAttributes=e._labelAttributes||new p(f.textAttributes()),e._drawLeaderLine=e._drawLeaderLine||!1,e._leaderLineAttributes=e._leaderLineAttributes||new d(f.shapeAttributes()),e},f.textAttributes=function(i){return i=i||{},i._color=i._color||new t(1,1,1,1),i._font=i._font||new e(14),i._offset=i._offset||new u(WorldWind.OFFSET_FRACTION,.5,WorldWind.OFFSET_FRACTION,0),i._scale=i._scale||1,i._depthTest=i._depthTest||!1,i._outlineColor=i._outlineColor||t.RED,i},f.shapeAttributes=function(e){return e=e||{},e._drawInterior=e._drawInterior||!0,e._drawOutline=e._drawOutline||!0,e._enableLighting=e._enableLighting||!1,e._interiorColor=e._interiorColor||t.WHITE,e._outlineColor=e._outlineColor||t.RED,e._outlineWidth=e._outlineWidth||1,e._outlineStippleFactor=e._outlineStippleFactor||0,e._outlineStipplePattern=e._outlineStipplePattern||61680,e._imageSource=e._imageSource||null,e._depthTest=e._depthTest||!0,e._drawVerticals=e._drawVerticals||!1,e._applyLighting=e._applyLighting||!1,e},f.default=function(){return new f({objectNode:document.createElement("Style")})},f}),i("formats/kml/util/KmlPair",["./../KmlElements","../KmlObject","../styles/KmlStyleSelector","./KmlNodeTransformers"],function(t,e,i,r){"use strict";var n=function(t){e.call(this,t)};return n.prototype=Object.create(e.prototype),Object.defineProperties(n.prototype,{kmlKey:{get:function(){return this._factory.specific(this,{name:"key",transformer:r.string})}},kmlStyleUrl:{get:function(){return this._factory.specific(this,{name:"styleUrl",transformer:r.string})}},kmlStyleSelector:{get:function(){return this._factory.any(this,{name:i.prototype.getTagNames()})}}}),n.prototype.getTagNames=function(){return["Pair"]},n.prototype.getStyle=function(t){return t.handleRemoteStyle(this.kmlStyleUrl,this.kmlStyleSelector)},t.addKey(n.prototype.getTagNames()[0],n),n}),i("formats/kml/styles/KmlStyleMap",["../KmlElements","./KmlSubStyle","../util/KmlPair","../../../util/Promise"],function(t,e,i,r){"use strict";var n=function(t){e.call(this,t)};return n.prototype=Object.create(e.prototype),Object.defineProperties(n.prototype,{kmlPairs:{get:function(){return this._factory.all(this)}},isMap:{get:function(){return!0}}}),n.prototype.resolve=function(t){var e={},i=this.kmlPairs.map(function(i){var r=i.kmlKey;return i.getStyle(t).then(function(t){e[r]=t.normal})});return r.all(i).then(function(){return e.normal||(e.normal=null),e.highlight||(e.highlight=null),e})},n.prototype.getTagNames=function(){return["StyleMap"]},t.addKey(n.prototype.getTagNames()[0],n),n}),i("formats/kml/KmlTimeSpan",["./KmlElements","./KmlTimePrimitive","./util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){t.isTimeSpan=!0,e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlBegin:{get:function(){return this._factory.specific(this,{name:"begin",transformer:i.date})}},kmlEnd:{get:function(){return this._factory.specific(this,{name:"end",transformer:i.date})}}}),r.prototype.getTagNames=function(){return["TimeSpan"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/KmlTimeStamp",["./KmlElements","./KmlTimePrimitive","./util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){t.isTimeStamp=!0,e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlWhen:{get:function(){return this._factory.specific(this,{name:"when",transformer:i.date})}}}),r.prototype.getTagNames=function(){return["TimeStamp"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("util/jszip",[],function(){return function(t){function e(r){if(i[r])return i[r].exports;var n=i[r]={i:r,l:!1,exports:{}};return t[r].call(n.exports,n,n.exports,e),n.l=!0,n.exports}var i={};return e.m=t,e.c=i,e.d=function(t,i,r){e.o(t,i)||Object.defineProperty(t,i,{enumerable:!0,get:r})},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.t=function(t,i){if(1&i&&(t=e(t)),8&i)return t;if(4&i&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(e.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&i&&"string"!=typeof t)for(var n in t)e.d(r,n,function(e){
return t[e]}.bind(null,n));return r},e.n=function(t){var i=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(i,"a",i),i},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=104)}([function(t,e,i){"use strict";function r(t){return t}function n(t,e){for(var i=0;i<t.length;++i)e[i]=255&t.charCodeAt(i);return e}function o(t){var i=65536,r=e.getTypeOf(t),n=!0;if("uint8array"===r?n=d.applyCanBeUsed.uint8array:"nodebuffer"===r&&(n=d.applyCanBeUsed.nodebuffer),n)for(;i>1;)try{return d.stringifyByChunk(t,r,i)}catch(t){i=Math.floor(i/2)}return d.stringifyByChar(t)}function s(t,e){for(var i=0;i<t.length;i++)e[i]=t[i];return e}var a=i(3),l=i(44),h=i(12),u=i(88),c=i(8);e.newBlob=function(t,i){e.checkSupport("blob");try{return new Blob([t],{type:i})}catch(e){try{var r=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);return r.append(t),r.getBlob(i)}catch(t){throw new Error("Bug : can't construct the Blob.")}}};var d={stringifyByChunk:function(t,e,i){var r=[],n=0,o=t.length;if(o<=i)return String.fromCharCode.apply(null,t);for(;n<o;)"array"===e||"nodebuffer"===e?r.push(String.fromCharCode.apply(null,t.slice(n,Math.min(n+i,o)))):r.push(String.fromCharCode.apply(null,t.subarray(n,Math.min(n+i,o)))),n+=i;return r.join("")},stringifyByChar:function(t){for(var e="",i=0;i<t.length;i++)e+=String.fromCharCode(t[i]);return e},applyCanBeUsed:{uint8array:function(){try{return a.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(t){return!1}}(),nodebuffer:function(){try{return a.nodebuffer&&1===String.fromCharCode.apply(null,h.allocBuffer(1)).length}catch(t){return!1}}()}};e.applyFromCharCode=o;var p={};p.string={string:r,array:function(t){return n(t,new Array(t.length))},arraybuffer:function(t){return p.string.uint8array(t).buffer},uint8array:function(t){return n(t,new Uint8Array(t.length))},nodebuffer:function(t){return n(t,h.allocBuffer(t.length))}},p.array={string:o,array:r,arraybuffer:function(t){return new Uint8Array(t).buffer},uint8array:function(t){return new Uint8Array(t)},nodebuffer:function(t){return h.newBufferFrom(t)}},p.arraybuffer={string:function(t){return o(new Uint8Array(t))},array:function(t){return s(new Uint8Array(t),new Array(t.byteLength))},arraybuffer:r,uint8array:function(t){return new Uint8Array(t)},nodebuffer:function(t){return h.newBufferFrom(new Uint8Array(t))}},p.uint8array={string:o,array:function(t){return s(t,new Array(t.length))},arraybuffer:function(t){return t.buffer},uint8array:r,nodebuffer:function(t){return h.newBufferFrom(t)}},p.nodebuffer={string:o,array:function(t){return s(t,new Array(t.length))},arraybuffer:function(t){return p.nodebuffer.uint8array(t).buffer},uint8array:function(t){return s(t,new Uint8Array(t.length))},nodebuffer:r},e.transformTo=function(t,i){if(i||(i=""),!t)return i;e.checkSupport(t);var r=e.getTypeOf(i);return p[r][t](i)},e.getTypeOf=function(t){return"string"==typeof t?"string":"[object Array]"===Object.prototype.toString.call(t)?"array":a.nodebuffer&&h.isBuffer(t)?"nodebuffer":a.uint8array&&t instanceof Uint8Array?"uint8array":a.arraybuffer&&t instanceof ArrayBuffer?"arraybuffer":void 0},e.checkSupport=function(t){if(!a[t.toLowerCase()])throw new Error(t+" is not supported by this platform")},e.MAX_VALUE_16BITS=65535,e.MAX_VALUE_32BITS=-1,e.pretty=function(t){var e,i,r="";for(i=0;i<(t||"").length;i++)r+="\\x"+((e=t.charCodeAt(i))<16?"0":"")+e.toString(16).toUpperCase();return r},e.delay=function(t,e,i){u(function(){t.apply(i||null,e||[])})},e.inherits=function(t,e){var i=function(){};i.prototype=e.prototype,t.prototype=new i},e.extend=function(){var t,e,i={};for(t=0;t<arguments.length;t++)for(e in arguments[t])arguments[t].hasOwnProperty(e)&&void 0===i[e]&&(i[e]=arguments[t][e]);return i},e.prepareContent=function(t,i,r,o,s){return c.Promise.resolve(i).then(function(t){return a.blob&&(t instanceof Blob||-1!==["[object File]","[object Blob]"].indexOf(Object.prototype.toString.call(t)))&&"undefined"!=typeof FileReader?new c.Promise(function(e,i){var r=new FileReader;r.onload=function(t){e(t.target.result)},r.onerror=function(t){i(t.target.error)},r.readAsArrayBuffer(t)}):t}).then(function(i){var h=e.getTypeOf(i);return h?("arraybuffer"===h?i=e.transformTo("uint8array",i):"string"===h&&(s?i=l.decode(i):r&&!0!==o&&(i=function(t){return n(t,a.uint8array?new Uint8Array(t.length):new Array(t.length))}(i))),i):c.Promise.reject(new Error("Can't read the data of '"+t+"'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))})}},function(t,e,i){"use strict";function r(t){this.name=t||"default",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null}r.prototype={push:function(t){this.emit("data",t)},end:function(){if(this.isFinished)return!1;this.flush();try{this.emit("end"),this.cleanUp(),this.isFinished=!0}catch(t){this.emit("error",t)}return!0},error:function(t){return!this.isFinished&&(this.isPaused?this.generatedError=t:(this.isFinished=!0,this.emit("error",t),this.previous&&this.previous.error(t),this.cleanUp()),!0)},on:function(t,e){return this._listeners[t].push(e),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[]},emit:function(t,e){if(this._listeners[t])for(var i=0;i<this._listeners[t].length;i++)this._listeners[t][i].call(this,e)},pipe:function(t){return t.registerPrevious(this)},registerPrevious:function(t){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.streamInfo=t.streamInfo,this.mergeStreamInfo(),this.previous=t;var e=this;return t.on("data",function(t){e.processChunk(t)}),t.on("end",function(){e.end()}),t.on("error",function(t){e.error(t)}),this},pause:function(){return!this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return!1;this.isPaused=!1;var t=!1;return this.generatedError&&(this.error(this.generatedError),t=!0),this.previous&&this.previous.resume(),!t},flush:function(){},processChunk:function(t){this.push(t)},withStreamInfo:function(t,e){return this.extraStreamInfo[t]=e,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var t in this.extraStreamInfo)this.extraStreamInfo.hasOwnProperty(t)&&(this.streamInfo[t]=this.extraStreamInfo[t])},lock:function(){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.isLocked=!0,this.previous&&this.previous.lock()},toString:function(){var t="Worker "+this.name;return this.previous?this.previous+" -> "+t:t}},t.exports=r},function(t,e,i){"use strict";var r="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;e.assign=function(t){for(var e=Array.prototype.slice.call(arguments,1);e.length;){var i=e.shift();if(i){if("object"!=typeof i)throw new TypeError(i+"must be non-object");for(var r in i)i.hasOwnProperty(r)&&(t[r]=i[r])}}return t},e.shrinkBuf=function(t,e){return t.length===e?t:t.subarray?t.subarray(0,e):(t.length=e,t)};var n={arraySet:function(t,e,i,r,n){if(e.subarray&&t.subarray)t.set(e.subarray(i,i+r),n);else for(var o=0;o<r;o++)t[n+o]=e[i+o]},flattenChunks:function(t){var e,i,r,n,o,s;for(r=0,e=0,i=t.length;e<i;e++)r+=t[e].length;for(s=new Uint8Array(r),n=0,e=0,i=t.length;e<i;e++)o=t[e],s.set(o,n),n+=o.length;return s}},o={arraySet:function(t,e,i,r,n){for(var o=0;o<r;o++)t[n+o]=e[i+o]},flattenChunks:function(t){return[].concat.apply([],t)}};e.setTyped=function(t){t?(e.Buf8=Uint8Array,e.Buf16=Uint16Array,e.Buf32=Int32Array,e.assign(e,n)):(e.Buf8=Array,e.Buf16=Array,e.Buf32=Array,e.assign(e,o))},e.setTyped(r)},function(t,e,i){"use strict";(function(t){if(e.base64=!0,e.array=!0,e.string=!0,e.arraybuffer="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,e.nodebuffer=void 0!==t,e.uint8array="undefined"!=typeof Uint8Array,"undefined"==typeof ArrayBuffer)e.blob=!1;else{var r=new ArrayBuffer(0);try{e.blob=0===new Blob([r],{type:"application/zip"}).size}catch(t){try{var n=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);n.append(r),e.blob=0===n.getBlob("application/zip").size}catch(t){e.blob=!1}}}try{e.nodestream=!!i(50).Readable}catch(t){e.nodestream=!1}}).call(this,i(10).Buffer)},function(t,e,i){"use strict";function r(t){return this instanceof r?(h.call(this,t),u.call(this,t),t&&!1===t.readable&&(this.readable=!1),t&&!1===t.writable&&(this.writable=!1),this.allowHalfOpen=!0,t&&!1===t.allowHalfOpen&&(this.allowHalfOpen=!1),this.once("end",n),void 0):new r(t)}function n(){this.allowHalfOpen||this._writableState.ended||s.nextTick(o,this)}function o(t){t.end()}var s=i(14),a=Object.keys||function(t){var e=[];for(var i in t)e.push(i);return e};t.exports=r;var l=i(9);l.inherits=i(6);var h=i(49),u=i(21);l.inherits(r,h);for(var c=a(u.prototype),d=0;d<c.length;d++){var p=c[d];r.prototype[p]||(r.prototype[p]=u.prototype[p])}Object.defineProperty(r.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),Object.defineProperty(r.prototype,"destroyed",{get:function(){return void 0!==this._readableState&&void 0!==this._writableState&&this._readableState.destroyed&&this._writableState.destroyed},set:function(t){void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=t,this._writableState.destroyed=t)}}),r.prototype._destroy=function(t,e){this.push(null),this.end(),s.nextTick(e,t)}},function(t,e){var i;i=function(){return this}();try{i=i||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(i=window)}t.exports=i},function(t,e){"function"==typeof Object.create?t.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}})}:t.exports=function(t,e){t.super_=e;var i=function(){};i.prototype=e.prototype,t.prototype=new i,t.prototype.constructor=t}},function(t,e,i){"use strict";function r(){l.call(this,"utf-8 decode"),this.leftOver=null}function n(){l.call(this,"utf-8 encode")}for(var o=i(0),s=i(3),a=i(12),l=i(1),h=new Array(256),u=0;u<256;u++)h[u]=u>=252?6:u>=248?5:u>=240?4:u>=224?3:u>=192?2:1;h[254]=h[254]=1,e.utf8encode=function(t){return s.nodebuffer?a.newBufferFrom(t,"utf-8"):function(t){var e,i,r,n,o,a=t.length,l=0;for(n=0;n<a;n++)55296==(64512&(i=t.charCodeAt(n)))&&n+1<a&&56320==(64512&(r=t.charCodeAt(n+1)))&&(i=65536+(i-55296<<10)+(r-56320),n++),l+=i<128?1:i<2048?2:i<65536?3:4;for(e=s.uint8array?new Uint8Array(l):new Array(l),o=0,n=0;o<l;n++)55296==(64512&(i=t.charCodeAt(n)))&&n+1<a&&56320==(64512&(r=t.charCodeAt(n+1)))&&(i=65536+(i-55296<<10)+(r-56320),n++),i<128?e[o++]=i:i<2048?(e[o++]=192|i>>>6,e[o++]=128|63&i):i<65536?(e[o++]=224|i>>>12,e[o++]=128|i>>>6&63,e[o++]=128|63&i):(e[o++]=240|i>>>18,e[o++]=128|i>>>12&63,e[o++]=128|i>>>6&63,e[o++]=128|63&i);return e}(t)},e.utf8decode=function(t){return s.nodebuffer?o.transformTo("nodebuffer",t).toString("utf-8"):function(t){var e,i,r,n,s=t.length,a=new Array(2*s);for(i=0,e=0;e<s;)if((r=t[e++])<128)a[i++]=r;else if((n=h[r])>4)a[i++]=65533,e+=n-1;else{for(r&=2===n?31:3===n?15:7;n>1&&e<s;)r=r<<6|63&t[e++],n--;n>1?a[i++]=65533:r<65536?a[i++]=r:(r-=65536,a[i++]=55296|r>>10&1023,a[i++]=56320|1023&r)}return a.length!==i&&(a.subarray?a=a.subarray(0,i):a.length=i),o.applyFromCharCode(a)}(t=o.transformTo(s.uint8array?"uint8array":"array",t))},o.inherits(r,l),r.prototype.processChunk=function(t){var i=o.transformTo(s.uint8array?"uint8array":"array",t.data);if(this.leftOver&&this.leftOver.length){if(s.uint8array){var r=i;(i=new Uint8Array(r.length+this.leftOver.length)).set(this.leftOver,0),i.set(r,this.leftOver.length)}else i=this.leftOver.concat(i);this.leftOver=null}var n=function(t,e){var i;for((e=e||t.length)>t.length&&(e=t.length),i=e-1;i>=0&&128==(192&t[i]);)i--;return i<0?e:0===i?e:i+h[t[i]]>e?i:e}(i),a=i;n!==i.length&&(s.uint8array?(a=i.subarray(0,n),this.leftOver=i.subarray(n,i.length)):(a=i.slice(0,n),this.leftOver=i.slice(n,i.length))),this.push({data:e.utf8decode(a),meta:t.meta})},r.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:e.utf8decode(this.leftOver),meta:{}}),this.leftOver=null)},e.Utf8DecodeWorker=r,o.inherits(n,l),n.prototype.processChunk=function(t){this.push({data:e.utf8encode(t.data),meta:t.meta})},e.Utf8EncodeWorker=n},function(t,e,i){"use strict";var r=null;r="undefined"!=typeof Promise?Promise:i(74),t.exports={Promise:r}},function(t,e,i){(function(t){function i(t){return Object.prototype.toString.call(t)}e.isArray=function(t){return Array.isArray?Array.isArray(t):"[object Array]"===i(t)},e.isBoolean=function(t){return"boolean"==typeof t},e.isNull=function(t){return null===t},e.isNullOrUndefined=function(t){return null==t},e.isNumber=function(t){return"number"==typeof t},e.isString=function(t){return"string"==typeof t},e.isSymbol=function(t){return"symbol"==typeof t},e.isUndefined=function(t){return void 0===t},e.isRegExp=function(t){return"[object RegExp]"===i(t)},e.isObject=function(t){return"object"==typeof t&&null!==t},e.isDate=function(t){return"[object Date]"===i(t)},e.isError=function(t){return"[object Error]"===i(t)||t instanceof Error},e.isFunction=function(t){return"function"==typeof t},e.isPrimitive=function(t){return null===t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||"symbol"==typeof t||void 0===t},e.isBuffer=t.isBuffer}).call(this,i(10).Buffer)},function(t,e,i){"use strict";(function(t){function r(){return o.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function n(t,e){if(r()<e)throw new RangeError("Invalid typed array length");return o.TYPED_ARRAY_SUPPORT?(t=new Uint8Array(e)).__proto__=o.prototype:(null===t&&(t=new o(e)),t.length=e),t}function o(t,e,i){if(!(o.TYPED_ARRAY_SUPPORT||this instanceof o))return new o(t,e,i);if("number"==typeof t){if("string"==typeof e)throw new Error("If encoding is specified then the first argument must be a string");return l(this,t)}return s(this,t,e,i)}function s(t,e,i,r){if("number"==typeof e)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer?function(t,e,i,r){if(e.byteLength,i<0||e.byteLength<i)throw new RangeError("'offset' is out of bounds");if(e.byteLength<i+(r||0))throw new RangeError("'length' is out of bounds");return e=void 0===i&&void 0===r?new Uint8Array(e):void 0===r?new Uint8Array(e,i):new Uint8Array(e,i,r),o.TYPED_ARRAY_SUPPORT?(t=e).__proto__=o.prototype:t=h(t,e),t}(t,e,i,r):"string"==typeof e?function(t,e,i){if("string"==typeof i&&""!==i||(i="utf8"),!o.isEncoding(i))throw new TypeError('"encoding" must be a valid string encoding');var r=0|c(e,i),s=(t=n(t,r)).write(e,i);return s!==r&&(t=t.slice(0,s)),t}(t,e,i):function(t,e){if(o.isBuffer(e)){var i=0|u(e.length);return 0===(t=n(t,i)).length?t:(e.copy(t,0,0,i),t)}if(e){if("undefined"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||"length"in e)return"number"!=typeof e.length||function(t){return t!=t}(e.length)?n(t,0):h(t,e);if("Buffer"===e.type&&W(e.data))return h(t,e.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(t,e)}function a(t){if("number"!=typeof t)throw new TypeError('"size" argument must be a number');if(t<0)throw new RangeError('"size" argument must not be negative')}function l(t,e){if(a(e),t=n(t,e<0?0:0|u(e)),!o.TYPED_ARRAY_SUPPORT)for(var i=0;i<e;++i)t[i]=0;return t}function h(t,e){var i=e.length<0?0:0|u(e.length);t=n(t,i);for(var r=0;r<i;r+=1)t[r]=255&e[r];return t}function u(t){if(t>=r())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+r().toString(16)+" bytes");return 0|t}function c(t,e){if(o.isBuffer(t))return t.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer))return t.byteLength;"string"!=typeof t&&(t=""+t);var i=t.length;if(0===i)return 0;for(var r=!1;;)switch(e){case"ascii":case"latin1":case"binary":return i;case"utf8":case"utf-8":case void 0:return D(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*i;case"hex":return i>>>1;case"base64":return k(t).length;default:if(r)return D(t).length;e=(""+e).toLowerCase(),r=!0}}function d(t,e,i){var r=t[e];t[e]=t[i],t[i]=r}function p(t,e,i,r,n){if(0===t.length)return-1;if("string"==typeof i?(r=i,i=0):i>2147483647?i=2147483647:i<-2147483648&&(i=-2147483648),i=+i,isNaN(i)&&(i=n?0:t.length-1),i<0&&(i=t.length+i),i>=t.length){if(n)return-1;i=t.length-1}else if(i<0){if(!n)return-1;i=0}if("string"==typeof e&&(e=o.from(e,r)),o.isBuffer(e))return 0===e.length?-1:f(t,e,i,r,n);if("number"==typeof e)return e&=255,o.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?n?Uint8Array.prototype.indexOf.call(t,e,i):Uint8Array.prototype.lastIndexOf.call(t,e,i):f(t,[e],i,r,n);throw new TypeError("val must be string, number or Buffer")}function f(t,e,i,r,n){function o(t,e){return 1===a?t[e]:t.readUInt16BE(e*a)}var s,a=1,l=t.length,h=e.length;if(void 0!==r&&("ucs2"===(r=String(r).toLowerCase())||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(t.length<2||e.length<2)return-1;a=2,l/=2,h/=2,i/=2}if(n){var u=-1;for(s=i;s<l;s++)if(o(t,s)===o(e,-1===u?0:s-u)){if(-1===u&&(u=s),s-u+1===h)return u*a}else-1!==u&&(s-=s-u),u=-1}else for(i+h>l&&(i=l-h),s=i;s>=0;s--){for(var c=!0,d=0;d<h;d++)if(o(t,s+d)!==o(e,d)){c=!1;break}if(c)return s}return-1}function g(t,e,i,r){i=Number(i)||0;var n=t.length-i;r?(r=Number(r))>n&&(r=n):r=n;var o=e.length;if(o%2!=0)throw new TypeError("Invalid hex string");r>o/2&&(r=o/2);for(var s=0;s<r;++s){var a=parseInt(e.substr(2*s,2),16);if(isNaN(a))return s;t[i+s]=a}return s}function m(t,e,i,r){return F(D(e,t.length-i),t,i,r)}function y(t,e,i,r){return F(function(t){for(var e=[],i=0;i<t.length;++i)e.push(255&t.charCodeAt(i));return e}(e),t,i,r)}function E(t,e,i,r){return y(t,e,i,r)}function v(t,e,i,r){return F(k(e),t,i,r)}function _(t,e,i,r){return F(function(t,e){for(var i,r,n,o=[],s=0;s<t.length&&!((e-=2)<0);++s)i=t.charCodeAt(s),r=i>>8,n=i%256,o.push(n),o.push(r);return o}(e,t.length-i),t,i,r)}function b(t,e,i){return 0===e&&i===t.length?V.fromByteArray(t):V.fromByteArray(t.slice(e,i))}function w(t,e,i){i=Math.min(t.length,i);for(var r=[],n=e;n<i;){var o,s,a,l,h=t[n],u=null,c=h>239?4:h>223?3:h>191?2:1;if(n+c<=i)switch(c){case 1:h<128&&(u=h);break;case 2:128==(192&(o=t[n+1]))&&(l=(31&h)<<6|63&o)>127&&(u=l);break;case 3:o=t[n+1],s=t[n+2],128==(192&o)&&128==(192&s)&&(l=(15&h)<<12|(63&o)<<6|63&s)>2047&&(l<55296||l>57343)&&(u=l);break;case 4:o=t[n+1],s=t[n+2],a=t[n+3],128==(192&o)&&128==(192&s)&&128==(192&a)&&(l=(15&h)<<18|(63&o)<<12|(63&s)<<6|63&a)>65535&&l<1114112&&(u=l)}null===u?(u=65533,c=1):u>65535&&(u-=65536,r.push(u>>>10&1023|55296),u=56320|1023&u),r.push(u),n+=c}return function(t){var e=t.length;if(e<=B)return String.fromCharCode.apply(String,t);for(var i="",r=0;r<e;)i+=String.fromCharCode.apply(String,t.slice(r,r+=B));return i}(r)}function S(t,e,i){var r="";i=Math.min(t.length,i);for(var n=e;n<i;++n)r+=String.fromCharCode(127&t[n]);return r}function L(t,e,i){var r="";i=Math.min(t.length,i);for(var n=e;n<i;++n)r+=String.fromCharCode(t[n]);return r}function T(t,e,i){var r=t.length;(!e||e<0)&&(e=0),(!i||i<0||i>r)&&(i=r);for(var n="",o=e;o<i;++o)n+=I(t[o]);return n}function A(t,e,i){for(var r=t.slice(e,i),n="",o=0;o<r.length;o+=2)n+=String.fromCharCode(r[o]+256*r[o+1]);return n}function R(t,e,i){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+e>i)throw new RangeError("Trying to access beyond buffer length")}function x(t,e,i,r,n,s){if(!o.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>n||e<s)throw new RangeError('"value" argument is out of bounds');if(i+r>t.length)throw new RangeError("Index out of range")}function C(t,e,i,r){e<0&&(e=65535+e+1);for(var n=0,o=Math.min(t.length-i,2);n<o;++n)t[i+n]=(e&255<<8*(r?n:1-n))>>>8*(r?n:1-n)}function M(t,e,i,r){e<0&&(e=4294967295+e+1);for(var n=0,o=Math.min(t.length-i,4);n<o;++n)t[i+n]=e>>>8*(r?n:3-n)&255}function P(t,e,i,r,n,o){if(i+r>t.length)throw new RangeError("Index out of range");if(i<0)throw new RangeError("Index out of range")}function O(t,e,i,r,n){return n||P(t,0,i,4),G.write(t,e,i,r,23,4),i+4}function N(t,e,i,r,n){return n||P(t,0,i,8),G.write(t,e,i,r,52,8),i+8}function I(t){return t<16?"0"+t.toString(16):t.toString(16)}function D(t,e){var i;e=e||1/0;for(var r=t.length,n=null,o=[],s=0;s<r;++s){if((i=t.charCodeAt(s))>55295&&i<57344){if(!n){if(i>56319){(e-=3)>-1&&o.push(239,191,189);continue}if(s+1===r){(e-=3)>-1&&o.push(239,191,189);continue}n=i;continue}if(i<56320){(e-=3)>-1&&o.push(239,191,189),n=i;continue}i=65536+(n-55296<<10|i-56320)}else n&&(e-=3)>-1&&o.push(239,191,189);if(n=null,i<128){if((e-=1)<0)break;o.push(i)}else if(i<2048){if((e-=2)<0)break;o.push(i>>6|192,63&i|128)}else if(i<65536){if((e-=3)<0)break;o.push(i>>12|224,i>>6&63|128,63&i|128)}else{if(!(i<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;o.push(i>>18|240,i>>12&63|128,i>>6&63|128,63&i|128)}}return o}function k(t){return V.toByteArray(function(t){if((t=function(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}(t).replace(U,"")).length<2)return"";for(;t.length%4!=0;)t+="=";return t}(t))}function F(t,e,i,r){for(var n=0;n<r&&!(n+i>=e.length||n>=t.length);++n)e[n+i]=t[n];return n}var V=i(102),G=i(101),W=i(51);e.Buffer=o,e.SlowBuffer=function(t){return+t!=t&&(t=0),o.alloc(+t)},e.INSPECT_MAX_BYTES=50,o.TYPED_ARRAY_SUPPORT=void 0!==t.TYPED_ARRAY_SUPPORT?t.TYPED_ARRAY_SUPPORT:function(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()&&"function"==typeof t.subarray&&0===t.subarray(1,1).byteLength}catch(t){return!1}}(),e.kMaxLength=r(),o.poolSize=8192,o._augment=function(t){return t.__proto__=o.prototype,t},o.from=function(t,e,i){return s(null,t,e,i)},o.TYPED_ARRAY_SUPPORT&&(o.prototype.__proto__=Uint8Array.prototype,o.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&o[Symbol.species]===o&&Object.defineProperty(o,Symbol.species,{value:null,configurable:!0})),o.alloc=function(t,e,i){return function(t,e,i,r){return a(e),e<=0?n(t,e):void 0!==i?"string"==typeof r?n(t,e).fill(i,r):n(t,e).fill(i):n(t,e)}(null,t,e,i)},o.allocUnsafe=function(t){return l(null,t)},o.allocUnsafeSlow=function(t){return l(null,t)},o.isBuffer=function(t){return!(null==t||!t._isBuffer)},o.compare=function(t,e){if(!o.isBuffer(t)||!o.isBuffer(e))throw new TypeError("Arguments must be Buffers");if(t===e)return 0;for(var i=t.length,r=e.length,n=0,s=Math.min(i,r);n<s;++n)if(t[n]!==e[n]){i=t[n],r=e[n];break}return i<r?-1:r<i?1:0},o.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},o.concat=function(t,e){if(!W(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return o.alloc(0);var i;if(void 0===e)for(e=0,i=0;i<t.length;++i)e+=t[i].length;var r=o.allocUnsafe(e),n=0;for(i=0;i<t.length;++i){var s=t[i];if(!o.isBuffer(s))throw new TypeError('"list" argument must be an Array of Buffers');s.copy(r,n),n+=s.length}return r},o.byteLength=c,o.prototype._isBuffer=!0,o.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;e<t;e+=2)d(this,e,e+1);return this},o.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;e<t;e+=4)d(this,e,e+3),d(this,e+1,e+2);return this},o.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;e<t;e+=8)d(this,e,e+7),d(this,e+1,e+6),d(this,e+2,e+5),d(this,e+3,e+4);return this},o.prototype.toString=function(){var t=0|this.length;return 0===t?"":0===arguments.length?w(this,0,t):function(t,e,i){var r=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===i||i>this.length)&&(i=this.length),i<=0)return"";if((i>>>=0)<=(e>>>=0))return"";for(t||(t="utf8");;)switch(t){case"hex":return T(this,e,i);case"utf8":case"utf-8":return w(this,e,i);case"ascii":return S(this,e,i);case"latin1":case"binary":return L(this,e,i);case"base64":return b(this,e,i);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return A(this,e,i);default:if(r)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),r=!0}}.apply(this,arguments)},o.prototype.equals=function(t){if(!o.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t||0===o.compare(this,t)},o.prototype.inspect=function(){var t="",i=e.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString("hex",0,i).match(/.{2}/g).join(" "),this.length>i&&(t+=" ... ")),"<Buffer "+t+">"},o.prototype.compare=function(t,e,i,r,n){if(!o.isBuffer(t))throw new TypeError("Argument must be a Buffer");if(void 0===e&&(e=0),void 0===i&&(i=t?t.length:0),void 0===r&&(r=0),void 0===n&&(n=this.length),e<0||i>t.length||r<0||n>this.length)throw new RangeError("out of range index");if(r>=n&&e>=i)return 0;if(r>=n)return-1;if(e>=i)return 1;if(e>>>=0,i>>>=0,r>>>=0,n>>>=0,this===t)return 0;for(var s=n-r,a=i-e,l=Math.min(s,a),h=this.slice(r,n),u=t.slice(e,i),c=0;c<l;++c)if(h[c]!==u[c]){s=h[c],a=u[c];break}return s<a?-1:a<s?1:0},o.prototype.includes=function(t,e,i){return-1!==this.indexOf(t,e,i)},o.prototype.indexOf=function(t,e,i){return p(this,t,e,i,!0)},o.prototype.lastIndexOf=function(t,e,i){return p(this,t,e,i,!1)},o.prototype.write=function(t,e,i,r){if(void 0===e)r="utf8",i=this.length,e=0;else if(void 0===i&&"string"==typeof e)r=e,i=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e|=0,isFinite(i)?(i|=0,void 0===r&&(r="utf8")):(r=i,i=void 0)}var n=this.length-e;if((void 0===i||i>n)&&(i=n),t.length>0&&(i<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var o=!1;;)switch(r){case"hex":return g(this,t,e,i);case"utf8":case"utf-8":return m(this,t,e,i);case"ascii":return y(this,t,e,i);case"latin1":case"binary":return E(this,t,e,i);case"base64":return v(this,t,e,i);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return _(this,t,e,i);default:if(o)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),o=!0}},o.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var B=4096;o.prototype.slice=function(t,e){var i,r=this.length;if(t=~~t,e=void 0===e?r:~~e,t<0?(t+=r)<0&&(t=0):t>r&&(t=r),e<0?(e+=r)<0&&(e=0):e>r&&(e=r),e<t&&(e=t),o.TYPED_ARRAY_SUPPORT)(i=this.subarray(t,e)).__proto__=o.prototype;else{var n=e-t;i=new o(n,void 0);for(var s=0;s<n;++s)i[s]=this[s+t]}return i},o.prototype.readUIntLE=function(t,e,i){t|=0,e|=0,i||R(t,e,this.length);for(var r=this[t],n=1,o=0;++o<e&&(n*=256);)r+=this[t+o]*n;return r},o.prototype.readUIntBE=function(t,e,i){t|=0,e|=0,i||R(t,e,this.length);for(var r=this[t+--e],n=1;e>0&&(n*=256);)r+=this[t+--e]*n;return r},o.prototype.readUInt8=function(t,e){return e||R(t,1,this.length),this[t]},o.prototype.readUInt16LE=function(t,e){return e||R(t,2,this.length),this[t]|this[t+1]<<8},o.prototype.readUInt16BE=function(t,e){return e||R(t,2,this.length),this[t]<<8|this[t+1]},o.prototype.readUInt32LE=function(t,e){return e||R(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},o.prototype.readUInt32BE=function(t,e){return e||R(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},o.prototype.readIntLE=function(t,e,i){t|=0,e|=0,i||R(t,e,this.length);for(var r=this[t],n=1,o=0;++o<e&&(n*=256);)r+=this[t+o]*n;return r>=(n*=128)&&(r-=Math.pow(2,8*e)),r},o.prototype.readIntBE=function(t,e,i){t|=0,e|=0,i||R(t,e,this.length);for(var r=e,n=1,o=this[t+--r];r>0&&(n*=256);)o+=this[t+--r]*n;return o>=(n*=128)&&(o-=Math.pow(2,8*e)),o},o.prototype.readInt8=function(t,e){return e||R(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},o.prototype.readInt16LE=function(t,e){e||R(t,2,this.length);var i=this[t]|this[t+1]<<8;return 32768&i?4294901760|i:i},o.prototype.readInt16BE=function(t,e){e||R(t,2,this.length);var i=this[t+1]|this[t]<<8;return 32768&i?4294901760|i:i},o.prototype.readInt32LE=function(t,e){return e||R(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},o.prototype.readInt32BE=function(t,e){return e||R(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},o.prototype.readFloatLE=function(t,e){return e||R(t,4,this.length),G.read(this,t,!0,23,4)},o.prototype.readFloatBE=function(t,e){return e||R(t,4,this.length),G.read(this,t,!1,23,4)},o.prototype.readDoubleLE=function(t,e){return e||R(t,8,this.length),G.read(this,t,!0,52,8)},o.prototype.readDoubleBE=function(t,e){return e||R(t,8,this.length),G.read(this,t,!1,52,8)},o.prototype.writeUIntLE=function(t,e,i,r){t=+t,e|=0,i|=0,r||x(this,t,e,i,Math.pow(2,8*i)-1,0);var n=1,o=0;for(this[e]=255&t;++o<i&&(n*=256);)this[e+o]=t/n&255;return e+i},o.prototype.writeUIntBE=function(t,e,i,r){t=+t,e|=0,i|=0,r||x(this,t,e,i,Math.pow(2,8*i)-1,0);var n=i-1,o=1;for(this[e+n]=255&t;--n>=0&&(o*=256);)this[e+n]=t/o&255;return e+i},o.prototype.writeUInt8=function(t,e,i){return t=+t,e|=0,i||x(this,t,e,1,255,0),o.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),this[e]=255&t,e+1},o.prototype.writeUInt16LE=function(t,e,i){return t=+t,e|=0,i||x(this,t,e,2,65535,0),o.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):C(this,t,e,!0),e+2},o.prototype.writeUInt16BE=function(t,e,i){return t=+t,e|=0,i||x(this,t,e,2,65535,0),o.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):C(this,t,e,!1),e+2},o.prototype.writeUInt32LE=function(t,e,i){return t=+t,e|=0,i||x(this,t,e,4,4294967295,0),o.TYPED_ARRAY_SUPPORT?(this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t):M(this,t,e,!0),e+4},o.prototype.writeUInt32BE=function(t,e,i){return t=+t,e|=0,i||x(this,t,e,4,4294967295,0),o.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):M(this,t,e,!1),e+4},o.prototype.writeIntLE=function(t,e,i,r){if(t=+t,e|=0,!r){var n=Math.pow(2,8*i-1);x(this,t,e,i,n-1,-n)}var o=0,s=1,a=0;for(this[e]=255&t;++o<i&&(s*=256);)t<0&&0===a&&0!==this[e+o-1]&&(a=1),this[e+o]=(t/s>>0)-a&255;return e+i},o.prototype.writeIntBE=function(t,e,i,r){if(t=+t,e|=0,!r){var n=Math.pow(2,8*i-1);x(this,t,e,i,n-1,-n)}var o=i-1,s=1,a=0;for(this[e+o]=255&t;--o>=0&&(s*=256);)t<0&&0===a&&0!==this[e+o+1]&&(a=1),this[e+o]=(t/s>>0)-a&255;return e+i},o.prototype.writeInt8=function(t,e,i){return t=+t,e|=0,i||x(this,t,e,1,127,-128),o.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),t<0&&(t=255+t+1),this[e]=255&t,e+1},o.prototype.writeInt16LE=function(t,e,i){return t=+t,e|=0,i||x(this,t,e,2,32767,-32768),o.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):C(this,t,e,!0),e+2},o.prototype.writeInt16BE=function(t,e,i){return t=+t,e|=0,i||x(this,t,e,2,32767,-32768),o.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):C(this,t,e,!1),e+2},o.prototype.writeInt32LE=function(t,e,i){return t=+t,e|=0,i||x(this,t,e,4,2147483647,-2147483648),o.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24):M(this,t,e,!0),e+4},o.prototype.writeInt32BE=function(t,e,i){return t=+t,e|=0,i||x(this,t,e,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),o.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):M(this,t,e,!1),e+4},o.prototype.writeFloatLE=function(t,e,i){return O(this,t,e,!0,i)},o.prototype.writeFloatBE=function(t,e,i){return O(this,t,e,!1,i)},o.prototype.writeDoubleLE=function(t,e,i){return N(this,t,e,!0,i)},o.prototype.writeDoubleBE=function(t,e,i){return N(this,t,e,!1,i)},o.prototype.copy=function(t,e,i,r){if(i||(i=0),r||0===r||(r=this.length),e>=t.length&&(e=t.length),e||(e=0),r>0&&r<i&&(r=i),
r===i)return 0;if(0===t.length||0===this.length)return 0;if(e<0)throw new RangeError("targetStart out of bounds");if(i<0||i>=this.length)throw new RangeError("sourceStart out of bounds");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),t.length-e<r-i&&(r=t.length-e+i);var n,s=r-i;if(this===t&&i<e&&e<r)for(n=s-1;n>=0;--n)t[n+e]=this[n+i];else if(s<1e3||!o.TYPED_ARRAY_SUPPORT)for(n=0;n<s;++n)t[n+e]=this[n+i];else Uint8Array.prototype.set.call(t,this.subarray(i,i+s),e);return s},o.prototype.fill=function(t,e,i,r){if("string"==typeof t){if("string"==typeof e?(r=e,e=0,i=this.length):"string"==typeof i&&(r=i,i=this.length),1===t.length){var n=t.charCodeAt(0);n<256&&(t=n)}if(void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!o.isEncoding(r))throw new TypeError("Unknown encoding: "+r)}else"number"==typeof t&&(t&=255);if(e<0||this.length<e||this.length<i)throw new RangeError("Out of range index");if(i<=e)return this;var s;if(e>>>=0,i=void 0===i?this.length:i>>>0,t||(t=0),"number"==typeof t)for(s=e;s<i;++s)this[s]=t;else{var a=o.isBuffer(t)?t:D(new o(t,r).toString()),l=a.length;for(s=0;s<i-e;++s)this[s+e]=a[s%l]}return this};var U=/[^+\/0-9A-Za-z-_]/g}).call(this,i(5))},function(t,e){var i=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=i)},function(t,e,i){"use strict";(function(e){t.exports={isNode:void 0!==e,newBufferFrom:function(t,i){return new e(t,i)},allocBuffer:function(t){return e.alloc?e.alloc(t):new e(t)},isBuffer:function(t){return e.isBuffer(t)},isStream:function(t){return t&&"function"==typeof t.on&&"function"==typeof t.pause&&"function"==typeof t.resume}}}).call(this,i(10).Buffer)},function(t,e,i){function r(t,e){for(var i in t)e[i]=t[i]}function n(t,e,i){return s(t,e,i)}var o=i(10),s=o.Buffer;s.from&&s.alloc&&s.allocUnsafe&&s.allocUnsafeSlow?t.exports=o:(r(o,e),e.Buffer=n),r(s,n),n.from=function(t,e,i){if("number"==typeof t)throw new TypeError("Argument must not be a number");return s(t,e,i)},n.alloc=function(t,e,i){if("number"!=typeof t)throw new TypeError("Argument must be a number");var r=s(t);return void 0!==e?"string"==typeof i?r.fill(e,i):r.fill(e):r.fill(0),r},n.allocUnsafe=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return s(t)},n.allocUnsafeSlow=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return o.SlowBuffer(t)}},function(t,e,i){"use strict";(function(e){!e.version||0===e.version.indexOf("v0.")||0===e.version.indexOf("v1.")&&0!==e.version.indexOf("v1.8.")?t.exports={nextTick:function(t,i,r,n){if("function"!=typeof t)throw new TypeError('"callback" argument must be a function');var o,s,a=arguments.length;switch(a){case 0:case 1:return e.nextTick(t);case 2:return e.nextTick(function(){t.call(null,i)});case 3:return e.nextTick(function(){t.call(null,i,r)});case 4:return e.nextTick(function(){t.call(null,i,r,n)});default:for(o=new Array(a-1),s=0;s<o.length;)o[s++]=arguments[s];return e.nextTick(function(){t.apply(null,o)})}}}:t.exports=e}).call(this,i(15))},function(t,e){function i(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function n(t){if(h===setTimeout)return setTimeout(t,0);if((h===i||!h)&&setTimeout)return h=setTimeout,setTimeout(t,0);try{return h(t,0)}catch(e){try{return h.call(null,t,0)}catch(e){return h.call(this,t,0)}}}function o(){f&&d&&(f=!1,d.length?p=d.concat(p):g=-1,p.length&&s())}function s(){if(!f){var t=n(o);f=!0;for(var e=p.length;e;){for(d=p,p=[];++g<e;)d&&d[g].run();g=-1,e=p.length}d=null,f=!1,function(t){if(u===clearTimeout)return clearTimeout(t);if((u===r||!u)&&clearTimeout)return u=clearTimeout,clearTimeout(t);try{u(t)}catch(e){try{return u.call(null,t)}catch(e){return u.call(this,t)}}}(t)}}function a(t,e){this.fun=t,this.array=e}function l(){}var h,u,c=t.exports={};!function(){try{h="function"==typeof setTimeout?setTimeout:i}catch(t){h=i}try{u="function"==typeof clearTimeout?clearTimeout:r}catch(t){u=r}}();var d,p=[],f=!1,g=-1;c.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var i=1;i<arguments.length;i++)e[i-1]=arguments[i];p.push(new a(t,e)),1!==p.length||f||n(s)},a.prototype.run=function(){this.fun.apply(null,this.array)},c.title="browser",c.browser=!0,c.env={},c.argv=[],c.version="",c.versions={},c.on=l,c.addListener=l,c.once=l,c.off=l,c.removeListener=l,c.removeAllListeners=l,c.emit=l,c.prependListener=l,c.prependOnceListener=l,c.listeners=function(t){return[]},c.binding=function(t){throw new Error("process.binding is not supported")},c.cwd=function(){return"/"},c.chdir=function(t){throw new Error("process.chdir is not supported")},c.umask=function(){return 0}},function(t,e,i){"use strict";t.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},function(t,e,i){"use strict";var r=i(0),n=function(){for(var t,e=[],i=0;i<256;i++){t=i;for(var r=0;r<8;r++)t=1&t?3988292384^t>>>1:t>>>1;e[i]=t}return e}();t.exports=function(t,e){return void 0!==t&&t.length?"string"!==r.getTypeOf(t)?function(t,e,i,r){var o=n,s=r+i;t^=-1;for(var a=r;a<s;a++)t=t>>>8^o[255&(t^e[a])];return-1^t}(0|e,t,t.length,0):function(t,e,i,r){var o=n,s=r+i;t^=-1;for(var a=r;a<s;a++)t=t>>>8^o[255&(t^e.charCodeAt(a))];return-1^t}(0|e,t,t.length,0):0}},function(t,e,i){"use strict";function r(t,e,i,r,n){this.compressedSize=t,this.uncompressedSize=e,this.crc32=i,this.compression=r,this.compressedContent=n}var n=i(8),o=i(37),s=i(36),a=i(35);s=i(36),r.prototype={getContentWorker:function(){var t=new o(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new s("data_length")),e=this;return t.on("end",function(){if(this.streamInfo.data_length!==e.uncompressedSize)throw new Error("Bug : uncompressed data size mismatch")}),t},getCompressedWorker:function(){return new o(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize",this.compressedSize).withStreamInfo("uncompressedSize",this.uncompressedSize).withStreamInfo("crc32",this.crc32).withStreamInfo("compression",this.compression)}},r.createWorkerFrom=function(t,e,i){return t.pipe(new a).pipe(new s("uncompressedSize")).pipe(e.compressWorker(i)).pipe(new s("compressedSize")).withStreamInfo("compression",e)},t.exports=r},function(t,e,i){t.exports=!i(41)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,i){"use strict";(function(e,r,n){function o(t){var e=this;this.next=null,this.entry=null,this.finish=function(){!function(t,e,i){var r=t.entry;for(t.entry=null;r;){var n=r.callback;e.pendingcb--,n(i),r=r.next}e.corkedRequestsFree?e.corkedRequestsFree.next=t:e.corkedRequestsFree=t}(e,t)}}function s(){}function a(t,e){m=m||i(4),t=t||{};var r=e instanceof m;this.objectMode=!!t.objectMode,r&&(this.objectMode=this.objectMode||!!t.writableObjectMode);var n=t.highWaterMark,s=t.writableHighWaterMark,a=this.objectMode?16:16384;this.highWaterMark=n||0===n?n:r&&(s||0===s)?s:a,this.highWaterMark=Math.floor(this.highWaterMark),this.finalCalled=!1,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1,this.destroyed=!1;var l=!1===t.decodeStrings;this.decodeStrings=!l,this.defaultEncoding=t.defaultEncoding||"utf8",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(t){!function(t,e){var i=t._writableState,r=i.sync,n=i.writecb;if(function(t){t.writing=!1,t.writecb=null,t.length-=t.writelen,t.writelen=0}(i),e)!function(t,e,i,r,n){--e.pendingcb,i?(g.nextTick(n,r),g.nextTick(f,t,e),t._writableState.errorEmitted=!0,t.emit("error",r)):(n(r),t._writableState.errorEmitted=!0,t.emit("error",r),f(t,e))}(t,i,r,e,n);else{var o=d(i);o||i.corked||i.bufferProcessing||!i.bufferedRequest||c(t,i),r?y(u,t,i,o,n):u(t,i,o,n)}}(e,t)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.bufferedRequestCount=0,this.corkedRequestsFree=new o(this)}function l(t){return m=m||i(4),v.call(l,this)||this instanceof m?(this._writableState=new a(t,this),this.writable=!0,t&&("function"==typeof t.write&&(this._write=t.write),"function"==typeof t.writev&&(this._writev=t.writev),"function"==typeof t.destroy&&(this._destroy=t.destroy),"function"==typeof t.final&&(this._final=t.final)),b.call(this),void 0):new l(t)}function h(t,e,i,r,n,o,s){e.writelen=r,e.writecb=s,e.writing=!0,e.sync=!0,i?t._writev(n,e.onwrite):t._write(n,o,e.onwrite),e.sync=!1}function u(t,e,i,r){i||function(t,e){0===e.length&&e.needDrain&&(e.needDrain=!1,t.emit("drain"))}(t,e),e.pendingcb--,r(),f(t,e)}function c(t,e){e.bufferProcessing=!0;var i=e.bufferedRequest;if(t._writev&&i&&i.next){var r=e.bufferedRequestCount,n=new Array(r),s=e.corkedRequestsFree;s.entry=i;for(var a=0,l=!0;i;)n[a]=i,i.isBuf||(l=!1),i=i.next,a+=1;n.allBuffers=l,h(t,e,!0,e.length,n,"",s.finish),e.pendingcb++,e.lastBufferedRequest=null,s.next?(e.corkedRequestsFree=s.next,s.next=null):e.corkedRequestsFree=new o(e),e.bufferedRequestCount=0}else{for(;i;){var u=i.chunk,c=i.encoding,d=i.callback;if(h(t,e,!1,e.objectMode?1:u.length,u,c,d),i=i.next,e.bufferedRequestCount--,e.writing)break}null===i&&(e.lastBufferedRequest=null)}e.bufferedRequest=i,e.bufferProcessing=!1}function d(t){return t.ending&&0===t.length&&null===t.bufferedRequest&&!t.finished&&!t.writing}function p(t,e){t._final(function(i){e.pendingcb--,i&&t.emit("error",i),e.prefinished=!0,t.emit("prefinish"),f(t,e)})}function f(t,e){var i=d(e);return i&&(!function(t,e){e.prefinished||e.finalCalled||("function"==typeof t._final?(e.pendingcb++,e.finalCalled=!0,g.nextTick(p,t,e)):(e.prefinished=!0,t.emit("prefinish")))}(t,e),0===e.pendingcb&&(e.finished=!0,t.emit("finish"))),i}var g=i(14);t.exports=l;var m,y=!e.browser&&["v0.10","v0.9."].indexOf(e.version.slice(0,5))>-1?r:g.nextTick;l.WritableState=a;var E=i(9);E.inherits=i(6);var v,_={deprecate:i(94)},b=i(48),w=i(13).Buffer,S=n.Uint8Array||function(){},L=i(47);E.inherits(l,b),a.prototype.getBuffer=function(){for(var t=this.bufferedRequest,e=[];t;)e.push(t),t=t.next;return e},function(){try{Object.defineProperty(a.prototype,"buffer",{get:_.deprecate(function(){return this.getBuffer()},"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.","DEP0003")})}catch(t){}}(),"function"==typeof Symbol&&Symbol.hasInstance&&"function"==typeof Function.prototype[Symbol.hasInstance]?(v=Function.prototype[Symbol.hasInstance],Object.defineProperty(l,Symbol.hasInstance,{value:function(t){return!!v.call(this,t)||this===l&&t&&t._writableState instanceof a}})):v=function(t){return t instanceof this},l.prototype.pipe=function(){this.emit("error",new Error("Cannot pipe, not readable"))},l.prototype.write=function(t,e,i){var r=this._writableState,n=!1,o=!r.objectMode&&function(t){return w.isBuffer(t)||t instanceof S}(t);return o&&!w.isBuffer(t)&&(t=function(t){return w.from(t)}(t)),"function"==typeof e&&(i=e,e=null),o?e="buffer":e||(e=r.defaultEncoding),"function"!=typeof i&&(i=s),r.ended?function(t,e){var i=new Error("write after end");t.emit("error",i),g.nextTick(e,i)}(this,i):(o||function(t,e,i,r){var n=!0,o=!1;return null===i?o=new TypeError("May not write null values to stream"):"string"==typeof i||void 0===i||e.objectMode||(o=new TypeError("Invalid non-string/buffer chunk")),o&&(t.emit("error",o),g.nextTick(r,o),n=!1),n}(this,r,t,i))&&(r.pendingcb++,n=function(t,e,i,r,n,o){if(!i){var s=function(t,e,i){return t.objectMode||!1===t.decodeStrings||"string"!=typeof e||(e=w.from(e,i)),e}(e,r,n);r!==s&&(i=!0,n="buffer",r=s)}var a=e.objectMode?1:r.length;e.length+=a;var l=e.length<e.highWaterMark;if(l||(e.needDrain=!0),e.writing||e.corked){var u=e.lastBufferedRequest;e.lastBufferedRequest={chunk:r,encoding:n,isBuf:i,callback:o,next:null},u?u.next=e.lastBufferedRequest:e.bufferedRequest=e.lastBufferedRequest,e.bufferedRequestCount+=1}else h(t,e,!1,a,r,n,o);return l}(this,r,o,t,e,i)),n},l.prototype.cork=function(){this._writableState.corked++},l.prototype.uncork=function(){var t=this._writableState;t.corked&&(t.corked--,t.writing||t.corked||t.finished||t.bufferProcessing||!t.bufferedRequest||c(this,t))},l.prototype.setDefaultEncoding=function(t){if("string"==typeof t&&(t=t.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((t+"").toLowerCase())>-1))throw new TypeError("Unknown encoding: "+t);return this._writableState.defaultEncoding=t,this},Object.defineProperty(l.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),l.prototype._write=function(t,e,i){i(new Error("_write() is not implemented"))},l.prototype._writev=null,l.prototype.end=function(t,e,i){var r=this._writableState;"function"==typeof t?(i=t,t=null,e=null):"function"==typeof e&&(i=e,e=null),null!==t&&void 0!==t&&this.write(t,e),r.corked&&(r.corked=1,this.uncork()),r.ending||r.finished||function(t,e,i){e.ending=!0,f(t,e),i&&(e.finished?g.nextTick(i):t.once("finish",i)),e.ended=!0,t.writable=!1}(this,r,i)},Object.defineProperty(l.prototype,"destroyed",{get:function(){return void 0!==this._writableState&&this._writableState.destroyed},set:function(t){this._writableState&&(this._writableState.destroyed=t)}}),l.prototype.destroy=L.destroy,l.prototype._undestroy=L.undestroy,l.prototype._destroy=function(t,e){this.end(),e(t)}}).call(this,i(15),i(96).setImmediate,i(5))},function(t,e,i){(e=t.exports=i(49)).Stream=e,e.Readable=e,e.Writable=i(21),e.Duplex=i(4),e.Transform=i(45),e.PassThrough=i(93)},function(t,e){function i(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function r(t){return"function"==typeof t}function n(t){return"object"==typeof t&&null!==t}function o(t){return void 0===t}t.exports=i,i.EventEmitter=i,i.prototype._events=void 0,i.prototype._maxListeners=void 0,i.defaultMaxListeners=10,i.prototype.setMaxListeners=function(t){if(!function(t){return"number"==typeof t}(t)||t<0||isNaN(t))throw TypeError("n must be a positive number");return this._maxListeners=t,this},i.prototype.emit=function(t){var e,i,s,a,l,h;if(this._events||(this._events={}),"error"===t&&(!this._events.error||n(this._events.error)&&!this._events.error.length)){if((e=arguments[1])instanceof Error)throw e;var u=new Error('Uncaught, unspecified "error" event. ('+e+")");throw u.context=e,u}if(o(i=this._events[t]))return!1;if(r(i))switch(arguments.length){case 1:i.call(this);break;case 2:i.call(this,arguments[1]);break;case 3:i.call(this,arguments[1],arguments[2]);break;default:a=Array.prototype.slice.call(arguments,1),i.apply(this,a)}else if(n(i))for(a=Array.prototype.slice.call(arguments,1),s=(h=i.slice()).length,l=0;l<s;l++)h[l].apply(this,a);return!0},i.prototype.addListener=function(t,e){var s;if(!r(e))throw TypeError("listener must be a function");return this._events||(this._events={}),this._events.newListener&&this.emit("newListener",t,r(e.listener)?e.listener:e),this._events[t]?n(this._events[t])?this._events[t].push(e):this._events[t]=[this._events[t],e]:this._events[t]=e,n(this._events[t])&&!this._events[t].warned&&(s=o(this._maxListeners)?i.defaultMaxListeners:this._maxListeners)&&s>0&&this._events[t].length>s&&(this._events[t].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[t].length),"function"==typeof console.trace&&console.trace()),this},i.prototype.on=i.prototype.addListener,i.prototype.once=function(t,e){function i(){this.removeListener(t,i),n||(n=!0,e.apply(this,arguments))}if(!r(e))throw TypeError("listener must be a function");var n=!1;return i.listener=e,this.on(t,i),this},i.prototype.removeListener=function(t,e){var i,o,s,a;if(!r(e))throw TypeError("listener must be a function");if(!this._events||!this._events[t])return this;if(s=(i=this._events[t]).length,o=-1,i===e||r(i.listener)&&i.listener===e)delete this._events[t],this._events.removeListener&&this.emit("removeListener",t,e);else if(n(i)){for(a=s;a-- >0;)if(i[a]===e||i[a].listener&&i[a].listener===e){o=a;break}if(o<0)return this;1===i.length?(i.length=0,delete this._events[t]):i.splice(o,1),this._events.removeListener&&this.emit("removeListener",t,e)}return this},i.prototype.removeAllListeners=function(t){var e,i;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[t]&&delete this._events[t],this;if(0===arguments.length){for(e in this._events)"removeListener"!==e&&this.removeAllListeners(e);return this.removeAllListeners("removeListener"),this._events={},this}if(r(i=this._events[t]))this.removeListener(t,i);else if(i)for(;i.length;)this.removeListener(t,i[i.length-1]);return delete this._events[t],this},i.prototype.listeners=function(t){return this._events&&this._events[t]?r(this._events[t])?[this._events[t]]:this._events[t].slice():[]},i.prototype.listenerCount=function(t){if(this._events){var e=this._events[t];if(r(e))return 1;if(e)return e.length}return 0},i.listenerCount=function(t,e){return t.listenerCount(e)}},function(t,e,i){"use strict";function r(t){n.call(this,t)}var n=i(26);i(0).inherits(r,n),r.prototype.readData=function(t){if(this.checkOffset(t),0===t)return new Uint8Array(0);var e=this.data.subarray(this.zero+this.index,this.zero+this.index+t);return this.index+=t,e},t.exports=r},function(t,e,i){"use strict";function r(t){this.data=t,this.length=t.length,this.index=0,this.zero=0}var n=i(0);r.prototype={checkOffset:function(t){this.checkIndex(this.index+t)},checkIndex:function(t){if(this.length<this.zero+t||t<0)throw new Error("End of data reached (data length = "+this.length+", asked index = "+t+"). Corrupted zip ?")},setIndex:function(t){this.checkIndex(t),this.index=t},skip:function(t){this.setIndex(this.index+t)},byteAt:function(t){},readInt:function(t){var e,i=0;for(this.checkOffset(t),e=this.index+t-1;e>=this.index;e--)i=(i<<8)+this.byteAt(e);return this.index+=t,i},readString:function(t){return n.transformTo("string",this.readData(t))},readData:function(t){},lastIndexOfSignature:function(t){},readAndCheckSignature:function(t){},readDate:function(){var t=this.readInt(4);return new Date(Date.UTC(1980+(t>>25&127),(t>>21&15)-1,t>>16&31,t>>11&31,t>>5&63,(31&t)<<1))}},t.exports=r},function(t,e,i){"use strict";function r(t){n.call(this,t);for(var e=0;e<this.data.length;e++)t[e]=255&t[e]}var n=i(25);i(0).inherits(r,n),r.prototype.byteAt=function(t){return this.data[this.zero+t]},r.prototype.lastIndexOfSignature=function(t){for(var e=t.charCodeAt(0),i=t.charCodeAt(1),r=t.charCodeAt(2),n=t.charCodeAt(3),o=this.length-4;o>=0;--o)if(this.data[o]===e&&this.data[o+1]===i&&this.data[o+2]===r&&this.data[o+3]===n)return o-this.zero;return-1},r.prototype.readAndCheckSignature=function(t){var e=t.charCodeAt(0),i=t.charCodeAt(1),r=t.charCodeAt(2),n=t.charCodeAt(3),o=this.readData(4);return e===o[0]&&i===o[1]&&r===o[2]&&n===o[3]},r.prototype.readData=function(t){if(this.checkOffset(t),0===t)return[];var e=this.data.slice(this.zero+this.index,this.zero+this.index+t);return this.index+=t,e},t.exports=r},function(t,e,i){"use strict";var r=i(0),n=i(3),o=i(26),s=i(54),a=i(53),l=i(24);t.exports=function(t){var e=r.getTypeOf(t);return r.checkSupport(e),"string"!==e||n.uint8array?"nodebuffer"===e?new a(t):n.uint8array?new l(r.transformTo("uint8array",t)):new o(r.transformTo("array",t)):new s(t)}},function(t,e,i){"use strict";e.LOCAL_FILE_HEADER="PK",e.CENTRAL_FILE_HEADER="PK",e.CENTRAL_DIRECTORY_END="PK",e.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK",e.ZIP64_CENTRAL_DIRECTORY_END="PK",e.DATA_DESCRIPTOR="PK\b"},function(t,e,i){"use strict";t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},function(t,e,i){"use strict";t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},function(t,e,i){"use strict";function r(t,e){if(e<65537&&(t.subarray&&s||!t.subarray&&o))return String.fromCharCode.apply(null,n.shrinkBuf(t,e));for(var i="",r=0;r<e;r++)i+=String.fromCharCode(t[r]);return i}var n=i(2),o=!0,s=!0;try{String.fromCharCode.apply(null,[0])}catch(t){o=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(t){s=!1}for(var a=new n.Buf8(256),l=0;l<256;l++)a[l]=l>=252?6:l>=248?5:l>=240?4:l>=224?3:l>=192?2:1;a[254]=a[254]=1,e.string2buf=function(t){var e,i,r,o,s,a=t.length,l=0;for(o=0;o<a;o++)55296==(64512&(i=t.charCodeAt(o)))&&o+1<a&&56320==(64512&(r=t.charCodeAt(o+1)))&&(i=65536+(i-55296<<10)+(r-56320),o++),l+=i<128?1:i<2048?2:i<65536?3:4;for(e=new n.Buf8(l),s=0,o=0;s<l;o++)55296==(64512&(i=t.charCodeAt(o)))&&o+1<a&&56320==(64512&(r=t.charCodeAt(o+1)))&&(i=65536+(i-55296<<10)+(r-56320),o++),i<128?e[s++]=i:i<2048?(e[s++]=192|i>>>6,e[s++]=128|63&i):i<65536?(e[s++]=224|i>>>12,e[s++]=128|i>>>6&63,e[s++]=128|63&i):(e[s++]=240|i>>>18,e[s++]=128|i>>>12&63,e[s++]=128|i>>>6&63,e[s++]=128|63&i);return e},e.buf2binstring=function(t){return r(t,t.length)},e.binstring2buf=function(t){for(var e=new n.Buf8(t.length),i=0,r=e.length;i<r;i++)e[i]=t.charCodeAt(i);return e},e.buf2string=function(t,e){var i,n,o,s,l=e||t.length,h=new Array(2*l);for(n=0,i=0;i<l;)if((o=t[i++])<128)h[n++]=o;else if((s=a[o])>4)h[n++]=65533,i+=s-1;else{for(o&=2===s?31:3===s?15:7;s>1&&i<l;)o=o<<6|63&t[i++],s--;s>1?h[n++]=65533:o<65536?h[n++]=o:(o-=65536,h[n++]=55296|o>>10&1023,h[n++]=56320|1023&o)}return r(h,n)},e.utf8border=function(t,e){var i;for((e=e||t.length)>t.length&&(e=t.length),i=e-1;i>=0&&128==(192&t[i]);)i--;return i<0?e:0===i?e:i+a[t[i]]>e?i:e}},function(t,e,i){"use strict";var r=function(){for(var t,e=[],i=0;i<256;i++){t=i;for(var r=0;r<8;r++)t=1&t?3988292384^t>>>1:t>>>1;e[i]=t}return e}();t.exports=function(t,e,i,n){var o=r,s=n+i;t^=-1;for(var a=n;a<s;a++)t=t>>>8^o[255&(t^e[a])];return-1^t}},function(t,e,i){"use strict";t.exports=function(t,e,i,r){for(var n=65535&t|0,o=t>>>16&65535|0,s=0;0!==i;){i-=s=i>2e3?2e3:i;do o=o+(n=n+e[r++]|0)|0;while(--s);n%=65521,o%=65521}return n|o<<16|0}},function(t,e,i){"use strict";var r=i(1);e.STORE={magic:"\0\0",compressWorker:function(t){return new r("STORE compression")},uncompressWorker:function(){return new r("STORE decompression")}},e.DEFLATE=i(68)},function(t,e,i){"use strict";function r(){n.call(this,"Crc32Probe"),this.withStreamInfo("crc32",0)}var n=i(1),o=i(17);i(0).inherits(r,n),r.prototype.processChunk=function(t){this.streamInfo.crc32=o(t.data,this.streamInfo.crc32||0),this.push(t)},t.exports=r},function(t,e,i){"use strict";function r(t){o.call(this,"DataLengthProbe for "+t),this.propName=t,this.withStreamInfo(t,0)}var n=i(0),o=i(1);n.inherits(r,o),r.prototype.processChunk=function(t){if(t){var e=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=e+t.data.length}o.prototype.processChunk.call(this,t)},t.exports=r},function(t,e,i){"use strict";function r(t){o.call(this,"DataWorker");var e=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type="",this._tickScheduled=!1,t.then(function(t){e.dataIsReady=!0,e.data=t,e.max=t&&t.length||0,e.type=n.getTypeOf(t),e.isPaused||e._tickAndRepeat()},function(t){e.error(t)})}var n=i(0),o=i(1);n.inherits(r,o),r.prototype.cleanUp=function(){o.prototype.cleanUp.call(this),this.data=null},r.prototype.resume=function(){return!!o.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,n.delay(this._tickAndRepeat,[],this)),!0)},r.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(n.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0))},r.prototype._tick=function(){if(this.isPaused||this.isFinished)return!1;var t=null,e=Math.min(this.max,this.index+16384);if(this.index>=this.max)return this.end();switch(this.type){case"string":t=this.data.substring(this.index,e);break;case"uint8array":t=this.data.subarray(this.index,e);break;case"array":case"nodebuffer":t=this.data.slice(this.index,e)}return this.index=e,this.push({data:t,meta:{percent:this.max?this.index/this.max*100:0}})},t.exports=r},function(t,e,i){"use strict";e.base64=!1,e.binary=!1,e.dir=!1,e.createFolders=!0,e.date=null,e.compression=null,e.compressionOptions=null,e.comment=null,e.unixPermissions=null,e.dosPermissions=null},function(t,e,i){"use strict";(function(e){function r(t,i){return new u.Promise(function(r,n){var s=[],a=t._internalType,h=t._outputType,u=t._mimeType;t.on("data",function(t,e){s.push(t),i&&i(e)}).on("error",function(t){s=[],n(t)}).on("end",function(){try{var t=function(t,e,i){switch(t){case"blob":return o.newBlob(o.transformTo("arraybuffer",e),i);case"base64":return l.encode(e);default:return o.transformTo(t,e)}}(h,function(t,i){var r,n=0,o=null,s=0;for(r=0;r<i.length;r++)s+=i[r].length;switch(t){case"string":return i.join("");case"array":return Array.prototype.concat.apply([],i);case"uint8array":for(o=new Uint8Array(s),r=0;r<i.length;r++)o.set(i[r],n),n+=i[r].length;return o;case"nodebuffer":return e.concat(i);default:throw new Error("concat : unsupported type '"+t+"'")}}(a,s),u);r(t)}catch(t){n(t)}s=[]}).resume()})}function n(t,e,i){var r=e;switch(e){case"blob":case"arraybuffer":r="uint8array";break;case"base64":r="string"}try{this._internalType=r,this._outputType=e,this._mimeType=i,o.checkSupport(r),this._worker=t.pipe(new s(r)),t.lock()}catch(t){this._worker=new a("error"),this._worker.error(t)}}var o=i(0),s=i(72),a=i(1),l=i(44),h=i(3),u=i(8),c=null;if(h.nodestream)try{c=i(71)}catch(t){}n.prototype={accumulate:function(t){return r(this,t)},on:function(t,e){var i=this;return"data"===t?this._worker.on(t,function(t){e.call(i,t.data,t.meta)}):this._worker.on(t,function(){o.delay(e,arguments,i)}),this},resume:function(){return o.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(t){if(o.checkSupport("nodestream"),"nodebuffer"!==this._outputType)throw new Error(this._outputType+" is not supported by this method");return new c(this,{objectMode:"nodebuffer"!==this._outputType},t)}},t.exports=n}).call(this,i(10).Buffer)},function(t,e,i){var r=i(20),n=i(11).document,o=r(n)&&r(n.createElement);t.exports=function(t){return o?n.createElement(t):{}}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,i){var r=i(85);t.exports=function(t,e,i){if(r(t),void 0===e)return t;switch(i){case 1:return function(i){return t.call(e,i)};case 2:return function(i,r){return t.call(e,i,r)};case 3:return function(i,r,n){return t.call(e,i,r,n)}}return function(){return t.apply(e,arguments)}}},function(t,e){var i=t.exports={version:"2.3.0"};"number"==typeof __e&&(__e=i)},function(t,e,i){"use strict";var r=i(0),n=i(3),o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";e.encode=function(t){for(var e,i,n,s,a,l,h,u=[],c=0,d=t.length,p=d,f="string"!==r.getTypeOf(t);c<t.length;)p=d-c,f?(e=t[c++],i=c<d?t[c++]:0,n=c<d?t[c++]:0):(e=t.charCodeAt(c++),i=c<d?t.charCodeAt(c++):0,n=c<d?t.charCodeAt(c++):0),s=e>>2,a=(3&e)<<4|i>>4,l=p>1?(15&i)<<2|n>>6:64,h=p>2?63&n:64,u.push(o.charAt(s)+o.charAt(a)+o.charAt(l)+o.charAt(h));return u.join("")},e.decode=function(t){var e,i,r,s,a,l,h=0,u=0;if("data:"===t.substr(0,"data:".length))throw new Error("Invalid base64 input, it looks like a data url.");var c,d=3*(t=t.replace(/[^A-Za-z0-9\+\/\=]/g,"")).length/4;if(t.charAt(t.length-1)===o.charAt(64)&&d--,t.charAt(t.length-2)===o.charAt(64)&&d--,d%1!=0)throw new Error("Invalid base64 input, bad content length.");for(c=n.uint8array?new Uint8Array(0|d):new Array(0|d);h<t.length;)e=o.indexOf(t.charAt(h++))<<2|(s=o.indexOf(t.charAt(h++)))>>4,i=(15&s)<<4|(a=o.indexOf(t.charAt(h++)))>>2,r=(3&a)<<6|(l=o.indexOf(t.charAt(h++))),c[u++]=e,64!==a&&(c[u++]=i),64!==l&&(c[u++]=r);return c}},function(t,e,i){"use strict";function r(t){return this instanceof r?(s.call(this,t),this._transformState={afterTransform:function(t,e){var i=this._transformState;i.transforming=!1;var r=i.writecb;if(!r)return this.emit("error",new Error("write callback called multiple times"));i.writechunk=null,i.writecb=null,null!=e&&this.push(e),r(t);var n=this._readableState;n.reading=!1,(n.needReadable||n.length<n.highWaterMark)&&this._read(n.highWaterMark)}.bind(this),needTransform:!1,transforming:!1,writecb:null,writechunk:null,writeencoding:null},this._readableState.needReadable=!0,this._readableState.sync=!1,t&&("function"==typeof t.transform&&(this._transform=t.transform),"function"==typeof t.flush&&(this._flush=t.flush)),this.on("prefinish",n),void 0):new r(t)}function n(){var t=this;"function"==typeof this._flush?this._flush(function(e,i){o(t,e,i)}):o(this,null,null)}function o(t,e,i){if(e)return t.emit("error",e);if(null!=i&&t.push(i),t._writableState.length)throw new Error("Calling transform done when ws.length != 0");if(t._transformState.transforming)throw new Error("Calling transform done when still transforming");return t.push(null)}t.exports=r;var s=i(4),a=i(9);a.inherits=i(6),a.inherits(r,s),r.prototype.push=function(t,e){return this._transformState.needTransform=!1,s.prototype.push.call(this,t,e)},r.prototype._transform=function(t,e,i){throw new Error("_transform() is not implemented")},r.prototype._write=function(t,e,i){var r=this._transformState;if(r.writecb=i,r.writechunk=t,r.writeencoding=e,!r.transforming){var n=this._readableState;(r.needTransform||n.needReadable||n.length<n.highWaterMark)&&this._read(n.highWaterMark)}},r.prototype._read=function(t){var e=this._transformState;null!==e.writechunk&&e.writecb&&!e.transforming?(e.transforming=!0,this._transform(e.writechunk,e.writeencoding,e.afterTransform)):e.needTransform=!0},r.prototype._destroy=function(t,e){var i=this;s.prototype._destroy.call(this,t,function(t){e(t),i.emit("close")})}},function(t,e,i){"use strict";function r(t){var e;switch(this.encoding=function(t){var e=function(t){if(!t)return"utf8";for(var e;;)switch(t){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return t;default:if(e)return;t=(""+t).toLowerCase(),e=!0}}(t);if("string"!=typeof e&&(d.isEncoding===p||!p(t)))throw new Error("Unknown encoding: "+t);return e||t}(t),this.encoding){case"utf16le":this.text=s,this.end=a,e=4;break;case"utf8":this.fillLast=o,e=4;break;case"base64":this.text=l,this.end=h,e=3;break;default:return this.write=u,void(this.end=c)}this.lastNeed=0,this.lastTotal=0,this.lastChar=d.allocUnsafe(e)}function n(t){return t<=127?0:t>>5==6?2:t>>4==14?3:t>>3==30?4:t>>6==2?-1:-2}function o(t){var e=this.lastTotal-this.lastNeed,i=function(t,e,i){if(128!=(192&e[0]))return t.lastNeed=0,"�";if(t.lastNeed>1&&e.length>1){if(128!=(192&e[1]))return t.lastNeed=1,"�";if(t.lastNeed>2&&e.length>2&&128!=(192&e[2]))return t.lastNeed=2,"�"}}(this,t);return void 0!==i?i:this.lastNeed<=t.length?(t.copy(this.lastChar,e,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,e,0,t.length),void(this.lastNeed-=t.length))}function s(t,e){if((t.length-e)%2==0){var i=t.toString("utf16le",e);if(i){var r=i.charCodeAt(i.length-1);if(r>=55296&&r<=56319)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=t[t.length-2],
this.lastChar[1]=t[t.length-1],i.slice(0,-1)}return i}return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=t[t.length-1],t.toString("utf16le",e,t.length-1)}function a(t){var e=t&&t.length?this.write(t):"";if(this.lastNeed){var i=this.lastTotal-this.lastNeed;return e+this.lastChar.toString("utf16le",0,i)}return e}function l(t,e){var i=(t.length-e)%3;return 0===i?t.toString("base64",e):(this.lastNeed=3-i,this.lastTotal=3,1===i?this.lastChar[0]=t[t.length-1]:(this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1]),t.toString("base64",e,t.length-i))}function h(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+this.lastChar.toString("base64",0,3-this.lastNeed):e}function u(t){return t.toString(this.encoding)}function c(t){return t&&t.length?this.write(t):""}var d=i(13).Buffer,p=d.isEncoding||function(t){switch((t=""+t)&&t.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return!0;default:return!1}};e.StringDecoder=r,r.prototype.write=function(t){if(0===t.length)return"";var e,i;if(this.lastNeed){if(void 0===(e=this.fillLast(t)))return"";i=this.lastNeed,this.lastNeed=0}else i=0;return i<t.length?e?e+this.text(t,i):this.text(t,i):e||""},r.prototype.end=function(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+"�":e},r.prototype.text=function(t,e){var i=function(t,e,i){var r=e.length-1;if(r<i)return 0;var o=n(e[r]);return o>=0?(o>0&&(t.lastNeed=o-1),o):--r<i||-2===o?0:(o=n(e[r]))>=0?(o>0&&(t.lastNeed=o-2),o):--r<i||-2===o?0:(o=n(e[r]))>=0?(o>0&&(2===o?o=0:t.lastNeed=o-3),o):0}(this,t,e);if(!this.lastNeed)return t.toString("utf8",e);this.lastTotal=i;var r=t.length-(i-this.lastNeed);return t.copy(this.lastChar,0,r),t.toString("utf8",e,r)},r.prototype.fillLast=function(t){return this.lastNeed<=t.length?(t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,t.length),void(this.lastNeed-=t.length))}},function(t,e,i){"use strict";function r(t,e){t.emit("error",e)}var n=i(14);t.exports={destroy:function(t,e){var i=this,o=this._readableState&&this._readableState.destroyed,s=this._writableState&&this._writableState.destroyed;return o||s?(e?e(t):!t||this._writableState&&this._writableState.errorEmitted||n.nextTick(r,this,t),this):(this._readableState&&(this._readableState.destroyed=!0),this._writableState&&(this._writableState.destroyed=!0),this._destroy(t||null,function(t){!e&&t?(n.nextTick(r,i,t),i._writableState&&(i._writableState.errorEmitted=!0)):e&&e(t)}),this)},undestroy:function(){this._readableState&&(this._readableState.destroyed=!1,this._readableState.reading=!1,this._readableState.ended=!1,this._readableState.endEmitted=!1),this._writableState&&(this._writableState.destroyed=!1,this._writableState.ended=!1,this._writableState.ending=!1,this._writableState.finished=!1,this._writableState.errorEmitted=!1)}}},function(t,e,i){t.exports=i(23).EventEmitter},function(t,e,i){"use strict";(function(e,r){function n(t,e){b=b||i(4),t=t||{};var r=e instanceof b;this.objectMode=!!t.objectMode,r&&(this.objectMode=this.objectMode||!!t.readableObjectMode);var n=t.highWaterMark,o=t.readableHighWaterMark,s=this.objectMode?16:16384;this.highWaterMark=n||0===n?n:r&&(o||0===o)?o:s,this.highWaterMark=Math.floor(this.highWaterMark),this.buffer=new P,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.destroyed=!1,this.defaultEncoding=t.defaultEncoding||"utf8",this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,t.encoding&&(M||(M=i(46).StringDecoder),this.decoder=new M(t.encoding),this.encoding=t.encoding)}function o(t){return b=b||i(4),this instanceof o?(this._readableState=new n(t,this),this.readable=!0,t&&("function"==typeof t.read&&(this._read=t.read),"function"==typeof t.destroy&&(this._destroy=t.destroy)),L.call(this),void 0):new o(t)}function s(t,e,i,r,n){var o,s=t._readableState;return null===e?(s.reading=!1,function(t,e){if(!e.ended){if(e.decoder){var i=e.decoder.end();i&&i.length&&(e.buffer.push(i),e.length+=e.objectMode?1:i.length)}e.ended=!0,h(t)}}(t,s)):(n||(o=function(t,e){var i;return function(t){return T.isBuffer(t)||t instanceof A}(e)||"string"==typeof e||void 0===e||t.objectMode||(i=new TypeError("Invalid non-string/buffer chunk")),i}(s,e)),o?t.emit("error",o):s.objectMode||e&&e.length>0?("string"==typeof e||s.objectMode||Object.getPrototypeOf(e)===T.prototype||(e=function(t){return T.from(t)}(e)),r?s.endEmitted?t.emit("error",new Error("stream.unshift() after end event")):a(t,s,e,!0):s.ended?t.emit("error",new Error("stream.push() after EOF")):(s.reading=!1,s.decoder&&!i?(e=s.decoder.write(e),s.objectMode||0!==e.length?a(t,s,e,!1):c(t,s)):a(t,s,e,!1))):r||(s.reading=!1)),function(t){return!t.ended&&(t.needReadable||t.length<t.highWaterMark||0===t.length)}(s)}function a(t,e,i,r){e.flowing&&0===e.length&&!e.sync?(t.emit("data",i),t.read(0)):(e.length+=e.objectMode?1:i.length,r?e.buffer.unshift(i):e.buffer.push(i),e.needReadable&&h(t)),c(t,e)}function l(t,e){return t<=0||0===e.length&&e.ended?0:e.objectMode?1:t!=t?e.flowing&&e.length?e.buffer.head.data.length:e.length:(t>e.highWaterMark&&(e.highWaterMark=function(t){return t>=I?t=I:(t--,t|=t>>>1,t|=t>>>2,t|=t>>>4,t|=t>>>8,t|=t>>>16,t++),t}(t)),t<=e.length?t:e.ended?e.length:(e.needReadable=!0,0))}function h(t){var e=t._readableState;e.needReadable=!1,e.emittedReadable||(C("emitReadable",e.flowing),e.emittedReadable=!0,e.sync?_.nextTick(u,t):u(t))}function u(t){C("emit readable"),t.emit("readable"),g(t)}function c(t,e){e.readingMore||(e.readingMore=!0,_.nextTick(d,t,e))}function d(t,e){for(var i=e.length;!e.reading&&!e.flowing&&!e.ended&&e.length<e.highWaterMark&&(C("maybeReadMore read 0"),t.read(0),i!==e.length);)i=e.length;e.readingMore=!1}function p(t){C("readable nexttick read 0"),t.read(0)}function f(t,e){e.reading||(C("resume read 0"),t.read(0)),e.resumeScheduled=!1,e.awaitDrain=0,t.emit("resume"),g(t),e.flowing&&!e.reading&&t.read(0)}function g(t){var e=t._readableState;for(C("flow",e.flowing);e.flowing&&null!==t.read(););}function m(t,e){return 0===e.length?null:(e.objectMode?i=e.buffer.shift():!t||t>=e.length?(i=e.decoder?e.buffer.join(""):1===e.buffer.length?e.buffer.head.data:e.buffer.concat(e.length),e.buffer.clear()):i=function(t,e,i){var r;return t<e.head.data.length?(r=e.head.data.slice(0,t),e.head.data=e.head.data.slice(t)):r=t===e.head.data.length?e.shift():i?function(t,e){var i=e.head,r=1,n=i.data;for(t-=n.length;i=i.next;){var o=i.data,s=t>o.length?o.length:t;if(n+=s===o.length?o:o.slice(0,t),0===(t-=s)){s===o.length?(++r,i.next?e.head=i.next:e.head=e.tail=null):(e.head=i,i.data=o.slice(s));break}++r}return e.length-=r,n}(t,e):function(t,e){var i=T.allocUnsafe(t),r=e.head,n=1;for(r.data.copy(i),t-=r.data.length;r=r.next;){var o=r.data,s=t>o.length?o.length:t;if(o.copy(i,i.length-t,0,s),0===(t-=s)){s===o.length?(++n,r.next?e.head=r.next:e.head=e.tail=null):(e.head=r,r.data=o.slice(s));break}++n}return e.length-=n,i}(t,e),r}(t,e.buffer,e.decoder),i);var i}function y(t){var e=t._readableState;if(e.length>0)throw new Error('"endReadable()" called on non-empty stream');e.endEmitted||(e.ended=!0,_.nextTick(E,e,t))}function E(t,e){t.endEmitted||0!==t.length||(t.endEmitted=!0,e.readable=!1,e.emit("end"))}function v(t,e){for(var i=0,r=t.length;i<r;i++)if(t[i]===e)return i;return-1}var _=i(14);t.exports=o;var b,w=i(51);o.ReadableState=n,i(23).EventEmitter;var S=function(t,e){return t.listeners(e).length},L=i(48),T=i(13).Buffer,A=e.Uint8Array||function(){},R=i(9);R.inherits=i(6);var x=i(99),C=void 0;C=x&&x.debuglog?x.debuglog("stream"):function(){};var M,P=i(98),O=i(47);R.inherits(o,L);var N=["error","close","destroy","pause","resume"];Object.defineProperty(o.prototype,"destroyed",{get:function(){return void 0!==this._readableState&&this._readableState.destroyed},set:function(t){this._readableState&&(this._readableState.destroyed=t)}}),o.prototype.destroy=O.destroy,o.prototype._undestroy=O.undestroy,o.prototype._destroy=function(t,e){this.push(null),e(t)},o.prototype.push=function(t,e){var i,r=this._readableState;return r.objectMode?i=!0:"string"==typeof t&&((e=e||r.defaultEncoding)!==r.encoding&&(t=T.from(t,e),e=""),i=!0),s(this,t,e,!1,i)},o.prototype.unshift=function(t){return s(this,t,null,!0,!1)},o.prototype.isPaused=function(){return!1===this._readableState.flowing},o.prototype.setEncoding=function(t){return M||(M=i(46).StringDecoder),this._readableState.decoder=new M(t),this._readableState.encoding=t,this};var I=8388608;o.prototype.read=function(t){C("read",t),t=parseInt(t,10);var e=this._readableState,i=t;if(0!==t&&(e.emittedReadable=!1),0===t&&e.needReadable&&(e.length>=e.highWaterMark||e.ended))return C("read: emitReadable",e.length,e.ended),0===e.length&&e.ended?y(this):h(this),null;if(0===(t=l(t,e))&&e.ended)return 0===e.length&&y(this),null;var r,n=e.needReadable;return C("need readable",n),(0===e.length||e.length-t<e.highWaterMark)&&C("length less than watermark",n=!0),e.ended||e.reading?C("reading or ended",n=!1):n&&(C("do read"),e.reading=!0,e.sync=!0,0===e.length&&(e.needReadable=!0),this._read(e.highWaterMark),e.sync=!1,e.reading||(t=l(i,e))),null===(r=t>0?m(t,e):null)?(e.needReadable=!0,t=0):e.length-=t,0===e.length&&(e.ended||(e.needReadable=!0),i!==t&&e.ended&&y(this)),null!==r&&this.emit("data",r),r},o.prototype._read=function(t){this.emit("error",new Error("_read() is not implemented"))},o.prototype.pipe=function(t,e){function i(e,r){C("onunpipe"),e===u&&r&&!1===r.hasUnpiped&&(r.hasUnpiped=!0,C("cleanup"),t.removeListener("close",a),t.removeListener("finish",l),t.removeListener("drain",p),t.removeListener("error",s),t.removeListener("unpipe",i),u.removeListener("end",n),u.removeListener("end",h),u.removeListener("data",o),f=!0,!c.awaitDrain||t._writableState&&!t._writableState.needDrain||p())}function n(){C("onend"),t.end()}function o(e){C("ondata"),m=!1,!1!==t.write(e)||m||((1===c.pipesCount&&c.pipes===t||c.pipesCount>1&&-1!==v(c.pipes,t))&&!f&&(C("false write response, pause",u._readableState.awaitDrain),u._readableState.awaitDrain++,m=!0),u.pause())}function s(e){C("onerror",e),h(),t.removeListener("error",s),0===S(t,"error")&&t.emit("error",e)}function a(){t.removeListener("finish",l),h()}function l(){C("onfinish"),t.removeListener("close",a),h()}function h(){C("unpipe"),u.unpipe(t)}var u=this,c=this._readableState;switch(c.pipesCount){case 0:c.pipes=t;break;case 1:c.pipes=[c.pipes,t];break;default:c.pipes.push(t)}c.pipesCount+=1,C("pipe count=%d opts=%j",c.pipesCount,e);var d=e&&!1===e.end||t===r.stdout||t===r.stderr?h:n;c.endEmitted?_.nextTick(d):u.once("end",d),t.on("unpipe",i);var p=function(t){return function(){var e=t._readableState;C("pipeOnDrain",e.awaitDrain),e.awaitDrain&&e.awaitDrain--,0===e.awaitDrain&&S(t,"data")&&(e.flowing=!0,g(t))}}(u);t.on("drain",p);var f=!1,m=!1;return u.on("data",o),function(t,e,i){return"function"==typeof t.prependListener?t.prependListener(e,i):void(t._events&&t._events[e]?w(t._events[e])?t._events[e].unshift(i):t._events[e]=[i,t._events[e]]:t.on(e,i))}(t,"error",s),t.once("close",a),t.once("finish",l),t.emit("pipe",u),c.flowing||(C("pipe resume"),u.resume()),t},o.prototype.unpipe=function(t){var e=this._readableState,i={hasUnpiped:!1};if(0===e.pipesCount)return this;if(1===e.pipesCount)return t&&t!==e.pipes?this:(t||(t=e.pipes),e.pipes=null,e.pipesCount=0,e.flowing=!1,t&&t.emit("unpipe",this,i),this);if(!t){var r=e.pipes,n=e.pipesCount;e.pipes=null,e.pipesCount=0,e.flowing=!1;for(var o=0;o<n;o++)r[o].emit("unpipe",this,i);return this}var s=v(e.pipes,t);return-1===s?this:(e.pipes.splice(s,1),e.pipesCount-=1,1===e.pipesCount&&(e.pipes=e.pipes[0]),t.emit("unpipe",this,i),this)},o.prototype.on=function(t,e){var i=L.prototype.on.call(this,t,e);if("data"===t)!1!==this._readableState.flowing&&this.resume();else if("readable"===t){var r=this._readableState;r.endEmitted||r.readableListening||(r.readableListening=r.needReadable=!0,r.emittedReadable=!1,r.reading?r.length&&h(this):_.nextTick(p,this))}return i},o.prototype.addListener=o.prototype.on,o.prototype.resume=function(){var t=this._readableState;return t.flowing||(C("resume"),t.flowing=!0,function(t,e){e.resumeScheduled||(e.resumeScheduled=!0,_.nextTick(f,t,e))}(this,t)),this},o.prototype.pause=function(){return C("call pause flowing=%j",this._readableState.flowing),!1!==this._readableState.flowing&&(C("pause"),this._readableState.flowing=!1,this.emit("pause")),this},o.prototype.wrap=function(t){var e=this,i=this._readableState,r=!1;for(var n in t.on("end",function(){if(C("wrapped end"),i.decoder&&!i.ended){var t=i.decoder.end();t&&t.length&&e.push(t)}e.push(null)}),t.on("data",function(n){C("wrapped data"),i.decoder&&(n=i.decoder.write(n)),(!i.objectMode||null!==n&&void 0!==n)&&(i.objectMode||n&&n.length)&&(e.push(n)||(r=!0,t.pause()))}),t)void 0===this[n]&&"function"==typeof t[n]&&(this[n]=function(e){return function(){return t[e].apply(t,arguments)}}(n));for(var o=0;o<N.length;o++)t.on(N[o],this.emit.bind(this,N[o]));return this._read=function(e){C("wrapped _read",e),r&&(r=!1,t.resume())},this},Object.defineProperty(o.prototype,"readableHighWaterMark",{enumerable:!1,get:function(){return this._readableState.highWaterMark}}),o._fromList=m}).call(this,i(5),i(15))},function(t,e,i){t.exports=i(100)},function(t,e){var i={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==i.call(t)}},function(t,e,i){"use strict";function r(t,e){this.options=t,this.loadOptions=e}var n=i(27),o=i(0),s=i(18),a=i(17),l=i(7),h=i(34),u=i(3);r.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(t){var e,i;if(t.skip(22),this.fileNameLength=t.readInt(2),i=t.readInt(2),this.fileName=t.readData(this.fileNameLength),t.skip(i),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory (compressedSize === -1 || uncompressedSize === -1)");if(null===(e=function(t){for(var e in h)if(h.hasOwnProperty(e)&&h[e].magic===t)return h[e];return null}(this.compressionMethod)))throw new Error("Corrupted zip : compression "+o.pretty(this.compressionMethod)+" unknown (inner file : "+o.transformTo("string",this.fileName)+")");this.decompressed=new s(this.compressedSize,this.uncompressedSize,this.crc32,e,t.readData(this.compressedSize))},readCentralPart:function(t){this.versionMadeBy=t.readInt(2),t.skip(2),this.bitFlag=t.readInt(2),this.compressionMethod=t.readString(2),this.date=t.readDate(),this.crc32=t.readInt(4),this.compressedSize=t.readInt(4),this.uncompressedSize=t.readInt(4);var e=t.readInt(2);if(this.extraFieldsLength=t.readInt(2),this.fileCommentLength=t.readInt(2),this.diskNumberStart=t.readInt(2),this.internalFileAttributes=t.readInt(2),this.externalFileAttributes=t.readInt(4),this.localHeaderOffset=t.readInt(4),this.isEncrypted())throw new Error("Encrypted zip are not supported");t.skip(e),this.readExtraFields(t),this.parseZIP64ExtraField(t),this.fileComment=t.readData(this.fileCommentLength)},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var t=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),0===t&&(this.dosPermissions=63&this.externalFileAttributes),3===t&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||"/"!==this.fileNameStr.slice(-1)||(this.dir=!0)},parseZIP64ExtraField:function(t){if(this.extraFields[1]){var e=n(this.extraFields[1].value);this.uncompressedSize===o.MAX_VALUE_32BITS&&(this.uncompressedSize=e.readInt(8)),this.compressedSize===o.MAX_VALUE_32BITS&&(this.compressedSize=e.readInt(8)),this.localHeaderOffset===o.MAX_VALUE_32BITS&&(this.localHeaderOffset=e.readInt(8)),this.diskNumberStart===o.MAX_VALUE_32BITS&&(this.diskNumberStart=e.readInt(4))}},readExtraFields:function(t){var e,i,r,n=t.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});t.index<n;)e=t.readInt(2),i=t.readInt(2),r=t.readData(i),this.extraFields[e]={id:e,length:i,value:r}},handleUTF8:function(){var t=u.uint8array?"uint8array":"array";if(this.useUTF8())this.fileNameStr=l.utf8decode(this.fileName),this.fileCommentStr=l.utf8decode(this.fileComment);else{var e=this.findExtraFieldUnicodePath();if(null!==e)this.fileNameStr=e;else{var i=o.transformTo(t,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(i)}var r=this.findExtraFieldUnicodeComment();if(null!==r)this.fileCommentStr=r;else{var n=o.transformTo(t,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(n)}}},findExtraFieldUnicodePath:function(){var t=this.extraFields[28789];if(t){var e=n(t.value);return 1!==e.readInt(1)?null:a(this.fileName)!==e.readInt(4)?null:l.utf8decode(e.readData(t.length-5))}return null},findExtraFieldUnicodeComment:function(){var t=this.extraFields[25461];if(t){var e=n(t.value);return 1!==e.readInt(1)?null:a(this.fileComment)!==e.readInt(4)?null:l.utf8decode(e.readData(t.length-5))}return null}},t.exports=r},function(t,e,i){"use strict";function r(t){n.call(this,t)}var n=i(24);i(0).inherits(r,n),r.prototype.readData=function(t){this.checkOffset(t);var e=this.data.slice(this.zero+this.index,this.zero+this.index+t);return this.index+=t,e},t.exports=r},function(t,e,i){"use strict";function r(t){n.call(this,t)}var n=i(25);i(0).inherits(r,n),r.prototype.byteAt=function(t){return this.data.charCodeAt(this.zero+t)},r.prototype.lastIndexOfSignature=function(t){return this.data.lastIndexOf(t)-this.zero},r.prototype.readAndCheckSignature=function(t){return t===this.readData(4)},r.prototype.readData=function(t){this.checkOffset(t);var e=this.data.slice(this.zero+this.index,this.zero+this.index+t);return this.index+=t,e},t.exports=r},function(t,e,i){"use strict";function r(t){this.files=[],this.loadOptions=t}var n=i(27),o=i(0),s=i(28),a=i(52),l=(i(7),i(3));r.prototype={checkSignature:function(t){if(!this.reader.readAndCheckSignature(t)){this.reader.index-=4;var e=this.reader.readString(4);throw new Error("Corrupted zip or bug: unexpected signature ("+o.pretty(e)+", expected "+o.pretty(t)+")")}},isSignature:function(t,e){var i=this.reader.index;this.reader.setIndex(t);var r=this.reader.readString(4)===e;return this.reader.setIndex(i),r},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var t=this.reader.readData(this.zipCommentLength),e=l.uint8array?"uint8array":"array",i=o.transformTo(e,t);this.zipComment=this.loadOptions.decodeFileName(i)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var t,e,i,r=this.zip64EndOfCentralSize-44;0<r;)t=this.reader.readInt(2),e=this.reader.readInt(4),i=this.reader.readData(e),this.zip64ExtensibleData[t]={id:t,length:e,value:i}},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),this.disksCount>1)throw new Error("Multi-volumes zip are not supported")},readLocalFiles:function(){var t,e;for(t=0;t<this.files.length;t++)e=this.files[t],this.reader.setIndex(e.localHeaderOffset),this.checkSignature(s.LOCAL_FILE_HEADER),e.readLocalPart(this.reader),e.handleUTF8(),e.processAttributes()},readCentralDir:function(){var t;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(t=new a({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(t);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error("Corrupted zip or bug: expected "+this.centralDirRecords+" records in central dir, got "+this.files.length)},readEndOfCentral:function(){var t=this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);if(t<0)throw this.isSignature(0,s.LOCAL_FILE_HEADER)?new Error("Corrupted zip: can't find end of central directory"):new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");this.reader.setIndex(t);var e=t;if(this.checkSignature(s.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===o.MAX_VALUE_16BITS||this.diskWithCentralDirStart===o.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===o.MAX_VALUE_16BITS||this.centralDirRecords===o.MAX_VALUE_16BITS||this.centralDirSize===o.MAX_VALUE_32BITS||this.centralDirOffset===o.MAX_VALUE_32BITS){if(this.zip64=!0,(t=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");if(this.reader.setIndex(t),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,s.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral()}var i=this.centralDirOffset+this.centralDirSize;this.zip64&&(i+=20,i+=12+this.zip64EndOfCentralSize);var r=e-i;if(r>0)this.isSignature(e,s.CENTRAL_FILE_HEADER)||(this.reader.zero=r);else if(r<0)throw new Error("Corrupted zip: missing "+Math.abs(r)+" bytes.")},prepareReader:function(t){this.reader=n(t)},load:function(t){this.prepareReader(t),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles()}},t.exports=r},function(t,e,i){"use strict";function r(t){return new o.Promise(function(e,i){var r=t.decompressed.getContentWorker().pipe(new l);r.on("error",function(t){i(t)}).on("end",function(){r.streamInfo.crc32!==t.decompressed.crc32?i(new Error("Corrupted zip : CRC32 mismatch")):e()}).resume()})}var n=i(0),o=i(8),s=i(7),a=(n=i(0),i(55)),l=i(35),h=i(12);t.exports=function(t,e){var i=this;return e=n.extend(e||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:s.utf8decode}),h.isNode&&h.isStream(t)?o.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")):n.prepareContent("the loaded zip file",t,!0,e.optimizedBinaryString,e.base64).then(function(t){var i=new a(e);return i.load(t),i}).then(function(t){var i=[o.Promise.resolve(t)],n=t.files;if(e.checkCRC32)for(var s=0;s<n.length;s++)i.push(r(n[s]));return o.Promise.all(i)}).then(function(t){for(var r=t.shift(),n=r.files,o=0;o<n.length;o++){var s=n[o];i.file(s.fileNameStr,s.decompressed,{binary:!0,optimizedBinaryString:!0,date:s.date,dir:s.dir,comment:s.fileCommentStr.length?s.fileCommentStr:null,unixPermissions:s.unixPermissions,dosPermissions:s.dosPermissions,createFolders:e.createFolders})}return r.zipComment.length&&(i.comment=r.zipComment),i})}},function(t,e,i){"use strict";function r(t,e){o.call(this,"Nodejs stream input adapter for "+t),this._upstreamEnded=!1,this._bindStream(e)}var n=i(0),o=i(1);n.inherits(r,o),r.prototype._bindStream=function(t){var e=this;this._stream=t,t.pause(),t.on("data",function(t){e.push({data:t,meta:{percent:0}})}).on("error",function(t){e.isPaused?this.generatedError=t:e.error(t)}).on("end",function(){e.isPaused?e._upstreamEnded=!0:e.end()})},r.prototype.pause=function(){return!!o.prototype.pause.call(this)&&(this._stream.pause(),!0)},r.prototype.resume=function(){return!!o.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},t.exports=r},function(t,e,i){"use strict";function r(t,e,i,r){o.call(this,"ZipFileWorker"),this.bytesWritten=0,this.zipComment=e,this.zipPlatform=i,this.encodeFileName=r,this.streamFiles=t,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[]}var n=i(0),o=i(1),s=i(7),a=i(17),l=i(28),h=function(t,e){var i,r="";for(i=0;i<e;i++)r+=String.fromCharCode(255&t),t>>>=8;return r},u=function(t,e,i,r,o,u){var c,d,p=t.file,f=t.compression,g=u!==s.utf8encode,m=n.transformTo("string",u(p.name)),y=n.transformTo("string",s.utf8encode(p.name)),E=p.comment,v=n.transformTo("string",u(E)),_=n.transformTo("string",s.utf8encode(E)),b=y.length!==p.name.length,w=_.length!==E.length,S="",L="",T="",A=p.dir,R=p.date,x={crc32:0,compressedSize:0,uncompressedSize:0};e&&!i||(x.crc32=t.crc32,x.compressedSize=t.compressedSize,x.uncompressedSize=t.uncompressedSize);var C=0;e&&(C|=8),g||!b&&!w||(C|=2048);var M=0,P=0;A&&(M|=16),"UNIX"===o?(P=798,M|=function(t,e){var i=t;return t||(i=e?16893:33204),(65535&i)<<16}(p.unixPermissions,A)):(P=20,M|=function(t,e){return 63&(t||0)}(p.dosPermissions)),c=R.getUTCHours(),c<<=6,c|=R.getUTCMinutes(),c<<=5,c|=R.getUTCSeconds()/2,d=R.getUTCFullYear()-1980,d<<=4,d|=R.getUTCMonth()+1,d<<=5,d|=R.getUTCDate(),b&&(L=h(1,1)+h(a(m),4)+y,S+="up"+h(L.length,2)+L),w&&(T=h(1,1)+h(a(v),4)+_,S+="uc"+h(T.length,2)+T);var O="";return O+="\n\0",O+=h(C,2),O+=f.magic,O+=h(c,2),O+=h(d,2),O+=h(x.crc32,4),O+=h(x.compressedSize,4),O+=h(x.uncompressedSize,4),O+=h(m.length,2),O+=h(S.length,2),{fileRecord:l.LOCAL_FILE_HEADER+O+m+S,dirRecord:l.CENTRAL_FILE_HEADER+h(P,2)+O+h(v.length,2)+"\0\0\0\0"+h(M,4)+h(r,4)+m+S+v}};n.inherits(r,o),r.prototype.push=function(t){var e=t.meta.percent||0,i=this.entriesCount,r=this._sources.length;this.accumulate?this.contentBuffer.push(t):(this.bytesWritten+=t.data.length,o.prototype.push.call(this,{data:t.data,meta:{currentFile:this.currentFile,percent:i?(e+100*(i-r-1))/i:100}}))},r.prototype.openedSource=function(t){this.currentSourceOffset=this.bytesWritten,this.currentFile=t.file.name;var e=this.streamFiles&&!t.file.dir;if(e){var i=u(t,e,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:i.fileRecord,meta:{percent:0}})}else this.accumulate=!0},r.prototype.closedSource=function(t){this.accumulate=!1;var e=this.streamFiles&&!t.file.dir,i=u(t,e,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(i.dirRecord),e)this.push({data:function(t){return l.DATA_DESCRIPTOR+h(t.crc32,4)+h(t.compressedSize,4)+h(t.uncompressedSize,4)}(t),meta:{percent:100}});else for(this.push({data:i.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null},r.prototype.flush=function(){for(var t=this.bytesWritten,e=0;e<this.dirRecords.length;e++)this.push({data:this.dirRecords[e],meta:{percent:100}});var i=this.bytesWritten-t,r=function(t,e,i,r,o){var s=n.transformTo("string",o(r));return l.CENTRAL_DIRECTORY_END+"\0\0\0\0"+h(t,2)+h(t,2)+h(e,4)+h(i,4)+h(s.length,2)+s}(this.dirRecords.length,i,t,this.zipComment,this.encodeFileName);this.push({data:r,meta:{percent:100}})},r.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume()},r.prototype.registerPrevious=function(t){this._sources.push(t);var e=this;return t.on("data",function(t){e.processChunk(t)}),t.on("end",function(){e.closedSource(e.previous.streamInfo),e._sources.length?e.prepareNextSource():e.end()}),t.on("error",function(t){e.error(t)}),this},r.prototype.resume=function(){return!!o.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},r.prototype.error=function(t){var e=this._sources;if(!o.prototype.error.call(this,t))return!1;for(var i=0;i<e.length;i++)try{e[i].error(t)}catch(t){}return!0},r.prototype.lock=function(){o.prototype.lock.call(this);for(var t=this._sources,e=0;e<t.length;e++)t[e].lock()},t.exports=r},function(t,e,i){"use strict";t.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},function(t,e,i){"use strict";var r=i(2),n=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],o=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],s=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],a=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(t,e,i,l,h,u,c,d){var p,f,g,m,y,E,v,_,b,w=d.bits,S=0,L=0,T=0,A=0,R=0,x=0,C=0,M=0,P=0,O=0,N=null,I=0,D=new r.Buf16(16),k=new r.Buf16(16),F=null,V=0;for(S=0;S<=15;S++)D[S]=0;for(L=0;L<l;L++)D[e[i+L]]++;for(R=w,A=15;A>=1&&0===D[A];A--);if(R>A&&(R=A),0===A)return h[u++]=20971520,h[u++]=20971520,d.bits=1,0;for(T=1;T<A&&0===D[T];T++);for(R<T&&(R=T),M=1,S=1;S<=15;S++)if(M<<=1,(M-=D[S])<0)return-1;if(M>0&&(0===t||1!==A))return-1;for(k[1]=0,S=1;S<15;S++)k[S+1]=k[S]+D[S];for(L=0;L<l;L++)0!==e[i+L]&&(c[k[e[i+L]]++]=L);if(0===t?(N=F=c,E=19):1===t?(N=n,I-=257,F=o,V-=257,E=256):(N=s,F=a,E=-1),O=0,L=0,S=T,y=u,x=R,C=0,g=-1,m=(P=1<<R)-1,1===t&&P>852||2===t&&P>592)return 1;for(;;){v=S-C,c[L]<E?(_=0,b=c[L]):c[L]>E?(_=F[V+c[L]],b=N[I+c[L]]):(_=96,b=0),p=1<<S-C,T=f=1<<x;do h[y+(O>>C)+(f-=p)]=v<<24|_<<16|b|0;while(0!==f);for(p=1<<S-1;O&p;)p>>=1;if(0!==p?(O&=p-1,O+=p):O=0,L++,0==--D[S]){if(S===A)break;S=e[i+c[L]]}if(S>R&&(O&m)!==g){for(0===C&&(C=R),y+=T,M=1<<(x=S-C);x+C<A&&!((M-=D[x+C])<=0);)x++,M<<=1;if(P+=1<<x,1===t&&P>852||2===t&&P>592)return 1;h[g=O&m]=R<<24|x<<16|y-u|0}}return 0!==O&&(h[y+O]=S-C<<24|64<<16|0),d.bits=R,0}},function(t,e,i){"use strict";t.exports=function(t,e){var i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_,b,w,S,L,T,A;i=t.state,r=t.next_in,T=t.input,n=r+(t.avail_in-5),o=t.next_out,A=t.output,s=o-(e-t.avail_out),a=o+(t.avail_out-257),l=i.dmax,h=i.wsize,u=i.whave,c=i.wnext,d=i.window,p=i.hold,f=i.bits,g=i.lencode,m=i.distcode,y=(1<<i.lenbits)-1,E=(1<<i.distbits)-1;t:do{f<15&&(p+=T[r++]<<f,f+=8,p+=T[r++]<<f,f+=8),v=g[p&y];e:for(;;){if(p>>>=_=v>>>24,f-=_,0===(_=v>>>16&255))A[o++]=65535&v;else{if(!(16&_)){if(0==(64&_)){v=g[(65535&v)+(p&(1<<_)-1)];continue e}if(32&_){i.mode=12;break t}t.msg="invalid literal/length code",i.mode=30;break t}b=65535&v,(_&=15)&&(f<_&&(p+=T[r++]<<f,f+=8),b+=p&(1<<_)-1,p>>>=_,f-=_),f<15&&(p+=T[r++]<<f,f+=8,p+=T[r++]<<f,f+=8),v=m[p&E];i:for(;;){if(p>>>=_=v>>>24,f-=_,!(16&(_=v>>>16&255))){if(0==(64&_)){v=m[(65535&v)+(p&(1<<_)-1)];continue i}t.msg="invalid distance code",i.mode=30;break t}if(w=65535&v,f<(_&=15)&&(p+=T[r++]<<f,(f+=8)<_&&(p+=T[r++]<<f,f+=8)),(w+=p&(1<<_)-1)>l){t.msg="invalid distance too far back",i.mode=30;break t}if(p>>>=_,f-=_,w>(_=o-s)){if((_=w-_)>u&&i.sane){t.msg="invalid distance too far back",i.mode=30;break t}if(S=0,L=d,0===c){if(S+=h-_,_<b){b-=_;do A[o++]=d[S++];while(--_);S=o-w,L=A}}else if(c<_){if(S+=h+c-_,(_-=c)<b){b-=_;do A[o++]=d[S++];while(--_);if(S=0,c<b){b-=_=c;do A[o++]=d[S++];while(--_);S=o-w,L=A}}}else if(S+=c-_,_<b){b-=_;do A[o++]=d[S++];while(--_);S=o-w,L=A}for(;b>2;)A[o++]=L[S++],A[o++]=L[S++],A[o++]=L[S++],b-=3;b&&(A[o++]=L[S++],b>1&&(A[o++]=L[S++]))}else{S=o-w;do A[o++]=A[S++],A[o++]=A[S++],A[o++]=A[S++],b-=3;while(b>2);
b&&(A[o++]=A[S++],b>1&&(A[o++]=A[S++]))}break}}break}}while(r<n&&o<a);r-=b=f>>3,p&=(1<<(f-=b<<3))-1,t.next_in=r,t.next_out=o,t.avail_in=r<n?n-r+5:5-(r-n),t.avail_out=o<a?a-o+257:257-(o-a),i.hold=p,i.bits=f}},function(t,e,i){"use strict";function r(t){return(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24)}function n(t){var e;return t&&t.state?(e=t.state,t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=P,e.last=0,e.havedict=0,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new d.Buf32(ht),e.distcode=e.distdyn=new d.Buf32(ut),e.sane=1,e.back=-1,S):A}function o(t){var e;return t&&t.state?((e=t.state).wsize=0,e.whave=0,e.wnext=0,n(t)):A}function s(t,e){var i,r;return t&&t.state?(r=t.state,e<0?(i=0,e=-e):(i=1+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?A:(null!==r.window&&r.wbits!==e&&(r.window=null),r.wrap=i,r.wbits=e,o(t))):A}function a(t,e){var i,r;return t?(r=new function(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new d.Buf16(320),this.work=new d.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0},t.state=r,r.window=null,(i=s(t,e))!==S&&(t.state=null),i):A}function l(t){if(dt){var e;for(u=new d.Buf32(512),c=new d.Buf32(32),e=0;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(m(E,t.lens,0,288,u,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;m(v,t.lens,0,32,c,0,t.work,{bits:5}),dt=!1}t.lencode=u,t.lenbits=9,t.distcode=c,t.distbits=5}function h(t,e,i,r){var n,o=t.state;return null===o.window&&(o.wsize=1<<o.wbits,o.wnext=0,o.whave=0,o.window=new d.Buf8(o.wsize)),r>=o.wsize?(d.arraySet(o.window,e,i-o.wsize,o.wsize,0),o.wnext=0,o.whave=o.wsize):((n=o.wsize-o.wnext)>r&&(n=r),d.arraySet(o.window,e,i-r,n,o.wnext),(r-=n)?(d.arraySet(o.window,e,i-r,r,0),o.wnext=r,o.whave=o.wsize):(o.wnext+=n,o.wnext===o.wsize&&(o.wnext=0),o.whave<o.wsize&&(o.whave+=n))),0}var u,c,d=i(2),p=i(33),f=i(32),g=i(61),m=i(60),y=0,E=1,v=2,_=4,b=5,w=6,S=0,L=1,T=2,A=-2,R=-3,x=-4,C=-5,M=8,P=1,O=2,N=3,I=4,D=5,k=6,F=7,V=8,G=9,W=10,B=11,U=12,K=13,j=14,z=15,H=16,q=17,Y=18,X=19,J=20,Q=21,Z=22,$=23,tt=24,et=25,it=26,rt=27,nt=28,ot=29,st=30,at=31,lt=32,ht=852,ut=592,ct=15,dt=!0;e.inflateReset=o,e.inflateReset2=s,e.inflateResetKeep=n,e.inflateInit=function(t){return a(t,ct)},e.inflateInit2=a,e.inflate=function(t,e){var i,n,o,s,a,u,c,ht,ut,ct,dt,pt,ft,gt,mt,yt,Et,vt,_t,bt,wt,St,Lt,Tt,At=0,Rt=new d.Buf8(4),xt=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!t||!t.state||!t.output||!t.input&&0!==t.avail_in)return A;(i=t.state).mode===U&&(i.mode=K),a=t.next_out,o=t.output,c=t.avail_out,s=t.next_in,n=t.input,u=t.avail_in,ht=i.hold,ut=i.bits,ct=u,dt=c,St=S;t:for(;;)switch(i.mode){case P:if(0===i.wrap){i.mode=K;break}for(;ut<16;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}if(2&i.wrap&&35615===ht){i.check=0,Rt[0]=255&ht,Rt[1]=ht>>>8&255,i.check=f(i.check,Rt,2,0),ht=0,ut=0,i.mode=O;break}if(i.flags=0,i.head&&(i.head.done=!1),!(1&i.wrap)||(((255&ht)<<8)+(ht>>8))%31){t.msg="incorrect header check",i.mode=st;break}if((15&ht)!==M){t.msg="unknown compression method",i.mode=st;break}if(ut-=4,wt=8+(15&(ht>>>=4)),0===i.wbits)i.wbits=wt;else if(wt>i.wbits){t.msg="invalid window size",i.mode=st;break}i.dmax=1<<wt,t.adler=i.check=1,i.mode=512&ht?W:U,ht=0,ut=0;break;case O:for(;ut<16;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}if(i.flags=ht,(255&i.flags)!==M){t.msg="unknown compression method",i.mode=st;break}if(57344&i.flags){t.msg="unknown header flags set",i.mode=st;break}i.head&&(i.head.text=ht>>8&1),512&i.flags&&(Rt[0]=255&ht,Rt[1]=ht>>>8&255,i.check=f(i.check,Rt,2,0)),ht=0,ut=0,i.mode=N;case N:for(;ut<32;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}i.head&&(i.head.time=ht),512&i.flags&&(Rt[0]=255&ht,Rt[1]=ht>>>8&255,Rt[2]=ht>>>16&255,Rt[3]=ht>>>24&255,i.check=f(i.check,Rt,4,0)),ht=0,ut=0,i.mode=I;case I:for(;ut<16;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}i.head&&(i.head.xflags=255&ht,i.head.os=ht>>8),512&i.flags&&(Rt[0]=255&ht,Rt[1]=ht>>>8&255,i.check=f(i.check,Rt,2,0)),ht=0,ut=0,i.mode=D;case D:if(1024&i.flags){for(;ut<16;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}i.length=ht,i.head&&(i.head.extra_len=ht),512&i.flags&&(Rt[0]=255&ht,Rt[1]=ht>>>8&255,i.check=f(i.check,Rt,2,0)),ht=0,ut=0}else i.head&&(i.head.extra=null);i.mode=k;case k:if(1024&i.flags&&((pt=i.length)>u&&(pt=u),pt&&(i.head&&(wt=i.head.extra_len-i.length,i.head.extra||(i.head.extra=new Array(i.head.extra_len)),d.arraySet(i.head.extra,n,s,pt,wt)),512&i.flags&&(i.check=f(i.check,n,pt,s)),u-=pt,s+=pt,i.length-=pt),i.length))break t;i.length=0,i.mode=F;case F:if(2048&i.flags){if(0===u)break t;pt=0;do wt=n[s+pt++],i.head&&wt&&i.length<65536&&(i.head.name+=String.fromCharCode(wt));while(wt&&pt<u);if(512&i.flags&&(i.check=f(i.check,n,pt,s)),u-=pt,s+=pt,wt)break t}else i.head&&(i.head.name=null);i.length=0,i.mode=V;case V:if(4096&i.flags){if(0===u)break t;pt=0;do wt=n[s+pt++],i.head&&wt&&i.length<65536&&(i.head.comment+=String.fromCharCode(wt));while(wt&&pt<u);if(512&i.flags&&(i.check=f(i.check,n,pt,s)),u-=pt,s+=pt,wt)break t}else i.head&&(i.head.comment=null);i.mode=G;case G:if(512&i.flags){for(;ut<16;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}if(ht!==(65535&i.check)){t.msg="header crc mismatch",i.mode=st;break}ht=0,ut=0}i.head&&(i.head.hcrc=i.flags>>9&1,i.head.done=!0),t.adler=i.check=0,i.mode=U;break;case W:for(;ut<32;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}t.adler=i.check=r(ht),ht=0,ut=0,i.mode=B;case B:if(0===i.havedict)return t.next_out=a,t.avail_out=c,t.next_in=s,t.avail_in=u,i.hold=ht,i.bits=ut,T;t.adler=i.check=1,i.mode=U;case U:if(e===b||e===w)break t;case K:if(i.last){ht>>>=7&ut,ut-=7&ut,i.mode=rt;break}for(;ut<3;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}switch(i.last=1&ht,ut-=1,3&(ht>>>=1)){case 0:i.mode=j;break;case 1:if(l(i),i.mode=J,e===w){ht>>>=2,ut-=2;break t}break;case 2:i.mode=q;break;case 3:t.msg="invalid block type",i.mode=st}ht>>>=2,ut-=2;break;case j:for(ht>>>=7&ut,ut-=7&ut;ut<32;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}if((65535&ht)!=(ht>>>16^65535)){t.msg="invalid stored block lengths",i.mode=st;break}if(i.length=65535&ht,ht=0,ut=0,i.mode=z,e===w)break t;case z:i.mode=H;case H:if(pt=i.length){if(pt>u&&(pt=u),pt>c&&(pt=c),0===pt)break t;d.arraySet(o,n,s,pt,a),u-=pt,s+=pt,c-=pt,a+=pt,i.length-=pt;break}i.mode=U;break;case q:for(;ut<14;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}if(i.nlen=257+(31&ht),ht>>>=5,ut-=5,i.ndist=1+(31&ht),ht>>>=5,ut-=5,i.ncode=4+(15&ht),ht>>>=4,ut-=4,i.nlen>286||i.ndist>30){t.msg="too many length or distance symbols",i.mode=st;break}i.have=0,i.mode=Y;case Y:for(;i.have<i.ncode;){for(;ut<3;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}i.lens[xt[i.have++]]=7&ht,ht>>>=3,ut-=3}for(;i.have<19;)i.lens[xt[i.have++]]=0;if(i.lencode=i.lendyn,i.lenbits=7,Lt={bits:i.lenbits},St=m(y,i.lens,0,19,i.lencode,0,i.work,Lt),i.lenbits=Lt.bits,St){t.msg="invalid code lengths set",i.mode=st;break}i.have=0,i.mode=X;case X:for(;i.have<i.nlen+i.ndist;){for(;yt=(At=i.lencode[ht&(1<<i.lenbits)-1])>>>16&255,Et=65535&At,!((mt=At>>>24)<=ut);){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}if(Et<16)ht>>>=mt,ut-=mt,i.lens[i.have++]=Et;else{if(16===Et){for(Tt=mt+2;ut<Tt;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}if(ht>>>=mt,ut-=mt,0===i.have){t.msg="invalid bit length repeat",i.mode=st;break}wt=i.lens[i.have-1],pt=3+(3&ht),ht>>>=2,ut-=2}else if(17===Et){for(Tt=mt+3;ut<Tt;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}ut-=mt,wt=0,pt=3+(7&(ht>>>=mt)),ht>>>=3,ut-=3}else{for(Tt=mt+7;ut<Tt;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}ut-=mt,wt=0,pt=11+(127&(ht>>>=mt)),ht>>>=7,ut-=7}if(i.have+pt>i.nlen+i.ndist){t.msg="invalid bit length repeat",i.mode=st;break}for(;pt--;)i.lens[i.have++]=wt}}if(i.mode===st)break;if(0===i.lens[256]){t.msg="invalid code -- missing end-of-block",i.mode=st;break}if(i.lenbits=9,Lt={bits:i.lenbits},St=m(E,i.lens,0,i.nlen,i.lencode,0,i.work,Lt),i.lenbits=Lt.bits,St){t.msg="invalid literal/lengths set",i.mode=st;break}if(i.distbits=6,i.distcode=i.distdyn,Lt={bits:i.distbits},St=m(v,i.lens,i.nlen,i.ndist,i.distcode,0,i.work,Lt),i.distbits=Lt.bits,St){t.msg="invalid distances set",i.mode=st;break}if(i.mode=J,e===w)break t;case J:i.mode=Q;case Q:if(u>=6&&c>=258){t.next_out=a,t.avail_out=c,t.next_in=s,t.avail_in=u,i.hold=ht,i.bits=ut,g(t,dt),a=t.next_out,o=t.output,c=t.avail_out,s=t.next_in,n=t.input,u=t.avail_in,ht=i.hold,ut=i.bits,i.mode===U&&(i.back=-1);break}for(i.back=0;yt=(At=i.lencode[ht&(1<<i.lenbits)-1])>>>16&255,Et=65535&At,!((mt=At>>>24)<=ut);){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}if(yt&&0==(240&yt)){for(vt=mt,_t=yt,bt=Et;yt=(At=i.lencode[bt+((ht&(1<<vt+_t)-1)>>vt)])>>>16&255,Et=65535&At,!(vt+(mt=At>>>24)<=ut);){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}ht>>>=vt,ut-=vt,i.back+=vt}if(ht>>>=mt,ut-=mt,i.back+=mt,i.length=Et,0===yt){i.mode=it;break}if(32&yt){i.back=-1,i.mode=U;break}if(64&yt){t.msg="invalid literal/length code",i.mode=st;break}i.extra=15&yt,i.mode=Z;case Z:if(i.extra){for(Tt=i.extra;ut<Tt;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}i.length+=ht&(1<<i.extra)-1,ht>>>=i.extra,ut-=i.extra,i.back+=i.extra}i.was=i.length,i.mode=$;case $:for(;yt=(At=i.distcode[ht&(1<<i.distbits)-1])>>>16&255,Et=65535&At,!((mt=At>>>24)<=ut);){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}if(0==(240&yt)){for(vt=mt,_t=yt,bt=Et;yt=(At=i.distcode[bt+((ht&(1<<vt+_t)-1)>>vt)])>>>16&255,Et=65535&At,!(vt+(mt=At>>>24)<=ut);){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}ht>>>=vt,ut-=vt,i.back+=vt}if(ht>>>=mt,ut-=mt,i.back+=mt,64&yt){t.msg="invalid distance code",i.mode=st;break}i.offset=Et,i.extra=15&yt,i.mode=tt;case tt:if(i.extra){for(Tt=i.extra;ut<Tt;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}i.offset+=ht&(1<<i.extra)-1,ht>>>=i.extra,ut-=i.extra,i.back+=i.extra}if(i.offset>i.dmax){t.msg="invalid distance too far back",i.mode=st;break}i.mode=et;case et:if(0===c)break t;if(pt=dt-c,i.offset>pt){if((pt=i.offset-pt)>i.whave&&i.sane){t.msg="invalid distance too far back",i.mode=st;break}pt>i.wnext?(pt-=i.wnext,ft=i.wsize-pt):ft=i.wnext-pt,pt>i.length&&(pt=i.length),gt=i.window}else gt=o,ft=a-i.offset,pt=i.length;pt>c&&(pt=c),c-=pt,i.length-=pt;do o[a++]=gt[ft++];while(--pt);0===i.length&&(i.mode=Q);break;case it:if(0===c)break t;o[a++]=i.length,c--,i.mode=Q;break;case rt:if(i.wrap){for(;ut<32;){if(0===u)break t;u--,ht|=n[s++]<<ut,ut+=8}if(dt-=c,t.total_out+=dt,i.total+=dt,dt&&(t.adler=i.check=i.flags?f(i.check,o,dt,a-dt):p(i.check,o,dt,a-dt)),dt=c,(i.flags?ht:r(ht))!==i.check){t.msg="incorrect data check",i.mode=st;break}ht=0,ut=0}i.mode=nt;case nt:if(i.wrap&&i.flags){for(;ut<32;){if(0===u)break t;u--,ht+=n[s++]<<ut,ut+=8}if(ht!==(4294967295&i.total)){t.msg="incorrect length check",i.mode=st;break}ht=0,ut=0}i.mode=ot;case ot:St=L;break t;case st:St=R;break t;case at:return x;case lt:default:return A}return t.next_out=a,t.avail_out=c,t.next_in=s,t.avail_in=u,i.hold=ht,i.bits=ut,(i.wsize||dt!==t.avail_out&&i.mode<st&&(i.mode<rt||e!==_))&&h(t,t.output,t.next_out,dt-t.avail_out)?(i.mode=at,x):(ct-=t.avail_in,dt-=t.avail_out,t.total_in+=ct,t.total_out+=dt,i.total+=dt,i.wrap&&dt&&(t.adler=i.check=i.flags?f(i.check,o,dt,t.next_out-dt):p(i.check,o,dt,t.next_out-dt)),t.data_type=i.bits+(i.last?64:0)+(i.mode===U?128:0)+(i.mode===J||i.mode===z?256:0),(0===ct&&0===dt||e===_)&&St===S&&(St=C),St)},e.inflateEnd=function(t){if(!t||!t.state)return A;var e=t.state;return e.window&&(e.window=null),t.state=null,S},e.inflateGetHeader=function(t,e){var i;return t&&t.state?0==(2&(i=t.state).wrap)?A:(i.head=e,e.done=!1,S):A},e.inflateSetDictionary=function(t,e){var i,r=e.length;return t&&t.state?0!==(i=t.state).wrap&&i.mode!==B?A:i.mode===B&&p(1,e,r,0)!==i.check?R:h(t,e,r,r)?(i.mode=at,x):(i.havedict=1,S):A},e.inflateInfo="pako inflate (from Nodeca project)"},function(t,e,i){"use strict";function r(t){if(!(this instanceof r))return new r(t);this.options=s.assign({chunkSize:16384,windowBits:0,to:""},t||{});var e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new u,this.strm.avail_out=0;var i=o.inflateInit2(this.strm,e.windowBits);if(i!==l.Z_OK)throw new Error(h[i]);this.header=new c,o.inflateGetHeader(this.strm,this.header)}function n(t,e){var i=new r(e);if(i.push(t,!0),i.err)throw i.msg||h[i.err];return i.result}var o=i(62),s=i(2),a=i(31),l=i(29),h=i(16),u=i(30),c=i(59),d=Object.prototype.toString;r.prototype.push=function(t,e){var i,r,n,h,u,c,p=this.strm,f=this.options.chunkSize,g=this.options.dictionary,m=!1;if(this.ended)return!1;r=e===~~e?e:!0===e?l.Z_FINISH:l.Z_NO_FLUSH,"string"==typeof t?p.input=a.binstring2buf(t):"[object ArrayBuffer]"===d.call(t)?p.input=new Uint8Array(t):p.input=t,p.next_in=0,p.avail_in=p.input.length;do{if(0===p.avail_out&&(p.output=new s.Buf8(f),p.next_out=0,p.avail_out=f),(i=o.inflate(p,l.Z_NO_FLUSH))===l.Z_NEED_DICT&&g&&(c="string"==typeof g?a.string2buf(g):"[object ArrayBuffer]"===d.call(g)?new Uint8Array(g):g,i=o.inflateSetDictionary(this.strm,c)),i===l.Z_BUF_ERROR&&!0===m&&(i=l.Z_OK,m=!1),i!==l.Z_STREAM_END&&i!==l.Z_OK)return this.onEnd(i),this.ended=!0,!1;p.next_out&&(0!==p.avail_out&&i!==l.Z_STREAM_END&&(0!==p.avail_in||r!==l.Z_FINISH&&r!==l.Z_SYNC_FLUSH)||("string"===this.options.to?(n=a.utf8border(p.output,p.next_out),h=p.next_out-n,u=a.buf2string(p.output,n),p.next_out=h,p.avail_out=f-h,h&&s.arraySet(p.output,p.output,n,h,0),this.onData(u)):this.onData(s.shrinkBuf(p.output,p.next_out)))),0===p.avail_in&&0===p.avail_out&&(m=!0)}while((p.avail_in>0||0===p.avail_out)&&i!==l.Z_STREAM_END);return i===l.Z_STREAM_END&&(r=l.Z_FINISH),r===l.Z_FINISH?(i=o.inflateEnd(this.strm),this.onEnd(i),this.ended=!0,i===l.Z_OK):r!==l.Z_SYNC_FLUSH||(this.onEnd(l.Z_OK),p.avail_out=0,!0)},r.prototype.onData=function(t){this.chunks.push(t)},r.prototype.onEnd=function(t){t===l.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=s.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},e.Inflate=r,e.inflate=n,e.inflateRaw=function(t,e){return(e=e||{}).raw=!0,n(t,e)},e.ungzip=n},function(t,e,i){"use strict";function r(t){for(var e=t.length;--e>=0;)t[e]=0}function n(t,e,i,r,n){this.static_tree=t,this.extra_bits=e,this.extra_base=i,this.elems=r,this.max_length=n,this.has_stree=t&&t.length}function o(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}function s(t){return t<256?Y[t]:Y[256+(t>>>7)]}function a(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255}function l(t,e,i){t.bi_valid>k-i?(t.bi_buf|=e<<t.bi_valid&65535,a(t,t.bi_buf),t.bi_buf=e>>k-t.bi_valid,t.bi_valid+=i-k):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=i)}function h(t,e,i){l(t,i[2*e],i[2*e+1])}function u(t,e){var i=0;do i|=1&t,t>>>=1,i<<=1;while(--e>0);return i>>>1}function c(t,e,i){var r,n,o=new Array(D+1),s=0;for(r=1;r<=D;r++)o[r]=s=s+i[r-1]<<1;for(n=0;n<=e;n++){var a=t[2*n+1];0!==a&&(t[2*n]=u(o[a]++,a))}}function d(t){var e;for(e=0;e<P;e++)t.dyn_ltree[2*e]=0;for(e=0;e<O;e++)t.dyn_dtree[2*e]=0;for(e=0;e<N;e++)t.bl_tree[2*e]=0;t.dyn_ltree[2*V]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0}function p(t){t.bi_valid>8?a(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0}function f(t,e,i,r){var n=2*e,o=2*i;return t[n]<t[o]||t[n]===t[o]&&r[e]<=r[i]}function g(t,e,i){for(var r=t.heap[i],n=i<<1;n<=t.heap_len&&(n<t.heap_len&&f(e,t.heap[n+1],t.heap[n],t.depth)&&n++,!f(e,r,t.heap[n],t.depth));)t.heap[i]=t.heap[n],i=n,n<<=1;t.heap[i]=r}function m(t,e,i){var r,n,o,a,u=0;if(0!==t.last_lit)do r=t.pending_buf[t.d_buf+2*u]<<8|t.pending_buf[t.d_buf+2*u+1],n=t.pending_buf[t.l_buf+u],u++,0===r?h(t,n,e):(h(t,(o=X[n])+M+1,e),0!==(a=U[o])&&l(t,n-=J[o],a),h(t,o=s(--r),i),0!==(a=K[o])&&l(t,r-=tt[o],a));while(u<t.last_lit);h(t,V,e)}function y(t,e){var i,r,n,o=e.dyn_tree,s=e.stat_desc.static_tree,a=e.stat_desc.has_stree,l=e.stat_desc.elems,h=-1;for(t.heap_len=0,t.heap_max=I,i=0;i<l;i++)0!==o[2*i]?(t.heap[++t.heap_len]=h=i,t.depth[i]=0):o[2*i+1]=0;for(;t.heap_len<2;)o[2*(n=t.heap[++t.heap_len]=h<2?++h:0)]=1,t.depth[n]=0,t.opt_len--,a&&(t.static_len-=s[2*n+1]);for(e.max_code=h,i=t.heap_len>>1;i>=1;i--)g(t,o,i);n=l;do i=t.heap[1],t.heap[1]=t.heap[t.heap_len--],g(t,o,1),r=t.heap[1],t.heap[--t.heap_max]=i,t.heap[--t.heap_max]=r,o[2*n]=o[2*i]+o[2*r],t.depth[n]=(t.depth[i]>=t.depth[r]?t.depth[i]:t.depth[r])+1,o[2*i+1]=o[2*r+1]=n,t.heap[1]=n++,g(t,o,1);while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var i,r,n,o,s,a,l=e.dyn_tree,h=e.max_code,u=e.stat_desc.static_tree,c=e.stat_desc.has_stree,d=e.stat_desc.extra_bits,p=e.stat_desc.extra_base,f=e.stat_desc.max_length,g=0;for(o=0;o<=D;o++)t.bl_count[o]=0;for(l[2*t.heap[t.heap_max]+1]=0,i=t.heap_max+1;i<I;i++)(o=l[2*l[2*(r=t.heap[i])+1]+1]+1)>f&&(o=f,g++),l[2*r+1]=o,r>h||(t.bl_count[o]++,s=0,r>=p&&(s=d[r-p]),a=l[2*r],t.opt_len+=a*(o+s),c&&(t.static_len+=a*(u[2*r+1]+s)));if(0!==g){do{for(o=f-1;0===t.bl_count[o];)o--;t.bl_count[o]--,t.bl_count[o+1]+=2,t.bl_count[f]--,g-=2}while(g>0);for(o=f;0!==o;o--)for(r=t.bl_count[o];0!==r;)(n=t.heap[--i])>h||(l[2*n+1]!==o&&(t.opt_len+=(o-l[2*n+1])*l[2*n],l[2*n+1]=o),r--)}}(t,e),c(o,h,t.bl_count)}function E(t,e,i){var r,n,o=-1,s=e[1],a=0,l=7,h=4;for(0===s&&(l=138,h=3),e[2*(i+1)+1]=65535,r=0;r<=i;r++)n=s,s=e[2*(r+1)+1],++a<l&&n===s||(a<h?t.bl_tree[2*n]+=a:0!==n?(n!==o&&t.bl_tree[2*n]++,t.bl_tree[2*G]++):a<=10?t.bl_tree[2*W]++:t.bl_tree[2*B]++,a=0,o=n,0===s?(l=138,h=3):n===s?(l=6,h=3):(l=7,h=4))}function v(t,e,i){var r,n,o=-1,s=e[1],a=0,u=7,c=4;for(0===s&&(u=138,c=3),r=0;r<=i;r++)if(n=s,s=e[2*(r+1)+1],!(++a<u&&n===s)){if(a<c){do h(t,n,t.bl_tree);while(0!=--a)}else 0!==n?(n!==o&&(h(t,n,t.bl_tree),a--),h(t,G,t.bl_tree),l(t,a-3,2)):a<=10?(h(t,W,t.bl_tree),l(t,a-3,3)):(h(t,B,t.bl_tree),l(t,a-11,7));a=0,o=n,0===s?(u=138,c=3):n===s?(u=6,c=3):(u=7,c=4)}}function _(t,e,i,r){l(t,(A<<1)+(r?1:0),3),function(t,e,i,r){p(t),r&&(a(t,i),a(t,~i)),b.arraySet(t.pending_buf,t.window,e,i,t.pending),t.pending+=i}(t,e,i,!0)}var b=i(2),w=4,S=0,L=1,T=2,A=0,R=1,x=2,C=29,M=256,P=M+1+C,O=30,N=19,I=2*P+1,D=15,k=16,F=7,V=256,G=16,W=17,B=18,U=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],K=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],j=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],z=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],H=new Array(2*(P+2));r(H);var q=new Array(2*O);r(q);var Y=new Array(512);r(Y);var X=new Array(256);r(X);var J=new Array(C);r(J);var Q,Z,$,tt=new Array(O);r(tt);var et=!1;e._tr_init=function(t){et||(function(){var t,e,i,r,o,s=new Array(D+1);for(i=0,r=0;r<C-1;r++)for(J[r]=i,t=0;t<1<<U[r];t++)X[i++]=r;for(X[i-1]=r,o=0,r=0;r<16;r++)for(tt[r]=o,t=0;t<1<<K[r];t++)Y[o++]=r;for(o>>=7;r<O;r++)for(tt[r]=o<<7,t=0;t<1<<K[r]-7;t++)Y[256+o++]=r;for(e=0;e<=D;e++)s[e]=0;for(t=0;t<=143;)H[2*t+1]=8,t++,s[8]++;for(;t<=255;)H[2*t+1]=9,t++,s[9]++;for(;t<=279;)H[2*t+1]=7,t++,s[7]++;for(;t<=287;)H[2*t+1]=8,t++,s[8]++;for(c(H,P+1,s),t=0;t<O;t++)q[2*t+1]=5,q[2*t]=u(t,5);Q=new n(H,U,M+1,P,D),Z=new n(q,K,0,O,D),$=new n(new Array(0),j,0,N,F)}(),et=!0),t.l_desc=new o(t.dyn_ltree,Q),t.d_desc=new o(t.dyn_dtree,Z),t.bl_desc=new o(t.bl_tree,$),t.bi_buf=0,t.bi_valid=0,d(t)},e._tr_stored_block=_,e._tr_flush_block=function(t,e,i,r){var n,o,s=0;t.level>0?(t.strm.data_type===T&&(t.strm.data_type=function(t){var e,i=4093624447;for(e=0;e<=31;e++,i>>>=1)if(1&i&&0!==t.dyn_ltree[2*e])return S;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return L;for(e=32;e<M;e++)if(0!==t.dyn_ltree[2*e])return L;return S}(t)),y(t,t.l_desc),y(t,t.d_desc),s=function(t){var e;for(E(t,t.dyn_ltree,t.l_desc.max_code),E(t,t.dyn_dtree,t.d_desc.max_code),y(t,t.bl_desc),e=N-1;e>=3&&0===t.bl_tree[2*z[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),n=t.opt_len+3+7>>>3,(o=t.static_len+3+7>>>3)<=n&&(n=o)):n=o=i+5,i+4<=n&&-1!==e?_(t,e,i,r):t.strategy===w||o===n?(l(t,(R<<1)+(r?1:0),3),m(t,H,q)):(l(t,(x<<1)+(r?1:0),3),function(t,e,i,r){var n;for(l(t,e-257,5),l(t,i-1,5),l(t,r-4,4),n=0;n<r;n++)l(t,t.bl_tree[2*z[n]+1],3);v(t,t.dyn_ltree,e-1),v(t,t.dyn_dtree,i-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,s+1),m(t,t.dyn_ltree,t.dyn_dtree)),d(t),r&&p(t)},e._tr_tally=function(t,e,i){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&i,t.last_lit++,0===e?t.dyn_ltree[2*i]++:(t.matches++,e--,t.dyn_ltree[2*(X[i]+M+1)]++,t.dyn_dtree[2*s(e)]++),t.last_lit===t.lit_bufsize-1},e._tr_align=function(t){l(t,R<<1,3),h(t,V,H),function(t){16===t.bi_valid?(a(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},function(t,e,i){"use strict";function r(t,e){return t.msg=L[e],e}function n(t){return(t<<1)-(t>4?9:0)}function o(t){for(var e=t.length;--e>=0;)t[e]=0}function s(t){var e=t.state,i=e.pending;i>t.avail_out&&(i=t.avail_out),0!==i&&(_.arraySet(t.output,e.pending_buf,e.pending_out,i,t.next_out),t.next_out+=i,e.pending_out+=i,t.total_out+=i,t.avail_out-=i,e.pending-=i,0===e.pending&&(e.pending_out=0))}function a(t,e){b._tr_flush_block(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,s(t.strm)}function l(t,e){t.pending_buf[t.pending++]=e}function h(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e}function u(t,e,i,r){var n=t.avail_in;return n>r&&(n=r),0===n?0:(t.avail_in-=n,_.arraySet(e,t.input,t.next_in,n,i),1===t.state.wrap?t.adler=w(t.adler,e,n,i):2===t.state.wrap&&(t.adler=S(t.adler,e,n,i)),t.next_in+=n,t.total_in+=n,n)}function c(t,e){var i,r,n=t.max_chain_length,o=t.strstart,s=t.prev_length,a=t.nice_match,l=t.strstart>t.w_size-$?t.strstart-(t.w_size-$):0,h=t.window,u=t.w_mask,c=t.prev,d=t.strstart+Z,p=h[o+s-1],f=h[o+s];t.prev_length>=t.good_match&&(n>>=2),a>t.lookahead&&(a=t.lookahead);do if(h[(i=e)+s]===f&&h[i+s-1]===p&&h[i]===h[o]&&h[++i]===h[o+1]){o+=2,i++;do;while(h[++o]===h[++i]&&h[++o]===h[++i]&&h[++o]===h[++i]&&h[++o]===h[++i]&&h[++o]===h[++i]&&h[++o]===h[++i]&&h[++o]===h[++i]&&h[++o]===h[++i]&&o<d);if(r=Z-(d-o),o=d-Z,r>s){if(t.match_start=e,s=r,r>=a)break;p=h[o+s-1],f=h[o+s]}}while((e=c[e&u])>l&&0!=--n);return s<=t.lookahead?s:t.lookahead}function d(t){var e,i,r,n,o,s=t.w_size;do{if(n=t.window_size-t.lookahead-t.strstart,t.strstart>=s+(s-$)){_.arraySet(t.window,t.window,s,s,0),t.match_start-=s,t.strstart-=s,t.block_start-=s,e=i=t.hash_size;do r=t.head[--e],t.head[e]=r>=s?r-s:0;while(--i);e=i=s;do r=t.prev[--e],t.prev[e]=r>=s?r-s:0;while(--i);n+=s}if(0===t.strm.avail_in)break;if(i=u(t.strm,t.window,t.strstart+t.lookahead,n),t.lookahead+=i,t.lookahead+t.insert>=Q)for(o=t.strstart-t.insert,t.ins_h=t.window[o],t.ins_h=(t.ins_h<<t.hash_shift^t.window[o+1])&t.hash_mask;t.insert&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[o+Q-1])&t.hash_mask,t.prev[o&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=o,o++,t.insert--,!(t.lookahead+t.insert<Q)););}while(t.lookahead<$&&0!==t.strm.avail_in)}function p(t,e){for(var i,r;;){if(t.lookahead<$){if(d(t),t.lookahead<$&&e===T)return lt;if(0===t.lookahead)break}if(i=0,t.lookahead>=Q&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+Q-1])&t.hash_mask,i=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==i&&t.strstart-i<=t.w_size-$&&(t.match_length=c(t,i)),t.match_length>=Q)if(r=b._tr_tally(t,t.strstart-t.match_start,t.match_length-Q),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=Q){t.match_length--;do t.strstart++,t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+Q-1])&t.hash_mask,i=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart;while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+1])&t.hash_mask;else r=b._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(r&&(a(t,!1),0===t.strm.avail_out))return lt}return t.insert=t.strstart<Q-1?t.strstart:Q-1,e===x?(a(t,!0),0===t.strm.avail_out?ut:ct):t.last_lit&&(a(t,!1),0===t.strm.avail_out)?lt:ht}function f(t,e){for(var i,r,n;;){if(t.lookahead<$){if(d(t),t.lookahead<$&&e===T)return lt;if(0===t.lookahead)break}if(i=0,t.lookahead>=Q&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+Q-1])&t.hash_mask,i=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=Q-1,0!==i&&t.prev_length<t.max_lazy_match&&t.strstart-i<=t.w_size-$&&(t.match_length=c(t,i),t.match_length<=5&&(t.strategy===k||t.match_length===Q&&t.strstart-t.match_start>4096)&&(t.match_length=Q-1)),t.prev_length>=Q&&t.match_length<=t.prev_length){n=t.strstart+t.lookahead-Q,r=b._tr_tally(t,t.strstart-1-t.prev_match,t.prev_length-Q),t.lookahead-=t.prev_length-1,t.prev_length-=2;do++t.strstart<=n&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+Q-1])&t.hash_mask,i=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart);while(0!=--t.prev_length);if(t.match_available=0,t.match_length=Q-1,t.strstart++,r&&(a(t,!1),0===t.strm.avail_out))return lt}else if(t.match_available){if((r=b._tr_tally(t,0,t.window[t.strstart-1]))&&a(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return lt}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(r=b._tr_tally(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<Q-1?t.strstart:Q-1,e===x?(a(t,!0),0===t.strm.avail_out?ut:ct):t.last_lit&&(a(t,!1),0===t.strm.avail_out)?lt:ht}function g(t,e,i,r,n){this.good_length=t,this.max_lazy=e,this.nice_length=i,this.max_chain=r,this.func=n}function m(t){var e;return t&&t.state?(t.total_in=t.total_out=0,t.data_type=B,(e=t.state).pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?et:st,t.adler=2===e.wrap?0:1,e.last_flush=T,b._tr_init(e),M):r(t,O)}function y(t){var e=m(t);return e===M&&function(t){t.window_size=2*t.w_size,o(t.head),t.max_lazy_match=v[t.level].max_lazy,t.good_match=v[t.level].good_length,t.nice_match=v[t.level].nice_length,t.max_chain_length=v[t.level].max_chain,t.strstart=0,t.block_start=0,t.lookahead=0,t.insert=0,t.match_length=t.prev_length=Q-1,t.match_available=0,t.ins_h=0}(t.state),e}function E(t,e,i,n,s,a){if(!t)return O;var l=1;if(e===D&&(e=6),n<0?(l=0,n=-n):n>15&&(l=2,n-=16),s<1||s>K||i!==U||n<8||n>15||e<0||e>9||a<0||a>G)return r(t,O);8===n&&(n=9);var h=new function(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=U,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new _.Buf16(2*X),this.dyn_dtree=new _.Buf16(2*(2*q+1)),this.bl_tree=new _.Buf16(2*(2*Y+1)),o(this.dyn_ltree),o(this.dyn_dtree),o(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new _.Buf16(J+1),this.heap=new _.Buf16(2*H+1),o(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new _.Buf16(2*H+1),o(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0};return t.state=h,h.strm=t,h.wrap=l,h.gzhead=null,h.w_bits=n,h.w_size=1<<h.w_bits,h.w_mask=h.w_size-1,h.hash_bits=s+7,h.hash_size=1<<h.hash_bits,h.hash_mask=h.hash_size-1,h.hash_shift=~~((h.hash_bits+Q-1)/Q),h.window=new _.Buf8(2*h.w_size),h.head=new _.Buf16(h.hash_size),h.prev=new _.Buf16(h.w_size),h.lit_bufsize=1<<s+6,h.pending_buf_size=4*h.lit_bufsize,h.pending_buf=new _.Buf8(h.pending_buf_size),h.d_buf=1*h.lit_bufsize,h.l_buf=3*h.lit_bufsize,h.level=e,h.strategy=a,h.method=i,y(t)}var v,_=i(2),b=i(64),w=i(33),S=i(32),L=i(16),T=0,A=1,R=3,x=4,C=5,M=0,P=1,O=-2,N=-3,I=-5,D=-1,k=1,F=2,V=3,G=4,W=0,B=2,U=8,K=9,j=15,z=8,H=286,q=30,Y=19,X=2*H+1,J=15,Q=3,Z=258,$=Z+Q+1,tt=32,et=42,it=69,rt=73,nt=91,ot=103,st=113,at=666,lt=1,ht=2,ut=3,ct=4,dt=3;v=[new g(0,0,0,0,function(t,e){var i=65535;for(i>t.pending_buf_size-5&&(i=t.pending_buf_size-5);;){if(t.lookahead<=1){if(d(t),0===t.lookahead&&e===T)return lt;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var r=t.block_start+i;if((0===t.strstart||t.strstart>=r)&&(t.lookahead=t.strstart-r,t.strstart=r,a(t,!1),0===t.strm.avail_out))return lt;if(t.strstart-t.block_start>=t.w_size-$&&(a(t,!1),0===t.strm.avail_out))return lt}return t.insert=0,e===x?(a(t,!0),0===t.strm.avail_out?ut:ct):(t.strstart>t.block_start&&(a(t,!1),t.strm.avail_out),lt)}),new g(4,4,8,4,p),new g(4,5,16,8,p),new g(4,6,32,32,p),new g(4,4,16,16,f),new g(8,16,32,32,f),new g(8,16,128,128,f),new g(8,32,128,256,f),new g(32,128,258,1024,f),new g(32,258,258,4096,f)],e.deflateInit=function(t,e){return E(t,e,U,j,z,W)},e.deflateInit2=E,e.deflateReset=y,e.deflateResetKeep=m,e.deflateSetHeader=function(t,e){return t&&t.state?2!==t.state.wrap?O:(t.state.gzhead=e,M):O},e.deflate=function(t,e){var i,u,c,p;if(!t||!t.state||e>C||e<0)return t?r(t,O):O;if(u=t.state,!t.output||!t.input&&0!==t.avail_in||u.status===at&&e!==x)return r(t,0===t.avail_out?I:O);if(u.strm=t,i=u.last_flush,u.last_flush=e,u.status===et)if(2===u.wrap)t.adler=0,l(u,31),l(u,139),l(u,8),u.gzhead?(l(u,(u.gzhead.text?1:0)+(u.gzhead.hcrc?2:0)+(u.gzhead.extra?4:0)+(u.gzhead.name?8:0)+(u.gzhead.comment?16:0)),l(u,255&u.gzhead.time),l(u,u.gzhead.time>>8&255),l(u,u.gzhead.time>>16&255),l(u,u.gzhead.time>>24&255),l(u,9===u.level?2:u.strategy>=F||u.level<2?4:0),l(u,255&u.gzhead.os),u.gzhead.extra&&u.gzhead.extra.length&&(l(u,255&u.gzhead.extra.length),l(u,u.gzhead.extra.length>>8&255)),u.gzhead.hcrc&&(t.adler=S(t.adler,u.pending_buf,u.pending,0)),u.gzindex=0,u.status=it):(l(u,0),l(u,0),l(u,0),l(u,0),l(u,0),l(u,9===u.level?2:u.strategy>=F||u.level<2?4:0),l(u,dt),u.status=st);else{var f=U+(u.w_bits-8<<4)<<8;f|=(u.strategy>=F||u.level<2?0:u.level<6?1:6===u.level?2:3)<<6,0!==u.strstart&&(f|=tt),f+=31-f%31,u.status=st,h(u,f),0!==u.strstart&&(h(u,t.adler>>>16),h(u,65535&t.adler)),t.adler=1}if(u.status===it)if(u.gzhead.extra){for(c=u.pending;u.gzindex<(65535&u.gzhead.extra.length)&&(u.pending!==u.pending_buf_size||(u.gzhead.hcrc&&u.pending>c&&(t.adler=S(t.adler,u.pending_buf,u.pending-c,c)),s(t),c=u.pending,u.pending!==u.pending_buf_size));)l(u,255&u.gzhead.extra[u.gzindex]),u.gzindex++;u.gzhead.hcrc&&u.pending>c&&(t.adler=S(t.adler,u.pending_buf,u.pending-c,c)),u.gzindex===u.gzhead.extra.length&&(u.gzindex=0,u.status=rt)}else u.status=rt;if(u.status===rt)if(u.gzhead.name){c=u.pending;do{if(u.pending===u.pending_buf_size&&(u.gzhead.hcrc&&u.pending>c&&(t.adler=S(t.adler,u.pending_buf,u.pending-c,c)),s(t),c=u.pending,u.pending===u.pending_buf_size)){p=1;break}p=u.gzindex<u.gzhead.name.length?255&u.gzhead.name.charCodeAt(u.gzindex++):0,l(u,p)}while(0!==p);u.gzhead.hcrc&&u.pending>c&&(t.adler=S(t.adler,u.pending_buf,u.pending-c,c)),0===p&&(u.gzindex=0,u.status=nt)}else u.status=nt;if(u.status===nt)if(u.gzhead.comment){c=u.pending;do{if(u.pending===u.pending_buf_size&&(u.gzhead.hcrc&&u.pending>c&&(t.adler=S(t.adler,u.pending_buf,u.pending-c,c)),s(t),c=u.pending,u.pending===u.pending_buf_size)){p=1;break}p=u.gzindex<u.gzhead.comment.length?255&u.gzhead.comment.charCodeAt(u.gzindex++):0,l(u,p)}while(0!==p);u.gzhead.hcrc&&u.pending>c&&(t.adler=S(t.adler,u.pending_buf,u.pending-c,c)),
0===p&&(u.status=ot)}else u.status=ot;if(u.status===ot&&(u.gzhead.hcrc?(u.pending+2>u.pending_buf_size&&s(t),u.pending+2<=u.pending_buf_size&&(l(u,255&t.adler),l(u,t.adler>>8&255),t.adler=0,u.status=st)):u.status=st),0!==u.pending){if(s(t),0===t.avail_out)return u.last_flush=-1,M}else if(0===t.avail_in&&n(e)<=n(i)&&e!==x)return r(t,I);if(u.status===at&&0!==t.avail_in)return r(t,I);if(0!==t.avail_in||0!==u.lookahead||e!==T&&u.status!==at){var g=u.strategy===F?function(t,e){for(var i;;){if(0===t.lookahead&&(d(t),0===t.lookahead)){if(e===T)return lt;break}if(t.match_length=0,i=b._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,i&&(a(t,!1),0===t.strm.avail_out))return lt}return t.insert=0,e===x?(a(t,!0),0===t.strm.avail_out?ut:ct):t.last_lit&&(a(t,!1),0===t.strm.avail_out)?lt:ht}(u,e):u.strategy===V?function(t,e){for(var i,r,n,o,s=t.window;;){if(t.lookahead<=Z){if(d(t),t.lookahead<=Z&&e===T)return lt;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=Q&&t.strstart>0&&(r=s[n=t.strstart-1])===s[++n]&&r===s[++n]&&r===s[++n]){o=t.strstart+Z;do;while(r===s[++n]&&r===s[++n]&&r===s[++n]&&r===s[++n]&&r===s[++n]&&r===s[++n]&&r===s[++n]&&r===s[++n]&&n<o);t.match_length=Z-(o-n),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=Q?(i=b._tr_tally(t,1,t.match_length-Q),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(i=b._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),i&&(a(t,!1),0===t.strm.avail_out))return lt}return t.insert=0,e===x?(a(t,!0),0===t.strm.avail_out?ut:ct):t.last_lit&&(a(t,!1),0===t.strm.avail_out)?lt:ht}(u,e):v[u.level].func(u,e);if(g!==ut&&g!==ct||(u.status=at),g===lt||g===ut)return 0===t.avail_out&&(u.last_flush=-1),M;if(g===ht&&(e===A?b._tr_align(u):e!==C&&(b._tr_stored_block(u,0,0,!1),e===R&&(o(u.head),0===u.lookahead&&(u.strstart=0,u.block_start=0,u.insert=0))),s(t),0===t.avail_out))return u.last_flush=-1,M}return e!==x?M:u.wrap<=0?P:(2===u.wrap?(l(u,255&t.adler),l(u,t.adler>>8&255),l(u,t.adler>>16&255),l(u,t.adler>>24&255),l(u,255&t.total_in),l(u,t.total_in>>8&255),l(u,t.total_in>>16&255),l(u,t.total_in>>24&255)):(h(u,t.adler>>>16),h(u,65535&t.adler)),s(t),u.wrap>0&&(u.wrap=-u.wrap),0!==u.pending?M:P)},e.deflateEnd=function(t){var e;return t&&t.state?(e=t.state.status)!==et&&e!==it&&e!==rt&&e!==nt&&e!==ot&&e!==st&&e!==at?r(t,O):(t.state=null,e===st?r(t,N):M):O},e.deflateSetDictionary=function(t,e){var i,r,n,s,a,l,h,u,c=e.length;if(!t||!t.state)return O;if(2===(s=(i=t.state).wrap)||1===s&&i.status!==et||i.lookahead)return O;for(1===s&&(t.adler=w(t.adler,e,c,0)),i.wrap=0,c>=i.w_size&&(0===s&&(o(i.head),i.strstart=0,i.block_start=0,i.insert=0),u=new _.Buf8(i.w_size),_.arraySet(u,e,c-i.w_size,i.w_size,0),e=u,c=i.w_size),a=t.avail_in,l=t.next_in,h=t.input,t.avail_in=c,t.next_in=0,t.input=e,d(i);i.lookahead>=Q;){r=i.strstart,n=i.lookahead-(Q-1);do i.ins_h=(i.ins_h<<i.hash_shift^i.window[r+Q-1])&i.hash_mask,i.prev[r&i.w_mask]=i.head[i.ins_h],i.head[i.ins_h]=r,r++;while(--n);i.strstart=r,i.lookahead=Q-1,d(i)}return i.strstart+=i.lookahead,i.block_start=i.strstart,i.insert=i.lookahead,i.lookahead=0,i.match_length=i.prev_length=Q-1,i.match_available=0,t.next_in=l,t.input=h,t.avail_in=a,i.wrap=s,M},e.deflateInfo="pako deflate (from Nodeca project)"},function(t,e,i){"use strict";function r(t){if(!(this instanceof r))return new r(t);this.options=s.assign({level:d,method:f,chunkSize:16384,windowBits:15,memLevel:8,strategy:p,to:""},t||{});var e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new h,this.strm.avail_out=0;var i=o.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(i!==c)throw new Error(l[i]);if(e.header&&o.deflateSetHeader(this.strm,e.header),e.dictionary){var n;if(n="string"==typeof e.dictionary?a.string2buf(e.dictionary):"[object ArrayBuffer]"===u.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,(i=o.deflateSetDictionary(this.strm,n))!==c)throw new Error(l[i]);this._dict_set=!0}}function n(t,e){var i=new r(e);if(i.push(t,!0),i.err)throw i.msg||l[i.err];return i.result}var o=i(65),s=i(2),a=i(31),l=i(16),h=i(30),u=Object.prototype.toString,c=0,d=-1,p=0,f=8;r.prototype.push=function(t,e){var i,r,n=this.strm,l=this.options.chunkSize;if(this.ended)return!1;r=e===~~e?e:!0===e?4:0,"string"==typeof t?n.input=a.string2buf(t):"[object ArrayBuffer]"===u.call(t)?n.input=new Uint8Array(t):n.input=t,n.next_in=0,n.avail_in=n.input.length;do{if(0===n.avail_out&&(n.output=new s.Buf8(l),n.next_out=0,n.avail_out=l),1!==(i=o.deflate(n,r))&&i!==c)return this.onEnd(i),this.ended=!0,!1;0!==n.avail_out&&(0!==n.avail_in||4!==r&&2!==r)||("string"===this.options.to?this.onData(a.buf2binstring(s.shrinkBuf(n.output,n.next_out))):this.onData(s.shrinkBuf(n.output,n.next_out)))}while((n.avail_in>0||0===n.avail_out)&&1!==i);return 4===r?(i=o.deflateEnd(this.strm),this.onEnd(i),this.ended=!0,i===c):2!==r||(this.onEnd(c),n.avail_out=0,!0)},r.prototype.onData=function(t){this.chunks.push(t)},r.prototype.onEnd=function(t){t===c&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=s.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},e.Deflate=r,e.deflate=n,e.deflateRaw=function(t,e){return(e=e||{}).raw=!0,n(t,e)},e.gzip=function(t,e){return(e=e||{}).gzip=!0,n(t,e)}},function(t,e,i){"use strict";var r={};(0,i(2).assign)(r,i(66),i(63),i(29)),t.exports=r},function(t,e,i){"use strict";function r(t,e){a.call(this,"FlateWorker/"+t),this._pako=null,this._pakoAction=t,this._pakoOptions=e,this.meta={}}var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array,o=i(67),s=i(0),a=i(1),l=n?"uint8array":"array";e.magic="\b\0",s.inherits(r,a),r.prototype.processChunk=function(t){this.meta=t.meta,null===this._pako&&this._createPako(),this._pako.push(s.transformTo(l,t.data),!1)},r.prototype.flush=function(){a.prototype.flush.call(this),null===this._pako&&this._createPako(),this._pako.push([],!0)},r.prototype.cleanUp=function(){a.prototype.cleanUp.call(this),this._pako=null},r.prototype._createPako=function(){this._pako=new o[this._pakoAction]({raw:!0,level:this._pakoOptions.level||-1});var t=this;this._pako.onData=function(e){t.push({data:e,meta:t.meta})}},e.compressWorker=function(t){return new r("Deflate",t)},e.uncompressWorker=function(){return new r("Inflate",{})}},function(t,e,i){"use strict";var r=i(34),n=i(58);e.generateWorker=function(t,e,i){var o=new n(e.streamFiles,i,e.platform,e.encodeFileName),s=0;try{t.forEach(function(t,i){s++;var n=function(t,e){var i=t||e,n=r[i];if(!n)throw new Error(i+" is not a valid compression method !");return n}(i.options.compression,e.compression),a=i.options.compressionOptions||e.compressionOptions||{},l=i.dir,h=i.date;i._compressWorker(n,a).withStreamInfo("file",{name:t,dir:l,date:h,comment:i.comment||"",unixPermissions:i.unixPermissions,dosPermissions:i.dosPermissions}).pipe(o)}),o.entriesCount=s}catch(t){o.error(t)}return o}},function(t,e,i){"use strict";var r=i(39),n=i(37),o=i(7),s=i(18),a=i(1),l=function(t,e,i){this.name=t,this.dir=i.dir,this.date=i.date,this.comment=i.comment,this.unixPermissions=i.unixPermissions,this.dosPermissions=i.dosPermissions,this._data=e,this._dataBinary=i.binary,this.options={compression:i.compression,compressionOptions:i.compressionOptions}};l.prototype={internalStream:function(t){var e=null,i="string";try{if(!t)throw new Error("No output type specified.");var n="string"===(i=t.toLowerCase())||"text"===i;"binarystring"!==i&&"text"!==i||(i="string"),e=this._decompressWorker();var s=!this._dataBinary;s&&!n&&(e=e.pipe(new o.Utf8EncodeWorker)),!s&&n&&(e=e.pipe(new o.Utf8DecodeWorker))}catch(t){(e=new a("error")).error(t)}return new r(e,i,"")},async:function(t,e){return this.internalStream(t).accumulate(e)},nodeStream:function(t,e){return this.internalStream(t||"nodebuffer").toNodejsStream(e)},_compressWorker:function(t,e){if(this._data instanceof s&&this._data.compression.magic===t.magic)return this._data.getCompressedWorker();var i=this._decompressWorker();return this._dataBinary||(i=i.pipe(new o.Utf8EncodeWorker)),s.createWorkerFrom(i,t,e)},_decompressWorker:function(){return this._data instanceof s?this._data.getContentWorker():this._data instanceof a?this._data:new n(this._data)}};for(var h=["asText","asBinary","asNodeBuffer","asUint8Array","asArrayBuffer"],u=function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},c=0;c<h.length;c++)l.prototype[h[c]]=u;t.exports=l},function(t,e,i){"use strict";function r(t,e,i){n.call(this,e),this._helper=t;var r=this;t.on("data",function(t,e){r.push(t)||r._helper.pause(),i&&i(e)}).on("error",function(t){r.emit("error",t)}).on("end",function(){r.push(null)})}var n=i(50).Readable;i(0).inherits(r,n),r.prototype._read=function(){this._helper.resume()},t.exports=r},function(t,e,i){"use strict";function r(t){n.call(this,"ConvertWorker to "+t),this.destType=t}var n=i(1),o=i(0);o.inherits(r,n),r.prototype.processChunk=function(t){this.push({data:o.transformTo(this.destType,t.data),meta:t.meta})},t.exports=r},function(t,e,i){"use strict";(function(e){function i(){var t,e;n=!0;for(var i=u.length;i;){for(e=u,u=[],t=-1;++t<i;)e[t]();i=u.length}n=!1}var r,n,o=e.MutationObserver||e.WebKitMutationObserver;if(o){var s=0,a=new o(i),l=e.document.createTextNode("");a.observe(l,{characterData:!0}),r=function(){l.data=s=++s%2}}else if(e.setImmediate||void 0===e.MessageChannel)r="document"in e&&"onreadystatechange"in e.document.createElement("script")?function(){var t=e.document.createElement("script");t.onreadystatechange=function(){i(),t.onreadystatechange=null,t.parentNode.removeChild(t),t=null},e.document.documentElement.appendChild(t)}:function(){setTimeout(i,0)};else{var h=new e.MessageChannel;h.port1.onmessage=i,r=function(){h.port2.postMessage(0)}}var u=[];t.exports=function(t){1!==u.push(t)||n||r()}}).call(this,i(5))},function(t,e,i){"use strict";function r(){}function n(t){if("function"!=typeof t)throw new TypeError("resolver must be a function");this.state=f,this.queue=[],this.outcome=void 0,t!==r&&l(this,t)}function o(t,e,i){this.promise=t,"function"==typeof e&&(this.onFulfilled=e,this.callFulfilled=this.otherCallFulfilled),"function"==typeof i&&(this.onRejected=i,this.callRejected=this.otherCallRejected)}function s(t,e,i){u(function(){var r;try{r=e(i)}catch(e){return c.reject(t,e)}r===t?c.reject(t,new TypeError("Cannot resolve promise with itself")):c.resolve(t,r)})}function a(t){var e=t&&t.then;if(t&&("object"==typeof t||"function"==typeof t)&&"function"==typeof e)return function(){e.apply(t,arguments)}}function l(t,e){function i(e){n||(n=!0,c.reject(t,e))}function r(e){n||(n=!0,c.resolve(t,e))}var n=!1,o=h(function(){e(r,i)});"error"===o.status&&i(o.value)}function h(t,e){var i={};try{i.value=t(e),i.status="success"}catch(t){i.status="error",i.value=t}return i}var u=i(73),c={},d=["REJECTED"],p=["FULFILLED"],f=["PENDING"];t.exports=n,n.prototype.catch=function(t){return this.then(null,t)},n.prototype.then=function(t,e){if("function"!=typeof t&&this.state===p||"function"!=typeof e&&this.state===d)return this;var i=new this.constructor(r);return this.state!==f?s(i,this.state===p?t:e,this.outcome):this.queue.push(new o(i,t,e)),i},o.prototype.callFulfilled=function(t){c.resolve(this.promise,t)},o.prototype.otherCallFulfilled=function(t){s(this.promise,this.onFulfilled,t)},o.prototype.callRejected=function(t){c.reject(this.promise,t)},o.prototype.otherCallRejected=function(t){s(this.promise,this.onRejected,t)},c.resolve=function(t,e){var i=h(a,e);if("error"===i.status)return c.reject(t,i.value);var r=i.value;if(r)l(t,r);else{t.state=p,t.outcome=e;for(var n=-1,o=t.queue.length;++n<o;)t.queue[n].callFulfilled(e)}return t},c.reject=function(t,e){t.state=d,t.outcome=e;for(var i=-1,r=t.queue.length;++i<r;)t.queue[i].callRejected(e);return t},n.resolve=function(t){return t instanceof this?t:c.resolve(new this(r),t)},n.reject=function(t){var e=new this(r);return c.reject(e,t)},n.all=function(t){function e(t,e){i.resolve(t).then(function(t){s[e]=t,++a!==n||o||(o=!0,c.resolve(h,s))},function(t){o||(o=!0,c.reject(h,t))})}var i=this;if("[object Array]"!==Object.prototype.toString.call(t))return this.reject(new TypeError("must be an array"));var n=t.length,o=!1;if(!n)return this.resolve([]);for(var s=new Array(n),a=0,l=-1,h=new this(r);++l<n;)e(t[l],l);return h},n.race=function(t){function e(t){i.resolve(t).then(function(t){o||(o=!0,c.resolve(a,t))},function(t){o||(o=!0,c.reject(a,t))})}var i=this;if("[object Array]"!==Object.prototype.toString.call(t))return this.reject(new TypeError("must be an array"));var n=t.length,o=!1;if(!n)return this.resolve([]);for(var s=-1,a=new this(r);++s<n;)e(t[s]);return a}},function(t,e){var i={}.toString;t.exports=function(t){return i.call(t).slice(8,-1)}},function(t,e,i){t.exports=i(11).document&&document.documentElement},function(t,e){t.exports=function(t,e,i){var r=void 0===i;switch(e.length){case 0:return r?t():t.call(i);case 1:return r?t(e[0]):t.call(i,e[0]);case 2:return r?t(e[0],e[1]):t.call(i,e[0],e[1]);case 3:return r?t(e[0],e[1],e[2]):t.call(i,e[0],e[1],e[2]);case 4:return r?t(e[0],e[1],e[2],e[3]):t.call(i,e[0],e[1],e[2],e[3])}return t.apply(i,e)}},function(t,e,i){var r,n,o,s=i(42),a=i(77),l=i(76),h=i(40),u=i(11),c=u.process,d=u.setImmediate,p=u.clearImmediate,f=u.MessageChannel,g=0,m={},y=function(){var t=+this;if(m.hasOwnProperty(t)){var e=m[t];delete m[t],e()}},E=function(t){y.call(t.data)};d&&p||(d=function(t){for(var e=[],i=1;arguments.length>i;)e.push(arguments[i++]);return m[++g]=function(){a("function"==typeof t?t:Function(t),e)},r(g),g},p=function(t){delete m[t]},"process"==i(75)(c)?r=function(t){c.nextTick(s(y,t,1))}:f?(o=(n=new f).port2,n.port1.onmessage=E,r=s(o.postMessage,o,1)):u.addEventListener&&"function"==typeof postMessage&&!u.importScripts?(r=function(t){u.postMessage(t+"","*")},u.addEventListener("message",E,!1)):r="onreadystatechange"in h("script")?function(t){l.appendChild(h("script")).onreadystatechange=function(){l.removeChild(this),y.call(t)}}:function(t){setTimeout(s(y,t,1),0)}),t.exports={set:d,clear:p}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,i){var r=i(20);t.exports=function(t,e){if(!r(t))return t;var i,n;if(e&&"function"==typeof(i=t.toString)&&!r(n=i.call(t)))return n;if("function"==typeof(i=t.valueOf)&&!r(n=i.call(t)))return n;if(!e&&"function"==typeof(i=t.toString)&&!r(n=i.call(t)))return n;throw TypeError("Can't convert object to primitive value")}},function(t,e,i){t.exports=!i(19)&&!i(41)(function(){return 7!=Object.defineProperty(i(40)("div"),"a",{get:function(){return 7}}).a})},function(t,e,i){var r=i(20);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e,i){var r=i(82),n=i(81),o=i(80),s=Object.defineProperty;e.f=i(19)?Object.defineProperty:function(t,e,i){if(r(t),e=o(e,!0),r(i),n)try{return s(t,e,i)}catch(t){}if("get"in i||"set"in i)throw TypeError("Accessors not supported!");return"value"in i&&(t[e]=i.value),t}},function(t,e,i){var r=i(83),n=i(79);t.exports=i(19)?function(t,e,i){return r.f(t,e,n(1,i))}:function(t,e,i){return t[e]=i,t}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e,i){var r=i(11),n=i(43),o=i(42),s=i(84),a=function(t,e,i){var l,h,u,c=t&a.F,d=t&a.G,p=t&a.S,f=t&a.P,g=t&a.B,m=t&a.W,y=d?n:n[e]||(n[e]={}),E=y.prototype,v=d?r:p?r[e]:(r[e]||{}).prototype;for(l in d&&(i=e),i)(h=!c&&v&&void 0!==v[l])&&l in y||(u=h?v[l]:i[l],y[l]=d&&"function"!=typeof v[l]?i[l]:g&&h?o(u,r):m&&v[l]==u?function(t){var e=function(e,i,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,i)}return new t(e,i,r)}return t.apply(this,arguments)};return e.prototype=t.prototype,e}(u):f&&"function"==typeof u?o(Function.call,u):u,f&&((y.virtual||(y.virtual={}))[l]=u,t&a.R&&E&&!E[l]&&s(E,l,u)))};a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e,i){var r=i(86),n=i(78);r(r.G+r.B,{setImmediate:n.set,clearImmediate:n.clear})},function(t,e,i){i(87),t.exports=i(43).setImmediate},function(t,e,i){t.exports=i(22).PassThrough},function(t,e,i){t.exports=i(22).Transform},function(t,e,i){t.exports=i(4)},function(t,e,i){t.exports=i(21)},function(t,e,i){"use strict";function r(t){return this instanceof r?void n.call(this,t):new r(t)}t.exports=r;var n=i(45),o=i(9);o.inherits=i(6),o.inherits(r,n),r.prototype._transform=function(t,e,i){i(null,t)}},function(t,e,i){(function(e){function i(t){try{if(!e.localStorage)return!1}catch(t){return!1}var i=e.localStorage[t];return null!=i&&"true"===String(i).toLowerCase()}t.exports=function(t,e){if(i("noDeprecation"))return t;var r=!1;return function(){if(!r){if(i("throwDeprecation"))throw new Error(e);i("traceDeprecation")?console.trace(e):console.warn(e),r=!0}return t.apply(this,arguments)}}}).call(this,i(5))},function(t,e,i){(function(t,e){!function(t,i){"use strict";function r(t){delete a[t]}function n(t){if(l)setTimeout(n,0,t);else{var e=a[t];if(e){l=!0;try{!function(t){var e=t.callback,r=t.args;switch(r.length){case 0:e();break;case 1:e(r[0]);break;case 2:e(r[0],r[1]);break;case 3:e(r[0],r[1],r[2]);break;default:e.apply(i,r)}}(e)}finally{r(t),l=!1}}}}if(!t.setImmediate){var o,s=1,a={},l=!1,h=t.document,u=Object.getPrototypeOf&&Object.getPrototypeOf(t);u=u&&u.setTimeout?u:t,"[object process]"==={}.toString.call(t.process)?o=function(t){e.nextTick(function(){n(t)})}:function(){if(t.postMessage&&!t.importScripts){var e=!0,i=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=i,e}}()?function(){var e="setImmediate$"+Math.random()+"$",i=function(i){i.source===t&&"string"==typeof i.data&&0===i.data.indexOf(e)&&n(+i.data.slice(e.length))};t.addEventListener?t.addEventListener("message",i,!1):t.attachEvent("onmessage",i),o=function(i){t.postMessage(e+i,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){n(t.data)},o=function(e){t.port2.postMessage(e)}}():h&&"onreadystatechange"in h.createElement("script")?function(){var t=h.documentElement;o=function(e){var i=h.createElement("script");i.onreadystatechange=function(){n(e),i.onreadystatechange=null,t.removeChild(i),i=null},t.appendChild(i)}}():o=function(t){setTimeout(n,0,t)},u.setImmediate=function(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),i=0;i<e.length;i++)e[i]=arguments[i+1];var r={callback:t,args:e};return a[s]=r,o(s),s++},u.clearImmediate=r}}("undefined"==typeof self?void 0===t?this:t:self)}).call(this,i(5),i(15))},function(t,e,i){(function(t){function r(t,e){this._id=t,this._clearFn=e}var n=void 0!==t&&t||"undefined"!=typeof self&&self||window,o=Function.prototype.apply;e.setTimeout=function(){return new r(o.call(setTimeout,n,arguments),clearTimeout)},e.setInterval=function(){return new r(o.call(setInterval,n,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},r.prototype.unref=r.prototype.ref=function(){},r.prototype.close=function(){this._clearFn.call(n,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},i(95),e.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==t&&t.setImmediate||this&&this.setImmediate,e.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==t&&t.clearImmediate||this&&this.clearImmediate}).call(this,i(5))},function(t,e){},function(t,e,i){"use strict";function r(t,e,i){t.copy(e,i)}var n=i(13).Buffer,o=i(97);t.exports=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.head=null,this.tail=null,this.length=0}return t.prototype.push=function(t){var e={data:t,next:null};this.length>0?this.tail.next=e:this.head=e,this.tail=e,++this.length},t.prototype.unshift=function(t){var e={data:t,next:this.head};0===this.length&&(this.tail=e),this.head=e,++this.length},t.prototype.shift=function(){if(0!==this.length){var t=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,t}},t.prototype.clear=function(){this.head=this.tail=null,this.length=0},t.prototype.join=function(t){if(0===this.length)return"";for(var e=this.head,i=""+e.data;e=e.next;)i+=t+e.data;return i},t.prototype.concat=function(t){if(0===this.length)return n.alloc(0);if(1===this.length)return this.head.data;for(var e=n.allocUnsafe(t>>>0),i=this.head,o=0;i;)r(i.data,e,o),o+=i.data.length,i=i.next;return e},t}(),o&&o.inspect&&o.inspect.custom&&(t.exports.prototype[o.inspect.custom]=function(){var t=o.inspect({length:this.length});return this.constructor.name+" "+t})},function(t,e){},function(t,e,i){function r(){n.call(this)}t.exports=r;var n=i(23).EventEmitter;i(6)(r,n),r.Readable=i(22),r.Writable=i(92),r.Duplex=i(91),r.Transform=i(90),r.PassThrough=i(89),r.Stream=r,r.prototype.pipe=function(t,e){function i(e){t.writable&&!1===t.write(e)&&h.pause&&h.pause()}function r(){h.readable&&h.resume&&h.resume()}function o(){u||(u=!0,t.end())}function s(){u||(u=!0,"function"==typeof t.destroy&&t.destroy())}function a(t){if(l(),0===n.listenerCount(this,"error"))throw t}function l(){h.removeListener("data",i),t.removeListener("drain",r),h.removeListener("end",o),h.removeListener("close",s),h.removeListener("error",a),t.removeListener("error",a),h.removeListener("end",l),h.removeListener("close",l),t.removeListener("close",l)}var h=this;h.on("data",i),t.on("drain",r),t._isStdio||e&&!1===e.end||(h.on("end",o),h.on("close",s));var u=!1;return h.on("error",a),t.on("error",a),h.on("end",l),h.on("close",l),t.on("close",l),t.emit("pipe",h),t}},function(t,e){e.read=function(t,e,i,r,n){var o,s,a=8*n-r-1,l=(1<<a)-1,h=l>>1,u=-7,c=i?n-1:0,d=i?-1:1,p=t[e+c];for(c+=d,o=p&(1<<-u)-1,p>>=-u,u+=a;u>0;o=256*o+t[e+c],c+=d,u-=8);for(s=o&(1<<-u)-1,o>>=-u,u+=r;u>0;s=256*s+t[e+c],c+=d,u-=8);if(0===o)o=1-h;else{if(o===l)return s?NaN:1/0*(p?-1:1);s+=Math.pow(2,r),o-=h}return(p?-1:1)*s*Math.pow(2,o-r)},e.write=function(t,e,i,r,n,o){var s,a,l,h=8*o-n-1,u=(1<<h)-1,c=u>>1,d=23===n?Math.pow(2,-24)-Math.pow(2,-77):0,p=r?0:o-1,f=r?1:-1,g=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,s=u):(s=Math.floor(Math.log(e)/Math.LN2),e*(l=Math.pow(2,-s))<1&&(s--,l*=2),(e+=s+c>=1?d/l:d*Math.pow(2,1-c))*l>=2&&(s++,l/=2),s+c>=u?(a=0,s=u):s+c>=1?(a=(e*l-1)*Math.pow(2,n),s+=c):(a=e*Math.pow(2,c-1)*Math.pow(2,n),s=0));n>=8;t[i+p]=255&a,p+=f,a/=256,n-=8);for(s=s<<n|a,h+=n;h>0;t[i+p]=255&s,p+=f,s/=256,h-=8);t[i+p-f]|=128*g}},function(t,e,i){"use strict";function r(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var i=t.indexOf("=");return-1===i&&(i=e),[i,i===e?0:4-i%4]}function n(t){return s[t>>18&63]+s[t>>12&63]+s[t>>6&63]+s[63&t]}function o(t,e,i){for(var r,o=[],s=e;s<i;s+=3)r=(t[s]<<16&16711680)+(t[s+1]<<8&65280)+(255&t[s+2]),o.push(n(r));return o.join("")}e.byteLength=function(t){var e=r(t),i=e[0],n=e[1];return 3*(i+n)/4-n},e.toByteArray=function(t){for(var e,i=r(t),n=i[0],o=i[1],s=new l(function(t,e,i){return 3*(e+i)/4-i}(0,n,o)),h=0,u=o>0?n-4:n,c=0;c<u;c+=4)e=a[t.charCodeAt(c)]<<18|a[t.charCodeAt(c+1)]<<12|a[t.charCodeAt(c+2)]<<6|a[t.charCodeAt(c+3)],s[h++]=e>>16&255,s[h++]=e>>8&255,s[h++]=255&e;return 2===o&&(e=a[t.charCodeAt(c)]<<2|a[t.charCodeAt(c+1)]>>4,s[h++]=255&e),1===o&&(e=a[t.charCodeAt(c)]<<10|a[t.charCodeAt(c+1)]<<4|a[t.charCodeAt(c+2)]>>2,s[h++]=e>>8&255,s[h++]=255&e),s},e.fromByteArray=function(t){for(var e,i=t.length,r=i%3,n=[],a=0,l=i-r;a<l;a+=16383)n.push(o(t,a,a+16383>l?l:a+16383));return 1===r?(e=t[i-1],n.push(s[e>>2]+s[e<<4&63]+"==")):2===r&&(e=(t[i-2]<<8)+t[i-1],n.push(s[e>>10]+s[e>>4&63]+s[e<<2&63]+"=")),n.join("")};for(var s=[],a=[],l="undefined"!=typeof Uint8Array?Uint8Array:Array,h="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",u=0,c=h.length;u<c;++u)s[u]=h[u],a[h.charCodeAt(u)]=u;a["-".charCodeAt(0)]=62,a["_".charCodeAt(0)]=63},function(t,e,i){"use strict";function r(t){return"[object RegExp]"===Object.prototype.toString.call(t)}var n=i(7),o=i(0),s=i(1),a=i(39),l=i(38),h=i(18),u=i(70),c=i(69),d=i(12),p=i(57),f=function(t,e,i){var r,n=o.getTypeOf(e),a=o.extend(i||{},l);a.date=a.date||new Date,null!==a.compression&&(a.compression=a.compression.toUpperCase()),"string"==typeof a.unixPermissions&&(a.unixPermissions=parseInt(a.unixPermissions,8)),a.unixPermissions&&16384&a.unixPermissions&&(a.dir=!0),a.dosPermissions&&16&a.dosPermissions&&(a.dir=!0),a.dir&&(t=m(t)),a.createFolders&&(r=g(t))&&y.call(this,r,!0);var c="string"===n&&!1===a.binary&&!1===a.base64;i&&void 0!==i.binary||(a.binary=!c),(e instanceof h&&0===e.uncompressedSize||a.dir||!e||0===e.length)&&(a.base64=!1,a.binary=!0,e="",a.compression="STORE",n="string");var f=null;f=e instanceof h||e instanceof s?e:d.isNode&&d.isStream(e)?new p(t,e):o.prepareContent(t,e,a.binary,a.optimizedBinaryString,a.base64);var E=new u(t,f,a);this.files[t]=E},g=function(t){"/"===t.slice(-1)&&(t=t.substring(0,t.length-1));var e=t.lastIndexOf("/");return e>0?t.substring(0,e):""},m=function(t){return"/"!==t.slice(-1)&&(t+="/"),t},y=function(t,e){return e=void 0!==e?e:l.createFolders,t=m(t),this.files[t]||f.call(this,t,null,{dir:!0,createFolders:e}),this.files[t]},E={load:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},forEach:function(t){var e,i,r;for(e in this.files)this.files.hasOwnProperty(e)&&(r=this.files[e],(i=e.slice(this.root.length,e.length))&&e.slice(0,this.root.length)===this.root&&t(i,r))},filter:function(t){var e=[];return this.forEach(function(i,r){t(i,r)&&e.push(r)}),e},file:function(t,e,i){if(1===arguments.length){if(r(t)){var n=t;return this.filter(function(t,e){return!e.dir&&n.test(t)})}var o=this.files[this.root+t];return o&&!o.dir?o:null}return t=this.root+t,f.call(this,t,e,i),this},folder:function(t){if(!t)return this;if(r(t))return this.filter(function(e,i){return i.dir&&t.test(e)});var e=this.root+t,i=y.call(this,e),n=this.clone();return n.root=i.name,n},remove:function(t){t=this.root+t;var e=this.files[t];if(e||("/"!==t.slice(-1)&&(t+="/"),e=this.files[t]),e&&!e.dir)delete this.files[t];else for(var i=this.filter(function(e,i){return i.name.slice(0,t.length)===t}),r=0;r<i.length;r++)delete this.files[i[r].name];return this},generate:function(t){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},generateInternalStream:function(t){var e,i={};try{if((i=o.extend(t||{},{streamFiles:!1,compression:"STORE",compressionOptions:null,type:"",platform:"DOS",comment:null,mimeType:"application/zip",encodeFileName:n.utf8encode})).type=i.type.toLowerCase(),i.compression=i.compression.toUpperCase(),"binarystring"===i.type&&(i.type="string"),!i.type)throw new Error("No output type specified.");o.checkSupport(i.type),"darwin"!==i.platform&&"freebsd"!==i.platform&&"linux"!==i.platform&&"sunos"!==i.platform||(i.platform="UNIX"),"win32"===i.platform&&(i.platform="DOS");var r=i.comment||this.comment||"";e=c.generateWorker(this,i,r)}catch(t){(e=new s("error")).error(t)}return new a(e,i.type||"string",i.mimeType)},generateAsync:function(t,e){return this.generateInternalStream(t).accumulate(e)},generateNodeStream:function(t,e){return(t=t||{}).type||(t.type="nodebuffer"),this.generateInternalStream(t).toNodejsStream(e)}};t.exports=E},function(t,e,i){"use strict";function r(){if(!(this instanceof r))return new r;if(arguments.length)throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");this.files={},this.comment=null,this.root="",this.clone=function(){var t=new r;for(var e in this)"function"!=typeof this[e]&&(t[e]=this[e]);return t}}r.prototype=i(103),r.prototype.loadAsync=i(56),r.support=i(3),r.defaults=i(38),r.version="3.1.5",r.loadAsync=function(t,e){return(new r).loadAsync(t,e)},r.external=i(8),t.exports=r}])}),i("formats/kml/KmzFile",["../../util/jszip","../../util/Promise","../../util/WWUtil"],function(t,e,i){"use strict";var r=function(t,e){this._binary=t,this._fileCache=e};return r.prototype.load=function(){var i=this,r=null,n=!1;return(new t).loadAsync(this._binary).then(function(t){return e.all(Object.keys(t.files).map(function(e){return t.files[e]}).map(function(t){return i.hasExtension("kml",t.name)&&!n?(n=!0,t.async("text").then(function(t){r=t})):i.hasExtension("kml",t.name)?t.async("base64").then(function(e){return new WorldWind.KmlFile(e).then(function(e){i._fileCache.add("href;"+t.name,e)})}):t.async("base64").then(function(e){var r="data:image/jpeg;base64,"+e;i._fileCache.add("href;"+t.name,r)})}))}).then(function(){return r})},r.prototype.hasExtension=function(t,e){return i.endsWith(e,"."+t)},r}),i("formats/kml/util/KmlRefreshListener",[],function(){var t=function(){this.currentActiveEvents=[]};return t.prototype.addEvent=function(t){var e=this;setTimeout(function(){e.currentActiveEvents.push(t)},t.time)},t.prototype.getActiveEvents=function(){var t=this.currentActiveEvents.slice();return this.currentActiveEvents=[],t},t.Event=function(t,e,i){this.type=t,this.payload=i,this.time=e},t}),i("formats/kml/util/KmlRemoteFile",["../../../error/ArgumentError","../../../util/Logger","../../../util/Promise"],function(t,e,i){"use strict";var r=function(i){if(!i.ajax&&!i.zip)throw new t(e.logMessage(e.LEVEL_SEVERE,"RemoteDocument","constructor","Invalid option for retrieval specified. Use either ajax or zip option."));this.options=i};return r.prototype.get=function(){var i=this.options;if(i.ajax)return this.ajax(i.url,i);if(i.zip)return i.responseType=i.responseType||"arraybuffer",this.ajax(i.url,i);throw new t(e.logMessage(e.LEVEL_SEVERE,"RemoteDocument","constructor","Invalid option for retrieval specified. Use either ajax or zip option."))},r.prototype.ajax=function(t,r){return new i(function(i,n){var o=new XMLHttpRequest;o.open("GET",t,!0),r.responseType&&(o.responseType=r.responseType),o.onreadystatechange=function(){if(4===o.readyState)if(200===o.status){var n;n="arraybuffer"==r.responseType?this.response:this.responseText,i({text:n,headers:o.getAllResponseHeaders()})}else e.log(e.LEVEL_WARNING,"KmlFile retrieval failed ("+o.statusText+"): "+t)},o.onerror=function(){e.log(e.LEVEL_WARNING,"Remote file retrieval failed: "+t),n()}.bind(this),o.ontimeout=function(){e.log(e.LEVEL_WARNING,"Remote file retrieval timed out: "+t),n()}.bind(this),o.send(null)})},r}),i("formats/kml/util/KmlStyleResolver",["../KmlFile","../styles/KmlStyle","../../../util/Logger","../../../util/Promise"],function(t,e,i,r){"use strict";var n=function(t){this._fileCache=t};return n.prototype.handleRemoteStyle=function(t,n){return t?this.handleStyleUrl(t):n?this.handleStyleSelector(n):(i.logMessage(i.LEVEL_INFO,"KmlStyleResolver","handleRemoteStyle","Style was null."),r.resolve(e.default()))},n.prototype.handleStyleUrl=function(t){var e=this;return this.handlePromiseOfFile(t).then(function(e){return e.resolveStyle(t)}).then(function(t){return t.isMap?t.resolve(e):r.resolve({normal:t,highlight:null})})},n.prototype.handlePromiseOfFile=function(t){var e=this._fileCache.retrieve(t);return e?r.resolve(e):new WorldWind.KmlFile({url:t}).then(function(e){return this._fileCache.add(t,e),e}.bind(this))},n.prototype.handleStyleSelector=function(t){return t.isMap?t.resolve(this):new r(function(e){window.setTimeout(function(){e({normal:t,highlight:null})},0)})},n}),i("util/XmlDocument",["../error/ArgumentError","../util/Logger"],function(t,e){var i=function(t){this._document=t};return i.prototype.dom=function(){
if(DOMParser){var i=new DOMParser,r=i.parseFromString(this._document,"text/xml");if(r.getElementsByTagName("parsererror").length||!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"XmlDocument","dom","Invalid XML document. "+r.getElementsByTagName("parsererror")[0].innerHTML));return r}var n=new ActiveXObject("Microsoft.XMLDOM");return n.async=!1,n.loadXML(text),n},i.isValid=function(t){try{return new i(t).dom(),!0}catch(t){return!1}},i}),i("formats/kml/KmlFile",["../../error/ArgumentError","./KmlElements","./KmlFileCache","./KmlObject","./styles/KmlStyle","./styles/KmlStyleMap","./KmlTimeSpan","./KmlTimeStamp","./KmzFile","../../util/Logger","../../util/Promise","./util/KmlRefreshListener","./util/KmlRemoteFile","./util/KmlStyleResolver","../../util/XmlDocument","../../util/WWUtil"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g){"use strict";var m=function(e,n){var o=this;if(!e)throw new t(h.logMessage(h.LEVEL_SEVERE,"KmlFile","constructor","invalidDocumentPassed"));return this._controls=n||null,this._fileCache=new i,this._styleResolver=new p(this._fileCache),this._listener=new c,this._headers=null,this.requestRemote(e).then(function(t){var i=t.text;if(o._headers=t.headers,o.hasExtension("kmz",e)){var r=new l(i,o._fileCache);return r.load()}return i}).then(function(t){return o._document=new f(t).dom(),r.call(o,{objectNode:o._document.documentElement,controls:n}),o._fileCache.add(e,o,!0),o})};return m.prototype=Object.create(r.prototype),Object.defineProperties(m.prototype,{shapes:{get:function(){return this._factory.all(this)}}}),m.prototype.render=function(t,e){var i=this;e=e||{},this.shapes.forEach(function(r){r.render(t,{lastStyle:e.lastStyle||null,lastVisibility:e.lastVisibility||null,timeRange:e.timeRange||null,regionInvisible:e.regionInvisible||null,fileCache:i._fileCache,styleResolver:i._styleResolver,listener:i._listener,activeEvents:i._listener.getActiveEvents()})})},m.prototype.hasExtension=function(t,e){return g.endsWith(e,"."+t)},m.prototype.requestRemote=function(t){var e={};return e.url=t,this.hasExtension("kmz",t)?e.zip=!0:e.ajax=!0,new d(e).get()},m.prototype.resolveStyle=function(t){var e=this,i=t.substring(t.indexOf("#")+1,t.length);return new u(function(t,r){var s;s=e._document.querySelector?e._document.querySelector("*[id='"+i+"']"):e._document.getElementById(i),s&&null!=s||r(),s.nodeName==n.prototype.getTagNames()[0]?t(new n({objectNode:s},{styleResolver:e._styleResolver})):s.nodeName==o.prototype.getTagNames()[0]?t(new o({objectNode:s},{styleResolver:e._styleResolver})):h.logMessage(h.LEVEL_WARNING,"KmlFile","resolveStyle","Style must contain either Style node or StyleMap node.")})},m.prototype.getExpired=function(){var t=new Date(this._headers.getRequestHeader("Expires")),e=new Date;return e.getTime-t.getTime()},m}),i("formats/kml/KmlLatLonAltBox",["./KmlElements","./KmlObject","./util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlNorth:{get:function(){return this._factory.specific(this,{name:"north",transformer:i.number})}},kmlSouth:{get:function(){return this._factory.specific(this,{name:"south",transformer:i.number})}},kmlEast:{get:function(){return this._factory.specific(this,{name:"east",transformer:i.number})}},kmlWest:{get:function(){return this._factory.specific(this,{name:"west",transformer:i.number})}},kmlMinAltitude:{get:function(){return this._factory.specific(this,{name:"minAltitude",transformer:i.number})}},kmlMaxAltitude:{get:function(){return this._factory.specific(this,{name:"maxAltitude",transformer:i.number})}}}),r.prototype.getTagNames=function(){return["LatLonAltBox"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/KmlLod",["./KmlElements","./KmlObject","./util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlMinLodPixels:{get:function(){return this._factory.specific(this,{name:"minLodPixels",transformer:i.number})}},kmlMaxLodPixels:{get:function(){return this._factory.specific(this,{name:"maxLodPixels",transformer:i.number})}},kmlMinFadeExtent:{get:function(){return this._factory.specific(this,{name:"minFadeExtent",transformer:i.number})}},kmlMaxFadeExtent:{get:function(){return this._factory.specific(this,{name:"maxFadeExtent",transformer:i.number})}}}),r.prototype.getTagNames=function(){return["Lod"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/KmlRegion",["../../geom/BoundingBox","../../util/Color","./KmlElements","./KmlLatLonAltBox","./KmlLod","./KmlObject","./styles/KmlStyle","./util/KmlNodeTransformers","../../geom/Sector"],function(t,e,i,r,n,o,s,a,l){"use strict";var h=function(t){o.call(this,t)};return h.prototype=Object.create(o.prototype),Object.defineProperties(h.prototype,{kmlLatLonAltBox:{get:function(){return this._factory.specific(this,{name:r.prototype.getTagNames(),transformer:a.kmlObject})}},kmlLod:{get:function(){return this._factory.specific(this,{name:n.prototype.getTagNames(),transformer:a.kmlObject})}}}),h.prototype.intersectsVisible=function(e){var i=this.kmlLatLonAltBox,r=new t;return r.setToSector(new l(i.kmlSouth,i.kmlNorth,i.kmlWest,i.kmlEast),e.globe,i.kmlMinAltitude,i.kmlMaxAltitude),r.intersectsFrustum(e.frustumInModelCoordinates)&&(!i.kmlMinAltitude||e.eyePosition.altitude>i.kmlMinAltitude)&&(!i.kmlMaxAltitude||e.eyePosition.altitude<i.kmlMaxAltitude)},h.prototype.getTagNames=function(){return["Region"]},i.addKey(h.prototype.getTagNames()[0],h),h}),i("formats/kml/features/KmlFeature",["./../KmlObject","../KmlAbstractView","../KmlFile","../styles/KmlStyleMap","../styles/KmlStyleSelector","../KmlRegion","../KmlTimePrimitive","../util/KmlNodeTransformers","../../../util/Promise"],function(t,e,i,r,n,o,s,a,l){"use strict";var h=function(e){this.isFeature=e.isFeature=!0,t.call(this,e),this._pStyle=null,this.controlledVisibility=null};return h.prototype=Object.create(t.prototype),Object.defineProperties(h.prototype,{style:{get:function(){return this._pStyle}},kmlName:{get:function(){return this._factory.specific(this,{name:"name",transformer:a.string})}},kmlVisibility:{get:function(){return this._factory.specific(this,{name:"visibility",transformer:a.boolean})}},kmlOpen:{get:function(){return this._factory.specific(this,{name:"open",transformer:a.boolean})}},kmlAddress:{get:function(){return this._factory.specific(this,{name:"address",transformer:a.string})}},kmlPhoneNumber:{get:function(){return this._factory.specific(this,{name:"phoneNumber",transformer:a.string})}},kmlDescription:{get:function(){return this._factory.specific(this,{name:"description",transformer:a.string})}},kmlStyleUrl:{get:function(){return this._factory.specific(this,{name:"styleUrl",transformer:a.string})}},kmlSnippet:{get:function(){return this._factory.specific(this,{name:"Snippet",transformer:a.string})}},kmlAbstractView:{get:function(){return this._factory.any(this,{name:e.prototype.getTagNames()})}},kmlTimePrimitive:{get:function(){return this._factory.any(this,{name:s.prototype.getTagNames()})}},kmlStyleSelector:{get:function(){return this._factory.any(this,{name:n.prototype.getTagNames()})}},kmlRegion:{get:function(){return this._factory.any(this,{name:o.prototype.getTagNames()})}}}),h.prototype.render=function(e,i){t.prototype.render.call(this,e,i),this.solveStyle(e,i),this.solveVisibility(e,i)},h.prototype.solveStyle=function(t,e){this.getStyle(t,e),null!=this.style&&(e.lastStyle=this.style)},h.prototype.solveRegion=function(t){return!this.kmlRegion||this.kmlRegion.intersectsVisible(t)},h.prototype.solveVisibility=function(t,e){var i=e.lastVisibility!==!1,r=this.solveTimeVisibility(t),n=this.solveRegion(t),o=this.kmlVisibility!==!1;this.controlledVisibility===!0?this.enabled=!0:this.controlledVisibility===!1?this.enabled=!1:this.enabled=i&&r&&n&&o,e.lastVisibility=this.enabled,this._renderable&&(this._renderable.enabled=this.enabled)},h.prototype.solveTimeVisibility=function(t){var e=this.kmlTimePrimitive&&this.kmlTimePrimitive.kmlTimeRange(),i=t.currentLayer.timeRange;if(e&&i.length>=2){var r=e.from,n=e.to,o=i[0],s=i[1];if(r<o||n>s)return!1}return!0},h.prototype.getStyle=function(t,e){if(!this._pStyle){var i=this;return e.styleResolver.handleRemoteStyle(i.kmlStyleUrl,i.kmlStyleSelector).then(function(e){i._pStyle=e,t.redrawRequested=!0})}},h.prototype.getTagNames=function(){return["NetworkLink","Placemark","PhotoOverlay","ScreenOverlay","GroundOverlay","Folder","Document"]},h}),i("formats/kml/features/KmlContainer",["./KmlFeature"],function(t){"use strict";var e=function(e){t.call(this,e)};return e.prototype=Object.create(t.prototype),Object.defineProperties(e.prototype,{kmlShapes:{get:function(){var t=this._factory.all(this);return t.filter(function(t){return t.isFeature})}}}),e.prototype.render=function(e,i){t.prototype.render.call(this,e,i);var r=this;this.kmlShapes.forEach(function(t){t.render(e,{lastStyle:i.lastStyle,lastVisibility:r.enabled,timeRange:i.timeRange,regionInvisible:i.regionInvisible,fileCache:i.fileCache,styleResolver:i.styleResolver,listener:i.listener,activeEvents:i.activeEvents})})},e.prototype.getTagNames=function(){return["Folder","Document"]},e}),i("formats/kml/controls/KmlControls",["../../../util/Logger"],function(t){"use strict";var e=function(){};return e.prototype.hook=function(){t.logMessage(t.LEVEL_WARNING,"KmlControls","hook","Every KML controls should override hook method.")},e}),i("formats/kml/util/KmlCreate",["../KmlElements","../KmlObject"],function(t,e){var i=function(t){e.call(this,t)};return i.prototype=Object.create(e.prototype),Object.defineProperties(i.prototype,{shapes:{get:function(){return this._factory.all(this)}}}),i.prototype.getTagNames=function(){return["Create"]},t.addKey(i.prototype.getTagNames()[0],i),i}),i("formats/kml/util/KmlDelete",["../KmlElements","../KmlObject"],function(t,e){var i=function(t){e.call(this,t)};return i.prototype=Object.create(e.prototype),Object.defineProperties(i.prototype,{shapes:{get:function(){return this._factory.all(this)}}}),i.prototype.getTagNames=function(){return["Delete"]},t.addKey(i.prototype.getTagNames()[0],i),i}),i("formats/kml/util/KmlSchema",["./../KmlElements","../KmlObject"],function(t,e){"use strict";var i=function(t){e.call(this,t)};return i.prototype=Object.create(e.prototype),i.prototype.getTagNames=function(){return["Schema"]},t.addKey(i.prototype.getTagNames()[0],i),i}),i("formats/kml/features/KmlDocument",["./KmlContainer","../KmlElements","./KmlFeature","../util/KmlSchema"],function(t,e,i,r){"use strict";var n=function(e){t.call(this,e)};return n.prototype=Object.create(t.prototype),Object.defineProperties(n.prototype,{kmlSchemas:{get:function(){var t=this._factory.all(this);return t.filter(function(t){return t instanceof r})}}}),n.prototype.getTagNames=function(){return["Document"]},e.addKey(n.prototype.getTagNames()[0],n),n}),i("formats/kml/features/KmlFolder",["./KmlContainer","./../KmlElements"],function(t,e){"use strict";var i=function(e){t.call(this,e)};return i.prototype=Object.create(t.prototype),i.prototype.getTagNames=function(){return["Folder"]},e.addKey(i.prototype.getTagNames()[0],i),i}),i("formats/kml/geom/KmlGeometry",["../KmlObject"],function(t){"use strict";var e=function(e){t.call(this,e),this._renderable=null};return e.prototype=Object.create(t.prototype),e.prototype.render=function(e,i){t.prototype.render.call(this,e,i),this.enabled=i.lastVisibility},e.prototype.getTagNames=e.getTagNames=function(){return["Point","LinearRing","LineString","MultiGeometry","Polygon"]},e}),i("formats/kml/KmlLatLonBox",["./KmlElements","./KmlObject","./util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlNorth:{get:function(){return this._factory.specific(this,{name:"north",transformer:i.number})}},kmlSouth:{get:function(){return this._factory.specific(this,{name:"south",transformer:i.number})}},kmlEast:{get:function(){return this._factory.specific(this,{name:"east",transformer:i.number})}},kmlWest:{get:function(){return this._factory.specific(this,{name:"west",transformer:i.number})}},kmlRotation:{get:function(){return this._factory.specific(this,{name:"rotation",transformer:i.string})}}}),r.prototype.getTagNames=function(){return["LatLonBox"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/KmlLatLonQuad",["./KmlElements","./KmlObject","./util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlCoordinates:{get:function(){return this._factory.specific(this,{name:"coordinates",transformer:i.string})}}}),r.prototype.getTagNames=function(){return["gx:LatLonQuad"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/features/KmlOverlay",["./KmlFeature","./../KmlIcon","../util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(e){t.call(this,e)};return r.prototype=Object.create(t.prototype),Object.defineProperties(r.prototype,{kmlColor:{get:function(){return this._factory.specific(this,{name:"color",transformer:i.string})}},kmlDrawOrder:{get:function(){return this._factory.specific(this,{name:"drawOrder",transformer:i.string})}},kmlIcon:{get:function(){return this._factory.any(this,{name:e.prototype.getTagNames()})}}}),r.prototype.getTagNames=function(){return["PhotoOverlay","ScreenOverlay","GroundOverlay"]},r}),i("formats/kml/features/KmlGroundOverlay",["./../KmlElements","./KmlFeature","../KmlLatLonBox","../KmlLatLonQuad","./KmlOverlay","../util/KmlNodeTransformers","../../../geom/Sector","../../../shapes/SurfaceImage"],function(t,e,i,r,n,o,s,a){"use strict";var l=function(t){this.isGroundOverlay=!0,n.call(this,t)};return l.prototype=Object.create(n.prototype),Object.defineProperties(l.prototype,{kmlAltitude:{get:function(){return this._factory.specific(this,{name:"altitude",transformer:o.string})}},kmlAltitudeMode:{get:function(){return this._factory.specific(this,{name:"altitudeMode",transformer:o.string})}},kmlLatLonBox:{get:function(){return this._factory.any(this,{name:i.prototype.getTagNames()})}},kmlLatLonQuad:{get:function(){return this._factory.any(this,{name:r.prototype.getTagNames()})}}}),l.prototype.render=function(t,i){e.prototype.render.call(this,t,i),!this._renderable&&this.enabled&&this.kmlIcon&&this.kmlLatLonBox&&(this._renderable=new a(new s(this.kmlLatLonBox.kmlSouth,this.kmlLatLonBox.kmlNorth,this.kmlLatLonBox.kmlWest,this.kmlLatLonBox.kmlEast),this.kmlIcon.kmlHref(i.fileCache)),t.redrawRequested=!0),this._renderable&&this._renderable.render(t)},l.prototype.getTagNames=function(){return["GroundOverlay"]},t.addKey(l.prototype.getTagNames()[0],l),l}),i("formats/kml/util/KmlImagePyramid",["../KmlElements","../KmlObject","../util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlTileSize:{get:function(){return this._factory.specific(this,{name:"tileSize",transformer:i.number})}},kmlMaxWidth:{get:function(){return this._factory.specific(this,{name:"maxWidth",transformer:i.number})}},kmlMaxHeight:{get:function(){return this._factory.specific(this,{name:"maxHeight",transformer:i.number})}},kmlGridOrigin:{get:function(){return this._factory.specific(this,{name:"gridOrigin",transformer:i.string})}}}),r.prototype.getTagNames=function(){return["ImagePyramid"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("shapes/Path",["../shapes/AbstractShape","../error/ArgumentError","../shaders/BasicTextureProgram","../geom/BoundingBox","../util/Color","../geom/Location","../util/Logger","../geom/Matrix","../pick/PickedObject","../geom/Position","../shapes/ShapeAttributes","../shapes/SurfacePolyline","../geom/Vec2","../geom/Vec3"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p){"use strict";var f=function(i,r){if(!i)throw new e(s.logMessage(s.LEVEL_SEVERE,"Path","constructor","missingPositions"));t.call(this,r),this._positions=i,this._pathType=WorldWind.GREAT_CIRCLE,this._terrainConformance=10,this._numSubSegments=10,this.referencePosition=this.determineReferencePosition(this._positions),this.scratchPoint=new p(0,0,0)};return f.prototype=Object.create(t.prototype),Object.defineProperties(f.prototype,{positions:{get:function(){return this._positions},set:function(t){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Path","constructor","missingPositions"));this._positions=t,this.referencePosition=this.determineReferencePosition(this._positions),this.reset()}},followTerrain:{get:function(){return this._followTerrain},set:function(t){this._followTerrain=t,this.reset()}},terrainConformance:{get:function(){return this._terrainConformance},set:function(t){this._terrainConformance=t,this.reset()}},numSubSegments:{get:function(){return this._numSubSegments},set:function(t){this._numSubSegments=t>=0?t:0,this.reset()}},pathType:{get:function(){return this._pathType},set:function(t){this._pathType=t,this.reset()}},extrude:{get:function(){return this._extrude},set:function(t){this._extrude=t,this.reset()}}}),f.prototype.determineReferencePosition=function(t){return t.length>0?t[0]:null},f.prototype.mustGenerateGeometry=function(t){return!this.currentData.tessellatedPoints||(this.currentData.drawInterior!==this.activeAttributes.drawInterior||this.currentData.drawVerticals!==this.activeAttributes.drawVerticals||(!this.followTerrain&&this.currentData.numSubSegments!==this.numSubSegments||(!(!this.followTerrain||this.currentData.terrainConformance===this.terrainConformance)||this.altitudeMode!==WorldWind.ABSOLUTE&&this.currentData.isExpired)))},f.prototype.createSurfaceShape=function(){return new c(this.positions,null)},f.prototype.doMakeOrderedRenderable=function(t){if(!this.referencePosition)return null;if(!this.mustGenerateGeometry(t))return this;var e=this.currentData.referencePoint;t.surfacePointForMode(this.referencePosition.latitude,this.referencePosition.longitude,this.referencePosition.altitude,this._altitudeMode,e),this.currentData.transformationMatrix.setToTranslation(e[0],e[1],e[2]);var i=this.makeTessellatedPositions(t);if(i.length<2)return null;var n=this.computeRenderedPath(t,i);return this.currentData.tessellatedPoints=n,this.currentData.drawInterior=this.activeAttributes.drawInterior,this.currentData.drawVerticals=this.activeAttributes.drawVerticals,this.currentData.numSubSegments=this.numSubSegments,this.currentData.terrainConformance=this.terrainConformance,this.resetExpiration(this.currentData),this.currentData.fillVbo=!0,this.currentData.extent||(this.currentData.extent=new r),this.currentData.extent.setToPoints(n),this.currentData.extent.translate(this.currentData.referencePoint),this},f.prototype.makeTessellatedPositions=function(t){var e,i,r,n=[],o=t.eyePoint,s=this.mustDrawVerticals(t),a=new p(0,0,0),l=new p(0,0,0),h=this._positions[0];s&&(this.currentData.verticalIndices=new Int16Array(2*this.positions.length),this.currentData.verticalIndices[0]=0,this.currentData.verticalIndices[1]=1),n.push(h),t.surfacePointForMode(h.latitude,h.longitude,h.altitude,this._altitudeMode,a);for(var u=1,c=this._positions.length;u<c;u++)if(e=this._positions[u],t.surfacePointForMode(e.latitude,e.longitude,e.altitude,this._altitudeMode,l),i=o.distanceTo(a),r=t.pixelSizeAtDistance(i),a.distanceTo(l)<8*r&&this.altitudeMode!==WorldWind.ABSOLUTE?n.push(e):this.makeSegment(t,h,e,a,l,n),h=e,a.copy(l),s){var d=2*(n.length-1);this.currentData.verticalIndices[2*u]=d,this.currentData.verticalIndices[2*u+1]=d+1}return n},f.prototype.makeSegment=function(t,e,i,r,n,s){var a,l,u,c,d,p,f=t.eyePoint,g=new o(0,0),m=0;if(this._pathType===WorldWind.LINEAR&&!this._followTerrain)return void(r.equals(n)||s.push(i));if(u=this._pathType===WorldWind.LINEAR?o.linearDistance(e,i):this._pathType===WorldWind.RHUMB_LINE?o.rhumbDistance(e,i):o.greatCircleDistance(e,i),this._altitudeMode!==WorldWind.CLAMP_TO_GROUND&&(m=.5*(e.altitude+i.altitude)),a=u*(t.globe.equatorialRadius+m*t.verticalExaggeration),!(a<=0)){for(l=this._pathType===WorldWind.LINEAR?o.linearAzimuth(e,i):this._pathType===WorldWind.RHUMB_LINE?o.rhumbAzimuth(e,i):o.greatCircleAzimuth(e,i),this.scratchPoint.copy(r),c=0,d=0;c<1&&(d+=this._followTerrain?this._terrainConformance*t.pixelSizeAtDistance(this.scratchPoint.distanceTo(f)):a/this._numSubSegments,!(a<d||a-d<1e-9));)c=d/a,p=c*u,this._pathType===WorldWind.LINEAR?o.linearLocation(e,l,p,g):this._pathType===WorldWind.RHUMB_LINE?o.rhumbLocation(e,l,p,g):o.greatCircleLocation(e,l,p,g),g.altitude=(1-c)*e.altitude+c*i.altitude,s.push(new h(g.latitude,g.longitude,g.altitude)),this._followTerrain&&t.surfacePointForMode(g.latitude,g.longitude,g.altitude,WorldWind.CLAMP_TO_GROUND,this.scratchPoint);s.push(i)}},f.prototype.computeRenderedPath=function(t,e){var i,r,n,o,s=this.mustDrawInterior(t)||this.mustDrawVerticals(t),a=Number.MAX_VALUE,l=t.eyePoint,h=(s?2:1)*e.length,u=new Float32Array(3*h),c=s?6:3,d=new p(0,0,0);i=this._followTerrain&&this.altitudeMode!==WorldWind.CLAMP_TO_GROUND?WorldWind.RELATIVE_TO_GROUND:this.altitudeMode;for(var f=0,g=e.length;f<g;f++)r=e[f],t.surfacePointForMode(r.latitude,r.longitude,r.altitude,i,d),o=d.distanceToSquared(l),o<a&&(a=o),d.subtract(this.currentData.referencePoint),n=c*f,u[n]=d[0],u[n+1]=d[1],u[n+2]=d[2],s&&(t.surfacePointForMode(r.latitude,r.longitude,0,WorldWind.CLAMP_TO_GROUND,d),o=d.distanceToSquared(l),o<a&&(a=o),d.subtract(this.currentData.referencePoint),u[n+3]=d[0],u[n+4]=d[1],u[n+5]=d[2]);return this.currentData.pointBufferHasExtrusionPoints=s,this.currentData.eyeDistance=Math.sqrt(a),u},f.prototype.mustDrawInterior=function(t){return this.activeAttributes.drawInterior&&this._extrude&&this._altitudeMode!==WorldWind.CLAMP_TO_GROUND},f.prototype.mustDrawVerticals=function(t){return this.activeAttributes.drawOutline&&this.activeAttributes.drawVerticals&&this.altitudeMode!==WorldWind.CLAMP_TO_GROUND},f.prototype.doRenderOrdered=function(t){var e,i,r,n,o,s=t.currentGlContext,a=t.currentProgram,h=this.currentData,u=h.tessellatedPoints.length/3;if(this.applyMvpMatrix(t),h.vboCacheKey||(h.vboCacheKey=t.gpuResourceCache.generateCacheKey()),e=t.gpuResourceCache.resourceForKey(h.vboCacheKey),e||(e=s.createBuffer(),t.gpuResourceCache.putResource(this.currentData.vboCacheKey,e,4*h.tessellatedPoints.length),h.fillVbo=!0),s.bindBuffer(s.ARRAY_BUFFER,e),h.fillVbo&&(s.bufferData(s.ARRAY_BUFFER,h.tessellatedPoints,s.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1)),a.loadTextureEnabled(s,!1),t.pickingMode&&(r=t.uniquePickColor()),this.mustDrawInterior(t)&&(i=this.activeAttributes.interiorColor,s.depthMask(i.alpha*this.layer.opacity>=1||t.pickingMode),a.loadColor(s,t.pickingMode?r:i),a.loadOpacity(s,t.pickingMode?1:this.layer.opacity),s.vertexAttribPointer(a.vertexPointLocation,3,s.FLOAT,!1,0,0),s.drawArrays(s.TRIANGLE_STRIP,0,u)),this.activeAttributes.drawOutline&&((this.mustDrawVerticals(t)&&this.mustDrawInterior(t)||this.altitudeMode===WorldWind.CLAMP_TO_GROUND)&&this.applyMvpMatrixForOutline(t),i=this.activeAttributes.outlineColor,s.depthMask(i.alpha*this.layer.opacity>=1||t.pickingMode),a.loadColor(s,t.pickingMode?r:i),a.loadOpacity(s,t.pickingMode?1:this.layer.opacity),s.lineWidth(this.activeAttributes.outlineWidth),this.currentData.pointBufferHasExtrusionPoints?(n=24,o=u/2):(n=12,o=u),s.vertexAttribPointer(a.vertexPointLocation,3,s.FLOAT,!1,n,0),s.drawArrays(s.LINE_STRIP,0,o),this.mustDrawVerticals(t)&&(h.verticalIndicesVboCacheKey||(h.verticalIndicesVboCacheKey=t.gpuResourceCache.generateCacheKey()),e=t.gpuResourceCache.resourceForKey(h.verticalIndicesVboCacheKey),e||(e=s.createBuffer(),t.gpuResourceCache.putResource(h.verticalIndicesVboCacheKey,e,4*h.verticalIndices.length),h.fillVbo=!0),s.bindBuffer(s.ELEMENT_ARRAY_BUFFER,e),h.fillVbo&&(s.bufferData(s.ELEMENT_ARRAY_BUFFER,h.verticalIndices,s.STATIC_DRAW),t.frameStatistics.incrementVboLoadCount(1)),s.vertexAttribPointer(a.vertexPointLocation,3,s.FLOAT,!1,0,0),s.drawElements(s.LINES,h.verticalIndices.length,s.UNSIGNED_SHORT,0))),h.fillVbo=!1,t.pickingMode){var c=new l(r,this.pickDelegate?this.pickDelegate:this,null,this.layer,!1);t.resolvePick(c)}},f.prototype.beginDrawing=function(t){var e=t.currentGlContext;this.mustDrawInterior(t)&&e.disable(e.CULL_FACE),t.findAndBindProgram(i),e.enableVertexAttribArray(t.currentProgram.vertexPointLocation)},f.prototype.endDrawing=function(t){var e=t.currentGlContext;e.disableVertexAttribArray(t.currentProgram.vertexPointLocation),e.depthMask(!0),e.lineWidth(1),e.enable(e.CULL_FACE)},f}),i("formats/kml/geom/KmlLineString",["../../../util/Color","../KmlElements","./KmlGeometry","../styles/KmlStyle","../../../geom/Location","../util/KmlNodeTransformers","../../../shapes/Path","../../../geom/Position","../../../shapes/ShapeAttributes","../../../shapes/SurfacePolyline","../../../util/WWUtil"],function(t,e,i,r,n,o,s,a,l,h,u){"use strict";var c=function(t){i.call(this,t),this._style=null};return c.prototype=Object.create(i.prototype),Object.defineProperties(c.prototype,{kmlExtrude:{get:function(){return this._factory.specific(this,{name:"extrude",transformer:o.boolean})||!1}},kmlTessellate:{get:function(){return this._factory.specific(this,{name:"tessellate",transformer:o.boolean})||!1}},kmlAltitudeMode:{get:function(){return this._factory.specific(this,{name:"altitudeMode",transformer:o.string})||WorldWind.ABSOLUTE}},kmlPositions:{get:function(){return this._factory.specific(this,{name:"coordinates",transformer:o.positions})}},kmlCenter:{get:function(){var t=this.kmlPositions,e=0,i=0,r=0;return t.forEach(function(t){e+=t.latitude,i+=t.longitude,r+=t.altitude}),new a(e/this.kmlPositions.length,i/this.kmlPositions.length,r/this.kmlPositions.length)}}}),c.prototype.createPath=function(t,e){this.kmlAltitudeMode==WorldWind.CLAMP_TO_GROUND?this._renderable=new h(this.prepareLocations(),this.prepareAttributes(t.normal,e)):this._renderable=new s(this.prepareLocations(),this.prepareAttributes(t.normal,e)),t.highlight&&(this._renderable.highlightAttributes=this.prepareAttributes(t.highlight,e)),this.moveValidProperties()},c.prototype.render=function(t,e){i.prototype.render.call(this,t,e),e.lastStyle&&!this._renderable&&(this.createPath(e.lastStyle,e.fileCache),t.redrawRequested=!0),this._renderable&&(this._renderable.enabled=this.enabled,this._renderable.render(t))},c.prototype.prepareAttributes=function(t,e){var i=t&&t.generate(e)||{};return i._applyLighting=!0,i._drawOutline=!0,i._drawInterior=!0,i._drawVerticals=this.kmlExtrude||!1,i._outlineStippleFactor=0,i._outlineStipplePattern=61680,i._enableLighting=!0,new l(r.shapeAttributes(i))},c.prototype.prepareLocations=function(){return this.kmlPositions},c.prototype.moveValidProperties=function(){this._renderable.extrude=this.kmlExtrude||!1,this._renderable.altitudeMode=this.kmlAltitudeMode||WorldWind.ABSOLUTE,this._renderable.tesselate=this.kmlTesselate||!1},c.prototype.equals=function(t){if(!t)return!1;var e=u.arrayEquals(t.kmlPositions,this.kmlPositions);return e&&t.kmlExtrude==this.kmlExtrude&&t.kmlTessellate==this.kmlTessellate&&t.kmlAltitudeMode==this.kmlAltitudeMode},c.prototype.getTagNames=function(){return["LineString"]},e.addKey(c.prototype.getTagNames()[0],c),c}),i("formats/kml/geom/KmlLinearRing",["./KmlLineString","../KmlElements"],function(t,e){"use strict";var i=function(e){t.call(this,e)};return i.prototype=Object.create(t.prototype),i.prototype.getTagNames=function(){return["LinearRing"]},e.addKey(i.prototype.getTagNames()[0],i),i}),i("formats/kml/KmlLocation",["./KmlElements","./KmlObject","./util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlLongitude:{get:function(){return this._factory.specific(this,{name:"longitude",transformer:i.string})}},kmlLatitude:{get:function(){return this._factory.specific(this,{name:"latitude",transformer:i.string})}},kmlAltitude:{get:function(){return this._factory.specific(this,{name:"altitude",transformer:i.string})}}}),r.prototype.getTagNames=function(){return["Location"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/KmlLookAt",["./KmlAbstractView","./KmlElements","./util/KmlNodeTransformers","../../geom/Position"],function(t,e,i,r){"use strict";var n=function(e){t.call(this,e)};return n.prototype=Object.create(t.prototype),Object.defineProperties(n.prototype,{kmlLongitude:{get:function(){return this._factory.specific(this,{name:"longitude",transformer:i.number})}},kmlLatitude:{get:function(){return this._factory.specific(this,{name:"latitude",transformer:i.number})}},kmlAltitude:{get:function(){return this._factory.specific(this,{name:"altitude",transformer:i.number})}},kmlHeading:{get:function(){return this._factory.specific(this,{name:"heading",transformer:i.number})}},kmlTilt:{get:function(){return this._factory.specific(this,{name:"tilt",transformer:i.number})}},kmlRange:{get:function(){return this._factory.specific(this,{name:"range",transformer:i.number})}},kmlAltitudeMode:{get:function(){return this._factory.specific(this,{name:"altitudeMode",transformer:i.string})}}}),n.prototype.update=function(t){if(t.wwd){var e=this.kmlAltitude||4e3;t.wwd.goTo(new r(this.kmlLatitude,this.kmlLongitude,e))}},n.prototype.getTagNames=function(){return["LookAt"]},e.addKey(n.prototype.getTagNames()[0],n),n}),i("formats/kml/geom/KmlMultiGeometry",["./../KmlElements","./KmlGeometry","../../../geom/Position"],function(t,e,i){"use strict";var r=function(t){e.call(this,t),this._style=t.style};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlShapes:{get:function(){return this._factory.all(this)}},kmlCenter:{get:function(){var t=this.kmlShapes.map(function(t){return t.kmlCenter}),e=0,r=0,n=0;return t.forEach(function(t){e+=t.latitude,r+=t.longitude,n+=t.altitude}),new i(e/t.length,r/t.length,n/t.length)}}}),r.prototype.render=function(t,i){e.prototype.render.call(this,t,i),this.kmlShapes.forEach(function(e){e.render(t,i)})},r.prototype.getTagNames=function(){return["MultiGeometry"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/geom/KmlMultiTrack",["./../KmlElements","./KmlGeometry"],function(t,e){"use strict";var i=function(t){e.call(this,t)};return i.prototype=Object.create(e.prototype),i.prototype.getTagNames=function(){return["gx:MultiTrack"]},t.addKey(i.prototype.getTagNames()[0],i),i}),i("formats/kml/features/KmlNetworkLink",["./../KmlElements","./KmlFeature","../KmlFile","../KmlLink","../util/KmlNodeTransformers","../util/KmlRefreshListener"],function(t,e,i,r,n,o){"use strict";var s="refreshNetworkLinkEvent",a=function(t){e.call(this,t),this.isFeature=!0,this.resolvedFile=null,this.displayed=!1,this.isDownloading=!1};return a.prototype=Object.create(e.prototype),Object.defineProperties(a.prototype,{kmlRefreshVisibility:{get:function(){return this._factory.specific(this,{name:"refreshVisibility",transformer:n.boolean})}},kmlFlyToView:{get:function(){return this._factory.specific(this,{name:"flyToView",transformer:n.boolean})}},kmlLink:{get:function(){return this._factory.any(this,{name:r.prototype.getTagNames()})}}}),a.prototype.getTagNames=function(){return["NetworkLink"]},a.prototype.render=function(t,r){if(e.prototype.render.call(this,t,r),r.lastVisibility||this.displayed){if(!this.isDownloading&&!this.resolvedFile){this.isDownloading=!0;var n=this;new i(n.buildUrl(r.fileCache)).then(function(t){n.resolvedFile=t,n.isDownloading=!1,n.fireEvent(r)})}this.resolvedFile&&!this.displayed&&(this.resolvedFile.render(t,r),this.handleRefresh(r))}},a.prototype.buildUrl=function(t){return this.kmlLink.kmlHref(t)},a.prototype.handleRefresh=function(t){var e=t.activeEvents;if(e=e.filter(function(t){return t.type==s}),e.length>0){var r=this;new i(r.buildUrl(t.fileCache)).then(function(e){r.resolvedFile=e,r.fireEvent(t)})}},a.prototype.fireEvent=function(t){
var e=0;if("onInterval"==this.kmlLink.kmlRefreshMode)e=1e3*this.kmlLink.kmlRefreshInterval;else{if("onExpire"!=this.kmlLink.kmlRefreshMode)return;if(!this.resolvedFile)return;e=this.resolvedFile.getExpired()}t.listener.addEvent(new o.Event(s,e,null))},t.addKey(a.prototype.getTagNames()[0],a),a}),i("formats/kml/util/KmlUpdate",["./KmlChange","./KmlCreate","./KmlDelete","../KmlElements","../KmlObject","./KmlNodeTransformers"],function(t,e,i,r,n,o){var s=function(t){n.call(this,t)};return s.prototype=Object.create(n.prototype),Object.defineProperties(s.prototype,{targetHref:{get:function(){return this._factory.specific(this,{name:"minRefreshPeriod",transformer:o.number})}},Change:{get:function(){return this._factory.any(this,{name:t.prototype.getTagNames()})}},Create:{get:function(){return this._factory.any(this,{name:e.prototype.getTagNames()})}},Delete:{get:function(){return this._factory.any(this,{name:i.prototype.getTagNames()})}}}),s.prototype.getTagNames=function(){return["Update"]},r.addKey(s.prototype.getTagNames()[0],s),s}),i("formats/kml/util/KmlNetworkLinkControl",["../KmlAbstractView","../KmlElements","../KmlObject","./KmlNodeTransformers","./KmlUpdate"],function(t,e,i,r,n){var o=function(t){i.call(this,t)};return o.prototype=Object.create(i.prototype),Object.defineProperties(o.prototype,{minRefreshPeriod:{get:function(){return this._factory.specific(this,{name:"minRefreshPeriod",transformer:r.number})}},maxSessionLength:{get:function(){return this._factory.specific(this,{name:"maxSessionLength",transformer:r.number})}},cookie:{get:function(){return this._factory.specific(this,{name:"cookie",transformer:r.string})}},message:{get:function(){return this._factory.specific(this,{name:"message",transformer:r.string})}},linkName:{get:function(){return this._factory.specific(this,{name:"linkName",transformer:r.string})}},linkDescription:{get:function(){return this._factory.specific(this,{name:"linkDescription",transformer:r.string})}},linkSnippet:{get:function(){return this._factory.specific(this,{name:"linkSnippet",transformer:r.string})}},expires:{get:function(){return this._factory.specific(this,{name:"expires",transformer:r.date})}},Update:{get:function(){return this._factory.any(this,{name:n.prototype.getTagNames()})}},AbstractView:{get:function(){return this._factory.any(this,{name:t.prototype.getTagNames()})}}}),o.prototype.getTagNames=function(){return["NetworkLinkControl"]},e.addKey(o.prototype.getTagNames()[0],o),o}),i("formats/kml/KmlOrientation",["./KmlElements","./KmlObject","./util/KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlHeading:{get:function(){return this._factory.specific(this,{name:"heading",transformer:i.number})}},kmlTilt:{get:function(){return this._factory.specific(this,{name:"tilt",transformer:i.number})}},kmlRoll:{get:function(){return this._factory.specific(this,{name:"roll",transformer:i.number})}}}),r.prototype.getTagNames=function(){return["Orientation"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/geom/KmlPoint",["../../../util/Color","../KmlElements","./KmlGeometry","../../../geom/Location","../util/KmlNodeTransformers","../../../shapes/Polygon","../../../geom/Position"],function(t,e,i,r,n,o,s){"use strict";var a=function(t){i.call(this,t),this._shape=null};return a.prototype=Object.create(i.prototype),Object.defineProperties(a.prototype,{kmlPosition:{get:function(){var t=this._factory.specific(this,{name:"coordinates",transformer:n.string}).split(",");return new s(t[1],t[0],t[2]||0)}},kmlExtrude:{get:function(){return this._factory.specific(this,{name:"extrude",transformer:n.boolean})}},kmlAltitudeMode:{get:function(){return this._factory.specific(this,{name:"altitudeMode",transformer:n.string})}},kmlCenter:{get:function(){return this.kmlPosition}}}),a.prototype.getTagNames=function(){return["Point"]},e.addKey(a.prototype.getTagNames()[0],a),a}),i("formats/kml/util/KmlViewVolume",["../KmlElements","../KmlObject","./KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlLeftFov:{get:function(){return this._factory.specific(this,{name:"leftFov",transformer:i.number})}},kmlRightFov:{get:function(){return this._factory.specific(this,{name:"rightFov",transformer:i.number})}},kmlBottomFov:{get:function(){return this._factory.specific(this,{name:"bottomFov",transformer:i.number})}},kmlTopFov:{get:function(){return this._factory.specific(this,{name:"topFov",transformer:i.number})}},kmlNear:{get:function(){return this._factory.specific(this,{name:"near",transformer:i.string})}}}),r.prototype.getTagNames=function(){return["ViewVolume"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/features/KmlPhotoOverlay",["../util/KmlImagePyramid","./../KmlElements","./KmlOverlay","../geom/KmlPoint","../util/KmlNodeTransformers","../util/KmlViewVolume"],function(t,e,i,r,n,o){"use strict";var s=function(t){i.call(this,t)};return s.prototype=Object.create(i.prototype),Object.defineProperties(s.prototype,{kmlRotation:{get:function(){return this._factory.specific(this,{name:"rotation",transformer:n.string})}},kmlShape:{get:function(){return this._factory.specific(this,{name:"shape",transformer:n.string})}},kmlPoint:{get:function(){return this._factory.any(this,{name:r.prototype.getTagNames()})}},kmlViewVolume:{get:function(){return this._factory.any(this,{name:o.prototype.getTagNames()})}},kmlImagePyramid:{get:function(){return this._factory.any(this,{name:t.prototype.getTagNames()})}}}),s.prototype.getTagNames=function(){return["PhotoOverlay"]},e.addKey(s.prototype.getTagNames[0],s),s}),i("formats/kml/features/KmlPlacemark",["./../KmlElements","./KmlFeature","../geom/KmlGeometry","../styles/KmlStyle","../KmlTimeSpan","../KmlTimeStamp","../../../shapes/PlacemarkAttributes","../../../shapes/Placemark","../../../util/Color","../../../shapes/ShapeAttributes","../../../shapes/TextAttributes","../../../util/Offset","../../../util/WWUtil"],function(t,e,i,r,n,o,s,a,l,h,u,c,d){"use strict";var p=function(t){e.call(this,t)};return p.prototype=Object.create(e.prototype),Object.defineProperties(p.prototype,{kmlGeometry:{get:function(){return this._factory.any(this,{name:i.prototype.getTagNames()})}}}),p.prototype.render=function(t,i){e.prototype.render.call(this,t,i),i=d.clone(i),i.lastStyle&&!this._renderable&&this.kmlGeometry&&(this._renderable=new a(this.kmlGeometry.kmlCenter,!1,this.prepareAttributes(i.lastStyle.normal,i.fileCache)),i.lastStyle.highlight&&(this._renderable.highlightAttributes=this.prepareAttributes(i.lastStyle.highlight,i.fileCache)),this.moveValidProperties(),t.redrawRequested=!0),this._renderable&&this.kmlGeometry&&(this.kmlGeometry.render(t,i),this._renderable.render(t))},p.prototype.prepareAttributes=function(t,e){var i=t&&t.generate({},e)||{normal:{},highlight:{}},n=new s(r.placemarkAttributes(i));return n.imageOffset=new c(WorldWind.OFFSET_FRACTION,.3,WorldWind.OFFSET_FRACTION,0),n.imageColor=l.WHITE,n.labelAttributes=new u(r.textAttributes({_offset:new c(WorldWind.OFFSET_FRACTION,.5,WorldWind.OFFSET_FRACTION,1),_color:l.YELLOW})),n.drawLeaderLine=!0,n.leaderLineAttributes=new h(r.shapeAttributes({_outlineColor:l.RED})),n},p.prototype.moveValidProperties=function(){this._renderable.label=this.kmlName||"",this._renderable.altitudeMode=this.kmlAltitudeMode||WorldWind.RELATIVE_TO_GROUND,this._renderable.enableLeaderLinePicking=!0},p.prototype.getTagNames=function(){return["Placemark"]},t.addKey(p.prototype.getTagNames()[0],p),p}),i("formats/kml/geom/KmlPolygon",["../../../util/Color","../KmlElements","./KmlGeometry","./KmlLinearRing","../styles/KmlStyle","../../../geom/Location","../util/KmlNodeTransformers","../../../shapes/Polygon","../../../shapes/ShapeAttributes","../../../shapes/SurfacePolygon"],function(t,e,i,r,n,o,s,a,l,h){"use strict";var u=function(t){i.call(this,t),this.initialized=!1};return u.prototype=Object.create(i.prototype),Object.defineProperties(u.prototype,{kmlExtrude:{get:function(){return this._factory.specific(this,{name:"extrude",transformer:s.boolean})}},kmlTessellate:{get:function(){return this._factory.specific(this,{name:"tessellate",transformer:s.boolean})}},kmlAltitudeMode:{get:function(){return this._factory.specific(this,{name:"altitudeMode",transformer:s.string})}},kmlOuterBoundary:{get:function(){return this._factory.specific(this,{name:"outerBoundaryIs",transformer:s.linearRing})}},kmlInnerBoundary:{get:function(){return this._factory.specific(this,{name:"innerBoundaryIs",transformer:s.linearRing})}},kmlCenter:{get:function(){return this.kmlOuterBoundary.kmlCenter}}}),u.prototype.createPolygon=function(t,e){this.kmlAltitudeMode===WorldWind.CLAMP_TO_GROUND||this.kmlInnerBoundary&&this.kmlInnerBoundary.kmlAltitudeMode===WorldWind.CLAMP_TO_GROUND||this.kmlOuterBoundary&&this.kmlOuterBoundary.kmlAltitudeMode===WorldWind.CLAMP_TO_GROUND?this._renderable=new h(this.prepareLocations(),this.prepareAttributes(t.normal,e)):this._renderable=new a(this.prepareLocations(),this.prepareAttributes(t.normal,e)),t.highlight&&(this._renderable.highlightAttributes=this.prepareAttributes(t.highlight,e)),this.moveValidProperties()},u.prototype.render=function(t,e){i.prototype.render.call(this,t,e),e.lastStyle&&!this._renderable&&(this.createPolygon(e.lastStyle,e.fileCache),t.redrawRequested=!0),this._renderable&&(this._renderable.enabled=this.enabled,this._renderable.render(t))},u.prototype.moveValidProperties=function(){this._renderable.extrude=this.kmlExtrude||!0,this._renderable.altitudeMode=this.kmlAltitudeMode||WorldWind.CLAMP_TO_GROUND},u.prototype.prepareAttributes=function(t,e){var i=t&&t.generate(e)||{};return i._drawVerticals=this.kmlExtrude||!1,i._applyLighting=!0,i._depthTest=!0,i._outlineStippleFactor=0,i._outlineStipplePattern=61680,i._enableLighting=!0,new l(n.shapeAttributes(i))},u.prototype.prepareLocations=function(){var t=[];return null!=this.kmlInnerBoundary?(t[0]=this.kmlInnerBoundary.kmlPositions,t[1]=this.kmlOuterBoundary.kmlPositions):t=this.kmlOuterBoundary.kmlPositions,t},u.prototype.getStyle=function(){return this._style},u.prototype.getTagNames=function(){return["Polygon"]},e.addKey(u.prototype.getTagNames()[0],u),u}),i("formats/kml/util/KmlScale",["./../KmlElements","../KmlObject","./KmlNodeTransformers"],function(t,e,i){"use strict";var r=function(t){e.call(this,t)};return r.prototype=Object.create(e.prototype),Object.defineProperties(r.prototype,{kmlX:{get:function(){return this._factory.specific(this,{name:"x",transformer:i.number})}},kmlY:{get:function(){return this._factory.specific(this,{name:"y",transformer:i.number})}},kmlZ:{get:function(){return this._factory.specific(this,{name:"z",transformer:i.number})}}}),r.prototype.getTagNames=function(){return["Scale"]},t.addKey(r.prototype.getTagNames()[0],r),r}),i("formats/kml/features/KmlScreenOverlay",["./../KmlElements","./KmlFeature","./KmlOverlay","../util/KmlNodeTransformers","../../../util/Offset","../../../shapes/ScreenImage"],function(t,e,i,r,n,o){"use strict";var s=function(t){i.call(this,t)};return s.prototype=Object.create(i.prototype),Object.defineProperties(s.prototype,{kmlRotation:{get:function(){return this._factory.specific(this,{name:"rotation",transformer:r.number})}},kmlOverlayXYx:{get:function(){return this._factory.specific(this,{name:"overlayXY",transformer:r.attribute("x"),attribute:"kmlOverlayXYx"})}},kmlOverlayXYy:{get:function(){return this._factory.specific(this,{name:"overlayXY",transformer:r.attribute("y"),attribute:"kmlOverlayXYy"})}},kmlOverlayXYxunits:{get:function(){return this._factory.specific(this,{name:"overlayXY",transformer:r.attribute("xunits"),attribute:"kmlOverlayXYxunits"})}},kmlOverlayXYyunits:{get:function(){return this._factory.specific(this,{name:"overlayXY",transformer:r.attribute("yunits"),attribute:"kmlOverlayXYyunits"})}},kmlScreenXYx:{get:function(){return this._factory.specific(this,{name:"screenXY",transformer:r.attribute("x"),attribute:"kmlScreenXYx"})}},kmlScreenXYy:{get:function(){return this._factory.specific(this,{name:"screenXY",transformer:r.attribute("y"),attribute:"kmlScreenXYy"})}},kmlScreenXYxunits:{get:function(){return this._factory.specific(this,{name:"screenXY",transformer:r.attribute("xunits"),attribute:"kmlScreenXYxunits"})}},kmlScreenXYyunits:{get:function(){return this._factory.specific(this,{name:"screenXY",transformer:r.attribute("yunits"),attribute:"kmlScreenXYyunits"})}},kmlRotationXYx:{get:function(){return this._factory.specific(this,{name:"rotationXY",transformer:r.attribute("x"),attribute:"kmlRotationXYx"})}},kmlRotationXYy:{get:function(){return this._factory.specific(this,{name:"rotationXY",transformer:r.attribute("y"),attribute:"kmlRotationXYy"})}},kmlRotationXYxunits:{get:function(){return this._factory.specific(this,{name:"rotationXY",transformer:r.attribute("xunits"),attribute:"kmlRotationXYxunits"})}},kmlRotationXYyunits:{get:function(){return this._factory.specific(this,{name:"rotationXY",transformer:r.attribute("yunits"),attribute:"kmlRotationXYyunits"})}},kmlSizex:{get:function(){return this._factory.specific(this,{name:"size",transformer:r.attribute("x"),attribute:"kmlSizex"})}},kmlSizey:{get:function(){return this._factory.specific(this,{name:"size",transformer:r.attribute("y"),attribute:"kmlSizey"})}},kmlSizexunits:{get:function(){return this._factory.specific(this,{name:"size",transformer:r.attribute("xunits"),attribute:"kmlSizexunits"})}},kmlSizeyunits:{get:function(){return this._factory.specific(this,{name:"size",transformer:r.attribute("yunits"),attribute:"kmlSizeyunits"})}}}),s.prototype.render=function(t,i){e.prototype.render.call(this,t,i),this._renderable||this.kmlIcon&&(this._renderable=new o(new n(this.kmlScreenXYxunits,this.kmlScreenXYx,this.kmlScreenXYyunits,this.kmlScreenXYy),this.kmlIcon.kmlHref(i.fileCache)),this._renderable.imageOffset=new n(this.kmlOverlayXYxunits,this.kmlOverlayXYx,this.kmlOverlayXYyunits,this.kmlOverlayXYy),t.redrawRequested=!0),this._renderable&&this._renderable.render(t)},s.prototype.getTagNames=function(){return["ScreenOverlay"]},t.addKey(s.prototype.getTagNames()[0],s),s}),i("formats/kml/features/KmlTour",["./../KmlElements","./KmlFeature"],function(t,e){"use strict";var i=function(t){e.call(this,t)};return i.prototype=Object.create(e.prototype),i.prototype.getTagNames=function(){return["gx:Tour"]},t.addKey(i.prototype.getTagNames()[0],i),i}),i("formats/kml/geom/KmlTrack",["./../KmlElements","./KmlGeometry"],function(t,e){"use strict";var i=function(t){e.call(this,t)};return i.prototype=Object.create(e.prototype),i.prototype.getTagNames=function(){return["gx:Track"]},t.addKey(i.prototype.getTagNames()[0],i),i}),i("formats/kml/controls/KmlTreeVisibility",["../../../util/WWUtil","./KmlControls"],function(t,e){"use strict";var i=function(t,i){e.apply(this),this._visualElementId=t,this._wwd=i};return i.prototype=Object.create(e.prototype),i.prototype.hook=function(t,e){e.isFeature&&this.createControls(t)},i.prototype.createControls=function(e){function i(){o=!o,h.updateDescendants(e,o)}function r(){e.kmlAbstractView&&e.kmlAbstractView.update({wwd:h._wwd})}var n=e.kmlName||e.id||t.guid(),o=e.enabled&&e.kmlVisibility===!0,s=document.createElement("div"),a=document.createElement("input");a.setAttribute("type","checkbox"),o&&a.setAttribute("checked","checked"),a.addEventListener("click",i,!0),s.appendChild(a);var l;l=e.kmlAbstractView?document.createElement("a"):document.createElement("span"),l.appendChild(document.createTextNode(n)),l.addEventListener("click",r,!0),s.appendChild(l),document.getElementById(this._visualElementId).appendChild(s);var h=this},i.prototype.updateDescendants=function(t,e){t.controlledVisibility=e,this._wwd.redraw()},i}),i("layer/LandsatRestLayer",["../error/ArgumentError","../geom/Location","../util/Logger","../geom/Sector","../layer/TiledImageLayer","../util/LevelRowColumnUrlBuilder","../util/WWUtil"],function(t,e,i,r,n,o,s){"use strict";var a=function(t,i,a){var l=s.urlPath(t+"/"+i);n.call(this,r.FULL_SPHERE,new e(36,36),10,"image/png",l,512,512),this.displayName=a,this.pickEnabled=!1,this.urlBuilder=new o(t,i)};return a.prototype=Object.create(n.prototype),a}),i("util/measure/LengthMeasurer",["../../error/ArgumentError","../../geom/Location","../Logger","./MeasurerUtils","../../geom/Position","../../geom/Vec3"],function(t,e,i,r,n,o){var s=function(e){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"LengthMeasurer","constructor","missingWorldWindow"));this.wwd=e,this.DEFAULT_MIN_SEGMENT_LENGTH=30,this._maxSegmentLength=1e5,this._lengthTerrainSamplingSteps=128,this.subdividedPositions=null};return Object.defineProperties(s.prototype,{maxSegmentLength:{get:function(){return this._maxSegmentLength},set:function(t){this._maxSegmentLength=t}},lengthTerrainSamplingSteps:{get:function(){return this._lengthTerrainSamplingSteps},set:function(t){this._lengthTerrainSamplingSteps=t}}}),s.prototype.getLength=function(t,e,i){return i=i||WorldWind.GREAT_CIRCLE,this.subdividedPositions=null,this.computeLength(t,e,i)},s.prototype.getPathLength=function(t){return this.subdividedPositions=null,this.computeLength(t.positions,t.followTerrain,t.pathType)},s.prototype.getGeographicDistance=function(t,i){if(t instanceof WorldWind.Path)var r=t.positions,n=t.pathType;else Array.isArray(t)&&(r=t,n=i||WorldWind.GREAT_CIRCLE);if(!r||r.length<2)return-1;var o=e.greatCircleDistance;n===WorldWind.RHUMB_LINE?o=e.rhumbDistance:n===WorldWind.LINEAR&&(o=e.linearDistance);for(var s=0,a=0,l=r.length-1;a<l;a++){var h=r[a],u=r[a+1];s+=o(h,u)}return s*this.wwd.globe.equatorialRadius},s.prototype.computeLength=function(t,e,i){if(!t||t.length<2)return-1;var n=this.wwd.globe;if(null==this.subdividedPositions){var s=this._maxSegmentLength;if(e){var a=this.computeLength(t,!1,i);s=a/this._lengthTerrainSamplingSteps,s=Math.min(Math.max(s,this.DEFAULT_MIN_SEGMENT_LENGTH),this._maxSegmentLength)}this.subdividedPositions=r.subdividePositions(n,t,e,i,s)}var l=0,h=this.subdividedPositions[0],u=new o(0,0,0),c=new o(0,0,0);u=n.computePointFromPosition(h.latitude,h.longitude,h.altitude,u);for(var d=1,p=this.subdividedPositions.length;d<p;d++){var f=this.subdividedPositions[d];c=n.computePointFromPosition(f.latitude,f.longitude,f.altitude,c),l+=u.distanceTo(c),u.copy(c)}return l},s}),i("navigate/Navigator",["../ArcBallCamera","../error/ArgumentError","../FirstPersonCamera","../util/Logger"],function(t,e,i,r){"use strict";var n=function(t){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"Navigator","constructor","Missing camera."));this._camera=t};return Object.defineProperties(n.prototype,{camera:{get:function(){return this._camera},set:function(t){this._camera=t}},lookAtLocation:{get:function(){return this.camera.position},set:function(t){this.camera.position=t}},range:{get:function(){return this.camera.range},set:function(t){this.camera.range=t}},heading:{get:function(){return this.camera.heading},set:function(t){this.camera.heading=t}},tilt:{get:function(){return this.camera.tilt},set:function(t){this.camera.tilt=t}},roll:{get:function(){return this.camera.roll},set:function(t){this.camera.roll=t}}}),n.prototype.getAsFirstPersonCamera=function(t){return t=t||new i(this.camera.wwd),this.camera instanceof i?t.copy(this.camera):this.camera.toFirstPerson(t),t},n.prototype.getAsArcBallCamera=function(e){return e=e||new t(this.camera.wwd),this.camera instanceof i?this.camera.toArcBall(e):e.copy(this.camera),e},n}),i("navigate/LookAtNavigator",["../navigate/Navigator"],function(t){"use strict";return t}),i("cache/MemoryCacheListener",["../util/Logger","../error/UnsupportedOperationError"],function(t,e){"use strict";var i=function(){};return i.prototype.entryRemoved=function(i,r){throw new e(t.logMessage(t.LEVEL_SEVERE,"MemoryCacheListener","entryRemoved","abstractInvocation"))},i.prototype.removalError=function(i,r,n){throw new e(t.logMessage(t.LEVEL_SEVERE,"MemoryCacheListener","removalError","abstractInvocation"))},i}),i("util/NominatimGeocoder",["../util/Logger"],function(t){"use strict";var e=function(){this.service="https://open.mapquestapi.com/nominatim/v1/search/"};return e.prototype.lookup=function(t,e,i){var r=this.service+t.replace(" ","%20")+"?format=json",n=new XMLHttpRequest,o=this;r+="&key="+(i||"lUvVRchXGGDh5Xwk3oidrXeIDAAevOUS"),n.open("GET",r,!0),n.onreadystatechange=function(){if(4===n.readyState&&200===n.status){var t=JSON.parse(n.responseText);e(o,t)}},n.send(null)},e}),i("ogc/openSearch/OpenSearchConstants",[],function(){"use strict";var t={COLLECTION:"collection",RESULTS:"results"};return t}),i("ogc/openSearch/OpenSearchNamespaces",[],function(){"use strict";var t={openSearch:"http://a9.com/-/spec/opensearch/1.1/",geo:"http://a9.com/-/opensearch/extensions/geo/1.0/",time:"http://a9.com/-/opensearch/extensions/time/1.0/",parameters:"http://a9.com/-/spec/opensearch/extensions/parameters/1.0/",eo:"http://a9.com/-/opensearch/extensions/eo/1.0/",gml:"http://www.opengis.net/gml",dc:"http://purl.org/dc/elements/1.1/",georss:"http://www.georss.org/georss"};return t}),i("ogc/openSearch/OpenSearchUtils",["../../util/Promise"],function(t){"use strict";var e={getChildTextContent:function(t,e,i){var r=this.getXmlElements(t,e,i);return r.length?r[0].textContent.trim():""},getTextContent:function(t){return t.textContent.trim()},getXmlElements:function(t,e,i){var r;return i?r=t.getElementsByTagNameNS(i,e):(r=t.getElementsByTagName(e),r.length||(r=t.getElementsByTagNameNS("*",e))),r&&r.length?[].slice.call(r):[]},getNodeAttributes:function(t,e){for(var i=0,r=t.attributes.length;i<r;i++){var n=t.attributes[i];e[n.name]=n.value}return e},arrayFind:function(t,e,i){if(!Array.isArray(t))throw new Error("arrayFind - missing array");if("function"!=typeof e)throw new Error("arrayFind - missing predicate");for(var r=0,n=t.length;r<n;r++)if(e.call(i,t[r],r,t))return t[r]},parseXml:function(t){var e=(new DOMParser).parseFromString(t,"text/xml");return e.documentElement},fetch:function(e){return new t(function(t,i){var r=new XMLHttpRequest;r.onload=function(){return this.status>=200&&this.status<300?t(this.response):i(new Error(this.status+" "+this.statusText))},r.onerror=function(){return i(new Error("Unable to fetch data"))},r.ontimeout=function(){return i(new Error("Request timed out"))},r.open(e.method,e.url,!0,e.user,e.password),r.withCredentials=e.withCredentials,r.timeout=e.timeout,r.responseType=e.responseType,Object.keys(e.headers).forEach(function(t){r.setRequestHeader(t,e.headers[t])}),r.send(e.body)})}};return e}),i("ogc/openSearch/responseFormats/atomParser/OpenSearchGeoRssParser",["../../OpenSearchNamespaces","../../OpenSearchUtils"],function(t,e){"use strict";var i={parseSimple:function(t){var e={type:"",coordinates:[]};return"polygon"===t.localName?(e.type="Polygon",e.coordinates.push(i.parseLocations(t))):"point"===t.localName?(e.type="Point",e.coordinates=i.parseLocations(t)):"line"===t.localName&&(e.type="LineString",e.coordinates=i.parseLocations(t)),e},parseGml:function(t){var r={type:"",coordinates:[]},n=t.firstElementChild;switch(n.localName){case"Point":r.type="Point";var o=e.getXmlElements(n,"pos")[0];o&&(r.coordinates=i.parseLocations(o));break;case"LineString":r.type="LineString";var s=e.getXmlElements(n,"posList")[0];s&&(r.coordinates=i.parseLocations(s));break;case"Polygon":r.type="Polygon",r.coordinates=i.parseGmlPolygon(n);break;case"MultiSurface":r.type="MultiPolygon",r.coordinates=[i.parseMultiPolygon(n)]}return r},parseBox:function(t){var e=i.parseLocations(t);return[].concat.apply([],e)},parseLocations:function(t){for(var e=t.textContent.trim().replace(/\s+/g," ").split(" "),i=[],r=0;r<e.length;r+=2){var n=+e[r],o=+e[r+1];i.push([o,n])}return i},parseGmlPolygon:function(t){for(var r=e.getXmlElements(t,"posList")[0],n=e.getXmlElements(t,"interior"),o=i.parseLocations(r),s=[],a=0;a<n.length;a++){var l=e.getXmlElements(n[a],"posList")[0];if(l){var h=i.parseLocations(l);s.push(h)}}return o.concat(s)},parseMultiPolygon:function(t){var r=e.getXmlElements(t,"surfaceMember").map(function(t){return e.getXmlElements(t,"Polygon")}),n=e.getXmlElements(t,"surfaceMembers")[0];return n&&(r=r.concat(e.getXmlElements(n,"Polygon"))),r.map(function(t){return i.parseGmlPolygon(t)})}};return i}),i("ogc/openSearch/responseFormats/atomParser/OpenSearchAtomParser",["../../OpenSearchConstants","./OpenSearchGeoRssParser"],function(t,e){"use strict";var i={parse:function(t,e){for(var r=(new DOMParser).parseFromString(t,"text/xml").documentElement,n={id:"",type:"FeatureCollection",features:[],properties:{}},o=n.properties,s=0,a=r.childNodes.length;s<a;s++){var l=r.childNodes[s];if(1===l.nodeType)switch(l.localName){case"id":n.id=l.textContent.trim();break;case"title":case"updated":case"rights":o[l.localName]=l.textContent.trim();break;case"generator":o.creator=l.textContent.trim();break;case"totalResults":case"startIndex":case"itemsPerPage":o[l.localName]=+l.textContent.trim();break;case"Query":o.query=i.parseAttributesAsString(l);break;case"link":i.parseFeedLinks(l,o);break;case"entry":n.features.push(i.parseEntry(l,e))}}return n},parseFeedLinks:function(t,e){e.links||(e.links={});var r=e.links,n=t.getAttribute("rel")||"alternate",o=i.parseLink(t);"first"===n||"next"===n||"last"===n?r[n]=o:("alternate"===n&&(n="alternates"),r[n]||(r[n]=[]),r[n].push(o))},parseLink:function(t){var e={},i=t.getAttribute("href"),r=t.getAttribute("type"),n=t.getAttribute("title"),o=t.getAttribute("hreflang");return e.href=i,r&&(e.type=r),n&&(e.title=n),o&&(e.hreflang=o),e},parseAttributesAsString:function(t){for(var e="",i=0,r=t.attributes.length;i<r;i++){var n=t.attributes[i];e+=n.name+'="'+n.value+'"',i<r-1&&(e+=" ")}return e},parseEntry:function(t,r){for(var n={id:"",type:"Feature",bbox:[],geometry:null,properties:{}},o=n.properties,s=0,a=t.childNodes.length;s<a;s++){var l=t.childNodes[s];if(1===l.nodeType)switch(l.localName){case"id":n.id=l.textContent.trim();break;case"title":case"date":case"identifier":case"updated":case"rights":case"published":o[l.localName]=l.textContent.trim();break;case"category":o.categories||(o.categories=[]),o.categories.push({label:l.getAttribute("label"),term:l.getAttribute("term")});break;case"link":i.parseEntryLinks(l,n,r);break;case"polygon":case"point":case"line":n.geometry=e.parseSimple(l);break;case"where":n.geometry=e.parseGml(l);break;case"box":n.bbox=e.parseBox(l)}}return n},parseEntryLinks:function(e,r,n){if(n===t.COLLECTION){r.links||(r.links={});var o=r.links}else r.properties.links||(r.properties.links={}),o=r.properties.links;var s=e.getAttribute("rel")||"alternate";"alternate"===s&&(s="alternates"),o[s]||(o[s]=[]),o[s].push(i.parseLink(e))}};return i}),i("ogc/openSearch/descriptionDocument/OpenSearchParameter",["../OpenSearchUtils"],function(t){"use strict";var e=function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g){this._internalType=t,this.name=e,this.value=i,this.required=r,this.replaceable=n,this.ns=o||"",this.minimum=s,this.maximum=a,this.pattern=l,this.title=h,this.minExclusive=u,this.maxExclusive=c,this.minInclusive=d,this.maxInclusive=p,this.step=f,this.options=g||[]};return e.fromQuery=function(t){var i=t.split("="),r=i[0],n=i[1],o=!0;if("{"===n[0])var s=n.slice(1,n.length-1);else s=n,o=!1;var a=!0;"?"===s[s.length-1]&&(a=!1,s=s.slice(0,s.length-1));var l=s.split(":"),h="";return l&&2===l.length&&(h=l[0],s=l[1]),new e(e.types.TEMPLATE,r,s,a,o,h)},e.fromNode=function(i){var r=i.getAttribute("name"),n=i.getAttribute("value")||"",o=!0;if("{"===n[0])var s=n.slice(1,n.length-1);else s=n,o=!1;var a="",l=s.split(":");l&&2===l.length&&(a=l[0],s=l[1]);var h,u=i.getAttribute("minimum");u?(u=+u,h=u>0):(u=1,h=!1);var c=i.getAttribute("maximum"),d=1;c&&(d="*"===c?c:+c);var p=i.getAttribute("pattern")||"",f=i.getAttribute("title")||"",g=+i.getAttribute("minExclusive")||"",m=+i.getAttribute("maxExclusive")||"",y=+i.getAttribute("minInclusive")||"",E=+i.getAttribute("maxInclusive")||"",v=+i.getAttribute("step")||"",_=t.getXmlElements(i,"Option"),b=[];if(_.length)for(var w=0,S=_.length;w<S;w++)b.push({label:_[w].getAttribute("label")||"",value:_[w].getAttribute("value")});return new e(e.types.NODE,r,s,h,o,a,u,d,p,f,g,m,y,E,v,b)},e.prototype.merge=function(t){var i=t.name,r=t.value,n=t.required,o=t.replaceable,s=t.ns;if(this._internalType===e.types.TEMPLATE&&(i=this.name,r=this.value,n=this.required,o=this.replaceable,s=this.ns),this.options&&t.options)var a=this.options.concat(t.options);else a=this.options||t.options||[];return new e(e.types.MIX,i,r,n,o,s,this.minimum||t.minimum,this.maximum||t.maximum,this.pattern||t.pattern,this.title||t.title,this.minExclusive||t.minExclusive,this.maxExclusive||t.maxExclusive,this.minInclusive||t.minInclusive,this.maxInclusive||t.maxInclusive,this.step||t.step,a)},e.types={TEMPLATE:"TEMPLATE",NODE:"NODE",MIX:"MIX"},e}),i("ogc/openSearch/descriptionDocument/OpenSearchUrl",["../../../util/Logger","../OpenSearchConstants","../OpenSearchNamespaces","./OpenSearchParameter","../OpenSearchUtils"],function(t,e,i,r,n){"use strict";var o=function(){this._type="",this._method="",this._encType="",this._template="",this._parameters=[],this._indexOffset=1,this._pageOffset=1,this._relations=[],this._baseUrl="",this._paramsByName=Object.create(null),this._staticParams=[]};return Object.defineProperties(o.prototype,{type:{get:function(){return this._type}},method:{get:function(){return this._method}},encType:{get:function(){return this._encType}},template:{get:function(){return this._template}},parameters:{get:function(){return this._parameters}},indexOffset:{get:function(){return this._indexOffset}},pageOffset:{get:function(){return this._pageOffset}},relations:{get:function(){return this._relations}},paramsByName:{get:function(){return this._paramsByName}},staticParams:{get:function(){return this._staticParams}}}),o.prototype.parse=function(t){this.parseAttributes(t);var e=this.parseTemplate(this._template);if(!e)return this;var i=this.parseNodeParams(t),r=i.filter(function(t){var i=n.arrayFind(e,function(e){return e.name===t.name});return null==i}),o=e.map(function(t){var e=n.arrayFind(i,function(e){return e.name===t.name});return e?t.merge(e):t}).concat(r);return this._parameters=o.filter(function(t){return t.replaceable}),this._staticParams=o.filter(function(t){return!t.replaceable}),this._parameters.forEach(function(t){this._paramsByName[t.name]=t},this),this},o.prototype.parseAttributes=function(t){this._type=t.getAttribute("type"),this._template=t.getAttribute("template");var r=t.getAttribute("rel");r?this._relations=r.split(" "):this._relations=[e.RESULTS],this._indexOffset=t.getAttribute("indexOffset"),this._indexOffset?this._indexOffset=+this._indexOffset:this._indexOffset=1,this._pageOffset=t.getAttribute("pageOffset"),this._pageOffset?this._pageOffset=+this._pageOffset:this._pageOffset=1,this._method=t.getAttributeNS(i.parameters,"method")||"GET",this._encType=t.getAttributeNS(i.parameters,"enctype")||"application/x-www-form-urlencoded"},o.prototype.parseTemplate=function(t){if(t){var e=[],i=o.createUrlParser();i.href=t;var n=i.search;if(this._baseUrl=i.protocol+"//"+i.host+i.port+i.pathname,this._baseUrl=i.protocol+"//"+i.hostname,i.port&&(this._baseUrl+=":"+i.port),i.pathname&&("/"===i.pathname[0]?this._baseUrl+=i.pathname:this._baseUrl+="/"+i.pathname),!n)return e;"?"===n[0]&&(n=n.slice(1)),n=n.replace(/&(?!amp;)/g,"&amp;");for(var s=n.split("&amp;"),a=0;a<s.length;a++)e.push(r.fromQuery(s[a]));return e}},o.prototype.parseNodeParams=function(t){var e=n.getXmlElements(t,"Parameter");return e.map(function(t){return r.fromNode(t)})},o.prototype.isCompatible=function(e){var i=e.every(function(t){return t.name in this._paramsByName},this);if(!i)return!1;var r=this._parameters.filter(function(t){return t.required&&!e.some(function(e){return e.name===t.name})});return r.length>0&&t.logMessage(t.LEVEL_WARNING,"OpenSearchUrl","isCompatible","Missing required params: ",r.map(function(t){
return t.name+": "+t.value}).join(",")),0===r.length},o.prototype.createRequestUrl=function(t){t=t||[];var e=this._baseUrl,i=this._staticParams.map(function(t){return t.name+"="+t.value}).concat(t.map(function(t){return t.name+"="+this.serializeParam(t.value)},this)).join("&");return i.length&&(e+="?"+i),e},o.prototype.createRequestBody=function(t){var e=new FormData,i=this.createQueryParts(t);return i.forEach(function(t){e.append(t.name,t.value)}),e},o.prototype.createQueryParts=function(t){return t=t||[],this._staticParams.map(function(t){return{name:t.name,value:this.serializeParam(t.value)}},this).concat(t.map(function(t){return{name:t.name,value:this.serializeParam(t.value)}},this))},o.prototype.serializeParam=function(t){return"string"==typeof t?encodeURIComponent(t):"number"==typeof t?t.toString():t instanceof Date?t.toISOString():t&&"object"==typeof t&&null!=t.minLongitude&&null!=t.minLatitude&&null!=t.maxLongitude&&null!=t.maxLatitude?t.minLongitude+","+t.minLatitude+","+t.maxLongitude+","+t.maxLatitude:encodeURIComponent(String(t))},o.createUrlParser=function(){return o.urlParser||(o.urlParser=document.createElement("a")),o.urlParser},o}),i("ogc/openSearch/descriptionDocument/OpenSearchDescriptionDocument",["../../../error/ArgumentError","../../../util/Logger","../OpenSearchNamespaces","./OpenSearchUrl","../OpenSearchUtils"],function(t,e,i,r,n){"use strict";var o=function(o){if(!o)throw new t(e.logMessage(e.LEVEL_SEVERE,"OpenSearchDescriptionDocument","constructor","missingDomElement"));var s=i.openSearch;this._namespaces=n.getNodeAttributes(o,{}),this._shortName=n.getChildTextContent(o,"ShortName",s),this._description=n.getChildTextContent(o,"Description",s),this._urls=n.getXmlElements(o,"Url",s).map(function(t){return(new r).parse(t)}),this._contact=n.getChildTextContent(o,"Contact",s),this._tags=n.getChildTextContent(o,"Tags",s),this._longName=n.getChildTextContent(o,"LongName",s),this._images=n.getXmlElements(o,"Image",s).map(this.parseImage),this._queries=n.getXmlElements(o,"Query",s).map(this.parseQuery),this._developer=n.getChildTextContent(o,"Developer",s),this._attribution=n.getChildTextContent(o,"Attribution",s),this._syndicationRight=n.getChildTextContent(o,"SyndicationRight",s),this._adultContent=n.getChildTextContent(o,"AdultContent",s),"false"===this._adultContent?this._adultContent=!1:"true"===this._adultContent&&(this._adultContent=!0),this._languages=n.getXmlElements(o,"Language",s).map(n.getTextContent),this._inputEncodings=n.getXmlElements(o,"InputEncoding",s).map(n.getTextContent),this._outputEncodings=n.getXmlElements(o,"OutputEncoding",s).map(n.getTextContent)};return Object.defineProperties(o.prototype,{shortName:{get:function(){return this._shortName}},description:{get:function(){return this._description}},urls:{get:function(){return this._urls}},contact:{get:function(){return this._contact}},tags:{get:function(){return this._tags}},longName:{get:function(){return this._longName}},images:{get:function(){return this._images}},queries:{get:function(){return this._queries}},developer:{get:function(){return this._developer}},attribution:{get:function(){return this._attribution}},syndicationRight:{get:function(){return this._syndicationRight}},adultContent:{get:function(){return this._adultContent}},languages:{get:function(){return this._languages}},inputEncodings:{get:function(){return this._inputEncodings}},outputEncodings:{get:function(){return this._outputEncodings}}}),o.prototype.parseImage=function(t){var e={};return n.getNodeAttributes(t,e),e.src=t.textContent,e.height&&(e.height=Number(e.height)),e.width&&(e.width=Number(e.width)),e},o.prototype.parseQuery=function(t){var e={};return n.getNodeAttributes(t,e),e},o.prototype.findFirstSearchUrl=function(t){return this.findCompatibleUrls(t.searchParams,t.requestOptions,t.supportedFormats)[0]||null},o.prototype.hasExtension=function(t){var e=this._namespaces,i=!1;return Object.keys(e).forEach(function(r){e[r]===t&&(i=!0)}),i},o.prototype.findCompatibleUrls=function(t,e,i){var r=this.urls.filter(function(t){return i.indexOf(t.type)!==-1});return r=r.filter(function(t){return t.relations.indexOf(e.relation)!==-1}),e.type&&(r=r.filter(function(t){return t.type===e.type})),e.method&&(r=r.filter(function(t){return t.method===e.method})),t&&(r=r.filter(function(e){return e.isCompatible(t)})),r},o}),i("ogc/openSearch/responseFormats/OpenSearchParserRegistry",["../../../error/ArgumentError","../../../util/Logger","../OpenSearchConstants"],function(t,e,i){"use strict";var r=function(){this._entries=Object.create(null)};return r.prototype.registerParser=function(i,r,n){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"OpenSearchParserRegistry","registerParser","The specified type is missing."));if("string"!=typeof i)throw new t(e.logMessage(e.LEVEL_SEVERE,"OpenSearchParserRegistry","registerParser","The specified type is not a string."));if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"OpenSearchParserRegistry","registerParser","The specified rel is missing."));if("string"!=typeof r)throw new t(e.logMessage(e.LEVEL_SEVERE,"OpenSearchParserRegistry","registerParser","The specified rel is not a string"));if(!n)throw new t(e.logMessage(e.LEVEL_SEVERE,"OpenSearchParserRegistry","registerParser","The specified parser is missing."));if("object"!=typeof n)throw new t(e.logMessage(e.LEVEL_SEVERE,"OpenSearchParserRegistry","registerParser","The specified parser is not an object."));if("function"!=typeof n.parse)throw new t(e.logMessage(e.LEVEL_SEVERE,"OpenSearchParserRegistry","registerParser","The specified parser does not have a parse method."));this._entries[i]||(this._entries[i]=Object.create(null)),this._entries[i][r]=n},r.prototype.getParser=function(t,e){if(t&&"string"==typeof t&&"string"==typeof e&&(e=e||i.RESULTS,this._entries[t]))return this._entries[t][e]},r.prototype.getFormats=function(){return Object.keys(this._entries)},r.prototype.removeParser=function(t,e){this._entries[t]&&(e||delete this._entries[t],delete this._entries[t][e])},r}),i("ogc/openSearch/OpenSearchRequest",["./OpenSearchConstants"],function(t){var e=function(t){var i=e.defaultOptions;t=t||i,this.url=t.url||i.url,this.method=t.method||i.method,this.encType=t.encType||i.encType,this.type=t.type||i.type,this.relation=t.relation||i.relation,this.withCredentials=t.withCredentials||i.withCredentials,this.timeout=t.timeout||i.timeout,this.headers=t.headers||{},this.body=t.body||i.body,this.responseType=t.responseType||i.responseType,this.user=t.user||i.user,this.password=t.password||i.password};return e.prototype.addHeader=function(t,e){var i=this.getHeader(t);i?this.headers[t]=i+","+e:this.headers[t]=e},e.prototype.getHeader=function(t){return this.headers[t]},e.defaultOptions={url:"",method:"",encType:"application/x-www-form-urlencoded",type:"",relation:t.RESULTS,withCredentials:!1,timeout:0,headers:null,body:null,responseType:"text",user:null,password:null},e}),i("ogc/openSearch/OpenSearchService",["../../error/ArgumentError","../../util/Logger","./responseFormats/atomParser/OpenSearchAtomParser","./OpenSearchConstants","./descriptionDocument/OpenSearchDescriptionDocument","./responseFormats/OpenSearchParserRegistry","./OpenSearchRequest","./OpenSearchUtils","../../util/Promise"],function(t,e,i,r,n,o,s,a,l){"use strict";var h=function(){this._url="",this._descriptionDocument=null,this._rawDescriptionDocument=null,this._parserRegistry=new o,this.registerDefaultParsers()};return Object.defineProperties(h.prototype,{url:{get:function(){return this._url}},descriptionDocument:{get:function(){return this._descriptionDocument}},rawDescriptionDocument:{get:function(){return this._rawDescriptionDocument}},parserRegistry:{get:function(){return this._parserRegistry},set:function(t){this._parserRegistry=t}}}),h.create=function(t){var e=new h,i=new s(t);return i.method=i.method||"GET",i.url?(this._url=i.url,a.fetch(i).then(function(t){var i=a.parseXml(t);return e._rawDescriptionDocument=i,e._descriptionDocument=new n(i),e})):l.reject(new Error("OpenSearchService discover - no url provided"))},h.prototype.search=function(t,e){if(!this._descriptionDocument)return l.reject(new Error("OpenSearchService search - no descriptionDocument, create the service via create first"));var i=this,r=new s(e),n=this.getSupportedFormats(),o=this._descriptionDocument.findFirstSearchUrl({searchParams:t,requestOptions:r,supportedFormats:n});if(!o)return l.reject(new Error("OpenSearchService - no suitable Url found"));if(r.method=o.method,r.encType=o.encType,"GET"===o.method)r.url=o.createRequestUrl(t);else{if("application/x-www-form-urlencoded"!==o.encType&&"multipart/form-data"!==o.encType)return l.reject(new Error("OpenSearchService search - unsupported encoding"));r.url=o._baseUrl,r.body=o.createRequestBody(t),r.addHeader("Content-Type",o.encType)}return a.fetch(r).then(function(t){var e=i.getParser(o.type,r.relation);if(!e)throw new Error("OpenSearchService search - no suitable response parser found");return e.parse(t,r.relation)})},h.prototype.findUrl=function(t,e){return a.arrayFind(this._descriptionDocument.urls,t,e)},h.prototype.registerParser=function(t,e,i){this.parserRegistry.registerParser(t,e,i)},h.prototype.getSupportedFormats=function(){return this.parserRegistry.getFormats()},h.prototype.getParser=function(t,e){return this.parserRegistry.getParser(t,e)},h.prototype.removeParser=function(t,e){this.parserRegistry.removeParser(t,e)},h.prototype.registerDefaultParsers=function(){this.registerParser("application/atom+xml",r.RESULTS,i),this.registerParser("application/atom+xml",r.COLLECTION,i),this.registerParser("application/vnd.geo+json",r.RESULTS,window.JSON),this.registerParser("application/vnd.geo+json",r.COLLECTION,window.JSON),this.registerParser("application/geo+json",r.RESULTS,window.JSON),this.registerParser("application/geo+json",r.COLLECTION,window.JSON),this.registerParser("application/json",r.RESULTS,window.JSON),this.registerParser("application/json",r.COLLECTION,window.JSON)},h}),i("ogc/ows/OwsLanguageString",["../../error/ArgumentError","../../util/Logger"],function(t,e){"use strict";var i=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"LanguageString","constructor","missingDomElement"));this.value=i.textContent,this.lang;var r=i.getAttribute("lang");r&&(this.lang=r)};return i}),i("ogc/ows/OwsDescription",["../../error/ArgumentError","../../util/Logger","../../ogc/ows/OwsLanguageString"],function(t,e,i){"use strict";var r=function(r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsDescription","assembleDescriptions","missingDomElement"));for(var n=r.children||r.childNodes,o=0;o<n.length;o++){var s=n[o];if("Title"===s.localName)this.titles=this.titles||[],this.titles.push(new i(s));else if("Abstract"===s.localName)this.abstracts=this.abstracts||[],this.abstracts.push(new i(s));else if("Keywords"===s.localName){this.keywords=this.keywords||[];for(var a=s.children||s.childNodes,l=0;l<a.length;l++){var h=a[l];"Keyword"===h.localName&&this.keywords.push(new i(h))}}}};return r}),i("ogc/ows/OwsConstraint",["../../error/ArgumentError","../../util/Logger"],function(t,e){"use strict";var i=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsConstraint","constructor","missingDomElement"));this.name=i.getAttribute("name");for(var r=i.children||i.childNodes,n=0;n<r.length;n++){var o=r[n];if("AllowedValues"===o.localName){this.allowedValues=this.allowedValues||[];for(var s=o.children||o.childNodes,a=0;a<s.length;a++)"Value"===s[a].localName&&this.allowedValues.push(s[a].textContent)}else"AnyValue"===o.localName?this.anyValue=!0:"NoValues"===o.localName&&(this.noValues=!0)}};return i}),i("ogc/ows/OwsOperationsMetadata",["../../error/ArgumentError","../../util/Logger","../../ogc/ows/OwsConstraint"],function(t,e,i){"use strict";var r=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsOperationsMetadata","constructor","missingDomElement"));for(var n=i.children||i.childNodes,o=0;o<n.length;o++){var s=n[o];"Operation"===s.localName&&(this.operation=this.operation||[],this.operation.push(r.assembleOperation(s)))}};return r.prototype.getGetCapabilities=function(){return this.getOperationMetadataByName("GetCapabilities")},r.prototype.getGetTile=function(){return this.getOperationMetadataByName("GetTile")},r.prototype.getOperationMetadataByName=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsOperationsMetadata","getOperationsMetadataByName","missingName"));for(var r=0;r<this.operation.length;r++)if(this.operation[r].name===i)return this.operation[r];return null},r.assembleOperation=function(t){var e={};e.name=t.getAttribute("name");for(var i=t.children||t.childNodes,n=0;n<i.length;n++){var o=i[n];"DCP"===o.localName&&(e.dcp=e.dcp||[],e.dcp.push(r.assembleDcp(o)))}return e},r.assembleDcp=function(t){for(var e={},i=t.children||t.childNodes,n=0;n<i.length;n++){var o=i[n];if("HTTP"===o.localName)for(var s=o.children||o.childNodes,a=0;a<s.length;a++){var l=s[a];"Get"===l.localName?(e.getMethods=e.getMethods||[],e.getMethods.push(r.assembleMethod(l))):"Post"===l.localName&&(e.postMethods=e.postMethods||[],e.postMethods.push(r.assembleMethod(l)))}}return e},r.assembleMethod=function(t){var e={};e.url=t.getAttribute("xlink:href");for(var r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];"Constraint"===o.localName&&(e.constraint=e.constraint||[],e.constraint.push(new i(o)))}return e},r}),i("ogc/ows/OwsServiceIdentification",["../../error/ArgumentError","../../util/Logger","../../ogc/ows/OwsDescription"],function(t,e,i){"use strict";var r=function(r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsServiceIdentification","constructor","missingDomElement"));i.call(this,r);for(var n=r.children||r.childNodes,o=0;o<n.length;o++){var s=n[o];"ServiceType"===s.localName?this.serviceType=s.textContent:"ServiceTypeVersion"===s.localName?(this.serviceTypeVersions=this.serviceTypeVersions||[],this.serviceTypeVersions.push(s.textContent)):"Profile"===s.localName?(this.profile=this.profile||[],this.profile.push(s.textContent)):"Fees"===s.localName?this.fees=s.textContent:"AccessConstraints"===s.localName&&(this.accessConstraints=this.accessConstraints||[],this.accessConstraints.push(s.textContent))}};return r.prototype=Object.create(i.prototype),r}),i("ogc/ows/OwsServiceProvider",["../../error/ArgumentError","../../util/Logger"],function(t,e){"use strict";var i=function(r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsServiceProvider","constructor","missingDomElement"));for(var n=r.children||r.childNodes,o=0;o<n.length;o++){var s=n[o];"ProviderName"===s.localName?this.providerName=s.textContent:"ProviderSite"===s.localName?this.providerSiteUrl=s.getAttribute("xlink:href"):"ServiceContact"===s.localName&&(this.serviceContact=i.assembleServiceContact(s))}};return i.assembleServiceContact=function(r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsServiceProvider","assembleServiceContact","missingDomElement"));for(var n={},o=r.children||r.childNodes,s=0;s<o.length;s++){var a=o[s];"IndividualName"===a.localName?n.individualName=a.textContent:"PositionName"===a.localName?n.positionName=a.textContent:"ContactInfo"===a.localName&&(n.contactInfo=i.assembleContacts(a))}return n},i.assembleContacts=function(r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsServiceProvider","assembleContacts","missingDomElement"));for(var n={},o=r.children||r.childNodes,s=0;s<o.length;s++){var a=o[s];"HoursOfService"===a.localName?n.hoursOfService=a.textContent:"ContactInstructions"===a.localName?n.contactInstructions=a.textContent:"Phone"===a.localName?n.phone=i.assemblePhone(a):"Address"===a.localName&&(n.address=i.assembleAddress(a))}return n},i.assemblePhone=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsServiceProvider","assemblePhone","missingDomElement"));for(var r={},n=i.children||i.childNodes,o=0;o<n.length;o++){var s=n[o];"Voice"===s.localName?r.voice=s.textContent:"Facsimile"===s.localName&&(r.facsimile=s.textContent)}return r},i.assembleAddress=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsServiceProvider","assembleAddress","missingDomElement"));for(var r={},n=i.children||i.childNodes,o=0;o<n.length;o++){var s=n[o];"DeliveryPoint"===s.localName?(r.deliveryPoints=r.deliveryPoints||[],r.deliveryPoints.push(s.textContent)):"City"===s.localName?r.city=s.textContent:"AdministrativeArea"===s.localName?r.administrativeArea=s.textContent:"PostalCode"===s.localName?(r.postalCodes=r.postalCodes||[],r.postalCodes.push(s.textContent)):"Country"===s.localName?(r.countries=r.countries||[],r.countries.push(s.textContent)):"ElectronicMailAddress"===s.localName&&(r.electronicMailAddresses=r.electronicMailAddresses||[],r.electronicMailAddresses.push(s.textContent))}return r},i}),i("ogc/wms/WmsLayerCapabilities",["../../error/ArgumentError","../../util/Logger"],function(t,e){"use strict";var i=function(i,r){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsLayerCapabilities","constructor","Layer element is null or undefined."));this.parent=r,this.layers,this.name,this.title,this.abstract,this.keywordList,this.identifiers,this.metadataUrls,this.dataUrls,this.featureListUrls,this.assembleLayer(i)};return Object.defineProperties(i.prototype,{capability:{get:function(){for(var t=this;t&&t instanceof i;)t=t.parent;return t}},queryable:{get:function(){return i.replace(this,"_queryable")}},cascaded:{get:function(){return i.replace(this,"_cascaded")}},opaque:{get:function(){return i.replace(this,"_opaque")}},noSubsets:{get:function(){return i.replace(this,"_noSubsets")}},fixedWidth:{get:function(){return i.replace(this,"_fixedWidth")}},fixedHeight:{get:function(){return i.replace(this,"_fixedHeight")}},styles:{get:function(){return i.accumulate(this,"_styles",[])}},crses:{get:function(){return i.accumulate(this,"_crses",[])}},srses:{get:function(){return i.accumulate(this,"_srses",[])}},geographicBoundingBox:{get:function(){return i.replace(this,"_geographicBoundingBox")}},latLonBoundingBox:{get:function(){return i.replace(this,"_latLonBoundingBox")}},boundingBoxes:{get:function(){return i.replace(this,"_boundingBoxes")}},dimensions:{get:function(){for(var t=[],e=this;e&&e instanceof i;)e._dimensions&&e._dimensions.length>0&&e._dimensions.forEach(function(e){var i=e.name,r=!0;t.forEach(function(t){t.name===i&&(r=!1)}),r&&t.push(e)}),e=e.parent;return t.length>0?t:void 0}},extents:{get:function(){for(var t=[],e=this;e&&e instanceof i;)e._extents&&e._extents.length>0&&e._extents.forEach(function(e){var i=e.name,r=!0;t.forEach(function(t){t.name===i&&(r=!1)}),r&&t.push(e)}),e=e.parent;return t.length>0?t:void 0}},attribution:{get:function(){return i.replace(this,"_attribution")}},authorityUrls:{get:function(){return i.accumulate(this,"_authorityUrls",[])}},minScaleDenominator:{get:function(){return i.replace(this,"_minScaleDenominator")}},maxScaleDenominator:{get:function(){return i.replace(this,"_maxScaleDenominator")}},scaleHint:{get:function(){return i.replace(this,"_scaleHint")}}}),i.prototype.style=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsLayerCapabilities","style","Style name is null or undefined."));var r=this.styles;if(!r)return null;for(var n,o=0,s=r.length;o<s;o++)if(n=r[o],n.name===i)return n},i.accumulate=function(t,e,r){for(;t&&t instanceof i;){var n=t[e];if(n)for(var o=0;o<n.length;o++)r.push(n[o]);t=t.parent}return r.length>0?r:null},i.replace=function(t,e){for(;t&&t instanceof i;){var r=t[e];if(r)return r;t=t.parent}},i.prototype.assembleLayer=function(t){var e,r;e=t.getAttribute("queryable"),e&&(this._queryable="1"===e||"true"===e),e=t.getAttribute("opaque"),e&&(this._opaque="1"===e||"true"===e),e=t.getAttribute("noSubsets"),e&&(this._noSubsets="1"===e||"true"===e),e=t.getAttribute("cascaded"),e&&(this._cascaded=parseInt("10")),e=t.getAttribute("fixedWidth"),e&&(this._fixedWidth=parseInt("10")),e=t.getAttribute("fixedHeight"),e&&(this._fixedHeight=parseInt("10"));var n=t.children||t.childNodes;for(r=0;r<n.length;r++){var o=n[r];if("Layer"===o.localName)this.layers||(this.layers=[]),this.layers.push(new i(o,this));else if("Name"===o.localName)this.name=o.textContent;else if("Title"===o.localName)this.title=o.textContent;else if("Abstract"===o.localName)this.abstract=o.textContent;else if("KeywordList"===o.localName){this.keywordList=this.keywordList||[];for(var s=o.children||o.childNodes,a=0;a<s.length;a++){var l=s[a];"Keyword"===l.localName&&this.keywordList.push(l.textContent)}}else"Style"===o.localName?(this._styles||(this._styles=[]),this._styles.push(i.assembleStyle(o))):"CRS"===o.localName?(this._crses||(this._crses=[]),this._crses.push(o.textContent)):"SRS"===o.localName?(this._srses||(this._srses=[]),this._srses.push(o.textContent)):"EX_GeographicBoundingBox"===o.localName?this._geographicBoundingBox=i.assembleGeographicBoundingBox(o):"LatLonBoundingBox"===o.localName?this._geographicBoundingBox=i.assembleLatLonBoundingBox(o):"BoundingBox"===o.localName?(this._boundingBoxes||(this._boundingBoxes=[]),this._boundingBoxes.push(i.assembleBoundingBox(o))):"Dimension"===o.localName?(this._dimensions||(this._dimensions=[]),this._dimensions.push(i.assembleDimension(o))):"Extent"===o.localName?(this._extents||(this._extents=[]),this._extents.push(i.assembleDimension(o))):"Attribution"===o.localName?this._attribution=i.assembleAttribution(o):"AuthorityURL"===o.localName?(this._authorityUrls||(this._authorityUrls=[]),this._authorityUrls.push(i.assembleAuthorityUrl(o))):"Identifier"===o.localName?(this.identifiers||(this.identifiers=[]),this.identifiers.push(i.assembleIdentifier(o))):"MetadataURL"===o.localName?(this.metadataUrls||(this.metadataUrls=[]),this.metadataUrls.push(i.assembleMetadataUrl(o))):"DataURL"===o.localName?(this.dataUrls||(this.dataUrls=[]),this.dataUrls.push(i.assembleUrl(o))):"FeatureListURL"===o.localName?(this.featureListUrls||(this.featureListUrls=[]),this.featureListUrls.push(i.assembleUrl(o))):"MinScaleDenominator"===o.localName?this._minScaleDenominator=parseFloat(o.textContent):"MaxScaleDenominator"===o.localName?this._maxScaleDenominator=parseFloat(o.textContent):"ScaleHint"===o.localName&&(this._scaleHint={},this._scaleHint.min=i.getFloatAttribute(o,"min"),this._scaleHint.max=i.getFloatAttribute(o,"max"))}},i.assembleStyle=function(t){for(var e={},r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];"Name"===o.localName?e.name=o.textContent:"Title"===o.localName?e.title=o.textContent:"Abstract"===o.localName?e.abstract=o.textContent:"LegendURL"===o.localName?(e.legendUrls||(e.legendUrls=[]),e.legendUrls.push(i.assembleLegendUrl(o))):"StyleSheetURL"===o.localName?e.styleSheetUrl=i.assembleUrl(o):"StyleURL"===o.localName&&(e.styleUrl=i.assembleUrl(o))}return e},i.assembleGeographicBoundingBox=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"westBoundLongitude"===n.localName?e.westBoundLongitude=parseFloat(n.textContent):"eastBoundLongitude"===n.localName?e.eastBoundLongitude=parseFloat(n.textContent):"southBoundLatitude"===n.localName?e.southBoundLatitude=parseFloat(n.textContent):"northBoundLatitude"===n.localName&&(e.northBoundLatitude=parseFloat(n.textContent))}return e},i.assembleLatLonBoundingBox=function(t){var e={};return e.minx=i.getFloatAttribute(t,"minx"),e.miny=i.getFloatAttribute(t,"miny"),e.maxx=i.getFloatAttribute(t,"maxx"),e.maxy=i.getFloatAttribute(t,"maxy"),e},i.assembleBoundingBox=function(t){var e={};return e.crs=t.getAttribute("CRS"),e.minx=i.getFloatAttribute(t,"minx"),e.miny=i.getFloatAttribute(t,"miny"),e.maxx=i.getFloatAttribute(t,"maxx"),e.maxy=i.getFloatAttribute(t,"maxy"),e.resx=i.getFloatAttribute(t,"resx"),e.resy=i.getFloatAttribute(t,"resy"),e},i.assembleDimension=function(t){var e={};return e.name=t.getAttribute("name"),e.units=t.getAttribute("units"),e.unitSymbol=t.getAttribute("unitSymbol"),e.default=t.getAttribute("default"),e.multipleValues=t.getAttribute("multipleValues"),e.multipleValues&&(e.multipleValues="true"===e.multipleValues||"1"===e.multipleValues),e.nearestValue=t.getAttribute("nearestValue"),e.nearestValue&&(e.nearestValue="true"===e.nearestValue||"1"===e.nearestValue),e.current=t.getAttribute("current"),e.current&&(e.current="true"===e.current||"1"===e.current),e.content=t.textContent,e},i.assembleAttribution=function(t){for(var e={},r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];"Title"===o.localName?e.title=o.textContent:"OnlineResource"===o.localName?e.url=o.getAttribute("xlink:href"):"LogoUrul"===o.localName&&(e.logoUrl=i.assembleLogoUrl(o))}return e},i.assembleAuthorityUrl=function(t){var e={};e.name=t.getAttribute("name");for(var i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"OnlineResource"===n.localName&&(e.url=n.getAttribute("xlink:href"))}return e},i.assembleIdentifier=function(t){var e={};return e.authority=t.getAttribute("authority"),e.content=t.textContent,e},i.assembleMetadataUrl=function(t){var e={};e.type=t.getAttribute("type");for(var i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Format"===n.localName?e.format=n.textContent:"OnlineResource"===n.localName&&(e.url=n.getAttribute("xlink:href"))}return e},i.assembleLegendUrl=function(t){var e={};e.width=i.getIntegerAttribute(t,"width"),e.height=i.getIntegerAttribute(t,"height");for(var r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];"Format"===o.localName?e.format=o.textContent:"OnlineResource"===o.localName&&(e.url=o.getAttribute("xlink:href"))}return e},i.assembleLogoUrl=function(t){var e={};e.width=i.getIntegerAttribute(t,"width"),e.height=i.getIntegerAttribute(t,"height");for(var r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];"Format"===o.localName?e.format=o.textContent:"OnlineResource"===o.localName&&(e.url=o.getAttribute("xlink:href"))}return e},i.assembleUrl=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Format"===n.localName?e.format=n.textContent:"OnlineResource"===n.localName&&(e.url=n.getAttribute("xlink:href"))}return e},i.getIntegerAttribute=function(t,e){var i=t.getAttribute(e);return i=i?parseInt(i):void 0},i.getFloatAttribute=function(t,e){var i=t.getAttribute(e);return i=i?parseFloat(i):void 0},i}),i("ogc/wms/WmsCapabilities",["../../error/ArgumentError","../../util/Logger","../../ogc/wms/WmsLayerCapabilities"],function(t,e,i){"use strict";var r=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsCapabilities","constructor","No XML DOM specified."));this.assembleDocument(i)};return r.prototype.getNamedLayers=function(){return this.accumulateNamedLayers(this.capability.layers)},r.prototype.accumulateNamedLayers=function(t,e){var i=e||[];if(!t)return i;for(var r=0,n=t.length;r<n;r++){var o=t[r];o.name&&i.push(o),o.layers&&this.accumulateNamedLayers(o.layers,i)}return i},r.prototype.getNamedLayer=function(i){if(!i||0===i.length)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsCapabilities","getNamedLayer","No WMS layer name provided."));for(var r=this.getNamedLayers(),n=0,o=r.length;n<o;n++)if(i===r[n].name)return r[n];return null},r.prototype.assembleDocument=function(t){var e=t.documentElement;this.version=e.getAttribute("version"),this.updateSequence=e.getAttribute("updateSequence");for(var i=e.children||e.childNodes,r=0;r<i.length;r++){var n=i[r];"Service"===n.localName?this.service=this.assembleService(n):"Capability"===n.localName&&(this.capability=this.assembleCapability(n))}},r.prototype.assembleService=function(t){for(var e={capsDoc:this},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Name"===n.localName?e.name=n.textContent:"Title"===n.localName?e.title=n.textContent:"Abstract"===n.localName?e.abstract=n.textContent:"KeywordList"===n.localName?e.keywordList=this.assembleKeywordList(n):"OnlineResource"===n.localName?e.url=n.getAttribute("xlink:href"):"Fees"===n.localName?e.fees=n.textContent:"AccessConstraints"===n.localName?e.accessConstraints=n.textContent:"LayerLimit"==n.localName?e.layerLimit=parseInt(n.textContent):"MaxWidth"==n.localName?e.maxWidth=parseInt(n.textContent):"MaxHeight"==n.localName?e.maxHeight=parseInt(n.textContent):"ContactInformation"===n.localName&&(e.contactInformation=this.assembleContactInformation(n))}return e},r.prototype.assembleKeywordList=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Keyword"===n.localName&&e.push(n.textContent)}return e},r.prototype.assembleContactInformation=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"ContactPersonPrimary"===n.localName?e.contactPersonPrimary=this.assembleContactPersonPrimary(n):"ContactPosition"===n.localName?e.contactPosition=n.textContent:"ContactVoiceTelephone"===n.localName?e.contactVoiceTelephone=n.textContent:"ContactFacsimileTelephone"===n.localName?e.contactFacsimileTelephone=n.textContent:"ContactElectronicMailAddress"===n.localName?e.contactElectronicMailAddress=n.textContent:"ContactAddress"===n.localName&&(e.contactAddress=this.assembleContactAddress(n))}return e},r.prototype.assembleContactPersonPrimary=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"ContactPerson"===n.localName?e.contactPerson=n.textContent:"ContactOrganization"===n.localName&&(e.contactOrganization=n.textContent)}return e},r.prototype.assembleContactAddress=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"AddressType"===n.localName?e.addressType=n.textContent:"Address"===n.localName?e.address=n.textContent:"City"===n.localName?e.city=n.textContent:"StateOrProvince"===n.localName?e.stateOrProvince=n.textContent:"PostCode"===n.localName?e.postCode=n.textContent:"Country"===n.localName&&(e.country=n.textContent)}return e},r.prototype.assembleCapability=function(t){for(var e={capsDoc:this},r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];"Request"===o.localName?e.request=this.assembleRequests(o):"Exception"===o.localName?e.exception=this.assembleException(o):"Layer"===o.localName&&(e.layers=e.layers||[],e.layers.push(new i(o,e)))}return e},r.prototype.assembleRequests=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"GetCapabilities"===n.localName?e.getCapabilities=this.assembleRequest(n):"GetMap"===n.localName?e.getMap=this.assembleRequest(n):"GetFeatureInfo"===n.localName&&(e.getFeatureInfo=this.assembleRequest(n))}return e},r.prototype.assembleRequest=function(t){for(var e={name:t.localName},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];if("Format"===n.localName)e.formats=e.formats||[],e.formats.push(n.textContent);else if("DCPType"===n.localName)for(var o=n.children||n.childNodes,s=0;s<o.length;s++){var a=o[s];if("HTTP"===a.localName)for(var l=a.children||a.childNodes,h=0;h<l.length;h++){var u=l[h];if("Get"===u.localName)for(var c=u.children||u.childNodes,d=0;d<c.length;d++){var p=c[d];"OnlineResource"===p.localName&&(e.getUrl=p.getAttribute("xlink:href"))}}}}return e},r.prototype.assembleException=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Format"===n.localName&&(e.formats=e.formats||[],e.formats.push(n.textContent))}return e},r}),i("ogc/wmts/WmtsLayerCapabilities",["../../error/ArgumentError","../../geom/Sector","../../ogc/ows/OwsDescription","../../util/Logger"],function(t,e,i,r){"use strict";var n=function(e,n){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"WmtsLayerCapabilities","constructor","missingDomElement"));i.call(this,e),this.capabilities=n,this.identifier,this.title,this.abstract,this.keywords,this.wgs84BoundingBox,this.boundingBox,this.styles,this.formats,this.infoFormat,this.dimension,this.metadata,this.tileMatrixSetLink,this.resourceUrl,this.assembleLayer(e)};return n.prototype=Object.create(i.prototype),n.prototype.getLayerSupportedTileMatrixSets=function(){for(var t=[],e=0,i=this.tileMatrixSetLink.length;e<i;e++)for(var r=this.tileMatrixSetLink[e].tileMatrixSet,n=0,o=this.capabilities.contents.tileMatrixSet.length;n<o;n++){var s=this.capabilities.contents.tileMatrixSet[n].identifier;s===r&&t.push(this.capabilities.contents.tileMatrixSet[n]);
}return t},n.prototype.assembleLayer=function(t){for(var e=t.children||t.childNodes,i=0;i<e.length;i++){var r=e[i];"Identifier"===r.localName?this.identifier=r.textContent:"WGS84BoundingBox"===r.localName?this.wgs84BoundingBox=n.assembleBoundingBox(r):"BoundingBox"===r.localName?(this.boundingBox=this.boundingBox||[],this.boundingBox.push(n.assembleBoundingBox(r))):"Style"===r.localName?(this.style=this.style||[],this.style.push(n.assembleStyle(r))):"Format"===r.localName?(this.format=this.format||[],this.format.push(r.textContent)):"InfoFormat"===r.localName?(this.infoFormat=this.infoFormat||[],this.infoFormat.push(r.textContent)):"Dimension"===r.localName?(this.dimension=this.dimension||[],this.dimension.push(n.assembleDimension(r))):"Metadata"===r.localName?(this.metadata=this.metadata||[],this.metadata.push(n.assembleMetadata(r))):"ResourceURL"===r.localName?(this.resourceUrl=this.resourceUrl||[],this.resourceUrl.push(n.assembleResourceUrl(r))):"TileMatrixSetLink"===r.localName&&(this.tileMatrixSetLink=this.tileMatrixSetLink||[],this.tileMatrixSetLink.push(n.assembleTileMatrixSetLink(r)))}},n.assembleStyle=function(t){var e=new i(t);e.isDefault=t.getAttribute("isDefault");for(var r=t.children||t.childNodes,o=0;o<r.length;o++){var s=r[o];"Identifier"===s.localName?e.identifier=s.textContent:"LegendURL"===s.localName&&(e.legendUrl=e.legendUrl||[],e.legendUrl.push(n.assembleLegendUrl(s)))}return e},n.assembleBoundingBox=function(t){var i={},r=t.getAttribute("crs");r&&(i.crs=r);for(var n=t.children||t.childNodes,o=0;o<n.length;o++){var s=n[o];if("LowerCorner"===s.localName){var a=s.textContent.split(" ");i.lowerCorner=[parseFloat(a[0]),parseFloat(a[1])]}else if("UpperCorner"===s.localName){var l=s.textContent.split(" ");i.upperCorner=[parseFloat(l[0]),parseFloat(l[1])]}}return"WGS84BoundingBox"===t.localName&&(i.getSector=function(){return new e(i.lowerCorner[1],i.upperCorner[1],i.lowerCorner[0],i.upperCorner[0])}),i},n.assembleDimension=function(t){for(var e=new i(t),r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];"Identifier"===o.localName?e.identifier=o.textContent:"UOM"===o.localName?e.uom={name:o.getAttribute("name"),reference:o.getAttribute("reference")}:"UnitSymbol"==o.localName?e.unitSymbol=o.textContent:"Default"===o.localName?e.default=o.textContent:"Current"===o.localName?e.current="true"===o.textContent:"Value"===o.localName&&(e.value=e.value||[],e.value.push(o.textContent))}return e},n.assembleMetadata=function(t){var e={},i=t.getAttribute("xlink:href");i&&(e.url=i);var r=t.getAttribute("about");i&&(e.about=r);var n=t.getAttribute("xlink:type");n&&(e.type=n);var o=t.getAttribute("xlink:role");o&&(e.role=o);var s=t.getAttribute("xlink:title");s&&(e.title=s);for(var a=t.children||t.childNodes,l=0;l<a.length;l++){var h=a[l];"Metadata"===h.localName&&(e.metadata=WmsLayerCapabilities.assembleMetadata(h))}return e},n.assembleResourceUrl=function(t){var e={};return e.format=t.getAttribute("format"),e.resourceType=t.getAttribute("resourceType"),e.template=t.getAttribute("template"),e},n.assembleLegendUrl=function(t){var e={};return e.format=t.getAttribute("format"),e.minScaleDenominator=t.getAttribute("minScaleDenominator"),e.maxScaleDenominator=t.getAttribute("maxScaleDenominator"),e.href=t.getAttribute("xlink:href"),e.width=t.getAttribute("width"),e.height=t.getAttribute("height"),e},n.assembleTileMatrixSetLink=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var o=i[r];"TileMatrixSet"===o.localName?e.tileMatrixSet=o.textContent:"TileMatrixSetLimits"===o.localName&&(e.tileMatrixSetLimits=n.assembleTileMatrixSetLimits(o))}return e},n.assembleTileMatrixSetLimits=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var o=i[r];"TileMatrixLimits"===o.localName&&(e.tileMatrixLimits=e.tileMatrixLimits||[],e.tileMatrixLimits.push(n.assembleTileMatrixLimits(o)))}return e},n.assembleTileMatrixLimits=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"TileMatrix"===n.localName?e.tileMatrix=n.textContent:"MinTileRow"===n.localName?e.minTileRow=parseInt(n.textContent):"MaxTileRow"===n.localName?e.maxTileRow=parseInt(n.textContent):"MinTileCol"===n.localName?e.minTileCol=parseInt(n.textContent):"maxTileCol"===n.localName&&(e.maxTileCol=parseInt(n.textContent))}return e},n}),i("ogc/wmts/WmtsCapabilities",["../../error/ArgumentError","../../util/Logger","../../ogc/ows/OwsDescription","../../ogc/ows/OwsLanguageString","../../ogc/ows/OwsOperationsMetadata","../../ogc/ows/OwsServiceIdentification","../../ogc/ows/OwsServiceProvider","../../ogc/wms/WmsCapabilities","../../ogc/wmts/WmtsLayerCapabilities"],function(t,e,i,r,n,o,s,a,l){"use strict";var h=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmtsCapabilities","constructor","No XML DOM specified."));this.assembleDocument(i)};return h.prototype.getLayers=function(){return this.contents.layer},h.prototype.getLayer=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmtsCapabilities","getLayer","empty identifier"));for(var r=0,n=this.contents.layer.length;r<n;r++){var o=this.contents.layer[r];if(o.identifier===i)return o}return null},h.prototype.assembleDocument=function(t){var e=t.documentElement;this.version=e.getAttribute("version"),this.updateSequence=e.getAttribute("updateSequence");for(var i=e.children||e.childNodes,r=0;r<i.length;r++){var a=i[r];"ServiceIdentification"===a.localName?this.serviceIdentification=new o(a):"ServiceProvider"===a.localName?this.serviceProvider=new s(a):"OperationsMetadata"===a.localName?this.operationsMetadata=new n(a):"Contents"===a.localName?this.contents=this.assembleContents(a):"Themes"===a.localName?this.themes=h.assembleThemes(a):"ServiceMetadataURL"===a.localName&&(this.serviceMetadataUrls=this.serviceMetadataUrls||[],this.serviceMetadataUrls.push(h.assembleServiceMetadataURL(a)))}},h.prototype.assembleContents=function(t){for(var i={},r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];if("Layer"===o.localName){i.layer=i.layer||[];try{i.layer.push(new l(o,this))}catch(t){e.logMessage(e.LEVEL_SEVERE,"WmtsCapabilities","constructor","Exception reading WMTS layer description: "+t.message)}}else if("TileMatrixSet"===o.localName){i.tileMatrixSet=i.tileMatrixSet||[];try{i.tileMatrixSet.push(h.assembleTileMatrixSet(o))}catch(t){e.logMessage(e.LEVEL_SEVERE,"WmtsCapabilities","constructor","Exception reading WMTS tile matrix set description: "+t.message)}}}return i},h.assembleTileMatrixSet=function(t){for(var e=new i(t),r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];"Identifier"===o.localName?e.identifier=o.textContent:"SupportedCRS"===o.localName?e.supportedCRS=o.textContent:"WellKnownScaleSet"===o.localName?e.wellKnownScaleSet=o.textContent:"BoundingBox"===o.localName?e.boundingBox=l.assembleBoundingBox(o):"TileMatrix"===o.localName&&(e.tileMatrix=e.tileMatrix||[],e.tileMatrix.push(h.assembleTileMatrix(o)))}h.sortTileMatrices(e);for(var s=0;s<e.tileMatrix.length;s++)e.tileMatrix[s].levelNumber=s;return e},h.assembleTileMatrix=function(t){for(var e=new i(t),r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];if("Identifier"===o.localName)e.identifier=o.textContent;else if("ScaleDenominator"===o.localName)e.scaleDenominator=parseFloat(o.textContent);else if("TileWidth"===o.localName)e.tileWidth=parseFloat(o.textContent);else if("TileHeight"===o.localName)e.tileHeight=parseFloat(o.textContent);else if("MatrixWidth"===o.localName)e.matrixWidth=parseFloat(o.textContent);else if("MatrixHeight"===o.localName)e.matrixHeight=parseFloat(o.textContent);else if("TopLeftCorner"===o.localName){var s=o.textContent.split(" ");e.topLeftCorner=[parseFloat(s[0]),parseFloat(s[1])]}}return e},h.assembleThemes=function(t){for(var e,i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Theme"===n.localName&&(e=e||[],e.push(h.assembleTheme(n)))}return e},h.assembleTheme=function(t){for(var e=new i(t),r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];"Identifier"===o.localName?e.identifier=o.textContent:"LayerRef"===o.localName?(e.layerRef=e.layerRef||[],e.layerRef.push(o.textContent)):"Theme"===o.localName&&(e.themes=e.themes||[],e.themes.push(h.assembleTheme(o)))}return e},h.assembleServiceMetadataURL=function(t){var e={},i=t.getAttribute("xlink:href");return i&&(e.url=i),e},h.sortTileMatrices=function(t){t.tileMatrix.sort(function(t,e){return e.scaleDenominator-t.scaleDenominator})},h.prototype.getGetTileKvpAddress=function(){for(var t=0;t<this.operationsMetadata.operation.length;t++){var e=this.operationsMetadata.operation[t];if("GetTile"===e.name)return e.dcp[0].getMethods[0].url}return null},h}),i("layer/WmtsLayerTile",["../geom/Angle","../error/ArgumentError","../geom/BoundingBox","../util/Logger","../geom/Vec3","../util/WWUtil"],function(t,e,i,r,n,o){"use strict";var s=function(e,i,r,n,o){this.sector=e,this.tileMatrix=i,this.row=r,this.column=n,this.imagePath=o,this.texelSize=e.deltaLatitude()*t.DEGREES_TO_RADIANS/i.tileHeight,this.tileKey=i.levelNumber.toString()+"."+r.toString()+"."+n.toString(),this.gpuCacheKey=o};return s.prototype.isEqual=function(t){return!!t&&(!!t.tileKey&&this.tileKey==t.tileKey)},s.prototype.distanceTo=function(t){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"Tile","distanceTo","missingVector"));for(var i,n,o,s=t[0],a=t[1],l=t[2],h=this.samplePoints,u=Number.POSITIVE_INFINITY,c=0,d=h.length;c<d;c+=3)i=s-h[c],n=a-h[c+1],o=l-h[c+2],u=Math.min(u,i*i+n*n+o*o);return Math.sqrt(u)},s.prototype.subdivide=function(t,i){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"WmtsLayerTile","subdivide","The specified tile matrix is null or undefined."));if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"WmtsLayerTile","subdivide","The specified tile factory is null or undefined."));for(var n,o,s=[],a=t.matrixHeight/this.tileMatrix.matrixHeight,l=t.matrixWidth/this.tileMatrix.matrixWidth,h=0;h<a;h++)for(var u=0;u<l;u++)n=a*this.row+h,o=l*this.column+u,s.push(i.createTile(t,n,o));return s},s.prototype.subdivideToCache=function(t,i,n){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"Tile","subdivideToCache","The specified tile matrix is null or undefined."));if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"Tile","subdivideToCache","The specified tile factory is null or undefined."));var o=n?n.entryForKey(this.tileKey):null;return o||(o=this.subdivide(t,i),o&&n&&n.putEntry(this.tileKey,o,o.length)),o},s.prototype.mustSubdivide=function(t,e){var i=t.globe.equatorialRadius*this.texelSize,r=this.distanceTo(t.eyePoint),n=t.pixelSizeAtDistance(r);return i>Math.max(e*n,.5)},s.prototype.update=function(t){var e=t.globe.elevationTimestamp(),i=t.verticalExaggeration,r=t.globeStateKey;this.updateTimestamp==e&&this.updateVerticalExaggeration==i&&this.updateGlobeStateKey==r||(this.doUpdate(t),t.frameStatistics.incrementTileUpdateCount(1),this.updateTimestamp=e,this.updateVerticalExaggeration=i,this.updateGlobeStateKey=r)},s.prototype.doUpdate=function(t){var e=t.globe,r=t.verticalExaggeration,s=e.minAndMaxElevationsForSector(this.sector),a=s[0]*r,l=s[1]*r;a===l&&(a=l+10),this.extent||(this.extent=new i),this.extent.setToSector(this.sector,e,a,l),this.samplePoints||(this.sampleElevations=new Float64Array(9),this.samplePoints=new Float64Array(3*this.sampleElevations.length)),o.fillArray(this.sampleElevations,.5*(a+l)),e.computePointsForGrid(this.sector,3,3,this.sampleElevations,n.ZERO,this.samplePoints),this.referencePoint||(this.referencePoint=new n(0,0,0)),e.computePointFromPosition(this.sector.centroidLatitude(),this.sector.centroidLongitude(),0,this.referencePoint)},s.prototype.bind=function(t){var e=t.gpuResourceCache.resourceForKey(this.gpuCacheKey);return!(!e||!e.bind(t))||!!this.fallbackTile&&this.fallbackTile.bind(t)},s.prototype.applyInternalTransform=function(t,e){},s}),i("layer/WmtsLayer",["../util/AbsentResourceList","../error/ArgumentError","../util/Logger","../geom/Matrix","../geom/Sector","../layer/Layer","../cache/MemoryCache","../render/Texture","../util/WmsUrlBuilder","../layer/WmtsLayerTile","../util/WWMath","../util/WWUtil"],function(t,e,i,r,n,o,s,a,l,h,u,c){"use strict";var d=function(a,l){if(!a)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","constructor","No layer configuration specified."));if(o.call(this,"WMTS Layer"),this.layerIdentifier=a.identifier,this.styleIdentifier=a.style,this.timeString=l,this.imageFormat=a.format,this.resourceUrl=a.resourceUrl,this.serviceUrl=a.service,this.tileMatrixSet=a.tileMatrixSet,this.lasTtMVP=r.fromIdentity(),a.wgs84BoundingBox||a.boundingBox){if(a.wgs84BoundingBox)this.sector=a.wgs84BoundingBox.getSector();else if(this.tileMatrixSet.boundingBox&&d.isEpsg4326Crs(this.tileMatrixSet.boundingBox.crs))this.sector=new n(this.tileMatrixSet.boundingBox.lowerCorner[1],this.tileMatrixSet.boundingBox.upperCorner[1],this.tileMatrixSet.boundingBox.lowerCorner[0],this.tileMatrixSet.boundingBox.upperCorner[0]);else if(d.isEpsg4326Crs(this.tileMatrixSet.supportedCRS))throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","constructor","No EPSG:4326 bounding box was specified in the layer or tile matrix set capabilities."))}else{if(!this.tileMatrixSet.boundingBox)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","constructor","No bounding box was specified in the layer or tile matrix set capabilities."));this.sector=new n(a.tileMatrixSet.boundingBox.lowerCorner[1],a.tileMatrixSet.boundingBox.upperCorner[1],a.tileMatrixSet.boundingBox.lowerCorner[0],a.tileMatrixSet.boundingBox.upperCorner[0])}if(!d.isTileSubdivisionCompatible(this.tileMatrixSet))throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","constructor","TileMatrixSet level division not compatible."));var h=this.tileMatrixSet.supportedCRS,u=d.isEpsg3857Crs(h)||d.isEpsg4326Crs(h)||d.isOGCCrs84(h);if(!u)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","constructor","Provided CRS is not compatible."));this.cachePath=(this.resourceUrl||this.serviceUrl)+this.layerIdentifier+this.styleIdentifier+this.tileMatrixSet.identifier,l&&(this.cachePath=this.cachePath+l),this.displayName=a.title,this.currentTiles=[],this.currentTilesInvalid=!0,this.tileCache=new s(1e3,850),this.currentRetrievals=[],this.absentResourceList=new t(3,5e4),this.pickEnabled=!1,this.detailControl=1.75,this.retrievalQueueSize=WorldWind.configuration.layerRetrievalQueueSize};return d.isTileSubdivisionCompatible=function(t){if(!t||!t.tileMatrix||t.tileMatrix.length<1)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","isTileSubdivisionCompatible","Empty tile matrix set"));for(var r,n,o,s=t.tileMatrix[0],a=1,l=t.tileMatrix.length;a<l;a++)if(o=t.tileMatrix[a],r=o.matrixHeight/s.matrixHeight,n=o.matrixWidth/s.matrixWidth,s=o,2!==r||2!==n)return!1;return!0},d.createTileMatrixSet=function(t){if(!t.matrixSet)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","createTileMatrixSet","No matrixSet provided."));if(!t.projection)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","createTileMatrixSet","No projection provided."));if(!t.extent||4!=t.extent.length)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","createTileMatrixSet","No extent provided."));var r={lowerCorner:[t.extent[0],t.extent[1]],upperCorner:[t.extent[2],t.extent[3]]};if(!t.resolutions)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","createTileMatrixSet","No resolutions provided."));if(!t.tileSize)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","createTileMatrixSet","No tile size provided."));if(!t.topLeftCorner||2!=t.topLeftCorner.length)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","createTileMatrixSet","No extent provided."));if(void 0===t.prefix)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","createTileMatrixSet","Prefix not provided."));if(!(d.isEpsg4326Crs(t.projection)||d.isOGCCrs84(t.projection)||d.isEpsg3857Crs(t.projection)))throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","createTileMatrixSet","Projection provided not supported."));for(var n,o=[],s=0;s<t.resolutions.length;s++){d.isEpsg4326Crs(t.projection)||d.isOGCCrs84(t.projection)?n=6378137*t.resolutions[s]*2*Math.PI/360/28e-5:d.isEpsg3857Crs(t.projection)&&(n=t.resolutions[s]/28e-5);var a=t.tileSize*t.resolutions[s],l=t.tileSize*t.resolutions[s],h=Math.ceil((t.extent[2]-t.extent[0]-.01*a)/a),u=Math.ceil((t.extent[3]-t.extent[1]-.01*l)/l),c={identifier:t.prefix?t.matrixSet+":"+s:s,levelNumber:s,matrixHeight:u,matrixWidth:h,tileHeight:t.tileSize,tileWidth:t.tileSize,topLeftCorner:t.topLeftCorner,scaleDenominator:n};o.push(c)}return{identifier:t.matrixSet,supportedCRS:t.projection,boundingBox:r,tileMatrix:o}},d.formLayerConfiguration=function(t,r,n,o){var s={};if(s.identifier=t.identifier,o){for(var a=!1,h=0;h<t.format.length;h++)if(t.format[h]===o){a=!0,s.format=t.format[h];break}a||(i.logMessage(i.LEVEL_WARNING,"WmtsLayer","formLayerConfiguration","The specified image format is not available. Another one will be used."),s.format=null)}if(s.format||(t.format.indexOf("image/png")>=0?s.format="image/png":t.format.indexOf("image/jpeg")>=0?s.format="image/jpeg":t.format.indexOf("image/tiff")>=0?s.format="image/tiff":t.format.indexOf("image/gif")>=0?s.format="image/gif":s.format=t.format[0]),!s.format)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","formLayerConfiguration","Layer does not provide a supported image format."));if(t.resourceUrl&&t.resourceUrl.length>=1){for(var h=0;h<t.resourceUrl.length;h++)if(s.format===t.resourceUrl[h].format){s.resourceUrl=t.resourceUrl[h].template;break}}else s.service=t.capabilities.getGetTileKvpAddress(),s.service&&(s.service=l.fixGetMapString(s.service));if(!s.resourceUrl&&!s.service)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","formLayerConfiguration","No resource URL or KVP GetTile service URL specified in WMTS capabilities."));if(r){for(var u=!1,h=0;h<t.style.length;h++)if(t.style[h].identifier===r){u=!0,s.style=t.style[h].identifier;break}u||(i.logMessage(i.LEVEL_WARNING,"WmtsLayer","formLayerConfiguration","The specified style identifier is not available. The server's default style will be used."),s.style=null)}if(!s.style)for(h=0;h<t.style.length;h++)if(t.style[h].isDefault){s.style=t.style[h].identifier;break}s.style||i.logMessage(i.LEVEL_WARNING,"WmtsLayer","formLayerConfiguration","No default style available. A style will not be specified in tile requests.");var c=t.getLayerSupportedTileMatrixSets();if(n){for(var h=0,p=c.length;h<p;h++)if(c[h].identifier===n&&d.isTileSubdivisionCompatible(c[h])){s.tileMatrixSet=c[h];break}s.tileMatrixSet||(i.logMessage(i.LEVEL_WARNING,"WmtsLayer","formLayerConfiguration","The specified tileMatrixSet is not available. Another one will be used."),s.tileMatrixSet=null)}if(!s.tileMatrixSet){for(var f,g=null,m=null,y=null,h=0,p=c.length;h<p;h++)f=c[h],d.isTileSubdivisionCompatible(f)&&(d.isEpsg4326Crs(f.supportedCRS)?g=g||f:d.isEpsg3857Crs(f.supportedCRS)?m=m||f:d.isOGCCrs84(f.supportedCRS)&&(y=y||f));s.tileMatrixSet=g||m||y}if(!s.tileMatrixSet)throw new e(i.logMessage(i.LEVEL_SEVERE,"WmtsLayer","formLayerConfiguration","No supported Tile Matrix Set could be found."));return s.boundingBox=t.boundingBox,s.wgs84BoundingBox=t.wgs84BoundingBox,t.titles.length>0?s.title=t.titles[0].value:s.title=t.identifier,s},d.prototype=Object.create(o.prototype),d.prototype.doRender=function(t){t.terrain&&(!this.currentTilesInvalid&&t.modelviewProjection.equals(this.lasTtMVP)&&t.globeStateKey===this.lastGlobeStateKey||(this.currentTilesInvalid=!1,this.assembleTiles(t)),this.lasTtMVP.copy(t.modelviewProjection),this.lastGlobeStateKey=t.globeStateKey,this.currentTiles.length>0&&(t.surfaceTileRenderer.renderTiles(t,this.currentTiles,this.opacity),t.frameStatistics.incrementImageTileCount(this.currentTiles.length),this.inCurrentFrame=!0))},d.prototype.isLayerInView=function(t){return t.terrain&&t.terrain.sector&&t.terrain.sector.intersects(this.sector)},d.prototype.isTileVisible=function(t,e){return!(t.globe.projectionLimits&&!e.sector.overlaps(t.globe.projectionLimits))&&e.extent.intersectsFrustum(t.frustumInModelCoordinates)},d.prototype.assembleTiles=function(t){this.currentTiles=[],this.topLevelTiles&&0!==this.topLevelTiles.length||this.createTopLevelTiles(t);for(var e=0,i=this.topLevelTiles.length;e<i;e++){var r=this.topLevelTiles[e];r.update(t),this.currentAncestorTile=null,this.isTileVisible(t,r)&&this.addTileOrDescendants(t,r)}},d.prototype.addTileOrDescendants=function(t,e){if(e.column>=e.tileMatrix.matrixWidth&&(e.column=e.column-e.tileMatrix.matrixWidth),e.column<0&&(e.column=e.column+e.tileMatrix.matrixWidth),this.tileMeetsRenderingCriteria(t,e))return void this.addTile(t,e);var i=null;try{(this.isTileTextureInMemory(t,e)||0===e.tileMatrix.levelNumber)&&(i=this.currentAncestorTile,this.currentAncestorTile=e);for(var r=this.tileMatrixSet.tileMatrix[e.tileMatrix.levelNumber+1],n=e.subdivideToCache(r,this,this.tileCache),o=0,s=n.length;o<s;o++){var a=n[o];a.update(t),this.sector.intersects(a.sector)&&this.isTileVisible(t,a)&&this.addTileOrDescendants(t,a)}}finally{i&&(this.currentAncestorTile=i)}},d.prototype.addTile=function(t,e){e.fallbackTile=null;var i=t.gpuResourceCache.resourceForKey(e.imagePath);return i?(this.currentTiles.push(e),void(this.expiration&&this.isTextureExpired(i)&&this.retrieveTileImage(t,e))):(this.retrieveTileImage(t,e),void(this.currentAncestorTile&&this.isTileTextureInMemory(t,this.currentAncestorTile)&&this.currentTiles.push(this.currentAncestorTile)))},d.prototype.isTextureExpired=function(t){return this.expiration&&t.creationTime.getTime()<=this.expiration.getTime()},d.prototype.isTileTextureInMemory=function(t,e){return t.gpuResourceCache.containsResource(e.imagePath)},d.prototype.tileMeetsRenderingCriteria=function(t,e){var i=this.detailControl;return(e.sector.minLatitude>=75||e.sector.maxLatitude<=-75)&&(i*=1.2),e.tileMatrix.levelNumber===this.tileMatrixSet.tileMatrix.length-1||!e.mustSubdivide(t,i)},d.prototype.retrieveTileImage=function(t,e){if(this.currentRetrievals.indexOf(e.imagePath)<0){if(this.currentRetrievals.length>this.retrievalQueueSize)return;if(this.absentResourceList.isResourceAbsent(e.imagePath))return;var r=this.resourceUrlForTile(e,this.imageFormat),n=new Image,o=e.imagePath,s=t.gpuResourceCache,a=t.currentGlContext.canvas,l=this;if(!r)return void(this.currentTilesInvalid=!0);n.onload=function(){i.log(i.LEVEL_INFO,"Image retrieval succeeded: "+r);var h=l.createTexture(t,e,n);if(l.removeFromCurrentRetrievals(o),h){s.putResource(o,h,h.size),l.currentTilesInvalid=!0,l.absentResourceList.unmarkResourceAbsent(o);var u=document.createEvent("Event");u.initEvent(WorldWind.REDRAW_EVENT_TYPE,!0,!0),a.dispatchEvent(u)}},n.onerror=function(){l.removeFromCurrentRetrievals(o),l.absentResourceList.markResourceAbsent(o),i.log(i.LEVEL_WARNING,"Image retrieval failed: "+r)},this.currentRetrievals.push(o),n.crossOrigin="anonymous",n.src=r}},d.prototype.resourceUrlForTile=function(t,e){var i;return this.resourceUrl?(i=this.resourceUrl.replace("{Style}",this.styleIdentifier).replace("{TileMatrixSet}",this.tileMatrixSet.identifier).replace("{TileMatrix}",t.tileMatrix.identifier).replace("{TileCol}",t.column).replace("{TileRow}",t.row),this.timeString&&(i=i.replace("{Time}",this.timeString))):(i=this.serviceUrl+"service=WMTS&request=GetTile&version=1.0.0",i+="&Layer="+this.layerIdentifier,this.styleIdentifier&&(i+="&Style="+this.styleIdentifier),i+="&Format="+e,this.timeString&&(i+="&Time="+this.timeString),i+="&TileMatrixSet="+this.tileMatrixSet.identifier,i+="&TileMatrix="+t.tileMatrix.identifier,i+="&TileRow="+t.row,i+="&TileCol="+t.column),i},d.prototype.removeFromCurrentRetrievals=function(t){var e=this.currentRetrievals.indexOf(t);e>-1&&this.currentRetrievals.splice(e,1)},d.prototype.createTopLevelTiles=function(t){var e=this.tileMatrixSet.tileMatrix[0];this.topLevelTiles=[];for(var i=0;i<e.matrixHeight;i++)for(var r=0;r<e.matrixWidth;r++)this.topLevelTiles.push(this.createTile(e,i,r))},d.prototype.createTile=function(t,e,i){return d.isEpsg4326Crs(this.tileMatrixSet.supportedCRS)?this.createTile4326(t,e,i):d.isEpsg3857Crs(this.tileMatrixSet.supportedCRS)?this.createTile3857(t,e,i):d.isOGCCrs84(this.tileMatrixSet.supportedCRS)?this.createTileCrs84(t,e,i):void 0},d.prototype.createTileCrs84=function(t,e,i){var r=this.sector.deltaLatitude()/t.matrixHeight,o=this.sector.deltaLongitude()/t.matrixWidth,s=t.topLeftCorner[1]-e*r,a=s-r,l=t.topLeftCorner[0]+o*i,h=l+o,u=new n(a,s,l,h);return this.makeTile(u,t,e,i)},d.prototype.createTile4326=function(t,e,i){var r=this.sector.deltaLatitude()/t.matrixHeight,o=this.sector.deltaLongitude()/t.matrixWidth,s=t.topLeftCorner[0]-e*r,a=s-r,l=t.topLeftCorner[1]+o*i,h=l+o,u=new n(a,s,l,h);return this.makeTile(u,t,e,i)},d.prototype.createTile3857=function(t,e,i){t.mapWidth||this.computeTileMatrixValues3857(t);var r,o,s,a,l,h,c=u.clamp(i*t.tileWidth-.5,0,t.mapWidth),d=u.clamp(e*t.tileHeight-.5,0,t.mapHeight),p=u.clamp(c+t.tileWidth+.5,0,t.mapWidth),f=u.clamp(d+t.tileHeight+.5,0,t.mapHeight);r=c/t.mapWidth,o=f/t.mapHeight,a=t.topLeftCorner[0]+r*t.tileMatrixDeltaX,s=t.topLeftCorner[1]-o*t.tileMatrixDeltaY;var g=u.epsg3857ToEpsg4326(a,s);r=p/t.mapWidth,o=d/t.mapHeight,h=t.topLeftCorner[0]+r*t.tileMatrixDeltaX,l=t.topLeftCorner[1]-o*t.tileMatrixDeltaY;var m=u.epsg3857ToEpsg4326(h,l),y=new n(g[0],m[0],g[1],m[1]);return this.makeTile(y,t,e,i)},d.prototype.computeTileMatrixValues3857=function(t){var e=28e-5*t.scaleDenominator,i=t.tileWidth*e,r=t.tileHeight*e,n=t.topLeftCorner[0]+i*t.matrixWidth,o=t.topLeftCorner[1]-r*t.matrixHeight,s=[n,o],a=t.topLeftCorner;t.tileMatrixDeltaX=s[0]-a[0],t.tileMatrixDeltaY=a[1]-s[1],t.mapWidth=t.tileWidth*t.matrixWidth,t.mapHeight=t.tileHeight*t.matrixHeight},d.prototype.makeTile=function(t,e,i,r){var n=this.cachePath+"-layer/"+e.identifier+"/"+i+"/"+r+"."+c.suffixForMimeType(this.imageFormat);return new h(t,e,i,r,n)},d.prototype.createTexture=function(t,e,i){return d.isEpsg4326Crs(this.tileMatrixSet.supportedCRS)?new a(t.currentGlContext,i):d.isEpsg3857Crs(this.tileMatrixSet.supportedCRS)?this.createTexture3857(t,e,i):d.isOGCCrs84(this.tileMatrixSet.supportedCRS)?new a(t.currentGlContext,i):void 0},d.prototype.createTexture3857=function(t,e,i){this.destCanvas||(this.destCanvas=document.createElement("canvas"),this.destContext=this.destCanvas.getContext("2d"));var r,n,o,s,l,h,c,d,p=t.canvas2D,f=t.ctx2D,g=this.destCanvas,m=this.destContext,y=m.createImageData(i.width,i.height),E=e.sector,v=u.gudermannianInverse(E.minLatitude),_=u.gudermannianInverse(E.maxLatitude);p.width=i.width,p.height=i.height,g.width=i.width,g.height=i.height,f.drawImage(i,0,0,i.width,i.height),r=f.getImageData(0,0,i.width,i.height);for(var b=0;b<1;b++)for(var w=0;w<i.height;w++){c=1-w/(i.height-1),n=c*E.deltaLatitude()+E.minLatitude,o=u.gudermannianInverse(n),d=1-(o-v)/(_-v),d=u.clamp(d,0,1),s=Math.floor(d*(i.height-1));for(var S=0;S<i.width;S++)l=4*(S+s*i.width),h=4*(S+w*i.width),y.data[h]=r.data[l],y.data[h+1]=r.data[l+1],y.data[h+2]=r.data[l+2],y.data[h+3]=r.data[l+3]}return m.putImageData(y,0,0),new a(t.currentGlContext,g)},d.isEpsg4326Crs=function(t){return t.indexOf("EPSG")>=0&&t.indexOf("4326")>=0},d.isEpsg3857Crs=function(t){return t.indexOf("EPSG")>=0&&(t.indexOf("3857")>=0||t.indexOf("900913")>=0)},d.isOGCCrs84=function(t){return t.indexOf("OGC")>=0&&t.indexOf("CRS84")>=0},d}),i("layer/OpenStreetMapImageLayer",["../util/Color","../layer/Layer","../util/Logger","../ogc/wmts/WmtsCapabilities","../layer/WmtsLayer"],function(t,e,i,r,n){"use strict";var o=function(t){e.call(this,this.displayName),this.displayName=t||"Open Street Map",this.layer=null,this.xhr=null,this.pickEnabled=!0};return o.prototype=Object.create(e.prototype),o.prototype.doRender=function(e){this.configureLayer(e),this.layer&&(this.layer.opacity=this.opacity,this.layer.doRender(e),this.inCurrentFrame=this.layer.inCurrentFrame,this.inCurrentFrame&&(e.screenCreditController.addCredit("OpenStreetMap ©",t.DARK_GRAY),e.screenCreditController.addCredit("EOX.at ©",t.DARK_GRAY)))},o.prototype.configureLayer=function(t){if(!this.xhr){var e=this,o=t.currentGlContext.canvas;this.xhr=new XMLHttpRequest,this.xhr.open("GET","https://tiles.maps.eox.at/wmts/1.0.0/WMTSCapabilities.xml",!0),this.xhr.onreadystatechange=function(){if(4===e.xhr.readyState)if(200===e.xhr.status){var t=new r(e.xhr.responseXML),s=t.getLayer("osm"),a=n.formLayerConfiguration(s);a.title=e.displayName,e.layer=new n(a);var l=document.createEvent("Event");l.initEvent(WorldWind.REDRAW_EVENT_TYPE,!0,!0),o.dispatchEvent(l)}else i.log(i.LEVEL_WARNING,"OSM retrieval failed ("+xhr.statusText+"): "+url)},this.xhr.onerror=function(){i.log(i.LEVEL_WARNING,"OSM retrieval failed: "+url)},this.xhr.ontimeout=function(){i.log(i.LEVEL_WARNING,"OSM retrieval timed out: "+url)},this.xhr.send(null)}},o}),i("projections/ProjectionGnomonic",["../geom/Angle","../error/ArgumentError","../projections/GeographicProjection","../util/Logger","../geom/Sector","../util/WWMath"],function(t,e,i,r,n,o){"use strict";var s=function(t){this.north=!("South"===t);var e=this.north?new n(30,90,-180,180):new n(-90,-30,-180,180);i.call(this,"Polar Gnomonic",!1,e),this._pole=t,this.displayName=this.north?"North Gnomonic":"South Gnomonic",this._stateKey="projection polar gnomonic "+this._pole+" "};return s.prototype=Object.create(i.prototype),Object.defineProperties(s.prototype,{pole:{get:function(){return this._pole},set:function(t){this._pole=t,this.north=!("South"===this._pole),this.projectionLimits=this.north?new n(30,90,-180,180):new n(-90,-30,-180,180),this._stateKey="projection polar gnomonic "+this._pole+" "}},stateKey:{get:function(){return this._stateKey}}}),s.prototype.geographicToCartesian=function(i,n,o,s,a,l){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionGnomonic","geographicToCartesian","missingGlobe"));if(!l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionGnomonic","geographicToCartesian","missingResult"));if(this.north&&90===n||!this.north&&n===-90)l[0]=0,l[1]=0,l[2]=s;else{var h=this.north?1:-1,u=i.equatorialRadius/Math.tan(n*t.DEGREES_TO_RADIANS);l[0]=u*Math.sin(o*t.DEGREES_TO_RADIANS)*h,l[1]=u*-Math.cos(o*t.DEGREES_TO_RADIANS),l[2]=s}return l},s.prototype.geographicToCartesianGrid=function(i,n,s,a,l,h,u,c){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionGnomonic","geographicToCartesianGrid","missingGlobe"));if(!n)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionGnomonic","geographicToCartesianGrid","missingSector"));if(!l||l.length<s*a)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionGnomonic","geographicToCartesianGrid","The specified elevations array is null, undefined or insufficient length"));if(!c)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionGnomonic","geographicToCartesianGrid","missingResult"));var d,p,f,g,m,y,E=n.minLatitude*t.DEGREES_TO_RADIANS,v=n.maxLatitude*t.DEGREES_TO_RADIANS,_=n.minLongitude*t.DEGREES_TO_RADIANS,b=n.maxLongitude*t.DEGREES_TO_RADIANS,w=(v-E)/(s>1?s-1:1),S=(b-_)/(a>1?a-1:1),L=this.projectionLimits.minLatitude*t.DEGREES_TO_RADIANS,T=this.projectionLimits.maxLatitude*t.DEGREES_TO_RADIANS,A=this.north?1:-1,R=h?h:new Vec3(0,0,0),x=0,C=0;for(d=0,f=E;d<s;d++,f+=w)for(d===s-1&&(f=v),m=o.clamp(f,L,T),y=i.equatorialRadius/Math.tan(m),(this.north&&m===Math.PI/2||!this.north&&m===-Math.PI/2)&&(y=0),p=0,g=_;p<a;p++,g+=S)p===a-1&&(g=b),c[C++]=y*Math.sin(g)*A-R[0],c[C++]=y*-Math.cos(g)-R[1],c[C++]=l[x++]-R[2];return c},s.prototype.cartesianToGeographic=function(i,n,o,s,a,l){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionGnomonic","cartesianToGeographic","missingGlobe"));if(!l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionGnomonic","cartesianToGeographic","missingResult"));var h,u=Math.sqrt(n*n+o*o);return u<1e-4?(l.latitude=this.north?90:-90,l.longitude=0,l.altitude=s):(h=Math.atan2(u,i.equatorialRadius),h>Math.PI&&(h=Math.PI),l.latitude=Math.asin(Math.cos(h)*(this.north?1:-1))*t.RADIANS_TO_DEGREES,l.longitude=Math.atan2(n,o*(this.north?-1:1))*t.RADIANS_TO_DEGREES,l.altitude=s),l},s.prototype.northTangentAtLocation=function(i,n,o,s){if(!s)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionGnomonic","northTangentAtLocation","missingResult"));
return s[0]=Math.sin(o*t.DEGREES_TO_RADIANS)*(this.north?-1:1),s[1]=Math.cos(o*t.DEGREES_TO_RADIANS),s[2]=0,s},s.prototype.northTangentAtPoint=function(t,i,n,o,s,a){if(!a)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionGnomonic","northTangentAtLocation","missingResult"));var l=Math.sqrt(i*i+n*n);return l<1e-4?(a[0]=0,a[1]=1,a[2]=0):(a[0]=i/l*(this.north?-1:1),a[1]=n/l*(this.north?-1:1),a[2]=0),a},s}),i("projections/ProjectionMercator",["../geom/Angle","../error/ArgumentError","../projections/GeographicProjection","../util/Logger","../geom/Sector","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o,s){"use strict";var a=function(){i.call(this,"Mercator",!0,new n(-78,78,-180,180))};return a.prototype=Object.create(i.prototype),a.prototype.geographicToCartesian=function(i,n,o,s,a,l){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionMercator","geographicToCartesian","missingGlobe"));if(!l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionMercator","geographicToCartesian","missingResult"));n>this.projectionLimits.maxLatitude&&(n=this.projectionLimits.maxLatitude),n<this.projectionLimits.minLatitude&&(n=this.projectionLimits.minLatitude);var h=Math.sqrt(i.eccentricitySquared),u=Math.sin(n*t.DEGREES_TO_RADIANS),c=(1+u)/(1-u)*Math.pow((1-h*u)/(1+h*u),h);return l[0]=i.equatorialRadius*o*t.DEGREES_TO_RADIANS+(a?a[0]:0),l[1]=.5*i.equatorialRadius*Math.log(c),l[2]=s,l},Object.defineProperties(a.prototype,{stateKey:{get:function(){return"projection mercator "}}}),a.prototype.geographicToCartesianGrid=function(i,n,a,l,h,u,c,d){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionMercator","geographicToCartesianGrid","missingGlobe"));if(!n)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionMercator","geographicToCartesianGrid","missingSector"));if(!h||h.length<a*l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionMercator","geographicToCartesianGrid","The specified elevations array is null, undefined or insufficient length"));if(!d)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionMercator","geographicToCartesianGrid","missingResult"));var p,f,g,m,y,E,v,_,b=i.equatorialRadius,w=Math.sqrt(i.eccentricitySquared),S=n.minLatitude*t.DEGREES_TO_RADIANS,L=n.maxLatitude*t.DEGREES_TO_RADIANS,T=n.minLongitude*t.DEGREES_TO_RADIANS,A=n.maxLongitude*t.DEGREES_TO_RADIANS,R=(L-S)/(a>1?a-1:1),x=(A-T)/(l>1?l-1:1),C=this.projectionLimits.minLatitude*t.DEGREES_TO_RADIANS,M=this.projectionLimits.maxLatitude*t.DEGREES_TO_RADIANS,P=u?u:new o(0,0,0),O=c?c[0]:0,N=0,I=0;for(p=0,g=S;p<a;p++,g+=R)for(p===a-1&&(g=L),y=s.clamp(g,C,M),E=Math.sin(y),v=(1+E)/(1-E)*Math.pow((1-w*E)/(1+w*E),w),_=b*Math.log(v)*.5-P[1],f=0,m=T;f<l;f++,m+=x)f===l-1&&(m=A),d[I++]=b*m-P[0]+O,d[I++]=_,d[I++]=h[N++]-P[2];return d},a.prototype.cartesianToGeographic=function(i,n,o,s,a,l){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionMercator","cartesianToGeographic","missingGlobe"));if(!l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionMercator","cartesianToGeographic","missingResult"));var h=i.eccentricitySquared,u=h*h,c=u*h,d=c*h,p=Math.pow(Math.E,-o/i.equatorialRadius),f=Math.PI/2-2*Math.atan(p),g=h/2+5*u/24+c/12+13*d/360,m=7*u/48+29*c/240+811*d/11520,y=7*c/120+81*d/1120,E=4279*d/161280,v=f-m+E,_=g-3*y,b=2*m-8*E,w=4*y,S=8*E,L=Math.sin(2*f),T=v+L*(_+L*(b+L*(w+S*L)));return l.latitude=T*t.RADIANS_TO_DEGREES,l.longitude=(n-(a?a[0]:0))/i.equatorialRadius*t.RADIANS_TO_DEGREES,l.altitude=s,l},a}),i("projections/ProjectionPolarEquidistant",["../geom/Angle","../error/ArgumentError","../projections/GeographicProjection","../util/Logger"],function(t,e,i,r){"use strict";var n=function(t){i.call(this,"Polar Equidistant",!1,null),this._pole=t,this.north=!("South"===t),this.displayName=this.north?"North Polar":"South Polar",this._stateKey="projection polar equidistant "+this._pole+" "};return n.prototype=Object.create(i.prototype),Object.defineProperties(n.prototype,{pole:{get:function(){return this._pole},set:function(t){this._pole=t,this.north=!("South"===this._pole),this._stateKey="projection polar equidistant "+this._pole+" "}},stateKey:{get:function(){return this._stateKey}}}),n.prototype.geographicToCartesian=function(i,n,o,s,a,l){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionPolarEquidistant","geographicToCartesian","missingGlobe"));if(!l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionPolarEquidistant","geographicToCartesian","missingResult"));if(this.north&&90===n||!this.north&&n===-90)l[0]=0,l[1]=0,l[2]=s;else{var h=this.north?-1:1,u=i.equatorialRadius*(Math.PI/2+n*t.DEGREES_TO_RADIANS*h);l[0]=u*Math.sin(o*t.DEGREES_TO_RADIANS),l[1]=u*Math.cos(o*t.DEGREES_TO_RADIANS)*h,l[2]=s}return l},n.prototype.geographicToCartesianGrid=function(i,n,o,s,a,l,h,u){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionPolarEquidistant","geographicToCartesianGrid","missingGlobe"));if(!n)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionPolarEquidistant","geographicToCartesianGrid","missingSector"));if(!a||a.length<o*s)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionPolarEquidistant","geographicToCartesianGrid","The specified elevations array is null, undefined or insufficient length"));if(!u)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionPolarEquidistant","geographicToCartesianGrid","missingResult"));var c,d,p,f,g,m=i.equatorialRadius,y=n.minLatitude*t.DEGREES_TO_RADIANS,E=n.maxLatitude*t.DEGREES_TO_RADIANS,v=n.minLongitude*t.DEGREES_TO_RADIANS,_=n.maxLongitude*t.DEGREES_TO_RADIANS,b=(E-y)/(o>1?o-1:1),w=(_-v)/(s>1?s-1:1),S=this.north?-1:1,L=l?l:new Vec3(0,0,0),T=Math.PI/2,A=0,R=0,x=new Float64Array(s),C=new Float64Array(s);for(d=0,f=v;d<s;d++,f+=w)d===s-1&&(f=_),x[d]=Math.cos(f),C[d]=Math.sin(f);for(c=0,p=y;c<o;c++,p+=b)for(c===o-1&&(p=E),g=m*(T+p*S),(this.north&&p===T||!this.north&&p===-T)&&(g=0),d=0;d<s;d++)u[R++]=g*C[d]-L[0],u[R++]=g*x[d]*S-L[1],u[R++]=a[A++]-L[2];return u},n.prototype.cartesianToGeographic=function(i,n,o,s,a,l){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionPolarEquidistant","cartesianToGeographic","missingGlobe"));if(!l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionPolarEquidistant","cartesianToGeographic","missingResult"));var h,u=Math.sqrt(n*n+o*o);return u<1e-4?(l.latitude=this.north?90:-90,l.longitude=0,l.altitude=s):(h=u/i.equatorialRadius,h>Math.PI&&(h=Math.PI),l.latitude=Math.asin(Math.cos(h)*(this.north?1:-1))*t.RADIANS_TO_DEGREES,l.longitude=Math.atan2(n,o*(this.north?-1:1))*t.RADIANS_TO_DEGREES,l.altitude=s),l},n.prototype.northTangentAtLocation=function(i,n,o,s){if(!s)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionPolarEquidistant","northTangentAtLocation","missingResult"));return s[0]=Math.sin(o*t.DEGREES_TO_RADIANS)*(this.north?-1:1),s[1]=Math.cos(o*t.DEGREES_TO_RADIANS),s[2]=0,s},n.prototype.northTangentAtPoint=function(t,i,n,o,s,a){if(!a)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionPolarEquidistant","northTangentAtLocation","missingResult"));var l=Math.sqrt(i*i+n*n);return l<1e-4?(a[0]=0,a[1]=1,a[2]=0):(a[0]=i/l*(this.north?-1:1),a[1]=n/l*(this.north?-1:1),a[2]=0),a},n}),i("projections/ProjectionUPS",["../geom/Angle","../error/ArgumentError","../projections/GeographicProjection","../util/Logger","../geom/Sector","../geom/Vec3","../util/WWMath"],function(t,e,i,r,n,o,s){"use strict";var a=function(t){this.north=!("South"===t);var e=this.north?new n(0,90,-180,180):new n(-90,0,-180,180);i.call(this,"Uniform Polar Stereographic",!1,e),this._pole=t,this.displayName=this.north?"North UPS":"South UPS",this._stateKey="projection ups "+this._pole+" "};return a.prototype=Object.create(i.prototype),Object.defineProperties(a.prototype,{pole:{get:function(){return this._pole},set:function(t){this._pole=t,this.north=!("South"===this._pole),this.projectionLimits=this.north?new n(0,90,-180,180):new n(-90,0,-180,180),this._stateKey="projection ups "+this._pole+" "}},stateKey:{get:function(){return this._stateKey}}}),a.prototype.geographicToCartesian=function(i,n,o,s,a,l){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionUPS","geographicToCartesian","missingGlobe"));if(!l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionUPS","geographicToCartesian","missingResult"));if(this.north&&90===n||!this.north&&n===-90)l[0]=0,l[1]=0,l[2]=s;else{var h,u,c,d=this.north?1:-1,p=n*t.DEGREES_TO_RADIANS,f=o*t.DEGREES_TO_RADIANS,g=.994,m=Math.sqrt(i.eccentricitySquared),y=Math.sqrt(Math.pow(1+m,1+m)*Math.pow(1-m,1-m));(this.north&&p<0||!this.north&&p>0)&&(p=0),h=Math.sin(p*d),u=Math.sqrt((1-h)/(1+h)*Math.pow((1+m*h)/(1-m*h),m)),c=2*i.equatorialRadius*g*u/y,l[0]=c*Math.sin(f),l[1]=-c*Math.cos(f)*d,l[2]=s}return l},a.prototype.geographicToCartesianGrid=function(i,n,a,l,h,u,c,d){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionUPS","geographicToCartesianGrid","missingGlobe"));if(!n)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionUPS","geographicToCartesianGrid","missingSector"));if(!h||h.length<a*l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionUPS","geographicToCartesianGrid","The specified elevations array is null, undefined or insufficient length"));if(!d)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionUPS","geographicToCartesianGrid","missingResult"));var p,f,g,m,y,E,v,_,b=i.equatorialRadius,w=n.minLatitude*t.DEGREES_TO_RADIANS,S=n.maxLatitude*t.DEGREES_TO_RADIANS,L=n.minLongitude*t.DEGREES_TO_RADIANS,T=n.maxLongitude*t.DEGREES_TO_RADIANS,A=(S-w)/(a>1?a-1:1),R=(T-L)/(l>1?l-1:1),x=this.projectionLimits.minLatitude*t.DEGREES_TO_RADIANS,C=this.projectionLimits.maxLatitude*t.DEGREES_TO_RADIANS,M=.994,P=Math.sqrt(i.eccentricitySquared),O=Math.sqrt(Math.pow(1+P,1+P)*Math.pow(1-P,1-P)),N=this.north?1:-1,I=u?u:new o(0,0,0),D=0,k=0;for(p=0,g=w;p<a;p++,g+=A)for(p===a-1&&(g=S),y=s.clamp(g,x,C),E=Math.sin(y*N),v=Math.sqrt((1-E)/(1+E)*Math.pow((1+P*E)/(1-P*E),P)),_=2*b*M*v/O,f=0,m=L;f<l;f++,m+=R)f===l-1&&(m=T),d[k++]=_*Math.sin(m)-I[0],d[k++]=-_*Math.cos(m)*N-I[1],d[k++]=h[D++]-I[2];return d},a.prototype.cartesianToGeographic=function(i,n,o,s,a,l){if(!i)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionUPS","cartesianToGeographic","missingGlobe"));if(!l)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionUPS","cartesianToGeographic","missingResult"));var h=Math.atan2(n,o*(this.north?-1:1)),u=.994,c=Math.sqrt(i.eccentricitySquared),d=Math.sqrt(n*n+o*o),p=Math.sqrt(Math.pow(1+c,1+c)*Math.pow(1-c,1-c)),f=d*p/(2*i.equatorialRadius*u),g=i.eccentricitySquared,m=g*g,y=m*g,E=y*g,v=Math.PI/2-2*Math.atan(f),_=g/2+5*m/24+y/12+13*E/360,b=7*m/48+29*y/240+811*E/11520,w=7*y/120+81*E/1120,S=4279*E/161280,L=v-b+S,T=_-3*w,A=2*b-8*S,R=4*w,x=8*S,C=Math.sin(2*v),M=L+C*(T+C*(A+C*(R+x*C)));return M*=this.north?1:-1,l.latitude=M*t.RADIANS_TO_DEGREES,l.longitude=h*t.RADIANS_TO_DEGREES,l.altitude=s,l},a.prototype.northTangentAtLocation=function(i,n,o,s){if(!s)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionUPS","northTangentAtLocation","missingResult"));return s[0]=Math.sin(o*t.DEGREES_TO_RADIANS)*(this.north?-1:1),s[1]=Math.cos(o*t.DEGREES_TO_RADIANS),s[2]=0,s},a.prototype.northTangentAtPoint=function(t,i,n,o,s,a){if(!a)throw new e(r.logMessage(r.LEVEL_SEVERE,"ProjectionPolarEquidistant","northTangentAtLocation","missingResult"));var l=Math.sqrt(i*i+n*n);return l<1e-4?(a[0]=0,a[1]=1,a[2]=0):(a[0]=i/l*(this.north?-1:1),a[1]=n/l*(this.north?-1:1),a[2]=0),a},a}),i("layer/WmsLayer",["../error/ArgumentError","../geom/Location","../util/Logger","../util/PeriodicTimeSequence","../geom/Sector","../layer/TiledImageLayer","../util/WmsUrlBuilder"],function(t,e,i,r,n,o,s){"use strict";var a=function(e,r){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"WmsLayer","constructor","No configuration specified."));var n=e.service+e.layerNames+e.styleNames;r&&(n+=r),o.call(this,e.sector,e.levelZeroDelta,e.numLevels,e.format,n,e.size,e.size),this.displayName=e.title,this.pickEnabled=!1,this.urlBuilder=new s(e.service,e.layerNames,e.styleNames,e.version,r),e.coordinateSystem&&(this.urlBuilder.crs=e.coordinateSystem),this.timeString=r};return a.prototype=Object.create(o.prototype),a.formLayerConfiguration=function(t){var i={title:t.title,version:t.capability.capsDoc.version},r=t.geographicBoundingBox||t.latLonBoundingBox;r&&r.westBoundLongitude?i.sector=new n(r.southBoundLatitude,r.northBoundLatitude,r.westBoundLongitude,r.eastBoundLongitude):r&&r.minx?i.sector=new n(r.miny,r.maxy,r.minx,r.maxx):i.sector=n.FULL_SPHERE,i.levelZeroDelta=new e(36,36),i.numLevels=19,i.size=256,i.layerNames=t.name;var o=t.capability.request.getMap,s=o.formats;s.indexOf("image/png")>=0?i.format="image/png":s.indexOf("image/jpeg")>=0?i.format="image/jpeg":s.indexOf("image/tiff")>=0?i.format="image/tiff":s.indexOf("image/gif")>=0&&(i.format="image/gif"),i.service=o.getUrl;var l=t.crses;l||(l=t.srses),l&&(l.indexOf("EPSG:4326")>=0||l.indexOf("epsg:4326")>=0?i.coordinateSystem="EPSG:4326":(l.indexOf("CRS84")>=0||l.indexOf("CRS:84")>=0)&&(i.coordinateSystem="CRS:84"));var h=a.parseTimeDimensions(t);return h&&h.length>0&&(i.timeSequences=h),i},a.parseTimeDimensions=function(t){var e=t.extents||t.dimensions,i=null;if(e){i=[];for(var n=0;n<e.length;n++){var o=e[n];if("time"===o.name.toLowerCase()&&(!o.units||"iso8601"===o.units.toLowerCase()))for(var s=o.content.split(","),a=0;a<s.length;a++){var l=s[a],h=l.split("/");1===h.length?i.push(new Date(l)):3===h.length&&i.push(new r(l))}}}return i},a}),i("layer/Sentinel2CloudlessLayer",["../geom/Location","../geom/Sector","../layer/WmsLayer","../util/Color"],function(t,e,i,r){"use strict";var n=function(){i.call(this,{service:"https://tiles.maps.eox.at/wms",layerNames:"s2cloudless-2018",title:"Sentinel-2 Cloudless Layer",sector:e.FULL_SPHERE,levelZeroDelta:new t(45,45),numLevels:7,format:"image/jpeg",opacity:1,size:256,version:"1.3.0"},null)};return n.prototype=Object.create(i.prototype),n.prototype.doRender=function(t){i.prototype.doRender.call(this,t),this.inCurrentFrame&&t.screenCreditController.addCredit("Sentinel-2 cloudless - https://s2maps.eu by EOX IT Services GmbH (Contains modified Copernicus Sentinel data 2017 & 2018)",r.DARK_GRAY)},n}),i("util/editor/ShapeEditorConstants",[],function(){"use strict";var t={LOCATION:"location",ROTATION:"rotation",WIDTH:"width",HEIGHT:"height",RADIUS:"radius",DRAG:"drag",MIN_CORNER:"min_corner",MAX_CORNER:"max_corner",SHADOW:"shadow"};return t}),i("util/editor/BaseSurfaceEditorFragment",["../../geom/Angle","../../geom/Line","../../geom/Location","../Logger","../../shapes/Path","../../shapes/Placemark","../../shapes/PlacemarkAttributes","../../geom/Position","../../shapes/ShapeAttributes","./ShapeEditorConstants","../../error/UnsupportedOperationError","../../geom/Vec3"],function(t,e,i,r,n,o,s,a,l,h,u,c){"use strict";var d=function(){};return d.prototype.canHandle=function(t){throw new u(r.logMessage(r.LEVEL_SEVERE,"BaseSurfaceEditorFragment","canHandle","abstractInvocation"))},d.prototype.createShadowShape=function(t){throw new u(r.logMessage(r.LEVEL_SEVERE,"BaseSurfaceEditorFragment","createShadowShape","abstractInvocation"))},d.prototype.getShapeCenter=function(t,e){throw new u(r.logMessage(r.LEVEL_SEVERE,"BaseSurfaceEditorFragment","getShapeCenter","abstractInvocation"))},d.prototype.initializeControlElements=function(t,e,i,n,o,s,a,l){throw new u(r.logMessage(r.LEVEL_SEVERE,"BaseSurfaceEditorFragment","initializeControlElements","abstractInvocation"))},d.prototype.updateControlElements=function(t,e,i,n,o){throw new u(r.logMessage(r.LEVEL_SEVERE,"BaseSurfaceEditorFragment","updateControlElements","abstractInvocation"))},d.prototype.reshape=function(t,e,i,n,o,s){throw new u(r.logMessage(r.LEVEL_SEVERE,"BaseSurfaceEditorFragment","reshape","abstractInvocation"))},d.prototype.addNewVertex=function(t,e,i){},d.prototype.createControlPoint=function(t,e,r,n){var a=new o(new i(0,0),!1,e),l=new s(null);switch(l.imageScale=.15,a.altitudeMode=WorldWind.CLAMP_TO_GROUND,a.userProperties.purpose=r,a.userProperties.purpose){case h.ROTATION:l.imageSource="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFcklEQVR4AeXbS2xVVRvG8c0l4buE7zPqwIsOHGBwIBpN1DBwYAzRBEdG4wyIF0YmiIkTjTHxsnqRtkqFBhVCIQUU0VaEVC4iUCtgqphKGgqlBaS00MNp5ZzSy96P/8HaycpJofee7uXzyxsIdNB37b32WXvtfYLJjqRZ1ELqlVDhB73q/SqrbEOf+joiRSE1eE3XUvzbyYwyP/L/mwY1+JqkBdTMIImRNId6miYrBzTQrTGGgbmWUqqewWFAdEsSGn+IX7aGI9g7wgY1iJGEnwvb1V53SqcWTcfG7+XU3anr5CKOYAc2Yg2KYaxSrEMVqnEQ5xBhqHSp62KnOpdImpHvxu/iNN8UKYrkJEITdqAUZozKUI1GZJEbBqH5rM4+kI/GZ9D4q6HCATnJoA7lMBOsCLvRjZypETEtdlH/m6rm/8Pc/VJO+rAPRTA5pmog0kpfbVHLw5Pd/Lx+9TfLyR9YDTPFirAHA3AuquFpnV42Wc0v5nTLyuYqtsDk2XpcQZwIrWpdO6EXSOb6IiqUTTvKYaaJUpyEmzM6UztRR/4Rjnyfe8oXw0wzBfgBbpgOG8bb/H003yObozDT3D64aVPbm2Nt/m6ab5dNIwpgEqABcUJ0qOOF0TY/k+brnFNJhTAJUYjTiMMqtZ+V5R2jGYDlsunAKpiEKUEn4jAATSNt/k5Om6siIdbDJNQaDCDOeZ1fPuwSl6qWzWGYhKuDMxV6Jd18owF4VjaXUASTcCXIwJnSFdc9+pGiBtlUwXiiFs5Z0Md9xL+HGoBH3ft345FCdCEOq8aSoQZgo2xqYDzzNeJwBqTl3itIupXTv0+kB4UwnilGP5yp8IQ7AG/I5icYTzXBmeZV7gAcls02GE/VwJkGnXHzs6msbEphPFWKEHGYErcHkhbI5jKM51oQh42T1wNJL8rmOIznDsC5Vd4cSKqQzW4Yz30LZ2erPpD0s2w+g/FcFeKwl3gukNQgmzIYz1UgTlbZTCDpqGw+gvFcMdz7gkBSvWxWw/hPWdjnCIOBpEOyKYfxn/6CXQcwANIB2XwC4z8NgIg/BwJJe2WzBv+kawBPt9KBpFrZVMB4rhxxUkq1BJK2y2YHjOc2wdkeYyEkrZDNMRjP7UecC7qwNZB0f+5WmM9OwnlW8HK8Fd7h/e2wlYETtsiJpC2y+QLGU+sRh7VAh7sj9JJs6mE89QucG6Ft7gDc426KFMDHz/9eOC9XLczdFm+RzTcwnqmGc/qnJM3IHYC3ZdMFn7bGC3ARzqddWZAbSXOpTtl8B+OJnXBfuZV0WzBU3EVRN3x4OPoheuCc/hU3ejr8L6pNNt/DJNwhONvgvZJuGu4dgWWyySDJmySVCOHc/b0VDBf7oKRRNhdQDJMwZeiG0/yfkuaM9DWZ+VRaNieQtKv+KRDFGx9c/OaP9k2xp6hQNgeRxBWf3ftbOtZ3BVfKyV6Yae4Y3LD6qxzX9wKoDXLyK6brIuko3PDxVyNp1kR8AeqAnLRiOt02r8IJuEkptWvCvnVmB2GDnKSwESbPPkUX3GSU2TpRzedOhxVUKCe/42Pk40q/G/1w3guOmPPv2OYnJ5IWRYrSctKH/ZiqpfMWdCDnqF9hMB4LpiKS5lHHlZMe1GEtJuOIb0YzcpNWmvmuucFUxn4ldgl1VkOkFTUogRmHz1GPbuSGo97Eaf9kkM/YG6iVTIuUrpMuNGIPKrEapShGAQyKsA7bsR+/4RKcuHd0bSxunnE2NfIfSf+n3qcuaZQZRIRhfqafKbaHI744/40PPzUep0qpVo0jNNufVbZW0nPUf4OkxX50Pkgtpd6lqqgjHO3LVDdHNcWV+zJ1nr830/BOSe9Rz9sbstnBJOdvB05s7/twc1gAAAAASUVORK5CYII=";break;case h.LOCATION:l.imageSource="data:image/png;base64,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";break;case h.SHADOW:l.imageSource="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAACBFBMVEUAAAD////////////////////////+/v7////////////9/f3////////////////////////+/v79/f3////////////////////////+/v7////////////////9/f3////////9/f3////////+/v7+/v7////////+/v7+/v79/f3+/v7////////////+/v7////+/v7////////////+/v7+/v7////+/v7////9/f3////////////9/f3////9/f3////+/v7////+/v7////9/f3////9/f3+/v7////+/v7////////////+/v79/f3////+/v79/f3+/v7////9/f3////////+/v7+/v79/f3+/v7////////9/f3+/v7+/v7+/v7////+/v7////+/v7+/v79/f3+/v79/f3+/v7////+/v7////////+/v7////////+/v7+/v7////////////////+/v7////////////9/f3+/v7+/v7+/v7+/v7////////+/v7////////+/v7+/v7+/v7+/v7+/v7+/v7////+/v7////////+/v7+/v7+/v7+/v7////+/v7+/v7+/v7+/v7+/v7////+/v7+/v7+/v7+/v7+/v7+/v7+/v7////+/v76+vr7+/v8/Pz9/f3+/v7///+XJ/0FAAAApnRSTlMAAQIDBAcICQoLDQ4PEBITFBgZGhscHSElJigoKS0uLzAyMzY3ODo6PkJERkZGSElMTE1TVVZYX19gYGFhY2RlZmdnbXBxcnN2e3x+gIOEhYaOj5CXmJifn6Gio6SmpqeoqKmrrK2xsrS2trm5ubu8wMHDxMXHx8jJys7O0dTY2Nrb3t7g4eHi4+Tl5+jp6erq6+zu7/Dw8fL09fb29/j5+vv8/f3+K7BQkAAAApBJREFUeAGl1/df01AUBfCTlqKi4lYUxb333htw7w3uIYhDVHDgUNxDHFREVCxQSF7e+Sdt36efQkdo8vL9/dzce18zCifB2VsOXmloinaFX9ypLCsJwJPQ4opWpvhXXzYMbk2tamcW0br5cGN8NRVpC8syYyxLCEnl82oDOYyp7GGMLcw0wmZc42T0x9jeqeKWmY3qo+faYDgaeIkxiYs7lmibBgdFjcmrOxIko+uR1dI/JC0zB0uS8qiBTAuipFT5HGyS15FheoS0TVcEyRNIM/GXyruvsAspxn7ykFdTyFXoI1BHStMDSXaMQq9tKu+xwjMkjW5T5+eFRXIrEoyryQV4WkN7IRQs9zqAQvIYFKPB6wCKICMDEDdDqwG1x0OIO6VuQK0WWgwAwyMaDSgk5wLYqY5Ah02eAXBPrVBzhq9A3l/S1ERyJEr0zkCR5A5s1F6BmuE0jpPCR4F6PNDboWKR7/GYNH0U+I1HpKmNjOC+vwJduKu5A0WyC7V+CpCduO2vQAtu+jvGl7hMCh8F6lHq76d8HpN83Ew2uRnGF1+3cyFwjrS0V9AEYJOfR9pFAOPo46E6CzGv9B/rYQMxe/RfLEcQV/CNFFoNREdAKdVqQSZfrsh/Swqd1/tQJGwg6f03wN1AQt5TnU+cjyEkFf8kbY/5zgnoY1E3KTwtgGuRopyk8JKvQCrjJEnbfb4qiDShWpLSbb4mgAyheA/S1ec+LwSQhVHanXsMQbJnbwDZLWxhjMhx+R8z4ajoCWOkbTnHWVOAfgTXvKOqITLStoo/n4cc8svDvX88E1khVJp8s8xAbkMOfGc2HbeWGHAnOOfw6/T0jRWD4IUxZd2+sw+bW8PNHxqr968szoOD/0KVHzHYRB3yAAAAAElFTkSuQmCC";break;case h.WIDTH:l.imageSource="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFl0lEQVR4AeWbS2xV1RrHN4+E+wj33tx7B/ehAwcYHIhGEzUMHBhDNMGR0TgD4oORCWLiRGNMfAylUIQqYkN5a4nysLVCsIhQqqGKYmis0FJooA9Lex57n/1Y309OYGd92TmWlvb09Gx+yX9I6P9/9vrWt769tlNugDnAYuAFxLyDeHuuqgMJ+hExiESIP4xxf8HkjyCFrYh5CVgEzHaqEWAe8DjiNyDhKDeL+AXMlTbEKwbyr2owfh/i7UMib5wGgYhxIZEhunyMsHvJTDR+J1I4wB8R9YN/Etz9kNsJ2c0wWntVa64pswGyWyDfCG4zFI5D1AcIJTFXLhMNLQNmVdr4bYi/FREBjUDQBfn9kNlojU5UxX/rNkFwBsQrEexQF+HFeyphfBbiv4iYEI3kodAO2U3WxJRpHXiHwGSSS0MIu5uu6m/TZf4viP8JGgnAO1L8I8c2Uc4gzGiOsOf+cptfgARdaIJOyHxQfuMlg/gKCCFGCoawe0W5zC9FIhf9uOf3VMB4QrntYEZUCAJh78YpLZCIWYIYo6u6XecVld1FwrOgCc+3TI15eACJfPXI2y1sRqkGCkcTIfTUT9b8XUhkq41/cgYaT8g7kgjhwqs3a/52xFwiJjhTTHkmm7fyT0GMGIgGnpmo+dlIdMym2A2ja2e8cau1EHarELyAsO9/EwlgJTHRIGTWV4t5q8x7YAbVUujrHK/5/yMmBwAGctuqzbxVdjMQ6hBW3rjFhb3EFE5Uq3mrQrtulDzgn2MF8CQxZqhUa1udS0Fc1JKuG+OAIx3E5Bur3byVd1gXRB+T+XOpAB5UnV5azNtdwQxDTHD23VIBbCHGbU6LeSv3c2IwmRH0WQH4NyI+AJK1e36qVAsS6oL4iA7gFVv529Nm3kqf5KOBHTqAb2zx+zS9AbjNehkMxObnAi4xmQ3pDaDoDaMnWf91gEU2ld/Sat4q7CGGsPdlB3iWmOB0+gMoHNNH5W0OUEeMdzD9AbhfoPqdNgc4QUy2If0B5BuJwYxccADb/mbq0h9Atl63xXkH+NYG8H5qjVvV6mbId4A2Yux8P90SLw4gcoCjNoBNt0gAubgPKAZAqy2CH94KAdgpkYShAxyyAWy+tWqAyY84QIsNoD79AWQ26XsG5xzAboz5/ekPILdbnwiLjRCriPE70h+A97UK4NIuB7g7OQpLtcJf9Zj8+XgU3p/y47CVnhDHI3Jgp60Dn6V4/W8nBpPt1xOh54jxv0tvAP4P+iC0WwdwB+ihSE1Kh6IF/dZ4saMBzhHjNqV8HpgbBmYlA3idGDOcstF4DUT9ev+vcZIA84EBYtwvU/Trt6Cv3AL/cUqhmyJMJiUvR9eDZHX1rxvr7fCfgPPEeIdTMARt02NwD/iHMxbACn0XsKqHJLldgNGnv9fGNK9elJxW/XIlr8VN7qK1yWjzfcA8ZzwAC4ERdTew+qp+aHd1JAyRaKEzEYDH9PND4XgVdXzfo0H85c7NAKxG47VWgfmOhPlCw+S+C4B6NP6PxSapOsyb7D5gzlR8ANWKJuwtFpmZdREq6Ex+VtM0NV+d2RDqE/9BcZupvPlsg73/Yyv+rikzn1gOqwCDJvi5Qr1CDXiHEtdejCCFN6z5MgAsQWQkUWWLs7bpa53zjRANgsa4V5DwIWc6ABYAp0histc/mvqoPL947mO7v2vMaBMw35lOgDnAMqAXjS6UbvPkZ4y5rcUple7q9FrvRMyjTsWwB6jViAyTRM8XgjPgtRYLZ7FmXA+mVk2f1l3/eHLvteUU/ARmiJKY3HnEf0IPNSoO8HfgbWCQCRMBwphIFGCyBxGztPLGb7w0HgbWAD1MBjEB4rUATwF/daoKu3XeCywH3gR2AO2IDCEyikTDSDCEhBeRqAsxB4C3gKeBhcBcp8z8DjRUCbmVu2RWAAAAAElFTkSuQmCC";break;case h.HEIGHT:l.imageSource="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFl0lEQVR4AeWbS2xV1RrHN4+E+wj33tx7B/ehAwcYHIhGEzUMHBhDNMGR0TgD4oORCWLiRGNMfAylUIQqYkN5a4nysLVCsIhQqqGKYmis0FJooA9Lex57n/1Y309OYGd92TmWlvb09Gx+yX9I6P9/9vrWt769tlNugDnAYuAFxLyDeHuuqgMJ+hExiESIP4xxf8HkjyCFrYh5CVgEzHaqEWAe8DjiNyDhKDeL+AXMlTbEKwbyr2owfh/i7UMib5wGgYhxIZEhunyMsHvJTDR+J1I4wB8R9YN/Etz9kNsJ2c0wWntVa64pswGyWyDfCG4zFI5D1AcIJTFXLhMNLQNmVdr4bYi/FREBjUDQBfn9kNlojU5UxX/rNkFwBsQrEexQF+HFeyphfBbiv4iYEI3kodAO2U3WxJRpHXiHwGSSS0MIu5uu6m/TZf4viP8JGgnAO1L8I8c2Uc4gzGiOsOf+cptfgARdaIJOyHxQfuMlg/gKCCFGCoawe0W5zC9FIhf9uOf3VMB4QrntYEZUCAJh78YpLZCIWYIYo6u6XecVld1FwrOgCc+3TI15eACJfPXI2y1sRqkGCkcTIfTUT9b8XUhkq41/cgYaT8g7kgjhwqs3a/52xFwiJjhTTHkmm7fyT0GMGIgGnpmo+dlIdMym2A2ja2e8cau1EHarELyAsO9/EwlgJTHRIGTWV4t5q8x7YAbVUujrHK/5/yMmBwAGctuqzbxVdjMQ6hBW3rjFhb3EFE5Uq3mrQrtulDzgn2MF8CQxZqhUa1udS0Fc1JKuG+OAIx3E5Bur3byVd1gXRB+T+XOpAB5UnV5azNtdwQxDTHD23VIBbCHGbU6LeSv3c2IwmRH0WQH4NyI+AJK1e36qVAsS6oL4iA7gFVv529Nm3kqf5KOBHTqAb2zx+zS9AbjNehkMxObnAi4xmQ3pDaDoDaMnWf91gEU2ld/Sat4q7CGGsPdlB3iWmOB0+gMoHNNH5W0OUEeMdzD9AbhfoPqdNgc4QUy2If0B5BuJwYxccADb/mbq0h9Atl63xXkH+NYG8H5qjVvV6mbId4A2Yux8P90SLw4gcoCjNoBNt0gAubgPKAZAqy2CH94KAdgpkYShAxyyAWy+tWqAyY84QIsNoD79AWQ26XsG5xzAboz5/ekPILdbnwiLjRCriPE70h+A97UK4NIuB7g7OQpLtcJf9Zj8+XgU3p/y47CVnhDHI3Jgp60Dn6V4/W8nBpPt1xOh54jxv0tvAP4P+iC0WwdwB+ihSE1Kh6IF/dZ4saMBzhHjNqV8HpgbBmYlA3idGDOcstF4DUT9ev+vcZIA84EBYtwvU/Trt6Cv3AL/cUqhmyJMJiUvR9eDZHX1rxvr7fCfgPPEeIdTMARt02NwD/iHMxbACn0XsKqHJLldgNGnv9fGNK9elJxW/XIlr8VN7qK1yWjzfcA8ZzwAC4ERdTew+qp+aHd1JAyRaKEzEYDH9PND4XgVdXzfo0H85c7NAKxG47VWgfmOhPlCw+S+C4B6NP6PxSapOsyb7D5gzlR8ANWKJuwtFpmZdREq6Ex+VtM0NV+d2RDqE/9BcZupvPlsg73/Yyv+rikzn1gOqwCDJvi5Qr1CDXiHEtdejCCFN6z5MgAsQWQkUWWLs7bpa53zjRANgsa4V5DwIWc6ABYAp0histc/mvqoPL947mO7v2vMaBMw35lOgDnAMqAXjS6UbvPkZ4y5rcUple7q9FrvRMyjTsWwB6jViAyTRM8XgjPgtRYLZ7FmXA+mVk2f1l3/eHLvteUU/ARmiJKY3HnEf0IPNSoO8HfgbWCQCRMBwphIFGCyBxGztPLGb7w0HgbWAD1MBjEB4rUATwF/daoKu3XeCywH3gR2AO2IDCEyikTDSDCEhBeRqAsxB4C3gKeBhcBcp8z8DjRUCbmVu2RWAAAAAElFTkSuQmCC";break;case h.RADIUS:l.imageSource="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFl0lEQVR4AeWbS2xV1RrHN4+E+wj33tx7B/ehAwcYHIhGEzUMHBhDNMGR0TgD4oORCWLiRGNMfAylUIQqYkN5a4nysLVCsIhQqqGKYmis0FJooA9Lex57n/1Y309OYGd92TmWlvb09Gx+yX9I6P9/9vrWt769tlNugDnAYuAFxLyDeHuuqgMJ+hExiESIP4xxf8HkjyCFrYh5CVgEzHaqEWAe8DjiNyDhKDeL+AXMlTbEKwbyr2owfh/i7UMib5wGgYhxIZEhunyMsHvJTDR+J1I4wB8R9YN/Etz9kNsJ2c0wWntVa64pswGyWyDfCG4zFI5D1AcIJTFXLhMNLQNmVdr4bYi/FREBjUDQBfn9kNlojU5UxX/rNkFwBsQrEexQF+HFeyphfBbiv4iYEI3kodAO2U3WxJRpHXiHwGSSS0MIu5uu6m/TZf4viP8JGgnAO1L8I8c2Uc4gzGiOsOf+cptfgARdaIJOyHxQfuMlg/gKCCFGCoawe0W5zC9FIhf9uOf3VMB4QrntYEZUCAJh78YpLZCIWYIYo6u6XecVld1FwrOgCc+3TI15eACJfPXI2y1sRqkGCkcTIfTUT9b8XUhkq41/cgYaT8g7kgjhwqs3a/52xFwiJjhTTHkmm7fyT0GMGIgGnpmo+dlIdMym2A2ja2e8cau1EHarELyAsO9/EwlgJTHRIGTWV4t5q8x7YAbVUujrHK/5/yMmBwAGctuqzbxVdjMQ6hBW3rjFhb3EFE5Uq3mrQrtulDzgn2MF8CQxZqhUa1udS0Fc1JKuG+OAIx3E5Bur3byVd1gXRB+T+XOpAB5UnV5azNtdwQxDTHD23VIBbCHGbU6LeSv3c2IwmRH0WQH4NyI+AJK1e36qVAsS6oL4iA7gFVv529Nm3kqf5KOBHTqAb2zx+zS9AbjNehkMxObnAi4xmQ3pDaDoDaMnWf91gEU2ld/Sat4q7CGGsPdlB3iWmOB0+gMoHNNH5W0OUEeMdzD9AbhfoPqdNgc4QUy2If0B5BuJwYxccADb/mbq0h9Atl63xXkH+NYG8H5qjVvV6mbId4A2Yux8P90SLw4gcoCjNoBNt0gAubgPKAZAqy2CH94KAdgpkYShAxyyAWy+tWqAyY84QIsNoD79AWQ26XsG5xzAboz5/ekPILdbnwiLjRCriPE70h+A97UK4NIuB7g7OQpLtcJf9Zj8+XgU3p/y47CVnhDHI3Jgp60Dn6V4/W8nBpPt1xOh54jxv0tvAP4P+iC0WwdwB+ihSE1Kh6IF/dZ4saMBzhHjNqV8HpgbBmYlA3idGDOcstF4DUT9ev+vcZIA84EBYtwvU/Trt6Cv3AL/cUqhmyJMJiUvR9eDZHX1rxvr7fCfgPPEeIdTMARt02NwD/iHMxbACn0XsKqHJLldgNGnv9fGNK9elJxW/XIlr8VN7qK1yWjzfcA8ZzwAC4ERdTew+qp+aHd1JAyRaKEzEYDH9PND4XgVdXzfo0H85c7NAKxG47VWgfmOhPlCw+S+C4B6NP6PxSapOsyb7D5gzlR8ANWKJuwtFpmZdREq6Ex+VtM0NV+d2RDqE/9BcZupvPlsg73/Yyv+rikzn1gOqwCDJvi5Qr1CDXiHEtdejCCFN6z5MgAsQWQkUWWLs7bpa53zjRANgsa4V5DwIWc6ABYAp0histc/mvqoPL947mO7v2vMaBMw35lOgDnAMqAXjS6UbvPkZ4y5rcUple7q9FrvRMyjTsWwB6jViAyTRM8XgjPgtRYLZ7FmXA+mVk2f1l3/eHLvteUU/ARmiJKY3HnEf0IPNSoO8HfgbWCQCRMBwphIFGCyBxGztPLGb7w0HgbWAD1MBjEB4rUATwF/daoKu3XeCywH3gR2AO2IDCEyikTDSDCEhBeRqAsxB4C3gKeBhcBcp8z8DjRUCbmVu2RWAAAAAElFTkSuQmCC";break;case h.MIN_CORNER:l.imageSource="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFl0lEQVR4AeWbS2xV1RrHN4+E+wj33tx7B/ehAwcYHIhGEzUMHBhDNMGR0TgD4oORCWLiRGNMfAylUIQqYkN5a4nysLVCsIhQqqGKYmis0FJooA9Lex57n/1Y309OYGd92TmWlvb09Gx+yX9I6P9/9vrWt769tlNugDnAYuAFxLyDeHuuqgMJ+hExiESIP4xxf8HkjyCFrYh5CVgEzHaqEWAe8DjiNyDhKDeL+AXMlTbEKwbyr2owfh/i7UMib5wGgYhxIZEhunyMsHvJTDR+J1I4wB8R9YN/Etz9kNsJ2c0wWntVa64pswGyWyDfCG4zFI5D1AcIJTFXLhMNLQNmVdr4bYi/FREBjUDQBfn9kNlojU5UxX/rNkFwBsQrEexQF+HFeyphfBbiv4iYEI3kodAO2U3WxJRpHXiHwGSSS0MIu5uu6m/TZf4viP8JGgnAO1L8I8c2Uc4gzGiOsOf+cptfgARdaIJOyHxQfuMlg/gKCCFGCoawe0W5zC9FIhf9uOf3VMB4QrntYEZUCAJh78YpLZCIWYIYo6u6XecVld1FwrOgCc+3TI15eACJfPXI2y1sRqkGCkcTIfTUT9b8XUhkq41/cgYaT8g7kgjhwqs3a/52xFwiJjhTTHkmm7fyT0GMGIgGnpmo+dlIdMym2A2ja2e8cau1EHarELyAsO9/EwlgJTHRIGTWV4t5q8x7YAbVUujrHK/5/yMmBwAGctuqzbxVdjMQ6hBW3rjFhb3EFE5Uq3mrQrtulDzgn2MF8CQxZqhUa1udS0Fc1JKuG+OAIx3E5Bur3byVd1gXRB+T+XOpAB5UnV5azNtdwQxDTHD23VIBbCHGbU6LeSv3c2IwmRH0WQH4NyI+AJK1e36qVAsS6oL4iA7gFVv529Nm3kqf5KOBHTqAb2zx+zS9AbjNehkMxObnAi4xmQ3pDaDoDaMnWf91gEU2ld/Sat4q7CGGsPdlB3iWmOB0+gMoHNNH5W0OUEeMdzD9AbhfoPqdNgc4QUy2If0B5BuJwYxccADb/mbq0h9Atl63xXkH+NYG8H5qjVvV6mbId4A2Yux8P90SLw4gcoCjNoBNt0gAubgPKAZAqy2CH94KAdgpkYShAxyyAWy+tWqAyY84QIsNoD79AWQ26XsG5xzAboz5/ekPILdbnwiLjRCriPE70h+A97UK4NIuB7g7OQpLtcJf9Zj8+XgU3p/y47CVnhDHI3Jgp60Dn6V4/W8nBpPt1xOh54jxv0tvAP4P+iC0WwdwB+ihSE1Kh6IF/dZ4saMBzhHjNqV8HpgbBmYlA3idGDOcstF4DUT9ev+vcZIA84EBYtwvU/Trt6Cv3AL/cUqhmyJMJiUvR9eDZHX1rxvr7fCfgPPEeIdTMARt02NwD/iHMxbACn0XsKqHJLldgNGnv9fGNK9elJxW/XIlr8VN7qK1yWjzfcA8ZzwAC4ERdTew+qp+aHd1JAyRaKEzEYDH9PND4XgVdXzfo0H85c7NAKxG47VWgfmOhPlCw+S+C4B6NP6PxSapOsyb7D5gzlR8ANWKJuwtFpmZdREq6Ex+VtM0NV+d2RDqE/9BcZupvPlsg73/Yyv+rikzn1gOqwCDJvi5Qr1CDXiHEtdejCCFN6z5MgAsQWQkUWWLs7bpa53zjRANgsa4V5DwIWc6ABYAp0histc/mvqoPL947mO7v2vMaBMw35lOgDnAMqAXjS6UbvPkZ4y5rcUple7q9FrvRMyjTsWwB6jViAyTRM8XgjPgtRYLZ7FmXA+mVk2f1l3/eHLvteUU/ARmiJKY3HnEf0IPNSoO8HfgbWCQCRMBwphIFGCyBxGztPLGb7w0HgbWAD1MBjEB4rUATwF/daoKu3XeCywH3gR2AO2IDCEyikTDSDCEhBeRqAsxB4C3gKeBhcBcp8z8DjRUCbmVu2RWAAAAAElFTkSuQmCC";break;case h.MAX_CORNER:l.imageSource="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFl0lEQVR4AeWbS2xV1RrHN4+E+wj33tx7B/ehAwcYHIhGEzUMHBhDNMGR0TgD4oORCWLiRGNMfAylUIQqYkN5a4nysLVCsIhQqqGKYmis0FJooA9Lex57n/1Y309OYGd92TmWlvb09Gx+yX9I6P9/9vrWt769tlNugDnAYuAFxLyDeHuuqgMJ+hExiESIP4xxf8HkjyCFrYh5CVgEzHaqEWAe8DjiNyDhKDeL+AXMlTbEKwbyr2owfh/i7UMib5wGgYhxIZEhunyMsHvJTDR+J1I4wB8R9YN/Etz9kNsJ2c0wWntVa64pswGyWyDfCG4zFI5D1AcIJTFXLhMNLQNmVdr4bYi/FREBjUDQBfn9kNlojU5UxX/rNkFwBsQrEexQF+HFeyphfBbiv4iYEI3kodAO2U3WxJRpHXiHwGSSS0MIu5uu6m/TZf4viP8JGgnAO1L8I8c2Uc4gzGiOsOf+cptfgARdaIJOyHxQfuMlg/gKCCFGCoawe0W5zC9FIhf9uOf3VMB4QrntYEZUCAJh78YpLZCIWYIYo6u6XecVld1FwrOgCc+3TI15eACJfPXI2y1sRqkGCkcTIfTUT9b8XUhkq41/cgYaT8g7kgjhwqs3a/52xFwiJjhTTHkmm7fyT0GMGIgGnpmo+dlIdMym2A2ja2e8cau1EHarELyAsO9/EwlgJTHRIGTWV4t5q8x7YAbVUujrHK/5/yMmBwAGctuqzbxVdjMQ6hBW3rjFhb3EFE5Uq3mrQrtulDzgn2MF8CQxZqhUa1udS0Fc1JKuG+OAIx3E5Bur3byVd1gXRB+T+XOpAB5UnV5azNtdwQxDTHD23VIBbCHGbU6LeSv3c2IwmRH0WQH4NyI+AJK1e36qVAsS6oL4iA7gFVv529Nm3kqf5KOBHTqAb2zx+zS9AbjNehkMxObnAi4xmQ3pDaDoDaMnWf91gEU2ld/Sat4q7CGGsPdlB3iWmOB0+gMoHNNH5W0OUEeMdzD9AbhfoPqdNgc4QUy2If0B5BuJwYxccADb/mbq0h9Atl63xXkH+NYG8H5qjVvV6mbId4A2Yux8P90SLw4gcoCjNoBNt0gAubgPKAZAqy2CH94KAdgpkYShAxyyAWy+tWqAyY84QIsNoD79AWQ26XsG5xzAboz5/ekPILdbnwiLjRCriPE70h+A97UK4NIuB7g7OQpLtcJf9Zj8+XgU3p/y47CVnhDHI3Jgp60Dn6V4/W8nBpPt1xOh54jxv0tvAP4P+iC0WwdwB+ihSE1Kh6IF/dZ4saMBzhHjNqV8HpgbBmYlA3idGDOcstF4DUT9ev+vcZIA84EBYtwvU/Trt6Cv3AL/cUqhmyJMJiUvR9eDZHX1rxvr7fCfgPPEeIdTMARt02NwD/iHMxbACn0XsKqHJLldgNGnv9fGNK9elJxW/XIlr8VN7qK1yWjzfcA8ZzwAC4ERdTew+qp+aHd1JAyRaKEzEYDH9PND4XgVdXzfo0H85c7NAKxG47VWgfmOhPlCw+S+C4B6NP6PxSapOsyb7D5gzlR8ANWKJuwtFpmZdREq6Ex+VtM0NV+d2RDqE/9BcZupvPlsg73/Yyv+rikzn1gOqwCDJvi5Qr1CDXiHEtdejCCFN6z5MgAsQWQkUWWLs7bpa53zjRANgsa4V5DwIWc6ABYAp0histc/mvqoPL947mO7v2vMaBMw35lOgDnAMqAXjS6UbvPkZ4y5rcUple7q9FrvRMyjTsWwB6jViAyTRM8XgjPgtRYLZ7FmXA+mVk2f1l3/eHLvteUU/ARmiJKY3HnEf0IPNSoO8HfgbWCQCRMBwphIFGCyBxGztPLGb7w0HgbWAD1MBjEB4rUATwF/daoKu3XeCywH3gR2AO2IDCEyikTDSDCEhBeRqAsxB4C3gKeBhcBcp8z8DjRUCbmVu2RWAAAAAElFTkSuQmCC";
}a.highlightAttributes=l,"undefined"!=typeof n&&(a.userProperties.index=n),t.push(a)},d.prototype.computeControlPointDelta=function(t,e,i){var r=t.computePointFromPosition(e.latitude,e.longitude,0,new c(0,0,0)),n=t.computePointFromPosition(i.latitude,i.longitude,0,new c(0,0,0));return r.subtract(n)},d.prototype.createRotationAccessory=function(t,e){var i=new l(null);i.outlineColor=e.imageColor,i.outlineWidth=2;var r=new n([],i);r.altitudeMode=WorldWind.CLAMP_TO_GROUND,r.followTerrain=!0,t.push(r)},d.prototype.updateRotationAccessory=function(t,e,i){i[0].positions=[t,e]},d.prototype.normalizedHeading=function(e,i){var r=e*t.DEGREES_TO_RADIANS+i*t.DEGREES_TO_RADIANS;return Math.abs(r)>t.TWO_PI&&(r%=t.TWO_PI),t.RADIANS_TO_DEGREES*(r>=0?r:r+t.TWO_PI)},d.prototype.deepCopyLocations=function(t){var e=[];if(t.length>0&&Array.isArray(t[0]))for(var r=0,n=t.length;r<n;r++){for(var o=[],s=0,a=t[r].length;s<a;s++)o.push(new i(t[r][s].latitude,t[r][s].longitude));e.push(o)}else for(var r=0,l=t.length;r<l;r++)e.push(new i(t[r].latitude,t[r].longitude));return e},d.prototype.getCenterFromLocations=function(t,e){var i=0,r=new c(0,0,0),n=new c(0,0,0);if(e.length>0&&Array.isArray(e[0]))for(var o=0,s=e.length;o<s;o++)for(var l=0,h=e[o].length;l<h;l++)r.add(t.computePointFromPosition(e[o][l].latitude,e[o][l].longitude,0,n)),i++;else for(var o=0,u=e.length;o<u;o++)r.add(t.computePointFromPosition(e[o].latitude,e[o].longitude,0,n)),i++;return r.divide(i),t.computePositionFromPoint(r[0],r[1],r[2],new a(0,0,0))},d.prototype.getAverageDistance=function(t,e,i){for(var r=t.computePointFromLocation(e.latitude,e.longitude,new c(0,0,0)),n=i.length,o=0,s=new c(0,0,0),a=0;a<n;a++){var l=t.computePointFromLocation(i[a].latitude,i[a].longitude,s).distanceTo(r);o+=l/n}return o/t.equatorialRadius},d.prototype.moveLocation=function(t,e,i,r,n){var o=t.computePointFromPosition(i.latitude,i.longitude,0,new c(0,0,0));return t.computePositionFromPoint(o[0],o[1],o[2],n)},d.prototype.rotateLocations=function(t,e,r,n){var o=this.getCenterFromLocations(t,n),s=i.greatCircleAzimuth(o,r),a=i.greatCircleAzimuth(o,e)-s;if(n.length>0&&Array.isArray(n[0]))for(var l=0,h=n.length;l<h;l++)for(var u=0,c=n[l].length;u<c;u++){var d=i.greatCircleAzimuth(o,n[l][u]),p=i.greatCircleDistance(o,n[l][u]);i.greatCircleLocation(o,d+a,p,n[l][u])}else for(var l=0,f=n.length;l<f;l++){var d=i.greatCircleAzimuth(o,n[l]),p=i.greatCircleDistance(o,n[l]);i.greatCircleLocation(o,d+a,p,n[l])}return a},d.prototype.closestPointOnSegment=function(t,i,r){var n=i.subtract(t),o=new c(0,0,0);o.copy(n);var s=o.normalize(),a=new c(0,0,0);a.copy(r);var l=a.subtract(t).dot(s);return l<0?o.copy(t):l>n.magnitude()?o.copy(i):new e(t,s).pointAt(l,o)},d.prototype.computeShadowPointLocations=function(t,e,r,n){var o=null,s=null;t.pathType===WorldWind.LINEAR?e.position=new i((r.latitude+n.latitude)/2,(r.longitude+n.longitude)/2):t.pathType===WorldWind.RHUMB_LINE?(null==o&&(o=i.rhumbAzimuth(r,n),s=i.rhumbDistance(r,n)),i.rhumbLocation(r,o,.5*s,e.position)):(null==o&&(o=i.greatCircleAzimuth(r,n),s=i.greatCircleDistance(r,n)),i.greatCircleLocation(r,o,.5*s,e.position))},d}),i("util/editor/PlacemarkEditorFragment",["./BaseSurfaceEditorFragment","../../geom/Location","./ShapeEditorConstants","../../shapes/Placemark"],function(t,e,i,r){"use strict";var n=function(){};return n.prototype=Object.create(t.prototype),n.prototype.canHandle=function(t){return t instanceof Function?"Placemark"===t.name:t instanceof r},n.prototype.createShadowShape=function(t){return new r(t.position,null,t.attributes)},n.prototype.getShapeCenter=function(t){return t.position},n.prototype.isRegularShape=function(){return!0},n.prototype.initializeControlElements=function(t,e,r,n,o,s,a){a&&(t.userProperties.purpose=i.DRAG,e.push(t))},n.prototype.updateControlElements=function(t,e,i){i[0].position=t.position},n.prototype.reshape=function(t,e,i,r,n){return!1},n}),i("shapes/SurfaceEllipse",["../geom/Angle","../error/ArgumentError","../geom/Location","../util/Logger","../shapes/ShapeAttributes","../shapes/SurfaceShape","../util/WWMath"],function(t,e,i,r,n,o,s){"use strict";var a=function(t,i,n,s,l){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"SurfaceEllipse","constructor","missingLocation"));if(i<0||n<0)throw new e(r.logMessage(r.LEVEL_SEVERE,"SurfaceEllipse","constructor","Radius is negative."));o.call(this,l),this._center=t,this._majorRadius=i,this._minorRadius=n,this._heading=s,this._intervals=a.DEFAULT_NUM_INTERVALS};return a.prototype=Object.create(o.prototype),Object.defineProperties(a.prototype,{center:{get:function(){return this._center},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._center=t}},majorRadius:{get:function(){return this._majorRadius},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._majorRadius=t}},minorRadius:{get:function(){return this._minorRadius},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._minorRadius=t}},heading:{get:function(){return this._heading},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._heading=t}},intervals:{get:function(){return this._intervals},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._intervals=t}}}),a.staticStateKey=function(t){var e=o.staticStateKey(t);return e+" ce "+t.center.toString()+" ma "+t.majorRadius.toString()+" mi "+t.minorRadius.toString()+" he "+t.heading.toString()+" in "+t.intervals.toString()},a.prototype.computeStateKey=function(){return a.staticStateKey(this)},a.prototype.computeBoundaries=function(e){if(0==this.majorRadius&&0==this.minorRadius)return null;var r=e.globe,n=1+Math.max(a.MIN_NUM_INTERVALS,this.intervals),o=2*Math.PI/(n-1),l=r.radiusAt(this.center.latitude,this.center.longitude);this._boundaries=new Array(n);for(var h=0;h<n;h++){var u=h!=n-1?h*o:0,c=this.majorRadius*Math.cos(u),d=this.minorRadius*Math.sin(u),p=Math.sqrt(c*c+d*d),f=Math.PI/2-(Math.acos(c/p)*s.signum(d)-this.heading*t.DEGREES_TO_RADIANS);this._boundaries[h]=i.greatCircleLocation(this.center,f*t.RADIANS_TO_DEGREES,p/l,new i(0,0))}},a.prototype.getReferencePosition=function(){return this.center},a.prototype.moveTo=function(t,e){this.center=e},a.MIN_NUM_INTERVALS=8,a.DEFAULT_NUM_INTERVALS=64,a}),i("util/editor/SurfaceEllipseEditorFragment",["./BaseSurfaceEditorFragment","../../geom/Location","./ShapeEditorConstants","../../shapes/SurfaceEllipse"],function(t,e,i,r){"use strict";var n=function(){};return n.prototype=Object.create(t.prototype),n.prototype.canHandle=function(t){return t instanceof Function?"SurfaceEllipse"===t.name:t instanceof r},n.prototype.createShadowShape=function(t){return new r(t.center,t.majorRadius,t.minorRadius,t.heading,t.attributes)},n.prototype.getShapeCenter=function(t){return t.center},n.prototype.isRegularShape=function(){return!0},n.prototype.initializeControlElements=function(t,e,r,n,o,s){o&&(this.createControlPoint(e,o,i.WIDTH),this.createControlPoint(e,o,i.HEIGHT)),s&&(this.createControlPoint(e,s,i.ROTATION),this.createRotationAccessory(n,s))},n.prototype.updateControlElements=function(t,r,n,o,s){var a=n.length;if(a>0)for(var l=0;l<a;l++)n[l].userProperties.purpose===i.WIDTH&&(e.greatCircleLocation(t.center,90+t.heading,t.majorRadius/r.equatorialRadius,n[l].position),n[l].userProperties.size=t.majorRadius),n[l].userProperties.purpose===i.HEIGHT&&(e.greatCircleLocation(t.center,t.heading,t.minorRadius/r.equatorialRadius,n[l].position),n[l].userProperties.size=t.minorRadius),n[l].userProperties.purpose===i.ROTATION&&(e.greatCircleLocation(t.center,t.heading,1.6*t.minorRadius/r.equatorialRadius,n[l].position),n[l].userProperties.rotation=t.heading,this.updateRotationAccessory(t.center,n[l].position,s))},n.prototype.reshape=function(t,r,n,o,s){var a=this.computeControlPointDelta(r,o,s),l=this.computeControlPointDelta(r,n.position,t.center).normalize();if(n.userProperties.purpose===i.WIDTH){var h=t.majorRadius+a.dot(l);h>0&&(t.majorRadius=h)}else if(n.userProperties.purpose===i.HEIGHT){var u=t.minorRadius+a.dot(l);u>0&&(t.minorRadius=u)}else if(n.userProperties.purpose===i.ROTATION){var c=e.greatCircleAzimuth(t.center,s),d=e.greatCircleAzimuth(t.center,o)-c;t.heading=this.normalizedHeading(t.heading,d)}},n}),i("shapes/SurfaceCircle",["../error/ArgumentError","../geom/Location","../util/Logger","../shapes/ShapeAttributes","../shapes/SurfaceShape"],function(t,e,i,r,n){"use strict";var o=function(e,r,s){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"SurfaceCircle","constructor","missingLocation"));if(r<0)throw new t(i.logMessage(i.LEVEL_SEVERE,"SurfaceCircle","constructor","Radius is negative"));n.call(this,s),this._center=e,this._radius=r,this._intervals=o.DEFAULT_NUM_INTERVALS};return o.prototype=Object.create(n.prototype),Object.defineProperties(o.prototype,{center:{get:function(){return this._center},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._center=t}},radius:{get:function(){return this._radius},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._radius=t}},intervals:{get:function(){return this._intervals},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._intervals=t}}}),o.staticStateKey=function(t){var e=n.staticStateKey(t);return e+" ce "+t.center.toString()+" ra "+t.radius.toString()},o.prototype.computeStateKey=function(){return o.staticStateKey(this)},o.prototype.computeBoundaries=function(t){if(0===this.radius)return null;var i=1+Math.max(o.MIN_NUM_INTERVALS,this.intervals),r=360/(i-1),n=this.radius/t.globe.radiusAt(this.center.latitude,this.center.longitude);this._boundaries=new Array(i);for(var s=0;s<i;s++){var a=s!==i-1?s*r:0;this._boundaries[s]=e.greatCircleLocation(this.center,a,n,new e(0,0))}},o.prototype.getReferencePosition=function(){return this.center},o.prototype.moveTo=function(t,e){this.center=e},o.MIN_NUM_INTERVALS=8,o.DEFAULT_NUM_INTERVALS=64,o}),i("util/editor/SurfaceCircleEditorFragment",["./BaseSurfaceEditorFragment","../../geom/Location","./ShapeEditorConstants","../../shapes/SurfaceCircle"],function(t,e,i,r){"use strict";var n=function(){};return n.prototype=Object.create(t.prototype),n.prototype.canHandle=function(t){return t instanceof Function?"SurfaceCircle"===t.name:t instanceof r},n.prototype.createShadowShape=function(t){return new r(t.center,t.radius,t.attributes)},n.prototype.getShapeCenter=function(t){return t.center},n.prototype.isRegularShape=function(){return!0},n.prototype.initializeControlElements=function(t,e,r,n,o){o&&this.createControlPoint(e,o,i.RADIUS)},n.prototype.updateControlElements=function(t,i,r){r.length>0&&(e.greatCircleLocation(t.center,90,t.radius/i.equatorialRadius,r[0].position),r[0].userProperties.size=t.radius)},n.prototype.reshape=function(t,e,r,n,o){if(r.userProperties.purpose===i.RADIUS){var s=this.computeControlPointDelta(e,n,o),a=this.computeControlPointDelta(e,r.position,t.center).normalize(),l=t.radius+s.dot(a);l>0&&(t.radius=l)}},n}),i("util/editor/SurfacePolygonEditorFragment",["./BaseSurfaceEditorFragment","../../geom/Location","../../geom/Position","./ShapeEditorConstants","../../shapes/SurfacePolygon","../../geom/Vec3"],function(t,e,i,r,n,o){"use strict";var s=function(){this.currentHeading=0,this.moveControlPointAttributes=null,this.shadowControlPointAttributes=null};return s.prototype=Object.create(t.prototype),s.prototype.canHandle=function(t){return t instanceof Function?"SurfacePolygon"===t.name:t instanceof n},s.prototype.createShadowShape=function(t){return new n(this.deepCopyLocations(t.boundaries),t.attributes)},s.prototype.getShapeCenter=function(t,e){return this.getCenterFromLocations(e,t.boundaries)},s.prototype.isRegularShape=function(){return!1},s.prototype.initializeCreationControlElements=function(t,e,i){var n=this.getLocations(t);this.currentHeading=0,this.moveControlPointAttributes=i;for(var o=0,s=n.length;o<s;o++)this.createControlPoint(e,i,r.LOCATION,o)},s.prototype.initializeControlElements=function(t,e,i,n,o,s,a,l){var h=this.getLocations(t);if(this.currentHeading=0,a){this.moveControlPointAttributes=a,this.shadowControlPointAttributes=l;for(var u=0,c=h.length;u<c;u++)this.createControlPoint(e,a,r.LOCATION,u)}if(s&&(this.createControlPoint(e,s,r.ROTATION),this.createRotationAccessory(n,s)),l)for(var u=0,c=h.length;u<c;u++)this.createControlPoint(i,l,r.SHADOW,u)},s.prototype.updateCreationControlElements=function(t,e,i){for(var n=this.getLocations(t),o=i.length,s=n.length,a=0;a<s;a++)a>=o&&this.createControlPoint(i,this.moveControlPointAttributes,r.LOCATION,a),i[a].position=n[a];o>s&&i.splice(s,o-s)},s.prototype.updateControlElements=function(t,i,n,o,s){for(var a=this.getLocations(t),l=a.length,h=n.length,u=[],c=null,d=h-1;d>-1;d--){if(null!==n[d])if(n[d].userProperties.purpose===r.ROTATION){c=n[d];var p=this.getCenterFromLocations(i,a),f=1.2*this.getAverageDistance(i,p,a);e.greatCircleLocation(p,this.currentHeading,f,c.position),c.userProperties.rotation=this.currentHeading,this.updateRotationAccessory(p,c.position,s)}else u.push(n[d]);n.pop()}u.reverse();for(var g=u.length,d=0;d<l;d++)d>=g&&(this.createControlPoint(u,this.moveControlPointAttributes,r.LOCATION,d),this.createControlPoint(o,this.shadowControlPointAttributes,r.SHADOW,d)),u[d].position=a[d];u.length>l&&(u.splice(l,u.length-l),o.splice(l,o.length-l));for(var d=0;d<u.length;d++)n.push(u[d]);if(t.boundaries.length>0&&Array.isArray(t.boundaries[0]))for(var m=0,d=0,y=t.boundaries.length;d<y;d++)for(var E=0,v=t.boundaries[d].length-1;E<v;E++)this.computeShadowPointLocations(t,o[m],t.boundaries[d][E],t.boundaries[d][E+1]),E==v-1&&(this.computeShadowPointLocations(t,o[m+1],t.boundaries[d][E+1],t.boundaries[d][0]),m+=1),m+=1;else for(var d=0;d<n.length-1;d++)this.computeShadowPointLocations(t,o[d],a[d],a[d+1]),d==n.length-2&&this.computeShadowPointLocations(t,o[d+1],a[d+1],a[0]);null!==c&&n.push(c)},s.prototype.reshape=function(t,e,i,o,s,a){var l=this.getLocations(t);if(i.userProperties.purpose===r.ROTATION){var h=this.rotateLocations(e,o,s,l);this.currentHeading=this.normalizedHeading(this.currentHeading,h),t.resetBoundaries(),t._stateId=n.stateId++,t.stateKeyInvalid=!0}else if(i.userProperties.purpose===r.LOCATION||i.userProperties.purpose===r.SHADOW){var u=i.userProperties.index,c=t.boundaries,d=c.length,p=this.getRingAndLocationIndex(t,u);if(a)if(p.ringIndex!==-1){var f=c[p.ringIndex];f.length>3?f.splice(p.locationIndex,1):d>2&&c.splice(p.ringIndex,1)}else c.length>3&&c.splice(u,1);else i.userProperties.purpose===r.SHADOW?p.ringIndex!==-1?this.moveLocation(e,i,s,o,c[p.ringIndex][p.locationIndex+1]):this.moveLocation(e,i,s,o,l[u+1]):this.moveLocation(e,i,s,o,l[u]);t.resetBoundaries(),t._stateId=n.stateId++,t.stateKeyInvalid=!0}},s.prototype.getRingAndLocationIndex=function(t,e){var i=t.boundaries,r=i.length,n={locationIndex:-1,ringIndex:-1};if(r>0&&Array.isArray(t.boundaries[0]))for(var o=0,s=0;s<r&&n.ringIndex==-1;s++){var a=i[s].length;o+a>e&&(n.ringIndex=s,n.locationIndex=e-o),o+=a}return n},s.prototype.convertShadowControlPoint=function(t,e,i,r){var o=t.boundaries,s=this.getRingAndLocationIndex(t,i);s.ringIndex!==-1?o[s.ringIndex].splice(s.locationIndex+1,0,r):o.splice(i+1,0,r),t.resetBoundaries(),t._stateId=n.stateId++,t.stateKeyInvalid=!0},s.prototype.addNewVertex=function(t,e,r){var s=new o(0,0,0),a=new o(0,0,0),l=new o(0,0,0),h=t.boundaries,u=e.computePointFromPosition(r.latitude,r.longitude,0,new o(0,0,0)),c=new o(0,0,0),d=-1,p=Number.MAX_VALUE;if(Array.isArray(t.boundaries[0])){for(var f=-1,g=0,m=h.length;g<m;g++)for(var y=1,E=h[g].length;y<=E;y++){var v=h[g][y-1],_=h[g][y==E?0:y];e.computePointFromPosition(v.latitude,v.longitude,0,s),e.computePointFromPosition(_.latitude,_.longitude,0,a),l.copy(u),l=this.closestPointOnSegment(s,a,u);var b=l.distanceTo(u);b<p&&(c.copy(l),f=g,d=y,p=b)}var w=e.computePositionFromPoint(c[0],c[1],c[2],new i(0,0,0));d==h[f].length?h[f].push(w):h[f].splice(d,0,w),t.resetBoundaries(),t._stateId=n.stateId++,t.stateKeyInvalid=!0}else{for(var g=1,S=h.length;g<=S;g++){var v=h[g-1],_=h[g==S?0:g];e.computePointFromPosition(v.latitude,v.longitude,0,s),e.computePointFromPosition(_.latitude,_.longitude,0,a),l.copy(u),l=this.closestPointOnSegment(s,a,u);var b=l.distanceTo(u);b<p&&(c.copy(l),d=g,p=b)}var w=e.computePositionFromPoint(c[0],c[1],c[2],new i(0,0,0));d==h.length?h.push(w):h.splice(d,0,w),t.resetBoundaries(),t._stateId=n.stateId++,t.stateKeyInvalid=!0}},s.prototype.createNewVertex=function(t,i,r){var o=t.boundaries;o.push(new e(r.latitude,r.longitude)),t.resetBoundaries(),t._stateId=n.stateId++,t.stateKeyInvalid=!0},s.prototype.getLocations=function(t){var e=[];if(t.boundaries.length>0&&Array.isArray(t.boundaries[0]))for(var i=0,r=t.boundaries.length;i<r;i++)for(var n=0,o=t.boundaries[i].length;n<o;n++)e.push(t.boundaries[i][n]);else for(var i=0,s=t.boundaries.length;i<s;i++)e.push(t.boundaries[i]);return e},s}),i("util/editor/SurfacePolylineEditorFragment",["./BaseSurfaceEditorFragment","../../geom/Location","../../geom/Position","./ShapeEditorConstants","../../shapes/SurfacePolyline","../../geom/Vec3"],function(t,e,i,r,n,o){"use strict";var s=function(){this.currentHeading=0,this.moveControlPointAttributes=null,this.shadowControlPointAttributes=null};return s.prototype=Object.create(t.prototype),s.prototype.canHandle=function(t){return t instanceof Function?"SurfacePolyline"===t.name:t instanceof n},s.prototype.createShadowShape=function(t){return new n(this.deepCopyLocations(t.boundaries),t.attributes)},s.prototype.getShapeCenter=function(t,e){return this.getCenterFromLocations(e,t.boundaries)},s.prototype.isRegularShape=function(){return!1},s.prototype.initializeCreationControlElements=function(t,e,i){this.currentHeading=0,this.moveControlPointAttributes=i;for(var n=t.boundaries,o=0,s=n.length;o<s;o++)this.createControlPoint(e,i,r.LOCATION,o)},s.prototype.initializeControlElements=function(t,e,i,n,o,s,a,l){if(this.currentHeading=0,a){this.moveControlPointAttributes=a,this.shadowControlPointAttributes=l;for(var h=t.boundaries,u=0,c=h.length;u<c;u++)this.createControlPoint(e,a,r.LOCATION,u)}if(s&&(this.createControlPoint(e,s,r.ROTATION),this.createRotationAccessory(n,s)),l)for(var u=0,c=h.length-1;u<c;u++)this.createControlPoint(i,l,r.SHADOW,u)},s.prototype.updateCreationControlElements=function(t,e,i){for(var n=t.boundaries,o=i.length,s=n.length,a=0;a<s;a++)a>=o&&this.createControlPoint(i,this.moveControlPointAttributes,r.LOCATION,a),i[a].position=n[a];o>s&&i.splice(s,o-s)},s.prototype.updateControlElements=function(t,i,n,o,s){for(var a=t.boundaries,l=a.length,h=n.length,u=[],c=null,d=h-1;d>-1;d--){if(null!==n[d])if(n[d].userProperties.purpose===r.ROTATION){c=n[d];var p=this.getCenterFromLocations(i,a),f=1.2*this.getAverageDistance(i,p,a);e.greatCircleLocation(p,this.currentHeading,f,c.position),c.userProperties.rotation=this.currentHeading,this.updateRotationAccessory(p,c.position,s)}else u.push(n[d]);n.pop()}u.reverse();for(var g=u.length,d=0;d<l;d++)d>=g&&(this.createControlPoint(u,this.moveControlPointAttributes,r.LOCATION,d),this.createControlPoint(o,this.shadowControlPointAttributes,r.SHADOW,d-1)),u[d].position=a[d];u.length>l&&(u.splice(l,u.length-l),o.splice(l-1,o.length-l-1));for(var d=0;d<u.length;d++)n.push(u[d]);for(var d=0;d<n.length-1;d++)this.computeShadowPointLocations(t,o[d],a[d],a[d+1]);null!==c&&n.push(c)},s.prototype.reshape=function(t,e,i,o,s,a){var l=t.boundaries;if(i.userProperties.purpose===r.ROTATION){var h=this.rotateLocations(e,o,s,l);this.currentHeading=this.normalizedHeading(this.currentHeading,h),t.resetBoundaries(),t._stateId=n.stateId++,t.stateKeyInvalid=!0}else if(i.userProperties.purpose===r.LOCATION||i.userProperties.purpose===r.SHADOW){var u=i.userProperties.index;a?l.length>2&&l.splice(u,1):i.userProperties.purpose===r.SHADOW?this.moveLocation(e,i,s,o,l[u+1]):this.moveLocation(e,i,s,o,l[u]),t.resetBoundaries(),t._stateId=n.stateId++,t.stateKeyInvalid=!0}},s.prototype.convertShadowControlPoint=function(t,e,i,r){var o=t.boundaries;o.splice(i+1,0,r),t.resetBoundaries(),t._stateId=n.stateId++,t.stateKeyInvalid=!0},s.prototype.addNewVertex=function(t,e,r){for(var s=new o(0,0,0),a=new o(0,0,0),l=new o(0,0,0),h=t.boundaries,u=e.computePointFromPosition(r.latitude,r.longitude,0,new o(0,0,0)),c=new o(0,0,0),d=-1,p=Number.MAX_VALUE,f=1,g=h.length;f<g;f++){var m=h[f-1],y=h[f];e.computePointFromPosition(m.latitude,m.longitude,0,s),e.computePointFromPosition(y.latitude,y.longitude,0,a),l.copy(u),l=this.closestPointOnSegment(s,a,u);var E=l.distanceTo(u);E<p&&(c.copy(l),d=f,p=E)}var v=e.computePositionFromPoint(c[0],c[1],c[2],new i(0,0,0));d==h.length?h.push(v):h.splice(d,0,v),t.resetBoundaries(),t._stateId=n.stateId++,t.stateKeyInvalid=!0},s.prototype.createNewVertex=function(t,i,r){var o=t.boundaries;o.push(new e(r.latitude,r.longitude)),t.resetBoundaries(),t._stateId=n.stateId++,t.stateKeyInvalid=!0},s}),i("shapes/SurfaceRectangle",["../geom/Angle","../error/ArgumentError","../geom/Location","../util/Logger","../shapes/ShapeAttributes","../shapes/SurfaceShape","../util/WWMath"],function(t,e,i,r,n,o,s){"use strict";var a=function(t,i,n,s,a){if(!t)throw new e(r.logMessage(r.LEVEL_SEVERE,"SurfaceRectangle","constructor","missingLocation"));if(i<0||n<0)throw new e(r.logMessage(r.LEVEL_SEVERE,"SurfaceRectangle","constructor","Size is negative."));o.call(this,a),this._center=t,this._width=i,this._height=n,this._heading=s};return a.prototype=Object.create(o.prototype),Object.defineProperties(a.prototype,{center:{get:function(){return this._center},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._center=t}},width:{get:function(){return this._width},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._width=t}},height:{get:function(){return this._height},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._height=t}},heading:{get:function(){return this._heading},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._heading=t}}}),a.staticStateKey=function(t){var e=o.staticStateKey(t);return e+" ce "+t.center.toString()+" wi "+t.width.toString()+" he "+t.height.toString()+" hd "+t.heading.toString()},a.prototype.computeStateKey=function(){return a.staticStateKey(this)},a.prototype.computeBoundaries=function(t){var e=.5*this.width,i=.5*this.height,r=t.globe.radiusAt(this.center.latitude,this.center.longitude);this._boundaries=new Array(4),this.addLocation(0,-e,-i,r),this.addLocation(1,e,-i,r),this.addLocation(2,e,i,r),this.addLocation(3,-e,i,r)},a.prototype.addLocation=function(e,r,n,o){var a=Math.sqrt(r*r+n*n),l=Math.PI/2-(Math.acos(r/a)*s.signum(n)-this.heading*t.DEGREES_TO_RADIANS);this._boundaries[e]=i.greatCircleLocation(this.center,l*t.RADIANS_TO_DEGREES,a/o,new i(0,0))},a.prototype.getReferencePosition=function(){return this.center},a.prototype.moveTo=function(t,e){this.center=this.computeShiftedLocations(t,this.getReferencePosition(),e,[this.center])[0]},a}),i("util/editor/SurfaceRectangleEditorFragment",["./BaseSurfaceEditorFragment","../../geom/Location","./ShapeEditorConstants","../../shapes/SurfaceRectangle"],function(t,e,i,r){"use strict";var n=function(){};return n.prototype=Object.create(t.prototype),n.prototype.canHandle=function(t){return t instanceof Function?"SurfaceRectangle"===t.name:t instanceof r},n.prototype.createShadowShape=function(t){return new r(t.center,t.width,t.height,t.heading,t.attributes)},n.prototype.getShapeCenter=function(t){return t.center},n.prototype.isRegularShape=function(){return!0},n.prototype.initializeControlElements=function(t,e,r,n,o,s){o&&(this.createControlPoint(e,o,i.WIDTH),this.createControlPoint(e,o,i.HEIGHT)),s&&(this.createControlPoint(e,s,i.ROTATION),this.createRotationAccessory(n,s))},n.prototype.updateControlElements=function(t,r,n,o,s){var a=n.length;if(a>0)for(var l=0;l<a;l++)n[l].userProperties.purpose===i.WIDTH&&(e.greatCircleLocation(t.center,90+t.heading,.5*t.width/r.equatorialRadius,n[l].position),n[l].userProperties.size=t.width),n[l].userProperties.purpose===i.HEIGHT&&(e.greatCircleLocation(t.center,t.heading,.5*t.height/r.equatorialRadius,n[l].position),n[l].userProperties.size=t.height),n[l].userProperties.purpose===i.ROTATION&&(e.greatCircleLocation(t.center,t.heading,.8*t.height/r.equatorialRadius,n[l].position),n[l].userProperties.rotation=t.heading,this.updateRotationAccessory(t.center,n[l].position,s))},n.prototype.reshape=function(t,r,n,o,s){var a=this.computeControlPointDelta(r,o,s),l=this.computeControlPointDelta(r,n.position,t.center).normalize();if(n.userProperties.purpose===i.WIDTH){var h=t.width+2*a.dot(l);h>0&&(t.width=h)}else if(n.userProperties.purpose===i.HEIGHT){var u=t.height+2*a.dot(l);u>0&&(t.height=u)}else if(n.userProperties.purpose===i.ROTATION){var c=e.greatCircleAzimuth(t.center,s),d=e.greatCircleAzimuth(t.center,o)-c;t.heading=this.normalizedHeading(t.heading,d)}},n}),i("shapes/SurfaceSector",["../error/ArgumentError","../geom/Location","../util/Logger","../shapes/ShapeAttributes","../shapes/SurfaceShape"],function(t,e,i,r,n){"use strict";var o=function(e,r){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"SurfaceSector","constructor","missingSector"));n.call(this,r),this._sector=e,this._pathType=WorldWind.LINEAR};return o.prototype=Object.create(n.prototype),Object.defineProperties(o.prototype,{sector:{get:function(){return this._sector},set:function(t){this.stateKeyInvalid=!0,this.resetBoundaries(),this._sector=t}}}),o.staticStateKey=function(t){var e=n.staticStateKey(t);return e},o.prototype.computeStateKey=function(){return o.staticStateKey(this)},o.prototype.computeBoundaries=function(t){var i=this._sector;this._boundaries=new Array(4),this._boundaries[0]=new e(i.minLatitude,i.minLongitude),this._boundaries[1]=new e(i.maxLatitude,i.minLongitude),this._boundaries[2]=new e(i.maxLatitude,i.maxLongitude),this._boundaries[3]=new e(i.minLatitude,i.maxLongitude)},o.prototype.getReferencePosition=function(){return new e(this.sector.centroidLatitude(),this.sector.centroidLongitude())},o.prototype.moveTo=function(t,i){var r=this._sector,n=new Array(3);n[0]=new e(r.minLatitude,r.minLongitude),n[1]=new e(r.maxLatitude,r.minLongitude),n[2]=new e(r.maxLatitude,r.maxLongitude),n=this.computeShiftedLocations(t,this.getReferencePosition(),i,n),this.sector=new WorldWind.Sector(n[0].latitude,n[1].latitude,n[1].longitude,n[2].longitude)},o}),i("util/editor/SurfaceSectorEditorFragment",["./BaseSurfaceEditorFragment","../../geom/Location","../../geom/Position","../../geom/Sector","./ShapeEditorConstants","../../shapes/SurfaceSector"],function(t,e,i,r,n,o){"use strict";var s=function(){};return s.prototype=Object.create(t.prototype),s.prototype.canHandle=function(t){return t instanceof Function?"SurfaceSector"===t.name:t instanceof o},s.prototype.createShadowShape=function(t){return new o(new r(t._boundaries[0].latitude,t._boundaries[1].latitude,t._boundaries[0].longitude,t._boundaries[2].longitude),t.attributes)},s.prototype.getShapeCenter=function(t,e){return this.getCenterFromLocations(e,t._boundaries)},s.prototype.isRegularShape=function(){return!0},s.prototype.initializeControlElements=function(t,e,i,r,o){o&&(this.createControlPoint(e,o,n.MIN_CORNER),this.createControlPoint(e,o,n.MAX_CORNER))},s.prototype.updateControlElements=function(t,i,r){r.length>0&&(r[0].position=new e(t._sector.minLatitude,t._sector.minLongitude),r[1].position=new e(t._sector.maxLatitude,t._sector.maxLongitude))},s.prototype.reshape=function(t,e,i,o,s){i.userProperties.purpose===n.MIN_CORNER?t.sector=new r(o.latitude,t._sector.maxLatitude,o.longitude,t._sector.maxLongitude):i.userProperties.purpose===n.MAX_CORNER&&(t.sector=new r(t._sector.minLatitude,o.latitude,t._sector.minLongitude,o.longitude))},s}),i("util/editor/ShapeEditor",["../../shapes/Annotation","../../shapes/AnnotationAttributes","../../error/ArgumentError","../Color","../Font","../Insets","../../geom/Location","../Logger","../../shapes/Placemark","../../shapes/PlacemarkAttributes","./PlacemarkEditorFragment","../../geom/Position","../../layer/RenderableLayer","../../shapes/ShapeAttributes","./ShapeEditorConstants","./SurfaceEllipseEditorFragment","./SurfaceCircleEditorFragment","../../shapes/SurfacePolygon","../../shapes/SurfacePolyline","./SurfacePolygonEditorFragment","./SurfacePolylineEditorFragment","./SurfaceRectangleEditorFragment","./SurfaceSectorEditorFragment","../../geom/Vec2","../../geom/Vec3"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_,b,w,S,L){"use strict";var T=function(t){if(!t)throw new i(a.logMessage(a.LEVEL_SEVERE,"ShapeEditor","constructor","missingWorldWindow"));this._worldWindow=t,this._shape=null,this._allowMove=!0,this._allowReshape=!0,this._allowRotate=!0,this._allowManageControlPoint=!0,this._highlightedItems=[],this._moveControlPointAttributes=new h(null),this._moveControlPointAttributes.imageSource="data:image/png;base64,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",this._moveControlPointAttributes.imageScale=.15,this._shadowControlPointAttributes=new h(null),this._shadowControlPointAttributes.imageSource="data:image/png;base64,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",
this._shadowControlPointAttributes.imageScale=.15,this._resizeControlPointAttributes=new h(null),this._resizeControlPointAttributes.imageSource="data:image/png;base64,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",this._resizeControlPointAttributes.imageScale=.15,this._rotateControlPointAttributes=new h(null),this._rotateControlPointAttributes.imageColor=WorldWind.Color.GREEN,this._rotateControlPointAttributes.imageSource="data:image/png;base64,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",this._rotateControlPointAttributes.imageScale=.15,this._annotationAttributes=new e(null),this._annotationAttributes.altitudeMode=WorldWind.CLAMP_TO_GROUND,this._annotationAttributes.cornerRadius=5,this._annotationAttributes.backgroundColor=new r(.67,.67,.67,.8),this._annotationAttributes.leaderGapHeight=0,this._annotationAttributes.drawLeader=!1,this._annotationAttributes.scale=1,this._annotationAttributes.textAttributes.color=r.BLACK,this._annotationAttributes.textAttributes.font=new n(10),this._annotationAttributes.insets=new o(5,5,5,5),this.annotation=new WorldWind.Annotation(new WorldWind.Position(0,0,0),this._annotationAttributes),this.editorFragments=[new u,new m,new g,new v,new _,new b,new w],this.controlPointsLayer=new d("Shape Editor Control Points"),this.shadowControlPointsLayer=new d("Shape Editor Shadow Control Points"),this.accessoriesLayer=new d("Shape Editor Accessories"),this.accessoriesLayer.pickEnabled=!1,this.annotationLayer=new d("Shape Editor Annotation"),this.annotationLayer.pickEnabled=!1,this.annotationLayer.enabled=!1,this.annotationLayer.addRenderable(this.annotation),this.shadowShapeLayer=new d("Shape Editor Shadow Shape"),this.shadowShapeLayer.pickEnabled=!1,this.creatorShapeLayer=new d("Shape Creator Initial Shape"),this.creatorShapeLayer.pickEnabled=!1,this.activeEditorFragment=null,this.actionType=null,this.actionControlPoint=null,this.actionControlPosition=null,this.actionSecondaryBehavior=!1,this.actionCurrentX=null,this.actionCurrentY=null,this.originalHighlightAttributes=new p(null),this.originalPlacemarkHighlightAttributes=new h(null),this._clicked0X=null,this._clicked0Y=null,this._clicked1X=null,this._clicked1Y=null,this._click0Time=0,this._click1Time=0,this._dbclickTimeout=0,this._clickDelay=200,this.creatorEnabled=!1,this.creatorShapeProperties=null,this.promisedShape=null,this._worldWindow.worldWindowController.addGestureListener(this)};return Object.defineProperties(T.prototype,{worldWindow:{get:function(){return this._worldWindow}},shape:{get:function(){return this._shape}},moveControlPointAttributes:{get:function(){return this._moveControlPointAttributes},set:function(t){this._moveControlPointAttributes=t}},shadowControlPointAttributes:{get:function(){return this._shadowControlPointAttributes},set:function(t){this._shadowControlPointAttributes=t}},resizeControlPointAttributes:{get:function(){return this._resizeControlPointAttributes},set:function(t){this._resizeControlPointAttributes=t}},rotateControlPointAttributes:{get:function(){return this._rotateControlPointAttributes},set:function(t){this._rotateControlPointAttributes=t}},annotationAttributes:{get:function(){return this._annotationAttributes},set:function(t){this._annotationAttributes=t,this.annotation.attributes=t}}}),T.prototype.create=function(t,e){var i,r;this.stop(),this.setCreatorEnabled(!0);for(var n=0,o=this.editorFragments.length;n<o;n++){var s=this.editorFragments[n];s.canHandle(t)&&(this.activeEditorFragment=s,this.creatorShapeProperties=e)}if(null!=this.activeEditorFragment){var a=new Promise(function(t,e){i=t,r=e});return a.resolve=i,a.reject=r,this.promisedShape=a,a}return null},T.prototype.isCreatorEnabled=function(){return this.creatorEnabled},T.prototype.setCreatorEnabled=function(t){this.creatorEnabled!=t&&(this.creatorEnabled=t)},T.prototype.edit=function(t,e){this.stop(),this._allowMove=Object.prototype.hasOwnProperty.call(e,"move")?e.move:this._allowMove,this._allowReshape=Object.prototype.hasOwnProperty.call(e,"reshape")?e.reshape:this._allowReshape,this._allowRotate=Object.prototype.hasOwnProperty.call(e,"rotate")?e.rotate:this._allowRotate,this._allowManageControlPoint=Object.prototype.hasOwnProperty.call(e,"manageControlPoint")?e.manageControlPoint:this._allowManageControlPoint,this._allowReshape||(this._allowManageControlPoint=!1);for(var i=0,r=this.editorFragments.length;i<r;i++){var n=this.editorFragments[i];n.canHandle(t)&&(this.activeEditorFragment=n)}return null!=this.activeEditorFragment&&(this._shape=t,this._shape.highlighted=!0,this.initializeControlElements(),!0)},T.prototype.stop=function(){this.removeControlElements(),this.activeEditorFragment=null,this._allowMove=!0,this._allowReshape=!0,this._allowRotate=!0,this._allowManageControlPoint=!0;var t=this._shape;return this._shape=null,null!==t&&(t.highlighted=!1),t},T.prototype.initializeControlElements=function(){var t=this._moveControlPointAttributes,e=this._resizeControlPointAttributes,i=this._rotateControlPointAttributes,r=this._shadowControlPointAttributes;this._allowMove||(t=null),this._allowReshape||(e=null),this._allowRotate||(i=null),this._allowManageControlPoint||(r=null),this._worldWindow.indexOfLayer(this.shadowShapeLayer)==-1&&this._worldWindow.insertLayer(0,this.shadowShapeLayer),this._worldWindow.indexOfLayer(this.creatorShapeLayer)==-1&&this._worldWindow.addLayer(this.creatorShapeLayer),this._worldWindow.indexOfLayer(this.controlPointsLayer)==-1&&this._worldWindow.addLayer(this.controlPointsLayer),this._worldWindow.indexOfLayer(this.shadowControlPointsLayer)==-1&&this._worldWindow.addLayer(this.shadowControlPointsLayer),this._worldWindow.indexOfLayer(this.accessoriesLayer)==-1&&this._worldWindow.addLayer(this.accessoriesLayer),this._worldWindow.indexOfLayer(this.annotationLayer)==-1&&this._worldWindow.addLayer(this.annotationLayer),this.isCreatorEnabled()&&(this.activeEditorFragment instanceof _||this.activeEditorFragment instanceof v)?this.activeEditorFragment.initializeCreationControlElements(this._shape,this.controlPointsLayer.renderables,t):this.activeEditorFragment.initializeControlElements(this._shape,this.controlPointsLayer.renderables,this.shadowControlPointsLayer.renderables,this.accessoriesLayer.renderables,e,i,t,r),this.updateControlElements()},T.prototype.removeControlElements=function(){this._worldWindow.removeLayer(this.controlPointsLayer),this.controlPointsLayer.removeAllRenderables(),this._worldWindow.removeLayer(this.creatorShapeLayer),this.creatorShapeLayer.removeAllRenderables(),this._worldWindow.removeLayer(this.shadowControlPointsLayer),this.shadowControlPointsLayer.removeAllRenderables(),this._worldWindow.removeLayer(this.accessoriesLayer),this.accessoriesLayer.removeAllRenderables(),this._worldWindow.removeLayer(this.shadowShapeLayer),this.shadowShapeLayer.removeAllRenderables(),this._worldWindow.removeLayer(this.annotationLayer)},T.prototype.updateControlElements=function(){this.isCreatorEnabled()&&(this.activeEditorFragment instanceof _||this.activeEditorFragment instanceof v)?this.activeEditorFragment.updateCreationControlElements(this._shape,this._worldWindow.globe,this.controlPointsLayer.renderables):this.activeEditorFragment.updateControlElements(this._shape,this._worldWindow.globe,this.controlPointsLayer.renderables,this.shadowControlPointsLayer.renderables,this.accessoriesLayer.renderables)},T.prototype.onGestureEvent=function(t){(null!==this._shape||this.isCreatorEnabled())&&("pointerup"===t.type||"mouseup"===t.type?this.handleMouseUp(t):"pointerdown"===t.type||"mousedown"===t.type?this.handleMouseDown(t):"pointermove"!==t.type&&"mousemove"!==t.type||this.handleMouseMove(t))},T.prototype.handleMouseDown=function(t){var e=t.clientX,i=t.clientY;this.actionCurrentX=e,this.actionCurrentY=i;var n=this._worldWindow.canvasCoordinates(e,i),o=0;null===this._shape||this.isCreatorEnabled()||(o=this._shape.highlightAttributes.outlineWidth,this._shape.highlightAttributes.outlineWidth=5);var a=this._worldWindow.pick(n);0!==o&&(this._shape.highlightAttributes.outlineWidth=o);var l=a.terrainObject();this._click0Time&&!this._click1Time?(this._clicked1X=e,this._clicked1Y=i,this._click1Time=Date.now()-this._click0Time):(this._clicked0X=e,this._clicked0Y=i,this._click0Time=Date.now(),this._click1Time=0,clearTimeout(this._dbclickTimeout),this._dbclickTimeout=setTimeout(function(){this._click0Time=0},this._clickDelay));for(var c=0,d=a.objects.length;c<d;c++){var f=a.objects[c];if(f.isTerrain||this.isCreatorEnabled()){if(this.isCreatorEnabled()&&null!==this.activeEditorFragment&&null===this._shape){var g=new p(null);g.outlineColor=r.BLACK,g.interiorColor=new r(.8,.9,.9,1),g.outlineWidth=5;var m=new WorldWind.ShapeAttributes(g);if(m.outlineColor=WorldWind.Color.RED,m.outlineWidth=5,this.activeEditorFragment.isRegularShape())if(this.activeEditorFragment instanceof u?this.creatorShapeProperties.position=l.position:this.creatorShapeProperties.center=l.position,this.creatorShapeProperties.radius=3,this.creatorShapeProperties._boundaries=[{latitude:l.position.latitude-.5,longitude:l.position.longitude-.5},{latitude:l.position.latitude+.5,longitude:l.position.longitude-.5},{latitude:l.position.latitude+.5,longitude:l.position.longitude+.5}],this._shape=this.activeEditorFragment.createShadowShape(this.creatorShapeProperties),this.activeEditorFragment instanceof u){var y=new h(null);y.imageSource="data:image/png;base64,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",y.imageScale=1,y.imageColor=r.WHITE,y.drawLeaderLine=!0,y.leaderLineAttributes.outlineColor=r.RED;var E=new h(null);E.imageSource="data:image/png;base64,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",E.imageScale=1,E.imageColor=r.RED,this._shape.attributes=y,this._shape.highlightAttributes=E}else this._shape.attributes=g,this._shape.highlightAttributes=m;else null==this.creatorShapeProperties.boundaries&&(this.creatorShapeProperties.boundaries=[]),this.creatorShapeProperties.boundaries.length<2&&(this.creatorShapeProperties.boundaries.push(new s(l.position.latitude,l.position.longitude)),this.creatorShapeProperties.boundaries.push(new s(l.position.latitude,l.position.longitude)),this._shape=this.editorFragments[4].createShadowShape(this.creatorShapeProperties),this._shape.attributes=g,this._shape.highlightAttributes=m);this._shape.highlighted=!0,this.initializeControlElements(),this.beginAction(l.position,this._allowManageControlPoint,this.controlPointsLayer.renderables[0]),t.preventDefault()}}else{var v=f.userObject;if(v===this._shape){this.beginAction(l.position,this._allowManageControlPoint),t.preventDefault();break}if(this.controlPointsLayer.renderables.indexOf(v)!==-1){this.beginAction(l.position,this._allowManageControlPoint,v),t.preventDefault();break}if(this.shadowControlPointsLayer.renderables.indexOf(v)!==-1){this.beginAction(l.position,this._allowManageControlPoint,v),"shadow"==this.actionType&&this._allowManageControlPoint&&(this.activeEditorFragment.convertShadowControlPoint(this._shape,this._worldWindow.globe,v.userProperties.index,l.position),this.updateControlElements()),t.preventDefault();break}}}},T.prototype.handleMouseMove=function(t){var e=this._highlightedItems.length>0,i=this._worldWindow.canvasCoordinates(t.clientX,t.clientY);this._click0Time&&!this._click1Time&&(this._clicked1X=t.clientX,this._clicked1Y=t.clientY),this._clicked0X===this._clicked1X&&this._clicked0Y===this._clicked1Y||(clearTimeout(this._dbclickTimeout),this._click0Time=0,this._click1Time=0);for(var r=0;r<this._highlightedItems.length;r++)this._highlightedItems[r].highlighted=!1;this._highlightedItems=[];var n=this._worldWindow.pick(this._worldWindow.canvasCoordinates(t.clientX,t.clientY));if(n.objects.length>0&&(e=!0),n.objects.length>0)for(var o=0;o<n.objects.length;o++)!n.objects[o].isTerrain&&n.objects[o].userObject.userProperties.purpose&&(n.objects[o].userObject.highlighted=!0,this._highlightedItems.push(n.objects[o].userObject));if(e&&this._worldWindow.redraw(),this.actionType&&null!==this._shape){var s=this._worldWindow.pickTerrain(i).terrainObject();s&&(this.actionType===f.DRAG?this._allowMove?this.drag(t.clientX,t.clientY):a.logMessage(a.LEVEL_INFO,"ShapeEditor","handleMouseMove","Disabled action for selected shape."):this._allowReshape||this._allowRotate?(this.actionSecondaryBehavior=!1,this.actionControlPoint.highlighted=!0,this.reshape(s.position)):a.logMessage(a.LEVEL_INFO,"ShapeEditor","handleMouseMove","Disabled action for selected shape."),t.preventDefault())}},T.prototype.handleMouseUp=function(t){var e=this._worldWindow.canvasCoordinates(t.clientX,t.clientY),i=this._worldWindow.pickTerrain(e).terrainObject();if(this.isCreatorEnabled()&&null!==this.activeEditorFragment&&null!==this._shape)if(this.activeEditorFragment.isRegularShape())this.setCreatorEnabled(!1),this.promisedShape.resolve(this._shape);else{if(this.activeEditorFragment.createNewVertex(this._shape,this._worldWindow.globe,i.position),this.activeEditorFragment instanceof _){this.updateControlElements();var n=this.controlPointsLayer.renderables.length-1;this.actionControlPoint=this.controlPointsLayer.renderables[n]}if(this.activeEditorFragment instanceof v&&this._shape instanceof E&&3===this._shape.boundaries.length){var o=new p(null);o.outlineColor=r.BLACK,o.interiorColor=new r(.8,.9,.9,1),o.outlineWidth=5;var s=new p(o);s.outlineColor=r.RED,s.outlineWidth=5,this._shape=this.activeEditorFragment.createShadowShape(this._shape),this._shape.attributes=o,this._shape.highlightAttributes=s,this._shape.highlighted=!0,this.initializeControlElements(),this.beginAction(i.position,this._allowManageControlPoint,this.controlPointsLayer.renderables[0])}this.updateControlElements(),this.updateAnnotation(this.actionControlPoint),this._worldWindow.redraw()}if(this.actionType){if(this._click0Time&&this._click1Time){if(this._click1Time<=this._clickDelay&&this.actionControlPoint&&"location"==this.actionType&&i&&this._allowManageControlPoint){if(this.isCreatorEnabled()&&null!==this.activeEditorFragment){
this.activeEditorFragment instanceof _?this._shape.boundaries<2?this._shape=null:(this._shape.boundaries.splice(-2,2),this._shape.boundaries.shift(),this.controlPointsLayer.renderables.pop(),this.updateControlElements(),this.updateAnnotation(this.actionControlPoint),this._worldWindow.redraw()):this.activeEditorFragment instanceof v?this._shape.boundaries<3?this._shape=null:(this._shape.boundaries.pop(),this._shape.boundaries.shift(),this.controlPointsLayer.renderables.pop(),this.updateControlElements(),this.updateAnnotation(this.actionControlPoint),this._worldWindow.redraw()):this._shape=null;var a=this;this.promisedShape.resolve(this._shape),this.promisedShape.then(function(t){a.setCreatorEnabled(!1),a.endAction()}).finally(function(){a.stop()})}this.actionSecondaryBehavior=!0,this.reshape(i.position)}clearTimeout(this._dbclickTimeout),this._click0Time=0,this._click1Time=0}this.isCreatorEnabled()||null===this.activeEditorFragment||this.endAction()}},T.prototype.beginAction=function(t,e,i){i?this.actionType=i.userProperties.purpose:this.actionType=f.DRAG,this.actionControlPoint=i,this.actionControlPosition=t,this.actionSecondaryBehavior=e;var r=null;this.isCreatorEnabled()&&this.creatorShapeLayer.addRenderable(this._shape),this.activeEditorFragment instanceof u?(this.originalHighlightAttributes=null,this.originalPlacemarkHighlightAttributes=this._shape.highlightAttributes,r=new h(this.originalPlacemarkHighlightAttributes),r.imageColor.alpha=.7*r.imageColor.alpha):(this.originalHighlightAttributes=this._shape.highlightAttributes,this.originalPlacemarkHighlightAttributes=null,r=new p(this.originalHighlightAttributes),r.interiorColor.alpha=.7*r.interiorColor.alpha,r.outlineColor.alpha=.7*r.outlineColor.alpha),this._shape.highlightAttributes=r;var n=this.activeEditorFragment.createShadowShape(this._shape);this.activeEditorFragment instanceof u?(n.altitudeMode=WorldWind.CLAMP_TO_GROUND,n.highlightAttributes=new h(this.originalPlacemarkHighlightAttributes)):n.highlightAttributes=new p(this.originalHighlightAttributes),n.highlighted=!0,this.shadowShapeLayer.addRenderable(n),this._worldWindow.redraw()},T.prototype.endAction=function(){this.creatorShapeLayer.removeAllRenderables(),this.shadowShapeLayer.removeAllRenderables(),this.activeEditorFragment instanceof u?this._shape.highlightAttributes=this.originalPlacemarkHighlightAttributes:this._shape.highlightAttributes=this.originalHighlightAttributes,this.hideAnnotation(),this.actionControlPoint&&(this.actionControlPoint.highlighted=!1),this.actionControlPoint=null,this.actionType=null,this.actionControlPosition=null,this._worldWindow.redraw()},T.prototype.reshape=function(t){var e=this.actionControlPoint.userProperties.purpose;(e===f.ROTATION&&this._allowRotate||e!==f.ROTATION&&this._allowReshape||e===f.LOCATION&&this._allowManageControlPoint&&this.actionSecondaryBehavior||e===f.SHADOW&&this._allowManageControlPoint&&this.actionSecondaryBehavior)&&(this.activeEditorFragment.reshape(this._shape,this._worldWindow.globe,this.actionControlPoint,t,this.actionControlPosition,this.actionSecondaryBehavior),this.actionControlPosition=t,this.updateControlElements(),this.updateAnnotation(this.actionControlPoint),this._worldWindow.redraw())},T.prototype.drag=function(t,e){var i=this._shape.getReferencePosition(),r=this._worldWindow.globe.computePointFromPosition(i.latitude,i.longitude,0,new L(0,0,0)),n=new L(0,0,0);this._worldWindow.drawContext.project(r,n);var o=t-this.actionCurrentX,a=e-this.actionCurrentY;this.actionCurrentX=t,this.actionCurrentY=e;var l=n[0]+o,h=this._worldWindow.canvas.height-n[1]+a,u=this._worldWindow.rayThroughScreenPoint(new S(l,h)),d=new L(0,0,0);if(this._worldWindow.globe.intersectsLine(u,d)){var p=new c(0,0,0);this._worldWindow.globe.computePositionFromPoint(d[0],d[1],d[2],p),this._shape.moveTo(this._worldWindow.globe,new s(p.latitude,p.longitude))}this.updateControlElements(),this.updateShapeAnnotation(),this._worldWindow.redraw()},T.prototype.updateAnnotation=function(t){this.annotationLayer.enabled=!0,this.annotation.position=new c(t.position.latitude,t.position.longitude,0);var e;e=void 0!==t.userProperties.size?this.formatLength(t.userProperties.size):void 0!==t.userProperties.rotation?this.formatRotation(t.userProperties.rotation):this.formatLatitude(t.position.latitude)+" "+this.formatLongitude(t.position.longitude),this.annotation.text=e},T.prototype.hideAnnotation=function(t){this.annotationLayer.enabled=!1},T.prototype.updateShapeAnnotation=function(){var t=this.activeEditorFragment.getShapeCenter(this._shape,this._worldWindow.globe),e=new l(new c(t.latitude,t.longitude,0),null);this.updateAnnotation(e)},T.prototype.formatLatitude=function(t){var e=t<0?"°S":"°N";return Math.abs(t).toFixed(4)+e},T.prototype.formatLongitude=function(t){var e=t<0?"°W":"°E";return Math.abs(t).toFixed(4)+e},T.prototype.formatLength=function(t){var e=" km";return Math.abs(t/1e3).toFixed(3)+e},T.prototype.formatRotation=function(t){return t.toFixed(4)+"°"},T}),i("util/ByteBuffer",["../error/ArgumentError","../util/Logger"],function(t,e){"use strict";var i=function(r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"ByteBuffer","constructor","missingArray"));this.array=r,this.data=new DataView(r),this.position=0,this._order=i.LITTLE_ENDIAN};return i.prototype.getByte=function(){var t=this.data.getUint8(this.position);return this.position+=i.BYTE_SIZE,t},i.prototype.getByteArray=function(t){var e=new Uint8Array(this.array,this.position,t);return this.position+=i.BYTE_SIZE*t,e},i.prototype.getInt16=function(){var t=this.data.getInt16(this.position,this._order);return this.position+=i.INT16_SIZE,t},i.prototype.getInt16Array=function(t){var e=new Int16Array(this.array,this.position,t);return this.position+=i.INT16_SIZE*t,e},i.prototype.getInt32=function(){var t=this.data.getInt32(this.position,this._order);return this.position+=i.INT32_SIZE,t},i.prototype.getInt32Array=function(t){var e=new Int32Array(this.array,this.position,t);return this.position+=i.INT32_SIZE*t,e},i.prototype.getFloat=function(){var t=this.data.getFloat32(this.position,this._order);return this.position+=i.FLOAT_SIZE,t},i.prototype.getFloatArray=function(t){var e=new Float32Array(this.array,this.position,t);return this.position+=i.FLOAT_SIZE*t,e},i.prototype.getDouble=function(){var t=this.data.getFloat64(this.position,this._order);return this.position+=i.DOUBLE_SIZE,t},i.prototype.getDoubleArray=function(t){var e;if(this.position%8!=0){var r=this.array.slice(this.position,this.position+t*i.DOUBLE_SIZE);e=new Float64Array(r)}else e=new Float64Array(this.array,this.position,t);return this.position+=i.DOUBLE_SIZE*t,e},i.prototype.skipBytes=function(t){this.position+=t*i.BYTE_SIZE},i.prototype.skipInt16s=function(t){this.position+=t*i.INT16_SIZE},i.prototype.skipInt32s=function(t){this.position+=t*i.INT32_SIZE},i.prototype.skipFloats=function(t){this.position+=t*i.FLOAT_SIZE},i.prototype.skipDoubles=function(t){this.position+=t*i.DOUBLE_SIZE},i.prototype.seek=function(t){this.position=t},i.prototype.order=function(t){this._order=t},i.prototype.limit=function(){return this.data.byteLength},i.prototype.hasRemaining=function(){return this.position<this.data.byteLength},i.BIG_ENDIAN=!1,i.LITTLE_ENDIAN=!0,i.BYTE_SIZE=1,i.INT16_SIZE=2,i.INT32_SIZE=4,i.FLOAT_SIZE=4,i.DOUBLE_SIZE=8,i}),i("formats/shapefile/DBaseField",["../../error/ArgumentError","../../util/ByteBuffer","../../formats/shapefile/DBaseFile","../../util/Logger"],function(t,e,i,r){"use strict";var n=function(e,i){if(!e)throw new t(r.logMessage(r.LEVEL_SEVERE,"DBaseField","constructor","missingAttributeName"));if(!i)throw new t(r.logMessage(r.LEVEL_SEVERE,"DBaseField","constructor","missingBuffer"));this.name=null,this.type=null,this.typeCode=-1,this.length=-1,this.decimals=-1,this.readFieldDescriptor(e,i)};return n.prototype.getName=function(){return this.name},n.prototype.getType=function(){return this.type},n.prototype.getLength=function(){return this.length},n.prototype.getDecimals=function(){return this.decimals},n.prototype.readFieldDescriptor=function(t,i){i.order(e.LITTLE_ENDIAN);var o=i.position;if(this.name=t.readNullTerminatedString(i,n.FIELD_NAME_LENGTH),i.seek(o+n.FIELD_NAME_LENGTH),this.typeCode=String.fromCharCode(i.getByte()),this.type=n.getFieldType(this.typeCode),null==this.type)throw new Error(r.log(r.LEVEL_SEVERE,"Shapefile dBase encountered unsupported field type: "+this.typeCode));i.skipBytes(4),this.length=i.getByte(),this.decimals=i.getByte(),i.seek(o+n.FIELD_DESCRIPTOR_LENGTH)},n.getFieldType=function(t){switch(t){case"C":return n.TYPE_CHAR;case"D":return n.TYPE_DATE;case"F":return n.TYPE_NUMBER;case"L":return n.TYPE_BOOLEAN;case"N":return n.TYPE_NUMBER;default:return null}},n.prototype.toString=function(){return this.name+"("+this.typeCode+")"},n.TYPE_CHAR="DBase.FieldTypeChar",n.TYPE_NUMBER="DBase.FieldTypeNumber",n.TYPE_DATE="DBase.FieldTypeDate",n.TYPE_BOOLEAN="DBase.FieldTypeBoolean",n.FIELD_NAME_LENGTH=11,n.FIELD_DESCRIPTOR_LENGTH=32,n}),i("formats/shapefile/DBaseRecord",["../../error/ArgumentError","../../util/ByteBuffer","../../formats/shapefile/DBaseField","../../formats/shapefile/DBaseFile","../../util/Logger"],function(t,e,i,r,n){"use strict";var o=function(e,i,r){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"DBaseRecord","constructor","missingAttributeName"));if(!i)throw new t(n.logMessage(n.LEVEL_SEVERE,"DBaseRecord","constructor","missingBuffer"));this.deleted=!1,this.recordNumber=r,this.values=null,this.readFromBuffer(e,i,r)};return o.prototype.isDeleted=function(){return this.deleted},o.prototype.getRecordNumber=function(){return this.recordNumber},o.prototype.readFromBuffer=function(t,r,o){r.order(e.LITTLE_ENDIAN),this.recordNumber=o;var s=r.getByte();this.deleted=42==s;var a=t.getFields();this.values={};for(var l=0,h=a.length;l<h;l+=1){var u=a[l],c=u.getName(),d=t.readNullTerminatedString(r,u.getLength()).trim();try{if(u.getType()==i.TYPE_BOOLEAN){var p=d.charAt(0);this.values[c]="t"==p||"T"==p||"Y"==p||"y"==p}else u.getType()==i.TYPE_CHAR?this.values[c]=d:u.getType()==i.TYPE_DATE?this.values[c]=new Date(d):u.getType()==i.TYPE_NUMBER&&(this.values[c]=+d)}catch(t){n.log(n.LEVEL_WARNING,"Shapefile attribute parsing error:"+u.toString()+" -> "+d.toString()+" ["+t+"]")}}},o}),i("formats/shapefile/DBaseFile",["../../error/ArgumentError","../../util/ByteBuffer","../../formats/shapefile/DBaseField","../../formats/shapefile/DBaseRecord","../../util/Logger"],function(t,e,i,r,n){"use strict";var o=function(e){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"DBaseFile","constructor","missingUrl"));this.url=e,this.header=null,this.fields=null,this.buffer=null,this.boolean=!0,this.numRecordsRead=0,this._completionCallback=null};return o.prototype.getLastModificationDate=function(){return this.header.lastModificationDate},o.prototype.getNumberOfRecords=function(){return this.header.numberOfRecords},o.prototype.getHeaderLength=function(){return this.header.headerLength},o.prototype.getRecordLength=function(){return this.header.recordLength},o.prototype.getNumberOfFields=function(){return(this.header.headerLength-1-o.FIXED_HEADER_LENGTH)/o.FIELD_DESCRIPTOR_LENGTH},o.prototype.getFields=function(){return this.fields},o.prototype.hasNext=function(){return this.numRecordsRead<this.header.numberOfRecords},o.prototype.nextRecord=function(){return this.numRecordsRead>=this.getNumberOfRecords()?null:this.readNextRecord(this._buffer,++this.numRecordsRead)},o.prototype.load=function(t){this._completionCallback=t,this.requestUrl(this.url)},o.prototype.requestUrl=function(t){var i=new XMLHttpRequest;i.open("GET",t,!0),i.responseType="arraybuffer",i.onreadystatechange=function(){4===i.readyState&&(200===i.status?(this._buffer=new e(i.response),this.parse(),this._completionCallback&&this._completionCallback(this)):(n.log(n.LEVEL_WARNING,"DBaseFile retrieval failed ("+i.statusText+"): "+t),this._completionCallback&&this._completionCallback(this)))}.bind(this),i.onerror=function(){n.log(n.LEVEL_WARNING,"DBaseFile retrieval failed: "+t),this._completionCallback&&this._completionCallback(this)},i.ontimeout=function(){n.log(n.LEVEL_WARNING,"DBaseFile retrieval timed out: "+t),this._completionCallback&&this._completionCallback(this)},i.send(null)},o.prototype.parse=function(){this.header=this.readHeader(this._buffer),this.fields=this.readFieldDescriptors(this._buffer,this.getNumberOfFields())},o.prototype.readHeader=function(t){var i=t.position;t.order(e.LITTLE_ENDIAN);var r=t.getByte();if(r>5)throw new Error("???");var n=t.getByte(),s=t.getByte(),a=t.getByte(),l=t.getInt32(),h=t.getInt16(),u=t.getInt16(),c={year:1900+n,month:s-1,day:a},d={fileCode:r,lastModificationDate:c,numberOfRecords:l,headerLength:h,recordLength:u};return t.seek(i+o.FIXED_HEADER_LENGTH),d},o.prototype.readFieldDescriptors=function(t,e){for(var r=t.position,n=[],s=0;s<e;s+=1)n[s]=new i(this,t);var a=this.header.headerLength-o.FIXED_HEADER_LENGTH;return t.seek(r+a),n},o.prototype.readNextRecord=function(t,e){return new r(this,t,e)},o.prototype.readNullTerminatedString=function(t,e){if(e<=0)return 0;for(var i="",r=0;r<e;r+=1){var n=t.getByte();if(0==n)break;i+=String.fromCharCode(n)}return this.isStringEmpty(i)?"":i},o.prototype.isStringEmpty=function(t){return t.length<=0||o.isStringFilled(t,32)||o.isStringFilled(t,42)},o.isStringFilled=function(t,e){if(t.length<=0)return!1;for(var i=0;i<t.length;i++)if(t.charAt(i)!=e)return!1;return!0},o.FIXED_HEADER_LENGTH=32,o.FIELD_DESCRIPTOR_LENGTH=32,o}),i("formats/shapefile/PrjFile",["../../error/ArgumentError","../../util/Logger","../../error/NotYetImplementedError"],function(t,e,i){"use strict";var r=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"DBaseFile","constructor","missingUrl"));this._url=i,this._completionCallback=null,this._params=null};return Object.defineProperties(r.prototype,{url:{get:function(){return this._url}},coordinateSystem:{get:function(){return this.params?this.params[r.COORDINATE_SYSTEM]:null}},params:{get:function(){return this._params}}}),r.prototype.load=function(t){this._completionCallback=t,this.requestUrl(this._url)},r.prototype.requestUrl=function(t){var i=new XMLHttpRequest;i.open("GET",t,!0),i.responseType="arraybuffer",i.onreadystatechange=function(){if(4===i.readyState){if(200===i.status){var r=String.fromCharCode.apply(null,new Uint8Array(i.response));this._params=this.decodeOGCCoordinateSystem(r)}else e.log(e.LEVEL_WARNING,"PrjFile retrieval failed ("+i.statusText+"): "+t);this._completionCallback&&this._completionCallback(this)}}.bind(this),i.onerror=function(){e.log(e.LEVEL_WARNING,"PrjFile retrieval failed: "+t),this._completionCallback&&this._completionCallback(this)}.bind(this),i.ontimeout=function(){e.log(e.LEVEL_WARNING,"PrjFile retrieval timed out: "+t),this._completionCallback&&this._completionCallback(this)}.bind(this),i.send(null)},r.prototype.decodeOGCCoordinateSystem=function(n){n||new t(e.logMessage(e.LEVEL_SEVERE,"PrjFile","decodeOGCCoordinateSystem","missingText"));var o={};if(n=n.trim().toUpperCase(),r.GEOGCS_WKT_PATTERN.test(n))o[r.COORDINATE_SYSTEM]=r.COORDINATE_SYSTEM_GEOGRAPHIC;else{var s=n.match(r.PROJCS_WKT_PATTERN);if(s)throw o[PrfFile.COORDINATE_SYSTEM]=r.COORDINATE_SYSTEM_PROJECTED,new i(e.log(e.LEVEL_SEVERE,"PrjFile implementation  for projected coordinate systems in incomplete."));o[r.COORDINATE_SYSTEM]=r.COORDINATE_SYSTEM_UNKNOWN}return o},r.prototype.isUnknownCoordinateSystem=function(){return!this.params||this.params.coordinateSystem===r.COORDINATE_SYSTEM_UNKNOWN},r.prototype.isKnownCoordinateSystem=function(){return!!this.params&&this.params.coordinateSystem!==r.COORDINATE_SYSTEM_UNKNOWN},r.prototype.isGeographicCoordinateSystem=function(){return!!this.params&&this.params.coordinateSystem===r.COORDINATE_SYSTEM_GEOGRAPHIC},r.prototype.isProjectedCoordinateSystem=function(){return!!this.params&&this.params.coordinateSystem===r.COORDINATE_SYSTEM_PROJECTED},r.GEOGCS_WKT_PATTERN=new RegExp("\\{*GEOGCS[\\[\\(](.*)[\\]\\)]\\}*"),r.PROJCS_WKT_PATTERN=new RegExp("\\{*PROJCS[\\[\\(](.*)[\\]\\)]\\}*"),r.UTM_NAME_WKT_PATTERN=new RegExp(".*UTM.*ZONE.*?(\\d+).*?([\\w\\s]+).*?"),r.COORDINATE_SYSTEM="Coordinate_system",r.COORDINATE_SYSTEM_GEOGRAPHIC="Coordinate_system_geographic",r.COORDINATE_SYSTEM_PROJECTED="Coordinate_system_projected",r.COORDINATE_SYSTEM_UNKNOWN="Coordinate_system_unknown",r.PROJECTION_NAME="Projection_name",r.PROJECTION_UTM="Projection_UTM",r.PROJECTION_ZONE="Projection_zone",r.PROJECTION_HEMISPHERE="Projection_hemisphere",r.PROJECTION_HEMISPHERE_NORTH="Projection_hemisphere_north",r.PROJECTION_HEMISPHERE_SOUTH="Projection_hemisphere_south",r}),i("formats/shapefile/ShapefileRecord",["../../geom/Angle","../../error/ArgumentError","../../util/ByteBuffer","../../geom/Location","../../util/Logger","../../formats/shapefile/Shapefile"],function(t,e,i,r,n,o){"use strict";var s=function(t,i){if(!t)throw new e(n.logMessage(n.LEVEL_SEVERE,"ShapefileRecord","constructor","The specified shapefile is null or undefined"));if(!i)throw new e(n.logMessage(n.LEVEL_SEVERE,"ShapefileRecord","constructor","The specified buffer is null or undefined"));this._shapefile=t,this._recordNumber=-1,this._attributes={},this._numberOfParts=0,this._firstPartNumber=0,this._lastPartNumber=0,this._numberOfPoints=0,this._boundingRectangle=[],this._zRange=null,this._zValues=null,this._mRange=null,this._mValues=null,this._contentLengthInBytes=-1,this._buffer=i,this._isNormalized=!1,this._parts=[],this.readRecord()};return Object.defineProperties(s.prototype,{shapefile:{get:function(){return this._shapefile}},recordNumber:{get:function(){return this._recordNumber}},attributes:{get:function(){return this._attributes}},numberOfParts:{get:function(){return this._numberOfParts}},firstPartNumber:{get:function(){return this._firstPartNumber}},lastPartNumber:{get:function(){return this._lastPartNumber}},numberOfPoints:{get:function(){return this._numberOfPoints}},boundingRectangle:{get:function(){return this._boundingRectangle}},zRange:{get:function(){return this._zRange}},zValues:{get:function(){return this._zValues}},mRange:{get:function(){return this._mRange}},mValues:{get:function(){return this._mValues}}}),s.prototype.pointBuffer=function(t){return t>=0&&t<this._parts.length?this._parts[t]:null},s.prototype.readRecord=function(){this.readHeader(),this._buffer.order(i.LITTLE_ENDIAN);var t=this._buffer.getInt32(),e=this.shapefile.getShapeType(t);this.validateShapeType(e),this.readContents()},s.prototype.readHeader=function(){this._buffer.order(i.BIG_ENDIAN),this._recordNumber=this._buffer.getInt32(),this._contentLengthInBytes=2*this._buffer.getInt32()},s.prototype.validateShapeType=function(t){if(t!==this.shapefile.NULL&&t!==this.shapefile.shapeType)throw new Error(n.log(n.LEVEL_SEVERE,"Shapefile record is not supported."))},s.prototype.readNullContents=function(){this._numberOfParts=0,this._numberOfPoints=0,this._parts=null,this._boundingRectangle=null,this._buffer.seek(this._contentLengthInBytes-i.INT32_SIZE)},s.prototype.readPointContents=function(){this._numberOfParts=1,this._firstPartNumber=0,this._lastPartNumber=this._numberOfParts-1,this._numberOfPoints=1,this._parts=[this._buffer.getDoubleArray(2)];var t=this._parts[0][1],e=this._parts[0][0];this._boundingRectangle=[t,t,e,e],this.isZType()&&this.readZ(!0),this.isMeasureType()&&this.readOptionalMeasures(!0)},s.prototype.readPolylineContents=function(){var t=this.shapefile.readBoundingRectangle(this._buffer);if(this._boundingRectangle=t.coords,this._isNormalized=t.isNormalized,this._numberOfParts=this._buffer.getInt32(),this._firstPartNumber=0,this._lastPartNumber=this._numberOfParts-1,this._numberOfPoints=this._buffer.getInt32(),this._numberOfParts>0&&this._numberOfPoints>0)for(var e=this._buffer.getInt32Array(this.numberOfParts),i=0;i<this.numberOfParts;i+=1){var r=i==this.numberOfParts-1?this._numberOfPoints-e[i]:e[i+1]-e[i];this._parts[i]=this._buffer.getDoubleArray(2*r),s.normalizeLocations(this._parts[i])}this.isZType()&&this.readZ(!1),this.isMeasureType()&&this.readOptionalMeasures(!1)},s.prototype.readMultiPointContents=function(){var t=this.shapefile.readBoundingRectangle(this._buffer);this._boundingRectangle=t.coords,this._isNormalized=t.isNormalized,this._numberOfParts=1,this._numberOfPoints=this._buffer.getInt32(),this._parts=[this._buffer.getDoubleArray(2*this._numberOfPoints)],s.normalizeLocations(this._parts[0]),this.isZType()&&this.readZ(!1),this.isMeasureType()&&this.readOptionalMeasures(!1)},s.prototype.readZ=function(t){if(t){this._zValues=this._buffer.getDoubleArray(1);var e=this._zValues[0];this._zRange=[e,e]}else this._zRange=this._buffer.getDoubleArray(2),this._zValues=this._buffer.getDoubleArray(this.numberOfPoints)},s.prototype.readOptionalMeasures=function(t){if(this._buffer.hasRemaining()&&this._buffer.limit()-this._buffer.position>=8*this.numberOfPoints)if(t){this._mValues=this._buffer.getDoubleArray(1);var e=this._mValues[0];this._mRange=[e,e]}else this._mRange=this._buffer.getDoubleArray(2),this._mValues=this._buffer.getDoubleArray(this.numberOfPoints)},s.normalizeLocations=function(e){for(var i=0,r=e.length;i<r;i+=2){var n=e[i],o=e[i+1];e[i]=t.normalizedDegreesLongitude(n),e[i+1]=t.normalizedDegreesLatitude(o)}},s.prototype.isPointType=function(){return this.shapefile.isPointType()},s.prototype.isMultiPointType=function(){return this.shapefile.isMultiPointType()},s.prototype.isPolylineType=function(){return this.shapefile.isPolylineType()},s.prototype.isPolygonType=function(){return this.shapefile.isPolygonType()},s.prototype.isZType=function(){return this.shapefile.isZType()},s.prototype.isMeasureType=function(){return this.shapefile.isMeasureType()},s.prototype.setAttributes=function(t){this._attributes=t},s.RECORD_HEADER_LENGTH=8,s}),i("formats/shapefile/ShapefileRecordMultiPoint",["../../util/ByteBuffer","../../formats/shapefile/Shapefile","../../formats/shapefile/ShapefileRecord"],function(t,e,i){"use strict";var r=function(t,e){i.call(this,t,e)};return r.prototype=Object.create(i.prototype),r.prototype.readContents=function(){this.readMultiPointContents()},r}),i("formats/shapefile/ShapefileRecordNull",["../../formats/shapefile/Shapefile","../../formats/shapefile/ShapefileRecord"],function(t,e){"use strict";var i=function(t,i){e.call(this,t,i)};return i.prototype=Object.create(e.prototype),i.prototype.readContents=function(){this.readNullContents()},i}),i("formats/shapefile/ShapefileRecordPoint",["../../formats/shapefile/Shapefile","../../formats/shapefile/ShapefileRecord"],function(t,e){"use strict";var i=function(t,i){e.call(this,t,i)};return i.prototype=Object.create(e.prototype),i.prototype.readContents=function(){this.readPointContents()},i}),i("formats/shapefile/ShapefileRecordPolygon",["../../formats/shapefile/Shapefile","../../formats/shapefile/ShapefileRecord"],function(t,e){"use strict";var i=function(t,i){e.call(this,t,i)};return i.prototype=Object.create(e.prototype),i.prototype.readContents=function(){this.readPolylineContents()},i}),i("formats/shapefile/ShapefileRecordPolyline",["../../formats/shapefile/Shapefile","../../formats/shapefile/ShapefileRecord"],function(t,e){"use strict";var i=function(t,i){e.call(this,t,i)};return i.prototype=Object.create(e.prototype),i.prototype.readContents=function(){this.readPolylineContents()},i}),i("formats/shapefile/Shapefile",["../../geom/Angle","../../error/ArgumentError","../../util/ByteBuffer","../../util/Color","../../formats/shapefile/DBaseFile","../../geom/Location","../../util/Logger","../../error/NotYetImplementedError","../../shapes/Path","../../shapes/Placemark","../../shapes/PlacemarkAttributes","../../shapes/Polygon","../../geom/Position","../../formats/shapefile/PrjFile","../../layer/RenderableLayer","../../shapes/ShapeAttributes","../../formats/shapefile/ShapefileRecord","../../formats/shapefile/ShapefileRecordMultiPoint","../../formats/shapefile/ShapefileRecordNull","../../formats/shapefile/ShapefileRecordPoint","../../formats/shapefile/ShapefileRecordPolygon","../../formats/shapefile/ShapefileRecordPolyline","../../shapes/SurfacePolygon","../../shapes/SurfacePolyline"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_,b,w,S){"use strict";var L=function(t){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Shapefile","constructor","missingUrl"));this._url=t,this._shapeType=null,this._layer=null,this._shapeConfigurationCallback=this.defaultShapeConfigurationCallback,this._parserCompletionCallback=this.defaultParserCompletionCallback,this._buffer=null,this.attributeFile=new n(t.replace(".shp",".dbf")),this.projectionFile=new p(t.replace(".shp",".prj")),this.defaultPlacemarkAttributes=new u(null),this.defaultShapeAttributes=new g(null)};return Object.defineProperties(L.prototype,{url:{get:function(){return this._url}},shapeType:{get:function(){return this._shapeType}},layer:{get:function(){return this._layer}},parserCompletionCallback:{get:function(){return this._parserCompletionCallback}},shapeConfigurationCallback:{get:function(){return this._shapeConfigurationCallback}}}),L.prototype.load=function(t,e,i){t&&(this._parserCompletionCallback=t),e&&(this._shapeConfigurationCallback=e),this._layer=i||new f;var r=function(){var t=function(){this.requestUrl(this.url)}.bind(this);this.attributeFile.load(t)}.bind(this);this.projectionFile.load(r)},L.prototype.defaultParserCompletionCallback=function(t){this.addRenderablesForShapefile(this.layer)},L.prototype.defaultShapeConfigurationCallback=function(t,e){var i={},r=t.values.name||t.values.Name||t.values.NAME;if(r&&(i.name=r),e.isPointType())i.attributes=this.defaultPlacemarkAttributes;else if(e.isMultiPointType())i.attributes=this.defaultPlacemarkAttributes;else if(e.isPolylineType())i.attributes=this.defaultShapeAttributes;else if(e.isPolygonType()){i.attributes=this.defaultShapeAttributes;var n=t.values.height||t.values.Height||t.values.HEIGHT;n&&(i.height=n)}return i},L.prototype.addRenderablesForShapefile=function(t){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Shapefile","addRenderablesForShapefile","missingLayer"));this.isPointType()?this.addRenderablesForPoints(t):this.isMultiPointType()?this.addRenderablesForMultiPoints(t):this.isPolylineType()?this.addRenderablesForPolylines(t):this.isPolygonType()&&this.addRenderablesForPolygons(t)},L.prototype.addRenderablesForPoints=function(t){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Shapefile","addRenderablesForPoints","missingLayer"));for(var i=this.next();i;i=this.next()){var r=this.shapeConfigurationCallback(i.attributes,i),n=r&&r.altitude?r.altitude:0;if(r)for(var o=0,a=i.numberOfParts;o<a;o+=1)for(var l=i.pointBuffer(o),u=0,c=l.length;u<c;u+=2){var p=l[u],f=l[u+1],g=new d(f,p,n),m=new h(g,!1,r.attributes);m.altitudeMode=r.altitudeMode||WorldWind.RELATIVE_TO_GROUND,r.highlightAttributes&&(m.highlightAttributes=r.highlightAttributes),r.name&&(m.label=r.name),r.pickDelegate&&(m.pickDelegate=r.pickDelegate),r.userProperties&&(m.userProperties=r.userProperties),r.timeRange&&(m.timeRange=r.timeRange),t.addRenderable(m)}}},L.prototype.addRenderablesForMultiPoints=function(t){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Shapefile","addRenderablesForMultiPoints","missingLayer"));for(var i=this.next();i;i=this.next()){var r=this.shapeConfigurationCallback(i.attributes,i),n=r&&r.altitude?r.altitude:0;if(r)for(var o=0,a=i.numberOfParts;o<a;o+=1)for(var l=i.pointBuffer(o),u=0,c=l.length;u<c;u+=2){var p=l[u],f=l[u+1],g=new d(f,p,n),m=new h(g,!1,r.attributes);m.altitudeMode=r.altitudeMode||WorldWind.RELATIVE_TO_GROUND,r.highlightAttributes&&(m.highlightAttributes=r.highlightAttributes),r.name&&(m.label=r.name),r.pickDelegate&&(m.pickDelegate=r.pickDelegate),r.userProperties&&(m.userProperties=r.userProperties),r.timeRange&&(m.timeRange=r.timeRange),t.addRenderable(m)}}},L.prototype.addRenderablesForPolylines=function(t){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Shapefile","addRenderablesForPolylines","missingLayer"));for(var i=this.next();i;i=this.next()){var r=this.shapeConfigurationCallback(i.attributes,i),n=r&&r.altitude?r.altitude:0;if(r)for(var a=0,h=i.numberOfParts;a<h;a+=1){for(var u=i.pointBuffer(a),c=[],p=0,f=u.length;p<f;p+=2){var g=u[p],m=u[p+1],y=n?new d(m,g,n):new o(m,g);c.push(y)}var E;n?(E=new l(c,r.attributes),E.altitudeMode=r.altitudeMode||WorldWind.RELATIVE_TO_GROUND):E=new S(c,r.attributes),r.highlightAttributes&&(E.highlightAttributes=r.highlightAttributes),r.name&&(E.displayName=r.name),r.pickDelegate&&(E.pickDelegate=r.pickDelegate),r.userProperties&&(E.userProperties=r.userProperties),r.timeRange&&(E.timeRange=r.timeRange),t.addRenderable(E)}}},L.prototype.addRenderablesForPolygons=function(t){if(!t)throw new e(s.logMessage(s.LEVEL_SEVERE,"Shapefile","addRenderablesForPolygons","missingLayer"));for(var i=this.next();i;i=this.next()){for(var r,n=this.shapeConfigurationCallback(i.attributes,i),a=[],l=n.height,h=n.altitude,u=0,p=i.numberOfParts;u<p;u+=1){for(var f=i.pointBuffer(u),g=[],m=0,y=f.length-2;m<y;m+=2){var E=f[m],v=f[m+1];r=l?new d(v,E,l):h?new d(v,E,h):new o(v,E),g.push(r)}a.push(g)}var _;l?(_=new c(a,n.attributes),_.extrude=!0,_.altitudeMode=n.altitudeMode||WorldWind.RELATIVE_TO_GROUND):h?(_=new c(a,n.attributes),_.altitudeMode=n.altitudeMode||WorldWind.RELATIVE_TO_GROUND):_=new w(a,n.attributes),n.highlightAttributes&&(_.highlightAttributes=n.highlightAttributes),n.name&&(_.displayName=n.name),n.pickDelegate&&(_.pickDelegate=n.pickDelegate),n.userProperties&&(_.userProperties=n.userProperties),n.timeRange&&(_.timeRange=n.timeRange),t.addRenderable(_)}},L.prototype.next=function(){for(;this._buffer.position<this._buffer.limit();){var t=this.readRecord(this._buffer);if(!(t instanceof E))return t}return null},L.prototype.requestUrl=function(t){var e=new XMLHttpRequest;e.open("GET",t,!0),e.responseType="arraybuffer",e.onreadystatechange=function(){4===e.readyState&&(200===e.status?(this._buffer=new i(e.response),this.parse()):s.log(s.LEVEL_WARNING,"Shapefile retrieval failed ("+e.statusText+"): "+t),this._parserCompletionCallback&&this._parserCompletionCallback(this))}.bind(this),e.onerror=function(){s.log(s.LEVEL_WARNING,"Shapefile retrieval failed: "+t),this._parserCompletionCallback&&this._parserCompletionCallback(this)},e.ontimeout=function(){s.log(s.LEVEL_WARNING,"Shapefile retrieval timed out: "+t),this._parserCompletionCallback&&this._parserCompletionCallback(this)},e.send(null)},L.prototype.parse=function(){try{var t=this.readHeader(this._buffer);this._shapeType=t.shapeType}catch(t){console.log(t)}finally{}},L.prototype.readHeader=function(t){t.order(i.BIG_ENDIAN);var e=t.getInt32();if(e!=L.FILE_CODE)throw new Error(s.log(s.LEVEL_SEVERE,"Shapefile header is invalid"));t.skipInt32s(5);var r=t.getInt32();t.order(i.LITTLE_ENDIAN);var n=t.getInt32(),o=t.getInt32(),a=this.readBoundingRectangle(t),l=this.getShapeType(o);if(null==l)throw new Error(s.log(s.LEVEL_SEVERE,"Shapefile type is unsupported: "+o.toString()));var h={fileLength:2*r,version:n,shapeType:l,boundingRectangle:a.coords,normalizePoints:a.isNormalized};return t.skipDoubles(4),h},L.prototype.readBoundingRectangle=function(t){return this.projectionFile?this.projectionFile.isGeographicCoordinateSystem()?this.readGeographicBoundingRectangle(t):this.projectionFile.isProjectedCoordinateSystem()?this.readProjectedBoundingRectangle(t):this.readUnspecifiedBoundingRectangle(t):this.readUnspecifiedBoundingRectangle(t)},L.prototype.readUnspecifiedBoundingRectangle=function(t){var e=this.readBoundingRectangleCoordinates(t);return{coords:e,isNormalized:!1}},L.prototype.readGeographicBoundingRectangle=function(e){var i=this.readBoundingRectangleCoordinates(e),r=!1,n=0;return i[0]<-90&&(n=t.normalizedDegreesLatitude(i[0]),i[0]=90,r=!0,i[1]<n&&(i[1]=n)),i[1]>90&&(n=t.normalizedDegreesLatitude(i[1]),i[1]=90,r=!0,i[0]>n&&(i[0]=n)),(i[2]<-180||i[3]>180)&&(i[2]=-180,i[3]=180,r=!0),{coords:i,isNormalized:r}},L.prototype.readProjectedBoundingRectangle=function(t){throw new a(s.log(s.LEVEL_SEVERE,"Shapefile.readProjectedBoundingRectangle() not yet implemented"));
},L.prototype.readBoundingRectangleCoordinates=function(t){var e=t.getDouble(),i=t.getDouble(),r=t.getDouble(),n=t.getDouble();return[i,n,e,r]},L.prototype.readRecord=function(t){var e=this.createRecord(t);if(null!=e&&null!=this.attributeFile&&this.attributeFile.hasNext()){var i=this.attributeFile.nextRecord();e.setAttributes(i)}return e},L.prototype.createRecord=function(t){return this.isNullType()?this.createNull(t):this.isPointType()?this.createPoint(t):this.isMultiPointType()?this.createMultiPoint(t):this.isPolygonType()?this.createPolygon(t):this.isPolylineType()?this.createPolyline(t):null},L.prototype.createNull=function(t){return new E(this,t)},L.prototype.createPoint=function(t){return new v(this,t)},L.prototype.createMultiPoint=function(t){return new y(this,t)},L.prototype.createPolyline=function(t){return new b(this,t)},L.prototype.createPolygon=function(t){return new _(this,t)},L.prototype.getShapeType=function(t){switch(t){case 0:return L.NULL;case 1:return L.POINT;case 3:return L.POLYLINE;case 5:return L.POLYGON;case 8:return L.MULTI_POINT;case 11:return L.POINT_Z;case 13:return L.POLYLINE_Z;case 15:return L.POLYGON_Z;case 18:return L.MULTI_POINT_Z;case 21:return L.POINT_M;case 23:return L.POLYLINE_M;case 25:return L.POLYGON_M;case 28:return L.MULTI_POINT_M;default:return null}},L.prototype.isMeasureType=function(){return L.measureTypes.hasOwnProperty(this._shapeType)},L.prototype.isZType=function(){return L.zTypes.hasOwnProperty(this._shapeType)},L.prototype.isNullType=function(){return this._shapeType===L.NULL},L.prototype.isPointType=function(){return L.pointTypes.hasOwnProperty(this._shapeType)},L.prototype.isMultiPointType=function(){return L.multiPointTypes.hasOwnProperty(this._shapeType)},L.prototype.isPolylineType=function(){return L.polylineTypes.hasOwnProperty(this._shapeType)},L.prototype.isPolygonType=function(){return L.polygonTypes.hasOwnProperty(this._shapeType)},L.NULL="null",L.POINT="point",L.MULTI_POINT="multiPoint",L.POLYLINE="polyline",L.POLYGON="polygon",L.POINT_M=L.POINT+"M",L.MULTI_POINT_M=L.MULTI_POINT+"M",L.POLYLINE_M=L.POLYLINE+"M",L.POLYGON_M=L.POLYGON+"M",L.POINT_Z=L.POINT+"Z",L.MULTI_POINT_Z=L.MULTI_POINT+"Z",L.POLYLINE_Z=L.POLYLINE+"Z",L.POLYGON_Z=L.POLYGON+"Z",L.SHAPE_MULTI_PATCH="multiPatch",L.measureTypes={pointM:L.POINT_M,pointZ:L.POINT_Z,multiPointM:L.MULTI_POINT_M,multiPointZ:L.MULTI_POINT_Z,polylineM:L.POLYLINE_M,polylineZ:L.POLYLINE_Z,polygonM:L.POLYGON_M,polygonZ:L.POLYGON_Z},L.zTypes={pointZ:L.POINT_Z,multiPointZ:L.MULTI_POINT_Z,polylineZ:L.POLYLINE_Z,polygonZ:L.POLYGON_Z},L.pointTypes={point:L.POINT,pointZ:L.POINT_Z,pointM:L.POINT_M},L.multiPointTypes={multiPoint:L.MULTI_POINT,multiPointZ:L.MULTI_POINT_Z,multiPointM:L.MULTI_POINT_M},L.polylineTypes={polyline:L.POLYLINE,polylineZ:L.POLYLINE_Z,polylineM:L.POLYLINE_M},L.polygonTypes={polygon:L.POLYGON,polygonZ:L.POLYGON_Z,polygonM:L.POLYGON_M},L.FILE_CODE=9994,L}),i("layer/ShowTessellationLayer",["../shaders/BasicProgram","../layer/Layer"],function(t,e){"use strict";var i=function(){e.call(this,"Show Tessellation"),this.enableTerrainGeometry=!0,this.enableTerrainExtent=!1};return i.prototype=Object.create(e.prototype),i.prototype.doRender=function(t){try{this.beginRendering(t),this.enableTerrainGeometry&&this.drawTerrainGeometry(t),this.enableTerrainExtent&&this.drawTerrainExtent(t)}finally{this.endRendering(t)}},i.prototype.beginRendering=function(t){var e=t.currentGlContext;e.depthMask(!1)},i.prototype.endRendering=function(t){var e=t.currentGlContext;e.depthMask(!0)},i.prototype.drawTerrainGeometry=function(e){if(e.terrain&&e.terrain.tessellator){var i,r,n=e.currentGlContext,o=e.terrain,s=o.tessellator,a=o.surfaceGeometry;try{i=e.findAndBindProgram(t),s.beginRendering(e);for(var l=0,h=a.length;l<h;l++)r=a[l],s.beginRenderingTile(e,r),i.loadColorComponents(n,1,1,1,.3),s.renderWireframeTile(e,r),i.loadColorComponents(n,1,0,0,.6),s.renderTileOutline(e,r),s.endRenderingTile(e,r)}finally{s.endRendering(e)}}},i.prototype.drawTerrainExtent=function(t){for(var e,i=t.terrain.surfaceGeometry,r=0,n=i.length;r<n;r++)e=i[r],e.extent.render(t)},i}),i("shaders/StarFieldProgram",["../error/ArgumentError","../shaders/GpuProgram","../util/Logger"],function(t,e,i){"use strict";var r=function(t){var i="attribute vec4 vertexPoint;\nuniform mat4 mvpMatrix;\nuniform float numDays;\nuniform vec2 magnitudeRange;\nvarying float magnitudeWeight;\nfloat normalizeAngle(float angle) {\n   float angleDivisions = angle / 360.0;\n   return 360.0 * (angleDivisions - floor(angleDivisions));\n}\nvec3 computePosition(float dec, float ra) {\n   float GMST = normalizeAngle(280.46061837 + 360.98564736629 * numDays);\n   float GHA = normalizeAngle(GMST - ra);\n   float lon = -GHA + 360.0 * step(180.0, GHA);\n   float latRad = radians(dec);\n   float lonRad = radians(lon);\n   float radCosLat = cos(latRad);\n   return vec3(radCosLat * sin(lonRad), sin(latRad), radCosLat * cos(lonRad));\n}\nfloat normalizeScalar(float value, float minValue, float maxValue){\n   return (value - minValue) / (maxValue - minValue);\n}\nvoid main() {\n   vec3 vertexPosition = computePosition(vertexPoint.x, vertexPoint.y);\n   gl_Position = mvpMatrix * vec4(vertexPosition.xyz, 1.0);\n   gl_Position.z = gl_Position.w - 0.00001;\n   gl_PointSize = vertexPoint.z;\n   magnitudeWeight = normalizeScalar(vertexPoint.w, magnitudeRange.x, magnitudeRange.y);\n}",r="precision mediump float;\nuniform sampler2D textureSampler;\nuniform int textureEnabled;\nvarying float magnitudeWeight;\nconst vec4 white = vec4(1.0, 1.0, 1.0, 1.0);\nconst vec4 grey = vec4(0.5, 0.5, 0.5, 1.0);\nvoid main() {\n   if (textureEnabled == 1) {\n       gl_FragColor = texture2D(textureSampler, gl_PointCoord);\n   }\n   else {\n       gl_FragColor = mix(white, grey, magnitudeWeight);\n   }\n}";e.call(this,t,i,r,["vertexPoint"]),this.vertexPointLocation=this.attributeLocation(t,"vertexPoint"),this.mvpMatrixLocation=this.uniformLocation(t,"mvpMatrix"),this.numDaysLocation=this.uniformLocation(t,"numDays"),this.magnitudeRangeLocation=this.uniformLocation(t,"magnitudeRange"),this.textureUnitLocation=this.uniformLocation(t,"textureSampler"),this.textureEnabledLocation=this.uniformLocation(t,"textureEnabled")};return r.key="WorldWindGpuStarFieldProgram",r.prototype=Object.create(e.prototype),r.prototype.loadModelviewProjection=function(e,r){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"StarFieldProgram","loadModelviewProjection","missingMatrix"));this.loadUniformMatrix(e,r,this.mvpMatrixLocation)},r.prototype.loadNumDays=function(e,r){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"StarFieldProgram","loadNumDays","missingNumDays"));e.uniform1f(this.numDaysLocation,r)},r.prototype.loadMagnitudeRange=function(e,r,n){if(null==r)throw new t(i.logMessage(i.LEVEL_SEVERE,"StarFieldProgram","loadMagRange","missingMinMag"));if(null==n)throw new t(i.logMessage(i.LEVEL_SEVERE,"StarFieldProgram","loadMagRange","missingMaxMag"));e.uniform2f(this.magnitudeRangeLocation,r,n)},r.prototype.loadTextureUnit=function(t,e){t.uniform1i(this.textureUnitLocation,e-t.TEXTURE0)},r.prototype.loadTextureEnabled=function(t,e){t.uniform1i(this.textureEnabledLocation,e?1:0)},r}),i("layer/StarFieldLayer",["./Layer","../util/Logger","../geom/Matrix","../shaders/StarFieldProgram","../util/SunPosition"],function(t,e,i,r,n){"use strict";var o=function(e){t.call(this,"StarField"),this.pickEnabled=!1,this.sunSize=128,this.showSun=!0,this._starDataSource=e||WorldWind.configuration.baseUrl+"images/stars.json",this._sunImageSource=WorldWind.configuration.baseUrl+"images/sunTexture.png",this._matrix=i.fromIdentity(),this._starsPositionsVboCacheKey=null,this._numStars=0,this._starData=null,this._minMagnitude=Number.MAX_VALUE,this._maxMagnitude=Number.MIN_VALUE,this._loadStarted=!1,this._scale=Number.MAX_SAFE_INTEGER||Math.pow(2,53)-1,this._sunPositionsCacheKey="",this._sunBufferView=new Float32Array(4),this._MAX_GL_POINT_SIZE=0};return o.prototype=Object.create(t.prototype),Object.defineProperties(o.prototype,{starDataSource:{get:function(){return this._starDataSource},set:function(t){this._starDataSource=t,this.invalidateStarData()}},sunImageSource:{get:function(){return this._sunImageSource},set:function(t){this._sunImageSource=t}}}),o.prototype.doRender=function(t){if(!t.globe.is2D()){if(!this.haveResources(t))return void this.loadResources(t);this.beginRendering(t);try{this.doDraw(t)}finally{this.endRendering(t)}}},o.prototype.haveResources=function(t){var e=t.gpuResourceCache.resourceForKey(this._sunImageSource);return null!=this._starData&&null!=e},o.prototype.loadResources=function(t){var e=t.currentGlContext,i=t.gpuResourceCache;this._starData||this.fetchStarData();var r=i.resourceForKey(this._sunImageSource);r||i.retrieveTexture(e,this._sunImageSource)},o.prototype.beginRendering=function(t){var e=t.currentGlContext;t.findAndBindProgram(r),e.enableVertexAttribArray(0),e.depthMask(!1)},o.prototype.doDraw=function(t){this.loadCommonUniforms(t),this.renderStars(t),this.showSun&&this.renderSun(t)},o.prototype.loadCommonUniforms=function(t){var e=t.currentGlContext,i=t.currentProgram;this._matrix.copy(t.modelviewProjection),this._matrix.multiplyByScale(this._scale,this._scale,this._scale),i.loadModelviewProjection(e,this._matrix);var r=n.computeJulianDate(this.time||new Date);i.loadNumDays(e,r-2451545)},o.prototype.renderStars=function(t){var e=t.currentGlContext,i=t.gpuResourceCache,r=t.currentProgram;this._starsPositionsVboCacheKey||(this._starsPositionsVboCacheKey=i.generateCacheKey());var n=i.resourceForKey(this._starsPositionsVboCacheKey);if(n)e.bindBuffer(e.ARRAY_BUFFER,n);else{n=e.createBuffer();var o=this.createStarsGeometry();i.putResource(this._starsPositionsVboCacheKey,n,4*o.length),e.bindBuffer(e.ARRAY_BUFFER,n),e.bufferData(e.ARRAY_BUFFER,new Float32Array(o),e.STATIC_DRAW)}t.frameStatistics.incrementVboLoadCount(1),e.vertexAttribPointer(0,4,e.FLOAT,!1,0,0),r.loadMagnitudeRange(e,this._minMagnitude,this._maxMagnitude),r.loadTextureEnabled(e,!1),e.drawArrays(e.POINTS,0,this._numStars)},o.prototype.renderSun=function(t){var i=t.currentGlContext,r=t.currentProgram,o=t.gpuResourceCache;this._MAX_GL_POINT_SIZE||(this._MAX_GL_POINT_SIZE=i.getParameter(i.ALIASED_POINT_SIZE_RANGE)[1]),this.sunSize>this._MAX_GL_POINT_SIZE&&e.log(e.LEVEL_WARNING,"StarFieldLayer - sunSize is to big, max size allowed is: "+this._MAX_GL_POINT_SIZE);var s=n.getAsCelestialLocation(this.time||new Date);this._sunBufferView[0]=s.declination,this._sunBufferView[1]=s.rightAscension,this._sunBufferView[2]=Math.min(this.sunSize,this._MAX_GL_POINT_SIZE),this._sunBufferView[3]=1,this._sunPositionsCacheKey||(this._sunPositionsCacheKey=o.generateCacheKey());var a=o.resourceForKey(this._sunPositionsCacheKey);a?(i.bindBuffer(i.ARRAY_BUFFER,a),i.bufferSubData(i.ARRAY_BUFFER,0,this._sunBufferView)):(a=i.createBuffer(),o.putResource(this._sunPositionsCacheKey,a,4*this._sunBufferView.length),i.bindBuffer(i.ARRAY_BUFFER,a),i.bufferData(i.ARRAY_BUFFER,this._sunBufferView,i.DYNAMIC_DRAW)),t.frameStatistics.incrementVboLoadCount(1),i.vertexAttribPointer(0,4,i.FLOAT,!1,0,0),r.loadTextureEnabled(i,!0);var l=t.gpuResourceCache.resourceForKey(this._sunImageSource);l.bind(t),i.drawArrays(i.POINTS,0,1)},o.prototype.endRendering=function(t){var e=t.currentGlContext;e.depthMask(!0),e.disableVertexAttribArray(0)},o.prototype.fetchStarData=function(){if(!this._loadStarted){this._loadStarted=!0;var t=this,i=new XMLHttpRequest;i.onload=function(){if(this.status>=200&&this.status<300)try{t._starData=JSON.parse(this.response),t.sendRedrawRequest()}catch(t){e.log(e.LEVEL_SEVERE,"StarFieldLayer unable to parse JSON for star data "+t.toString())}else e.log(e.LEVEL_SEVERE,"StarFieldLayer unable to fetch star data. Status: "+this.status+" "+this.statusText);t._loadStarted=!1},i.onerror=function(){e.log(e.LEVEL_SEVERE,"StarFieldLayer unable to fetch star data"),t._loadStarted=!1},i.ontimeout=function(){e.log(e.LEVEL_SEVERE,"StarFieldLayer fetch star data has timeout"),t._loadStarted=!1},i.open("GET",this._starDataSource,!0),i.send()}},o.prototype.createStarsGeometry=function(){var t=this.parseStarsMetadata(this._starData.metadata);if(t.raIndex===-1)throw new Error(e.logMessage(e.LEVEL_SEVERE,"StarFieldLayer","createStarsGeometry","Missing ra field in star data."));if(t.decIndex===-1)throw new Error(e.logMessage(e.LEVEL_SEVERE,"StarFieldLayer","createStarsGeometry","Missing dec field in star data."));if(t.magIndex===-1)throw new Error(e.logMessage(e.LEVEL_SEVERE,"StarFieldLayer","createStarsGeometry","Missing vmag field in star data."));var i=this._starData.data,r=[];this._minMagnitude=Number.MAX_VALUE,this._maxMagnitude=Number.MIN_VALUE;for(var n=0,o=i.length;n<o;n++){var s=i[n],a=s[t.decIndex],l=s[t.raIndex],h=s[t.magIndex],u=h<2?2:1;r.push(a,l,u,h),this._minMagnitude=Math.min(this._minMagnitude,h),this._maxMagnitude=Math.max(this._maxMagnitude,h)}return this._numStars=Math.floor(r.length/4),r},o.prototype.parseStarsMetadata=function(t){for(var e=-1,i=-1,r=-1,n=0,o=t.length;n<o;n++){var s=t[n];"ra"===s.name&&(e=n),"dec"===s.name&&(i=n),"vmag"===s.name&&(r=n)}return{raIndex:e,decIndex:i,magIndex:r}},o.prototype.invalidateStarData=function(){this._starData=null,this._starsPositionsVboCacheKey=null},o.prototype.sendRedrawRequest=function(){var t=document.createEvent("Event");t.initEvent(WorldWind.REDRAW_EVENT_TYPE,!0,!0),window.dispatchEvent(t)},o}),i("render/SurfaceRenderable",["../util/Logger","../error/UnsupportedOperationError"],function(t,e){"use strict";var i=function(){throw this.displayName="Renderable",this.enabled=!0,new e(t.logMessage(t.LEVEL_SEVERE,"SurfaceRenderable","constructor","abstractInvocation"))};return i.prototype.renderSurface=function(i){throw new e(t.logMessage(t.LEVEL_SEVERE,"SurfaceRenderable","renderSurface","abstractInvocation"))},i}),i("layer/TectonicPlatesLayer",["../error/ArgumentError","../util/Color","../geom/Location","../util/Logger","../layer/RenderableLayer","../shapes/ShapeAttributes","../shapes/SurfacePolygon"],function(t,e,i,r,n,o,s){"use strict";var a=function(t){n.call(this,"Tectonic Plates"),t?this._attributes=t:(this._attributes=new o(null),this._attributes.drawInterior=!1,this._attributes.drawOutline=!0,this._attributes.outlineColor=e.RED),this.loadPlateData()};return a.prototype=Object.create(n.prototype),Object.defineProperties(a.prototype,{attributes:{get:function(){return this._attributes},set:function(t){t&&this.renderables.map(function(e,i,r){e.attributes=t})}}}),a.prototype.loadPlateData=function(){var t=WorldWind.configuration.baseUrl+"images/TectonicPlates.json",e=new XMLHttpRequest;e.open("GET",t,!0),e.onreadystatechange=function(){4===e.readyState&&(200===e.status?this.parse(e.responseText):r.log(r.LEVEL_WARNING,"Tectonic plate data retrieval failed ("+e.statusText+"): "+t))}.bind(this),e.onerror=function(){r.log(r.LEVEL_WARNING,"Tectonic plate data retrieval failed: "+t)},e.ontimeout=function(){r.log(r.LEVEL_WARNING,"Tectonic plate data retrieval timed out: "+t)},e.send(null)},a.prototype.parse=function(t){var e=JSON.parse(t),r=this;e.features.map(function(t,e,n){var o=[];t.geometry.coordinates.map(function(t,e,r){o.push(new i(t[1],t[0]))});var a=new s(o,r._attributes);r.addRenderable(a)})},a}),i("util/TileFactory",["../util/Logger","../error/UnsupportedOperationError"],function(t,e){"use strict";var i=function(){};return i.prototype.createTile=function(i,r,n,o){throw new e(t.logMessage(t.LEVEL_SEVERE,"TileFactory","createTile","abstractInvocation"))},i}),i("shapes/TriangleMesh",["../shapes/AbstractMesh","../error/ArgumentError","../shaders/BasicTextureProgram","../geom/BoundingBox","../util/Color","../util/ImageSource","../geom/Location","../util/Logger","../geom/Matrix","../pick/PickedObject","../geom/Position","../shapes/ShapeAttributes","../shapes/SurfacePolygon","../geom/Vec2","../geom/Vec3"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f){"use strict";var g=function(i,r,n){if(!i)throw new e(a.logMessage(a.LEVEL_SEVERE,"TriangleMesh","constructor","missingPositions"));if(i.length<1)throw new e(a.logMessage(a.LEVEL_SEVERE,"TriangleMesh","constructor","missingPositions"));if(i.length>65536)throw new e(a.logMessage(a.LEVEL_SEVERE,"TriangleMesh","constructor","Too many positions. Must be fewer than 65537. Use TriangleMesh.split to split the shape."));if(!r)throw new e(a.logMessage(a.LEVEL_SEVERE,"TriangleMesh","constructor","Indices array is null or undefined"));if(r.length<3)throw new e(a.logMessage(a.LEVEL_SEVERE,"TriangleMesh","constructor","Too few indices."));t.call(this,n),this._positions=i,this._indices=r,this.referencePosition=this._positions[0]};return g.prototype=Object.create(t.prototype),Object.defineProperties(g.prototype,{positions:{get:function(){return this._positions},set:function(t){if(!t)throw new e(a.logMessage(a.LEVEL_SEVERE,"TriangleMesh","positions","missingPositions"));this._positions=t,this.referencePosition=this._positions[0],this.reset()}},indices:{get:function(){return this._indices},set:function(t){if(!t)throw new e(a.logMessage(a.LEVEL_SEVERE,"TriangleMesh","indices","Indices array is null or undefined"));this._indices=t,this.meshIndices=null,this.reset()}},outlineIndices:{get:function(){return this._outlineIndices},set:function(t){this._outlineIndices=t,this.meshOutlineIndices=null,this.reset()}},textureCoordinates:{get:function(){return this._textureCoordinates},set:function(t){if(t&&t.length!=this._positions.length)throw new e(a.logMessage(a.LEVEL_SEVERE,"TriangleMesh","textureCoordinates","Number of texture coordinates is inconsistent with the currently specified positions."));this._textureCoordinates=t,this.reset(),this.texCoords=null}}}),g.prototype.createSurfaceShape=function(){if(this._outlineIndices){for(var t=[],e=0;e<this._outlineIndices.length;e++)t.push(this._positions[this._outlineIndices[e]]);return new d(t,null)}return null},g.prototype.computeMeshPoints=function(t,e){for(var i,r,n=Number.MAX_VALUE,o=t.eyePoint,s=new Float32Array(3*this._positions.length),a=new f(0,0,0),l=0,h=0;h<this._positions.length;h++)i=this._positions[h],t.surfacePointForMode(i.latitude,i.longitude,i.altitude*this._altitudeScale,this.altitudeMode,a),r=a.distanceToSquared(o),r<n&&(n=r),a.subtract(this.currentData.referencePoint),s[l++]=a[0],s[l++]=a[1],s[l++]=a[2];return e.eyeDistance=Math.sqrt(n),s},g.prototype.computeTexCoords=function(){if(this._textureCoordinates){for(var t=new Float32Array(2*this._textureCoordinates.length),e=0,i=0,r=this._textureCoordinates.length;i<r;i++){var n=this._textureCoordinates[i];t[e++]=n[0],t[e++]=n[1]}return t}return null},g.prototype.computeMeshIndices=function(){for(var t=new Uint16Array(this._indices.length),e=0,i=this._indices.length;e<i;e++)t[e]=this._indices[e];return t},g.prototype.computeOutlineIndices=function(){if(this._outlineIndices){for(var t=new Uint16Array(this._outlineIndices.length),e=0;e<this._outlineIndices.length;e++)t[e]=this._outlineIndices[e];return t}return null},g.split=function(t,e,i,r){for(var n,o,s=[],a=[],l=[],h=[],u=[],c=0;c<=e.length;c++){if(c===e.length||s.length>65533&&l.length%3===0){if(s.length>0){var d={positions:s,indices:l};if(i&&(d.textureCoords=a),r){for(var p=[],f=0;f<r.length;f++)n=r[f],o=h[n],o&&p.push(h[r[f]]);d.outlineIndices=p}u.push(d)}if(c===e.length)break;s=[],l=[],h=[]}n=e[c],o=h[n],o||(o=s.length,h[n]=o,s.push(t[n]),i&&a.push(i[n])),l.push(o)}return u},g}),i("util/UrlBuilder",["../util/Logger","../error/UnsupportedOperationError"],function(t,e){"use strict";var i=function(){};return i.prototype.urlForTile=function(i,r){throw new e(t.logMessage(t.LEVEL_SEVERE,"UrlBuilder","urlForTile","abstractInvocation"))},i}),i("layer/ViewControlsLayer",["../geom/Angle","../error/ArgumentError","../layer/Layer","../geom/Location","../util/Logger","../util/Offset","../shapes/ScreenImage","../geom/Vec2"],function(t,e,i,r,n,o,s,a){"use strict";var l=function(t){if(!t)throw new e(n.logMessage(n.LEVEL_SEVERE,"ViewControlsLayer","constructor","missingWorldWindow"));i.call(this,"View Controls"),this.wwd=t,this.placement=new o(WorldWind.OFFSET_PIXELS,11,WorldWind.OFFSET_PIXELS,11),this.alignment=new o(WorldWind.OFFSET_FRACTION,0,WorldWind.OFFSET_FRACTION,0),this.exaggerationIncrement=.01,this.zoomIncrement=.04,this.headingIncrement=1,this.tiltIncrement=1,this.fieldOfViewIncrement=.1,this.panIncrement=.001,this._inactiveOpacity=.5,this._activeOpacity=1;var r=new o(WorldWind.OFFSET_PIXELS,0,WorldWind.OFFSET_PIXELS,0),l=WorldWind.configuration.baseUrl+"images/view/";this.panControl=new s(r.clone(),l+"view-pan-64x64.png"),this.zoomInControl=new s(r.clone(),l+"view-zoom-in-32x32.png"),this.zoomOutControl=new s(r.clone(),l+"view-zoom-out-32x32.png"),this.headingLeftControl=new s(r.clone(),l+"view-heading-left-32x32.png"),this.headingRightControl=new s(r.clone(),l+"view-heading-right-32x32.png"),this.tiltUpControl=new s(r.clone(),l+"view-pitch-up-32x32.png"),this.tiltDownControl=new s(r.clone(),l+"view-pitch-down-32x32.png"),this.exaggerationUpControl=new s(r.clone(),l+"view-elevation-up-32x32.png"),this.exaggerationDownControl=new s(r.clone(),l+"view-elevation-down-32x32.png"),this.fovNarrowControl=new s(r.clone(),l+"view-fov-narrow-32x32.png"),this.fovWideControl=new s(r.clone(),l+"view-fov-wide-32x32.png"),this.fovNarrowControl.enabled=!1,this.fovWideControl.enabled=!1,this.controls=[this.panControl,this.zoomInControl,this.zoomOutControl,this.headingLeftControl,this.headingRightControl,this.tiltUpControl,this.tiltDownControl,this.exaggerationUpControl,this.exaggerationDownControl,this.fovNarrowControl,this.fovWideControl];for(var h=0;h<this.controls.length;h++)this.controls[h].imageOffset=r.clone(),this.controls[h].opacity=this._inactiveOpacity,this.controls[h]===this.panControl?this.controls[h].size=64:this.controls[h].size=32;this.panControlCenter=new a(0,0),this.pickEnabled=!1,this.wwd.worldWindowController.addGestureListener(this)};return l.prototype=Object.create(i.prototype),Object.defineProperties(l.prototype,{showPanControl:{get:function(){return this.panControl.enabled},set:function(t){this.panControl.enabled=t}},showZoomControl:{get:function(){return this.zoomInControl.enabled},set:function(t){this.zoomInControl.enabled=t,this.zoomOutControl.enabled=t}},showHeadingControl:{get:function(){return this.headingLeftControl.enabled},set:function(t){this.headingLeftControl.enabled=t,this.headingRightControl.enabled=t}},showTiltControl:{get:function(){return this.tiltUpControl.enabled},set:function(t){this.tiltUpControl.enabled=t,this.tiltDownControl.enabled=t}},showExaggerationControl:{get:function(){return this.exaggerationUpControl.enabled},set:function(t){this.exaggerationUpControl.enabled=t,this.exaggerationDownControl.enabled=t}},showFieldOfViewControl:{get:function(){return this.fovNarrowControl.enabled},set:function(t){this.fovNarrowControl.enabled=t,this.fovWideControl.enabled=t}},inactiveOpacity:{get:function(){return this._inactiveOpacity},set:function(t){this._inactiveOpacity=t;for(var e=0;e<this.controls.length;e++)this.controls[e].opacity=t}},activeOpacity:{get:function(){return this._activeOpacity},set:function(t){this._activeOpacity=t;for(var e=0;e<this.controls.length;e++)this.controls[e].opacity=t}}}),l.prototype.doRender=function(t){var e,i,r,n,o=0,s=64;this.inCurrentFrame=!1,this.showPanControl&&(o+=this.panControl.size,this.inCurrentFrame=!0),this.showZoomControl&&(o+=this.zoomInControl.size,this.inCurrentFrame=!0),this.showHeadingControl&&(o+=this.headingLeftControl.size,this.inCurrentFrame=!0),this.showTiltControl&&(o+=this.tiltDownControl.size,this.inCurrentFrame=!0),this.showExaggerationControl&&(o+=this.exaggerationDownControl.size,this.inCurrentFrame=!0),this.showFieldOfViewControl&&(o+=this.fovNarrowControl.size,this.inCurrentFrame=!0),i=this.placement.offsetForSize(t.viewport.width,t.viewport.height),e=this.alignment.offsetForSize(o,s),r=i[0]-e[0],n=i[1]-e[1],this.showPanControl&&(this.panControl.screenOffset.x=r,this.panControl.screenOffset.y=n,this.panControl.render(t),this.panControlCenter[0]=r+this.panControl.size/2,this.panControlCenter[1]=n+this.panControl.size/2,r+=this.panControl.size),this.showZoomControl&&(this.zoomOutControl.screenOffset.x=r,this.zoomOutControl.screenOffset.y=n,this.zoomInControl.screenOffset.x=r,this.zoomInControl.screenOffset.y=n+this.zoomOutControl.size,this.zoomOutControl.render(t),this.zoomInControl.render(t),r+=this.zoomOutControl.size),this.showHeadingControl&&(this.headingRightControl.screenOffset.x=r,this.headingRightControl.screenOffset.y=n,this.headingLeftControl.screenOffset.x=r,this.headingLeftControl.screenOffset.y=n+this.headingLeftControl.size,this.headingRightControl.render(t),this.headingLeftControl.render(t),r+=this.headingLeftControl.size),this.showTiltControl&&(this.tiltDownControl.screenOffset.x=r,this.tiltDownControl.screenOffset.y=n,this.tiltUpControl.screenOffset.x=r,this.tiltUpControl.screenOffset.y=n+this.tiltDownControl.size,this.tiltDownControl.render(t),this.tiltUpControl.render(t),r+=this.tiltDownControl.size),this.showExaggerationControl&&(this.exaggerationDownControl.screenOffset.x=r,this.exaggerationDownControl.screenOffset.y=n,this.exaggerationUpControl.screenOffset.x=r,this.exaggerationUpControl.screenOffset.y=n+this.exaggerationDownControl.size,this.exaggerationUpControl.render(t),this.exaggerationDownControl.render(t),r+=this.exaggerationDownControl.size),this.showFieldOfViewControl&&(this.fovNarrowControl.screenOffset.x=r,this.fovNarrowControl.screenOffset.y=n,this.fovWideControl.screenOffset.x=r,this.fovWideControl.screenOffset.y=n+this.fovNarrowControl.size,this.fovNarrowControl.render(t),this.fovWideControl.render(t))},l.prototype.isPointerDown=function(t){return"pointerdown"===t.type||"mousedown"===t.type&&1===t.which},l.prototype.isPointerUp=function(t){return"pointerup"===t.type||"mouseup"===t.type&&1===t.which},l.prototype.isPointerMove=function(t){return"pointermove"===t.type||"mousemove"===t.type},l.prototype.isTouchStart=function(t){return"touchstart"===t.type},l.prototype.isTouchEnd=function(t){return"touchend"===t.type||"touchcancel"===t.type},l.prototype.isTouchMove=function(t){return"touchmove"===t.type},l.prototype.onGestureEvent=function(t){var e,i=!1;if(!this.enabled)return i;this.highlightedControl&&(this.highlight(this.highlightedControl,!1),this.wwd.redraw());var r=!1;if(t.type&&this.activeControl&&(this.isPointerUp(t)?r=!0:this.isTouchEnd(t)&&this.isCurrentTouch(t)?r=!0:(e=this.pickControl(t),this.activeControl!==e&&(r=!0))),r)this.activeControl=null,this.activeOperation=null,t.preventDefault();else{if(this.activeOperation)i=this.activeOperation.call(this,t,null),t.preventDefault();else if(e=this.pickControl(t)){var n=this.determineOperation(t,e);n&&(i=n.call(this,t,e))}this.handleHighlight(t,e),this.wwd.redraw()}return i},l.prototype.isControl=function(t){for(var e=0;e<this.controls.length;e++)if(this.controls[e]==t)return!0;return!1},l.prototype.pickControl=function(t){var e,i;if(t.changedTouches){var r=t.changedTouches.item(0);e=r.clientX,i=r.clientY}else e=t.clientX,i=t.clientY;for(var n,o=this.wwd.canvasCoordinates(e,i),s=o[0],a=this.wwd.canvas.height-o[1],l=0;l<this.controls.length;l++)if(n=this.controls[l],n.enabled&&s>=n.screenOffset.x&&s<=n.screenOffset.x+n.size&&a>=n.screenOffset.y&&a<=n.screenOffset.y+n.size)return n;return null},l.prototype.determineOperation=function(t,e){var i=null;return e&&e instanceof s&&(e===this.panControl?i=this.handlePan:e===this.zoomInControl||e===this.zoomOutControl?i=this.handleZoom:e===this.headingLeftControl||e===this.headingRightControl?i=this.handleHeading:e===this.tiltUpControl||e===this.tiltDownControl?i=this.handleTilt:e===this.exaggerationUpControl||e===this.exaggerationDownControl?i=this.handleExaggeration:e!==this.fovNarrowControl&&e!==this.fovWideControl||(i=this.handleFov)),i},l.prototype.isCurrentTouch=function(t){for(var e=0;e<t.changedTouches.length;e++)if(t.changedTouches.item(e).identifier===this.currentTouchId)return!0;return!1},l.prototype.handlePan=function(e,i){var n=!1;if(this.isPointerDown(e)||this.isPointerMove(e))this.currentEventPoint=this.wwd.canvasCoordinates(e.clientX,e.clientY);else if(this.isTouchStart(e)||this.isTouchMove(e)){var o=e.changedTouches.item(0);this.currentEventPoint=this.wwd.canvasCoordinates(o.clientX,o.clientY)}if(this.isPointerDown(e)||this.isTouchStart(e)){this.activeControl=i,this.activeOperation=this.handlePan,e.preventDefault(),this.isTouchStart(e)&&(this.currentTouchId=e.changedTouches.item(0).identifier);var s=this,a=function(){if(s.activeControl){var e=s.panControlCenter[0]-s.currentEventPoint[0],i=s.panControlCenter[1]-(s.wwd.viewport.height-s.currentEventPoint[1]),n=s.wwd.navigator.lookAtLocation.latitude,o=s.wwd.navigator.lookAtLocation.longitude,l=s.panIncrement*(s.wwd.navigator.range/s.wwd.globe.radiusAt(n,o)),h=s.wwd.navigator.heading+Math.atan2(e,i)*t.RADIANS_TO_DEGREES,u=l*Math.sqrt(e*e+i*i);r.greatCircleLocation(s.wwd.navigator.lookAtLocation,h,-u,s.wwd.navigator.lookAtLocation),s.wwd.redraw(),setTimeout(a,50)}};setTimeout(a,50),n=!0}return n},l.prototype.handleZoom=function(t,e){var i=!1;if(this.isPointerDown(t)||this.isTouchStart(t)){this.activeControl=e,this.activeOperation=this.handleZoom,t.preventDefault(),this.isTouchStart(t)&&(this.currentTouchId=t.changedTouches.item(0).identifier);var r=this,n=function(){r.activeControl&&(r.activeControl===r.zoomInControl?r.wwd.navigator.range*=1-r.zoomIncrement:r.activeControl===r.zoomOutControl&&(r.wwd.navigator.range*=1+r.zoomIncrement),r.wwd.redraw(),setTimeout(n,50))};setTimeout(n,50),i=!0}return i},l.prototype.handleHeading=function(t,e){var i=!1;if(this.isPointerDown(t)||this.isTouchStart(t)){this.activeControl=e,this.activeOperation=this.handleHeading,t.preventDefault(),this.isTouchStart(t)&&(this.currentTouchId=t.changedTouches.item(0).identifier);var r=this,n=function(){r.activeControl&&(r.activeControl===r.headingLeftControl?r.wwd.navigator.heading+=r.headingIncrement:r.activeControl===r.headingRightControl&&(r.wwd.navigator.heading-=r.headingIncrement),r.wwd.redraw(),setTimeout(n,50))};setTimeout(n,50),i=!0}return i},l.prototype.handleTilt=function(t,e){var i=!1;if(this.isPointerDown(t)||this.isTouchStart(t)){this.activeControl=e,this.activeOperation=this.handleTilt,t.preventDefault(),this.isTouchStart(t)&&(this.currentTouchId=t.changedTouches.item(0).identifier);var r=this,n=function(){r.activeControl&&(r.activeControl===r.tiltUpControl?r.wwd.navigator.tilt=Math.max(0,r.wwd.navigator.tilt-r.tiltIncrement):r.activeControl===r.tiltDownControl&&(r.wwd.navigator.tilt=Math.min(90,r.wwd.navigator.tilt+r.tiltIncrement)),r.wwd.redraw(),setTimeout(n,50))};setTimeout(n,50),i=!0}return i},l.prototype.handleExaggeration=function(t,e){var i=!1;if(this.isPointerDown(t)||this.isTouchStart(t)){this.activeControl=e,this.activeOperation=this.handleExaggeration,t.preventDefault(),this.isTouchStart(t)&&(this.currentTouchId=t.changedTouches.item(0).identifier);var r=this,n=function(){r.activeControl&&(r.activeControl===r.exaggerationUpControl?r.wwd.verticalExaggeration+=r.exaggerationIncrement:r.activeControl===r.exaggerationDownControl&&(r.wwd.verticalExaggeration=Math.max(1,r.wwd.verticalExaggeration-r.exaggerationIncrement)),r.wwd.redraw(),setTimeout(n,50))};setTimeout(n,50),i=!0}return i},l.prototype.handleFov=function(t,e){var i=!1;if(this.isPointerDown(t)||this.isTouchStart(t)){this.activeControl=e,this.activeOperation=this.handleFov,t.preventDefault(),this.isTouchStart(t)&&(this.currentTouchId=t.changedTouches.item(0).identifier);var r=this,n=function(){r.activeControl&&(r.activeControl===r.fovWideControl?r.wwd.navigator.fieldOfView=Math.max(90,r.wwd.navigator.fieldOfView+r.fieldOfViewIncrement):r.activeControl===r.fovNarrowControl&&(r.wwd.navigator.fieldOfView=Math.min(0,r.wwd.navigator.fieldOfView-r.fieldOfViewIncrement)),r.wwd.redraw(),setTimeout(n,50))};setTimeout(n,50),i=!0}return i},l.prototype.handleHighlight=function(t,e){this.activeControl?this.highlight(this.activeControl,!0):e&&this.isControl(e)&&this.highlight(e,!0);
},l.prototype.highlight=function(t,e){t.opacity=e?this._activeOpacity:this._inactiveOpacity,e?this.highlightedControl=t:this.highlightedControl=null},l}),i("ogc/ows/OwsBoundingBox",["../../error/ArgumentError","../../util/Logger","../../geom/Sector"],function(t,e,i){"use strict";var r=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsBoundingBox","constructor","missingDomElement"));this.assembleElement(i)};return r.prototype.assembleElement=function(t){this.crs="WGS84BoundingBox"===t.localName?"WGS84":t.getAttribute("crs"),this.dimensions=t.getAttribute("dimensions");for(var e=t.children||t.childNodes,i=0;i<e.length;i++){var r=e[i];"LowerCorner"===r.localName?this.lowerCorner=r.textContent:"UpperCorner"===r.localName&&(this.upperCorner=r.textContent)}},r.prototype.getSector=function(){var t,e,r,n,o;return this.crs.indexOf("WGS84")!==-1||this.crs.indexOf("EPSG:4326")!==-1?(o=this.lowerCorner.split(/\s+/),e=o[0],t=o[1],o=this.upperCorner.split(/\s+/),n=o[0],r=o[1],new i(t,r,e,n)):null},r}),i("ogc/ows/OwsKeywords",["../../error/ArgumentError","../../util/Logger","../../ogc/ows/OwsLanguageString"],function(t,e,i){"use strict";var r=function(r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsKeywords","constructor","missingDomElement"));for(var n=r.children||r.childNodes,o=0;o<n.length;o++){var s=n[o];"keyword"===s.localName&&(this.keywords=this.keywords||[],this.keywords.push(new i(s)))}};return r}),i("ogc/ows/OwsDatasetSummary",["../../error/ArgumentError","../../util/Logger","../../ogc/ows/OwsBoundingBox","../../ogc/ows/OwsKeywords","../../ogc/ows/OwsLanguageString"],function(t,e,i,r,n){"use strict";var o=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"OwsDatasetSummary","constructor","missingDomElement"));this.assembleElement(i)};return o.prototype.assembleElement=function(t){for(var e=t.children||t.childNodes,o=0;o<e.length;o++){var s=e[o];"Title"===s.localName?(this.titles=this.titles||[],this.titles.push(new n(s))):"Abstract"===s.localName?(this.abstracts=this.abtracts||[],this.abstracts.push(new n(s))):"Keywords"===s.localName?(this.keywords=this.keywords||[],this.keywords.push(new r(s))):"Identifier"===s.localName?this.identifier=s.textContent:"WGS84BoundingBox"===s.localName?this.wgs84BoundingBox=new i(s):"BoundingBox"===s.localName?(this.boundingBox=this.boundingBox||[],this.boundingBox.push(new i(s))):"OutputFormat"===s.localName?(this.outputFormat=this.outputFormat||[],this.outputFormat.push(s.textContent)):"AvailableCRS"===s.localName&&(this.availableCrs=this.availableCrs||[],this.availableCRS.push(s.textContent))}},o}),i("ogc/wcs/WcsCapabilities",["../../error/ArgumentError","../../util/Logger","../../ogc/ows/OwsDatasetSummary","../../ogc/ows/OwsKeywords","../../ogc/ows/OwsOperationsMetadata","../../ogc/ows/OwsServiceIdentification","../../ogc/ows/OwsServiceProvider"],function(t,e,i,r,n,o,s){"use strict";var a=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsCapabilities","constructor","missingDom"));this.xmlDom=i,this.assembleDocument()};return a.prototype.getCoverageBaseUrl=function(){return"1.0.0"===this.version?this.capability.request.getCoverage.get:"2.0.1"===this.version||"2.0.0"===this.version?this.operationsMetadata.getOperationMetadataByName("GetCoverage").dcp[0].getMethods[0].url:null},a.prototype.assembleDocument=function(){var i=this.xmlDom.documentElement;if(this.version=i.getAttribute("version"),this.updateSequence=i.getAttribute("updateSequence"),"1.0.0"===this.version)this.assembleDocument100(i);else{if("2.0.0"!==this.version&&"2.0.1"!==this.version)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsCapabilities","assembleDocument","unsupportedVersion"));this.assembleDocument20x(i)}},a.prototype.assembleDocument100=function(t){for(var e=t.children||t.childNodes,i=0;i<e.length;i++){var r=e[i];"Service"===r.localName?this.service=this.assembleService100(r):"Capability"===r.localName?this.capability=this.assembleCapability100(r):"ContentMetadata"===r.localName&&this.assembleContents100(r)}},a.prototype.assembleDocument20x=function(t){for(var e=t.children||t.childNodes,i=0;i<e.length;i++){var r=e[i];"ServiceIdentification"===r.localName?this.serviceIdentification=new o(r):"ServiceProvider"===r.localName?this.serviceProvider=new s(r):"OperationsMetadata"===r.localName?this.operationsMetadata=new n(r):"ServiceMetadata"===r.localName?this.serviceMetadata=this.assembleServiceMetadata(r):"Contents"===r.localName&&this.assembleContents20x(r)}},a.prototype.assembleContents100=function(t){for(var e=t.children||t.childNodes,i=0;i<e.length;i++){var r=e[i];"CoverageOfferingBrief"===r.localName&&(this.coverages=this.coverages||[],this.coverages.push(this.assembleCoverages100(r)))}},a.prototype.assembleContents20x=function(t){for(var e,r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];"CoverageSummary"===o.localName&&(e=new i(o),this.assembleDatasetAugment20x(o,e),this.coverages=this.coverages||[],this.coverages.push(e))}},a.prototype.assembleDatasetAugment20x=function(t,e){for(var i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"CoverageId"===n.localName?e.coverageId=n.textContent:"CoverageSubtype"===n.localName&&(e.subType=e.subType||[],e.subType.push(n.textContent))}},a.prototype.assembleCoverages100=function(t){for(var e=t.children||t.childNodes,i={},n=0;n<e.length;n++){var o=e[n];"name"===o.localName?i.name=o.textContent:"description"===o.localName?i.description=o.textContent:"label"===o.localName?i.label=o.textContent:"Keywords"===o.localName?(i.keywords=i.keywords||[],i.keywords.push(new r(o))):"lonLatEnvelope"===o.localName&&(i.wgs84BoundingBox=this.assembleLatLonBoundingBox(o))}return i},a.prototype.assembleService100=function(t){for(var e=t.children||t.childNodes,i={},n=0;n<e.length;n++){var o=e[n];"description"===o.localName?i.description=o.textContent:"name"===o.localName?i.name=o.textContent:"label"===o.localName?i.label=o.textContent:"fees"===o.localName?i.fees=o.textContent:"accessConstraints"===o.localName?(i.accessConstraints=i.accessConstraints||[],i.accessConstraints.push(o.textContent)):"Keywords"===o.localName&&(i.keywords=new r(o))}return i},a.prototype.assembleCapability100=function(t){for(var e=t.children||t.childNodes,i={},r=0;r<e.length;r++){var n=e[r];"Request"===n.localName?i.request=this.assembleRequestCapabilities100(n):"Exception"===n.localName&&(n=n.children||n.childNodes,n=n[0],i.exception=i.exception||[],i.exception.push(n.textContent))}return i},a.prototype.assembleRequestCapabilities100=function(t){for(var e=t.children||t.childNodes,i={},r=0;r<e.length;r++){var n=e[r];"GetCapabilities"===n.localName?i.getCapabilities=this.assembleDCPType100(n):"DescribeCoverage"===n.localName?i.describeCoverage=this.assembleDCPType100(n):"GetCoverage"===n.localName&&(i.getCoverage=this.assembleDCPType100(n))}return i},a.prototype.assembleDCPType100=function(t){for(var e=t.children||t.childNodes,i={},r=0;r<e.length;r++){var n=e[r];"DCPType"===n.localName&&this.assembleHttp100(n,i)}return i},a.prototype.assembleHttp100=function(t,e){for(var i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];if("HTTP"===n.localName)return this.assembleMethod100(n,e)}},a.prototype.assembleMethod100=function(t,e){for(var i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Get"===n.localName?e.get=this.assembleOnlineResource100(n):"Post"===n.localName&&(e.post=this.assembleOnlineResource100(n))}},a.prototype.assembleOnlineResource100=function(t){for(var e=t.children||t.childNodes,i=0;i<e.length;i++){var r=e[i];if("OnlineResource"===r.localName)return r.getAttribute("xlink:href")}},a.prototype.assembleLatLonBoundingBox=function(t){for(var e,i,r,n=t.children||t.childNodes,o={},s=0;s<n.length;s++){var a=n[s];"pos"===a.localName&&(e?(r=parseFloat(a.textContent.split(/\s+/)[0]),i<r?(o.lowerCorner=e,o.upperCorner=a.textContent):(o.lowerCorner=a.textContent,o.upperCorner=e)):(e=a.textContent,i=parseFloat(e.split(/\s+/)[0])))}return o},a.prototype.assembleServiceMetadata=function(t){for(var e=t.children||t.childNodes,i={},r=0;r<e.length;r++){var n=e[r];"formatSupported"===n.localName?(i.formatsSupported=i.formatsSupported||[],i.formatsSupported.push(n.textContent)):"Extension"===n.localName&&(i.extension=this.assembleServiceMetadataExtension(n))}return i},a.prototype.assembleServiceMetadataExtension=function(t){for(var e=t.children||t.childNodes,i=e.length,r={},n=0;n<i;n++){var o=e[n];"crsSupported"===o.localName?(r.crsSupported=r.crsSupported||[],r.crsSupported.push(o.textContent)):"interpolationSupported"===o.localName&&(r.interpolationSupported=r.interpolationSupported||[],r.interpolationSupported.push(o.textContent))}return r},a}),i("ogc/wcs/WcsUrlBuilder",["../../error/ArgumentError","../../util/Logger"],function(t,e){"use strict";var i=function(i,r){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsUrlBuilder","constructor","missingId"));if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsUrlBuilder","constructor","missingWebCoverageService"));this.coverageId=i,this.service=r};return i.prototype.urlForTile=function(i,r){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsUrlBuilder","urlForTile","missingTile"));if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsUrlBuilder","urlForTile","The specified format is null or undefined."));var n=this.service.capabilities.version,o=this.fixGetCoverageString(this.service.capabilities.getCoverageBaseUrl());return o+="SERVICE=WCS",o+="&REQUEST=GetCoverage","1.0.0"===n?this.buildUrl100(i,r,o):"2.0.1"===n||"2.0.0"===n?this.buildUrl20x(i,r,o):void 0},i.prototype.buildUrl100=function(t,e,i){var r=t.sector;return i+="&VERSION=1.0.0",i+="&COVERAGE="+this.coverageId,i+="&CRS=EPSG:4326",i+="&WIDTH="+t.tileWidth,i+="&HEIGHT="+t.tileHeight,i+="&FORMAT="+e,i+="&BBOX="+r.minLongitude+","+r.minLatitude+","+r.maxLongitude+","+r.maxLatitude,encodeURI(i)},i.prototype.buildUrl20x=function(t,e,i){for(var r,n,o,s,a,l=t.sector,h=0,u=this.service.coverageDescriptions.coverages.length;h<u;h++)if(this.coverageId===this.service.coverageDescriptions.coverages[h].coverageId){o=this.service.coverageDescriptions.coverages[h];break}return s=o.domainSet.rectifiedGrid.axisLabels,a=o.boundedBy.envelope.axisLabels,a[0].toLowerCase().indexOf("lat")>=0?(r=a[0],n=a[1]):(r=a[1],n=a[0]),i+="&VERSION="+this.service.capabilities.version,i+="&COVERAGEID="+this.coverageId,i+="&FORMAT="+e,i+="&SCALESIZE="+s[0]+"("+t.tileWidth+"),",i+=s[1]+"("+t.tileHeight+")",i+="&OVERVIEWPOLICY=NEAREST",i+="&SUBSET="+r+"("+l.minLatitude+","+l.maxLatitude+")",i+="&SUBSET="+n+"("+l.minLongitude+","+l.maxLongitude+")",encodeURI(i)},i.prototype.fixGetCoverageString=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WmsUrlBuilder","fixGetMapString","The specified service address is null or undefined."));var r=i.indexOf("?");return r<0?i+="?":r!==i.length-1&&(r=i.search(/&$/),r<0&&(i+="&")),i},i}),i("ogc/wcs/WcsCoverage",["../../error/ArgumentError","../../util/Logger","../../ogc/wcs/WcsUrlBuilder"],function(t,e,i){"use strict";var r=function(i,r){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsCoverage","constructor","missingId"));if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsCoverage","constructor","missingWebCoverageService"));this.coverageId=i,this.service=r,this.sector=this.service.coverageDescriptions.getSector(this.coverageId),this.resolution=this.service.coverageDescriptions.getResolution(this.coverageId),this.elevationConfig=this.createElevationConfig()};return r.PREFERRED_FORMATS={GeoTIFF:!0,"image/tiff":!0,TIFF:!0},r.DEFAULT_FORMAT="image/tiff",r.prototype.createElevationConfig=function(){return{resolution:this.resolution,coverageSector:this.sector,retrievalImageFormat:this.determineFormatFromService(),urlBuilder:new i(this.coverageId,this.service)}},r.prototype.determineFormatFromService=function(){var t,e,i,n=this.service.capabilities.version;if("1.0.0"===n){for(e=0,i=this.service.coverageDescriptions.coverages.length;e<i;e++)if(this.coverageId===this.service.coverageDescriptions.coverages[e].name){t=this.service.coverageDescriptions.coverages[e].supportedFormats.formats;break}}else"2.0.1"!==n&&"2.0.0"!==n||(t=this.service.capabilities.serviceMetadata.formatsSupported);if(!t)return r.DEFAULT_FORMAT;for(e=0,i=t.length;e<i;e++)if(r.PREFERRED_FORMATS.hasOwnProperty(t[e]))return t[e];return r.DEFAULT_FORMAT},r}),i("ogc/gml/GmlBoundedBy",["../../error/ArgumentError","../../util/Logger"],function(t,e){"use strict";var i=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"GmlAbstractGeometry","constructor","missingDom"));this.assembleElement(i)};return i.prototype.assembleElement=function(t){var e=t.children||t.childNodes;this.nilReason=t.getAttribute("nilReason");for(var i=0;i<e.length;i++){var r=e[i];"Envelope"===r.localName&&(this.envelope=this.assembleEnvelope(r))}},i.prototype.assembleEnvelope=function(t){var e=t.children||t.childNodes,i={};i.srsName=t.getAttribute("srsName"),i.srsDimension=parseInt(t.getAttribute("srsDimension")),i.axisLabels=t.getAttribute("axisLabels"),i.axisLabels&&(i.axisLabels=i.axisLabels.split(/\s+/)),i.uomLabels=t.getAttribute("uomLabels"),i.uomLabels&&(i.uomLabels=i.uomLabels.split(/\s+/));for(var r=0;r<e.length;r++){var n=e[r];if("lowerCorner"===n.localName){i.lower=n.textContent.split(/\s+/);for(var o=0;o<i.lower.length;o++)i.lower[o]=parseFloat(i.lower[o])}else if("upperCorner"===n.localName){i.upper=n.textContent.split(/\s+/);for(var o=0;o<i.upper.length;o++)i.upper[o]=parseFloat(i.upper[o])}}return i},i}),i("ogc/gml/GmlRectifiedGrid",["../../error/ArgumentError","../../util/Logger"],function(t,e){"use strict";var i=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"GmlRectifiedGrid","constructor","missingDom"));this.assembleElement(i)};return i.prototype.assembleElement=function(t){var e=t.children||t.childNodes;this.captureAttributes(t);for(var i=0;i<e.length;i++){var r=e[i];"description"===r.localName?this.description=r.textContent:"descriptionReference"===r.localName?this.descriptionReference=r.getAttribute("xlink:href"):"identifier"===r.localName?this.identifier=r.textContent:"name"===r.localName?(this.names=this.names||[],this.names.push(r.textContent)):"limits"===r.localName?this.limits=this.assembleLimits(r):"axisLabels"===r.localName?this.axisLabels=r.textContent.split(/\s+/):"axisName"===r.localName?(this.axisNames=this.axisNames||[],this.axisNames.push(r.textContent)):"origin"===r.localName?this.origin=this.assembleOrigin(r):"offsetVector"===r.localName&&(this.offsetVector=this.offsetVector||[],this.offsetVector.push(this.assembleOffsetVector(r)))}},i.prototype.captureAttributes=function(t){this.id=t.getAttribute("gml:id"),this.srsName=t.getAttribute("srsName"),this.srsDimension=t.getAttribute("srsDimension"),this.axisLabels=t.getAttribute("axisLabels"),this.axisLabels&&(this.axisLabels=this.axisLabels.split(/\s+/)),this.uomLabels=t.getAttribute("uomLabels"),this.uomLabels&&(this.uomLabels=this.uomLabels.split(/\s+/)),this.dimension=parseInt(t.getAttribute("dimension"))},i.prototype.assembleLimits=function(t){for(var e=t.children||t.childNodes,i=0;i<e.length;i++){var r=e[i];if("GridEnvelope"===r.localName)return this.assembleGridEnvelope(r)}},i.prototype.assembleGridEnvelope=function(t){for(var e=t.children||t.childNodes,i={},r=0;r<e.length;r++){var n=e[r];i[n.localName]=n.textContent.split(/\s+/)}return i},i.prototype.assembleOrigin=function(t){var e={};e.type=t.getAttribute("xlink:type"),e.href=t.getAttribute("xlink:href"),e.role=t.getAttribute("xlink:role"),e.arcrole=t.getAttribute("xlink:arcrole"),e.title=t.getAttribute("xlink:title"),e.show=t.getAttribute("xlink:show"),e.actuate=t.getAttribute("xlink:actuate"),e.nilReason=t.getAttribute("nilReason"),e.remoteSchema=t.getAttribute("gml:remoteSchema"),e.owns=t.getAttribute("owns");for(var i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Point"===n.localName?e.point=this.assemblePoint(n):"pos"===n.localName&&(e.pos=this.assemblePos(n))}return e},i.prototype.assemblePoint=function(t){var e={};e.id=t.getAttribute("gml:id"),e.srsName=t.getAttribute("srsName"),e.srsDimension=t.getAttribute("srsDimension"),e.axisLabels=t.getAttribute("axisLabels"),e.axisLabels&&(e.axisLabels=e.axisLabels.split(/\s+/)),e.uomLabels=t.getAttribute("uomLabels"),e.uomLabels&&(e.uomLabels=e.uomLabels.split(/\s+/));for(var i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"description"===n.localName?e.description=n.textContent:"descriptionReference"===n.localName?e.descriptionReference=this.assembleOrigin(n):"identifier"===n.localName?e.identifier=n.textContent:"name"===n.localName?e.name=n.textContent:"pos"===n.localName&&(e.pos=this.assemblePos(n))}return e},i.prototype.assemblePos=function(t){var e={};if(e.srsName=t.getAttribute("srsName"),e.srsDimension=parseInt(t.getAttribute("srsDimension")),e.axisLabels=t.getAttribute("axisLabels"),e.axisLabels&&(e.axisLabels=e.axisLabels.split(/\s+/)),e.uomLabels=t.getAttribute("uomLabels"),e.uomLabels&&(e.uomLabels=e.uomLabels.split(/\s+/)),e.pos=t.textContent,e.pos){e.pos=e.pos.split(/\s+/);for(var i=0;i<e.pos.length;i++)e.pos[i]=parseFloat(e.pos[i])}return e},i.prototype.assembleOffsetVector=function(t){var e,i=(t.children||t.childNodes,{});i.srsName=t.getAttribute("srsName"),i.srsDimension=parseInt(t.getAttribute("srsDimension")),i.axisLabels=t.getAttribute("axisLabels"),i.axisLabels&&(i.axisLabels=i.axisLabels.split(/\s+/)),i.uomLabels=t.getAttribute("uomLabels"),i.uomLabels&&(i.uomLabels=i.uomLabels.split(/\s+/)),e=t.textContent.split(/\s+/),i.values=[];for(var r=0;r<e.length;r++)i.values.push(parseFloat(e[r]));return i},i}),i("ogc/gml/GmlDomainSet",["../../error/ArgumentError","../../ogc/gml/GmlRectifiedGrid","../../util/Logger"],function(t,e,i){"use strict";var r=function(e){if(!e)throw new t(i.logMessage(i.LEVEL_SEVERE,"GmlAbstractGeometry","constructor","missingDom"));this.assembleElement(e)};return r.prototype.assembleElement=function(t){for(var i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"RectifiedGrid"===n.localName&&(this.rectifiedGrid=new e(n))}},r}),i("ogc/wcs/WcsCoverageDescriptions",["../../error/ArgumentError","../../ogc/gml/GmlBoundedBy","../../ogc/gml/GmlDomainSet","../../ogc/gml/GmlRectifiedGrid","../../util/Logger","../../ogc/ows/OwsKeywords","../../geom/Sector"],function(t,e,i,r,n,o,s){"use strict";var a=function(e){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"WcsCoverageDescriptions","constructor","missingDom"));this.xmlDom=e,this.assembleDocument()};return a.prototype.getSector=function(e){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"WcsCoverageDescriptions","getSector","missingId"));var i,r=this.getCoverage(e);return r?"1.0.0"===this.version?(i=r.lonLatEnvelope.pos,new s(i[0][1],i[1][1],i[0][0],i[1][0])):"2.0.1"===this.version||"2.0.0"===this.version?(i=r.boundedBy.envelope,new s(i.lower[0],i.upper[0],i.lower[1],i.upper[1])):null:null},a.prototype.getResolution=function(e){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"WcsCoverageDescriptions","getResolution","missingId"));var i,r,o,s,a,l,h=this.getCoverage(e),u=this.getSector(e);return h?("1.0.0"===this.version?(i=h.domainSet.spatialDomain.rectifiedGrid.limits.low[0],r=h.domainSet.spatialDomain.rectifiedGrid.limits.low[1],o=h.domainSet.spatialDomain.rectifiedGrid.limits.high[0],s=h.domainSet.spatialDomain.rectifiedGrid.limits.high[1]):"2.0.1"!==this.version&&"2.0.0"!==this.version||(i=h.domainSet.rectifiedGrid.limits.low[0],r=h.domainSet.rectifiedGrid.limits.low[1],o=h.domainSet.rectifiedGrid.limits.high[0],s=h.domainSet.rectifiedGrid.limits.high[1]),a=u.deltaLongitude()/(o-i),l=u.deltaLatitude()/(s-r),Math.max(a,l)):null},a.prototype.getSupportedCrs=function(e){if(!e)throw new t(n.logMessage(n.LEVEL_SEVERE,"WcsCoverageDescriptions","getSupportedCrs","missingId"));var i=this.getCoverage(e),r=[];return i?"1.0.0"===this.version?i.supportedCrs.requests:"2.0.1"===this.version||"2.0.0"===this.version?(r.push(i.boundedBy.envelope.srsName),r):null:null},a.prototype.getCoverage=function(t){for(var e=0,i=this.coverages.length;e<i;e++)if(t===(this.coverages[e].coverageId||this.coverages[e].name))return this.coverages[e];return null},a.prototype.assembleDocument=function(){var e=this.xmlDom.documentElement;if("CoverageDescription"===e.localName)this.assembleDocument100(e),this.version="1.0.0";else{if("CoverageDescriptions"!==e.localName)throw new t(n.logMessage(n.LEVEL_SEVERE,"WcsCapabilities","assembleDocument","unsupportedVersion"));this.assembleDocument20x(e),this.version=e.getAttribute("version")||"2.0.1"}},a.prototype.assembleDocument100=function(t){this.version=t.getAttribute("version");for(var e=t.children||t.childNodes,i=0;i<e.length;i++){var r=e[i];"CoverageOffering"===r.localName&&(this.coverages=this.coverages||[],this.coverages.push(this.assembleCoverages100(r)))}},a.prototype.assembleDocument20x=function(t){for(var e=t.children||t.childNodes,i=0;i<e.length;i++){var r=e[i];"CoverageDescription"===r.localName&&(this.coverages=this.coverages||[],this.coverages.push(this.assembleCoverages20x(r)))}},a.prototype.assembleCoverages100=function(t){for(var e=t.children||t.childNodes,i={},r=0;r<e.length;r++){var n=e[r];"name"===n.localName?i.name=n.textContent:"description"===n.localName?i.description=n.textContent:"label"===n.localName?i.label=n.textContent:"keywords"===n.localName?i.keywords=new o(n).keywords:"lonLatEnvelope"===n.localName?i.lonLatEnvelope=this.assembleLonLatEnvelope100(n):"supportedCRSs"===n.localName?i.supportedCrs=this.assembleSupportedCrs100(n):"supportedFormats"===n.localName?i.supportedFormats=this.assembleSupportedFormats100(n):"supportedInterpolations"===n.localName?i.supportedInterpolations=this.assembleSupportedInterpolations100(n):"domainSet"===n.localName?i.domainSet=this.assembleDomainSet100(n):"rangeSet"===n.localName&&(i.rangeSet=this.assembleRangeSet100(n))}return i},a.prototype.assembleCoverages20x=function(t){for(var r=t.children||t.childNodes,n={},o=0;o<r.length;o++){var s=r[o];"CoverageId"===s.localName?n.coverageId=s.textContent:"domainSet"===s.localName?n.domainSet=new i(s):"boundedBy"===s.localName?n.boundedBy=new e(s):"ServiceParameters"===s.localName?n.serviceParameters=this.assembleServiceParameters20x(s):"rangeType"===s.localName&&(n.rangeType=s)}return n},a.prototype.assembleServiceParameters20x=function(t){for(var e=t.children||t.childNodes,i={},r=0;r<e.length;r++){var n=e[r];"nativeFormat"===n.localName?i.nativeFormat=n.textContent:"CoverageSubtype"===n.localName&&(i.coverageSubtype=n.textContent)}return i},a.prototype.assembleLonLatEnvelope100=function(t){var e=t.children||t.childNodes,i={};i.srsName=t.getAttribute("srsName");for(var r=0;r<e.length;r++){var n=e[r];"pos"===n.localName&&(i.pos=i.pos||[],i.pos.push(a.parseSpacedFloatArray(n.textContent)))}return i},a.prototype.assembleSupportedCrs100=function(t){for(var e=t.children||t.childNodes,i={},r=0;r<e.length;r++){var n=e[r];"requestResponseCRSs"===n.localName?(i.requests=i.requests||[],i.requests.push(n.textContent),i.responses=i.responses||[],i.responses.push(n.textContent)):"requestCRSs"===n.localName?(i.requests=i.requests||[],i.push(n.textContent)):"responseCRSs"===n.localName?(i.responses=i.responses||[],i.push(n.textContent)):"NativeCRSs"===n.localName&&(i.nativeCrs=i.nativeCrs||[],i.push(n.textContent))}return i},a.prototype.assembleSupportedFormats100=function(t){var e=t.children||t.childNodes,i={};i.nativeFormat=t.getAttribute("nativeFormat");for(var r=0;r<e.length;r++){var n=e[r];"formats"===n.localName&&(i.formats=i.formats||[],i.formats.push(n.textContent))}return i},a.prototype.assembleSupportedInterpolations100=function(t){var e=t.children||t.childNodes,i={};i.default=t.getAttribute("default");for(var r=0;r<e.length;r++){var n=e[r];"interpolationMethod"===n.localName&&(i.methods=i.methods||[],i.methods.push(n.textContent))}return i},a.prototype.assembleDomainSet100=function(t){for(var e=t.children||t.childNodes,i={},r=0;r<e.length;r++){var n=e[r];"spatialDomain"===n.localName&&(i.spatialDomain=this.assembleSpatialDomain100(n))}return i},a.prototype.assembleSpatialDomain100=function(t){for(var e=t.children||t.childNodes,i={},n=0;n<e.length;n++){var o=e[n];"Envelope"===o.localName?i.envelope=this.assembleLonLatEnvelope100(o):"RectifiedGrid"===o.localName&&(i.rectifiedGrid=new r(o))}return i},a.prototype.assembleRangeSet100=function(t){for(var e=t.children||t.childNodes,i=0;i<e.length;i++){var r=e[i];if("RangeSet"===r.localName)return this.assembleRangeSetElement100(r)}},a.prototype.assembleRangeSetElement100=function(t){var e=t.children||t.childNodes,i={};i.semantic=t.getAttribute("semantic"),i.refSys=t.getAttribute("refSys"),i.refSysLable=t.getAttribute("refSysLabel");for(var r=0;r<e.length;r++){var n=e[r];"name"===n.localName?i.name=n.textContent:"label"===n.localName?i.label=n.textContent:"axisDescription"===n.localName&&(i.axisDescriptions=this.assembleRangeSetAxisDescription100(n))}return i},a.prototype.assembleRangeSetAxisDescription100=function(t){for(var e=t.children||t.childNodes,i=[],r=0;r<e.length;r++){var n=e[r];"AxisDescription"===n.localName&&i.push(this.assembleRangeSetAxisDescriptionElement100(n))}return i},a.prototype.assembleRangeSetAxisDescriptionElement100=function(t){for(var e=t.children||t.childNodes,i={},r=0;r<e.length;r++){var n=e[r];"name"===n.localName?i.name=n.textContent:"label"===n.localName?i.label=n.textContent:"values"===n.localName&&(i.values=this.assembleRangeSetValues100(n))}return i},a.prototype.assembleRangeSetValues100=function(t){for(var e=t.children||t.childNodes,i={},r=0;r<e.length;r++){var n=e[r];"singleValue"===n.localName&&(i.singleValue=n.textContent)}return i},a.parseSpacedFloatArray=function(t){for(var e=[],i=t.split(/\s+/),r=0;r<i.length;r++)e.push(parseFloat(i[r]));return e},a}),i("util/WcsTileUrlBuilder",["../error/ArgumentError","../util/Logger"],function(t,e){"use strict";var i=function(i,r,n){if(!i||0===i.length)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsTileUrlBuilder","constructor","The WCS service address is missing."));if(!r||0===r.length)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsTileUrlBuilder","constructor","The WCS coverage name is missing."));this.serviceAddress=i,this.coverageName=r,this.wcsVersion=n&&n.length>0?n:"1.0.0",this.crs="EPSG:4326"};return i.prototype.urlForTile=function(r,n){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsUrlBuilder","urlForTile","missingTile"));if(!n)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsUrlBuilder","urlForTile","The coverage format is null or undefined."));var o=r.sector,s=i.fixGetCoverageString(this.serviceAddress);return s.search(/service=wcs/i)<0&&(s+="service=WCS"),s+="&request=GetCoverage",s=s+"&version="+this.wcsVersion,s=s+"&coverage="+this.coverageName,s=s+"&format="+n,s=s+"&width="+r.tileWidth,s=s+"&height="+r.tileHeight,s=s+"&crs="+this.crs,s+="&bbox=",s=s+o.minLongitude+","+o.minLatitude+",",s=s+o.maxLongitude+","+o.maxLatitude,s=s.replace(" ","%20")},i.fixGetCoverageString=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WcsTileUrlBuilder","fixGetCoverageString","The specified service address is null or undefined."));var r=i.indexOf("?");return r<0?i+="?":r!==i.length-1&&(r=i.search(/&$/),r<0&&(i+="&")),i},i}),i("globe/WcsEarthElevationCoverage",["../geom/Location","../geom/Sector","../globe/TiledElevationCoverage","../util/WcsTileUrlBuilder"],function(t,e,i,r){"use strict";var n=function(){i.call(this,{coverageSector:e.FULL_SPHERE,resolution:.008333333333333,retrievalImageFormat:"image/tiff",minElevation:-11e3,maxElevation:8850,urlBuilder:new r("https://worldwind26.arc.nasa.gov/wms2","NASA_SRTM30_900m_Tiled","1.0.0")}),this.displayName="WCS Earth Elevation Coverage"};return n.prototype=Object.create(i.prototype),n}),i("ogc/wcs/WebCoverageService",["../../error/ArgumentError","../../util/Logger","../../util/Promise","../../ogc/wcs/WcsCapabilities","../../ogc/wcs/WcsCoverage","../../ogc/wcs/WcsCoverageDescriptions"],function(t,e,i,r,n,o){"use strict";var s=function(){this.serviceAddress=null,this.coverages=[],this.capabilities=null,this.coverageDescriptions=null};return s.WCS_XLMNS="http://www.opengis.net/wcs",s.WCS_2_XLMNS="http://www.opengis.net/wcs/2.0",s.create=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WebCoverageService","constructor","missingUrl"));var r=new s;return r.serviceAddress=i,r.retrieveCapabilities().then(function(t){return r.capabilities=t,r.retrieveCoverageDescriptions(t)}).then(function(t){return r.parseCoverages(t),r})},s.prototype.getCoverage=function(t){},s.prototype.retrieveCapabilities=function(){var t,e=this;return e.retrieveXml(e.buildCapabilitiesXmlRequest("2.0.1")).then(function(i){return t=i.documentElement.getAttribute("version"),"2.0.1"===t||"2.0.0"===t?i:e.retrieveXml(e.buildCapabilitiesXmlRequest("1.0.0"))}).then(function(t){return new r(t)})},s.prototype.retrieveCoverageDescriptions=function(){return this.retrieveXml(this.buildDescribeCoverageXmlRequest())},s.prototype.parseCoverages=function(t){this.coverageDescriptions=new o(t);for(var e,i,r=this.coverageDescriptions.coverages.length,s=0;s<r;s++)e=this.coverageDescriptions.coverages[s].coverageId||this.coverageDescriptions.coverages[s].name,i=new n(e,this),this.coverages.push(i)},s.prototype.retrieveXml=function(t){return new i(function(i,r){var n=new XMLHttpRequest;n.open("POST",t.url),n.onreadystatechange=function(){4===n.readyState&&(200===n.status?i(n.responseXML):r(new Error(e.logMessage(e.LEVEL_WARNING,"XML retrieval failed ("+n.statusText+"): "+t.url))))},n.onerror=function(){r(new Error(e.logMessage(e.LEVEL_WARNING,"XML retrieval failed: "+t.url)))},n.ontimeout=function(){r(new Error(e.logMessage(e.LEVEL_WARNING,"XML retrieval timed out: "+t.url)))},n.send(t.body)})},s.prototype.buildCapabilitiesXmlRequest=function(t){var e=this.createBaseWcsElement("GetCapabilities",t);return{url:this.serviceAddress,body:(new XMLSerializer).serializeToString(e)}},s.prototype.buildDescribeCoverageXmlRequest=function(){var t,e,i,r=this.capabilities.version,n=this.capabilities.coverages.length;t=this.createBaseWcsElement("DescribeCoverage",r),"1.0.0"===r?i=this.capabilities.capability.request.describeCoverage.get:"2.0.1"!==r&&"2.0.0"!==r||(i=this.capabilities.operationsMetadata.getOperationMetadataByName("DescribeCoverage").dcp[0].getMethods[0].url);for(var o=0;o<n;o++)"1.0.0"===r?(e=document.createElementNS(s.WCS_XLMNS,"Coverage"),e.appendChild(document.createTextNode(this.capabilities.coverages[o].name))):"2.0.1"!==r&&"2.0.0"!==r||(e=document.createElementNS(s.WCS_2_XLMNS,"CoverageId"),e.appendChild(document.createTextNode(this.capabilities.coverages[o].coverageId))),t.appendChild(e);return{url:i,body:(new XMLSerializer).serializeToString(t)}},s.prototype.createBaseWcsElement=function(t,e){var i;return"1.0.0"===e?(i=document.createElementNS(s.WCS_XLMNS,t),i.setAttribute("version","1.0.0")):"2.0.1"!==e&&"2.0.0"!==e||(i=document.createElementNS(s.WCS_2_XLMNS,t),i.setAttribute("version",e)),i.setAttribute("service","WCS"),i},s}),i("ogc/WfsCapabilities",["../error/ArgumentError","../util/Logger","../ogc/ows/OwsLanguageString","../ogc/ows/OwsOperationsMetadata","../ogc/ows/OwsServiceIdentification","../ogc/ows/OwsServiceProvider"],function(t,e,i,r,n,o){"use strict";var s=function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WfsCapabilities","constructor","No XML DOM specified."));this.assembleDocument(i)};return s.prototype.assembleDocument=function(t){var e=t.documentElement;this.version=e.getAttribute("version"),this.updateSequence=e.getAttribute("updateSequence");for(var i=e.children||e.childNodes,s=0;s<i.length;s++){var a=i[s];"ServiceIdentification"===a.localName?this.serviceIdentification=new n(a):"ServiceProvider"===a.localName?this.serviceProvider=new o(a):"OperationsMetadata"===a.localName?this.operationsMetadata=new r(a):"FeatureTypeList"===a.localName?this.featureTypeList=this.assembleFeatureTypeList(a):"Filter_Capabilities"===a.localName&&(this.filterCapabilities=this.assembleFilterCapabilities(a))}},s.prototype.assembleFeatureTypeList=function(t){for(var i={},r=t.children||t.childNodes,n=0;n<r.length;n++){
var o=r[n];if("Operations"==o.localName){i.operations=i.operations||[];try{i.operations=s.assembleOperations(o)}catch(t){e.logMessage(e.LEVEL_SEVERE,"WfsCapabilities","constructor","Exception reading WFS operations description: "+t.message)}}else if("FeatureType"==o.localName){i.featureType=i.featureType||[];try{i.featureType.push(s.assembleFeatureType(o))}catch(t){e.logMessage(e.LEVEL_SEVERE,"WfsCapabilities","constructor","Exception reading WFS operations description: "+t.message)}}}return i},s.prototype.assembleFilterCapabilities=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Conformance"===n.localName?e.conformance=s.assembleConformance(n):"Id_Capabilities"===n.localName?e.idCapabilities=s.assembleIdCapabilities(n):"Scalar_Capabilities"===n.localName?e.scalarCapabilities=s.assembleScalarCapabilities(n):"Spatial_Capabilities"===n.localName?e.spatialCapabilities=s.assembleSpatialCapabilities(n):"Functions"===n.localName&&(e.functions=s.assembleFunctions(n))}return e},s.assembleOperations=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Operation"==n.localName&&e.push(n.textContent)}return e},s.assembleFeatureType=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Name"==n.localName?e.name=n.textContent:"Title"==n.localName?e.title=n.textContent:"Abstract"==n.localName?e.abstract=n.textContent:"Keywords"==n.localName?(e.keywords=e.keywords||[],e.keywords=s.assembleKeywords(n)):"DefaultSRS"==n.localName?e.defaultSRS=n.textContent:"OtherSRS"==n.localName?(e.otherSRS=e.otherSRS||[],e.otherSRS.push(n.textContent)):"WGS84BoundingBox"==n.localName?e.wgs84BoundingBox=s.assembleBoundingBox(n):"DefaultCRS"==n.localName?e.defaultCRS=n.textContent:"OtherCRS"==n.localName?(e.otherCRS=e.otherCRS||[],e.otherCRS.push(n.textContent)):"OutputFormats"==n.localName?e.outputFormats=s.assembleOutputFormats(n):"MetadataURL"==n.localName&&(e.metadataUrl=s.assembleMetadataUrl(n))}return e},s.assembleBoundingBox=function(t){var e={},i=t.getAttribute("crs");i&&(e.crs=i);for(var r=t.children||t.childNodes,n=0;n<r.length;n++){var o=r[n];if("LowerCorner"===o.localName){var s=o.textContent.split(" ");e.lowerCorner=[parseFloat(s[0]),parseFloat(s[1])]}else if("UpperCorner"===o.localName){var a=o.textContent.split(" ");e.upperCorner=[parseFloat(a[0]),parseFloat(a[1])]}}return e},s.assembleOutputFormats=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Format"===n.localName&&e.push(n.textContent)}return e},s.assembleMetadataUrl=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"MetadataURL"===n.localName&&(e.format=n.getAttribute("format"),e.type=n.getAttribute("type"))}return outputFormats},s.assembleKeywords=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Keyword"===n.localName&&e.push(n.textContent)}return e},s.assembleConformance=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];if("Constraint"===n.localName){var o;o=s.assembleConstraint(n),o.name=n.getAttribute("name"),e.push(o)}}return e},s.assembleConstraint=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"DefaultValue"===n.localName&&(e.defaultValue=n.textContent)}return e},s.assembleIdCapabilities=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"ResourceIdentifier"===n.localName&&(e.resourceIdentifier=n.getAttribute("name"))}return e},s.assembleScalarCapabilities=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"ComparisonOperators"===n.localName?e.comparisonOperators=s.assembleComparisonOperators(n):"ArithmeticOperators"===n.localName&&(e.arithmeticOperators=s.assembleArithmeticOperators(n))}return e},s.assembleComparisonOperators=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"ComparisonOperator"===n.localName&&e.push(n.textContent)}return e},s.assembleArithmeticOperators=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Functions"===n.localName&&(e.functions=s.assembleArithmeticFunctions(n))}return e},s.assembleArithmeticFunctions=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"FunctionNames"===n.localName&&(e=s.assembleFunctionNames(n))}return e},s.assembleFunctionNames=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];if("FunctionName"===n.localName){var o={name:n.textContent,nArgs:n.getAttribute("nArgs")};e.push(o)}}return e},s.assembleSpatialCapabilities=function(t){for(var e={},i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"GeometryOperands"===n.localName?e.geometryOperands=s.assembleGeometryOperands(n):"SpatialOperators"===n.localName&&(e.spatialOperators=s.assembleSpatialOperators(n))}return e},s.assembleGeometryOperands=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"GeometryOperand"===n.localName&&e.push(n.getAttribute("name"))}return e},s.assembleSpatialOperators=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"SpatialOperator"===n.localName&&e.push(n.getAttribute("name"))}return e},s.assembleFunctions=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Function"===n.localName&&e.push(s.assembleFunction(n))}return e},s.assembleFunction=function(t){var e={};e.name=t.getAttribute("name");for(var i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Returns"===n.localName?e.returns=n.textContent:"Arguments"===n.localName&&(e.arguments=s.assembleArguments(n))}return e},s.assembleArguments=function(t){for(var e=[],i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Argument"===n.localName&&e.push(s.assembleArgument(n))}return e},s.assembleArgument=function(t){var e={};e.name=t.getAttribute("name");for(var i=t.children||t.childNodes,r=0;r<i.length;r++){var n=i[r];"Type"===n.localName&&(e.type=n.textContent)}return e},s}),i("formats/wkt/WktElements",[],function(){var t={};return t}),i("formats/wkt/WktType",[],function(){var t=function(){};return t.SupportedGeometries={LINE_STRING:"LINESTRING",MULTI_LINE_STRING:"MULTILINESTRING",POLYGON:"POLYGON",MULTI_POLYGON:"MULTIPOLYGON",POINT:"POINT",MULTI_POINT:"MULTIPOINT",TRIANGLE:"TRIANGLE",GEOMETRY_COLLECTION:"GEOMETRYCOLLECTION"},t.TokenType={LEFT_PARENTHESIS:0,COMMA:1,RIGHT_PARENTHESIS:2,NUMBER:3,TEXT:4},t}),i("formats/wkt/geom/WktObject",["../../../geom/Location","../../../geom/Position","../WktElements","../WktType"],function(t,e,i,r){var n=function(t){this.type=t,this._is3d=!1,this._isLrs=!1,this.coordinates=[],this.options={coordinates:[],leftParenthesis:0,rightParenthesis:0,tokens:[]}};return n.prototype.set3d=function(){this._is3d=!0},n.prototype.setLrs=function(){this._isLrs=!0},n.prototype.addCoordinates=function(i){this._is3d?this.coordinates.push(new e(i[1],i[0],i[2]||0)):this.coordinates.push(new t(i[1],i[0]))},n.prototype.shapes=function(){return[]},n.prototype.handleToken=function(t){var e=t.value,i=this.options;t.type===r.TokenType.TEXT?this.text(i,e):t.type===r.TokenType.LEFT_PARENTHESIS?this.leftParenthesis(i):t.type===r.TokenType.RIGHT_PARENTHESIS?this.rightParenthesis(i):t.type===r.TokenType.NUMBER?this.number(i,e):t.type===r.TokenType.COMMA&&this.comma(i),i.tokens.push(t)},n.prototype.text=function(t,e){e=e.toUpperCase();var r=null;if(e.length<=2)this.setOptions(e,this);else if(0===e.indexOf("EMPTY"))t.leftParenthesis=1,t.rightParenthesis=1;else{var o=e.match("[M]?[Z]?$");o&&o.length>0&&""!=o[0]&&this.setOptions(o,r);var s=i[e]&&new i[e];s||(s=new n),o&&o.length>0&&""!=o[0]&&s.setOptions(o[0],s),this.add(s)}},n.prototype.rightParenthesis=function(t){t.rightParenthesis++,t.coordinates&&(this.addCoordinates(t.coordinates),t.coordinates=null)},n.prototype.leftParenthesis=function(t){t.leftParenthesis++},n.prototype.comma=function(t){t.coordinates?(this.addCoordinates(t.coordinates),t.coordinates=null):this.commaWithoutCoordinates(t)},n.prototype.commaWithoutCoordinates=function(t){},n.prototype.number=function(t,e){t.coordinates=t.coordinates||[],t.coordinates.push(e)},n.prototype.setOptions=function(t,e){"Z"==t?e.set3d():"M"==t?e.setLrs():"MZ"==t&&(e.set3d(),e.setLrs())},n.prototype.isFinished=function(){return this.options.leftParenthesis===this.options.rightParenthesis&&this.options.leftParenthesis>0},n}),i("formats/wkt/WktTokens",["./WktElements","./geom/WktObject","./WktType"],function(t,e,i){var r=function(t){this.sourceText=t};return r.prototype.objects=function(){var i,r=[];return this.tokenize(this.sourceText).forEach(function(n){if(i&&i.isFinished()||!i){var o=n.value,s=o.match("[M]?[Z]?$");s&&s.length>0&&""!=s[0]&&(o=o.substring(0,o.length-s.length)),i=t[o]&&new t[o],i||(i=new e),s&&s.length>0&&""!=s[0]&&i.setOptions(s[0],i),r.push(i)}else i.handleToken(n)}),r},r.prototype.tokenize=function(t){this.currentPosition=0;for(var e=[];this.currentPosition<t.length;this.currentPosition++){var r=t.charAt(this.currentPosition);if("("==r)e.push({type:i.TokenType.LEFT_PARENTHESIS});else if(","==r)e.push({type:i.TokenType.COMMA});else if(")"==r)e.push({type:i.TokenType.RIGHT_PARENTHESIS});else if(this.isAlpha(r)){var n=this.readText(t);e.push({type:i.TokenType.TEXT,value:n})}else{if(!this.isNumeric(r)){if(this.isWhiteSpace(r))continue;throw new Error("Invalid character: {{",r,"}}")}var o=this.readNumeric(t);e.push({type:i.TokenType.NUMBER,value:o})}}return e},r.prototype.isAlpha=function(t){return t>="a"&&t<="z"||t>="A"&&t<="Z"},r.prototype.isNumeric=function(t){return t>="0"&&t<="9"||"."==t||"-"==t},r.prototype.isWhiteSpace=function(t){return" "==t||"\t"==t||"\r"==t||"\n"==t},r.prototype.readText=function(t){for(var e="";this.isAlpha(t.charAt(this.currentPosition));)e+=t.charAt(this.currentPosition),this.currentPosition++;return this.currentPosition--,e},r.prototype.readNumeric=function(t){for(var e="";this.isNumeric(t.charAt(this.currentPosition));)e+=t.charAt(this.currentPosition),this.currentPosition++;return this.currentPosition--,Number(e)},r}),i("formats/wkt/Wkt",["../../error/ArgumentError","../../util/Logger","./WktTokens"],function(t,e,i){var r=function(t){this.textRepresentation=t,this._parserCompletionCallback=this.defaultParserCompletionCallback,this._shapeConfigurationCallback=this.defaultShapeConfigurationCallback,this._layer=null};return Object.defineProperties(r.prototype,{parserCompletionCallback:{get:function(){return this._parserCompletionCallback}},shapeConfigurationCallback:{get:function(){return this._shapeConfigurationCallback}},layer:{get:function(){return this._layer}}}),r.prototype.load=function(t,e,r){r&&(this._layer=r),t&&(this._parserCompletionCallback=t),e&&(this._shapeConfigurationCallback=e),this.parserCompletionCallback(this,new i(this.textRepresentation).objects())},r.prototype.defaultShapeConfigurationCallback=function(t){},r.prototype.defaultParserCompletionCallback=function(t,e){var i=t.shapeConfigurationCallback,r=[];e.forEach(function(t){t.shapes().forEach(function(e){var n=i(t);n&&n.name&&(e.displayName=n.name),n&&n.attributes&&(e.attributes=n.attributes),n&&n.highlightAttributes&&(e.highlightAttributes=n.highlightAttributes),n&&n.pickDelegate&&(e.pickDelegate=n.pickDelegate),n&&n.userProperties&&(e.userProperties=n.userProperties),n&&n.timeRange&&(e.timeRange=n.timeRange),r.push(e)})}),t.layer&&t.layer.addRenderables(r)},r}),i("formats/wkt/WktExporter",["../../error/ArgumentError","../../util/Logger","./WktType"],function(t,e,i){"use strict";var r={exportRenderable:function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportRenderable","missingRenderable"));return i instanceof WorldWind.Placemark?this.exportPlacemark(i):i instanceof WorldWind.Path?this.exportPath(i):i instanceof WorldWind.Polygon?this.exportPolygon(i):i instanceof WorldWind.SurfacePolyline?this.exportSurfacePolyline(i):i instanceof WorldWind.SurfacePolygon?this.exportSurfacePolygon(i):i instanceof WorldWind.SurfaceEllipse?this.exportSurfaceEllipse(i):i instanceof WorldWind.SurfaceCircle?this.exportSurfaceCircle(i):i instanceof WorldWind.SurfaceRectangle?this.exportSurfaceRectangle(i):i instanceof WorldWind.SurfaceSector?this.exportSurfaceSector(i):(e.log(e.LEVEL_WARNING,"Export renderable not implemented: "+i),null)},exportRenderables:function(r){if(!r)throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportRenderables","missingRenderables"));if(0!=r.length){if(r.length>1){for(var n=i.SupportedGeometries.GEOMETRY_COLLECTION+"(",o=0;o<r.length;o++){var s=this.exportRenderable(r[o]);s&&(n+=s,n+=",")}return n=n.substring(0,n.length-1),n+=")"}return this.exportRenderable(r[0])}},exportLayer:function(i){if(!i)throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportLayer","missingLayer"));return this.exportRenderables(i.renderables)},exportPlacemark:function(r){if(!(r instanceof WorldWind.Placemark))throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportPlacemark","invalidTypeOfRenderable"));var n=i.SupportedGeometries.POINT+"(";return n=n+r.position.longitude+" "+r.position.latitude,n+=")"},exportPath:function(r){if(!(r instanceof WorldWind.Path))throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportPath","invalidTypeOfRenderable"));for(var n=i.SupportedGeometries.LINE_STRING+"(",o=0;o<r.positions.length;o++)n=n+r.positions[o].longitude+" "+r.positions[o].latitude;return n=n.substring(0,n.length-2),n+=")"},exportPolygon:function(r){if(!(r instanceof WorldWind.Polygon))throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportPolygon","invalidTypeOfRenderable"));var n=i.SupportedGeometries.POLYGON+"(";if(r.boundaries.length>0&&r.boundaries[0].length>2){for(var o=0;o<r.boundaries.length;o++){n+="(";for(var s=0;s<r.boundaries[o].length;s++)n=n+r.boundaries[o][s].longitude+" "+r.boundaries[o][s].latitude,n+=", ";n=n.substring(0,n.length-2),n+=")",n+=", "}n=n.substring(0,n.length-2)}else{n+="(";for(var o=0;o<r.boundaries.length;o++)n=n+r.boundaries[o].longitude+" "+r.boundaries[o].latitude,n+=", ";n=n.substring(0,n.length-2),n+=")"}return n+=")"},exportSurfacePolyline:function(r){if(!(r instanceof WorldWind.SurfacePolyline))throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportSurfacePolyline","invalidTypeOfRenderable"));for(var n=i.SupportedGeometries.LINE_STRING+"(",o=0;o<r.boundaries.length;o++)n=n+r.boundaries[o].longitude+" "+r.boundaries[o].latitude,n+=", ";return n=n.substring(0,n.length-2),n+=")"},exportSurfacePolygon:function(r){if(!(r instanceof WorldWind.SurfacePolygon))throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportSurfacePolygon","invalidTypeOfRenderable"));var n=i.SupportedGeometries.POLYGON+"(";if(r.boundaries.length>0&&r.boundaries[0].length>2){for(var o=0;o<r.boundaries.length;o++){n+="(";for(var s=0;s<r.boundaries[o].length;s++)n=n+r.boundaries[o][s].longitude+" "+r.boundaries[o][s].latitude,n+=", ";n=n.substring(0,n.length-2),n+=")",n+=", "}n=n.substring(0,n.length-2)}else{n+="(";for(var o=0;o<r.boundaries.length;o++)n=n+r.boundaries[o].longitude+" "+r.boundaries[o].latitude,n+=", ";n=n.substring(0,n.length-2),n+=")"}return n+=")"},exportSurfaceEllipse:function(r){if(!(r instanceof WorldWind.SurfaceEllipse))throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportSurfaceEllipse","invalidTypeOfRenderable"));var n=i.SupportedGeometries.POLYGON+"(";n+="(";for(var o=0;o<r._boundaries.length;o++)n=n+r._boundaries[o].longitude+" "+r._boundaries[o].latitude,n+=", ";return n=n.substring(0,n.length-2),n+=")",n+=")"},exportSurfaceCircle:function(r){if(!(r instanceof WorldWind.SurfaceCircle))throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportSurfaceCircle","invalidTypeOfRenderable"));var n=i.SupportedGeometries.POLYGON+"(";n+="(";for(var o=0;o<r._boundaries.length;o++)n=n+r._boundaries[o].longitude+" "+r._boundaries[o].latitude,n+=", ";return n=n.substring(0,n.length-2),n+=")",n+=")"},exportSurfaceRectangle:function(r){if(!(r instanceof WorldWind.SurfaceRectangle))throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportSurfaceRectangle","invalidTypeOfRenderable"));var n=i.SupportedGeometries.POLYGON+"(";n+="(";for(var o=0;o<r._boundaries.length;o++)n=n+r._boundaries[o].longitude+" "+r._boundaries[o].latitude,n+=", ";return n=n.substring(0,n.length-2),n+=")",n+=")"},exportSurfaceSector:function(r){if(!(r instanceof WorldWind.SurfaceSector))throw new t(e.logMessage(e.LEVEL_SEVERE,"WktExporter","exportSurfaceSector","invalidTypeOfRenderable"));var n=i.SupportedGeometries.POLYGON+"(";n+="(";for(var o=0;o<r._boundaries.length;o++)n=n+r._boundaries[o].longitude+" "+r._boundaries[o].latitude,n+=", ";return n=n.substring(0,n.length-2),n+=")",n+=")"}};return r}),i("formats/wkt/geom/WktGeometryCollection",["../../../geom/Location","../../../geom/Position","../WktElements","./WktObject","../WktType"],function(t,e,i,r,n){var o=function(){r.call(this,n.SupportedGeometries.GEOMETRY_COLLECTION),this.objects=[]};return o.prototype=Object.create(r.prototype),o.prototype.add=function(t){this.objects.push(t)},o.prototype.addCoordinates=function(i){var r=this.objects[this.objects.length-1];this._is3d?r.coordinates.push(new e(i[0],i[1],i[2]||0)):r.coordinates.push(new t(i[0],i[1]))},o.prototype.shapes=function(){var t=[];return this.objects.forEach(function(e){e.shapes().forEach(function(e){t.push(e)})}),t},i.GEOMETRYCOLLECTION=o,o}),i("formats/wkt/geom/WktLineString",["../../../shapes/Path","../../../shapes/ShapeAttributes","../../../shapes/SurfacePolyline","../WktElements","./WktObject","../WktType"],function(t,e,i,r,n,o){var s=function(){n.call(this,o.SupportedGeometries.LINE_STRING)};return s.prototype=Object.create(n.prototype),s.prototype.shapes=function(){return this._is3d?[new t(this.coordinates,new e(null))]:[new i(this.coordinates,new e(null))]},r.LINESTRING=s,s}),i("formats/wkt/geom/WktMultiLineString",["../../../shapes/Path","../../../shapes/ShapeAttributes","../../../shapes/SurfacePolyline","../WktElements","./WktObject","../WktType"],function(t,e,i,r,n,o){var s=function(){n.call(this,o.SupportedGeometries.MULTI_LINE_STRING),this.objectBoundaries=[]};return s.prototype=Object.create(n.prototype),s.prototype.commaWithoutCoordinates=function(){this.objectBoundaries.push(this.coordinates.slice()),this.coordinates=[]},s.prototype.shapes=function(){return this.commaWithoutCoordinates(),this._is3d?this.objectBoundaries.map(function(i){return new t(i,new e(null))}.bind(this)):this.objectBoundaries.map(function(t){return new i(t,new e(null))}.bind(this))},r.MULTILINESTRING=s,s}),i("formats/wkt/geom/WktPoint",["../../../shapes/Placemark","../../../shapes/PlacemarkAttributes","../WktElements","./WktObject","../WktType"],function(t,e,i,r,n){var o=function(){r.call(this,n.SupportedGeometries.POINT)};return o.prototype=Object.create(r.prototype),o.prototype.shapes=function(){return[o.placemark(this.coordinates[0])]},o.placemark=function(i){var r=new e(null);r.imageScale=1,r.imageOffset=new WorldWind.Offset(WorldWind.OFFSET_FRACTION,.3,WorldWind.OFFSET_FRACTION,0),r.imageColor=WorldWind.Color.WHITE,r.labelAttributes.offset=new WorldWind.Offset(WorldWind.OFFSET_FRACTION,.5,WorldWind.OFFSET_FRACTION,1),r.labelAttributes.color=WorldWind.Color.YELLOW,r.drawLeaderLine=!0,r.leaderLineAttributes.outlineColor=WorldWind.Color.RED,r.imageSource=WorldWind.configuration.baseUrl+"images/pushpins/castshadow-purple.png";var n=new t(i,!0,r);return n.altitudeMode=WorldWind.RELATIVE_TO_GROUND,n},i.POINT=o,o}),i("formats/wkt/geom/WktMultiPoint",["../../../shapes/Placemark","../../../shapes/PlacemarkAttributes","../WktElements","./WktObject","./WktPoint","../WktType"],function(t,e,i,r,n,o){var s=function(){r.call(this,o.SupportedGeometries.MULTI_POINT)};return s.prototype=Object.create(r.prototype),s.prototype.commaWithoutCoordinates=function(){},s.prototype.shapes=function(){return this.coordinates.map(function(t){return n.placemark(t)}.bind(this))},i.MULTIPOINT=s,s}),i("formats/wkt/geom/WktMultiPolygon",["../../../shapes/Polygon","../../../shapes/ShapeAttributes","../../../shapes/SurfacePolygon","../WktElements","./WktObject","../WktType"],function(t,e,i,r,n,o){var s=function(){n.call(this,o.SupportedGeometries.MULTI_POLYGON),this.objectBoundaries=[],this.currentIndex=0};return s.prototype=Object.create(n.prototype),s.prototype.rightParenthesis=function(t){n.prototype.rightParenthesis.call(this,t),t.tokens[t.tokens.length-1].type!=o.TokenType.RIGHT_PARENTHESIS?this.addBoundaries():t.tokens[t.tokens.length-1].type==o.TokenType.RIGHT_PARENTHESIS&&t.tokens[t.tokens.length-2].type!=o.TokenType.RIGHT_PARENTHESIS&&this.addObject()},s.prototype.addBoundaries=function(){this.objectBoundaries[this.currentIndex]||(this.objectBoundaries[this.currentIndex]=[]),this.objectBoundaries[this.currentIndex].push(this.coordinates.slice()),this.coordinates=[]},s.prototype.addObject=function(){this.currentIndex++},s.prototype.shapes=function(){return this._is3d?this.objectBoundaries.map(function(i){return new t(i,new e(null))}.bind(this)):this.objectBoundaries.map(function(t){return new i(t,new e(null))}.bind(this))},r.MULTIPOLYGON=s,s}),i("formats/wkt/geom/WktPolygon",["../../../shapes/Polygon","../../../shapes/ShapeAttributes","../../../shapes/SurfacePolygon","../WktElements","./WktObject","../WktType"],function(t,e,i,r,n,o){var s=function(){n.call(this,o.SupportedGeometries.POLYGON),this._renderable=null};return s.prototype=Object.create(n.prototype),s.prototype.commaWithoutCoordinates=function(){this.outerBoundaries=this.coordinates.slice(),this.coordinates=[]},s.prototype.shapes=function(){return this._is3d?this.outerBoundaries?[new t([this.outerBoundaries,this.coordinates],new e(null))]:[new t(this.coordinates,new e(null))]:this.outerBoundaries?[new i([this.outerBoundaries,this.coordinates],new e(null))]:[new i(this.coordinates,new e(null))]},r.POLYGON=s,s}),i("formats/wkt/geom/WktTriangle",["../../../shapes/Polygon","../../../shapes/ShapeAttributes","../../../shapes/SurfacePolygon","../WktElements","./WktObject","../WktType"],function(t,e,i,r,n,o){var s=function(){n.call(this,o.SupportedGeometries.TRIANGLE),this._renderable=null};return s.prototype=Object.create(n.prototype),s.prototype.shapes=function(){return this._is3d?[new t(this.coordinates,new e(null))]:[new i(this.coordinates,new e(null))]},r.TRIANGLE=s,s}),i("layer/WmsTimeDimensionedLayer",["../error/ArgumentError","../layer/Layer","../util/Logger","../layer/WmsLayer"],function(t,e,i,r){"use strict";var n=function(r){if(!r)throw new t(i.logMessage(i.LEVEL_SEVERE,"WmsTimeDimensionedLayer","constructor","No configuration specified."));e.call(this,"WMS Time Dimensioned Layer"),this.config=r,this.displayName=r.title,this.pickEnabled=!1,this.layers={}};return n.prototype=Object.create(e.prototype),n.prototype.doRender=function(t){if(this.time){var e=this.time.toISOString(),i=this.layers[e];i||(i=new r(this.config,e),this.layers[e]=i),i.opacity=this.opacity,i.doRender(t),this.inCurrentFrame=i.inCurrentFrame}},n}),i("WorldWindow",["./ArcBallCamera","./error/ArgumentError","./BasicWorldWindowController","./render/DrawContext","./globe/EarthElevationModel","./util/FrameStatistics","./geom/Frustum","./globe/Globe","./globe/Globe2D","./util/GoToAnimator","./cache/GpuResourceCache","./geom/Line","./util/Logger","./navigate/LookAtNavigator","./geom/Matrix","./navigate/Navigator","./pick/PickedObjectList","./geom/Position","./geom/Rectangle","./geom/Sector","./shapes/SurfaceShape","./shapes/SurfaceShapeTileBuilder","./globe/Terrain","./geom/Vec2","./geom/Vec3","./util/WWMath"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_,b,w,S,L,T){"use strict";var A=function(s,l){function u(t){t.preventDefault()}function c(t){b.onGestureEvent(t)}function p(t){b.handleContextLost(t)}function m(t){b.handleContextRestored(t)}function y(t){b.handleRedrawEvent(t)}if(!window.WebGLRenderingContext)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","constructor","webglNotSupported"));var v;if(s instanceof HTMLCanvasElement)v=s;else if(v=document.getElementById(s),!v)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","constructor","The specified canvas ID is not in the document."));var _=this.createContext(v);if(!_)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","constructor","webglNotSupported"));this.drawContext=new r(_),this.eventListeners={},this.redrawRequested=!0,this.redrawRequestId=null,this.scratchModelview=f.fromIdentity(),this.scratchProjection=f.fromIdentity(),this.hasStencilBuffer=_.getContextAttributes().stencil,this.canvas=v,this.depthBits=_.getParameter(_.DEPTH_BITS),this.viewport=new E(0,0,_.drawingBufferWidth,_.drawingBufferHeight),this.globe=new a(l||new n),this.layers=[],this.navigator=new g(new t(this)),this.worldWindowController=new i(this),this.verticalExaggeration=1,this.deepPicking=!1,this.subsurfaceMode=!1,this.surfaceOpacity=1,this.frameStatistics=new o,this.goToAnimator=new h(this),this._redrawCallbacks=[],this._orderedRenderingFilters=[function(t){b.declutter(t,1)},function(t){b.declutter(t,2)}],this.pixelScale=1,this.addEventListener("mousedown",u),this.addEventListener("touchstart",u),this.addEventListener("contextmenu",u),this.addEventListener("wheel",u);var b=this;window.PointerEvent?(this.canvas.style.setProperty("touch-action","none"),this.addEventListener("pointerdown",c,!1),window.addEventListener("pointermove",c,!1),window.addEventListener("pointercancel",c,!1),window.addEventListener("pointerup",c,!1)):(this.addEventListener("mousedown",c,!1),window.addEventListener("mousemove",c,!1),window.addEventListener("mouseup",c,!1),this.addEventListener("touchstart",c,!1),this.addEventListener("touchmove",c,!1),this.addEventListener("touchend",c,!1),this.addEventListener("touchcancel",c,!1)),this.addEventListener("wheel",function(t){c(t)}),this.canvas.addEventListener("webglcontextlost",p,!1),this.canvas.addEventListener("webglcontextrestored",m,!1),this.canvas.addEventListener(WorldWind.REDRAW_EVENT_TYPE,y,!1),window.addEventListener(WorldWind.REDRAW_EVENT_TYPE,y,!1),this.animationFrameLoop()};return Object.defineProperties(A.prototype,{orderedRenderingFilters:{get:function(){return this._orderedRenderingFilters}},redrawCallbacks:{get:function(){return this._redrawCallbacks}}}),A.prototype.canvasCoordinates=function(t,e){var i=this.canvas.getBoundingClientRect(),r=t-(i.left+this.canvas.clientLeft),n=e-(i.top+this.canvas.clientTop);return new S(r,n)},A.prototype.onGestureEvent=function(t){this.worldWindowController.onGestureEvent(t)},A.prototype.addEventListener=function(t,i){if(!t)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","addEventListener","missingType"));if(!i)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","addEventListener","missingListener"));var r=this,n=this.eventListeners[t];n||(n={listeners:[],callback:function(t){t.worldWindow=r;for(var e=0,i=n.listeners.length;e<i;e++)n.listeners[e](t)}},this.eventListeners[t]=n);var o=n.listeners.indexOf(i);o==-1&&(n.listeners.splice(0,0,i),1==n.listeners.length&&this.canvas.addEventListener(t,n.callback,!1))},A.prototype.removeEventListener=function(t,i){if(!t)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","removeEventListener","missingType"));if(!i)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","removeEventListener","missingListener"));var r=this.eventListeners[t];if(r){var n=r.listeners.indexOf(i);n!=-1&&(r.listeners.splice(n,1),0==r.listeners.length&&this.canvas.removeEventListener(t,r.callback,!1))}},A.prototype.redraw=function(){this.redrawRequested=!0},A.prototype.pick=function(t){if(!t)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","pick","missingPoint"));return this.drawContext.currentGlContext.isContextLost()?new m:(this.resize(),this.resetDrawContext(),this.drawContext.pickingMode=!0,this.drawContext.pickPoint=t,this.drawContext.pickRay=this.rayThroughScreenPoint(t),this.drawFrame(),this.drawContext.objectsAtPickPoint)},A.prototype.pickTerrain=function(t){if(!t)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","pickTerrain","missingPoint"));return this.drawContext.currentGlContext.isContextLost()?new m:(this.resize(),this.resetDrawContext(),this.drawContext.pickingMode=!0,this.drawContext.pickTerrainOnly=!0,this.drawContext.pickPoint=t,this.drawContext.pickRay=this.rayThroughScreenPoint(t),this.drawFrame(),this.drawContext.objectsAtPickPoint)},A.prototype.pickShapesInRegion=function(t){if(!t)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","pickShapesInRegion","missingRectangle"));return this.drawContext.currentGlContext.isContextLost()?new m:(this.resize(),this.resetDrawContext(),this.drawContext.pickingMode=!0,this.drawContext.regionPicking=!0,this.drawContext.pickRectangle=new E(t.x,this.canvas.height-t.y,t.width,t.height),this.drawFrame(),this.drawContext.objectsAtPickPoint)},A.prototype.createContext=function(t){var e={antialias:!1,stencil:!0},i=t.getContext("webgl",e);return i||(i=t.getContext("experimental-webgl",e)),i},A.prototype.handleContextLost=function(t){d.log(d.LEVEL_INFO,"WebGL context event: "+t.statusMessage),t.preventDefault(),this.drawContext.contextLost(),window.cancelAnimationFrame(this.redrawRequestId)},A.prototype.handleContextRestored=function(t){d.log(d.LEVEL_INFO,"WebGL context event: "+t.statusMessage),this.drawContext.contextRestored(),this.redraw(),this.animationFrameLoop()},A.prototype.handleRedrawEvent=function(t){this.redraw()},A.prototype.animationFrameLoop=function(){function t(){e.animationFrameLoop()}this.redrawIfNeeded();var e=this;this.redrawRequestId=window.requestAnimationFrame(t)},A.prototype.redrawIfNeeded=function(){if(this.resize(),this.redrawRequested)try{this.redrawRequested=!1,this.drawContext.previousRedrawTimestamp=this.drawContext.timestamp,this.callRedrawCallbacks(WorldWind.BEFORE_REDRAW),this.resetDrawContext(),this.drawFrame()}catch(t){d.logMessage(d.LEVEL_SEVERE,"WorldWindow","redrawIfNeeded","Exception occurred during redrawing.\n"+t.toString())}finally{this.callRedrawCallbacks(WorldWind.AFTER_REDRAW),this.drawContext.redrawRequested&&(this.redrawRequested=!0)}},A.prototype.resize=function(){var t=this.drawContext.currentGlContext,e=t.canvas.clientWidth*this.pixelScale,i=t.canvas.clientHeight*this.pixelScale;t.canvas.width==e&&t.canvas.height==i||(t.canvas.width=e,t.canvas.height=i,t.viewport(0,0,t.drawingBufferWidth,t.drawingBufferHeight),this.viewport=new E(0,0,t.drawingBufferWidth,t.drawingBufferHeight),this.redrawRequested=!0)},A.prototype.computeViewingTransform=function(t,i){if(!i)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","computeViewingTransform","missingModelview"));var r=this.globe;if(this.navigator.camera.createViewMatrix(i),t){t.setToIdentity();var n=T.max(r.equatorialRadius,r.polarRadius),o=i.extractEyePoint(new L(0,0,0)),s=r.computePositionFromPoint(o[0],o[1],o[2],new y(0,0,0)),a=T.horizonDistanceForGlobeRadius(n,s.altitude),l=T.horizonDistanceForGlobeRadius(n,16e4),h=this.viewport,u=a+l;u<1e3&&(u=1e3);var c=T.perspectiveNearDistanceForFarDistance(u,10,this.depthBits),p=s.altitude-r.elevationAtLocation(s.latitude,s.longitude);if(p>0){var f=T.perspectiveNearDistance(h.width,h.height,p);c>f&&(c=f)}c<1&&(c=1),t.setToPerspectiveProjection(h.width,h.height,c,u)}},A.prototype.computePixelMetrics=function(t){var e=f.fromIdentity();e.invertMatrix(t);var i=new L(-1,-1,-1),r=new L(1,1,-1),n=new L(-1,-1,1),o=new L(1,1,1);i.multiplyByMatrix(e),r.multiplyByMatrix(e),n.multiplyByMatrix(e),o.multiplyByMatrix(e);var s=T.fabs(r[0]-i[0]),a=T.fabs(o[0]-n[0]),l=-i[2],h=-n[2],u=(a-s)/(h-l),c=s-u*l;return{pixelSizeFactor:u/this.viewport.width,pixelSizeOffset:c/this.viewport.height}},A.prototype.pixelSizeAtDistance=function(t){this.computeViewingTransform(this.scratchProjection,this.scratchModelview);var e=this.computePixelMetrics(this.scratchProjection);return e.pixelSizeFactor*t+e.pixelSizeOffset},A.prototype.computeDrawContext=function(){var t=this.drawContext;this.computeViewingTransform(t.projection,t.modelview),t.viewport=this.viewport,
t.eyePoint=t.modelview.extractEyePoint(new L(0,0,0)),t.modelviewProjection.setToIdentity(),t.modelviewProjection.setToMultiply(t.projection,t.modelview);var e=this.computePixelMetrics(t.projection);t.pixelSizeFactor=e.pixelSizeFactor,t.pixelSizeOffset=e.pixelSizeOffset;var i=f.fromIdentity();i.invertOrthonormalMatrix(t.modelview),t.modelviewNormalTransform=f.fromIdentity().setToTransposeOfMatrix(i.upper3By3());var r=f.fromIdentity();r.setToTransposeOfMatrix(t.modelview),t.frustumInModelCoordinates=s.fromProjectionMatrix(t.projection),t.frustumInModelCoordinates.transformByMatrix(r),t.frustumInModelCoordinates.normalize()},A.prototype.resetDrawContext=function(){this.globe.offset=0;var t=this.drawContext;t.reset(),t.globe=this.globe,t.navigator=this.navigator,t.layers=this.layers.slice(),t.layers.push(t.screenCreditController),this.computeDrawContext(),t.verticalExaggeration=this.verticalExaggeration,t.surfaceOpacity=this.surfaceOpacity,t.deepPicking=this.deepPicking,t.frameStatistics=this.frameStatistics,t.pixelScale=this.pixelScale,t.update()},A.prototype.drawFrame=function(){try{this.drawContext.frameStatistics.beginFrame(),this.beginFrame(),this.drawContext.globe.is2D()&&this.drawContext.globe.continuous?this.do2DContiguousRepaint():this.doNormalRepaint()}finally{this.endFrame(),this.drawContext.frameStatistics.endFrame()}},A.prototype.doNormalRepaint=function(){this.createTerrain(),this.clearFrame(),this.deferOrderedRendering=!1,this.drawContext.pickingMode?this.drawContext.makePickFrustum()&&(this.doPick(),this.resolvePick()):(this.doDraw(),this.subsurfaceMode&&this.hasStencilBuffer&&(this.redrawSurface(),this.drawScreenRenderables()))},A.prototype.do2DContiguousRepaint=function(){this.createTerrain2DContiguous(),this.clearFrame(),this.drawContext.pickingMode?this.drawContext.makePickFrustum()&&(this.pick2DContiguous(),this.resolvePick()):this.draw2DContiguous()},A.prototype.resolvePick=function(){this.drawContext.pickTerrainOnly?this.resolveTerrainPick():this.drawContext.regionPicking?this.resolveRegionPick():this.resolveTopPick()},A.prototype.beginFrame=function(){var t=this.drawContext.currentGlContext;t.enable(t.BLEND),t.enable(t.CULL_FACE),t.enable(t.DEPTH_TEST),t.blendFunc(t.ONE,t.ONE_MINUS_SRC_ALPHA),t.depthFunc(t.LEQUAL),this.drawContext.pickingMode&&(this.drawContext.makePickFramebuffer(),this.drawContext.bindFramebuffer(this.drawContext.pickFramebuffer))},A.prototype.endFrame=function(){var t=this.drawContext.currentGlContext;t.disable(t.BLEND),t.disable(t.CULL_FACE),t.disable(t.DEPTH_TEST),t.blendFunc(t.ONE,t.ZERO),t.depthFunc(t.LESS),t.clearColor(0,0,0,1),this.drawContext.bindFramebuffer(null),this.drawContext.bindProgram(null)},A.prototype.clearFrame=function(){var t=this.drawContext,e=t.currentGlContext;e.clearColor(t.clearColor.red,t.clearColor.green,t.clearColor.blue,t.clearColor.alpha),e.clear(e.COLOR_BUFFER_BIT|e.DEPTH_BUFFER_BIT)},A.prototype.doDraw=function(){this.drawContext.renderShapes=!0,this.subsurfaceMode&&this.hasStencilBuffer?(this.drawContext.currentGlContext.disable(this.drawContext.currentGlContext.STENCIL_TEST),this.drawContext.surfaceShapeTileBuilder.clear(),this.drawLayers(!0),this.drawSurfaceRenderables(),this.drawContext.surfaceShapeTileBuilder.doRender(this.drawContext),this.deferOrderedRendering||(this.drawContext.currentGlContext.clear(this.drawContext.currentGlContext.DEPTH_BUFFER_BIT|this.drawContext.currentGlContext.STENCIL_BUFFER_BIT),this.drawContext.currentGlContext.enable(this.drawContext.currentGlContext.STENCIL_TEST),this.drawContext.currentGlContext.stencilFunc(this.drawContext.currentGlContext.ALWAYS,1,1),this.drawContext.currentGlContext.stencilOp(this.drawContext.currentGlContext.REPLACE,this.drawContext.currentGlContext.REPLACE,this.drawContext.currentGlContext.REPLACE),this.drawOrderedRenderables())):(this.drawContext.surfaceShapeTileBuilder.clear(),this.drawLayers(!0),this.drawSurfaceRenderables(),this.drawContext.surfaceShapeTileBuilder.doRender(this.drawContext),this.deferOrderedRendering||(this.drawOrderedRenderables(),this.drawScreenRenderables()))},A.prototype.redrawSurface=function(){this.drawContext.currentGlContext.enable(this.drawContext.currentGlContext.STENCIL_TEST),this.drawContext.currentGlContext.stencilFunc(this.drawContext.currentGlContext.EQUAL,1,1),this.drawContext.currentGlContext.stencilOp(this.drawContext.currentGlContext.KEEP,this.drawContext.currentGlContext.KEEP,this.drawContext.currentGlContext.KEEP),this.drawContext.surfaceShapeTileBuilder.clear(),this.drawLayers(!1),this.drawSurfaceRenderables(),this.drawContext.surfaceShapeTileBuilder.doRender(this.drawContext),this.drawContext.currentGlContext.disable(this.drawContext.currentGlContext.STENCIL_TEST)},A.prototype.doPick=function(){this.drawContext.terrain&&this.drawContext.terrain.pick(this.drawContext),this.drawContext.pickTerrainOnly||(this.subsurfaceMode&&this.hasStencilBuffer?(this.drawContext.currentGlContext.disable(this.drawContext.currentGlContext.STENCIL_TEST),this.drawContext.surfaceShapeTileBuilder.clear(),this.drawLayers(!0),this.drawSurfaceRenderables(),this.drawContext.surfaceShapeTileBuilder.doRender(this.drawContext),this.deferOrderedRendering||(this.drawContext.currentGlContext.clear(this.drawContext.currentGlContext.DEPTH_BUFFER_BIT|this.drawContext.currentGlContext.STENCIL_BUFFER_BIT),this.drawContext.currentGlContext.enable(this.drawContext.currentGlContext.STENCIL_TEST),this.drawContext.currentGlContext.stencilFunc(this.drawContext.currentGlContext.ALWAYS,1,1),this.drawContext.currentGlContext.stencilOp(this.drawContext.currentGlContext.REPLACE,this.drawContext.currentGlContext.REPLACE,this.drawContext.currentGlContext.REPLACE),this.drawOrderedRenderables(),this.drawContext.terrain.pick(this.drawContext),this.drawScreenRenderables())):(this.drawContext.surfaceShapeTileBuilder.clear(),this.drawLayers(!0),this.drawSurfaceRenderables(),this.drawContext.surfaceShapeTileBuilder.doRender(this.drawContext),this.deferOrderedRendering||(this.drawOrderedRenderables(),this.drawScreenRenderables())))},A.prototype.createTerrain=function(){var t=this.drawContext;t.terrain=this.globe.tessellator.tessellate(t),t.frameStatistics.setTerrainTileCount(t.terrain?t.terrain.surfaceGeometry.length:0)},A.prototype.makeCurrent=function(t){var e=this.drawContext;switch(e.globe.offset=t,e.globeStateKey=e.globe.stateKey,t){case-1:e.terrain=this.terrainLeft;break;case 0:e.terrain=this.terrainCenter;break;case 1:e.terrain=this.terrainRight}},A.prototype.createTerrain2DContiguous=function(){var t=this.drawContext;this.terrainCenter=null,t.globe.offset=0,t.globeStateKey=t.globe.stateKey,t.globe.intersectsFrustum(t.frustumInModelCoordinates)&&(this.terrainCenter=t.globe.tessellator.tessellate(t)),this.terrainRight=null,t.globe.offset=1,t.globeStateKey=t.globe.stateKey,t.globe.intersectsFrustum(t.frustumInModelCoordinates)&&(this.terrainRight=t.globe.tessellator.tessellate(t)),this.terrainLeft=null,t.globe.offset=-1,t.globeStateKey=t.globe.stateKey,t.globe.intersectsFrustum(t.frustumInModelCoordinates)&&(this.terrainLeft=t.globe.tessellator.tessellate(t))},A.prototype.draw2DContiguous=function(){var t="";this.terrainCenter&&(t+=" 0 ",this.makeCurrent(0),this.deferOrderedRendering=this.terrainLeft||this.terrainRight,this.doDraw()),this.terrainRight&&(t+=" 1 ",this.makeCurrent(1),this.deferOrderedRendering=this.terrainLeft||this.terrainLeft,this.doDraw()),this.deferOrderedRendering=!1,this.terrainLeft&&(t+=" -1 ",this.makeCurrent(-1),this.doDraw()),this.subsurfaceMode&&this.hasStencilBuffer&&(this.deferOrderedRendering=!0,this.terrainCenter&&(t+=" 0 ",this.makeCurrent(0),this.redrawSurface()),this.terrainRight&&(t+=" 1 ",this.makeCurrent(1),this.redrawSurface()),this.terrainLeft&&(t+=" -1 ",this.makeCurrent(-1),this.redrawSurface())),this.drawScreenRenderables()},A.prototype.pick2DContiguous=function(){this.terrainCenter&&(this.makeCurrent(0),this.deferOrderedRendering=this.terrainLeft||this.terrainRight,this.doPick()),this.terrainRight&&(this.makeCurrent(1),this.deferOrderedRendering=this.terrainLeft||this.terrainLeft,this.doPick()),this.deferOrderedRendering=!1,this.terrainLeft&&(this.makeCurrent(-1),this.doPick())},A.prototype.drawLayers=function(t){var e,i=Date.now(),r=this.drawContext,n=r.layers;r.accumulateOrderedRenderables=t;for(var o=0,s=n.length;o<s;o++)if(e=n[o]){r.currentLayer=e;try{e.render(r)}catch(t){d.log(d.LEVEL_SEVERE,"Error while rendering layer "+e.displayName+".\n"+t.toString())}}r.currentLayer=null;var a=Date.now();r.frameStatistics.layerRenderingTime=a-i},A.prototype.addLayer=function(t){t&&this.layers.push(t)},A.prototype.removeLayer=function(t){var e=this.indexOfLayer(t);e>=0&&this.layers.splice(e,1)},A.prototype.insertLayer=function(t,e){e&&this.layers.splice(t,0,e)},A.prototype.indexOfLayer=function(t){return this.layers.indexOf(t)},A.prototype.drawSurfaceRenderables=function(){var t,e=this.drawContext;for(e.reverseSurfaceRenderables();t=e.popSurfaceRenderable();)try{t.renderSurface(e)}catch(t){d.logMessage(d.LEVEL_WARNING,"WorldWindow","drawSurfaceRenderables","Error while rendering a surface renderable.\n"+t.message)}},A.prototype.drawOrderedRenderables=function(){var t,e=Date.now(),i=this.drawContext;if(i.sortOrderedRenderables(),this._orderedRenderingFilters)for(var r=0;r<this._orderedRenderingFilters.length;r++)this._orderedRenderingFilters[r](this.drawContext);for(i.orderedRenderingMode=!0;t=i.popOrderedRenderable();)try{t.renderOrdered(i)}catch(t){d.logMessage(d.LEVEL_WARNING,"WorldWindow","drawOrderedRenderables","Error while rendering an ordered renderable.\n"+t.message)}i.orderedRenderingMode=!1,i.frameStatistics.orderedRenderingTime=Date.now()-e},A.prototype.drawScreenRenderables=function(){for(var t,e=this.drawContext;t=e.nextScreenRenderable();)try{t.renderOrdered(e)}catch(t){d.logMessage(d.LEVEL_WARNING,"WorldWindow","drawOrderedRenderables","Error while rendering a screen renderable.\n"+t.message)}},A.prototype.resolveTopPick=function(){if(0!=this.drawContext.objectsAtPickPoint.objects.length){var t=this.drawContext.objectsAtPickPoint,e=this.drawContext.readPickColor(this.drawContext.pickPoint),i=null,r=null;if(e){for(var n=0,o=t.objects.length;n<o;n++){var s=t.objects[n];if(s.isTerrain&&(r=s),s.color.equals(e)&&(s.isOnTop=!0,i=s,r))break}this.drawContext.deepPicking||(t.clear(),i&&t.add(i),r&&r!=i&&t.add(r))}else t.clear()}},A.prototype.resolveTerrainPick=function(){for(var t,e=this.drawContext.objectsAtPickPoint,i=0,r=e.objects.length;i<r;i++)if(t=e.objects[i],t.isTerrain){t.isOnTop=!0;break}},A.prototype.resolveRegionPick=function(){if(0!=this.drawContext.objectsAtPickPoint.objects.length)for(var t,e,i=this.drawContext.objectsAtPickPoint,r=this.drawContext.readPickColors(this.drawContext.pickRectangle),n=0,o=i.objects.length;n<o;n++)if(t=i.objects[n]){var s=t.color.toByteString();e=r[s],e?t.isOnTop=!0:t.userObject instanceof _&&(i.objects.splice(n,1),n-=1)}},A.prototype.callRedrawCallbacks=function(t){for(var e=0,i=this._redrawCallbacks.length;e<i;e++)try{this._redrawCallbacks[e](this,t)}catch(t){d.log(d.LEVEL_SEVERE,"Exception calling redraw callback.\n"+t.toString())}},A.prototype.goTo=function(t,e){this.goToAnimator.goTo(t,e)},A.prototype.declutter=function(t,i){if(!i)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","declutter","Group ID is null, undefined or 0."));for(var r=[],n=0;n<t.orderedRenderables.length;n++){var o=t.orderedRenderables[n].orderedRenderable;o.declutterGroup===i&&r.push(o)}for(var s=[],a=0;a<r.length;a++){var l=r[a],h=l.screenBounds;h&&h.intersectsRectangles(s)?l.targetVisibility=0:(l.targetVisibility=1,h&&s.push(h))}},A.prototype.rayThroughScreenPoint=function(t){if(!t)throw new e(d.logMessage(d.LEVEL_SEVERE,"WorldWindow","rayThroughScreenPoint","missingPoint"));var i=new L(t[0],this.viewport.height-t[1],0),r=new L(0,0,0),n=new L(0,0,0);this.computeViewingTransform(this.scratchProjection,this.scratchModelview);var o=f.fromIdentity();o.setToMultiply(this.scratchProjection,this.scratchModelview);var s=f.fromIdentity();if(s.invertMatrix(o),!s.unProject(i,this.viewport,r))return null;if(i[2]=1,!s.unProject(i,this.viewport,n))return null;var a=this.scratchModelview.extractEyePoint(new L(0,0,0)),l=new L(a[0],a[1],a[2]),h=new L(n[0],n[1],n[2]);return h.subtract(r),h.normalize(),new c(l,h)},A}),i("util/WWMessage",[],function(){"use strict";var t=function(t,e){this.type=t,this.source=e};return t}),i("WorldWind",["./formats/aaigrid/AAIGridConstants","./formats/aaigrid/AAIGridMetadata","./formats/aaigrid/AAIGridReader","./error/AbstractError","./geom/Angle","./shapes/Annotation","./shapes/AnnotationAttributes","./ArcBallCamera","./util/measure/AreaMeasurer","./error/ArgumentError","./globe/AsterV2ElevationCoverage","./layer/AtmosphereLayer","./shaders/AtmosphereProgram","./shaders/BasicProgram","./shaders/BasicTextureProgram","./util/BasicTimeSequence","./BasicWorldWindowController","./layer/BingAerialLayer","./layer/BingAerialWithLabelsLayer","./layer/BingRoadsLayer","./layer/BingWMSLayer","./layer/BMNGLandsatLayer","./layer/BMNGLayer","./layer/BMNGOneImageLayer","./layer/BMNGRestLayer","./geom/BoundingBox","./gesture/ClickRecognizer","./formats/collada/ColladaLoader","./formats/collada/ColladaScene","./util/Color","./shapes/Compass","./layer/CompassLayer","./layer/CoordinatesDisplayLayer","./util/Date","./layer/DigitalGlobeTiledImageLayer","./render/DoubleBufferedFbo","./gesture/DragRecognizer","./render/DrawContext","./globe/EarthElevationModel","./globe/EarthRestElevationCoverage","./globe/ElevationCoverage","./globe/ElevationModel","./FirstPersonCamera","./gesture/FlingRecognizer","./util/Font","./util/FrameStatistics","./layer/FrameStatisticsLayer","./render/FramebufferTexture","./render/FramebufferTile","./render/FramebufferTileController","./geom/Frustum","./globe/GebcoElevationCoverage","./shapes/GeographicMesh","./projections/GeographicProjection","./shapes/GeographicText","./formats/geojson/GeoJSONExporter","./formats/geojson/GeoJSONGeometry","./formats/geojson/GeoJSONGeometryCollection","./formats/geojson/GeoJSONGeometryLineString","./formats/geojson/GeoJSONGeometryMultiLineString","./formats/geojson/GeoJSONGeometryMultiPoint","./formats/geojson/GeoJSONGeometryMultiPolygon","./formats/geojson/GeoJSONGeometryPoint","./formats/geojson/GeoJSONGeometryPolygon","./formats/geojson/GeoJSONParser","./formats/geotiff/GeoTiffReader","./gesture/GestureRecognizer","./globe/Globe","./globe/Globe2D","./util/GoToAnimator","./shaders/GpuProgram","./cache/GpuResourceCache","./shaders/GpuShader","./layer/GriddedDataLayer","./shaders/GridParticleProgram","./shaders/GridParticleSimProgram","./shaders/GroundProgram","./util/HashMap","./layer/heatmap/HeatMapColoredTile","./layer/heatmap/HeatMapIntervalType","./layer/heatmap/HeatMapLayer","./layer/heatmap/HeatMapTile","./util/HighlightController","./util/ImageSource","./render/ImageTile","./util/Insets","./formats/kml/KmlAbstractView","./formats/kml/util/KmlAttribute","./formats/kml/styles/KmlBalloonStyle","./formats/kml/KmlCamera","./formats/kml/util/KmlChange","./formats/kml/styles/KmlColorStyle","./formats/kml/features/KmlContainer","./formats/kml/controls/KmlControls","./formats/kml/util/KmlCreate","./formats/kml/util/KmlDelete","./formats/kml/features/KmlDocument","./formats/kml/KmlElements","./formats/kml/util/KmlElementsFactory","./formats/kml/util/KmlElementsFactoryCached","./formats/kml/features/KmlFeature","./formats/kml/KmlFile","./formats/kml/KmlFileCache","./formats/kml/features/KmlFolder","./formats/kml/geom/KmlGeometry","./formats/kml/features/KmlGroundOverlay","./formats/kml/util/KmlHrefResolver","./formats/kml/KmlIcon","./formats/kml/styles/KmlIconStyle","./formats/kml/util/KmlImagePyramid","./formats/kml/util/KmlItemIcon","./formats/kml/styles/KmlLabelStyle","./formats/kml/KmlLatLonAltBox","./formats/kml/KmlLatLonBox","./formats/kml/KmlLatLonQuad","./formats/kml/geom/KmlLinearRing","./formats/kml/geom/KmlLineString","./formats/kml/styles/KmlLineStyle","./formats/kml/KmlLink","./formats/kml/styles/KmlListStyle","./formats/kml/KmlLocation","./formats/kml/KmlLod","./formats/kml/KmlLookAt","./formats/kml/geom/KmlMultiGeometry","./formats/kml/geom/KmlMultiTrack","./formats/kml/features/KmlNetworkLink","./formats/kml/util/KmlNetworkLinkControl","./formats/kml/util/KmlNodeTransformers","./formats/kml/KmlObject","./formats/kml/KmlOrientation","./formats/kml/features/KmlOverlay","./formats/kml/util/KmlPair","./formats/kml/features/KmlPhotoOverlay","./formats/kml/features/KmlPlacemark","./formats/kml/geom/KmlPoint","./formats/kml/geom/KmlPolygon","./formats/kml/styles/KmlPolyStyle","./formats/kml/util/KmlRefreshListener","./formats/kml/KmlRegion","./formats/kml/util/KmlRemoteFile","./formats/kml/util/KmlScale","./formats/kml/util/KmlSchema","./formats/kml/features/KmlScreenOverlay","./formats/kml/styles/KmlStyle","./formats/kml/styles/KmlStyleMap","./formats/kml/util/KmlStyleResolver","./formats/kml/styles/KmlStyleSelector","./formats/kml/styles/KmlSubStyle","./formats/kml/KmlTimePrimitive","./formats/kml/KmlTimeSpan","./formats/kml/KmlTimeStamp","./formats/kml/features/KmlTour","./formats/kml/geom/KmlTrack","./formats/kml/util/KmlTreeKeyValueCache","./formats/kml/controls/KmlTreeVisibility","./formats/kml/util/KmlUpdate","./formats/kml/util/KmlViewVolume","./formats/kml/KmzFile","./layer/LandsatRestLayer","./layer/Layer","./util/measure/LengthMeasurer","./util/Level","./util/LevelRowColumnUrlBuilder","./util/LevelSet","./geom/Line","./geom/Location","./util/Logger","./navigate/LookAtNavigator","./geom/Matrix","./geom/MeasuredLocation","./util/measure/MeasurerUtils","./cache/MemoryCache","./cache/MemoryCacheListener","./layer/MercatorTiledImageLayer","./navigate/Navigator","./util/NominatimGeocoder","./error/NotYetImplementedError","./util/Offset","./ogc/openSearch/responseFormats/atomParser/OpenSearchAtomParser","./ogc/openSearch/OpenSearchConstants","./ogc/openSearch/descriptionDocument/OpenSearchDescriptionDocument","./ogc/openSearch/responseFormats/atomParser/OpenSearchGeoRssParser","./ogc/openSearch/OpenSearchNamespaces","./ogc/openSearch/descriptionDocument/OpenSearchParameter","./ogc/openSearch/responseFormats/OpenSearchParserRegistry","./ogc/openSearch/OpenSearchRequest","./ogc/openSearch/OpenSearchService","./ogc/openSearch/descriptionDocument/OpenSearchUrl","./ogc/openSearch/OpenSearchUtils","./layer/OpenStreetMapImageLayer","./gesture/PanRecognizer","./shapes/Path","./util/PeriodicTimeSequence","./pick/PickedObject","./pick/PickedObjectList","./gesture/PinchRecognizer","./shapes/Placemark","./shapes/PlacemarkAttributes","./geom/Plane","./shapes/Polygon","./util/PolygonSplitter","./geom/Position","./projections/ProjectionEquirectangular","./projections/ProjectionGnomonic","./projections/ProjectionMercator","./projections/ProjectionPolarEquidistant","./projections/ProjectionUPS","./projections/ProjectionWgs84","./geom/Rectangle","./render/Renderable","./layer/RenderableLayer","./layer/RestTiledImageLayer","./gesture/RotationRecognizer","./shapes/ScreenImage","./shapes/ScreenText","./geom/Sector","./layer/Sentinel2CloudlessLayer","./shapes/ShapeAttributes","./util/editor/ShapeEditor","./formats/shapefile/Shapefile","./layer/ShowTessellationLayer","./shaders/SkyProgram","./layer/StarFieldLayer","./shaders/StarFieldProgram","./util/SunPosition","./shapes/SurfaceImage","./shapes/SurfaceCircle","./shapes/SurfaceEllipse","./shapes/SurfacePolygon","./shapes/SurfacePolyline","./shapes/SurfaceRectangle","./render/SurfaceRenderable","./shapes/SurfaceSector","./shapes/SurfaceShape","./shapes/SurfaceShapeTile","./shapes/SurfaceShapeTileBuilder","./render/SurfaceTile","./render/SurfaceTileRenderer","./shaders/SurfaceTileRendererProgram","./gesture/TapRecognizer","./layer/TectonicPlatesLayer","./globe/Terrain","./globe/TerrainTile","./globe/TerrainTileList","./globe/Tessellator","./shapes/Text","./shapes/TextAttributes","./render/TextRenderer","./render/Texture","./render/TextureTile","./util/Tile","./globe/TiledElevationCoverage","./layer/TiledImageLayer","./util/TileFactory","./gesture/TiltRecognizer","./gesture/Touch","./shapes/TriangleMesh","./error/UnsupportedOperationError","./globe/UsgsNedElevationCoverage","./globe/UsgsNedHiElevationCoverage","./util/UrlBuilder","./geom/Vec2","./geom/Vec3","./layer/ViewControlsLayer","./ogc/wcs/WcsCapabilities","./ogc/wcs/WcsCoverage","./ogc/wcs/WcsCoverageDescriptions","./globe/WcsEarthElevationCoverage","./util/WcsTileUrlBuilder","./ogc/wcs/WebCoverageService","./ogc/WfsCapabilities","./formats/wkt/Wkt","./formats/wkt/WktElements","./formats/wkt/WktExporter","./formats/wkt/geom/WktGeometryCollection","./formats/wkt/geom/WktLineString","./formats/wkt/geom/WktMultiLineString","./formats/wkt/geom/WktMultiPoint","./formats/wkt/geom/WktMultiPolygon","./formats/wkt/geom/WktObject","./formats/wkt/geom/WktPoint","./formats/wkt/geom/WktPolygon","./formats/wkt/WktTokens","./formats/wkt/geom/WktTriangle","./formats/wkt/WktType","./ogc/wms/WmsCapabilities","./layer/WmsLayer","./ogc/wms/WmsLayerCapabilities","./layer/WmsTimeDimensionedLayer","./util/WmsUrlBuilder","./ogc/wmts/WmtsCapabilities","./layer/WmtsLayer","./ogc/wmts/WmtsLayerCapabilities","./WorldWindow","./WorldWindowController","./util/WWMath","./util/WWMessage","./util/WWUtil","./util/XmlDocument"],function(t,e,i,r,n,o,s,a,l,h,u,c,d,p,f,g,m,y,E,v,_,b,w,S,L,T,A,R,x,C,M,P,O,N,I,D,k,F,V,G,W,B,U,K,j,z,H,q,Y,X,J,Q,Z,$,tt,et,it,rt,nt,ot,st,at,lt,ht,ut,ct,dt,pt,ft,gt,mt,yt,Et,vt,_t,bt,wt,St,Lt,Tt,At,Rt,xt,Ct,Mt,Pt,Ot,Nt,It,Dt,kt,Ft,Vt,Gt,Wt,Bt,Ut,Kt,jt,zt,Ht,qt,Yt,Xt,Jt,Qt,Zt,$t,te,ee,ie,re,ne,oe,se,ae,le,he,ue,ce,de,pe,fe,ge,me,ye,Ee,ve,_e,be,we,Se,Le,Te,Ae,Re,xe,Ce,Me,Pe,Oe,Ne,Ie,De,ke,Fe,Ve,Ge,We,Be,Ue,Ke,je,ze,He,qe,Ye,Xe,Je,Qe,Ze,$e,ti,ei,ii,ri,ni,oi,si,ai,li,hi,ui,ci,di,pi,fi,gi,mi,yi,Ei,vi,_i,bi,wi,Si,Li,Ti,Ai,Ri,xi,Ci,Mi,Pi,Oi,Ni,Ii,Di,ki,Fi,Vi,Gi,Wi,Bi,Ui,Ki,ji,zi,Hi,qi,Yi,Xi,Ji,Qi,Zi,$i,tr,er,ir,rr,nr,or,sr,ar,lr,hr,ur,cr,dr,pr,fr,gr,mr,yr,Er,vr,_r,br,wr,Sr,Lr,Tr,Ar,Rr,xr,Cr,Mr,Pr,Or,Nr,Ir,Dr,kr,Fr,Vr,Gr,Wr,Br,Ur,Kr,jr,zr,Hr,qr,Yr,Xr,Jr,Qr,Zr,$r,tn,en,rn,nn,on,sn,an,ln,hn,un,cn,dn,pn,fn,gn,mn,yn,En,vn,_n,bn,wn,Sn,Ln,Tn,An,Rn,xn,Cn,Mn){"use strict";var Pn={VERSION:"0.9.0",ABSOLUTE:"absolute",AFTER_REDRAW:"afterRedraw",BEFORE_REDRAW:"beforeRedraw",BEGAN:"began",CANCELLED:"cancelled",CHANGED:"changed",CLAMP_TO_GROUND:"clampToGround",EARTH_RADIUS:6371e3,EAST:"east",ENDED:"ended",FAILED:"failed",FILTER_LINEAR:"filter_linear",FILTER_NEAREST:"filter_nearest",GREAT_CIRCLE:"greatCircle",LINEAR:"linear",MULTI_POINT:"multiPoint",NORTH:"north",NULL:"null",OFFSET_FRACTION:"fraction",OFFSET_INSET_PIXELS:"insetPixels",OFFSET_PIXELS:"pixels",POINT:"point",POLYLINE:"polyline",POLYGON:"polygon",POSSIBLE:"possible",RECOGNIZED:"recognized",REDRAW_EVENT_TYPE:"WorldWindRedraw",RELATIVE_TO_GLOBE:"relativeToGlobe",RELATIVE_TO_GROUND:"relativeToGround",RELATIVE_TO_SCREEN:"relativeToScreen",RHUMB_LINE:"rhumbLine",SOUTH:"south",WEST:"west",WGS84_SEMI_MAJOR_AXIS:6378137,WGS84_INVERSE_FLATTENING:298.257223563};return Pn.AAIGridConstants=t,Pn.AAIGridMetadata=e,Pn.AAIGridReader=i,Pn.AbstractError=r,Pn.Angle=n,Pn.Annotation=o,Pn.AnnotationAttributes=s,Pn.ArcBallCamera=a,Pn.AreaMeasurer=l,Pn.ArgumentError=h,Pn.AsterV2ElevationCoverage=u,Pn.AtmosphereLayer=c,Pn.AtmosphereProgram=d,Pn.BasicProgram=p,Pn.BasicTextureProgram=f,Pn.BasicTimeSequence=g,Pn.BasicWorldWindowController=m,Pn.BingAerialLayer=y,Pn.BingAerialWithLabelsLayer=E,Pn.BingRoadsLayer=v,Pn.BingWMSLayer=_,Pn.BMNGLandsatLayer=b,Pn.BMNGLayer=w,Pn.BMNGOneImageLayer=S,Pn.BMNGRestLayer=L,Pn.BoundingBox=T,Pn.ClickRecognizer=A,Pn.ColladaLoader=R,Pn.ColladaScene=x,Pn.Color=C,Pn.Compass=M,Pn.CompassLayer=P,Pn.CoordinatesDisplayLayer=O,Pn.DateWW=N,Pn.DigitalGlobeTiledImageLayer=I,Pn.DoubleBufferedFbo=D,Pn.DragRecognizer=k,Pn.DrawContext=F,Pn.EarthElevationModel=V,Pn.EarthRestElevationCoverage=G,Pn.ElevationCoverage=W,Pn.ElevationModel=B,Pn.FirstPersonCamera=U,Pn.FlingRecognizer=K,Pn.Font=j,Pn.FrameStatistics=z,Pn.FrameStatisticsLayer=H,Pn.FramebufferTexture=q,Pn.FramebufferTile=Y,Pn.FramebufferTileController=X,Pn.Frustum=J,Pn.GebcoElevationCoverage=Q,Pn.GeographicMesh=Z,Pn.GeographicProjection=$,Pn.GeographicText=tt,Pn.GeoJSONExporter=et,Pn.GeoJSONGeometry=it,Pn.GeoJSONGeometryCollection=rt,Pn.GeoJSONGeometryLineString=nt,Pn.GeoJSONGeometryMultiLineString=ot,Pn.GeoJSONGeometryMultiPoint=st,Pn.GeoJSONGeometryMultiPolygon=at,Pn.GeoJSONGeometryPoint=lt,Pn.GeoJSONGeometryPolygon=ht,Pn.GeoJSONParser=ut,Pn.GeoTiffReader=ct,Pn.GestureRecognizer=dt,Pn.Globe=pt,Pn.Globe2D=ft,Pn.GoToAnimator=gt,Pn.GpuProgram=mt,Pn.GpuResourceCache=yt,Pn.GpuShader=Et,Pn.GriddedDataLayer=vt,Pn.GridParticleProgram=_t,Pn.GridParticleSimProgram=bt,Pn.GroundProgram=wt,Pn.HashMap=St,Pn.HeatMapColoredTile=Lt,Pn.HeatMapIntervalType=Tt,Pn.HeatMapLayer=At,Pn.HeatMapTile=Rt,Pn.HighlightController=xt,Pn.ImageSource=Ct,Pn.ImageTile=Mt,Pn.Insets=Pt,Pn.KmlAbstractView=Ot,Pn.KmlAttribute=Nt,Pn.KmlBalloonStyle=It,Pn.KmlCamera=Dt,Pn.KmlChange=kt,Pn.KmlColorStyle=Ft,Pn.KmlContainer=Vt,Pn.KmlControls=Gt,Pn.KmlCreate=Wt,Pn.KmlDelete=Bt,Pn.KmlDocument=Ut,Pn.KmlElements=Kt,Pn.KmlElementsFactory=jt,Pn.KmlElementsFactoryCached=zt,Pn.KmlFeature=Ht,Pn.KmlFile=qt,Pn.KmlFileCache=Yt,Pn.KmlFolder=Xt,Pn.KmlGeometry=Jt,Pn.KmlGroundOverlay=Qt,Pn.KmlHrefResolver=Zt,Pn.KmlIcon=$t,Pn.KmlIconStyle=te,Pn.KmlImagePyramid=ee,Pn.KmlItemIcon=ie,Pn.KmlLabelStyle=re,Pn.KmlLatLonAltBox=ne,Pn.KmlLatLonBox=oe,Pn.KmlLatLonQuad=se,Pn.KmlLinearRing=ae,Pn.KmlLineString=le,Pn.KmlLineStyle=he,Pn.KmlListStyle=ce,Pn.KmlLink=ue,Pn.KmlLocation=de,Pn.KmlLod=pe,Pn.KmlLookAt=fe,Pn.KmlMultiGeometry=ge,Pn.KmlMultiTrack=me,Pn.KmlNetworkLink=ye,Pn.KmlNetworkLinkControl=Ee,Pn.KmlNodeTransformers=ve,Pn.KmlObject=_e,Pn.KmlOrientation=be,Pn.KmlOverlay=we,Pn.KmlPair=Se,Pn.KmlPhotoOverlay=Le,Pn.KmlPlacemark=Te,Pn.KmlPoint=Ae,Pn.KmlPolygon=Re,Pn.KmlPolyStyle=xe,Pn.KmlRefreshListener=Ce,Pn.KmlRegion=Me,Pn.KmlRemoteFile=Pe,Pn.KmlScale=Oe,Pn.KmlSchema=Ne,Pn.KmlScreenOverlay=Ie,Pn.KmlStyle=De,Pn.KmlStyleMap=ke,Pn.KmlStyleResolver=Fe,Pn.KmlStyleSelector=Ve,Pn.KmlSubStyle=Ge,Pn.KmlTimePrimitive=We,Pn.KmlTimeSpan=Be,Pn.KmlTimeStamp=Ue,Pn.KmlTour=Ke,Pn.KmlTrack=je,Pn.KmlTreeKeyValueCache=ze,Pn.KmlTreeVisibility=He,Pn.KmlUpdate=qe,Pn.KmlViewVolume=Ye,Pn.KmzFile=Xe,Pn.LandsatRestLayer=Je,Pn.Layer=Qe,Pn.LengthMeasurer=Ze,Pn.Level=$e,Pn.LevelRowColumnUrlBuilder=ti,Pn.LevelSet=ei,Pn.Line=ii,Pn.Location=ri,Pn.Logger=ni,Pn.LookAtNavigator=oi,Pn.Matrix=si,Pn.MeasuredLocation=ai,Pn.MeasurerUtils=li,Pn.MemoryCache=hi,Pn.MemoryCacheListener=ui,Pn.MercatorTiledImageLayer=ci,Pn.Navigator=di,Pn.NominatimGeocoder=pi,Pn.NotYetImplementedError=fi,Pn.Offset=gi,Pn.OpenSearchAtomParser=mi,Pn.OpenSearchConstants=yi,Pn.OpenSearchDescriptionDocument=Ei,Pn.OpenSearchGeoRssParser=vi,Pn.OpenSearchNamespaces=_i,Pn.OpenSearchParameter=bi,Pn.OpenSearchParserRegistry=wi,Pn.OpenSearchRequest=Si,Pn.OpenSearchService=Li,Pn.OpenSearchUrl=Ti,Pn.OpenSearchUtils=Ai,Pn.OpenStreetMapImageLayer=Ri,Pn.PanRecognizer=xi,Pn.Path=Ci,Pn.PeriodicTimeSequence=Mi,Pn.PickedObject=Pi,Pn.PickedObjectList=Oi,Pn.PinchRecognizer=Ni,Pn.Placemark=Ii,Pn.PlacemarkAttributes=Di,Pn.Plane=ki,Pn.Polygon=Fi,Pn.PolygonSplitter=Vi,Pn.Position=Gi,Pn.ProjectionEquirectangular=Wi,Pn.ProjectionGnomonic=Bi,Pn.ProjectionMercator=Ui,Pn.ProjectionPolarEquidistant=Ki,Pn.ProjectionUPS=ji,Pn.ProjectionWgs84=zi,Pn.Rectangle=Hi,Pn.Renderable=qi,Pn.RenderableLayer=Yi,Pn.RestTiledImageLayer=Xi,Pn.RotationRecognizer=Ji,Pn.ScreenText=Zi,Pn.ScreenImage=Qi,Pn.Sector=$i,Pn.Sentinel2CloudlessLayer=tr,Pn.ShapeAttributes=er,Pn.ShapeEditor=ir,Pn.Shapefile=rr,Pn.ShowTessellationLayer=nr,Pn.SkyProgram=or,Pn.StarFieldLayer=sr,Pn.StarFieldProgram=ar,Pn.SunPosition=lr,Pn.SurfaceImage=hr,Pn.SurfaceCircle=ur,Pn.SurfaceEllipse=cr,Pn.SurfacePolygon=dr,Pn.SurfacePolyline=pr,Pn.SurfaceRectangle=fr,Pn.SurfaceRenderable=gr,Pn.SurfaceSector=mr,Pn.SurfaceShape=yr,Pn.SurfaceShapeTile=Er,Pn.SurfaceShapeTileBuilder=vr,Pn.SurfaceTile=_r,Pn.SurfaceTileRenderer=br,Pn.SurfaceTileRendererProgram=wr,Pn.TapRecognizer=Sr,Pn.TectonicPlatesLayer=Lr,Pn.Terrain=Tr,Pn.TerrainTile=Ar,Pn.TerrainTileList=Rr,Pn.Tessellator=xr,Pn.Text=Cr,Pn.TextAttributes=Mr,Pn.TextRenderer=Pr,Pn.Texture=Or,Pn.TextureTile=Nr,Pn.Tile=Ir,Pn.TiledElevationCoverage=Dr,Pn.TiledImageLayer=kr,Pn.TileFactory=Fr,Pn.TiltRecognizer=Vr,Pn.Touch=Gr,Pn.TriangleMesh=Wr,Pn.UsgsNedElevationCoverage=Br,Pn.UsgsNedHiElevationCoverage=Ur,Pn.UnsupportedOperationError=Kr,Pn.UrlBuilder=jr,Pn.Vec2=zr,Pn.Vec3=Hr,Pn.ViewControlsLayer=qr,Pn.WcsCapabilities=Yr,Pn.WcsCoverage=Xr,Pn.WcsCoverageDescriptions=Jr,Pn.WcsEarthElevationCoverage=Qr,Pn.WcsTileUrlBuilder=Zr,Pn.WebCoverageService=$r,Pn.WfsCapabilities=tn,Pn.Wkt=en,Pn.WktElements=rn,Pn.WktExporter=nn,Pn.WktGeometryCollection=on,Pn.WktLineString=sn,Pn.WktMultiLineString=an,Pn.WktMultiPoint=ln,Pn.WktMultiPolygon=hn,Pn.WktObject=un,Pn.WktPoint=cn,Pn.WktPolygon=dn,Pn.WktTokens=pn,Pn.WktTriangle=fn,Pn.WktType=gn,Pn.WmsCapabilities=mn,Pn.WmsLayer=yn,Pn.WmsLayerCapabilities=En,Pn.WmsTimeDimensionedLayer=vn,Pn.WmsUrlBuilder=_n,Pn.WmtsCapabilities=bn,Pn.WmtsLayer=wn,Pn.WmtsLayerCapabilities=Sn,Pn.WWMath=An,Pn.WWMessage=Rn,Pn.WWUtil=xn,Pn.WorldWindow=Ln,Pn.WorldWindowController=Tn,Pn.configuration={gpuCacheSize:25e7,baseUrl:xn.worldwindlibLocation()||xn.currentUrlSansFilePart()+"/../",layerRetrievalQueueSize:16,coverageRetrievalQueueSize:16,bingLogoPlacement:new gi(Pn.OFFSET_INSET_PIXELS,7,Pn.OFFSET_PIXELS,7),bingLogoAlignment:new gi(Pn.OFFSET_FRACTION,1,Pn.OFFSET_FRACTION,0)},Pn.BingMapsKey=null,window.WorldWind=Pn,Pn}),e("WorldWind")});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Re-usable DropZone component
var DropZone=function(_React$Component){_inherits(DropZone,_React$Component);function DropZone(){_classCallCheck(this,DropZone);var _this=_possibleConstructorReturn(this,(DropZone.__proto__||Object.getPrototypeOf(DropZone)).call(this));_this.state={className:'drop-zone-hide'};_this._onDragEnter=_this._onDragEnter.bind(_this);_this._onDragLeave=_this._onDragLeave.bind(_this);_this._onDragOver=_this._onDragOver.bind(_this);_this._onDrop=_this._onDrop.bind(_this);_this._onPaste=_this._onPaste.bind(_this);return _this;}_createClass(DropZone,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('mouseup',this._onDragLeave);window.addEventListener('dragenter',this._onDragEnter);window.addEventListener('dragover',this._onDragOver);document.getElementById('dragbox').addEventListener('dragleave',this._onDragLeave);window.addEventListener('drop',this._onDrop);window.addEventListener('paste',this._onPaste);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('mouseup',this._onDragLeave);window.removeEventListener('dragenter',this._onDragEnter);window.addEventListener('dragover',this._onDragOver);document.getElementById('dragbox').removeEventListener('dragleave',this._onDragLeave);window.removeEventListener('drop',this._onDrop);window.removeEventListener('paste',this._onPaste);}},{key:'_onDragEnter',value:function _onDragEnter(e){this.setState({className:'drop-zone-show'});e.stopPropagation();e.preventDefault();return false;}},{key:'_onDragOver',value:function _onDragOver(e){e.preventDefault();e.stopPropagation();return false;}},{key:'_onDragLeave',value:function _onDragLeave(e){this.setState({className:'drop-zone-hide'});e.stopPropagation();e.preventDefault();return false;}},{key:'_onDrop',value:function _onDrop(e){e.preventDefault();//console.log("dropped text: " + e.dataTransfer.getData("Text"));
if(e.dataTransfer.getData("Text").length!=0){this.refs.child0.handleDropText(e.dataTransfer.getData("Text"));}else{this.refs.child0.handleDropFiles(e.dataTransfer.files);}this.setState({className:'drop-zone-hide'});return false;}},{key:'_onPaste',value:function _onPaste(e){e.preventDefault();//console.log(e.clipboardData.getData('Text') );
this.refs.child0.handlePaste(e.clipboardData.getData('Text'));return false;}},{key:'render',value:function render(){var children=__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children,function(child,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child,{ref:'child'+index});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'dragbox',className:this.state.className}));}}]);return DropZone;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (DropZone);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(79);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(96);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fscreen = __webpack_require__(98);

var _fscreen2 = _interopRequireDefault(_fscreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullScreen = function (_Component) {
  _inherits(FullScreen, _Component);

  function FullScreen(props) {
    _classCallCheck(this, FullScreen);

    var _this = _possibleConstructorReturn(this, (FullScreen.__proto__ || Object.getPrototypeOf(FullScreen)).call(this, props));

    _this.detectFullScreen = _this.detectFullScreen.bind(_this);
    _this.enterFullScreen = _this.enterFullScreen.bind(_this);
    _this.leaveFullScreen = _this.leaveFullScreen.bind(_this);
    return _this;
  }

  _createClass(FullScreen, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _fscreen2.default.addEventListener("fullscreenchange", this.detectFullScreen);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _fscreen2.default.removeEventListener("fullscreenchange", this.detectFullScreen);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleProps(this.props);
    }
  }, {
    key: "handleProps",
    value: function handleProps(props) {
      var enabled = _fscreen2.default.fullscreenElement;
      if (enabled && !props.enabled) {
        this.leaveFullScreen();
      } else if (!enabled && props.enabled) {
        this.enterFullScreen();
      }
    }
  }, {
    key: "detectFullScreen",
    value: function detectFullScreen() {
      if (this.props.onChange) {
        this.props.onChange(!!_fscreen2.default.fullscreenElement);
      }
    }
  }, {
    key: "enterFullScreen",
    value: function enterFullScreen() {
      if (_fscreen2.default.fullscreenEnabled) {
        _fscreen2.default.requestFullscreen(this.node);
      }
    }
  }, {
    key: "leaveFullScreen",
    value: function leaveFullScreen() {
      if (_fscreen2.default.fullscreenEnabled) {
        _fscreen2.default.exitFullscreen();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = ["fullscreen"];
      if (this.props.enabled) {
        className.push("fullscreen-enabled");
      }

      return _react2.default.createElement(
        "div",
        {
          className: className.join(" "),
          ref: function ref(node) {
            return _this2.node = node;
          },
          style: this.props.enabled ? { height: "100%", width: "100%" } : undefined
        },
        this.props.children
      );
    }
  }]);

  return FullScreen;
}(_react.Component);

FullScreen.propTypes = {
  children: _propTypes2.default.node.isRequired,
  enabled: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func
};
FullScreen.defaultProps = {
  enabled: false
};
exports.default = FullScreen;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(80);


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var ReactBaseClasses = __webpack_require__(21);
var ReactChildren = __webpack_require__(82);
var ReactDOMFactories = __webpack_require__(87);
var ReactElement = __webpack_require__(6);
var ReactPropTypes = __webpack_require__(88);
var ReactVersion = __webpack_require__(92);

var createReactClass = __webpack_require__(93);
var onlyChild = __webpack_require__(95);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(83);
var ReactElement = __webpack_require__(6);

var emptyFunction = __webpack_require__(4);
var traverseAllChildren = __webpack_require__(84);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(8);

var invariant = __webpack_require__(5);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(8);

var ReactCurrentOwner = __webpack_require__(24);
var REACT_ELEMENT_TYPE = __webpack_require__(25);

var getIteratorFn = __webpack_require__(85);
var invariant = __webpack_require__(5);
var KeyEscapeUtils = __webpack_require__(86);
var warning = __webpack_require__(9);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(6);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(6),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(89);

module.exports = factory(isValidElement);

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(90);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(4);
var invariant = __webpack_require__(5);
var warning = __webpack_require__(9);
var assign = __webpack_require__(3);

var ReactPropTypesSecret = __webpack_require__(26);
var checkPropTypes = __webpack_require__(91);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(21),
    Component = _require.Component;

var _require2 = __webpack_require__(6),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(22);
var factory = __webpack_require__(94);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var emptyObject = __webpack_require__(7);
var _invariant = __webpack_require__(5);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(8);

var ReactElement = __webpack_require__(6);

var invariant = __webpack_require__(5);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(97)();
}


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(4);
var invariant = __webpack_require__(5);
var ReactPropTypesSecret = __webpack_require__(26);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var key = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5
};

var webkit = ['webkitFullscreenEnabled', 'webkitFullscreenElement', 'webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitfullscreenchange', 'webkitfullscreenerror'];

var moz = ['mozFullScreenEnabled', 'mozFullScreenElement', 'mozRequestFullScreen', 'mozCancelFullScreen', 'mozfullscreenchange', 'mozfullscreenerror'];

var ms = ['msFullscreenEnabled', 'msFullscreenElement', 'msRequestFullscreen', 'msExitFullscreen', 'MSFullscreenChange', 'MSFullscreenError'];

// so it doesn't throw if no window or document
var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};

var vendor = 'fullscreenEnabled' in document && Object.keys(key) || webkit[0] in document && webkit || moz[0] in document && moz || ms[0] in document && ms || [];

exports.default = {
  requestFullscreen: function requestFullscreen(element) {
    return element[vendor[key.requestFullscreen]]();
  },
  requestFullscreenFunction: function requestFullscreenFunction(element) {
    return element[vendor[key.requestFullscreen]];
  },
  get exitFullscreen() {
    return document[vendor[key.exitFullscreen]].bind(document);
  },
  addEventListener: function addEventListener(type, handler, options) {
    return document.addEventListener(vendor[key[type]], handler, options);
  },
  removeEventListener: function removeEventListener(type, handler, options) {
    return document.removeEventListener(vendor[key[type]], handler, options);
  },
  get fullscreenEnabled() {
    return Boolean(document[vendor[key.fullscreenEnabled]]);
  },
  set fullscreenEnabled(val) {},
  get fullscreenElement() {
    return document[vendor[key.fullscreenElement]];
  },
  set fullscreenElement(val) {},
  get onfullscreenchange() {
    return document[('on' + vendor[key.fullscreenchange]).toLowerCase()];
  },
  set onfullscreenchange(handler) {
    return document[('on' + vendor[key.fullscreenchange]).toLowerCase()] = handler;
  },
  get onfullscreenerror() {
    return document[('on' + vendor[key.fullscreenerror]).toLowerCase()];
  },
  set onfullscreenerror(handler) {
    return document[('on' + vendor[key.fullscreenerror]).toLowerCase()] = handler;
  }
};

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_burger_menu__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_burger_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_burger_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slideMenu_css__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slideMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__slideMenu_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SlideMenu=function(_React$Component){_inherits(SlideMenu,_React$Component);function SlideMenu(props){_classCallCheck(this,SlideMenu);var _this=_possibleConstructorReturn(this,(SlideMenu.__proto__||Object.getPrototypeOf(SlideMenu)).call(this,props));_this.state={};return _this;}_createClass(SlideMenu,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'render',value:function render(){var menuStyles={bmBurgerButton:{position:'fixed',width:'36px',height:'30px',left:'26px',top:'26px'},bmBurgerBars:{background:'#373a47'},bmCrossButton:{height:'24px',width:'24px'},bmCross:{background:'#bdc3c7'},bmMenu:{//background: '#373a47',
background:'rgba(27, 59, 9, .7)',padding:'3.5em 0.5em 0',fontSize:'1.5em',overflow:'hidden'},bmMorphShape:{fill:'#373a47'},bmItemList:{display:'block',color:'#b8b7ad',padding:'0.1em'},bmItem:{display:'block'//position: 'relative',
//left: '10px',
//fontSize: '10px',
},bmOverlay:{background:'rgba(0, 0, 0, 0.3)'}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_burger_menu__["slide"],{styles:menuStyles,disableOverlayClick:true,noOverlay:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menuTitle'},'Shortcuts'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'commandKey'},'f'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'commandDesc'},'Fullscreen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'commandKey'},'p'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'commandDesc'},'Toggle projections')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'commandKey'},'c'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'commandDesc'},'Delete last item')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'commandKey'},'C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'commandDesc'},'Delete all items'))))));}}]);return SlideMenu;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SlideMenu);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  slide: __webpack_require__(101),
  stack: __webpack_require__(107),
  elastic: __webpack_require__(108),
  bubble: __webpack_require__(111),
  push: __webpack_require__(112),
  pushRotate: __webpack_require__(113),
  scaleDown: __webpack_require__(114),
  scaleRotate: __webpack_require__(115),
  fallDown: __webpack_require__(116),
  reveal: __webpack_require__(117)
};
module.exports = exports['default'];

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(1);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(103);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
var styles = {
  overlay: function overlay(isOpen) {
    return {
      position: 'fixed',
      zIndex: 1000,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.3)',
      opacity: isOpen ? 1 : 0,
      MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      position: 'fixed',
      right: right ? 0 : 'inherit',
      zIndex: 1100,
      width: width,
      height: '100%',
      MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: 'all 0.5s'
    };
  },

  menu: function menu() {
    return {
      height: '100%',
      boxSizing: 'border-box',
      overflow: 'auto'
    };
  },

  itemList: function itemList() {
    return {
      height: '100%'
    };
  },

  item: function item() {
    return {
      display: 'block',
      outline: 'none'
    };
  }
};

exports['default'] = styles;
module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var BurgerIcon = (function (_Component) {
  _inherits(BurgerIcon, _Component);

  function BurgerIcon(props) {
    _classCallCheck(this, BurgerIcon);

    _get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
    this.state = {
      hover: false
    };
  }

  _createClass(BurgerIcon, [{
    key: 'getLineStyle',
    value: function getLineStyle(index) {
      return {
        position: 'absolute',
        height: '20%',
        left: 0,
        right: 0,
        top: 20 * (index * 2) + '%',
        opacity: this.state.hover ? 0.6 : 1
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var icon = undefined;
      var buttonStyle = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        border: 'none',
        opacity: 0,
        fontSize: 8,
        cursor: 'pointer'
      };

      if (this.props.customIcon) {
        var extraProps = {
          className: 'bm-icon',
          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmIcon)
        };
        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
      } else {
        icon = _react2['default'].createElement(
          'span',
          null,
          [0, 1, 2].map(function (bar) {
            return _react2['default'].createElement('span', {
              key: bar,
              className: ('bm-burger-bars ' + _this.props.barClassName).trim(),
              style: _extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
            });
          })
        );
      }

      return _react2['default'].createElement(
        'div',
        {
          className: ('bm-burger-button ' + this.props.className).trim(),
          style: _extends({ zIndex: 1000 }, this.props.styles.bmBurgerButton)
        },
        icon,
        _react2['default'].createElement(
          'button',
          {
            onClick: this.props.onClick,
            onMouseOver: function () {
              return _this.setState({ hover: true });
            },
            onMouseOut: function () {
              return _this.setState({ hover: false });
            },
            style: buttonStyle
          },
          'Open Menu'
        )
      );
    }
  }]);

  return BurgerIcon;
})(_react.Component);

exports['default'] = BurgerIcon;

BurgerIcon.propTypes = {
  barClassName: _propTypes2['default'].string,
  customIcon: _propTypes2['default'].element,
  styles: _propTypes2['default'].object
};

BurgerIcon.defaultProps = {
  barClassName: '',
  className: '',
  styles: {}
};
module.exports = exports['default'];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var CrossIcon = (function (_Component) {
  _inherits(CrossIcon, _Component);

  function CrossIcon() {
    _classCallCheck(this, CrossIcon);

    _get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(CrossIcon, [{
    key: 'getCrossStyle',
    value: function getCrossStyle(type) {
      return {
        position: 'absolute',
        width: 3,
        height: 14,
        transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var icon;
      var buttonWrapperStyle = {
        position: 'absolute',
        width: 24,
        height: 24,
        right: 8,
        top: 8
      };
      var buttonStyle = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        border: 'none',
        textIndent: -9999,
        background: 'transparent',
        outline: 'none',
        cursor: 'pointer'
      };

      if (this.props.customIcon) {
        var extraProps = {
          className: 'bm-cross',
          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmCross)
        };
        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
      } else {
        icon = _react2['default'].createElement(
          'span',
          { style: { position: 'absolute', top: '6px', right: '14px' } },
          ['before', 'after'].map(function (type, i) {
            return _react2['default'].createElement('span', {
              key: i,
              className: ('bm-cross ' + _this.props.crossClassName).trim(),
              style: _extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
            });
          })
        );
      }

      return _react2['default'].createElement(
        'div',
        {
          className: ('bm-cross-button ' + this.props.className).trim(),
          style: _extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
        },
        icon,
        _react2['default'].createElement(
          'button',
          { onClick: this.props.onClick, style: buttonStyle },
          'Close Menu'
        )
      );
    }
  }]);

  return CrossIcon;
})(_react.Component);

exports['default'] = CrossIcon;

CrossIcon.propTypes = {
  crossClassName: _propTypes2['default'].string,
  customIcon: _propTypes2['default'].element,
  styles: _propTypes2['default'].object
};

CrossIcon.defaultProps = {
  crossClassName: '',
  className: '',
  styles: {}
};
module.exports = exports['default'];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(1);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0.4s cubic-bezier(0.7, 0, 0.3, 1)'
    };
  },

  item: function item(isOpen, width, right, nthChild) {
    return {
      MozTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      MsTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      OTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      WebkitTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      transform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0s 0.2s cubic-bezier(0.7, 0, 0.3, 1)'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _snapsvgImporter = __webpack_require__(27);

var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);

var _menuFactory = __webpack_require__(1);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  svg: {
    lib: _snapsvgImporter2['default'],
    pathInitial: 'M-1,0h101c0,0-97.833,153.603-97.833,396.167C2.167,627.579,100,800,100,800H-1V0z',
    pathOpen: 'M-1,0h101c0,0,0-1,0,395c0,404,0,405,0,405H-1V0z',
    animate: function animate(path) {
      path.animate({ path: this.pathOpen }, 400, window.mina.easeinout);
    }
  },

  morphShape: function morphShape(isOpen, width, right) {
    return {
      position: 'absolute',
      width: 120,
      height: '100%',
      right: right ? 'inherit' : 0,
      left: right ? 0 : 'inherit',
      MozTransform: right ? 'rotateY(180deg)' : '',
      MsTransform: right ? 'rotateY(180deg)' : '',
      OTransform: right ? 'rotateY(180deg)' : '',
      WebkitTransform: right ? 'rotateY(180deg)' : '',
      transform: right ? 'rotateY(180deg)' : ''
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: 'all 0.3s'
    };
  },

  menu: function menu(isOpen, width, right) {
    return {
      position: 'fixed',
      right: right ? 0 : 'inherit',
      width: 180,
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      overflow: 'visible'
    };
  },

  itemList: function itemList(isOpen, width, right) {
    if (right) {
      return {
        position: 'relative',
        left: '-110px',
        width: '170%',
        overflow: 'auto'
      };
    }
  },

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      transition: isOpen ? 'all 0.3s' : 'all 0.3s 0.1s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

window.eve = __webpack_require__(110)

// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var mina = (function (eve) {
    var animations = {},
    requestAnimFrame = window.requestAnimationFrame       ||
                       window.webkitRequestAnimationFrame ||
                       window.mozRequestAnimationFrame    ||
                       window.oRequestAnimationFrame      ||
                       window.msRequestAnimationFrame     ||
                       function (callback) {
                           setTimeout(callback, 16, new Date().getTime());
                           return true;
                       },
    requestID,
    isArray = Array.isArray || function (a) {
        return a instanceof Array ||
            Object.prototype.toString.call(a) == "[object Array]";
    },
    idgen = 0,
    idprefix = "M" + (+new Date).toString(36),
    ID = function () {
        return idprefix + (idgen++).toString(36);
    },
    diff = function (a, b, A, B) {
        if (isArray(a)) {
            res = [];
            for (var i = 0, ii = a.length; i < ii; i++) {
                res[i] = diff(a[i], b, A[i], B);
            }
            return res;
        }
        var dif = (A - a) / (B - b);
        return function (bb) {
            return a + dif * (bb - b);
        };
    },
    timer = Date.now || function () {
        return +new Date;
    },
    sta = function (val) {
        var a = this;
        if (val == null) {
            return a.s;
        }
        var ds = a.s - val;
        a.b += a.dur * ds;
        a.B += a.dur * ds;
        a.s = val;
    },
    speed = function (val) {
        var a = this;
        if (val == null) {
            return a.spd;
        }
        a.spd = val;
    },
    duration = function (val) {
        var a = this;
        if (val == null) {
            return a.dur;
        }
        a.s = a.s * val / a.dur;
        a.dur = val;
    },
    stopit = function () {
        var a = this;
        delete animations[a.id];
        a.update();
        eve("mina.stop." + a.id, a);
    },
    pause = function () {
        var a = this;
        if (a.pdif) {
            return;
        }
        delete animations[a.id];
        a.update();
        a.pdif = a.get() - a.b;
    },
    resume = function () {
        var a = this;
        if (!a.pdif) {
            return;
        }
        a.b = a.get() - a.pdif;
        delete a.pdif;
        animations[a.id] = a;
        frame();
    },
    update = function () {
        var a = this,
            res;
        if (isArray(a.start)) {
            res = [];
            for (var j = 0, jj = a.start.length; j < jj; j++) {
                res[j] = +a.start[j] +
                    (a.end[j] - a.start[j]) * a.easing(a.s);
            }
        } else {
            res = +a.start + (a.end - a.start) * a.easing(a.s);
        }
        a.set(res);
    },
    frame = function (timeStamp) {
        // Manual invokation?
        if (!timeStamp) {
            // Frame loop stopped?
            if (!requestID) {
                // Start frame loop...
                requestID = requestAnimFrame(frame);
            }
            return;
        }
        var len = 0;
        for (var i in animations) if (animations.hasOwnProperty(i)) {
            var a = animations[i],
                b = a.get(),
                res;
            len++;
            a.s = (b - a.b) / (a.dur / a.spd);
            if (a.s >= 1) {
                delete animations[i];
                a.s = 1;
                len--;
                (function (a) {
                    setTimeout(function () {
                        eve("mina.finish." + a.id, a);
                    });
                }(a));
            }
            a.update();
        }
        requestID = len ? requestAnimFrame(frame) : false;
    },
    /*\
     * mina
     [ method ]
     **
     * Generic animation of numbers
     **
     - a (number) start _slave_ number
     - A (number) end _slave_ number
     - b (number) start _master_ number (start time in general case)
     - B (number) end _master_ number (end time in general case)
     - get (function) getter of _master_ number (see @mina.time)
     - set (function) setter of _slave_ number
     - easing (function) #optional easing function, default is @mina.linear
     = (object) animation descriptor
     o {
     o         id (string) animation id,
     o         start (number) start _slave_ number,
     o         end (number) end _slave_ number,
     o         b (number) start _master_ number,
     o         s (number) animation status (0..1),
     o         dur (number) animation duration,
     o         spd (number) animation speed,
     o         get (function) getter of _master_ number (see @mina.time),
     o         set (function) setter of _slave_ number,
     o         easing (function) easing function, default is @mina.linear,
     o         status (function) status getter/setter,
     o         speed (function) speed getter/setter,
     o         duration (function) duration getter/setter,
     o         stop (function) animation stopper
     o         pause (function) pauses the animation
     o         resume (function) resumes the animation
     o         update (function) calles setter with the right value of the animation
     o }
    \*/
    mina = function (a, A, b, B, get, set, easing) {
        var anim = {
            id: ID(),
            start: a,
            end: A,
            b: b,
            s: 0,
            dur: B - b,
            spd: 1,
            get: get,
            set: set,
            easing: easing || mina.linear,
            status: sta,
            speed: speed,
            duration: duration,
            stop: stopit,
            pause: pause,
            resume: resume,
            update: update
        };
        animations[anim.id] = anim;
        var len = 0, i;
        for (i in animations) if (animations.hasOwnProperty(i)) {
            len++;
            if (len == 2) {
                break;
            }
        }
        len == 1 && frame();
        return anim;
    };
    /*\
     * mina.time
     [ method ]
     **
     * Returns the current time. Equivalent to:
     | function () {
     |     return (new Date).getTime();
     | }
    \*/
    mina.time = timer;
    /*\
     * mina.getById
     [ method ]
     **
     * Returns an animation by its id
     - id (string) animation's id
     = (object) See @mina
    \*/
    mina.getById = function (id) {
        return animations[id] || null;
    };

    /*\
     * mina.linear
     [ method ]
     **
     * Default linear easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.linear = function (n) {
        return n;
    };
    /*\
     * mina.easeout
     [ method ]
     **
     * Easeout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easeout = function (n) {
        return Math.pow(n, 1.7);
    };
    /*\
     * mina.easein
     [ method ]
     **
     * Easein easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easein = function (n) {
        return Math.pow(n, .48);
    };
    /*\
     * mina.easeinout
     [ method ]
     **
     * Easeinout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easeinout = function (n) {
        if (n == 1) {
            return 1;
        }
        if (n == 0) {
            return 0;
        }
        var q = .48 - n / 1.04,
            Q = Math.sqrt(.1734 + q * q),
            x = Q - q,
            X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1),
            y = -Q - q,
            Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1),
            t = X + Y + .5;
        return (1 - t) * 3 * t * t + t * t * t;
    };
    /*\
     * mina.backin
     [ method ]
     **
     * Backin easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.backin = function (n) {
        if (n == 1) {
            return 1;
        }
        var s = 1.70158;
        return n * n * ((s + 1) * n - s);
    };
    /*\
     * mina.backout
     [ method ]
     **
     * Backout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.backout = function (n) {
        if (n == 0) {
            return 0;
        }
        n = n - 1;
        var s = 1.70158;
        return n * n * ((s + 1) * n + s) + 1;
    };
    /*\
     * mina.elastic
     [ method ]
     **
     * Elastic easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.elastic = function (n) {
        if (n == !!n) {
            return n;
        }
        return Math.pow(2, -10 * n) * Math.sin((n - .075) *
            (2 * Math.PI) / .3) + 1;
    };
    /*\
     * mina.bounce
     [ method ]
     **
     * Bounce easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.bounce = function (n) {
        var s = 7.5625,
            p = 2.75,
            l;
        if (n < 1 / p) {
            l = s * n * n;
        } else {
            if (n < 2 / p) {
                n -= 1.5 / p;
                l = s * n * n + .75;
            } else {
                if (n < 2.5 / p) {
                    n -= 2.25 / p;
                    l = s * n * n + .9375;
                } else {
                    n -= 2.625 / p;
                    l = s * n * n + .984375;
                }
            }
        }
        return l;
    };
    window.mina = mina;
    return mina;
})(typeof eve == "undefined" ? function () {} : eve);

// Copyright (c) 2013 - 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var Snap = (function(root) {
Snap.version = "0.5.1";
/*\
 * Snap
 [ method ]
 **
 * Creates a drawing surface or wraps existing SVG element.
 **
 - width (number|string) width of surface
 - height (number|string) height of surface
 * or
 - DOM (SVGElement) element to be wrapped into Snap structure
 * or
 - array (array) array of elements (will return set of elements)
 * or
 - query (string) CSS query selector
 = (object) @Element
\*/
function Snap(w, h) {
    if (w) {
        if (w.nodeType) {
            return wrap(w);
        }
        if (is(w, "array") && Snap.set) {
            return Snap.set.apply(Snap, w);
        }
        if (w instanceof Element) {
            return w;
        }
        if (h == null) {
            try {
                w = glob.doc.querySelector(String(w));
                return wrap(w);
            } catch (e) {
                return null;
            }
        }
    }
    w = w == null ? "100%" : w;
    h = h == null ? "100%" : h;
    return new Paper(w, h);
}
Snap.toString = function () {
    return "Snap v" + this.version;
};
Snap._ = {};
var glob = {
    win: root.window,
    doc: root.window.document
};
Snap._.glob = glob;
var has = "hasOwnProperty",
    Str = String,
    toFloat = parseFloat,
    toInt = parseInt,
    math = Math,
    mmax = math.max,
    mmin = math.min,
    abs = math.abs,
    pow = math.pow,
    PI = math.PI,
    round = math.round,
    E = "",
    S = " ",
    objectToString = Object.prototype.toString,
    ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i,
    colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
    bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
    separator = Snap._.separator = /[,\s]+/,
    whitespace = /[\s]/g,
    commaSpaces = /[\s]*,[\s]*/,
    hsrg = {hs: 1, rg: 1},
    pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
    tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
    pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/ig,
    idgen = 0,
    idprefix = "S" + (+new Date).toString(36),
    ID = function (el) {
        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
    },
    xlink = "http://www.w3.org/1999/xlink",
    xmlns = "http://www.w3.org/2000/svg",
    hub = {},
    /*\
     * Snap.url
     [ method ]
     **
     * Wraps path into `"url('<path>')"`.
     - value (string) path
     = (string) wrapped path
    \*/
    URL = Snap.url = function (url) {
        return "url('#" + url + "')";
    };

function $(el, attr) {
    if (attr) {
        if (el == "#text") {
            el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
        }
        if (el == "#comment") {
            el = glob.doc.createComment(attr.text || attr["#text"] || "");
        }
        if (typeof el == "string") {
            el = $(el);
        }
        if (typeof attr == "string") {
            if (el.nodeType == 1) {
                if (attr.substring(0, 6) == "xlink:") {
                    return el.getAttributeNS(xlink, attr.substring(6));
                }
                if (attr.substring(0, 4) == "xml:") {
                    return el.getAttributeNS(xmlns, attr.substring(4));
                }
                return el.getAttribute(attr);
            } else if (attr == "text") {
                return el.nodeValue;
            } else {
                return null;
            }
        }
        if (el.nodeType == 1) {
            for (var key in attr) if (attr[has](key)) {
                var val = Str(attr[key]);
                if (val) {
                    if (key.substring(0, 6) == "xlink:") {
                        el.setAttributeNS(xlink, key.substring(6), val);
                    } else if (key.substring(0, 4) == "xml:") {
                        el.setAttributeNS(xmlns, key.substring(4), val);
                    } else {
                        el.setAttribute(key, val);
                    }
                } else {
                    el.removeAttribute(key);
                }
            }
        } else if ("text" in attr) {
            el.nodeValue = attr.text;
        }
    } else {
        el = glob.doc.createElementNS(xmlns, el);
    }
    return el;
}
Snap._.$ = $;
Snap._.id = ID;
function getAttrs(el) {
    var attrs = el.attributes,
        name,
        out = {};
    for (var i = 0; i < attrs.length; i++) {
        if (attrs[i].namespaceURI == xlink) {
            name = "xlink:";
        } else {
            name = "";
        }
        name += attrs[i].name;
        out[name] = attrs[i].textContent;
    }
    return out;
}
function is(o, type) {
    type = Str.prototype.toLowerCase.call(type);
    if (type == "finite") {
        return isFinite(o);
    }
    if (type == "array" &&
        (o instanceof Array || Array.isArray && Array.isArray(o))) {
        return true;
    }
    return  type == "null" && o === null ||
            type == typeof o && o !== null ||
            type == "object" && o === Object(o) ||
            objectToString.call(o).slice(8, -1).toLowerCase() == type;
}
/*\
 * Snap.format
 [ method ]
 **
 * Replaces construction of type `{<name>}` to the corresponding argument
 **
 - token (string) string to format
 - json (object) object which properties are used as a replacement
 = (string) formatted string
 > Usage
 | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
 | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
 |     x: 10,
 |     y: 20,
 |     dim: {
 |         width: 40,
 |         height: 50,
 |         "negative width": -40
 |     }
 | }));
\*/
Snap.format = (function () {
    var tokenRegex = /\{([^\}]+)\}/g,
        objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
        replacer = function (all, key, obj) {
            var res = obj;
            key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
                name = name || quotedName;
                if (res) {
                    if (name in res) {
                        res = res[name];
                    }
                    typeof res == "function" && isFunc && (res = res());
                }
            });
            res = (res == null || res == obj ? all : res) + "";
            return res;
        };
    return function (str, obj) {
        return Str(str).replace(tokenRegex, function (all, key) {
            return replacer(all, key, obj);
        });
    };
})();
function clone(obj) {
    if (typeof obj == "function" || Object(obj) !== obj) {
        return obj;
    }
    var res = new obj.constructor;
    for (var key in obj) if (obj[has](key)) {
        res[key] = clone(obj[key]);
    }
    return res;
}
Snap._.clone = clone;
function repush(array, item) {
    for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
        return array.push(array.splice(i, 1)[0]);
    }
}
function cacher(f, scope, postprocessor) {
    function newf() {
        var arg = Array.prototype.slice.call(arguments, 0),
            args = arg.join("\u2400"),
            cache = newf.cache = newf.cache || {},
            count = newf.count = newf.count || [];
        if (cache[has](args)) {
            repush(count, args);
            return postprocessor ? postprocessor(cache[args]) : cache[args];
        }
        count.length >= 1e3 && delete cache[count.shift()];
        count.push(args);
        cache[args] = f.apply(scope, arg);
        return postprocessor ? postprocessor(cache[args]) : cache[args];
    }
    return newf;
}
Snap._.cacher = cacher;
function angle(x1, y1, x2, y2, x3, y3) {
    if (x3 == null) {
        var x = x1 - x2,
            y = y1 - y2;
        if (!x && !y) {
            return 0;
        }
        return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
    } else {
        return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
    }
}
function rad(deg) {
    return deg % 360 * PI / 180;
}
function deg(rad) {
    return rad * 180 / PI % 360;
}
function x_y() {
    return this.x + S + this.y;
}
function x_y_w_h() {
    return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
}

/*\
 * Snap.rad
 [ method ]
 **
 * Transform angle to radians
 - deg (number) angle in degrees
 = (number) angle in radians
\*/
Snap.rad = rad;
/*\
 * Snap.deg
 [ method ]
 **
 * Transform angle to degrees
 - rad (number) angle in radians
 = (number) angle in degrees
\*/
Snap.deg = deg;
/*\
 * Snap.sin
 [ method ]
 **
 * Equivalent to `Math.sin()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) sin
\*/
Snap.sin = function (angle) {
    return math.sin(Snap.rad(angle));
};
/*\
 * Snap.tan
 [ method ]
 **
 * Equivalent to `Math.tan()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) tan
\*/
Snap.tan = function (angle) {
    return math.tan(Snap.rad(angle));
};
/*\
 * Snap.cos
 [ method ]
 **
 * Equivalent to `Math.cos()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) cos
\*/
Snap.cos = function (angle) {
    return math.cos(Snap.rad(angle));
};
/*\
 * Snap.asin
 [ method ]
 **
 * Equivalent to `Math.asin()` only works with degrees, not radians.
 - num (number) value
 = (number) asin in degrees
\*/
Snap.asin = function (num) {
    return Snap.deg(math.asin(num));
};
/*\
 * Snap.acos
 [ method ]
 **
 * Equivalent to `Math.acos()` only works with degrees, not radians.
 - num (number) value
 = (number) acos in degrees
\*/
Snap.acos = function (num) {
    return Snap.deg(math.acos(num));
};
/*\
 * Snap.atan
 [ method ]
 **
 * Equivalent to `Math.atan()` only works with degrees, not radians.
 - num (number) value
 = (number) atan in degrees
\*/
Snap.atan = function (num) {
    return Snap.deg(math.atan(num));
};
/*\
 * Snap.atan2
 [ method ]
 **
 * Equivalent to `Math.atan2()` only works with degrees, not radians.
 - num (number) value
 = (number) atan2 in degrees
\*/
Snap.atan2 = function (num) {
    return Snap.deg(math.atan2(num));
};
/*\
 * Snap.angle
 [ method ]
 **
 * Returns an angle between two or three points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 - x3 (number) #optional x coord of third point
 - y3 (number) #optional y coord of third point
 = (number) angle in degrees
\*/
Snap.angle = angle;
/*\
 * Snap.len
 [ method ]
 **
 * Returns distance between two points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/
Snap.len = function (x1, y1, x2, y2) {
    return Math.sqrt(Snap.len2(x1, y1, x2, y2));
};
/*\
 * Snap.len2
 [ method ]
 **
 * Returns squared distance between two points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/
Snap.len2 = function (x1, y1, x2, y2) {
    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
};
/*\
 * Snap.closestPoint
 [ method ]
 **
 * Returns closest point to a given one on a given path.
 - path (Element) path element
 - x (number) x coord of a point
 - y (number) y coord of a point
 = (object) in format
 {
    x (number) x coord of the point on the path
    y (number) y coord of the point on the path
    length (number) length of the path to the point
    distance (number) distance from the given point to the path
 }
\*/
// Copied from http://bl.ocks.org/mbostock/8027637
Snap.closestPoint = function (path, x, y) {
    function distance2(p) {
        var dx = p.x - x,
            dy = p.y - y;
        return dx * dx + dy * dy;
    }
    var pathNode = path.node,
        pathLength = pathNode.getTotalLength(),
        precision = pathLength / pathNode.pathSegList.numberOfItems * .125,
        best,
        bestLength,
        bestDistance = Infinity;

    // linear scan for coarse approximation
    for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
        if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
            best = scan;
            bestLength = scanLength;
            bestDistance = scanDistance;
        }
    }

    // binary search for precise estimate
    precision *= .5;
    while (precision > .5) {
        var before,
            after,
            beforeLength,
            afterLength,
            beforeDistance,
            afterDistance;
        if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
            best = before;
            bestLength = beforeLength;
            bestDistance = beforeDistance;
        } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
            best = after;
            bestLength = afterLength;
            bestDistance = afterDistance;
        } else {
            precision *= .5;
        }
    }

    best = {
        x: best.x,
        y: best.y,
        length: bestLength,
        distance: Math.sqrt(bestDistance)
    };
    return best;
}
/*\
 * Snap.is
 [ method ]
 **
 * Handy replacement for the `typeof` operator
 - o (…) any object or primitive
 - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
 = (boolean) `true` if given value is of given type
\*/
Snap.is = is;
/*\
 * Snap.snapTo
 [ method ]
 **
 * Snaps given value to given grid
 - values (array|number) given array of values or step of the grid
 - value (number) value to adjust
 - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
 = (number) adjusted value
\*/
Snap.snapTo = function (values, value, tolerance) {
    tolerance = is(tolerance, "finite") ? tolerance : 10;
    if (is(values, "array")) {
        var i = values.length;
        while (i--) if (abs(values[i] - value) <= tolerance) {
            return values[i];
        }
    } else {
        values = +values;
        var rem = value % values;
        if (rem < tolerance) {
            return value - rem;
        }
        if (rem > values - tolerance) {
            return value - rem + values;
        }
    }
    return value;
};
// Colour
/*\
 * Snap.getRGB
 [ method ]
 **
 * Parses color string as RGB object
 - color (string) color string in one of the following formats:
 # <ul>
 #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
 #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
 #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
 #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
 #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
 #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
 #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
 #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
 # </ul>
 * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) true if string can't be parsed
 o }
\*/
Snap.getRGB = cacher(function (colour) {
    if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
    }
    if (colour == "none") {
        return {r: -1, g: -1, b: -1, hex: "none", toString: rgbtoString};
    }
    !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
    if (!colour) {
        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
    }
    var res,
        red,
        green,
        blue,
        opacity,
        t,
        values,
        rgb = colour.match(colourRegExp);
    if (rgb) {
        if (rgb[2]) {
            blue = toInt(rgb[2].substring(5), 16);
            green = toInt(rgb[2].substring(3, 5), 16);
            red = toInt(rgb[2].substring(1, 3), 16);
        }
        if (rgb[3]) {
            blue = toInt((t = rgb[3].charAt(3)) + t, 16);
            green = toInt((t = rgb[3].charAt(2)) + t, 16);
            red = toInt((t = rgb[3].charAt(1)) + t, 16);
        }
        if (rgb[4]) {
            values = rgb[4].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red *= 2.55);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green *= 2.55);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue *= 2.55);
            rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
        }
        if (rgb[5]) {
            values = rgb[5].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red /= 100);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green /= 100);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue /= 100);
            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
            rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
            return Snap.hsb2rgb(red, green, blue, opacity);
        }
        if (rgb[6]) {
            values = rgb[6].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red /= 100);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green /= 100);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue /= 100);
            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
            rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
            return Snap.hsl2rgb(red, green, blue, opacity);
        }
        red = mmin(math.round(red), 255);
        green = mmin(math.round(green), 255);
        blue = mmin(math.round(blue), 255);
        opacity = mmin(mmax(opacity, 0), 1);
        rgb = {r: red, g: green, b: blue, toString: rgbtoString};
        rgb.hex = "#" + (16777216 | blue | green << 8 | red << 16).toString(16).slice(1);
        rgb.opacity = is(opacity, "finite") ? opacity : 1;
        return rgb;
    }
    return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
}, Snap);
/*\
 * Snap.hsb
 [ method ]
 **
 * Converts HSB values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - b (number) value or brightness
 = (string) hex representation of the color
\*/
Snap.hsb = cacher(function (h, s, b) {
    return Snap.hsb2rgb(h, s, b).hex;
});
/*\
 * Snap.hsl
 [ method ]
 **
 * Converts HSL values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (string) hex representation of the color
\*/
Snap.hsl = cacher(function (h, s, l) {
    return Snap.hsl2rgb(h, s, l).hex;
});
/*\
 * Snap.rgb
 [ method ]
 **
 * Converts RGB values to a hex representation of the color
 - r (number) red
 - g (number) green
 - b (number) blue
 = (string) hex representation of the color
\*/
Snap.rgb = cacher(function (r, g, b, o) {
    if (is(o, "finite")) {
        var round = math.round;
        return "rgba(" + [round(r), round(g), round(b), +o.toFixed(2)] + ")";
    }
    return "#" + (16777216 | b | g << 8 | r << 16).toString(16).slice(1);
});
var toHex = function (color) {
    var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0],
        red = "rgb(255, 0, 0)";
    toHex = cacher(function (color) {
        if (color.toLowerCase() == "red") {
            return red;
        }
        i.style.color = red;
        i.style.color = color;
        var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
        return out == red ? null : out;
    });
    return toHex(color);
},
hsbtoString = function () {
    return "hsb(" + [this.h, this.s, this.b] + ")";
},
hsltoString = function () {
    return "hsl(" + [this.h, this.s, this.l] + ")";
},
rgbtoString = function () {
    return this.opacity == 1 || this.opacity == null ?
            this.hex :
            "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
},
prepareRGB = function (r, g, b) {
    if (g == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
        b = r.b;
        g = r.g;
        r = r.r;
    }
    if (g == null && is(r, string)) {
        var clr = Snap.getRGB(r);
        r = clr.r;
        g = clr.g;
        b = clr.b;
    }
    if (r > 1 || g > 1 || b > 1) {
        r /= 255;
        g /= 255;
        b /= 255;
    }

    return [r, g, b];
},
packageRGB = function (r, g, b, o) {
    r = math.round(r * 255);
    g = math.round(g * 255);
    b = math.round(b * 255);
    var rgb = {
        r: r,
        g: g,
        b: b,
        opacity: is(o, "finite") ? o : 1,
        hex: Snap.rgb(r, g, b),
        toString: rgbtoString
    };
    is(o, "finite") && (rgb.opacity = o);
    return rgb;
};
/*\
 * Snap.color
 [ method ]
 **
 * Parses the color string and returns an object featuring the color's component values
 - clr (string) color string in one of the supported formats (see @Snap.getRGB)
 = (object) Combined RGB/HSB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) `true` if string can't be parsed,
 o     h (number) hue,
 o     s (number) saturation,
 o     v (number) value (brightness),
 o     l (number) lightness
 o }
\*/
Snap.color = function (clr) {
    var rgb;
    if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
        rgb = Snap.hsb2rgb(clr);
        clr.r = rgb.r;
        clr.g = rgb.g;
        clr.b = rgb.b;
        clr.opacity = 1;
        clr.hex = rgb.hex;
    } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
        rgb = Snap.hsl2rgb(clr);
        clr.r = rgb.r;
        clr.g = rgb.g;
        clr.b = rgb.b;
        clr.opacity = 1;
        clr.hex = rgb.hex;
    } else {
        if (is(clr, "string")) {
            clr = Snap.getRGB(clr);
        }
        if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
            rgb = Snap.rgb2hsl(clr);
            clr.h = rgb.h;
            clr.s = rgb.s;
            clr.l = rgb.l;
            rgb = Snap.rgb2hsb(clr);
            clr.v = rgb.b;
        } else {
            clr = {hex: "none"};
            clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
            clr.error = 1;
        }
    }
    clr.toString = rgbtoString;
    return clr;
};
/*\
 * Snap.hsb2rgb
 [ method ]
 **
 * Converts HSB values to an RGB object
 - h (number) hue
 - s (number) saturation
 - v (number) value or brightness
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/
Snap.hsb2rgb = function (h, s, v, o) {
    if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
        v = h.b;
        s = h.s;
        o = h.o;
        h = h.h;
    }
    h *= 360;
    var R, G, B, X, C;
    h = h % 360 / 60;
    C = v * s;
    X = C * (1 - abs(h % 2 - 1));
    R = G = B = v - C;

    h = ~~h;
    R += [C, X, 0, 0, X, C][h];
    G += [X, C, C, X, 0, 0][h];
    B += [0, 0, X, C, C, X][h];
    return packageRGB(R, G, B, o);
};
/*\
 * Snap.hsl2rgb
 [ method ]
 **
 * Converts HSL values to an RGB object
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/
Snap.hsl2rgb = function (h, s, l, o) {
    if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
        l = h.l;
        s = h.s;
        h = h.h;
    }
    if (h > 1 || s > 1 || l > 1) {
        h /= 360;
        s /= 100;
        l /= 100;
    }
    h *= 360;
    var R, G, B, X, C;
    h = h % 360 / 60;
    C = 2 * s * (l < .5 ? l : 1 - l);
    X = C * (1 - abs(h % 2 - 1));
    R = G = B = l - C / 2;

    h = ~~h;
    R += [C, X, 0, 0, X, C][h];
    G += [X, C, C, X, 0, 0][h];
    B += [0, 0, X, C, C, X][h];
    return packageRGB(R, G, B, o);
};
/*\
 * Snap.rgb2hsb
 [ method ]
 **
 * Converts RGB values to an HSB object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSB object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     b (number) brightness
 o }
\*/
Snap.rgb2hsb = function (r, g, b) {
    b = prepareRGB(r, g, b);
    r = b[0];
    g = b[1];
    b = b[2];

    var H, S, V, C;
    V = mmax(r, g, b);
    C = V - mmin(r, g, b);
    H = C == 0 ? null :
        V == r ? (g - b) / C :
        V == g ? (b - r) / C + 2 :
                 (r - g) / C + 4;
    H = (H + 360) % 6 * 60 / 360;
    S = C == 0 ? 0 : C / V;
    return {h: H, s: S, b: V, toString: hsbtoString};
};
/*\
 * Snap.rgb2hsl
 [ method ]
 **
 * Converts RGB values to an HSL object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSL object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     l (number) luminosity
 o }
\*/
Snap.rgb2hsl = function (r, g, b) {
    b = prepareRGB(r, g, b);
    r = b[0];
    g = b[1];
    b = b[2];

    var H, S, L, M, m, C;
    M = mmax(r, g, b);
    m = mmin(r, g, b);
    C = M - m;
    H = C == 0 ? null :
        M == r ? (g - b) / C :
        M == g ? (b - r) / C + 2 :
                 (r - g) / C + 4;
    H = (H + 360) % 6 * 60 / 360;
    L = (M + m) / 2;
    S = C == 0 ? 0 :
         L < .5 ? C / (2 * L) :
                  C / (2 - 2 * L);
    return {h: H, s: S, l: L, toString: hsltoString};
};

// Transformations
/*\
 * Snap.parsePathString
 [ method ]
 **
 * Utility method
 **
 * Parses given path string into an array of arrays of path segments
 - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
 = (array) array of segments
\*/
Snap.parsePathString = function (pathString) {
    if (!pathString) {
        return null;
    }
    var pth = Snap.path(pathString);
    if (pth.arr) {
        return Snap.path.clone(pth.arr);
    }

    var paramCounts = {a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0},
        data = [];
    if (is(pathString, "array") && is(pathString[0], "array")) { // rough assumption
        data = Snap.path.clone(pathString);
    }
    if (!data.length) {
        Str(pathString).replace(pathCommand, function (a, b, c) {
            var params = [],
                name = b.toLowerCase();
            c.replace(pathValues, function (a, b) {
                b && params.push(+b);
            });
            if (name == "m" && params.length > 2) {
                data.push([b].concat(params.splice(0, 2)));
                name = "l";
                b = b == "m" ? "l" : "L";
            }
            if (name == "o" && params.length == 1) {
                data.push([b, params[0]]);
            }
            if (name == "r") {
                data.push([b].concat(params));
            } else while (params.length >= paramCounts[name]) {
                data.push([b].concat(params.splice(0, paramCounts[name])));
                if (!paramCounts[name]) {
                    break;
                }
            }
        });
    }
    data.toString = Snap.path.toString;
    pth.arr = Snap.path.clone(data);
    return data;
};
/*\
 * Snap.parseTransformString
 [ method ]
 **
 * Utility method
 **
 * Parses given transform string into an array of transformations
 - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
 = (array) array of transformations
\*/
var parseTransformString = Snap.parseTransformString = function (TString) {
    if (!TString) {
        return null;
    }
    var paramCounts = {r: 3, s: 4, t: 2, m: 6},
        data = [];
    if (is(TString, "array") && is(TString[0], "array")) { // rough assumption
        data = Snap.path.clone(TString);
    }
    if (!data.length) {
        Str(TString).replace(tCommand, function (a, b, c) {
            var params = [],
                name = b.toLowerCase();
            c.replace(pathValues, function (a, b) {
                b && params.push(+b);
            });
            data.push([b].concat(params));
        });
    }
    data.toString = Snap.path.toString;
    return data;
};
function svgTransform2string(tstr) {
    var res = [];
    tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function (all, name, params) {
        params = params.split(/\s*,\s*|\s+/);
        if (name == "rotate" && params.length == 1) {
            params.push(0, 0);
        }
        if (name == "scale") {
            if (params.length > 2) {
                params = params.slice(0, 2);
            } else if (params.length == 2) {
                params.push(0, 0);
            }
            if (params.length == 1) {
                params.push(params[0], 0, 0);
            }
        }
        if (name == "skewX") {
            res.push(["m", 1, 0, math.tan(rad(params[0])), 1, 0, 0]);
        } else if (name == "skewY") {
            res.push(["m", 1, math.tan(rad(params[0])), 0, 1, 0, 0]);
        } else {
            res.push([name.charAt(0)].concat(params));
        }
        return all;
    });
    return res;
}
Snap._.svgTransform2string = svgTransform2string;
Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
function transform2matrix(tstr, bbox) {
    var tdata = parseTransformString(tstr),
        m = new Snap.Matrix;
    if (tdata) {
        for (var i = 0, ii = tdata.length; i < ii; i++) {
            var t = tdata[i],
                tlen = t.length,
                command = Str(t[0]).toLowerCase(),
                absolute = t[0] != command,
                inver = absolute ? m.invert() : 0,
                x1,
                y1,
                x2,
                y2,
                bb;
            if (command == "t" && tlen == 2){
                m.translate(t[1], 0);
            } else if (command == "t" && tlen == 3) {
                if (absolute) {
                    x1 = inver.x(0, 0);
                    y1 = inver.y(0, 0);
                    x2 = inver.x(t[1], t[2]);
                    y2 = inver.y(t[1], t[2]);
                    m.translate(x2 - x1, y2 - y1);
                } else {
                    m.translate(t[1], t[2]);
                }
            } else if (command == "r") {
                if (tlen == 2) {
                    bb = bb || bbox;
                    m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.rotate(t[1], x2, y2);
                    } else {
                        m.rotate(t[1], t[2], t[3]);
                    }
                }
            } else if (command == "s") {
                if (tlen == 2 || tlen == 3) {
                    bb = bb || bbox;
                    m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.scale(t[1], t[1], x2, y2);
                    } else {
                        m.scale(t[1], t[1], t[2], t[3]);
                    }
                } else if (tlen == 5) {
                    if (absolute) {
                        x2 = inver.x(t[3], t[4]);
                        y2 = inver.y(t[3], t[4]);
                        m.scale(t[1], t[2], x2, y2);
                    } else {
                        m.scale(t[1], t[2], t[3], t[4]);
                    }
                }
            } else if (command == "m" && tlen == 7) {
                m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
            }
        }
    }
    return m;
}
Snap._.transform2matrix = transform2matrix;
Snap._unit2px = unit2px;
var contains = glob.doc.contains || glob.doc.compareDocumentPosition ?
    function (a, b) {
        var adown = a.nodeType == 9 ? a.documentElement : a,
            bup = b && b.parentNode;
            return a == bup || !!(bup && bup.nodeType == 1 && (
                adown.contains ?
                    adown.contains(bup) :
                    a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
            ));
    } :
    function (a, b) {
        if (b) {
            while (b) {
                b = b.parentNode;
                if (b == a) {
                    return true;
                }
            }
        }
        return false;
    };
function getSomeDefs(el) {
    var p = el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) ||
            el.node.parentNode && wrap(el.node.parentNode) ||
            Snap.select("svg") ||
            Snap(0, 0),
        pdefs = p.select("defs"),
        defs  = pdefs == null ? false : pdefs.node;
    if (!defs) {
        defs = make("defs", p.node).node;
    }
    return defs;
}
function getSomeSVG(el) {
    return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
}
Snap._.getSomeDefs = getSomeDefs;
Snap._.getSomeSVG = getSomeSVG;
function unit2px(el, name, value) {
    var svg = getSomeSVG(el).node,
        out = {},
        mgr = svg.querySelector(".svg---mgr");
    if (!mgr) {
        mgr = $("rect");
        $(mgr, {x: -9e9, y: -9e9, width: 10, height: 10, "class": "svg---mgr", fill: "none"});
        svg.appendChild(mgr);
    }
    function getW(val) {
        if (val == null) {
            return E;
        }
        if (val == +val) {
            return val;
        }
        $(mgr, {width: val});
        try {
            return mgr.getBBox().width;
        } catch (e) {
            return 0;
        }
    }
    function getH(val) {
        if (val == null) {
            return E;
        }
        if (val == +val) {
            return val;
        }
        $(mgr, {height: val});
        try {
            return mgr.getBBox().height;
        } catch (e) {
            return 0;
        }
    }
    function set(nam, f) {
        if (name == null) {
            out[nam] = f(el.attr(nam) || 0);
        } else if (nam == name) {
            out = f(value == null ? el.attr(nam) || 0 : value);
        }
    }
    switch (el.type) {
        case "rect":
            set("rx", getW);
            set("ry", getH);
        case "image":
            set("width", getW);
            set("height", getH);
        case "text":
            set("x", getW);
            set("y", getH);
        break;
        case "circle":
            set("cx", getW);
            set("cy", getH);
            set("r", getW);
        break;
        case "ellipse":
            set("cx", getW);
            set("cy", getH);
            set("rx", getW);
            set("ry", getH);
        break;
        case "line":
            set("x1", getW);
            set("x2", getW);
            set("y1", getH);
            set("y2", getH);
        break;
        case "marker":
            set("refX", getW);
            set("markerWidth", getW);
            set("refY", getH);
            set("markerHeight", getH);
        break;
        case "radialGradient":
            set("fx", getW);
            set("fy", getH);
        break;
        case "tspan":
            set("dx", getW);
            set("dy", getH);
        break;
        default:
            set(name, getW);
    }
    svg.removeChild(mgr);
    return out;
}
/*\
 * Snap.select
 [ method ]
 **
 * Wraps a DOM element specified by CSS selector as @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/
Snap.select = function (query) {
    query = Str(query).replace(/([^\\]):/g, "$1\\:");
    return wrap(glob.doc.querySelector(query));
};
/*\
 * Snap.selectAll
 [ method ]
 **
 * Wraps DOM elements specified by CSS selector as set or array of @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/
Snap.selectAll = function (query) {
    var nodelist = glob.doc.querySelectorAll(query),
        set = (Snap.set || Array)();
    for (var i = 0; i < nodelist.length; i++) {
        set.push(wrap(nodelist[i]));
    }
    return set;
};

function add2group(list) {
    if (!is(list, "array")) {
        list = Array.prototype.slice.call(arguments, 0);
    }
    var i = 0,
        j = 0,
        node = this.node;
    while (this[i]) delete this[i++];
    for (i = 0; i < list.length; i++) {
        if (list[i].type == "set") {
            list[i].forEach(function (el) {
                node.appendChild(el.node);
            });
        } else {
            node.appendChild(list[i].node);
        }
    }
    var children = node.childNodes;
    for (i = 0; i < children.length; i++) {
        this[j++] = wrap(children[i]);
    }
    return this;
}
// Hub garbage collector every 10s
setInterval(function () {
    for (var key in hub) if (hub[has](key)) {
        var el = hub[key],
            node = el.node;
        if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) {
            delete hub[key];
        }
    }
}, 1e4);
function Element(el) {
    if (el.snap in hub) {
        return hub[el.snap];
    }
    var svg;
    try {
        svg = el.ownerSVGElement;
    } catch(e) {}
    /*\
     * Element.node
     [ property (object) ]
     **
     * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
     > Usage
     | // draw a circle at coordinate 10,10 with radius of 10
     | var c = paper.circle(10, 10, 10);
     | c.node.onclick = function () {
     |     c.attr("fill", "red");
     | };
    \*/
    this.node = el;
    if (svg) {
        this.paper = new Paper(svg);
    }
    /*\
     * Element.type
     [ property (string) ]
     **
     * SVG tag name of the given element.
    \*/
    this.type = el.tagName || el.nodeName;
    var id = this.id = ID(this);
    this.anims = {};
    this._ = {
        transform: []
    };
    el.snap = id;
    hub[id] = this;
    if (this.type == "g") {
        this.add = add2group;
    }
    if (this.type in {g: 1, mask: 1, pattern: 1, symbol: 1}) {
        for (var method in Paper.prototype) if (Paper.prototype[has](method)) {
            this[method] = Paper.prototype[method];
        }
    }
}
   /*\
     * Element.attr
     [ method ]
     **
     * Gets or sets given attributes of the element.
     **
     - params (object) contains key-value pairs of attributes you want to set
     * or
     - param (string) name of the attribute
     = (Element) the current element
     * or
     = (string) value of attribute
     > Usage
     | el.attr({
     |     fill: "#fc0",
     |     stroke: "#000",
     |     strokeWidth: 2, // CamelCase...
     |     "fill-opacity": 0.5, // or dash-separated names
     |     width: "*=2" // prefixed values
     | });
     | console.log(el.attr("fill")); // #fc0
     * Prefixed values in format `"+=10"` supported. All four operations
     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
     * and `-`: `"+=2em"`.
    \*/
    Element.prototype.attr = function (params, value) {
        var el = this,
            node = el.node;
        if (!params) {
            if (node.nodeType != 1) {
                return {
                    text: node.nodeValue
                };
            }
            var attr = node.attributes,
                out = {};
            for (var i = 0, ii = attr.length; i < ii; i++) {
                out[attr[i].nodeName] = attr[i].nodeValue;
            }
            return out;
        }
        if (is(params, "string")) {
            if (arguments.length > 1) {
                var json = {};
                json[params] = value;
                params = json;
            } else {
                return eve("snap.util.getattr." + params, el).firstDefined();
            }
        }
        for (var att in params) {
            if (params[has](att)) {
                eve("snap.util.attr." + att, el, params[att]);
            }
        }
        return el;
    };
/*\
 * Snap.parse
 [ method ]
 **
 * Parses SVG fragment and converts it into a @Fragment
 **
 - svg (string) SVG string
 = (Fragment) the @Fragment
\*/
Snap.parse = function (svg) {
    var f = glob.doc.createDocumentFragment(),
        full = true,
        div = glob.doc.createElement("div");
    svg = Str(svg);
    if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
        svg = "<svg>" + svg + "</svg>";
        full = false;
    }
    div.innerHTML = svg;
    svg = div.getElementsByTagName("svg")[0];
    if (svg) {
        if (full) {
            f = svg;
        } else {
            while (svg.firstChild) {
                f.appendChild(svg.firstChild);
            }
        }
    }
    return new Fragment(f);
};
function Fragment(frag) {
    this.node = frag;
}
/*\
 * Snap.fragment
 [ method ]
 **
 * Creates a DOM fragment from a given list of elements or strings
 **
 - varargs (…) SVG string
 = (Fragment) the @Fragment
\*/
Snap.fragment = function () {
    var args = Array.prototype.slice.call(arguments, 0),
        f = glob.doc.createDocumentFragment();
    for (var i = 0, ii = args.length; i < ii; i++) {
        var item = args[i];
        if (item.node && item.node.nodeType) {
            f.appendChild(item.node);
        }
        if (item.nodeType) {
            f.appendChild(item);
        }
        if (typeof item == "string") {
            f.appendChild(Snap.parse(item).node);
        }
    }
    return new Fragment(f);
};

function make(name, parent) {
    var res = $(name);
    parent.appendChild(res);
    var el = wrap(res);
    return el;
}
function Paper(w, h) {
    var res,
        desc,
        defs,
        proto = Paper.prototype;
    if (w && w.tagName && w.tagName.toLowerCase() == "svg") {
        if (w.snap in hub) {
            return hub[w.snap];
        }
        var doc = w.ownerDocument;
        res = new Element(w);
        desc = w.getElementsByTagName("desc")[0];
        defs = w.getElementsByTagName("defs")[0];
        if (!desc) {
            desc = $("desc");
            desc.appendChild(doc.createTextNode("Created with Snap"));
            res.node.appendChild(desc);
        }
        if (!defs) {
            defs = $("defs");
            res.node.appendChild(defs);
        }
        res.defs = defs;
        for (var key in proto) if (proto[has](key)) {
            res[key] = proto[key];
        }
        res.paper = res.root = res;
    } else {
        res = make("svg", glob.doc.body);
        $(res.node, {
            height: h,
            version: 1.1,
            width: w,
            xmlns: xmlns
        });
    }
    return res;
}
function wrap(dom) {
    if (!dom) {
        return dom;
    }
    if (dom instanceof Element || dom instanceof Fragment) {
        return dom;
    }
    if (dom.tagName && dom.tagName.toLowerCase() == "svg") {
        return new Paper(dom);
    }
    if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") {
        return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
    }
    return new Element(dom);
}

Snap._.make = make;
Snap._.wrap = wrap;
/*\
 * Paper.el
 [ method ]
 **
 * Creates an element on paper with a given name and no attributes
 **
 - name (string) tag name
 - attr (object) attributes
 = (Element) the current element
 > Usage
 | var c = paper.circle(10, 10, 10); // is the same as...
 | var c = paper.el("circle").attr({
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
 | // and the same as
 | var c = paper.el("circle", {
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
\*/
Paper.prototype.el = function (name, attr) {
    var el = make(name, this.node);
    attr && el.attr(attr);
    return el;
};
/*\
 * Element.children
 [ method ]
 **
 * Returns array of all the children of the element.
 = (array) array of Elements
\*/
Element.prototype.children = function () {
    var out = [],
        ch = this.node.childNodes;
    for (var i = 0, ii = ch.length; i < ii; i++) {
        out[i] = Snap(ch[i]);
    }
    return out;
};
function jsonFiller(root, o) {
    for (var i = 0, ii = root.length; i < ii; i++) {
        var item = {
                type: root[i].type,
                attr: root[i].attr()
            },
            children = root[i].children();
        o.push(item);
        if (children.length) {
            jsonFiller(children, item.childNodes = []);
        }
    }
}
/*\
 * Element.toJSON
 [ method ]
 **
 * Returns object representation of the given element and all its children.
 = (object) in format
 o {
 o     type (string) this.type,
 o     attr (object) attributes map,
 o     childNodes (array) optional array of children in the same format
 o }
\*/
Element.prototype.toJSON = function () {
    var out = [];
    jsonFiller([this], out);
    return out[0];
};
// default
eve.on("snap.util.getattr", function () {
    var att = eve.nt();
    att = att.substring(att.lastIndexOf(".") + 1);
    var css = att.replace(/[A-Z]/g, function (letter) {
        return "-" + letter.toLowerCase();
    });
    if (cssAttr[has](css)) {
        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
    } else {
        return $(this.node, att);
    }
});
var cssAttr = {
    "alignment-baseline": 0,
    "baseline-shift": 0,
    "clip": 0,
    "clip-path": 0,
    "clip-rule": 0,
    "color": 0,
    "color-interpolation": 0,
    "color-interpolation-filters": 0,
    "color-profile": 0,
    "color-rendering": 0,
    "cursor": 0,
    "direction": 0,
    "display": 0,
    "dominant-baseline": 0,
    "enable-background": 0,
    "fill": 0,
    "fill-opacity": 0,
    "fill-rule": 0,
    "filter": 0,
    "flood-color": 0,
    "flood-opacity": 0,
    "font": 0,
    "font-family": 0,
    "font-size": 0,
    "font-size-adjust": 0,
    "font-stretch": 0,
    "font-style": 0,
    "font-variant": 0,
    "font-weight": 0,
    "glyph-orientation-horizontal": 0,
    "glyph-orientation-vertical": 0,
    "image-rendering": 0,
    "kerning": 0,
    "letter-spacing": 0,
    "lighting-color": 0,
    "marker": 0,
    "marker-end": 0,
    "marker-mid": 0,
    "marker-start": 0,
    "mask": 0,
    "opacity": 0,
    "overflow": 0,
    "pointer-events": 0,
    "shape-rendering": 0,
    "stop-color": 0,
    "stop-opacity": 0,
    "stroke": 0,
    "stroke-dasharray": 0,
    "stroke-dashoffset": 0,
    "stroke-linecap": 0,
    "stroke-linejoin": 0,
    "stroke-miterlimit": 0,
    "stroke-opacity": 0,
    "stroke-width": 0,
    "text-anchor": 0,
    "text-decoration": 0,
    "text-rendering": 0,
    "unicode-bidi": 0,
    "visibility": 0,
    "word-spacing": 0,
    "writing-mode": 0
};

eve.on("snap.util.attr", function (value) {
    var att = eve.nt(),
        attr = {};
    att = att.substring(att.lastIndexOf(".") + 1);
    attr[att] = value;
    var style = att.replace(/-(\w)/gi, function (all, letter) {
            return letter.toUpperCase();
        }),
        css = att.replace(/[A-Z]/g, function (letter) {
            return "-" + letter.toLowerCase();
        });
    if (cssAttr[has](css)) {
        this.node.style[style] = value == null ? E : value;
    } else {
        $(this.node, attr);
    }
});
(function (proto) {}(Paper.prototype));

// simple ajax
/*\
 * Snap.ajax
 [ method ]
 **
 * Simple implementation of Ajax
 **
 - url (string) URL
 - postData (object|string) data for post request
 - callback (function) callback
 - scope (object) #optional scope of callback
 * or
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
 = (XMLHttpRequest) the XMLHttpRequest object, just in case
\*/
Snap.ajax = function (url, postData, callback, scope){
    var req = new XMLHttpRequest,
        id = ID();
    if (req) {
        if (is(postData, "function")) {
            scope = callback;
            callback = postData;
            postData = null;
        } else if (is(postData, "object")) {
            var pd = [];
            for (var key in postData) if (postData.hasOwnProperty(key)) {
                pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
            }
            postData = pd.join("&");
        }
        req.open(postData ? "POST" : "GET", url, true);
        if (postData) {
            req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        }
        if (callback) {
            eve.once("snap.ajax." + id + ".0", callback);
            eve.once("snap.ajax." + id + ".200", callback);
            eve.once("snap.ajax." + id + ".304", callback);
        }
        req.onreadystatechange = function() {
            if (req.readyState != 4) return;
            eve("snap.ajax." + id + "." + req.status, scope, req);
        };
        if (req.readyState == 4) {
            return req;
        }
        req.send(postData);
        return req;
    }
};
/*\
 * Snap.load
 [ method ]
 **
 * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
 **
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
\*/
Snap.load = function (url, callback, scope) {
    Snap.ajax(url, function (req) {
        var f = Snap.parse(req.responseText);
        scope ? callback.call(scope, f) : callback(f);
    });
};
var getOffset = function (elem) {
    var box = elem.getBoundingClientRect(),
        doc = elem.ownerDocument,
        body = doc.body,
        docElem = doc.documentElement,
        clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0,
        top  = box.top  + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop ) - clientTop,
        left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
    return {
        y: top,
        x: left
    };
};
/*\
 * Snap.getElementByPoint
 [ method ]
 **
 * Returns you topmost element under given point.
 **
 = (object) Snap element object
 - x (number) x coordinate from the top left corner of the window
 - y (number) y coordinate from the top left corner of the window
 > Usage
 | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
\*/
Snap.getElementByPoint = function (x, y) {
    var paper = this,
        svg = paper.canvas,
        target = glob.doc.elementFromPoint(x, y);
    if (glob.win.opera && target.tagName == "svg") {
        var so = getOffset(target),
            sr = target.createSVGRect();
        sr.x = x - so.x;
        sr.y = y - so.y;
        sr.width = sr.height = 1;
        var hits = target.getIntersectionList(sr, null);
        if (hits.length) {
            target = hits[hits.length - 1];
        }
    }
    if (!target) {
        return null;
    }
    return wrap(target);
};
/*\
 * Snap.plugin
 [ method ]
 **
 * Let you write plugins. You pass in a function with five arguments, like this:
 | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
 |     Snap.newmethod = function () {};
 |     Element.prototype.newmethod = function () {};
 |     Paper.prototype.newmethod = function () {};
 | });
 * Inside the function you have access to all main objects (and their
 * prototypes). This allow you to extend anything you want.
 **
 - f (function) your plugin body
\*/
Snap.plugin = function (f) {
    f(Snap, Element, Paper, glob, Fragment);
};
glob.win.Snap = Snap;
return Snap;
}(window || this));

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype,
        is = Snap.is,
        Str = String,
        unit2px = Snap._unit2px,
        $ = Snap._.$,
        make = Snap._.make,
        getSomeDefs = Snap._.getSomeDefs,
        has = "hasOwnProperty",
        wrap = Snap._.wrap;
    /*\
     * Element.getBBox
     [ method ]
     **
     * Returns the bounding box descriptor for the given element
     **
     = (object) bounding box descriptor:
     o {
     o     cx: (number) x of the center,
     o     cy: (number) x of the center,
     o     h: (number) height,
     o     height: (number) height,
     o     path: (string) path command for the box,
     o     r0: (number) radius of a circle that fully encloses the box,
     o     r1: (number) radius of the smallest circle that can be enclosed,
     o     r2: (number) radius of the largest circle that can be enclosed,
     o     vb: (string) box as a viewbox command,
     o     w: (number) width,
     o     width: (number) width,
     o     x2: (number) x of the right side,
     o     x: (number) x of the left side,
     o     y2: (number) y of the bottom edge,
     o     y: (number) y of the top edge
     o }
    \*/
    elproto.getBBox = function (isWithoutTransform) {
        if (this.type == "tspan") {
            return Snap._.box(this.node.getClientRects().item(0));
        }
        if (!Snap.Matrix || !Snap.path) {
            return this.node.getBBox();
        }
        var el = this,
            m = new Snap.Matrix;
        if (el.removed) {
            return Snap._.box();
        }
        while (el.type == "use") {
            if (!isWithoutTransform) {
                m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
            }
            if (el.original) {
                el = el.original;
            } else {
                var href = el.attr("xlink:href");
                el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
            }
        }
        var _ = el._,
            pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
        try {
            if (isWithoutTransform) {
                _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
                return Snap._.box(_.bboxwt);
            } else {
                el.realPath = pathfinder(el);
                el.matrix = el.transform().localMatrix;
                _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
                return Snap._.box(_.bbox);
            }
        } catch (e) {
            // Firefox doesn’t give you bbox of hidden element
            return Snap._.box();
        }
    };
    var propString = function () {
        return this.string;
    };
    function extractTransform(el, tstr) {
        if (tstr == null) {
            var doReturn = true;
            if (el.type == "linearGradient" || el.type == "radialGradient") {
                tstr = el.node.getAttribute("gradientTransform");
            } else if (el.type == "pattern") {
                tstr = el.node.getAttribute("patternTransform");
            } else {
                tstr = el.node.getAttribute("transform");
            }
            if (!tstr) {
                return new Snap.Matrix;
            }
            tstr = Snap._.svgTransform2string(tstr);
        } else {
            if (!Snap._.rgTransform.test(tstr)) {
                tstr = Snap._.svgTransform2string(tstr);
            } else {
                tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
            }
            if (is(tstr, "array")) {
                tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
            }
            el._.transform = tstr;
        }
        var m = Snap._.transform2matrix(tstr, el.getBBox(1));
        if (doReturn) {
            return m;
        } else {
            el.matrix = m;
        }
    }
    /*\
     * Element.transform
     [ method ]
     **
     * Gets or sets transformation of the element
     **
     - tstr (string) transform string in Snap or SVG format
     = (Element) the current element
     * or
     = (object) transformation descriptor:
     o {
     o     string (string) transform string,
     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
     o     localMatrix (Matrix) matrix of transformations applied only to the element,
     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
     o     global (string) global transformation as string,
     o     local (string) local transformation as string,
     o     toString (function) returns `string` property
     o }
    \*/
    elproto.transform = function (tstr) {
        var _ = this._;
        if (tstr == null) {
            var papa = this,
                global = new Snap.Matrix(this.node.getCTM()),
                local = extractTransform(this),
                ms = [local],
                m = new Snap.Matrix,
                i,
                localString = local.toTransformString(),
                string = Str(local) == Str(this.matrix) ?
                            Str(_.transform) : localString;
            while (papa.type != "svg" && (papa = papa.parent())) {
                ms.push(extractTransform(papa));
            }
            i = ms.length;
            while (i--) {
                m.add(ms[i]);
            }
            return {
                string: string,
                globalMatrix: global,
                totalMatrix: m,
                localMatrix: local,
                diffMatrix: global.clone().add(local.invert()),
                global: global.toTransformString(),
                total: m.toTransformString(),
                local: localString,
                toString: propString
            };
        }
        if (tstr instanceof Snap.Matrix) {
            this.matrix = tstr;
            this._.transform = tstr.toTransformString();
        } else {
            extractTransform(this, tstr);
        }

        if (this.node) {
            if (this.type == "linearGradient" || this.type == "radialGradient") {
                $(this.node, {gradientTransform: this.matrix});
            } else if (this.type == "pattern") {
                $(this.node, {patternTransform: this.matrix});
            } else {
                $(this.node, {transform: this.matrix});
            }
        }

        return this;
    };
    /*\
     * Element.parent
     [ method ]
     **
     * Returns the element's parent
     **
     = (Element) the parent element
    \*/
    elproto.parent = function () {
        return wrap(this.node.parentNode);
    };
    /*\
     * Element.append
     [ method ]
     **
     * Appends the given element to current one
     **
     - el (Element|Set) element to append
     = (Element) the parent element
    \*/
    /*\
     * Element.add
     [ method ]
     **
     * See @Element.append
    \*/
    elproto.append = elproto.add = function (el) {
        if (el) {
            if (el.type == "set") {
                var it = this;
                el.forEach(function (el) {
                    it.add(el);
                });
                return this;
            }
            el = wrap(el);
            this.node.appendChild(el.node);
            el.paper = this.paper;
        }
        return this;
    };
    /*\
     * Element.appendTo
     [ method ]
     **
     * Appends the current element to the given one
     **
     - el (Element) parent element to append to
     = (Element) the child element
    \*/
    elproto.appendTo = function (el) {
        if (el) {
            el = wrap(el);
            el.append(this);
        }
        return this;
    };
    /*\
     * Element.prepend
     [ method ]
     **
     * Prepends the given element to the current one
     **
     - el (Element) element to prepend
     = (Element) the parent element
    \*/
    elproto.prepend = function (el) {
        if (el) {
            if (el.type == "set") {
                var it = this,
                    first;
                el.forEach(function (el) {
                    if (first) {
                        first.after(el);
                    } else {
                        it.prepend(el);
                    }
                    first = el;
                });
                return this;
            }
            el = wrap(el);
            var parent = el.parent();
            this.node.insertBefore(el.node, this.node.firstChild);
            this.add && this.add();
            el.paper = this.paper;
            this.parent() && this.parent().add();
            parent && parent.add();
        }
        return this;
    };
    /*\
     * Element.prependTo
     [ method ]
     **
     * Prepends the current element to the given one
     **
     - el (Element) parent element to prepend to
     = (Element) the child element
    \*/
    elproto.prependTo = function (el) {
        el = wrap(el);
        el.prepend(this);
        return this;
    };
    /*\
     * Element.before
     [ method ]
     **
     * Inserts given element before the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/
    elproto.before = function (el) {
        if (el.type == "set") {
            var it = this;
            el.forEach(function (el) {
                var parent = el.parent();
                it.node.parentNode.insertBefore(el.node, it.node);
                parent && parent.add();
            });
            this.parent().add();
            return this;
        }
        el = wrap(el);
        var parent = el.parent();
        this.node.parentNode.insertBefore(el.node, this.node);
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.after
     [ method ]
     **
     * Inserts given element after the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/
    elproto.after = function (el) {
        el = wrap(el);
        var parent = el.parent();
        if (this.node.nextSibling) {
            this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
        } else {
            this.node.parentNode.appendChild(el.node);
        }
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.insertBefore
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/
    elproto.insertBefore = function (el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.insertAfter
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/
    elproto.insertAfter = function (el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.remove
     [ method ]
     **
     * Removes element from the DOM
     = (Element) the detached element
    \*/
    elproto.remove = function () {
        var parent = this.parent();
        this.node.parentNode && this.node.parentNode.removeChild(this.node);
        delete this.paper;
        this.removed = true;
        parent && parent.add();
        return this;
    };
    /*\
     * Element.select
     [ method ]
     **
     * Gathers the nested @Element matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Element) result of query selection
    \*/
    elproto.select = function (query) {
        return wrap(this.node.querySelector(query));
    };
    /*\
     * Element.selectAll
     [ method ]
     **
     * Gathers nested @Element objects matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Set|array) result of query selection
    \*/
    elproto.selectAll = function (query) {
        var nodelist = this.node.querySelectorAll(query),
            set = (Snap.set || Array)();
        for (var i = 0; i < nodelist.length; i++) {
            set.push(wrap(nodelist[i]));
        }
        return set;
    };
    /*\
     * Element.asPX
     [ method ]
     **
     * Returns given attribute of the element as a `px` value (not %, em, etc.)
     **
     - attr (string) attribute name
     - value (string) #optional attribute value
     = (Element) result of query selection
    \*/
    elproto.asPX = function (attr, value) {
        if (value == null) {
            value = this.attr(attr);
        }
        return +unit2px(this, attr, value);
    };
    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
    /*\
     * Element.use
     [ method ]
     **
     * Creates a `<use>` element linked to the current element
     **
     = (Element) the `<use>` element
    \*/
    elproto.use = function () {
        var use,
            id = this.node.id;
        if (!id) {
            id = this.id;
            $(this.node, {
                id: id
            });
        }
        if (this.type == "linearGradient" || this.type == "radialGradient" ||
            this.type == "pattern") {
            use = make(this.type, this.node.parentNode);
        } else {
            use = make("use", this.node.parentNode);
        }
        $(use.node, {
            "xlink:href": "#" + id
        });
        use.original = this;
        return use;
    };
    function fixids(el) {
        var els = el.selectAll("*"),
            it,
            url = /^\s*url\(("|'|)(.*)\1\)\s*$/,
            ids = [],
            uses = {};
        function urltest(it, name) {
            var val = $(it.node, name);
            val = val && val.match(url);
            val = val && val[2];
            if (val && val.charAt() == "#") {
                val = val.substring(1);
            } else {
                return;
            }
            if (val) {
                uses[val] = (uses[val] || []).concat(function (id) {
                    var attr = {};
                    attr[name] = Snap.url(id);
                    $(it.node, attr);
                });
            }
        }
        function linktest(it) {
            var val = $(it.node, "xlink:href");
            if (val && val.charAt() == "#") {
                val = val.substring(1);
            } else {
                return;
            }
            if (val) {
                uses[val] = (uses[val] || []).concat(function (id) {
                    it.attr("xlink:href", "#" + id);
                });
            }
        }
        for (var i = 0, ii = els.length; i < ii; i++) {
            it = els[i];
            urltest(it, "fill");
            urltest(it, "stroke");
            urltest(it, "filter");
            urltest(it, "mask");
            urltest(it, "clip-path");
            linktest(it);
            var oldid = $(it.node, "id");
            if (oldid) {
                $(it.node, {id: it.id});
                ids.push({
                    old: oldid,
                    id: it.id
                });
            }
        }
        for (i = 0, ii = ids.length; i < ii; i++) {
            var fs = uses[ids[i].old];
            if (fs) {
                for (var j = 0, jj = fs.length; j < jj; j++) {
                    fs[j](ids[i].id);
                }
            }
        }
    }
    /*\
     * Element.clone
     [ method ]
     **
     * Creates a clone of the element and inserts it after the element
     **
     = (Element) the clone
    \*/
    elproto.clone = function () {
        var clone = wrap(this.node.cloneNode(true));
        if ($(clone.node, "id")) {
            $(clone.node, {id: clone.id});
        }
        fixids(clone);
        clone.insertAfter(this);
        return clone;
    };
    /*\
     * Element.toDefs
     [ method ]
     **
     * Moves element to the shared `<defs>` area
     **
     = (Element) the element
    \*/
    elproto.toDefs = function () {
        var defs = getSomeDefs(this);
        defs.appendChild(this.node);
        return this;
    };
    /*\
     * Element.toPattern
     [ method ]
     **
     * Creates a `<pattern>` element from the current element
     **
     * To create a pattern you have to specify the pattern rect:
     - x (string|number)
     - y (string|number)
     - width (string|number)
     - height (string|number)
     = (Element) the `<pattern>` element
     * You can use pattern later on as an argument for `fill` attribute:
     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
     |         fill: "none",
     |         stroke: "#bada55",
     |         strokeWidth: 5
     |     }).pattern(0, 0, 10, 10),
     |     c = paper.circle(200, 200, 100);
     | c.attr({
     |     fill: p
     | });
    \*/
    elproto.pattern = elproto.toPattern = function (x, y, width, height) {
        var p = make("pattern", getSomeDefs(this));
        if (x == null) {
            x = this.getBBox();
        }
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        $(p.node, {
            x: x,
            y: y,
            width: width,
            height: height,
            patternUnits: "userSpaceOnUse",
            id: p.id,
            viewBox: [x, y, width, height].join(" ")
        });
        p.node.appendChild(this.node);
        return p;
    };
// SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
// SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
    /*\
     * Element.marker
     [ method ]
     **
     * Creates a `<marker>` element from the current element
     **
     * To create a marker you have to specify the bounding rect and reference point:
     - x (number)
     - y (number)
     - width (number)
     - height (number)
     - refX (number)
     - refY (number)
     = (Element) the `<marker>` element
     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
    \*/
    // TODO add usage for markers
    elproto.marker = function (x, y, width, height, refX, refY) {
        var p = make("marker", getSomeDefs(this));
        if (x == null) {
            x = this.getBBox();
        }
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            refX = x.refX || x.cx;
            refY = x.refY || x.cy;
            x = x.x;
        }
        $(p.node, {
            viewBox: [x, y, width, height].join(" "),
            markerWidth: width,
            markerHeight: height,
            orient: "auto",
            refX: refX || 0,
            refY: refY || 0,
            id: p.id
        });
        p.node.appendChild(this.node);
        return p;
    };
    var eldata = {};
    /*\
     * Element.data
     [ method ]
     **
     * Adds or retrieves given value associated with given key. (Don’t confuse
     * with `data-` attributes)
     *
     * See also @Element.removeData
     - key (string) key to store data
     - value (any) #optional value to store
     = (object) @Element
     * or, if value is not specified:
     = (any) value
     > Usage
     | for (var i = 0, i < 5, i++) {
     |     paper.circle(10 + 15 * i, 10, 10)
     |          .attr({fill: "#000"})
     |          .data("i", i)
     |          .click(function () {
     |             alert(this.data("i"));
     |          });
     | }
    \*/
    elproto.data = function (key, value) {
        var data = eldata[this.id] = eldata[this.id] || {};
        if (arguments.length == 0){
            eve("snap.data.get." + this.id, this, data, null);
            return data;
        }
        if (arguments.length == 1) {
            if (Snap.is(key, "object")) {
                for (var i in key) if (key[has](i)) {
                    this.data(i, key[i]);
                }
                return this;
            }
            eve("snap.data.get." + this.id, this, data[key], key);
            return data[key];
        }
        data[key] = value;
        eve("snap.data.set." + this.id, this, value, key);
        return this;
    };
    /*\
     * Element.removeData
     [ method ]
     **
     * Removes value associated with an element by given key.
     * If key is not provided, removes all the data of the element.
     - key (string) #optional key
     = (object) @Element
    \*/
    elproto.removeData = function (key) {
        if (key == null) {
            eldata[this.id] = {};
        } else {
            eldata[this.id] && delete eldata[this.id][key];
        }
        return this;
    };
    /*\
     * Element.outerSVG
     [ method ]
     **
     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
     *
     * See also @Element.innerSVG
     = (string) SVG code for the element
    \*/
    /*\
     * Element.toString
     [ method ]
     **
     * See @Element.outerSVG
    \*/
    elproto.outerSVG = elproto.toString = toString(1);
    /*\
     * Element.innerSVG
     [ method ]
     **
     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
     = (string) SVG code for the element
    \*/
    elproto.innerSVG = toString();
    function toString(type) {
        return function () {
            var res = type ? "<" + this.type : "",
                attr = this.node.attributes,
                chld = this.node.childNodes;
            if (type) {
                for (var i = 0, ii = attr.length; i < ii; i++) {
                    res += " " + attr[i].name + '="' +
                            attr[i].value.replace(/"/g, '\\"') + '"';
                }
            }
            if (chld.length) {
                type && (res += ">");
                for (i = 0, ii = chld.length; i < ii; i++) {
                    if (chld[i].nodeType == 3) {
                        res += chld[i].nodeValue;
                    } else if (chld[i].nodeType == 1) {
                        res += wrap(chld[i]).toString();
                    }
                }
                type && (res += "</" + this.type + ">");
            } else {
                type && (res += "/>");
            }
            return res;
        };
    }
    elproto.toDataURL = function () {
        if (window && window.btoa) {
            var bb = this.getBBox(),
                svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
                x: +bb.x.toFixed(3),
                y: +bb.y.toFixed(3),
                width: +bb.width.toFixed(3),
                height: +bb.height.toFixed(3),
                contents: this.outerSVG()
            });
            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
        }
    };
    /*\
     * Fragment.select
     [ method ]
     **
     * See @Element.select
    \*/
    Fragment.prototype.select = elproto.select;
    /*\
     * Fragment.selectAll
     [ method ]
     **
     * See @Element.selectAll
    \*/
    Fragment.prototype.selectAll = elproto.selectAll;
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var objectToString = Object.prototype.toString,
        Str = String,
        math = Math,
        E = "";
    function Matrix(a, b, c, d, e, f) {
        if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
            this.a = a.a;
            this.b = a.b;
            this.c = a.c;
            this.d = a.d;
            this.e = a.e;
            this.f = a.f;
            return;
        }
        if (a != null) {
            this.a = +a;
            this.b = +b;
            this.c = +c;
            this.d = +d;
            this.e = +e;
            this.f = +f;
        } else {
            this.a = 1;
            this.b = 0;
            this.c = 0;
            this.d = 1;
            this.e = 0;
            this.f = 0;
        }
    }
    (function (matrixproto) {
        /*\
         * Matrix.add
         [ method ]
         **
         * Adds the given matrix to existing one
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/
        matrixproto.add = function (a, b, c, d, e, f) {
            if (a && a instanceof Matrix) {
                return this.add(a.a, a.b, a.c, a.d, a.e, a.f);
            }
            var aNew = a * this.a + b * this.c,
                bNew = a * this.b + b * this.d;
            this.e += e * this.a + f * this.c;
            this.f += e * this.b + f * this.d;
            this.c = c * this.a + d * this.c;
            this.d = c * this.b + d * this.d;

            this.a = aNew;
            this.b = bNew;
            return this;
        };
        /*\
         * Matrix.multLeft
         [ method ]
         **
         * Multiplies a passed affine transform to the left: M * this.
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/
        Matrix.prototype.multLeft = function (a, b, c, d, e, f) {
            if (a && a instanceof Matrix) {
                return this.multLeft(a.a, a.b, a.c, a.d, a.e, a.f);
            }
            var aNew = a * this.a + c * this.b,
                cNew = a * this.c + c * this.d,
                eNew = a * this.e + c * this.f + e;
            this.b = b * this.a + d * this.b;
            this.d = b * this.c + d * this.d;
            this.f = b * this.e + d * this.f + f;

            this.a = aNew;
            this.c = cNew;
            this.e = eNew;
            return this;
        };
        /*\
         * Matrix.invert
         [ method ]
         **
         * Returns an inverted version of the matrix
         = (object) @Matrix
        \*/
        matrixproto.invert = function () {
            var me = this,
                x = me.a * me.d - me.b * me.c;
            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
        };
        /*\
         * Matrix.clone
         [ method ]
         **
         * Returns a copy of the matrix
         = (object) @Matrix
        \*/
        matrixproto.clone = function () {
            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
        };
        /*\
         * Matrix.translate
         [ method ]
         **
         * Translate the matrix
         - x (number) horizontal offset distance
         - y (number) vertical offset distance
        \*/
        matrixproto.translate = function (x, y) {
            this.e += x * this.a + y * this.c;
            this.f += x * this.b + y * this.d;
            return this;
        };
        /*\
         * Matrix.scale
         [ method ]
         **
         * Scales the matrix
         - x (number) amount to be scaled, with `1` resulting in no change
         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
         - cx (number) #optional horizontal origin point from which to scale
         - cy (number) #optional vertical origin point from which to scale
         * Default cx, cy is the middle point of the element.
        \*/
        matrixproto.scale = function (x, y, cx, cy) {
            y == null && (y = x);
            (cx || cy) && this.translate(cx, cy);
            this.a *= x;
            this.b *= x;
            this.c *= y;
            this.d *= y;
            (cx || cy) && this.translate(-cx, -cy);
            return this;
        };
        /*\
         * Matrix.rotate
         [ method ]
         **
         * Rotates the matrix
         - a (number) angle of rotation, in degrees
         - x (number) horizontal origin point from which to rotate
         - y (number) vertical origin point from which to rotate
        \*/
        matrixproto.rotate = function (a, x, y) {
            a = Snap.rad(a);
            x = x || 0;
            y = y || 0;
            var cos = +math.cos(a).toFixed(9),
                sin = +math.sin(a).toFixed(9);
            this.add(cos, sin, -sin, cos, x, y);
            return this.add(1, 0, 0, 1, -x, -y);
        };
        /*\
         * Matrix.skewX
         [ method ]
         **
         * Skews the matrix along the x-axis
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/
        matrixproto.skewX = function (x) {
            return this.skew(x, 0);
        };
        /*\
         * Matrix.skewY
         [ method ]
         **
         * Skews the matrix along the y-axis
         - y (number) Angle to skew along the y-axis (in degrees).
        \*/
        matrixproto.skewY = function (y) {
            return this.skew(0, y);
        };
        /*\
         * Matrix.skew
         [ method ]
         **
         * Skews the matrix
         - y (number) Angle to skew along the y-axis (in degrees).
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/
        matrixproto.skew = function (x, y) {
            x = x || 0;
            y = y || 0;
            x = Snap.rad(x);
            y = Snap.rad(y);
            var c = math.tan(x).toFixed(9);
            var b = math.tan(y).toFixed(9);
            return this.add(1, b, c, 1, 0, 0);
        };
        /*\
         * Matrix.x
         [ method ]
         **
         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
         - x (number)
         - y (number)
         = (number) x
        \*/
        matrixproto.x = function (x, y) {
            return x * this.a + y * this.c + this.e;
        };
        /*\
         * Matrix.y
         [ method ]
         **
         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
         - x (number)
         - y (number)
         = (number) y
        \*/
        matrixproto.y = function (x, y) {
            return x * this.b + y * this.d + this.f;
        };
        matrixproto.get = function (i) {
            return +this[Str.fromCharCode(97 + i)].toFixed(4);
        };
        matrixproto.toString = function () {
            return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
        };
        matrixproto.offset = function () {
            return [this.e.toFixed(4), this.f.toFixed(4)];
        };
        function norm(a) {
            return a[0] * a[0] + a[1] * a[1];
        }
        function normalize(a) {
            var mag = math.sqrt(norm(a));
            a[0] && (a[0] /= mag);
            a[1] && (a[1] /= mag);
        }
        /*\
         * Matrix.determinant
         [ method ]
         **
         * Finds determinant of the given matrix.
         = (number) determinant
        \*/
        matrixproto.determinant = function () {
            return this.a * this.d - this.b * this.c;
        };
        /*\
         * Matrix.split
         [ method ]
         **
         * Splits matrix into primitive transformations
         = (object) in format:
         o dx (number) translation by x
         o dy (number) translation by y
         o scalex (number) scale by x
         o scaley (number) scale by y
         o shear (number) shear
         o rotate (number) rotation in deg
         o isSimple (boolean) could it be represented via simple transformations
        \*/
        matrixproto.split = function () {
            var out = {};
            // translation
            out.dx = this.e;
            out.dy = this.f;

            // scale and shear
            var row = [[this.a, this.b], [this.c, this.d]];
            out.scalex = math.sqrt(norm(row[0]));
            normalize(row[0]);

            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
            row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];

            out.scaley = math.sqrt(norm(row[1]));
            normalize(row[1]);
            out.shear /= out.scaley;

            if (this.determinant() < 0) {
                out.scalex = -out.scalex;
            }

            // rotation
            var sin = row[0][1],
                cos = row[1][1];
            if (cos < 0) {
                out.rotate = Snap.deg(math.acos(cos));
                if (sin < 0) {
                    out.rotate = 360 - out.rotate;
                }
            } else {
                out.rotate = Snap.deg(math.asin(sin));
            }

            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
            return out;
        };
        /*\
         * Matrix.toTransformString
         [ method ]
         **
         * Returns transform string that represents given matrix
         = (string) transform string
        \*/
        matrixproto.toTransformString = function (shorter) {
            var s = shorter || this.split();
            if (!+s.shear.toFixed(9)) {
                s.scalex = +s.scalex.toFixed(4);
                s.scaley = +s.scaley.toFixed(4);
                s.rotate = +s.rotate.toFixed(4);
                return  (s.dx || s.dy ? "t" + [+s.dx.toFixed(4), +s.dy.toFixed(4)] : E) +
                        (s.rotate ? "r" + [+s.rotate.toFixed(4), 0, 0] : E) +
                        (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E);
            } else {
                return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
            }
        };
    })(Matrix.prototype);
    /*\
     * Snap.Matrix
     [ method ]
     **
     * Matrix constructor, extend on your own risk.
     * To create matrices use @Snap.matrix.
    \*/
    Snap.Matrix = Matrix;
    /*\
     * Snap.matrix
     [ method ]
     **
     * Utility method
     **
     * Returns a matrix based on the given parameters
     - a (number)
     - b (number)
     - c (number)
     - d (number)
     - e (number)
     - f (number)
     * or
     - svgMatrix (SVGMatrix)
     = (object) @Matrix
    \*/
    Snap.matrix = function (a, b, c, d, e, f) {
        return new Matrix(a, b, c, d, e, f);
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var has = "hasOwnProperty",
        make = Snap._.make,
        wrap = Snap._.wrap,
        is = Snap.is,
        getSomeDefs = Snap._.getSomeDefs,
        reURLValue = /^url\((['"]?)([^)]+)\1\)$/,
        $ = Snap._.$,
        URL = Snap.url,
        Str = String,
        separator = Snap._.separator,
        E = "";
    /*\
     * Snap.deurl
     [ method ]
     **
     * Unwraps path from `"url(<path>)"`.
     - value (string) url path
     = (string) unwrapped path
    \*/
    Snap.deurl = function (value) {
        var res = String(value).match(reURLValue);
        return res ? res[2] : value;
    }
    // Attributes event handlers
    eve.on("snap.util.attr.mask", function (value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value.type == "mask") {
                var mask = value;
            } else {
                mask = make("mask", getSomeDefs(this));
                mask.node.appendChild(value.node);
            }
            !mask.node.id && $(mask.node, {
                id: mask.id
            });
            $(this.node, {
                mask: URL(mask.id)
            });
        }
    });
    (function (clipIt) {
        eve.on("snap.util.attr.clip", clipIt);
        eve.on("snap.util.attr.clip-path", clipIt);
        eve.on("snap.util.attr.clipPath", clipIt);
    }(function (value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            var clip,
                node = value.node;
            while (node) {
                if (node.nodeName === "clipPath") {
                    clip = new Element(node);
                    break;
                }
                if (node.nodeName === "svg") {
                    clip = undefined;
                    break;
                }
                node = node.parentNode;
            }
            if (!clip) {
                clip = make("clipPath", getSomeDefs(this));
                clip.node.appendChild(value.node);
                !clip.node.id && $(clip.node, {
                    id: clip.id
                });
            }
            $(this.node, {
                "clip-path": URL(clip.node.id || clip.id)
            });
        }
    }));
    function fillStroke(name) {
        return function (value) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1 &&
                (value.node.firstChild.tagName == "radialGradient" ||
                value.node.firstChild.tagName == "linearGradient" ||
                value.node.firstChild.tagName == "pattern")) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value instanceof Element) {
                if (value.type == "radialGradient" || value.type == "linearGradient"
                   || value.type == "pattern") {
                    if (!value.node.id) {
                        $(value.node, {
                            id: value.id
                        });
                    }
                    var fill = URL(value.node.id);
                } else {
                    fill = value.attr(name);
                }
            } else {
                fill = Snap.color(value);
                if (fill.error) {
                    var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
                    if (grad) {
                        if (!grad.node.id) {
                            $(grad.node, {
                                id: grad.id
                            });
                        }
                        fill = URL(grad.node.id);
                    } else {
                        fill = value;
                    }
                } else {
                    fill = Str(fill);
                }
            }
            var attrs = {};
            attrs[name] = fill;
            $(this.node, attrs);
            this.node.style[name] = E;
        };
    }
    eve.on("snap.util.attr.fill", fillStroke("fill"));
    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
    eve.on("snap.util.grad.parse", function parseGrad(string) {
        string = Str(string);
        var tokens = string.match(gradrg);
        if (!tokens) {
            return null;
        }
        var type = tokens[1],
            params = tokens[2],
            stops = tokens[3];
        params = params.split(/\s*,\s*/).map(function (el) {
            return +el == el ? +el : el;
        });
        if (params.length == 1 && params[0] == 0) {
            params = [];
        }
        stops = stops.split("-");
        stops = stops.map(function (el) {
            el = el.split(":");
            var out = {
                color: el[0]
            };
            if (el[1]) {
                out.offset = parseFloat(el[1]);
            }
            return out;
        });
        var len = stops.length,
            start = 0,
            j = 0;
        function seed(i, end) {
            var step = (end - start) / (i - j);
            for (var k = j; k < i; k++) {
                stops[k].offset = +(+start + step * (k - j)).toFixed(2);
            }
            j = i;
            start = end;
        }
        len--;
        for (var i = 0; i < len; i++) if ("offset" in stops[i]) {
            seed(i, stops[i].offset);
        }
        stops[len].offset = stops[len].offset || 100;
        seed(len, stops[len].offset);
        return {
            type: type,
            params: params,
            stops: stops
        };
    });

    eve.on("snap.util.attr.d", function (value) {
        eve.stop();
        if (is(value, "array") && is(value[0], "array")) {
            value = Snap.path.toString.call(value);
        }
        value = Str(value);
        if (value.match(/[ruo]/i)) {
            value = Snap.path.toAbsolute(value);
        }
        $(this.node, {d: value});
    })(-1);
    eve.on("snap.util.attr.#text", function (value) {
        eve.stop();
        value = Str(value);
        var txt = glob.doc.createTextNode(value);
        while (this.node.firstChild) {
            this.node.removeChild(this.node.firstChild);
        }
        this.node.appendChild(txt);
    })(-1);
    eve.on("snap.util.attr.path", function (value) {
        eve.stop();
        this.attr({d: value});
    })(-1);
    eve.on("snap.util.attr.class", function (value) {
        eve.stop();
        this.node.className.baseVal = value;
    })(-1);
    eve.on("snap.util.attr.viewBox", function (value) {
        var vb;
        if (is(value, "object") && "x" in value) {
            vb = [value.x, value.y, value.width, value.height].join(" ");
        } else if (is(value, "array")) {
            vb = value.join(" ");
        } else {
            vb = value;
        }
        $(this.node, {
            viewBox: vb
        });
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.transform", function (value) {
        this.transform(value);
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.r", function (value) {
        if (this.type == "rect") {
            eve.stop();
            $(this.node, {
                rx: value,
                ry: value
            });
        }
    })(-1);
    eve.on("snap.util.attr.textpath", function (value) {
        eve.stop();
        if (this.type == "text") {
            var id, tp, node;
            if (!value && this.textPath) {
                tp = this.textPath;
                while (tp.node.firstChild) {
                    this.node.appendChild(tp.node.firstChild);
                }
                tp.remove();
                delete this.textPath;
                return;
            }
            if (is(value, "string")) {
                var defs = getSomeDefs(this),
                    path = wrap(defs.parentNode).path(value);
                defs.appendChild(path.node);
                id = path.id;
                path.attr({id: id});
            } else {
                value = wrap(value);
                if (value instanceof Element) {
                    id = value.attr("id");
                    if (!id) {
                        id = value.id;
                        value.attr({id: id});
                    }
                }
            }
            if (id) {
                tp = this.textPath;
                node = this.node;
                if (tp) {
                    tp.attr({"xlink:href": "#" + id});
                } else {
                    tp = $("textPath", {
                        "xlink:href": "#" + id
                    });
                    while (node.firstChild) {
                        tp.appendChild(node.firstChild);
                    }
                    node.appendChild(tp);
                    this.textPath = wrap(tp);
                }
            }
        }
    })(-1);
    eve.on("snap.util.attr.text", function (value) {
        if (this.type == "text") {
            var i = 0,
                node = this.node,
                tuner = function (chunk) {
                    var out = $("tspan");
                    if (is(chunk, "array")) {
                        for (var i = 0; i < chunk.length; i++) {
                            out.appendChild(tuner(chunk[i]));
                        }
                    } else {
                        out.appendChild(glob.doc.createTextNode(chunk));
                    }
                    out.normalize && out.normalize();
                    return out;
                };
            while (node.firstChild) {
                node.removeChild(node.firstChild);
            }
            var tuned = tuner(value);
            while (tuned.firstChild) {
                node.appendChild(tuned.firstChild);
            }
        }
        eve.stop();
    })(-1);
    function setFontSize(value) {
        eve.stop();
        if (value == +value) {
            value += "px";
        }
        this.node.style.fontSize = value;
    }
    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
    eve.on("snap.util.attr.font-size", setFontSize)(-1);


    eve.on("snap.util.getattr.transform", function () {
        eve.stop();
        return this.transform();
    })(-1);
    eve.on("snap.util.getattr.textpath", function () {
        eve.stop();
        return this.textPath;
    })(-1);
    // Markers
    (function () {
        function getter(end) {
            return function () {
                eve.stop();
                var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
                if (style == "none") {
                    return style;
                } else {
                    return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
                }
            };
        }
        function setter(end) {
            return function (value) {
                eve.stop();
                var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
                if (value == "" || !value) {
                    this.node.style[name] = "none";
                    return;
                }
                if (value.type == "marker") {
                    var id = value.node.id;
                    if (!id) {
                        $(value.node, {id: value.id});
                    }
                    this.node.style[name] = URL(id);
                    return;
                }
            };
        }
        eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
        eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
        eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
        eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
        eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
        eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
        eve.on("snap.util.attr.marker-end", setter("end"))(-1);
        eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
        eve.on("snap.util.attr.marker-start", setter("start"))(-1);
        eve.on("snap.util.attr.markerStart", setter("start"))(-1);
        eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
        eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
    }());
    eve.on("snap.util.getattr.r", function () {
        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
            eve.stop();
            return $(this.node, "rx");
        }
    })(-1);
    function textExtract(node) {
        var out = [];
        var children = node.childNodes;
        for (var i = 0, ii = children.length; i < ii; i++) {
            var chi = children[i];
            if (chi.nodeType == 3) {
                out.push(chi.nodeValue);
            }
            if (chi.tagName == "tspan") {
                if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) {
                    out.push(chi.firstChild.nodeValue);
                } else {
                    out.push(textExtract(chi));
                }
            }
        }
        return out;
    }
    eve.on("snap.util.getattr.text", function () {
        if (this.type == "text" || this.type == "tspan") {
            eve.stop();
            var out = textExtract(this.node);
            return out.length == 1 ? out[0] : out;
        }
    })(-1);
    eve.on("snap.util.getattr.#text", function () {
        return this.node.textContent;
    })(-1);
    eve.on("snap.util.getattr.fill", function (internal) {
        if (internal) {
            return;
        }
        eve.stop();
        var value = eve("snap.util.getattr.fill", this, true).firstDefined();
        return Snap(Snap.deurl(value)) || value;
    })(-1);
    eve.on("snap.util.getattr.stroke", function (internal) {
        if (internal) {
            return;
        }
        eve.stop();
        var value = eve("snap.util.getattr.stroke", this, true).firstDefined();
        return Snap(Snap.deurl(value)) || value;
    })(-1);
    eve.on("snap.util.getattr.viewBox", function () {
        eve.stop();
        var vb = $(this.node, "viewBox");
        if (vb) {
            vb = vb.split(separator);
            return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
        } else {
            return;
        }
    })(-1);
    eve.on("snap.util.getattr.points", function () {
        var p = $(this.node, "points");
        eve.stop();
        if (p) {
            return p.split(separator);
        } else {
            return;
        }
    })(-1);
    eve.on("snap.util.getattr.path", function () {
        var p = $(this.node, "d");
        eve.stop();
        return p;
    })(-1);
    eve.on("snap.util.getattr.class", function () {
        return this.node.className.baseVal;
    })(-1);
    function getFontSize() {
        eve.stop();
        return this.node.style.fontSize;
    }
    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
});

// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var rgNotSpace = /\S+/g,
        rgBadSpace = /[\t\r\n\f]/g,
        rgTrim = /(^\s+|\s+$)/g,
        Str = String,
        elproto = Element.prototype;
    /*\
     * Element.addClass
     [ method ]
     **
     * Adds given class name or list of class names to the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/
    elproto.addClass = function (value) {
        var classes = Str(value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;

        if (classes.length) {
            j = 0;
            while (clazz = classes[j++]) {
                pos = curClasses.indexOf(clazz);
                if (!~pos) {
                    curClasses.push(clazz);
                }
            }

            finalValue = curClasses.join(" ");
            if (className != finalValue) {
                elem.className.baseVal = finalValue;
            }
        }
        return this;
    };
    /*\
     * Element.removeClass
     [ method ]
     **
     * Removes given class name or list of class names from the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/
    elproto.removeClass = function (value) {
        var classes = Str(value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;
        if (curClasses.length) {
            j = 0;
            while (clazz = classes[j++]) {
                pos = curClasses.indexOf(clazz);
                if (~pos) {
                    curClasses.splice(pos, 1);
                }
            }

            finalValue = curClasses.join(" ");
            if (className != finalValue) {
                elem.className.baseVal = finalValue;
            }
        }
        return this;
    };
    /*\
     * Element.hasClass
     [ method ]
     **
     * Checks if the element has a given class name in the list of class names applied to it.
     - value (string) class name
     **
     = (boolean) `true` if the element has given class
    \*/
    elproto.hasClass = function (value) {
        var elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [];
        return !!~curClasses.indexOf(value);
    };
    /*\
     * Element.toggleClass
     [ method ]
     **
     * Add or remove one or more classes from the element, depending on either
     * the class’s presence or the value of the `flag` argument.
     - value (string) class name or space separated list of class names
     - flag (boolean) value to determine whether the class should be added or removed
     **
     = (Element) original element.
    \*/
    elproto.toggleClass = function (value, flag) {
        if (flag != null) {
            if (flag) {
                return this.addClass(value);
            } else {
                return this.removeClass(value);
            }
        }
        var classes = (value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;
        j = 0;
        while (clazz = classes[j++]) {
            pos = curClasses.indexOf(clazz);
            if (~pos) {
                curClasses.splice(pos, 1);
            } else {
                curClasses.push(clazz);
            }
        }

        finalValue = curClasses.join(" ");
        if (className != finalValue) {
            elem.className.baseVal = finalValue;
        }
        return this;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var operators = {
            "+": function (x, y) {
                    return x + y;
                },
            "-": function (x, y) {
                    return x - y;
                },
            "/": function (x, y) {
                    return x / y;
                },
            "*": function (x, y) {
                    return x * y;
                }
        },
        Str = String,
        reUnit = /[a-z]+$/i,
        reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function (val) {
            return +val.toFixed(3) + unit;
        };
    }
    eve.on("snap.util.attr", function (val) {
        var plus = Str(val).match(reAddon);
        if (plus) {
            var evnt = eve.nt(),
                name = evnt.substring(evnt.lastIndexOf(".") + 1),
                a = this.attr(name),
                atr = {};
            eve.stop();
            var unit = plus[3] || "",
                aUnit = a.match(reUnit),
                op = operators[plus[1]];
            if (aUnit && aUnit == unit) {
                val = op(parseFloat(a), +plus[2]);
            } else {
                a = this.asPX(name);
                val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
            }
            if (isNaN(a) || isNaN(val)) {
                return;
            }
            atr[name] = val;
            this.attr(atr);
        }
    })(-10);
    eve.on("snap.util.equal", function (name, b) {
        var A, B, a = Str(this.attr(name) || ""),
            el = this,
            bplus = Str(b).match(reAddon);
        if (bplus) {
            eve.stop();
            var unit = bplus[3] || "",
                aUnit = a.match(reUnit),
                op = operators[bplus[1]];
            if (aUnit && aUnit == unit) {
                return {
                    from: parseFloat(a),
                    to: op(parseFloat(a), +bplus[2]),
                    f: getUnit(aUnit)
                };
            } else {
                a = this.asPX(name);
                return {
                    from: a,
                    to: op(a, this.asPX(name, bplus[2] + unit)),
                    f: getNumber
                };
            }
        }
    })(-10);
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var proto = Paper.prototype,
        is = Snap.is;
    /*\
     * Paper.rect
     [ method ]
     *
     * Draws a rectangle
     **
     - x (number) x coordinate of the top left corner
     - y (number) y coordinate of the top left corner
     - width (number) width
     - height (number) height
     - rx (number) #optional horizontal radius for rounded corners, default is 0
     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
     = (object) the `rect` element
     **
     > Usage
     | // regular rectangle
     | var c = paper.rect(10, 10, 50, 50);
     | // rectangle with rounded corners
     | var c = paper.rect(40, 40, 50, 50, 10);
    \*/
    proto.rect = function (x, y, w, h, rx, ry) {
        var attr;
        if (ry == null) {
            ry = rx;
        }
        if (is(x, "object") && x == "[object Object]") {
            attr = x;
        } else if (x != null) {
            attr = {
                x: x,
                y: y,
                width: w,
                height: h
            };
            if (rx != null) {
                attr.rx = rx;
                attr.ry = ry;
            }
        }
        return this.el("rect", attr);
    };
    /*\
     * Paper.circle
     [ method ]
     **
     * Draws a circle
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - r (number) radius
     = (object) the `circle` element
     **
     > Usage
     | var c = paper.circle(50, 50, 40);
    \*/
    proto.circle = function (cx, cy, r) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") {
            attr = cx;
        } else if (cx != null) {
            attr = {
                cx: cx,
                cy: cy,
                r: r
            };
        }
        return this.el("circle", attr);
    };

    var preload = (function () {
        function onerror() {
            this.parentNode.removeChild(this);
        }
        return function (src, f) {
            var img = glob.doc.createElement("img"),
                body = glob.doc.body;
            img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
            img.onload = function () {
                f.call(img);
                img.onload = img.onerror = null;
                body.removeChild(img);
            };
            img.onerror = onerror;
            body.appendChild(img);
            img.src = src;
        };
    }());

    /*\
     * Paper.image
     [ method ]
     **
     * Places an image on the surface
     **
     - src (string) URI of the source image
     - x (number) x offset position
     - y (number) y offset position
     - width (number) width of the image
     - height (number) height of the image
     = (object) the `image` element
     * or
     = (object) Snap element object with type `image`
     **
     > Usage
     | var c = paper.image("apple.png", 10, 10, 80, 80);
    \*/
    proto.image = function (src, x, y, width, height) {
        var el = this.el("image");
        if (is(src, "object") && "src" in src) {
            el.attr(src);
        } else if (src != null) {
            var set = {
                "xlink:href": src,
                preserveAspectRatio: "none"
            };
            if (x != null && y != null) {
                set.x = x;
                set.y = y;
            }
            if (width != null && height != null) {
                set.width = width;
                set.height = height;
            } else {
                preload(src, function () {
                    Snap._.$(el.node, {
                        width: this.offsetWidth,
                        height: this.offsetHeight
                    });
                });
            }
            Snap._.$(el.node, set);
        }
        return el;
    };
    /*\
     * Paper.ellipse
     [ method ]
     **
     * Draws an ellipse
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - rx (number) horizontal radius
     - ry (number) vertical radius
     = (object) the `ellipse` element
     **
     > Usage
     | var c = paper.ellipse(50, 50, 40, 20);
    \*/
    proto.ellipse = function (cx, cy, rx, ry) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") {
            attr = cx;
        } else if (cx != null) {
            attr ={
                cx: cx,
                cy: cy,
                rx: rx,
                ry: ry
            };
        }
        return this.el("ellipse", attr);
    };
    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
    /*\
     * Paper.path
     [ method ]
     **
     * Creates a `<path>` element using the given string as the path's definition
     - pathString (string) #optional path string in SVG format
     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
     | "M10,20L30,40"
     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
     *
     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
     > Usage
     | var c = paper.path("M10 10L90 90");
     | // draw a diagonal line:
     | // move to 10,10, line to 90,90
    \*/
    proto.path = function (d) {
        var attr;
        if (is(d, "object") && !is(d, "array")) {
            attr = d;
        } else if (d) {
            attr = {d: d};
        }
        return this.el("path", attr);
    };
    /*\
     * Paper.g
     [ method ]
     **
     * Creates a group element
     **
     - varargs (…) #optional elements to nest within the group
     = (object) the `g` element
     **
     > Usage
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g(c2, c1); // note that the order of elements is different
     * or
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g();
     | g.add(c2, c1);
    \*/
    /*\
     * Paper.group
     [ method ]
     **
     * See @Paper.g
    \*/
    proto.group = proto.g = function (first) {
        var attr,
            el = this.el("g");
        if (arguments.length == 1 && first && !first.type) {
            el.attr(first);
        } else if (arguments.length) {
            el.add(Array.prototype.slice.call(arguments, 0));
        }
        return el;
    };
    /*\
     * Paper.svg
     [ method ]
     **
     * Creates a nested SVG element.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `svg` element
     **
    \*/
    proto.svg = function (x, y, width, height, vbx, vby, vbw, vbh) {
        var attrs = {};
        if (is(x, "object") && y == null) {
            attrs = x;
        } else {
            if (x != null) {
                attrs.x = x;
            }
            if (y != null) {
                attrs.y = y;
            }
            if (width != null) {
                attrs.width = width;
            }
            if (height != null) {
                attrs.height = height;
            }
            if (vbx != null && vby != null && vbw != null && vbh != null) {
                attrs.viewBox = [vbx, vby, vbw, vbh];
            }
        }
        return this.el("svg", attrs);
    };
    /*\
     * Paper.mask
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a mask.
     **
     = (object) the `mask` element
     **
    \*/
    proto.mask = function (first) {
        var attr,
            el = this.el("mask");
        if (arguments.length == 1 && first && !first.type) {
            el.attr(first);
        } else if (arguments.length) {
            el.add(Array.prototype.slice.call(arguments, 0));
        }
        return el;
    };
    /*\
     * Paper.ptrn
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `pattern` element
     **
    \*/
    proto.ptrn = function (x, y, width, height, vx, vy, vw, vh) {
        if (is(x, "object")) {
            var attr = x;
        } else {
            attr = {patternUnits: "userSpaceOnUse"};
            if (x) {
                attr.x = x;
            }
            if (y) {
                attr.y = y;
            }
            if (width != null) {
                attr.width = width;
            }
            if (height != null) {
                attr.height = height;
            }
            if (vx != null && vy != null && vw != null && vh != null) {
                attr.viewBox = [vx, vy, vw, vh];
            } else {
                attr.viewBox = [x || 0, y || 0, width || 0, height || 0];
            }
        }
        return this.el("pattern", attr);
    };
    /*\
     * Paper.use
     [ method ]
     **
     * Creates a <use> element.
     - id (string) @optional id of element to link
     * or
     - id (Element) @optional element to link
     **
     = (object) the `use` element
     **
    \*/
    proto.use = function (id) {
        if (id != null) {
            if (id instanceof Element) {
                if (!id.attr("id")) {
                    id.attr({id: Snap._.id(id)});
                }
                id = id.attr("id");
            }
            if (String(id).charAt() == "#") {
                id = id.substring(1);
            }
            return this.el("use", {"xlink:href": "#" + id});
        } else {
            return Element.prototype.use.call(this);
        }
    };
    /*\
     * Paper.symbol
     [ method ]
     **
     * Creates a <symbol> element.
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     = (object) the `symbol` element
     **
    \*/
    proto.symbol = function (vx, vy, vw, vh) {
        var attr = {};
        if (vx != null && vy != null && vw != null && vh != null) {
            attr.viewBox = [vx, vy, vw, vh];
        }

        return this.el("symbol", attr);
    };
    /*\
     * Paper.text
     [ method ]
     **
     * Draws a text string
     **
     - x (number) x coordinate position
     - y (number) y coordinate position
     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
     = (object) the `text` element
     **
     > Usage
     | var t1 = paper.text(50, 50, "Snap");
     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
     | // Text path usage
     | t1.attr({textpath: "M10,10L100,100"});
     | // or
     | var pth = paper.path("M10,10L100,100");
     | t1.attr({textpath: pth});
    \*/
    proto.text = function (x, y, text) {
        var attr = {};
        if (is(x, "object")) {
            attr = x;
        } else if (x != null) {
            attr = {
                x: x,
                y: y,
                text: text || ""
            };
        }
        return this.el("text", attr);
    };
    /*\
     * Paper.line
     [ method ]
     **
     * Draws a line
     **
     - x1 (number) x coordinate position of the start
     - y1 (number) y coordinate position of the start
     - x2 (number) x coordinate position of the end
     - y2 (number) y coordinate position of the end
     = (object) the `line` element
     **
     > Usage
     | var t1 = paper.line(50, 50, 100, 100);
    \*/
    proto.line = function (x1, y1, x2, y2) {
        var attr = {};
        if (is(x1, "object")) {
            attr = x1;
        } else if (x1 != null) {
            attr = {
                x1: x1,
                x2: x2,
                y1: y1,
                y2: y2
            };
        }
        return this.el("line", attr);
    };
    /*\
     * Paper.polyline
     [ method ]
     **
     * Draws a polyline
     **
     - points (array) array of points
     * or
     - varargs (…) points
     = (object) the `polyline` element
     **
     > Usage
     | var p1 = paper.polyline([10, 10, 100, 100]);
     | var p2 = paper.polyline(10, 10, 100, 100);
    \*/
    proto.polyline = function (points) {
        if (arguments.length > 1) {
            points = Array.prototype.slice.call(arguments, 0);
        }
        var attr = {};
        if (is(points, "object") && !is(points, "array")) {
            attr = points;
        } else if (points != null) {
            attr = {points: points};
        }
        return this.el("polyline", attr);
    };
    /*\
     * Paper.polygon
     [ method ]
     **
     * Draws a polygon. See @Paper.polyline
    \*/
    proto.polygon = function (points) {
        if (arguments.length > 1) {
            points = Array.prototype.slice.call(arguments, 0);
        }
        var attr = {};
        if (is(points, "object") && !is(points, "array")) {
            attr = points;
        } else if (points != null) {
            attr = {points: points};
        }
        return this.el("polygon", attr);
    };
    // gradients
    (function () {
        var $ = Snap._.$;
        // gradients' helpers
        /*\
         * Element.stops
         [ method ]
         **
         * Only for gradients!
         * Returns array of gradient stops elements.
         = (array) the stops array.
        \*/
        function Gstops() {
            return this.selectAll("stop");
        }
        /*\
         * Element.addStop
         [ method ]
         **
         * Only for gradients!
         * Adds another stop to the gradient.
         - color (string) stops color
         - offset (number) stops offset 0..100
         = (object) gradient element
        \*/
        function GaddStop(color, offset) {
            var stop = $("stop"),
                attr = {
                    offset: +offset + "%"
                };
            color = Snap.color(color);
            attr["stop-color"] = color.hex;
            if (color.opacity < 1) {
                attr["stop-opacity"] = color.opacity;
            }
            $(stop, attr);
            var stops = this.stops(),
                inserted;
            for (var i = 0; i < stops.length; i++) {
                var stopOffset = parseFloat(stops[i].attr("offset"));
                if (stopOffset > offset) {
                    this.node.insertBefore(stop, stops[i].node);
                    inserted = true;
                    break;
                }
            }
            if (!inserted) {
                this.node.appendChild(stop);
            }
            return this;
        }
        function GgetBBox() {
            if (this.type == "linearGradient") {
                var x1 = $(this.node, "x1") || 0,
                    x2 = $(this.node, "x2") || 1,
                    y1 = $(this.node, "y1") || 0,
                    y2 = $(this.node, "y2") || 0;
                return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
            } else {
                var cx = this.node.cx || .5,
                    cy = this.node.cy || .5,
                    r = this.node.r || 0;
                return Snap._.box(cx - r, cy - r, r * 2, r * 2);
            }
        }
        /*\
         * Element.setStops
         [ method ]
         **
         * Only for gradients!
         * Updates stops of the gradient based on passed gradient descriptor. See @Ppaer.gradient
         - str (string) gradient descriptor part after `()`.
         = (object) gradient element
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         | g.setStops("#fff-#000-#f00-#fc0");
        \*/
        function GsetStops(str) {
            var grad = str,
                stops = this.stops();
            if (typeof str == "string") {
                grad = eve("snap.util.grad.parse", null, "l(0,0,0,1)" + str).firstDefined().stops;
            }
            if (!Snap.is(grad, "array")) {
                return;
            }
            for (var i = 0; i < stops.length; i++) {
                if (grad[i]) {
                    var color = Snap.color(grad[i].color),
                        attr = {"offset": grad[i].offset + "%"};
                    attr["stop-color"] = color.hex;
                    if (color.opacity < 1) {
                        attr["stop-opacity"] = color.opacity;
                    }
                    stops[i].attr(attr);
                } else {
                    stops[i].remove();
                }
            }
            for (i = stops.length; i < grad.length; i++) {
                this.addStop(grad[i].color, grad[i].offset);
            }
            return this;
        }
        function gradient(defs, str) {
            var grad = eve("snap.util.grad.parse", null, str).firstDefined(),
                el;
            if (!grad) {
                return null;
            }
            grad.params.unshift(defs);
            if (grad.type.toLowerCase() == "l") {
                el = gradientLinear.apply(0, grad.params);
            } else {
                el = gradientRadial.apply(0, grad.params);
            }
            if (grad.type != grad.type.toLowerCase()) {
                $(el.node, {
                    gradientUnits: "userSpaceOnUse"
                });
            }
            var stops = grad.stops,
                len = stops.length;
            for (var i = 0; i < len; i++) {
                var stop = stops[i];
                el.addStop(stop.color, stop.offset);
            }
            return el;
        }
        function gradientLinear(defs, x1, y1, x2, y2) {
            var el = Snap._.make("linearGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            el.setStops = GsetStops;
            if (x1 != null) {
                $(el.node, {
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                });
            }
            return el;
        }
        function gradientRadial(defs, cx, cy, r, fx, fy) {
            var el = Snap._.make("radialGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            if (cx != null) {
                $(el.node, {
                    cx: cx,
                    cy: cy,
                    r: r
                });
            }
            if (fx != null && fy != null) {
                $(el.node, {
                    fx: fx,
                    fy: fy
                });
            }
            return el;
        }
        /*\
         * Paper.gradient
         [ method ]
         **
         * Creates a gradient element
         **
         - gradient (string) gradient descriptor
         > Gradient Descriptor
         * The gradient descriptor is an expression formatted as
         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
         * either linear or radial.  The uppercase `L` or `R` letters
         * indicate absolute coordinates offset from the SVG surface.
         * Lowercase `l` or `r` letters indicate coordinates
         * calculated relative to the element to which the gradient is
         * applied.  Coordinates specify a linear gradient vector as
         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
         * `r` and optional `fx`, `fy` specifying a focal point away
         * from the center of the circle. Specify `<colors>` as a list
         * of dash-separated CSS color values.  Each color may be
         * followed by a custom offset value, separated with a colon
         * character.
         > Examples
         * Linear gradient, relative from top-left corner to bottom-right
         * corner, from black through red to white:
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         * Linear gradient, absolute from (0, 0) to (100, 100), from black
         * through red at 25% to white:
         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
         * Radial gradient, relative from the center of the element with radius
         * half the width, from black to white:
         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
         * To apply the gradient:
         | paper.circle(50, 50, 40).attr({
         |     fill: g
         | });
         = (object) the `gradient` element
        \*/
        proto.gradient = function (str) {
            return gradient(this.defs, str);
        };
        proto.gradientLinear = function (x1, y1, x2, y2) {
            return gradientLinear(this.defs, x1, y1, x2, y2);
        };
        proto.gradientRadial = function (cx, cy, r, fx, fy) {
            return gradientRadial(this.defs, cx, cy, r, fx, fy);
        };
        /*\
         * Paper.toString
         [ method ]
         **
         * Returns SVG code for the @Paper
         = (string) SVG code for the @Paper
        \*/
        proto.toString = function () {
            var doc = this.node.ownerDocument,
                f = doc.createDocumentFragment(),
                d = doc.createElement("div"),
                svg = this.node.cloneNode(true),
                res;
            f.appendChild(d);
            d.appendChild(svg);
            Snap._.$(svg, {xmlns: "http://www.w3.org/2000/svg"});
            res = d.innerHTML;
            f.removeChild(f.firstChild);
            return res;
        };
        /*\
         * Paper.toDataURL
         [ method ]
         **
         * Returns SVG code for the @Paper as Data URI string.
         = (string) Data URI string
        \*/
        proto.toDataURL = function () {
            if (window && window.btoa) {
                return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
            }
        };
        /*\
         * Paper.clear
         [ method ]
         **
         * Removes all child nodes of the paper, except <defs>.
        \*/
        proto.clear = function () {
            var node = this.node.firstChild,
                next;
            while (node) {
                next = node.nextSibling;
                if (node.tagName != "defs") {
                    node.parentNode.removeChild(node);
                } else {
                    proto.clear.call({node: node});
                }
                node = next;
            }
        };
    }());
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
        is = Snap.is,
        clone = Snap._.clone,
        has = "hasOwnProperty",
        p2s = /,?([a-z]),?/gi,
        toFloat = parseFloat,
        math = Math,
        PI = math.PI,
        mmin = math.min,
        mmax = math.max,
        pow = math.pow,
        abs = math.abs;
    function paths(ps) {
        var p = paths.ps = paths.ps || {};
        if (p[ps]) {
            p[ps].sleep = 100;
        } else {
            p[ps] = {
                sleep: 100
            };
        }
        setTimeout(function () {
            for (var key in p) if (p[has](key) && key != ps) {
                p[key].sleep--;
                !p[key].sleep && delete p[key];
            }
        });
        return p[ps];
    }
    function box(x, y, width, height) {
        if (x == null) {
            x = y = width = height = 0;
        }
        if (y == null) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        return {
            x: x,
            y: y,
            width: width,
            w: width,
            height: height,
            h: height,
            x2: x + width,
            y2: y + height,
            cx: x + width / 2,
            cy: y + height / 2,
            r1: math.min(width, height) / 2,
            r2: math.max(width, height) / 2,
            r0: math.sqrt(width * width + height * height) / 2,
            path: rectPath(x, y, width, height),
            vb: [x, y, width, height].join(" ")
        };
    }
    function toString() {
        return this.join(",").replace(p2s, "$1");
    }
    function pathClone(pathArray) {
        var res = clone(pathArray);
        res.toString = toString;
        return res;
    }
    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
        if (length == null) {
            return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
        } else {
            return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y,
                getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
        }
    }
    function getLengthFactory(istotal, subpath) {
        function O(val) {
            return +(+val).toFixed(3);
        }
        return Snap._.cacher(function (path, length, onlystart) {
            if (path instanceof Element) {
                path = path.attr("d");
            }
            path = path2curve(path);
            var x, y, p, l, sp = "", subpaths = {}, point,
                len = 0;
            for (var i = 0, ii = path.length; i < ii; i++) {
                p = path[i];
                if (p[0] == "M") {
                    x = +p[1];
                    y = +p[2];
                } else {
                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                    if (len + l > length) {
                        if (subpath && !subpaths.start) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            sp += [
                                "C" + O(point.start.x),
                                O(point.start.y),
                                O(point.m.x),
                                O(point.m.y),
                                O(point.x),
                                O(point.y)
                            ];
                            if (onlystart) {return sp;}
                            subpaths.start = sp;
                            sp = [
                                "M" + O(point.x),
                                O(point.y) + "C" + O(point.n.x),
                                O(point.n.y),
                                O(point.end.x),
                                O(point.end.y),
                                O(p[5]),
                                O(p[6])
                            ].join();
                            len += l;
                            x = +p[5];
                            y = +p[6];
                            continue;
                        }
                        if (!istotal && !subpath) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            return point;
                        }
                    }
                    len += l;
                    x = +p[5];
                    y = +p[6];
                }
                sp += p.shift() + p;
            }
            subpaths.end = sp;
            point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
            return point;
        }, null, Snap._.clone);
    }
    var getTotalLength = getLengthFactory(1),
        getPointAtLength = getLengthFactory(),
        getSubpathsAtLength = getLengthFactory(0, 1);
    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t,
            t13 = pow(t1, 3),
            t12 = pow(t1, 2),
            t2 = t * t,
            t3 = t2 * t,
            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
            ax = t1 * p1x + t * c1x,
            ay = t1 * p1y + t * c1y,
            cx = t1 * c2x + t * p2x,
            cy = t1 * c2y + t * p2y,
            alpha = 90 - math.atan2(mx - nx, my - ny) * 180 / PI;
        // (mx > nx || my < ny) && (alpha += 180);
        return {
            x: x,
            y: y,
            m: {x: mx, y: my},
            n: {x: nx, y: ny},
            start: {x: ax, y: ay},
            end: {x: cx, y: cy},
            alpha: alpha
        };
    }
    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
        if (!Snap.is(p1x, "array")) {
            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
        }
        var bbox = curveDim.apply(null, p1x);
        return box(
            bbox.min.x,
            bbox.min.y,
            bbox.max.x - bbox.min.x,
            bbox.max.y - bbox.min.y
        );
    }
    function isPointInsideBBox(bbox, x, y) {
        return  x >= bbox.x &&
                x <= bbox.x + bbox.width &&
                y >= bbox.y &&
                y <= bbox.y + bbox.height;
    }
    function isBBoxIntersect(bbox1, bbox2) {
        bbox1 = box(bbox1);
        bbox2 = box(bbox2);
        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y)
            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y)
            || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2)
            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2)
            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y)
            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y)
            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2)
            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2)
            || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x
                || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x)
            && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y
                || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
    }
    function base3(t, p1, p2, p3, p4) {
        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
            t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
        return t * t2 - 3 * p1 + 3 * p2;
    }
    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
        if (z == null) {
            z = 1;
        }
        z = z > 1 ? 1 : z < 0 ? 0 : z;
        var z2 = z / 2,
            n = 12,
            Tvalues = [-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],
            Cvalues = [0.2491,0.2491,0.2335,0.2335,0.2032,0.2032,0.1601,0.1601,0.1069,0.1069,0.0472,0.0472],
            sum = 0;
        for (var i = 0; i < n; i++) {
            var ct = z2 * Tvalues[i] + z2,
                xbase = base3(ct, x1, x2, x3, x4),
                ybase = base3(ct, y1, y2, y3, y4),
                comb = xbase * xbase + ybase * ybase;
            sum += Cvalues[i] * math.sqrt(comb);
        }
        return z2 * sum;
    }
    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
            return;
        }
        var t = 1,
            step = t / 2,
            t2 = t - step,
            l,
            e = .01;
        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        while (abs(l - ll) > e) {
            step /= 2;
            t2 += (l < ll ? 1 : -1) * step;
            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        }
        return t2;
    }
    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
        if (
            mmax(x1, x2) < mmin(x3, x4) ||
            mmin(x1, x2) > mmax(x3, x4) ||
            mmax(y1, y2) < mmin(y3, y4) ||
            mmin(y1, y2) > mmax(y3, y4)
        ) {
            return;
        }
        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);

        if (!denominator) {
            return;
        }
        var px = nx / denominator,
            py = ny / denominator,
            px2 = +px.toFixed(2),
            py2 = +py.toFixed(2);
        if (
            px2 < +mmin(x1, x2).toFixed(2) ||
            px2 > +mmax(x1, x2).toFixed(2) ||
            px2 < +mmin(x3, x4).toFixed(2) ||
            px2 > +mmax(x3, x4).toFixed(2) ||
            py2 < +mmin(y1, y2).toFixed(2) ||
            py2 > +mmax(y1, y2).toFixed(2) ||
            py2 < +mmin(y3, y4).toFixed(2) ||
            py2 > +mmax(y3, y4).toFixed(2)
        ) {
            return;
        }
        return {x: px, y: py};
    }
    function inter(bez1, bez2) {
        return interHelper(bez1, bez2);
    }
    function interCount(bez1, bez2) {
        return interHelper(bez1, bez2, 1);
    }
    function interHelper(bez1, bez2, justCount) {
        var bbox1 = bezierBBox(bez1),
            bbox2 = bezierBBox(bez2);
        if (!isBBoxIntersect(bbox1, bbox2)) {
            return justCount ? 0 : [];
        }
        var l1 = bezlen.apply(0, bez1),
            l2 = bezlen.apply(0, bez2),
            n1 = ~~(l1 / 8),
            n2 = ~~(l2 / 8),
            dots1 = [],
            dots2 = [],
            xy = {},
            res = justCount ? 0 : [];
        for (var i = 0; i < n1 + 1; i++) {
            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
            dots1.push({x: p.x, y: p.y, t: i / n1});
        }
        for (i = 0; i < n2 + 1; i++) {
            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
            dots2.push({x: p.x, y: p.y, t: i / n2});
        }
        for (i = 0; i < n1; i++) {
            for (var j = 0; j < n2; j++) {
                var di = dots1[i],
                    di1 = dots1[i + 1],
                    dj = dots2[j],
                    dj1 = dots2[j + 1],
                    ci = abs(di1.x - di.x) < .001 ? "y" : "x",
                    cj = abs(dj1.x - dj.x) < .001 ? "y" : "x",
                    is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
                if (is) {
                    if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
                        continue;
                    }
                    xy[is.x.toFixed(4)] = is.y.toFixed(4);
                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
                    if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
                        if (justCount) {
                            res++;
                        } else {
                            res.push({
                                x: is.x,
                                y: is.y,
                                t1: t1,
                                t2: t2
                            });
                        }
                    }
                }
            }
        }
        return res;
    }
    function pathIntersection(path1, path2) {
        return interPathHelper(path1, path2);
    }
    function pathIntersectionNumber(path1, path2) {
        return interPathHelper(path1, path2, 1);
    }
    function interPathHelper(path1, path2, justCount) {
        path1 = path2curve(path1);
        path2 = path2curve(path2);
        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2,
            res = justCount ? 0 : [];
        for (var i = 0, ii = path1.length; i < ii; i++) {
            var pi = path1[i];
            if (pi[0] == "M") {
                x1 = x1m = pi[1];
                y1 = y1m = pi[2];
            } else {
                if (pi[0] == "C") {
                    bez1 = [x1, y1].concat(pi.slice(1));
                    x1 = bez1[6];
                    y1 = bez1[7];
                } else {
                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
                    x1 = x1m;
                    y1 = y1m;
                }
                for (var j = 0, jj = path2.length; j < jj; j++) {
                    var pj = path2[j];
                    if (pj[0] == "M") {
                        x2 = x2m = pj[1];
                        y2 = y2m = pj[2];
                    } else {
                        if (pj[0] == "C") {
                            bez2 = [x2, y2].concat(pj.slice(1));
                            x2 = bez2[6];
                            y2 = bez2[7];
                        } else {
                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
                            x2 = x2m;
                            y2 = y2m;
                        }
                        var intr = interHelper(bez1, bez2, justCount);
                        if (justCount) {
                            res += intr;
                        } else {
                            for (var k = 0, kk = intr.length; k < kk; k++) {
                                intr[k].segment1 = i;
                                intr[k].segment2 = j;
                                intr[k].bez1 = bez1;
                                intr[k].bez2 = bez2;
                            }
                            res = res.concat(intr);
                        }
                    }
                }
            }
        }
        return res;
    }
    function isPointInsidePath(path, x, y) {
        var bbox = pathBBox(path);
        return isPointInsideBBox(bbox, x, y) &&
               interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
    }
    function pathBBox(path) {
        var pth = paths(path);
        if (pth.bbox) {
            return clone(pth.bbox);
        }
        if (!path) {
            return box();
        }
        path = path2curve(path);
        var x = 0,
            y = 0,
            X = [],
            Y = [],
            p;
        for (var i = 0, ii = path.length; i < ii; i++) {
            p = path[i];
            if (p[0] == "M") {
                x = p[1];
                y = p[2];
                X.push(x);
                Y.push(y);
            } else {
                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                X = X.concat(dim.min.x, dim.max.x);
                Y = Y.concat(dim.min.y, dim.max.y);
                x = p[5];
                y = p[6];
            }
        }
        var xmin = mmin.apply(0, X),
            ymin = mmin.apply(0, Y),
            xmax = mmax.apply(0, X),
            ymax = mmax.apply(0, Y),
            bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
        pth.bbox = clone(bb);
        return bb;
    }
    function rectPath(x, y, w, h, r) {
        if (r) {
            return [
                ["M", +x + +r, y],
                ["l", w - r * 2, 0],
                ["a", r, r, 0, 0, 1, r, r],
                ["l", 0, h - r * 2],
                ["a", r, r, 0, 0, 1, -r, r],
                ["l", r * 2 - w, 0],
                ["a", r, r, 0, 0, 1, -r, -r],
                ["l", 0, r * 2 - h],
                ["a", r, r, 0, 0, 1, r, -r],
                ["z"]
            ];
        }
        var res = [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
        res.toString = toString;
        return res;
    }
    function ellipsePath(x, y, rx, ry, a) {
        if (a == null && ry == null) {
            ry = rx;
        }
        x = +x;
        y = +y;
        rx = +rx;
        ry = +ry;
        if (a != null) {
            var rad = Math.PI / 180,
                x1 = x + rx * Math.cos(-ry * rad),
                x2 = x + rx * Math.cos(-a * rad),
                y1 = y + rx * Math.sin(-ry * rad),
                y2 = y + rx * Math.sin(-a * rad),
                res = [["M", x1, y1], ["A", rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
        } else {
            res = [
                ["M", x, y],
                ["m", 0, -ry],
                ["a", rx, ry, 0, 1, 1, 0, 2 * ry],
                ["a", rx, ry, 0, 1, 1, 0, -2 * ry],
                ["z"]
            ];
        }
        res.toString = toString;
        return res;
    }
    var unit2px = Snap._unit2px,
        getPath = {
        path: function (el) {
            return el.attr("path");
        },
        circle: function (el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx, attr.cy, attr.r);
        },
        ellipse: function (el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
        },
        rect: function (el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
        },
        image: function (el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
        },
        line: function (el) {
            return "M" + [el.attr("x1") || 0, el.attr("y1") || 0, el.attr("x2"), el.attr("y2")];
        },
        polyline: function (el) {
            return "M" + el.attr("points");
        },
        polygon: function (el) {
            return "M" + el.attr("points") + "z";
        },
        deflt: function (el) {
            var bbox = el.node.getBBox();
            return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
        }
    };
    function pathToRelative(pathArray) {
        var pth = paths(pathArray),
            lowerCase = String.prototype.toLowerCase;
        if (pth.rel) {
            return pathClone(pth.rel);
        }
        if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) {
            pathArray = Snap.parsePathString(pathArray);
        }
        var res = [],
            x = 0,
            y = 0,
            mx = 0,
            my = 0,
            start = 0;
        if (pathArray[0][0] == "M") {
            x = pathArray[0][1];
            y = pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res.push(["M", x, y]);
        }
        for (var i = start, ii = pathArray.length; i < ii; i++) {
            var r = res[i] = [],
                pa = pathArray[i];
            if (pa[0] != lowerCase.call(pa[0])) {
                r[0] = lowerCase.call(pa[0]);
                switch (r[0]) {
                    case "a":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +(pa[6] - x).toFixed(3);
                        r[7] = +(pa[7] - y).toFixed(3);
                        break;
                    case "v":
                        r[1] = +(pa[1] - y).toFixed(3);
                        break;
                    case "m":
                        mx = pa[1];
                        my = pa[2];
                    default:
                        for (var j = 1, jj = pa.length; j < jj; j++) {
                            r[j] = +(pa[j] - (j % 2 ? x : y)).toFixed(3);
                        }
                }
            } else {
                r = res[i] = [];
                if (pa[0] == "m") {
                    mx = pa[1] + x;
                    my = pa[2] + y;
                }
                for (var k = 0, kk = pa.length; k < kk; k++) {
                    res[i][k] = pa[k];
                }
            }
            var len = res[i].length;
            switch (res[i][0]) {
                case "z":
                    x = mx;
                    y = my;
                    break;
                case "h":
                    x += +res[i][len - 1];
                    break;
                case "v":
                    y += +res[i][len - 1];
                    break;
                default:
                    x += +res[i][len - 2];
                    y += +res[i][len - 1];
            }
        }
        res.toString = toString;
        pth.rel = pathClone(res);
        return res;
    }
    function pathToAbsolute(pathArray) {
        var pth = paths(pathArray);
        if (pth.abs) {
            return pathClone(pth.abs);
        }
        if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) { // rough assumption
            pathArray = Snap.parsePathString(pathArray);
        }
        if (!pathArray || !pathArray.length) {
            return [["M", 0, 0]];
        }
        var res = [],
            x = 0,
            y = 0,
            mx = 0,
            my = 0,
            start = 0,
            pa0;
        if (pathArray[0][0] == "M") {
            x = +pathArray[0][1];
            y = +pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res[0] = ["M", x, y];
        }
        var crz = pathArray.length == 3 &&
            pathArray[0][0] == "M" &&
            pathArray[1][0].toUpperCase() == "R" &&
            pathArray[2][0].toUpperCase() == "Z";
        for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
            res.push(r = []);
            pa = pathArray[i];
            pa0 = pa[0];
            if (pa0 != pa0.toUpperCase()) {
                r[0] = pa0.toUpperCase();
                switch (r[0]) {
                    case "A":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +pa[6] + x;
                        r[7] = +pa[7] + y;
                        break;
                    case "V":
                        r[1] = +pa[1] + y;
                        break;
                    case "H":
                        r[1] = +pa[1] + x;
                        break;
                    case "R":
                        var dots = [x, y].concat(pa.slice(1));
                        for (var j = 2, jj = dots.length; j < jj; j++) {
                            dots[j] = +dots[j] + x;
                            dots[++j] = +dots[j] + y;
                        }
                        res.pop();
                        res = res.concat(catmullRom2bezier(dots, crz));
                        break;
                    case "O":
                        res.pop();
                        dots = ellipsePath(x, y, pa[1], pa[2]);
                        dots.push(dots[0]);
                        res = res.concat(dots);
                        break;
                    case "U":
                        res.pop();
                        res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                        r = ["U"].concat(res[res.length - 1].slice(-2));
                        break;
                    case "M":
                        mx = +pa[1] + x;
                        my = +pa[2] + y;
                    default:
                        for (j = 1, jj = pa.length; j < jj; j++) {
                            r[j] = +pa[j] + (j % 2 ? x : y);
                        }
                }
            } else if (pa0 == "R") {
                dots = [x, y].concat(pa.slice(1));
                res.pop();
                res = res.concat(catmullRom2bezier(dots, crz));
                r = ["R"].concat(pa.slice(-2));
            } else if (pa0 == "O") {
                res.pop();
                dots = ellipsePath(x, y, pa[1], pa[2]);
                dots.push(dots[0]);
                res = res.concat(dots);
            } else if (pa0 == "U") {
                res.pop();
                res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                r = ["U"].concat(res[res.length - 1].slice(-2));
            } else {
                for (var k = 0, kk = pa.length; k < kk; k++) {
                    r[k] = pa[k];
                }
            }
            pa0 = pa0.toUpperCase();
            if (pa0 != "O") {
                switch (r[0]) {
                    case "Z":
                        x = +mx;
                        y = +my;
                        break;
                    case "H":
                        x = r[1];
                        break;
                    case "V":
                        y = r[1];
                        break;
                    case "M":
                        mx = r[r.length - 2];
                        my = r[r.length - 1];
                    default:
                        x = r[r.length - 2];
                        y = r[r.length - 1];
                }
            }
        }
        res.toString = toString;
        pth.abs = pathClone(res);
        return res;
    }
    function l2c(x1, y1, x2, y2) {
        return [x1, y1, x2, y2, x2, y2];
    }
    function q2c(x1, y1, ax, ay, x2, y2) {
        var _13 = 1 / 3,
            _23 = 2 / 3;
        return [
                _13 * x1 + _23 * ax,
                _13 * y1 + _23 * ay,
                _13 * x2 + _23 * ax,
                _13 * y2 + _23 * ay,
                x2,
                y2
            ];
    }
    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
        // for more information of where this math came from visit:
        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
        var _120 = PI * 120 / 180,
            rad = PI / 180 * (+angle || 0),
            res = [],
            xy,
            rotate = Snap._.cacher(function (x, y, rad) {
                var X = x * math.cos(rad) - y * math.sin(rad),
                    Y = x * math.sin(rad) + y * math.cos(rad);
                return {x: X, y: Y};
            });
        if (!rx || !ry) {
            return [x1, y1, x2, y2, x2, y2];
        }
        if (!recursive) {
            xy = rotate(x1, y1, -rad);
            x1 = xy.x;
            y1 = xy.y;
            xy = rotate(x2, y2, -rad);
            x2 = xy.x;
            y2 = xy.y;
            var cos = math.cos(PI / 180 * angle),
                sin = math.sin(PI / 180 * angle),
                x = (x1 - x2) / 2,
                y = (y1 - y2) / 2;
            var h = x * x / (rx * rx) + y * y / (ry * ry);
            if (h > 1) {
                h = math.sqrt(h);
                rx = h * rx;
                ry = h * ry;
            }
            var rx2 = rx * rx,
                ry2 = ry * ry,
                k = (large_arc_flag == sweep_flag ? -1 : 1) *
                    math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
                cx = k * rx * y / ry + (x1 + x2) / 2,
                cy = k * -ry * x / rx + (y1 + y2) / 2,
                f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
                f2 = math.asin(((y2 - cy) / ry).toFixed(9));

            f1 = x1 < cx ? PI - f1 : f1;
            f2 = x2 < cx ? PI - f2 : f2;
            f1 < 0 && (f1 = PI * 2 + f1);
            f2 < 0 && (f2 = PI * 2 + f2);
            if (sweep_flag && f1 > f2) {
                f1 = f1 - PI * 2;
            }
            if (!sweep_flag && f2 > f1) {
                f2 = f2 - PI * 2;
            }
        } else {
            f1 = recursive[0];
            f2 = recursive[1];
            cx = recursive[2];
            cy = recursive[3];
        }
        var df = f2 - f1;
        if (abs(df) > _120) {
            var f2old = f2,
                x2old = x2,
                y2old = y2;
            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
            x2 = cx + rx * math.cos(f2);
            y2 = cy + ry * math.sin(f2);
            res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
        }
        df = f2 - f1;
        var c1 = math.cos(f1),
            s1 = math.sin(f1),
            c2 = math.cos(f2),
            s2 = math.sin(f2),
            t = math.tan(df / 4),
            hx = 4 / 3 * rx * t,
            hy = 4 / 3 * ry * t,
            m1 = [x1, y1],
            m2 = [x1 + hx * s1, y1 - hy * c1],
            m3 = [x2 + hx * s2, y2 - hy * c2],
            m4 = [x2, y2];
        m2[0] = 2 * m1[0] - m2[0];
        m2[1] = 2 * m1[1] - m2[1];
        if (recursive) {
            return [m2, m3, m4].concat(res);
        } else {
            res = [m2, m3, m4].concat(res).join().split(",");
            var newres = [];
            for (var i = 0, ii = res.length; i < ii; i++) {
                newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
            }
            return newres;
        }
    }
    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t;
        return {
            x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
            y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
        };
    }

    // Returns bounding box of cubic bezier curve.
    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
    // Original version: NISHIO Hirokazu
    // Modifications: https://github.com/timo22345
    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
        var tvalues = [],
            bounds = [[], []],
            a, b, c, t, t1, t2, b2ac, sqrtb2ac;
        for (var i = 0; i < 2; ++i) {
            if (i == 0) {
                b = 6 * x0 - 12 * x1 + 6 * x2;
                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                c = 3 * x1 - 3 * x0;
            } else {
                b = 6 * y0 - 12 * y1 + 6 * y2;
                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                c = 3 * y1 - 3 * y0;
            }
            if (abs(a) < 1e-12) {
                if (abs(b) < 1e-12) {
                    continue;
                }
                t = -c / b;
                if (0 < t && t < 1) {
                    tvalues.push(t);
                }
                continue;
            }
            b2ac = b * b - 4 * c * a;
            sqrtb2ac = math.sqrt(b2ac);
            if (b2ac < 0) {
                continue;
            }
            t1 = (-b + sqrtb2ac) / (2 * a);
            if (0 < t1 && t1 < 1) {
                tvalues.push(t1);
            }
            t2 = (-b - sqrtb2ac) / (2 * a);
            if (0 < t2 && t2 < 1) {
                tvalues.push(t2);
            }
        }

        var x, y, j = tvalues.length,
            jlen = j,
            mt;
        while (j--) {
            t = tvalues[j];
            mt = 1 - t;
            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
        }

        bounds[0][jlen] = x0;
        bounds[1][jlen] = y0;
        bounds[0][jlen + 1] = x3;
        bounds[1][jlen + 1] = y3;
        bounds[0].length = bounds[1].length = jlen + 2;


        return {
          min: {x: mmin.apply(0, bounds[0]), y: mmin.apply(0, bounds[1])},
          max: {x: mmax.apply(0, bounds[0]), y: mmax.apply(0, bounds[1])}
        };
    }

    function path2curve(path, path2) {
        var pth = !path2 && paths(path);
        if (!path2 && pth.curve) {
            return pathClone(pth.curve);
        }
        var p = pathToAbsolute(path),
            p2 = path2 && pathToAbsolute(path2),
            attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
            attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
            processPath = function (path, d, pcom) {
                var nx, ny;
                if (!path) {
                    return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
                }
                !(path[0] in {T: 1, Q: 1}) && (d.qx = d.qy = null);
                switch (path[0]) {
                    case "M":
                        d.X = path[1];
                        d.Y = path[2];
                        break;
                    case "A":
                        path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
                        break;
                    case "S":
                        if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
                            nx = d.x * 2 - d.bx;          // And reflect the previous
                            ny = d.y * 2 - d.by;          // command's control point relative to the current point.
                        }
                        else {                            // or some else or nothing
                            nx = d.x;
                            ny = d.y;
                        }
                        path = ["C", nx, ny].concat(path.slice(1));
                        break;
                    case "T":
                        if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
                            d.qx = d.x * 2 - d.qx;        // And make a reflection similar
                            d.qy = d.y * 2 - d.qy;        // to case "S".
                        }
                        else {                            // or something else or nothing
                            d.qx = d.x;
                            d.qy = d.y;
                        }
                        path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
                        break;
                    case "Q":
                        d.qx = path[1];
                        d.qy = path[2];
                        path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
                        break;
                    case "L":
                        path = ["C"].concat(l2c(d.x, d.y, path[1], path[2]));
                        break;
                    case "H":
                        path = ["C"].concat(l2c(d.x, d.y, path[1], d.y));
                        break;
                    case "V":
                        path = ["C"].concat(l2c(d.x, d.y, d.x, path[1]));
                        break;
                    case "Z":
                        path = ["C"].concat(l2c(d.x, d.y, d.X, d.Y));
                        break;
                }
                return path;
            },
            fixArc = function (pp, i) {
                if (pp[i].length > 7) {
                    pp[i].shift();
                    var pi = pp[i];
                    while (pi.length) {
                        pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
                        p2 && (pcoms2[i] = "A"); // the same as above
                        pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
                    }
                    pp.splice(i, 1);
                    ii = mmax(p.length, p2 && p2.length || 0);
                }
            },
            fixM = function (path1, path2, a1, a2, i) {
                if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
                    path2.splice(i, 0, ["M", a2.x, a2.y]);
                    a1.bx = 0;
                    a1.by = 0;
                    a1.x = path1[i][1];
                    a1.y = path1[i][2];
                    ii = mmax(p.length, p2 && p2.length || 0);
                }
            },
            pcoms1 = [], // path commands of original path p
            pcoms2 = [], // path commands of original path p2
            pfirst = "", // temporary holder for original path command
            pcom = ""; // holder for previous path command of original path
        for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
            p[i] && (pfirst = p[i][0]); // save current path command

            if (pfirst != "C") // C is not saved yet, because it may be result of conversion
            {
                pcoms1[i] = pfirst; // Save current path command
                i && ( pcom = pcoms1[i - 1]); // Get previous path command pcom
            }
            p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath

            if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
            // which may produce multiple C:s
            // so we have to make sure that C is also C in original path

            fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1

            if (p2) { // the same procedures is done to p2
                p2[i] && (pfirst = p2[i][0]);
                if (pfirst != "C") {
                    pcoms2[i] = pfirst;
                    i && (pcom = pcoms2[i - 1]);
                }
                p2[i] = processPath(p2[i], attrs2, pcom);

                if (pcoms2[i] != "A" && pfirst == "C") {
                    pcoms2[i] = "C";
                }

                fixArc(p2, i);
            }
            fixM(p, p2, attrs, attrs2, i);
            fixM(p2, p, attrs2, attrs, i);
            var seg = p[i],
                seg2 = p2 && p2[i],
                seglen = seg.length,
                seg2len = p2 && seg2.length;
            attrs.x = seg[seglen - 2];
            attrs.y = seg[seglen - 1];
            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
            attrs2.x = p2 && seg2[seg2len - 2];
            attrs2.y = p2 && seg2[seg2len - 1];
        }
        if (!p2) {
            pth.curve = pathClone(p);
        }
        return p2 ? [p, p2] : p;
    }
    function mapPath(path, matrix) {
        if (!matrix) {
            return path;
        }
        var x, y, i, j, ii, jj, pathi;
        path = path2curve(path);
        for (i = 0, ii = path.length; i < ii; i++) {
            pathi = path[i];
            for (j = 1, jj = pathi.length; j < jj; j += 2) {
                x = matrix.x(pathi[j], pathi[j + 1]);
                y = matrix.y(pathi[j], pathi[j + 1]);
                pathi[j] = x;
                pathi[j + 1] = y;
            }
        }
        return path;
    }

    // http://schepers.cc/getting-to-the-point
    function catmullRom2bezier(crp, z) {
        var d = [];
        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
            var p = [
                        {x: +crp[i - 2], y: +crp[i - 1]},
                        {x: +crp[i],     y: +crp[i + 1]},
                        {x: +crp[i + 2], y: +crp[i + 3]},
                        {x: +crp[i + 4], y: +crp[i + 5]}
                    ];
            if (z) {
                if (!i) {
                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
                } else if (iLen - 4 == i) {
                    p[3] = {x: +crp[0], y: +crp[1]};
                } else if (iLen - 2 == i) {
                    p[2] = {x: +crp[0], y: +crp[1]};
                    p[3] = {x: +crp[2], y: +crp[3]};
                }
            } else {
                if (iLen - 4 == i) {
                    p[3] = p[2];
                } else if (!i) {
                    p[0] = {x: +crp[i], y: +crp[i + 1]};
                }
            }
            d.push(["C",
                  (-p[0].x + 6 * p[1].x + p[2].x) / 6,
                  (-p[0].y + 6 * p[1].y + p[2].y) / 6,
                  (p[1].x + 6 * p[2].x - p[3].x) / 6,
                  (p[1].y + 6*p[2].y - p[3].y) / 6,
                  p[2].x,
                  p[2].y
            ]);
        }

        return d;
    }

    // export
    Snap.path = paths;

    /*\
     * Snap.path.getTotalLength
     [ method ]
     **
     * Returns the length of the given path in pixels
     **
     - path (string) SVG path string
     **
     = (number) length
    \*/
    Snap.path.getTotalLength = getTotalLength;
    /*\
     * Snap.path.getPointAtLength
     [ method ]
     **
     * Returns the coordinates of the point located at the given length along the given path
     **
     - path (string) SVG path string
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/
    Snap.path.getPointAtLength = getPointAtLength;
    /*\
     * Snap.path.getSubpath
     [ method ]
     **
     * Returns the subpath of a given path between given start and end lengths
     **
     - path (string) SVG path string
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/
    Snap.path.getSubpath = function (path, from, to) {
        if (this.getTotalLength(path) - to < 1e-6) {
            return getSubpathsAtLength(path, from).end;
        }
        var a = getSubpathsAtLength(path, to, 1);
        return from ? getSubpathsAtLength(a, from).end : a;
    };
    /*\
     * Element.getTotalLength
     [ method ]
     **
     * Returns the length of the path in pixels (only works for `path` elements)
     = (number) length
    \*/
    elproto.getTotalLength = function () {
        if (this.node.getTotalLength) {
            return this.node.getTotalLength();
        }
    };
    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
    /*\
     * Element.getPointAtLength
     [ method ]
     **
     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
     **
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/
    elproto.getPointAtLength = function (length) {
        return getPointAtLength(this.attr("d"), length);
    };
    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
    /*\
     * Element.getSubpath
     [ method ]
     **
     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
     **
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/
    elproto.getSubpath = function (from, to) {
        return Snap.path.getSubpath(this.attr("d"), from, to);
    };
    Snap._.box = box;
    /*\
     * Snap.path.findDotsAtSegment
     [ method ]
     **
     * Utility method
     **
     * Finds dot coordinates on the given cubic beziér curve at the given t
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     - t (number) position on the curve (0..1)
     = (object) point information in format:
     o {
     o     x: (number) x coordinate of the point,
     o     y: (number) y coordinate of the point,
     o     m: {
     o         x: (number) x coordinate of the left anchor,
     o         y: (number) y coordinate of the left anchor
     o     },
     o     n: {
     o         x: (number) x coordinate of the right anchor,
     o         y: (number) y coordinate of the right anchor
     o     },
     o     start: {
     o         x: (number) x coordinate of the start of the curve,
     o         y: (number) y coordinate of the start of the curve
     o     },
     o     end: {
     o         x: (number) x coordinate of the end of the curve,
     o         y: (number) y coordinate of the end of the curve
     o     },
     o     alpha: (number) angle of the curve derivative at the point
     o }
    \*/
    Snap.path.findDotsAtSegment = findDotsAtSegment;
    /*\
     * Snap.path.bezierBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given cubic beziér curve
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     * or
     - bez (array) array of six points for beziér curve
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/
    Snap.path.bezierBBox = bezierBBox;
    /*\
     * Snap.path.isPointInsideBBox
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside bounding box
     - bbox (string) bounding box
     - x (string) x coordinate of the point
     - y (string) y coordinate of the point
     = (boolean) `true` if point is inside
    \*/
    Snap.path.isPointInsideBBox = isPointInsideBBox;
    Snap.closest = function (x, y, X, Y) {
        var r = 100,
            b = box(x - r / 2, y - r / 2, r, r),
            inside = [],
            getter = X[0].hasOwnProperty("x") ? function (i) {
                return {
                    x: X[i].x,
                    y: X[i].y
                };
            } : function (i) {
                return {
                    x: X[i],
                    y: Y[i]
                };
            },
            found = 0;
        while (r <= 1e6 && !found) {
            for (var i = 0, ii = X.length; i < ii; i++) {
                var xy = getter(i);
                if (isPointInsideBBox(b, xy.x, xy.y)) {
                    found++;
                    inside.push(xy);
                    break;
                }
            }
            if (!found) {
                r *= 2;
                b = box(x - r / 2, y - r / 2, r, r)
            }
        }
        if (r == 1e6) {
            return;
        }
        var len = Infinity,
            res;
        for (i = 0, ii = inside.length; i < ii; i++) {
            var l = Snap.len(x, y, inside[i].x, inside[i].y);
            if (len > l) {
                len = l;
                inside[i].len = l;
                res = inside[i];
            }
        }
        return res;
    };
    /*\
     * Snap.path.isBBoxIntersect
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if two bounding boxes intersect
     - bbox1 (string) first bounding box
     - bbox2 (string) second bounding box
     = (boolean) `true` if bounding boxes intersect
    \*/
    Snap.path.isBBoxIntersect = isBBoxIntersect;
    /*\
     * Snap.path.intersection
     [ method ]
     **
     * Utility method
     **
     * Finds intersections of two paths
     - path1 (string) path string
     - path2 (string) path string
     = (array) dots of intersection
     o [
     o     {
     o         x: (number) x coordinate of the point,
     o         y: (number) y coordinate of the point,
     o         t1: (number) t value for segment of path1,
     o         t2: (number) t value for segment of path2,
     o         segment1: (number) order number for segment of path1,
     o         segment2: (number) order number for segment of path2,
     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
     o     }
     o ]
    \*/
    Snap.path.intersection = pathIntersection;
    Snap.path.intersectionNumber = pathIntersectionNumber;
    /*\
     * Snap.path.isPointInside
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside a given closed path.
     *
     * Note: fill mode doesn’t affect the result of this method.
     - path (string) path string
     - x (number) x of the point
     - y (number) y of the point
     = (boolean) `true` if point is inside the path
    \*/
    Snap.path.isPointInside = isPointInsidePath;
    /*\
     * Snap.path.getBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given path
     - path (string) path string
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/
    Snap.path.getBBox = pathBBox;
    Snap.path.get = getPath;
    /*\
     * Snap.path.toRelative
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into relative values
     - path (string) path string
     = (array) path string
    \*/
    Snap.path.toRelative = pathToRelative;
    /*\
     * Snap.path.toAbsolute
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into absolute values
     - path (string) path string
     = (array) path string
    \*/
    Snap.path.toAbsolute = pathToAbsolute;
    /*\
     * Snap.path.toCubic
     [ method ]
     **
     * Utility method
     **
     * Converts path to a new path where all segments are cubic beziér curves
     - pathString (string|array) path string or array of segments
     = (array) array of segments
    \*/
    Snap.path.toCubic = path2curve;
    /*\
     * Snap.path.map
     [ method ]
     **
     * Transform the path string with the given matrix
     - path (string) path string
     - matrix (object) see @Matrix
     = (string) transformed path string
    \*/
    Snap.path.map = mapPath;
    Snap.path.toString = toString;
    Snap.path.clone = pathClone;
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var mmax = Math.max,
        mmin = Math.min;

    // Set
    var Set = function (items) {
        this.items = [];
	this.bindings = {};
        this.length = 0;
        this.type = "set";
        if (items) {
            for (var i = 0, ii = items.length; i < ii; i++) {
                if (items[i]) {
                    this[this.items.length] = this.items[this.items.length] = items[i];
                    this.length++;
                }
            }
        }
    },
    setproto = Set.prototype;
    /*\
     * Set.push
     [ method ]
     **
     * Adds each argument to the current set
     = (object) original element
    \*/
    setproto.push = function () {
        var item,
            len;
        for (var i = 0, ii = arguments.length; i < ii; i++) {
            item = arguments[i];
            if (item) {
                len = this.items.length;
                this[len] = this.items[len] = item;
                this.length++;
            }
        }
        return this;
    };
    /*\
     * Set.pop
     [ method ]
     **
     * Removes last element and returns it
     = (object) element
    \*/
    setproto.pop = function () {
        this.length && delete this[this.length--];
        return this.items.pop();
    };
    /*\
     * Set.forEach
     [ method ]
     **
     * Executes given function for each element in the set
     *
     * If the function returns `false`, the loop stops running.
     **
     - callback (function) function to run
     - thisArg (object) context object for the callback
     = (object) Set object
    \*/
    setproto.forEach = function (callback, thisArg) {
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            if (callback.call(thisArg, this.items[i], i) === false) {
                return this;
            }
        }
        return this;
    };
    /*\
     * Set.animate
     [ method ]
     **
     * Animates each element in set in sync.
     *
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     * or
     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
     > Usage
     | // animate all elements in set to radius 10
     | set.animate({r: 10}, 500, mina.easein);
     | // or
     | // animate first element to radius 10, but second to radius 20 and in different time
     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
     = (Element) the current element
    \*/
    setproto.animate = function (attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        if (attrs instanceof Snap._.Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = easing.dur;
            attrs = attrs.attr;
        }
        var args = arguments;
        if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) {
            var each = true;
        }
        var begin,
            handler = function () {
                if (begin) {
                    this.b = begin;
                } else {
                    begin = this.b;
                }
            },
            cb = 0,
            set = this,
            callbacker = callback && function () {
                if (++cb == set.length) {
                    callback.call(this);
                }
            };
        return this.forEach(function (el, i) {
            eve.once("snap.animcreated." + el.id, handler);
            if (each) {
                args[i] && el.animate.apply(el, args[i]);
            } else {
                el.animate(attrs, ms, easing, callbacker);
            }
        });
    };
    /*\
     * Set.remove
     [ method ]
     **
     * Removes all children of the set.
     *
     = (object) Set object
    \*/
    setproto.remove = function () {
        while (this.length) {
            this.pop().remove();
        }
        return this;
    };
    /*\
     * Set.bind
     [ method ]
     **
     * Specifies how to handle a specific attribute when applied
     * to a set.
     *
     **
     - attr (string) attribute name
     - callback (function) function to run
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     - eattr (string) attribute on the element to bind the attribute to
     = (object) Set object
    \*/
    setproto.bind = function (attr, a, b) {
        var data = {};
        if (typeof a == "function") {
            this.bindings[attr] = a;
        } else {
            var aname = b || attr;
            this.bindings[attr] = function (v) {
                data[aname] = v;
                a.attr(data);
            };
        }
        return this;
    };
    /*\
     * Set.attr
     [ method ]
     **
     * Equivalent of @Element.attr.
     = (object) Set object
    \*/
    setproto.attr = function (value) {
        var unbound = {};
        for (var k in value) {
            if (this.bindings[k]) {
                this.bindings[k](value[k]);
            } else {
                unbound[k] = value[k];
            }
        }
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            this.items[i].attr(unbound);
        }
        return this;
    };
    /*\
     * Set.clear
     [ method ]
     **
     * Removes all elements from the set
    \*/
    setproto.clear = function () {
        while (this.length) {
            this.pop();
        }
    };
    /*\
     * Set.splice
     [ method ]
     **
     * Removes range of elements from the set
     **
     - index (number) position of the deletion
     - count (number) number of element to remove
     - insertion… (object) #optional elements to insert
     = (object) set elements that were deleted
    \*/
    setproto.splice = function (index, count, insertion) {
        index = index < 0 ? mmax(this.length + index, 0) : index;
        count = mmax(0, mmin(this.length - index, count));
        var tail = [],
            todel = [],
            args = [],
            i;
        for (i = 2; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        for (i = 0; i < count; i++) {
            todel.push(this[index + i]);
        }
        for (; i < this.length - index; i++) {
            tail.push(this[index + i]);
        }
        var arglen = args.length;
        for (i = 0; i < arglen + tail.length; i++) {
            this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
        }
        i = this.items.length = this.length -= count - arglen;
        while (this[i]) {
            delete this[i++];
        }
        return new Set(todel);
    };
    /*\
     * Set.exclude
     [ method ]
     **
     * Removes given element from the set
     **
     - element (object) element to remove
     = (boolean) `true` if object was found and removed from the set
    \*/
    setproto.exclude = function (el) {
        for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
            this.splice(i, 1);
            return true;
        }
        return false;
    };
    /*\
     * Set.insertAfter
     [ method ]
     **
     * Inserts set elements after given element.
     **
     - element (object) set will be inserted after this element
     = (object) Set object
    \*/
    setproto.insertAfter = function (el) {
        var i = this.items.length;
        while (i--) {
            this.items[i].insertAfter(el);
        }
        return this;
    };
    /*\
     * Set.getBBox
     [ method ]
     **
     * Union of all bboxes of the set. See @Element.getBBox.
     = (object) bounding box descriptor. See @Element.getBBox.
    \*/
    setproto.getBBox = function () {
        var x = [],
            y = [],
            x2 = [],
            y2 = [];
        for (var i = this.items.length; i--;) if (!this.items[i].removed) {
            var box = this.items[i].getBBox();
            x.push(box.x);
            y.push(box.y);
            x2.push(box.x + box.width);
            y2.push(box.y + box.height);
        }
        x = mmin.apply(0, x);
        y = mmin.apply(0, y);
        x2 = mmax.apply(0, x2);
        y2 = mmax.apply(0, y2);
        return {
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            width: x2 - x,
            height: y2 - y,
            cx: x + (x2 - x) / 2,
            cy: y + (y2 - y) / 2
        };
    };
    /*\
     * Set.insertAfter
     [ method ]
     **
     * Creates a clone of the set.
     **
     = (object) New Set object
    \*/
    setproto.clone = function (s) {
        s = new Set;
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            s.push(this.items[i].clone());
        }
        return s;
    };
    setproto.toString = function () {
        return "Snap\u2018s set";
    };
    setproto.type = "set";
    // export
    /*\
     * Snap.Set
     [ property ]
     **
     * Set constructor.
    \*/
    Snap.Set = Set;
    /*\
     * Snap.set
     [ method ]
     **
     * Creates a set and fills it with list of arguments.
     **
     = (object) New Set object
     | var r = paper.rect(0, 0, 10, 10),
     |     s1 = Snap.set(), // empty set
     |     s2 = Snap.set(r, paper.circle(100, 100, 20)); // prefilled set
    \*/
    Snap.set = function () {
        var set = new Set;
        if (arguments.length) {
            set.push.apply(set, Array.prototype.slice.call(arguments, 0));
        }
        return set;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var names = {},
        reUnit = /[%a-z]+$/i,
        Str = String;
    names.stroke = names.fill = "colour";
    function getEmpty(item) {
        var l = item[0];
        switch (l.toLowerCase()) {
            case "t": return [l, 0, 0];
            case "m": return [l, 1, 0, 0, 1, 0, 0];
            case "r": if (item.length == 4) {
                return [l, 0, item[2], item[3]];
            } else {
                return [l, 0];
            }
            case "s": if (item.length == 5) {
                return [l, 1, 1, item[3], item[4]];
            } else if (item.length == 3) {
                return [l, 1, 1];
            } else {
                return [l, 1];
            }
        }
    }
    function equaliseTransform(t1, t2, getBBox) {
        t1 = t1 || new Snap.Matrix;
        t2 = t2 || new Snap.Matrix;
        t1 = Snap.parseTransformString(t1.toTransformString()) || [];
        t2 = Snap.parseTransformString(t2.toTransformString()) || [];
        var maxlength = Math.max(t1.length, t2.length),
            from = [],
            to = [],
            i = 0, j, jj,
            tt1, tt2;
        for (; i < maxlength; i++) {
            tt1 = t1[i] || getEmpty(t2[i]);
            tt2 = t2[i] || getEmpty(tt1);
            if (tt1[0] != tt2[0] ||
                tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3]) ||
                tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4])
                ) {
                    t1 = Snap._.transform2matrix(t1, getBBox());
                    t2 = Snap._.transform2matrix(t2, getBBox());
                    from = [["m", t1.a, t1.b, t1.c, t1.d, t1.e, t1.f]];
                    to = [["m", t2.a, t2.b, t2.c, t2.d, t2.e, t2.f]];
                    break;
            }
            from[i] = [];
            to[i] = [];
            for (j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++) {
                j in tt1 && (from[i][j] = tt1[j]);
                j in tt2 && (to[i][j] = tt2[j]);
            }
        }
        return {
            from: path2array(from),
            to: path2array(to),
            f: getPath(from)
        };
    }
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function (val) {
            return +val.toFixed(3) + unit;
        };
    }
    function getViewBox(val) {
        return val.join(" ");
    }
    function getColour(clr) {
        return Snap.rgb(clr[0], clr[1], clr[2], clr[3]);
    }
    function getPath(path) {
        var k = 0, i, ii, j, jj, out, a, b = [];
        for (i = 0, ii = path.length; i < ii; i++) {
            out = "[";
            a = ['"' + path[i][0] + '"'];
            for (j = 1, jj = path[i].length; j < jj; j++) {
                a[j] = "val[" + k++ + "]";
            }
            out += a + "]";
            b[i] = out;
        }
        return Function("val", "return Snap.path.toString.call([" + b + "])");
    }
    function path2array(path) {
        var out = [];
        for (var i = 0, ii = path.length; i < ii; i++) {
            for (var j = 1, jj = path[i].length; j < jj; j++) {
                out.push(path[i][j]);
            }
        }
        return out;
    }
    function isNumeric(obj) {
        return isFinite(obj);
    }
    function arrayEqual(arr1, arr2) {
        if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) {
            return false;
        }
        return arr1.toString() == arr2.toString();
    }
    Element.prototype.equal = function (name, b) {
        return eve("snap.util.equal", this, name, b).firstDefined();
    };
    eve.on("snap.util.equal", function (name, b) {
        var A, B, a = Str(this.attr(name) || ""),
            el = this;
        if (names[name] == "colour") {
            A = Snap.color(a);
            B = Snap.color(b);
            return {
                from: [A.r, A.g, A.b, A.opacity],
                to: [B.r, B.g, B.b, B.opacity],
                f: getColour
            };
        }
        if (name == "viewBox") {
            A = this.attr(name).vb.split(" ").map(Number);
            B = b.split(" ").map(Number);
            return {
                from: A,
                to: B,
                f: getViewBox
            };
        }
        if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
            if (typeof b == "string") {
                b = Str(b).replace(/\.{3}|\u2026/g, a);
            }
            a = this.matrix;
            if (!Snap._.rgTransform.test(b)) {
                b = Snap._.transform2matrix(Snap._.svgTransform2string(b), this.getBBox());
            } else {
                b = Snap._.transform2matrix(b, this.getBBox());
            }
            return equaliseTransform(a, b, function () {
                return el.getBBox(1);
            });
        }
        if (name == "d" || name == "path") {
            A = Snap.path.toCubic(a, b);
            return {
                from: path2array(A[0]),
                to: path2array(A[1]),
                f: getPath(A[0])
            };
        }
        if (name == "points") {
            A = Str(a).split(Snap._.separator);
            B = Str(b).split(Snap._.separator);
            return {
                from: A,
                to: B,
                f: function (val) { return val; }
            };
        }
        if (isNumeric(a) && isNumeric(b)) {
            return {
                from: parseFloat(a),
                to: parseFloat(b),
                f: getNumber
            };
        }
        var aUnit = a.match(reUnit),
            bUnit = Str(b).match(reUnit);
        if (aUnit && arrayEqual(aUnit, bUnit)) {
            return {
                from: parseFloat(a),
                to: parseFloat(b),
                f: getUnit(aUnit)
            };
        } else {
            return {
                from: this.asPX(name),
                to: this.asPX(name, b),
                f: getNumber
            };
        }
    });
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
    has = "hasOwnProperty",
    supportsTouch = "createTouch" in glob.doc,
    events = [
        "click", "dblclick", "mousedown", "mousemove", "mouseout",
        "mouseover", "mouseup", "touchstart", "touchmove", "touchend",
        "touchcancel"
    ],
    touchMap = {
        mousedown: "touchstart",
        mousemove: "touchmove",
        mouseup: "touchend"
    },
    getScroll = function (xy, el) {
        var name = xy == "y" ? "scrollTop" : "scrollLeft",
            doc = el && el.node ? el.node.ownerDocument : glob.doc;
        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
    },
    preventDefault = function () {
        this.returnValue = false;
    },
    preventTouch = function () {
        return this.originalEvent.preventDefault();
    },
    stopPropagation = function () {
        this.cancelBubble = true;
    },
    stopTouch = function () {
        return this.originalEvent.stopPropagation();
    },
    addEvent = function (obj, type, fn, element) {
        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type,
            f = function (e) {
                var scrollY = getScroll("y", element),
                    scrollX = getScroll("x", element);
                if (supportsTouch && touchMap[has](type)) {
                    for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
                        if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
                            var olde = e;
                            e = e.targetTouches[i];
                            e.originalEvent = olde;
                            e.preventDefault = preventTouch;
                            e.stopPropagation = stopTouch;
                            break;
                        }
                    }
                }
                var x = e.clientX + scrollX,
                    y = e.clientY + scrollY;
                return fn.call(element, e, x, y);
            };

        if (type !== realName) {
            obj.addEventListener(type, f, false);
        }

        obj.addEventListener(realName, f, false);

        return function () {
            if (type !== realName) {
                obj.removeEventListener(type, f, false);
            }

            obj.removeEventListener(realName, f, false);
            return true;
        };
    },
    drag = [],
    dragMove = function (e) {
        var x = e.clientX,
            y = e.clientY,
            scrollY = getScroll("y"),
            scrollX = getScroll("x"),
            dragi,
            j = drag.length;
        while (j--) {
            dragi = drag[j];
            if (supportsTouch) {
                var i = e.touches && e.touches.length,
                    touch;
                while (i--) {
                    touch = e.touches[i];
                    if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
                        x = touch.clientX;
                        y = touch.clientY;
                        (e.originalEvent ? e.originalEvent : e).preventDefault();
                        break;
                    }
                }
            } else {
                e.preventDefault();
            }
            var node = dragi.el.node,
                o,
                next = node.nextSibling,
                parent = node.parentNode,
                display = node.style.display;
            // glob.win.opera && parent.removeChild(node);
            // node.style.display = "none";
            // o = dragi.el.paper.getElementByPoint(x, y);
            // node.style.display = display;
            // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
            // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
            x += scrollX;
            y += scrollY;
            eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
        }
    },
    dragUp = function (e) {
        Snap.unmousemove(dragMove).unmouseup(dragUp);
        var i = drag.length,
            dragi;
        while (i--) {
            dragi = drag[i];
            dragi.el._drag = {};
            eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
            eve.off("snap.drag.*." + dragi.el.id);
        }
        drag = [];
    };
    /*\
     * Element.click
     [ method ]
     **
     * Adds a click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unclick
     [ method ]
     **
     * Removes a click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.dblclick
     [ method ]
     **
     * Adds a double click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.undblclick
     [ method ]
     **
     * Removes a double click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mousedown
     [ method ]
     **
     * Adds a mousedown event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousedown
     [ method ]
     **
     * Removes a mousedown event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mousemove
     [ method ]
     **
     * Adds a mousemove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousemove
     [ method ]
     **
     * Removes a mousemove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mouseout
     [ method ]
     **
     * Adds a mouseout event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseout
     [ method ]
     **
     * Removes a mouseout event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mouseover
     [ method ]
     **
     * Adds a mouseover event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseover
     [ method ]
     **
     * Removes a mouseover event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mouseup
     [ method ]
     **
     * Adds a mouseup event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseup
     [ method ]
     **
     * Removes a mouseup event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchstart
     [ method ]
     **
     * Adds a touchstart event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchstart
     [ method ]
     **
     * Removes a touchstart event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchmove
     [ method ]
     **
     * Adds a touchmove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchmove
     [ method ]
     **
     * Removes a touchmove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchend
     [ method ]
     **
     * Adds a touchend event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchend
     [ method ]
     **
     * Removes a touchend event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchcancel
     [ method ]
     **
     * Adds a touchcancel event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchcancel
     [ method ]
     **
     * Removes a touchcancel event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    for (var i = events.length; i--;) {
        (function (eventName) {
            Snap[eventName] = elproto[eventName] = function (fn, scope) {
                if (Snap.is(fn, "function")) {
                    this.events = this.events || [];
                    this.events.push({
                        name: eventName,
                        f: fn,
                        unbind: addEvent(this.node || document, eventName, fn, scope || this)
                    });
                } else {
                    for (var i = 0, ii = this.events.length; i < ii; i++) if (this.events[i].name == eventName) {
                        try {
                            this.events[i].f.call(this);
                        } catch (e) {}
                    }
                }
                return this;
            };
            Snap["un" + eventName] =
            elproto["un" + eventName] = function (fn) {
                var events = this.events || [],
                    l = events.length;
                while (l--) if (events[l].name == eventName &&
                               (events[l].f == fn || !fn)) {
                    events[l].unbind();
                    events.splice(l, 1);
                    !events.length && delete this.events;
                    return this;
                }
                return this;
            };
        })(events[i]);
    }
    /*\
     * Element.hover
     [ method ]
     **
     * Adds hover event handlers to the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     - icontext (object) #optional context for hover in handler
     - ocontext (object) #optional context for hover out handler
     = (object) @Element
    \*/
    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
    };
    /*\
     * Element.unhover
     [ method ]
     **
     * Removes hover event handlers from the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     = (object) @Element
    \*/
    elproto.unhover = function (f_in, f_out) {
        return this.unmouseover(f_in).unmouseout(f_out);
    };
    var draggable = [];
    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
    /*\
     * Element.drag
     [ method ]
     **
     * Adds event handlers for an element's drag gesture
     **
     - onmove (function) handler for moving
     - onstart (function) handler for drag start
     - onend (function) handler for drag end
     - mcontext (object) #optional context for moving handler
     - scontext (object) #optional context for drag start handler
     - econtext (object) #optional context for drag end handler
     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start, 
     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element 
     * `drag.over.<id>` fires as well.
     *
     * Start event and start handler are called in specified context or in context of the element with following parameters:
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * Move event and move handler are called in specified context or in context of the element with following parameters:
     o dx (number) shift by x from the start point
     o dy (number) shift by y from the start point
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * End event and end handler are called in specified context or in context of the element with following parameters:
     o event (object) DOM event object
     = (object) @Element
    \*/
    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
        var el = this;
        if (!arguments.length) {
            var origTransform;
            return el.drag(function (dx, dy) {
                this.attr({
                    transform: origTransform + (origTransform ? "T" : "t") + [dx, dy]
                });
            }, function () {
                origTransform = this.transform().local;
            });
        }
        function start(e, x, y) {
            (e.originalEvent || e).preventDefault();
            el._drag.x = x;
            el._drag.y = y;
            el._drag.id = e.identifier;
            !drag.length && Snap.mousemove(dragMove).mouseup(dragUp);
            drag.push({el: el, move_scope: move_scope, start_scope: start_scope, end_scope: end_scope});
            onstart && eve.on("snap.drag.start." + el.id, onstart);
            onmove && eve.on("snap.drag.move." + el.id, onmove);
            onend && eve.on("snap.drag.end." + el.id, onend);
            eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
        }
        function init(e, x, y) {
            eve("snap.draginit." + el.id, el, e, x, y);
        }
        eve.on("snap.draginit." + el.id, start);
        el._drag = {};
        draggable.push({el: el, start: start, init: init});
        el.mousedown(init);
        return el;
    };
    /*
     * Element.onDragOver
     [ method ]
     **
     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
     - f (function) handler for event, first argument would be the element you are dragging over
    \*/
    // elproto.onDragOver = function (f) {
    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
    // };
    /*\
     * Element.undrag
     [ method ]
     **
     * Removes all drag event handlers from the given element
    \*/
    elproto.undrag = function () {
        var i = draggable.length;
        while (i--) if (draggable[i].el == this) {
            this.unmousedown(draggable[i].init);
            draggable.splice(i, 1);
            eve.unbind("snap.drag.*." + this.id);
            eve.unbind("snap.draginit." + this.id);
        }
        !draggable.length && Snap.unmousemove(dragMove).unmouseup(dragUp);
        return this;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
        pproto = Paper.prototype,
        rgurl = /^\s*url\((.+)\)/,
        Str = String,
        $ = Snap._.$;
    Snap.filter = {};
    /*\
     * Paper.filter
     [ method ]
     **
     * Creates a `<filter>` element
     **
     - filstr (string) SVG fragment of filter provided as a string
     = (object) @Element
     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
     > Usage
     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    pproto.filter = function (filstr) {
        var paper = this;
        if (paper.type != "svg") {
            paper = paper.paper;
        }
        var f = Snap.parse(Str(filstr)),
            id = Snap._.id(),
            width = paper.node.offsetWidth,
            height = paper.node.offsetHeight,
            filter = $("filter");
        $(filter, {
            id: id,
            filterUnits: "userSpaceOnUse"
        });
        filter.appendChild(f.node);
        paper.defs.appendChild(filter);
        return new Element(filter);
    };

    eve.on("snap.util.getattr.filter", function () {
        eve.stop();
        var p = $(this.node, "filter");
        if (p) {
            var match = Str(p).match(rgurl);
            return match && Snap.select(match[1]);
        }
    });
    eve.on("snap.util.attr.filter", function (value) {
        if (value instanceof Element && value.type == "filter") {
            eve.stop();
            var id = value.node.id;
            if (!id) {
                $(value.node, {id: value.id});
                id = value.id;
            }
            $(this.node, {
                filter: Snap.url(id)
            });
        }
        if (!value || value == "none") {
            eve.stop();
            this.node.removeAttribute("filter");
        }
    });
    /*\
     * Snap.filter.blur
     [ method ]
     **
     * Returns an SVG markup string for the blur filter
     **
     - x (number) amount of horizontal blur, in pixels
     - y (number) #optional amount of vertical blur, in pixels
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.blur(5, 10)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    Snap.filter.blur = function (x, y) {
        if (x == null) {
            x = 2;
        }
        var def = y == null ? x : [x, y];
        return Snap.format('\<feGaussianBlur stdDeviation="{def}"/>', {
            def: def
        });
    };
    Snap.filter.blur.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.shadow
     [ method ]
     **
     * Returns an SVG markup string for the shadow filter
     **
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - blur (number) #optional amount of blur
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * which makes blur default to `4`. Or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - opacity (number) #optional `0..1` opacity of the shadow
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.shadow(0, 2, .3)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    Snap.filter.shadow = function (dx, dy, blur, color, opacity) {
        if (opacity == null) {
            if (color == null) {
                opacity = blur;
                blur = 4;
                color = "#000";
            } else {
                opacity = color;
                color = blur;
                blur = 4;
            }
        }
        if (blur == null) {
            blur = 4;
        }
        if (opacity == null) {
            opacity = 1;
        }
        if (dx == null) {
            dx = 0;
            dy = 2;
        }
        if (dy == null) {
            dy = dx;
        }
        color = Snap.color(color);
        return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
            color: color,
            dx: dx,
            dy: dy,
            blur: blur,
            opacity: opacity
        });
    };
    Snap.filter.shadow.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.grayscale
     [ method ]
     **
     * Returns an SVG markup string for the grayscale filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.grayscale = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
            a: 0.2126 + 0.7874 * (1 - amount),
            b: 0.7152 - 0.7152 * (1 - amount),
            c: 0.0722 - 0.0722 * (1 - amount),
            d: 0.2126 - 0.2126 * (1 - amount),
            e: 0.7152 + 0.2848 * (1 - amount),
            f: 0.0722 - 0.0722 * (1 - amount),
            g: 0.2126 - 0.2126 * (1 - amount),
            h: 0.0722 + 0.9278 * (1 - amount)
        });
    };
    Snap.filter.grayscale.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.sepia
     [ method ]
     **
     * Returns an SVG markup string for the sepia filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.sepia = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
            a: 0.393 + 0.607 * (1 - amount),
            b: 0.769 - 0.769 * (1 - amount),
            c: 0.189 - 0.189 * (1 - amount),
            d: 0.349 - 0.349 * (1 - amount),
            e: 0.686 + 0.314 * (1 - amount),
            f: 0.168 - 0.168 * (1 - amount),
            g: 0.272 - 0.272 * (1 - amount),
            h: 0.534 - 0.534 * (1 - amount),
            i: 0.131 + 0.869 * (1 - amount)
        });
    };
    Snap.filter.sepia.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.saturate
     [ method ]
     **
     * Returns an SVG markup string for the saturate filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.saturate = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
            amount: 1 - amount
        });
    };
    Snap.filter.saturate.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.hueRotate
     [ method ]
     **
     * Returns an SVG markup string for the hue-rotate filter
     **
     - angle (number) angle of rotation
     = (string) filter representation
    \*/
    Snap.filter.hueRotate = function (angle) {
        angle = angle || 0;
        return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
            angle: angle
        });
    };
    Snap.filter.hueRotate.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.invert
     [ method ]
     **
     * Returns an SVG markup string for the invert filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.invert = function (amount) {
        if (amount == null) {
            amount = 1;
        }
//        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
        return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: 1 - amount
        });
    };
    Snap.filter.invert.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.brightness
     [ method ]
     **
     * Returns an SVG markup string for the brightness filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.brightness = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
            amount: amount
        });
    };
    Snap.filter.brightness.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.contrast
     [ method ]
     **
     * Returns an SVG markup string for the contrast filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.contrast = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: .5 - amount / 2
        });
    };
    Snap.filter.contrast.toString = function () {
        return this();
    };
});

// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var box = Snap._.box,
        is = Snap.is,
        firstLetter = /^[^a-z]*([tbmlrc])/i,
        toString = function () {
            return "T" + this.dx + "," + this.dy;
        };
    /*\
     * Element.getAlign
     [ method ]
     **
     * Returns shift needed to align the element relatively to given element.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
     > Usage
     | el.transform(el.getAlign(el2, "top"));
     * or
     | var dy = el.getAlign(el2, "top").dy;
    \*/
    Element.prototype.getAlign = function (el, way) {
        if (way == null && is(el, "string")) {
            way = el;
            el = null;
        }
        el = el || this.paper;
        var bx = el.getBBox ? el.getBBox() : box(el),
            bb = this.getBBox(),
            out = {};
        way = way && way.match(firstLetter);
        way = way ? way[1].toLowerCase() : "c";
        switch (way) {
            case "t":
                out.dx = 0;
                out.dy = bx.y - bb.y;
            break;
            case "b":
                out.dx = 0;
                out.dy = bx.y2 - bb.y2;
            break;
            case "m":
                out.dx = 0;
                out.dy = bx.cy - bb.cy;
            break;
            case "l":
                out.dx = bx.x - bb.x;
                out.dy = 0;
            break;
            case "r":
                out.dx = bx.x2 - bb.x2;
                out.dy = 0;
            break;
            default:
                out.dx = bx.cx - bb.cx;
                out.dy = 0;
            break;
        }
        out.toString = toString;
        return out;
    };
    /*\
     * Element.align
     [ method ]
     **
     * Aligns the element relatively to given one via transformation.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object) this element
     > Usage
     | el.align(el2, "top");
     * or
     | el.align("middle");
    \*/
    Element.prototype.align = function (el, way) {
        return this.transform("..." + this.getAlign(el, way));
    };
});

// Copyright (c) 2016 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype,
        is = Snap.is,
        Str = String,
        has = "hasOwnProperty";
    function slice(from, to, f) {
        return function (arr) {
            var res = arr.slice(from, to);
            if (res.length == 1) {
                res = res[0];
            }
            return f ? f(res) : res;
        };
    }
    var Animation = function (attr, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        this.attr = attr;
        this.dur = ms;
        easing && (this.easing = easing);
        callback && (this.callback = callback);
    };
    Snap._.Animation = Animation;
    /*\
     * Snap.animation
     [ method ]
     **
     * Creates an animation object
     **
     - attr (object) attributes of final destination
     - duration (number) duration of the animation, in milliseconds
     - easing (function) #optional one of easing functions of @mina or custom one
     - callback (function) #optional callback function that fires when animation ends
     = (object) animation object
    \*/
    Snap.animation = function (attr, ms, easing, callback) {
        return new Animation(attr, ms, easing, callback);
    };
    /*\
     * Element.inAnim
     [ method ]
     **
     * Returns a set of animations that may be able to manipulate the current element
     **
     = (object) in format:
     o {
     o     anim (object) animation object,
     o     mina (object) @mina object,
     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
    \*/
    elproto.inAnim = function () {
        var el = this,
            res = [];
        for (var id in el.anims) if (el.anims[has](id)) {
            (function (a) {
                res.push({
                    anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
                    mina: a,
                    curStatus: a.status(),
                    status: function (val) {
                        return a.status(val);
                    },
                    stop: function () {
                        a.stop();
                    }
                });
            }(el.anims[id]));
        }
        return res;
    };
    /*\
     * Snap.animate
     [ method ]
     **
     * Runs generic animation of one number into another with a caring function
     **
     - from (number|array) number or array of numbers
     - to (number|array) number or array of numbers
     - setter (function) caring function that accepts one number argument
     - duration (number) duration, in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function to execute when animation ends
     = (object) animation object in @mina format
     o {
     o     id (string) animation id, consider it read-only,
     o     duration (function) gets or sets the duration of the animation,
     o     easing (function) easing,
     o     speed (function) gets or sets the speed of the animation,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
     | var rect = Snap().rect(0, 0, 10, 10);
     | Snap.animate(0, 10, function (val) {
     |     rect.attr({
     |         x: val
     |     });
     | }, 1000);
     | // in given context is equivalent to
     | rect.animate({x: 10}, 1000);
    \*/
    Snap.animate = function (from, to, setter, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        var now = mina.time(),
            anim = mina(from, to, now, now + ms, mina.time, setter, easing);
        callback && eve.once("mina.finish." + anim.id, callback);
        return anim;
    };
    /*\
     * Element.stop
     [ method ]
     **
     * Stops all the animations for the current element
     **
     = (Element) the current element
    \*/
    elproto.stop = function () {
        var anims = this.inAnim();
        for (var i = 0, ii = anims.length; i < ii; i++) {
            anims[i].stop();
        }
        return this;
    };
    /*\
     * Element.animate
     [ method ]
     **
     * Animates the given attributes of the element
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     = (Element) the current element
    \*/
    elproto.animate = function (attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        if (attrs instanceof Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = attrs.dur;
            attrs = attrs.attr;
        }
        var fkeys = [], tkeys = [], keys = {}, from, to, f, eq,
            el = this;
        for (var key in attrs) if (attrs[has](key)) {
            if (el.equal) {
                eq = el.equal(key, Str(attrs[key]));
                from = eq.from;
                to = eq.to;
                f = eq.f;
            } else {
                from = +el.attr(key);
                to = +attrs[key];
            }
            var len = is(from, "array") ? from.length : 1;
            keys[key] = slice(fkeys.length, fkeys.length + len, f);
            fkeys = fkeys.concat(from);
            tkeys = tkeys.concat(to);
        }
        var now = mina.time(),
            anim = mina(fkeys, tkeys, now, now + ms, mina.time, function (val) {
                var attr = {};
                for (var key in keys) if (keys[has](key)) {
                    attr[key] = keys[key](val);
                }
                el.attr(attr);
            }, easing);
        el.anims[anim.id] = anim;
        anim._attrs = attrs;
        anim._callback = callback;
        eve("snap.animcreated." + el.id, anim);
        eve.once("mina.finish." + anim.id, function () {
            eve.off("mina.*." + anim.id);
            delete el.anims[anim.id];
            callback && callback.call(el);
        });
        eve.once("mina.stop." + anim.id, function () {
            eve.off("mina.*." + anim.id);
            delete el.anims[anim.id];
        });
        return el;
    };
});

// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    // Colours are from https://www.materialui.co
    var red         = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000",
        pink        = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162",
        purple      = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF",
        deeppurple  = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA",
        indigo      = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE",
        blue        = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF",
        lightblue   = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA",
        cyan        = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4",
        teal        = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5",
        green       = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853",
        lightgreen  = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17",
        lime        = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00",
        yellow      = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600",
        amber       = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00",
        orange      = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00",
        deeporange  = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00",
        brown       = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723",
        grey        = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121",
        bluegrey    = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
    /*\
     * Snap.mui
     [ property ]
     **
     * Contain Material UI colours.
     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.mui.deeppurple, stroke: Snap.mui.amber[600]});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/
    Snap.mui = {};
    /*\
     * Snap.flat
     [ property ]
     **
     * Contain Flat UI colours.
     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.flat.carrot, stroke: Snap.flat.wetasphalt});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/
    Snap.flat = {};
    function saveColor(colors) {
        colors = colors.split(/(?=#)/);
        var color = new String(colors[5]);
        color[50] = colors[0];
        color[100] = colors[1];
        color[200] = colors[2];
        color[300] = colors[3];
        color[400] = colors[4];
        color[500] = colors[5];
        color[600] = colors[6];
        color[700] = colors[7];
        color[800] = colors[8];
        color[900] = colors[9];
        if (colors[10]) {
            color.A100 = colors[10];
            color.A200 = colors[11];
            color.A400 = colors[12];
            color.A700 = colors[13];
        }
        return color;
    }
    Snap.mui.red = saveColor(red);
    Snap.mui.pink = saveColor(pink);
    Snap.mui.purple = saveColor(purple);
    Snap.mui.deeppurple = saveColor(deeppurple);
    Snap.mui.indigo = saveColor(indigo);
    Snap.mui.blue = saveColor(blue);
    Snap.mui.lightblue = saveColor(lightblue);
    Snap.mui.cyan = saveColor(cyan);
    Snap.mui.teal = saveColor(teal);
    Snap.mui.green = saveColor(green);
    Snap.mui.lightgreen = saveColor(lightgreen);
    Snap.mui.lime = saveColor(lime);
    Snap.mui.yellow = saveColor(yellow);
    Snap.mui.amber = saveColor(amber);
    Snap.mui.orange = saveColor(orange);
    Snap.mui.deeporange = saveColor(deeporange);
    Snap.mui.brown = saveColor(brown);
    Snap.mui.grey = saveColor(grey);
    Snap.mui.bluegrey = saveColor(bluegrey);
    Snap.flat.turquoise = "#1abc9c";
    Snap.flat.greensea = "#16a085";
    Snap.flat.sunflower = "#f1c40f";
    Snap.flat.orange = "#f39c12";
    Snap.flat.emerland = "#2ecc71";
    Snap.flat.nephritis = "#27ae60";
    Snap.flat.carrot = "#e67e22";
    Snap.flat.pumpkin = "#d35400";
    Snap.flat.peterriver = "#3498db";
    Snap.flat.belizehole = "#2980b9";
    Snap.flat.alizarin = "#e74c3c";
    Snap.flat.pomegranate = "#c0392b";
    Snap.flat.amethyst = "#9b59b6";
    Snap.flat.wisteria = "#8e44ad";
    Snap.flat.clouds = "#ecf0f1";
    Snap.flat.silver = "#bdc3c7";
    Snap.flat.wetasphalt = "#34495e";
    Snap.flat.midnightblue = "#2c3e50";
    Snap.flat.concrete = "#95a5a6";
    Snap.flat.asbestos = "#7f8c8d";
    /*\
     * Snap.importMUIColors
     [ method ]
     **
     * Imports Material UI colours into global object.
     | Snap.importMUIColors();
     | Snap().rect(0, 0, 10, 10).attr({fill: deeppurple, stroke: amber[600]});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/
    Snap.importMUIColors = function () {
        for (var color in Snap.mui) {
            if (Snap.mui.hasOwnProperty(color)) {
                window[color] = Snap.mui[color];
            }
        }
    };
});

module.exports = Snap


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ┌────────────────────────────────────────────────────────────┐ \\
// │ Eve 0.5.4 - JavaScript Events Library                      │ \\
// ├────────────────────────────────────────────────────────────┤ \\
// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
// └────────────────────────────────────────────────────────────┘ \\

(function (glob) {
    var version = "0.5.4",
        has = "hasOwnProperty",
        separator = /[\.\/]/,
        comaseparator = /\s*,\s*/,
        wildcard = "*",
        numsort = function (a, b) {
            return a - b;
        },
        current_event,
        stop,
        events = {n: {}},
        firstDefined = function () {
            for (var i = 0, ii = this.length; i < ii; i++) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
        lastDefined = function () {
            var i = this.length;
            while (--i) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
        objtos = Object.prototype.toString,
        Str = String,
        isArray = Array.isArray || function (ar) {
            return ar instanceof Array || objtos.call(ar) == "[object Array]";
        },
    /*\
     * eve
     [ method ]

     * Fires event with given `name`, given scope and other parameters.

     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
     - scope (object) context for the event handlers
     - varargs (...) the rest of arguments will be sent to event handlers

     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
    \*/
        eve = function (name, scope) {
            var oldstop = stop,
                args = Array.prototype.slice.call(arguments, 2),
                listeners = eve.listeners(name),
                z = 0,
                l,
                indexed = [],
                queue = {},
                out = [],
                ce = current_event;
            out.firstDefined = firstDefined;
            out.lastDefined = lastDefined;
            current_event = name;
            stop = 0;
            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
                indexed.push(listeners[i].zIndex);
                if (listeners[i].zIndex < 0) {
                    queue[listeners[i].zIndex] = listeners[i];
                }
            }
            indexed.sort(numsort);
            while (indexed[z] < 0) {
                l = queue[indexed[z++]];
                out.push(l.apply(scope, args));
                if (stop) {
                    stop = oldstop;
                    return out;
                }
            }
            for (i = 0; i < ii; i++) {
                l = listeners[i];
                if ("zIndex" in l) {
                    if (l.zIndex == indexed[z]) {
                        out.push(l.apply(scope, args));
                        if (stop) {
                            break;
                        }
                        do {
                            z++;
                            l = queue[indexed[z]];
                            l && out.push(l.apply(scope, args));
                            if (stop) {
                                break;
                            }
                        } while (l)
                    } else {
                        queue[l.zIndex] = l;
                    }
                } else {
                    out.push(l.apply(scope, args));
                    if (stop) {
                        break;
                    }
                }
            }
            stop = oldstop;
            current_event = ce;
            return out;
        };
    // Undocumented. Debug only.
    eve._events = events;
    /*\
     * eve.listeners
     [ method ]

     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.

     - name (string) name of the event, dot (`.`) or slash (`/`) separated

     = (array) array of event handlers
    \*/
    eve.listeners = function (name) {
        var names = isArray(name) ? name : name.split(separator),
            e = events,
            item,
            items,
            k,
            i,
            ii,
            j,
            jj,
            nes,
            es = [e],
            out = [];
        for (i = 0, ii = names.length; i < ii; i++) {
            nes = [];
            for (j = 0, jj = es.length; j < jj; j++) {
                e = es[j].n;
                items = [e[names[i]], e[wildcard]];
                k = 2;
                while (k--) {
                    item = items[k];
                    if (item) {
                        nes.push(item);
                        out = out.concat(item.f || []);
                    }
                }
            }
            es = nes;
        }
        return out;
    };
    /*\
     * eve.separator
     [ method ]

     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
     * here. Be aware that if you pass a string longer than one character it will be treated as
     * a list of characters.

     - separator (string) new separator. Empty string resets to default: `.` or `/`.
    \*/
    eve.separator = function (sep) {
        if (sep) {
            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
            sep = "[" + sep + "]";
            separator = new RegExp(sep);
        } else {
            separator = /[\.\/]/;
        }
    };
    /*\
     * eve.on
     [ method ]
     **
     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
     | eve.on("*.under.*", f);
     | eve("mouse.under.floor"); // triggers f
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     - name (array) if you don’t want to use separators, you can use array of strings
     - f (function) event handler function
     **
     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment.
     > Example:
     | eve.on("mouse", eatIt)(2);
     | eve.on("mouse", scream);
     | eve.on("mouse", catchIt)(1);
     * This will ensure that `catchIt` function will be called before `eatIt`.
     *
     * If you want to put your handler before non-indexed handlers, specify a negative value.
     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
    \*/
    eve.on = function (name, f) {
        if (typeof f != "function") {
            return function () {};
        }
        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
        for (var i = 0, ii = names.length; i < ii; i++) {
            (function (name) {
                var names = isArray(name) ? name : Str(name).split(separator),
                    e = events,
                    exist;
                for (var i = 0, ii = names.length; i < ii; i++) {
                    e = e.n;
                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
                }
                e.f = e.f || [];
                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
                    exist = true;
                    break;
                }
                !exist && e.f.push(f);
            }(names[i]));
        }
        return function (zIndex) {
            if (+zIndex == +zIndex) {
                f.zIndex = +zIndex;
            }
        };
    };
    /*\
     * eve.f
     [ method ]
     **
     * Returns function that will fire given event with optional arguments.
     * Arguments that will be passed to the result function will be also
     * concated to the list of final arguments.
     | el.onclick = eve.f("click", 1, 2);
     | eve.on("click", function (a, b, c) {
     |     console.log(a, b, c); // 1, 2, [event object]
     | });
     - event (string) event name
     - varargs (…) and any other arguments
     = (function) possible event handler function
    \*/
    eve.f = function (event) {
        var attrs = [].slice.call(arguments, 1);
        return function () {
            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
        };
    };
    /*\
     * eve.stop
     [ method ]
     **
     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
    \*/
    eve.stop = function () {
        stop = 1;
    };
    /*\
     * eve.nt
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     - subname (string) #optional subname of the event
     **
     = (string) name of the event, if `subname` is not specified
     * or
     = (boolean) `true`, if current event’s name contains `subname`
    \*/
    eve.nt = function (subname) {
        var cur = isArray(current_event) ? current_event.join(".") : current_event;
        if (subname) {
            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
        }
        return cur;
    };
    /*\
     * eve.nts
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     **
     = (array) names of the event
    \*/
    eve.nts = function () {
        return isArray(current_event) ? current_event : current_event.split(separator);
    };
    /*\
     * eve.off
     [ method ]
     **
     * Removes given function from the list of event listeners assigned to given name.
     * If no arguments specified all the events will be cleared.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
    \*/
    /*\
     * eve.unbind
     [ method ]
     **
     * See @eve.off
    \*/
    eve.off = eve.unbind = function (name, f) {
        if (!name) {
            eve._events = events = {n: {}};
            return;
        }
        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
        if (names.length > 1) {
            for (var i = 0, ii = names.length; i < ii; i++) {
                eve.off(names[i], f);
            }
            return;
        }
        names = isArray(name) ? name : Str(name).split(separator);
        var e,
            key,
            splice,
            i, ii, j, jj,
            cur = [events],
            inodes = [];
        for (i = 0, ii = names.length; i < ii; i++) {
            for (j = 0; j < cur.length; j += splice.length - 2) {
                splice = [j, 1];
                e = cur[j].n;
                if (names[i] != wildcard) {
                    if (e[names[i]]) {
                        splice.push(e[names[i]]);
                        inodes.unshift({
                            n: e,
                            name: names[i]
                        });
                    }
                } else {
                    for (key in e) if (e[has](key)) {
                        splice.push(e[key]);
                        inodes.unshift({
                            n: e,
                            name: key
                        });
                    }
                }
                cur.splice.apply(cur, splice);
            }
        }
        for (i = 0, ii = cur.length; i < ii; i++) {
            e = cur[i];
            while (e.n) {
                if (f) {
                    if (e.f) {
                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
                            e.f.splice(j, 1);
                            break;
                        }
                        !e.f.length && delete e.f;
                    }
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        var funcs = e.n[key].f;
                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
                            funcs.splice(j, 1);
                            break;
                        }
                        !funcs.length && delete e.n[key].f;
                    }
                } else {
                    delete e.f;
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        delete e.n[key].f;
                    }
                }
                e = e.n;
            }
        }
        // prune inner nodes in path
        prune: for (i = 0, ii = inodes.length; i < ii; i++) {
            e = inodes[i];
            for (key in e.n[e.name].f) {
                // not empty (has listeners)
                continue prune;
            }
            for (key in e.n[e.name].n) {
                // not empty (has children)
                continue prune;
            }
            // is empty
            delete e.n[e.name];
        }
    };
    /*\
     * eve.once
     [ method ]
     **
     * Binds given event handler with a given name to only run once then unbind itself.
     | eve.once("login", f);
     | eve("login"); // triggers f
     | eve("login"); // no listeners
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) same return function as @eve.on
    \*/
    eve.once = function (name, f) {
        var f2 = function () {
            eve.off(name, f2);
            return f.apply(this, arguments);
        };
        return eve.on(name, f2);
    };
    /*\
     * eve.version
     [ property (string) ]
     **
     * Current version of the library.
    \*/
    eve.version = version;
    eve.toString = function () {
        return "You are running Eve " + version;
    };
    glob.eve = eve;
    typeof module != "undefined" && module.exports ? module.exports = eve :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () { return eve; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : glob.eve = eve;
})(typeof window != "undefined" ? window : this);


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _snapsvgImporter = __webpack_require__(27);

var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);

var _menuFactory = __webpack_require__(1);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  svg: {
    lib: _snapsvgImporter2['default'],
    pathInitial: 'M-7.312,0H0c0,0,0,113.839,0,400c0,264.506,0,400,0,400h-7.312V0z',
    pathOpen: 'M-7.312,0H15c0,0,66,113.339,66,399.5C81,664.006,15,800,15,800H-7.312V0z;M-7.312,0H100c0,0,0,113.839,0,400c0,264.506,0,400,0,400H-7.312V0z',
    animate: function animate(path) {
      var pos = 0;
      var steps = this.pathOpen.split(';');
      var stepsTotal = steps.length;
      var mina = window.mina;

      var nextStep = function nextStep() {
        if (pos > stepsTotal - 1) return;

        path.animate({ path: steps[pos] }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function () {
          nextStep();
        });

        pos++;
      };

      nextStep();
    }
  },

  morphShape: function morphShape(isOpen, width, right) {
    return {
      position: 'absolute',
      width: '100%',
      height: '100%',
      right: right ? 'inherit' : 0,
      left: right ? 0 : 'inherit',
      MozTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      MsTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      OTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      WebkitTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      transform: right ? 'rotateY(180deg)' : 'rotateY(0deg)'
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: isOpen ? 'transform 0.4s 0s' : 'transform 0.4s'
    };
  },

  menu: function menu(isOpen, width, right) {
    width -= 140;
    return {
      position: 'fixed',
      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'opacity 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  },

  item: function item(isOpen, width, right, nthChild) {
    width -= 140;
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'opacity 0.3s 0.4s, transform 0.3s 0.4s' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  },

  closeButton: function closeButton(isOpen, width, right) {
    width -= 140;
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'opacity 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(1);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(1);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      transformOrigin: right ? '100% 50%' : '0% 50%',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(1);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width) {
    return {
      MozTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      MsTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      OTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      WebkitTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      transform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      transformOrigin: '100%',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer() {
    return {
      perspective: '1500px'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(1);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s',
      overflow: isOpen ? '' : 'hidden'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(1);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  menuWrap: function menuWrap(isOpen) {
    return {
      MozTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      MsTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      OTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      WebkitTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      transform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      transition: 'all 0.5s ease-in-out'
    };
  },

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      perspectiveOrigin: '0% 50%',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(1);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      visibility: isOpen ? 'visible' : 'hidden',
      MozTransform: 'translate3d(0, 0, 0)',
      MsTransform: 'translate3d(0, 0, 0)',
      OTransform: 'translate3d(0, 0, 0)',
      WebkitTransform: 'translate3d(0, 0, 0)',
      transform: 'translate3d(0, 0, 0)',
      zIndex: 1000
    };
  },

  overlay: function overlay(isOpen, width, right) {
    return {
      zIndex: 1400,
      MozTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      MsTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      OTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      WebkitTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transition: 'all 0.5s',
      visibility: isOpen ? 'visible' : 'hidden'
    };
  },

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transition: 'all 0.5s',
      zIndex: 1200,
      position: 'relative'
    };
  },

  burgerIcon: function burgerIcon(isOpen, width, right) {
    return {
      MozTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      MsTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      OTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      WebkitTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transition: 'all 0.1s',
      position: 'relative',
      zIndex: 1300
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/drop2worldwind",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/drop2worldwind"+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.454188ee.js